
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49d7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49d7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("2Mqjh", function(module, exports) {
$parcel$export(module.exports, "getAnalyticsWebClientPromise", () => $8deb09a86a2f21e1$export$799525ac94ca811d);
$parcel$export(module.exports, "resolveAnalyticsWebClientPromise", () => $8deb09a86a2f21e1$export$2b194038750b3976);
let $8deb09a86a2f21e1$var$markAnalyticsClientAsReady;
const $8deb09a86a2f21e1$var$analyticsClientPromise = new Promise((resolve)=>{
    $8deb09a86a2f21e1$var$markAnalyticsClientAsReady = resolve;
});
const $8deb09a86a2f21e1$export$799525ac94ca811d = ()=>$8deb09a86a2f21e1$var$analyticsClientPromise;
const $8deb09a86a2f21e1$export$2b194038750b3976 = (client)=>$8deb09a86a2f21e1$var$markAnalyticsClientAsReady(client);

});

parcelRegister("4cTDP", function(module, exports) {
$parcel$export(module.exports, "withoutFeatureExistenceCheck", () => $8ecadf1db338fa00$export$ede4c4e7e9dad3f2);
$parcel$export(module.exports, "fg", () => $8ecadf1db338fa00$export$b40ec24ac8275656);
$parcel$export(module.exports, "UNSAFE__fgNoExposure", () => $8ecadf1db338fa00$export$c7fa95c00de0c062);

var $59rsN = parcelRequire("59rsN");

var $4iJGP = parcelRequire("4iJGP");

var $11lp0 = parcelRequire("11lp0");

var $es5G8 = parcelRequire("es5G8");

var $igDjg = parcelRequire("igDjg");
class $8ecadf1db338fa00$var$ErrorPointingUp extends Error {
    constructor(message){
        super(message);
        // Capture the stack without the error construction
        if (this.stack) {
            const stackLines = this.stack.split('\n');
            // Remove the error creation line and preserve caller stack
            // 1 - checkIfGateExists
            // 2 - featureGate
            // 3 - fg
            this.stack = [
                ...stackLines.slice(3)
            ].join('\n');
        }
    }
}
const $8ecadf1db338fa00$var$checkedGates = new Set();
const $8ecadf1db338fa00$var$checkIfGateExists = (gateName)=>{
    // perform early exist to minimize performance impact
    if ($8ecadf1db338fa00$var$checkedGates.has(gateName)) return;
    $8ecadf1db338fa00$var$checkedGates.add(gateName);
    if ((0, $59rsN.default).checkGate('jfp_magma_jira-report-incorrect-gates', {
        fireGateExposure: false
    })) {
        if (!(0, $59rsN.default).isGateExists(gateName)) {
            const error = new $8ecadf1db338fa00$var$ErrorPointingUp(`Feature gate ${gateName} does not exist`);
            (0, $es5G8.captureException)('FeatureGates.isGateExists', error);
            // eslint-disable-next-line no-console
            console.error(`Feature gate ${gateName} does not exist in StatSig. It was archived or hasn't been created yet`);
        }
    }
};
let $8ecadf1db338fa00$var$shouldPerformGateExistenceCheck = true;
const $8ecadf1db338fa00$export$ede4c4e7e9dad3f2 = (fn)=>{
    $8ecadf1db338fa00$var$shouldPerformGateExistenceCheck = false;
    const result = fn();
    $8ecadf1db338fa00$var$shouldPerformGateExistenceCheck = true;
    return result;
};
const $8ecadf1db338fa00$var$featureGate = (gateName)=>{
    // Handle vendorless scripts use of gates
    (0, $11lp0.UNSAFE_initIfNeeded)();
    const value = (0, $59rsN.default).checkGate(gateName);
    (0, $4iJGP.addFeatureFlagAccessed)(gateName, value);
    if ($8ecadf1db338fa00$var$shouldPerformGateExistenceCheck) $8ecadf1db338fa00$var$checkIfGateExists(gateName);
    return value;
};
const $8ecadf1db338fa00$export$b40ec24ac8275656 = (gateName)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const globalVar = typeof window !== 'undefined' ? window : globalThis;
    if (false) {
        /**
		 * These overrides are set by the server-side code in jira/src/entry-fs
		 */ if (globalVar?.__SSR_STATSIG_OVERRIDES__?.gates?.[gateName] !== undefined) return globalVar.__SSR_STATSIG_OVERRIDES__.gates[gateName];
        // for smoke tests to test when all gates are on
        if (globalVar?.__SSR_STATSIG_OVERRIDES__?.allGatesTrue) return true;
        /**
		 * This is the codepath before _statsigValues is initilaised.
		 * This function is defined within jira/src/entry-fs
		 */ if (typeof globalVar.__SSR_SYNC_FG__ === 'function' && // if global variable is ready, then don't reach out to native
        !globalVar._statsigValuesReady) return globalVar.__SSR_SYNC_FG__(gateName);
        return $8ecadf1db338fa00$var$featureGate(gateName);
    }
    if (globalVar.__MCOND_EVALUATED && gateName in globalVar.__MCOND_EVALUATED) {
        const serverResult = globalVar.__MCOND_EVALUATED[gateName];
        const browserResult = $8ecadf1db338fa00$var$featureGate(gateName);
        if (serverResult !== browserResult) {
            let errorMessage = `Conditional import mismatch (returning server result), cond: ${gateName}, ${browserResult} !== ${serverResult} (browser !== server).`;
            if ($igDjg?.env?.NODE_ENV === 'development' || globalThis.BUILD_KEY?.startsWith('MRJF-BB')) errorMessage = `${errorMessage} Do not introduce this error into the codebase. Please see https://hello.atlassian.net/wiki/x/_hjGRAE for details and context.`;
            else {
                // We can proceed with the server result, but we should log the error to help us debug the issue
                // eslint-disable-next-line no-console
                console.error(errorMessage);
                (0, $es5G8.captureException)('FeatureGates.fg', new Error('Conditional import mismatch (returning server result)'), {
                    teamName: 'uip-app-framework-bundler',
                    gateName: gateName,
                    serverResult: serverResult.toString(),
                    browserResult: browserResult.toString()
                });
            }
        }
        // Return the server-evaluated result
        return globalVar.__MCOND_EVALUATED[gateName];
    }
    return $8ecadf1db338fa00$var$featureGate(gateName);
};
const $8ecadf1db338fa00$var$featureGateNoExposure = (gateName)=>{
    if (false) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const globalVar = typeof window !== 'undefined' ? window : globalThis;
        /**
		 * These overrides are set by the server-side code in jira/src/entry-fs
		 */ if (globalVar?.__SSR_STATSIG_OVERRIDES__?.gates?.[gateName] !== undefined) return globalVar.__SSR_STATSIG_OVERRIDES__.gates[gateName];
        // for smoke tests to test when all gates are on
        if (globalVar?.__SSR_STATSIG_OVERRIDES__?.allGatesTrue) return true;
        /**
		 * This is the codepath before _statsigValues is initilaised.
		 * This function is defined within jira/src/entry-fs
		 */ if (typeof globalVar?.__SSR_SYNC_FG__ === 'function' && // if global variable is ready, then don't reach out to native
        // API, stay within js runtime as it is faster
        !globalVar._statsigValuesReady) return globalVar.__SSR_SYNC_FG__(gateName);
    }
    // Handle vendorless scripts use of gates
    (0, $11lp0.UNSAFE_initIfNeeded)();
    const value = (0, $59rsN.default).checkGate(gateName, {
        fireGateExposure: false
    });
    return value;
};
const $8ecadf1db338fa00$export$c7fa95c00de0c062 = (gateName)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const globalVar = typeof window !== 'undefined' ? window : globalThis;
    if (false) {
        /**
		 * These overrides are set by the server-side code in jira/src/entry-fs
		 */ if (globalVar?.__SSR_STATSIG_OVERRIDES__?.gates?.[gateName] !== undefined) return globalVar.__SSR_STATSIG_OVERRIDES__.gates[gateName];
        // for smoke tests to test when all gates are on
        if (globalVar?.__SSR_STATSIG_OVERRIDES__?.allGatesTrue) return true;
        /**
		 * This function is defined within jira/src/entry-fs
		 */ if (typeof globalVar.__SSR_SYNC_FG_NO_EXPOSURE__ === 'function') return globalVar.__SSR_SYNC_FG_NO_EXPOSURE__(gateName);
    }
    return $8ecadf1db338fa00$var$featureGateNoExposure(gateName);
};

});
parcelRegister("11lp0", function(module, exports) {
$parcel$export(module.exports, "UNSAFE_initIfNeeded", () => $4ac2e18c3913dbbb$export$c9517ca8c289160f);

var $59rsN = parcelRequire("59rsN");
var $clEsg = parcelRequire("clEsg");

var $hWeHP = parcelRequire("hWeHP");


var $jXzWG = parcelRequire("jXzWG");

var $aEA8G = parcelRequire("aEA8G");
// This script is part of early scripts, where analytics clients are too heavy to be included.
// Therefore, we just record the error in a global variable. Downstream code will report this.
const $4ac2e18c3913dbbb$var$captureStatsigInitError = (error)=>{
    (0, $aEA8G.setUnreportedStatsigInitialisationError)(new Error('Statsig initialisation failed', {
        cause: error
    }));
};
const $4ac2e18c3913dbbb$var$initIfNeeded = ()=>{
    if (!(0, $59rsN.default).initializeCalled()) try {
        const gateValues = (0, $jXzWG.getGateValues)();
        const isNotPillarLocalDev = globalThis.localDevContext?.PILLAR_LOCAL_DEVELOPMENT != null ? !globalThis.localDevContext?.PILLAR_LOCAL_DEVELOPMENT : true;
        const initPromise = (0, $59rsN.default).initializeFromValues({
            sdkKey: 'client-7hFqlBhHaY5b2zA7LaaHDy1QKH7yZigbikmrwNpCuRy',
            // this environment variable is defined in webpack.config.js
            environment: (0, $hWeHP.default)('ajs-environment') === 'prod' ? (0, $clEsg.FeatureGateEnvironment).Production : (0, $clEsg.FeatureGateEnvironment).Staging,
            targetApp: 'jira_web',
            // Enable exposure firing from server side
            ...false && isNotPillarLocalDev ? {
                ignoreWindowUndefined: true
            } : null
        }, {
            // These getMeta functions should only be called once due to performance implications
            // Ideally we should get these passed through from react which memoizes this call already
            atlassianAccountId: (0, $hWeHP.default)('ajs-atlassian-account-id') || undefined,
            tenantId: (0, $hWeHP.default)('ajs-cloud-id') ?? undefined,
            atlassianOrgId: (0, $hWeHP.default)('ajs-org-id') ?? undefined
        }, (0, $jXzWG.getCustomAttributes)(), gateValues);
        initPromise.catch($4ac2e18c3913dbbb$var$captureStatsigInitError);
    } catch (error) {
        $4ac2e18c3913dbbb$var$captureStatsigInitError(error);
        if (error instanceof Error) // eslint-disable-next-line no-console
        console.error('statsig.client.initialization', error.message);
    }
};
const $4ac2e18c3913dbbb$export$c9517ca8c289160f = ()=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const globalVar = typeof window !== 'undefined' ? window : globalThis;
    // If on entry-fs, we need to check if the statsig values are ready
    // Mainly avoid the statsig initialisation is trying to use a default value
    // which is an empty object.
    if ((0, $9790b8dfe6f31c81$export$19d68f5aa485d903) && globalVar._statsigValuesReady !== true) return;
    $4ac2e18c3913dbbb$var$initIfNeeded();
};

});
parcelRegister("hWeHP", function(module, exports) {
$parcel$export(module.exports, "default", () => $be05d3bcb92d4a02$export$2e2bcd8739ae039);
// code-reaper-ignore - file is referenced as "browser" entry in package.json

var $dxvxh = parcelRequire("dxvxh");
var // eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
$be05d3bcb92d4a02$export$2e2bcd8739ae039 = (0, $dxvxh.default);

});
parcelRegister("dxvxh", function(module, exports) {
$parcel$export(module.exports, "getMeta", () => $7fbfe9a55b4d744d$export$c47913ca32a5c6f7);
$parcel$export(module.exports, "default", () => $7fbfe9a55b4d744d$export$2e2bcd8739ae039);
const $7fbfe9a55b4d744d$export$c47913ca32a5c6f7 = (name)=>{
    // NOTE: this code in this false block has been copied from the `server.tsx` file, please keep them in sync until the flag is rolled out
    // `document` doesn't work in Node envs
    if (false) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        const value = globalThis.ssr__metadata && globalThis.ssr__metadata[name];
        return value !== undefined ? value : null;
    }
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const node = document.querySelector(`meta[name="${name}"]`);
    const metaValue = node && node.getAttribute('content');
    return metaValue !== undefined ? metaValue : null;
};
var $7fbfe9a55b4d744d$export$2e2bcd8739ae039 = $7fbfe9a55b4d744d$export$c47913ca32a5c6f7;

});


// This constant will be true on entry-fs (modern SSR) bundles and false on jira-fe-gateway (legacy SSR) and client bundles
const $9790b8dfe6f31c81$export$19d68f5aa485d903 = false;

parcelRegister("jXzWG", function(module, exports) {
$parcel$export(module.exports, "getCustomAttributes", () => $feda9422d8c98df0$export$1ef2b1f78c9e40d9);
$parcel$export(module.exports, "getGateValues", () => $feda9422d8c98df0$export$fc7c61934a5b05);

var $hWeHP = parcelRequire("hWeHP");

var $6D8kE = parcelRequire("6D8kE");
const $feda9422d8c98df0$export$1ef2b1f78c9e40d9 = ()=>({
        ...(0, $6D8kE.getProductEditions)(),
        exposureSource: false ? 'server' : 'client'
    });
const $feda9422d8c98df0$var$valuesFromGlobal = (()=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const globalVar = typeof window !== 'undefined' ? window : globalThis;
    return {
        locator: ()=>'_statsigValues' in globalVar,
        processor: ()=>globalVar._statsigValues
    };
})();
const $feda9422d8c98df0$var$valuesFromMeta = (()=>{
    // If parsing fails once, it will always fail. Avoid overhead of parsing again & again.
    let parsingFailed = false;
    const locator = ()=>{
        if (parsingFailed) return null;
        const statsigValues = (0, $hWeHP.default)('ajs-fe-statsig-values');
        try {
            const statsigValues2 = (0, $hWeHP.default)('ajs-fe-statsig-values-2');
            if (statsigValues && statsigValues2) {
                const statsigValuesObject = JSON.parse(statsigValues);
                const statsigValues2Object = JSON.parse(statsigValues2);
                Object.assign(statsigValuesObject.feature_gates, statsigValues2Object);
                return JSON.stringify(statsigValuesObject);
            }
            return statsigValues;
        } catch (e) {
            return statsigValues;
        }
    };
    return {
        locator: locator,
        processor: ()=>{
            if (parsingFailed) throw new Error("Can't parse 'ajs-fe-statsig-values' value");
            const featureFlags = locator();
            if (featureFlags != null && featureFlags !== '') {
                globalThis.performance?.mark?.('statsig-parse:start');
                try {
                    const result = JSON.parse(featureFlags);
                    globalThis.performance?.mark?.('statsig-parse:end');
                    return result;
                } catch  {
                    parsingFailed = true;
                    throw new Error("Can't parse 'ajs-fe-statsig-values' value");
                }
            }
        }
    };
})();
const $feda9422d8c98df0$export$8ece9c90e8293278 = ()=>{
    return Boolean($feda9422d8c98df0$var$valuesFromGlobal.locator() || $feda9422d8c98df0$var$valuesFromMeta.locator());
};
const $feda9422d8c98df0$export$fc7c61934a5b05 = ()=>{
    if ($feda9422d8c98df0$var$valuesFromGlobal.locator()) return $feda9422d8c98df0$var$valuesFromGlobal.processor();
    if ($feda9422d8c98df0$var$valuesFromMeta.locator()) return $feda9422d8c98df0$var$valuesFromMeta.processor();
    return undefined;
};

});
parcelRegister("6D8kE", function(module, exports) {
$parcel$export(module.exports, "getProductEditions", () => $0184211174c222c2$export$61e1423c6d76fbe3);

var $hWeHP = parcelRequire("hWeHP");
const $0184211174c222c2$var$TAP_VALUES = {
    f: 'free',
    s: 'standard',
    p: 'premium'
};
const $0184211174c222c2$var$getTapValue = (editionShorthand)=>$0184211174c222c2$var$TAP_VALUES[editionShorthand] ?? 'UNLICENSED';
const $0184211174c222c2$export$61e1423c6d76fbe3 = ()=>{
    try {
        const tenantContextEditions = JSON.parse((0, $hWeHP.default)('ajs-product-editions') || '{}');
        return {
            'jira-software_edition': $0184211174c222c2$var$getTapValue(tenantContextEditions['jira-software']),
            'jira-servicedesk_edition': $0184211174c222c2$var$getTapValue(tenantContextEditions['jira-servicedesk']),
            'jira-workmanagement_edition': $0184211174c222c2$var$getTapValue(tenantContextEditions['jira-core'])
        };
    } catch (error) {
        // eslint-disable-next-line no-console
        console.warn(`Error parsing application editions from tenant context: ${error}`);
        return {
            'jira-software_edition': 'UNLICENSED',
            'jira-servicedesk_edition': 'UNLICENSED',
            'jira-workmanagement_edition': 'UNLICENSED'
        };
    }
};

});


parcelRegister("aEA8G", function(module, exports) {
$parcel$export(module.exports, "unreportedStatsigInitialisationError", () => $6791f94faee64576$export$2f1d868dc4cd45f5);
$parcel$export(module.exports, "setUnreportedStatsigInitialisationError", () => $6791f94faee64576$export$f0253a32470c87a6);
// eslint-disable-next-line import/no-mutable-exports
let $6791f94faee64576$export$2f1d868dc4cd45f5;
const $6791f94faee64576$export$f0253a32470c87a6 = (error)=>{
    $6791f94faee64576$export$2f1d868dc4cd45f5 = error;
};

});


parcelRegister("es5G8", function(module, exports) {
$parcel$export(module.exports, "captureException", () => $a3b4b2ff7be31ea3$export$f5282963edea4a68);

var $dBRvd = parcelRequire("dBRvd");
const $a3b4b2ff7be31ea3$export$f5282963edea4a68 = (location, error, details = {})=>false ? undefined : (0, $dBRvd.captureException)(location, error, details);

});
parcelRegister("dBRvd", function(module, exports) {
$parcel$export(module.exports, "captureException", () => $3163ef8ec0b84319$export$f5282963edea4a68);

var $3vr70 = parcelRequire("3vr70");
// structured tags that we send to Sentry
// everything else from details object will go into "extras"
const $3163ef8ec0b84319$var$tags = [
    'packageName',
    'teamName',
    'hash',
    'userLocation'
];
const $3163ef8ec0b84319$export$f5282963edea4a68 = (location, error, details)=>{
    if (!error) return;
    (0, $3vr70.withScope)((scope)=>{
        scope.setTag('logger', location);
        if (details) Object.keys(details).forEach((key)=>{
            if ($3163ef8ec0b84319$var$tags.includes(key)) scope.setTag(key, details[key]);
            else scope.setExtra(key, details[key]);
        });
        (0, $3vr70.captureException)(error);
    });
};

});
parcelRegister("3vr70", function(module, exports) {
$parcel$export(module.exports, "captureException", () => $28d94c353fd03344$export$f5282963edea4a68);
$parcel$export(module.exports, "captureMessage", () => $28d94c353fd03344$export$45654777c133ae80);
$parcel$export(module.exports, "captureEvent", () => $28d94c353fd03344$export$1462b974fdcf6ba2);
$parcel$export(module.exports, "configureScope", () => $28d94c353fd03344$export$99d44f04437e9cb8);
$parcel$export(module.exports, "addBreadcrumb", () => $28d94c353fd03344$export$efda9a273d7a036d);
$parcel$export(module.exports, "withScope", () => $28d94c353fd03344$export$ec58d9285c204497);
$parcel$export(module.exports, "getCurrentScope", () => $28d94c353fd03344$export$c7be4b0125a10cba);
$parcel$export(module.exports, "getClient", () => $28d94c353fd03344$export$6bb76d6eba7e258c);
$parcel$export(module.exports, "startSession", () => $28d94c353fd03344$export$c0d84948cecf78d8);
$parcel$export(module.exports, "captureSession", () => $28d94c353fd03344$export$667e7b4d445d566b);

var $aFn2S = parcelRequire("aFn2S");
var $2Jaqc = parcelRequire("2Jaqc");
var $6lJZW = parcelRequire("6lJZW");
var $gv1sw = parcelRequire("gv1sw");
var $kgI9H = parcelRequire("kgI9H");

var $b2zyj = parcelRequire("b2zyj");

var $fZ2r3 = parcelRequire("fZ2r3");

var $kINbm = parcelRequire("kINbm");

var $bHHGA = parcelRequire("bHHGA");

var $2biSp = parcelRequire("2biSp");
/**
 * Captures an exception event and sends it to Sentry.
 *
 * @param exception The exception to capture.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured Sentry event.
 */ function $28d94c353fd03344$export$f5282963edea4a68(// eslint-disable-next-line @typescript-eslint/no-explicit-any
exception, hint) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $kINbm.getCurrentHub)().captureException(exception, (0, $2biSp.parseEventHintOrCaptureContext)(hint));
}
/**
 * Captures a message event and sends it to Sentry.
 *
 * @param exception The exception to capture.
 * @param captureContext Define the level of the message or pass in additional data to attach to the message.
 * @returns the id of the captured message.
 */ function $28d94c353fd03344$export$45654777c133ae80(message, // eslint-disable-next-line deprecation/deprecation
captureContext) {
    // This is necessary to provide explicit scopes upgrade, without changing the original
    // arity of the `captureMessage(message, level)` method.
    const level = typeof captureContext === 'string' ? captureContext : undefined;
    const context = typeof captureContext !== 'string' ? {
        captureContext: captureContext
    } : undefined;
    // eslint-disable-next-line deprecation/deprecation
    return (0, $kINbm.getCurrentHub)().captureMessage(message, level, context);
}
/**
 * Captures a manually created event and sends it to Sentry.
 *
 * @param exception The event to send to Sentry.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured event.
 */ function $28d94c353fd03344$export$1462b974fdcf6ba2(event, hint) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $kINbm.getCurrentHub)().captureEvent(event, hint);
}
/**
 * Callback to set context information onto the scope.
 * @param callback Callback function that receives Scope.
 *
 * @deprecated Use getCurrentScope() directly.
 */ // eslint-disable-next-line deprecation/deprecation
function $28d94c353fd03344$export$99d44f04437e9cb8(callback) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $kINbm.getCurrentHub)().configureScope(callback);
}
/**
 * Records a new breadcrumb which will be attached to future events.
 *
 * Breadcrumbs will be added to subsequent events to provide more context on
 * user's actions prior to an error or crash.
 *
 * @param breadcrumb The breadcrumb to record.
 */ // eslint-disable-next-line deprecation/deprecation
function $28d94c353fd03344$export$efda9a273d7a036d(breadcrumb, hint) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $kINbm.getCurrentHub)().addBreadcrumb(breadcrumb, hint);
}
/**
 * Sets context data with the given name.
 * @param name of the context
 * @param context Any kind of data. This data will be normalized.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, deprecation/deprecation
function $28d94c353fd03344$export$2f04de43fe27971a(name, context) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $kINbm.getCurrentHub)().setContext(name, context);
}
/**
 * Set an object that will be merged sent as extra data with the event.
 * @param extras Extras object to merge into current context.
 */ // eslint-disable-next-line deprecation/deprecation
function $28d94c353fd03344$export$bb4922da0dd51b92(extras) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $kINbm.getCurrentHub)().setExtras(extras);
}
/**
 * Set key:value that will be sent as extra data with the event.
 * @param key String of extra
 * @param extra Any kind of data. This data will be normalized.
 */ // eslint-disable-next-line deprecation/deprecation
function $28d94c353fd03344$export$8e8e7789d42ed61d(key, extra) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $kINbm.getCurrentHub)().setExtra(key, extra);
}
/**
 * Set an object that will be merged sent as tags data with the event.
 * @param tags Tags context object to merge into current context.
 */ // eslint-disable-next-line deprecation/deprecation
function $28d94c353fd03344$export$74a8fb34822092e6(tags) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $kINbm.getCurrentHub)().setTags(tags);
}
/**
 * Set key:value that will be sent as tags data with the event.
 *
 * Can also be used to unset a tag, by passing `undefined`.
 *
 * @param key String key of tag
 * @param value Value of tag
 */ // eslint-disable-next-line deprecation/deprecation
function $28d94c353fd03344$export$a37d07ee78eb4569(key, value) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $kINbm.getCurrentHub)().setTag(key, value);
}
/**
 * Updates user context information for future events.
 *
 * @param user User context object to be set in the current context. Pass `null` to unset the user.
 */ // eslint-disable-next-line deprecation/deprecation
function $28d94c353fd03344$export$8b6bb3dd62a01be2(user) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $kINbm.getCurrentHub)().setUser(user);
}
/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 *
 * This is essentially a convenience function for:
 *
 *     pushScope();
 *     callback();
 *     popScope();
 */ /**
 * Either creates a new active scope, or sets the given scope as active scope in the given callback.
 */ function $28d94c353fd03344$export$ec58d9285c204497(...rest) {
    // eslint-disable-next-line deprecation/deprecation
    const hub = (0, $kINbm.getCurrentHub)();
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        const [scope, callback] = rest;
        if (!scope) // eslint-disable-next-line deprecation/deprecation
        return hub.withScope(callback);
        // eslint-disable-next-line deprecation/deprecation
        return hub.withScope(()=>{
            // eslint-disable-next-line deprecation/deprecation
            hub.getStackTop().scope = scope;
            return callback(scope);
        });
    }
    // eslint-disable-next-line deprecation/deprecation
    return hub.withScope(rest[0]);
}
/**
 * Attempts to fork the current isolation scope and the current scope based on the current async context strategy. If no
 * async context strategy is set, the isolation scope and the current scope will not be forked (this is currently the
 * case, for example, in the browser).
 *
 * Usage of this function in environments without async context strategy is discouraged and may lead to unexpected behaviour.
 *
 * This function is intended for Sentry SDK and SDK integration development. It is not recommended to be used in "normal"
 * applications directly because it comes with pitfalls. Use at your own risk!
 *
 * @param callback The callback in which the passed isolation scope is active. (Note: In environments without async
 * context strategy, the currently active isolation scope may change within execution of the callback.)
 * @returns The same value that `callback` returns.
 */ function $28d94c353fd03344$export$9a4fed82c350c2bd(callback) {
    return (0, $kINbm.runWithAsyncContext)(()=>{
        return callback((0, $kINbm.getIsolationScope)());
    });
}
/**
 * Forks the current scope and sets the provided span as active span in the context of the provided callback.
 *
 * @param span Spans started in the context of the provided callback will be children of this span.
 * @param callback Execution context in which the provided span will be active. Is passed the newly forked scope.
 * @returns the value returned from the provided callback function.
 */ function $28d94c353fd03344$export$e57ac09b143d92a2(span, callback) {
    return $28d94c353fd03344$export$ec58d9285c204497((scope)=>{
        // eslint-disable-next-line deprecation/deprecation
        scope.setSpan(span);
        return callback(scope);
    });
}
/**
 * Starts a new `Transaction` and returns it. This is the entry point to manual tracing instrumentation.
 *
 * A tree structure can be built by adding child spans to the transaction, and child spans to other spans. To start a
 * new child span within the transaction or any span, call the respective `.startChild()` method.
 *
 * Every child span must be finished before the transaction is finished, otherwise the unfinished spans are discarded.
 *
 * The transaction must be finished with a call to its `.end()` method, at which point the transaction with all its
 * finished child spans will be sent to Sentry.
 *
 * NOTE: This function should only be used for *manual* instrumentation. Auto-instrumentation should call
 * `startTransaction` directly on the hub.
 *
 * @param context Properties of the new `Transaction`.
 * @param customSamplingContext Information given to the transaction sampling function (along with context-dependent
 * default values). See {@link Options.tracesSampler}.
 *
 * @returns The transaction which was just started
 *
 * @deprecated Use `startSpan()`, `startSpanManual()` or `startInactiveSpan()` instead.
 */ function $28d94c353fd03344$export$e262da7ae6480481(context, customSamplingContext) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $kINbm.getCurrentHub)().startTransaction({
        ...context
    }, customSamplingContext);
}
/**
 * Create a cron monitor check in and send it to Sentry.
 *
 * @param checkIn An object that describes a check in.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $28d94c353fd03344$export$413528111fbc67c(checkIn, upsertMonitorConfig) {
    const scope = $28d94c353fd03344$export$c7be4b0125a10cba();
    const client = $28d94c353fd03344$export$6bb76d6eba7e258c();
    if (!client) (0, $fZ2r3.DEBUG_BUILD) && (0, $6lJZW.logger).warn('Cannot capture check-in. No client defined.');
    else if (!client.captureCheckIn) (0, $fZ2r3.DEBUG_BUILD) && (0, $6lJZW.logger).warn('Cannot capture check-in. Client does not support sending check-ins.');
    else return client.captureCheckIn(checkIn, upsertMonitorConfig, scope);
    return (0, $kgI9H.uuid4)();
}
/**
 * Wraps a callback with a cron monitor check in. The check in will be sent to Sentry when the callback finishes.
 *
 * @param monitorSlug The distinct slug of the monitor.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $28d94c353fd03344$export$553526fc5f03c0b1(monitorSlug, callback, upsertMonitorConfig) {
    const checkInId = $28d94c353fd03344$export$413528111fbc67c({
        monitorSlug: monitorSlug,
        status: 'in_progress'
    }, upsertMonitorConfig);
    const now = (0, $gv1sw.timestampInSeconds)();
    function finishCheckIn(status) {
        $28d94c353fd03344$export$413528111fbc67c({
            monitorSlug: monitorSlug,
            status: status,
            checkInId: checkInId,
            duration: (0, $gv1sw.timestampInSeconds)() - now
        });
    }
    let maybePromiseResult;
    try {
        maybePromiseResult = callback();
    } catch (e) {
        finishCheckIn('error');
        throw e;
    }
    if ((0, $2Jaqc.isThenable)(maybePromiseResult)) Promise.resolve(maybePromiseResult).then(()=>{
        finishCheckIn('ok');
    }, ()=>{
        finishCheckIn('error');
    });
    else finishCheckIn('ok');
    return maybePromiseResult;
}
/**
 * Call `flush()` on the current client, if there is one. See {@link Client.flush}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue. Omitting this parameter will cause
 * the client to wait until all events are sent before resolving the promise.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $28d94c353fd03344$export$4909b86c8034bf73(timeout) {
    const client = $28d94c353fd03344$export$6bb76d6eba7e258c();
    if (client) return client.flush(timeout);
    (0, $fZ2r3.DEBUG_BUILD) && (0, $6lJZW.logger).warn('Cannot flush events. No client defined.');
    return Promise.resolve(false);
}
/**
 * Call `close()` on the current client, if there is one. See {@link Client.close}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue before shutting down. Omitting this
 * parameter will cause the client to wait until all events are sent before disabling itself.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $28d94c353fd03344$export$8360e631d277ea4d(timeout) {
    const client = $28d94c353fd03344$export$6bb76d6eba7e258c();
    if (client) return client.close(timeout);
    (0, $fZ2r3.DEBUG_BUILD) && (0, $6lJZW.logger).warn('Cannot flush events and disable SDK. No client defined.');
    return Promise.resolve(false);
}
/**
 * This is the getter for lastEventId.
 *
 * @returns The last event id of a captured event.
 */ function $28d94c353fd03344$export$5d4e9fd7fac8e617() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $kINbm.getCurrentHub)().lastEventId();
}
/**
 * Get the currently active client.
 */ function $28d94c353fd03344$export$6bb76d6eba7e258c() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $kINbm.getCurrentHub)().getClient();
}
/**
 * Returns true if Sentry has been properly initialized.
 */ function $28d94c353fd03344$export$3f95c6f800b78024() {
    return !!$28d94c353fd03344$export$6bb76d6eba7e258c();
}
/**
 * Get the currently active scope.
 */ function $28d94c353fd03344$export$c7be4b0125a10cba() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $kINbm.getCurrentHub)().getScope();
}
/**
 * Start a session on the current isolation scope.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns the new active session
 */ function $28d94c353fd03344$export$c0d84948cecf78d8(context) {
    const client = $28d94c353fd03344$export$6bb76d6eba7e258c();
    const isolationScope = (0, $kINbm.getIsolationScope)();
    const currentScope = $28d94c353fd03344$export$c7be4b0125a10cba();
    const { release: release, environment: environment = (0, $b2zyj.DEFAULT_ENVIRONMENT) } = client && client.getOptions() || {};
    // Will fetch userAgent if called from browser sdk
    const { userAgent: userAgent } = (0, $aFn2S.GLOBAL_OBJ).navigator || {};
    const session = (0, $bHHGA.makeSession)({
        release: release,
        environment: environment,
        user: currentScope.getUser() || isolationScope.getUser(),
        ...userAgent && {
            userAgent: userAgent
        },
        ...context
    });
    // End existing session if there's one
    const currentSession = isolationScope.getSession();
    if (currentSession && currentSession.status === 'ok') (0, $bHHGA.updateSession)(currentSession, {
        status: 'exited'
    });
    $28d94c353fd03344$export$17a5be43989a0bc1();
    // Afterwards we set the new session on the scope
    isolationScope.setSession(session);
    // TODO (v8): Remove this and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    currentScope.setSession(session);
    return session;
}
/**
 * End the session on the current isolation scope.
 */ function $28d94c353fd03344$export$17a5be43989a0bc1() {
    const isolationScope = (0, $kINbm.getIsolationScope)();
    const currentScope = $28d94c353fd03344$export$c7be4b0125a10cba();
    const session = currentScope.getSession() || isolationScope.getSession();
    if (session) (0, $bHHGA.closeSession)(session);
    $28d94c353fd03344$var$_sendSessionUpdate();
    // the session is over; take it off of the scope
    isolationScope.setSession();
    // TODO (v8): Remove this and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    currentScope.setSession();
}
/**
 * Sends the current Session on the scope
 */ function $28d94c353fd03344$var$_sendSessionUpdate() {
    const isolationScope = (0, $kINbm.getIsolationScope)();
    const currentScope = $28d94c353fd03344$export$c7be4b0125a10cba();
    const client = $28d94c353fd03344$export$6bb76d6eba7e258c();
    // TODO (v8): Remove currentScope and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    const session = currentScope.getSession() || isolationScope.getSession();
    if (session && client && client.captureSession) client.captureSession(session);
}
/**
 * Sends the current session on the scope to Sentry
 *
 * @param end If set the session will be marked as exited and removed from the scope.
 *            Defaults to `false`.
 */ function $28d94c353fd03344$export$667e7b4d445d566b(end = false) {
    // both send the update and pull the session from the scope
    if (end) {
        $28d94c353fd03344$export$17a5be43989a0bc1();
        return;
    }
    // only send the update
    $28d94c353fd03344$var$_sendSessionUpdate();
}

});
parcelRegister("aFn2S", function(module, exports) {
$parcel$export(module.exports, "GLOBAL_OBJ", () => $7c3f9c0f6968cd76$export$f1a6cdb1459e81d1);
$parcel$export(module.exports, "getGlobalObject", () => $7c3f9c0f6968cd76$export$256479dc0cea61c4);
$parcel$export(module.exports, "getGlobalSingleton", () => $7c3f9c0f6968cd76$export$7e223ec222791509);
/** Internal global with common properties and Sentry extensions  */ // The code below for 'isGlobalObj' and 'GLOBAL_OBJ' was copied from core-js before modification
// https://github.com/zloirock/core-js/blob/1b944df55282cdc99c90db5f49eb0b6eda2cc0a3/packages/core-js/internals/global.js
// core-js has the following licence:
//
// Copyright (c) 2014-2022 Denis Pushkarev
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.
/** Returns 'obj' if it's the global object, otherwise returns undefined */ function $7c3f9c0f6968cd76$var$isGlobalObj(obj) {
    return obj && obj.Math == Math ? obj : undefined;
}
/** Get's the global object for the current JavaScript runtime */ const $7c3f9c0f6968cd76$export$f1a6cdb1459e81d1 = typeof globalThis == 'object' && $7c3f9c0f6968cd76$var$isGlobalObj(globalThis) || // eslint-disable-next-line no-restricted-globals
typeof window == 'object' && $7c3f9c0f6968cd76$var$isGlobalObj(window) || typeof self == 'object' && $7c3f9c0f6968cd76$var$isGlobalObj(self) || typeof $parcel$global == 'object' && $7c3f9c0f6968cd76$var$isGlobalObj($parcel$global) || function() {
    return this;
}() || {};
/**
 * @deprecated Use GLOBAL_OBJ instead or WINDOW from @sentry/browser. This will be removed in v8
 */ function $7c3f9c0f6968cd76$export$256479dc0cea61c4() {
    return $7c3f9c0f6968cd76$export$f1a6cdb1459e81d1;
}
/**
 * Returns a global singleton contained in the global `__SENTRY__` object.
 *
 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
 * function and added to the `__SENTRY__` object.
 *
 * @param name name of the global singleton on __SENTRY__
 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `GLOBAL_OBJ`'s return value
 * @returns the singleton
 */ function $7c3f9c0f6968cd76$export$7e223ec222791509(name, creator, obj) {
    const gbl = obj || $7c3f9c0f6968cd76$export$f1a6cdb1459e81d1;
    const __SENTRY__ = gbl.__SENTRY__ = gbl.__SENTRY__ || {};
    const singleton = __SENTRY__[name] || (__SENTRY__[name] = creator());
    return singleton;
}

});

parcelRegister("2Jaqc", function(module, exports) {
$parcel$export(module.exports, "isError", () => $1fc7de4124485181$export$e6127cc7fe7395c3);
$parcel$export(module.exports, "isInstanceOf", () => $1fc7de4124485181$export$49034edbe6b62415);
$parcel$export(module.exports, "isErrorEvent", () => $1fc7de4124485181$export$9f9636d330b71954);
$parcel$export(module.exports, "isDOMError", () => $1fc7de4124485181$export$ef9e2056653f0c8e);
$parcel$export(module.exports, "isDOMException", () => $1fc7de4124485181$export$12e869b2a583f783);
$parcel$export(module.exports, "isString", () => $1fc7de4124485181$export$844ec244b1367d54);
$parcel$export(module.exports, "isParameterizedString", () => $1fc7de4124485181$export$dbcbffa59149b824);
$parcel$export(module.exports, "isPrimitive", () => $1fc7de4124485181$export$c3825b437cbdea5c);
$parcel$export(module.exports, "isPlainObject", () => $1fc7de4124485181$export$53b83ca8eaab0383);
$parcel$export(module.exports, "isEvent", () => $1fc7de4124485181$export$9671ea99bd126ace);
$parcel$export(module.exports, "isElement", () => $1fc7de4124485181$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isRegExp", () => $1fc7de4124485181$export$49841c62b9eff15);
$parcel$export(module.exports, "isThenable", () => $1fc7de4124485181$export$f5b060c2914b97c8);
$parcel$export(module.exports, "isSyntheticEvent", () => $1fc7de4124485181$export$bc2894c7158efbac);
$parcel$export(module.exports, "isNaN", () => $1fc7de4124485181$export$c9f5652083b8129d);
$parcel$export(module.exports, "isVueViewModel", () => $1fc7de4124485181$export$7916fad0ebc23f48);
// eslint-disable-next-line @typescript-eslint/unbound-method
const $1fc7de4124485181$var$objectToString = Object.prototype.toString;
/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $1fc7de4124485181$export$e6127cc7fe7395c3(wat) {
    switch($1fc7de4124485181$var$objectToString.call(wat)){
        case '[object Error]':
        case '[object Exception]':
        case '[object DOMException]':
            return true;
        default:
            return $1fc7de4124485181$export$49034edbe6b62415(wat, Error);
    }
}
/**
 * Checks whether given value is an instance of the given built-in class.
 *
 * @param wat The value to be checked
 * @param className
 * @returns A boolean representing the result.
 */ function $1fc7de4124485181$var$isBuiltin(wat, className) {
    return $1fc7de4124485181$var$objectToString.call(wat) === `[object ${className}]`;
}
/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $1fc7de4124485181$export$9f9636d330b71954(wat) {
    return $1fc7de4124485181$var$isBuiltin(wat, 'ErrorEvent');
}
/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $1fc7de4124485181$export$ef9e2056653f0c8e(wat) {
    return $1fc7de4124485181$var$isBuiltin(wat, 'DOMError');
}
/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $1fc7de4124485181$export$12e869b2a583f783(wat) {
    return $1fc7de4124485181$var$isBuiltin(wat, 'DOMException');
}
/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $1fc7de4124485181$export$844ec244b1367d54(wat) {
    return $1fc7de4124485181$var$isBuiltin(wat, 'String');
}
/**
 * Checks whether given string is parameterized
 * {@link isParameterizedString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $1fc7de4124485181$export$dbcbffa59149b824(wat) {
    return typeof wat === 'object' && wat !== null && '__sentry_template_string__' in wat && '__sentry_template_values__' in wat;
}
/**
 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $1fc7de4124485181$export$c3825b437cbdea5c(wat) {
    return wat === null || $1fc7de4124485181$export$dbcbffa59149b824(wat) || typeof wat !== 'object' && typeof wat !== 'function';
}
/**
 * Checks whether given value's type is an object literal, or a class instance.
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $1fc7de4124485181$export$53b83ca8eaab0383(wat) {
    return $1fc7de4124485181$var$isBuiltin(wat, 'Object');
}
/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $1fc7de4124485181$export$9671ea99bd126ace(wat) {
    return typeof Event !== 'undefined' && $1fc7de4124485181$export$49034edbe6b62415(wat, Event);
}
/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $1fc7de4124485181$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== 'undefined' && $1fc7de4124485181$export$49034edbe6b62415(wat, Element);
}
/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $1fc7de4124485181$export$49841c62b9eff15(wat) {
    return $1fc7de4124485181$var$isBuiltin(wat, 'RegExp');
}
/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */ function $1fc7de4124485181$export$f5b060c2914b97c8(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat && wat.then && typeof wat.then === 'function');
}
/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $1fc7de4124485181$export$bc2894c7158efbac(wat) {
    return $1fc7de4124485181$export$53b83ca8eaab0383(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
}
/**
 * Checks whether given value is NaN
 * {@link isNaN}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $1fc7de4124485181$export$c9f5652083b8129d(wat) {
    return typeof wat === 'number' && wat !== wat;
}
/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */ function $1fc7de4124485181$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch (_e) {
        return false;
    }
}
/**
 * Checks whether given value's type is a Vue ViewModel.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $1fc7de4124485181$export$7916fad0ebc23f48(wat) {
    // Not using Object.prototype.toString because in Vue 3 it would read the instance's Symbol(Symbol.toStringTag) property.
    return !!(typeof wat === 'object' && wat !== null && (wat.__isVue || wat._isVue));
}

});

parcelRegister("6lJZW", function(module, exports) {
$parcel$export(module.exports, "CONSOLE_LEVELS", () => $49f86280643a7dcb$export$2a2b1d2252a69ecb);
$parcel$export(module.exports, "originalConsoleMethods", () => $49f86280643a7dcb$export$77c4ce905194557b);
$parcel$export(module.exports, "consoleSandbox", () => $49f86280643a7dcb$export$cda52e2a8927a2ca);
$parcel$export(module.exports, "logger", () => $49f86280643a7dcb$export$af88d00dbe7f521);

var $fUFQt = parcelRequire("fUFQt");

var $aFn2S = parcelRequire("aFn2S");
/** Prefix for logging strings */ const $49f86280643a7dcb$var$PREFIX = 'Sentry Logger ';
const $49f86280643a7dcb$export$2a2b1d2252a69ecb = [
    'debug',
    'info',
    'warn',
    'error',
    'log',
    'assert',
    'trace'
];
/** This may be mutated by the console instrumentation. */ const $49f86280643a7dcb$export$77c4ce905194557b = {};
/** JSDoc */ /**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */ function $49f86280643a7dcb$export$cda52e2a8927a2ca(callback) {
    if (!('console' in (0, $aFn2S.GLOBAL_OBJ))) return callback();
    const console = (0, $aFn2S.GLOBAL_OBJ).console;
    const wrappedFuncs = {};
    const wrappedLevels = Object.keys($49f86280643a7dcb$export$77c4ce905194557b);
    // Restore all wrapped console methods
    wrappedLevels.forEach((level)=>{
        const originalConsoleMethod = $49f86280643a7dcb$export$77c4ce905194557b[level];
        wrappedFuncs[level] = console[level];
        console[level] = originalConsoleMethod;
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        wrappedLevels.forEach((level)=>{
            console[level] = wrappedFuncs[level];
        });
    }
}
function $49f86280643a7dcb$var$makeLogger() {
    let enabled = false;
    const logger = {
        enable: ()=>{
            enabled = true;
        },
        disable: ()=>{
            enabled = false;
        },
        isEnabled: ()=>enabled
    };
    if (0, $fUFQt.DEBUG_BUILD) $49f86280643a7dcb$export$2a2b1d2252a69ecb.forEach((name)=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        logger[name] = (...args)=>{
            if (enabled) $49f86280643a7dcb$export$cda52e2a8927a2ca(()=>{
                (0, $aFn2S.GLOBAL_OBJ).console[name](`${$49f86280643a7dcb$var$PREFIX}[${name}]:`, ...args);
            });
        };
    });
    else $49f86280643a7dcb$export$2a2b1d2252a69ecb.forEach((name)=>{
        logger[name] = ()=>undefined;
    });
    return logger;
}
const $49f86280643a7dcb$export$af88d00dbe7f521 = $49f86280643a7dcb$var$makeLogger();

});
parcelRegister("fUFQt", function(module, exports) {
$parcel$export(module.exports, "DEBUG_BUILD", () => $b95c8b951133f0ba$export$16a28057038b10ef);
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $b95c8b951133f0ba$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;

});


parcelRegister("gv1sw", function(module, exports) {
$parcel$export(module.exports, "dateTimestampInSeconds", () => $c030ac4d4ebe4e89$export$7740643b9eeaf0c4);
$parcel$export(module.exports, "timestampInSeconds", () => $c030ac4d4ebe4e89$export$ee52dced521e3e18);

var $aFn2S = parcelRequire("aFn2S");
const $c030ac4d4ebe4e89$var$ONE_SECOND_IN_MS = 1000;
/**
 * A partial definition of the [Performance Web API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Performance}
 * for accessing a high-resolution monotonic clock.
 */ /**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 *
 * TODO(v8): Return type should be rounded.
 */ function $c030ac4d4ebe4e89$export$7740643b9eeaf0c4() {
    return Date.now() / $c030ac4d4ebe4e89$var$ONE_SECOND_IN_MS;
}
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function $c030ac4d4ebe4e89$var$createUnixTimestampInSecondsFunc() {
    const { performance: performance } = (0, $aFn2S.GLOBAL_OBJ);
    if (!performance || !performance.now) return $c030ac4d4ebe4e89$export$7740643b9eeaf0c4;
    // Some browser and environments don't have a timeOrigin, so we fallback to
    // using Date.now() to compute the starting time.
    const approxStartingTimeOrigin = Date.now() - performance.now();
    const timeOrigin = performance.timeOrigin == undefined ? approxStartingTimeOrigin : performance.timeOrigin;
    // performance.now() is a monotonic clock, which means it starts at 0 when the process begins. To get the current
    // wall clock time (actual UNIX timestamp), we need to add the starting time origin and the current time elapsed.
    //
    // TODO: This does not account for the case where the monotonic clock that powers performance.now() drifts from the
    // wall clock time, which causes the returned timestamp to be inaccurate. We should investigate how to detect and
    // correct for this.
    // See: https://github.com/getsentry/sentry-javascript/issues/2590
    // See: https://github.com/mdn/content/issues/4713
    // See: https://dev.to/noamr/when-a-millisecond-is-not-a-millisecond-3h6
    return ()=>{
        return (timeOrigin + performance.now()) / $c030ac4d4ebe4e89$var$ONE_SECOND_IN_MS;
    };
}
/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */ const $c030ac4d4ebe4e89$export$ee52dced521e3e18 = $c030ac4d4ebe4e89$var$createUnixTimestampInSecondsFunc();
/**
 * Re-exported with an old name for backwards-compatibility.
 * TODO (v8): Remove this
 *
 * @deprecated Use `timestampInSeconds` instead.
 */ const $c030ac4d4ebe4e89$export$c5907b5a8838db13 = $c030ac4d4ebe4e89$export$ee52dced521e3e18;
/**
 * Internal helper to store what is the source of browserPerformanceTimeOrigin below. For debugging only.
 */ let $c030ac4d4ebe4e89$export$f9f8cce55af5194c;
/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */ const $c030ac4d4ebe4e89$export$baf075a948ffc0bf = (()=>{
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    const { performance: performance } = (0, $aFn2S.GLOBAL_OBJ);
    if (!performance || !performance.now) {
        $c030ac4d4ebe4e89$export$f9f8cce55af5194c = 'none';
        return undefined;
    }
    const threshold = 3600000;
    const performanceNow = performance.now();
    const dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    const timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    const timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    const navigationStart = performance.timing && performance.timing.navigationStart;
    const hasNavigationStart = typeof navigationStart === 'number';
    // if navigationStart isn't available set delta to threshold so it isn't used
    const navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    const navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) {
            $c030ac4d4ebe4e89$export$f9f8cce55af5194c = 'timeOrigin';
            return performance.timeOrigin;
        } else {
            $c030ac4d4ebe4e89$export$f9f8cce55af5194c = 'navigationStart';
            return navigationStart;
        }
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    $c030ac4d4ebe4e89$export$f9f8cce55af5194c = 'dateNow';
    return dateNow;
})();

});

parcelRegister("kgI9H", function(module, exports) {
$parcel$export(module.exports, "uuid4", () => $ec178d9c779b02a4$export$19f53698e68b2496);
$parcel$export(module.exports, "getEventDescription", () => $ec178d9c779b02a4$export$4157119e2b157127);
$parcel$export(module.exports, "addExceptionTypeValue", () => $ec178d9c779b02a4$export$f26508487bf83ee7);
$parcel$export(module.exports, "addExceptionMechanism", () => $ec178d9c779b02a4$export$c69a9a0313b03bb1);
$parcel$export(module.exports, "checkOrSetAlreadyCaught", () => $ec178d9c779b02a4$export$6de4ffac6a2f1098);
$parcel$export(module.exports, "arrayify", () => $ec178d9c779b02a4$export$3131421a7d01b4fb);

var $3dFJR = parcelRequire("3dFJR");

var $4RzNY = parcelRequire("4RzNY");

var $aFn2S = parcelRequire("aFn2S");
/**
 * UUID4 generator
 *
 * @returns string Generated UUID4.
 */ function $ec178d9c779b02a4$export$19f53698e68b2496() {
    const gbl = (0, $aFn2S.GLOBAL_OBJ);
    const crypto = gbl.crypto || gbl.msCrypto;
    let getRandomByte = ()=>Math.random() * 16;
    try {
        if (crypto && crypto.randomUUID) return crypto.randomUUID().replace(/-/g, '');
        if (crypto && crypto.getRandomValues) getRandomByte = ()=>{
            // crypto.getRandomValues might return undefined instead of the typed array
            // in old Chromium versions (e.g. 23.0.1235.0 (151422))
            // However, `typedArray` is still filled in-place.
            // @see https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues#typedarray
            const typedArray = new Uint8Array(1);
            crypto.getRandomValues(typedArray);
            return typedArray[0];
        };
    } catch (_) {
    // some runtimes can crash invoking crypto
    // https://github.com/getsentry/sentry-javascript/issues/8935
    }
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    // Concatenating the following numbers as strings results in '10000000100040008000100000000000'
    return "10000000100040008000100000000000".replace(/[018]/g, (c)=>// eslint-disable-next-line no-bitwise
        (c ^ (getRandomByte() & 15) >> c / 4).toString(16));
}
function $ec178d9c779b02a4$var$getFirstException(event) {
    return event.exception && event.exception.values ? event.exception.values[0] : undefined;
}
/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */ function $ec178d9c779b02a4$export$4157119e2b157127(event) {
    const { message: message, event_id: eventId } = event;
    if (message) return message;
    const firstException = $ec178d9c779b02a4$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return `${firstException.type}: ${firstException.value}`;
        return firstException.type || firstException.value || eventId || '<unknown>';
    }
    return eventId || '<unknown>';
}
/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */ function $ec178d9c779b02a4$export$f26508487bf83ee7(event, value, type) {
    const exception = event.exception = event.exception || {};
    const values = exception.values = exception.values || [];
    const firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || '';
    if (!firstException.type) firstException.type = type || 'Error';
}
/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */ function $ec178d9c779b02a4$export$c69a9a0313b03bb1(event, newMechanism) {
    const firstException = $ec178d9c779b02a4$var$getFirstException(event);
    if (!firstException) return;
    const defaultMechanism = {
        type: 'generic',
        handled: true
    };
    const currentMechanism = firstException.mechanism;
    firstException.mechanism = {
        ...defaultMechanism,
        ...currentMechanism,
        ...newMechanism
    };
    if (newMechanism && 'data' in newMechanism) {
        const mergedData = {
            ...currentMechanism && currentMechanism.data,
            ...newMechanism.data
        };
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
const $ec178d9c779b02a4$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
/**
 * Represents Semantic Versioning object
 */ /**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */ function $ec178d9c779b02a4$export$d364f2020ab30578(input) {
    const match = input.match($ec178d9c779b02a4$var$SEMVER_REGEXP) || [];
    const major = parseInt(match[1], 10);
    const minor = parseInt(match[2], 10);
    const patch = parseInt(match[3], 10);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */ function $ec178d9c779b02a4$export$ec2291bfc64632f0(lines, frame, linesOfContext = 5) {
    // When there is no line number in the frame, attaching context is nonsensical and will even break grouping
    if (frame.lineno === undefined) return;
    const maxLines = lines.length;
    const sourceLine = Math.max(Math.min(maxLines - 1, frame.lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map((line)=>(0, $4RzNY.snipLine)(line, 0));
    frame.context_line = (0, $4RzNY.snipLine)(lines[Math.min(maxLines - 1, sourceLine)], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map((line)=>(0, $4RzNY.snipLine)(line, 0));
}
/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */ function $ec178d9c779b02a4$export$6de4ffac6a2f1098(exception) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (exception && exception.__sentry_captured__) return true;
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0, $3dFJR.addNonEnumerableProperty)(exception, '__sentry_captured__', true);
    } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}
/**
 * Checks whether the given input is already an array, and if it isn't, wraps it in one.
 *
 * @param maybeArray Input to turn into an array, if necessary
 * @returns The input, if already an array, or an array with the input as the only element, if not
 */ function $ec178d9c779b02a4$export$3131421a7d01b4fb(maybeArray) {
    return Array.isArray(maybeArray) ? maybeArray : [
        maybeArray
    ];
}

});
parcelRegister("3dFJR", function(module, exports) {
$parcel$export(module.exports, "fill", () => $2582f67441a9158e$export$9563e054e6f787fb);
$parcel$export(module.exports, "markFunctionWrapped", () => $2582f67441a9158e$export$5c1499e2e5d010ae);
$parcel$export(module.exports, "addNonEnumerableProperty", () => $2582f67441a9158e$export$e73679ffaf56810e);
$parcel$export(module.exports, "getOriginalFunction", () => $2582f67441a9158e$export$e6cc1e135e2092e5);
$parcel$export(module.exports, "urlEncode", () => $2582f67441a9158e$export$9ef804feabbcbaf1);
$parcel$export(module.exports, "convertToPlainObject", () => $2582f67441a9158e$export$62ff257738bf57f5);
$parcel$export(module.exports, "extractExceptionKeysForMessage", () => $2582f67441a9158e$export$b0244d5063c0b61b);
$parcel$export(module.exports, "dropUndefinedKeys", () => $2582f67441a9158e$export$d25f2688db1bb433);

var $1Pi8W = parcelRequire("1Pi8W");

var $fUFQt = parcelRequire("fUFQt");

var $2Jaqc = parcelRequire("2Jaqc");

var $6lJZW = parcelRequire("6lJZW");

var $4RzNY = parcelRequire("4RzNY");
/**
 * Replace a method in an object with a wrapped version of itself.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */ function $2582f67441a9158e$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    const original = source[name];
    const wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === 'function') $2582f67441a9158e$export$5c1499e2e5d010ae(wrapped, original);
    source[name] = wrapped;
}
/**
 * Defines a non-enumerable property on the given object.
 *
 * @param obj The object on which to set the property
 * @param name The name of the property to be set
 * @param value The value to which to set the property
 */ function $2582f67441a9158e$export$e73679ffaf56810e(obj, name, value) {
    try {
        Object.defineProperty(obj, name, {
            // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
            value: value,
            writable: true,
            configurable: true
        });
    } catch (o_O) {
        (0, $fUFQt.DEBUG_BUILD) && (0, $6lJZW.logger).log(`Failed to add non-enumerable property "${name}" to object`, obj);
    }
}
/**
 * Remembers the original function on the wrapped function and
 * patches up the prototype.
 *
 * @param wrapped the wrapper function
 * @param original the original function that gets wrapped
 */ function $2582f67441a9158e$export$5c1499e2e5d010ae(wrapped, original) {
    try {
        const proto = original.prototype || {};
        wrapped.prototype = original.prototype = proto;
        $2582f67441a9158e$export$e73679ffaf56810e(wrapped, '__sentry_original__', original);
    } catch (o_O) {} // eslint-disable-line no-empty
}
/**
 * This extracts the original function if available.  See
 * `markFunctionWrapped` for more information.
 *
 * @param func the function to unwrap
 * @returns the unwrapped version of the function if available.
 */ function $2582f67441a9158e$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
/**
 * Encodes given object into url-friendly format
 *
 * @param object An object that contains serializable values
 * @returns string Encoded
 */ function $2582f67441a9158e$export$9ef804feabbcbaf1(object) {
    return Object.keys(object).map((key)=>`${encodeURIComponent(key)}=${encodeURIComponent(object[key])}`).join('&');
}
/**
 * Transforms any `Error` or `Event` into a plain object with all of their enumerable properties, and some of their
 * non-enumerable properties attached.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 * @returns An Event or Error turned into an object - or the value argurment itself, when value is neither an Event nor
 *  an Error.
 */ function $2582f67441a9158e$export$62ff257738bf57f5(value) {
    if ((0, $2Jaqc.isError)(value)) return {
        message: value.message,
        name: value.name,
        stack: value.stack,
        ...$2582f67441a9158e$var$getOwnProperties(value)
    };
    else if ((0, $2Jaqc.isEvent)(value)) {
        const newObj = {
            type: value.type,
            target: $2582f67441a9158e$var$serializeEventTarget(value.target),
            currentTarget: $2582f67441a9158e$var$serializeEventTarget(value.currentTarget),
            ...$2582f67441a9158e$var$getOwnProperties(value)
        };
        if (typeof CustomEvent !== 'undefined' && (0, $2Jaqc.isInstanceOf)(value, CustomEvent)) newObj.detail = value.detail;
        return newObj;
    } else return value;
}
/** Creates a string representation of the target of an `Event` object */ function $2582f67441a9158e$var$serializeEventTarget(target) {
    try {
        return (0, $2Jaqc.isElement)(target) ? (0, $1Pi8W.htmlTreeAsString)(target) : Object.prototype.toString.call(target);
    } catch (_oO) {
        return '<unknown>';
    }
}
/** Filters out all but an object's own properties */ function $2582f67441a9158e$var$getOwnProperties(obj) {
    if (typeof obj === 'object' && obj !== null) {
        const extractedProps = {};
        for(const property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
        return extractedProps;
    } else return {};
}
/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */ function $2582f67441a9158e$export$b0244d5063c0b61b(exception, maxLength = 40) {
    const keys = Object.keys($2582f67441a9158e$export$62ff257738bf57f5(exception));
    keys.sort();
    if (!keys.length) return '[object has no keys]';
    if (keys[0].length >= maxLength) return (0, $4RzNY.truncate)(keys[0], maxLength);
    for(let includedKeys = keys.length; includedKeys > 0; includedKeys--){
        const serialized = keys.slice(0, includedKeys).join(', ');
        if (serialized.length > maxLength) continue;
        if (includedKeys === keys.length) return serialized;
        return (0, $4RzNY.truncate)(serialized, maxLength);
    }
    return '';
}
/**
 * Given any object, return a new object having removed all fields whose value was `undefined`.
 * Works recursively on objects and arrays.
 *
 * Attention: This function keeps circular references in the returned object.
 */ function $2582f67441a9158e$export$d25f2688db1bb433(inputValue) {
    // This map keeps track of what already visited nodes map to.
    // Our Set - based memoBuilder doesn't work here because we want to the output object to have the same circular
    // references as the input object.
    const memoizationMap = new Map();
    // This function just proxies `_dropUndefinedKeys` to keep the `memoBuilder` out of this function's API
    return $2582f67441a9158e$var$_dropUndefinedKeys(inputValue, memoizationMap);
}
function $2582f67441a9158e$var$_dropUndefinedKeys(inputValue, memoizationMap) {
    if ($2582f67441a9158e$var$isPojo(inputValue)) {
        // If this node has already been visited due to a circular reference, return the object it was mapped to in the new object
        const memoVal = memoizationMap.get(inputValue);
        if (memoVal !== undefined) return memoVal;
        const returnValue = {};
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue);
        for (const key of Object.keys(inputValue))if (typeof inputValue[key] !== 'undefined') returnValue[key] = $2582f67441a9158e$var$_dropUndefinedKeys(inputValue[key], memoizationMap);
        return returnValue;
    }
    if (Array.isArray(inputValue)) {
        // If this node has already been visited due to a circular reference, return the array it was mapped to in the new object
        const memoVal = memoizationMap.get(inputValue);
        if (memoVal !== undefined) return memoVal;
        const returnValue = [];
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue);
        inputValue.forEach((item)=>{
            returnValue.push($2582f67441a9158e$var$_dropUndefinedKeys(item, memoizationMap));
        });
        return returnValue;
    }
    return inputValue;
}
function $2582f67441a9158e$var$isPojo(input) {
    if (!(0, $2Jaqc.isPlainObject)(input)) return false;
    try {
        const name = Object.getPrototypeOf(input).constructor.name;
        return !name || name === 'Object';
    } catch (e) {
        return true;
    }
}
/**
 * Ensure that something is an object.
 *
 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
 *
 * @param wat The subject of the objectification
 * @returns A version of `wat` which can safely be used with `Object` class methods
 */ function $2582f67441a9158e$export$92b78acdbe066b6b(wat) {
    let objectified;
    switch(true){
        case wat === undefined || wat === null:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === 'symbol' || typeof wat === 'bigint':
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $2Jaqc.isPrimitive)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}

});
parcelRegister("1Pi8W", function(module, exports) {
$parcel$export(module.exports, "htmlTreeAsString", () => $1548a0b8d71bedbf$export$5647df6b7814ac86);
$parcel$export(module.exports, "getLocationHref", () => $1548a0b8d71bedbf$export$1cfafeee2987818b);
$parcel$export(module.exports, "getComponentName", () => $1548a0b8d71bedbf$export$26727cfcc4d7e0fc);

var $2Jaqc = parcelRequire("2Jaqc");

var $aFn2S = parcelRequire("aFn2S");
// eslint-disable-next-line deprecation/deprecation
const $1548a0b8d71bedbf$var$WINDOW = (0, $aFn2S.getGlobalObject)();
const $1548a0b8d71bedbf$var$DEFAULT_MAX_STRING_LENGTH = 80;
/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $1548a0b8d71bedbf$export$5647df6b7814ac86(elem, options = {}) {
    if (!elem) return '<unknown>';
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        let currentElem = elem;
        const MAX_TRAVERSE_HEIGHT = 5;
        const out = [];
        let height = 0;
        let len = 0;
        const separator = ' > ';
        const sepLength = separator.length;
        let nextStr;
        const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        const maxStringLength = !Array.isArray(options) && options.maxStringLength || $1548a0b8d71bedbf$var$DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $1548a0b8d71bedbf$var$_htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds maxStringLength
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === 'html' || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (_oO) {
        return '<unknown>';
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $1548a0b8d71bedbf$var$_htmlElementAsString(el, keyAttrs) {
    const elem = el;
    const out = [];
    let className;
    let classes;
    let key;
    let attr;
    let i;
    if (!elem || !elem.tagName) return '';
    // @ts-expect-error WINDOW has HTMLElement
    if ($1548a0b8d71bedbf$var$WINDOW.HTMLElement) {
        // If using the component name annotation plugin, this value may be available on the DOM node
        if (elem instanceof HTMLElement && elem.dataset && elem.dataset['sentryComponent']) return elem.dataset['sentryComponent'];
    }
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    const keyAttrPairs = keyAttrs && keyAttrs.length ? keyAttrs.filter((keyAttr)=>elem.getAttribute(keyAttr)).map((keyAttr)=>[
            keyAttr,
            elem.getAttribute(keyAttr)
        ]) : null;
    if (keyAttrPairs && keyAttrPairs.length) keyAttrPairs.forEach((keyAttrPair)=>{
        out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
    else {
        if (elem.id) out.push(`#${elem.id}`);
        // eslint-disable-next-line prefer-const
        className = elem.className;
        if (className && (0, $2Jaqc.isString)(className)) {
            classes = className.split(/\s+/);
            for(i = 0; i < classes.length; i++)out.push(`.${classes[i]}`);
        }
    }
    const allowedAttrs = [
        'aria-label',
        'type',
        'name',
        'title',
        'alt'
    ];
    for(i = 0; i < allowedAttrs.length; i++){
        key = allowedAttrs[i];
        attr = elem.getAttribute(key);
        if (attr) out.push(`[${key}="${attr}"]`);
    }
    return out.join('');
}
/**
 * A safe form of location.href
 */ function $1548a0b8d71bedbf$export$1cfafeee2987818b() {
    try {
        return $1548a0b8d71bedbf$var$WINDOW.document.location.href;
    } catch (oO) {
        return '';
    }
}
/**
 * Gets a DOM element by using document.querySelector.
 *
 * This wrapper will first check for the existance of the function before
 * actually calling it so that we don't have to take care of this check,
 * every time we want to access the DOM.
 *
 * Reason: DOM/querySelector is not available in all environments.
 *
 * We have to cast to any because utils can be consumed by a variety of environments,
 * and we don't want to break TS users. If you know what element will be selected by
 * `document.querySelector`, specify it as part of the generic call. For example,
 * `const element = getDomElement<Element>('selector');`
 *
 * @param selector the selector string passed on to document.querySelector
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $1548a0b8d71bedbf$export$c660c1f3ab49225c(selector) {
    if ($1548a0b8d71bedbf$var$WINDOW.document && $1548a0b8d71bedbf$var$WINDOW.document.querySelector) return $1548a0b8d71bedbf$var$WINDOW.document.querySelector(selector);
    return null;
}
/**
 * Given a DOM element, traverses up the tree until it finds the first ancestor node
 * that has the `data-sentry-component` attribute. This attribute is added at build-time
 * by projects that have the component name annotation plugin installed.
 *
 * @returns a string representation of the component for the provided DOM element, or `null` if not found
 */ function $1548a0b8d71bedbf$export$26727cfcc4d7e0fc(elem) {
    // @ts-expect-error WINDOW has HTMLElement
    if (!$1548a0b8d71bedbf$var$WINDOW.HTMLElement) return null;
    let currentElem = elem;
    const MAX_TRAVERSE_HEIGHT = 5;
    for(let i = 0; i < MAX_TRAVERSE_HEIGHT; i++){
        if (!currentElem) return null;
        if (currentElem instanceof HTMLElement && currentElem.dataset['sentryComponent']) return currentElem.dataset['sentryComponent'];
        currentElem = currentElem.parentNode;
    }
    return null;
}

});

parcelRegister("4RzNY", function(module, exports) {
$parcel$export(module.exports, "truncate", () => $38a7e2d0786ee260$export$6a506b36fdea397d);
$parcel$export(module.exports, "snipLine", () => $38a7e2d0786ee260$export$4215662d762d6f9d);
$parcel$export(module.exports, "safeJoin", () => $38a7e2d0786ee260$export$465e9d514283d4fd);
$parcel$export(module.exports, "stringMatchesSomePattern", () => $38a7e2d0786ee260$export$a7a5ec66062ea5d);

var $2Jaqc = parcelRequire("2Jaqc");
/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */ function $38a7e2d0786ee260$export$6a506b36fdea397d(str, max = 0) {
    if (typeof str !== 'string' || max === 0) return str;
    return str.length <= max ? str : `${str.slice(0, max)}...`;
}
/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */ function $38a7e2d0786ee260$export$4215662d762d6f9d(line, colno) {
    let newLine = line;
    const lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    let start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    let end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = `'{snip} ${newLine}`;
    if (end < lineLength) newLine += ' {snip}';
    return newLine;
}
/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $38a7e2d0786ee260$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return '';
    const output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(let i = 0; i < input.length; i++){
        const value = input[i];
        try {
            // This is a hack to fix a Vue3-specific bug that causes an infinite loop of
            // console warnings. This happens when a Vue template is rendered with
            // an undeclared variable, which we try to stringify, ultimately causing
            // Vue to issue another warning which repeats indefinitely.
            // see: https://github.com/getsentry/sentry-javascript/pull/8981
            if ((0, $2Jaqc.isVueViewModel)(value)) output.push('[VueViewModel]');
            else output.push(String(value));
        } catch (e) {
            output.push('[value cannot be serialized]');
        }
    }
    return output.join(delimiter);
}
/**
 * Checks if the given value matches a regex or string
 *
 * @param value The string to test
 * @param pattern Either a regex or a string against which `value` will be matched
 * @param requireExactStringMatch If true, `value` must match `pattern` exactly. If false, `value` will match
 * `pattern` if it contains `pattern`. Only applies to string-type patterns.
 */ function $38a7e2d0786ee260$export$cdded5b28a5f8c6d(value, pattern, requireExactStringMatch = false) {
    if (!(0, $2Jaqc.isString)(value)) return false;
    if ((0, $2Jaqc.isRegExp)(pattern)) return pattern.test(value);
    if ((0, $2Jaqc.isString)(pattern)) return requireExactStringMatch ? value === pattern : value.includes(pattern);
    return false;
}
/**
 * Test the given string against an array of strings and regexes. By default, string matching is done on a
 * substring-inclusion basis rather than a strict equality basis
 *
 * @param testString The string to test
 * @param patterns The patterns against which to test the string
 * @param requireExactStringMatch If true, `testString` must match one of the given string patterns exactly in order to
 * count. If false, `testString` will match a string pattern if it contains that pattern.
 * @returns
 */ function $38a7e2d0786ee260$export$a7a5ec66062ea5d(testString, patterns = [], requireExactStringMatch = false) {
    return patterns.some((pattern)=>$38a7e2d0786ee260$export$cdded5b28a5f8c6d(testString, pattern, requireExactStringMatch));
}

});



parcelRegister("b2zyj", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_ENVIRONMENT", () => $809b759bb94cfae6$export$849dbeeeda01ae98);
const $809b759bb94cfae6$export$849dbeeeda01ae98 = 'production';

});

parcelRegister("fZ2r3", function(module, exports) {
$parcel$export(module.exports, "DEBUG_BUILD", () => $ba2e71206df7669d$export$16a28057038b10ef);
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $ba2e71206df7669d$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;

});

parcelRegister("kINbm", function(module, exports) {
$parcel$export(module.exports, "Hub", () => $f15e114438008602$export$8c41bb232f1008b1);
$parcel$export(module.exports, "getCurrentHub", () => $f15e114438008602$export$a07cdf6544bbd7c);
$parcel$export(module.exports, "getIsolationScope", () => $f15e114438008602$export$68f3af03034c9e90);
$parcel$export(module.exports, "runWithAsyncContext", () => $f15e114438008602$export$70d775fb1f267027);

var $6lJZW = parcelRequire("6lJZW");
var $gv1sw = parcelRequire("gv1sw");
var $aFn2S = parcelRequire("aFn2S");
var $2Jaqc = parcelRequire("2Jaqc");
var $kgI9H = parcelRequire("kgI9H");

var $b2zyj = parcelRequire("b2zyj");

var $fZ2r3 = parcelRequire("fZ2r3");

var $31p7m = parcelRequire("31p7m");

var $bHHGA = parcelRequire("bHHGA");

var $7IBdF = parcelRequire("7IBdF");
/**
 * API compatibility version of this hub.
 *
 * WARNING: This number should only be increased when the global interface
 * changes and new methods are introduced.
 *
 * @hidden
 */ const $f15e114438008602$export$24a86ef7798177e4 = parseFloat((0, $7IBdF.SDK_VERSION));
/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */ const $f15e114438008602$var$DEFAULT_BREADCRUMBS = 100;
/**
 * @deprecated The `Hub` class will be removed in version 8 of the SDK in favour of `Scope` and `Client` objects.
 *
 * If you previously used the `Hub` class directly, replace it with `Scope` and `Client` objects. More information:
 * - [Multiple Sentry Instances](https://docs.sentry.io/platforms/javascript/best-practices/multiple-sentry-instances/)
 * - [Browser Extensions](https://docs.sentry.io/platforms/javascript/best-practices/browser-extensions/)
 *
 * Some of our APIs are typed with the Hub class instead of the interface (e.g. `getCurrentHub`). Most of them are deprecated
 * themselves and will also be removed in version 8. More information:
 * - [Migration Guide](https://github.com/getsentry/sentry-javascript/blob/develop/MIGRATION.md#deprecate-hub)
 */ // eslint-disable-next-line deprecation/deprecation
class $f15e114438008602$export$8c41bb232f1008b1 {
    /** Is a {@link Layer}[] containing the client and scope */ /** Contains the last event id of a captured event.  */ /**
   * Creates a new instance of the hub, will push one {@link Layer} into the
   * internal stack on creation.
   *
   * @param client bound to the hub.
   * @param scope bound to the hub.
   * @param version number, higher number means higher priority.
   *
   * @deprecated Instantiation of Hub objects is deprecated and the constructor will be removed in version 8 of the SDK.
   *
   * If you are currently using the Hub for multi-client use like so:
   *
   * ```
   * // OLD
   * const hub = new Hub();
   * hub.bindClient(client);
   * makeMain(hub)
   * ```
   *
   * instead initialize the client as follows:
   *
   * ```
   * // NEW
   * Sentry.withIsolationScope(() => {
   *    Sentry.setCurrentClient(client);
   *    client.init();
   * });
   * ```
   *
   * If you are using the Hub to capture events like so:
   *
   * ```
   * // OLD
   * const client = new Client();
   * const hub = new Hub(client);
   * hub.captureException()
   * ```
   *
   * instead capture isolated events as follows:
   *
   * ```
   * // NEW
   * const client = new Client();
   * const scope = new Scope();
   * scope.setClient(client);
   * scope.captureException();
   * ```
   */ constructor(client, scope, isolationScope, _version = $f15e114438008602$export$24a86ef7798177e4){
        this._version = _version;
        let assignedScope;
        if (!scope) {
            assignedScope = new (0, $31p7m.Scope)();
            assignedScope.setClient(client);
        } else assignedScope = scope;
        let assignedIsolationScope;
        if (!isolationScope) {
            assignedIsolationScope = new (0, $31p7m.Scope)();
            assignedIsolationScope.setClient(client);
        } else assignedIsolationScope = isolationScope;
        this._stack = [
            {
                scope: assignedScope
            }
        ];
        if (client) // eslint-disable-next-line deprecation/deprecation
        this.bindClient(client);
        this._isolationScope = assignedIsolationScope;
    }
    /**
   * Checks if this hub's version is older than the given version.
   *
   * @param version A version number to compare to.
   * @return True if the given version is newer; otherwise false.
   *
   * @deprecated This will be removed in v8.
   */ isOlderThan(version) {
        return this._version < version;
    }
    /**
   * This binds the given client to the current scope.
   * @param client An SDK client (client) instance.
   *
   * @deprecated Use `initAndBind()` directly, or `setCurrentClient()` and/or `client.init()` instead.
   */ bindClient(client) {
        // eslint-disable-next-line deprecation/deprecation
        const top = this.getStackTop();
        top.client = client;
        top.scope.setClient(client);
        // eslint-disable-next-line deprecation/deprecation
        if (client && client.setupIntegrations) // eslint-disable-next-line deprecation/deprecation
        client.setupIntegrations();
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `withScope` instead.
   */ pushScope() {
        // We want to clone the content of prev scope
        // eslint-disable-next-line deprecation/deprecation
        const scope = this.getScope().clone();
        // eslint-disable-next-line deprecation/deprecation
        this.getStack().push({
            // eslint-disable-next-line deprecation/deprecation
            client: this.getClient(),
            scope: scope
        });
        return scope;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `withScope` instead.
   */ popScope() {
        // eslint-disable-next-line deprecation/deprecation
        if (this.getStack().length <= 1) return false;
        // eslint-disable-next-line deprecation/deprecation
        return !!this.getStack().pop();
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.withScope()` instead.
   */ withScope(callback) {
        // eslint-disable-next-line deprecation/deprecation
        const scope = this.pushScope();
        let maybePromiseResult;
        try {
            maybePromiseResult = callback(scope);
        } catch (e) {
            // eslint-disable-next-line deprecation/deprecation
            this.popScope();
            throw e;
        }
        if ((0, $2Jaqc.isThenable)(maybePromiseResult)) // @ts-expect-error - isThenable returns the wrong type
        return maybePromiseResult.then((res)=>{
            // eslint-disable-next-line deprecation/deprecation
            this.popScope();
            return res;
        }, (e)=>{
            // eslint-disable-next-line deprecation/deprecation
            this.popScope();
            throw e;
        });
        // eslint-disable-next-line deprecation/deprecation
        this.popScope();
        return maybePromiseResult;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.getClient()` instead.
   */ getClient() {
        // eslint-disable-next-line deprecation/deprecation
        return this.getStackTop().client;
    }
    /**
   * Returns the scope of the top stack.
   *
   * @deprecated Use `Sentry.getCurrentScope()` instead.
   */ getScope() {
        // eslint-disable-next-line deprecation/deprecation
        return this.getStackTop().scope;
    }
    /**
   * @deprecated Use `Sentry.getIsolationScope()` instead.
   */ getIsolationScope() {
        return this._isolationScope;
    }
    /**
   * Returns the scope stack for domains or the process.
   * @deprecated This will be removed in v8.
   */ getStack() {
        return this._stack;
    }
    /**
   * Returns the topmost scope layer in the order domain > local > process.
   * @deprecated This will be removed in v8.
   */ getStackTop() {
        return this._stack[this._stack.length - 1];
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.captureException()` instead.
   */ captureException(exception, hint) {
        const eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, $kgI9H.uuid4)();
        const syntheticException = new Error('Sentry syntheticException');
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().captureException(exception, {
            originalException: exception,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        });
        return eventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use  `Sentry.captureMessage()` instead.
   */ captureMessage(message, // eslint-disable-next-line deprecation/deprecation
    level, hint) {
        const eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, $kgI9H.uuid4)();
        const syntheticException = new Error(message);
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().captureMessage(message, level, {
            originalException: message,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        });
        return eventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.captureEvent()` instead.
   */ captureEvent(event, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $kgI9H.uuid4)();
        if (!event.type) this._lastEventId = eventId;
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().captureEvent(event, {
            ...hint,
            event_id: eventId
        });
        return eventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated This will be removed in v8.
   */ lastEventId() {
        return this._lastEventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.addBreadcrumb()` instead.
   */ addBreadcrumb(breadcrumb, hint) {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        if (!client) return;
        const { beforeBreadcrumb: beforeBreadcrumb = null, maxBreadcrumbs: maxBreadcrumbs = $f15e114438008602$var$DEFAULT_BREADCRUMBS } = client.getOptions && client.getOptions() || {};
        if (maxBreadcrumbs <= 0) return;
        const timestamp = (0, $gv1sw.dateTimestampInSeconds)();
        const mergedBreadcrumb = {
            timestamp: timestamp,
            ...breadcrumb
        };
        const finalBreadcrumb = beforeBreadcrumb ? (0, $6lJZW.consoleSandbox)(()=>beforeBreadcrumb(mergedBreadcrumb, hint)) : mergedBreadcrumb;
        if (finalBreadcrumb === null) return;
        if (client.emit) client.emit('beforeAddBreadcrumb', finalBreadcrumb, hint);
        // TODO(v8): I know this comment doesn't make much sense because the hub will be deprecated but I still wanted to
        // write it down. In theory, we would have to add the breadcrumbs to the isolation scope here, however, that would
        // duplicate all of the breadcrumbs. There was the possibility of adding breadcrumbs to both, the isolation scope
        // and the normal scope, and deduplicating it down the line in the event processing pipeline. However, that would
        // have been very fragile, because the breadcrumb objects would have needed to keep their identity all throughout
        // the event processing pipeline.
        // In the new implementation, the top level `Sentry.addBreadcrumb()` should ONLY write to the isolation scope.
        scope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setUser()` instead.
   */ setUser(user) {
        // TODO(v8): The top level `Sentry.setUser()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setUser(user);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setUser(user);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setTags()` instead.
   */ setTags(tags) {
        // TODO(v8): The top level `Sentry.setTags()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setTags(tags);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setTags(tags);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setExtras()` instead.
   */ setExtras(extras) {
        // TODO(v8): The top level `Sentry.setExtras()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setExtras(extras);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setExtras(extras);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setTag()` instead.
   */ setTag(key, value) {
        // TODO(v8): The top level `Sentry.setTag()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setTag(key, value);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setTag(key, value);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setExtra()` instead.
   */ setExtra(key, extra) {
        // TODO(v8): The top level `Sentry.setExtra()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setExtra(key, extra);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setExtra(key, extra);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setContext()` instead.
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setContext(name, context) {
        // TODO(v8): The top level `Sentry.setContext()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setContext(name, context);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setContext(name, context);
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `getScope()` directly.
   */ configureScope(callback) {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        if (client) callback(scope);
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line deprecation/deprecation
    run(callback) {
        // eslint-disable-next-line deprecation/deprecation
        const oldHub = $f15e114438008602$export$4188a14ad302d1bc(this);
        try {
            callback(this);
        } finally{
            // eslint-disable-next-line deprecation/deprecation
            $f15e114438008602$export$4188a14ad302d1bc(oldHub);
        }
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.getClient().getIntegrationByName()` instead.
   */ getIntegration(integration) {
        // eslint-disable-next-line deprecation/deprecation
        const client = this.getClient();
        if (!client) return null;
        try {
            // eslint-disable-next-line deprecation/deprecation
            return client.getIntegration(integration);
        } catch (_oO) {
            (0, $fZ2r3.DEBUG_BUILD) && (0, $6lJZW.logger).warn(`Cannot retrieve integration ${integration.id} from the current Hub`);
            return null;
        }
    }
    /**
   * Starts a new `Transaction` and returns it. This is the entry point to manual tracing instrumentation.
   *
   * A tree structure can be built by adding child spans to the transaction, and child spans to other spans. To start a
   * new child span within the transaction or any span, call the respective `.startChild()` method.
   *
   * Every child span must be finished before the transaction is finished, otherwise the unfinished spans are discarded.
   *
   * The transaction must be finished with a call to its `.end()` method, at which point the transaction with all its
   * finished child spans will be sent to Sentry.
   *
   * @param context Properties of the new `Transaction`.
   * @param customSamplingContext Information given to the transaction sampling function (along with context-dependent
   * default values). See {@link Options.tracesSampler}.
   *
   * @returns The transaction which was just started
   *
   * @deprecated Use `startSpan()`, `startSpanManual()` or `startInactiveSpan()` instead.
   */ startTransaction(context, customSamplingContext) {
        const result = this._callExtensionMethod('startTransaction', context, customSamplingContext);
        if ((0, $fZ2r3.DEBUG_BUILD) && !result) {
            // eslint-disable-next-line deprecation/deprecation
            const client = this.getClient();
            if (!client) (0, $6lJZW.logger).warn("Tracing extension 'startTransaction' is missing. You should 'init' the SDK before calling 'startTransaction'");
            else (0, $6lJZW.logger).warn(`Tracing extension 'startTransaction' has not been added. Call 'addTracingExtensions' before calling 'init':
Sentry.addTracingExtensions();
Sentry.init({...});
`);
        }
        return result;
    }
    /**
   * @inheritDoc
   * @deprecated Use `spanToTraceHeader()` instead.
   */ traceHeaders() {
        return this._callExtensionMethod('traceHeaders');
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use top level `captureSession` instead.
   */ captureSession(endSession = false) {
        // both send the update and pull the session from the scope
        if (endSession) // eslint-disable-next-line deprecation/deprecation
        return this.endSession();
        // only send the update
        this._sendSessionUpdate();
    }
    /**
   * @inheritDoc
   * @deprecated Use top level `endSession` instead.
   */ endSession() {
        // eslint-disable-next-line deprecation/deprecation
        const layer = this.getStackTop();
        const scope = layer.scope;
        const session = scope.getSession();
        if (session) (0, $bHHGA.closeSession)(session);
        this._sendSessionUpdate();
        // the session is over; take it off of the scope
        scope.setSession();
    }
    /**
   * @inheritDoc
   * @deprecated Use top level `startSession` instead.
   */ startSession(context) {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        const { release: release, environment: environment = (0, $b2zyj.DEFAULT_ENVIRONMENT) } = client && client.getOptions() || {};
        // Will fetch userAgent if called from browser sdk
        const { userAgent: userAgent } = (0, $aFn2S.GLOBAL_OBJ).navigator || {};
        const session = (0, $bHHGA.makeSession)({
            release: release,
            environment: environment,
            user: scope.getUser(),
            ...userAgent && {
                userAgent: userAgent
            },
            ...context
        });
        // End existing session if there's one
        const currentSession = scope.getSession && scope.getSession();
        if (currentSession && currentSession.status === 'ok') (0, $bHHGA.updateSession)(currentSession, {
            status: 'exited'
        });
        // eslint-disable-next-line deprecation/deprecation
        this.endSession();
        // Afterwards we set the new session on the scope
        scope.setSession(session);
        return session;
    }
    /**
   * Returns if default PII should be sent to Sentry and propagated in ourgoing requests
   * when Tracing is used.
   *
   * @deprecated Use top-level `getClient().getOptions().sendDefaultPii` instead. This function
   * only unnecessarily increased API surface but only wrapped accessing the option.
   */ shouldSendDefaultPii() {
        // eslint-disable-next-line deprecation/deprecation
        const client = this.getClient();
        const options = client && client.getOptions();
        return Boolean(options && options.sendDefaultPii);
    }
    /**
   * Sends the current Session on the scope
   */ _sendSessionUpdate() {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        const session = scope.getSession();
        if (session && client && client.captureSession) client.captureSession(session);
    }
    /**
   * Calls global extension method and binding current instance to the function call
   */ // @ts-expect-error Function lacks ending return statement and return type does not include 'undefined'. ts(2366)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    _callExtensionMethod(method, ...args) {
        const carrier = $f15e114438008602$export$19eade501500c6c1();
        const sentry = carrier.__SENTRY__;
        if (sentry && sentry.extensions && typeof sentry.extensions[method] === 'function') return sentry.extensions[method].apply(this, args);
        (0, $fZ2r3.DEBUG_BUILD) && (0, $6lJZW.logger).warn(`Extension method ${method} couldn't be found, doing nothing.`);
    }
}
/**
 * Returns the global shim registry.
 *
 * FIXME: This function is problematic, because despite always returning a valid Carrier,
 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
 **/ function $f15e114438008602$export$19eade501500c6c1() {
    (0, $aFn2S.GLOBAL_OBJ).__SENTRY__ = (0, $aFn2S.GLOBAL_OBJ).__SENTRY__ || {
        extensions: {},
        hub: undefined
    };
    return 0, $aFn2S.GLOBAL_OBJ;
}
/**
 * Replaces the current main hub with the passed one on the global object
 *
 * @returns The old replaced hub
 *
 * @deprecated Use `setCurrentClient()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
function $f15e114438008602$export$4188a14ad302d1bc(hub) {
    const registry = $f15e114438008602$export$19eade501500c6c1();
    const oldHub = $f15e114438008602$export$bfa8a924a84a76b7(registry);
    $f15e114438008602$export$849f05434e95d2f2(registry, hub);
    return oldHub;
}
/**
 * Returns the default hub instance.
 *
 * If a hub is already registered in the global carrier but this module
 * contains a more recent version, it replaces the registered version.
 * Otherwise, the currently registered hub will be returned.
 *
 * @deprecated Use the respective replacement method directly instead.
 */ // eslint-disable-next-line deprecation/deprecation
function $f15e114438008602$export$a07cdf6544bbd7c() {
    // Get main carrier (global for every environment)
    const registry = $f15e114438008602$export$19eade501500c6c1();
    if (registry.__SENTRY__ && registry.__SENTRY__.acs) {
        const hub = registry.__SENTRY__.acs.getCurrentHub();
        if (hub) return hub;
    }
    // Return hub that lives on a global object
    return $f15e114438008602$var$getGlobalHub(registry);
}
/**
 * Get the currently active isolation scope.
 * The isolation scope is active for the current exection context,
 * meaning that it will remain stable for the same Hub.
 */ function $f15e114438008602$export$68f3af03034c9e90() {
    // eslint-disable-next-line deprecation/deprecation
    return $f15e114438008602$export$a07cdf6544bbd7c().getIsolationScope();
}
// eslint-disable-next-line deprecation/deprecation
function $f15e114438008602$var$getGlobalHub(registry = $f15e114438008602$export$19eade501500c6c1()) {
    // If there's no hub, or its an old API, assign a new one
    if (!$f15e114438008602$var$hasHubOnCarrier(registry) || // eslint-disable-next-line deprecation/deprecation
    $f15e114438008602$export$bfa8a924a84a76b7(registry).isOlderThan($f15e114438008602$export$24a86ef7798177e4)) // eslint-disable-next-line deprecation/deprecation
    $f15e114438008602$export$849f05434e95d2f2(registry, new $f15e114438008602$export$8c41bb232f1008b1());
    // Return hub that lives on a global object
    return $f15e114438008602$export$bfa8a924a84a76b7(registry);
}
/**
 * @private Private API with no semver guarantees!
 *
 * If the carrier does not contain a hub, a new hub is created with the global hub client and scope.
 */ // eslint-disable-next-line deprecation/deprecation
function $f15e114438008602$export$236689a79f5aa020(carrier, parent = $f15e114438008602$var$getGlobalHub()) {
    // If there's no hub on current domain, or it's an old API, assign a new one
    if (!$f15e114438008602$var$hasHubOnCarrier(carrier) || // eslint-disable-next-line deprecation/deprecation
    $f15e114438008602$export$bfa8a924a84a76b7(carrier).isOlderThan($f15e114438008602$export$24a86ef7798177e4)) {
        // eslint-disable-next-line deprecation/deprecation
        const client = parent.getClient();
        // eslint-disable-next-line deprecation/deprecation
        const scope = parent.getScope();
        // eslint-disable-next-line deprecation/deprecation
        const isolationScope = parent.getIsolationScope();
        // eslint-disable-next-line deprecation/deprecation
        $f15e114438008602$export$849f05434e95d2f2(carrier, new $f15e114438008602$export$8c41bb232f1008b1(client, scope.clone(), isolationScope.clone()));
    }
}
/**
 * @private Private API with no semver guarantees!
 *
 * Sets the global async context strategy
 */ function $f15e114438008602$export$774ae0e6b6e444ca(strategy) {
    // Get main carrier (global for every environment)
    const registry = $f15e114438008602$export$19eade501500c6c1();
    registry.__SENTRY__ = registry.__SENTRY__ || {};
    registry.__SENTRY__.acs = strategy;
}
/**
 * Runs the supplied callback in its own async context. Async Context strategies are defined per SDK.
 *
 * @param callback The callback to run in its own async context
 * @param options Options to pass to the async context strategy
 * @returns The result of the callback
 */ function $f15e114438008602$export$70d775fb1f267027(callback, options = {}) {
    const registry = $f15e114438008602$export$19eade501500c6c1();
    if (registry.__SENTRY__ && registry.__SENTRY__.acs) return registry.__SENTRY__.acs.runWithAsyncContext(callback, options);
    // if there was no strategy, fallback to just calling the callback
    return callback();
}
/**
 * This will tell whether a carrier has a hub on it or not
 * @param carrier object
 */ function $f15e114438008602$var$hasHubOnCarrier(carrier) {
    return !!(carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub);
}
/**
 * This will create a new {@link Hub} and add to the passed object on
 * __SENTRY__.hub.
 * @param carrier object
 * @hidden
 */ // eslint-disable-next-line deprecation/deprecation
function $f15e114438008602$export$bfa8a924a84a76b7(carrier) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $aFn2S.getGlobalSingleton)('hub', ()=>new $f15e114438008602$export$8c41bb232f1008b1(), carrier);
}
/**
 * This will set passed {@link Hub} on the passed object's __SENTRY__.hub attribute
 * @param carrier object
 * @param hub Hub
 * @returns A boolean indicating success or failure
 */ // eslint-disable-next-line deprecation/deprecation
function $f15e114438008602$export$849f05434e95d2f2(carrier, hub) {
    if (!carrier) return false;
    const __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    __SENTRY__.hub = hub;
    return true;
}

});
parcelRegister("31p7m", function(module, exports) {
$parcel$export(module.exports, "Scope", () => $2334f2efc7e25317$export$775b6bb06e53a214);
$parcel$export(module.exports, "getGlobalScope", () => $2334f2efc7e25317$export$aa55d5ab8e05984f);

var $gv1sw = parcelRequire("gv1sw");
var $2Jaqc = parcelRequire("2Jaqc");
var $6lJZW = parcelRequire("6lJZW");
var $kgI9H = parcelRequire("kgI9H");

var $1feQE = parcelRequire("1feQE");

var $bHHGA = parcelRequire("bHHGA");

var $gqwnB = parcelRequire("gqwnB");
/**
 * Default value for maximum number of breadcrumbs added to an event.
 */ const $2334f2efc7e25317$var$DEFAULT_MAX_BREADCRUMBS = 100;
/**
 * The global scope is kept in this module.
 * When accessing this via `getGlobalScope()` we'll make sure to set one if none is currently present.
 */ let $2334f2efc7e25317$var$globalScope;
/**
 * Holds additional event information. {@link Scope.applyToEvent} will be
 * called by the client before an event will be sent.
 */ class $2334f2efc7e25317$export$775b6bb06e53a214 {
    /** Flag if notifying is happening. */ /** Callback for client to receive scope changes. */ /** Callback list that will be called after {@link applyToEvent}. */ /** Array of breadcrumbs. */ /** User */ /** Tags */ /** Extra */ /** Contexts */ /** Attachments */ /** Propagation Context for distributed tracing */ /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */ /** Fingerprint */ /** Severity */ // eslint-disable-next-line deprecation/deprecation
    /**
   * Transaction Name
   */ /** Span */ /** Session */ /** Request Mode Session Status */ /** The client on this scope */ // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
    constructor(){
        this._notifyingListeners = false;
        this._scopeListeners = [];
        this._eventProcessors = [];
        this._breadcrumbs = [];
        this._attachments = [];
        this._user = {};
        this._tags = {};
        this._extra = {};
        this._contexts = {};
        this._sdkProcessingMetadata = {};
        this._propagationContext = $2334f2efc7e25317$var$generatePropagationContext();
    }
    /**
   * Inherit values from the parent scope.
   * @deprecated Use `scope.clone()` and `new Scope()` instead.
   */ static clone(scope) {
        return scope ? scope.clone() : new $2334f2efc7e25317$export$775b6bb06e53a214();
    }
    /**
   * Clone this scope instance.
   */ clone() {
        const newScope = new $2334f2efc7e25317$export$775b6bb06e53a214();
        newScope._breadcrumbs = [
            ...this._breadcrumbs
        ];
        newScope._tags = {
            ...this._tags
        };
        newScope._extra = {
            ...this._extra
        };
        newScope._contexts = {
            ...this._contexts
        };
        newScope._user = this._user;
        newScope._level = this._level;
        newScope._span = this._span;
        newScope._session = this._session;
        newScope._transactionName = this._transactionName;
        newScope._fingerprint = this._fingerprint;
        newScope._eventProcessors = [
            ...this._eventProcessors
        ];
        newScope._requestSession = this._requestSession;
        newScope._attachments = [
            ...this._attachments
        ];
        newScope._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata
        };
        newScope._propagationContext = {
            ...this._propagationContext
        };
        newScope._client = this._client;
        return newScope;
    }
    /** Update the client on the scope. */ setClient(client) {
        this._client = client;
    }
    /**
   * Get the client assigned to this scope.
   *
   * It is generally recommended to use the global function `Sentry.getClient()` instead, unless you know what you are doing.
   */ getClient() {
        return this._client;
    }
    /**
   * Add internal on change listener. Used for sub SDKs that need to store the scope.
   * @hidden
   */ addScopeListener(callback) {
        this._scopeListeners.push(callback);
    }
    /**
   * @inheritDoc
   */ addEventProcessor(callback) {
        this._eventProcessors.push(callback);
        return this;
    }
    /**
   * @inheritDoc
   */ setUser(user) {
        // If null is passed we want to unset everything, but still define keys,
        // so that later down in the pipeline any existing values are cleared.
        this._user = user || {
            email: undefined,
            id: undefined,
            ip_address: undefined,
            segment: undefined,
            username: undefined
        };
        if (this._session) (0, $bHHGA.updateSession)(this._session, {
            user: user
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getUser() {
        return this._user;
    }
    /**
   * @inheritDoc
   */ getRequestSession() {
        return this._requestSession;
    }
    /**
   * @inheritDoc
   */ setRequestSession(requestSession) {
        this._requestSession = requestSession;
        return this;
    }
    /**
   * @inheritDoc
   */ setTags(tags) {
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setTag(key, value) {
        this._tags = {
            ...this._tags,
            [key]: value
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setExtras(extras) {
        this._extra = {
            ...this._extra,
            ...extras
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setExtra(key, extra) {
        this._extra = {
            ...this._extra,
            [key]: extra
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setFingerprint(fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setLevel(// eslint-disable-next-line deprecation/deprecation
    level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the transaction name on the scope for future events.
   */ setTransactionName(name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setContext(key, context) {
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts[key] = context;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the Span on the scope.
   * @param span Span
   * @deprecated Instead of setting a span on a scope, use `startSpan()`/`startSpanManual()` instead.
   */ setSpan(span) {
        this._span = span;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Returns the `Span` if there is one.
   * @deprecated Use `getActiveSpan()` instead.
   */ getSpan() {
        return this._span;
    }
    /**
   * Returns the `Transaction` attached to the scope (if there is one).
   * @deprecated You should not rely on the transaction, but just use `startSpan()` APIs instead.
   */ getTransaction() {
        // Often, this span (if it exists at all) will be a transaction, but it's not guaranteed to be. Regardless, it will
        // have a pointer to the currently-active transaction.
        const span = this._span;
        // Cannot replace with getRootSpan because getRootSpan returns a span, not a transaction
        // Also, this method will be removed anyway.
        // eslint-disable-next-line deprecation/deprecation
        return span && span.transaction;
    }
    /**
   * @inheritDoc
   */ setSession(session) {
        if (!session) delete this._session;
        else this._session = session;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getSession() {
        return this._session;
    }
    /**
   * @inheritDoc
   */ update(captureContext) {
        if (!captureContext) return this;
        const scopeToMerge = typeof captureContext === 'function' ? captureContext(this) : captureContext;
        if (scopeToMerge instanceof $2334f2efc7e25317$export$775b6bb06e53a214) {
            const scopeData = scopeToMerge.getScopeData();
            this._tags = {
                ...this._tags,
                ...scopeData.tags
            };
            this._extra = {
                ...this._extra,
                ...scopeData.extra
            };
            this._contexts = {
                ...this._contexts,
                ...scopeData.contexts
            };
            if (scopeData.user && Object.keys(scopeData.user).length) this._user = scopeData.user;
            if (scopeData.level) this._level = scopeData.level;
            if (scopeData.fingerprint.length) this._fingerprint = scopeData.fingerprint;
            if (scopeToMerge.getRequestSession()) this._requestSession = scopeToMerge.getRequestSession();
            if (scopeData.propagationContext) this._propagationContext = scopeData.propagationContext;
        } else if ((0, $2Jaqc.isPlainObject)(scopeToMerge)) {
            const scopeContext = captureContext;
            this._tags = {
                ...this._tags,
                ...scopeContext.tags
            };
            this._extra = {
                ...this._extra,
                ...scopeContext.extra
            };
            this._contexts = {
                ...this._contexts,
                ...scopeContext.contexts
            };
            if (scopeContext.user) this._user = scopeContext.user;
            if (scopeContext.level) this._level = scopeContext.level;
            if (scopeContext.fingerprint) this._fingerprint = scopeContext.fingerprint;
            if (scopeContext.requestSession) this._requestSession = scopeContext.requestSession;
            if (scopeContext.propagationContext) this._propagationContext = scopeContext.propagationContext;
        }
        return this;
    }
    /**
   * @inheritDoc
   */ clear() {
        this._breadcrumbs = [];
        this._tags = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = undefined;
        this._transactionName = undefined;
        this._fingerprint = undefined;
        this._requestSession = undefined;
        this._span = undefined;
        this._session = undefined;
        this._notifyScopeListeners();
        this._attachments = [];
        this._propagationContext = $2334f2efc7e25317$var$generatePropagationContext();
        return this;
    }
    /**
   * @inheritDoc
   */ addBreadcrumb(breadcrumb, maxBreadcrumbs) {
        const maxCrumbs = typeof maxBreadcrumbs === 'number' ? maxBreadcrumbs : $2334f2efc7e25317$var$DEFAULT_MAX_BREADCRUMBS;
        // No data has been changed, so don't notify scope listeners
        if (maxCrumbs <= 0) return this;
        const mergedBreadcrumb = {
            timestamp: (0, $gv1sw.dateTimestampInSeconds)(),
            ...breadcrumb
        };
        const breadcrumbs = this._breadcrumbs;
        breadcrumbs.push(mergedBreadcrumb);
        this._breadcrumbs = breadcrumbs.length > maxCrumbs ? breadcrumbs.slice(-maxCrumbs) : breadcrumbs;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getLastBreadcrumb() {
        return this._breadcrumbs[this._breadcrumbs.length - 1];
    }
    /**
   * @inheritDoc
   */ clearBreadcrumbs() {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ addAttachment(attachment) {
        this._attachments.push(attachment);
        return this;
    }
    /**
   * @inheritDoc
   * @deprecated Use `getScopeData()` instead.
   */ getAttachments() {
        const data = this.getScopeData();
        return data.attachments;
    }
    /**
   * @inheritDoc
   */ clearAttachments() {
        this._attachments = [];
        return this;
    }
    /** @inheritDoc */ getScopeData() {
        const { _breadcrumbs: _breadcrumbs, _attachments: _attachments, _contexts: _contexts, _tags: _tags, _extra: _extra, _user: _user, _level: _level, _fingerprint: _fingerprint, _eventProcessors: _eventProcessors, _propagationContext: _propagationContext, _sdkProcessingMetadata: _sdkProcessingMetadata, _transactionName: _transactionName, _span: _span } = this;
        return {
            breadcrumbs: _breadcrumbs,
            attachments: _attachments,
            contexts: _contexts,
            tags: _tags,
            extra: _extra,
            user: _user,
            level: _level,
            fingerprint: _fingerprint || [],
            eventProcessors: _eventProcessors,
            propagationContext: _propagationContext,
            sdkProcessingMetadata: _sdkProcessingMetadata,
            transactionName: _transactionName,
            span: _span
        };
    }
    /**
   * Applies data from the scope to the event and runs all event processors on it.
   *
   * @param event Event
   * @param hint Object containing additional information about the original exception, for use by the event processors.
   * @hidden
   * @deprecated Use `applyScopeDataToEvent()` directly
   */ applyToEvent(event, hint = {}, additionalEventProcessors = []) {
        (0, $gqwnB.applyScopeDataToEvent)(event, this.getScopeData());
        // TODO (v8): Update this order to be: Global > Client > Scope
        const eventProcessors = [
            ...additionalEventProcessors,
            // eslint-disable-next-line deprecation/deprecation
            ...(0, $1feQE.getGlobalEventProcessors)(),
            ...this._eventProcessors
        ];
        return (0, $1feQE.notifyEventProcessors)(eventProcessors, event, hint);
    }
    /**
   * Add data which will be accessible during event processing but won't get sent to Sentry
   */ setSDKProcessingMetadata(newData) {
        this._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata,
            ...newData
        };
        return this;
    }
    /**
   * @inheritDoc
   */ setPropagationContext(context) {
        this._propagationContext = context;
        return this;
    }
    /**
   * @inheritDoc
   */ getPropagationContext() {
        return this._propagationContext;
    }
    /**
   * Capture an exception for this scope.
   *
   * @param exception The exception to capture.
   * @param hint Optinal additional data to attach to the Sentry event.
   * @returns the id of the captured Sentry event.
   */ captureException(exception, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $kgI9H.uuid4)();
        if (!this._client) {
            (0, $6lJZW.logger).warn('No client configured on scope - will not capture exception!');
            return eventId;
        }
        const syntheticException = new Error('Sentry syntheticException');
        this._client.captureException(exception, {
            originalException: exception,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Capture a message for this scope.
   *
   * @param message The message to capture.
   * @param level An optional severity level to report the message with.
   * @param hint Optional additional data to attach to the Sentry event.
   * @returns the id of the captured message.
   */ captureMessage(message, level, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $kgI9H.uuid4)();
        if (!this._client) {
            (0, $6lJZW.logger).warn('No client configured on scope - will not capture message!');
            return eventId;
        }
        const syntheticException = new Error(message);
        this._client.captureMessage(message, level, {
            originalException: message,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Captures a manually created event for this scope and sends it to Sentry.
   *
   * @param exception The event to capture.
   * @param hint Optional additional data to attach to the Sentry event.
   * @returns the id of the captured event.
   */ captureEvent(event, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $kgI9H.uuid4)();
        if (!this._client) {
            (0, $6lJZW.logger).warn('No client configured on scope - will not capture event!');
            return eventId;
        }
        this._client.captureEvent(event, {
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * This will be called on every set call.
   */ _notifyScopeListeners() {
        // We need this check for this._notifyingListeners to be able to work on scope during updates
        // If this check is not here we'll produce endless recursion when something is done with the scope
        // during the callback.
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach((callback)=>{
                callback(this);
            });
            this._notifyingListeners = false;
        }
    }
}
/**
 * Get the global scope.
 * This scope is applied to _all_ events.
 */ function $2334f2efc7e25317$export$aa55d5ab8e05984f() {
    if (!$2334f2efc7e25317$var$globalScope) $2334f2efc7e25317$var$globalScope = new $2334f2efc7e25317$export$775b6bb06e53a214();
    return $2334f2efc7e25317$var$globalScope;
}
/**
 * This is mainly needed for tests.
 * DO NOT USE this, as this is an internal API and subject to change.
 * @hidden
 */ function $2334f2efc7e25317$export$c83048efd17527d6(scope) {
    $2334f2efc7e25317$var$globalScope = scope;
}
function $2334f2efc7e25317$var$generatePropagationContext() {
    return {
        traceId: (0, $kgI9H.uuid4)(),
        spanId: (0, $kgI9H.uuid4)().substring(16)
    };
}

});
parcelRegister("1feQE", function(module, exports) {
$parcel$export(module.exports, "getGlobalEventProcessors", () => $0e82b5ba442ff062$export$3c4238858b85e8ac);
$parcel$export(module.exports, "addGlobalEventProcessor", () => $0e82b5ba442ff062$export$8e4e25f54d456511);
$parcel$export(module.exports, "notifyEventProcessors", () => $0e82b5ba442ff062$export$bf2a096c3e883e79);

var $aFn2S = parcelRequire("aFn2S");
var $2Jaqc = parcelRequire("2Jaqc");
var $6lJZW = parcelRequire("6lJZW");
var $dtmqq = parcelRequire("dtmqq");

var $fZ2r3 = parcelRequire("fZ2r3");
/**
 * Returns the global event processors.
 * @deprecated Global event processors will be removed in v8.
 */ function $0e82b5ba442ff062$export$3c4238858b85e8ac() {
    return (0, $aFn2S.getGlobalSingleton)('globalEventProcessors', ()=>[]);
}
/**
 * Add a EventProcessor to be kept globally.
 * @deprecated Use `addEventProcessor` instead. Global event processors will be removed in v8.
 */ function $0e82b5ba442ff062$export$8e4e25f54d456511(callback) {
    // eslint-disable-next-line deprecation/deprecation
    $0e82b5ba442ff062$export$3c4238858b85e8ac().push(callback);
}
/**
 * Process an array of event processors, returning the processed event (or `null` if the event was dropped).
 */ function $0e82b5ba442ff062$export$bf2a096c3e883e79(processors, event, hint, index = 0) {
    return new (0, $dtmqq.SyncPromise)((resolve, reject)=>{
        const processor = processors[index];
        if (event === null || typeof processor !== 'function') resolve(event);
        else {
            const result = processor({
                ...event
            }, hint);
            (0, $fZ2r3.DEBUG_BUILD) && processor.id && result === null && (0, $6lJZW.logger).log(`Event processor "${processor.id}" dropped event`);
            if ((0, $2Jaqc.isThenable)(result)) result.then((final)=>$0e82b5ba442ff062$export$bf2a096c3e883e79(processors, final, hint, index + 1).then(resolve)).then(null, reject);
            else $0e82b5ba442ff062$export$bf2a096c3e883e79(processors, result, hint, index + 1).then(resolve).then(null, reject);
        }
    });
}

});
parcelRegister("dtmqq", function(module, exports) {
$parcel$export(module.exports, "resolvedSyncPromise", () => $9cef60f59f310cc6$export$1fda8aa4d135f8aa);
$parcel$export(module.exports, "SyncPromise", () => $9cef60f59f310cc6$export$6f292d4960313241);
$parcel$export(module.exports, "rejectedSyncPromise", () => $9cef60f59f310cc6$export$78e43115b553f358);

var $2Jaqc = parcelRequire("2Jaqc");
/* eslint-disable @typescript-eslint/explicit-function-return-type */ /** SyncPromise internal states */ var $9cef60f59f310cc6$var$States;
(function(States) {
    /** Pending */ const PENDING = 0;
    States[States["PENDING"] = PENDING] = "PENDING";
    /** Resolved / OK */ const RESOLVED = 1;
    States[States["RESOLVED"] = RESOLVED] = "RESOLVED";
    /** Rejected / Error */ const REJECTED = 2;
    States[States["REJECTED"] = REJECTED] = "REJECTED";
})($9cef60f59f310cc6$var$States || ($9cef60f59f310cc6$var$States = {}));
// Overloads so we can call resolvedSyncPromise without arguments and generic argument
/**
 * Creates a resolved sync promise.
 *
 * @param value the value to resolve the promise with
 * @returns the resolved sync promise
 */ function $9cef60f59f310cc6$export$1fda8aa4d135f8aa(value) {
    return new $9cef60f59f310cc6$export$6f292d4960313241((resolve)=>{
        resolve(value);
    });
}
/**
 * Creates a rejected sync promise.
 *
 * @param value the value to reject the promise with
 * @returns the rejected sync promise
 */ function $9cef60f59f310cc6$export$78e43115b553f358(reason) {
    return new $9cef60f59f310cc6$export$6f292d4960313241((_, reject)=>{
        reject(reason);
    });
}
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */ class $9cef60f59f310cc6$export$6f292d4960313241 {
    constructor(executor){
        $9cef60f59f310cc6$export$6f292d4960313241.prototype.__init.call(this);
        $9cef60f59f310cc6$export$6f292d4960313241.prototype.__init2.call(this);
        $9cef60f59f310cc6$export$6f292d4960313241.prototype.__init3.call(this);
        $9cef60f59f310cc6$export$6f292d4960313241.prototype.__init4.call(this);
        this._state = $9cef60f59f310cc6$var$States.PENDING;
        this._handlers = [];
        try {
            executor(this._resolve, this._reject);
        } catch (e) {
            this._reject(e);
        }
    }
    /** JSDoc */ then(onfulfilled, onrejected) {
        return new $9cef60f59f310cc6$export$6f292d4960313241((resolve, reject)=>{
            this._handlers.push([
                false,
                (result)=>{
                    if (!onfulfilled) // TODO: ¯\_(ツ)_/¯
                    // TODO: FIXME
                    resolve(result);
                    else try {
                        resolve(onfulfilled(result));
                    } catch (e) {
                        reject(e);
                    }
                },
                (reason)=>{
                    if (!onrejected) reject(reason);
                    else try {
                        resolve(onrejected(reason));
                    } catch (e) {
                        reject(e);
                    }
                }
            ]);
            this._executeHandlers();
        });
    }
    /** JSDoc */ catch(onrejected) {
        return this.then((val)=>val, onrejected);
    }
    /** JSDoc */ finally(onfinally) {
        return new $9cef60f59f310cc6$export$6f292d4960313241((resolve, reject)=>{
            let val;
            let isRejected;
            return this.then((value)=>{
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, (reason)=>{
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(()=>{
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    }
    /** JSDoc */ __init() {
        this._resolve = (value)=>{
            this._setResult($9cef60f59f310cc6$var$States.RESOLVED, value);
        };
    }
    /** JSDoc */ __init2() {
        this._reject = (reason)=>{
            this._setResult($9cef60f59f310cc6$var$States.REJECTED, reason);
        };
    }
    /** JSDoc */ __init3() {
        this._setResult = (state, value)=>{
            if (this._state !== $9cef60f59f310cc6$var$States.PENDING) return;
            if ((0, $2Jaqc.isThenable)(value)) {
                value.then(this._resolve, this._reject);
                return;
            }
            this._state = state;
            this._value = value;
            this._executeHandlers();
        };
    }
    /** JSDoc */ __init4() {
        this._executeHandlers = ()=>{
            if (this._state === $9cef60f59f310cc6$var$States.PENDING) return;
            const cachedHandlers = this._handlers.slice();
            this._handlers = [];
            cachedHandlers.forEach((handler)=>{
                if (handler[0]) return;
                if (this._state === $9cef60f59f310cc6$var$States.RESOLVED) // eslint-disable-next-line @typescript-eslint/no-floating-promises
                handler[1](this._value);
                if (this._state === $9cef60f59f310cc6$var$States.REJECTED) handler[2](this._value);
                handler[0] = true;
            });
        };
    }
}

});


parcelRegister("bHHGA", function(module, exports) {
$parcel$export(module.exports, "makeSession", () => $885598f6296f8beb$export$14a186326edbb264);
$parcel$export(module.exports, "updateSession", () => $885598f6296f8beb$export$531818e825e774db);
$parcel$export(module.exports, "closeSession", () => $885598f6296f8beb$export$56521d9ba90f62ee);

var $3dFJR = parcelRequire("3dFJR");
var $gv1sw = parcelRequire("gv1sw");
var $kgI9H = parcelRequire("kgI9H");
/**
 * Creates a new `Session` object by setting certain default parameters. If optional @param context
 * is passed, the passed properties are applied to the session object.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns a new `Session` object
 */ function $885598f6296f8beb$export$14a186326edbb264(context) {
    // Both timestamp and started are in seconds since the UNIX epoch.
    const startingTime = (0, $gv1sw.timestampInSeconds)();
    const session = {
        sid: (0, $kgI9H.uuid4)(),
        init: true,
        timestamp: startingTime,
        started: startingTime,
        duration: 0,
        status: 'ok',
        errors: 0,
        ignoreDuration: false,
        toJSON: ()=>$885598f6296f8beb$var$sessionToJSON(session)
    };
    if (context) $885598f6296f8beb$export$531818e825e774db(session, context);
    return session;
}
/**
 * Updates a session object with the properties passed in the context.
 *
 * Note that this function mutates the passed object and returns void.
 * (Had to do this instead of returning a new and updated session because closing and sending a session
 * makes an update to the session after it was passed to the sending logic.
 * @see BaseClient.captureSession )
 *
 * @param session the `Session` to update
 * @param context the `SessionContext` holding the properties that should be updated in @param session
 */ // eslint-disable-next-line complexity
function $885598f6296f8beb$export$531818e825e774db(session, context = {}) {
    if (context.user) {
        if (!session.ipAddress && context.user.ip_address) session.ipAddress = context.user.ip_address;
        if (!session.did && !context.did) session.did = context.user.id || context.user.email || context.user.username;
    }
    session.timestamp = context.timestamp || (0, $gv1sw.timestampInSeconds)();
    if (context.abnormal_mechanism) session.abnormal_mechanism = context.abnormal_mechanism;
    if (context.ignoreDuration) session.ignoreDuration = context.ignoreDuration;
    if (context.sid) // Good enough uuid validation. — Kamil
    session.sid = context.sid.length === 32 ? context.sid : (0, $kgI9H.uuid4)();
    if (context.init !== undefined) session.init = context.init;
    if (!session.did && context.did) session.did = `${context.did}`;
    if (typeof context.started === 'number') session.started = context.started;
    if (session.ignoreDuration) session.duration = undefined;
    else if (typeof context.duration === 'number') session.duration = context.duration;
    else {
        const duration = session.timestamp - session.started;
        session.duration = duration >= 0 ? duration : 0;
    }
    if (context.release) session.release = context.release;
    if (context.environment) session.environment = context.environment;
    if (!session.ipAddress && context.ipAddress) session.ipAddress = context.ipAddress;
    if (!session.userAgent && context.userAgent) session.userAgent = context.userAgent;
    if (typeof context.errors === 'number') session.errors = context.errors;
    if (context.status) session.status = context.status;
}
/**
 * Closes a session by setting its status and updating the session object with it.
 * Internally calls `updateSession` to update the passed session object.
 *
 * Note that this function mutates the passed session (@see updateSession for explanation).
 *
 * @param session the `Session` object to be closed
 * @param status the `SessionStatus` with which the session was closed. If you don't pass a status,
 *               this function will keep the previously set status, unless it was `'ok'` in which case
 *               it is changed to `'exited'`.
 */ function $885598f6296f8beb$export$56521d9ba90f62ee(session, status) {
    let context = {};
    if (status) context = {
        status: status
    };
    else if (session.status === 'ok') context = {
        status: 'exited'
    };
    $885598f6296f8beb$export$531818e825e774db(session, context);
}
/**
 * Serializes a passed session object to a JSON object with a slightly different structure.
 * This is necessary because the Sentry backend requires a slightly different schema of a session
 * than the one the JS SDKs use internally.
 *
 * @param session the session to be converted
 *
 * @returns a JSON object of the passed session
 */ function $885598f6296f8beb$var$sessionToJSON(session) {
    return (0, $3dFJR.dropUndefinedKeys)({
        sid: `${session.sid}`,
        init: session.init,
        // Make sure that sec is converted to ms for date constructor
        started: new Date(session.started * 1000).toISOString(),
        timestamp: new Date(session.timestamp * 1000).toISOString(),
        status: session.status,
        errors: session.errors,
        did: typeof session.did === 'number' || typeof session.did === 'string' ? `${session.did}` : undefined,
        duration: session.duration,
        abnormal_mechanism: session.abnormal_mechanism,
        attrs: {
            release: session.release,
            environment: session.environment,
            ip_address: session.ipAddress,
            user_agent: session.userAgent
        }
    });
}

});

parcelRegister("gqwnB", function(module, exports) {
$parcel$export(module.exports, "applyScopeDataToEvent", () => $bf5830f6a4320fa0$export$43988bc651a80216);
$parcel$export(module.exports, "mergeScopeData", () => $bf5830f6a4320fa0$export$25ac7e259a513db4);

var $kgI9H = parcelRequire("kgI9H");
var $3dFJR = parcelRequire("3dFJR");

var $13IdK = parcelRequire("13IdK");

var $57myZ = parcelRequire("57myZ");

var $9NVyI = parcelRequire("9NVyI");
/**
 * Applies data from the scope to the event and runs all event processors on it.
 */ function $bf5830f6a4320fa0$export$43988bc651a80216(event, data) {
    const { fingerprint: fingerprint, span: span, breadcrumbs: breadcrumbs, sdkProcessingMetadata: sdkProcessingMetadata } = data;
    // Apply general data
    $bf5830f6a4320fa0$var$applyDataToEvent(event, data);
    // We want to set the trace context for normal events only if there isn't already
    // a trace context on the event. There is a product feature in place where we link
    // errors with transaction and it relies on that.
    if (span) $bf5830f6a4320fa0$var$applySpanToEvent(event, span);
    $bf5830f6a4320fa0$var$applyFingerprintToEvent(event, fingerprint);
    $bf5830f6a4320fa0$var$applyBreadcrumbsToEvent(event, breadcrumbs);
    $bf5830f6a4320fa0$var$applySdkMetadataToEvent(event, sdkProcessingMetadata);
}
/** Merge data of two scopes together. */ function $bf5830f6a4320fa0$export$25ac7e259a513db4(data, mergeData) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, sdkProcessingMetadata: sdkProcessingMetadata, breadcrumbs: breadcrumbs, fingerprint: fingerprint, eventProcessors: eventProcessors, attachments: attachments, propagationContext: propagationContext, transactionName: // eslint-disable-next-line deprecation/deprecation
    transactionName, span: span } = mergeData;
    $bf5830f6a4320fa0$export$b1a120a2871faa46(data, 'extra', extra);
    $bf5830f6a4320fa0$export$b1a120a2871faa46(data, 'tags', tags);
    $bf5830f6a4320fa0$export$b1a120a2871faa46(data, 'user', user);
    $bf5830f6a4320fa0$export$b1a120a2871faa46(data, 'contexts', contexts);
    $bf5830f6a4320fa0$export$b1a120a2871faa46(data, 'sdkProcessingMetadata', sdkProcessingMetadata);
    if (level) data.level = level;
    if (transactionName) // eslint-disable-next-line deprecation/deprecation
    data.transactionName = transactionName;
    if (span) data.span = span;
    if (breadcrumbs.length) data.breadcrumbs = [
        ...data.breadcrumbs,
        ...breadcrumbs
    ];
    if (fingerprint.length) data.fingerprint = [
        ...data.fingerprint,
        ...fingerprint
    ];
    if (eventProcessors.length) data.eventProcessors = [
        ...data.eventProcessors,
        ...eventProcessors
    ];
    if (attachments.length) data.attachments = [
        ...data.attachments,
        ...attachments
    ];
    data.propagationContext = {
        ...data.propagationContext,
        ...propagationContext
    };
}
/**
 * Merges certain scope data. Undefined values will overwrite any existing values.
 * Exported only for tests.
 */ function $bf5830f6a4320fa0$export$b1a120a2871faa46(data, prop, mergeVal) {
    if (mergeVal && Object.keys(mergeVal).length) {
        // Clone object
        data[prop] = {
            ...data[prop]
        };
        for(const key in mergeVal)if (Object.prototype.hasOwnProperty.call(mergeVal, key)) data[prop][key] = mergeVal[key];
    }
}
function $bf5830f6a4320fa0$var$applyDataToEvent(event, data) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, transactionName: // eslint-disable-next-line deprecation/deprecation
    transactionName } = data;
    const cleanedExtra = (0, $3dFJR.dropUndefinedKeys)(extra);
    if (cleanedExtra && Object.keys(cleanedExtra).length) event.extra = {
        ...cleanedExtra,
        ...event.extra
    };
    const cleanedTags = (0, $3dFJR.dropUndefinedKeys)(tags);
    if (cleanedTags && Object.keys(cleanedTags).length) event.tags = {
        ...cleanedTags,
        ...event.tags
    };
    const cleanedUser = (0, $3dFJR.dropUndefinedKeys)(user);
    if (cleanedUser && Object.keys(cleanedUser).length) event.user = {
        ...cleanedUser,
        ...event.user
    };
    const cleanedContexts = (0, $3dFJR.dropUndefinedKeys)(contexts);
    if (cleanedContexts && Object.keys(cleanedContexts).length) event.contexts = {
        ...cleanedContexts,
        ...event.contexts
    };
    if (level) event.level = level;
    if (transactionName) event.transaction = transactionName;
}
function $bf5830f6a4320fa0$var$applyBreadcrumbsToEvent(event, breadcrumbs) {
    const mergedBreadcrumbs = [
        ...event.breadcrumbs || [],
        ...breadcrumbs
    ];
    event.breadcrumbs = mergedBreadcrumbs.length ? mergedBreadcrumbs : undefined;
}
function $bf5830f6a4320fa0$var$applySdkMetadataToEvent(event, sdkProcessingMetadata) {
    event.sdkProcessingMetadata = {
        ...event.sdkProcessingMetadata,
        ...sdkProcessingMetadata
    };
}
function $bf5830f6a4320fa0$var$applySpanToEvent(event, span) {
    event.contexts = {
        trace: (0, $9NVyI.spanToTraceContext)(span),
        ...event.contexts
    };
    const rootSpan = (0, $57myZ.getRootSpan)(span);
    if (rootSpan) {
        event.sdkProcessingMetadata = {
            dynamicSamplingContext: (0, $13IdK.getDynamicSamplingContextFromSpan)(span),
            ...event.sdkProcessingMetadata
        };
        const transactionName = (0, $9NVyI.spanToJSON)(rootSpan).description;
        if (transactionName) event.tags = {
            transaction: transactionName,
            ...event.tags
        };
    }
}
/**
 * Applies fingerprint from the scope to the event if there's one,
 * uses message if there's one instead or get rid of empty fingerprint
 */ function $bf5830f6a4320fa0$var$applyFingerprintToEvent(event, fingerprint) {
    // Make sure it's an array first and we actually have something in place
    event.fingerprint = event.fingerprint ? (0, $kgI9H.arrayify)(event.fingerprint) : [];
    // If we have something on the scope, then merge it with event
    if (fingerprint) event.fingerprint = event.fingerprint.concat(fingerprint);
    // If we have no data at all, remove empty array default
    if (event.fingerprint && !event.fingerprint.length) delete event.fingerprint;
}

});
parcelRegister("13IdK", function(module, exports) {
$parcel$export(module.exports, "getDynamicSamplingContextFromClient", () => $0c585f8e2a081ceb$export$366bad00d6815eed);
$parcel$export(module.exports, "getDynamicSamplingContextFromSpan", () => $0c585f8e2a081ceb$export$a117f995597e25df);

var $3dFJR = parcelRequire("3dFJR");

var $b2zyj = parcelRequire("b2zyj");

var $3vr70 = parcelRequire("3vr70");

var $57myZ = parcelRequire("57myZ");

var $9NVyI = parcelRequire("9NVyI");
/**
 * Creates a dynamic sampling context from a client.
 *
 * Dispatches the `createDsc` lifecycle hook as a side effect.
 */ function $0c585f8e2a081ceb$export$366bad00d6815eed(trace_id, client, scope) {
    const options = client.getOptions();
    const { publicKey: public_key } = client.getDsn() || {};
    // TODO(v8): Remove segment from User
    // eslint-disable-next-line deprecation/deprecation
    const { segment: user_segment } = scope && scope.getUser() || {};
    const dsc = (0, $3dFJR.dropUndefinedKeys)({
        environment: options.environment || (0, $b2zyj.DEFAULT_ENVIRONMENT),
        release: options.release,
        user_segment: user_segment,
        public_key: public_key,
        trace_id: trace_id
    });
    client.emit && client.emit('createDsc', dsc);
    return dsc;
}
/**
 * A Span with a frozen dynamic sampling context.
 */ /**
 * Creates a dynamic sampling context from a span (and client and scope)
 *
 * @param span the span from which a few values like the root span name and sample rate are extracted.
 *
 * @returns a dynamic sampling context
 */ function $0c585f8e2a081ceb$export$a117f995597e25df(span) {
    const client = (0, $3vr70.getClient)();
    if (!client) return {};
    // passing emit=false here to only emit later once the DSC is actually populated
    const dsc = $0c585f8e2a081ceb$export$366bad00d6815eed((0, $9NVyI.spanToJSON)(span).trace_id || '', client, (0, $3vr70.getCurrentScope)());
    // TODO (v8): Remove v7FrozenDsc as a Transaction will no longer have _frozenDynamicSamplingContext
    const txn = (0, $57myZ.getRootSpan)(span);
    if (!txn) return dsc;
    // TODO (v8): Remove v7FrozenDsc as a Transaction will no longer have _frozenDynamicSamplingContext
    // For now we need to avoid breaking users who directly created a txn with a DSC, where this field is still set.
    // @see Transaction class constructor
    const v7FrozenDsc = txn && txn._frozenDynamicSamplingContext;
    if (v7FrozenDsc) return v7FrozenDsc;
    // TODO (v8): Replace txn.metadata with txn.attributes[]
    // We can't do this yet because attributes aren't always set yet.
    // eslint-disable-next-line deprecation/deprecation
    const { sampleRate: maybeSampleRate, source: source } = txn.metadata;
    if (maybeSampleRate != null) dsc.sample_rate = `${maybeSampleRate}`;
    // We don't want to have a transaction name in the DSC if the source is "url" because URLs might contain PII
    const jsonSpan = (0, $9NVyI.spanToJSON)(txn);
    // after JSON conversion, txn.name becomes jsonSpan.description
    if (source && source !== 'url') dsc.transaction = jsonSpan.description;
    dsc.sampled = String((0, $9NVyI.spanIsSampled)(txn));
    client.emit && client.emit('createDsc', dsc);
    return dsc;
}

});
parcelRegister("57myZ", function(module, exports) {
$parcel$export(module.exports, "getRootSpan", () => $3b9f1bcd16d7ea24$export$c4c6a79b1260ca1b);
/**
 * Returns the root span of a given span.
 *
 * As long as we use `Transaction`s internally, the returned root span
 * will be a `Transaction` but be aware that this might change in the future.
 *
 * If the given span has no root span or transaction, `undefined` is returned.
 */ function $3b9f1bcd16d7ea24$export$c4c6a79b1260ca1b(span) {
    // TODO (v8): Remove this check and just return span
    // eslint-disable-next-line deprecation/deprecation
    return span.transaction;
}

});

parcelRegister("9NVyI", function(module, exports) {
$parcel$export(module.exports, "spanToTraceContext", () => $723556b007dc5979$export$46c6fbd1d265ebf0);
$parcel$export(module.exports, "spanToJSON", () => $723556b007dc5979$export$92d8c23565496537);
$parcel$export(module.exports, "spanIsSampled", () => $723556b007dc5979$export$5caecac1caaf3a71);

var $3dFJR = parcelRequire("3dFJR");
var $i99Cl = parcelRequire("i99Cl");
var $gv1sw = parcelRequire("gv1sw");
// These are aligned with OpenTelemetry trace flags
const $723556b007dc5979$export$208d5b368507fb8b = 0x0;
const $723556b007dc5979$export$eb571cd9b5d98de8 = 0x1;
/**
 * Convert a span to a trace context, which can be sent as the `trace` context in an event.
 */ function $723556b007dc5979$export$46c6fbd1d265ebf0(span) {
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    const { data: data, op: op, parent_span_id: parent_span_id, status: status, tags: tags, origin: origin } = $723556b007dc5979$export$92d8c23565496537(span);
    return (0, $3dFJR.dropUndefinedKeys)({
        data: data,
        op: op,
        parent_span_id: parent_span_id,
        span_id: span_id,
        status: status,
        tags: tags,
        trace_id: trace_id,
        origin: origin
    });
}
/**
 * Convert a Span to a Sentry trace header.
 */ function $723556b007dc5979$export$7e9f8ae9e4a328ab(span) {
    const { traceId: traceId, spanId: spanId } = span.spanContext();
    const sampled = $723556b007dc5979$export$5caecac1caaf3a71(span);
    return (0, $i99Cl.generateSentryTraceHeader)(traceId, spanId, sampled);
}
/**
 * Convert a span time input intp a timestamp in seconds.
 */ function $723556b007dc5979$export$3f7581298f56c6d7(input) {
    if (typeof input === 'number') return $723556b007dc5979$var$ensureTimestampInSeconds(input);
    if (Array.isArray(input)) // See {@link HrTime} for the array-based time format
    return input[0] + input[1] / 1e9;
    if (input instanceof Date) return $723556b007dc5979$var$ensureTimestampInSeconds(input.getTime());
    return (0, $gv1sw.timestampInSeconds)();
}
/**
 * Converts a timestamp to second, if it was in milliseconds, or keeps it as second.
 */ function $723556b007dc5979$var$ensureTimestampInSeconds(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1000 : timestamp;
}
/**
 * Convert a span to a JSON representation.
 * Note that all fields returned here are optional and need to be guarded against.
 *
 * Note: Because of this, we currently have a circular type dependency (which we opted out of in package.json).
 * This is not avoidable as we need `spanToJSON` in `spanUtils.ts`, which in turn is needed by `span.ts` for backwards compatibility.
 * And `spanToJSON` needs the Span class from `span.ts` to check here.
 * TODO v8: When we remove the deprecated stuff from `span.ts`, we can remove the circular dependency again.
 */ function $723556b007dc5979$export$92d8c23565496537(span) {
    if ($723556b007dc5979$var$spanIsSpanClass(span)) return span.getSpanJSON();
    // Fallback: We also check for `.toJSON()` here...
    // eslint-disable-next-line deprecation/deprecation
    if (typeof span.toJSON === 'function') // eslint-disable-next-line deprecation/deprecation
    return span.toJSON();
    return {};
}
/**
 * Sadly, due to circular dependency checks we cannot actually import the Span class here and check for instanceof.
 * :( So instead we approximate this by checking if it has the `getSpanJSON` method.
 */ function $723556b007dc5979$var$spanIsSpanClass(span) {
    return typeof span.getSpanJSON === 'function';
}
/**
 * Returns true if a span is sampled.
 * In most cases, you should just use `span.isRecording()` instead.
 * However, this has a slightly different semantic, as it also returns false if the span is finished.
 * So in the case where this distinction is important, use this method.
 */ function $723556b007dc5979$export$5caecac1caaf3a71(span) {
    // We align our trace flags with the ones OpenTelemetry use
    // So we also check for sampled the same way they do.
    const { traceFlags: traceFlags } = span.spanContext();
    // eslint-disable-next-line no-bitwise
    return Boolean(traceFlags & $723556b007dc5979$export$eb571cd9b5d98de8);
}

});
parcelRegister("i99Cl", function(module, exports) {
$parcel$export(module.exports, "generateSentryTraceHeader", () => $d3608715cbc675f3$export$f35d907436da45cf);

var $dXnsY = parcelRequire("dXnsY");

var $kgI9H = parcelRequire("kgI9H");
// eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor -- RegExp is used for readability here
const $d3608715cbc675f3$export$394a210812ba3012 = new RegExp("^[ \\t]*([0-9a-f]{32})?-?([0-9a-f]{16})?-?([01])?[ \\t]*$");
/**
 * Extract transaction context data from a `sentry-trace` header.
 *
 * @param traceparent Traceparent string
 *
 * @returns Object containing data from the header, or undefined if traceparent string is malformed
 */ function $d3608715cbc675f3$export$8e9a29865c0a1226(traceparent) {
    if (!traceparent) return undefined;
    const matches = traceparent.match($d3608715cbc675f3$export$394a210812ba3012);
    if (!matches) return undefined;
    let parentSampled;
    if (matches[3] === '1') parentSampled = true;
    else if (matches[3] === '0') parentSampled = false;
    return {
        traceId: matches[1],
        parentSampled: parentSampled,
        parentSpanId: matches[2]
    };
}
/**
 * Create tracing context from incoming headers.
 *
 * @deprecated Use `propagationContextFromHeaders` instead.
 */ // TODO(v8): Remove this function
function $d3608715cbc675f3$export$ca5c066532785b6e(sentryTrace, baggage) {
    const traceparentData = $d3608715cbc675f3$export$8e9a29865c0a1226(sentryTrace);
    const dynamicSamplingContext = (0, $dXnsY.baggageHeaderToDynamicSamplingContext)(baggage);
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = traceparentData || {};
    if (!traceparentData) return {
        traceparentData: traceparentData,
        dynamicSamplingContext: undefined,
        propagationContext: {
            traceId: traceId || (0, $kgI9H.uuid4)(),
            spanId: (0, $kgI9H.uuid4)().substring(16)
        }
    };
    else return {
        traceparentData: traceparentData,
        dynamicSamplingContext: dynamicSamplingContext || {},
        propagationContext: {
            traceId: traceId || (0, $kgI9H.uuid4)(),
            parentSpanId: parentSpanId || (0, $kgI9H.uuid4)().substring(16),
            spanId: (0, $kgI9H.uuid4)().substring(16),
            sampled: parentSampled,
            dsc: dynamicSamplingContext || {}
        }
    };
}
/**
 * Create a propagation context from incoming headers.
 */ function $d3608715cbc675f3$export$261f383d16a93e39(sentryTrace, baggage) {
    const traceparentData = $d3608715cbc675f3$export$8e9a29865c0a1226(sentryTrace);
    const dynamicSamplingContext = (0, $dXnsY.baggageHeaderToDynamicSamplingContext)(baggage);
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = traceparentData || {};
    if (!traceparentData) return {
        traceId: traceId || (0, $kgI9H.uuid4)(),
        spanId: (0, $kgI9H.uuid4)().substring(16)
    };
    else return {
        traceId: traceId || (0, $kgI9H.uuid4)(),
        parentSpanId: parentSpanId || (0, $kgI9H.uuid4)().substring(16),
        spanId: (0, $kgI9H.uuid4)().substring(16),
        sampled: parentSampled,
        dsc: dynamicSamplingContext || {}
    };
}
/**
 * Create sentry-trace header from span context values.
 */ function $d3608715cbc675f3$export$f35d907436da45cf(traceId = (0, $kgI9H.uuid4)(), spanId = (0, $kgI9H.uuid4)().substring(16), sampled) {
    let sampledString = '';
    if (sampled !== undefined) sampledString = sampled ? '-1' : '-0';
    return `${traceId}-${spanId}${sampledString}`;
}

});
parcelRegister("dXnsY", function(module, exports) {
$parcel$export(module.exports, "baggageHeaderToDynamicSamplingContext", () => $a292fcfc09426e20$export$5b96ee2c8421f107);

var $fUFQt = parcelRequire("fUFQt");

var $2Jaqc = parcelRequire("2Jaqc");

var $6lJZW = parcelRequire("6lJZW");
const $a292fcfc09426e20$export$9ca9946bd449ac06 = 'baggage';
const $a292fcfc09426e20$export$6e69537d67fa20f = 'sentry-';
const $a292fcfc09426e20$export$eb0401070c617ea5 = /^sentry-/;
/**
 * Max length of a serialized baggage string
 *
 * https://www.w3.org/TR/baggage/#limits
 */ const $a292fcfc09426e20$export$bdd844ddb2def819 = 8192;
/**
 * Takes a baggage header and turns it into Dynamic Sampling Context, by extracting all the "sentry-" prefixed values
 * from it.
 *
 * @param baggageHeader A very bread definition of a baggage header as it might appear in various frameworks.
 * @returns The Dynamic Sampling Context that was found on `baggageHeader`, if there was any, `undefined` otherwise.
 */ function $a292fcfc09426e20$export$5b96ee2c8421f107(// Very liberal definition of what any incoming header might look like
baggageHeader) {
    if (!(0, $2Jaqc.isString)(baggageHeader) && !Array.isArray(baggageHeader)) return undefined;
    // Intermediary object to store baggage key value pairs of incoming baggage headers on.
    // It is later used to read Sentry-DSC-values from.
    let baggageObject = {};
    if (Array.isArray(baggageHeader)) // Combine all baggage headers into one object containing the baggage values so we can later read the Sentry-DSC-values from it
    baggageObject = baggageHeader.reduce((acc, curr)=>{
        const currBaggageObject = $a292fcfc09426e20$var$baggageHeaderToObject(curr);
        for (const key of Object.keys(currBaggageObject))acc[key] = currBaggageObject[key];
        return acc;
    }, {});
    else {
        // Return undefined if baggage header is an empty string (technically an empty baggage header is not spec conform but
        // this is how we choose to handle it)
        if (!baggageHeader) return undefined;
        baggageObject = $a292fcfc09426e20$var$baggageHeaderToObject(baggageHeader);
    }
    // Read all "sentry-" prefixed values out of the baggage object and put it onto a dynamic sampling context object.
    const dynamicSamplingContext = Object.entries(baggageObject).reduce((acc, [key, value])=>{
        if (key.match($a292fcfc09426e20$export$eb0401070c617ea5)) {
            const nonPrefixedKey = key.slice($a292fcfc09426e20$export$6e69537d67fa20f.length);
            acc[nonPrefixedKey] = value;
        }
        return acc;
    }, {});
    // Only return a dynamic sampling context object if there are keys in it.
    // A keyless object means there were no sentry values on the header, which means that there is no DSC.
    if (Object.keys(dynamicSamplingContext).length > 0) return dynamicSamplingContext;
    else return undefined;
}
/**
 * Turns a Dynamic Sampling Object into a baggage header by prefixing all the keys on the object with "sentry-".
 *
 * @param dynamicSamplingContext The Dynamic Sampling Context to turn into a header. For convenience and compatibility
 * with the `getDynamicSamplingContext` method on the Transaction class ,this argument can also be `undefined`. If it is
 * `undefined` the function will return `undefined`.
 * @returns a baggage header, created from `dynamicSamplingContext`, or `undefined` either if `dynamicSamplingContext`
 * was `undefined`, or if `dynamicSamplingContext` didn't contain any values.
 */ function $a292fcfc09426e20$export$56766feef403f365(// this also takes undefined for convenience and bundle size in other places
dynamicSamplingContext) {
    if (!dynamicSamplingContext) return undefined;
    // Prefix all DSC keys with "sentry-" and put them into a new object
    const sentryPrefixedDSC = Object.entries(dynamicSamplingContext).reduce((acc, [dscKey, dscValue])=>{
        if (dscValue) acc[`${$a292fcfc09426e20$export$6e69537d67fa20f}${dscKey}`] = dscValue;
        return acc;
    }, {});
    return $a292fcfc09426e20$var$objectToBaggageHeader(sentryPrefixedDSC);
}
/**
 * Will parse a baggage header, which is a simple key-value map, into a flat object.
 *
 * @param baggageHeader The baggage header to parse.
 * @returns a flat object containing all the key-value pairs from `baggageHeader`.
 */ function $a292fcfc09426e20$var$baggageHeaderToObject(baggageHeader) {
    return baggageHeader.split(',').map((baggageEntry)=>baggageEntry.split('=').map((keyOrValue)=>decodeURIComponent(keyOrValue.trim()))).reduce((acc, [key, value])=>{
        acc[key] = value;
        return acc;
    }, {});
}
/**
 * Turns a flat object (key-value pairs) into a baggage header, which is also just key-value pairs.
 *
 * @param object The object to turn into a baggage header.
 * @returns a baggage header string, or `undefined` if the object didn't have any values, since an empty baggage header
 * is not spec compliant.
 */ function $a292fcfc09426e20$var$objectToBaggageHeader(object) {
    if (Object.keys(object).length === 0) // An empty baggage header is not spec compliant: We return undefined.
    return undefined;
    return Object.entries(object).reduce((baggageHeader, [objectKey, objectValue], currentIndex)=>{
        const baggageEntry = `${encodeURIComponent(objectKey)}=${encodeURIComponent(objectValue)}`;
        const newBaggageHeader = currentIndex === 0 ? baggageEntry : `${baggageHeader},${baggageEntry}`;
        if (newBaggageHeader.length > $a292fcfc09426e20$export$bdd844ddb2def819) {
            (0, $fUFQt.DEBUG_BUILD) && (0, $6lJZW.logger).warn(`Not adding key: ${objectKey} with val: ${objectValue} to baggage header due to exceeding baggage size limits.`);
            return baggageHeader;
        } else return newBaggageHeader;
    }, '');
}

});






parcelRegister("7IBdF", function(module, exports) {
$parcel$export(module.exports, "SDK_VERSION", () => $59e9837458c8c862$export$31499a9cd224b78c);
const $59e9837458c8c862$export$31499a9cd224b78c = '7.119.0';

});


parcelRegister("2biSp", function(module, exports) {
$parcel$export(module.exports, "prepareEvent", () => $196b40565d120093$export$2d67fb380bd11267);
$parcel$export(module.exports, "parseEventHintOrCaptureContext", () => $196b40565d120093$export$76b5f966996d1653);

var $kgI9H = parcelRequire("kgI9H");
var $gv1sw = parcelRequire("gv1sw");
var $aFn2S = parcelRequire("aFn2S");
var $9ZmTE = parcelRequire("9ZmTE");
var $4RzNY = parcelRequire("4RzNY");

var $b2zyj = parcelRequire("b2zyj");

var $1feQE = parcelRequire("1feQE");

var $31p7m = parcelRequire("31p7m");

var $gqwnB = parcelRequire("gqwnB");

var $9NVyI = parcelRequire("9NVyI");
/**
 * This type makes sure that we get either a CaptureContext, OR an EventHint.
 * It does not allow mixing them, which could lead to unexpected outcomes, e.g. this is disallowed:
 * { user: { id: '123' }, mechanism: { handled: false } }
 */ /**
 * Adds common information to events.
 *
 * The information includes release and environment from `options`,
 * breadcrumbs and context (extra, tags and user) from the scope.
 *
 * Information that is already present in the event is never overwritten. For
 * nested objects, such as the context, keys are merged.
 *
 * Note: This also triggers callbacks for `addGlobalEventProcessor`, but not `beforeSend`.
 *
 * @param event The original event.
 * @param hint May contain additional information about the original exception.
 * @param scope A scope containing event metadata.
 * @returns A new event with more information.
 * @hidden
 */ function $196b40565d120093$export$2d67fb380bd11267(options, event, hint, scope, client, isolationScope) {
    const { normalizeDepth: normalizeDepth = 3, normalizeMaxBreadth: normalizeMaxBreadth = 1000 } = options;
    const prepared = {
        ...event,
        event_id: event.event_id || hint.event_id || (0, $kgI9H.uuid4)(),
        timestamp: event.timestamp || (0, $gv1sw.dateTimestampInSeconds)()
    };
    const integrations = hint.integrations || options.integrations.map((i)=>i.name);
    $196b40565d120093$var$applyClientOptions(prepared, options);
    $196b40565d120093$var$applyIntegrationsMetadata(prepared, integrations);
    // Only put debug IDs onto frames for error events.
    if (event.type === undefined) $196b40565d120093$export$63042efc86f043e7(prepared, options.stackParser);
    // If we have scope given to us, use it as the base for further modifications.
    // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
    const finalScope = $196b40565d120093$var$getFinalScope(scope, hint.captureContext);
    if (hint.mechanism) (0, $kgI9H.addExceptionMechanism)(prepared, hint.mechanism);
    const clientEventProcessors = client && client.getEventProcessors ? client.getEventProcessors() : [];
    // This should be the last thing called, since we want that
    // {@link Hub.addEventProcessor} gets the finished prepared event.
    // Merge scope data together
    const data = (0, $31p7m.getGlobalScope)().getScopeData();
    if (isolationScope) {
        const isolationData = isolationScope.getScopeData();
        (0, $gqwnB.mergeScopeData)(data, isolationData);
    }
    if (finalScope) {
        const finalScopeData = finalScope.getScopeData();
        (0, $gqwnB.mergeScopeData)(data, finalScopeData);
    }
    const attachments = [
        ...hint.attachments || [],
        ...data.attachments
    ];
    if (attachments.length) hint.attachments = attachments;
    (0, $gqwnB.applyScopeDataToEvent)(prepared, data);
    // TODO (v8): Update this order to be: Global > Client > Scope
    const eventProcessors = [
        ...clientEventProcessors,
        // eslint-disable-next-line deprecation/deprecation
        ...(0, $1feQE.getGlobalEventProcessors)(),
        // Run scope event processors _after_ all other processors
        ...data.eventProcessors
    ];
    const result = (0, $1feQE.notifyEventProcessors)(eventProcessors, prepared, hint);
    return result.then((evt)=>{
        if (evt) // We apply the debug_meta field only after all event processors have ran, so that if any event processors modified
        // file names (e.g.the RewriteFrames integration) the filename -> debug ID relationship isn't destroyed.
        // This should not cause any PII issues, since we're only moving data that is already on the event and not adding
        // any new data
        $196b40565d120093$export$1be657ba8ef44ff0(evt);
        if (typeof normalizeDepth === 'number' && normalizeDepth > 0) return $196b40565d120093$var$normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
        return evt;
    });
}
/**
 *  Enhances event using the client configuration.
 *  It takes care of all "static" values like environment, release and `dist`,
 *  as well as truncating overly long values.
 * @param event event instance to be enhanced
 */ function $196b40565d120093$var$applyClientOptions(event, options) {
    const { environment: environment, release: release, dist: dist, maxValueLength: maxValueLength = 250 } = options;
    if (!('environment' in event)) event.environment = 'environment' in options ? environment : (0, $b2zyj.DEFAULT_ENVIRONMENT);
    if (event.release === undefined && release !== undefined) event.release = release;
    if (event.dist === undefined && dist !== undefined) event.dist = dist;
    if (event.message) event.message = (0, $4RzNY.truncate)(event.message, maxValueLength);
    const exception = event.exception && event.exception.values && event.exception.values[0];
    if (exception && exception.value) exception.value = (0, $4RzNY.truncate)(exception.value, maxValueLength);
    const request = event.request;
    if (request && request.url) request.url = (0, $4RzNY.truncate)(request.url, maxValueLength);
}
const $196b40565d120093$var$debugIdStackParserCache = new WeakMap();
/**
 * Puts debug IDs into the stack frames of an error event.
 */ function $196b40565d120093$export$63042efc86f043e7(event, stackParser) {
    const debugIdMap = (0, $aFn2S.GLOBAL_OBJ)._sentryDebugIds;
    if (!debugIdMap) return;
    let debugIdStackFramesCache;
    const cachedDebugIdStackFrameCache = $196b40565d120093$var$debugIdStackParserCache.get(stackParser);
    if (cachedDebugIdStackFrameCache) debugIdStackFramesCache = cachedDebugIdStackFrameCache;
    else {
        debugIdStackFramesCache = new Map();
        $196b40565d120093$var$debugIdStackParserCache.set(stackParser, debugIdStackFramesCache);
    }
    // Build a map of filename -> debug_id
    const filenameDebugIdMap = Object.keys(debugIdMap).reduce((acc, debugIdStackTrace)=>{
        let parsedStack;
        const cachedParsedStack = debugIdStackFramesCache.get(debugIdStackTrace);
        if (cachedParsedStack) parsedStack = cachedParsedStack;
        else {
            parsedStack = stackParser(debugIdStackTrace);
            debugIdStackFramesCache.set(debugIdStackTrace, parsedStack);
        }
        for(let i = parsedStack.length - 1; i >= 0; i--){
            const stackFrame = parsedStack[i];
            if (stackFrame.filename) {
                acc[stackFrame.filename] = debugIdMap[debugIdStackTrace];
                break;
            }
        }
        return acc;
    }, {});
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values.forEach((exception)=>{
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            exception.stacktrace.frames.forEach((frame)=>{
                if (frame.filename) frame.debug_id = filenameDebugIdMap[frame.filename];
            });
        });
    } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
    }
}
/**
 * Moves debug IDs from the stack frames of an error event into the debug_meta field.
 */ function $196b40565d120093$export$1be657ba8ef44ff0(event) {
    // Extract debug IDs and filenames from the stack frames on the event.
    const filenameDebugIdMap = {};
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values.forEach((exception)=>{
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            exception.stacktrace.frames.forEach((frame)=>{
                if (frame.debug_id) {
                    if (frame.abs_path) filenameDebugIdMap[frame.abs_path] = frame.debug_id;
                    else if (frame.filename) filenameDebugIdMap[frame.filename] = frame.debug_id;
                    delete frame.debug_id;
                }
            });
        });
    } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
    }
    if (Object.keys(filenameDebugIdMap).length === 0) return;
    // Fill debug_meta information
    event.debug_meta = event.debug_meta || {};
    event.debug_meta.images = event.debug_meta.images || [];
    const images = event.debug_meta.images;
    Object.keys(filenameDebugIdMap).forEach((filename)=>{
        images.push({
            type: 'sourcemap',
            code_file: filename,
            debug_id: filenameDebugIdMap[filename]
        });
    });
}
/**
 * This function adds all used integrations to the SDK info in the event.
 * @param event The event that will be filled with all integrations.
 */ function $196b40565d120093$var$applyIntegrationsMetadata(event, integrationNames) {
    if (integrationNames.length > 0) {
        event.sdk = event.sdk || {};
        event.sdk.integrations = [
            ...event.sdk.integrations || [],
            ...integrationNames
        ];
    }
}
/**
 * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
 * Normalized keys:
 * - `breadcrumbs.data`
 * - `user`
 * - `contexts`
 * - `extra`
 * @param event Event
 * @returns Normalized event
 */ function $196b40565d120093$var$normalizeEvent(event, depth, maxBreadth) {
    if (!event) return null;
    const normalized = {
        ...event,
        ...event.breadcrumbs && {
            breadcrumbs: event.breadcrumbs.map((b)=>({
                    ...b,
                    ...b.data && {
                        data: (0, $9ZmTE.normalize)(b.data, depth, maxBreadth)
                    }
                }))
        },
        ...event.user && {
            user: (0, $9ZmTE.normalize)(event.user, depth, maxBreadth)
        },
        ...event.contexts && {
            contexts: (0, $9ZmTE.normalize)(event.contexts, depth, maxBreadth)
        },
        ...event.extra && {
            extra: (0, $9ZmTE.normalize)(event.extra, depth, maxBreadth)
        }
    };
    // event.contexts.trace stores information about a Transaction. Similarly,
    // event.spans[] stores information about child Spans. Given that a
    // Transaction is conceptually a Span, normalization should apply to both
    // Transactions and Spans consistently.
    // For now the decision is to skip normalization of Transactions and Spans,
    // so this block overwrites the normalized event to add back the original
    // Transaction information prior to normalization.
    if (event.contexts && event.contexts.trace && normalized.contexts) {
        normalized.contexts.trace = event.contexts.trace;
        // event.contexts.trace.data may contain circular/dangerous data so we need to normalize it
        if (event.contexts.trace.data) normalized.contexts.trace.data = (0, $9ZmTE.normalize)(event.contexts.trace.data, depth, maxBreadth);
    }
    // event.spans[].data may contain circular/dangerous data so we need to normalize it
    if (event.spans) normalized.spans = event.spans.map((span)=>{
        const data = (0, $9NVyI.spanToJSON)(span).data;
        if (data) // This is a bit weird, as we generally have `Span` instances here, but to be safe we do not assume so
        // eslint-disable-next-line deprecation/deprecation
        span.data = (0, $9ZmTE.normalize)(data, depth, maxBreadth);
        return span;
    });
    return normalized;
}
function $196b40565d120093$var$getFinalScope(scope, captureContext) {
    if (!captureContext) return scope;
    const finalScope = scope ? scope.clone() : new (0, $31p7m.Scope)();
    finalScope.update(captureContext);
    return finalScope;
}
/**
 * Parse either an `EventHint` directly, or convert a `CaptureContext` to an `EventHint`.
 * This is used to allow to update method signatures that used to accept a `CaptureContext` but should now accept an `EventHint`.
 */ function $196b40565d120093$export$76b5f966996d1653(hint) {
    if (!hint) return undefined;
    // If you pass a Scope or `() => Scope` as CaptureContext, we just return this as captureContext
    if ($196b40565d120093$var$hintIsScopeOrFunction(hint)) return {
        captureContext: hint
    };
    if ($196b40565d120093$var$hintIsScopeContext(hint)) return {
        captureContext: hint
    };
    return hint;
}
function $196b40565d120093$var$hintIsScopeOrFunction(hint) {
    return hint instanceof (0, $31p7m.Scope) || typeof hint === 'function';
}
const $196b40565d120093$var$captureContextKeys = [
    'user',
    'level',
    'extra',
    'contexts',
    'tags',
    'fingerprint',
    'requestSession',
    'propagationContext'
];
function $196b40565d120093$var$hintIsScopeContext(hint) {
    return Object.keys(hint).some((key)=>$196b40565d120093$var$captureContextKeys.includes(key));
}

});
parcelRegister("9ZmTE", function(module, exports) {
$parcel$export(module.exports, "normalize", () => $745b925dd90cd883$export$a3295358bff77e);
$parcel$export(module.exports, "normalizeToSize", () => $745b925dd90cd883$export$23fbbb20bed71033);

var $2Jaqc = parcelRequire("2Jaqc");

var $frvRv = parcelRequire("frvRv");

var $3dFJR = parcelRequire("3dFJR");

var $amn5g = parcelRequire("amn5g");
/**
 * Recursively normalizes the given object.
 *
 * - Creates a copy to prevent original input mutation
 * - Skips non-enumerable properties
 * - When stringifying, calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializable values (`undefined`/`NaN`/functions) to serializable format
 * - Translates known global objects/classes to a string representations
 * - Takes care of `Error` object serialization
 * - Optionally limits depth of final output
 * - Optionally limits number of properties/elements included in any single object/array
 *
 * @param input The object to be normalized.
 * @param depth The max depth to which to normalize the object. (Anything deeper stringified whole.)
 * @param maxProperties The max number of elements or properties to be included in any single array or
 * object in the normallized output.
 * @returns A normalized version of the object, or `"**non-serializable**"` if any errors are thrown during normalization.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $745b925dd90cd883$export$a3295358bff77e(input, depth = 100, maxProperties = Infinity) {
    try {
        // since we're at the outermost level, we don't provide a key
        return $745b925dd90cd883$export$588732934346abbf('', input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: `**non-serializable** (${err})`
        };
    }
}
/** JSDoc */ function $745b925dd90cd883$export$23fbbb20bed71033(// eslint-disable-next-line @typescript-eslint/no-explicit-any
object, // Default Node.js REPL depth
depth = 3, // 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize = 102400) {
    const normalized = $745b925dd90cd883$export$a3295358bff77e(object, depth);
    if ($745b925dd90cd883$var$jsonSize(normalized) > maxSize) return $745b925dd90cd883$export$23fbbb20bed71033(object, depth - 1, maxSize);
    return normalized;
}
/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */ function $745b925dd90cd883$export$588732934346abbf(key, value, depth = Infinity, maxProperties = Infinity, memo = (0, $frvRv.memoBuilder)()) {
    const [memoize, unmemoize] = memo;
    // Get the simple cases out of the way first
    if (value == null || // this matches null and undefined -> eqeq not eqeqeq
    [
        'number',
        'boolean',
        'string'
    ].includes(typeof value) && !(0, $2Jaqc.isNaN)(value)) return value;
    const stringified = $745b925dd90cd883$var$stringifyValue(key, value);
    // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
    // Everything else will have already been serialized, so if we don't see that pattern, we're done.
    if (!stringified.startsWith('[object ')) return stringified;
    // From here on, we can assert that `value` is either an object or an array.
    // Do not normalize objects that we know have already been normalized. As a general rule, the
    // "__sentry_skip_normalization__" property should only be used sparingly and only should only be set on objects that
    // have already been normalized.
    if (value['__sentry_skip_normalization__']) return value;
    // We can set `__sentry_override_normalization_depth__` on an object to ensure that from there
    // We keep a certain amount of depth.
    // This should be used sparingly, e.g. we use it for the redux integration to ensure we get a certain amount of state.
    const remainingDepth = typeof value['__sentry_override_normalization_depth__'] === 'number' ? value['__sentry_override_normalization_depth__'] : depth;
    // We're also done if we've reached the max depth
    if (remainingDepth === 0) // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace('object ', '');
    // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
    if (memoize(value)) return '[Circular ~]';
    // If the value has a `toJSON` method, we call it to extract more information
    const valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === 'function') try {
        const jsonValue = valueWithToJSON.toJSON();
        // We need to normalize the return value of `.toJSON()` in case it has circular references
        return $745b925dd90cd883$export$588732934346abbf('', jsonValue, remainingDepth - 1, maxProperties, memo);
    } catch (err) {
    // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
    // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
    // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
    // property/entry, and keep track of the number of items we add to it.
    const normalized = Array.isArray(value) ? [] : {};
    let numAdded = 0;
    // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
    // properties are non-enumerable and otherwise would get missed.
    const visitable = (0, $3dFJR.convertToPlainObject)(value);
    for(const visitKey in visitable){
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = '[MaxProperties ~]';
            break;
        }
        // Recursively visit all the child nodes
        const visitValue = visitable[visitKey];
        normalized[visitKey] = $745b925dd90cd883$export$588732934346abbf(visitKey, visitValue, remainingDepth - 1, maxProperties, memo);
        numAdded++;
    }
    // Once we've visited all the branches, remove the parent from memo storage
    unmemoize(value);
    // Return accumulated values
    return normalized;
}
/* eslint-disable complexity */ /**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */ function $745b925dd90cd883$var$stringifyValue(key, // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
// our internal use, it'll do
value) {
    try {
        if (key === 'domain' && value && typeof value === 'object' && value._events) return '[Domain]';
        if (key === 'domainEmitter') return '[DomainEmitter]';
        // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
        // which won't throw if they are not present.
        if (typeof $parcel$global !== 'undefined' && value === $parcel$global) return '[Global]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof window !== 'undefined' && value === window) return '[Window]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof document !== 'undefined' && value === document) return '[Document]';
        if ((0, $2Jaqc.isVueViewModel)(value)) return '[VueViewModel]';
        // React's SyntheticEvent thingy
        if ((0, $2Jaqc.isSyntheticEvent)(value)) return '[SyntheticEvent]';
        if (typeof value === 'number' && value !== value) return '[NaN]';
        if (typeof value === 'function') return `[Function: ${(0, $amn5g.getFunctionName)(value)}]`;
        if (typeof value === 'symbol') return `[${String(value)}]`;
        // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
        if (typeof value === 'bigint') return `[BigInt: ${String(value)}]`;
        // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
        // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
        // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
        // we can make sure that only plain objects come out that way.
        const objName = $745b925dd90cd883$var$getConstructorName(value);
        // Handle HTML Elements
        if (/^HTML(\w*)Element$/.test(objName)) return `[HTMLElement: ${objName}]`;
        return `[object ${objName}]`;
    } catch (err) {
        return `**non-serializable** (${err})`;
    }
}
/* eslint-enable complexity */ function $745b925dd90cd883$var$getConstructorName(value) {
    const prototype = Object.getPrototypeOf(value);
    return prototype ? prototype.constructor.name : 'null prototype';
}
/** Calculates bytes size of input string */ function $745b925dd90cd883$var$utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $745b925dd90cd883$var$jsonSize(value) {
    return $745b925dd90cd883$var$utf8Length(JSON.stringify(value));
}
/**
 * Normalizes URLs in exceptions and stacktraces to a base path so Sentry can fingerprint
 * across platforms and working directory.
 *
 * @param url The URL to be normalized.
 * @param basePath The application base path.
 * @returns The normalized URL.
 */ function $745b925dd90cd883$export$472b29734be05be3(url, basePath) {
    const escapedBase = basePath// Backslash to forward
    .replace(/\\/g, '/')// Escape RegExp special characters
    .replace(/[|\\{}()[\]^$+*?.]/g, '\\$&');
    let newUrl = url;
    try {
        newUrl = decodeURI(url);
    } catch (_Oo) {
    // Sometime this breaks
    }
    return newUrl.replace(/\\/g, '/').replace(/webpack:\/?/g, '') // Remove intermediate base path
    // eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor
    .replace(new RegExp(`(file://)?/*${escapedBase}/*`, 'ig'), 'app:///');
}

});
parcelRegister("frvRv", function(module, exports) {
$parcel$export(module.exports, "memoBuilder", () => $b3e217c7e60fc6e0$export$8115b0b78e956ab3);
/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Helper to decycle json objects
 */ function $b3e217c7e60fc6e0$export$8115b0b78e956ab3() {
    const hasWeakSet = typeof WeakSet === 'function';
    const inner = hasWeakSet ? new WeakSet() : [];
    function memoize(obj) {
        if (hasWeakSet) {
            if (inner.has(obj)) return true;
            inner.add(obj);
            return false;
        }
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for(let i = 0; i < inner.length; i++){
            const value = inner[i];
            if (value === obj) return true;
        }
        inner.push(obj);
        return false;
    }
    function unmemoize(obj) {
        if (hasWeakSet) inner.delete(obj);
        else {
            for(let i = 0; i < inner.length; i++)if (inner[i] === obj) {
                inner.splice(i, 1);
                break;
            }
        }
    }
    return [
        memoize,
        unmemoize
    ];
}

});

parcelRegister("amn5g", function(module, exports) {
$parcel$export(module.exports, "createStackParser", () => $78addd7199ad4a5e$export$a5739666fb2d03d4);
$parcel$export(module.exports, "stackParserFromStackParserOptions", () => $78addd7199ad4a5e$export$1d5cf88b347146d4);
$parcel$export(module.exports, "getFunctionName", () => $78addd7199ad4a5e$export$aad197c7121a6651);

var $ddbiW = parcelRequire("ddbiW");
const $78addd7199ad4a5e$var$STACKTRACE_FRAME_LIMIT = 50;
// Used to sanitize webpack (error: *) wrapped stack errors
const $78addd7199ad4a5e$var$WEBPACK_ERROR_REGEXP = /\(error: (.*)\)/;
const $78addd7199ad4a5e$var$STRIP_FRAME_REGEXP = /captureMessage|captureException/;
/**
 * Creates a stack parser with the supplied line parsers
 *
 * StackFrames are returned in the correct order for Sentry Exception
 * frames and with Sentry SDK internal frames removed from the top and bottom
 *
 */ function $78addd7199ad4a5e$export$a5739666fb2d03d4(...parsers) {
    const sortedParsers = parsers.sort((a, b)=>a[0] - b[0]).map((p)=>p[1]);
    return (stack, skipFirst = 0)=>{
        const frames = [];
        const lines = stack.split('\n');
        for(let i = skipFirst; i < lines.length; i++){
            const line = lines[i];
            // Ignore lines over 1kb as they are unlikely to be stack frames.
            // Many of the regular expressions use backtracking which results in run time that increases exponentially with
            // input size. Huge strings can result in hangs/Denial of Service:
            // https://github.com/getsentry/sentry-javascript/issues/2286
            if (line.length > 1024) continue;
            // https://github.com/getsentry/sentry-javascript/issues/5459
            // Remove webpack (error: *) wrappers
            const cleanedLine = $78addd7199ad4a5e$var$WEBPACK_ERROR_REGEXP.test(line) ? line.replace($78addd7199ad4a5e$var$WEBPACK_ERROR_REGEXP, '$1') : line;
            // https://github.com/getsentry/sentry-javascript/issues/7813
            // Skip Error: lines
            if (cleanedLine.match(/\S*Error: /)) continue;
            for (const parser of sortedParsers){
                const frame = parser(cleanedLine);
                if (frame) {
                    frames.push(frame);
                    break;
                }
            }
            if (frames.length >= $78addd7199ad4a5e$var$STACKTRACE_FRAME_LIMIT) break;
        }
        return $78addd7199ad4a5e$export$c55c24c0eeba0205(frames);
    };
}
/**
 * Gets a stack parser implementation from Options.stackParser
 * @see Options
 *
 * If options contains an array of line parsers, it is converted into a parser
 */ function $78addd7199ad4a5e$export$1d5cf88b347146d4(stackParser) {
    if (Array.isArray(stackParser)) return $78addd7199ad4a5e$export$a5739666fb2d03d4(...stackParser);
    return stackParser;
}
/**
 * Removes Sentry frames from the top and bottom of the stack if present and enforces a limit of max number of frames.
 * Assumes stack input is ordered from top to bottom and returns the reverse representation so call site of the
 * function that caused the crash is the last frame in the array.
 * @hidden
 */ function $78addd7199ad4a5e$export$c55c24c0eeba0205(stack) {
    if (!stack.length) return [];
    const localStack = Array.from(stack);
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (/sentryWrapped/.test(localStack[localStack.length - 1].function || '')) localStack.pop();
    // Reversing in the middle of the procedure allows us to just pop the values off the stack
    localStack.reverse();
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if ($78addd7199ad4a5e$var$STRIP_FRAME_REGEXP.test(localStack[localStack.length - 1].function || '')) {
        localStack.pop();
        // When using synthetic events, we will have a 2 levels deep stack, as `new Error('Sentry syntheticException')`
        // is produced within the hub itself, making it:
        //
        //   Sentry.captureException()
        //   getCurrentHub().captureException()
        //
        // instead of just the top `Sentry` call itself.
        // This forces us to possibly strip an additional frame in the exact same was as above.
        if ($78addd7199ad4a5e$var$STRIP_FRAME_REGEXP.test(localStack[localStack.length - 1].function || '')) localStack.pop();
    }
    return localStack.slice(0, $78addd7199ad4a5e$var$STACKTRACE_FRAME_LIMIT).map((frame)=>({
            ...frame,
            filename: frame.filename || localStack[localStack.length - 1].filename,
            function: frame.function || '?'
        }));
}
const $78addd7199ad4a5e$var$defaultFunctionName = '<anonymous>';
/**
 * Safely extract function name from itself
 */ function $78addd7199ad4a5e$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== 'function') return $78addd7199ad4a5e$var$defaultFunctionName;
        return fn.name || $78addd7199ad4a5e$var$defaultFunctionName;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return $78addd7199ad4a5e$var$defaultFunctionName;
    }
}
/**
 * Node.js stack line parser
 *
 * This is in @sentry/utils so it can be used from the Electron SDK in the browser for when `nodeIntegration == true`.
 * This allows it to be used without referencing or importing any node specific code which causes bundlers to complain
 */ function $78addd7199ad4a5e$export$673345a0da635a78(getModule) {
    return [
        90,
        (0, $ddbiW.node)(getModule)
    ];
}

});
parcelRegister("ddbiW", function(module, exports) {
$parcel$export(module.exports, "node", () => $99e5421b5e46cd4d$export$35059013cd4a06db);
/**
 * Does this filename look like it's part of the app code?
 */ function $99e5421b5e46cd4d$export$1de92f38f4de99a8(filename, isNative = false) {
    const isInternal = isNative || filename && // It's not internal if it's an absolute linux path
    !filename.startsWith('/') && // It's not internal if it's an absolute windows path
    !filename.match(/^[A-Z]:/) && // It's not internal if the path is starting with a dot
    !filename.startsWith('.') && // It's not internal if the frame has a protocol. In node, this is usually the case if the file got pre-processed with a bundler like webpack
    !filename.match(/^[a-zA-Z]([a-zA-Z0-9.\-+])*:\/\//); // Schema from: https://stackoverflow.com/a/3641782
    // in_app is all that's not an internal Node function or a module within node_modules
    // note that isNative appears to return true even for node core libraries
    // see https://github.com/getsentry/raven-node/issues/176
    return !isInternal && filename !== undefined && !filename.includes('node_modules/');
}
/** Node Stack line parser */ // eslint-disable-next-line complexity
function $99e5421b5e46cd4d$export$35059013cd4a06db(getModule) {
    const FILENAME_MATCH = /^\s*[-]{4,}$/;
    const FULL_MATCH = /at (?:async )?(?:(.+?)\s+\()?(?:(.+):(\d+):(\d+)?|([^)]+))\)?/;
    // eslint-disable-next-line complexity
    return (line)=>{
        const lineMatch = line.match(FULL_MATCH);
        if (lineMatch) {
            let object;
            let method;
            let functionName;
            let typeName;
            let methodName;
            if (lineMatch[1]) {
                functionName = lineMatch[1];
                let methodStart = functionName.lastIndexOf('.');
                if (functionName[methodStart - 1] === '.') methodStart--;
                if (methodStart > 0) {
                    object = functionName.slice(0, methodStart);
                    method = functionName.slice(methodStart + 1);
                    const objectEnd = object.indexOf('.Module');
                    if (objectEnd > 0) {
                        functionName = functionName.slice(objectEnd + 1);
                        object = object.slice(0, objectEnd);
                    }
                }
                typeName = undefined;
            }
            if (method) {
                typeName = object;
                methodName = method;
            }
            if (method === '<anonymous>') {
                methodName = undefined;
                functionName = undefined;
            }
            if (functionName === undefined) {
                methodName = methodName || '<anonymous>';
                functionName = typeName ? `${typeName}.${methodName}` : methodName;
            }
            let filename = lineMatch[2] && lineMatch[2].startsWith('file://') ? lineMatch[2].slice(7) : lineMatch[2];
            const isNative = lineMatch[5] === 'native';
            // If it's a Windows path, trim the leading slash so that `/C:/foo` becomes `C:/foo`
            if (filename && filename.match(/\/[A-Z]:/)) filename = filename.slice(1);
            if (!filename && lineMatch[5] && !isNative) filename = lineMatch[5];
            return {
                filename: filename,
                module: getModule ? getModule(filename) : undefined,
                function: functionName,
                lineno: parseInt(lineMatch[3], 10) || undefined,
                colno: parseInt(lineMatch[4], 10) || undefined,
                in_app: $99e5421b5e46cd4d$export$1de92f38f4de99a8(filename, isNative)
            };
        }
        if (line.match(FILENAME_MATCH)) return {
            filename: line
        };
        return undefined;
    };
}

});







parcelRegister("igDjg", function(module, exports) {
// shim for using process in browser
var $d4c836af0ec1e846$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $d4c836af0ec1e846$var$cachedSetTimeout;
var $d4c836af0ec1e846$var$cachedClearTimeout;
function $d4c836af0ec1e846$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $d4c836af0ec1e846$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $d4c836af0ec1e846$var$cachedSetTimeout = setTimeout;
        else $d4c836af0ec1e846$var$cachedSetTimeout = $d4c836af0ec1e846$var$defaultSetTimout;
    } catch (e) {
        $d4c836af0ec1e846$var$cachedSetTimeout = $d4c836af0ec1e846$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $d4c836af0ec1e846$var$cachedClearTimeout = clearTimeout;
        else $d4c836af0ec1e846$var$cachedClearTimeout = $d4c836af0ec1e846$var$defaultClearTimeout;
    } catch (e) {
        $d4c836af0ec1e846$var$cachedClearTimeout = $d4c836af0ec1e846$var$defaultClearTimeout;
    }
})();
function $d4c836af0ec1e846$var$runTimeout(fun) {
    if ($d4c836af0ec1e846$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($d4c836af0ec1e846$var$cachedSetTimeout === $d4c836af0ec1e846$var$defaultSetTimout || !$d4c836af0ec1e846$var$cachedSetTimeout) && setTimeout) {
        $d4c836af0ec1e846$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $d4c836af0ec1e846$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $d4c836af0ec1e846$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $d4c836af0ec1e846$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $d4c836af0ec1e846$var$runClearTimeout(marker) {
    if ($d4c836af0ec1e846$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($d4c836af0ec1e846$var$cachedClearTimeout === $d4c836af0ec1e846$var$defaultClearTimeout || !$d4c836af0ec1e846$var$cachedClearTimeout) && clearTimeout) {
        $d4c836af0ec1e846$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $d4c836af0ec1e846$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $d4c836af0ec1e846$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $d4c836af0ec1e846$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $d4c836af0ec1e846$var$queue = [];
var $d4c836af0ec1e846$var$draining = false;
var $d4c836af0ec1e846$var$currentQueue;
var $d4c836af0ec1e846$var$queueIndex = -1;
function $d4c836af0ec1e846$var$cleanUpNextTick() {
    if (!$d4c836af0ec1e846$var$draining || !$d4c836af0ec1e846$var$currentQueue) return;
    $d4c836af0ec1e846$var$draining = false;
    if ($d4c836af0ec1e846$var$currentQueue.length) $d4c836af0ec1e846$var$queue = $d4c836af0ec1e846$var$currentQueue.concat($d4c836af0ec1e846$var$queue);
    else $d4c836af0ec1e846$var$queueIndex = -1;
    if ($d4c836af0ec1e846$var$queue.length) $d4c836af0ec1e846$var$drainQueue();
}
function $d4c836af0ec1e846$var$drainQueue() {
    if ($d4c836af0ec1e846$var$draining) return;
    var timeout = $d4c836af0ec1e846$var$runTimeout($d4c836af0ec1e846$var$cleanUpNextTick);
    $d4c836af0ec1e846$var$draining = true;
    var len = $d4c836af0ec1e846$var$queue.length;
    while(len){
        $d4c836af0ec1e846$var$currentQueue = $d4c836af0ec1e846$var$queue;
        $d4c836af0ec1e846$var$queue = [];
        while(++$d4c836af0ec1e846$var$queueIndex < len)if ($d4c836af0ec1e846$var$currentQueue) $d4c836af0ec1e846$var$currentQueue[$d4c836af0ec1e846$var$queueIndex].run();
        $d4c836af0ec1e846$var$queueIndex = -1;
        len = $d4c836af0ec1e846$var$queue.length;
    }
    $d4c836af0ec1e846$var$currentQueue = null;
    $d4c836af0ec1e846$var$draining = false;
    $d4c836af0ec1e846$var$runClearTimeout(timeout);
}
$d4c836af0ec1e846$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $d4c836af0ec1e846$var$queue.push(new $d4c836af0ec1e846$var$Item(fun, args));
    if ($d4c836af0ec1e846$var$queue.length === 1 && !$d4c836af0ec1e846$var$draining) $d4c836af0ec1e846$var$runTimeout($d4c836af0ec1e846$var$drainQueue);
};
// v8 likes predictible objects
function $d4c836af0ec1e846$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$d4c836af0ec1e846$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$d4c836af0ec1e846$var$process.title = 'browser';
$d4c836af0ec1e846$var$process.browser = true;
$d4c836af0ec1e846$var$process.env = {};
$d4c836af0ec1e846$var$process.argv = [];
$d4c836af0ec1e846$var$process.version = ''; // empty string to avoid regexp issues
$d4c836af0ec1e846$var$process.versions = {};
function $d4c836af0ec1e846$var$noop() {}
$d4c836af0ec1e846$var$process.on = $d4c836af0ec1e846$var$noop;
$d4c836af0ec1e846$var$process.addListener = $d4c836af0ec1e846$var$noop;
$d4c836af0ec1e846$var$process.once = $d4c836af0ec1e846$var$noop;
$d4c836af0ec1e846$var$process.off = $d4c836af0ec1e846$var$noop;
$d4c836af0ec1e846$var$process.removeListener = $d4c836af0ec1e846$var$noop;
$d4c836af0ec1e846$var$process.removeAllListeners = $d4c836af0ec1e846$var$noop;
$d4c836af0ec1e846$var$process.emit = $d4c836af0ec1e846$var$noop;
$d4c836af0ec1e846$var$process.prependListener = $d4c836af0ec1e846$var$noop;
$d4c836af0ec1e846$var$process.prependOnceListener = $d4c836af0ec1e846$var$noop;
$d4c836af0ec1e846$var$process.listeners = function(name) {
    return [];
};
$d4c836af0ec1e846$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$d4c836af0ec1e846$var$process.cwd = function() {
    return '/';
};
$d4c836af0ec1e846$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$d4c836af0ec1e846$var$process.umask = function() {
    return 0;
};

});


parcelRegister("4SQvv", function(module, exports) {
"use strict";
var $38e4ef6728bf3690$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $38e4ef6728bf3690$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $38e4ef6728bf3690$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigClient = void 0;


var $5nHOn = parcelRequire("5nHOn");
module.exports.StatsigClient = $5nHOn.default;

$38e4ef6728bf3690$var$__exportStar((parcelRequire("bRnho")), module.exports);
const $38e4ef6728bf3690$var$__STATSIG__ = Object.assign((0, (parcelRequire("bRnho"))._getStatsigGlobal)(), {
    StatsigClient: $5nHOn.default
});
module.exports.default = $38e4ef6728bf3690$var$__STATSIG__;

});
parcelRegister("bRnho", function(module, exports) {
"use strict";
var $8a26b3c77ba67d3b$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $8a26b3c77ba67d3b$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $8a26b3c77ba67d3b$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Storage = module.exports.Log = module.exports.EventLogger = module.exports.Diagnostics = void 0;



Object.defineProperty(module.exports, "Diagnostics", {
    enumerable: true,
    get: function() {
        return (parcelRequire("9lGFS")).Diagnostics;
    }
});

var $4I8X8 = parcelRequire("4I8X8");
Object.defineProperty(module.exports, "EventLogger", {
    enumerable: true,
    get: function() {
        return $4I8X8.EventLogger;
    }
});

Object.defineProperty(module.exports, "Log", {
    enumerable: true,
    get: function() {
        return (parcelRequire("42M1N")).Log;
    }
});


Object.defineProperty(module.exports, "Storage", {
    enumerable: true,
    get: function() {
        return (parcelRequire("c7w2G")).Storage;
    }
});

$8a26b3c77ba67d3b$var$__exportStar((parcelRequire("lAepD")), module.exports);

$8a26b3c77ba67d3b$var$__exportStar((parcelRequire("8JdtX")), module.exports);

$8a26b3c77ba67d3b$var$__exportStar((parcelRequire("jBkAn")), module.exports);

$8a26b3c77ba67d3b$var$__exportStar((parcelRequire("9UmxL")), module.exports);

$8a26b3c77ba67d3b$var$__exportStar((parcelRequire("9lGFS")), module.exports);

$8a26b3c77ba67d3b$var$__exportStar((parcelRequire("6PWnW")), module.exports);

$8a26b3c77ba67d3b$var$__exportStar((parcelRequire("lgFld")), module.exports);

$8a26b3c77ba67d3b$var$__exportStar((parcelRequire("g77GD")), module.exports);

$8a26b3c77ba67d3b$var$__exportStar((parcelRequire("9BQZJ")), module.exports);

$8a26b3c77ba67d3b$var$__exportStar((parcelRequire("e7Snh")), module.exports);

$8a26b3c77ba67d3b$var$__exportStar((parcelRequire("emPgf")), module.exports);

$8a26b3c77ba67d3b$var$__exportStar((parcelRequire("42M1N")), module.exports);

$8a26b3c77ba67d3b$var$__exportStar((parcelRequire("bEyUY")), module.exports);

$8a26b3c77ba67d3b$var$__exportStar((parcelRequire("7wBBk")), module.exports);

$8a26b3c77ba67d3b$var$__exportStar((parcelRequire("gTP3r")), module.exports);

$8a26b3c77ba67d3b$var$__exportStar((parcelRequire("gSXsz")), module.exports);

$8a26b3c77ba67d3b$var$__exportStar((parcelRequire("abuSO")), module.exports);

$8a26b3c77ba67d3b$var$__exportStar((parcelRequire("j3d6r")), module.exports);

$8a26b3c77ba67d3b$var$__exportStar((parcelRequire("7otkv")), module.exports);

$8a26b3c77ba67d3b$var$__exportStar((parcelRequire("c0WIS")), module.exports);

$8a26b3c77ba67d3b$var$__exportStar((parcelRequire("hpfea")), module.exports);

$8a26b3c77ba67d3b$var$__exportStar((parcelRequire("d51pD")), module.exports);

$8a26b3c77ba67d3b$var$__exportStar((parcelRequire("d3UEg")), module.exports);

$8a26b3c77ba67d3b$var$__exportStar((parcelRequire("dzswy")), module.exports);

$8a26b3c77ba67d3b$var$__exportStar((parcelRequire("2GgI2")), module.exports);

$8a26b3c77ba67d3b$var$__exportStar((parcelRequire("dxmXR")), module.exports);

$8a26b3c77ba67d3b$var$__exportStar((parcelRequire("a58GC")), module.exports);

$8a26b3c77ba67d3b$var$__exportStar((parcelRequire("kvUc3")), module.exports);

$8a26b3c77ba67d3b$var$__exportStar((parcelRequire("gaSPj")), module.exports);

$8a26b3c77ba67d3b$var$__exportStar((parcelRequire("eoU6t")), module.exports);

$8a26b3c77ba67d3b$var$__exportStar((parcelRequire("iZx3S")), module.exports);

$8a26b3c77ba67d3b$var$__exportStar((parcelRequire("6vkeZ")), module.exports);

$8a26b3c77ba67d3b$var$__exportStar((parcelRequire("c7w2G")), module.exports);

$8a26b3c77ba67d3b$var$__exportStar((parcelRequire("184qv")), module.exports);

$8a26b3c77ba67d3b$var$__exportStar((parcelRequire("9XePg")), module.exports);

$8a26b3c77ba67d3b$var$__exportStar((parcelRequire("1PXuA")), module.exports);

$8a26b3c77ba67d3b$var$__exportStar((parcelRequire("8dVoQ")), module.exports);

$8a26b3c77ba67d3b$var$__exportStar((parcelRequire("k8vQZ")), module.exports);

$8a26b3c77ba67d3b$var$__exportStar((parcelRequire("OcpvB")), module.exports);

$8a26b3c77ba67d3b$var$__exportStar((parcelRequire("cBUKu")), module.exports);
Object.assign((0, (parcelRequire("lAepD"))._getStatsigGlobal)(), {
    Log: (parcelRequire("42M1N")).Log,
    SDK_VERSION: (parcelRequire("a58GC")).SDK_VERSION
});

});
parcelRegister("lAepD", function(module, exports) {
"use strict";
/* eslint-disable @typescript-eslint/no-unsafe-assignment */ var $fb6823ccd8f27a09$var$_a, $fb6823ccd8f27a09$var$_b, $fb6823ccd8f27a09$var$_c;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getInstance = module.exports._getStatsigGlobalFlag = module.exports._getStatsigGlobal = void 0;

var $42M1N = parcelRequire("42M1N");
const $fb6823ccd8f27a09$var$_getStatsigGlobal = ()=>{
    // Avoid ReferenceError, which is happening with Cloudflare pages
    try {
        return typeof __STATSIG__ !== 'undefined' ? __STATSIG__ : $fb6823ccd8f27a09$var$statsigGlobal;
    } catch (e) {
        return $fb6823ccd8f27a09$var$statsigGlobal;
    }
};
module.exports._getStatsigGlobal = $fb6823ccd8f27a09$var$_getStatsigGlobal;
const $fb6823ccd8f27a09$var$_getStatsigGlobalFlag = (flag)=>{
    return (0, module.exports._getStatsigGlobal)()[flag];
};
module.exports._getStatsigGlobalFlag = $fb6823ccd8f27a09$var$_getStatsigGlobalFlag;
const $fb6823ccd8f27a09$var$_getInstance = (sdkKey)=>{
    const gbl = (0, module.exports._getStatsigGlobal)();
    if (!sdkKey) {
        if (gbl.instances && Object.keys(gbl.instances).length > 1) $42M1N.Log.warn('Call made to Statsig global instance without an SDK key but there is more than one client instance. If you are using mulitple clients, please specify the SDK key.');
        return gbl.firstInstance;
    }
    return gbl.instances && gbl.instances[sdkKey];
};
module.exports._getInstance = $fb6823ccd8f27a09$var$_getInstance;
const $fb6823ccd8f27a09$var$GLOBAL_KEY = '__STATSIG__';
const $fb6823ccd8f27a09$var$_window = typeof window !== 'undefined' ? window : {};
const $fb6823ccd8f27a09$var$_global = typeof $parcel$global !== 'undefined' ? $parcel$global : {};
const $fb6823ccd8f27a09$var$_globalThis = typeof globalThis !== 'undefined' ? globalThis : {};
const $fb6823ccd8f27a09$var$statsigGlobal = ($fb6823ccd8f27a09$var$_c = ($fb6823ccd8f27a09$var$_b = ($fb6823ccd8f27a09$var$_a = $fb6823ccd8f27a09$var$_window[$fb6823ccd8f27a09$var$GLOBAL_KEY]) !== null && $fb6823ccd8f27a09$var$_a !== void 0 ? $fb6823ccd8f27a09$var$_a : $fb6823ccd8f27a09$var$_global[$fb6823ccd8f27a09$var$GLOBAL_KEY]) !== null && $fb6823ccd8f27a09$var$_b !== void 0 ? $fb6823ccd8f27a09$var$_b : $fb6823ccd8f27a09$var$_globalThis[$fb6823ccd8f27a09$var$GLOBAL_KEY]) !== null && $fb6823ccd8f27a09$var$_c !== void 0 ? $fb6823ccd8f27a09$var$_c : {
    instance: module.exports._getInstance
};
$fb6823ccd8f27a09$var$_window[$fb6823ccd8f27a09$var$GLOBAL_KEY] = $fb6823ccd8f27a09$var$statsigGlobal;
$fb6823ccd8f27a09$var$_global[$fb6823ccd8f27a09$var$GLOBAL_KEY] = $fb6823ccd8f27a09$var$statsigGlobal;
$fb6823ccd8f27a09$var$_globalThis[$fb6823ccd8f27a09$var$GLOBAL_KEY] = $fb6823ccd8f27a09$var$statsigGlobal;

});
parcelRegister("42M1N", function(module, exports) {
"use strict";
/* eslint-disable no-console */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Log = module.exports.LogLevel = void 0;
// intentionally spaced for formatting
const $2f1c9ab1a9ee9f02$var$DEBUG = ' DEBUG ';
const $2f1c9ab1a9ee9f02$var$_INFO = '  INFO ';
const $2f1c9ab1a9ee9f02$var$_WARN = '  WARN ';
const $2f1c9ab1a9ee9f02$var$ERROR = ' ERROR ';
function $2f1c9ab1a9ee9f02$var$addTag(args) {
    args.unshift('[Statsig]');
    return args; // ['[Statsig]', ...args];
}
module.exports.LogLevel = {
    None: 0,
    Error: 1,
    Warn: 2,
    Info: 3,
    Debug: 4
};
class $2f1c9ab1a9ee9f02$var$Log {
    static info(...args) {
        if ($2f1c9ab1a9ee9f02$var$Log.level >= module.exports.LogLevel.Info) console.info($2f1c9ab1a9ee9f02$var$_INFO, ...$2f1c9ab1a9ee9f02$var$addTag(args));
    }
    static debug(...args) {
        if ($2f1c9ab1a9ee9f02$var$Log.level >= module.exports.LogLevel.Debug) console.debug($2f1c9ab1a9ee9f02$var$DEBUG, ...$2f1c9ab1a9ee9f02$var$addTag(args));
    }
    static warn(...args) {
        if ($2f1c9ab1a9ee9f02$var$Log.level >= module.exports.LogLevel.Warn) console.warn($2f1c9ab1a9ee9f02$var$_WARN, ...$2f1c9ab1a9ee9f02$var$addTag(args));
    }
    static error(...args) {
        if ($2f1c9ab1a9ee9f02$var$Log.level >= module.exports.LogLevel.Error) console.error($2f1c9ab1a9ee9f02$var$ERROR, ...$2f1c9ab1a9ee9f02$var$addTag(args));
    }
}
module.exports.Log = $2f1c9ab1a9ee9f02$var$Log;
$2f1c9ab1a9ee9f02$var$Log.level = module.exports.LogLevel.Warn;

});


parcelRegister("9lGFS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Diagnostics = void 0;
const $6ce72d7d88577e5c$var$MARKER_MAP = new Map();
const $6ce72d7d88577e5c$var$ACT_START = 'start';
const $6ce72d7d88577e5c$var$ACT_END = 'end';
const $6ce72d7d88577e5c$var$DIAGNOSTICS_EVENT = 'statsig::diagnostics';
module.exports.Diagnostics = {
    _getMarkers: (sdkKey)=>{
        return $6ce72d7d88577e5c$var$MARKER_MAP.get(sdkKey);
    },
    _markInitOverallStart: (sdkKey)=>{
        $6ce72d7d88577e5c$var$_addMarker(sdkKey, $6ce72d7d88577e5c$var$_createMarker({}, $6ce72d7d88577e5c$var$ACT_START, 'overall'));
    },
    _markInitOverallEnd: (sdkKey, success, evaluationDetails)=>{
        $6ce72d7d88577e5c$var$_addMarker(sdkKey, $6ce72d7d88577e5c$var$_createMarker({
            success: success,
            error: success ? undefined : {
                name: 'InitializeError',
                message: 'Failed to initialize'
            },
            evaluationDetails: evaluationDetails
        }, $6ce72d7d88577e5c$var$ACT_END, 'overall'));
    },
    _markInitNetworkReqStart: (sdkKey, data)=>{
        $6ce72d7d88577e5c$var$_addMarker(sdkKey, $6ce72d7d88577e5c$var$_createMarker(data, $6ce72d7d88577e5c$var$ACT_START, 'initialize', 'network_request'));
    },
    _markInitNetworkReqEnd: (sdkKey, data)=>{
        $6ce72d7d88577e5c$var$_addMarker(sdkKey, $6ce72d7d88577e5c$var$_createMarker(data, $6ce72d7d88577e5c$var$ACT_END, 'initialize', 'network_request'));
    },
    _markInitProcessStart: (sdkKey)=>{
        $6ce72d7d88577e5c$var$_addMarker(sdkKey, $6ce72d7d88577e5c$var$_createMarker({}, $6ce72d7d88577e5c$var$ACT_START, 'initialize', 'process'));
    },
    _markInitProcessEnd: (sdkKey, data)=>{
        $6ce72d7d88577e5c$var$_addMarker(sdkKey, $6ce72d7d88577e5c$var$_createMarker(data, $6ce72d7d88577e5c$var$ACT_END, 'initialize', 'process'));
    },
    _clearMarkers: (sdkKey)=>{
        $6ce72d7d88577e5c$var$MARKER_MAP.delete(sdkKey);
    },
    _formatError (e) {
        if (!(e && typeof e === 'object')) return;
        return {
            code: $6ce72d7d88577e5c$var$_safeGetField(e, 'code'),
            name: $6ce72d7d88577e5c$var$_safeGetField(e, 'name'),
            message: $6ce72d7d88577e5c$var$_safeGetField(e, 'message')
        };
    },
    _getDiagnosticsData (res, attempt, body, e) {
        var _a;
        return {
            success: (res === null || res === void 0 ? void 0 : res.ok) === true,
            statusCode: res === null || res === void 0 ? void 0 : res.status,
            sdkRegion: (_a = res === null || res === void 0 ? void 0 : res.headers) === null || _a === void 0 ? void 0 : _a.get('x-statsig-region'),
            isDelta: body.includes('"is_delta":true') === true ? true : undefined,
            attempt: attempt,
            error: module.exports.Diagnostics._formatError(e)
        };
    },
    _enqueueDiagnosticsEvent (user, logger, sdk, options) {
        const markers = module.exports.Diagnostics._getMarkers(sdk);
        if (markers == null || markers.length <= 0) return -1;
        const overallInitDuration = markers[markers.length - 1].timestamp - markers[0].timestamp;
        module.exports.Diagnostics._clearMarkers(sdk);
        const event = $6ce72d7d88577e5c$var$_makeDiagnosticsEvent(user, {
            context: 'initialize',
            markers: markers.slice(),
            statsigOptions: options
        });
        logger.enqueue(event);
        return overallInitDuration;
    }
};
function $6ce72d7d88577e5c$var$_createMarker(data, action, key, step) {
    return Object.assign({
        key: key,
        action: action,
        step: step,
        timestamp: Date.now()
    }, data);
}
function $6ce72d7d88577e5c$var$_makeDiagnosticsEvent(user, data) {
    const latencyEvent = {
        eventName: $6ce72d7d88577e5c$var$DIAGNOSTICS_EVENT,
        user: user,
        value: null,
        metadata: data,
        time: Date.now()
    };
    return latencyEvent;
}
function $6ce72d7d88577e5c$var$_addMarker(sdkKey, marker) {
    var _a;
    const markers = (_a = $6ce72d7d88577e5c$var$MARKER_MAP.get(sdkKey)) !== null && _a !== void 0 ? _a : [];
    markers.push(marker);
    $6ce72d7d88577e5c$var$MARKER_MAP.set(sdkKey, markers);
}
function $6ce72d7d88577e5c$var$_safeGetField(data, field) {
    if (field in data) return data[field];
    return undefined;
}

});

parcelRegister("4I8X8", function(module, exports) {
"use strict";
var $36e23753a145acb1$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EventLogger = void 0;

var $8JdtX = parcelRequire("8JdtX");

var $e7Snh = parcelRequire("e7Snh");

var $42M1N = parcelRequire("42M1N");

var $7wBBk = parcelRequire("7wBBk");

var $j3d6r = parcelRequire("j3d6r");

var $dxmXR = parcelRequire("dxmXR");

var $kvUc3 = parcelRequire("kvUc3");

var $c7w2G = parcelRequire("c7w2G");

var $1PXuA = parcelRequire("1PXuA");

var $k8vQZ = parcelRequire("k8vQZ");
const $36e23753a145acb1$var$DEFAULT_QUEUE_SIZE = 100;
const $36e23753a145acb1$var$DEFAULT_FLUSH_INTERVAL_MS = 10000;
const $36e23753a145acb1$var$MAX_DEDUPER_KEYS = 1000;
const $36e23753a145acb1$var$DEDUPER_WINDOW_DURATION_MS = 600000;
const $36e23753a145acb1$var$MAX_FAILED_LOGS = 500;
const $36e23753a145acb1$var$QUICK_FLUSH_WINDOW_MS = 200;
const $36e23753a145acb1$var$EVENT_LOGGER_MAP = {};
const $36e23753a145acb1$var$RetryFailedLogsTrigger = {
    Startup: 'startup',
    GainedFocus: 'gained_focus'
};
class $36e23753a145acb1$var$EventLogger {
    static _safeFlushAndForget(sdkKey) {
        var _a;
        (_a = $36e23753a145acb1$var$EVENT_LOGGER_MAP[sdkKey]) === null || _a === void 0 || _a.flush().catch(()=>{
        // noop
        });
    }
    static _safeRetryFailedLogs(sdkKey) {
        var _a;
        (_a = $36e23753a145acb1$var$EVENT_LOGGER_MAP[sdkKey]) === null || _a === void 0 || _a._retryFailedLogs($36e23753a145acb1$var$RetryFailedLogsTrigger.GainedFocus);
    }
    constructor(_sdkKey, _emitter, _network, _options){
        var _a, _b;
        this._sdkKey = _sdkKey;
        this._emitter = _emitter;
        this._network = _network;
        this._options = _options;
        this._queue = [];
        this._lastExposureTimeMap = {};
        this._nonExposedChecks = {};
        this._hasRunQuickFlush = false;
        this._creationTime = Date.now();
        this._loggingEnabled = (_a = _options === null || _options === void 0 ? void 0 : _options.loggingEnabled) !== null && _a !== void 0 ? _a : (_options === null || _options === void 0 ? void 0 : _options.disableLogging) === true ? $kvUc3.LoggingEnabledOption.disabled : $kvUc3.LoggingEnabledOption.browserOnly;
        if ((_options === null || _options === void 0 ? void 0 : _options.loggingEnabled) && _options.disableLogging !== undefined) $42M1N.Log.warn('Detected both loggingEnabled and disableLogging options. loggingEnabled takes precedence - please remove disableLogging.');
        this._maxQueueSize = (_b = _options === null || _options === void 0 ? void 0 : _options.loggingBufferMaxSize) !== null && _b !== void 0 ? _b : $36e23753a145acb1$var$DEFAULT_QUEUE_SIZE;
        const config = _options === null || _options === void 0 ? void 0 : _options.networkConfig;
        this._logEventUrlConfig = new $1PXuA.UrlConfiguration($7wBBk.Endpoint._rgstr, config === null || config === void 0 ? void 0 : config.logEventUrl, config === null || config === void 0 ? void 0 : config.api, config === null || config === void 0 ? void 0 : config.logEventFallbackUrls);
    }
    setLogEventCompressionMode(mode) {
        this._network.setLogEventCompressionMode(mode);
    }
    setLoggingEnabled(loggingEnabled) {
        this._loggingEnabled = loggingEnabled;
    }
    enqueue(event) {
        if (!this._shouldLogEvent(event)) return;
        this._normalizeAndAppendEvent(event);
        this._quickFlushIfNeeded();
        if (this._queue.length > this._maxQueueSize) $36e23753a145acb1$var$EventLogger._safeFlushAndForget(this._sdkKey);
    }
    incrementNonExposureCount(name) {
        var _a;
        const current = (_a = this._nonExposedChecks[name]) !== null && _a !== void 0 ? _a : 0;
        this._nonExposedChecks[name] = current + 1;
    }
    reset() {
        // attempt to flush any remaining events
        this.flush().catch(()=>{
        // noop
        });
        this._lastExposureTimeMap = {};
    }
    start() {
        var _a;
        const isServerEnv = (0, $j3d6r._isServerEnv)();
        if (isServerEnv && ((_a = this._options) === null || _a === void 0 ? void 0 : _a.loggingEnabled) !== 'always') return;
        $36e23753a145acb1$var$EVENT_LOGGER_MAP[this._sdkKey] = this;
        if (!isServerEnv) (0, $k8vQZ._subscribeToVisiblityChanged)((visibility)=>{
            if (visibility === 'background') $36e23753a145acb1$var$EventLogger._safeFlushAndForget(this._sdkKey);
            else if (visibility === 'foreground') $36e23753a145acb1$var$EventLogger._safeRetryFailedLogs(this._sdkKey);
        });
        this._retryFailedLogs($36e23753a145acb1$var$RetryFailedLogsTrigger.Startup);
        this._startBackgroundFlushInterval();
    }
    stop() {
        return $36e23753a145acb1$var$__awaiter(this, void 0, void 0, function*() {
            if (this._flushIntervalId) {
                clearInterval(this._flushIntervalId);
                this._flushIntervalId = null;
            }
            delete $36e23753a145acb1$var$EVENT_LOGGER_MAP[this._sdkKey];
            yield this.flush();
        });
    }
    flush() {
        return $36e23753a145acb1$var$__awaiter(this, void 0, void 0, function*() {
            this._appendAndResetNonExposedChecks();
            if (this._queue.length === 0) return;
            const events = this._queue;
            this._queue = [];
            yield this._sendEvents(events);
        });
    }
    /**
     * We 'Quick Flush' following the very first event enqueued
     * within the quick flush window
     */ _quickFlushIfNeeded() {
        if (this._hasRunQuickFlush) return;
        this._hasRunQuickFlush = true;
        if (Date.now() - this._creationTime > $36e23753a145acb1$var$QUICK_FLUSH_WINDOW_MS) return;
        setTimeout(()=>$36e23753a145acb1$var$EventLogger._safeFlushAndForget(this._sdkKey), $36e23753a145acb1$var$QUICK_FLUSH_WINDOW_MS);
    }
    _shouldLogEvent(event) {
        var _a;
        if (((_a = this._options) === null || _a === void 0 ? void 0 : _a.loggingEnabled) !== 'always' && (0, $j3d6r._isServerEnv)()) return false;
        if (!(0, $dxmXR._isExposureEvent)(event)) return true;
        const user = event.user ? event.user : {
            statsigEnvironment: undefined
        };
        const userKey = (0, $8JdtX._getUserStorageKey)(this._sdkKey, user);
        const metadata = event.metadata ? event.metadata : {};
        const key = [
            event.eventName,
            userKey,
            metadata['gate'],
            metadata['config'],
            metadata['ruleID'],
            metadata['allocatedExperiment'],
            metadata['parameterName'],
            String(metadata['isExplicitParameter']),
            metadata['reason']
        ].join('|');
        const previous = this._lastExposureTimeMap[key];
        const now = Date.now();
        if (previous && now - previous < $36e23753a145acb1$var$DEDUPER_WINDOW_DURATION_MS) return false;
        if (Object.keys(this._lastExposureTimeMap).length > $36e23753a145acb1$var$MAX_DEDUPER_KEYS) this._lastExposureTimeMap = {};
        this._lastExposureTimeMap[key] = now;
        return true;
    }
    _sendEvents(events) {
        return $36e23753a145acb1$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b;
            if (this._loggingEnabled === 'disabled') {
                this._saveFailedLogsToStorage(events);
                return false;
            }
            try {
                const isClosing = (0, $k8vQZ._isUnloading)();
                const shouldUseBeacon = isClosing && this._network.isBeaconSupported() && ((_b = (_a = this._options) === null || _a === void 0 ? void 0 : _a.networkConfig) === null || _b === void 0 ? void 0 : _b.networkOverrideFunc) == null;
                this._emitter({
                    name: 'pre_logs_flushed',
                    events: events
                });
                const response = shouldUseBeacon ? this._sendEventsViaBeacon(events) : yield this._sendEventsViaPost(events);
                if (response.success) {
                    this._emitter({
                        name: 'logs_flushed',
                        events: events
                    });
                    return true;
                } else {
                    $42M1N.Log.warn('Failed to flush events.');
                    this._saveFailedLogsToStorage(events);
                    return false;
                }
            } catch (_c) {
                $42M1N.Log.warn('Failed to flush events.');
                return false;
            }
        });
    }
    _sendEventsViaPost(events) {
        return $36e23753a145acb1$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const result = yield this._network.post(this._getRequestData(events));
            const code = (_a = result === null || result === void 0 ? void 0 : result.code) !== null && _a !== void 0 ? _a : -1;
            return {
                success: code >= 200 && code < 300
            };
        });
    }
    _sendEventsViaBeacon(events) {
        return {
            success: this._network.beacon(this._getRequestData(events))
        };
    }
    _getRequestData(events) {
        return {
            sdkKey: this._sdkKey,
            data: {
                events: events
            },
            urlConfig: this._logEventUrlConfig,
            retries: 3,
            isCompressable: true,
            params: {
                [$7wBBk.NetworkParam.EventCount]: String(events.length)
            },
            credentials: 'same-origin'
        };
    }
    _saveFailedLogsToStorage(events) {
        while(events.length > $36e23753a145acb1$var$MAX_FAILED_LOGS)events.shift();
        const storageKey = this._getStorageKey();
        try {
            (0, $c7w2G._setObjectInStorage)(storageKey, events);
        } catch (_a) {
            $42M1N.Log.warn('Unable to save failed logs to storage');
        }
    }
    _retryFailedLogs(trigger) {
        const storageKey = this._getStorageKey();
        (()=>$36e23753a145acb1$var$__awaiter(this, void 0, void 0, function*() {
                if (!$c7w2G.Storage.isReady()) yield $c7w2G.Storage.isReadyResolver();
                const events = (0, $c7w2G._getObjectFromStorage)(storageKey);
                if (!events) return;
                if (trigger === $36e23753a145acb1$var$RetryFailedLogsTrigger.Startup) $c7w2G.Storage.removeItem(storageKey);
                const isSuccess = yield this._sendEvents(events);
                if (isSuccess && trigger === $36e23753a145acb1$var$RetryFailedLogsTrigger.GainedFocus) $c7w2G.Storage.removeItem(storageKey);
            }))().catch(()=>{
            $42M1N.Log.warn('Failed to flush stored logs');
        });
    }
    _getStorageKey() {
        return `statsig.failed_logs.${(0, $e7Snh._DJB2)(this._sdkKey)}`;
    }
    _normalizeAndAppendEvent(event) {
        if (event.user) {
            event.user = Object.assign({}, event.user);
            delete event.user.privateAttributes;
        }
        const extras = {};
        const currentPage = this._getCurrentPageUrl();
        if (currentPage) extras.statsigMetadata = {
            currentPage: currentPage
        };
        const final = Object.assign(Object.assign({}, event), extras);
        $42M1N.Log.debug('Enqueued Event:', final);
        this._queue.push(final);
    }
    _appendAndResetNonExposedChecks() {
        if (Object.keys(this._nonExposedChecks).length === 0) return;
        this._normalizeAndAppendEvent({
            eventName: 'statsig::non_exposed_checks',
            user: null,
            time: Date.now(),
            metadata: {
                checks: Object.assign({}, this._nonExposedChecks)
            }
        });
        this._nonExposedChecks = {};
    }
    _getCurrentPageUrl() {
        var _a;
        if (((_a = this._options) === null || _a === void 0 ? void 0 : _a.includeCurrentPageUrlWithEvents) === false) return;
        return (0, $j3d6r._getCurrentPageUrlSafe)();
    }
    _startBackgroundFlushInterval() {
        var _a, _b;
        const flushInterval = (_b = (_a = this._options) === null || _a === void 0 ? void 0 : _a.loggingIntervalMs) !== null && _b !== void 0 ? _b : $36e23753a145acb1$var$DEFAULT_FLUSH_INTERVAL_MS;
        const intervalId = setInterval(()=>{
            const logger = $36e23753a145acb1$var$EVENT_LOGGER_MAP[this._sdkKey];
            if (!logger || logger._flushIntervalId !== intervalId) clearInterval(intervalId);
            else $36e23753a145acb1$var$EventLogger._safeFlushAndForget(this._sdkKey);
        }, flushInterval);
        this._flushIntervalId = intervalId;
    }
}
module.exports.EventLogger = $36e23753a145acb1$var$EventLogger;

});
parcelRegister("8JdtX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getStorageKey = module.exports._getUserStorageKey = void 0;

var $e7Snh = parcelRequire("e7Snh");
function $65acfbff4bb308f4$var$_getUserStorageKey(sdkKey, user, customKeyGenerator) {
    var _a;
    if (customKeyGenerator) return customKeyGenerator(sdkKey, user);
    const cids = user && user.customIDs ? user.customIDs : {};
    const parts = [
        `uid:${(_a = user === null || user === void 0 ? void 0 : user.userID) !== null && _a !== void 0 ? _a : ''}`,
        `cids:${Object.keys(cids).sort((leftKey, rightKey)=>leftKey.localeCompare(rightKey)).map((key)=>`${key}-${cids[key]}`).join(',')}`,
        `k:${sdkKey}`
    ];
    return (0, $e7Snh._DJB2)(parts.join('|'));
}
module.exports._getUserStorageKey = $65acfbff4bb308f4$var$_getUserStorageKey;
function $65acfbff4bb308f4$var$_getStorageKey(sdkKey, user, customKeyGenerator) {
    if (user) return $65acfbff4bb308f4$var$_getUserStorageKey(sdkKey, user, customKeyGenerator);
    return (0, $e7Snh._DJB2)(`k:${sdkKey}`);
}
module.exports._getStorageKey = $65acfbff4bb308f4$var$_getStorageKey;

});
parcelRegister("e7Snh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getSortedObject = module.exports._DJB2Object = module.exports._DJB2 = void 0;

var $9XePg = parcelRequire("9XePg");
const $a48be5c666253fb9$var$_DJB2 = (value)=>{
    let hash = 0;
    for(let i = 0; i < value.length; i++){
        const character = value.charCodeAt(i);
        hash = (hash << 5) - hash + character;
        hash = hash & hash; // Convert to 32bit integer
    }
    return String(hash >>> 0);
};
module.exports._DJB2 = $a48be5c666253fb9$var$_DJB2;
const $a48be5c666253fb9$var$_DJB2Object = (value, maxLevels)=>{
    return (0, module.exports._DJB2)(JSON.stringify((0, module.exports._getSortedObject)(value, maxLevels)));
};
module.exports._DJB2Object = $a48be5c666253fb9$var$_DJB2Object;
const $a48be5c666253fb9$var$_getSortedObject = (object, maxDepth)=>{
    if (object == null) return null;
    const keys = Object.keys(object).sort();
    const sortedObject = {};
    keys.forEach((key)=>{
        const value = object[key];
        if (maxDepth === 0 || (0, $9XePg._typeOf)(value) !== 'object') {
            sortedObject[key] = value;
            return;
        }
        sortedObject[key] = (0, module.exports._getSortedObject)(value, maxDepth != null ? maxDepth - 1 : maxDepth);
    });
    return sortedObject;
};
module.exports._getSortedObject = $a48be5c666253fb9$var$_getSortedObject;

});
parcelRegister("9XePg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._isTypeMatch = module.exports._typeOf = void 0;
function $73f51fdc62fe368d$var$_typeOf(input) {
    return Array.isArray(input) ? 'array' : typeof input;
}
module.exports._typeOf = $73f51fdc62fe368d$var$_typeOf;
function $73f51fdc62fe368d$var$_isTypeMatch(a, b) {
    const typeOf = (x)=>Array.isArray(x) ? 'array' : x === null ? 'null' : typeof x;
    return typeOf(a) === typeOf(b);
}
module.exports._isTypeMatch = $73f51fdc62fe368d$var$_isTypeMatch;

});



parcelRegister("7wBBk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NetworkParam = module.exports.NetworkDefault = module.exports.Endpoint = void 0;
module.exports.Endpoint = {
    _initialize: 'initialize',
    _rgstr: 'rgstr',
    _download_config_specs: 'download_config_specs'
};
module.exports.NetworkDefault = {
    [module.exports.Endpoint._rgstr]: 'https://prodregistryv2.org/v1',
    [module.exports.Endpoint._initialize]: 'https://featureassets.org/v1',
    [module.exports.Endpoint._download_config_specs]: 'https://api.statsigcdn.com/v1'
};
module.exports.NetworkParam = {
    EventCount: 'ec',
    SdkKey: 'k',
    SdkType: 'st',
    SdkVersion: 'sv',
    Time: 't',
    SessionID: 'sid',
    StatsigEncoded: 'se',
    IsGzipped: 'gz'
};

});

parcelRegister("j3d6r", function(module, exports) {

var $igDjg = parcelRequire("igDjg");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getUnloadEvent = module.exports._getCurrentPageUrlSafe = module.exports._addDocumentEventListenerSafe = module.exports._addWindowEventListenerSafe = module.exports._isServerEnv = module.exports._getDocumentSafe = module.exports._getWindowSafe = void 0;
const $dde8761d790efff5$var$_getWindowSafe = ()=>{
    return typeof window !== 'undefined' ? window : null;
};
module.exports._getWindowSafe = $dde8761d790efff5$var$_getWindowSafe;
const $dde8761d790efff5$var$_getDocumentSafe = ()=>{
    var _a;
    const win = (0, module.exports._getWindowSafe)();
    return (_a = win === null || win === void 0 ? void 0 : win.document) !== null && _a !== void 0 ? _a : null;
};
module.exports._getDocumentSafe = $dde8761d790efff5$var$_getDocumentSafe;
const $dde8761d790efff5$var$_isServerEnv = ()=>{
    if ((0, module.exports._getDocumentSafe)() !== null) return false;
    const isNode = typeof $igDjg !== 'undefined' && $igDjg.versions != null && $igDjg.versions.node != null;
    const isVercel = typeof EdgeRuntime === 'string';
    return isVercel || isNode;
};
module.exports._isServerEnv = $dde8761d790efff5$var$_isServerEnv;
const $dde8761d790efff5$var$_addWindowEventListenerSafe = (key, listener)=>{
    const win = (0, module.exports._getWindowSafe)();
    if (typeof (win === null || win === void 0 ? void 0 : win.addEventListener) === 'function') win.addEventListener(key, listener);
};
module.exports._addWindowEventListenerSafe = $dde8761d790efff5$var$_addWindowEventListenerSafe;
const $dde8761d790efff5$var$_addDocumentEventListenerSafe = (key, listener)=>{
    const doc = (0, module.exports._getDocumentSafe)();
    if (typeof (doc === null || doc === void 0 ? void 0 : doc.addEventListener) === 'function') doc.addEventListener(key, listener);
};
module.exports._addDocumentEventListenerSafe = $dde8761d790efff5$var$_addDocumentEventListenerSafe;
const $dde8761d790efff5$var$_getCurrentPageUrlSafe = ()=>{
    var _a;
    try {
        return (_a = (0, module.exports._getWindowSafe)()) === null || _a === void 0 ? void 0 : _a.location.href.split(/[?#]/)[0];
    } catch (_b) {
        return;
    }
};
module.exports._getCurrentPageUrlSafe = $dde8761d790efff5$var$_getCurrentPageUrlSafe;
const $dde8761d790efff5$var$_getUnloadEvent = ()=>{
    const win = (0, module.exports._getWindowSafe)();
    if (!win) return 'beforeunload';
    const eventType = 'onpagehide' in win ? 'pagehide' : 'beforeunload';
    return eventType;
};
module.exports._getUnloadEvent = $dde8761d790efff5$var$_getUnloadEvent;

});

parcelRegister("dxmXR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._createLayerParameterExposure = module.exports._createConfigExposure = module.exports._mapExposures = module.exports._createGateExposure = module.exports._isExposureEvent = void 0;
const $9db02bb5e45f1c63$var$CONFIG_EXPOSURE_NAME = 'statsig::config_exposure';
const $9db02bb5e45f1c63$var$GATE_EXPOSURE_NAME = 'statsig::gate_exposure';
const $9db02bb5e45f1c63$var$LAYER_EXPOSURE_NAME = 'statsig::layer_exposure';
const $9db02bb5e45f1c63$var$_createExposure = (eventName, user, details, metadata, secondaryExposures)=>{
    if (details.bootstrapMetadata) metadata['bootstrapMetadata'] = details.bootstrapMetadata;
    return {
        eventName: eventName,
        user: user,
        value: null,
        metadata: $9db02bb5e45f1c63$var$_addEvaluationDetailsToMetadata(details, metadata),
        secondaryExposures: secondaryExposures,
        time: Date.now()
    };
};
const $9db02bb5e45f1c63$var$_isExposureEvent = ({ eventName: eventName })=>{
    return eventName === $9db02bb5e45f1c63$var$GATE_EXPOSURE_NAME || eventName === $9db02bb5e45f1c63$var$CONFIG_EXPOSURE_NAME || eventName === $9db02bb5e45f1c63$var$LAYER_EXPOSURE_NAME;
};
module.exports._isExposureEvent = $9db02bb5e45f1c63$var$_isExposureEvent;
const $9db02bb5e45f1c63$var$_createGateExposure = (user, gate, exposureMapping)=>{
    var _a, _b, _c;
    const metadata = {
        gate: gate.name,
        gateValue: String(gate.value),
        ruleID: gate.ruleID
    };
    if (((_a = gate.__evaluation) === null || _a === void 0 ? void 0 : _a.version) != null) metadata['configVersion'] = gate.__evaluation.version;
    return $9db02bb5e45f1c63$var$_createExposure($9db02bb5e45f1c63$var$GATE_EXPOSURE_NAME, user, gate.details, metadata, $9db02bb5e45f1c63$var$_mapExposures((_c = (_b = gate.__evaluation) === null || _b === void 0 ? void 0 : _b.secondary_exposures) !== null && _c !== void 0 ? _c : [], exposureMapping));
};
module.exports._createGateExposure = $9db02bb5e45f1c63$var$_createGateExposure;
function $9db02bb5e45f1c63$var$_mapExposures(exposures, exposureMapping) {
    return exposures.map((exposure)=>{
        if (typeof exposure === 'string') return (exposureMapping !== null && exposureMapping !== void 0 ? exposureMapping : {})[exposure];
        return exposure;
    }).filter((exposure)=>exposure != null);
}
module.exports._mapExposures = $9db02bb5e45f1c63$var$_mapExposures;
const $9db02bb5e45f1c63$var$_createConfigExposure = (user, config, exposureMapping)=>{
    var _a, _b, _c, _d;
    const metadata = {
        config: config.name,
        ruleID: config.ruleID
    };
    if (((_a = config.__evaluation) === null || _a === void 0 ? void 0 : _a.version) != null) metadata['configVersion'] = config.__evaluation.version;
    if (((_b = config.__evaluation) === null || _b === void 0 ? void 0 : _b.passed) != null) metadata['rulePassed'] = String(config.__evaluation.passed);
    return $9db02bb5e45f1c63$var$_createExposure($9db02bb5e45f1c63$var$CONFIG_EXPOSURE_NAME, user, config.details, metadata, $9db02bb5e45f1c63$var$_mapExposures((_d = (_c = config.__evaluation) === null || _c === void 0 ? void 0 : _c.secondary_exposures) !== null && _d !== void 0 ? _d : [], exposureMapping));
};
module.exports._createConfigExposure = $9db02bb5e45f1c63$var$_createConfigExposure;
const $9db02bb5e45f1c63$var$_createLayerParameterExposure = (user, layer, parameterName, exposureMapping)=>{
    var _a, _b, _c, _d, _e, _f, _g;
    const evaluation = layer.__evaluation;
    const isExplicit = ((_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.explicit_parameters) === null || _a === void 0 ? void 0 : _a.includes(parameterName)) === true;
    let allocatedExperiment = '';
    let secondaryExposures = (_b = evaluation === null || evaluation === void 0 ? void 0 : evaluation.undelegated_secondary_exposures) !== null && _b !== void 0 ? _b : [];
    if (isExplicit) {
        allocatedExperiment = (_c = evaluation.allocated_experiment_name) !== null && _c !== void 0 ? _c : '';
        secondaryExposures = (_d = evaluation.secondary_exposures) !== null && _d !== void 0 ? _d : [];
    }
    const parameterRuleIDs = (_e = layer.__evaluation) === null || _e === void 0 ? void 0 : _e.parameter_rule_ids;
    const metadata = {
        config: layer.name,
        parameterName: parameterName,
        ruleID: (_f = parameterRuleIDs === null || parameterRuleIDs === void 0 ? void 0 : parameterRuleIDs[parameterName]) !== null && _f !== void 0 ? _f : layer.ruleID,
        allocatedExperiment: allocatedExperiment,
        isExplicitParameter: String(isExplicit)
    };
    if (((_g = layer.__evaluation) === null || _g === void 0 ? void 0 : _g.version) != null) metadata['configVersion'] = layer.__evaluation.version;
    return $9db02bb5e45f1c63$var$_createExposure($9db02bb5e45f1c63$var$LAYER_EXPOSURE_NAME, user, layer.details, metadata, $9db02bb5e45f1c63$var$_mapExposures(secondaryExposures, exposureMapping));
};
module.exports._createLayerParameterExposure = $9db02bb5e45f1c63$var$_createLayerParameterExposure;
const $9db02bb5e45f1c63$var$_addEvaluationDetailsToMetadata = (details, metadata)=>{
    metadata['reason'] = details.reason;
    if (details.lcut) metadata['lcut'] = String(details.lcut);
    if (details.receivedAt) metadata['receivedAt'] = String(details.receivedAt);
    return metadata;
};

});

parcelRegister("kvUc3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LoggingEnabledOption = module.exports.LogEventCompressionMode = void 0;
module.exports.LogEventCompressionMode = {
    /** Do not compress request bodies */ Disabled: 'd',
    /** Compress request bodies unless a network proxy is configured */ Enabled: 'e',
    /** Always compress request bodies, even when a proxy is configured */ Forced: 'f'
};
module.exports.LoggingEnabledOption = {
    disabled: 'disabled',
    browserOnly: 'browser-only',
    always: 'always'
};

});

parcelRegister("c7w2G", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._setObjectInStorage = module.exports._getObjectFromStorage = module.exports.Storage = void 0;

var $42M1N = parcelRequire("42M1N");

var $j3d6r = parcelRequire("j3d6r");
const $8d2efe68ba55b6af$var$inMemoryStore = {};
const $8d2efe68ba55b6af$var$_inMemoryProvider = {
    isReady: ()=>true,
    isReadyResolver: ()=>null,
    getProviderName: ()=>'InMemory',
    getItem: (key)=>$8d2efe68ba55b6af$var$inMemoryStore[key] ? $8d2efe68ba55b6af$var$inMemoryStore[key] : null,
    setItem: (key, value)=>{
        $8d2efe68ba55b6af$var$inMemoryStore[key] = value;
    },
    removeItem: (key)=>{
        delete $8d2efe68ba55b6af$var$inMemoryStore[key];
    },
    getAllKeys: ()=>Object.keys($8d2efe68ba55b6af$var$inMemoryStore)
};
let $8d2efe68ba55b6af$var$_localStorageProvider = null;
try {
    const win = (0, $j3d6r._getWindowSafe)();
    if (win && win.localStorage && typeof win.localStorage.getItem === 'function') $8d2efe68ba55b6af$var$_localStorageProvider = {
        isReady: ()=>true,
        isReadyResolver: ()=>null,
        getProviderName: ()=>'LocalStorage',
        getItem: (key)=>win.localStorage.getItem(key),
        setItem: (key, value)=>win.localStorage.setItem(key, value),
        removeItem: (key)=>win.localStorage.removeItem(key),
        getAllKeys: ()=>Object.keys(win.localStorage)
    };
} catch (error) {
    $42M1N.Log.warn('Failed to setup localStorageProvider.');
}
let $8d2efe68ba55b6af$var$_main = $8d2efe68ba55b6af$var$_localStorageProvider !== null && $8d2efe68ba55b6af$var$_localStorageProvider !== void 0 ? $8d2efe68ba55b6af$var$_localStorageProvider : $8d2efe68ba55b6af$var$_inMemoryProvider;
let $8d2efe68ba55b6af$var$_current = $8d2efe68ba55b6af$var$_main;
function $8d2efe68ba55b6af$var$_inMemoryBreaker(action) {
    try {
        return action();
    } catch (error) {
        if (error instanceof Error && error.name === 'SecurityError') {
            module.exports.Storage._setProvider($8d2efe68ba55b6af$var$_inMemoryProvider);
            return null;
        }
        if (error instanceof Error && error.name === 'QuotaExceededError') {
            const allKeys = module.exports.Storage.getAllKeys();
            const statsigKeys = allKeys.filter((key)=>key.startsWith('statsig.'));
            error.message = `${error.message}. Statsig Keys: ${statsigKeys.length}`;
        }
        throw error;
    }
}
module.exports.Storage = {
    isReady: ()=>$8d2efe68ba55b6af$var$_current.isReady(),
    isReadyResolver: ()=>$8d2efe68ba55b6af$var$_current.isReadyResolver(),
    getProviderName: ()=>$8d2efe68ba55b6af$var$_current.getProviderName(),
    getItem: (key)=>$8d2efe68ba55b6af$var$_inMemoryBreaker(()=>$8d2efe68ba55b6af$var$_current.getItem(key)),
    setItem: (key, value)=>$8d2efe68ba55b6af$var$_inMemoryBreaker(()=>$8d2efe68ba55b6af$var$_current.setItem(key, value)),
    removeItem: (key)=>$8d2efe68ba55b6af$var$_current.removeItem(key),
    getAllKeys: ()=>$8d2efe68ba55b6af$var$_current.getAllKeys(),
    // StorageProviderManagment
    _setProvider: (newProvider)=>{
        $8d2efe68ba55b6af$var$_main = newProvider;
        $8d2efe68ba55b6af$var$_current = newProvider;
    },
    _setDisabled: (isDisabled)=>{
        if (isDisabled) $8d2efe68ba55b6af$var$_current = $8d2efe68ba55b6af$var$_inMemoryProvider;
        else $8d2efe68ba55b6af$var$_current = $8d2efe68ba55b6af$var$_main;
    }
};
function $8d2efe68ba55b6af$var$_getObjectFromStorage(key) {
    const value = module.exports.Storage.getItem(key);
    return JSON.parse(value !== null && value !== void 0 ? value : 'null');
}
module.exports._getObjectFromStorage = $8d2efe68ba55b6af$var$_getObjectFromStorage;
function $8d2efe68ba55b6af$var$_setObjectInStorage(key, obj) {
    module.exports.Storage.setItem(key, JSON.stringify(obj));
}
module.exports._setObjectInStorage = $8d2efe68ba55b6af$var$_setObjectInStorage;

});

parcelRegister("1PXuA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UrlConfiguration = void 0;

var $e7Snh = parcelRequire("e7Snh");

var $7wBBk = parcelRequire("7wBBk");
const $1568b3cdda545b18$var$ENDPOINT_DNS_KEY_MAP = {
    [$7wBBk.Endpoint._initialize]: 'i',
    [$7wBBk.Endpoint._rgstr]: 'e',
    [$7wBBk.Endpoint._download_config_specs]: 'd'
};
class $1568b3cdda545b18$var$UrlConfiguration {
    constructor(endpoint, customUrl, customApi, fallbackUrls){
        this.customUrl = null;
        this.fallbackUrls = null;
        this.endpoint = endpoint;
        this.endpointDnsKey = $1568b3cdda545b18$var$ENDPOINT_DNS_KEY_MAP[endpoint];
        if (customUrl) this.customUrl = customUrl;
        if (!customUrl && customApi) this.customUrl = customApi.endsWith('/') ? `${customApi}${endpoint}` : `${customApi}/${endpoint}`;
        if (fallbackUrls) this.fallbackUrls = fallbackUrls;
        const defaultApi = $7wBBk.NetworkDefault[endpoint];
        this.defaultUrl = `${defaultApi}/${endpoint}`;
    }
    getUrl() {
        var _a;
        return (_a = this.customUrl) !== null && _a !== void 0 ? _a : this.defaultUrl;
    }
    getChecksum() {
        var _a;
        const fallbacks = ((_a = this.fallbackUrls) !== null && _a !== void 0 ? _a : []).sort().join(',');
        return (0, $e7Snh._DJB2)(this.customUrl + fallbacks);
    }
}
module.exports.UrlConfiguration = $1568b3cdda545b18$var$UrlConfiguration;

});

parcelRegister("k8vQZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._notifyVisibilityChanged = module.exports._subscribeToVisiblityChanged = module.exports._isUnloading = module.exports._isCurrentlyVisible = void 0;

var $j3d6r = parcelRequire("j3d6r");
const $ea8d437b8183621f$var$FOREGROUND = 'foreground';
const $ea8d437b8183621f$var$BACKGROUND = 'background';
const $ea8d437b8183621f$var$LISTENERS = [];
let $ea8d437b8183621f$var$current = $ea8d437b8183621f$var$FOREGROUND;
let $ea8d437b8183621f$var$isUnloading = false;
const $ea8d437b8183621f$var$_isCurrentlyVisible = ()=>{
    return $ea8d437b8183621f$var$current === $ea8d437b8183621f$var$FOREGROUND;
};
module.exports._isCurrentlyVisible = $ea8d437b8183621f$var$_isCurrentlyVisible;
const $ea8d437b8183621f$var$_isUnloading = ()=>$ea8d437b8183621f$var$isUnloading;
module.exports._isUnloading = $ea8d437b8183621f$var$_isUnloading;
const $ea8d437b8183621f$var$_subscribeToVisiblityChanged = (listener)=>{
    $ea8d437b8183621f$var$LISTENERS.unshift(listener);
};
module.exports._subscribeToVisiblityChanged = $ea8d437b8183621f$var$_subscribeToVisiblityChanged;
const $ea8d437b8183621f$var$_notifyVisibilityChanged = (visibility)=>{
    if (visibility === $ea8d437b8183621f$var$current) return;
    $ea8d437b8183621f$var$current = visibility;
    $ea8d437b8183621f$var$LISTENERS.forEach((l)=>l(visibility));
};
module.exports._notifyVisibilityChanged = $ea8d437b8183621f$var$_notifyVisibilityChanged;
(0, $j3d6r._addWindowEventListenerSafe)('focus', ()=>{
    $ea8d437b8183621f$var$isUnloading = false;
    (0, module.exports._notifyVisibilityChanged)($ea8d437b8183621f$var$FOREGROUND);
});
(0, $j3d6r._addWindowEventListenerSafe)('blur', ()=>(0, module.exports._notifyVisibilityChanged)($ea8d437b8183621f$var$BACKGROUND));
(0, $j3d6r._addDocumentEventListenerSafe)('visibilitychange', ()=>{
    (0, module.exports._notifyVisibilityChanged)(document.visibilityState === 'visible' ? $ea8d437b8183621f$var$FOREGROUND : $ea8d437b8183621f$var$BACKGROUND);
});
(0, $j3d6r._addWindowEventListenerSafe)((0, $j3d6r._getUnloadEvent)(), ()=>{
    $ea8d437b8183621f$var$isUnloading = true;
    (0, module.exports._notifyVisibilityChanged)($ea8d437b8183621f$var$BACKGROUND);
});

});


parcelRegister("a58GC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigMetadataProvider = module.exports.SDK_VERSION = void 0;
module.exports.SDK_VERSION = '3.21.1';
let $75711bf1b4378831$var$metadata = {
    sdkVersion: module.exports.SDK_VERSION,
    sdkType: 'js-mono'
};
module.exports.StatsigMetadataProvider = {
    get: ()=>$75711bf1b4378831$var$metadata,
    add: (additions)=>{
        $75711bf1b4378831$var$metadata = Object.assign(Object.assign({}, $75711bf1b4378831$var$metadata), additions);
    }
};

});

parcelRegister("jBkAn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("9UmxL", function(module, exports) {
"use strict";
var $736ad4b3ea278d40$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._makeDataAdapterResult = module.exports.DataAdapterCore = void 0;

var $42M1N = parcelRequire("42M1N");

var $d51pD = parcelRequire("d51pD");

var $6vkeZ = parcelRequire("6vkeZ");

var $c7w2G = parcelRequire("c7w2G");

var $184qv = parcelRequire("184qv");
const $736ad4b3ea278d40$var$CACHE_LIMIT = 10;
class $736ad4b3ea278d40$var$DataAdapterCore {
    constructor(_adapterName, _cacheSuffix){
        this._adapterName = _adapterName;
        this._cacheSuffix = _cacheSuffix;
        this._options = null;
        this._sdkKey = null;
        this._lastModifiedStoreKey = `statsig.last_modified_time.${_cacheSuffix}`;
        this._inMemoryCache = new $736ad4b3ea278d40$var$InMemoryCache();
    }
    attach(sdkKey, options, _network) {
        this._sdkKey = sdkKey;
        this._options = options;
    }
    getDataSync(user) {
        const normalized = user && (0, $6vkeZ._normalizeUser)(user, this._options);
        const cacheKey = this._getCacheKey(normalized);
        const inMem = this._inMemoryCache.get(cacheKey, normalized);
        if (inMem && this._getIsCacheValueValid(inMem)) return inMem;
        const cache = this._loadFromCache(cacheKey);
        if (cache && this._getIsCacheValueValid(cache)) {
            this._inMemoryCache.add(cacheKey, cache);
            return this._inMemoryCache.get(cacheKey, normalized);
        }
        return null;
    }
    setData(data, user) {
        const normalized = user && (0, $6vkeZ._normalizeUser)(user, this._options);
        const cacheKey = this._getCacheKey(normalized);
        this._inMemoryCache.add(cacheKey, $736ad4b3ea278d40$var$_makeDataAdapterResult('Bootstrap', data, null, normalized));
    }
    _getIsCacheValueValid(current) {
        return current.stableID == null || current.stableID === $d51pD.StableID.get(this._getSdkKey());
    }
    _getDataAsyncImpl(current, user, options) {
        return $736ad4b3ea278d40$var$__awaiter(this, void 0, void 0, function*() {
            if (!$c7w2G.Storage.isReady()) yield $c7w2G.Storage.isReadyResolver();
            const cache = current !== null && current !== void 0 ? current : this.getDataSync(user);
            const ops = [
                this._fetchAndPrepFromNetwork(cache, user, options)
            ];
            if (options === null || options === void 0 ? void 0 : options.timeoutMs) ops.push(new Promise((r)=>setTimeout(r, options.timeoutMs)).then(()=>{
                $42M1N.Log.debug('Fetching latest value timed out');
                return null;
            }));
            return yield Promise.race(ops);
        });
    }
    _prefetchDataImpl(user, options) {
        return $736ad4b3ea278d40$var$__awaiter(this, void 0, void 0, function*() {
            const normalized = user && (0, $6vkeZ._normalizeUser)(user, this._options);
            const cacheKey = this._getCacheKey(normalized);
            const result = yield this._getDataAsyncImpl(null, normalized, options);
            if (result) this._inMemoryCache.add(cacheKey, Object.assign(Object.assign({}, result), {
                source: 'Prefetch'
            }));
        });
    }
    _fetchAndPrepFromNetwork(cachedResult, user, options) {
        return $736ad4b3ea278d40$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const cachedData = (_a = cachedResult === null || cachedResult === void 0 ? void 0 : cachedResult.data) !== null && _a !== void 0 ? _a : null;
            const isCacheValidFor204 = cachedResult != null && this._isCachedResultValidFor204(cachedResult, user);
            const latest = yield this._fetchFromNetwork(cachedData, user, options, isCacheValidFor204);
            if (!latest) {
                $42M1N.Log.debug('No response returned for latest value');
                return null;
            }
            const response = (0, $184qv._typedJsonParse)(latest, 'has_updates', 'Response');
            const sdkKey = this._getSdkKey();
            const stableID = $d51pD.StableID.get(sdkKey);
            let result = null;
            if ((response === null || response === void 0 ? void 0 : response.has_updates) === true) result = $736ad4b3ea278d40$var$_makeDataAdapterResult('Network', latest, stableID, user);
            else if (cachedData && (response === null || response === void 0 ? void 0 : response.has_updates) === false) result = $736ad4b3ea278d40$var$_makeDataAdapterResult('NetworkNotModified', cachedData, stableID, user);
            else return null;
            const cacheKey = this._getCacheKey(user);
            this._inMemoryCache.add(cacheKey, result);
            this._writeToCache(cacheKey, result);
            return result;
        });
    }
    _getSdkKey() {
        if (this._sdkKey != null) return this._sdkKey;
        $42M1N.Log.error(`${this._adapterName} is not attached to a Client`);
        return '';
    }
    _loadFromCache(cacheKey) {
        var _a;
        const cache = (_a = $c7w2G.Storage.getItem) === null || _a === void 0 ? void 0 : _a.call($c7w2G.Storage, cacheKey);
        if (cache == null) return null;
        const result = (0, $184qv._typedJsonParse)(cache, 'source', 'Cached Result');
        return result ? Object.assign(Object.assign({}, result), {
            source: 'Cache'
        }) : null;
    }
    _writeToCache(cacheKey, result) {
        $c7w2G.Storage.setItem(cacheKey, JSON.stringify(result));
        this._runLocalStorageCacheEviction(cacheKey);
    }
    _runLocalStorageCacheEviction(cacheKey) {
        var _a;
        const lastModifiedTimeMap = (_a = (0, $c7w2G._getObjectFromStorage)(this._lastModifiedStoreKey)) !== null && _a !== void 0 ? _a : {};
        lastModifiedTimeMap[cacheKey] = Date.now();
        const evictable = $736ad4b3ea278d40$var$_getEvictableKey(lastModifiedTimeMap, $736ad4b3ea278d40$var$CACHE_LIMIT);
        if (evictable) {
            delete lastModifiedTimeMap[evictable];
            $c7w2G.Storage.removeItem(evictable);
        }
        (0, $c7w2G._setObjectInStorage)(this._lastModifiedStoreKey, lastModifiedTimeMap);
    }
}
module.exports.DataAdapterCore = $736ad4b3ea278d40$var$DataAdapterCore;
function $736ad4b3ea278d40$var$_makeDataAdapterResult(source, data, stableID, user) {
    return {
        source: source,
        data: data,
        receivedAt: Date.now(),
        stableID: stableID,
        fullUserHash: (0, $6vkeZ._getFullUserHash)(user)
    };
}
module.exports._makeDataAdapterResult = $736ad4b3ea278d40$var$_makeDataAdapterResult;
class $736ad4b3ea278d40$var$InMemoryCache {
    constructor(){
        this._data = {};
    }
    get(cacheKey, user) {
        var _a;
        const result = this._data[cacheKey];
        const cached = result === null || result === void 0 ? void 0 : result.stableID;
        const provided = (_a = user === null || user === void 0 ? void 0 : user.customIDs) === null || _a === void 0 ? void 0 : _a.stableID;
        if (provided && cached && provided !== cached) {
            $42M1N.Log.warn("'StatsigUser.customIDs.stableID' mismatch");
            return null;
        }
        return result;
    }
    add(cacheKey, value) {
        const oldest = $736ad4b3ea278d40$var$_getEvictableKey(this._data, $736ad4b3ea278d40$var$CACHE_LIMIT - 1);
        if (oldest) delete this._data[oldest];
        this._data[cacheKey] = value;
    }
    merge(values) {
        this._data = Object.assign(Object.assign({}, this._data), values);
    }
}
function $736ad4b3ea278d40$var$_getEvictableKey(data, limit) {
    const keys = Object.keys(data);
    if (keys.length <= limit) return null;
    return keys.reduce((prevKey, currKey)=>{
        const prev = data[prevKey];
        const current = data[currKey];
        if (typeof prev === 'object' && typeof current === 'object') return current.receivedAt < prev.receivedAt ? currKey : prevKey;
        return current < prev ? currKey : prevKey;
    });
}

});
parcelRegister("d51pD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StableID = void 0;

var $8JdtX = parcelRequire("8JdtX");

var $42M1N = parcelRequire("42M1N");

var $j3d6r = parcelRequire("j3d6r");

var $c7w2G = parcelRequire("c7w2G");

var $8dVoQ = parcelRequire("8dVoQ");
const $985cd677bfa5ef94$var$PROMISE_MAP = {};
const $985cd677bfa5ef94$var$COOKIE_ENABLED_MAP = {};
const $985cd677bfa5ef94$var$DISABLED_MAP = {};
module.exports.StableID = {
    cookiesEnabled: false,
    randomID: Math.random().toString(36),
    get: (sdkKey)=>{
        if ($985cd677bfa5ef94$var$DISABLED_MAP[sdkKey]) return null;
        if ($985cd677bfa5ef94$var$PROMISE_MAP[sdkKey] != null) return $985cd677bfa5ef94$var$PROMISE_MAP[sdkKey];
        let stableID = null;
        stableID = $985cd677bfa5ef94$var$_loadFromCookie(sdkKey);
        if (stableID != null) {
            $985cd677bfa5ef94$var$PROMISE_MAP[sdkKey] = stableID;
            $985cd677bfa5ef94$var$_persistToStorage(stableID, sdkKey);
            return stableID;
        }
        stableID = $985cd677bfa5ef94$var$_loadFromStorage(sdkKey);
        if (stableID == null) stableID = (0, $8dVoQ.getUUID)();
        $985cd677bfa5ef94$var$_persistToStorage(stableID, sdkKey);
        $985cd677bfa5ef94$var$_persistToCookie(stableID, sdkKey);
        $985cd677bfa5ef94$var$PROMISE_MAP[sdkKey] = stableID;
        return stableID;
    },
    setOverride: (override, sdkKey)=>{
        $985cd677bfa5ef94$var$PROMISE_MAP[sdkKey] = override;
        $985cd677bfa5ef94$var$_persistToStorage(override, sdkKey);
        $985cd677bfa5ef94$var$_persistToCookie(override, sdkKey);
    },
    _setCookiesEnabled: (sdkKey, cookiesEnabled)=>{
        $985cd677bfa5ef94$var$COOKIE_ENABLED_MAP[sdkKey] = cookiesEnabled;
    },
    _setDisabled: (sdkKey, disabled)=>{
        $985cd677bfa5ef94$var$DISABLED_MAP[sdkKey] = disabled;
    }
};
function $985cd677bfa5ef94$var$_getStableIDStorageKey(sdkKey) {
    return `statsig.stable_id.${(0, $8JdtX._getStorageKey)(sdkKey)}`;
}
function $985cd677bfa5ef94$var$_persistToStorage(stableID, sdkKey) {
    const storageKey = $985cd677bfa5ef94$var$_getStableIDStorageKey(sdkKey);
    try {
        (0, $c7w2G._setObjectInStorage)(storageKey, stableID);
    } catch (e) {
        $42M1N.Log.warn('Failed to save StableID to storage');
    }
}
function $985cd677bfa5ef94$var$_loadFromStorage(sdkKey) {
    const storageKey = $985cd677bfa5ef94$var$_getStableIDStorageKey(sdkKey);
    return (0, $c7w2G._getObjectFromStorage)(storageKey);
}
function $985cd677bfa5ef94$var$_loadFromCookie(sdkKey) {
    if (!$985cd677bfa5ef94$var$COOKIE_ENABLED_MAP[sdkKey] || (0, $j3d6r._getDocumentSafe)() == null) return null;
    const cookies = document.cookie.split(';');
    for (const cookie of cookies){
        const [key, value] = cookie.trim().split('=');
        if (key === $985cd677bfa5ef94$var$_getCookieName(sdkKey)) return decodeURIComponent(value);
    }
    return null;
}
function $985cd677bfa5ef94$var$_persistToCookie(stableID, sdkKey) {
    if (!$985cd677bfa5ef94$var$COOKIE_ENABLED_MAP[sdkKey] || !document) return;
    const expiryDate = new Date();
    expiryDate.setFullYear(expiryDate.getFullYear() + 1);
    document.cookie = `${$985cd677bfa5ef94$var$_getCookieName(sdkKey)}=${encodeURIComponent(stableID)}; expires=${expiryDate.toUTCString()}; path=/`;
}
function $985cd677bfa5ef94$var$_getCookieName(sdkKey) {
    return `statsig.stable_id.${(0, $8JdtX._getStorageKey)(sdkKey)}`;
}

});
parcelRegister("8dVoQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getUUID = void 0;
function $5fcc1002104df3b3$var$getUUID() {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') return crypto.randomUUID();
    let d = new Date().getTime();
    let d2 = typeof performance !== 'undefined' && performance.now && performance.now() * 1000 || 0;
    const y = '89ab'[Math.floor(Math.random() * 4)];
    return `xxxxxxxx-xxxx-4xxx-${y}xxx-xxxxxxxxxxxx`.replace(/[xy]/g, (c)=>{
        let r = Math.random() * 16;
        if (d > 0) {
            r = (d + r) % 16 | 0;
            d = Math.floor(d / 16);
        } else {
            r = (d2 + r) % 16 | 0;
            d2 = Math.floor(d2 / 16);
        }
        return (c === 'x' ? r : r & 0x7 | 0x8).toString(16);
    });
}
module.exports.getUUID = $5fcc1002104df3b3$var$getUUID;

});


parcelRegister("6vkeZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getFullUserHash = module.exports._normalizeUser = void 0;

var $e7Snh = parcelRequire("e7Snh");

var $42M1N = parcelRequire("42M1N");
function $4bc556b336d04694$var$_normalizeUser(original, options, fallbackEnvironment) {
    try {
        const copy = JSON.parse(JSON.stringify(original));
        if (options != null && options.environment != null) copy.statsigEnvironment = options.environment;
        else if (fallbackEnvironment != null) copy.statsigEnvironment = {
            tier: fallbackEnvironment
        };
        return copy;
    } catch (error) {
        $42M1N.Log.error('Failed to JSON.stringify user');
        return {
            statsigEnvironment: undefined
        };
    }
}
module.exports._normalizeUser = $4bc556b336d04694$var$_normalizeUser;
function $4bc556b336d04694$var$_getFullUserHash(user) {
    return user ? (0, $e7Snh._DJB2Object)(user) : null;
}
module.exports._getFullUserHash = $4bc556b336d04694$var$_getFullUserHash;

});

parcelRegister("184qv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._typedJsonParse = void 0;

var $42M1N = parcelRequire("42M1N");
/**
 *
 * @param {string} data The values to parse into T
 * @param {string} guard A field that must exists on the parsed object for the parse to be valid
 * @param {string} error An error to print via Log.error() when parsing fails
 * @returns {T | null} The parse object T or null if it failed
 */ function $0d29f8d60f149945$var$_typedJsonParse(data, guard, typeName) {
    try {
        const result = JSON.parse(data);
        if (result && typeof result === 'object' && guard in result) return result;
    } catch (_a) {
    // noop
    }
    $42M1N.Log.error(`Failed to parse ${typeName}`);
    return null;
}
module.exports._typedJsonParse = $0d29f8d60f149945$var$_typedJsonParse;

});


parcelRegister("6PWnW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("lgFld", function(module, exports) {
"use strict";
var $f7bb2913cb111bd7$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ErrorBoundary = module.exports.EXCEPTION_ENDPOINT = void 0;

var $42M1N = parcelRequire("42M1N");

var $7otkv = parcelRequire("7otkv");

var $a58GC = parcelRequire("a58GC");
module.exports.EXCEPTION_ENDPOINT = 'https://statsigapi.net/v1/sdk_exception';
const $f7bb2913cb111bd7$var$UNKNOWN_ERROR = '[Statsig] UnknownError';
class $f7bb2913cb111bd7$var$ErrorBoundary {
    constructor(_sdkKey, _options, _emitter, _lastSeenError){
        this._sdkKey = _sdkKey;
        this._options = _options;
        this._emitter = _emitter;
        this._lastSeenError = _lastSeenError;
        this._seen = new Set();
    }
    wrap(instance) {
        try {
            const obj = instance;
            $f7bb2913cb111bd7$var$_getAllInstanceMethodNames(obj).forEach((name)=>{
                const original = obj[name];
                if ('$EB' in original) return;
                obj[name] = (...args)=>{
                    return this._capture(name, ()=>original.apply(instance, args));
                };
                obj[name].$EB = true;
            });
        } catch (err) {
            this._onError('eb:wrap', err);
        }
    }
    logError(tag, error) {
        this._onError(tag, error);
    }
    getLastSeenErrorAndReset() {
        const tempError = this._lastSeenError;
        this._lastSeenError = undefined;
        return tempError !== null && tempError !== void 0 ? tempError : null;
    }
    attachErrorIfNoneExists(error) {
        if (this._lastSeenError) return;
        this._lastSeenError = $f7bb2913cb111bd7$var$_resolveError(error);
    }
    _capture(tag, task) {
        try {
            const res = task();
            if (res && res instanceof Promise) return res.catch((err)=>this._onError(tag, err));
            return res;
        } catch (error) {
            this._onError(tag, error);
            return null;
        }
    }
    _onError(tag, error) {
        try {
            $42M1N.Log.warn(`Caught error in ${tag}`, {
                error: error
            });
            const impl = ()=>$f7bb2913cb111bd7$var$__awaiter(this, void 0, void 0, function*() {
                    var _a, _b, _c, _d, _e, _f, _g;
                    const unwrapped = error ? error : Error($f7bb2913cb111bd7$var$UNKNOWN_ERROR);
                    const isError = unwrapped instanceof Error;
                    const name = isError ? unwrapped.name : 'No Name';
                    const resolvedError = $f7bb2913cb111bd7$var$_resolveError(unwrapped);
                    this._lastSeenError = resolvedError;
                    if (this._seen.has(name)) return;
                    this._seen.add(name);
                    if ((_b = (_a = this._options) === null || _a === void 0 ? void 0 : _a.networkConfig) === null || _b === void 0 ? void 0 : _b.preventAllNetworkTraffic) {
                        (_c = this._emitter) === null || _c === void 0 || _c.call(this, {
                            name: 'error',
                            error: error,
                            tag: tag
                        });
                        return;
                    }
                    const sdkType = $7otkv.SDKType._get(this._sdkKey);
                    const statsigMetadata = $a58GC.StatsigMetadataProvider.get();
                    const info = isError ? unwrapped.stack : $f7bb2913cb111bd7$var$_getDescription(unwrapped);
                    const body = Object.assign({
                        tag: tag,
                        exception: name,
                        info: info,
                        statsigOptions: $f7bb2913cb111bd7$var$_getStatsigOptionLoggingCopy(this._options)
                    }, Object.assign(Object.assign({}, statsigMetadata), {
                        sdkType: sdkType
                    }));
                    const func = (_f = (_e = (_d = this._options) === null || _d === void 0 ? void 0 : _d.networkConfig) === null || _e === void 0 ? void 0 : _e.networkOverrideFunc) !== null && _f !== void 0 ? _f : fetch;
                    yield func(module.exports.EXCEPTION_ENDPOINT, {
                        method: 'POST',
                        headers: {
                            'STATSIG-API-KEY': this._sdkKey,
                            'STATSIG-SDK-TYPE': String(sdkType),
                            'STATSIG-SDK-VERSION': String(statsigMetadata.sdkVersion),
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify(body)
                    });
                    (_g = this._emitter) === null || _g === void 0 || _g.call(this, {
                        name: 'error',
                        error: error,
                        tag: tag
                    });
                });
            impl().then(()=>{
            /* noop */ }).catch(()=>{
            /* noop */ });
        } catch (_error) {
        /* noop */ }
    }
}
module.exports.ErrorBoundary = $f7bb2913cb111bd7$var$ErrorBoundary;
function $f7bb2913cb111bd7$var$_resolveError(error) {
    if (error instanceof Error) return error;
    else if (typeof error === 'string') return new Error(error);
    else return new Error('An unknown error occurred.');
}
function $f7bb2913cb111bd7$var$_getDescription(obj) {
    try {
        return JSON.stringify(obj);
    } catch (_a) {
        return $f7bb2913cb111bd7$var$UNKNOWN_ERROR;
    }
}
function $f7bb2913cb111bd7$var$_getAllInstanceMethodNames(instance) {
    const names = new Set();
    let proto = Object.getPrototypeOf(instance);
    while(proto && proto !== Object.prototype){
        Object.getOwnPropertyNames(proto).filter((prop)=>typeof (proto === null || proto === void 0 ? void 0 : proto[prop]) === 'function').forEach((name)=>names.add(name));
        proto = Object.getPrototypeOf(proto);
    }
    return Array.from(names);
}
function $f7bb2913cb111bd7$var$_getStatsigOptionLoggingCopy(options) {
    if (!options) return {};
    const loggingCopy = {};
    Object.entries(options).forEach(([option, value])=>{
        const valueType = typeof value;
        switch(valueType){
            case 'number':
            case 'bigint':
            case 'boolean':
                loggingCopy[String(option)] = value;
                break;
            case 'string':
                if (value.length < 50) loggingCopy[String(option)] = value;
                else loggingCopy[String(option)] = 'set';
                break;
            case 'object':
                if (option === 'environment') loggingCopy['environment'] = value;
                else if (option === 'networkConfig') loggingCopy['networkConfig'] = value;
                else loggingCopy[String(option)] = value != null ? 'set' : 'unset';
                break;
            default:
        }
    });
    return loggingCopy;
}

});
parcelRegister("7otkv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SDKType = void 0;
const $562186930fbba15e$var$SDK_CLIENT = {};
let $562186930fbba15e$var$suffix;
module.exports.SDKType = {
    _get: (sdkKey)=>{
        var _a;
        return ((_a = $562186930fbba15e$var$SDK_CLIENT[sdkKey]) !== null && _a !== void 0 ? _a : 'js-mono') + ($562186930fbba15e$var$suffix !== null && $562186930fbba15e$var$suffix !== void 0 ? $562186930fbba15e$var$suffix : '');
    },
    _setClientType (sdkKey, client) {
        $562186930fbba15e$var$SDK_CLIENT[sdkKey] = client;
    },
    _setBindingType (binding) {
        if (!$562186930fbba15e$var$suffix || $562186930fbba15e$var$suffix === '-react') $562186930fbba15e$var$suffix = '-' + binding;
    }
};

});


parcelRegister("g77GD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("9BQZJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("emPgf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("bEyUY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createMemoKey = module.exports.MemoPrefix = void 0;
module.exports.MemoPrefix = {
    _gate: 'g',
    _dynamicConfig: 'c',
    _experiment: 'e',
    _configList: 'cl',
    _layer: 'l',
    _paramStore: 'p'
};
const $87be84189060547e$var$EXIST_KEYS = new Set([]);
const $87be84189060547e$var$DO_NOT_MEMO_KEYS = new Set([
    // Add keys that if exist, should not be memoized
    'userPersistedValues'
]);
function $87be84189060547e$var$createMemoKey(prefix, name, options) {
    let cacheKey = `${prefix}|${name}`;
    if (!options) return cacheKey;
    for (const key of Object.keys(options)){
        if ($87be84189060547e$var$DO_NOT_MEMO_KEYS.has(key)) return undefined;
        if ($87be84189060547e$var$EXIST_KEYS.has(key)) cacheKey += `|${key}=true`;
        else cacheKey += `|${key}=${options[key]}`;
    }
    return cacheKey;
}
module.exports.createMemoKey = $87be84189060547e$var$createMemoKey;

});

parcelRegister("gTP3r", function(module, exports) {
"use strict";
var $c4d962bfd4d48d71$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NetworkCore = void 0;

var $lAepD = parcelRequire("lAepD");

var $lAepD = parcelRequire("lAepD");

var $9lGFS = parcelRequire("9lGFS");

var $42M1N = parcelRequire("42M1N");

var $7wBBk = parcelRequire("7wBBk");

var $25BoS = parcelRequire("25BoS");

var $cBUKu = parcelRequire("cBUKu");

var $7otkv = parcelRequire("7otkv");

var $j3d6r = parcelRequire("j3d6r");

var $c0WIS = parcelRequire("c0WIS");

var $d51pD = parcelRequire("d51pD");

var $dzswy = parcelRequire("dzswy");

var $a58GC = parcelRequire("a58GC");

var $kvUc3 = parcelRequire("kvUc3");

var $k8vQZ = parcelRequire("k8vQZ");
const $c4d962bfd4d48d71$var$DEFAULT_TIMEOUT_MS = 10000;
const $c4d962bfd4d48d71$var$BACKOFF_BASE_MS = 500;
const $c4d962bfd4d48d71$var$BACKOFF_MAX_MS = 30000;
const $c4d962bfd4d48d71$var$RATE_LIMIT_WINDOW_MS = 1000;
const $c4d962bfd4d48d71$var$RATE_LIMIT_MAX_REQ_COUNT = 50;
const $c4d962bfd4d48d71$var$LEAK_RATE = $c4d962bfd4d48d71$var$RATE_LIMIT_MAX_REQ_COUNT / $c4d962bfd4d48d71$var$RATE_LIMIT_WINDOW_MS;
const $c4d962bfd4d48d71$var$RETRYABLE_CODES = new Set([
    408,
    500,
    502,
    503,
    504,
    522,
    524,
    599
]);
class $c4d962bfd4d48d71$var$NetworkCore {
    constructor(options, _emitter){
        this._emitter = _emitter;
        this._errorBoundary = null;
        this._timeout = $c4d962bfd4d48d71$var$DEFAULT_TIMEOUT_MS;
        this._netConfig = {};
        this._options = {};
        this._leakyBucket = {};
        this._lastUsedInitUrl = null;
        if (options) this._options = options;
        if (this._options.networkConfig) this._netConfig = this._options.networkConfig;
        if (this._netConfig.networkTimeoutMs) this._timeout = this._netConfig.networkTimeoutMs;
        this._fallbackResolver = new $25BoS.NetworkFallbackResolver(this._options);
        this.setLogEventCompressionMode(this._getLogEventCompressionMode(options));
    }
    setLogEventCompressionMode(mode) {
        this._options.logEventCompressionMode = mode;
    }
    setErrorBoundary(errorBoundary) {
        this._errorBoundary = errorBoundary;
        this._errorBoundary.wrap(this);
        this._errorBoundary.wrap(this._fallbackResolver);
        this._fallbackResolver.setErrorBoundary(errorBoundary);
    }
    isBeaconSupported() {
        return typeof navigator !== 'undefined' && typeof navigator.sendBeacon === 'function';
    }
    getLastUsedInitUrlAndReset() {
        const tempUrl = this._lastUsedInitUrl;
        this._lastUsedInitUrl = null;
        return tempUrl;
    }
    beacon(args) {
        if (!$c4d962bfd4d48d71$var$_ensureValidSdkKey(args)) return false;
        const argsInternal = this._getInternalRequestArgs('POST', args);
        const url = this._getPopulatedURL(argsInternal);
        const nav = navigator;
        return nav.sendBeacon.bind(nav)(url, argsInternal.body);
    }
    post(args) {
        return $c4d962bfd4d48d71$var$__awaiter(this, void 0, void 0, function*() {
            const argsInternal = this._getInternalRequestArgs('POST', args);
            this._tryEncodeBody(argsInternal);
            yield this._tryToCompressBody(argsInternal);
            return this._sendRequest(argsInternal);
        });
    }
    get(args) {
        const argsInternal = this._getInternalRequestArgs('GET', args);
        return this._sendRequest(argsInternal);
    }
    _sendRequest(args) {
        return $c4d962bfd4d48d71$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b, _c, _d;
            if (!$c4d962bfd4d48d71$var$_ensureValidSdkKey(args)) return null;
            if (this._netConfig.preventAllNetworkTraffic) return null;
            const { method: method, body: body, retries: retries, attempt: attempt } = args;
            const endpoint = args.urlConfig.endpoint;
            if (this._isRateLimited(endpoint)) {
                $42M1N.Log.warn(`Request to ${endpoint} was blocked because you are making requests too frequently.`);
                return null;
            }
            const currentAttempt = attempt !== null && attempt !== void 0 ? attempt : 1;
            const abortController = typeof AbortController !== 'undefined' ? new AbortController() : null;
            const timeoutHandle = setTimeout(()=>{
                abortController === null || abortController === void 0 || abortController.abort(`Timeout of ${this._timeout}ms expired.`);
            }, this._timeout);
            const populatedUrl = this._getPopulatedURL(args);
            let response = null;
            const keepalive = (0, $k8vQZ._isUnloading)();
            try {
                const config = {
                    method: method,
                    body: body,
                    headers: Object.assign({}, args.headers),
                    signal: abortController === null || abortController === void 0 ? void 0 : abortController.signal,
                    priority: args.priority,
                    keepalive: keepalive
                };
                $c4d962bfd4d48d71$var$_tryMarkInitStart(args, currentAttempt);
                const bucket = this._leakyBucket[endpoint];
                if (bucket) {
                    bucket.lastRequestTime = Date.now();
                    this._leakyBucket[endpoint] = bucket;
                }
                const func = (_a = this._netConfig.networkOverrideFunc) !== null && _a !== void 0 ? _a : fetch;
                response = yield func(populatedUrl, config);
                clearTimeout(timeoutHandle);
                if (!response.ok) {
                    const text = yield response.text().catch(()=>'No Text');
                    const err = new Error(`NetworkError: ${populatedUrl} ${text}`);
                    err.name = 'NetworkError';
                    throw err;
                }
                const text = yield response.text();
                $c4d962bfd4d48d71$var$_tryMarkInitEnd(args, response, currentAttempt, text);
                this._fallbackResolver.tryBumpExpiryTime(args.sdkKey, args.urlConfig);
                return {
                    body: text,
                    code: response.status
                };
            } catch (error) {
                const errorMessage = $c4d962bfd4d48d71$var$_getErrorMessage(abortController, error);
                const timedOut = $c4d962bfd4d48d71$var$_didTimeout(abortController);
                $c4d962bfd4d48d71$var$_tryMarkInitEnd(args, response, currentAttempt, '', error);
                const fallbackUpdated = yield this._fallbackResolver.tryFetchUpdatedFallbackInfo(args.sdkKey, args.urlConfig, errorMessage, timedOut);
                if (fallbackUpdated) args.fallbackUrl = this._fallbackResolver.getActiveFallbackUrl(args.sdkKey, args.urlConfig);
                if (!retries || currentAttempt > retries || !$c4d962bfd4d48d71$var$RETRYABLE_CODES.has((_b = response === null || response === void 0 ? void 0 : response.status) !== null && _b !== void 0 ? _b : 500)) {
                    (_c = this._emitter) === null || _c === void 0 || _c.call(this, {
                        name: 'error',
                        error: error,
                        tag: $dzswy.ErrorTag.NetworkError,
                        requestArgs: args
                    });
                    const formattedErrorMsg = `A networking error occurred during ${method} request to ${populatedUrl}.`;
                    $42M1N.Log.error(formattedErrorMsg, errorMessage, error);
                    (_d = this._errorBoundary) === null || _d === void 0 || _d.attachErrorIfNoneExists(formattedErrorMsg);
                    return null;
                }
                yield $c4d962bfd4d48d71$var$_exponentialBackoff(currentAttempt);
                return this._sendRequest(Object.assign(Object.assign({}, args), {
                    retries: retries,
                    attempt: currentAttempt + 1
                }));
            }
        });
    }
    _getLogEventCompressionMode(options) {
        // Handle backward compatibility for deprecated disableCompression flag
        let compressionMode = options === null || options === void 0 ? void 0 : options.logEventCompressionMode;
        if (!compressionMode && (options === null || options === void 0 ? void 0 : options.disableCompression) === true) compressionMode = $kvUc3.LogEventCompressionMode.Disabled;
        // Default to enabled if unset
        if (!compressionMode) compressionMode = $kvUc3.LogEventCompressionMode.Enabled;
        return compressionMode;
    }
    _isRateLimited(endpoint) {
        var _a;
        const now = Date.now();
        const bucket = (_a = this._leakyBucket[endpoint]) !== null && _a !== void 0 ? _a : {
            count: 0,
            lastRequestTime: now
        };
        const elapsed = now - bucket.lastRequestTime;
        const leakedRequests = Math.floor(elapsed * $c4d962bfd4d48d71$var$LEAK_RATE);
        bucket.count = Math.max(0, bucket.count - leakedRequests);
        if (bucket.count >= $c4d962bfd4d48d71$var$RATE_LIMIT_MAX_REQ_COUNT) return true;
        bucket.count += 1;
        bucket.lastRequestTime = now;
        this._leakyBucket[endpoint] = bucket;
        return false;
    }
    _getPopulatedURL(args) {
        var _a;
        const url = (_a = args.fallbackUrl) !== null && _a !== void 0 ? _a : args.urlConfig.getUrl();
        if (args.urlConfig.endpoint === $7wBBk.Endpoint._initialize || args.urlConfig.endpoint === $7wBBk.Endpoint._download_config_specs) this._lastUsedInitUrl = url;
        const params = Object.assign({
            [$7wBBk.NetworkParam.SdkKey]: args.sdkKey,
            [$7wBBk.NetworkParam.SdkType]: $7otkv.SDKType._get(args.sdkKey),
            [$7wBBk.NetworkParam.SdkVersion]: $a58GC.SDK_VERSION,
            [$7wBBk.NetworkParam.Time]: String(Date.now()),
            [$7wBBk.NetworkParam.SessionID]: $c0WIS.SessionID.get(args.sdkKey)
        }, args.params);
        const query = Object.keys(params).map((key)=>{
            return `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`;
        }).join('&');
        return `${url}${query ? `?${query}` : ''}`;
    }
    _tryEncodeBody(args) {
        var _a;
        const win = (0, $j3d6r._getWindowSafe)();
        const body = args.body;
        if (!args.isStatsigEncodable || this._options.disableStatsigEncoding || typeof body !== 'string' || (0, $lAepD._getStatsigGlobalFlag)('no-encode') != null || !(win === null || win === void 0 ? void 0 : win.btoa)) return;
        try {
            args.body = win.btoa(body).split('').reverse().join('');
            args.params = Object.assign(Object.assign({}, (_a = args.params) !== null && _a !== void 0 ? _a : {}), {
                [$7wBBk.NetworkParam.StatsigEncoded]: '1'
            });
        } catch (e) {
            $42M1N.Log.warn(`Request encoding failed for ${args.urlConfig.getUrl()}`, e);
        }
    }
    _tryToCompressBody(args) {
        return $c4d962bfd4d48d71$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const body = args.body;
            if (typeof body !== 'string' || !$c4d962bfd4d48d71$var$_allowCompression(args, this._options)) return;
            try {
                const bytes = new TextEncoder().encode(body);
                const stream = new CompressionStream('gzip');
                const writer = stream.writable.getWriter();
                writer.write(bytes).catch($42M1N.Log.error);
                writer.close().catch($42M1N.Log.error);
                const reader = stream.readable.getReader();
                const chunks = [];
                let result;
                // eslint-disable-next-line no-await-in-loop
                while(!(result = yield reader.read()).done)chunks.push(result.value);
                const totalLength = chunks.reduce((acc, chunk)=>acc + chunk.length, 0);
                const combined = new Uint8Array(totalLength);
                let offset = 0;
                for (const chunk of chunks){
                    combined.set(chunk, offset);
                    offset += chunk.length;
                }
                args.body = combined;
                args.params = Object.assign(Object.assign({}, (_a = args.params) !== null && _a !== void 0 ? _a : {}), {
                    [$7wBBk.NetworkParam.IsGzipped]: '1'
                });
            } catch (e) {
                $42M1N.Log.warn(`Request compression failed for ${args.urlConfig.getUrl()}`, e);
            }
        });
    }
    _getInternalRequestArgs(method, args) {
        const fallbackUrl = this._fallbackResolver.getActiveFallbackUrl(args.sdkKey, args.urlConfig);
        const result = Object.assign(Object.assign({}, args), {
            method: method,
            fallbackUrl: fallbackUrl
        });
        if ('data' in args) $c4d962bfd4d48d71$var$_populateRequestBody(result, args.data);
        return result;
    }
}
module.exports.NetworkCore = $c4d962bfd4d48d71$var$NetworkCore;
const $c4d962bfd4d48d71$var$_ensureValidSdkKey = (args)=>{
    if (!args.sdkKey) {
        $42M1N.Log.warn('Unable to make request without an SDK key');
        return false;
    }
    return true;
};
const $c4d962bfd4d48d71$var$_populateRequestBody = (args, data)=>{
    const { sdkKey: sdkKey, fallbackUrl: fallbackUrl } = args;
    const stableID = $d51pD.StableID.get(sdkKey);
    const sessionID = $c0WIS.SessionID.get(sdkKey);
    const sdkType = $7otkv.SDKType._get(sdkKey);
    args.body = JSON.stringify(Object.assign(Object.assign({}, data), {
        statsigMetadata: Object.assign(Object.assign({}, $a58GC.StatsigMetadataProvider.get()), {
            stableID: stableID,
            sessionID: sessionID,
            sdkType: sdkType,
            fallbackUrl: fallbackUrl
        })
    }));
};
function $c4d962bfd4d48d71$var$_allowCompression(args, options) {
    if (!args.isCompressable) return false;
    // Never compress if 'no-compress' is set globally or required APIs are unavailable
    if ((0, $lAepD._getStatsigGlobalFlag)('no-compress') != null || typeof CompressionStream === 'undefined' || typeof TextEncoder === 'undefined') return false;
    const isProxy = args.urlConfig.customUrl != null || args.urlConfig.fallbackUrls != null;
    const flagEnabled = $cBUKu.SDKFlags.get(args.sdkKey, 'enable_log_event_compression') === true;
    switch(options.logEventCompressionMode){
        case $kvUc3.LogEventCompressionMode.Disabled:
            return false;
        case $kvUc3.LogEventCompressionMode.Enabled:
            // Only compress through proxy if flag is explicitly on
            if (isProxy && !flagEnabled) return false;
            return true;
        case $kvUc3.LogEventCompressionMode.Forced:
            return true;
        default:
            return false;
    }
}
function $c4d962bfd4d48d71$var$_getErrorMessage(controller, error) {
    if ((controller === null || controller === void 0 ? void 0 : controller.signal.aborted) && typeof controller.signal.reason === 'string') return controller.signal.reason;
    if (typeof error === 'string') return error;
    if (error instanceof Error) return `${error.name}: ${error.message}`;
    return 'Unknown Error';
}
function $c4d962bfd4d48d71$var$_didTimeout(controller) {
    const timeout = (controller === null || controller === void 0 ? void 0 : controller.signal.aborted) && typeof controller.signal.reason === 'string' && controller.signal.reason.includes('Timeout');
    return timeout || false;
}
function $c4d962bfd4d48d71$var$_tryMarkInitStart(args, attempt) {
    if (args.urlConfig.endpoint !== $7wBBk.Endpoint._initialize) return;
    $9lGFS.Diagnostics._markInitNetworkReqStart(args.sdkKey, {
        attempt: attempt
    });
}
function $c4d962bfd4d48d71$var$_tryMarkInitEnd(args, response, attempt, body, err) {
    if (args.urlConfig.endpoint !== $7wBBk.Endpoint._initialize) return;
    $9lGFS.Diagnostics._markInitNetworkReqEnd(args.sdkKey, $9lGFS.Diagnostics._getDiagnosticsData(response, attempt, body, err));
}
function $c4d962bfd4d48d71$var$_exponentialBackoff(attempt) {
    return $c4d962bfd4d48d71$var$__awaiter(this, void 0, void 0, function*() {
        // 1*1*1000 1s
        // 2*2*1000 4s
        // 3*3*1000 9s
        // 4*4*1000 16s
        // 5*5*1000 25s
        yield new Promise((r)=>setTimeout(r, Math.min($c4d962bfd4d48d71$var$BACKOFF_BASE_MS * (attempt * attempt), $c4d962bfd4d48d71$var$BACKOFF_MAX_MS)));
    });
}

});
parcelRegister("25BoS", function(module, exports) {
"use strict";
var $18590f52bdef7d7b$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._isDomainFailure = module.exports.NetworkFallbackResolver = void 0;

var $beBXx = parcelRequire("beBXx");

var $e7Snh = parcelRequire("e7Snh");

var $42M1N = parcelRequire("42M1N");

var $c7w2G = parcelRequire("c7w2G");
const $18590f52bdef7d7b$var$DEFAULT_TTL_MS = 604800000; // 7 days
const $18590f52bdef7d7b$var$COOLDOWN_TIME_MS = 14400000; // 4 hours
class $18590f52bdef7d7b$var$NetworkFallbackResolver {
    constructor(options){
        var _a;
        this._fallbackInfo = null;
        this._errorBoundary = null;
        this._dnsQueryCooldowns = {};
        this._networkOverrideFunc = (_a = options.networkConfig) === null || _a === void 0 ? void 0 : _a.networkOverrideFunc;
    }
    setErrorBoundary(errorBoundary) {
        this._errorBoundary = errorBoundary;
    }
    tryBumpExpiryTime(sdkKey, urlConfig) {
        var _a;
        const info = (_a = this._fallbackInfo) === null || _a === void 0 ? void 0 : _a[urlConfig.endpoint];
        if (!info) return;
        info.expiryTime = Date.now() + $18590f52bdef7d7b$var$DEFAULT_TTL_MS;
        $18590f52bdef7d7b$var$_tryWriteFallbackInfoToCache(sdkKey, Object.assign(Object.assign({}, this._fallbackInfo), {
            [urlConfig.endpoint]: info
        }));
    }
    getActiveFallbackUrl(sdkKey, urlConfig) {
        var _a, _b;
        if (urlConfig.customUrl != null && urlConfig.fallbackUrls != null) return null;
        let info = this._fallbackInfo;
        if (info == null) {
            info = (_a = $18590f52bdef7d7b$var$_readFallbackInfoFromCache(sdkKey)) !== null && _a !== void 0 ? _a : {};
            this._fallbackInfo = info;
        }
        const entry = info[urlConfig.endpoint];
        if (!entry || Date.now() > ((_b = entry.expiryTime) !== null && _b !== void 0 ? _b : 0) || urlConfig.getChecksum() !== entry.urlConfigChecksum) {
            delete info[urlConfig.endpoint];
            this._fallbackInfo = info;
            $18590f52bdef7d7b$var$_tryWriteFallbackInfoToCache(sdkKey, this._fallbackInfo);
            return null;
        }
        if (entry.url) return entry.url;
        return null;
    }
    tryFetchUpdatedFallbackInfo(sdkKey, urlConfig, errorMessage, timedOut) {
        return $18590f52bdef7d7b$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b;
            try {
                if (!$18590f52bdef7d7b$var$_isDomainFailure(errorMessage, timedOut)) return false;
                const canUseNetworkFallbacks = urlConfig.customUrl == null && urlConfig.fallbackUrls == null;
                const urls = canUseNetworkFallbacks ? yield this._tryFetchFallbackUrlsFromNetwork(urlConfig) : urlConfig.fallbackUrls;
                const newUrl = this._pickNewFallbackUrl((_a = this._fallbackInfo) === null || _a === void 0 ? void 0 : _a[urlConfig.endpoint], urls);
                if (!newUrl) return false;
                this._updateFallbackInfoWithNewUrl(sdkKey, urlConfig, newUrl);
                return true;
            } catch (error) {
                (_b = this._errorBoundary) === null || _b === void 0 || _b.logError('tryFetchUpdatedFallbackInfo', error);
                return false;
            }
        });
    }
    _updateFallbackInfoWithNewUrl(sdkKey, urlConfig, newUrl) {
        var _a, _b, _c;
        const newFallbackInfo = {
            urlConfigChecksum: urlConfig.getChecksum(),
            url: newUrl,
            expiryTime: Date.now() + $18590f52bdef7d7b$var$DEFAULT_TTL_MS,
            previous: []
        };
        const endpoint = urlConfig.endpoint;
        const previousInfo = (_a = this._fallbackInfo) === null || _a === void 0 ? void 0 : _a[endpoint];
        if (previousInfo) newFallbackInfo.previous.push(...previousInfo.previous);
        if (newFallbackInfo.previous.length > 10) newFallbackInfo.previous = [];
        const previousUrl = (_c = (_b = this._fallbackInfo) === null || _b === void 0 ? void 0 : _b[endpoint]) === null || _c === void 0 ? void 0 : _c.url;
        if (previousUrl != null) newFallbackInfo.previous.push(previousUrl);
        this._fallbackInfo = Object.assign(Object.assign({}, this._fallbackInfo), {
            [endpoint]: newFallbackInfo
        });
        $18590f52bdef7d7b$var$_tryWriteFallbackInfoToCache(sdkKey, this._fallbackInfo);
    }
    _tryFetchFallbackUrlsFromNetwork(urlConfig) {
        return $18590f52bdef7d7b$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const cooldown = this._dnsQueryCooldowns[urlConfig.endpoint];
            if (cooldown && Date.now() < cooldown) return null;
            this._dnsQueryCooldowns[urlConfig.endpoint] = Date.now() + $18590f52bdef7d7b$var$COOLDOWN_TIME_MS;
            const result = [];
            const records = yield (0, $beBXx._fetchTxtRecords)((_a = this._networkOverrideFunc) !== null && _a !== void 0 ? _a : fetch);
            const path = $18590f52bdef7d7b$var$_extractPathFromUrl(urlConfig.defaultUrl);
            for (const record of records){
                if (!record.startsWith(urlConfig.endpointDnsKey + '=')) continue;
                const parts = record.split('=');
                if (parts.length > 1) {
                    let baseUrl = parts[1];
                    if (baseUrl.endsWith('/')) baseUrl = baseUrl.slice(0, -1);
                    result.push(`https://${baseUrl}${path}`);
                }
            }
            return result;
        });
    }
    _pickNewFallbackUrl(currentFallbackInfo, urls) {
        var _a;
        if (urls == null) return null;
        const previouslyUsed = new Set((_a = currentFallbackInfo === null || currentFallbackInfo === void 0 ? void 0 : currentFallbackInfo.previous) !== null && _a !== void 0 ? _a : []);
        const currentFallbackUrl = currentFallbackInfo === null || currentFallbackInfo === void 0 ? void 0 : currentFallbackInfo.url;
        let found = null;
        for (const loopUrl of urls){
            const url = loopUrl.endsWith('/') ? loopUrl.slice(0, -1) : loopUrl;
            if (!previouslyUsed.has(loopUrl) && url !== currentFallbackUrl) {
                found = url;
                break;
            }
        }
        return found;
    }
}
module.exports.NetworkFallbackResolver = $18590f52bdef7d7b$var$NetworkFallbackResolver;
function $18590f52bdef7d7b$var$_isDomainFailure(errorMsg, timedOut) {
    var _a;
    const lowerErrorMsg = (_a = errorMsg === null || errorMsg === void 0 ? void 0 : errorMsg.toLowerCase()) !== null && _a !== void 0 ? _a : '';
    return timedOut || lowerErrorMsg.includes('uncaught exception') || lowerErrorMsg.includes('failed to fetch') || lowerErrorMsg.includes('networkerror when attempting to fetch resource');
}
module.exports._isDomainFailure = $18590f52bdef7d7b$var$_isDomainFailure;
function $18590f52bdef7d7b$var$_getFallbackInfoStorageKey(sdkKey) {
    return `statsig.network_fallback.${(0, $e7Snh._DJB2)(sdkKey)}`;
}
function $18590f52bdef7d7b$var$_tryWriteFallbackInfoToCache(sdkKey, info) {
    const hashKey = $18590f52bdef7d7b$var$_getFallbackInfoStorageKey(sdkKey);
    if (!info || Object.keys(info).length === 0) {
        $c7w2G.Storage.removeItem(hashKey);
        return;
    }
    $c7w2G.Storage.setItem(hashKey, JSON.stringify(info));
}
function $18590f52bdef7d7b$var$_readFallbackInfoFromCache(sdkKey) {
    const hashKey = $18590f52bdef7d7b$var$_getFallbackInfoStorageKey(sdkKey);
    const data = $c7w2G.Storage.getItem(hashKey);
    if (!data) return null;
    try {
        return JSON.parse(data);
    } catch (_a) {
        $42M1N.Log.error('Failed to parse FallbackInfo');
        return null;
    }
}
function $18590f52bdef7d7b$var$_extractPathFromUrl(urlString) {
    try {
        const url = new URL(urlString);
        return url.pathname;
    } catch (error) {
        return null;
    }
}

});
parcelRegister("beBXx", function(module, exports) {
"use strict";
var $82de726a1adb3f45$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._fetchTxtRecords = void 0;
// See example: https://github.com/statsig-io/private-js-client-monorepo/pull/340
const $82de726a1adb3f45$var$FEATURE_ASSETS_DNS_QUERY = new Uint8Array([
    0x00,
    0x00,
    0x01,
    0x00,
    0x00,
    0x01,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x0d,
    0x66,
    0x65,
    0x61,
    0x74,
    0x75,
    0x72,
    0x65,
    0x61,
    0x73,
    0x73,
    0x65,
    0x74,
    0x73,
    0x03,
    0x6f,
    0x72,
    0x67,
    0x00,
    0x00,
    0x10,
    0x00,
    0x01
]);
const $82de726a1adb3f45$var$DNS_QUERY_ENDPOINT = 'https://cloudflare-dns.com/dns-query';
const $82de726a1adb3f45$var$DOMAIN_CHARS = [
    'i',
    'e',
    'd'
];
const $82de726a1adb3f45$var$MAX_START_LOOKUP = 200;
function $82de726a1adb3f45$var$_fetchTxtRecords(networkFunc) {
    return $82de726a1adb3f45$var$__awaiter(this, void 0, void 0, function*() {
        const response = yield networkFunc($82de726a1adb3f45$var$DNS_QUERY_ENDPOINT, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/dns-message',
                Accept: 'application/dns-message'
            },
            body: $82de726a1adb3f45$var$FEATURE_ASSETS_DNS_QUERY
        });
        if (!response.ok) {
            const err = new Error('Failed to fetch TXT records from DNS');
            err.name = 'DnsTxtFetchError';
            throw err;
        }
        const data = yield response.arrayBuffer();
        const bytes = new Uint8Array(data);
        return $82de726a1adb3f45$var$_parseDnsResponse(bytes);
    });
}
module.exports._fetchTxtRecords = $82de726a1adb3f45$var$_fetchTxtRecords;
function $82de726a1adb3f45$var$_parseDnsResponse(input) {
    // loop until we find the first valid domain char. One of [i=, e=, d=]
    const start = input.findIndex((byte, index)=>index < $82de726a1adb3f45$var$MAX_START_LOOKUP && String.fromCharCode(byte) === '=' && $82de726a1adb3f45$var$DOMAIN_CHARS.includes(String.fromCharCode(input[index - 1])));
    if (start === -1) {
        const err = new Error('Failed to parse TXT records from DNS');
        err.name = 'DnsTxtParseError';
        throw err;
    }
    // decode the remaining bytes as a string
    let result = '';
    for(let i = start - 1; i < input.length; i++)result += String.fromCharCode(input[i]);
    return result.split(',');
}

});


parcelRegister("cBUKu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SDKFlags = void 0;
const $92e4f5da7f510238$var$FLAGMAP = {};
module.exports.SDKFlags = {
    setFlags: (sdkKey, flags)=>{
        $92e4f5da7f510238$var$FLAGMAP[sdkKey] = flags;
    },
    get: (sdkKey, flagKey)=>{
        var _a, _b;
        return (_b = (_a = $92e4f5da7f510238$var$FLAGMAP[sdkKey]) === null || _a === void 0 ? void 0 : _a[flagKey]) !== null && _b !== void 0 ? _b : false;
    }
};

});

parcelRegister("c0WIS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigSession = module.exports.SessionID = void 0;

var $lAepD = parcelRequire("lAepD");

var $8JdtX = parcelRequire("8JdtX");

var $42M1N = parcelRequire("42M1N");

var $c7w2G = parcelRequire("c7w2G");

var $8dVoQ = parcelRequire("8dVoQ");
const $8bf3093e09d2e153$var$MAX_SESSION_IDLE_TIME = 1800000; // 30 minutes
const $8bf3093e09d2e153$var$MAX_SESSION_AGE = 14400000; // 4 hours
const $8bf3093e09d2e153$var$PROMISE_MAP = {};
module.exports.SessionID = {
    get: (sdkKey)=>{
        return module.exports.StatsigSession.get(sdkKey).data.sessionID;
    }
};
module.exports.StatsigSession = {
    get: (sdkKey)=>{
        if ($8bf3093e09d2e153$var$PROMISE_MAP[sdkKey] == null) $8bf3093e09d2e153$var$PROMISE_MAP[sdkKey] = $8bf3093e09d2e153$var$_loadSession(sdkKey);
        const session = $8bf3093e09d2e153$var$PROMISE_MAP[sdkKey];
        return $8bf3093e09d2e153$var$_bumpSession(session);
    },
    overrideInitialSessionID: (override, sdkKey)=>{
        $8bf3093e09d2e153$var$PROMISE_MAP[sdkKey] = $8bf3093e09d2e153$var$_overrideSessionId(override, sdkKey);
    }
};
function $8bf3093e09d2e153$var$_loadSession(sdkKey) {
    let data = $8bf3093e09d2e153$var$_loadFromStorage(sdkKey);
    const now = Date.now();
    if (!data) data = {
        sessionID: (0, $8dVoQ.getUUID)(),
        startTime: now,
        lastUpdate: now
    };
    return {
        data: data,
        sdkKey: sdkKey
    };
}
function $8bf3093e09d2e153$var$_overrideSessionId(override, sdkKey) {
    const now = Date.now();
    return {
        data: {
            sessionID: override,
            startTime: now,
            lastUpdate: now
        },
        sdkKey: sdkKey
    };
}
function $8bf3093e09d2e153$var$_bumpSession(session) {
    const now = Date.now();
    const data = session.data;
    const sdkKey = session.sdkKey;
    if ($8bf3093e09d2e153$var$_isIdle(data) || $8bf3093e09d2e153$var$_hasRunTooLong(data)) {
        data.sessionID = (0, $8dVoQ.getUUID)();
        data.startTime = now;
        const client = __STATSIG__ === null || __STATSIG__ === void 0 ? void 0 : __STATSIG__.instance(sdkKey);
        if (client) client.$emt({
            name: 'session_expired'
        });
    }
    data.lastUpdate = now;
    $8bf3093e09d2e153$var$_persistToStorage(data, session.sdkKey);
    clearTimeout(session.idleTimeoutID);
    clearTimeout(session.ageTimeoutID);
    const lifetime = now - data.startTime;
    session.idleTimeoutID = $8bf3093e09d2e153$var$_createSessionTimeout(sdkKey, $8bf3093e09d2e153$var$MAX_SESSION_IDLE_TIME);
    session.ageTimeoutID = $8bf3093e09d2e153$var$_createSessionTimeout(sdkKey, $8bf3093e09d2e153$var$MAX_SESSION_AGE - lifetime);
    return session;
}
function $8bf3093e09d2e153$var$_createSessionTimeout(sdkKey, duration) {
    return setTimeout(()=>{
        var _a;
        const client = (_a = (0, $lAepD._getStatsigGlobal)()) === null || _a === void 0 ? void 0 : _a.instance(sdkKey);
        if (client) client.$emt({
            name: 'session_expired'
        });
    }, duration);
}
function $8bf3093e09d2e153$var$_isIdle({ lastUpdate: lastUpdate }) {
    return Date.now() - lastUpdate > $8bf3093e09d2e153$var$MAX_SESSION_IDLE_TIME;
}
function $8bf3093e09d2e153$var$_hasRunTooLong({ startTime: startTime }) {
    return Date.now() - startTime > $8bf3093e09d2e153$var$MAX_SESSION_AGE;
}
function $8bf3093e09d2e153$var$_getSessionIDStorageKey(sdkKey) {
    return `statsig.session_id.${(0, $8JdtX._getStorageKey)(sdkKey)}`;
}
function $8bf3093e09d2e153$var$_persistToStorage(session, sdkKey) {
    const storageKey = $8bf3093e09d2e153$var$_getSessionIDStorageKey(sdkKey);
    try {
        (0, $c7w2G._setObjectInStorage)(storageKey, session);
    } catch (e) {
        $42M1N.Log.warn('Failed to save SessionID');
    }
}
function $8bf3093e09d2e153$var$_loadFromStorage(sdkKey) {
    const storageKey = $8bf3093e09d2e153$var$_getSessionIDStorageKey(sdkKey);
    return (0, $c7w2G._getObjectFromStorage)(storageKey);
}

});

parcelRegister("dzswy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ErrorTag = void 0;
module.exports.ErrorTag = {
    NetworkError: 'NetworkError'
};

});


parcelRegister("gSXsz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("abuSO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("hpfea", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._fastApproxSizeOf = void 0;
const $cac0954f7f36daf5$var$CURLY_AND_SQUARE_BRACKET_SIZE = 2; // [] for array, {} for object
const $cac0954f7f36daf5$var$APPROX_ADDITIONAL_SIZE = 1; // additional size for comma and stuff
const $cac0954f7f36daf5$var$_fastApproxSizeOf = (obj, max)=>{
    let size = 0;
    const keys = Object.keys(obj);
    for(let i = 0; i < keys.length; i++){
        const key = keys[i];
        const value = obj[key];
        size += key.length;
        if (typeof value === 'object' && value !== null) size += (0, module.exports._fastApproxSizeOf)(value, max) + $cac0954f7f36daf5$var$CURLY_AND_SQUARE_BRACKET_SIZE;
        else size += String(value).length + $cac0954f7f36daf5$var$APPROX_ADDITIONAL_SIZE;
        if (size >= max) // exit early if we've exceeded the max
        return size;
    }
    return size;
};
module.exports._fastApproxSizeOf = $cac0954f7f36daf5$var$_fastApproxSizeOf;

});

parcelRegister("d3UEg", function(module, exports) {
"use strict";
var $98277f591b987594$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigClientBase = void 0;

var $lAepD = parcelRequire("lAepD");

var $lAepD = parcelRequire("lAepD");

var $lgFld = parcelRequire("lgFld");

var $4I8X8 = parcelRequire("4I8X8");

var $42M1N = parcelRequire("42M1N");

var $bEyUY = parcelRequire("bEyUY");

var $j3d6r = parcelRequire("j3d6r");

var $c0WIS = parcelRequire("c0WIS");

var $d51pD = parcelRequire("d51pD");

var $kvUc3 = parcelRequire("kvUc3");

var $c7w2G = parcelRequire("c7w2G");
const $98277f591b987594$var$MAX_MEMO_CACHE_SIZE = 3000;
class $98277f591b987594$var$StatsigClientBase {
    constructor(sdkKey, adapter, network, options){
        var _a, _b, _c, _d;
        this.loadingStatus = 'Uninitialized';
        this._initializePromise = null;
        this._listeners = {};
        const emitter = this.$emt.bind(this);
        (options === null || options === void 0 ? void 0 : options.logLevel) != null && ($42M1N.Log.level = options.logLevel);
        (options === null || options === void 0 ? void 0 : options.disableStorage) && $c7w2G.Storage._setDisabled(true);
        (options === null || options === void 0 ? void 0 : options.initialSessionID) && $c0WIS.StatsigSession.overrideInitialSessionID(options.initialSessionID, sdkKey);
        (options === null || options === void 0 ? void 0 : options.storageProvider) && $c7w2G.Storage._setProvider(options.storageProvider);
        (options === null || options === void 0 ? void 0 : options.enableCookies) && $d51pD.StableID._setCookiesEnabled(sdkKey, options.enableCookies);
        (options === null || options === void 0 ? void 0 : options.disableStableID) && $d51pD.StableID._setDisabled(sdkKey, true);
        this._sdkKey = sdkKey;
        this._options = options !== null && options !== void 0 ? options : {};
        this._memoCache = {};
        this.overrideAdapter = (_a = options === null || options === void 0 ? void 0 : options.overrideAdapter) !== null && _a !== void 0 ? _a : null;
        this._logger = new $4I8X8.EventLogger(sdkKey, emitter, network, options);
        this._errorBoundary = new $lgFld.ErrorBoundary(sdkKey, options, emitter);
        this._errorBoundary.wrap(this);
        this._errorBoundary.wrap(adapter);
        this._errorBoundary.wrap(this._logger);
        network.setErrorBoundary(this._errorBoundary);
        this.dataAdapter = adapter;
        this.dataAdapter.attach(sdkKey, options, network);
        this.storageProvider = $c7w2G.Storage;
        (_d = (_c = (_b = this.overrideAdapter) === null || _b === void 0 ? void 0 : _b.loadFromStorage) === null || _c === void 0 ? void 0 : _c.call(_b)) === null || _d === void 0 || _d.catch((e)=>this._errorBoundary.logError('OA::loadFromStorage', e));
        this._primeReadyRipcord();
        $98277f591b987594$var$_assignGlobalInstance(sdkKey, this);
    }
    /**
     * Updates runtime configuration options for the SDK, allowing toggling of certain behaviors such as logging and storage to comply with user preferences or regulations such as GDPR.
     *
     * @param {StatsigRuntimeMutableOptions} options - The configuration options that dictate the runtime behavior of the SDK.
     */ updateRuntimeOptions(options) {
        if (options.loggingEnabled) {
            this._options.loggingEnabled = options.loggingEnabled;
            this._logger.setLoggingEnabled(options.loggingEnabled);
        } else if (options.disableLogging != null) {
            this._options.disableLogging = options.disableLogging;
            this._logger.setLoggingEnabled(options.disableLogging ? 'disabled' : 'browser-only');
        }
        if (options.disableStorage != null) {
            this._options.disableStorage = options.disableStorage;
            $c7w2G.Storage._setDisabled(options.disableStorage);
        }
        if (options.enableCookies != null) {
            this._options.enableCookies = options.enableCookies;
            $d51pD.StableID._setCookiesEnabled(this._sdkKey, options.enableCookies);
        }
        if (options.logEventCompressionMode) this._logger.setLogEventCompressionMode(options.logEventCompressionMode);
        else if (options.disableCompression) this._logger.setLogEventCompressionMode($kvUc3.LogEventCompressionMode.Disabled);
    }
    /**
     * Flushes any currently queued events.
     */ flush() {
        return this._logger.flush();
    }
    /**
     * Gracefully shuts down the SDK, ensuring that all pending events are send before the SDK stops.
     * This function emits a 'pre_shutdown' event and then waits for the logger to complete its shutdown process.
     *
     * @returns {Promise<void>} A promise that resolves when all shutdown procedures, including logging shutdown, have been completed.
     */ shutdown() {
        return $98277f591b987594$var$__awaiter(this, void 0, void 0, function*() {
            this.$emt({
                name: 'pre_shutdown'
            });
            this._setStatus('Uninitialized', null);
            this._initializePromise = null;
            yield this._logger.stop();
        });
    }
    /**
     * Subscribes a callback function to a specific {@link StatsigClientEvent} or all StatsigClientEvents if the wildcard '*' is used.
     * Once subscribed, the listener callback will be invoked whenever the specified event is emitted.
     *
     * @param {StatsigClientEventName} event - The name of the event to subscribe to, or '*' to subscribe to all events.
     * @param {StatsigClientEventCallback<T>} listener - The callback function to execute when the event occurs. The function receives event-specific data as its parameter.
     * @see {@link off} for unsubscribing from events.
     */ on(event, listener) {
        if (!this._listeners[event]) this._listeners[event] = [];
        this._listeners[event].push(listener);
    }
    /**
     * Unsubscribes a previously registered callback function from a specific {@link StatsigClientEvent} or all StatsigClientEvents if the wildcard '*' is used.
     *
     * @param {StatsigClientEventName} event - The name of the event from which to unsubscribe, or '*' to unsubscribe from all events.
     * @param {StatsigClientEventCallback<T>} listener - The callback function to remove from the event's notification list.
     * @see {@link on} for subscribing to events.
     */ off(event, listener) {
        if (this._listeners[event]) {
            const index = this._listeners[event].indexOf(listener);
            if (index !== -1) this._listeners[event].splice(index, 1);
        }
    }
    $on(event, listener) {
        listener.__isInternal = true;
        this.on(event, listener);
    }
    $emt(event) {
        var _a;
        const barrier = (listener)=>{
            try {
                listener(event);
            } catch (error) {
                if (listener.__isInternal === true) {
                    this._errorBoundary.logError(`__emit:${event.name}`, error);
                    return;
                }
                $42M1N.Log.error(`An error occurred in a StatsigClientEvent listener. This is not an issue with Statsig.`, event);
            }
        };
        if (this._listeners[event.name]) this._listeners[event.name].forEach((l)=>barrier(l));
        (_a = this._listeners['*']) === null || _a === void 0 || _a.forEach(barrier);
    }
    _setStatus(newStatus, values) {
        this.loadingStatus = newStatus;
        this._memoCache = {};
        this.$emt({
            name: 'values_updated',
            status: newStatus,
            values: values
        });
    }
    _enqueueExposure(name, exposure, options) {
        if ((options === null || options === void 0 ? void 0 : options.disableExposureLog) === true) {
            this._logger.incrementNonExposureCount(name);
            return;
        }
        this._logger.enqueue(exposure);
    }
    _memoize(prefix, fn) {
        return (name, options)=>{
            if (this._options.disableEvaluationMemoization) return fn(name, options);
            const memoKey = (0, $bEyUY.createMemoKey)(prefix, name, options);
            if (!memoKey) return fn(name, options);
            if (!(memoKey in this._memoCache)) {
                if (Object.keys(this._memoCache).length >= $98277f591b987594$var$MAX_MEMO_CACHE_SIZE) this._memoCache = {};
                this._memoCache[memoKey] = fn(name, options);
            }
            return this._memoCache[memoKey];
        };
    }
}
module.exports.StatsigClientBase = $98277f591b987594$var$StatsigClientBase;
function $98277f591b987594$var$_assignGlobalInstance(sdkKey, client) {
    var _a;
    if ((0, $j3d6r._isServerEnv)()) return;
    const statsigGlobal = (0, $lAepD._getStatsigGlobal)();
    const instances = (_a = statsigGlobal.instances) !== null && _a !== void 0 ? _a : {};
    const inst = client;
    if (instances[sdkKey] != null) $42M1N.Log.warn('Creating multiple Statsig clients with the same SDK key can lead to unexpected behavior. Multi-instance support requires different SDK keys.');
    instances[sdkKey] = inst;
    if (!statsigGlobal.firstInstance) statsigGlobal.firstInstance = inst;
    statsigGlobal.instances = instances;
    __STATSIG__ = statsigGlobal;
}

});

parcelRegister("2GgI2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DataAdapterCachePrefix = void 0;
module.exports.DataAdapterCachePrefix = 'statsig.cached';

});

parcelRegister("gaSPj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("eoU6t", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._makeTypedGet = module.exports._mergeOverride = module.exports._makeLayer = module.exports._makeExperiment = module.exports._makeDynamicConfig = module.exports._makeFeatureGate = void 0;

var $42M1N = parcelRequire("42M1N");

var $9XePg = parcelRequire("9XePg");
function $a7bed38b9a9c1255$var$_makeEvaluation(name, details, evaluation, value) {
    var _a;
    return {
        name: name,
        details: details,
        ruleID: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.rule_id) !== null && _a !== void 0 ? _a : '',
        __evaluation: evaluation,
        value: value
    };
}
function $a7bed38b9a9c1255$var$_makeFeatureGate(name, details, evaluation) {
    var _a;
    return Object.assign(Object.assign({}, $a7bed38b9a9c1255$var$_makeEvaluation(name, details, evaluation, (evaluation === null || evaluation === void 0 ? void 0 : evaluation.value) === true)), {
        idType: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.id_type) !== null && _a !== void 0 ? _a : null
    });
}
module.exports._makeFeatureGate = $a7bed38b9a9c1255$var$_makeFeatureGate;
function $a7bed38b9a9c1255$var$_makeDynamicConfig(name, details, evaluation) {
    var _a;
    const value = (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.value) !== null && _a !== void 0 ? _a : {};
    return Object.assign(Object.assign({}, $a7bed38b9a9c1255$var$_makeEvaluation(name, details, evaluation, value)), {
        get: $a7bed38b9a9c1255$var$_makeTypedGet(name, evaluation === null || evaluation === void 0 ? void 0 : evaluation.value)
    });
}
module.exports._makeDynamicConfig = $a7bed38b9a9c1255$var$_makeDynamicConfig;
function $a7bed38b9a9c1255$var$_makeExperiment(name, details, evaluation) {
    var _a;
    const result = $a7bed38b9a9c1255$var$_makeDynamicConfig(name, details, evaluation);
    return Object.assign(Object.assign({}, result), {
        groupName: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.group_name) !== null && _a !== void 0 ? _a : null
    });
}
module.exports._makeExperiment = $a7bed38b9a9c1255$var$_makeExperiment;
function $a7bed38b9a9c1255$var$_makeLayer(name, details, evaluation, exposeFunc) {
    var _a, _b;
    return Object.assign(Object.assign({}, $a7bed38b9a9c1255$var$_makeEvaluation(name, details, evaluation, undefined)), {
        get: $a7bed38b9a9c1255$var$_makeTypedGet(name, evaluation === null || evaluation === void 0 ? void 0 : evaluation.value, exposeFunc),
        groupName: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.group_name) !== null && _a !== void 0 ? _a : null,
        __value: (_b = evaluation === null || evaluation === void 0 ? void 0 : evaluation.value) !== null && _b !== void 0 ? _b : {}
    });
}
module.exports._makeLayer = $a7bed38b9a9c1255$var$_makeLayer;
function $a7bed38b9a9c1255$var$_mergeOverride(original, overridden, value, exposeFunc) {
    return Object.assign(Object.assign(Object.assign({}, original), overridden), {
        get: $a7bed38b9a9c1255$var$_makeTypedGet(original.name, value, exposeFunc)
    });
}
module.exports._mergeOverride = $a7bed38b9a9c1255$var$_mergeOverride;
function $a7bed38b9a9c1255$var$_makeTypedGet(name, value, exposeFunc) {
    return (param, fallback)=>{
        var _a;
        const found = (_a = value === null || value === void 0 ? void 0 : value[param]) !== null && _a !== void 0 ? _a : null;
        if (found == null) return fallback !== null && fallback !== void 0 ? fallback : null;
        if (fallback != null && !(0, $9XePg._isTypeMatch)(found, fallback)) {
            $42M1N.Log.warn(`Parameter type mismatch. '${name}.${param}' was found to be type '${typeof found}' but fallback/return type is '${typeof fallback}'. See https://docs.statsig.com/client/javascript-sdk/#typed-getters`);
            return fallback !== null && fallback !== void 0 ? fallback : null;
        }
        exposeFunc === null || exposeFunc === void 0 || exposeFunc(param);
        return found;
    };
}
module.exports._makeTypedGet = $a7bed38b9a9c1255$var$_makeTypedGet;

});

parcelRegister("iZx3S", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("OcpvB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UPDATE_DETAIL_ERROR_MESSAGES = module.exports.createUpdateDetails = void 0;
const $096e4c1458ac69a6$var$createUpdateDetails = (success, source, initDuration, error, sourceUrl, warnings)=>{
    return {
        duration: initDuration,
        source: source,
        success: success,
        error: error,
        sourceUrl: sourceUrl,
        warnings: warnings
    };
};
module.exports.createUpdateDetails = $096e4c1458ac69a6$var$createUpdateDetails;
module.exports.UPDATE_DETAIL_ERROR_MESSAGES = {
    NO_NETWORK_DATA: 'No data was returned from the network. This may be due to a network timeout if a timeout value was specified in the options or ad blocker error.'
};

});


parcelRegister("5nHOn", function(module, exports) {
"use strict";
var $3eb115c55ac17f68$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $bRnho = parcelRequire("bRnho");

var $9hBkc = parcelRequire("9hBkc");

var $l5DUV = parcelRequire("l5DUV");

var $1QefW = parcelRequire("1QefW");

var $2mGEv = parcelRequire("2mGEv");
class $3eb115c55ac17f68$var$StatsigClient extends $bRnho.StatsigClientBase {
    /**
     * Retrieves an instance of the StatsigClient based on the provided SDK key.
     *  If no SDK key is provided, the method returns the most recently created instance of the StatsigClient.
     *  The method ensures that each unique SDK key corresponds to a single instance of StatsigClient, effectively implementing a singleton pattern for each key.
     *  If no instance exists for the given SDK key, a new StatsigClient instance will be created and returned.
     *
     * @param {string} [sdkKey] - Optional. The SDK key used to identify a specific instance of the StatsigClient. If omitted, the method returns the last created instance.
     * @returns {StatsigClient} Returns the StatsigClient instance associated with the given SDK key, creating a new one if needed.
     */ static instance(sdkKey) {
        const instance = (0, $bRnho._getStatsigGlobal)().instance(sdkKey);
        if (instance instanceof $3eb115c55ac17f68$var$StatsigClient) return instance;
        $bRnho.Log.warn((0, $bRnho._isServerEnv)() ? 'StatsigClient.instance is not supported in server environments' : 'Unable to find StatsigClient instance');
        return new $3eb115c55ac17f68$var$StatsigClient(sdkKey !== null && sdkKey !== void 0 ? sdkKey : '', {});
    }
    /**
     * StatsigClient constructor
     *
     * @param {string} sdkKey A Statsig client SDK key. eg "client-xyz123..."
     * @param {StatsigUser} user StatsigUser object containing various attributes related to a user.
     * @param {StatsigOptions | null} options StatsigOptions, used to customize the behavior of the SDK.
     */ constructor(sdkKey, user, options = null){
        var _a, _b;
        $bRnho.SDKType._setClientType(sdkKey, 'javascript-client');
        const network = new $l5DUV.default(options, (e)=>{
            this.$emt(e);
        });
        super(sdkKey, (_a = options === null || options === void 0 ? void 0 : options.dataAdapter) !== null && _a !== void 0 ? _a : new $2mGEv.StatsigEvaluationsDataAdapter(), network, options);
        this._possibleFirstTouchMetadata = {};
        /**
         * Retrieves the value of a feature gate for the current user, represented as a {@link FeatureGate} object.
         *
         * @param {string} name - The name of the feature gate to retrieve.
         * @param {FeatureGateEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {FeatureGate} - The {@link FeatureGate} object representing the gate's current evaluation results for the user.
         */ this.getFeatureGate = this._memoize($bRnho.MemoPrefix._gate, this._getFeatureGateImpl.bind(this));
        /**
         * Retrieves the value of a dynamic config for the current user.
         *
         * @param {string} name The name of the dynamic config to get.
         * @param {DynamicConfigEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {DynamicConfig} - The {@link DynamicConfig} object representing the dynamic configs's current evaluation results for the user.
         */ this.getDynamicConfig = this._memoize($bRnho.MemoPrefix._dynamicConfig, this._getDynamicConfigImpl.bind(this));
        /**
         * Retrieves the value of a experiment for the current user.
         *
         * @param {string} name The name of the experiment to get.
         * @param {ExperimentEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {Experiment} - The {@link Experiment} object representing the experiments's current evaluation results for the user.
         */ this.getExperiment = this._memoize($bRnho.MemoPrefix._experiment, this._getExperimentImpl.bind(this));
        /**
         * Retrieves the list of all Dynamic Configs and Experiments for the current user.
         *
         * @returns {string[]} The list of all Dynamic Config and Experiment names for the current user. Note - these will be hashed unless you've disabled hashing.
         * This is intended to be used for debugging.
         */ this.getConfigList = this._memoize($bRnho.MemoPrefix._configList, this._getConfigListImpl.bind(this));
        /**
         * Retrieves the value of a layer for the current user.
         *
         * @param {string} name The name of the layer to get.
         * @param {LayerEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {Layer} - The {@link Layer} object representing the layers's current evaluation results for the user.
         */ this.getLayer = this._memoize($bRnho.MemoPrefix._layer, this._getLayerImpl.bind(this));
        /**
         * Retrieves the value of a parameter store for the current user.
         *
         * @param {string} name The name of the parameter store to get.
         * @param {ParameterStoreEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {ParameterStore} - The {@link ParameterStore} object representing the parameter store's current mappings for the user.
         */ this.getParameterStore = this._memoize($bRnho.MemoPrefix._paramStore, this._getParameterStoreImpl.bind(this));
        this._store = new $9hBkc.default(sdkKey);
        this._network = network;
        this._user = this._configureUser(user, options);
        this._sdkInstanceID = (0, $bRnho.getUUID)();
        const plugins = (_b = options === null || options === void 0 ? void 0 : options.plugins) !== null && _b !== void 0 ? _b : [];
        for (const plugin of plugins)plugin.bind(this);
    }
    /**
     * Initializes the StatsigClient using cached values. This method sets up the client synchronously by utilizing previously cached values.
     * After initialization, cache values are updated in the background for future use, either in subsequent sessions or when `updateUser` is called.
     * This is useful for quickly starting with the last-known-good configurations while refreshing data to keep settings up-to-date.
     *
     * @see {@link initializeAsync} for the asynchronous version of this method.
     */ initializeSync(options) {
        var _a;
        if (this.loadingStatus !== 'Uninitialized') return (0, $bRnho.createUpdateDetails)(true, this._store.getSource(), -1, null, null, [
            'MultipleInitializations',
            ...(_a = this._store.getWarnings()) !== null && _a !== void 0 ? _a : []
        ]);
        this._logger.start();
        return this.updateUserSync(this._user, options);
    }
    /**
     * Initializes the StatsigClient asynchronously by first using cached values and then updating to the latest values from the network.
     * Once the network values are fetched, they replace the existing cached values. If this method's promise is not awaited,
     * there might be a transition from cached to network values during the session, which can affect consistency.
     * This method is useful when it's acceptable to begin with potentially stale data and switch to the latest configuration as it becomes available.
     *
     * @param {AsyncUpdateOptions} [options] - Optional. Additional options to customize the method call.
     * @returns {Promise<void>} A promise that resolves once the client is fully initialized with the latest values from the network or a timeout (if set) is hit.
     * @see {@link initializeSync} for the synchronous version of this method.
     */ initializeAsync(options) {
        return $3eb115c55ac17f68$var$__awaiter(this, void 0, void 0, function*() {
            if (this._initializePromise) return this._initializePromise;
            this._initializePromise = this._initializeAsyncImpl(options);
            return this._initializePromise;
        });
    }
    /**
     * Synchronously updates the user in the Statsig client and switches the internal state to use cached values for the newly specified user.
     * After the initial switch to cached values, this method updates these values in the background, preparing them for future sessions or subsequent calls to updateUser.
     * This method ensures the client is quickly ready with available data.
     *
     * @param {StatsigUser} user - The new StatsigUser for which the client should update its internal state.
     * @see {@link updateUserAsync} for the asynchronous version of this method.
     */ updateUserSync(user, options) {
        const startTime = performance.now();
        try {
            return this._updateUserSyncImpl(user, options, startTime);
        } catch (e) {
            const err = e instanceof Error ? e : new Error(String(e));
            return this._createErrorUpdateDetails(err, startTime);
        }
    }
    _updateUserSyncImpl(user, options, startTime) {
        var _a;
        const warnings = [
            ...(_a = this._store.getWarnings()) !== null && _a !== void 0 ? _a : []
        ];
        this._resetForUser(user);
        const result = this.dataAdapter.getDataSync(this._user);
        if (result == null) warnings.push('NoCachedValues');
        this._store.setValues(result, this._user);
        this._finalizeUpdate(result);
        const disable = options === null || options === void 0 ? void 0 : options.disableBackgroundCacheRefresh;
        if (disable === true || disable == null && (result === null || result === void 0 ? void 0 : result.source) === 'Bootstrap') return (0, $bRnho.createUpdateDetails)(true, this._store.getSource(), performance.now() - startTime, this._errorBoundary.getLastSeenErrorAndReset(), this._network.getLastUsedInitUrlAndReset(), warnings);
        this._runPostUpdate(result !== null && result !== void 0 ? result : null, this._user);
        return (0, $bRnho.createUpdateDetails)(true, this._store.getSource(), performance.now() - startTime, this._errorBoundary.getLastSeenErrorAndReset(), this._network.getLastUsedInitUrlAndReset(), warnings);
    }
    /**
     * Asynchronously updates the user in the Statsig client by initially using cached values and then fetching the latest values from the network.
     * When the latest values are fetched, they replace the cached values. If the promise returned by this method is not awaited,
     * the client's state may shift from cached to updated network values during the session, potentially affecting consistency.
     * This method is best used in scenarios where up-to-date configuration is critical and initial delays are acceptable.
     *
     * @param {StatsigUser} user - The new StatsigUser for which the client should update its internal state.
     * @param {AsyncUpdateOptions} [options] - Optional. Additional options to customize the method call.
     * @returns {Promise<void>} A promise that resolves once the client is fully updated with the latest values from the network or a timeout (if set) is hit.
     * @see {@link updateUserSync} for the synchronous version of this method.
     */ updateUserAsync(user, options) {
        return $3eb115c55ac17f68$var$__awaiter(this, void 0, void 0, function*() {
            const startTime = performance.now();
            try {
                return yield this._updateUserAsyncImpl(user, options);
            } catch (e) {
                const err = e instanceof Error ? e : new Error(String(e));
                return this._createErrorUpdateDetails(err, startTime);
            }
        });
    }
    _updateUserAsyncImpl(user, options) {
        return $3eb115c55ac17f68$var$__awaiter(this, void 0, void 0, function*() {
            this._resetForUser(user);
            const initiator = this._user;
            $bRnho.Diagnostics._markInitOverallStart(this._sdkKey);
            let result = this.dataAdapter.getDataSync(initiator);
            this._store.setValues(result, this._user);
            this._setStatus('Loading', result);
            result = yield this.dataAdapter.getDataAsync(result, initiator, options);
            // ensure the user hasn't changed while we were waiting
            if (initiator !== this._user) return (0, $bRnho.createUpdateDetails)(false, this._store.getSource(), -1, new Error('User changed during update'), this._network.getLastUsedInitUrlAndReset());
            let isUsingNetworkValues = false;
            if (result != null) {
                $bRnho.Diagnostics._markInitProcessStart(this._sdkKey);
                isUsingNetworkValues = this._store.setValues(result, this._user);
                $bRnho.Diagnostics._markInitProcessEnd(this._sdkKey, {
                    success: isUsingNetworkValues
                });
            }
            this._finalizeUpdate(result);
            if (!isUsingNetworkValues) {
                this._errorBoundary.attachErrorIfNoneExists($bRnho.UPDATE_DETAIL_ERROR_MESSAGES.NO_NETWORK_DATA);
                this.$emt({
                    name: 'initialization_failure'
                });
            }
            $bRnho.Diagnostics._markInitOverallEnd(this._sdkKey, isUsingNetworkValues, this._store.getCurrentSourceDetails());
            const initDuration = $bRnho.Diagnostics._enqueueDiagnosticsEvent(this._user, this._logger, this._sdkKey, this._options);
            return (0, $bRnho.createUpdateDetails)(isUsingNetworkValues, this._store.getSource(), initDuration, this._errorBoundary.getLastSeenErrorAndReset(), this._network.getLastUsedInitUrlAndReset(), this._store.getWarnings());
        });
    }
    /**
     * Retrieves a synchronous context containing data currently being used by the SDK. Represented as a {@link PrecomputedEvaluationsContext} object.
     *
     * @returns {PrecomputedEvaluationsContext} The current synchronous context for the this StatsigClient instance.
     */ getContext() {
        return {
            sdkKey: this._sdkKey,
            options: this._options,
            values: this._store.getValues(),
            user: JSON.parse(JSON.stringify(this._user)),
            errorBoundary: this._errorBoundary,
            session: $bRnho.StatsigSession.get(this._sdkKey),
            stableID: $bRnho.StableID.get(this._sdkKey),
            sdkInstanceID: this._sdkInstanceID
        };
    }
    /**
     * Retrieves the value of a feature gate for the current user, represented as a simple boolean.
     *
     * @param {string} name - The name of the feature gate to retrieve.
     * @param {FeatureGateEvaluationOptions} [options] - Optional. Additional options to customize the method call.
     * @returns {boolean} - The boolean value representing the gate's current evaluation results for the user.
     */ checkGate(name, options) {
        return this.getFeatureGate(name, options).value;
    }
    /**
     * Logs an event to the internal logging system. This function allows logging by either passing a fully formed event object or by specifying the event name with optional value and metadata.
     *
     * @param {StatsigEvent|string} eventOrName - The event object conforming to the StatsigEvent interface, or the name of the event as a string.
     * @param {string|number} value - Optional. The value associated with the event, which can be a string or a number. This parameter is ignored if the first parameter is a StatsigEvent object.
     * @param {Record<string, string>} metadata - Optional. A key-value record containing metadata about the event. This is also ignored if the first parameter is an event object.
     */ logEvent(eventOrName, value, metadata) {
        const event = typeof eventOrName === 'string' ? {
            eventName: eventOrName,
            value: value,
            metadata: metadata
        } : eventOrName;
        this.$emt({
            name: 'log_event_called',
            event: event
        });
        this._logger.enqueue(Object.assign(Object.assign({}, event), {
            user: this._user,
            time: Date.now()
        }));
    }
    /**
     * Updates the user with analytics only metadata. This will override any existing analytics only metadata.
     *
     * @param {Record<string, string | number | boolean>} metadata - The metadata to add to the user.
     */ updateUserWithAnalyticsOnlyMetadata(metadata) {
        this._user = this._configureUser(Object.assign(Object.assign({}, this._user), {
            analyticsOnlyMetadata: metadata
        }), this._options);
    }
    _primeReadyRipcord() {
        this.$on('error', ()=>{
            this.loadingStatus === 'Loading' && this._finalizeUpdate(null);
        });
    }
    _initializeAsyncImpl(options) {
        return $3eb115c55ac17f68$var$__awaiter(this, void 0, void 0, function*() {
            if (!$bRnho.Storage.isReady()) yield $bRnho.Storage.isReadyResolver();
            this._logger.start();
            return this.updateUserAsync(this._user, options);
        });
    }
    _createErrorUpdateDetails(error, startTime) {
        var _a;
        return (0, $bRnho.createUpdateDetails)(false, this._store.getSource(), performance.now() - startTime, error, null, [
            ...(_a = this._store.getWarnings()) !== null && _a !== void 0 ? _a : []
        ]);
    }
    _finalizeUpdate(values) {
        this._store.finalize();
        this._setStatus('Ready', values);
    }
    _runPostUpdate(current, user) {
        this.dataAdapter.getDataAsync(current, user, {
            priority: 'low'
        }).catch((err)=>{
            $bRnho.Log.error('An error occurred after update.', err);
        });
    }
    _resetForUser(user) {
        this._logger.reset();
        this._store.reset();
        this._user = this._configureUser(user, this._options);
    }
    _configureUser(originalUser, options) {
        var _a;
        const user = (0, $bRnho._normalizeUser)(originalUser, options);
        const stableIdOverride = (_a = user.customIDs) === null || _a === void 0 ? void 0 : _a.stableID;
        if (stableIdOverride) $bRnho.StableID.setOverride(stableIdOverride, this._sdkKey);
        user.analyticsOnlyMetadata = Object.assign(Object.assign({}, user.analyticsOnlyMetadata), this._possibleFirstTouchMetadata);
        return user;
    }
    _getFeatureGateImpl(name, options) {
        var _a, _b;
        const { result: evaluation, details: details } = this._store.getGate(name);
        const gate = (0, $bRnho._makeFeatureGate)(name, details, evaluation);
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getGateOverride) === null || _b === void 0 ? void 0 : _b.call(_a, gate, this._user, options);
        const result = overridden !== null && overridden !== void 0 ? overridden : gate;
        this._enqueueExposure(name, (0, $bRnho._createGateExposure)(this._user, result, this._store.getExposureMapping()), options);
        this.$emt({
            name: 'gate_evaluation',
            gate: result
        });
        return result;
    }
    _getDynamicConfigImpl(name, options) {
        var _a, _b;
        const { result: evaluation, details: details } = this._store.getConfig(name);
        const config = (0, $bRnho._makeDynamicConfig)(name, details, evaluation);
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getDynamicConfigOverride) === null || _b === void 0 ? void 0 : _b.call(_a, config, this._user, options);
        const result = overridden !== null && overridden !== void 0 ? overridden : config;
        this._enqueueExposure(name, (0, $bRnho._createConfigExposure)(this._user, result, this._store.getExposureMapping()), options);
        this.$emt({
            name: 'dynamic_config_evaluation',
            dynamicConfig: result
        });
        return result;
    }
    _getExperimentImpl(name, options) {
        var _a, _b, _c, _d;
        const { result: evaluation, details: details } = this._store.getConfig(name);
        const experiment = (0, $bRnho._makeExperiment)(name, details, evaluation);
        if (experiment.__evaluation != null) experiment.__evaluation.secondary_exposures = (0, $bRnho._mapExposures)((_b = (_a = experiment.__evaluation) === null || _a === void 0 ? void 0 : _a.secondary_exposures) !== null && _b !== void 0 ? _b : [], this._store.getExposureMapping());
        const overridden = (_d = (_c = this.overrideAdapter) === null || _c === void 0 ? void 0 : _c.getExperimentOverride) === null || _d === void 0 ? void 0 : _d.call(_c, experiment, this._user, options);
        const result = overridden !== null && overridden !== void 0 ? overridden : experiment;
        this._enqueueExposure(name, (0, $bRnho._createConfigExposure)(this._user, result, this._store.getExposureMapping()), options);
        this.$emt({
            name: 'experiment_evaluation',
            experiment: result
        });
        return result;
    }
    _getConfigListImpl() {
        return this._store.getConfigList();
    }
    _getLayerImpl(name, options) {
        var _a, _b, _c;
        const { result: evaluation, details: details } = this._store.getLayer(name);
        const layer = (0, $bRnho._makeLayer)(name, details, evaluation);
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getLayerOverride) === null || _b === void 0 ? void 0 : _b.call(_a, layer, this._user, options);
        if (options === null || options === void 0 ? void 0 : options.disableExposureLog) this._logger.incrementNonExposureCount(name);
        const result = (0, $bRnho._mergeOverride)(layer, overridden, (_c = overridden === null || overridden === void 0 ? void 0 : overridden.__value) !== null && _c !== void 0 ? _c : layer.__value, (param)=>{
            if (options === null || options === void 0 ? void 0 : options.disableExposureLog) return;
            this._enqueueExposure(name, (0, $bRnho._createLayerParameterExposure)(this._user, result, param, this._store.getExposureMapping()), options);
        });
        this.$emt({
            name: 'layer_evaluation',
            layer: result
        });
        return result;
    }
    _getParameterStoreImpl(name, options) {
        var _a, _b;
        const { result: configuration, details: details } = this._store.getParamStore(name);
        this._logger.incrementNonExposureCount(name);
        const paramStore = {
            name: name,
            details: details,
            __configuration: configuration,
            get: (0, $1QefW._makeParamStoreGetter)(this, configuration, options)
        };
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getParamStoreOverride) === null || _b === void 0 ? void 0 : _b.call(_a, paramStore, options);
        if (overridden != null) {
            paramStore.__configuration = overridden.config;
            paramStore.details = overridden.details;
            paramStore.get = (0, $1QefW._makeParamStoreGetter)(this, overridden.config, options);
        }
        return paramStore;
    }
}
module.exports.default = $3eb115c55ac17f68$var$StatsigClient;

});
parcelRegister("9hBkc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $bRnho = parcelRequire("bRnho");
class $6c22a7838ff9da58$var$EvaluationStore {
    constructor(_sdkKey){
        this._sdkKey = _sdkKey;
        this._rawValues = null;
        this._values = null;
        this._source = 'Uninitialized';
        this._lcut = 0;
        this._receivedAt = 0;
        this._bootstrapMetadata = null;
        this._warnings = new Set();
    }
    reset() {
        this._values = null;
        this._rawValues = null;
        this._source = 'Loading';
        this._lcut = 0;
        this._receivedAt = 0;
        this._bootstrapMetadata = null;
        this._warnings.clear();
    }
    finalize() {
        if (this._values) return;
        this._source = 'NoValues';
    }
    getValues() {
        return this._rawValues ? (0, $bRnho._typedJsonParse)(this._rawValues, 'has_updates', 'EvaluationStoreValues') : null;
    }
    setValues(result, user) {
        var _a;
        if (!result) return false;
        const values = (0, $bRnho._typedJsonParse)(result.data, 'has_updates', 'EvaluationResponse');
        if (values == null) return false;
        this._source = result.source;
        if ((values === null || values === void 0 ? void 0 : values.has_updates) !== true) return true;
        this._rawValues = result.data;
        this._lcut = values.time;
        this._receivedAt = result.receivedAt;
        this._values = values;
        this._bootstrapMetadata = this._extractBootstrapMetadata(result.source, values);
        if (result.source && values.user) this._setWarningState(user, values);
        $bRnho.SDKFlags.setFlags(this._sdkKey, (_a = values.sdk_flags) !== null && _a !== void 0 ? _a : {});
        return true;
    }
    getWarnings() {
        if (this._warnings.size === 0) return undefined;
        return Array.from(this._warnings);
    }
    getGate(name) {
        var _a;
        return this._getDetailedStoreResult((_a = this._values) === null || _a === void 0 ? void 0 : _a.feature_gates, name);
    }
    getConfig(name) {
        var _a;
        return this._getDetailedStoreResult((_a = this._values) === null || _a === void 0 ? void 0 : _a.dynamic_configs, name);
    }
    getConfigList() {
        var _a;
        if (!((_a = this._values) === null || _a === void 0 ? void 0 : _a.dynamic_configs)) return [];
        return Object.values(this._values.dynamic_configs).map((config)=>config.name);
    }
    getLayer(name) {
        var _a;
        return this._getDetailedStoreResult((_a = this._values) === null || _a === void 0 ? void 0 : _a.layer_configs, name);
    }
    getParamStore(name) {
        var _a;
        return this._getDetailedStoreResult((_a = this._values) === null || _a === void 0 ? void 0 : _a.param_stores, name);
    }
    getSource() {
        return this._source;
    }
    getExposureMapping() {
        var _a;
        return (_a = this._values) === null || _a === void 0 ? void 0 : _a.exposures;
    }
    _extractBootstrapMetadata(source, values) {
        if (source !== 'Bootstrap') return null;
        const bootstrapMetadata = {};
        if (values.user) bootstrapMetadata.user = values.user;
        if (values.sdkInfo) bootstrapMetadata.generatorSDKInfo = values.sdkInfo;
        bootstrapMetadata.lcut = values.time;
        return bootstrapMetadata;
    }
    _getDetailedStoreResult(lookup, name) {
        let result = null;
        if (lookup) result = lookup[name] ? lookup[name] : lookup[(0, $bRnho._DJB2)(name)];
        return {
            result: result,
            details: this._getDetails(result == null)
        };
    }
    _setWarningState(user, values) {
        var _a, _b;
        const stableID = $bRnho.StableID.get(this._sdkKey);
        if (((_a = user.customIDs) === null || _a === void 0 ? void 0 : _a.stableID) !== stableID && // don't throw if they're both undefined
        (((_b = user.customIDs) === null || _b === void 0 ? void 0 : _b.stableID) || stableID)) {
            this._warnings.add('StableIDMismatch');
            return;
        }
        if ('user' in values) {
            const bootstrapUser = values['user'];
            const userForComparison = Object.assign(Object.assign({}, user), {
                analyticsOnlyMetadata: undefined,
                privateAttributes: undefined
            });
            if ((0, $bRnho._getFullUserHash)(userForComparison) !== (0, $bRnho._getFullUserHash)(bootstrapUser)) this._warnings.add('PartialUserMatch');
        }
    }
    getCurrentSourceDetails() {
        if (this._source === 'Uninitialized' || this._source === 'NoValues') return {
            reason: this._source
        };
        const sourceDetails = {
            reason: this._source,
            lcut: this._lcut,
            receivedAt: this._receivedAt
        };
        if (this._warnings.size > 0) sourceDetails.warnings = Array.from(this._warnings);
        return sourceDetails;
    }
    _getDetails(isUnrecognized) {
        var _a, _b;
        const sourceDetails = this.getCurrentSourceDetails();
        let reason = sourceDetails.reason;
        const warnings = (_a = sourceDetails.warnings) !== null && _a !== void 0 ? _a : [];
        if (this._source === 'Bootstrap' && warnings.length > 0) reason = reason + warnings[0];
        if (reason !== 'Uninitialized' && reason !== 'NoValues') {
            const subreason = isUnrecognized ? 'Unrecognized' : 'Recognized';
            reason = `${reason}:${subreason}`;
        }
        const bootstrapMetadata = this._source === 'Bootstrap' ? (_b = this._bootstrapMetadata) !== null && _b !== void 0 ? _b : undefined : undefined;
        if (bootstrapMetadata) sourceDetails.bootstrapMetadata = bootstrapMetadata;
        return Object.assign(Object.assign({}, sourceDetails), {
            reason: reason
        });
    }
}
module.exports.default = $6c22a7838ff9da58$var$EvaluationStore;

});

parcelRegister("l5DUV", function(module, exports) {
"use strict";
var $f5a9075729c8f253$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $bRnho = parcelRequire("bRnho");

var $2x134 = parcelRequire("2x134");
class $f5a9075729c8f253$var$StatsigNetwork extends $bRnho.NetworkCore {
    constructor(options, emitter){
        super(options, emitter);
        const config = options === null || options === void 0 ? void 0 : options.networkConfig;
        this._option = options;
        this._initializeUrlConfig = new $bRnho.UrlConfiguration($bRnho.Endpoint._initialize, config === null || config === void 0 ? void 0 : config.initializeUrl, config === null || config === void 0 ? void 0 : config.api, config === null || config === void 0 ? void 0 : config.initializeFallbackUrls);
    }
    fetchEvaluations(sdkKey, current, priority, user, isCacheValidFor204) {
        return $f5a9075729c8f253$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b, _c, _d, _e, _f;
            const cache = current ? (0, $bRnho._typedJsonParse)(current, 'has_updates', 'InitializeResponse') : null;
            let data = {
                user: user,
                hash: (_c = (_b = (_a = this._option) === null || _a === void 0 ? void 0 : _a.networkConfig) === null || _b === void 0 ? void 0 : _b.initializeHashAlgorithm) !== null && _c !== void 0 ? _c : 'djb2',
                deltasResponseRequested: false,
                full_checksum: null
            };
            if (cache === null || cache === void 0 ? void 0 : cache.has_updates) {
                const hasHashChanged = (cache === null || cache === void 0 ? void 0 : cache.hash_used) !== ((_f = (_e = (_d = this._option) === null || _d === void 0 ? void 0 : _d.networkConfig) === null || _e === void 0 ? void 0 : _e.initializeHashAlgorithm) !== null && _f !== void 0 ? _f : 'djb2');
                data = Object.assign(Object.assign({}, data), {
                    sinceTime: isCacheValidFor204 && !hasHashChanged ? cache.time : 0,
                    previousDerivedFields: 'derived_fields' in cache && isCacheValidFor204 ? cache.derived_fields : {},
                    deltasResponseRequested: true,
                    full_checksum: cache.full_checksum,
                    partialUserMatchSinceTime: !hasHashChanged ? cache.time : 0
                });
            }
            return this._fetchEvaluations(sdkKey, cache, data, priority);
        });
    }
    _fetchEvaluations(sdkKey, cache, data, priority) {
        return $f5a9075729c8f253$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b;
            const response = yield this.post({
                sdkKey: sdkKey,
                urlConfig: this._initializeUrlConfig,
                data: data,
                retries: 2,
                isStatsigEncodable: true,
                priority: priority
            });
            if ((response === null || response === void 0 ? void 0 : response.code) === 204) return '{"has_updates": false}';
            if ((response === null || response === void 0 ? void 0 : response.code) !== 200) return (_a = response === null || response === void 0 ? void 0 : response.body) !== null && _a !== void 0 ? _a : null;
            if ((cache === null || cache === void 0 ? void 0 : cache.has_updates) !== true || ((_b = response.body) === null || _b === void 0 ? void 0 : _b.includes('"is_delta":true')) !== true || data.deltasResponseRequested !== true) return response.body;
            const result = (0, $2x134._resolveDeltasResponse)(cache, response.body);
            if (typeof result === 'string') return result;
            // retry without deltas
            return this._fetchEvaluations(sdkKey, cache, Object.assign(Object.assign(Object.assign({}, data), result), {
                deltasResponseRequested: false
            }), priority);
        });
    }
}
module.exports.default = $f5a9075729c8f253$var$StatsigNetwork;

});
parcelRegister("2x134", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._resolveDeltasResponse = void 0;

var $bRnho = parcelRequire("bRnho");
const $1d7f7a110a2ffeaf$var$MAX_DELTAS_SORT_DEPTH = 2;
function $1d7f7a110a2ffeaf$var$_resolveDeltasResponse(cache, deltasString) {
    const deltas = (0, $bRnho._typedJsonParse)(deltasString, 'checksum', 'DeltasEvaluationResponse');
    if (!deltas) return {
        hadBadDeltaChecksum: true
    };
    const merged = $1d7f7a110a2ffeaf$var$_mergeDeltasIntoCache(cache, deltas);
    const resolved = $1d7f7a110a2ffeaf$var$_handleDeletedEntries(merged);
    const actualChecksum = (0, $bRnho._DJB2Object)({
        feature_gates: resolved.feature_gates,
        dynamic_configs: resolved.dynamic_configs,
        layer_configs: resolved.layer_configs
    }, $1d7f7a110a2ffeaf$var$MAX_DELTAS_SORT_DEPTH);
    const isMatch = actualChecksum === deltas.checksumV2;
    if (!isMatch) return {
        hadBadDeltaChecksum: true,
        badChecksum: actualChecksum,
        badMergedConfigs: resolved,
        badFullResponse: deltas.deltas_full_response
    };
    return JSON.stringify(resolved);
}
module.exports._resolveDeltasResponse = $1d7f7a110a2ffeaf$var$_resolveDeltasResponse;
function $1d7f7a110a2ffeaf$var$_mergeDeltasIntoCache(cache, deltas) {
    return Object.assign(Object.assign(Object.assign({}, cache), deltas), {
        feature_gates: Object.assign(Object.assign({}, cache.feature_gates), deltas.feature_gates),
        layer_configs: Object.assign(Object.assign({}, cache.layer_configs), deltas.layer_configs),
        dynamic_configs: Object.assign(Object.assign({}, cache.dynamic_configs), deltas.dynamic_configs)
    });
}
function $1d7f7a110a2ffeaf$var$_handleDeletedEntries(deltas) {
    const result = deltas;
    $1d7f7a110a2ffeaf$var$_deleteEntriesInRecord(deltas.deleted_gates, result.feature_gates);
    delete result.deleted_gates;
    $1d7f7a110a2ffeaf$var$_deleteEntriesInRecord(deltas.deleted_configs, result.dynamic_configs);
    delete result.deleted_configs;
    $1d7f7a110a2ffeaf$var$_deleteEntriesInRecord(deltas.deleted_layers, result.layer_configs);
    delete result.deleted_layers;
    return result;
}
function $1d7f7a110a2ffeaf$var$_deleteEntriesInRecord(keys, values) {
    keys === null || keys === void 0 || keys.forEach((key)=>{
        delete values[key];
    });
}

});


parcelRegister("1QefW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._makeParamStoreGetter = void 0;

var $bRnho = parcelRequire("bRnho");
const $1575b4bfc01784f4$var$NO_EXPOSURE_OPT = {
    disableExposureLog: true
};
function $1575b4bfc01784f4$var$_shouldLogExposure(options) {
    return options == null || options.disableExposureLog === false;
}
function $1575b4bfc01784f4$var$_shouldReturnFallback(value, fallback) {
    return fallback != null && !(0, $bRnho._isTypeMatch)(value, fallback);
}
function $1575b4bfc01784f4$var$_getMappedStaticValue(param, _options) {
    return param.value;
}
function $1575b4bfc01784f4$var$_getMappedGateValue(client, param, options) {
    const gate = client.getFeatureGate(param.gate_name, $1575b4bfc01784f4$var$_shouldLogExposure(options) ? undefined : $1575b4bfc01784f4$var$NO_EXPOSURE_OPT);
    if (gate.value) return param.pass_value;
    return param.fail_value;
}
function $1575b4bfc01784f4$var$_getMappedDynamicConfigValue(client, param, fallback, options) {
    const config = client.getDynamicConfig(param.config_name, $1575b4bfc01784f4$var$_shouldLogExposure(options) ? undefined : $1575b4bfc01784f4$var$NO_EXPOSURE_OPT);
    const value = config.get(param.param_name);
    if ($1575b4bfc01784f4$var$_shouldReturnFallback(value, fallback)) return fallback;
    return value;
}
function $1575b4bfc01784f4$var$_getMappedExperimentValue(client, param, fallback, options) {
    const experiment = client.getExperiment(param.experiment_name, $1575b4bfc01784f4$var$_shouldLogExposure(options) ? undefined : $1575b4bfc01784f4$var$NO_EXPOSURE_OPT);
    const value = experiment.get(param.param_name);
    if ($1575b4bfc01784f4$var$_shouldReturnFallback(value, fallback)) return fallback;
    return value;
}
function $1575b4bfc01784f4$var$_getMappedLayerValue(client, param, fallback, options) {
    const layer = client.getLayer(param.layer_name, $1575b4bfc01784f4$var$_shouldLogExposure(options) ? undefined : $1575b4bfc01784f4$var$NO_EXPOSURE_OPT);
    const value = layer.get(param.param_name);
    if ($1575b4bfc01784f4$var$_shouldReturnFallback(value, fallback)) return fallback;
    return value;
}
function $1575b4bfc01784f4$var$_makeParamStoreGetter(client, config, options) {
    return (paramName, fallback)=>{
        if (config == null) return fallback;
        const param = config[paramName];
        if (param == null || fallback != null && (0, $bRnho._typeOf)(fallback) !== param.param_type) return fallback;
        switch(param.ref_type){
            case 'static':
                return $1575b4bfc01784f4$var$_getMappedStaticValue(param, options);
            case 'gate':
                return $1575b4bfc01784f4$var$_getMappedGateValue(client, param, options);
            case 'dynamic_config':
                return $1575b4bfc01784f4$var$_getMappedDynamicConfigValue(client, param, fallback, options);
            case 'experiment':
                return $1575b4bfc01784f4$var$_getMappedExperimentValue(client, param, fallback, options);
            case 'layer':
                return $1575b4bfc01784f4$var$_getMappedLayerValue(client, param, fallback, options);
            default:
                return fallback;
        }
    };
}
module.exports._makeParamStoreGetter = $1575b4bfc01784f4$var$_makeParamStoreGetter;

});

parcelRegister("2mGEv", function(module, exports) {
"use strict";
var $1b8eb8b434e6d00f$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigEvaluationsDataAdapter = void 0;

var $bRnho = parcelRequire("bRnho");

var $l5DUV = parcelRequire("l5DUV");
class $1b8eb8b434e6d00f$var$StatsigEvaluationsDataAdapter extends $bRnho.DataAdapterCore {
    constructor(){
        super('EvaluationsDataAdapter', 'evaluations');
        this._network = null;
        this._options = null;
    }
    attach(sdkKey, options, network) {
        super.attach(sdkKey, options, network);
        if (network !== null && network instanceof $l5DUV.default) this._network = network;
        else this._network = new $l5DUV.default(options !== null && options !== void 0 ? options : {});
    }
    getDataAsync(current, user, options) {
        return this._getDataAsyncImpl(current, (0, $bRnho._normalizeUser)(user, this._options), options);
    }
    prefetchData(user, options) {
        return this._prefetchDataImpl(user, options);
    }
    setData(data) {
        const values = (0, $bRnho._typedJsonParse)(data, 'has_updates', 'data');
        if (values && 'user' in values) super.setData(data, values.user);
        else $bRnho.Log.error('StatsigUser not found. You may be using an older server SDK version. Please upgrade your SDK or use setDataLegacy.');
    }
    setDataLegacy(data, user) {
        super.setData(data, user);
    }
    _fetchFromNetwork(current, user, options, isCacheValidFor204) {
        return $1b8eb8b434e6d00f$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const result = yield (_a = this._network) === null || _a === void 0 ? void 0 : _a.fetchEvaluations(this._getSdkKey(), current, options === null || options === void 0 ? void 0 : options.priority, user, isCacheValidFor204);
            return result !== null && result !== void 0 ? result : null;
        });
    }
    _getCacheKey(user) {
        var _a;
        const key = (0, $bRnho._getStorageKey)(this._getSdkKey(), user, (_a = this._options) === null || _a === void 0 ? void 0 : _a.customUserCacheKeyFunc);
        return `${$bRnho.DataAdapterCachePrefix}.${this._cacheSuffix}.${key}`;
    }
    _isCachedResultValidFor204(result, user) {
        return result.fullUserHash != null && result.fullUserHash === (0, $bRnho._getFullUserHash)(user);
    }
}
module.exports.StatsigEvaluationsDataAdapter = $1b8eb8b434e6d00f$var$StatsigEvaluationsDataAdapter;

});



parcelRegister("cm6iB", function(module, exports) {
'use strict';
var $8fec6cfbc56ce4a8$var$has = Object.prototype.hasOwnProperty, $8fec6cfbc56ce4a8$var$prefix = '~';
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function $8fec6cfbc56ce4a8$var$Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    $8fec6cfbc56ce4a8$var$Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new $8fec6cfbc56ce4a8$var$Events().__proto__) $8fec6cfbc56ce4a8$var$prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function $8fec6cfbc56ce4a8$var$EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function $8fec6cfbc56ce4a8$var$addListener(emitter, event, fn, context, once) {
    if (typeof fn !== 'function') throw new TypeError('The listener must be a function');
    var listener = new $8fec6cfbc56ce4a8$var$EE(fn, context || emitter, once), evt = $8fec6cfbc56ce4a8$var$prefix ? $8fec6cfbc56ce4a8$var$prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function $8fec6cfbc56ce4a8$var$clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new $8fec6cfbc56ce4a8$var$Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function $8fec6cfbc56ce4a8$var$EventEmitter() {
    this._events = new $8fec6cfbc56ce4a8$var$Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ $8fec6cfbc56ce4a8$var$EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if ($8fec6cfbc56ce4a8$var$has.call(events, name)) names.push($8fec6cfbc56ce4a8$var$prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ $8fec6cfbc56ce4a8$var$EventEmitter.prototype.listeners = function listeners(event) {
    var evt = $8fec6cfbc56ce4a8$var$prefix ? $8fec6cfbc56ce4a8$var$prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ $8fec6cfbc56ce4a8$var$EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = $8fec6cfbc56ce4a8$var$prefix ? $8fec6cfbc56ce4a8$var$prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ $8fec6cfbc56ce4a8$var$EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = $8fec6cfbc56ce4a8$var$prefix ? $8fec6cfbc56ce4a8$var$prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $8fec6cfbc56ce4a8$var$EventEmitter.prototype.on = function on(event, fn, context) {
    return $8fec6cfbc56ce4a8$var$addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $8fec6cfbc56ce4a8$var$EventEmitter.prototype.once = function once(event, fn, context) {
    return $8fec6cfbc56ce4a8$var$addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ $8fec6cfbc56ce4a8$var$EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = $8fec6cfbc56ce4a8$var$prefix ? $8fec6cfbc56ce4a8$var$prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        $8fec6cfbc56ce4a8$var$clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) $8fec6cfbc56ce4a8$var$clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else $8fec6cfbc56ce4a8$var$clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ $8fec6cfbc56ce4a8$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = $8fec6cfbc56ce4a8$var$prefix ? $8fec6cfbc56ce4a8$var$prefix + event : event;
        if (this._events[evt]) $8fec6cfbc56ce4a8$var$clearEvent(this, evt);
    } else {
        this._events = new $8fec6cfbc56ce4a8$var$Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
$8fec6cfbc56ce4a8$var$EventEmitter.prototype.off = $8fec6cfbc56ce4a8$var$EventEmitter.prototype.removeListener;
$8fec6cfbc56ce4a8$var$EventEmitter.prototype.addListener = $8fec6cfbc56ce4a8$var$EventEmitter.prototype.on;
//
// Expose the prefix.
//
$8fec6cfbc56ce4a8$var$EventEmitter.prefixed = $8fec6cfbc56ce4a8$var$prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
$8fec6cfbc56ce4a8$var$EventEmitter.EventEmitter = $8fec6cfbc56ce4a8$var$EventEmitter;
module.exports = $8fec6cfbc56ce4a8$var$EventEmitter;

});

parcelRegister("4QJhg", function(module, exports) {

var $75yrv = parcelRequire("75yrv");

var $hVEQH = parcelRequire("hVEQH");
const $142e3110c21d70ca$var$isDevelopment = false;
const { performance: $142e3110c21d70ca$var$performance, document: $142e3110c21d70ca$var$document } = window || {};
const $142e3110c21d70ca$var$assetToShortName = (0, $hVEQH.sanitiseAssetName)($142e3110c21d70ca$var$isDevelopment);
// defensively check for the necessary APIs, in SSR these would be missing
// OSX El Capitan and earlier: `performance.mark` is not defined [even though `performance` is present]
// https://stackoverflow.com/a/32940166/12146527
if (window && $142e3110c21d70ca$var$document && $142e3110c21d70ca$var$performance && $142e3110c21d70ca$var$performance.mark) /**
	 * We rely on being passed the short basename of the chunk file.
	 * It must not include path or hash but should include ".js" extension.
	 */ // @ts-expect-error - TS2740 - Type '(shortName: string) => void' is missing the following properties from type 'Window': clientInformation, closed, customElements, devicePixelRatio, and 267 more.
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
window[0, $75yrv.JS_EVAL_API] = (shortName)=>{
    const prefix = shortName.replace(/\.js$/, '.');
    const nodeList = $142e3110c21d70ca$var$document.querySelectorAll(`script[src*="${prefix}"]`);
    const scripts = Array.from(nodeList).filter((node)=>$142e3110c21d70ca$var$assetToShortName(node.getAttribute('src') ?? '') === shortName);
    if (scripts.length !== 1) {
        $142e3110c21d70ca$var$performance.mark(`${shortName}${(0, $75yrv.JS_EVAL_STOP)}`);
        return;
    }
    const script = scripts[0];
    const onLoaded = ()=>{
        script.removeEventListener('load', onLoaded);
        $142e3110c21d70ca$var$performance.mark(`${shortName}${(0, $75yrv.JS_EVAL_STOP)}`);
        if ($142e3110c21d70ca$var$isDevelopment) try {
            // not all scripts are instrumented with eval mark so measure() may error
            $142e3110c21d70ca$var$performance.measure(`_${shortName}`, `${shortName}${(0, $75yrv.JS_EVAL_START)}`, `${shortName}${(0, $75yrv.JS_EVAL_STOP)}`);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
        /* do nothing */ }
    };
    script.addEventListener('load', onLoaded);
};

});
parcelRegister("75yrv", function(module, exports) {
$parcel$export(module.exports, "SPA_SSR_RENDERED_MARK", () => $5293b7a3e8573049$export$db6a769879aea97b, (v) => $5293b7a3e8573049$export$db6a769879aea97b = v);
$parcel$export(module.exports, "JS_EVAL_START", () => $5293b7a3e8573049$export$4719e2a29dbcb33d, (v) => $5293b7a3e8573049$export$4719e2a29dbcb33d = v);
$parcel$export(module.exports, "JS_EVAL_STOP", () => $5293b7a3e8573049$export$7ee4e0433d720dea, (v) => $5293b7a3e8573049$export$7ee4e0433d720dea = v);
$parcel$export(module.exports, "JS_EVAL_API", () => $5293b7a3e8573049$export$d619b0b88beaed3d, (v) => $5293b7a3e8573049$export$d619b0b88beaed3d = v);
/**
 *  IMPORTANT
 *  - this code must be nodejs compatible as it is also used in the webpack.config.js
 */ var $5293b7a3e8573049$export$db6a769879aea97b;
var $5293b7a3e8573049$export$4719e2a29dbcb33d;
var $5293b7a3e8573049$export$7ee4e0433d720dea;
var $5293b7a3e8573049$export$d619b0b88beaed3d;
$5293b7a3e8573049$export$db6a769879aea97b = 'ssr.spa.rendered';
/*::
export type JsEvalStart = ':eval-start';
 */ const $5293b7a3e8573049$var$JS_EVAL_START /*:: :JsEvalStart */  = ':eval-start';
$5293b7a3e8573049$export$4719e2a29dbcb33d = $5293b7a3e8573049$var$JS_EVAL_START;
/*::
export type JsEvalStop = ':eval-stop';
 */ const $5293b7a3e8573049$var$JS_EVAL_STOP /*:: :JsEvalStop */  = ':eval-stop';
$5293b7a3e8573049$export$7ee4e0433d720dea = $5293b7a3e8573049$var$JS_EVAL_STOP;
/*::
export type JsEvalApi = '__jsEvalStop';
*/ const $5293b7a3e8573049$var$JS_EVAL_API /*:: :JsEvalApi */  = '__jsEvalStop';
$5293b7a3e8573049$export$d619b0b88beaed3d = $5293b7a3e8573049$var$JS_EVAL_API;

});

parcelRegister("hVEQH", function(module, exports) {
const $d0d77252724a0918$var$getBaseName = (assetPathOrURL /*:: :string */ )=>assetPathOrURL.split('#')[0].split('?')[0].split('/').pop();
/**
 * Given an asset path or URL isolate the basename and remove the chunk hash and cache-bust integer.
 *
 * IMPORTANT
 *  - this algorithm must exactly match the webpack output filename format in webpack.config.js
 *  - this code must be nodejs compatible as it is also used in the webpack.config.js
 */ const $d0d77252724a0918$var$sanitiseAssetName = (isDevelopment /*:: :boolean */ )=>(assetPathOrURL /*:: :string */ )=>{
        const baseName = $d0d77252724a0918$var$getBaseName(assetPathOrURL);
        // we desire "[name.with.dots].[ext]"
        // in debug we expect "[name.with.dots].[ext]"
        // in production we expect "[name.with.dots].[hash].[cache-bust].[ext]"
        const split = baseName.split('.');
        if (split.length === 1) // Inline bundles are only an id
        return split[0];
        // Remove the has section from bundles (penultimate section separated by dots)
        // In the case of shared bundles (e.g. shared.hash.js) this will return 'shared.js'.
        // In the case of runtime bundles (e.g. bundle.runtime.hash.js) this will return 'bundle.runtime.js'.
        // This will cause only the first shared bundle loaded to be tracked.
        // In the short term this is desired to prevent too much noise.
        return [
            ...split.slice(0, -2),
            split[split.length - 1]
        ].join('.');
        return isDevelopment || split.length < 4 ? baseName : [
            ...split.slice(0, -3),
            ...split.slice(-1)
        ].join('.');
    };
module.exports = {
    sanitiseAssetName: $d0d77252724a0918$var$sanitiseAssetName
};

});


parcelRegister("3gZ8E", function(module, exports) {
/* eslint-disable @typescript-eslint/no-require-imports */ // Import polyfills first as a safety-net for the remaining imports

parcelRequire("1VFix");
parcelRequire("aQK2r");





parcelRequire("cdbP5");
parcelRequire("fdDkm");
parcelRequire("926XZ");






parcelRequire("eUaD0");


var $1NIU8 = parcelRequire("1NIU8");
parcelRequire("3bk1b");
var $eKnMP = parcelRequire("eKnMP");


parcelRequire("4QJhg");
// Cause emotion side-effects to persists
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $2e397b8f55169ca9$var$emotionSideEffect = [
    (0, $eKnMP.w),
    (0, $1NIU8.withEmotionCache)
];





















































































































// Need to disable this because this affects how files are bundled together
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $2e397b8f55169ca9$var$lazyImports = ()=>{
    (parcelRequire("3VCQy"));
    (parcelRequire("4FnHr"));
    (parcelRequire("ig36w"));
    (parcelRequire("6rpGm"));
    (parcelRequire("digBm"));
    (parcelRequire("gnQAk"));
    (parcelRequire("j4oe4"));
    (parcelRequire("4tM8k"));
    (parcelRequire("7HHI1"));
    (parcelRequire("37Ewn"));
    (parcelRequire("3PIWb"));
    // rx-js
    (parcelRequire("5CykT"));
    (parcelRequire("7kixv"));
    (parcelRequire("86Sof"));
    (parcelRequire("7lTHy"));
    (parcelRequire("6WhQS"));
    (parcelRequire("2PBDa"));
    (parcelRequire("baP6E"));
    (parcelRequire("1ZbB9"));
    (parcelRequire("1AyD5"));
    (parcelRequire("fu6rs"));
    (parcelRequire("ewPaU"));
    (parcelRequire("7SsGX"));
    (parcelRequire("cBiei"));
    (parcelRequire("klM4K"));
    (parcelRequire("ddfJz"));
    (parcelRequire("eI2tH"));
    (parcelRequire("9BkTq"));
    (parcelRequire("gdMGY"));
    (parcelRequire("1h54Q"));
    (parcelRequire("b0lv4"));
    (parcelRequire("2LfVe"));
    (parcelRequire("lSGp8"));
    (parcelRequire("d5LtT"));
    (parcelRequire("lKkBw"));
    (parcelRequire("c1D7V"));
    (parcelRequire("89McN"));
    (parcelRequire("66TKi"));
    (parcelRequire("bl9yo"));
    (parcelRequire("hnYRz"));
    (parcelRequire("8gLG0"));
    (parcelRequire("lxWa5"));
    (parcelRequire("7La6O"));
    (parcelRequire("jwtXh"));
    (parcelRequire("llumX"));
    (parcelRequire("g9mnH"));
    (parcelRequire("cD36E"));
    (parcelRequire("9HP3D"));
    (parcelRequire("8yIb3"));
    (parcelRequire("4EpK9"));
    (parcelRequire("1o2WJ"));
    (parcelRequire("6vF9h"));
    (parcelRequire("9Zsih"));
    (parcelRequire("2nN4w"));
    (parcelRequire("6cJUr"));
    (parcelRequire("8NvnU"));
    (parcelRequire("728CS"));
    (parcelRequire("iTiPP"));
    (parcelRequire("fUV9F"));
    (parcelRequire("ku0B3"));
    (parcelRequire("WcBYl"));
    (parcelRequire("lVRem"));
    (parcelRequire("hwyCA"));
    (parcelRequire("8rm0O"));
    (parcelRequire("d2zWP"));
    (parcelRequire("lf3vd"));
    (parcelRequire("ggmnc"));
    (parcelRequire("3Cpp3"));
    (parcelRequire("hfuHK"));
    (parcelRequire("gLxvt"));
    (parcelRequire("iyrwU"));
    (parcelRequire("7R7AG"));
    (parcelRequire("e3Wji"));
    (parcelRequire("iq68j"));
    (parcelRequire("9YWW5"));
    (parcelRequire("fBRVr"));
    (parcelRequire("iUwYT"));
    (parcelRequire("588Ya"));
    (parcelRequire("8obMu"));
    (parcelRequire("baLi5"));
    (parcelRequire("ejMUB"));
    (parcelRequire("h7WWX"));
    (parcelRequire("aXWgk"));
    (parcelRequire("ajQYh"));
    (parcelRequire("4z1SV"));
    (parcelRequire("7X9Es"));
    (parcelRequire("ioQbZ"));
    (parcelRequire("fpytS"));
    (parcelRequire("fU3mt"));
    (parcelRequire("cdN8w"));
    (parcelRequire("9HPbl"));
    (parcelRequire("9cPse"));
    (parcelRequire("9lW7X"));
    (parcelRequire("hoLUM"));
    (parcelRequire("jjQ5U"));
    (parcelRequire("4NFCE"));
    (parcelRequire("2ihZk"));
    (parcelRequire("aoje7"));
    (parcelRequire("hXhYX"));
    (parcelRequire("5yRpn"));
    (parcelRequire("4pIMA"));
    (parcelRequire("cepOA"));
    (parcelRequire("8m4JC"));
    (parcelRequire("d8PvE"));
    (parcelRequire("iJxyv"));
    (parcelRequire("jgg04"));
    (parcelRequire("i7QJ5"));
    (parcelRequire("kWDbL"));
    (parcelRequire("iq7pX"));
    (parcelRequire("4yGtN"));
    (parcelRequire("4Chqh"));
    (parcelRequire("jgII5"));
    (parcelRequire("dfP4l"));
    (parcelRequire("8OIuA"));
    (parcelRequire("bcmDP"));
    (parcelRequire("7LUj8"));
    (parcelRequire("kAhK4"));
};

});
parcelRegister("1VFix", function(module, exports) {
parcelRequire("3hMCP");
parcelRequire("c0kTV");
parcelRequire("8XHS6");
parcelRequire("3qHDe");

});
parcelRegister("3hMCP", function(module, exports) {

var $eJOHy = parcelRequire("eJOHy");
/**
 * we inject React as a global to support libraries that expect it to be available globally,
 * for example cases when classic jsx transform was used where modern one was expected
 */ globalThis.React = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy)));

});
parcelRegister("eJOHy", function(module, exports) {
'use strict';

module.exports = (parcelRequire("jK9Ql"));

});
parcelRegister("jK9Ql", function(module, exports) {
$parcel$export(module.exports, "Children", () => $e5f9f2e40c2edd6e$export$dca3b0875bd9a954, (v) => $e5f9f2e40c2edd6e$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $e5f9f2e40c2edd6e$export$16fa2f45be04daa8, (v) => $e5f9f2e40c2edd6e$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $e5f9f2e40c2edd6e$export$ffb0004e005737fa, (v) => $e5f9f2e40c2edd6e$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $e5f9f2e40c2edd6e$export$e2c29f18771995cb, (v) => $e5f9f2e40c2edd6e$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $e5f9f2e40c2edd6e$export$221d75b3f55bb0bd, (v) => $e5f9f2e40c2edd6e$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $e5f9f2e40c2edd6e$export$5f8d39834fd61797, (v) => $e5f9f2e40c2edd6e$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $e5f9f2e40c2edd6e$export$74bf444e3cd11ea5, (v) => $e5f9f2e40c2edd6e$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $e5f9f2e40c2edd6e$export$ae55be85d98224ed, (v) => $e5f9f2e40c2edd6e$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "act", () => $e5f9f2e40c2edd6e$export$3ba232387fd5d6dd, (v) => $e5f9f2e40c2edd6e$export$3ba232387fd5d6dd = v);
$parcel$export(module.exports, "cloneElement", () => $e5f9f2e40c2edd6e$export$e530037191fcd5d7, (v) => $e5f9f2e40c2edd6e$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $e5f9f2e40c2edd6e$export$fd42f52fd3ae1109, (v) => $e5f9f2e40c2edd6e$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $e5f9f2e40c2edd6e$export$c8a8987d4410bf2d, (v) => $e5f9f2e40c2edd6e$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $e5f9f2e40c2edd6e$export$d38cd72104c1f0e9, (v) => $e5f9f2e40c2edd6e$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $e5f9f2e40c2edd6e$export$7d1e3a5e95ceca43, (v) => $e5f9f2e40c2edd6e$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $e5f9f2e40c2edd6e$export$257a8862b851cb5b, (v) => $e5f9f2e40c2edd6e$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $e5f9f2e40c2edd6e$export$a8257692ac88316c, (v) => $e5f9f2e40c2edd6e$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $e5f9f2e40c2edd6e$export$488013bae63b21da, (v) => $e5f9f2e40c2edd6e$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $e5f9f2e40c2edd6e$export$7c73462e0d25e514, (v) => $e5f9f2e40c2edd6e$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $e5f9f2e40c2edd6e$export$7568632d0d33d16d, (v) => $e5f9f2e40c2edd6e$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $e5f9f2e40c2edd6e$export$88948ce120ea2619, (v) => $e5f9f2e40c2edd6e$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $e5f9f2e40c2edd6e$export$35808ee640e87ca7, (v) => $e5f9f2e40c2edd6e$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $e5f9f2e40c2edd6e$export$fae74005e78b1a27, (v) => $e5f9f2e40c2edd6e$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $e5f9f2e40c2edd6e$export$dc8fbce3eb94dc1e, (v) => $e5f9f2e40c2edd6e$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $e5f9f2e40c2edd6e$export$6a7bc4e911dc01cf, (v) => $e5f9f2e40c2edd6e$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $e5f9f2e40c2edd6e$export$6d9c69b0de29b591, (v) => $e5f9f2e40c2edd6e$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $e5f9f2e40c2edd6e$export$f680877a34711e37, (v) => $e5f9f2e40c2edd6e$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $e5f9f2e40c2edd6e$export$d5a552a76deda3c2, (v) => $e5f9f2e40c2edd6e$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $e5f9f2e40c2edd6e$export$aaabe4eda9ed9969, (v) => $e5f9f2e40c2edd6e$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $e5f9f2e40c2edd6e$export$e5c5a5f917a5871c, (v) => $e5f9f2e40c2edd6e$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $e5f9f2e40c2edd6e$export$1538c33de8887b59, (v) => $e5f9f2e40c2edd6e$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $e5f9f2e40c2edd6e$export$13e3392192263954, (v) => $e5f9f2e40c2edd6e$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $e5f9f2e40c2edd6e$export$b8f5890fc79d6aca, (v) => $e5f9f2e40c2edd6e$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $e5f9f2e40c2edd6e$export$60241385465d0a34, (v) => $e5f9f2e40c2edd6e$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $e5f9f2e40c2edd6e$export$306c0aa65ff9ec16, (v) => $e5f9f2e40c2edd6e$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $e5f9f2e40c2edd6e$export$7b286972b8d8ccbf, (v) => $e5f9f2e40c2edd6e$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $e5f9f2e40c2edd6e$export$83d89fbfd8236492, (v) => $e5f9f2e40c2edd6e$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $e5f9f2e40c2edd6e$export$dca3b0875bd9a954;
var $e5f9f2e40c2edd6e$export$16fa2f45be04daa8;
var $e5f9f2e40c2edd6e$export$ffb0004e005737fa;
var $e5f9f2e40c2edd6e$export$e2c29f18771995cb;
var $e5f9f2e40c2edd6e$export$221d75b3f55bb0bd;
var $e5f9f2e40c2edd6e$export$5f8d39834fd61797;
var $e5f9f2e40c2edd6e$export$74bf444e3cd11ea5;
var $e5f9f2e40c2edd6e$export$ae55be85d98224ed;
var $e5f9f2e40c2edd6e$export$3ba232387fd5d6dd;
var $e5f9f2e40c2edd6e$export$e530037191fcd5d7;
var $e5f9f2e40c2edd6e$export$fd42f52fd3ae1109;
var $e5f9f2e40c2edd6e$export$c8a8987d4410bf2d;
var $e5f9f2e40c2edd6e$export$d38cd72104c1f0e9;
var $e5f9f2e40c2edd6e$export$7d1e3a5e95ceca43;
var $e5f9f2e40c2edd6e$export$257a8862b851cb5b;
var $e5f9f2e40c2edd6e$export$a8257692ac88316c;
var $e5f9f2e40c2edd6e$export$488013bae63b21da;
var $e5f9f2e40c2edd6e$export$7c73462e0d25e514;
var $e5f9f2e40c2edd6e$export$7568632d0d33d16d;
var $e5f9f2e40c2edd6e$export$88948ce120ea2619;
var $e5f9f2e40c2edd6e$export$35808ee640e87ca7;
var $e5f9f2e40c2edd6e$export$fae74005e78b1a27;
var $e5f9f2e40c2edd6e$export$dc8fbce3eb94dc1e;
var $e5f9f2e40c2edd6e$export$6a7bc4e911dc01cf;
var $e5f9f2e40c2edd6e$export$6d9c69b0de29b591;
var $e5f9f2e40c2edd6e$export$f680877a34711e37;
var $e5f9f2e40c2edd6e$export$d5a552a76deda3c2;
var $e5f9f2e40c2edd6e$export$aaabe4eda9ed9969;
var $e5f9f2e40c2edd6e$export$e5c5a5f917a5871c;
var $e5f9f2e40c2edd6e$export$1538c33de8887b59;
var $e5f9f2e40c2edd6e$export$13e3392192263954;
var $e5f9f2e40c2edd6e$export$b8f5890fc79d6aca;
var $e5f9f2e40c2edd6e$export$60241385465d0a34;
var $e5f9f2e40c2edd6e$export$306c0aa65ff9ec16;
var $e5f9f2e40c2edd6e$export$7b286972b8d8ccbf;
var $e5f9f2e40c2edd6e$export$83d89fbfd8236492;
'use strict';
var $e5f9f2e40c2edd6e$var$l = Symbol.for("react.element"), $e5f9f2e40c2edd6e$var$n = Symbol.for("react.portal"), $e5f9f2e40c2edd6e$var$p = Symbol.for("react.fragment"), $e5f9f2e40c2edd6e$var$q = Symbol.for("react.strict_mode"), $e5f9f2e40c2edd6e$var$r = Symbol.for("react.profiler"), $e5f9f2e40c2edd6e$var$t = Symbol.for("react.provider"), $e5f9f2e40c2edd6e$var$u = Symbol.for("react.context"), $e5f9f2e40c2edd6e$var$v = Symbol.for("react.forward_ref"), $e5f9f2e40c2edd6e$var$w = Symbol.for("react.suspense"), $e5f9f2e40c2edd6e$var$x = Symbol.for("react.memo"), $e5f9f2e40c2edd6e$var$y = Symbol.for("react.lazy"), $e5f9f2e40c2edd6e$var$z = Symbol.iterator;
function $e5f9f2e40c2edd6e$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $e5f9f2e40c2edd6e$var$z && a[$e5f9f2e40c2edd6e$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $e5f9f2e40c2edd6e$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $e5f9f2e40c2edd6e$var$C = Object.assign, $e5f9f2e40c2edd6e$var$D = {};
function $e5f9f2e40c2edd6e$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $e5f9f2e40c2edd6e$var$D;
    this.updater = e || $e5f9f2e40c2edd6e$var$B;
}
$e5f9f2e40c2edd6e$var$E.prototype.isReactComponent = {};
$e5f9f2e40c2edd6e$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$e5f9f2e40c2edd6e$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $e5f9f2e40c2edd6e$var$F() {}
$e5f9f2e40c2edd6e$var$F.prototype = $e5f9f2e40c2edd6e$var$E.prototype;
function $e5f9f2e40c2edd6e$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $e5f9f2e40c2edd6e$var$D;
    this.updater = e || $e5f9f2e40c2edd6e$var$B;
}
var $e5f9f2e40c2edd6e$var$H = $e5f9f2e40c2edd6e$var$G.prototype = new $e5f9f2e40c2edd6e$var$F;
$e5f9f2e40c2edd6e$var$H.constructor = $e5f9f2e40c2edd6e$var$G;
$e5f9f2e40c2edd6e$var$C($e5f9f2e40c2edd6e$var$H, $e5f9f2e40c2edd6e$var$E.prototype);
$e5f9f2e40c2edd6e$var$H.isPureReactComponent = !0;
var $e5f9f2e40c2edd6e$var$I = Array.isArray, $e5f9f2e40c2edd6e$var$J = Object.prototype.hasOwnProperty, $e5f9f2e40c2edd6e$var$K = {
    current: null
}, $e5f9f2e40c2edd6e$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $e5f9f2e40c2edd6e$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$e5f9f2e40c2edd6e$var$J.call(b, d) && !$e5f9f2e40c2edd6e$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $e5f9f2e40c2edd6e$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $e5f9f2e40c2edd6e$var$K.current
    };
}
function $e5f9f2e40c2edd6e$var$N(a, b) {
    return {
        $$typeof: $e5f9f2e40c2edd6e$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $e5f9f2e40c2edd6e$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $e5f9f2e40c2edd6e$var$l;
}
function $e5f9f2e40c2edd6e$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $e5f9f2e40c2edd6e$var$P = /\/+/g;
function $e5f9f2e40c2edd6e$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $e5f9f2e40c2edd6e$var$escape("" + a.key) : b.toString(36);
}
function $e5f9f2e40c2edd6e$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $e5f9f2e40c2edd6e$var$l:
                case $e5f9f2e40c2edd6e$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $e5f9f2e40c2edd6e$var$Q(h, 0) : d, $e5f9f2e40c2edd6e$var$I(c) ? (e = "", null != a && (e = a.replace($e5f9f2e40c2edd6e$var$P, "$&/") + "/"), $e5f9f2e40c2edd6e$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($e5f9f2e40c2edd6e$var$O(c) && (c = $e5f9f2e40c2edd6e$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($e5f9f2e40c2edd6e$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($e5f9f2e40c2edd6e$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $e5f9f2e40c2edd6e$var$Q(k, g);
        h += $e5f9f2e40c2edd6e$var$R(k, b, e, f, c);
    }
    else if (f = $e5f9f2e40c2edd6e$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $e5f9f2e40c2edd6e$var$Q(k, g++), h += $e5f9f2e40c2edd6e$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $e5f9f2e40c2edd6e$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $e5f9f2e40c2edd6e$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $e5f9f2e40c2edd6e$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $e5f9f2e40c2edd6e$var$U = {
    current: null
}, $e5f9f2e40c2edd6e$var$V = {
    transition: null
}, $e5f9f2e40c2edd6e$var$W = {
    ReactCurrentDispatcher: $e5f9f2e40c2edd6e$var$U,
    ReactCurrentBatchConfig: $e5f9f2e40c2edd6e$var$V,
    ReactCurrentOwner: $e5f9f2e40c2edd6e$var$K
};
function $e5f9f2e40c2edd6e$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$e5f9f2e40c2edd6e$export$dca3b0875bd9a954 = {
    map: $e5f9f2e40c2edd6e$var$S,
    forEach: function(a, b, e) {
        $e5f9f2e40c2edd6e$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $e5f9f2e40c2edd6e$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $e5f9f2e40c2edd6e$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$e5f9f2e40c2edd6e$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$e5f9f2e40c2edd6e$export$16fa2f45be04daa8 = $e5f9f2e40c2edd6e$var$E;
$e5f9f2e40c2edd6e$export$ffb0004e005737fa = $e5f9f2e40c2edd6e$var$p;
$e5f9f2e40c2edd6e$export$e2c29f18771995cb = $e5f9f2e40c2edd6e$var$r;
$e5f9f2e40c2edd6e$export$221d75b3f55bb0bd = $e5f9f2e40c2edd6e$var$G;
$e5f9f2e40c2edd6e$export$5f8d39834fd61797 = $e5f9f2e40c2edd6e$var$q;
$e5f9f2e40c2edd6e$export$74bf444e3cd11ea5 = $e5f9f2e40c2edd6e$var$w;
$e5f9f2e40c2edd6e$export$ae55be85d98224ed = $e5f9f2e40c2edd6e$var$W;
$e5f9f2e40c2edd6e$export$3ba232387fd5d6dd = $e5f9f2e40c2edd6e$var$X;
$e5f9f2e40c2edd6e$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $e5f9f2e40c2edd6e$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $e5f9f2e40c2edd6e$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$e5f9f2e40c2edd6e$var$J.call(b, f) && !$e5f9f2e40c2edd6e$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $e5f9f2e40c2edd6e$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$e5f9f2e40c2edd6e$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $e5f9f2e40c2edd6e$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $e5f9f2e40c2edd6e$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$e5f9f2e40c2edd6e$export$c8a8987d4410bf2d = $e5f9f2e40c2edd6e$var$M;
$e5f9f2e40c2edd6e$export$d38cd72104c1f0e9 = function(a) {
    var b = $e5f9f2e40c2edd6e$var$M.bind(null, a);
    b.type = a;
    return b;
};
$e5f9f2e40c2edd6e$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$e5f9f2e40c2edd6e$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $e5f9f2e40c2edd6e$var$v,
        render: a
    };
};
$e5f9f2e40c2edd6e$export$a8257692ac88316c = $e5f9f2e40c2edd6e$var$O;
$e5f9f2e40c2edd6e$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $e5f9f2e40c2edd6e$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $e5f9f2e40c2edd6e$var$T
    };
};
$e5f9f2e40c2edd6e$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $e5f9f2e40c2edd6e$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$e5f9f2e40c2edd6e$export$7568632d0d33d16d = function(a) {
    var b = $e5f9f2e40c2edd6e$var$V.transition;
    $e5f9f2e40c2edd6e$var$V.transition = {};
    try {
        a();
    } finally{
        $e5f9f2e40c2edd6e$var$V.transition = b;
    }
};
$e5f9f2e40c2edd6e$export$88948ce120ea2619 = $e5f9f2e40c2edd6e$var$X;
$e5f9f2e40c2edd6e$export$35808ee640e87ca7 = function(a, b) {
    return $e5f9f2e40c2edd6e$var$U.current.useCallback(a, b);
};
$e5f9f2e40c2edd6e$export$fae74005e78b1a27 = function(a) {
    return $e5f9f2e40c2edd6e$var$U.current.useContext(a);
};
$e5f9f2e40c2edd6e$export$dc8fbce3eb94dc1e = function() {};
$e5f9f2e40c2edd6e$export$6a7bc4e911dc01cf = function(a) {
    return $e5f9f2e40c2edd6e$var$U.current.useDeferredValue(a);
};
$e5f9f2e40c2edd6e$export$6d9c69b0de29b591 = function(a, b) {
    return $e5f9f2e40c2edd6e$var$U.current.useEffect(a, b);
};
$e5f9f2e40c2edd6e$export$f680877a34711e37 = function() {
    return $e5f9f2e40c2edd6e$var$U.current.useId();
};
$e5f9f2e40c2edd6e$export$d5a552a76deda3c2 = function(a, b, e) {
    return $e5f9f2e40c2edd6e$var$U.current.useImperativeHandle(a, b, e);
};
$e5f9f2e40c2edd6e$export$aaabe4eda9ed9969 = function(a, b) {
    return $e5f9f2e40c2edd6e$var$U.current.useInsertionEffect(a, b);
};
$e5f9f2e40c2edd6e$export$e5c5a5f917a5871c = function(a, b) {
    return $e5f9f2e40c2edd6e$var$U.current.useLayoutEffect(a, b);
};
$e5f9f2e40c2edd6e$export$1538c33de8887b59 = function(a, b) {
    return $e5f9f2e40c2edd6e$var$U.current.useMemo(a, b);
};
$e5f9f2e40c2edd6e$export$13e3392192263954 = function(a, b, e) {
    return $e5f9f2e40c2edd6e$var$U.current.useReducer(a, b, e);
};
$e5f9f2e40c2edd6e$export$b8f5890fc79d6aca = function(a) {
    return $e5f9f2e40c2edd6e$var$U.current.useRef(a);
};
$e5f9f2e40c2edd6e$export$60241385465d0a34 = function(a) {
    return $e5f9f2e40c2edd6e$var$U.current.useState(a);
};
$e5f9f2e40c2edd6e$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $e5f9f2e40c2edd6e$var$U.current.useSyncExternalStore(a, b, e);
};
$e5f9f2e40c2edd6e$export$7b286972b8d8ccbf = function() {
    return $e5f9f2e40c2edd6e$var$U.current.useTransition();
};
$e5f9f2e40c2edd6e$export$83d89fbfd8236492 = "18.3.1";

});



parcelRegister("c0kTV", function(module, exports) {
parcelRequire("eJOHy");

});

parcelRegister("8XHS6", function(module, exports) {

});

parcelRegister("3qHDe", function(module, exports) {
/* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * @fileOverview this is a temporal file to support hydration rollout in Jira
 * It will be removed once the rollout is complete
 */ 
var $eJOHy = parcelRequire("eJOHy");
if (typeof window !== 'undefined') {
    const altFlags = new URLSearchParams(window.location.search).get('alt-flags');
    // `no-effects` flag disables all useEffect and useLayoutEffect calls
    // making Jira "static"
    if (altFlags?.includes('no-effects')) {
        // Disable useEffect calls to allow hydration to focus on Structure only
        // eslint-disable-next-line @atlassian/tangerine/import/no-implicit-imports,@typescript-eslint/no-empty-function
        (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useEffect = ()=>{};
        // eslint-disable-next-line @atlassian/tangerine/import/no-implicit-imports,@typescript-eslint/no-empty-function
        (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useLayoutEffect = ()=>{};
        // eslint-disable-next-line no-console
        console.warn("\u26D4\uFE0F React.useEffect is disabled \u26D4\uFE0F");
    }
    // `memo-all` flags causes all components to be wrapped in React.memo
    // React compiler without using compiler
    if (altFlags?.includes('memo-all')) {
        // eslint-disable-next-line @atlassian/tangerine/import/no-implicit-imports
        const originalCreateElement = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement;
        const componentMapping = new Map();
        // eslint-disable-next-line @atlassian/tangerine/import/no-implicit-imports
        (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement = (type, ...args)=>{
            // delegate incorrect or plain components
            if (!type || typeof type === 'string') return originalCreateElement(type, ...args);
            // do not handle Class components
            if (type.prototype && (Object.prototype.isPrototypeOf.call((0, $eJOHy.Component).prototype, type.prototype) || type.prototype.isReactComponent || // with support for React 14(!) components still being in use
            type.prototype.render)) return originalCreateElement(type, ...args);
            if (typeof type === 'function' || typeof type === 'object') {
                let standin = componentMapping.get(type);
                // for every function generate a standin to preserve req equality
                // this is not required for "single pass" render to string, but is a must-have to renderToStream
                if (!standin) {
                    standin = /*#__PURE__*/ (0, $eJOHy.memo)(type);
                    componentMapping.set(type, standin);
                }
                return originalCreateElement(standin, ...args);
            }
            return originalCreateElement(type, ...args);
        };
    }
}

});


parcelRegister("aQK2r", function(module, exports) {
'use strict';
function $7e6278f9fb6c6847$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($7e6278f9fb6c6847$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$7e6278f9fb6c6847$var$checkDCE();

module.exports = (parcelRequire("40lRD"));

});
parcelRegister("40lRD", function(module, exports) {
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $2ea81f475bdaffaf$export$ae55be85d98224ed, (v) => $2ea81f475bdaffaf$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $2ea81f475bdaffaf$export$d39a5bbd09211389, (v) => $2ea81f475bdaffaf$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $2ea81f475bdaffaf$export$882461b6382ed46c, (v) => $2ea81f475bdaffaf$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $2ea81f475bdaffaf$export$466bfc07425424d5, (v) => $2ea81f475bdaffaf$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $2ea81f475bdaffaf$export$cd75ccfd720a3cd4, (v) => $2ea81f475bdaffaf$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $2ea81f475bdaffaf$export$fa8d919ba61d84db, (v) => $2ea81f475bdaffaf$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $2ea81f475bdaffaf$export$757ceba2d55c277e, (v) => $2ea81f475bdaffaf$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $2ea81f475bdaffaf$export$b3890eb0ae9dca99, (v) => $2ea81f475bdaffaf$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $2ea81f475bdaffaf$export$502457920280e6be, (v) => $2ea81f475bdaffaf$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $2ea81f475bdaffaf$export$c78a37762a8d58e1, (v) => $2ea81f475bdaffaf$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $2ea81f475bdaffaf$export$dc54d992c10e8a18, (v) => $2ea81f475bdaffaf$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $2ea81f475bdaffaf$export$83d89fbfd8236492, (v) => $2ea81f475bdaffaf$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.profiling.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $2ea81f475bdaffaf$export$ae55be85d98224ed;
var $2ea81f475bdaffaf$export$d39a5bbd09211389;
var $2ea81f475bdaffaf$export$882461b6382ed46c;
var $2ea81f475bdaffaf$export$466bfc07425424d5;
var $2ea81f475bdaffaf$export$cd75ccfd720a3cd4;
var $2ea81f475bdaffaf$export$fa8d919ba61d84db;
var $2ea81f475bdaffaf$export$757ceba2d55c277e;
var $2ea81f475bdaffaf$export$b3890eb0ae9dca99;
var $2ea81f475bdaffaf$export$502457920280e6be;
var $2ea81f475bdaffaf$export$c78a37762a8d58e1;
var $2ea81f475bdaffaf$export$dc54d992c10e8a18;
var $2ea81f475bdaffaf$export$83d89fbfd8236492;
'use strict';
/* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart === 'function') __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ 'use strict';

var $eJOHy = parcelRequire("eJOHy");

var $jbhXM = parcelRequire("jbhXM");
function $2ea81f475bdaffaf$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $2ea81f475bdaffaf$var$da = new Set, $2ea81f475bdaffaf$var$ea = {};
function $2ea81f475bdaffaf$var$fa(a, b) {
    $2ea81f475bdaffaf$var$ha(a, b);
    $2ea81f475bdaffaf$var$ha(a + "Capture", b);
}
function $2ea81f475bdaffaf$var$ha(a, b) {
    $2ea81f475bdaffaf$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$2ea81f475bdaffaf$var$da.add(b[a]);
}
var $2ea81f475bdaffaf$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $2ea81f475bdaffaf$var$ja = Object.prototype.hasOwnProperty, $2ea81f475bdaffaf$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $2ea81f475bdaffaf$var$la = {}, $2ea81f475bdaffaf$var$ma = {};
function $2ea81f475bdaffaf$var$na(a) {
    if ($2ea81f475bdaffaf$var$ja.call($2ea81f475bdaffaf$var$ma, a)) return !0;
    if ($2ea81f475bdaffaf$var$ja.call($2ea81f475bdaffaf$var$la, a)) return !1;
    if ($2ea81f475bdaffaf$var$ka.test(a)) return $2ea81f475bdaffaf$var$ma[a] = !0;
    $2ea81f475bdaffaf$var$la[a] = !0;
    return !1;
}
function $2ea81f475bdaffaf$var$oa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $2ea81f475bdaffaf$var$pa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $2ea81f475bdaffaf$var$oa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $2ea81f475bdaffaf$var$qa(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $2ea81f475bdaffaf$var$t = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $2ea81f475bdaffaf$var$t[a] = new $2ea81f475bdaffaf$var$qa(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $2ea81f475bdaffaf$var$t[b] = new $2ea81f475bdaffaf$var$qa(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $2ea81f475bdaffaf$var$t[a] = new $2ea81f475bdaffaf$var$qa(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $2ea81f475bdaffaf$var$t[a] = new $2ea81f475bdaffaf$var$qa(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $2ea81f475bdaffaf$var$t[a] = new $2ea81f475bdaffaf$var$qa(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $2ea81f475bdaffaf$var$t[a] = new $2ea81f475bdaffaf$var$qa(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $2ea81f475bdaffaf$var$t[a] = new $2ea81f475bdaffaf$var$qa(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $2ea81f475bdaffaf$var$t[a] = new $2ea81f475bdaffaf$var$qa(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $2ea81f475bdaffaf$var$t[a] = new $2ea81f475bdaffaf$var$qa(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $2ea81f475bdaffaf$var$ra = /[\-:]([a-z])/g;
function $2ea81f475bdaffaf$var$ta(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($2ea81f475bdaffaf$var$ra, $2ea81f475bdaffaf$var$ta);
    $2ea81f475bdaffaf$var$t[b] = new $2ea81f475bdaffaf$var$qa(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($2ea81f475bdaffaf$var$ra, $2ea81f475bdaffaf$var$ta);
    $2ea81f475bdaffaf$var$t[b] = new $2ea81f475bdaffaf$var$qa(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($2ea81f475bdaffaf$var$ra, $2ea81f475bdaffaf$var$ta);
    $2ea81f475bdaffaf$var$t[b] = new $2ea81f475bdaffaf$var$qa(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $2ea81f475bdaffaf$var$t[a] = new $2ea81f475bdaffaf$var$qa(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$2ea81f475bdaffaf$var$t.xlinkHref = new $2ea81f475bdaffaf$var$qa("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $2ea81f475bdaffaf$var$t[a] = new $2ea81f475bdaffaf$var$qa(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $2ea81f475bdaffaf$var$ua(a, b, c, d) {
    var e = $2ea81f475bdaffaf$var$t.hasOwnProperty(b) ? $2ea81f475bdaffaf$var$t[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $2ea81f475bdaffaf$var$pa(b, c, e, d) && (c = null), d || null === e ? $2ea81f475bdaffaf$var$na(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $2ea81f475bdaffaf$var$va = $eJOHy.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $2ea81f475bdaffaf$var$wa = Symbol.for("react.element"), $2ea81f475bdaffaf$var$xa = Symbol.for("react.portal"), $2ea81f475bdaffaf$var$ya = Symbol.for("react.fragment"), $2ea81f475bdaffaf$var$za = Symbol.for("react.strict_mode"), $2ea81f475bdaffaf$var$Aa = Symbol.for("react.profiler"), $2ea81f475bdaffaf$var$Ba = Symbol.for("react.provider"), $2ea81f475bdaffaf$var$Ca = Symbol.for("react.context"), $2ea81f475bdaffaf$var$Da = Symbol.for("react.forward_ref"), $2ea81f475bdaffaf$var$Ea = Symbol.for("react.suspense"), $2ea81f475bdaffaf$var$Fa = Symbol.for("react.suspense_list"), $2ea81f475bdaffaf$var$Ga = Symbol.for("react.memo"), $2ea81f475bdaffaf$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $2ea81f475bdaffaf$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $2ea81f475bdaffaf$var$Ja = Symbol.iterator;
function $2ea81f475bdaffaf$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $2ea81f475bdaffaf$var$Ja && a[$2ea81f475bdaffaf$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $2ea81f475bdaffaf$var$u = Object.assign, $2ea81f475bdaffaf$var$La;
function $2ea81f475bdaffaf$var$Ma(a) {
    if (void 0 === $2ea81f475bdaffaf$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $2ea81f475bdaffaf$var$La = b && b[1] || "";
    }
    return "\n" + $2ea81f475bdaffaf$var$La + a;
}
var $2ea81f475bdaffaf$var$Na = !1;
function $2ea81f475bdaffaf$var$Oa(a, b) {
    if (!a || $2ea81f475bdaffaf$var$Na) return "";
    $2ea81f475bdaffaf$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $2ea81f475bdaffaf$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $2ea81f475bdaffaf$var$Ma(a) : "";
}
function $2ea81f475bdaffaf$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $2ea81f475bdaffaf$var$Ma(a.type);
        case 16:
            return $2ea81f475bdaffaf$var$Ma("Lazy");
        case 13:
            return $2ea81f475bdaffaf$var$Ma("Suspense");
        case 19:
            return $2ea81f475bdaffaf$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $2ea81f475bdaffaf$var$Oa(a.type, !1), a;
        case 11:
            return a = $2ea81f475bdaffaf$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $2ea81f475bdaffaf$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $2ea81f475bdaffaf$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $2ea81f475bdaffaf$var$ya:
            return "Fragment";
        case $2ea81f475bdaffaf$var$xa:
            return "Portal";
        case $2ea81f475bdaffaf$var$Aa:
            return "Profiler";
        case $2ea81f475bdaffaf$var$za:
            return "StrictMode";
        case $2ea81f475bdaffaf$var$Ea:
            return "Suspense";
        case $2ea81f475bdaffaf$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $2ea81f475bdaffaf$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $2ea81f475bdaffaf$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $2ea81f475bdaffaf$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $2ea81f475bdaffaf$var$Ga:
            return b = a.displayName || null, null !== b ? b : $2ea81f475bdaffaf$var$Qa(a.type) || "Memo";
        case $2ea81f475bdaffaf$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $2ea81f475bdaffaf$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $2ea81f475bdaffaf$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $2ea81f475bdaffaf$var$Qa(b);
        case 8:
            return b === $2ea81f475bdaffaf$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $2ea81f475bdaffaf$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $2ea81f475bdaffaf$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $2ea81f475bdaffaf$var$Ua(a) {
    var b = $2ea81f475bdaffaf$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $2ea81f475bdaffaf$var$Va(a) {
    a._valueTracker || (a._valueTracker = $2ea81f475bdaffaf$var$Ua(a));
}
function $2ea81f475bdaffaf$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $2ea81f475bdaffaf$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $2ea81f475bdaffaf$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $2ea81f475bdaffaf$var$Ya(a, b) {
    var c = b.checked;
    return $2ea81f475bdaffaf$var$u({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $2ea81f475bdaffaf$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $2ea81f475bdaffaf$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $2ea81f475bdaffaf$var$$a(a, b) {
    b = b.checked;
    null != b && $2ea81f475bdaffaf$var$ua(a, "checked", b, !1);
}
function $2ea81f475bdaffaf$var$ab(a, b) {
    $2ea81f475bdaffaf$var$$a(a, b);
    var c = $2ea81f475bdaffaf$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $2ea81f475bdaffaf$var$bb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $2ea81f475bdaffaf$var$bb(a, b.type, $2ea81f475bdaffaf$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $2ea81f475bdaffaf$var$cb(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $2ea81f475bdaffaf$var$bb(a, b, c) {
    if ("number" !== b || $2ea81f475bdaffaf$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $2ea81f475bdaffaf$var$db = Array.isArray;
function $2ea81f475bdaffaf$var$eb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $2ea81f475bdaffaf$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $2ea81f475bdaffaf$var$fb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($2ea81f475bdaffaf$var$p(91));
    return $2ea81f475bdaffaf$var$u({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $2ea81f475bdaffaf$var$gb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($2ea81f475bdaffaf$var$p(92));
            if ($2ea81f475bdaffaf$var$db(c)) {
                if (1 < c.length) throw Error($2ea81f475bdaffaf$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $2ea81f475bdaffaf$var$Sa(c)
    };
}
function $2ea81f475bdaffaf$var$hb(a, b) {
    var c = $2ea81f475bdaffaf$var$Sa(b.value), d = $2ea81f475bdaffaf$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $2ea81f475bdaffaf$var$ib(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $2ea81f475bdaffaf$var$jb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $2ea81f475bdaffaf$var$kb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $2ea81f475bdaffaf$var$jb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $2ea81f475bdaffaf$var$mb, $2ea81f475bdaffaf$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $2ea81f475bdaffaf$var$mb = $2ea81f475bdaffaf$var$mb || document.createElement("div");
        $2ea81f475bdaffaf$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $2ea81f475bdaffaf$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $2ea81f475bdaffaf$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $2ea81f475bdaffaf$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $2ea81f475bdaffaf$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($2ea81f475bdaffaf$var$pb).forEach(function(a) {
    $2ea81f475bdaffaf$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $2ea81f475bdaffaf$var$pb[b] = $2ea81f475bdaffaf$var$pb[a];
    });
});
function $2ea81f475bdaffaf$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $2ea81f475bdaffaf$var$pb.hasOwnProperty(a) && $2ea81f475bdaffaf$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $2ea81f475bdaffaf$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $2ea81f475bdaffaf$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $2ea81f475bdaffaf$var$tb = $2ea81f475bdaffaf$var$u({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $2ea81f475bdaffaf$var$ub(a, b) {
    if (b) {
        if ($2ea81f475bdaffaf$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($2ea81f475bdaffaf$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($2ea81f475bdaffaf$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($2ea81f475bdaffaf$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($2ea81f475bdaffaf$var$p(62));
    }
}
function $2ea81f475bdaffaf$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $2ea81f475bdaffaf$var$wb = null;
function $2ea81f475bdaffaf$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $2ea81f475bdaffaf$var$yb = null, $2ea81f475bdaffaf$var$zb = null, $2ea81f475bdaffaf$var$Ab = null;
function $2ea81f475bdaffaf$var$Bb(a) {
    if (a = $2ea81f475bdaffaf$var$Cb(a)) {
        if ("function" !== typeof $2ea81f475bdaffaf$var$yb) throw Error($2ea81f475bdaffaf$var$p(280));
        var b = a.stateNode;
        b && (b = $2ea81f475bdaffaf$var$Db(b), $2ea81f475bdaffaf$var$yb(a.stateNode, a.type, b));
    }
}
function $2ea81f475bdaffaf$var$Eb(a) {
    $2ea81f475bdaffaf$var$zb ? $2ea81f475bdaffaf$var$Ab ? $2ea81f475bdaffaf$var$Ab.push(a) : $2ea81f475bdaffaf$var$Ab = [
        a
    ] : $2ea81f475bdaffaf$var$zb = a;
}
function $2ea81f475bdaffaf$var$Fb() {
    if ($2ea81f475bdaffaf$var$zb) {
        var a = $2ea81f475bdaffaf$var$zb, b = $2ea81f475bdaffaf$var$Ab;
        $2ea81f475bdaffaf$var$Ab = $2ea81f475bdaffaf$var$zb = null;
        $2ea81f475bdaffaf$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$2ea81f475bdaffaf$var$Bb(b[a]);
    }
}
function $2ea81f475bdaffaf$var$Gb(a, b) {
    return a(b);
}
function $2ea81f475bdaffaf$var$Hb() {}
var $2ea81f475bdaffaf$var$Ib = !1;
function $2ea81f475bdaffaf$var$Jb(a, b, c) {
    if ($2ea81f475bdaffaf$var$Ib) return a(b, c);
    $2ea81f475bdaffaf$var$Ib = !0;
    try {
        return $2ea81f475bdaffaf$var$Gb(a, b, c);
    } finally{
        if ($2ea81f475bdaffaf$var$Ib = !1, null !== $2ea81f475bdaffaf$var$zb || null !== $2ea81f475bdaffaf$var$Ab) $2ea81f475bdaffaf$var$Hb(), $2ea81f475bdaffaf$var$Fb();
    }
}
function $2ea81f475bdaffaf$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $2ea81f475bdaffaf$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($2ea81f475bdaffaf$var$p(231, b, typeof c));
    return c;
}
var $2ea81f475bdaffaf$var$Lb = !1;
if ($2ea81f475bdaffaf$var$ia) try {
    var $2ea81f475bdaffaf$var$Mb = {};
    Object.defineProperty($2ea81f475bdaffaf$var$Mb, "passive", {
        get: function() {
            $2ea81f475bdaffaf$var$Lb = !0;
        }
    });
    window.addEventListener("test", $2ea81f475bdaffaf$var$Mb, $2ea81f475bdaffaf$var$Mb);
    window.removeEventListener("test", $2ea81f475bdaffaf$var$Mb, $2ea81f475bdaffaf$var$Mb);
} catch (a) {
    $2ea81f475bdaffaf$var$Lb = !1;
}
function $2ea81f475bdaffaf$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (n) {
        this.onError(n);
    }
}
var $2ea81f475bdaffaf$var$Ob = !1, $2ea81f475bdaffaf$var$Pb = null, $2ea81f475bdaffaf$var$Qb = !1, $2ea81f475bdaffaf$var$Rb = null, $2ea81f475bdaffaf$var$Sb = {
    onError: function(a) {
        $2ea81f475bdaffaf$var$Ob = !0;
        $2ea81f475bdaffaf$var$Pb = a;
    }
};
function $2ea81f475bdaffaf$var$Tb(a, b, c, d, e, f, g, h, k) {
    $2ea81f475bdaffaf$var$Ob = !1;
    $2ea81f475bdaffaf$var$Pb = null;
    $2ea81f475bdaffaf$var$Nb.apply($2ea81f475bdaffaf$var$Sb, arguments);
}
function $2ea81f475bdaffaf$var$Ub(a, b, c, d, e, f, g, h, k) {
    $2ea81f475bdaffaf$var$Tb.apply(this, arguments);
    if ($2ea81f475bdaffaf$var$Ob) {
        if ($2ea81f475bdaffaf$var$Ob) {
            var l = $2ea81f475bdaffaf$var$Pb;
            $2ea81f475bdaffaf$var$Ob = !1;
            $2ea81f475bdaffaf$var$Pb = null;
        } else throw Error($2ea81f475bdaffaf$var$p(198));
        $2ea81f475bdaffaf$var$Qb || ($2ea81f475bdaffaf$var$Qb = !0, $2ea81f475bdaffaf$var$Rb = l);
    }
}
function $2ea81f475bdaffaf$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $2ea81f475bdaffaf$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $2ea81f475bdaffaf$var$Xb(a) {
    if ($2ea81f475bdaffaf$var$Vb(a) !== a) throw Error($2ea81f475bdaffaf$var$p(188));
}
function $2ea81f475bdaffaf$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $2ea81f475bdaffaf$var$Vb(a);
        if (null === b) throw Error($2ea81f475bdaffaf$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $2ea81f475bdaffaf$var$Xb(e), a;
                if (f === d) return $2ea81f475bdaffaf$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($2ea81f475bdaffaf$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($2ea81f475bdaffaf$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($2ea81f475bdaffaf$var$p(190));
    }
    if (3 !== c.tag) throw Error($2ea81f475bdaffaf$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $2ea81f475bdaffaf$var$Zb(a) {
    a = $2ea81f475bdaffaf$var$Yb(a);
    return null !== a ? $2ea81f475bdaffaf$var$$b(a) : null;
}
function $2ea81f475bdaffaf$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $2ea81f475bdaffaf$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $2ea81f475bdaffaf$var$ac = $jbhXM.unstable_scheduleCallback, $2ea81f475bdaffaf$var$bc = $jbhXM.unstable_cancelCallback, $2ea81f475bdaffaf$var$cc = $jbhXM.unstable_shouldYield, $2ea81f475bdaffaf$var$dc = $jbhXM.unstable_requestPaint, $2ea81f475bdaffaf$var$A = $jbhXM.unstable_now, $2ea81f475bdaffaf$var$ec = $jbhXM.unstable_getCurrentPriorityLevel, $2ea81f475bdaffaf$var$fc = $jbhXM.unstable_ImmediatePriority, $2ea81f475bdaffaf$var$gc = $jbhXM.unstable_UserBlockingPriority, $2ea81f475bdaffaf$var$hc = $jbhXM.unstable_NormalPriority, $2ea81f475bdaffaf$var$ic = $jbhXM.unstable_LowPriority, $2ea81f475bdaffaf$var$jc = $jbhXM.unstable_IdlePriority, $2ea81f475bdaffaf$var$kc = null, $2ea81f475bdaffaf$var$lc = null, $2ea81f475bdaffaf$var$B = null, $2ea81f475bdaffaf$var$mc = "undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__;
function $2ea81f475bdaffaf$var$nc(a, b) {
    if ($2ea81f475bdaffaf$var$lc && "function" === typeof $2ea81f475bdaffaf$var$lc.onCommitFiberRoot) try {
        var c = 128 === (a.current.flags & 128);
        switch(b){
            case 1:
                var d = $2ea81f475bdaffaf$var$fc;
                break;
            case 4:
                d = $2ea81f475bdaffaf$var$gc;
                break;
            case 16:
                d = $2ea81f475bdaffaf$var$hc;
                break;
            case 536870912:
                d = $2ea81f475bdaffaf$var$jc;
                break;
            default:
                d = $2ea81f475bdaffaf$var$hc;
        }
        $2ea81f475bdaffaf$var$lc.onCommitFiberRoot($2ea81f475bdaffaf$var$kc, a, d, c);
    } catch (e) {}
}
function $2ea81f475bdaffaf$var$oc(a) {
    $2ea81f475bdaffaf$var$B = a;
}
function $2ea81f475bdaffaf$var$pc() {
    for(var a = new Map, b = 1, c = 0; 31 > c; c++){
        var d = $2ea81f475bdaffaf$var$qc(b);
        a.set(b, d);
        b *= 2;
    }
    return a;
}
function $2ea81f475bdaffaf$var$rc() {
    null !== $2ea81f475bdaffaf$var$B && "function" === typeof $2ea81f475bdaffaf$var$B.markCommitStopped && $2ea81f475bdaffaf$var$B.markCommitStopped();
}
function $2ea81f475bdaffaf$var$sc(a) {
    null !== $2ea81f475bdaffaf$var$B && "function" === typeof $2ea81f475bdaffaf$var$B.markComponentRenderStarted && $2ea81f475bdaffaf$var$B.markComponentRenderStarted(a);
}
function $2ea81f475bdaffaf$var$tc() {
    null !== $2ea81f475bdaffaf$var$B && "function" === typeof $2ea81f475bdaffaf$var$B.markComponentRenderStopped && $2ea81f475bdaffaf$var$B.markComponentRenderStopped();
}
function $2ea81f475bdaffaf$var$uc(a) {
    null !== $2ea81f475bdaffaf$var$B && "function" === typeof $2ea81f475bdaffaf$var$B.markComponentLayoutEffectUnmountStarted && $2ea81f475bdaffaf$var$B.markComponentLayoutEffectUnmountStarted(a);
}
function $2ea81f475bdaffaf$var$vc() {
    null !== $2ea81f475bdaffaf$var$B && "function" === typeof $2ea81f475bdaffaf$var$B.markComponentLayoutEffectUnmountStopped && $2ea81f475bdaffaf$var$B.markComponentLayoutEffectUnmountStopped();
}
function $2ea81f475bdaffaf$var$wc(a) {
    null !== $2ea81f475bdaffaf$var$B && "function" === typeof $2ea81f475bdaffaf$var$B.markRenderStarted && $2ea81f475bdaffaf$var$B.markRenderStarted(a);
}
function $2ea81f475bdaffaf$var$xc() {
    null !== $2ea81f475bdaffaf$var$B && "function" === typeof $2ea81f475bdaffaf$var$B.markRenderStopped && $2ea81f475bdaffaf$var$B.markRenderStopped();
}
function $2ea81f475bdaffaf$var$yc(a, b) {
    null !== $2ea81f475bdaffaf$var$B && "function" === typeof $2ea81f475bdaffaf$var$B.markStateUpdateScheduled && $2ea81f475bdaffaf$var$B.markStateUpdateScheduled(a, b);
}
var $2ea81f475bdaffaf$var$Ac = Math.clz32 ? Math.clz32 : $2ea81f475bdaffaf$var$zc, $2ea81f475bdaffaf$var$Bc = Math.log, $2ea81f475bdaffaf$var$Cc = Math.LN2;
function $2ea81f475bdaffaf$var$zc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($2ea81f475bdaffaf$var$Bc(a) / $2ea81f475bdaffaf$var$Cc | 0) | 0;
}
function $2ea81f475bdaffaf$var$qc(a) {
    if (a & 1) return "Sync";
    if (a & 2) return "InputContinuousHydration";
    if (a & 4) return "InputContinuous";
    if (a & 8) return "DefaultHydration";
    if (a & 16) return "Default";
    if (a & 32) return "TransitionHydration";
    if (a & 4194240) return "Transition";
    if (a & 130023424) return "Retry";
    if (a & 134217728) return "SelectiveHydration";
    if (a & 268435456) return "IdleHydration";
    if (a & 536870912) return "Idle";
    if (a & 1073741824) return "Offscreen";
}
var $2ea81f475bdaffaf$var$Dc = 64, $2ea81f475bdaffaf$var$Ec = 4194304;
function $2ea81f475bdaffaf$var$Fc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $2ea81f475bdaffaf$var$Gc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $2ea81f475bdaffaf$var$Fc(h) : (f &= g, 0 !== f && (d = $2ea81f475bdaffaf$var$Fc(f)));
    } else g = c & ~e, 0 !== g ? d = $2ea81f475bdaffaf$var$Fc(g) : 0 !== f && (d = $2ea81f475bdaffaf$var$Fc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $2ea81f475bdaffaf$var$Ac(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $2ea81f475bdaffaf$var$Hc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $2ea81f475bdaffaf$var$Ic(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $2ea81f475bdaffaf$var$Ac(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $2ea81f475bdaffaf$var$Hc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $2ea81f475bdaffaf$var$Jc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $2ea81f475bdaffaf$var$Kc() {
    var a = $2ea81f475bdaffaf$var$Dc;
    $2ea81f475bdaffaf$var$Dc <<= 1;
    0 === ($2ea81f475bdaffaf$var$Dc & 4194240) && ($2ea81f475bdaffaf$var$Dc = 64);
    return a;
}
function $2ea81f475bdaffaf$var$Lc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $2ea81f475bdaffaf$var$Mc(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $2ea81f475bdaffaf$var$Ac(b);
    a[b] = c;
}
function $2ea81f475bdaffaf$var$Nc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $2ea81f475bdaffaf$var$Ac(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $2ea81f475bdaffaf$var$Oc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $2ea81f475bdaffaf$var$Ac(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
function $2ea81f475bdaffaf$var$Pc(a, b, c) {
    if ($2ea81f475bdaffaf$var$mc) for(a = a.pendingUpdatersLaneMap; 0 < c;){
        var d = 31 - $2ea81f475bdaffaf$var$Ac(c), e = 1 << d;
        a[d].add(b);
        c &= ~e;
    }
}
function $2ea81f475bdaffaf$var$Qc(a, b) {
    if ($2ea81f475bdaffaf$var$mc) for(var c = a.pendingUpdatersLaneMap, d = a.memoizedUpdaters; 0 < b;){
        var e = 31 - $2ea81f475bdaffaf$var$Ac(b);
        a = 1 << e;
        e = c[e];
        0 < e.size && (e.forEach(function(a) {
            var b = a.alternate;
            null !== b && d.has(b) || d.add(a);
        }), e.clear());
        b &= ~a;
    }
}
var $2ea81f475bdaffaf$var$E = 0;
function $2ea81f475bdaffaf$var$Rc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $2ea81f475bdaffaf$var$Sc, $2ea81f475bdaffaf$var$Tc, $2ea81f475bdaffaf$var$Uc, $2ea81f475bdaffaf$var$Vc, $2ea81f475bdaffaf$var$Wc, $2ea81f475bdaffaf$var$Xc = !1, $2ea81f475bdaffaf$var$Yc = [], $2ea81f475bdaffaf$var$Zc = null, $2ea81f475bdaffaf$var$$c = null, $2ea81f475bdaffaf$var$ad = null, $2ea81f475bdaffaf$var$bd = new Map, $2ea81f475bdaffaf$var$cd = new Map, $2ea81f475bdaffaf$var$dd = [], $2ea81f475bdaffaf$var$ed = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $2ea81f475bdaffaf$var$fd(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $2ea81f475bdaffaf$var$Zc = null;
            break;
        case "dragenter":
        case "dragleave":
            $2ea81f475bdaffaf$var$$c = null;
            break;
        case "mouseover":
        case "mouseout":
            $2ea81f475bdaffaf$var$ad = null;
            break;
        case "pointerover":
        case "pointerout":
            $2ea81f475bdaffaf$var$bd.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $2ea81f475bdaffaf$var$cd.delete(b.pointerId);
    }
}
function $2ea81f475bdaffaf$var$gd(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $2ea81f475bdaffaf$var$Cb(b), null !== b && $2ea81f475bdaffaf$var$Tc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $2ea81f475bdaffaf$var$hd(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $2ea81f475bdaffaf$var$Zc = $2ea81f475bdaffaf$var$gd($2ea81f475bdaffaf$var$Zc, a, b, c, d, e), !0;
        case "dragenter":
            return $2ea81f475bdaffaf$var$$c = $2ea81f475bdaffaf$var$gd($2ea81f475bdaffaf$var$$c, a, b, c, d, e), !0;
        case "mouseover":
            return $2ea81f475bdaffaf$var$ad = $2ea81f475bdaffaf$var$gd($2ea81f475bdaffaf$var$ad, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $2ea81f475bdaffaf$var$bd.set(f, $2ea81f475bdaffaf$var$gd($2ea81f475bdaffaf$var$bd.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $2ea81f475bdaffaf$var$cd.set(f, $2ea81f475bdaffaf$var$gd($2ea81f475bdaffaf$var$cd.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $2ea81f475bdaffaf$var$id(a) {
    var b = $2ea81f475bdaffaf$var$jd(a.target);
    if (null !== b) {
        var c = $2ea81f475bdaffaf$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $2ea81f475bdaffaf$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $2ea81f475bdaffaf$var$Wc(a.priority, function() {
                        $2ea81f475bdaffaf$var$Uc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $2ea81f475bdaffaf$var$kd(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $2ea81f475bdaffaf$var$ld(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $2ea81f475bdaffaf$var$wb = d;
            c.target.dispatchEvent(d);
            $2ea81f475bdaffaf$var$wb = null;
        } else return b = $2ea81f475bdaffaf$var$Cb(c), null !== b && $2ea81f475bdaffaf$var$Tc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $2ea81f475bdaffaf$var$md(a, b, c) {
    $2ea81f475bdaffaf$var$kd(a) && c.delete(b);
}
function $2ea81f475bdaffaf$var$nd() {
    $2ea81f475bdaffaf$var$Xc = !1;
    null !== $2ea81f475bdaffaf$var$Zc && $2ea81f475bdaffaf$var$kd($2ea81f475bdaffaf$var$Zc) && ($2ea81f475bdaffaf$var$Zc = null);
    null !== $2ea81f475bdaffaf$var$$c && $2ea81f475bdaffaf$var$kd($2ea81f475bdaffaf$var$$c) && ($2ea81f475bdaffaf$var$$c = null);
    null !== $2ea81f475bdaffaf$var$ad && $2ea81f475bdaffaf$var$kd($2ea81f475bdaffaf$var$ad) && ($2ea81f475bdaffaf$var$ad = null);
    $2ea81f475bdaffaf$var$bd.forEach($2ea81f475bdaffaf$var$md);
    $2ea81f475bdaffaf$var$cd.forEach($2ea81f475bdaffaf$var$md);
}
function $2ea81f475bdaffaf$var$od(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $2ea81f475bdaffaf$var$Xc || ($2ea81f475bdaffaf$var$Xc = !0, $jbhXM.unstable_scheduleCallback($jbhXM.unstable_NormalPriority, $2ea81f475bdaffaf$var$nd)));
}
function $2ea81f475bdaffaf$var$pd(a) {
    function b(b) {
        return $2ea81f475bdaffaf$var$od(b, a);
    }
    if (0 < $2ea81f475bdaffaf$var$Yc.length) {
        $2ea81f475bdaffaf$var$od($2ea81f475bdaffaf$var$Yc[0], a);
        for(var c = 1; c < $2ea81f475bdaffaf$var$Yc.length; c++){
            var d = $2ea81f475bdaffaf$var$Yc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $2ea81f475bdaffaf$var$Zc && $2ea81f475bdaffaf$var$od($2ea81f475bdaffaf$var$Zc, a);
    null !== $2ea81f475bdaffaf$var$$c && $2ea81f475bdaffaf$var$od($2ea81f475bdaffaf$var$$c, a);
    null !== $2ea81f475bdaffaf$var$ad && $2ea81f475bdaffaf$var$od($2ea81f475bdaffaf$var$ad, a);
    $2ea81f475bdaffaf$var$bd.forEach(b);
    $2ea81f475bdaffaf$var$cd.forEach(b);
    for(c = 0; c < $2ea81f475bdaffaf$var$dd.length; c++)d = $2ea81f475bdaffaf$var$dd[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $2ea81f475bdaffaf$var$dd.length && (c = $2ea81f475bdaffaf$var$dd[0], null === c.blockedOn);)$2ea81f475bdaffaf$var$id(c), null === c.blockedOn && $2ea81f475bdaffaf$var$dd.shift();
}
var $2ea81f475bdaffaf$var$qd = $2ea81f475bdaffaf$var$va.ReactCurrentBatchConfig, $2ea81f475bdaffaf$var$rd = !0;
function $2ea81f475bdaffaf$var$sd(a, b, c, d) {
    var e = $2ea81f475bdaffaf$var$E, f = $2ea81f475bdaffaf$var$qd.transition;
    $2ea81f475bdaffaf$var$qd.transition = null;
    try {
        $2ea81f475bdaffaf$var$E = 1, $2ea81f475bdaffaf$var$td(a, b, c, d);
    } finally{
        $2ea81f475bdaffaf$var$E = e, $2ea81f475bdaffaf$var$qd.transition = f;
    }
}
function $2ea81f475bdaffaf$var$ud(a, b, c, d) {
    var e = $2ea81f475bdaffaf$var$E, f = $2ea81f475bdaffaf$var$qd.transition;
    $2ea81f475bdaffaf$var$qd.transition = null;
    try {
        $2ea81f475bdaffaf$var$E = 4, $2ea81f475bdaffaf$var$td(a, b, c, d);
    } finally{
        $2ea81f475bdaffaf$var$E = e, $2ea81f475bdaffaf$var$qd.transition = f;
    }
}
function $2ea81f475bdaffaf$var$td(a, b, c, d) {
    if ($2ea81f475bdaffaf$var$rd) {
        var e = $2ea81f475bdaffaf$var$ld(a, b, c, d);
        if (null === e) $2ea81f475bdaffaf$var$vd(a, b, d, $2ea81f475bdaffaf$var$wd, c), $2ea81f475bdaffaf$var$fd(a, d);
        else if ($2ea81f475bdaffaf$var$hd(e, a, b, c, d)) d.stopPropagation();
        else if ($2ea81f475bdaffaf$var$fd(a, d), b & 4 && -1 < $2ea81f475bdaffaf$var$ed.indexOf(a)) {
            for(; null !== e;){
                var f = $2ea81f475bdaffaf$var$Cb(e);
                null !== f && $2ea81f475bdaffaf$var$Sc(f);
                f = $2ea81f475bdaffaf$var$ld(a, b, c, d);
                null === f && $2ea81f475bdaffaf$var$vd(a, b, d, $2ea81f475bdaffaf$var$wd, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $2ea81f475bdaffaf$var$vd(a, b, d, null, c);
    }
}
var $2ea81f475bdaffaf$var$wd = null;
function $2ea81f475bdaffaf$var$ld(a, b, c, d) {
    $2ea81f475bdaffaf$var$wd = null;
    a = $2ea81f475bdaffaf$var$xb(d);
    a = $2ea81f475bdaffaf$var$jd(a);
    if (null !== a) {
        if (b = $2ea81f475bdaffaf$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $2ea81f475bdaffaf$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $2ea81f475bdaffaf$var$wd = a;
    return null;
}
function $2ea81f475bdaffaf$var$xd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($2ea81f475bdaffaf$var$ec()){
                case $2ea81f475bdaffaf$var$fc:
                    return 1;
                case $2ea81f475bdaffaf$var$gc:
                    return 4;
                case $2ea81f475bdaffaf$var$hc:
                case $2ea81f475bdaffaf$var$ic:
                    return 16;
                case $2ea81f475bdaffaf$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $2ea81f475bdaffaf$var$yd = null, $2ea81f475bdaffaf$var$zd = null, $2ea81f475bdaffaf$var$Ad = null;
function $2ea81f475bdaffaf$var$Bd() {
    if ($2ea81f475bdaffaf$var$Ad) return $2ea81f475bdaffaf$var$Ad;
    var a, b = $2ea81f475bdaffaf$var$zd, c = b.length, d, e = "value" in $2ea81f475bdaffaf$var$yd ? $2ea81f475bdaffaf$var$yd.value : $2ea81f475bdaffaf$var$yd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $2ea81f475bdaffaf$var$Ad = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $2ea81f475bdaffaf$var$Cd(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $2ea81f475bdaffaf$var$Dd() {
    return !0;
}
function $2ea81f475bdaffaf$var$Ed() {
    return !1;
}
function $2ea81f475bdaffaf$var$Fd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $2ea81f475bdaffaf$var$Dd : $2ea81f475bdaffaf$var$Ed;
        this.isPropagationStopped = $2ea81f475bdaffaf$var$Ed;
        return this;
    }
    $2ea81f475bdaffaf$var$u(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $2ea81f475bdaffaf$var$Dd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $2ea81f475bdaffaf$var$Dd);
        },
        persist: function() {},
        isPersistent: $2ea81f475bdaffaf$var$Dd
    });
    return b;
}
var $2ea81f475bdaffaf$var$Gd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $2ea81f475bdaffaf$var$Hd = $2ea81f475bdaffaf$var$Fd($2ea81f475bdaffaf$var$Gd), $2ea81f475bdaffaf$var$Id = $2ea81f475bdaffaf$var$u({}, $2ea81f475bdaffaf$var$Gd, {
    view: 0,
    detail: 0
}), $2ea81f475bdaffaf$var$Jd = $2ea81f475bdaffaf$var$Fd($2ea81f475bdaffaf$var$Id), $2ea81f475bdaffaf$var$Kd, $2ea81f475bdaffaf$var$Ld, $2ea81f475bdaffaf$var$Md, $2ea81f475bdaffaf$var$Od = $2ea81f475bdaffaf$var$u({}, $2ea81f475bdaffaf$var$Id, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $2ea81f475bdaffaf$var$Nd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $2ea81f475bdaffaf$var$Md && ($2ea81f475bdaffaf$var$Md && "mousemove" === a.type ? ($2ea81f475bdaffaf$var$Kd = a.screenX - $2ea81f475bdaffaf$var$Md.screenX, $2ea81f475bdaffaf$var$Ld = a.screenY - $2ea81f475bdaffaf$var$Md.screenY) : $2ea81f475bdaffaf$var$Ld = $2ea81f475bdaffaf$var$Kd = 0, $2ea81f475bdaffaf$var$Md = a);
        return $2ea81f475bdaffaf$var$Kd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $2ea81f475bdaffaf$var$Ld;
    }
}), $2ea81f475bdaffaf$var$Pd = $2ea81f475bdaffaf$var$Fd($2ea81f475bdaffaf$var$Od), $2ea81f475bdaffaf$var$Qd = $2ea81f475bdaffaf$var$u({}, $2ea81f475bdaffaf$var$Od, {
    dataTransfer: 0
}), $2ea81f475bdaffaf$var$Rd = $2ea81f475bdaffaf$var$Fd($2ea81f475bdaffaf$var$Qd), $2ea81f475bdaffaf$var$Sd = $2ea81f475bdaffaf$var$u({}, $2ea81f475bdaffaf$var$Id, {
    relatedTarget: 0
}), $2ea81f475bdaffaf$var$Td = $2ea81f475bdaffaf$var$Fd($2ea81f475bdaffaf$var$Sd), $2ea81f475bdaffaf$var$Ud = $2ea81f475bdaffaf$var$u({}, $2ea81f475bdaffaf$var$Gd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $2ea81f475bdaffaf$var$Vd = $2ea81f475bdaffaf$var$Fd($2ea81f475bdaffaf$var$Ud), $2ea81f475bdaffaf$var$Wd = $2ea81f475bdaffaf$var$u({}, $2ea81f475bdaffaf$var$Gd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $2ea81f475bdaffaf$var$Xd = $2ea81f475bdaffaf$var$Fd($2ea81f475bdaffaf$var$Wd), $2ea81f475bdaffaf$var$Yd = $2ea81f475bdaffaf$var$u({}, $2ea81f475bdaffaf$var$Gd, {
    data: 0
}), $2ea81f475bdaffaf$var$Zd = $2ea81f475bdaffaf$var$Fd($2ea81f475bdaffaf$var$Yd), $2ea81f475bdaffaf$var$$d = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $2ea81f475bdaffaf$var$ae = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $2ea81f475bdaffaf$var$be = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $2ea81f475bdaffaf$var$ce(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $2ea81f475bdaffaf$var$be[a]) ? !!b[a] : !1;
}
function $2ea81f475bdaffaf$var$Nd() {
    return $2ea81f475bdaffaf$var$ce;
}
var $2ea81f475bdaffaf$var$de = $2ea81f475bdaffaf$var$u({}, $2ea81f475bdaffaf$var$Id, {
    key: function(a) {
        if (a.key) {
            var b = $2ea81f475bdaffaf$var$$d[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $2ea81f475bdaffaf$var$Cd(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $2ea81f475bdaffaf$var$ae[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $2ea81f475bdaffaf$var$Nd,
    charCode: function(a) {
        return "keypress" === a.type ? $2ea81f475bdaffaf$var$Cd(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $2ea81f475bdaffaf$var$Cd(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $2ea81f475bdaffaf$var$ee = $2ea81f475bdaffaf$var$Fd($2ea81f475bdaffaf$var$de), $2ea81f475bdaffaf$var$fe = $2ea81f475bdaffaf$var$u({}, $2ea81f475bdaffaf$var$Od, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $2ea81f475bdaffaf$var$ge = $2ea81f475bdaffaf$var$Fd($2ea81f475bdaffaf$var$fe), $2ea81f475bdaffaf$var$he = $2ea81f475bdaffaf$var$u({}, $2ea81f475bdaffaf$var$Id, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $2ea81f475bdaffaf$var$Nd
}), $2ea81f475bdaffaf$var$ie = $2ea81f475bdaffaf$var$Fd($2ea81f475bdaffaf$var$he), $2ea81f475bdaffaf$var$je = $2ea81f475bdaffaf$var$u({}, $2ea81f475bdaffaf$var$Gd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $2ea81f475bdaffaf$var$ke = $2ea81f475bdaffaf$var$Fd($2ea81f475bdaffaf$var$je), $2ea81f475bdaffaf$var$le = $2ea81f475bdaffaf$var$u({}, $2ea81f475bdaffaf$var$Od, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $2ea81f475bdaffaf$var$me = $2ea81f475bdaffaf$var$Fd($2ea81f475bdaffaf$var$le), $2ea81f475bdaffaf$var$ne = [
    9,
    13,
    27,
    32
], $2ea81f475bdaffaf$var$oe = $2ea81f475bdaffaf$var$ia && "CompositionEvent" in window, $2ea81f475bdaffaf$var$pe = null;
$2ea81f475bdaffaf$var$ia && "documentMode" in document && ($2ea81f475bdaffaf$var$pe = document.documentMode);
var $2ea81f475bdaffaf$var$qe = $2ea81f475bdaffaf$var$ia && "TextEvent" in window && !$2ea81f475bdaffaf$var$pe, $2ea81f475bdaffaf$var$re = $2ea81f475bdaffaf$var$ia && (!$2ea81f475bdaffaf$var$oe || $2ea81f475bdaffaf$var$pe && 8 < $2ea81f475bdaffaf$var$pe && 11 >= $2ea81f475bdaffaf$var$pe), $2ea81f475bdaffaf$var$se = String.fromCharCode(32), $2ea81f475bdaffaf$var$te = !1;
function $2ea81f475bdaffaf$var$ue(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $2ea81f475bdaffaf$var$ne.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $2ea81f475bdaffaf$var$ve(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $2ea81f475bdaffaf$var$we = !1;
function $2ea81f475bdaffaf$var$xe(a, b) {
    switch(a){
        case "compositionend":
            return $2ea81f475bdaffaf$var$ve(b);
        case "keypress":
            if (32 !== b.which) return null;
            $2ea81f475bdaffaf$var$te = !0;
            return $2ea81f475bdaffaf$var$se;
        case "textInput":
            return a = b.data, a === $2ea81f475bdaffaf$var$se && $2ea81f475bdaffaf$var$te ? null : a;
        default:
            return null;
    }
}
function $2ea81f475bdaffaf$var$ye(a, b) {
    if ($2ea81f475bdaffaf$var$we) return "compositionend" === a || !$2ea81f475bdaffaf$var$oe && $2ea81f475bdaffaf$var$ue(a, b) ? (a = $2ea81f475bdaffaf$var$Bd(), $2ea81f475bdaffaf$var$Ad = $2ea81f475bdaffaf$var$zd = $2ea81f475bdaffaf$var$yd = null, $2ea81f475bdaffaf$var$we = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $2ea81f475bdaffaf$var$re && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $2ea81f475bdaffaf$var$ze = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $2ea81f475bdaffaf$var$Ae(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$2ea81f475bdaffaf$var$ze[a.type] : "textarea" === b ? !0 : !1;
}
function $2ea81f475bdaffaf$var$Be(a, b, c, d) {
    $2ea81f475bdaffaf$var$Eb(d);
    b = $2ea81f475bdaffaf$var$Ce(b, "onChange");
    0 < b.length && (c = new $2ea81f475bdaffaf$var$Hd("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $2ea81f475bdaffaf$var$De = null, $2ea81f475bdaffaf$var$Ee = null;
function $2ea81f475bdaffaf$var$Fe(a) {
    $2ea81f475bdaffaf$var$Ge(a, 0);
}
function $2ea81f475bdaffaf$var$He(a) {
    var b = $2ea81f475bdaffaf$var$Ie(a);
    if ($2ea81f475bdaffaf$var$Wa(b)) return a;
}
function $2ea81f475bdaffaf$var$Je(a, b) {
    if ("change" === a) return b;
}
var $2ea81f475bdaffaf$var$Ke = !1;
if ($2ea81f475bdaffaf$var$ia) {
    var $2ea81f475bdaffaf$var$Le;
    if ($2ea81f475bdaffaf$var$ia) {
        var $2ea81f475bdaffaf$var$Me = "oninput" in document;
        if (!$2ea81f475bdaffaf$var$Me) {
            var $2ea81f475bdaffaf$var$Ne = document.createElement("div");
            $2ea81f475bdaffaf$var$Ne.setAttribute("oninput", "return;");
            $2ea81f475bdaffaf$var$Me = "function" === typeof $2ea81f475bdaffaf$var$Ne.oninput;
        }
        $2ea81f475bdaffaf$var$Le = $2ea81f475bdaffaf$var$Me;
    } else $2ea81f475bdaffaf$var$Le = !1;
    $2ea81f475bdaffaf$var$Ke = $2ea81f475bdaffaf$var$Le && (!document.documentMode || 9 < document.documentMode);
}
function $2ea81f475bdaffaf$var$Oe() {
    $2ea81f475bdaffaf$var$De && ($2ea81f475bdaffaf$var$De.detachEvent("onpropertychange", $2ea81f475bdaffaf$var$Pe), $2ea81f475bdaffaf$var$Ee = $2ea81f475bdaffaf$var$De = null);
}
function $2ea81f475bdaffaf$var$Pe(a) {
    if ("value" === a.propertyName && $2ea81f475bdaffaf$var$He($2ea81f475bdaffaf$var$Ee)) {
        var b = [];
        $2ea81f475bdaffaf$var$Be(b, $2ea81f475bdaffaf$var$Ee, a, $2ea81f475bdaffaf$var$xb(a));
        $2ea81f475bdaffaf$var$Jb($2ea81f475bdaffaf$var$Fe, b);
    }
}
function $2ea81f475bdaffaf$var$Qe(a, b, c) {
    "focusin" === a ? ($2ea81f475bdaffaf$var$Oe(), $2ea81f475bdaffaf$var$De = b, $2ea81f475bdaffaf$var$Ee = c, $2ea81f475bdaffaf$var$De.attachEvent("onpropertychange", $2ea81f475bdaffaf$var$Pe)) : "focusout" === a && $2ea81f475bdaffaf$var$Oe();
}
function $2ea81f475bdaffaf$var$Re(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $2ea81f475bdaffaf$var$He($2ea81f475bdaffaf$var$Ee);
}
function $2ea81f475bdaffaf$var$Se(a, b) {
    if ("click" === a) return $2ea81f475bdaffaf$var$He(b);
}
function $2ea81f475bdaffaf$var$Te(a, b) {
    if ("input" === a || "change" === a) return $2ea81f475bdaffaf$var$He(b);
}
function $2ea81f475bdaffaf$var$Ue(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $2ea81f475bdaffaf$var$Ve = "function" === typeof Object.is ? Object.is : $2ea81f475bdaffaf$var$Ue;
function $2ea81f475bdaffaf$var$We(a, b) {
    if ($2ea81f475bdaffaf$var$Ve(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$2ea81f475bdaffaf$var$ja.call(b, e) || !$2ea81f475bdaffaf$var$Ve(a[e], b[e])) return !1;
    }
    return !0;
}
function $2ea81f475bdaffaf$var$Xe(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $2ea81f475bdaffaf$var$Ye(a, b) {
    var c = $2ea81f475bdaffaf$var$Xe(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $2ea81f475bdaffaf$var$Xe(c);
    }
}
function $2ea81f475bdaffaf$var$Ze(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $2ea81f475bdaffaf$var$Ze(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $2ea81f475bdaffaf$var$$e() {
    for(var a = window, b = $2ea81f475bdaffaf$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $2ea81f475bdaffaf$var$Xa(a.document);
    }
    return b;
}
function $2ea81f475bdaffaf$var$af(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $2ea81f475bdaffaf$var$bf(a) {
    var b = $2ea81f475bdaffaf$var$$e(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $2ea81f475bdaffaf$var$Ze(c.ownerDocument.documentElement, c)) {
        if (null !== d && $2ea81f475bdaffaf$var$af(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $2ea81f475bdaffaf$var$Ye(c, f);
                var g = $2ea81f475bdaffaf$var$Ye(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $2ea81f475bdaffaf$var$cf = $2ea81f475bdaffaf$var$ia && "documentMode" in document && 11 >= document.documentMode, $2ea81f475bdaffaf$var$df = null, $2ea81f475bdaffaf$var$ef = null, $2ea81f475bdaffaf$var$ff = null, $2ea81f475bdaffaf$var$gf = !1;
function $2ea81f475bdaffaf$var$hf(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $2ea81f475bdaffaf$var$gf || null == $2ea81f475bdaffaf$var$df || $2ea81f475bdaffaf$var$df !== $2ea81f475bdaffaf$var$Xa(d) || (d = $2ea81f475bdaffaf$var$df, "selectionStart" in d && $2ea81f475bdaffaf$var$af(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $2ea81f475bdaffaf$var$ff && $2ea81f475bdaffaf$var$We($2ea81f475bdaffaf$var$ff, d) || ($2ea81f475bdaffaf$var$ff = d, d = $2ea81f475bdaffaf$var$Ce($2ea81f475bdaffaf$var$ef, "onSelect"), 0 < d.length && (b = new $2ea81f475bdaffaf$var$Hd("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $2ea81f475bdaffaf$var$df)));
}
function $2ea81f475bdaffaf$var$jf(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $2ea81f475bdaffaf$var$kf = {
    animationend: $2ea81f475bdaffaf$var$jf("Animation", "AnimationEnd"),
    animationiteration: $2ea81f475bdaffaf$var$jf("Animation", "AnimationIteration"),
    animationstart: $2ea81f475bdaffaf$var$jf("Animation", "AnimationStart"),
    transitionend: $2ea81f475bdaffaf$var$jf("Transition", "TransitionEnd")
}, $2ea81f475bdaffaf$var$lf = {}, $2ea81f475bdaffaf$var$mf = {};
$2ea81f475bdaffaf$var$ia && ($2ea81f475bdaffaf$var$mf = document.createElement("div").style, "AnimationEvent" in window || (delete $2ea81f475bdaffaf$var$kf.animationend.animation, delete $2ea81f475bdaffaf$var$kf.animationiteration.animation, delete $2ea81f475bdaffaf$var$kf.animationstart.animation), "TransitionEvent" in window || delete $2ea81f475bdaffaf$var$kf.transitionend.transition);
function $2ea81f475bdaffaf$var$nf(a) {
    if ($2ea81f475bdaffaf$var$lf[a]) return $2ea81f475bdaffaf$var$lf[a];
    if (!$2ea81f475bdaffaf$var$kf[a]) return a;
    var b = $2ea81f475bdaffaf$var$kf[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $2ea81f475bdaffaf$var$mf) return $2ea81f475bdaffaf$var$lf[a] = b[c];
    return a;
}
var $2ea81f475bdaffaf$var$of = $2ea81f475bdaffaf$var$nf("animationend"), $2ea81f475bdaffaf$var$pf = $2ea81f475bdaffaf$var$nf("animationiteration"), $2ea81f475bdaffaf$var$qf = $2ea81f475bdaffaf$var$nf("animationstart"), $2ea81f475bdaffaf$var$rf = $2ea81f475bdaffaf$var$nf("transitionend"), $2ea81f475bdaffaf$var$sf = new Map, $2ea81f475bdaffaf$var$tf = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $2ea81f475bdaffaf$var$uf(a, b) {
    $2ea81f475bdaffaf$var$sf.set(a, b);
    $2ea81f475bdaffaf$var$fa(b, [
        a
    ]);
}
for(var $2ea81f475bdaffaf$var$vf = 0; $2ea81f475bdaffaf$var$vf < $2ea81f475bdaffaf$var$tf.length; $2ea81f475bdaffaf$var$vf++){
    var $2ea81f475bdaffaf$var$wf = $2ea81f475bdaffaf$var$tf[$2ea81f475bdaffaf$var$vf], $2ea81f475bdaffaf$var$xf = $2ea81f475bdaffaf$var$wf.toLowerCase(), $2ea81f475bdaffaf$var$yf = $2ea81f475bdaffaf$var$wf[0].toUpperCase() + $2ea81f475bdaffaf$var$wf.slice(1);
    $2ea81f475bdaffaf$var$uf($2ea81f475bdaffaf$var$xf, "on" + $2ea81f475bdaffaf$var$yf);
}
$2ea81f475bdaffaf$var$uf($2ea81f475bdaffaf$var$of, "onAnimationEnd");
$2ea81f475bdaffaf$var$uf($2ea81f475bdaffaf$var$pf, "onAnimationIteration");
$2ea81f475bdaffaf$var$uf($2ea81f475bdaffaf$var$qf, "onAnimationStart");
$2ea81f475bdaffaf$var$uf("dblclick", "onDoubleClick");
$2ea81f475bdaffaf$var$uf("focusin", "onFocus");
$2ea81f475bdaffaf$var$uf("focusout", "onBlur");
$2ea81f475bdaffaf$var$uf($2ea81f475bdaffaf$var$rf, "onTransitionEnd");
$2ea81f475bdaffaf$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$2ea81f475bdaffaf$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$2ea81f475bdaffaf$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$2ea81f475bdaffaf$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$2ea81f475bdaffaf$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$2ea81f475bdaffaf$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$2ea81f475bdaffaf$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$2ea81f475bdaffaf$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$2ea81f475bdaffaf$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$2ea81f475bdaffaf$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $2ea81f475bdaffaf$var$zf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $2ea81f475bdaffaf$var$Af = new Set("cancel close invalid load scroll toggle".split(" ").concat($2ea81f475bdaffaf$var$zf));
function $2ea81f475bdaffaf$var$Bf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $2ea81f475bdaffaf$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $2ea81f475bdaffaf$var$Ge(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $2ea81f475bdaffaf$var$Bf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $2ea81f475bdaffaf$var$Bf(e, h, l);
                f = k;
            }
        }
    }
    if ($2ea81f475bdaffaf$var$Qb) throw a = $2ea81f475bdaffaf$var$Rb, $2ea81f475bdaffaf$var$Qb = !1, $2ea81f475bdaffaf$var$Rb = null, a;
}
function $2ea81f475bdaffaf$var$F(a, b) {
    var c = b[$2ea81f475bdaffaf$var$Cf];
    void 0 === c && (c = b[$2ea81f475bdaffaf$var$Cf] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($2ea81f475bdaffaf$var$Df(b, a, 2, !1), c.add(d));
}
function $2ea81f475bdaffaf$var$Ef(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $2ea81f475bdaffaf$var$Df(c, a, d, b);
}
var $2ea81f475bdaffaf$var$Ff = "_reactListening" + Math.random().toString(36).slice(2);
function $2ea81f475bdaffaf$var$Gf(a) {
    if (!a[$2ea81f475bdaffaf$var$Ff]) {
        a[$2ea81f475bdaffaf$var$Ff] = !0;
        $2ea81f475bdaffaf$var$da.forEach(function(b) {
            "selectionchange" !== b && ($2ea81f475bdaffaf$var$Af.has(b) || $2ea81f475bdaffaf$var$Ef(b, !1, a), $2ea81f475bdaffaf$var$Ef(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$2ea81f475bdaffaf$var$Ff] || (b[$2ea81f475bdaffaf$var$Ff] = !0, $2ea81f475bdaffaf$var$Ef("selectionchange", !1, b));
    }
}
function $2ea81f475bdaffaf$var$Df(a, b, c, d) {
    switch($2ea81f475bdaffaf$var$xd(b)){
        case 1:
            var e = $2ea81f475bdaffaf$var$sd;
            break;
        case 4:
            e = $2ea81f475bdaffaf$var$ud;
            break;
        default:
            e = $2ea81f475bdaffaf$var$td;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$2ea81f475bdaffaf$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $2ea81f475bdaffaf$var$vd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $2ea81f475bdaffaf$var$jd(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $2ea81f475bdaffaf$var$Jb(function() {
        var d = f, e = $2ea81f475bdaffaf$var$xb(c), g = [];
        a: {
            var h = $2ea81f475bdaffaf$var$sf.get(a);
            if (void 0 !== h) {
                var k = $2ea81f475bdaffaf$var$Hd, m = a;
                switch(a){
                    case "keypress":
                        if (0 === $2ea81f475bdaffaf$var$Cd(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $2ea81f475bdaffaf$var$ee;
                        break;
                    case "focusin":
                        m = "focus";
                        k = $2ea81f475bdaffaf$var$Td;
                        break;
                    case "focusout":
                        m = "blur";
                        k = $2ea81f475bdaffaf$var$Td;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $2ea81f475bdaffaf$var$Td;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $2ea81f475bdaffaf$var$Pd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $2ea81f475bdaffaf$var$Rd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $2ea81f475bdaffaf$var$ie;
                        break;
                    case $2ea81f475bdaffaf$var$of:
                    case $2ea81f475bdaffaf$var$pf:
                    case $2ea81f475bdaffaf$var$qf:
                        k = $2ea81f475bdaffaf$var$Vd;
                        break;
                    case $2ea81f475bdaffaf$var$rf:
                        k = $2ea81f475bdaffaf$var$ke;
                        break;
                    case "scroll":
                        k = $2ea81f475bdaffaf$var$Jd;
                        break;
                    case "wheel":
                        k = $2ea81f475bdaffaf$var$me;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $2ea81f475bdaffaf$var$Xd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $2ea81f475bdaffaf$var$ge;
                }
                var w = 0 !== (b & 4), C = !w && "scroll" === a, x = w ? null !== h ? h + "Capture" : null : h;
                w = [];
                for(var y = d, v; null !== y;){
                    v = y;
                    var D = v.stateNode;
                    5 === v.tag && null !== D && (v = D, null !== x && (D = $2ea81f475bdaffaf$var$Kb(y, x), null != D && w.push($2ea81f475bdaffaf$var$Hf(y, D, v))));
                    if (C) break;
                    y = y.return;
                }
                0 < w.length && (h = new k(h, m, null, c, e), g.push({
                    event: h,
                    listeners: w
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $2ea81f475bdaffaf$var$wb && (m = c.relatedTarget || c.fromElement) && ($2ea81f475bdaffaf$var$jd(m) || m[$2ea81f475bdaffaf$var$If])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (m = c.relatedTarget || c.toElement, k = d, m = m ? $2ea81f475bdaffaf$var$jd(m) : null, null !== m && (C = $2ea81f475bdaffaf$var$Vb(m), m !== C || 5 !== m.tag && 6 !== m.tag)) m = null;
                    } else k = null, m = d;
                    if (k !== m) {
                        w = $2ea81f475bdaffaf$var$Pd;
                        D = "onMouseLeave";
                        x = "onMouseEnter";
                        y = "mouse";
                        if ("pointerout" === a || "pointerover" === a) w = $2ea81f475bdaffaf$var$ge, D = "onPointerLeave", x = "onPointerEnter", y = "pointer";
                        C = null == k ? h : $2ea81f475bdaffaf$var$Ie(k);
                        v = null == m ? h : $2ea81f475bdaffaf$var$Ie(m);
                        h = new w(D, y + "leave", k, c, e);
                        h.target = C;
                        h.relatedTarget = v;
                        D = null;
                        $2ea81f475bdaffaf$var$jd(e) === d && (w = new w(x, y + "enter", m, c, e), w.target = v, w.relatedTarget = C, D = w);
                        C = D;
                        if (k && m) b: {
                            w = k;
                            x = m;
                            y = 0;
                            for(v = w; v; v = $2ea81f475bdaffaf$var$Jf(v))y++;
                            v = 0;
                            for(D = x; D; D = $2ea81f475bdaffaf$var$Jf(D))v++;
                            for(; 0 < y - v;)w = $2ea81f475bdaffaf$var$Jf(w), y--;
                            for(; 0 < v - y;)x = $2ea81f475bdaffaf$var$Jf(x), v--;
                            for(; y--;){
                                if (w === x || null !== x && w === x.alternate) break b;
                                w = $2ea81f475bdaffaf$var$Jf(w);
                                x = $2ea81f475bdaffaf$var$Jf(x);
                            }
                            w = null;
                        }
                        else w = null;
                        null !== k && $2ea81f475bdaffaf$var$Kf(g, h, k, w, !1);
                        null !== m && null !== C && $2ea81f475bdaffaf$var$Kf(g, C, m, w, !0);
                    }
                }
            }
            a: {
                h = d ? $2ea81f475bdaffaf$var$Ie(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var ca = $2ea81f475bdaffaf$var$Je;
                else if ($2ea81f475bdaffaf$var$Ae(h)) {
                    if ($2ea81f475bdaffaf$var$Ke) ca = $2ea81f475bdaffaf$var$Te;
                    else {
                        ca = $2ea81f475bdaffaf$var$Re;
                        var R = $2ea81f475bdaffaf$var$Qe;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (ca = $2ea81f475bdaffaf$var$Se);
                if (ca && (ca = ca(a, d))) {
                    $2ea81f475bdaffaf$var$Be(g, ca, c, e);
                    break a;
                }
                R && R(a, h, d);
                "focusout" === a && (R = h._wrapperState) && R.controlled && "number" === h.type && $2ea81f475bdaffaf$var$bb(h, "number", h.value);
            }
            R = d ? $2ea81f475bdaffaf$var$Ie(d) : window;
            switch(a){
                case "focusin":
                    if ($2ea81f475bdaffaf$var$Ae(R) || "true" === R.contentEditable) $2ea81f475bdaffaf$var$df = R, $2ea81f475bdaffaf$var$ef = d, $2ea81f475bdaffaf$var$ff = null;
                    break;
                case "focusout":
                    $2ea81f475bdaffaf$var$ff = $2ea81f475bdaffaf$var$ef = $2ea81f475bdaffaf$var$df = null;
                    break;
                case "mousedown":
                    $2ea81f475bdaffaf$var$gf = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $2ea81f475bdaffaf$var$gf = !1;
                    $2ea81f475bdaffaf$var$hf(g, c, e);
                    break;
                case "selectionchange":
                    if ($2ea81f475bdaffaf$var$cf) break;
                case "keydown":
                case "keyup":
                    $2ea81f475bdaffaf$var$hf(g, c, e);
            }
            var sa;
            if ($2ea81f475bdaffaf$var$oe) b: {
                switch(a){
                    case "compositionstart":
                        var V = "onCompositionStart";
                        break b;
                    case "compositionend":
                        V = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        V = "onCompositionUpdate";
                        break b;
                }
                V = void 0;
            }
            else $2ea81f475bdaffaf$var$we ? $2ea81f475bdaffaf$var$ue(a, c) && (V = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (V = "onCompositionStart");
            V && ($2ea81f475bdaffaf$var$re && "ko" !== c.locale && ($2ea81f475bdaffaf$var$we || "onCompositionStart" !== V ? "onCompositionEnd" === V && $2ea81f475bdaffaf$var$we && (sa = $2ea81f475bdaffaf$var$Bd()) : ($2ea81f475bdaffaf$var$yd = e, $2ea81f475bdaffaf$var$zd = "value" in $2ea81f475bdaffaf$var$yd ? $2ea81f475bdaffaf$var$yd.value : $2ea81f475bdaffaf$var$yd.textContent, $2ea81f475bdaffaf$var$we = !0)), R = $2ea81f475bdaffaf$var$Ce(d, V), 0 < R.length && (V = new $2ea81f475bdaffaf$var$Zd(V, a, null, c, e), g.push({
                event: V,
                listeners: R
            }), sa ? V.data = sa : (sa = $2ea81f475bdaffaf$var$ve(c), null !== sa && (V.data = sa))));
            if (sa = $2ea81f475bdaffaf$var$qe ? $2ea81f475bdaffaf$var$xe(a, c) : $2ea81f475bdaffaf$var$ye(a, c)) d = $2ea81f475bdaffaf$var$Ce(d, "onBeforeInput"), 0 < d.length && (e = new $2ea81f475bdaffaf$var$Zd("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = sa);
        }
        $2ea81f475bdaffaf$var$Ge(g, b);
    });
}
function $2ea81f475bdaffaf$var$Hf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $2ea81f475bdaffaf$var$Ce(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $2ea81f475bdaffaf$var$Kb(a, c), null != f && d.unshift($2ea81f475bdaffaf$var$Hf(a, f, e)), f = $2ea81f475bdaffaf$var$Kb(a, b), null != f && d.push($2ea81f475bdaffaf$var$Hf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $2ea81f475bdaffaf$var$Jf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $2ea81f475bdaffaf$var$Kf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $2ea81f475bdaffaf$var$Kb(c, f), null != k && g.unshift($2ea81f475bdaffaf$var$Hf(c, k, h))) : e || (k = $2ea81f475bdaffaf$var$Kb(c, f), null != k && g.push($2ea81f475bdaffaf$var$Hf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $2ea81f475bdaffaf$var$Lf = /\r\n?/g, $2ea81f475bdaffaf$var$Mf = /\u0000|\uFFFD/g;
function $2ea81f475bdaffaf$var$Nf(a) {
    return ("string" === typeof a ? a : "" + a).replace($2ea81f475bdaffaf$var$Lf, "\n").replace($2ea81f475bdaffaf$var$Mf, "");
}
function $2ea81f475bdaffaf$var$Of(a, b, c) {
    b = $2ea81f475bdaffaf$var$Nf(b);
    if ($2ea81f475bdaffaf$var$Nf(a) !== b && c) throw Error($2ea81f475bdaffaf$var$p(425));
}
function $2ea81f475bdaffaf$var$Pf() {}
var $2ea81f475bdaffaf$var$Qf = null, $2ea81f475bdaffaf$var$Rf = null;
function $2ea81f475bdaffaf$var$Sf(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $2ea81f475bdaffaf$var$Tf = "function" === typeof setTimeout ? setTimeout : void 0, $2ea81f475bdaffaf$var$Uf = "function" === typeof clearTimeout ? clearTimeout : void 0, $2ea81f475bdaffaf$var$Vf = "function" === typeof Promise ? Promise : void 0, $2ea81f475bdaffaf$var$Xf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $2ea81f475bdaffaf$var$Vf ? function(a) {
    return $2ea81f475bdaffaf$var$Vf.resolve(null).then(a).catch($2ea81f475bdaffaf$var$Wf);
} : $2ea81f475bdaffaf$var$Tf;
function $2ea81f475bdaffaf$var$Wf(a) {
    setTimeout(function() {
        throw a;
    });
}
function $2ea81f475bdaffaf$var$Yf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $2ea81f475bdaffaf$var$pd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $2ea81f475bdaffaf$var$pd(b);
}
function $2ea81f475bdaffaf$var$Zf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $2ea81f475bdaffaf$var$$f(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $2ea81f475bdaffaf$var$ag = Math.random().toString(36).slice(2), $2ea81f475bdaffaf$var$bg = "__reactFiber$" + $2ea81f475bdaffaf$var$ag, $2ea81f475bdaffaf$var$cg = "__reactProps$" + $2ea81f475bdaffaf$var$ag, $2ea81f475bdaffaf$var$If = "__reactContainer$" + $2ea81f475bdaffaf$var$ag, $2ea81f475bdaffaf$var$Cf = "__reactEvents$" + $2ea81f475bdaffaf$var$ag, $2ea81f475bdaffaf$var$dg = "__reactListeners$" + $2ea81f475bdaffaf$var$ag, $2ea81f475bdaffaf$var$eg = "__reactHandles$" + $2ea81f475bdaffaf$var$ag;
function $2ea81f475bdaffaf$var$jd(a) {
    var b = a[$2ea81f475bdaffaf$var$bg];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$2ea81f475bdaffaf$var$If] || c[$2ea81f475bdaffaf$var$bg]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $2ea81f475bdaffaf$var$$f(a); null !== a;){
                if (c = a[$2ea81f475bdaffaf$var$bg]) return c;
                a = $2ea81f475bdaffaf$var$$f(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $2ea81f475bdaffaf$var$Cb(a) {
    a = a[$2ea81f475bdaffaf$var$bg] || a[$2ea81f475bdaffaf$var$If];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $2ea81f475bdaffaf$var$Ie(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($2ea81f475bdaffaf$var$p(33));
}
function $2ea81f475bdaffaf$var$Db(a) {
    return a[$2ea81f475bdaffaf$var$cg] || null;
}
var $2ea81f475bdaffaf$var$fg = [], $2ea81f475bdaffaf$var$gg = -1;
function $2ea81f475bdaffaf$var$hg(a) {
    return {
        current: a
    };
}
function $2ea81f475bdaffaf$var$G(a) {
    0 > $2ea81f475bdaffaf$var$gg || (a.current = $2ea81f475bdaffaf$var$fg[$2ea81f475bdaffaf$var$gg], $2ea81f475bdaffaf$var$fg[$2ea81f475bdaffaf$var$gg] = null, $2ea81f475bdaffaf$var$gg--);
}
function $2ea81f475bdaffaf$var$H(a, b) {
    $2ea81f475bdaffaf$var$gg++;
    $2ea81f475bdaffaf$var$fg[$2ea81f475bdaffaf$var$gg] = a.current;
    a.current = b;
}
var $2ea81f475bdaffaf$var$ig = {}, $2ea81f475bdaffaf$var$I = $2ea81f475bdaffaf$var$hg($2ea81f475bdaffaf$var$ig), $2ea81f475bdaffaf$var$jg = $2ea81f475bdaffaf$var$hg(!1), $2ea81f475bdaffaf$var$kg = $2ea81f475bdaffaf$var$ig;
function $2ea81f475bdaffaf$var$lg(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $2ea81f475bdaffaf$var$ig;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $2ea81f475bdaffaf$var$mg(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $2ea81f475bdaffaf$var$ng() {
    $2ea81f475bdaffaf$var$G($2ea81f475bdaffaf$var$jg);
    $2ea81f475bdaffaf$var$G($2ea81f475bdaffaf$var$I);
}
function $2ea81f475bdaffaf$var$og(a, b, c) {
    if ($2ea81f475bdaffaf$var$I.current !== $2ea81f475bdaffaf$var$ig) throw Error($2ea81f475bdaffaf$var$p(168));
    $2ea81f475bdaffaf$var$H($2ea81f475bdaffaf$var$I, b);
    $2ea81f475bdaffaf$var$H($2ea81f475bdaffaf$var$jg, c);
}
function $2ea81f475bdaffaf$var$pg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($2ea81f475bdaffaf$var$p(108, $2ea81f475bdaffaf$var$Ra(a) || "Unknown", e));
    return $2ea81f475bdaffaf$var$u({}, c, d);
}
function $2ea81f475bdaffaf$var$qg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $2ea81f475bdaffaf$var$ig;
    $2ea81f475bdaffaf$var$kg = $2ea81f475bdaffaf$var$I.current;
    $2ea81f475bdaffaf$var$H($2ea81f475bdaffaf$var$I, a);
    $2ea81f475bdaffaf$var$H($2ea81f475bdaffaf$var$jg, $2ea81f475bdaffaf$var$jg.current);
    return !0;
}
function $2ea81f475bdaffaf$var$rg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($2ea81f475bdaffaf$var$p(169));
    c ? (a = $2ea81f475bdaffaf$var$pg(a, b, $2ea81f475bdaffaf$var$kg), d.__reactInternalMemoizedMergedChildContext = a, $2ea81f475bdaffaf$var$G($2ea81f475bdaffaf$var$jg), $2ea81f475bdaffaf$var$G($2ea81f475bdaffaf$var$I), $2ea81f475bdaffaf$var$H($2ea81f475bdaffaf$var$I, a)) : $2ea81f475bdaffaf$var$G($2ea81f475bdaffaf$var$jg);
    $2ea81f475bdaffaf$var$H($2ea81f475bdaffaf$var$jg, c);
}
var $2ea81f475bdaffaf$var$sg = null, $2ea81f475bdaffaf$var$tg = !1, $2ea81f475bdaffaf$var$ug = !1;
function $2ea81f475bdaffaf$var$vg(a) {
    null === $2ea81f475bdaffaf$var$sg ? $2ea81f475bdaffaf$var$sg = [
        a
    ] : $2ea81f475bdaffaf$var$sg.push(a);
}
function $2ea81f475bdaffaf$var$wg(a) {
    $2ea81f475bdaffaf$var$tg = !0;
    $2ea81f475bdaffaf$var$vg(a);
}
function $2ea81f475bdaffaf$var$xg() {
    if (!$2ea81f475bdaffaf$var$ug && null !== $2ea81f475bdaffaf$var$sg) {
        $2ea81f475bdaffaf$var$ug = !0;
        var a = 0, b = $2ea81f475bdaffaf$var$E;
        try {
            var c = $2ea81f475bdaffaf$var$sg;
            for($2ea81f475bdaffaf$var$E = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $2ea81f475bdaffaf$var$sg = null;
            $2ea81f475bdaffaf$var$tg = !1;
        } catch (e) {
            throw null !== $2ea81f475bdaffaf$var$sg && ($2ea81f475bdaffaf$var$sg = $2ea81f475bdaffaf$var$sg.slice(a + 1)), $2ea81f475bdaffaf$var$ac($2ea81f475bdaffaf$var$fc, $2ea81f475bdaffaf$var$xg), e;
        } finally{
            $2ea81f475bdaffaf$var$E = b, $2ea81f475bdaffaf$var$ug = !1;
        }
    }
    return null;
}
var $2ea81f475bdaffaf$var$yg = [], $2ea81f475bdaffaf$var$zg = 0, $2ea81f475bdaffaf$var$Ag = null, $2ea81f475bdaffaf$var$Bg = 0, $2ea81f475bdaffaf$var$Cg = [], $2ea81f475bdaffaf$var$Dg = 0, $2ea81f475bdaffaf$var$Eg = null, $2ea81f475bdaffaf$var$Fg = 1, $2ea81f475bdaffaf$var$Gg = "";
function $2ea81f475bdaffaf$var$Hg(a, b) {
    $2ea81f475bdaffaf$var$yg[$2ea81f475bdaffaf$var$zg++] = $2ea81f475bdaffaf$var$Bg;
    $2ea81f475bdaffaf$var$yg[$2ea81f475bdaffaf$var$zg++] = $2ea81f475bdaffaf$var$Ag;
    $2ea81f475bdaffaf$var$Ag = a;
    $2ea81f475bdaffaf$var$Bg = b;
}
function $2ea81f475bdaffaf$var$Ig(a, b, c) {
    $2ea81f475bdaffaf$var$Cg[$2ea81f475bdaffaf$var$Dg++] = $2ea81f475bdaffaf$var$Fg;
    $2ea81f475bdaffaf$var$Cg[$2ea81f475bdaffaf$var$Dg++] = $2ea81f475bdaffaf$var$Gg;
    $2ea81f475bdaffaf$var$Cg[$2ea81f475bdaffaf$var$Dg++] = $2ea81f475bdaffaf$var$Eg;
    $2ea81f475bdaffaf$var$Eg = a;
    var d = $2ea81f475bdaffaf$var$Fg;
    a = $2ea81f475bdaffaf$var$Gg;
    var e = 32 - $2ea81f475bdaffaf$var$Ac(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $2ea81f475bdaffaf$var$Ac(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $2ea81f475bdaffaf$var$Fg = 1 << 32 - $2ea81f475bdaffaf$var$Ac(b) + e | c << e | d;
        $2ea81f475bdaffaf$var$Gg = f + a;
    } else $2ea81f475bdaffaf$var$Fg = 1 << f | c << e | d, $2ea81f475bdaffaf$var$Gg = a;
}
function $2ea81f475bdaffaf$var$Jg(a) {
    null !== a.return && ($2ea81f475bdaffaf$var$Hg(a, 1), $2ea81f475bdaffaf$var$Ig(a, 1, 0));
}
function $2ea81f475bdaffaf$var$Kg(a) {
    for(; a === $2ea81f475bdaffaf$var$Ag;)$2ea81f475bdaffaf$var$Ag = $2ea81f475bdaffaf$var$yg[--$2ea81f475bdaffaf$var$zg], $2ea81f475bdaffaf$var$yg[$2ea81f475bdaffaf$var$zg] = null, $2ea81f475bdaffaf$var$Bg = $2ea81f475bdaffaf$var$yg[--$2ea81f475bdaffaf$var$zg], $2ea81f475bdaffaf$var$yg[$2ea81f475bdaffaf$var$zg] = null;
    for(; a === $2ea81f475bdaffaf$var$Eg;)$2ea81f475bdaffaf$var$Eg = $2ea81f475bdaffaf$var$Cg[--$2ea81f475bdaffaf$var$Dg], $2ea81f475bdaffaf$var$Cg[$2ea81f475bdaffaf$var$Dg] = null, $2ea81f475bdaffaf$var$Gg = $2ea81f475bdaffaf$var$Cg[--$2ea81f475bdaffaf$var$Dg], $2ea81f475bdaffaf$var$Cg[$2ea81f475bdaffaf$var$Dg] = null, $2ea81f475bdaffaf$var$Fg = $2ea81f475bdaffaf$var$Cg[--$2ea81f475bdaffaf$var$Dg], $2ea81f475bdaffaf$var$Cg[$2ea81f475bdaffaf$var$Dg] = null;
}
var $2ea81f475bdaffaf$var$Lg = null, $2ea81f475bdaffaf$var$Mg = null, $2ea81f475bdaffaf$var$J = !1, $2ea81f475bdaffaf$var$Ng = null;
function $2ea81f475bdaffaf$var$Og(a, b) {
    var c = $2ea81f475bdaffaf$var$Pg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $2ea81f475bdaffaf$var$Qg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $2ea81f475bdaffaf$var$Lg = a, $2ea81f475bdaffaf$var$Mg = $2ea81f475bdaffaf$var$Zf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $2ea81f475bdaffaf$var$Lg = a, $2ea81f475bdaffaf$var$Mg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $2ea81f475bdaffaf$var$Eg ? {
                id: $2ea81f475bdaffaf$var$Fg,
                overflow: $2ea81f475bdaffaf$var$Gg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $2ea81f475bdaffaf$var$Pg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $2ea81f475bdaffaf$var$Lg = a, $2ea81f475bdaffaf$var$Mg = null, !0) : !1;
        default:
            return !1;
    }
}
function $2ea81f475bdaffaf$var$Rg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $2ea81f475bdaffaf$var$Sg(a) {
    if ($2ea81f475bdaffaf$var$J) {
        var b = $2ea81f475bdaffaf$var$Mg;
        if (b) {
            var c = b;
            if (!$2ea81f475bdaffaf$var$Qg(a, b)) {
                if ($2ea81f475bdaffaf$var$Rg(a)) throw Error($2ea81f475bdaffaf$var$p(418));
                b = $2ea81f475bdaffaf$var$Zf(c.nextSibling);
                var d = $2ea81f475bdaffaf$var$Lg;
                b && $2ea81f475bdaffaf$var$Qg(a, b) ? $2ea81f475bdaffaf$var$Og(d, c) : (a.flags = a.flags & -4097 | 2, $2ea81f475bdaffaf$var$J = !1, $2ea81f475bdaffaf$var$Lg = a);
            }
        } else {
            if ($2ea81f475bdaffaf$var$Rg(a)) throw Error($2ea81f475bdaffaf$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $2ea81f475bdaffaf$var$J = !1;
            $2ea81f475bdaffaf$var$Lg = a;
        }
    }
}
function $2ea81f475bdaffaf$var$Tg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $2ea81f475bdaffaf$var$Lg = a;
}
function $2ea81f475bdaffaf$var$Ug(a) {
    if (a !== $2ea81f475bdaffaf$var$Lg) return !1;
    if (!$2ea81f475bdaffaf$var$J) return $2ea81f475bdaffaf$var$Tg(a), $2ea81f475bdaffaf$var$J = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$2ea81f475bdaffaf$var$Sf(a.type, a.memoizedProps));
    if (b && (b = $2ea81f475bdaffaf$var$Mg)) {
        if ($2ea81f475bdaffaf$var$Rg(a)) throw $2ea81f475bdaffaf$var$Vg(), Error($2ea81f475bdaffaf$var$p(418));
        for(; b;)$2ea81f475bdaffaf$var$Og(a, b), b = $2ea81f475bdaffaf$var$Zf(b.nextSibling);
    }
    $2ea81f475bdaffaf$var$Tg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($2ea81f475bdaffaf$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $2ea81f475bdaffaf$var$Mg = $2ea81f475bdaffaf$var$Zf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $2ea81f475bdaffaf$var$Mg = null;
        }
    } else $2ea81f475bdaffaf$var$Mg = $2ea81f475bdaffaf$var$Lg ? $2ea81f475bdaffaf$var$Zf(a.stateNode.nextSibling) : null;
    return !0;
}
function $2ea81f475bdaffaf$var$Vg() {
    for(var a = $2ea81f475bdaffaf$var$Mg; a;)a = $2ea81f475bdaffaf$var$Zf(a.nextSibling);
}
function $2ea81f475bdaffaf$var$Wg() {
    $2ea81f475bdaffaf$var$Mg = $2ea81f475bdaffaf$var$Lg = null;
    $2ea81f475bdaffaf$var$J = !1;
}
function $2ea81f475bdaffaf$var$Xg(a) {
    null === $2ea81f475bdaffaf$var$Ng ? $2ea81f475bdaffaf$var$Ng = [
        a
    ] : $2ea81f475bdaffaf$var$Ng.push(a);
}
var $2ea81f475bdaffaf$var$Yg = $2ea81f475bdaffaf$var$va.ReactCurrentBatchConfig;
function $2ea81f475bdaffaf$var$Zg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($2ea81f475bdaffaf$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($2ea81f475bdaffaf$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($2ea81f475bdaffaf$var$p(284));
        if (!c._owner) throw Error($2ea81f475bdaffaf$var$p(290, a));
    }
    return a;
}
function $2ea81f475bdaffaf$var$$g(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($2ea81f475bdaffaf$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $2ea81f475bdaffaf$var$ah(a) {
    var b = a._init;
    return b(a._payload);
}
function $2ea81f475bdaffaf$var$bh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $2ea81f475bdaffaf$var$ch(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $2ea81f475bdaffaf$var$dh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $2ea81f475bdaffaf$var$ya) return n(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $2ea81f475bdaffaf$var$Ha && $2ea81f475bdaffaf$var$ah(f) === b.type)) return d = e(b, c.props), d.ref = $2ea81f475bdaffaf$var$Zg(a, b, c), d.return = a, d;
        d = $2ea81f475bdaffaf$var$eh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $2ea81f475bdaffaf$var$Zg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $2ea81f475bdaffaf$var$fh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function n(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $2ea81f475bdaffaf$var$gh(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $2ea81f475bdaffaf$var$dh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $2ea81f475bdaffaf$var$wa:
                    return c = $2ea81f475bdaffaf$var$eh(b.type, b.key, b.props, null, a.mode, c), c.ref = $2ea81f475bdaffaf$var$Zg(a, null, b), c.return = a, c;
                case $2ea81f475bdaffaf$var$xa:
                    return b = $2ea81f475bdaffaf$var$fh(b, a.mode, c), b.return = a, b;
                case $2ea81f475bdaffaf$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($2ea81f475bdaffaf$var$db(b) || $2ea81f475bdaffaf$var$Ka(b)) return b = $2ea81f475bdaffaf$var$gh(b, a.mode, c, null), b.return = a, b;
            $2ea81f475bdaffaf$var$$g(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $2ea81f475bdaffaf$var$wa:
                    return c.key === e ? k(a, b, c, d) : null;
                case $2ea81f475bdaffaf$var$xa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $2ea81f475bdaffaf$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($2ea81f475bdaffaf$var$db(c) || $2ea81f475bdaffaf$var$Ka(c)) return null !== e ? null : n(a, b, c, d, null);
            $2ea81f475bdaffaf$var$$g(a, c);
        }
        return null;
    }
    function z(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $2ea81f475bdaffaf$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $2ea81f475bdaffaf$var$xa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $2ea81f475bdaffaf$var$Ha:
                    var f = d._init;
                    return z(a, b, c, f(d._payload), e);
            }
            if ($2ea81f475bdaffaf$var$db(d) || $2ea81f475bdaffaf$var$Ka(d)) return a = a.get(c) || null, n(b, a, d, e, null);
            $2ea81f475bdaffaf$var$$g(b, d);
        }
        return null;
    }
    function m(e, g, h, k) {
        for(var l = null, v = null, n = g, m = g = 0, y = null; null !== n && m < h.length; m++){
            n.index > m ? (y = n, n = null) : y = n.sibling;
            var x = r(e, n, h[m], k);
            if (null === x) {
                null === n && (n = y);
                break;
            }
            a && n && null === x.alternate && b(e, n);
            g = f(x, g, m);
            null === v ? l = x : v.sibling = x;
            v = x;
            n = y;
        }
        if (m === h.length) return c(e, n), $2ea81f475bdaffaf$var$J && $2ea81f475bdaffaf$var$Hg(e, m), l;
        if (null === n) {
            for(; m < h.length; m++)n = q(e, h[m], k), null !== n && (g = f(n, g, m), null === v ? l = n : v.sibling = n, v = n);
            $2ea81f475bdaffaf$var$J && $2ea81f475bdaffaf$var$Hg(e, m);
            return l;
        }
        for(n = d(e, n); m < h.length; m++)y = z(n, e, m, h[m], k), null !== y && (a && null !== y.alternate && n.delete(null === y.key ? m : y.key), g = f(y, g, m), null === v ? l = y : v.sibling = y, v = y);
        a && n.forEach(function(a) {
            return b(e, a);
        });
        $2ea81f475bdaffaf$var$J && $2ea81f475bdaffaf$var$Hg(e, m);
        return l;
    }
    function w(e, g, h, k) {
        var l = $2ea81f475bdaffaf$var$Ka(h);
        if ("function" !== typeof l) throw Error($2ea81f475bdaffaf$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($2ea81f475bdaffaf$var$p(151));
        for(var n = l = null, m = g, v = g = 0, y = null, x = h.next(); null !== m && !x.done; v++, x = h.next()){
            m.index > v ? (y = m, m = null) : y = m.sibling;
            var w = r(e, m, x.value, k);
            if (null === w) {
                null === m && (m = y);
                break;
            }
            a && m && null === w.alternate && b(e, m);
            g = f(w, g, v);
            null === n ? l = w : n.sibling = w;
            n = w;
            m = y;
        }
        if (x.done) return c(e, m), $2ea81f475bdaffaf$var$J && $2ea81f475bdaffaf$var$Hg(e, v), l;
        if (null === m) {
            for(; !x.done; v++, x = h.next())x = q(e, x.value, k), null !== x && (g = f(x, g, v), null === n ? l = x : n.sibling = x, n = x);
            $2ea81f475bdaffaf$var$J && $2ea81f475bdaffaf$var$Hg(e, v);
            return l;
        }
        for(m = d(e, m); !x.done; v++, x = h.next())x = z(m, e, v, x.value, k), null !== x && (a && null !== x.alternate && m.delete(null === x.key ? v : x.key), g = f(x, g, v), null === n ? l = x : n.sibling = x, n = x);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $2ea81f475bdaffaf$var$J && $2ea81f475bdaffaf$var$Hg(e, v);
        return l;
    }
    function C(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $2ea81f475bdaffaf$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $2ea81f475bdaffaf$var$wa:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $2ea81f475bdaffaf$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $2ea81f475bdaffaf$var$Ha && $2ea81f475bdaffaf$var$ah(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $2ea81f475bdaffaf$var$Zg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $2ea81f475bdaffaf$var$ya ? (d = $2ea81f475bdaffaf$var$gh(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $2ea81f475bdaffaf$var$eh(f.type, f.key, f.props, null, a.mode, h), h.ref = $2ea81f475bdaffaf$var$Zg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $2ea81f475bdaffaf$var$xa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $2ea81f475bdaffaf$var$fh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $2ea81f475bdaffaf$var$Ha:
                    return l = f._init, C(a, d, l(f._payload), h);
            }
            if ($2ea81f475bdaffaf$var$db(f)) return m(a, d, f, h);
            if ($2ea81f475bdaffaf$var$Ka(f)) return w(a, d, f, h);
            $2ea81f475bdaffaf$var$$g(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $2ea81f475bdaffaf$var$dh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return C;
}
var $2ea81f475bdaffaf$var$hh = $2ea81f475bdaffaf$var$bh(!0), $2ea81f475bdaffaf$var$ih = $2ea81f475bdaffaf$var$bh(!1), $2ea81f475bdaffaf$var$jh = $2ea81f475bdaffaf$var$hg(null), $2ea81f475bdaffaf$var$kh = null, $2ea81f475bdaffaf$var$lh = null, $2ea81f475bdaffaf$var$mh = null;
function $2ea81f475bdaffaf$var$nh() {
    $2ea81f475bdaffaf$var$mh = $2ea81f475bdaffaf$var$lh = $2ea81f475bdaffaf$var$kh = null;
}
function $2ea81f475bdaffaf$var$oh(a) {
    var b = $2ea81f475bdaffaf$var$jh.current;
    $2ea81f475bdaffaf$var$G($2ea81f475bdaffaf$var$jh);
    a._currentValue = b;
}
function $2ea81f475bdaffaf$var$ph(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $2ea81f475bdaffaf$var$qh(a, b) {
    $2ea81f475bdaffaf$var$kh = a;
    $2ea81f475bdaffaf$var$mh = $2ea81f475bdaffaf$var$lh = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($2ea81f475bdaffaf$var$rh = !0), a.firstContext = null);
}
function $2ea81f475bdaffaf$var$sh(a) {
    var b = a._currentValue;
    if ($2ea81f475bdaffaf$var$mh !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $2ea81f475bdaffaf$var$lh) {
            if (null === $2ea81f475bdaffaf$var$kh) throw Error($2ea81f475bdaffaf$var$p(308));
            $2ea81f475bdaffaf$var$lh = a;
            $2ea81f475bdaffaf$var$kh.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $2ea81f475bdaffaf$var$lh = $2ea81f475bdaffaf$var$lh.next = a;
    }
    return b;
}
var $2ea81f475bdaffaf$var$th = null;
function $2ea81f475bdaffaf$var$uh(a) {
    null === $2ea81f475bdaffaf$var$th ? $2ea81f475bdaffaf$var$th = [
        a
    ] : $2ea81f475bdaffaf$var$th.push(a);
}
function $2ea81f475bdaffaf$var$vh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $2ea81f475bdaffaf$var$uh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $2ea81f475bdaffaf$var$wh(a, d);
}
function $2ea81f475bdaffaf$var$wh(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $2ea81f475bdaffaf$var$xh = !1;
function $2ea81f475bdaffaf$var$yh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $2ea81f475bdaffaf$var$zh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $2ea81f475bdaffaf$var$Ah(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $2ea81f475bdaffaf$var$Bh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($2ea81f475bdaffaf$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $2ea81f475bdaffaf$var$wh(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $2ea81f475bdaffaf$var$uh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $2ea81f475bdaffaf$var$wh(a, c);
}
function $2ea81f475bdaffaf$var$Ch(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $2ea81f475bdaffaf$var$Oc(a, c);
    }
}
function $2ea81f475bdaffaf$var$Dh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $2ea81f475bdaffaf$var$Eh(a, b, c, d) {
    var e = a.updateQueue;
    $2ea81f475bdaffaf$var$xh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var n = a.alternate;
        null !== n && (n = n.updateQueue, h = n.lastBaseUpdate, h !== g && (null === h ? n.firstBaseUpdate = l : h.next = l, n.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        n = l = k = null;
        h = f;
        do {
            var r = h.lane, z = h.eventTime;
            if ((d & r) === r) {
                null !== n && (n = n.next = {
                    eventTime: z,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var m = a, w = h;
                    r = b;
                    z = c;
                    switch(w.tag){
                        case 1:
                            m = w.payload;
                            if ("function" === typeof m) {
                                q = m.call(z, q, r);
                                break a;
                            }
                            q = m;
                            break a;
                        case 3:
                            m.flags = m.flags & -65537 | 128;
                        case 0:
                            m = w.payload;
                            r = "function" === typeof m ? m.call(z, q, r) : m;
                            if (null === r || void 0 === r) break a;
                            q = $2ea81f475bdaffaf$var$u({}, q, r);
                            break a;
                        case 2:
                            $2ea81f475bdaffaf$var$xh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else z = {
                eventTime: z,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === n ? (l = n = z, k = q) : n = n.next = z, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === n && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = n;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $2ea81f475bdaffaf$var$Fh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $2ea81f475bdaffaf$var$Gh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($2ea81f475bdaffaf$var$p(191, e));
            e.call(d);
        }
    }
}
var $2ea81f475bdaffaf$var$Hh = {}, $2ea81f475bdaffaf$var$Ih = $2ea81f475bdaffaf$var$hg($2ea81f475bdaffaf$var$Hh), $2ea81f475bdaffaf$var$Jh = $2ea81f475bdaffaf$var$hg($2ea81f475bdaffaf$var$Hh), $2ea81f475bdaffaf$var$Kh = $2ea81f475bdaffaf$var$hg($2ea81f475bdaffaf$var$Hh);
function $2ea81f475bdaffaf$var$Lh(a) {
    if (a === $2ea81f475bdaffaf$var$Hh) throw Error($2ea81f475bdaffaf$var$p(174));
    return a;
}
function $2ea81f475bdaffaf$var$Mh(a, b) {
    $2ea81f475bdaffaf$var$H($2ea81f475bdaffaf$var$Kh, b);
    $2ea81f475bdaffaf$var$H($2ea81f475bdaffaf$var$Jh, a);
    $2ea81f475bdaffaf$var$H($2ea81f475bdaffaf$var$Ih, $2ea81f475bdaffaf$var$Hh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $2ea81f475bdaffaf$var$kb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $2ea81f475bdaffaf$var$kb(b, a);
    }
    $2ea81f475bdaffaf$var$G($2ea81f475bdaffaf$var$Ih);
    $2ea81f475bdaffaf$var$H($2ea81f475bdaffaf$var$Ih, b);
}
function $2ea81f475bdaffaf$var$Nh() {
    $2ea81f475bdaffaf$var$G($2ea81f475bdaffaf$var$Ih);
    $2ea81f475bdaffaf$var$G($2ea81f475bdaffaf$var$Jh);
    $2ea81f475bdaffaf$var$G($2ea81f475bdaffaf$var$Kh);
}
function $2ea81f475bdaffaf$var$Oh(a) {
    $2ea81f475bdaffaf$var$Lh($2ea81f475bdaffaf$var$Kh.current);
    var b = $2ea81f475bdaffaf$var$Lh($2ea81f475bdaffaf$var$Ih.current);
    var c = $2ea81f475bdaffaf$var$kb(b, a.type);
    b !== c && ($2ea81f475bdaffaf$var$H($2ea81f475bdaffaf$var$Jh, a), $2ea81f475bdaffaf$var$H($2ea81f475bdaffaf$var$Ih, c));
}
function $2ea81f475bdaffaf$var$Ph(a) {
    $2ea81f475bdaffaf$var$Jh.current === a && ($2ea81f475bdaffaf$var$G($2ea81f475bdaffaf$var$Ih), $2ea81f475bdaffaf$var$G($2ea81f475bdaffaf$var$Jh));
}
var $2ea81f475bdaffaf$var$L = $2ea81f475bdaffaf$var$hg(0);
function $2ea81f475bdaffaf$var$Qh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $2ea81f475bdaffaf$var$Rh = [];
function $2ea81f475bdaffaf$var$Sh() {
    for(var a = 0; a < $2ea81f475bdaffaf$var$Rh.length; a++)$2ea81f475bdaffaf$var$Rh[a]._workInProgressVersionPrimary = null;
    $2ea81f475bdaffaf$var$Rh.length = 0;
}
var $2ea81f475bdaffaf$var$Th = $2ea81f475bdaffaf$var$va.ReactCurrentDispatcher, $2ea81f475bdaffaf$var$Uh = $2ea81f475bdaffaf$var$va.ReactCurrentBatchConfig, $2ea81f475bdaffaf$var$Vh = 0, $2ea81f475bdaffaf$var$M = null, $2ea81f475bdaffaf$var$N = null, $2ea81f475bdaffaf$var$O = null, $2ea81f475bdaffaf$var$Wh = !1, $2ea81f475bdaffaf$var$Xh = !1, $2ea81f475bdaffaf$var$Yh = 0, $2ea81f475bdaffaf$var$Zh = 0;
function $2ea81f475bdaffaf$var$P() {
    throw Error($2ea81f475bdaffaf$var$p(321));
}
function $2ea81f475bdaffaf$var$$h(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$2ea81f475bdaffaf$var$Ve(a[c], b[c])) return !1;
    return !0;
}
function $2ea81f475bdaffaf$var$ai(a, b, c, d, e, f) {
    $2ea81f475bdaffaf$var$Vh = f;
    $2ea81f475bdaffaf$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $2ea81f475bdaffaf$var$Th.current = null === a || null === a.memoizedState ? $2ea81f475bdaffaf$var$bi : $2ea81f475bdaffaf$var$ci;
    a = c(d, e);
    if ($2ea81f475bdaffaf$var$Xh) {
        f = 0;
        do {
            $2ea81f475bdaffaf$var$Xh = !1;
            $2ea81f475bdaffaf$var$Yh = 0;
            if (25 <= f) throw Error($2ea81f475bdaffaf$var$p(301));
            f += 1;
            $2ea81f475bdaffaf$var$O = $2ea81f475bdaffaf$var$N = null;
            b.updateQueue = null;
            $2ea81f475bdaffaf$var$Th.current = $2ea81f475bdaffaf$var$di;
            a = c(d, e);
        }while ($2ea81f475bdaffaf$var$Xh);
    }
    $2ea81f475bdaffaf$var$Th.current = $2ea81f475bdaffaf$var$ei;
    b = null !== $2ea81f475bdaffaf$var$N && null !== $2ea81f475bdaffaf$var$N.next;
    $2ea81f475bdaffaf$var$Vh = 0;
    $2ea81f475bdaffaf$var$O = $2ea81f475bdaffaf$var$N = $2ea81f475bdaffaf$var$M = null;
    $2ea81f475bdaffaf$var$Wh = !1;
    if (b) throw Error($2ea81f475bdaffaf$var$p(300));
    return a;
}
function $2ea81f475bdaffaf$var$fi() {
    var a = 0 !== $2ea81f475bdaffaf$var$Yh;
    $2ea81f475bdaffaf$var$Yh = 0;
    return a;
}
function $2ea81f475bdaffaf$var$gi() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $2ea81f475bdaffaf$var$O ? $2ea81f475bdaffaf$var$M.memoizedState = $2ea81f475bdaffaf$var$O = a : $2ea81f475bdaffaf$var$O = $2ea81f475bdaffaf$var$O.next = a;
    return $2ea81f475bdaffaf$var$O;
}
function $2ea81f475bdaffaf$var$hi() {
    if (null === $2ea81f475bdaffaf$var$N) {
        var a = $2ea81f475bdaffaf$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $2ea81f475bdaffaf$var$N.next;
    var b = null === $2ea81f475bdaffaf$var$O ? $2ea81f475bdaffaf$var$M.memoizedState : $2ea81f475bdaffaf$var$O.next;
    if (null !== b) $2ea81f475bdaffaf$var$O = b, $2ea81f475bdaffaf$var$N = a;
    else {
        if (null === a) throw Error($2ea81f475bdaffaf$var$p(310));
        $2ea81f475bdaffaf$var$N = a;
        a = {
            memoizedState: $2ea81f475bdaffaf$var$N.memoizedState,
            baseState: $2ea81f475bdaffaf$var$N.baseState,
            baseQueue: $2ea81f475bdaffaf$var$N.baseQueue,
            queue: $2ea81f475bdaffaf$var$N.queue,
            next: null
        };
        null === $2ea81f475bdaffaf$var$O ? $2ea81f475bdaffaf$var$M.memoizedState = $2ea81f475bdaffaf$var$O = a : $2ea81f475bdaffaf$var$O = $2ea81f475bdaffaf$var$O.next = a;
    }
    return $2ea81f475bdaffaf$var$O;
}
function $2ea81f475bdaffaf$var$ii(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $2ea81f475bdaffaf$var$ji(a) {
    var b = $2ea81f475bdaffaf$var$hi(), c = b.queue;
    if (null === c) throw Error($2ea81f475bdaffaf$var$p(311));
    c.lastRenderedReducer = a;
    var d = $2ea81f475bdaffaf$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var n = l.lane;
            if (($2ea81f475bdaffaf$var$Vh & n) === n) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: n,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $2ea81f475bdaffaf$var$M.lanes |= n;
                $2ea81f475bdaffaf$var$Fh |= n;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $2ea81f475bdaffaf$var$Ve(d, b.memoizedState) || ($2ea81f475bdaffaf$var$rh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $2ea81f475bdaffaf$var$M.lanes |= f, $2ea81f475bdaffaf$var$Fh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $2ea81f475bdaffaf$var$ki(a) {
    var b = $2ea81f475bdaffaf$var$hi(), c = b.queue;
    if (null === c) throw Error($2ea81f475bdaffaf$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $2ea81f475bdaffaf$var$Ve(f, b.memoizedState) || ($2ea81f475bdaffaf$var$rh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $2ea81f475bdaffaf$var$li() {}
function $2ea81f475bdaffaf$var$mi(a, b) {
    var c = $2ea81f475bdaffaf$var$M, d = $2ea81f475bdaffaf$var$hi(), e = b(), f = !$2ea81f475bdaffaf$var$Ve(d.memoizedState, e);
    f && (d.memoizedState = e, $2ea81f475bdaffaf$var$rh = !0);
    d = d.queue;
    $2ea81f475bdaffaf$var$ni($2ea81f475bdaffaf$var$oi.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $2ea81f475bdaffaf$var$O && $2ea81f475bdaffaf$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $2ea81f475bdaffaf$var$pi(9, $2ea81f475bdaffaf$var$qi.bind(null, c, d, e, b), void 0, null);
        if (null === $2ea81f475bdaffaf$var$Q) throw Error($2ea81f475bdaffaf$var$p(349));
        0 !== ($2ea81f475bdaffaf$var$Vh & 30) || $2ea81f475bdaffaf$var$ri(c, b, e);
    }
    return e;
}
function $2ea81f475bdaffaf$var$ri(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $2ea81f475bdaffaf$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $2ea81f475bdaffaf$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $2ea81f475bdaffaf$var$qi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $2ea81f475bdaffaf$var$si(b) && $2ea81f475bdaffaf$var$ti(a);
}
function $2ea81f475bdaffaf$var$oi(a, b, c) {
    return c(function() {
        $2ea81f475bdaffaf$var$si(b) && $2ea81f475bdaffaf$var$ti(a);
    });
}
function $2ea81f475bdaffaf$var$si(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$2ea81f475bdaffaf$var$Ve(a, c);
    } catch (d) {
        return !0;
    }
}
function $2ea81f475bdaffaf$var$ti(a) {
    var b = $2ea81f475bdaffaf$var$wh(a, 1);
    null !== b && $2ea81f475bdaffaf$var$ui(b, a, 1, -1);
}
function $2ea81f475bdaffaf$var$vi(a) {
    var b = $2ea81f475bdaffaf$var$gi();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $2ea81f475bdaffaf$var$ii,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $2ea81f475bdaffaf$var$wi.bind(null, $2ea81f475bdaffaf$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $2ea81f475bdaffaf$var$pi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $2ea81f475bdaffaf$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $2ea81f475bdaffaf$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $2ea81f475bdaffaf$var$xi() {
    return $2ea81f475bdaffaf$var$hi().memoizedState;
}
function $2ea81f475bdaffaf$var$Ai(a, b, c, d) {
    var e = $2ea81f475bdaffaf$var$gi();
    $2ea81f475bdaffaf$var$M.flags |= a;
    e.memoizedState = $2ea81f475bdaffaf$var$pi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $2ea81f475bdaffaf$var$Bi(a, b, c, d) {
    var e = $2ea81f475bdaffaf$var$hi();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $2ea81f475bdaffaf$var$N) {
        var g = $2ea81f475bdaffaf$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $2ea81f475bdaffaf$var$$h(d, g.deps)) {
            e.memoizedState = $2ea81f475bdaffaf$var$pi(b, c, f, d);
            return;
        }
    }
    $2ea81f475bdaffaf$var$M.flags |= a;
    e.memoizedState = $2ea81f475bdaffaf$var$pi(1 | b, c, f, d);
}
function $2ea81f475bdaffaf$var$Ci(a, b) {
    return $2ea81f475bdaffaf$var$Ai(8390656, 8, a, b);
}
function $2ea81f475bdaffaf$var$ni(a, b) {
    return $2ea81f475bdaffaf$var$Bi(2048, 8, a, b);
}
function $2ea81f475bdaffaf$var$Di(a, b) {
    return $2ea81f475bdaffaf$var$Bi(4, 2, a, b);
}
function $2ea81f475bdaffaf$var$Ei(a, b) {
    return $2ea81f475bdaffaf$var$Bi(4, 4, a, b);
}
function $2ea81f475bdaffaf$var$Fi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $2ea81f475bdaffaf$var$Gi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $2ea81f475bdaffaf$var$Bi(4, 4, $2ea81f475bdaffaf$var$Fi.bind(null, b, a), c);
}
function $2ea81f475bdaffaf$var$Hi() {}
function $2ea81f475bdaffaf$var$Ii(a, b) {
    var c = $2ea81f475bdaffaf$var$hi();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $2ea81f475bdaffaf$var$$h(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $2ea81f475bdaffaf$var$Ji(a, b) {
    var c = $2ea81f475bdaffaf$var$hi();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $2ea81f475bdaffaf$var$$h(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $2ea81f475bdaffaf$var$Ki(a, b, c) {
    if (0 === ($2ea81f475bdaffaf$var$Vh & 21)) return a.baseState && (a.baseState = !1, $2ea81f475bdaffaf$var$rh = !0), a.memoizedState = c;
    $2ea81f475bdaffaf$var$Ve(c, b) || (c = $2ea81f475bdaffaf$var$Kc(), $2ea81f475bdaffaf$var$M.lanes |= c, $2ea81f475bdaffaf$var$Fh |= c, a.baseState = !0);
    return b;
}
function $2ea81f475bdaffaf$var$Li(a, b) {
    var c = $2ea81f475bdaffaf$var$E;
    $2ea81f475bdaffaf$var$E = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $2ea81f475bdaffaf$var$Uh.transition;
    $2ea81f475bdaffaf$var$Uh.transition = {};
    try {
        a(!1), b();
    } finally{
        $2ea81f475bdaffaf$var$E = c, $2ea81f475bdaffaf$var$Uh.transition = d;
    }
}
function $2ea81f475bdaffaf$var$Mi() {
    return $2ea81f475bdaffaf$var$hi().memoizedState;
}
function $2ea81f475bdaffaf$var$Ni(a, b, c) {
    var d = $2ea81f475bdaffaf$var$Oi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($2ea81f475bdaffaf$var$Pi(a)) $2ea81f475bdaffaf$var$Qi(b, c);
    else if (c = $2ea81f475bdaffaf$var$vh(a, b, c, d), null !== c) {
        var e = $2ea81f475bdaffaf$var$Ri();
        $2ea81f475bdaffaf$var$ui(c, a, d, e);
        $2ea81f475bdaffaf$var$Si(c, b, d);
    }
    $2ea81f475bdaffaf$var$yc(a, d);
}
function $2ea81f475bdaffaf$var$wi(a, b, c) {
    var d = $2ea81f475bdaffaf$var$Oi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($2ea81f475bdaffaf$var$Pi(a)) $2ea81f475bdaffaf$var$Qi(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($2ea81f475bdaffaf$var$Ve(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $2ea81f475bdaffaf$var$uh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $2ea81f475bdaffaf$var$vh(a, b, e, d);
        null !== c && (e = $2ea81f475bdaffaf$var$Ri(), $2ea81f475bdaffaf$var$ui(c, a, d, e), $2ea81f475bdaffaf$var$Si(c, b, d));
    }
    $2ea81f475bdaffaf$var$yc(a, d);
}
function $2ea81f475bdaffaf$var$Pi(a) {
    var b = a.alternate;
    return a === $2ea81f475bdaffaf$var$M || null !== b && b === $2ea81f475bdaffaf$var$M;
}
function $2ea81f475bdaffaf$var$Qi(a, b) {
    $2ea81f475bdaffaf$var$Xh = $2ea81f475bdaffaf$var$Wh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $2ea81f475bdaffaf$var$Si(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $2ea81f475bdaffaf$var$Oc(a, c);
    }
}
var $2ea81f475bdaffaf$var$ei = {
    readContext: $2ea81f475bdaffaf$var$sh,
    useCallback: $2ea81f475bdaffaf$var$P,
    useContext: $2ea81f475bdaffaf$var$P,
    useEffect: $2ea81f475bdaffaf$var$P,
    useImperativeHandle: $2ea81f475bdaffaf$var$P,
    useInsertionEffect: $2ea81f475bdaffaf$var$P,
    useLayoutEffect: $2ea81f475bdaffaf$var$P,
    useMemo: $2ea81f475bdaffaf$var$P,
    useReducer: $2ea81f475bdaffaf$var$P,
    useRef: $2ea81f475bdaffaf$var$P,
    useState: $2ea81f475bdaffaf$var$P,
    useDebugValue: $2ea81f475bdaffaf$var$P,
    useDeferredValue: $2ea81f475bdaffaf$var$P,
    useTransition: $2ea81f475bdaffaf$var$P,
    useMutableSource: $2ea81f475bdaffaf$var$P,
    useSyncExternalStore: $2ea81f475bdaffaf$var$P,
    useId: $2ea81f475bdaffaf$var$P,
    unstable_isNewReconciler: !1
}, $2ea81f475bdaffaf$var$bi = {
    readContext: $2ea81f475bdaffaf$var$sh,
    useCallback: function(a, b) {
        $2ea81f475bdaffaf$var$gi().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $2ea81f475bdaffaf$var$sh,
    useEffect: $2ea81f475bdaffaf$var$Ci,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $2ea81f475bdaffaf$var$Ai(4194308, 4, $2ea81f475bdaffaf$var$Fi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $2ea81f475bdaffaf$var$Ai(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $2ea81f475bdaffaf$var$Ai(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $2ea81f475bdaffaf$var$gi();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $2ea81f475bdaffaf$var$gi();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $2ea81f475bdaffaf$var$Ni.bind(null, $2ea81f475bdaffaf$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $2ea81f475bdaffaf$var$gi();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $2ea81f475bdaffaf$var$vi,
    useDebugValue: $2ea81f475bdaffaf$var$Hi,
    useDeferredValue: function(a) {
        return $2ea81f475bdaffaf$var$gi().memoizedState = a;
    },
    useTransition: function() {
        var a = $2ea81f475bdaffaf$var$vi(!1), b = a[0];
        a = $2ea81f475bdaffaf$var$Li.bind(null, a[1]);
        $2ea81f475bdaffaf$var$gi().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $2ea81f475bdaffaf$var$M, e = $2ea81f475bdaffaf$var$gi();
        if ($2ea81f475bdaffaf$var$J) {
            if (void 0 === c) throw Error($2ea81f475bdaffaf$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $2ea81f475bdaffaf$var$Q) throw Error($2ea81f475bdaffaf$var$p(349));
            0 !== ($2ea81f475bdaffaf$var$Vh & 30) || $2ea81f475bdaffaf$var$ri(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $2ea81f475bdaffaf$var$Ci($2ea81f475bdaffaf$var$oi.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $2ea81f475bdaffaf$var$pi(9, $2ea81f475bdaffaf$var$qi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $2ea81f475bdaffaf$var$gi(), b = $2ea81f475bdaffaf$var$Q.identifierPrefix;
        if ($2ea81f475bdaffaf$var$J) {
            var c = $2ea81f475bdaffaf$var$Gg;
            var d = $2ea81f475bdaffaf$var$Fg;
            c = (d & ~(1 << 32 - $2ea81f475bdaffaf$var$Ac(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $2ea81f475bdaffaf$var$Yh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $2ea81f475bdaffaf$var$Zh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $2ea81f475bdaffaf$var$ci = {
    readContext: $2ea81f475bdaffaf$var$sh,
    useCallback: $2ea81f475bdaffaf$var$Ii,
    useContext: $2ea81f475bdaffaf$var$sh,
    useEffect: $2ea81f475bdaffaf$var$ni,
    useImperativeHandle: $2ea81f475bdaffaf$var$Gi,
    useInsertionEffect: $2ea81f475bdaffaf$var$Di,
    useLayoutEffect: $2ea81f475bdaffaf$var$Ei,
    useMemo: $2ea81f475bdaffaf$var$Ji,
    useReducer: $2ea81f475bdaffaf$var$ji,
    useRef: $2ea81f475bdaffaf$var$xi,
    useState: function() {
        return $2ea81f475bdaffaf$var$ji($2ea81f475bdaffaf$var$ii);
    },
    useDebugValue: $2ea81f475bdaffaf$var$Hi,
    useDeferredValue: function(a) {
        var b = $2ea81f475bdaffaf$var$hi();
        return $2ea81f475bdaffaf$var$Ki(b, $2ea81f475bdaffaf$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $2ea81f475bdaffaf$var$ji($2ea81f475bdaffaf$var$ii)[0], b = $2ea81f475bdaffaf$var$hi().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $2ea81f475bdaffaf$var$li,
    useSyncExternalStore: $2ea81f475bdaffaf$var$mi,
    useId: $2ea81f475bdaffaf$var$Mi,
    unstable_isNewReconciler: !1
}, $2ea81f475bdaffaf$var$di = {
    readContext: $2ea81f475bdaffaf$var$sh,
    useCallback: $2ea81f475bdaffaf$var$Ii,
    useContext: $2ea81f475bdaffaf$var$sh,
    useEffect: $2ea81f475bdaffaf$var$ni,
    useImperativeHandle: $2ea81f475bdaffaf$var$Gi,
    useInsertionEffect: $2ea81f475bdaffaf$var$Di,
    useLayoutEffect: $2ea81f475bdaffaf$var$Ei,
    useMemo: $2ea81f475bdaffaf$var$Ji,
    useReducer: $2ea81f475bdaffaf$var$ki,
    useRef: $2ea81f475bdaffaf$var$xi,
    useState: function() {
        return $2ea81f475bdaffaf$var$ki($2ea81f475bdaffaf$var$ii);
    },
    useDebugValue: $2ea81f475bdaffaf$var$Hi,
    useDeferredValue: function(a) {
        var b = $2ea81f475bdaffaf$var$hi();
        return null === $2ea81f475bdaffaf$var$N ? b.memoizedState = a : $2ea81f475bdaffaf$var$Ki(b, $2ea81f475bdaffaf$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $2ea81f475bdaffaf$var$ki($2ea81f475bdaffaf$var$ii)[0], b = $2ea81f475bdaffaf$var$hi().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $2ea81f475bdaffaf$var$li,
    useSyncExternalStore: $2ea81f475bdaffaf$var$mi,
    useId: $2ea81f475bdaffaf$var$Mi,
    unstable_isNewReconciler: !1
}, $2ea81f475bdaffaf$var$Ti = $jbhXM.unstable_now, $2ea81f475bdaffaf$var$Ui = 0, $2ea81f475bdaffaf$var$Vi = -1, $2ea81f475bdaffaf$var$Wi = -1, $2ea81f475bdaffaf$var$Xi = -1, $2ea81f475bdaffaf$var$Yi = !1, $2ea81f475bdaffaf$var$Zi = !1;
function $2ea81f475bdaffaf$var$$i(a, b) {
    if (0 <= $2ea81f475bdaffaf$var$Wi) {
        var c = $2ea81f475bdaffaf$var$Ti() - $2ea81f475bdaffaf$var$Wi;
        a.actualDuration += c;
        b && (a.selfBaseDuration = c);
        $2ea81f475bdaffaf$var$Wi = -1;
    }
}
function $2ea81f475bdaffaf$var$aj(a) {
    if (0 <= $2ea81f475bdaffaf$var$Vi) {
        var b = $2ea81f475bdaffaf$var$Ti() - $2ea81f475bdaffaf$var$Vi;
        $2ea81f475bdaffaf$var$Vi = -1;
        for(a = a.return; null !== a;){
            switch(a.tag){
                case 3:
                    a.stateNode.effectDuration += b;
                    return;
                case 12:
                    a.stateNode.effectDuration += b;
                    return;
            }
            a = a.return;
        }
    }
}
function $2ea81f475bdaffaf$var$bj(a) {
    if (0 <= $2ea81f475bdaffaf$var$Xi) {
        var b = $2ea81f475bdaffaf$var$Ti() - $2ea81f475bdaffaf$var$Xi;
        $2ea81f475bdaffaf$var$Xi = -1;
        for(a = a.return; null !== a;){
            switch(a.tag){
                case 3:
                    a = a.stateNode;
                    null !== a && (a.passiveEffectDuration += b);
                    return;
                case 12:
                    a = a.stateNode;
                    null !== a && (a.passiveEffectDuration += b);
                    return;
            }
            a = a.return;
        }
    }
}
function $2ea81f475bdaffaf$var$cj() {
    $2ea81f475bdaffaf$var$Vi = $2ea81f475bdaffaf$var$Ti();
}
function $2ea81f475bdaffaf$var$dj(a) {
    for(var b = a.child; b;)a.actualDuration += b.actualDuration, b = b.sibling;
}
function $2ea81f475bdaffaf$var$ej(a, b) {
    if (a && a.defaultProps) {
        b = $2ea81f475bdaffaf$var$u({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $2ea81f475bdaffaf$var$fj(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $2ea81f475bdaffaf$var$u({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $2ea81f475bdaffaf$var$gj = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $2ea81f475bdaffaf$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $2ea81f475bdaffaf$var$Ri(), e = $2ea81f475bdaffaf$var$Oi(a), f = $2ea81f475bdaffaf$var$Ah(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $2ea81f475bdaffaf$var$Bh(a, f, e);
        null !== b && ($2ea81f475bdaffaf$var$ui(b, a, e, d), $2ea81f475bdaffaf$var$Ch(b, a, e));
        $2ea81f475bdaffaf$var$yc(a, e);
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $2ea81f475bdaffaf$var$Ri(), e = $2ea81f475bdaffaf$var$Oi(a), f = $2ea81f475bdaffaf$var$Ah(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $2ea81f475bdaffaf$var$Bh(a, f, e);
        null !== b && ($2ea81f475bdaffaf$var$ui(b, a, e, d), $2ea81f475bdaffaf$var$Ch(b, a, e));
        $2ea81f475bdaffaf$var$yc(a, e);
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $2ea81f475bdaffaf$var$Ri(), d = $2ea81f475bdaffaf$var$Oi(a), e = $2ea81f475bdaffaf$var$Ah(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $2ea81f475bdaffaf$var$Bh(a, e, d);
        null !== b && ($2ea81f475bdaffaf$var$ui(b, a, d, c), $2ea81f475bdaffaf$var$Ch(b, a, d));
        null !== $2ea81f475bdaffaf$var$B && "function" === typeof $2ea81f475bdaffaf$var$B.markForceUpdateScheduled && $2ea81f475bdaffaf$var$B.markForceUpdateScheduled(a, d);
    }
};
function $2ea81f475bdaffaf$var$hj(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$2ea81f475bdaffaf$var$We(c, d) || !$2ea81f475bdaffaf$var$We(e, f) : !0;
}
function $2ea81f475bdaffaf$var$ij(a, b, c) {
    var d = !1, e = $2ea81f475bdaffaf$var$ig;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $2ea81f475bdaffaf$var$sh(f) : (e = $2ea81f475bdaffaf$var$mg(b) ? $2ea81f475bdaffaf$var$kg : $2ea81f475bdaffaf$var$I.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $2ea81f475bdaffaf$var$lg(a, e) : $2ea81f475bdaffaf$var$ig);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $2ea81f475bdaffaf$var$gj;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $2ea81f475bdaffaf$var$jj(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $2ea81f475bdaffaf$var$gj.enqueueReplaceState(b, b.state, null);
}
function $2ea81f475bdaffaf$var$kj(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $2ea81f475bdaffaf$var$yh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $2ea81f475bdaffaf$var$sh(f) : (f = $2ea81f475bdaffaf$var$mg(b) ? $2ea81f475bdaffaf$var$kg : $2ea81f475bdaffaf$var$I.current, e.context = $2ea81f475bdaffaf$var$lg(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($2ea81f475bdaffaf$var$fj(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $2ea81f475bdaffaf$var$gj.enqueueReplaceState(e, e.state, null), $2ea81f475bdaffaf$var$Eh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $2ea81f475bdaffaf$var$lj(a, b) {
    try {
        var c = "", d = b;
        do c += $2ea81f475bdaffaf$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $2ea81f475bdaffaf$var$mj(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $2ea81f475bdaffaf$var$nj(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $2ea81f475bdaffaf$var$oj = "function" === typeof WeakMap ? WeakMap : Map;
function $2ea81f475bdaffaf$var$pj(a, b, c) {
    c = $2ea81f475bdaffaf$var$Ah(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $2ea81f475bdaffaf$var$qj || ($2ea81f475bdaffaf$var$qj = !0, $2ea81f475bdaffaf$var$rj = d);
        $2ea81f475bdaffaf$var$nj(a, b);
    };
    return c;
}
function $2ea81f475bdaffaf$var$sj(a, b, c) {
    c = $2ea81f475bdaffaf$var$Ah(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $2ea81f475bdaffaf$var$nj(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $2ea81f475bdaffaf$var$nj(a, b);
        "function" !== typeof d && (null === $2ea81f475bdaffaf$var$tj ? $2ea81f475bdaffaf$var$tj = new Set([
            this
        ]) : $2ea81f475bdaffaf$var$tj.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $2ea81f475bdaffaf$var$uj(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $2ea81f475bdaffaf$var$oj;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), d = $2ea81f475bdaffaf$var$vj.bind(null, a, b, c), $2ea81f475bdaffaf$var$mc && $2ea81f475bdaffaf$var$wj(a, c), b.then(d, d));
}
function $2ea81f475bdaffaf$var$xj(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $2ea81f475bdaffaf$var$yj(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $2ea81f475bdaffaf$var$Ah(-1, 1), b.tag = 2, $2ea81f475bdaffaf$var$Bh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $2ea81f475bdaffaf$var$zj = $2ea81f475bdaffaf$var$va.ReactCurrentOwner, $2ea81f475bdaffaf$var$rh = !1;
function $2ea81f475bdaffaf$var$Aj(a, b, c, d) {
    b.child = null === a ? $2ea81f475bdaffaf$var$ih(b, null, c, d) : $2ea81f475bdaffaf$var$hh(b, a.child, c, d);
}
function $2ea81f475bdaffaf$var$Bj(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $2ea81f475bdaffaf$var$qh(b, e);
    $2ea81f475bdaffaf$var$sc(b);
    d = $2ea81f475bdaffaf$var$ai(a, b, c, d, f, e);
    c = $2ea81f475bdaffaf$var$fi();
    $2ea81f475bdaffaf$var$tc();
    if (null !== a && !$2ea81f475bdaffaf$var$rh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $2ea81f475bdaffaf$var$Cj(a, b, e);
    $2ea81f475bdaffaf$var$J && c && $2ea81f475bdaffaf$var$Jg(b);
    b.flags |= 1;
    $2ea81f475bdaffaf$var$Aj(a, b, d, e);
    return b.child;
}
function $2ea81f475bdaffaf$var$Dj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$2ea81f475bdaffaf$var$Ej(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $2ea81f475bdaffaf$var$Fj(a, b, f, d, e);
        a = $2ea81f475bdaffaf$var$eh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $2ea81f475bdaffaf$var$We;
        if (c(g, d) && a.ref === b.ref) return $2ea81f475bdaffaf$var$Cj(a, b, e);
    }
    b.flags |= 1;
    a = $2ea81f475bdaffaf$var$ch(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $2ea81f475bdaffaf$var$Fj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($2ea81f475bdaffaf$var$We(f, d) && a.ref === b.ref) {
            if ($2ea81f475bdaffaf$var$rh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($2ea81f475bdaffaf$var$rh = !0);
            else return b.lanes = a.lanes, $2ea81f475bdaffaf$var$Cj(a, b, e);
        }
    }
    return $2ea81f475bdaffaf$var$Gj(a, b, c, d, e);
}
function $2ea81f475bdaffaf$var$Hj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $2ea81f475bdaffaf$var$H($2ea81f475bdaffaf$var$Ij, $2ea81f475bdaffaf$var$Jj), $2ea81f475bdaffaf$var$Jj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $2ea81f475bdaffaf$var$H($2ea81f475bdaffaf$var$Ij, $2ea81f475bdaffaf$var$Jj), $2ea81f475bdaffaf$var$Jj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $2ea81f475bdaffaf$var$H($2ea81f475bdaffaf$var$Ij, $2ea81f475bdaffaf$var$Jj);
            $2ea81f475bdaffaf$var$Jj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $2ea81f475bdaffaf$var$H($2ea81f475bdaffaf$var$Ij, $2ea81f475bdaffaf$var$Jj), $2ea81f475bdaffaf$var$Jj |= d;
    $2ea81f475bdaffaf$var$Aj(a, b, e, c);
    return b.child;
}
function $2ea81f475bdaffaf$var$Kj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $2ea81f475bdaffaf$var$Gj(a, b, c, d, e) {
    var f = $2ea81f475bdaffaf$var$mg(c) ? $2ea81f475bdaffaf$var$kg : $2ea81f475bdaffaf$var$I.current;
    f = $2ea81f475bdaffaf$var$lg(b, f);
    $2ea81f475bdaffaf$var$qh(b, e);
    $2ea81f475bdaffaf$var$sc(b);
    c = $2ea81f475bdaffaf$var$ai(a, b, c, d, f, e);
    d = $2ea81f475bdaffaf$var$fi();
    $2ea81f475bdaffaf$var$tc();
    if (null !== a && !$2ea81f475bdaffaf$var$rh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $2ea81f475bdaffaf$var$Cj(a, b, e);
    $2ea81f475bdaffaf$var$J && d && $2ea81f475bdaffaf$var$Jg(b);
    b.flags |= 1;
    $2ea81f475bdaffaf$var$Aj(a, b, c, e);
    return b.child;
}
function $2ea81f475bdaffaf$var$Lj(a, b, c, d, e) {
    if ($2ea81f475bdaffaf$var$mg(c)) {
        var f = !0;
        $2ea81f475bdaffaf$var$qg(b);
    } else f = !1;
    $2ea81f475bdaffaf$var$qh(b, e);
    if (null === b.stateNode) $2ea81f475bdaffaf$var$Mj(a, b), $2ea81f475bdaffaf$var$ij(b, c, d), $2ea81f475bdaffaf$var$kj(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $2ea81f475bdaffaf$var$sh(l) : (l = $2ea81f475bdaffaf$var$mg(c) ? $2ea81f475bdaffaf$var$kg : $2ea81f475bdaffaf$var$I.current, l = $2ea81f475bdaffaf$var$lg(b, l));
        var n = c.getDerivedStateFromProps, q = "function" === typeof n || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $2ea81f475bdaffaf$var$jj(b, g, d, l);
        $2ea81f475bdaffaf$var$xh = !1;
        var r = b.memoizedState;
        g.state = r;
        $2ea81f475bdaffaf$var$Eh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $2ea81f475bdaffaf$var$jg.current || $2ea81f475bdaffaf$var$xh ? ("function" === typeof n && ($2ea81f475bdaffaf$var$fj(b, c, n, d), k = b.memoizedState), (h = $2ea81f475bdaffaf$var$xh || $2ea81f475bdaffaf$var$hj(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $2ea81f475bdaffaf$var$zh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $2ea81f475bdaffaf$var$ej(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $2ea81f475bdaffaf$var$sh(k) : (k = $2ea81f475bdaffaf$var$mg(c) ? $2ea81f475bdaffaf$var$kg : $2ea81f475bdaffaf$var$I.current, k = $2ea81f475bdaffaf$var$lg(b, k));
        var z = c.getDerivedStateFromProps;
        (n = "function" === typeof z || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $2ea81f475bdaffaf$var$jj(b, g, d, k);
        $2ea81f475bdaffaf$var$xh = !1;
        r = b.memoizedState;
        g.state = r;
        $2ea81f475bdaffaf$var$Eh(b, d, g, e);
        var m = b.memoizedState;
        h !== q || r !== m || $2ea81f475bdaffaf$var$jg.current || $2ea81f475bdaffaf$var$xh ? ("function" === typeof z && ($2ea81f475bdaffaf$var$fj(b, c, z, d), m = b.memoizedState), (l = $2ea81f475bdaffaf$var$xh || $2ea81f475bdaffaf$var$hj(b, c, l, d, r, m, k) || !1) ? (n || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, m, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, m, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = m), g.props = d, g.state = m, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $2ea81f475bdaffaf$var$Nj(a, b, c, d, f, e);
}
function $2ea81f475bdaffaf$var$Nj(a, b, c, d, e, f) {
    $2ea81f475bdaffaf$var$Kj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $2ea81f475bdaffaf$var$rg(b, c, !1), $2ea81f475bdaffaf$var$Cj(a, b, f);
    d = b.stateNode;
    $2ea81f475bdaffaf$var$zj.current = b;
    if (g && "function" !== typeof c.getDerivedStateFromError) {
        var h = null;
        $2ea81f475bdaffaf$var$Wi = -1;
    } else $2ea81f475bdaffaf$var$sc(b), h = d.render(), $2ea81f475bdaffaf$var$tc();
    b.flags |= 1;
    null !== a && g ? (g = h, b.child = $2ea81f475bdaffaf$var$hh(b, a.child, null, f), b.child = $2ea81f475bdaffaf$var$hh(b, null, g, f)) : $2ea81f475bdaffaf$var$Aj(a, b, h, f);
    b.memoizedState = d.state;
    e && $2ea81f475bdaffaf$var$rg(b, c, !0);
    return b.child;
}
function $2ea81f475bdaffaf$var$Oj(a) {
    var b = a.stateNode;
    b.pendingContext ? $2ea81f475bdaffaf$var$og(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $2ea81f475bdaffaf$var$og(a, b.context, !1);
    $2ea81f475bdaffaf$var$Mh(a, b.containerInfo);
}
function $2ea81f475bdaffaf$var$Rj(a, b, c, d, e) {
    $2ea81f475bdaffaf$var$Wg();
    $2ea81f475bdaffaf$var$Xg(e);
    b.flags |= 256;
    $2ea81f475bdaffaf$var$Aj(a, b, c, d);
    return b.child;
}
var $2ea81f475bdaffaf$var$Sj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $2ea81f475bdaffaf$var$Tj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $2ea81f475bdaffaf$var$Uj(a, b, c) {
    var d = b.pendingProps, e = $2ea81f475bdaffaf$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $2ea81f475bdaffaf$var$H($2ea81f475bdaffaf$var$L, e & 1);
    if (null === a) {
        $2ea81f475bdaffaf$var$Sg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g, b.mode & 2 && (f.actualDuration = 0, f.actualStartTime = -1, f.selfBaseDuration = 0, f.treeBaseDuration = 0)) : f = $2ea81f475bdaffaf$var$Vj(g, d, 0, null), a = $2ea81f475bdaffaf$var$gh(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $2ea81f475bdaffaf$var$Tj(c), b.memoizedState = $2ea81f475bdaffaf$var$Sj, a) : $2ea81f475bdaffaf$var$Wj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $2ea81f475bdaffaf$var$Xj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.mode & 2 && (d.actualDuration = 0, d.actualStartTime = -1, d.selfBaseDuration = e.selfBaseDuration, d.treeBaseDuration = e.treeBaseDuration), b.deletions = null) : (d = $2ea81f475bdaffaf$var$ch(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $2ea81f475bdaffaf$var$ch(h, f) : (f = $2ea81f475bdaffaf$var$gh(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $2ea81f475bdaffaf$var$Tj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $2ea81f475bdaffaf$var$Sj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $2ea81f475bdaffaf$var$ch(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $2ea81f475bdaffaf$var$Wj(a, b) {
    b = $2ea81f475bdaffaf$var$Vj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $2ea81f475bdaffaf$var$Yj(a, b, c, d) {
    null !== d && $2ea81f475bdaffaf$var$Xg(d);
    $2ea81f475bdaffaf$var$hh(b, a.child, null, c);
    a = $2ea81f475bdaffaf$var$Wj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $2ea81f475bdaffaf$var$Xj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = globalThis.__ATL_CAPTURE_HYDRATION_ERROR_DETAILS ? $2ea81f475bdaffaf$var$lj(Error($2ea81f475bdaffaf$var$p(422)), a) : $2ea81f475bdaffaf$var$mj(Error($2ea81f475bdaffaf$var$p(422))), $2ea81f475bdaffaf$var$Yj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $2ea81f475bdaffaf$var$Vj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $2ea81f475bdaffaf$var$gh(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $2ea81f475bdaffaf$var$hh(b, a.child, null, g);
        b.child.memoizedState = $2ea81f475bdaffaf$var$Tj(g);
        b.memoizedState = $2ea81f475bdaffaf$var$Sj;
        return f;
    }
    if (0 === (b.mode & 1)) return $2ea81f475bdaffaf$var$Yj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($2ea81f475bdaffaf$var$p(419));
        d = $2ea81f475bdaffaf$var$mj(f, d, void 0);
        return $2ea81f475bdaffaf$var$Yj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($2ea81f475bdaffaf$var$rh || (globalThis.__ATL_SKIP_HAS_CONTEXT_CHANGED ? 0 : h)) {
        d = $2ea81f475bdaffaf$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $2ea81f475bdaffaf$var$wh(a, e), $2ea81f475bdaffaf$var$ui(d, a, e, -1));
        }
        $2ea81f475bdaffaf$var$Zj();
        d = globalThis.__ATL_CAPTURE_HYDRATION_ERROR_DETAILS ? $2ea81f475bdaffaf$var$lj(Error($2ea81f475bdaffaf$var$p(421)), a) : $2ea81f475bdaffaf$var$mj(Error($2ea81f475bdaffaf$var$p(421)));
        return $2ea81f475bdaffaf$var$Yj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $2ea81f475bdaffaf$var$ak.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $2ea81f475bdaffaf$var$Mg = $2ea81f475bdaffaf$var$Zf(e.nextSibling);
    $2ea81f475bdaffaf$var$Lg = b;
    $2ea81f475bdaffaf$var$J = !0;
    $2ea81f475bdaffaf$var$Ng = null;
    null !== a && ($2ea81f475bdaffaf$var$Cg[$2ea81f475bdaffaf$var$Dg++] = $2ea81f475bdaffaf$var$Fg, $2ea81f475bdaffaf$var$Cg[$2ea81f475bdaffaf$var$Dg++] = $2ea81f475bdaffaf$var$Gg, $2ea81f475bdaffaf$var$Cg[$2ea81f475bdaffaf$var$Dg++] = $2ea81f475bdaffaf$var$Eg, $2ea81f475bdaffaf$var$Fg = a.id, $2ea81f475bdaffaf$var$Gg = a.overflow, $2ea81f475bdaffaf$var$Eg = b);
    b = $2ea81f475bdaffaf$var$Wj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $2ea81f475bdaffaf$var$bk(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $2ea81f475bdaffaf$var$ph(a.return, b, c);
}
function $2ea81f475bdaffaf$var$ck(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $2ea81f475bdaffaf$var$dk(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $2ea81f475bdaffaf$var$Aj(a, b, d.children, c);
    d = $2ea81f475bdaffaf$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $2ea81f475bdaffaf$var$bk(a, c, b);
            else if (19 === a.tag) $2ea81f475bdaffaf$var$bk(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $2ea81f475bdaffaf$var$H($2ea81f475bdaffaf$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $2ea81f475bdaffaf$var$Qh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $2ea81f475bdaffaf$var$ck(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $2ea81f475bdaffaf$var$Qh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $2ea81f475bdaffaf$var$ck(b, !0, c, null, f);
            break;
        case "together":
            $2ea81f475bdaffaf$var$ck(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $2ea81f475bdaffaf$var$Mj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $2ea81f475bdaffaf$var$Cj(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $2ea81f475bdaffaf$var$Wi = -1;
    $2ea81f475bdaffaf$var$Fh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($2ea81f475bdaffaf$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $2ea81f475bdaffaf$var$ch(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $2ea81f475bdaffaf$var$ch(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $2ea81f475bdaffaf$var$ek(a, b, c) {
    switch(b.tag){
        case 3:
            $2ea81f475bdaffaf$var$Oj(b);
            $2ea81f475bdaffaf$var$Wg();
            break;
        case 5:
            $2ea81f475bdaffaf$var$Oh(b);
            break;
        case 1:
            $2ea81f475bdaffaf$var$mg(b.type) && $2ea81f475bdaffaf$var$qg(b);
            break;
        case 4:
            $2ea81f475bdaffaf$var$Mh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $2ea81f475bdaffaf$var$H($2ea81f475bdaffaf$var$jh, d._currentValue);
            d._currentValue = e;
            break;
        case 12:
            0 !== (c & b.childLanes) && (b.flags |= 4);
            d = b.stateNode;
            d.effectDuration = 0;
            d.passiveEffectDuration = 0;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $2ea81f475bdaffaf$var$H($2ea81f475bdaffaf$var$L, $2ea81f475bdaffaf$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $2ea81f475bdaffaf$var$Uj(a, b, c);
                $2ea81f475bdaffaf$var$H($2ea81f475bdaffaf$var$L, $2ea81f475bdaffaf$var$L.current & 1);
                a = $2ea81f475bdaffaf$var$Cj(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $2ea81f475bdaffaf$var$H($2ea81f475bdaffaf$var$L, $2ea81f475bdaffaf$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $2ea81f475bdaffaf$var$dk(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $2ea81f475bdaffaf$var$H($2ea81f475bdaffaf$var$L, $2ea81f475bdaffaf$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $2ea81f475bdaffaf$var$Hj(a, b, c);
    }
    return $2ea81f475bdaffaf$var$Cj(a, b, c);
}
var $2ea81f475bdaffaf$var$fk, $2ea81f475bdaffaf$var$gk, $2ea81f475bdaffaf$var$hk, $2ea81f475bdaffaf$var$ik;
$2ea81f475bdaffaf$var$fk = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$2ea81f475bdaffaf$var$gk = function() {};
$2ea81f475bdaffaf$var$hk = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $2ea81f475bdaffaf$var$Lh($2ea81f475bdaffaf$var$Ih.current);
        var f = null;
        switch(c){
            case "input":
                e = $2ea81f475bdaffaf$var$Ya(a, e);
                d = $2ea81f475bdaffaf$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $2ea81f475bdaffaf$var$u({}, e, {
                    value: void 0
                });
                d = $2ea81f475bdaffaf$var$u({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $2ea81f475bdaffaf$var$fb(a, e);
                d = $2ea81f475bdaffaf$var$fb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $2ea81f475bdaffaf$var$Pf);
        }
        $2ea81f475bdaffaf$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($2ea81f475bdaffaf$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($2ea81f475bdaffaf$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $2ea81f475bdaffaf$var$F("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$2ea81f475bdaffaf$var$ik = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $2ea81f475bdaffaf$var$jk(a, b) {
    if (!$2ea81f475bdaffaf$var$J) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $2ea81f475bdaffaf$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) {
        if (0 !== (a.mode & 2)) {
            for(var e = a.selfBaseDuration, f = a.child; null !== f;)c |= f.lanes | f.childLanes, d |= f.subtreeFlags & 14680064, d |= f.flags & 14680064, e += f.treeBaseDuration, f = f.sibling;
            a.treeBaseDuration = e;
        } else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    } else if (0 !== (a.mode & 2)) {
        e = a.actualDuration;
        f = a.selfBaseDuration;
        for(var g = a.child; null !== g;)c |= g.lanes | g.childLanes, d |= g.subtreeFlags, d |= g.flags, e += g.actualDuration, f += g.treeBaseDuration, g = g.sibling;
        a.actualDuration = e;
        a.treeBaseDuration = f;
    } else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $2ea81f475bdaffaf$var$kk(a, b, c) {
    var d = b.pendingProps;
    $2ea81f475bdaffaf$var$Kg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $2ea81f475bdaffaf$var$S(b), null;
        case 1:
            return $2ea81f475bdaffaf$var$mg(b.type) && $2ea81f475bdaffaf$var$ng(), $2ea81f475bdaffaf$var$S(b), null;
        case 3:
            d = b.stateNode;
            $2ea81f475bdaffaf$var$Nh();
            $2ea81f475bdaffaf$var$G($2ea81f475bdaffaf$var$jg);
            $2ea81f475bdaffaf$var$G($2ea81f475bdaffaf$var$I);
            $2ea81f475bdaffaf$var$Sh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $2ea81f475bdaffaf$var$Ug(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $2ea81f475bdaffaf$var$Ng && ($2ea81f475bdaffaf$var$lk($2ea81f475bdaffaf$var$Ng), $2ea81f475bdaffaf$var$Ng = null));
            $2ea81f475bdaffaf$var$gk(a, b);
            $2ea81f475bdaffaf$var$S(b);
            return null;
        case 5:
            $2ea81f475bdaffaf$var$Ph(b);
            var e = $2ea81f475bdaffaf$var$Lh($2ea81f475bdaffaf$var$Kh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $2ea81f475bdaffaf$var$hk(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($2ea81f475bdaffaf$var$p(166));
                    $2ea81f475bdaffaf$var$S(b);
                    return null;
                }
                a = $2ea81f475bdaffaf$var$Lh($2ea81f475bdaffaf$var$Ih.current);
                if ($2ea81f475bdaffaf$var$Ug(b)) {
                    d = b.stateNode;
                    a = b.type;
                    c = b.memoizedProps;
                    d[$2ea81f475bdaffaf$var$bg] = b;
                    d[$2ea81f475bdaffaf$var$cg] = c;
                    var f = 0 !== (b.mode & 1);
                    switch(a){
                        case "dialog":
                            $2ea81f475bdaffaf$var$F("cancel", d);
                            $2ea81f475bdaffaf$var$F("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $2ea81f475bdaffaf$var$F("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $2ea81f475bdaffaf$var$zf.length; e++)$2ea81f475bdaffaf$var$F($2ea81f475bdaffaf$var$zf[e], d);
                            break;
                        case "source":
                            $2ea81f475bdaffaf$var$F("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $2ea81f475bdaffaf$var$F("error", d);
                            $2ea81f475bdaffaf$var$F("load", d);
                            break;
                        case "details":
                            $2ea81f475bdaffaf$var$F("toggle", d);
                            break;
                        case "input":
                            $2ea81f475bdaffaf$var$Za(d, c);
                            $2ea81f475bdaffaf$var$F("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!c.multiple
                            };
                            $2ea81f475bdaffaf$var$F("invalid", d);
                            break;
                        case "textarea":
                            $2ea81f475bdaffaf$var$gb(d, c), $2ea81f475bdaffaf$var$F("invalid", d);
                    }
                    $2ea81f475bdaffaf$var$ub(a, c);
                    e = null;
                    for(var g in c)if (c.hasOwnProperty(g)) {
                        var h = c[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== c.suppressHydrationWarning && $2ea81f475bdaffaf$var$Of(d.textContent, h, f), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== c.suppressHydrationWarning && $2ea81f475bdaffaf$var$Of(d.textContent, h, f), e = [
                            "children",
                            "" + h
                        ]) : $2ea81f475bdaffaf$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $2ea81f475bdaffaf$var$F("scroll", d);
                    }
                    switch(a){
                        case "input":
                            $2ea81f475bdaffaf$var$Va(d);
                            $2ea81f475bdaffaf$var$cb(d, c, !0);
                            break;
                        case "textarea":
                            $2ea81f475bdaffaf$var$Va(d);
                            $2ea81f475bdaffaf$var$ib(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof c.onClick && (d.onclick = $2ea81f475bdaffaf$var$Pf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $2ea81f475bdaffaf$var$jb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$2ea81f475bdaffaf$var$bg] = b;
                    a[$2ea81f475bdaffaf$var$cg] = d;
                    $2ea81f475bdaffaf$var$fk(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $2ea81f475bdaffaf$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $2ea81f475bdaffaf$var$F("cancel", a);
                                $2ea81f475bdaffaf$var$F("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $2ea81f475bdaffaf$var$F("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $2ea81f475bdaffaf$var$zf.length; e++)$2ea81f475bdaffaf$var$F($2ea81f475bdaffaf$var$zf[e], a);
                                e = d;
                                break;
                            case "source":
                                $2ea81f475bdaffaf$var$F("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $2ea81f475bdaffaf$var$F("error", a);
                                $2ea81f475bdaffaf$var$F("load", a);
                                e = d;
                                break;
                            case "details":
                                $2ea81f475bdaffaf$var$F("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $2ea81f475bdaffaf$var$Za(a, d);
                                e = $2ea81f475bdaffaf$var$Ya(a, d);
                                $2ea81f475bdaffaf$var$F("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $2ea81f475bdaffaf$var$u({}, d, {
                                    value: void 0
                                });
                                $2ea81f475bdaffaf$var$F("invalid", a);
                                break;
                            case "textarea":
                                $2ea81f475bdaffaf$var$gb(a, d);
                                e = $2ea81f475bdaffaf$var$fb(a, d);
                                $2ea81f475bdaffaf$var$F("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $2ea81f475bdaffaf$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $2ea81f475bdaffaf$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $2ea81f475bdaffaf$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $2ea81f475bdaffaf$var$ob(a, k) : "number" === typeof k && $2ea81f475bdaffaf$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($2ea81f475bdaffaf$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $2ea81f475bdaffaf$var$F("scroll", a) : null != k && $2ea81f475bdaffaf$var$ua(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $2ea81f475bdaffaf$var$Va(a);
                                $2ea81f475bdaffaf$var$cb(a, d, !1);
                                break;
                            case "textarea":
                                $2ea81f475bdaffaf$var$Va(a);
                                $2ea81f475bdaffaf$var$ib(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $2ea81f475bdaffaf$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $2ea81f475bdaffaf$var$eb(a, !!d.multiple, f, !1) : null != d.defaultValue && $2ea81f475bdaffaf$var$eb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $2ea81f475bdaffaf$var$Pf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $2ea81f475bdaffaf$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $2ea81f475bdaffaf$var$ik(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($2ea81f475bdaffaf$var$p(166));
                a = $2ea81f475bdaffaf$var$Lh($2ea81f475bdaffaf$var$Kh.current);
                $2ea81f475bdaffaf$var$Lh($2ea81f475bdaffaf$var$Ih.current);
                if ($2ea81f475bdaffaf$var$Ug(b)) {
                    d = b.stateNode;
                    a = b.memoizedProps;
                    d[$2ea81f475bdaffaf$var$bg] = b;
                    if (c = d.nodeValue !== a) {
                        if (f = $2ea81f475bdaffaf$var$Lg, null !== f) switch(f.tag){
                            case 3:
                                $2ea81f475bdaffaf$var$Of(d.nodeValue, a, 0 !== (f.mode & 1));
                                break;
                            case 5:
                                !0 !== f.memoizedProps.suppressHydrationWarning && $2ea81f475bdaffaf$var$Of(d.nodeValue, a, 0 !== (f.mode & 1));
                        }
                    }
                    c && (b.flags |= 4);
                } else d = (9 === a.nodeType ? a : a.ownerDocument).createTextNode(d), d[$2ea81f475bdaffaf$var$bg] = b, b.stateNode = d;
            }
            $2ea81f475bdaffaf$var$S(b);
            return null;
        case 13:
            $2ea81f475bdaffaf$var$G($2ea81f475bdaffaf$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($2ea81f475bdaffaf$var$J && null !== $2ea81f475bdaffaf$var$Mg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $2ea81f475bdaffaf$var$Vg(), $2ea81f475bdaffaf$var$Wg(), b.flags |= 98560, f = !1;
                else if (f = $2ea81f475bdaffaf$var$Ug(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($2ea81f475bdaffaf$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($2ea81f475bdaffaf$var$p(317));
                        f[$2ea81f475bdaffaf$var$bg] = b;
                        $2ea81f475bdaffaf$var$S(b);
                        0 !== (b.mode & 2) && null !== d && (f = b.child, null !== f && (b.treeBaseDuration -= f.treeBaseDuration));
                    } else $2ea81f475bdaffaf$var$Wg(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4, $2ea81f475bdaffaf$var$S(b), 0 !== (b.mode & 2) && null !== d && (f = b.child, null !== f && (b.treeBaseDuration -= f.treeBaseDuration));
                    f = !1;
                } else null !== $2ea81f475bdaffaf$var$Ng && ($2ea81f475bdaffaf$var$lk($2ea81f475bdaffaf$var$Ng), $2ea81f475bdaffaf$var$Ng = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, 0 !== (b.mode & 2) && $2ea81f475bdaffaf$var$dj(b), b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($2ea81f475bdaffaf$var$L.current & 1) ? 0 === $2ea81f475bdaffaf$var$T && ($2ea81f475bdaffaf$var$T = 3) : $2ea81f475bdaffaf$var$Zj()));
            null !== b.updateQueue && (b.flags |= 4);
            $2ea81f475bdaffaf$var$S(b);
            0 !== (b.mode & 2) && d && (d = b.child, null !== d && (b.treeBaseDuration -= d.treeBaseDuration));
            return null;
        case 4:
            return $2ea81f475bdaffaf$var$Nh(), $2ea81f475bdaffaf$var$gk(a, b), null === a && $2ea81f475bdaffaf$var$Gf(b.stateNode.containerInfo), $2ea81f475bdaffaf$var$S(b), null;
        case 10:
            return $2ea81f475bdaffaf$var$oh(b.type._context), $2ea81f475bdaffaf$var$S(b), null;
        case 17:
            return $2ea81f475bdaffaf$var$mg(b.type) && $2ea81f475bdaffaf$var$ng(), $2ea81f475bdaffaf$var$S(b), null;
        case 19:
            $2ea81f475bdaffaf$var$G($2ea81f475bdaffaf$var$L);
            f = b.memoizedState;
            if (null === f) return $2ea81f475bdaffaf$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $2ea81f475bdaffaf$var$jk(f, !1);
                else {
                    if (0 !== $2ea81f475bdaffaf$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $2ea81f475bdaffaf$var$Qh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $2ea81f475bdaffaf$var$jk(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(a = b.child; null !== a;)c = a, g = d, c.flags &= 14680066, f = c.alternate, null === f ? (c.childLanes = 0, c.lanes = g, c.child = null, c.subtreeFlags = 0, c.memoizedProps = null, c.memoizedState = null, c.updateQueue = null, c.dependencies = null, c.stateNode = null, c.selfBaseDuration = 0, c.treeBaseDuration = 0) : (c.childLanes = f.childLanes, c.lanes = f.lanes, c.child = f.child, c.subtreeFlags = 0, c.deletions = null, c.memoizedProps = f.memoizedProps, c.memoizedState = f.memoizedState, c.updateQueue = f.updateQueue, c.type = f.type, g = f.dependencies, c.dependencies = null === g ? null : {
                                lanes: g.lanes,
                                firstContext: g.firstContext
                            }, c.selfBaseDuration = f.selfBaseDuration, c.treeBaseDuration = f.treeBaseDuration), a = a.sibling;
                            $2ea81f475bdaffaf$var$H($2ea81f475bdaffaf$var$L, $2ea81f475bdaffaf$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $2ea81f475bdaffaf$var$A() > $2ea81f475bdaffaf$var$mk && (b.flags |= 128, d = !0, $2ea81f475bdaffaf$var$jk(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $2ea81f475bdaffaf$var$Qh(g), null !== a) {
                        if (b.flags |= 128, d = !0, a = a.updateQueue, null !== a && (b.updateQueue = a, b.flags |= 4), $2ea81f475bdaffaf$var$jk(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$2ea81f475bdaffaf$var$J) return $2ea81f475bdaffaf$var$S(b), null;
                    } else 2 * $2ea81f475bdaffaf$var$A() - f.renderingStartTime > $2ea81f475bdaffaf$var$mk && 1073741824 !== c && (b.flags |= 128, d = !0, $2ea81f475bdaffaf$var$jk(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (a = f.last, null !== a ? a.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $2ea81f475bdaffaf$var$A(), b.sibling = null, a = $2ea81f475bdaffaf$var$L.current, $2ea81f475bdaffaf$var$H($2ea81f475bdaffaf$var$L, d ? a & 1 | 2 : a & 1), b;
            $2ea81f475bdaffaf$var$S(b);
            return null;
        case 22:
        case 23:
            return $2ea81f475bdaffaf$var$nk(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($2ea81f475bdaffaf$var$Jj & 1073741824) && ($2ea81f475bdaffaf$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $2ea81f475bdaffaf$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($2ea81f475bdaffaf$var$p(156, b.tag));
}
function $2ea81f475bdaffaf$var$ok(a, b) {
    $2ea81f475bdaffaf$var$Kg(b);
    switch(b.tag){
        case 1:
            return $2ea81f475bdaffaf$var$mg(b.type) && $2ea81f475bdaffaf$var$ng(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, 0 !== (b.mode & 2) && $2ea81f475bdaffaf$var$dj(b), b) : null;
        case 3:
            return $2ea81f475bdaffaf$var$Nh(), $2ea81f475bdaffaf$var$G($2ea81f475bdaffaf$var$jg), $2ea81f475bdaffaf$var$G($2ea81f475bdaffaf$var$I), $2ea81f475bdaffaf$var$Sh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $2ea81f475bdaffaf$var$Ph(b), null;
        case 13:
            $2ea81f475bdaffaf$var$G($2ea81f475bdaffaf$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($2ea81f475bdaffaf$var$p(340));
                $2ea81f475bdaffaf$var$Wg();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, 0 !== (b.mode & 2) && $2ea81f475bdaffaf$var$dj(b), b) : null;
        case 19:
            return $2ea81f475bdaffaf$var$G($2ea81f475bdaffaf$var$L), null;
        case 4:
            return $2ea81f475bdaffaf$var$Nh(), null;
        case 10:
            return $2ea81f475bdaffaf$var$oh(b.type._context), null;
        case 22:
        case 23:
            return $2ea81f475bdaffaf$var$nk(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $2ea81f475bdaffaf$var$pk = !1, $2ea81f475bdaffaf$var$qk = !1, $2ea81f475bdaffaf$var$rk = "function" === typeof WeakSet ? WeakSet : Set, $2ea81f475bdaffaf$var$U = null, $2ea81f475bdaffaf$var$sk = null, $2ea81f475bdaffaf$var$tk = null;
function $2ea81f475bdaffaf$var$uk(a, b) {
    b.props = a.memoizedProps;
    b.state = a.memoizedState;
    if (a.mode & 2) try {
        $2ea81f475bdaffaf$var$cj(), b.componentWillUnmount();
    } finally{
        $2ea81f475bdaffaf$var$aj(a);
    }
    else b.componentWillUnmount();
}
function $2ea81f475bdaffaf$var$vk(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            if (a.mode & 2) try {
                $2ea81f475bdaffaf$var$cj(), c(null);
            } finally{
                $2ea81f475bdaffaf$var$aj(a);
            }
            else c(null);
        } catch (d) {
            $2ea81f475bdaffaf$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $2ea81f475bdaffaf$var$wk(a, b, c) {
    try {
        c();
    } catch (d) {
        $2ea81f475bdaffaf$var$W(a, b, d);
    }
}
var $2ea81f475bdaffaf$var$xk = !1;
function $2ea81f475bdaffaf$var$yk(a, b) {
    $2ea81f475bdaffaf$var$Qf = $2ea81f475bdaffaf$var$rd;
    a = $2ea81f475bdaffaf$var$$e();
    if ($2ea81f475bdaffaf$var$af(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (D) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, n = 0, q = a, r = null;
                b: for(;;){
                    for(var z;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (z = q.firstChild)) break;
                        r = q;
                        q = z;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++n === d && (k = g);
                        if (null !== (z = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = z;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $2ea81f475bdaffaf$var$Rf = {
        focusedElem: a,
        selectionRange: c
    };
    $2ea81f475bdaffaf$var$rd = !1;
    for($2ea81f475bdaffaf$var$U = b; null !== $2ea81f475bdaffaf$var$U;)if (b = $2ea81f475bdaffaf$var$U, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $2ea81f475bdaffaf$var$U = a;
    else for(; null !== $2ea81f475bdaffaf$var$U;){
        b = $2ea81f475bdaffaf$var$U;
        try {
            var m = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== m) {
                        var w = m.memoizedProps, C = m.memoizedState, x = b.stateNode, y = x.getSnapshotBeforeUpdate(b.elementType === b.type ? w : $2ea81f475bdaffaf$var$ej(b.type, w), C);
                        x.__reactInternalSnapshotBeforeUpdate = y;
                    }
                    break;
                case 3:
                    var v = b.stateNode.containerInfo;
                    1 === v.nodeType ? v.textContent = "" : 9 === v.nodeType && v.documentElement && v.removeChild(v.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($2ea81f475bdaffaf$var$p(163));
            }
        } catch (D) {
            $2ea81f475bdaffaf$var$W(b, b.return, D);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $2ea81f475bdaffaf$var$U = a;
            break;
        }
        $2ea81f475bdaffaf$var$U = b.return;
    }
    m = $2ea81f475bdaffaf$var$xk;
    $2ea81f475bdaffaf$var$xk = !1;
    return m;
}
function $2ea81f475bdaffaf$var$zk(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && (0 !== (a & 8) ? null !== $2ea81f475bdaffaf$var$B && "function" === typeof $2ea81f475bdaffaf$var$B.markComponentPassiveEffectUnmountStarted && $2ea81f475bdaffaf$var$B.markComponentPassiveEffectUnmountStarted(b) : 0 !== (a & 4) && $2ea81f475bdaffaf$var$uc(b), $2ea81f475bdaffaf$var$wk(b, c, f), 0 !== (a & 8) ? null !== $2ea81f475bdaffaf$var$B && "function" === typeof $2ea81f475bdaffaf$var$B.markComponentPassiveEffectUnmountStopped && $2ea81f475bdaffaf$var$B.markComponentPassiveEffectUnmountStopped() : 0 !== (a & 4) && $2ea81f475bdaffaf$var$vc());
            }
            e = e.next;
        }while (e !== d);
    }
}
function $2ea81f475bdaffaf$var$Ak(a, b) {
    var c = b.updateQueue;
    c = null !== c ? c.lastEffect : null;
    if (null !== c) {
        var d = c = c.next;
        do {
            if ((d.tag & a) === a) {
                0 !== (a & 8) ? null !== $2ea81f475bdaffaf$var$B && "function" === typeof $2ea81f475bdaffaf$var$B.markComponentPassiveEffectMountStarted && $2ea81f475bdaffaf$var$B.markComponentPassiveEffectMountStarted(b) : 0 !== (a & 4) && null !== $2ea81f475bdaffaf$var$B && "function" === typeof $2ea81f475bdaffaf$var$B.markComponentLayoutEffectMountStarted && $2ea81f475bdaffaf$var$B.markComponentLayoutEffectMountStarted(b);
                var e = d.create;
                d.destroy = e();
                0 !== (a & 8) ? null !== $2ea81f475bdaffaf$var$B && "function" === typeof $2ea81f475bdaffaf$var$B.markComponentPassiveEffectMountStopped && $2ea81f475bdaffaf$var$B.markComponentPassiveEffectMountStopped() : 0 !== (a & 4) && null !== $2ea81f475bdaffaf$var$B && "function" === typeof $2ea81f475bdaffaf$var$B.markComponentLayoutEffectMountStopped && $2ea81f475bdaffaf$var$B.markComponentLayoutEffectMountStopped();
            }
            d = d.next;
        }while (d !== c);
    }
}
function $2ea81f475bdaffaf$var$Bk(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        if ("function" === typeof b) {
            if (a.mode & 2) try {
                $2ea81f475bdaffaf$var$cj(), b(c);
            } finally{
                $2ea81f475bdaffaf$var$aj(a);
            }
            else b(c);
        } else b.current = c;
    }
}
function $2ea81f475bdaffaf$var$Ck(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $2ea81f475bdaffaf$var$Ck(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$2ea81f475bdaffaf$var$bg], delete b[$2ea81f475bdaffaf$var$cg], delete b[$2ea81f475bdaffaf$var$Cf], delete b[$2ea81f475bdaffaf$var$dg], delete b[$2ea81f475bdaffaf$var$eg]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $2ea81f475bdaffaf$var$Dk(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $2ea81f475bdaffaf$var$Ek(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $2ea81f475bdaffaf$var$Dk(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $2ea81f475bdaffaf$var$Fk(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $2ea81f475bdaffaf$var$Pf));
    else if (4 !== d && (a = a.child, null !== a)) for($2ea81f475bdaffaf$var$Fk(a, b, c), a = a.sibling; null !== a;)$2ea81f475bdaffaf$var$Fk(a, b, c), a = a.sibling;
}
function $2ea81f475bdaffaf$var$Gk(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($2ea81f475bdaffaf$var$Gk(a, b, c), a = a.sibling; null !== a;)$2ea81f475bdaffaf$var$Gk(a, b, c), a = a.sibling;
}
var $2ea81f475bdaffaf$var$X = null, $2ea81f475bdaffaf$var$Hk = !1;
function $2ea81f475bdaffaf$var$Ik(a, b, c) {
    for(c = c.child; null !== c;)$2ea81f475bdaffaf$var$Jk(a, b, c), c = c.sibling;
}
function $2ea81f475bdaffaf$var$Jk(a, b, c) {
    if ($2ea81f475bdaffaf$var$lc && "function" === typeof $2ea81f475bdaffaf$var$lc.onCommitFiberUnmount) try {
        $2ea81f475bdaffaf$var$lc.onCommitFiberUnmount($2ea81f475bdaffaf$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $2ea81f475bdaffaf$var$qk || $2ea81f475bdaffaf$var$vk(c, b);
        case 6:
            var d = $2ea81f475bdaffaf$var$X, e = $2ea81f475bdaffaf$var$Hk;
            $2ea81f475bdaffaf$var$X = null;
            $2ea81f475bdaffaf$var$Ik(a, b, c);
            $2ea81f475bdaffaf$var$X = d;
            $2ea81f475bdaffaf$var$Hk = e;
            null !== $2ea81f475bdaffaf$var$X && ($2ea81f475bdaffaf$var$Hk ? (a = $2ea81f475bdaffaf$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $2ea81f475bdaffaf$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $2ea81f475bdaffaf$var$X && ($2ea81f475bdaffaf$var$Hk ? (a = $2ea81f475bdaffaf$var$X, c = c.stateNode, 8 === a.nodeType ? $2ea81f475bdaffaf$var$Yf(a.parentNode, c) : 1 === a.nodeType && $2ea81f475bdaffaf$var$Yf(a, c), $2ea81f475bdaffaf$var$pd(a)) : $2ea81f475bdaffaf$var$Yf($2ea81f475bdaffaf$var$X, c.stateNode));
            break;
        case 4:
            d = $2ea81f475bdaffaf$var$X;
            e = $2ea81f475bdaffaf$var$Hk;
            $2ea81f475bdaffaf$var$X = c.stateNode.containerInfo;
            $2ea81f475bdaffaf$var$Hk = !0;
            $2ea81f475bdaffaf$var$Ik(a, b, c);
            $2ea81f475bdaffaf$var$X = d;
            $2ea81f475bdaffaf$var$Hk = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$2ea81f475bdaffaf$var$qk && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $2ea81f475bdaffaf$var$wk(c, b, g) : 0 !== (f & 4) && ($2ea81f475bdaffaf$var$uc(c), c.mode & 2 ? ($2ea81f475bdaffaf$var$cj(), $2ea81f475bdaffaf$var$wk(c, b, g), $2ea81f475bdaffaf$var$aj(c)) : $2ea81f475bdaffaf$var$wk(c, b, g), $2ea81f475bdaffaf$var$vc()));
                    e = e.next;
                }while (e !== d);
            }
            $2ea81f475bdaffaf$var$Ik(a, b, c);
            break;
        case 1:
            if (!$2ea81f475bdaffaf$var$qk && ($2ea81f475bdaffaf$var$vk(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                $2ea81f475bdaffaf$var$uk(c, d);
            } catch (h) {
                $2ea81f475bdaffaf$var$W(c, b, h);
            }
            $2ea81f475bdaffaf$var$Ik(a, b, c);
            break;
        case 21:
            $2ea81f475bdaffaf$var$Ik(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($2ea81f475bdaffaf$var$qk = (d = $2ea81f475bdaffaf$var$qk) || null !== c.memoizedState, $2ea81f475bdaffaf$var$Ik(a, b, c), $2ea81f475bdaffaf$var$qk = d) : $2ea81f475bdaffaf$var$Ik(a, b, c);
            break;
        default:
            $2ea81f475bdaffaf$var$Ik(a, b, c);
    }
}
function $2ea81f475bdaffaf$var$Kk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $2ea81f475bdaffaf$var$rk);
        b.forEach(function(b) {
            var d = $2ea81f475bdaffaf$var$Lk.bind(null, a, b);
            if (!c.has(b)) {
                c.add(b);
                if ($2ea81f475bdaffaf$var$mc) {
                    if (null !== $2ea81f475bdaffaf$var$sk && null !== $2ea81f475bdaffaf$var$tk) $2ea81f475bdaffaf$var$wj($2ea81f475bdaffaf$var$tk, $2ea81f475bdaffaf$var$sk);
                    else throw Error($2ea81f475bdaffaf$var$p(413));
                }
                b.then(d, d);
            }
        });
    }
}
function $2ea81f475bdaffaf$var$Mk(a, b, c) {
    $2ea81f475bdaffaf$var$sk = c;
    $2ea81f475bdaffaf$var$tk = a;
    $2ea81f475bdaffaf$var$Nk(b, a);
    $2ea81f475bdaffaf$var$tk = $2ea81f475bdaffaf$var$sk = null;
}
function $2ea81f475bdaffaf$var$Ok(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $2ea81f475bdaffaf$var$X = h.stateNode;
                        $2ea81f475bdaffaf$var$Hk = !1;
                        break a;
                    case 3:
                        $2ea81f475bdaffaf$var$X = h.stateNode.containerInfo;
                        $2ea81f475bdaffaf$var$Hk = !0;
                        break a;
                    case 4:
                        $2ea81f475bdaffaf$var$X = h.stateNode.containerInfo;
                        $2ea81f475bdaffaf$var$Hk = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $2ea81f475bdaffaf$var$X) throw Error($2ea81f475bdaffaf$var$p(160));
            $2ea81f475bdaffaf$var$Jk(f, g, e);
            $2ea81f475bdaffaf$var$X = null;
            $2ea81f475bdaffaf$var$Hk = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $2ea81f475bdaffaf$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$2ea81f475bdaffaf$var$Nk(b, a), b = b.sibling;
}
function $2ea81f475bdaffaf$var$Nk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $2ea81f475bdaffaf$var$Ok(b, a);
            $2ea81f475bdaffaf$var$Pk(a);
            if (d & 4) {
                try {
                    $2ea81f475bdaffaf$var$zk(3, a, a.return), $2ea81f475bdaffaf$var$Ak(3, a);
                } catch (m) {
                    $2ea81f475bdaffaf$var$W(a, a.return, m);
                }
                if (a.mode & 2) {
                    try {
                        $2ea81f475bdaffaf$var$cj(), $2ea81f475bdaffaf$var$zk(5, a, a.return);
                    } catch (m) {
                        $2ea81f475bdaffaf$var$W(a, a.return, m);
                    }
                    $2ea81f475bdaffaf$var$aj(a);
                } else try {
                    $2ea81f475bdaffaf$var$zk(5, a, a.return);
                } catch (m) {
                    $2ea81f475bdaffaf$var$W(a, a.return, m);
                }
            }
            break;
        case 1:
            $2ea81f475bdaffaf$var$Ok(b, a);
            $2ea81f475bdaffaf$var$Pk(a);
            d & 512 && null !== c && $2ea81f475bdaffaf$var$vk(c, c.return);
            break;
        case 5:
            $2ea81f475bdaffaf$var$Ok(b, a);
            $2ea81f475bdaffaf$var$Pk(a);
            d & 512 && null !== c && $2ea81f475bdaffaf$var$vk(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $2ea81f475bdaffaf$var$ob(e, "");
                } catch (m) {
                    $2ea81f475bdaffaf$var$W(a, a.return, m);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $2ea81f475bdaffaf$var$$a(e, f);
                    $2ea81f475bdaffaf$var$vb(h, g);
                    var l = $2ea81f475bdaffaf$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var n = k[g], q = k[g + 1];
                        "style" === n ? $2ea81f475bdaffaf$var$sb(e, q) : "dangerouslySetInnerHTML" === n ? $2ea81f475bdaffaf$var$nb(e, q) : "children" === n ? $2ea81f475bdaffaf$var$ob(e, q) : $2ea81f475bdaffaf$var$ua(e, n, q, l);
                    }
                    switch(h){
                        case "input":
                            $2ea81f475bdaffaf$var$ab(e, f);
                            break;
                        case "textarea":
                            $2ea81f475bdaffaf$var$hb(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var z = f.value;
                            null != z ? $2ea81f475bdaffaf$var$eb(e, !!f.multiple, z, !1) : r !== !!f.multiple && (null != f.defaultValue ? $2ea81f475bdaffaf$var$eb(e, !!f.multiple, f.defaultValue, !0) : $2ea81f475bdaffaf$var$eb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$2ea81f475bdaffaf$var$cg] = f;
                } catch (m) {
                    $2ea81f475bdaffaf$var$W(a, a.return, m);
                }
            }
            break;
        case 6:
            $2ea81f475bdaffaf$var$Ok(b, a);
            $2ea81f475bdaffaf$var$Pk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($2ea81f475bdaffaf$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (m) {
                    $2ea81f475bdaffaf$var$W(a, a.return, m);
                }
            }
            break;
        case 3:
            $2ea81f475bdaffaf$var$Ok(b, a);
            $2ea81f475bdaffaf$var$Pk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $2ea81f475bdaffaf$var$pd(b.containerInfo);
            } catch (m) {
                $2ea81f475bdaffaf$var$W(a, a.return, m);
            }
            break;
        case 4:
            $2ea81f475bdaffaf$var$Ok(b, a);
            $2ea81f475bdaffaf$var$Pk(a);
            break;
        case 13:
            $2ea81f475bdaffaf$var$Ok(b, a);
            $2ea81f475bdaffaf$var$Pk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($2ea81f475bdaffaf$var$Qk = $2ea81f475bdaffaf$var$A()));
            d & 4 && $2ea81f475bdaffaf$var$Kk(a);
            break;
        case 22:
            n = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($2ea81f475bdaffaf$var$qk = (l = $2ea81f475bdaffaf$var$qk) || n, $2ea81f475bdaffaf$var$Ok(b, a), $2ea81f475bdaffaf$var$qk = l) : $2ea81f475bdaffaf$var$Ok(b, a);
            $2ea81f475bdaffaf$var$Pk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !n && 0 !== (a.mode & 1)) for($2ea81f475bdaffaf$var$U = a, n = a.child; null !== n;){
                    for(q = $2ea81f475bdaffaf$var$U = n; null !== $2ea81f475bdaffaf$var$U;){
                        r = $2ea81f475bdaffaf$var$U;
                        z = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                if (r.mode & 2) try {
                                    $2ea81f475bdaffaf$var$cj(), $2ea81f475bdaffaf$var$zk(4, r, r.return);
                                } finally{
                                    $2ea81f475bdaffaf$var$aj(r);
                                }
                                else $2ea81f475bdaffaf$var$zk(4, r, r.return);
                                break;
                            case 1:
                                $2ea81f475bdaffaf$var$vk(r, r.return);
                                d = r.stateNode;
                                if ("function" === typeof d.componentWillUnmount) {
                                    c = r;
                                    b = r.return;
                                    try {
                                        $2ea81f475bdaffaf$var$uk(c, d);
                                    } catch (m) {
                                        $2ea81f475bdaffaf$var$W(c, b, m);
                                    }
                                }
                                break;
                            case 5:
                                $2ea81f475bdaffaf$var$vk(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $2ea81f475bdaffaf$var$Rk(q);
                                    continue;
                                }
                        }
                        null !== z ? (z.return = r, $2ea81f475bdaffaf$var$U = z) : $2ea81f475bdaffaf$var$Rk(q);
                    }
                    n = n.sibling;
                }
                a: for(n = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === n) {
                            n = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $2ea81f475bdaffaf$var$rb("display", g));
                            } catch (m) {
                                $2ea81f475bdaffaf$var$W(a, a.return, m);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === n) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (m) {
                            $2ea81f475bdaffaf$var$W(a, a.return, m);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        n === q && (n = null);
                        q = q.return;
                    }
                    n === q && (n = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $2ea81f475bdaffaf$var$Ok(b, a);
            $2ea81f475bdaffaf$var$Pk(a);
            d & 4 && $2ea81f475bdaffaf$var$Kk(a);
            break;
        case 21:
            break;
        default:
            $2ea81f475bdaffaf$var$Ok(b, a), $2ea81f475bdaffaf$var$Pk(a);
    }
}
function $2ea81f475bdaffaf$var$Pk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($2ea81f475bdaffaf$var$Dk(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($2ea81f475bdaffaf$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($2ea81f475bdaffaf$var$ob(e, ""), d.flags &= -33);
                    var f = $2ea81f475bdaffaf$var$Ek(a);
                    $2ea81f475bdaffaf$var$Gk(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $2ea81f475bdaffaf$var$Ek(a);
                    $2ea81f475bdaffaf$var$Fk(a, h, g);
                    break;
                default:
                    throw Error($2ea81f475bdaffaf$var$p(161));
            }
        } catch (k) {
            $2ea81f475bdaffaf$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $2ea81f475bdaffaf$var$Sk(a, b, c) {
    $2ea81f475bdaffaf$var$sk = c;
    $2ea81f475bdaffaf$var$tk = b;
    $2ea81f475bdaffaf$var$U = a;
    $2ea81f475bdaffaf$var$Tk(a, b, c);
    $2ea81f475bdaffaf$var$tk = $2ea81f475bdaffaf$var$sk = null;
}
function $2ea81f475bdaffaf$var$Tk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $2ea81f475bdaffaf$var$U;){
        var e = $2ea81f475bdaffaf$var$U, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $2ea81f475bdaffaf$var$pk;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $2ea81f475bdaffaf$var$qk;
                h = $2ea81f475bdaffaf$var$pk;
                var l = $2ea81f475bdaffaf$var$qk;
                $2ea81f475bdaffaf$var$pk = g;
                if (($2ea81f475bdaffaf$var$qk = k) && !l) for($2ea81f475bdaffaf$var$U = e; null !== $2ea81f475bdaffaf$var$U;)g = $2ea81f475bdaffaf$var$U, k = g.child, 22 === g.tag && null !== g.memoizedState ? $2ea81f475bdaffaf$var$Uk(e) : null !== k ? (k.return = g, $2ea81f475bdaffaf$var$U = k) : $2ea81f475bdaffaf$var$Uk(e);
                for(; null !== f;)$2ea81f475bdaffaf$var$U = f, $2ea81f475bdaffaf$var$Tk(f, b, c), f = f.sibling;
                $2ea81f475bdaffaf$var$U = e;
                $2ea81f475bdaffaf$var$pk = h;
                $2ea81f475bdaffaf$var$qk = l;
            }
            $2ea81f475bdaffaf$var$Vk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $2ea81f475bdaffaf$var$U = f) : $2ea81f475bdaffaf$var$Vk(a, b, c);
    }
}
function $2ea81f475bdaffaf$var$Vk(a) {
    for(; null !== $2ea81f475bdaffaf$var$U;){
        var b = $2ea81f475bdaffaf$var$U;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        if (!$2ea81f475bdaffaf$var$qk) {
                            if (b.mode & 2) try {
                                $2ea81f475bdaffaf$var$cj(), $2ea81f475bdaffaf$var$Ak(5, b);
                            } finally{
                                $2ea81f475bdaffaf$var$aj(b);
                            }
                            else $2ea81f475bdaffaf$var$Ak(5, b);
                        }
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$2ea81f475bdaffaf$var$qk) {
                            if (null === c) {
                                if (b.mode & 2) try {
                                    $2ea81f475bdaffaf$var$cj(), d.componentDidMount();
                                } finally{
                                    $2ea81f475bdaffaf$var$aj(b);
                                }
                                else d.componentDidMount();
                            } else {
                                var e = b.elementType === b.type ? c.memoizedProps : $2ea81f475bdaffaf$var$ej(b.type, c.memoizedProps), f = c.memoizedState;
                                if (b.mode & 2) try {
                                    $2ea81f475bdaffaf$var$cj(), d.componentDidUpdate(e, f, d.__reactInternalSnapshotBeforeUpdate);
                                } finally{
                                    $2ea81f475bdaffaf$var$aj(b);
                                }
                                else d.componentDidUpdate(e, f, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var g = b.updateQueue;
                        null !== g && $2ea81f475bdaffaf$var$Gh(b, g, d);
                        break;
                    case 3:
                        var h = b.updateQueue;
                        if (null !== h) {
                            var k = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    k = b.child.stateNode;
                                    break;
                                case 1:
                                    k = b.child.stateNode;
                            }
                            $2ea81f475bdaffaf$var$Gh(b, h, k);
                        }
                        break;
                    case 5:
                        var l = b.stateNode;
                        if (null === c && b.flags & 4) {
                            k = l;
                            var n = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    n.autoFocus && k.focus();
                                    break;
                                case "img":
                                    n.src && (k.src = n.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        var q = b.memoizedProps, r = q.onCommit, z = q.onRender, m = b.stateNode.effectDuration;
                        k = $2ea81f475bdaffaf$var$Ui;
                        c = null === c ? "mount" : "update";
                        $2ea81f475bdaffaf$var$Yi && (c = "nested-update");
                        "function" === typeof z && z(b.memoizedProps.id, c, b.actualDuration, b.treeBaseDuration, b.actualStartTime, k);
                        "function" === typeof r && r(b.memoizedProps.id, c, m, k);
                        $2ea81f475bdaffaf$var$Wk(b);
                        var w = b.return;
                        a: for(; null !== w;){
                            switch(w.tag){
                                case 3:
                                    w.stateNode.effectDuration += m;
                                    break a;
                                case 12:
                                    w.stateNode.effectDuration += m;
                                    break a;
                            }
                            w = w.return;
                        }
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var C = b.alternate;
                            if (null !== C) {
                                var x = C.memoizedState;
                                if (null !== x) {
                                    var y = x.dehydrated;
                                    null !== y && $2ea81f475bdaffaf$var$pd(y);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($2ea81f475bdaffaf$var$p(163));
                }
                $2ea81f475bdaffaf$var$qk || b.flags & 512 && $2ea81f475bdaffaf$var$Bk(b);
            } catch (v) {
                $2ea81f475bdaffaf$var$W(b, b.return, v);
            }
        }
        if (b === a) {
            $2ea81f475bdaffaf$var$U = null;
            break;
        }
        k = b.sibling;
        if (null !== k) {
            k.return = b.return;
            $2ea81f475bdaffaf$var$U = k;
            break;
        }
        $2ea81f475bdaffaf$var$U = b.return;
    }
}
function $2ea81f475bdaffaf$var$Rk(a) {
    for(; null !== $2ea81f475bdaffaf$var$U;){
        var b = $2ea81f475bdaffaf$var$U;
        if (b === a) {
            $2ea81f475bdaffaf$var$U = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $2ea81f475bdaffaf$var$U = c;
            break;
        }
        $2ea81f475bdaffaf$var$U = b.return;
    }
}
function $2ea81f475bdaffaf$var$Uk(a) {
    for(; null !== $2ea81f475bdaffaf$var$U;){
        var b = $2ea81f475bdaffaf$var$U;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    if (b.mode & 2) try {
                        $2ea81f475bdaffaf$var$cj();
                        var c = b.return;
                        try {
                            $2ea81f475bdaffaf$var$Ak(4, b);
                        } catch (l) {
                            $2ea81f475bdaffaf$var$W(b, c, l);
                        }
                    } finally{
                        $2ea81f475bdaffaf$var$aj(b);
                    }
                    else {
                        var d = b.return;
                        try {
                            $2ea81f475bdaffaf$var$Ak(4, b);
                        } catch (l) {
                            $2ea81f475bdaffaf$var$W(b, d, l);
                        }
                    }
                    break;
                case 1:
                    var e = b.stateNode;
                    if ("function" === typeof e.componentDidMount) {
                        var f = b.return;
                        try {
                            e.componentDidMount();
                        } catch (l) {
                            $2ea81f475bdaffaf$var$W(b, f, l);
                        }
                    }
                    var g = b.return;
                    try {
                        $2ea81f475bdaffaf$var$Bk(b);
                    } catch (l) {
                        $2ea81f475bdaffaf$var$W(b, g, l);
                    }
                    break;
                case 5:
                    var h = b.return;
                    try {
                        $2ea81f475bdaffaf$var$Bk(b);
                    } catch (l) {
                        $2ea81f475bdaffaf$var$W(b, h, l);
                    }
            }
        } catch (l) {
            $2ea81f475bdaffaf$var$W(b, b.return, l);
        }
        if (b === a) {
            $2ea81f475bdaffaf$var$U = null;
            break;
        }
        var k = b.sibling;
        if (null !== k) {
            k.return = b.return;
            $2ea81f475bdaffaf$var$U = k;
            break;
        }
        $2ea81f475bdaffaf$var$U = b.return;
    }
}
var $2ea81f475bdaffaf$var$Xk = Math.ceil, $2ea81f475bdaffaf$var$Yk = $2ea81f475bdaffaf$var$va.ReactCurrentDispatcher, $2ea81f475bdaffaf$var$Zk = $2ea81f475bdaffaf$var$va.ReactCurrentOwner, $2ea81f475bdaffaf$var$$k = $2ea81f475bdaffaf$var$va.ReactCurrentBatchConfig, $2ea81f475bdaffaf$var$K = 0, $2ea81f475bdaffaf$var$Q = null, $2ea81f475bdaffaf$var$Y = null, $2ea81f475bdaffaf$var$Z = 0, $2ea81f475bdaffaf$var$Jj = 0, $2ea81f475bdaffaf$var$Ij = $2ea81f475bdaffaf$var$hg(0), $2ea81f475bdaffaf$var$T = 0, $2ea81f475bdaffaf$var$al = null, $2ea81f475bdaffaf$var$Fh = 0, $2ea81f475bdaffaf$var$bl = 0, $2ea81f475bdaffaf$var$cl = 0, $2ea81f475bdaffaf$var$dl = null, $2ea81f475bdaffaf$var$el = null, $2ea81f475bdaffaf$var$Qk = 0, $2ea81f475bdaffaf$var$mk = Infinity, $2ea81f475bdaffaf$var$fl = null, $2ea81f475bdaffaf$var$qj = !1, $2ea81f475bdaffaf$var$rj = null, $2ea81f475bdaffaf$var$tj = null, $2ea81f475bdaffaf$var$gl = !1, $2ea81f475bdaffaf$var$hl = null, $2ea81f475bdaffaf$var$il = 0, $2ea81f475bdaffaf$var$jl = [], $2ea81f475bdaffaf$var$kl = 0, $2ea81f475bdaffaf$var$ll = null, $2ea81f475bdaffaf$var$ml = -1, $2ea81f475bdaffaf$var$nl = 0;
function $2ea81f475bdaffaf$var$Ri() {
    return 0 !== ($2ea81f475bdaffaf$var$K & 6) ? $2ea81f475bdaffaf$var$A() : -1 !== $2ea81f475bdaffaf$var$ml ? $2ea81f475bdaffaf$var$ml : $2ea81f475bdaffaf$var$ml = $2ea81f475bdaffaf$var$A();
}
function $2ea81f475bdaffaf$var$Oi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($2ea81f475bdaffaf$var$K & 2) && 0 !== $2ea81f475bdaffaf$var$Z) return $2ea81f475bdaffaf$var$Z & -$2ea81f475bdaffaf$var$Z;
    if (null !== $2ea81f475bdaffaf$var$Yg.transition) return 0 === $2ea81f475bdaffaf$var$nl && ($2ea81f475bdaffaf$var$nl = $2ea81f475bdaffaf$var$Kc()), $2ea81f475bdaffaf$var$nl;
    a = $2ea81f475bdaffaf$var$E;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $2ea81f475bdaffaf$var$xd(a.type);
    return a;
}
function $2ea81f475bdaffaf$var$ui(a, b, c, d) {
    if (50 < $2ea81f475bdaffaf$var$kl) throw $2ea81f475bdaffaf$var$kl = 0, $2ea81f475bdaffaf$var$ll = null, Error($2ea81f475bdaffaf$var$p(185));
    $2ea81f475bdaffaf$var$Mc(a, c, d);
    if (0 === ($2ea81f475bdaffaf$var$K & 2) || a !== $2ea81f475bdaffaf$var$Q) $2ea81f475bdaffaf$var$mc && $2ea81f475bdaffaf$var$Pc(a, b, c), a === $2ea81f475bdaffaf$var$Q && (0 === ($2ea81f475bdaffaf$var$K & 2) && ($2ea81f475bdaffaf$var$bl |= c), 4 === $2ea81f475bdaffaf$var$T && $2ea81f475bdaffaf$var$ol(a, $2ea81f475bdaffaf$var$Z)), $2ea81f475bdaffaf$var$pl(a, d), 1 === c && 0 === $2ea81f475bdaffaf$var$K && 0 === (b.mode & 1) && ($2ea81f475bdaffaf$var$mk = $2ea81f475bdaffaf$var$A() + 500, $2ea81f475bdaffaf$var$tg && $2ea81f475bdaffaf$var$xg());
}
function $2ea81f475bdaffaf$var$pl(a, b) {
    var c = a.callbackNode;
    $2ea81f475bdaffaf$var$Ic(a, b);
    var d = $2ea81f475bdaffaf$var$Gc(a, a === $2ea81f475bdaffaf$var$Q ? $2ea81f475bdaffaf$var$Z : 0);
    if (0 === d) null !== c && $2ea81f475bdaffaf$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $2ea81f475bdaffaf$var$bc(c);
        if (1 === b) 0 === a.tag ? $2ea81f475bdaffaf$var$wg($2ea81f475bdaffaf$var$ql.bind(null, a)) : $2ea81f475bdaffaf$var$vg($2ea81f475bdaffaf$var$ql.bind(null, a)), $2ea81f475bdaffaf$var$Xf(function() {
            0 === ($2ea81f475bdaffaf$var$K & 6) && $2ea81f475bdaffaf$var$xg();
        }), c = null;
        else {
            switch($2ea81f475bdaffaf$var$Rc(d)){
                case 1:
                    c = $2ea81f475bdaffaf$var$fc;
                    break;
                case 4:
                    c = $2ea81f475bdaffaf$var$gc;
                    break;
                case 16:
                    c = $2ea81f475bdaffaf$var$hc;
                    break;
                case 536870912:
                    c = $2ea81f475bdaffaf$var$jc;
                    break;
                default:
                    c = $2ea81f475bdaffaf$var$hc;
            }
            c = $2ea81f475bdaffaf$var$rl(c, $2ea81f475bdaffaf$var$sl.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $2ea81f475bdaffaf$var$sl(a, b) {
    $2ea81f475bdaffaf$var$Zi = $2ea81f475bdaffaf$var$Yi = !1;
    $2ea81f475bdaffaf$var$ml = -1;
    $2ea81f475bdaffaf$var$nl = 0;
    if (0 !== ($2ea81f475bdaffaf$var$K & 6)) throw Error($2ea81f475bdaffaf$var$p(327));
    var c = a.callbackNode;
    if ($2ea81f475bdaffaf$var$tl() && a.callbackNode !== c) return null;
    var d = $2ea81f475bdaffaf$var$Gc(a, a === $2ea81f475bdaffaf$var$Q ? $2ea81f475bdaffaf$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $2ea81f475bdaffaf$var$ul(a, d);
    else {
        b = d;
        var e = $2ea81f475bdaffaf$var$K;
        $2ea81f475bdaffaf$var$K |= 2;
        var f = $2ea81f475bdaffaf$var$vl();
        if ($2ea81f475bdaffaf$var$Q !== a || $2ea81f475bdaffaf$var$Z !== b) {
            if ($2ea81f475bdaffaf$var$mc) {
                var g = a.memoizedUpdaters;
                0 < g.size && ($2ea81f475bdaffaf$var$wj(a, $2ea81f475bdaffaf$var$Z), g.clear());
                $2ea81f475bdaffaf$var$Qc(a, b);
            }
            $2ea81f475bdaffaf$var$fl = null;
            $2ea81f475bdaffaf$var$mk = $2ea81f475bdaffaf$var$A() + 500;
            $2ea81f475bdaffaf$var$wl(a, b);
        }
        $2ea81f475bdaffaf$var$wc(b);
        for(;;)try {
            $2ea81f475bdaffaf$var$xl();
            break;
        } catch (h) {
            $2ea81f475bdaffaf$var$yl(a, h);
        }
        $2ea81f475bdaffaf$var$nh();
        $2ea81f475bdaffaf$var$Yk.current = f;
        $2ea81f475bdaffaf$var$K = e;
        null !== $2ea81f475bdaffaf$var$Y ? (null !== $2ea81f475bdaffaf$var$B && "function" === typeof $2ea81f475bdaffaf$var$B.markRenderYielded && $2ea81f475bdaffaf$var$B.markRenderYielded(), b = 0) : ($2ea81f475bdaffaf$var$xc(), $2ea81f475bdaffaf$var$Q = null, $2ea81f475bdaffaf$var$Z = 0, b = $2ea81f475bdaffaf$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $2ea81f475bdaffaf$var$Jc(a), 0 !== e && (d = e, b = $2ea81f475bdaffaf$var$zl(a, e)));
        if (1 === b) throw c = $2ea81f475bdaffaf$var$al, $2ea81f475bdaffaf$var$wl(a, 0), $2ea81f475bdaffaf$var$ol(a, d), $2ea81f475bdaffaf$var$pl(a, $2ea81f475bdaffaf$var$A()), c;
        if (6 === b) $2ea81f475bdaffaf$var$ol(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$2ea81f475bdaffaf$var$Al(e) && (b = $2ea81f475bdaffaf$var$ul(a, d), 2 === b && (f = $2ea81f475bdaffaf$var$Jc(a), 0 !== f && (d = f, b = $2ea81f475bdaffaf$var$zl(a, f))), 1 === b)) throw c = $2ea81f475bdaffaf$var$al, $2ea81f475bdaffaf$var$wl(a, 0), $2ea81f475bdaffaf$var$ol(a, d), $2ea81f475bdaffaf$var$pl(a, $2ea81f475bdaffaf$var$A()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($2ea81f475bdaffaf$var$p(345));
                case 2:
                    $2ea81f475bdaffaf$var$Cl(a, $2ea81f475bdaffaf$var$el, $2ea81f475bdaffaf$var$fl);
                    break;
                case 3:
                    $2ea81f475bdaffaf$var$ol(a, d);
                    if ((d & 130023424) === d && (b = $2ea81f475bdaffaf$var$Qk + (globalThis.REACT_FALLBACK_THROTTLE_MS || 500) - $2ea81f475bdaffaf$var$A(), 10 < b)) {
                        if (0 !== $2ea81f475bdaffaf$var$Gc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $2ea81f475bdaffaf$var$Ri();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $2ea81f475bdaffaf$var$Tf($2ea81f475bdaffaf$var$Cl.bind(null, a, $2ea81f475bdaffaf$var$el, $2ea81f475bdaffaf$var$fl), b);
                        break;
                    }
                    $2ea81f475bdaffaf$var$Cl(a, $2ea81f475bdaffaf$var$el, $2ea81f475bdaffaf$var$fl);
                    break;
                case 4:
                    $2ea81f475bdaffaf$var$ol(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;)g = 31 - $2ea81f475bdaffaf$var$Ac(d), f = 1 << g, g = b[g], g > e && (e = g), d &= ~f;
                    d = e;
                    d = $2ea81f475bdaffaf$var$A() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $2ea81f475bdaffaf$var$Xk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $2ea81f475bdaffaf$var$Tf($2ea81f475bdaffaf$var$Cl.bind(null, a, $2ea81f475bdaffaf$var$el, $2ea81f475bdaffaf$var$fl), d);
                        break;
                    }
                    $2ea81f475bdaffaf$var$Cl(a, $2ea81f475bdaffaf$var$el, $2ea81f475bdaffaf$var$fl);
                    break;
                case 5:
                    $2ea81f475bdaffaf$var$Cl(a, $2ea81f475bdaffaf$var$el, $2ea81f475bdaffaf$var$fl);
                    break;
                default:
                    throw Error($2ea81f475bdaffaf$var$p(329));
            }
        }
    }
    $2ea81f475bdaffaf$var$pl(a, $2ea81f475bdaffaf$var$A());
    return a.callbackNode === c ? $2ea81f475bdaffaf$var$sl.bind(null, a) : null;
}
function $2ea81f475bdaffaf$var$zl(a, b) {
    var c = $2ea81f475bdaffaf$var$dl;
    a.current.memoizedState.isDehydrated && ($2ea81f475bdaffaf$var$wl(a, b).flags |= 256);
    a = $2ea81f475bdaffaf$var$ul(a, b);
    2 !== a && (b = $2ea81f475bdaffaf$var$el, $2ea81f475bdaffaf$var$el = c, null !== b && $2ea81f475bdaffaf$var$lk(b));
    return a;
}
function $2ea81f475bdaffaf$var$lk(a) {
    null === $2ea81f475bdaffaf$var$el ? $2ea81f475bdaffaf$var$el = a : $2ea81f475bdaffaf$var$el.push.apply($2ea81f475bdaffaf$var$el, a);
}
function $2ea81f475bdaffaf$var$Al(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$2ea81f475bdaffaf$var$Ve(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $2ea81f475bdaffaf$var$ol(a, b) {
    b &= ~$2ea81f475bdaffaf$var$cl;
    b &= ~$2ea81f475bdaffaf$var$bl;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $2ea81f475bdaffaf$var$Ac(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $2ea81f475bdaffaf$var$ql(a) {
    $2ea81f475bdaffaf$var$Yi = $2ea81f475bdaffaf$var$Zi;
    $2ea81f475bdaffaf$var$Zi = !1;
    if (0 !== ($2ea81f475bdaffaf$var$K & 6)) throw Error($2ea81f475bdaffaf$var$p(327));
    $2ea81f475bdaffaf$var$tl();
    var b = $2ea81f475bdaffaf$var$Gc(a, 0);
    if (0 === (b & 1)) return $2ea81f475bdaffaf$var$pl(a, $2ea81f475bdaffaf$var$A()), null;
    var c = $2ea81f475bdaffaf$var$ul(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $2ea81f475bdaffaf$var$Jc(a);
        0 !== d && (b = d, c = $2ea81f475bdaffaf$var$zl(a, d));
    }
    if (1 === c) throw c = $2ea81f475bdaffaf$var$al, $2ea81f475bdaffaf$var$wl(a, 0), $2ea81f475bdaffaf$var$ol(a, b), $2ea81f475bdaffaf$var$pl(a, $2ea81f475bdaffaf$var$A()), c;
    if (6 === c) throw Error($2ea81f475bdaffaf$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $2ea81f475bdaffaf$var$Cl(a, $2ea81f475bdaffaf$var$el, $2ea81f475bdaffaf$var$fl);
    $2ea81f475bdaffaf$var$pl(a, $2ea81f475bdaffaf$var$A());
    return null;
}
function $2ea81f475bdaffaf$var$Dl(a, b) {
    var c = $2ea81f475bdaffaf$var$K;
    $2ea81f475bdaffaf$var$K |= 1;
    try {
        return a(b);
    } finally{
        $2ea81f475bdaffaf$var$K = c, 0 === $2ea81f475bdaffaf$var$K && ($2ea81f475bdaffaf$var$mk = $2ea81f475bdaffaf$var$A() + 500, $2ea81f475bdaffaf$var$tg && $2ea81f475bdaffaf$var$xg());
    }
}
function $2ea81f475bdaffaf$var$El(a) {
    null !== $2ea81f475bdaffaf$var$hl && 0 === $2ea81f475bdaffaf$var$hl.tag && 0 === ($2ea81f475bdaffaf$var$K & 6) && $2ea81f475bdaffaf$var$tl();
    var b = $2ea81f475bdaffaf$var$K;
    $2ea81f475bdaffaf$var$K |= 1;
    var c = $2ea81f475bdaffaf$var$$k.transition, d = $2ea81f475bdaffaf$var$E;
    try {
        if ($2ea81f475bdaffaf$var$$k.transition = null, $2ea81f475bdaffaf$var$E = 1, a) return a();
    } finally{
        $2ea81f475bdaffaf$var$E = d, $2ea81f475bdaffaf$var$$k.transition = c, $2ea81f475bdaffaf$var$K = b, 0 === ($2ea81f475bdaffaf$var$K & 6) && $2ea81f475bdaffaf$var$xg();
    }
}
function $2ea81f475bdaffaf$var$nk() {
    $2ea81f475bdaffaf$var$Jj = $2ea81f475bdaffaf$var$Ij.current;
    $2ea81f475bdaffaf$var$G($2ea81f475bdaffaf$var$Ij);
}
function $2ea81f475bdaffaf$var$wl(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $2ea81f475bdaffaf$var$Uf(c));
    if (null !== $2ea81f475bdaffaf$var$Y) for(c = $2ea81f475bdaffaf$var$Y.return; null !== c;){
        var d = c;
        $2ea81f475bdaffaf$var$Kg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $2ea81f475bdaffaf$var$ng();
                break;
            case 3:
                $2ea81f475bdaffaf$var$Nh();
                $2ea81f475bdaffaf$var$G($2ea81f475bdaffaf$var$jg);
                $2ea81f475bdaffaf$var$G($2ea81f475bdaffaf$var$I);
                $2ea81f475bdaffaf$var$Sh();
                break;
            case 5:
                $2ea81f475bdaffaf$var$Ph(d);
                break;
            case 4:
                $2ea81f475bdaffaf$var$Nh();
                break;
            case 13:
                $2ea81f475bdaffaf$var$G($2ea81f475bdaffaf$var$L);
                break;
            case 19:
                $2ea81f475bdaffaf$var$G($2ea81f475bdaffaf$var$L);
                break;
            case 10:
                $2ea81f475bdaffaf$var$oh(d.type._context);
                break;
            case 22:
            case 23:
                $2ea81f475bdaffaf$var$nk();
        }
        c = c.return;
    }
    $2ea81f475bdaffaf$var$Q = a;
    $2ea81f475bdaffaf$var$Y = a = $2ea81f475bdaffaf$var$ch(a.current, null);
    $2ea81f475bdaffaf$var$Z = $2ea81f475bdaffaf$var$Jj = b;
    $2ea81f475bdaffaf$var$T = 0;
    $2ea81f475bdaffaf$var$al = null;
    $2ea81f475bdaffaf$var$cl = $2ea81f475bdaffaf$var$bl = $2ea81f475bdaffaf$var$Fh = 0;
    $2ea81f475bdaffaf$var$el = $2ea81f475bdaffaf$var$dl = null;
    if (null !== $2ea81f475bdaffaf$var$th) {
        for(b = 0; b < $2ea81f475bdaffaf$var$th.length; b++)if (c = $2ea81f475bdaffaf$var$th[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $2ea81f475bdaffaf$var$th = null;
    }
    return a;
}
function $2ea81f475bdaffaf$var$yl(a, b) {
    do {
        var c = $2ea81f475bdaffaf$var$Y;
        try {
            $2ea81f475bdaffaf$var$nh();
            $2ea81f475bdaffaf$var$Th.current = $2ea81f475bdaffaf$var$ei;
            if ($2ea81f475bdaffaf$var$Wh) {
                for(var d = $2ea81f475bdaffaf$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $2ea81f475bdaffaf$var$Wh = !1;
            }
            $2ea81f475bdaffaf$var$Vh = 0;
            $2ea81f475bdaffaf$var$O = $2ea81f475bdaffaf$var$N = $2ea81f475bdaffaf$var$M = null;
            $2ea81f475bdaffaf$var$Xh = !1;
            $2ea81f475bdaffaf$var$Yh = 0;
            $2ea81f475bdaffaf$var$Zk.current = null;
            if (null === c || null === c.return) {
                $2ea81f475bdaffaf$var$T = 1;
                $2ea81f475bdaffaf$var$al = b;
                $2ea81f475bdaffaf$var$Y = null;
                break;
            }
            c.mode & 2 && $2ea81f475bdaffaf$var$$i(c, !0);
            $2ea81f475bdaffaf$var$tc();
            if (null !== b && "object" === typeof b && "function" === typeof b.then) {
                var f = b;
                null !== $2ea81f475bdaffaf$var$B && "function" === typeof $2ea81f475bdaffaf$var$B.markComponentSuspended && $2ea81f475bdaffaf$var$B.markComponentSuspended(c, f, $2ea81f475bdaffaf$var$Z);
            } else null !== $2ea81f475bdaffaf$var$B && "function" === typeof $2ea81f475bdaffaf$var$B.markComponentErrored && $2ea81f475bdaffaf$var$B.markComponentErrored(c, b, $2ea81f475bdaffaf$var$Z);
            a: {
                var g = a, h = c.return, k = c;
                f = b;
                b = $2ea81f475bdaffaf$var$Z;
                k.flags |= 32768;
                $2ea81f475bdaffaf$var$mc && $2ea81f475bdaffaf$var$wj(g, b);
                if (null !== f && "object" === typeof f && "function" === typeof f.then) {
                    var l = f, n = k, q = n.tag;
                    if (0 === (n.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = n.alternate;
                        r ? (n.updateQueue = r.updateQueue, n.memoizedState = r.memoizedState, n.lanes = r.lanes) : (n.updateQueue = null, n.memoizedState = null);
                    }
                    var z = $2ea81f475bdaffaf$var$xj(h);
                    if (null !== z) {
                        z.flags &= -257;
                        $2ea81f475bdaffaf$var$yj(z, h, k, g, b);
                        z.mode & 1 && $2ea81f475bdaffaf$var$uj(g, l, b);
                        b = z;
                        f = l;
                        var m = b.updateQueue;
                        if (null === m) {
                            var w = new Set;
                            w.add(f);
                            b.updateQueue = w;
                        } else m.add(f);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $2ea81f475bdaffaf$var$uj(g, l, b);
                            $2ea81f475bdaffaf$var$Zj();
                            break a;
                        }
                        f = Error($2ea81f475bdaffaf$var$p(426));
                    }
                } else if ($2ea81f475bdaffaf$var$J && k.mode & 1) {
                    var C = $2ea81f475bdaffaf$var$xj(h);
                    if (null !== C) {
                        0 === (C.flags & 65536) && (C.flags |= 256);
                        $2ea81f475bdaffaf$var$yj(C, h, k, g, b);
                        $2ea81f475bdaffaf$var$Xg($2ea81f475bdaffaf$var$lj(f, k));
                        break a;
                    }
                }
                g = f = $2ea81f475bdaffaf$var$lj(f, k);
                4 !== $2ea81f475bdaffaf$var$T && ($2ea81f475bdaffaf$var$T = 2);
                null === $2ea81f475bdaffaf$var$dl ? $2ea81f475bdaffaf$var$dl = [
                    g
                ] : $2ea81f475bdaffaf$var$dl.push(g);
                g = h;
                do {
                    switch(g.tag){
                        case 3:
                            g.flags |= 65536;
                            b &= -b;
                            g.lanes |= b;
                            var x = $2ea81f475bdaffaf$var$pj(g, f, b);
                            $2ea81f475bdaffaf$var$Dh(g, x);
                            break a;
                        case 1:
                            k = f;
                            var y = g.type, v = g.stateNode;
                            if (0 === (g.flags & 128) && ("function" === typeof y.getDerivedStateFromError || null !== v && "function" === typeof v.componentDidCatch && (null === $2ea81f475bdaffaf$var$tj || !$2ea81f475bdaffaf$var$tj.has(v)))) {
                                g.flags |= 65536;
                                b &= -b;
                                g.lanes |= b;
                                var D = $2ea81f475bdaffaf$var$sj(g, k, b);
                                $2ea81f475bdaffaf$var$Dh(g, D);
                                break a;
                            }
                    }
                    g = g.return;
                }while (null !== g);
            }
            $2ea81f475bdaffaf$var$Fl(c);
        } catch (ca) {
            b = ca;
            $2ea81f475bdaffaf$var$Y === c && null !== c && ($2ea81f475bdaffaf$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $2ea81f475bdaffaf$var$vl() {
    var a = $2ea81f475bdaffaf$var$Yk.current;
    $2ea81f475bdaffaf$var$Yk.current = $2ea81f475bdaffaf$var$ei;
    return null === a ? $2ea81f475bdaffaf$var$ei : a;
}
function $2ea81f475bdaffaf$var$Zj() {
    if (0 === $2ea81f475bdaffaf$var$T || 3 === $2ea81f475bdaffaf$var$T || 2 === $2ea81f475bdaffaf$var$T) $2ea81f475bdaffaf$var$T = 4;
    null === $2ea81f475bdaffaf$var$Q || 0 === ($2ea81f475bdaffaf$var$Fh & 268435455) && 0 === ($2ea81f475bdaffaf$var$bl & 268435455) || $2ea81f475bdaffaf$var$ol($2ea81f475bdaffaf$var$Q, $2ea81f475bdaffaf$var$Z);
}
function $2ea81f475bdaffaf$var$ul(a, b) {
    var c = $2ea81f475bdaffaf$var$K;
    $2ea81f475bdaffaf$var$K |= 2;
    var d = $2ea81f475bdaffaf$var$vl();
    if ($2ea81f475bdaffaf$var$Q !== a || $2ea81f475bdaffaf$var$Z !== b) {
        if ($2ea81f475bdaffaf$var$mc) {
            var e = a.memoizedUpdaters;
            0 < e.size && ($2ea81f475bdaffaf$var$wj(a, $2ea81f475bdaffaf$var$Z), e.clear());
            $2ea81f475bdaffaf$var$Qc(a, b);
        }
        $2ea81f475bdaffaf$var$fl = null;
        $2ea81f475bdaffaf$var$wl(a, b);
    }
    $2ea81f475bdaffaf$var$wc(b);
    for(;;)try {
        $2ea81f475bdaffaf$var$Gl();
        break;
    } catch (f) {
        $2ea81f475bdaffaf$var$yl(a, f);
    }
    $2ea81f475bdaffaf$var$nh();
    $2ea81f475bdaffaf$var$K = c;
    $2ea81f475bdaffaf$var$Yk.current = d;
    if (null !== $2ea81f475bdaffaf$var$Y) throw Error($2ea81f475bdaffaf$var$p(261));
    $2ea81f475bdaffaf$var$xc();
    $2ea81f475bdaffaf$var$Q = null;
    $2ea81f475bdaffaf$var$Z = 0;
    return $2ea81f475bdaffaf$var$T;
}
function $2ea81f475bdaffaf$var$Gl() {
    for(; null !== $2ea81f475bdaffaf$var$Y;)$2ea81f475bdaffaf$var$Hl($2ea81f475bdaffaf$var$Y);
}
function $2ea81f475bdaffaf$var$xl() {
    for(; null !== $2ea81f475bdaffaf$var$Y && !$2ea81f475bdaffaf$var$cc();)$2ea81f475bdaffaf$var$Hl($2ea81f475bdaffaf$var$Y);
}
function $2ea81f475bdaffaf$var$Hl(a) {
    var b = a.alternate;
    0 !== (a.mode & 2) ? ($2ea81f475bdaffaf$var$Wi = $2ea81f475bdaffaf$var$Ti(), 0 > a.actualStartTime && (a.actualStartTime = $2ea81f475bdaffaf$var$Ti()), b = $2ea81f475bdaffaf$var$Il(b, a, $2ea81f475bdaffaf$var$Jj), $2ea81f475bdaffaf$var$$i(a, !0)) : b = $2ea81f475bdaffaf$var$Il(b, a, $2ea81f475bdaffaf$var$Jj);
    a.memoizedProps = a.pendingProps;
    null === b ? $2ea81f475bdaffaf$var$Fl(a) : $2ea81f475bdaffaf$var$Y = b;
    $2ea81f475bdaffaf$var$Zk.current = null;
}
function $2ea81f475bdaffaf$var$Fl(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (0 === (b.mode & 2)) c = $2ea81f475bdaffaf$var$kk(c, b, $2ea81f475bdaffaf$var$Jj);
            else {
                var d = b;
                $2ea81f475bdaffaf$var$Wi = $2ea81f475bdaffaf$var$Ti();
                0 > d.actualStartTime && (d.actualStartTime = $2ea81f475bdaffaf$var$Ti());
                c = $2ea81f475bdaffaf$var$kk(c, b, $2ea81f475bdaffaf$var$Jj);
                $2ea81f475bdaffaf$var$$i(b, !1);
            }
            if (null !== c) {
                $2ea81f475bdaffaf$var$Y = c;
                return;
            }
        } else {
            c = $2ea81f475bdaffaf$var$ok(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $2ea81f475bdaffaf$var$Y = c;
                return;
            }
            if (0 !== (b.mode & 2)) {
                $2ea81f475bdaffaf$var$$i(b, !1);
                c = b.actualDuration;
                for(d = b.child; null !== d;)c += d.actualDuration, d = d.sibling;
                b.actualDuration = c;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $2ea81f475bdaffaf$var$T = 6;
                $2ea81f475bdaffaf$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $2ea81f475bdaffaf$var$Y = b;
            return;
        }
        $2ea81f475bdaffaf$var$Y = b = a;
    }while (null !== b);
    0 === $2ea81f475bdaffaf$var$T && ($2ea81f475bdaffaf$var$T = 5);
}
function $2ea81f475bdaffaf$var$Cl(a, b, c) {
    var d = $2ea81f475bdaffaf$var$E, e = $2ea81f475bdaffaf$var$$k.transition;
    try {
        $2ea81f475bdaffaf$var$$k.transition = null, $2ea81f475bdaffaf$var$E = 1, $2ea81f475bdaffaf$var$Jl(a, b, c, d);
    } finally{
        $2ea81f475bdaffaf$var$$k.transition = e, $2ea81f475bdaffaf$var$E = d;
    }
    return null;
}
function $2ea81f475bdaffaf$var$Jl(a, b, c, d) {
    do $2ea81f475bdaffaf$var$tl();
    while (null !== $2ea81f475bdaffaf$var$hl);
    if (0 !== ($2ea81f475bdaffaf$var$K & 6)) throw Error($2ea81f475bdaffaf$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    null !== $2ea81f475bdaffaf$var$B && "function" === typeof $2ea81f475bdaffaf$var$B.markCommitStarted && $2ea81f475bdaffaf$var$B.markCommitStarted(e);
    if (null === c) return $2ea81f475bdaffaf$var$rc(), null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($2ea81f475bdaffaf$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $2ea81f475bdaffaf$var$Nc(a, f);
    a === $2ea81f475bdaffaf$var$Q && ($2ea81f475bdaffaf$var$Y = $2ea81f475bdaffaf$var$Q = null, $2ea81f475bdaffaf$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $2ea81f475bdaffaf$var$gl || ($2ea81f475bdaffaf$var$gl = !0, $2ea81f475bdaffaf$var$rl($2ea81f475bdaffaf$var$hc, function() {
        $2ea81f475bdaffaf$var$tl();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $2ea81f475bdaffaf$var$$k.transition;
        $2ea81f475bdaffaf$var$$k.transition = null;
        var g = $2ea81f475bdaffaf$var$E;
        $2ea81f475bdaffaf$var$E = 1;
        var h = $2ea81f475bdaffaf$var$K;
        $2ea81f475bdaffaf$var$K |= 4;
        $2ea81f475bdaffaf$var$Zk.current = null;
        $2ea81f475bdaffaf$var$yk(a, c);
        $2ea81f475bdaffaf$var$Ui = $2ea81f475bdaffaf$var$Ti();
        $2ea81f475bdaffaf$var$Mk(a, c, e);
        $2ea81f475bdaffaf$var$bf($2ea81f475bdaffaf$var$Rf);
        $2ea81f475bdaffaf$var$rd = !!$2ea81f475bdaffaf$var$Qf;
        $2ea81f475bdaffaf$var$Rf = $2ea81f475bdaffaf$var$Qf = null;
        a.current = c;
        null !== $2ea81f475bdaffaf$var$B && "function" === typeof $2ea81f475bdaffaf$var$B.markLayoutEffectsStarted && $2ea81f475bdaffaf$var$B.markLayoutEffectsStarted(e);
        $2ea81f475bdaffaf$var$Sk(c, a, e);
        null !== $2ea81f475bdaffaf$var$B && "function" === typeof $2ea81f475bdaffaf$var$B.markLayoutEffectsStopped && $2ea81f475bdaffaf$var$B.markLayoutEffectsStopped();
        $2ea81f475bdaffaf$var$dc();
        $2ea81f475bdaffaf$var$K = h;
        $2ea81f475bdaffaf$var$E = g;
        $2ea81f475bdaffaf$var$$k.transition = f;
    } else a.current = c, $2ea81f475bdaffaf$var$Ui = $2ea81f475bdaffaf$var$Ti();
    $2ea81f475bdaffaf$var$gl && ($2ea81f475bdaffaf$var$gl = !1, $2ea81f475bdaffaf$var$hl = a, $2ea81f475bdaffaf$var$il = e);
    f = a.pendingLanes;
    0 === f && ($2ea81f475bdaffaf$var$tj = null);
    $2ea81f475bdaffaf$var$nc(c.stateNode, d);
    $2ea81f475bdaffaf$var$mc && a.memoizedUpdaters.clear();
    $2ea81f475bdaffaf$var$pl(a, $2ea81f475bdaffaf$var$A());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($2ea81f475bdaffaf$var$qj) throw $2ea81f475bdaffaf$var$qj = !1, a = $2ea81f475bdaffaf$var$rj, $2ea81f475bdaffaf$var$rj = null, a;
    0 !== ($2ea81f475bdaffaf$var$il & 1) && 0 !== a.tag && $2ea81f475bdaffaf$var$tl();
    f = a.pendingLanes;
    0 !== (f & 1) ? ($2ea81f475bdaffaf$var$Zi = !0, a === $2ea81f475bdaffaf$var$ll ? $2ea81f475bdaffaf$var$kl++ : ($2ea81f475bdaffaf$var$kl = 0, $2ea81f475bdaffaf$var$ll = a)) : $2ea81f475bdaffaf$var$kl = 0;
    $2ea81f475bdaffaf$var$xg();
    $2ea81f475bdaffaf$var$rc();
    return null;
}
function $2ea81f475bdaffaf$var$tl() {
    if (null !== $2ea81f475bdaffaf$var$hl) {
        var a = $2ea81f475bdaffaf$var$Rc($2ea81f475bdaffaf$var$il), b = $2ea81f475bdaffaf$var$$k.transition, c = $2ea81f475bdaffaf$var$E;
        try {
            $2ea81f475bdaffaf$var$$k.transition = null;
            $2ea81f475bdaffaf$var$E = 16 > a ? 16 : a;
            if (null === $2ea81f475bdaffaf$var$hl) var d = !1;
            else {
                a = $2ea81f475bdaffaf$var$hl;
                var e = $2ea81f475bdaffaf$var$il;
                $2ea81f475bdaffaf$var$hl = null;
                $2ea81f475bdaffaf$var$il = 0;
                if (0 !== ($2ea81f475bdaffaf$var$K & 6)) throw Error($2ea81f475bdaffaf$var$p(331));
                null !== $2ea81f475bdaffaf$var$B && "function" === typeof $2ea81f475bdaffaf$var$B.markPassiveEffectsStarted && $2ea81f475bdaffaf$var$B.markPassiveEffectsStarted(e);
                e = $2ea81f475bdaffaf$var$K;
                $2ea81f475bdaffaf$var$K |= 4;
                for($2ea81f475bdaffaf$var$U = a.current; null !== $2ea81f475bdaffaf$var$U;){
                    var f = $2ea81f475bdaffaf$var$U, g = f.child;
                    if (0 !== ($2ea81f475bdaffaf$var$U.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($2ea81f475bdaffaf$var$U = l; null !== $2ea81f475bdaffaf$var$U;){
                                    var n = $2ea81f475bdaffaf$var$U, q = n;
                                    switch(q.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            q.mode & 2 ? ($2ea81f475bdaffaf$var$Xi = $2ea81f475bdaffaf$var$Ti(), $2ea81f475bdaffaf$var$zk(8, q, f), $2ea81f475bdaffaf$var$bj(q)) : $2ea81f475bdaffaf$var$zk(8, q, f);
                                    }
                                    var r = n.child;
                                    if (null !== r) r.return = n, $2ea81f475bdaffaf$var$U = r;
                                    else for(; null !== $2ea81f475bdaffaf$var$U;){
                                        n = $2ea81f475bdaffaf$var$U;
                                        var z = n.sibling, m = n.return;
                                        $2ea81f475bdaffaf$var$Ck(n);
                                        if (n === l) {
                                            $2ea81f475bdaffaf$var$U = null;
                                            break;
                                        }
                                        if (null !== z) {
                                            z.return = m;
                                            $2ea81f475bdaffaf$var$U = z;
                                            break;
                                        }
                                        $2ea81f475bdaffaf$var$U = m;
                                    }
                                }
                            }
                            var w = f.alternate;
                            if (null !== w) {
                                var C = w.child;
                                if (null !== C) {
                                    w.child = null;
                                    do {
                                        var x = C.sibling;
                                        C.sibling = null;
                                        C = x;
                                    }while (null !== C);
                                }
                            }
                            $2ea81f475bdaffaf$var$U = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $2ea81f475bdaffaf$var$U = g;
                    else b: for(; null !== $2ea81f475bdaffaf$var$U;){
                        f = $2ea81f475bdaffaf$var$U;
                        if (0 !== (f.flags & 2048)) switch(k = f, k.tag){
                            case 0:
                            case 11:
                            case 15:
                                k.mode & 2 ? ($2ea81f475bdaffaf$var$Xi = $2ea81f475bdaffaf$var$Ti(), $2ea81f475bdaffaf$var$zk(9, k, k.return), $2ea81f475bdaffaf$var$bj(k)) : $2ea81f475bdaffaf$var$zk(9, k, k.return);
                        }
                        var y = f.sibling;
                        if (null !== y) {
                            y.return = f.return;
                            $2ea81f475bdaffaf$var$U = y;
                            break b;
                        }
                        $2ea81f475bdaffaf$var$U = f.return;
                    }
                }
                var v = a.current;
                for($2ea81f475bdaffaf$var$U = v; null !== $2ea81f475bdaffaf$var$U;){
                    g = $2ea81f475bdaffaf$var$U;
                    var D = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== D) D.return = g, $2ea81f475bdaffaf$var$U = D;
                    else b: for(g = v; null !== $2ea81f475bdaffaf$var$U;){
                        h = $2ea81f475bdaffaf$var$U;
                        if (0 !== (h.flags & 2048)) try {
                            switch(l = h, l.tag){
                                case 0:
                                case 11:
                                case 15:
                                    if (l.mode & 2) {
                                        $2ea81f475bdaffaf$var$Xi = $2ea81f475bdaffaf$var$Ti();
                                        try {
                                            $2ea81f475bdaffaf$var$Ak(9, l);
                                        } finally{
                                            $2ea81f475bdaffaf$var$bj(l);
                                        }
                                    } else $2ea81f475bdaffaf$var$Ak(9, l);
                            }
                        } catch (Pj) {
                            $2ea81f475bdaffaf$var$W(h, h.return, Pj);
                        }
                        if (h === g) {
                            $2ea81f475bdaffaf$var$U = null;
                            break b;
                        }
                        var ca = h.sibling;
                        if (null !== ca) {
                            ca.return = h.return;
                            $2ea81f475bdaffaf$var$U = ca;
                            break b;
                        }
                        $2ea81f475bdaffaf$var$U = h.return;
                    }
                }
                v = $2ea81f475bdaffaf$var$jl;
                $2ea81f475bdaffaf$var$jl = [];
                for(D = 0; D < v.length; D++){
                    var R = v[D];
                    if (0 !== (R.flags & 4)) switch(R.tag){
                        case 12:
                            var sa = R.stateNode.passiveEffectDuration, V = R.memoizedProps, Bl = V.id, yi = V.onPostCommit;
                            ca = $2ea81f475bdaffaf$var$Ui;
                            var zi = null === R.alternate ? "mount" : "update";
                            $2ea81f475bdaffaf$var$Yi && (zi = "nested-update");
                            "function" === typeof yi && yi(Bl, zi, sa, ca);
                            var lb = R.return;
                            b: for(; null !== lb;){
                                switch(lb.tag){
                                    case 3:
                                        lb.stateNode.passiveEffectDuration += sa;
                                        break b;
                                    case 12:
                                        lb.stateNode.passiveEffectDuration += sa;
                                        break b;
                                }
                                lb = lb.return;
                            }
                    }
                }
                null !== $2ea81f475bdaffaf$var$B && "function" === typeof $2ea81f475bdaffaf$var$B.markPassiveEffectsStopped && $2ea81f475bdaffaf$var$B.markPassiveEffectsStopped();
                $2ea81f475bdaffaf$var$K = e;
                $2ea81f475bdaffaf$var$xg();
                if ($2ea81f475bdaffaf$var$lc && "function" === typeof $2ea81f475bdaffaf$var$lc.onPostCommitFiberRoot) try {
                    $2ea81f475bdaffaf$var$lc.onPostCommitFiberRoot($2ea81f475bdaffaf$var$kc, a);
                } catch (Pj) {}
                var Qj = a.current.stateNode;
                Qj.effectDuration = 0;
                Qj.passiveEffectDuration = 0;
                d = !0;
            }
            return d;
        } finally{
            $2ea81f475bdaffaf$var$E = c, $2ea81f475bdaffaf$var$$k.transition = b;
        }
    }
    return !1;
}
function $2ea81f475bdaffaf$var$Wk(a) {
    $2ea81f475bdaffaf$var$jl.push(a);
    $2ea81f475bdaffaf$var$gl || ($2ea81f475bdaffaf$var$gl = !0, $2ea81f475bdaffaf$var$rl($2ea81f475bdaffaf$var$hc, function() {
        $2ea81f475bdaffaf$var$tl();
        return null;
    }));
}
function $2ea81f475bdaffaf$var$Kl(a, b, c) {
    b = $2ea81f475bdaffaf$var$lj(c, b);
    b = $2ea81f475bdaffaf$var$pj(a, b, 1);
    a = $2ea81f475bdaffaf$var$Bh(a, b, 1);
    b = $2ea81f475bdaffaf$var$Ri();
    null !== a && ($2ea81f475bdaffaf$var$Mc(a, 1, b), $2ea81f475bdaffaf$var$pl(a, b));
}
function $2ea81f475bdaffaf$var$W(a, b, c) {
    if (3 === a.tag) $2ea81f475bdaffaf$var$Kl(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $2ea81f475bdaffaf$var$Kl(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $2ea81f475bdaffaf$var$tj || !$2ea81f475bdaffaf$var$tj.has(d))) {
                a = $2ea81f475bdaffaf$var$lj(c, a);
                a = $2ea81f475bdaffaf$var$sj(b, a, 1);
                b = $2ea81f475bdaffaf$var$Bh(b, a, 1);
                a = $2ea81f475bdaffaf$var$Ri();
                null !== b && ($2ea81f475bdaffaf$var$Mc(b, 1, a), $2ea81f475bdaffaf$var$pl(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $2ea81f475bdaffaf$var$vj(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $2ea81f475bdaffaf$var$Ri();
    a.pingedLanes |= a.suspendedLanes & c;
    $2ea81f475bdaffaf$var$Q === a && ($2ea81f475bdaffaf$var$Z & c) === c && (4 === $2ea81f475bdaffaf$var$T || 3 === $2ea81f475bdaffaf$var$T && ($2ea81f475bdaffaf$var$Z & 130023424) === $2ea81f475bdaffaf$var$Z && (globalThis.REACT_FALLBACK_THROTTLE_MS || 500) > $2ea81f475bdaffaf$var$A() - $2ea81f475bdaffaf$var$Qk ? $2ea81f475bdaffaf$var$wl(a, 0) : $2ea81f475bdaffaf$var$cl |= c);
    $2ea81f475bdaffaf$var$pl(a, b);
}
function $2ea81f475bdaffaf$var$Ll(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $2ea81f475bdaffaf$var$Ec, $2ea81f475bdaffaf$var$Ec <<= 1, 0 === ($2ea81f475bdaffaf$var$Ec & 130023424) && ($2ea81f475bdaffaf$var$Ec = 4194304)));
    var c = $2ea81f475bdaffaf$var$Ri();
    a = $2ea81f475bdaffaf$var$wh(a, b);
    null !== a && ($2ea81f475bdaffaf$var$Mc(a, b, c), $2ea81f475bdaffaf$var$pl(a, c));
}
function $2ea81f475bdaffaf$var$ak(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $2ea81f475bdaffaf$var$Ll(a, c);
}
function $2ea81f475bdaffaf$var$Lk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($2ea81f475bdaffaf$var$p(314));
    }
    null !== d && d.delete(b);
    $2ea81f475bdaffaf$var$Ll(a, c);
}
var $2ea81f475bdaffaf$var$Il;
$2ea81f475bdaffaf$var$Il = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $2ea81f475bdaffaf$var$jg.current) $2ea81f475bdaffaf$var$rh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $2ea81f475bdaffaf$var$rh = !1, $2ea81f475bdaffaf$var$ek(a, b, c);
            $2ea81f475bdaffaf$var$rh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $2ea81f475bdaffaf$var$rh = !1, $2ea81f475bdaffaf$var$J && 0 !== (b.flags & 1048576) && $2ea81f475bdaffaf$var$Ig(b, $2ea81f475bdaffaf$var$Bg, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $2ea81f475bdaffaf$var$Mj(a, b);
            a = b.pendingProps;
            var e = $2ea81f475bdaffaf$var$lg(b, $2ea81f475bdaffaf$var$I.current);
            $2ea81f475bdaffaf$var$qh(b, c);
            $2ea81f475bdaffaf$var$sc(b);
            e = $2ea81f475bdaffaf$var$ai(null, b, d, a, e, c);
            var f = $2ea81f475bdaffaf$var$fi();
            $2ea81f475bdaffaf$var$tc();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $2ea81f475bdaffaf$var$mg(d) ? (f = !0, $2ea81f475bdaffaf$var$qg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $2ea81f475bdaffaf$var$yh(b), e.updater = $2ea81f475bdaffaf$var$gj, b.stateNode = e, e._reactInternals = b, $2ea81f475bdaffaf$var$kj(b, d, a, c), b = $2ea81f475bdaffaf$var$Nj(null, b, d, !0, f, c)) : (b.tag = 0, $2ea81f475bdaffaf$var$J && f && $2ea81f475bdaffaf$var$Jg(b), $2ea81f475bdaffaf$var$Aj(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $2ea81f475bdaffaf$var$Mj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $2ea81f475bdaffaf$var$Ml(d);
                a = $2ea81f475bdaffaf$var$ej(d, a);
                switch(e){
                    case 0:
                        b = $2ea81f475bdaffaf$var$Gj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $2ea81f475bdaffaf$var$Lj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $2ea81f475bdaffaf$var$Bj(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $2ea81f475bdaffaf$var$Dj(null, b, d, $2ea81f475bdaffaf$var$ej(d.type, a), c);
                        break a;
                }
                throw Error($2ea81f475bdaffaf$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $2ea81f475bdaffaf$var$ej(d, e), $2ea81f475bdaffaf$var$Gj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $2ea81f475bdaffaf$var$ej(d, e), $2ea81f475bdaffaf$var$Lj(a, b, d, e, c);
        case 3:
            a: {
                $2ea81f475bdaffaf$var$Oj(b);
                if (null === a) throw Error($2ea81f475bdaffaf$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $2ea81f475bdaffaf$var$zh(a, b);
                $2ea81f475bdaffaf$var$Eh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $2ea81f475bdaffaf$var$lj(Error($2ea81f475bdaffaf$var$p(423)), b);
                        b = $2ea81f475bdaffaf$var$Rj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $2ea81f475bdaffaf$var$lj(Error($2ea81f475bdaffaf$var$p(424)), b);
                        b = $2ea81f475bdaffaf$var$Rj(a, b, d, c, e);
                        break a;
                    } else for($2ea81f475bdaffaf$var$Mg = $2ea81f475bdaffaf$var$Zf(b.stateNode.containerInfo.firstChild), $2ea81f475bdaffaf$var$Lg = b, $2ea81f475bdaffaf$var$J = !0, $2ea81f475bdaffaf$var$Ng = null, c = $2ea81f475bdaffaf$var$ih(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $2ea81f475bdaffaf$var$Wg();
                    if (d === e) {
                        b = $2ea81f475bdaffaf$var$Cj(a, b, c);
                        break a;
                    }
                    $2ea81f475bdaffaf$var$Aj(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $2ea81f475bdaffaf$var$Oh(b), null === a && $2ea81f475bdaffaf$var$Sg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $2ea81f475bdaffaf$var$Sf(d, e) ? g = null : null !== f && $2ea81f475bdaffaf$var$Sf(d, f) && (b.flags |= 32), $2ea81f475bdaffaf$var$Kj(a, b), $2ea81f475bdaffaf$var$Aj(a, b, g, c), b.child;
        case 6:
            return null === a && $2ea81f475bdaffaf$var$Sg(b), null;
        case 13:
            return $2ea81f475bdaffaf$var$Uj(a, b, c);
        case 4:
            return $2ea81f475bdaffaf$var$Mh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $2ea81f475bdaffaf$var$hh(b, null, d, c) : $2ea81f475bdaffaf$var$Aj(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $2ea81f475bdaffaf$var$ej(d, e), $2ea81f475bdaffaf$var$Bj(a, b, d, e, c);
        case 7:
            return $2ea81f475bdaffaf$var$Aj(a, b, b.pendingProps, c), b.child;
        case 8:
            return $2ea81f475bdaffaf$var$Aj(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return b.flags |= 4, d = b.stateNode, d.effectDuration = 0, d.passiveEffectDuration = 0, $2ea81f475bdaffaf$var$Aj(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $2ea81f475bdaffaf$var$H($2ea81f475bdaffaf$var$jh, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($2ea81f475bdaffaf$var$Ve(f.value, g)) {
                        if (f.children === e.children && !$2ea81f475bdaffaf$var$jg.current) {
                            b = $2ea81f475bdaffaf$var$Cj(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $2ea81f475bdaffaf$var$Ah(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var n = l.pending;
                                            null === n ? k.next = k : (k.next = n.next, n.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $2ea81f475bdaffaf$var$ph(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($2ea81f475bdaffaf$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $2ea81f475bdaffaf$var$ph(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $2ea81f475bdaffaf$var$Aj(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $2ea81f475bdaffaf$var$qh(b, c), e = $2ea81f475bdaffaf$var$sh(e), $2ea81f475bdaffaf$var$sc(b), d = d(e), $2ea81f475bdaffaf$var$tc(), b.flags |= 1, $2ea81f475bdaffaf$var$Aj(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $2ea81f475bdaffaf$var$ej(d, b.pendingProps), e = $2ea81f475bdaffaf$var$ej(d.type, e), $2ea81f475bdaffaf$var$Dj(a, b, d, e, c);
        case 15:
            return $2ea81f475bdaffaf$var$Fj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $2ea81f475bdaffaf$var$ej(d, e), $2ea81f475bdaffaf$var$Mj(a, b), b.tag = 1, $2ea81f475bdaffaf$var$mg(d) ? (a = !0, $2ea81f475bdaffaf$var$qg(b)) : a = !1, $2ea81f475bdaffaf$var$qh(b, c), $2ea81f475bdaffaf$var$ij(b, d, e), $2ea81f475bdaffaf$var$kj(b, d, e, c), $2ea81f475bdaffaf$var$Nj(null, b, d, !0, a, c);
        case 19:
            return $2ea81f475bdaffaf$var$dk(a, b, c);
        case 22:
            return $2ea81f475bdaffaf$var$Hj(a, b, c);
    }
    throw Error($2ea81f475bdaffaf$var$p(156, b.tag));
};
function $2ea81f475bdaffaf$var$wj(a, b) {
    $2ea81f475bdaffaf$var$mc && a.memoizedUpdaters.forEach(function(c) {
        $2ea81f475bdaffaf$var$Pc(a, c, b);
    });
}
function $2ea81f475bdaffaf$var$rl(a, b) {
    return $2ea81f475bdaffaf$var$ac(a, b);
}
function $2ea81f475bdaffaf$var$Nl(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
    this.actualDuration = 0;
    this.actualStartTime = -1;
    this.treeBaseDuration = this.selfBaseDuration = 0;
}
function $2ea81f475bdaffaf$var$Pg(a, b, c, d) {
    return new $2ea81f475bdaffaf$var$Nl(a, b, c, d);
}
function $2ea81f475bdaffaf$var$Ej(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $2ea81f475bdaffaf$var$Ml(a) {
    if ("function" === typeof a) return $2ea81f475bdaffaf$var$Ej(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $2ea81f475bdaffaf$var$Da) return 11;
        if (a === $2ea81f475bdaffaf$var$Ga) return 14;
    }
    return 2;
}
function $2ea81f475bdaffaf$var$ch(a, b) {
    var c = a.alternate;
    null === c ? (c = $2ea81f475bdaffaf$var$Pg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null, c.actualDuration = 0, c.actualStartTime = -1);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    c.selfBaseDuration = a.selfBaseDuration;
    c.treeBaseDuration = a.treeBaseDuration;
    return c;
}
function $2ea81f475bdaffaf$var$eh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $2ea81f475bdaffaf$var$Ej(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $2ea81f475bdaffaf$var$ya:
            return $2ea81f475bdaffaf$var$gh(c.children, e, f, b);
        case $2ea81f475bdaffaf$var$za:
            g = 8;
            e |= 8;
            break;
        case $2ea81f475bdaffaf$var$Aa:
            return a = $2ea81f475bdaffaf$var$Pg(12, c, b, e | 2), a.elementType = $2ea81f475bdaffaf$var$Aa, a.lanes = f, a.stateNode = {
                effectDuration: 0,
                passiveEffectDuration: 0
            }, a;
        case $2ea81f475bdaffaf$var$Ea:
            return a = $2ea81f475bdaffaf$var$Pg(13, c, b, e), a.elementType = $2ea81f475bdaffaf$var$Ea, a.lanes = f, a;
        case $2ea81f475bdaffaf$var$Fa:
            return a = $2ea81f475bdaffaf$var$Pg(19, c, b, e), a.elementType = $2ea81f475bdaffaf$var$Fa, a.lanes = f, a;
        case $2ea81f475bdaffaf$var$Ia:
            return $2ea81f475bdaffaf$var$Vj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $2ea81f475bdaffaf$var$Ba:
                    g = 10;
                    break a;
                case $2ea81f475bdaffaf$var$Ca:
                    g = 9;
                    break a;
                case $2ea81f475bdaffaf$var$Da:
                    g = 11;
                    break a;
                case $2ea81f475bdaffaf$var$Ga:
                    g = 14;
                    break a;
                case $2ea81f475bdaffaf$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($2ea81f475bdaffaf$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $2ea81f475bdaffaf$var$Pg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $2ea81f475bdaffaf$var$gh(a, b, c, d) {
    a = $2ea81f475bdaffaf$var$Pg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $2ea81f475bdaffaf$var$Vj(a, b, c, d) {
    a = $2ea81f475bdaffaf$var$Pg(22, a, d, b);
    a.elementType = $2ea81f475bdaffaf$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $2ea81f475bdaffaf$var$dh(a, b, c) {
    a = $2ea81f475bdaffaf$var$Pg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $2ea81f475bdaffaf$var$fh(a, b, c) {
    b = $2ea81f475bdaffaf$var$Pg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $2ea81f475bdaffaf$var$Ol(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $2ea81f475bdaffaf$var$Lc(0);
    this.expirationTimes = $2ea81f475bdaffaf$var$Lc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $2ea81f475bdaffaf$var$Lc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
    this.passiveEffectDuration = this.effectDuration = 0;
    this.memoizedUpdaters = new Set;
    a = this.pendingUpdatersLaneMap = [];
    for(b = 0; 31 > b; b++)a.push(new Set);
}
function $2ea81f475bdaffaf$var$Pl(a, b, c, d, e, f, g, h, k) {
    a = new $2ea81f475bdaffaf$var$Ol(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    $2ea81f475bdaffaf$var$mc && (b |= 2);
    f = $2ea81f475bdaffaf$var$Pg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $2ea81f475bdaffaf$var$yh(f);
    return a;
}
function $2ea81f475bdaffaf$var$Ql(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $2ea81f475bdaffaf$var$xa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $2ea81f475bdaffaf$var$Rl(a) {
    if (!a) return $2ea81f475bdaffaf$var$ig;
    a = a._reactInternals;
    a: {
        if ($2ea81f475bdaffaf$var$Vb(a) !== a || 1 !== a.tag) throw Error($2ea81f475bdaffaf$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($2ea81f475bdaffaf$var$mg(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($2ea81f475bdaffaf$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($2ea81f475bdaffaf$var$mg(c)) return $2ea81f475bdaffaf$var$pg(a, c, b);
    }
    return b;
}
function $2ea81f475bdaffaf$var$Sl(a, b, c, d, e, f, g, h, k) {
    a = $2ea81f475bdaffaf$var$Pl(c, d, !0, a, e, f, g, h, k);
    a.context = $2ea81f475bdaffaf$var$Rl(null);
    c = a.current;
    d = $2ea81f475bdaffaf$var$Ri();
    e = $2ea81f475bdaffaf$var$Oi(c);
    f = $2ea81f475bdaffaf$var$Ah(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $2ea81f475bdaffaf$var$Bh(c, f, e);
    a.current.lanes = e;
    $2ea81f475bdaffaf$var$Mc(a, e, d);
    $2ea81f475bdaffaf$var$pl(a, d);
    return a;
}
function $2ea81f475bdaffaf$var$Tl(a, b, c, d) {
    var e = b.current, f = $2ea81f475bdaffaf$var$Ri(), g = $2ea81f475bdaffaf$var$Oi(e);
    null !== $2ea81f475bdaffaf$var$B && "function" === typeof $2ea81f475bdaffaf$var$B.markRenderScheduled && $2ea81f475bdaffaf$var$B.markRenderScheduled(g);
    c = $2ea81f475bdaffaf$var$Rl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $2ea81f475bdaffaf$var$Ah(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $2ea81f475bdaffaf$var$Bh(e, b, g);
    null !== a && ($2ea81f475bdaffaf$var$ui(a, e, g, f), $2ea81f475bdaffaf$var$Ch(a, e, g));
    return g;
}
function $2ea81f475bdaffaf$var$Ul(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $2ea81f475bdaffaf$var$Vl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $2ea81f475bdaffaf$var$Wl(a, b) {
    $2ea81f475bdaffaf$var$Vl(a, b);
    (a = a.alternate) && $2ea81f475bdaffaf$var$Vl(a, b);
}
function $2ea81f475bdaffaf$var$Xl() {
    return null;
}
var $2ea81f475bdaffaf$var$Yl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $2ea81f475bdaffaf$var$Zl(a) {
    this._internalRoot = a;
}
$2ea81f475bdaffaf$var$$l.prototype.render = $2ea81f475bdaffaf$var$Zl.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($2ea81f475bdaffaf$var$p(409));
    $2ea81f475bdaffaf$var$Tl(a, b, null, null);
};
$2ea81f475bdaffaf$var$$l.prototype.unmount = $2ea81f475bdaffaf$var$Zl.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $2ea81f475bdaffaf$var$El(function() {
            $2ea81f475bdaffaf$var$Tl(null, a, null, null);
        });
        b[$2ea81f475bdaffaf$var$If] = null;
    }
};
function $2ea81f475bdaffaf$var$$l(a) {
    this._internalRoot = a;
}
$2ea81f475bdaffaf$var$$l.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $2ea81f475bdaffaf$var$Vc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $2ea81f475bdaffaf$var$dd.length && 0 !== b && b < $2ea81f475bdaffaf$var$dd[c].priority; c++);
        $2ea81f475bdaffaf$var$dd.splice(c, 0, a);
        0 === c && $2ea81f475bdaffaf$var$id(a);
    }
};
function $2ea81f475bdaffaf$var$am(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $2ea81f475bdaffaf$var$bm(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $2ea81f475bdaffaf$var$cm() {}
function $2ea81f475bdaffaf$var$dm(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $2ea81f475bdaffaf$var$Ul(g);
                f.call(a);
            };
        }
        var g = $2ea81f475bdaffaf$var$Sl(b, d, a, 0, null, !1, !1, "", $2ea81f475bdaffaf$var$cm);
        a._reactRootContainer = g;
        a[$2ea81f475bdaffaf$var$If] = g.current;
        $2ea81f475bdaffaf$var$Gf(8 === a.nodeType ? a.parentNode : a);
        $2ea81f475bdaffaf$var$El();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $2ea81f475bdaffaf$var$Ul(k);
            h.call(a);
        };
    }
    var k = $2ea81f475bdaffaf$var$Pl(a, 0, !1, null, null, !1, !1, "", $2ea81f475bdaffaf$var$cm);
    a._reactRootContainer = k;
    a[$2ea81f475bdaffaf$var$If] = k.current;
    $2ea81f475bdaffaf$var$Gf(8 === a.nodeType ? a.parentNode : a);
    $2ea81f475bdaffaf$var$El(function() {
        $2ea81f475bdaffaf$var$Tl(b, k, c, d);
    });
    return k;
}
function $2ea81f475bdaffaf$var$em(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $2ea81f475bdaffaf$var$Ul(g);
                h.call(a);
            };
        }
        $2ea81f475bdaffaf$var$Tl(b, g, a, e);
    } else g = $2ea81f475bdaffaf$var$dm(c, b, a, e, d);
    return $2ea81f475bdaffaf$var$Ul(g);
}
$2ea81f475bdaffaf$var$Sc = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $2ea81f475bdaffaf$var$Fc(b.pendingLanes);
                0 !== c && ($2ea81f475bdaffaf$var$Oc(b, c | 1), $2ea81f475bdaffaf$var$pl(b, $2ea81f475bdaffaf$var$A()), 0 === ($2ea81f475bdaffaf$var$K & 6) && ($2ea81f475bdaffaf$var$mk = $2ea81f475bdaffaf$var$A() + 500, $2ea81f475bdaffaf$var$xg()));
            }
            break;
        case 13:
            $2ea81f475bdaffaf$var$El(function() {
                var b = $2ea81f475bdaffaf$var$wh(a, 1);
                if (null !== b) {
                    var c = $2ea81f475bdaffaf$var$Ri();
                    $2ea81f475bdaffaf$var$ui(b, a, 1, c);
                }
            }), $2ea81f475bdaffaf$var$Wl(a, 1);
    }
};
$2ea81f475bdaffaf$var$Tc = function(a) {
    if (13 === a.tag) {
        var b = $2ea81f475bdaffaf$var$wh(a, 134217728);
        if (null !== b) {
            var c = $2ea81f475bdaffaf$var$Ri();
            $2ea81f475bdaffaf$var$ui(b, a, 134217728, c);
        }
        $2ea81f475bdaffaf$var$Wl(a, 134217728);
    }
};
$2ea81f475bdaffaf$var$Uc = function(a) {
    if (13 === a.tag) {
        var b = $2ea81f475bdaffaf$var$Oi(a), c = $2ea81f475bdaffaf$var$wh(a, b);
        if (null !== c) {
            var d = $2ea81f475bdaffaf$var$Ri();
            $2ea81f475bdaffaf$var$ui(c, a, b, d);
        }
        $2ea81f475bdaffaf$var$Wl(a, b);
    }
};
$2ea81f475bdaffaf$var$Vc = function() {
    return $2ea81f475bdaffaf$var$E;
};
$2ea81f475bdaffaf$var$Wc = function(a, b) {
    var c = $2ea81f475bdaffaf$var$E;
    try {
        return $2ea81f475bdaffaf$var$E = a, b();
    } finally{
        $2ea81f475bdaffaf$var$E = c;
    }
};
$2ea81f475bdaffaf$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $2ea81f475bdaffaf$var$ab(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $2ea81f475bdaffaf$var$Db(d);
                        if (!e) throw Error($2ea81f475bdaffaf$var$p(90));
                        $2ea81f475bdaffaf$var$Wa(d);
                        $2ea81f475bdaffaf$var$ab(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $2ea81f475bdaffaf$var$hb(a, c);
            break;
        case "select":
            b = c.value, null != b && $2ea81f475bdaffaf$var$eb(a, !!c.multiple, b, !1);
    }
};
$2ea81f475bdaffaf$var$Gb = $2ea81f475bdaffaf$var$Dl;
$2ea81f475bdaffaf$var$Hb = $2ea81f475bdaffaf$var$El;
var $2ea81f475bdaffaf$var$fm = {
    usingClientEntryPoint: !1,
    Events: [
        $2ea81f475bdaffaf$var$Cb,
        $2ea81f475bdaffaf$var$Ie,
        $2ea81f475bdaffaf$var$Db,
        $2ea81f475bdaffaf$var$Eb,
        $2ea81f475bdaffaf$var$Fb,
        $2ea81f475bdaffaf$var$Dl
    ]
}, $2ea81f475bdaffaf$var$gm = {
    findFiberByHostInstance: $2ea81f475bdaffaf$var$jd,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
(function(a) {
    if ("undefined" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) return !1;
    var b = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (b.isDisabled || !b.supportsFiber) return !0;
    try {
        a = $2ea81f475bdaffaf$var$u({}, a, {
            getLaneLabelMap: $2ea81f475bdaffaf$var$pc,
            injectProfilingHooks: $2ea81f475bdaffaf$var$oc
        }), $2ea81f475bdaffaf$var$kc = b.inject(a), $2ea81f475bdaffaf$var$lc = b;
    } catch (c) {}
    return b.checkDCE ? !0 : !1;
})({
    bundleType: $2ea81f475bdaffaf$var$gm.bundleType,
    version: $2ea81f475bdaffaf$var$gm.version,
    rendererPackageName: $2ea81f475bdaffaf$var$gm.rendererPackageName,
    rendererConfig: $2ea81f475bdaffaf$var$gm.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $2ea81f475bdaffaf$var$va.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $2ea81f475bdaffaf$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $2ea81f475bdaffaf$var$gm.findFiberByHostInstance || $2ea81f475bdaffaf$var$Xl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
});
$2ea81f475bdaffaf$export$ae55be85d98224ed = $2ea81f475bdaffaf$var$fm;
$2ea81f475bdaffaf$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$2ea81f475bdaffaf$var$am(b)) throw Error($2ea81f475bdaffaf$var$p(200));
    return $2ea81f475bdaffaf$var$Ql(a, b, null, c);
};
$2ea81f475bdaffaf$export$882461b6382ed46c = function(a, b) {
    if (!$2ea81f475bdaffaf$var$am(a)) throw Error($2ea81f475bdaffaf$var$p(299));
    var c = !1, d = "", e = $2ea81f475bdaffaf$var$Yl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $2ea81f475bdaffaf$var$Pl(a, 1, !1, null, null, c, !1, d, e);
    a[$2ea81f475bdaffaf$var$If] = b.current;
    $2ea81f475bdaffaf$var$Gf(8 === a.nodeType ? a.parentNode : a);
    return new $2ea81f475bdaffaf$var$Zl(b);
};
$2ea81f475bdaffaf$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($2ea81f475bdaffaf$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($2ea81f475bdaffaf$var$p(268, a));
    }
    a = $2ea81f475bdaffaf$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$2ea81f475bdaffaf$export$cd75ccfd720a3cd4 = function(a) {
    return $2ea81f475bdaffaf$var$El(a);
};
$2ea81f475bdaffaf$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$2ea81f475bdaffaf$var$bm(b)) throw Error($2ea81f475bdaffaf$var$p(200));
    return $2ea81f475bdaffaf$var$em(null, a, b, !0, c);
};
$2ea81f475bdaffaf$export$757ceba2d55c277e = function(a, b, c) {
    if (!$2ea81f475bdaffaf$var$am(a)) throw Error($2ea81f475bdaffaf$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $2ea81f475bdaffaf$var$Yl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $2ea81f475bdaffaf$var$Sl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$2ea81f475bdaffaf$var$If] = b.current;
    $2ea81f475bdaffaf$var$Gf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $2ea81f475bdaffaf$var$$l(b);
};
$2ea81f475bdaffaf$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$2ea81f475bdaffaf$var$bm(b)) throw Error($2ea81f475bdaffaf$var$p(200));
    return $2ea81f475bdaffaf$var$em(null, a, b, !1, c);
};
$2ea81f475bdaffaf$export$502457920280e6be = function(a) {
    if (!$2ea81f475bdaffaf$var$bm(a)) throw Error($2ea81f475bdaffaf$var$p(40));
    return a._reactRootContainer ? ($2ea81f475bdaffaf$var$El(function() {
        $2ea81f475bdaffaf$var$em(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$2ea81f475bdaffaf$var$If] = null;
        });
    }), !0) : !1;
};
$2ea81f475bdaffaf$export$c78a37762a8d58e1 = $2ea81f475bdaffaf$var$Dl;
$2ea81f475bdaffaf$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$2ea81f475bdaffaf$var$bm(c)) throw Error($2ea81f475bdaffaf$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($2ea81f475bdaffaf$var$p(38));
    return $2ea81f475bdaffaf$var$em(a, b, c, !1, d);
};
$2ea81f475bdaffaf$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";
/* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop === 'function') __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());

});


parcelRegister("926XZ", function(module, exports) {
/**
 * Expose `pathToRegexp`.
 */ module.exports = $6939b462bdd18cc1$var$pathToRegexp;
module.exports.match = $6939b462bdd18cc1$var$match;
module.exports.regexpToFunction = $6939b462bdd18cc1$var$regexpToFunction;
module.exports.parse = $6939b462bdd18cc1$var$parse;
module.exports.compile = $6939b462bdd18cc1$var$compile;
module.exports.tokensToFunction = $6939b462bdd18cc1$var$tokensToFunction;
module.exports.tokensToRegExp = $6939b462bdd18cc1$var$tokensToRegExp;
/**
 * Default configs.
 */ var $6939b462bdd18cc1$var$DEFAULT_DELIMITER = '/';
/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */ var $6939b462bdd18cc1$var$PATH_REGEXP = new RegExp([
    // Match escaped characters that would otherwise appear in future matches.
    // This allows the user to escape special characters that won't transform.
    '(\\\\.)',
    // Match Express-style parameters and un-named parameters with a prefix
    // and optional suffixes. Matches appear as:
    //
    // ":test(\\d+)?" => ["test", "\d+", undefined, "?"]
    // "(\\d+)"  => [undefined, undefined, "\d+", undefined]
    '(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?'
].join('|'), 'g');
/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */ function $6939b462bdd18cc1$var$parse(str, options) {
    var tokens = [];
    var key = 0;
    var index = 0;
    var path = '';
    var defaultDelimiter = options && options.delimiter || $6939b462bdd18cc1$var$DEFAULT_DELIMITER;
    var whitelist = options && options.whitelist || undefined;
    var pathEscaped = false;
    var res;
    while((res = $6939b462bdd18cc1$var$PATH_REGEXP.exec(str)) !== null){
        var m = res[0];
        var escaped = res[1];
        var offset = res.index;
        path += str.slice(index, offset);
        index = offset + m.length;
        // Ignore already escaped sequences.
        if (escaped) {
            path += escaped[1];
            pathEscaped = true;
            continue;
        }
        var prev = '';
        var name = res[2];
        var capture = res[3];
        var group = res[4];
        var modifier = res[5];
        if (!pathEscaped && path.length) {
            var k = path.length - 1;
            var c = path[k];
            var matches = whitelist ? whitelist.indexOf(c) > -1 : true;
            if (matches) {
                prev = c;
                path = path.slice(0, k);
            }
        }
        // Push the current path onto the tokens.
        if (path) {
            tokens.push(path);
            path = '';
            pathEscaped = false;
        }
        var repeat = modifier === '+' || modifier === '*';
        var optional = modifier === '?' || modifier === '*';
        var pattern = capture || group;
        var delimiter = prev || defaultDelimiter;
        var prevText = prev || (typeof tokens[tokens.length - 1] === 'string' ? tokens[tokens.length - 1] : '');
        tokens.push({
            name: name || key++,
            prefix: prev,
            delimiter: delimiter,
            optional: optional,
            repeat: repeat,
            pattern: pattern ? $6939b462bdd18cc1$var$escapeGroup(pattern) : $6939b462bdd18cc1$var$restrictBacktrack(delimiter, defaultDelimiter, prevText)
        });
    }
    // Push any remaining characters.
    if (path || index < str.length) tokens.push(path + str.substr(index));
    return tokens;
}
function $6939b462bdd18cc1$var$restrictBacktrack(delimiter, defaultDelimiter, prevText) {
    var charGroup = '[^' + $6939b462bdd18cc1$var$escapeString(delimiter === defaultDelimiter ? delimiter : delimiter + defaultDelimiter) + ']';
    if (!prevText || prevText.indexOf(delimiter) > -1 || prevText.indexOf(defaultDelimiter) > -1) return charGroup + '+?';
    return $6939b462bdd18cc1$var$escapeString(prevText) + '|(?:(?!' + $6939b462bdd18cc1$var$escapeString(prevText) + ')' + charGroup + ')+?';
}
/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */ function $6939b462bdd18cc1$var$compile(str, options) {
    return $6939b462bdd18cc1$var$tokensToFunction($6939b462bdd18cc1$var$parse(str, options), options);
}
/**
 * Create path match function from `path-to-regexp` spec.
 */ function $6939b462bdd18cc1$var$match(str, options) {
    var keys = [];
    var re = $6939b462bdd18cc1$var$pathToRegexp(str, keys, options);
    return $6939b462bdd18cc1$var$regexpToFunction(re, keys);
}
/**
 * Create a path match function from `path-to-regexp` output.
 */ function $6939b462bdd18cc1$var$regexpToFunction(re, keys) {
    return function(pathname, options) {
        var m = re.exec(pathname);
        if (!m) return false;
        var path = m[0];
        var index = m.index;
        var params = {};
        var decode = options && options.decode || decodeURIComponent;
        for(var i = 1; i < m.length; i++){
            if (m[i] === undefined) continue;
            var key = keys[i - 1];
            if (key.repeat) params[key.name] = m[i].split(key.delimiter).map(function(value) {
                return decode(value, key);
            });
            else params[key.name] = decode(m[i], key);
        }
        return {
            path: path,
            index: index,
            params: params
        };
    };
}
/**
 * Expose a method for transforming tokens into the path function.
 */ function $6939b462bdd18cc1$var$tokensToFunction(tokens, options) {
    // Compile all the tokens into regexps.
    var matches = new Array(tokens.length);
    // Compile all the patterns before compilation.
    for(var i = 0; i < tokens.length; i++)if (typeof tokens[i] === 'object') matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$', $6939b462bdd18cc1$var$flags(options));
    return function(data, options) {
        var path = '';
        var encode = options && options.encode || encodeURIComponent;
        var validate = options ? options.validate !== false : true;
        for(var i = 0; i < tokens.length; i++){
            var token = tokens[i];
            if (typeof token === 'string') {
                path += token;
                continue;
            }
            var value = data ? data[token.name] : undefined;
            var segment;
            if (Array.isArray(value)) {
                if (!token.repeat) throw new TypeError('Expected "' + token.name + '" to not repeat, but got array');
                if (value.length === 0) {
                    if (token.optional) continue;
                    throw new TypeError('Expected "' + token.name + '" to not be empty');
                }
                for(var j = 0; j < value.length; j++){
                    segment = encode(value[j], token);
                    if (validate && !matches[i].test(segment)) throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '"');
                    path += (j === 0 ? token.prefix : token.delimiter) + segment;
                }
                continue;
            }
            if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
                segment = encode(String(value), token);
                if (validate && !matches[i].test(segment)) throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but got "' + segment + '"');
                path += token.prefix + segment;
                continue;
            }
            if (token.optional) continue;
            throw new TypeError('Expected "' + token.name + '" to be ' + (token.repeat ? 'an array' : 'a string'));
        }
        return path;
    };
}
/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */ function $6939b462bdd18cc1$var$escapeString(str) {
    return str.replace(/([.+*?=^!:${}()[\]|/\\])/g, '\\$1');
}
/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */ function $6939b462bdd18cc1$var$escapeGroup(group) {
    return group.replace(/([=!:$/()])/g, '\\$1');
}
/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */ function $6939b462bdd18cc1$var$flags(options) {
    return options && options.sensitive ? '' : 'i';
}
/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {Array=}  keys
 * @return {!RegExp}
 */ function $6939b462bdd18cc1$var$regexpToRegexp(path, keys) {
    if (!keys) return path;
    // Use a negative lookahead to match only capturing groups.
    var groups = path.source.match(/\((?!\?)/g);
    if (groups) for(var i = 0; i < groups.length; i++)keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        pattern: null
    });
    return path;
}
/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array=}  keys
 * @param  {Object=} options
 * @return {!RegExp}
 */ function $6939b462bdd18cc1$var$arrayToRegexp(path, keys, options) {
    var parts = [];
    for(var i = 0; i < path.length; i++)parts.push($6939b462bdd18cc1$var$pathToRegexp(path[i], keys, options).source);
    return new RegExp('(?:' + parts.join('|') + ')', $6939b462bdd18cc1$var$flags(options));
}
/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {Array=}  keys
 * @param  {Object=} options
 * @return {!RegExp}
 */ function $6939b462bdd18cc1$var$stringToRegexp(path, keys, options) {
    return $6939b462bdd18cc1$var$tokensToRegExp($6939b462bdd18cc1$var$parse(path, options), keys, options);
}
/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}  tokens
 * @param  {Array=}  keys
 * @param  {Object=} options
 * @return {!RegExp}
 */ function $6939b462bdd18cc1$var$tokensToRegExp(tokens, keys, options) {
    options = options || {};
    var strict = options.strict;
    var start = options.start !== false;
    var end = options.end !== false;
    var delimiter = options.delimiter || $6939b462bdd18cc1$var$DEFAULT_DELIMITER;
    var endsWith = [].concat(options.endsWith || []).map($6939b462bdd18cc1$var$escapeString).concat('$').join('|');
    var route = start ? '^' : '';
    // Iterate over the tokens and create our regexp string.
    for(var i = 0; i < tokens.length; i++){
        var token = tokens[i];
        if (typeof token === 'string') route += $6939b462bdd18cc1$var$escapeString(token);
        else {
            var capture = token.repeat ? '(?:' + token.pattern + ')(?:' + $6939b462bdd18cc1$var$escapeString(token.delimiter) + '(?:' + token.pattern + '))*' : token.pattern;
            if (keys) keys.push(token);
            if (token.optional) {
                if (!token.prefix) route += '(' + capture + ')?';
                else route += '(?:' + $6939b462bdd18cc1$var$escapeString(token.prefix) + '(' + capture + '))?';
            } else route += $6939b462bdd18cc1$var$escapeString(token.prefix) + '(' + capture + ')';
        }
    }
    if (end) {
        if (!strict) route += '(?:' + $6939b462bdd18cc1$var$escapeString(delimiter) + ')?';
        route += endsWith === '$' ? '$' : '(?=' + endsWith + ')';
    } else {
        var endToken = tokens[tokens.length - 1];
        var isEndDelimited = typeof endToken === 'string' ? endToken[endToken.length - 1] === delimiter : endToken === undefined;
        if (!strict) route += '(?:' + $6939b462bdd18cc1$var$escapeString(delimiter) + '(?=' + endsWith + '))?';
        if (!isEndDelimited) route += '(?=' + $6939b462bdd18cc1$var$escapeString(delimiter) + '|' + endsWith + ')';
    }
    return new RegExp(route, $6939b462bdd18cc1$var$flags(options));
}
/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {Array=}                keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */ function $6939b462bdd18cc1$var$pathToRegexp(path, keys, options) {
    if (path instanceof RegExp) return $6939b462bdd18cc1$var$regexpToRegexp(path, keys);
    if (Array.isArray(path)) return $6939b462bdd18cc1$var$arrayToRegexp(/** @type {!Array} */ path, keys, options);
    return $6939b462bdd18cc1$var$stringToRegexp(/** @type {string} */ path, keys, options);
}

});

parcelRegister("3bk1b", function(module, exports) {
$parcel$export(module.exports, "keyframes", () => $2511ed5d36abfd3d$export$d25ddfdf17c3ad3e);
$parcel$export(module.exports, "jsx", () => $2511ed5d36abfd3d$export$c8a8987d4410bf2d);
$parcel$export(module.exports, "ThemeContext", () => (parcelRequire("eKnMP")).T);
$parcel$export(module.exports, "withEmotionCache", () => (parcelRequire("eKnMP")).w);
$parcel$export(module.exports, "css", () => (parcelRequire("3lmqY")).default);

var $b8SSx = parcelRequire("b8SSx");

var $eJOHy = parcelRequire("eJOHy");
parcelRequire("4Z5dY");

var $eKnMP = parcelRequire("eKnMP");

var $l5tKr = parcelRequire("l5tKr");

var $915ra = parcelRequire("915ra");

var $6k6gF = parcelRequire("6k6gF");

var $3lmqY = parcelRequire("3lmqY");
var $2511ed5d36abfd3d$export$c8a8987d4410bf2d = function jsx(type, props) {
    var args = arguments;
    if (props == null || !(0, $eKnMP.h).call(props, 'css')) // $FlowFixMe
    return (0, $eJOHy.createElement).apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $eKnMP.E);
    createElementArgArray[1] = (0, $eKnMP.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
     // $FlowFixMe
    return (0, $eJOHy.createElement).apply(null, createElementArgArray);
};
var $2511ed5d36abfd3d$var$warnedAboutCssPropForGlobal = false;
var $2511ed5d36abfd3d$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $eKnMP.w)(function(props, cache) {
    var styles = props.styles;
    if (typeof styles === 'function') return /*#__PURE__*/ (0, $eJOHy.createElement)((0, $eKnMP.T).Consumer, null, function(theme) {
        var serialized = (0, $915ra.serializeStyles)([
            styles(theme)
        ]);
        return /*#__PURE__*/ (0, $eJOHy.createElement)($2511ed5d36abfd3d$var$InnerGlobal, {
            serialized: serialized,
            cache: cache
        });
    });
    var serialized = (0, $915ra.serializeStyles)([
        styles
    ]);
    return /*#__PURE__*/ (0, $eJOHy.createElement)($2511ed5d36abfd3d$var$InnerGlobal, {
        serialized: serialized,
        cache: cache
    });
});
// maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $2511ed5d36abfd3d$var$InnerGlobal = /*#__PURE__*/ function(_React$Component) {
    (0, $b8SSx.default)(InnerGlobal, _React$Component);
    function InnerGlobal(props, context, updater) {
        return _React$Component.call(this, props, context, updater) || this;
    }
    var _proto = InnerGlobal.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.sheet = new (0, $6k6gF.StyleSheet)({
            key: this.props.cache.key + "-global",
            nonce: this.props.cache.sheet.nonce,
            container: this.props.cache.sheet.container
        }); // $FlowFixMe
        var node = document.querySelector("style[data-emotion-" + this.props.cache.key + "=\"" + this.props.serialized.name + "\"]");
        if (node !== null) this.sheet.tags.push(node);
        if (this.props.cache.sheet.tags.length) this.sheet.before = this.props.cache.sheet.tags[0];
        this.insertStyles();
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (prevProps.serialized.name !== this.props.serialized.name) this.insertStyles();
    };
    _proto.insertStyles = function insertStyles$1() {
        if (this.props.serialized.next !== undefined) // insert keyframes
        (0, $l5tKr.insertStyles)(this.props.cache, this.props.serialized.next, true);
        if (this.sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = this.sheet.tags[this.sheet.tags.length - 1].nextElementSibling;
            this.sheet.before = element;
            this.sheet.flush();
        }
        this.props.cache.insert("", this.props.serialized, this.sheet, false);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.sheet.flush();
    };
    _proto.render = function render() {
        return null;
    };
    return InnerGlobal;
}((0, $eJOHy.Component));
var $2511ed5d36abfd3d$export$d25ddfdf17c3ad3e = function keyframes() {
    var insertable = (0, $3lmqY.default).apply(void 0, arguments);
    var name = "animation-" + insertable.name; // $FlowFixMe
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
};
var $2511ed5d36abfd3d$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = '';
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case 'boolean':
                break;
            case 'object':
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = '';
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += ' ');
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += ' ');
            cls += toAdd;
        }
    }
    return cls;
};
function $2511ed5d36abfd3d$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $l5tKr.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $2511ed5d36abfd3d$var$Noop = function Noop() {
    return null;
};
var $2511ed5d36abfd3d$export$9b9c0f9d9f3552b8 = (0, $eKnMP.w)(function(props, context) {
    return /*#__PURE__*/ (0, $eJOHy.createElement)((0, $eKnMP.T).Consumer, null, function(theme) {
        var hasRendered = false;
        var css = function css() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            var serialized = (0, $915ra.serializeStyles)(args, context.registered);
            (0, $l5tKr.insertStyles)(context, serialized, false);
            return context.key + "-" + serialized.name;
        };
        var cx = function cx() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            return $2511ed5d36abfd3d$var$merge(context.registered, css, $2511ed5d36abfd3d$var$classnames(args));
        };
        var content = {
            css: css,
            cx: cx,
            theme: theme
        };
        var ele = props.children(content);
        hasRendered = true;
        var possiblyStyleElement = /*#__PURE__*/ (0, $eJOHy.createElement)($2511ed5d36abfd3d$var$Noop, null);
        return /*#__PURE__*/ (0, $eJOHy.createElement)((0, $eJOHy.Fragment), null, possiblyStyleElement, ele);
    });
});

});
parcelRegister("4Z5dY", function(module, exports) {
$parcel$export(module.exports, "default", () => $3a10e967fa1217c9$export$2e2bcd8739ae039);

var $6k6gF = parcelRequire("6k6gF");

var $8hMoi = parcelRequire("8hMoi");
parcelRequire("ix02r");
// https://github.com/thysultan/stylis.js/tree/master/plugins/rule-sheet
// inlined to avoid umd wrapper and peerDep warnings/installing stylis
// since we use stylis after closure compiler
var $3a10e967fa1217c9$var$delimiter = '/*|*/';
var $3a10e967fa1217c9$var$needle = $3a10e967fa1217c9$var$delimiter + '}';
function $3a10e967fa1217c9$var$toSheet(block) {
    if (block) $3a10e967fa1217c9$var$Sheet.current.insert(block + '}');
}
var $3a10e967fa1217c9$var$Sheet = {
    current: null
};
var $3a10e967fa1217c9$var$ruleSheet = function ruleSheet(context, content, selectors, parents, line, column, length, ns, depth, at) {
    switch(context){
        // property
        case 1:
            switch(content.charCodeAt(0)){
                case 64:
                    // @import
                    $3a10e967fa1217c9$var$Sheet.current.insert(content + ';');
                    return '';
                // charcode for l
                case 108:
                    // charcode for b
                    // this ignores label
                    if (content.charCodeAt(2) === 98) return '';
            }
            break;
        // selector
        case 2:
            if (ns === 0) return content + $3a10e967fa1217c9$var$delimiter;
            break;
        // at-rule
        case 3:
            switch(ns){
                // @font-face, @page
                case 102:
                case 112:
                    $3a10e967fa1217c9$var$Sheet.current.insert(selectors[0] + content);
                    return '';
                default:
                    return content + (at === 0 ? $3a10e967fa1217c9$var$delimiter : '');
            }
        case -2:
            content.split($3a10e967fa1217c9$var$needle).forEach($3a10e967fa1217c9$var$toSheet);
    }
};
var $3a10e967fa1217c9$var$createCache = function createCache(options) {
    if (options === undefined) options = {};
    var key = options.key || 'css';
    var stylisOptions;
    if (options.prefix !== undefined) stylisOptions = {
        prefix: options.prefix
    };
    var stylis = new (0, $8hMoi.default)(stylisOptions);
    var inserted = {}; // $FlowFixMe
    var container;
    container = options.container || document.head;
    var nodes = document.querySelectorAll("style[data-emotion-" + key + "]");
    Array.prototype.forEach.call(nodes, function(node) {
        var attrib = node.getAttribute("data-emotion-" + key); // $FlowFixMe
        attrib.split(' ').forEach(function(id) {
            inserted[id] = true;
        });
        if (node.parentNode !== container) container.appendChild(node);
    });
    var _insert;
    stylis.use(options.stylisPlugins)($3a10e967fa1217c9$var$ruleSheet);
    _insert = function insert(selector, serialized, sheet, shouldCache) {
        var name = serialized.name;
        $3a10e967fa1217c9$var$Sheet.current = sheet;
        var map;
        stylis(selector, serialized.styles);
        if (shouldCache) cache.inserted[name] = true;
    };
    var commentStart, commentEnd;
    var cache = {
        key: key,
        sheet: new (0, $6k6gF.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    return cache;
};
var $3a10e967fa1217c9$export$2e2bcd8739ae039 = $3a10e967fa1217c9$var$createCache;

});
parcelRegister("6k6gF", function(module, exports) {
$parcel$export(module.exports, "StyleSheet", () => $49a978f9e4f0e518$export$9d753cd7ae895cce);
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ // $FlowFixMe
function $49a978f9e4f0e518$var$sheetForTag(tag) {
    if (tag.sheet) // $FlowFixMe
    return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) // $FlowFixMe
        return document.styleSheets[i];
    }
}
function $49a978f9e4f0e518$var$createStyleElement(options) {
    var tag = document.createElement('style');
    tag.setAttribute('data-emotion', options.key);
    if (options.nonce !== undefined) tag.setAttribute('nonce', options.nonce);
    tag.appendChild(document.createTextNode(''));
    tag.setAttribute('data-s', '');
    return tag;
}
var $49a978f9e4f0e518$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? true : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($49a978f9e4f0e518$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        var isImportRule;
        if (this.isSpeedy) {
            var sheet = $49a978f9e4f0e518$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        // $FlowFixMe
        this.tags.forEach(function(tag) {
            return tag.parentNode && tag.parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

});

parcelRegister("8hMoi", function(module, exports) {
$parcel$export(module.exports, "default", () => $608572a9ae1f6d36$export$2e2bcd8739ae039);
function $608572a9ae1f6d36$var$stylis_min(W) {
    function M(d, c, e, h, a) {
        for(var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = '', p = '', F = '', G = '', C; l < B;){
            g = e.charCodeAt(l);
            l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);
            if (0 === b + n + v + m) {
                if (l === J && (0 < r && (f = f.replace(N, '')), 0 < f.trim().length)) {
                    switch(g){
                        case 32:
                        case 9:
                        case 59:
                        case 13:
                        case 10:
                            break;
                        default:
                            f += e.charAt(l);
                    }
                    g = 59;
                }
                switch(g){
                    case 123:
                        f = f.trim();
                        q = f.charCodeAt(0);
                        k = 1;
                        for(t = ++l; l < B;){
                            switch(g = e.charCodeAt(l)){
                                case 123:
                                    k++;
                                    break;
                                case 125:
                                    k--;
                                    break;
                                case 47:
                                    switch(g = e.charCodeAt(l + 1)){
                                        case 42:
                                        case 47:
                                            a: {
                                                for(u = l + 1; u < J; ++u)switch(e.charCodeAt(u)){
                                                    case 47:
                                                        if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
                                                            l = u + 1;
                                                            break a;
                                                        }
                                                        break;
                                                    case 10:
                                                        if (47 === g) {
                                                            l = u + 1;
                                                            break a;
                                                        }
                                                }
                                                l = u;
                                            }
                                    }
                                    break;
                                case 91:
                                    g++;
                                case 40:
                                    g++;
                                case 34:
                                case 39:
                                    for(; l++ < J && e.charCodeAt(l) !== g;);
                            }
                            if (0 === k) break;
                            l++;
                        }
                        k = e.substring(t, l);
                        0 === q && (q = (f = f.replace(ca, '').trim()).charCodeAt(0));
                        switch(q){
                            case 64:
                                0 < r && (f = f.replace(N, ''));
                                g = f.charCodeAt(1);
                                switch(g){
                                    case 100:
                                    case 109:
                                    case 115:
                                    case 45:
                                        r = c;
                                        break;
                                    default:
                                        r = O;
                                }
                                k = M(c, r, k, g, a + 1);
                                t = k.length;
                                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(''), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ''));
                                if (0 < t) switch(g){
                                    case 115:
                                        f = f.replace(da, ea);
                                    case 100:
                                    case 109:
                                    case 45:
                                        k = f + '{' + k + '}';
                                        break;
                                    case 107:
                                        f = f.replace(fa, '$1 $2');
                                        k = f + '{' + k + '}';
                                        k = 1 === w || 2 === w && L('@' + k, 3) ? '@-webkit-' + k + '@' + k : '@' + k;
                                        break;
                                    default:
                                        k = f + k, 112 === h && (k = (p += k, ''));
                                }
                                else k = '';
                                break;
                            default:
                                k = M(c, X(c, f, I), k, h, a + 1);
                        }
                        F += k;
                        k = I = r = u = q = 0;
                        f = '';
                        g = e.charCodeAt(++l);
                        break;
                    case 125:
                    case 59:
                        f = (0 < r ? f.replace(N, '') : f).trim();
                        if (1 < (t = f.length)) switch(0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(' ', ':')).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = '\x00\x00'), q = f.charCodeAt(0), g = f.charCodeAt(1), q){
                            case 0:
                                break;
                            case 64:
                                if (105 === g || 99 === g) {
                                    G += f + e.charAt(l);
                                    break;
                                }
                            default:
                                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
                        }
                        I = r = u = q = 0;
                        f = '';
                        g = e.charCodeAt(++l);
                }
            }
            switch(g){
                case 13:
                case 10:
                    47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += '\x00');
                    0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
                    z = 1;
                    D++;
                    break;
                case 59:
                case 125:
                    if (0 === b + n + v + m) {
                        z++;
                        break;
                    }
                default:
                    z++;
                    y = e.charAt(l);
                    switch(g){
                        case 9:
                        case 32:
                            if (0 === n + m + b) switch(x){
                                case 44:
                                case 58:
                                case 9:
                                case 32:
                                    y = '';
                                    break;
                                default:
                                    32 !== g && (y = ' ');
                            }
                            break;
                        case 0:
                            y = '\\0';
                            break;
                        case 12:
                            y = '\\f';
                            break;
                        case 11:
                            y = '\\v';
                            break;
                        case 38:
                            0 === n + b + m && (r = I = 1, y = '\f' + y);
                            break;
                        case 108:
                            if (0 === n + b + m + E && 0 < u) switch(l - u){
                                case 2:
                                    112 === x && 58 === e.charCodeAt(l - 3) && (E = x);
                                case 8:
                                    111 === K && (E = K);
                            }
                            break;
                        case 58:
                            0 === n + b + m && (u = l);
                            break;
                        case 44:
                            0 === b + v + n + m && (r = 1, y += '\r');
                            break;
                        case 34:
                        case 39:
                            0 === b && (n = n === g ? 0 : 0 === n ? g : n);
                            break;
                        case 91:
                            0 === n + b + v && m++;
                            break;
                        case 93:
                            0 === n + b + v && m--;
                            break;
                        case 41:
                            0 === n + b + m && v--;
                            break;
                        case 40:
                            if (0 === n + b + m) {
                                if (0 === q) switch(2 * x + 3 * K){
                                    case 533:
                                        break;
                                    default:
                                        q = 1;
                                }
                                v++;
                            }
                            break;
                        case 64:
                            0 === b + v + n + m + u + k && (k = 1);
                            break;
                        case 42:
                        case 47:
                            if (!(0 < n + m + v)) switch(b){
                                case 0:
                                    switch(2 * g + 3 * e.charCodeAt(l + 1)){
                                        case 235:
                                            b = 47;
                                            break;
                                        case 220:
                                            t = l, b = 42;
                                    }
                                    break;
                                case 42:
                                    47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = '', b = 0);
                            }
                    }
                    0 === b && (f += y);
            }
            K = x;
            x = g;
            l++;
        }
        t = p.length;
        if (0 < t) {
            r = c;
            if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
            p = r.join(',') + '{' + p + '}';
            if (0 !== w * E) {
                2 !== w || L(p, 2) || (E = 0);
                switch(E){
                    case 111:
                        p = p.replace(ha, ':-moz-$1') + p;
                        break;
                    case 112:
                        p = p.replace(Q, '::-webkit-input-$1') + p.replace(Q, '::-moz-$1') + p.replace(Q, ':-ms-input-$1') + p;
                }
                E = 0;
            }
        }
        return G + p + F;
    }
    function X(d, c, e) {
        var h = c.trim().split(ia);
        c = h;
        var a = h.length, m = d.length;
        switch(m){
            case 0:
            case 1:
                var b = 0;
                for(d = 0 === m ? '' : d[0] + ' '; b < a; ++b)c[b] = Z(d, c[b], e).trim();
                break;
            default:
                var v = b = 0;
                for(c = []; b < a; ++b)for(var n = 0; n < m; ++n)c[v++] = Z(d[n] + ' ', h[b], e).trim();
        }
        return c;
    }
    function Z(d, c, e) {
        var h = c.charCodeAt(0);
        33 > h && (h = (c = c.trim()).charCodeAt(0));
        switch(h){
            case 38:
                return c.replace(F, '$1' + d.trim());
            case 58:
                return d.trim() + c.replace(F, '$1' + d.trim());
            default:
                if (0 < 1 * e && 0 < c.indexOf('\f')) return c.replace(F, (58 === d.charCodeAt(0) ? '' : '$1') + d.trim());
        }
        return d + c;
    }
    function P(d, c, e, h) {
        var a = d + ';', m = 2 * c + 3 * e + 4 * h;
        if (944 === m) {
            d = a.indexOf(':', 9) + 1;
            var b = a.substring(d, a.length - 1).trim();
            b = a.substring(0, d).trim() + b + ';';
            return 1 === w || 2 === w && L(b, 1) ? '-webkit-' + b + b : b;
        }
        if (0 === w || 2 === w && !L(a, 1)) return a;
        switch(m){
            case 1015:
                return 97 === a.charCodeAt(10) ? '-webkit-' + a + a : a;
            case 951:
                return 116 === a.charCodeAt(3) ? '-webkit-' + a + a : a;
            case 963:
                return 110 === a.charCodeAt(5) ? '-webkit-' + a + a : a;
            case 1009:
                if (100 !== a.charCodeAt(4)) break;
            case 969:
            case 942:
                return '-webkit-' + a + a;
            case 978:
                return '-webkit-' + a + '-moz-' + a + a;
            case 1019:
            case 983:
                return '-webkit-' + a + '-moz-' + a + '-ms-' + a + a;
            case 883:
                if (45 === a.charCodeAt(8)) return '-webkit-' + a + a;
                if (0 < a.indexOf('image-set(', 11)) return a.replace(ja, '$1-webkit-$2') + a;
                break;
            case 932:
                if (45 === a.charCodeAt(4)) switch(a.charCodeAt(5)){
                    case 103:
                        return '-webkit-box-' + a.replace('-grow', '') + '-webkit-' + a + '-ms-' + a.replace('grow', 'positive') + a;
                    case 115:
                        return '-webkit-' + a + '-ms-' + a.replace('shrink', 'negative') + a;
                    case 98:
                        return '-webkit-' + a + '-ms-' + a.replace('basis', 'preferred-size') + a;
                }
                return '-webkit-' + a + '-ms-' + a + a;
            case 964:
                return '-webkit-' + a + '-ms-flex-' + a + a;
            case 1023:
                if (99 !== a.charCodeAt(8)) break;
                b = a.substring(a.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify');
                return '-webkit-box-pack' + b + '-webkit-' + a + '-ms-flex-pack' + b + a;
            case 1005:
                return ka.test(a) ? a.replace(aa, ':-webkit-') + a.replace(aa, ':-moz-') + a : a;
            case 1e3:
                b = a.substring(13).trim();
                c = b.indexOf('-') + 1;
                switch(b.charCodeAt(0) + b.charCodeAt(c)){
                    case 226:
                        b = a.replace(G, 'tb');
                        break;
                    case 232:
                        b = a.replace(G, 'tb-rl');
                        break;
                    case 220:
                        b = a.replace(G, 'lr');
                        break;
                    default:
                        return a;
                }
                return '-webkit-' + a + '-ms-' + b + a;
            case 1017:
                if (-1 === a.indexOf('sticky', 9)) break;
            case 975:
                c = (a = d).length - 10;
                b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(':', 7) + 1).trim();
                switch(m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)){
                    case 203:
                        if (111 > b.charCodeAt(8)) break;
                    case 115:
                        a = a.replace(b, '-webkit-' + b) + ';' + a;
                        break;
                    case 207:
                    case 102:
                        a = a.replace(b, '-webkit-' + (102 < m ? 'inline-' : '') + 'box') + ';' + a.replace(b, '-webkit-' + b) + ';' + a.replace(b, '-ms-' + b + 'box') + ';' + a;
                }
                return a + ';';
            case 938:
                if (45 === a.charCodeAt(5)) switch(a.charCodeAt(6)){
                    case 105:
                        return b = a.replace('-items', ''), '-webkit-' + a + '-webkit-box-' + b + '-ms-flex-' + b + a;
                    case 115:
                        return '-webkit-' + a + '-ms-flex-item-' + a.replace(ba, '') + a;
                    default:
                        return '-webkit-' + a + '-ms-flex-line-pack' + a.replace('align-content', '').replace(ba, '') + a;
                }
                break;
            case 973:
            case 989:
                if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;
            case 931:
            case 953:
                if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(':') + 1)).charCodeAt(0) ? P(d.replace('stretch', 'fill-available'), c, e, h).replace(':fill-available', ':stretch') : a.replace(b, '-webkit-' + b) + a.replace(b, '-moz-' + b.replace('fill-', '')) + a;
                break;
            case 962:
                if (a = '-webkit-' + a + (102 === a.charCodeAt(5) ? '-ms-' + a : '') + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf('transform', 10)) return a.substring(0, a.indexOf(';', 27) + 1).replace(ma, '$1-webkit-$2') + a;
        }
        return a;
    }
    function L(d, c) {
        var e = d.indexOf(1 === c ? ':' : '{'), h = d.substring(0, 3 !== c ? e : 10);
        e = d.substring(e + 1, d.length - 1);
        return R(2 !== c ? h : h.replace(na, '$1'), e, c);
    }
    function ea(d, c) {
        var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
        return e !== c + ';' ? e.replace(oa, ' or ($1)').substring(4) : '(' + c + ')';
    }
    function H(d, c, e, h, a, m, b, v, n, q) {
        for(var g = 0, x = c, w; g < A; ++g)switch(w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)){
            case void 0:
            case !1:
            case !0:
            case null:
                break;
            default:
                x = w;
        }
        if (x !== c) return x;
    }
    function T(d) {
        switch(d){
            case void 0:
            case null:
                A = S.length = 0;
                break;
            default:
                if ('function' === typeof d) S[A++] = d;
                else if ('object' === typeof d) for(var c = 0, e = d.length; c < e; ++c)T(d[c]);
                else Y = !!d | 0;
        }
        return T;
    }
    function U(d) {
        d = d.prefix;
        void 0 !== d && (R = null, d ? 'function' !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
        return U;
    }
    function B(d, c) {
        var e = d;
        33 > e.charCodeAt(0) && (e = e.trim());
        V = e;
        e = [
            V
        ];
        if (0 < A) {
            var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
            void 0 !== h && 'string' === typeof h && (c = h);
        }
        var a = M(O, e, c, 0, 0);
        0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
        V = '';
        E = 0;
        z = D = 1;
        return a;
    }
    var ca = /^\0+/g, N = /[\0\r\f]/g, aa = /: */g, ka = /zoo|gra/, ma = /([,: ])(transform)/g, ia = /,\r+?/g, F = /([\t\r\n ])*\f?&/g, fa = /@(k\w+)\s*(\S*)\s*/, Q = /::(place)/g, ha = /:(read-only)/g, G = /[svh]\w+-[tblr]{2}/, da = /\(\s*(.*)\s*\)/g, oa = /([\s\S]*?);/g, ba = /-self|flex-/g, na = /[^]*?(:[rp][el]a[\w-]+)[^]*/, la = /stretch|:\s*\w+\-(?:conte|avail)/, ja = /([^-])(image-set\()/, z = 1, D = 1, E = 0, w = 1, O = [], S = [], A = 0, R = null, Y = 0, V = '';
    B.use = T;
    B.set = U;
    void 0 !== W && U(W);
    return B;
}
var $608572a9ae1f6d36$export$2e2bcd8739ae039 = $608572a9ae1f6d36$var$stylis_min;

});

parcelRegister("ix02r", function(module, exports) {
var $d7db56aec975d0bf$var$weakMemoize = function weakMemoize(func) {
    // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // $FlowFixMe
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};
var $d7db56aec975d0bf$export$2e2bcd8739ae039 = $d7db56aec975d0bf$var$weakMemoize;

});


parcelRegister("eKnMP", function(module, exports) {
$parcel$export(module.exports, "h", () => $abc7d01965c8426a$export$dda1d9f60106f0e9);
$parcel$export(module.exports, "T", () => $abc7d01965c8426a$export$971d5caa766a69d7);
$parcel$export(module.exports, "w", () => $abc7d01965c8426a$export$efccba1c4a2ef57b);
$parcel$export(module.exports, "c", () => $abc7d01965c8426a$export$db3b6bfb95261072);
$parcel$export(module.exports, "E", () => $abc7d01965c8426a$export$a9c23c6ac3fc3eca);
parcelRequire("b8SSx");

var $eJOHy = parcelRequire("eJOHy");

var $4Z5dY = parcelRequire("4Z5dY");

var $l5tKr = parcelRequire("l5tKr");

var $915ra = parcelRequire("915ra");
var $abc7d01965c8426a$export$dda1d9f60106f0e9 = Object.prototype.hasOwnProperty;
var $abc7d01965c8426a$var$EmotionCacheContext = /*#__PURE__*/ (0, $eJOHy.createContext)(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? (0, $4Z5dY.default)() : null);
var $abc7d01965c8426a$export$971d5caa766a69d7 = /*#__PURE__*/ (0, $eJOHy.createContext)({});
var $abc7d01965c8426a$export$e7094788287c5e9b = $abc7d01965c8426a$var$EmotionCacheContext.Provider;
var $abc7d01965c8426a$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    var render = function render(props, ref) {
        return /*#__PURE__*/ (0, $eJOHy.createElement)($abc7d01965c8426a$var$EmotionCacheContext.Consumer, null, function(cache) {
            return func(props, cache, ref);
        });
    }; // $FlowFixMe
    return /*#__PURE__*/ (0, $eJOHy.forwardRef)(render);
};
// thus we only need to replace what is a valid character for JS, but not for CSS
var $abc7d01965c8426a$var$sanitizeIdentifier = function sanitizeIdentifier(identifier) {
    return identifier.replace(/\$/g, '-');
};
var $abc7d01965c8426a$var$typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var $abc7d01965c8426a$var$labelPropName = '__EMOTION_LABEL_PLEASE_DO_NOT_USE__';
var $abc7d01965c8426a$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var key in props)if ($abc7d01965c8426a$export$dda1d9f60106f0e9.call(props, key)) newProps[key] = props[key];
    newProps[$abc7d01965c8426a$var$typePropName] = type; // TODO: check if this still works with all of those different JSX functions
    var error, match;
    return newProps;
};
var $abc7d01965c8426a$var$Noop = function Noop() {
    return null;
};
var $abc7d01965c8426a$var$render = function render(cache, props, theme, ref) {
    var cssProp = theme === null ? props.css : props.css(theme); // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var type = props[$abc7d01965c8426a$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = '';
    if (typeof props.className === 'string') className = (0, $l5tKr.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $915ra.serializeStyles)(registeredStyles);
    var labelFromStack;
    var rules = (0, $l5tKr.insertStyles)(cache, serialized, typeof type === 'string');
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var key in props)if ($abc7d01965c8426a$export$dda1d9f60106f0e9.call(props, key) && key !== 'css' && key !== $abc7d01965c8426a$var$typePropName && true) newProps[key] = props[key];
    newProps.ref = ref;
    newProps.className = className;
    var ele = /*#__PURE__*/ (0, $eJOHy.createElement)(type, newProps);
    var possiblyStyleElement = /*#__PURE__*/ (0, $eJOHy.createElement)($abc7d01965c8426a$var$Noop, null);
    return /*#__PURE__*/ (0, $eJOHy.createElement)((0, $eJOHy.Fragment), null, possiblyStyleElement, ele);
}; // eslint-disable-next-line no-undef
var $abc7d01965c8426a$export$a9c23c6ac3fc3eca = /* #__PURE__ */ $abc7d01965c8426a$export$efccba1c4a2ef57b(function(props, cache, ref) {
    if (typeof props.css === 'function') return /*#__PURE__*/ (0, $eJOHy.createElement)($abc7d01965c8426a$export$971d5caa766a69d7.Consumer, null, function(theme) {
        return $abc7d01965c8426a$var$render(cache, props, theme, ref);
    });
    return $abc7d01965c8426a$var$render(cache, props, null, ref);
});

});
parcelRegister("l5tKr", function(module, exports) {
$parcel$export(module.exports, "getRegisteredStyles", () => $f5a123f886bd264e$export$95d99596f328fd52);
$parcel$export(module.exports, "insertStyles", () => $f5a123f886bd264e$export$6f077d94b33a01aa);
var $f5a123f886bd264e$var$isBrowser = true;
function $f5a123f886bd264e$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className]);
        else rawClassName += className + " ";
    });
    return rawClassName;
}
var $f5a123f886bd264e$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $f5a123f886bd264e$var$isBrowser === false && cache.compat !== undefined) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
    if (cache.inserted[serialized.name] === undefined) {
        var current = serialized;
        do {
            var maybeStyles = cache.insert("." + className, current, cache.sheet, true);
            current = current.next;
        }while (current !== undefined);
    }
};

});

parcelRegister("915ra", function(module, exports) {
$parcel$export(module.exports, "serializeStyles", () => $69086cc2f487844f$export$6321afa313b251b5);

var $loC53 = parcelRequire("loC53");

var $3HrAl = parcelRequire("3HrAl");

var $1AyrA = parcelRequire("1AyrA");
var $69086cc2f487844f$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $69086cc2f487844f$var$UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var $69086cc2f487844f$var$hyphenateRegex = /[A-Z]|^ms/g;
var $69086cc2f487844f$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $69086cc2f487844f$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $69086cc2f487844f$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== 'boolean';
};
var $69086cc2f487844f$var$processStyleName = (0, $1AyrA.default)(function(styleName) {
    return $69086cc2f487844f$var$isCustomProperty(styleName) ? styleName : styleName.replace($69086cc2f487844f$var$hyphenateRegex, '-$&').toLowerCase();
});
var $69086cc2f487844f$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case 'animation':
        case 'animationName':
            if (typeof value === 'string') return value.replace($69086cc2f487844f$var$animationRegex, function(match, p1, p2) {
                $69086cc2f487844f$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $69086cc2f487844f$var$cursor
                };
                return p1;
            });
    }
    if ((0, $3HrAl.default)[key] !== 1 && !$69086cc2f487844f$var$isCustomProperty(key) && typeof value === 'number' && value !== 0) return value + 'px';
    return value;
};
var $69086cc2f487844f$var$contentValuePattern, $69086cc2f487844f$var$contentValues, $69086cc2f487844f$var$oldProcessStyleValue, $69086cc2f487844f$var$msPattern, $69086cc2f487844f$var$hyphenPattern, $69086cc2f487844f$var$hyphenatedCache;
var $69086cc2f487844f$var$shouldWarnAboutInterpolatingClassNameFromCss = true;
function $69086cc2f487844f$var$handleInterpolation(mergedProps, registered, interpolation, couldBeSelectorInterpolation) {
    if (interpolation == null) return '';
    if (interpolation.__emotion_styles !== undefined) return interpolation;
    switch(typeof interpolation){
        case 'boolean':
            return '';
        case 'object':
            if (interpolation.anim === 1) {
                $69086cc2f487844f$var$cursor = {
                    name: interpolation.name,
                    styles: interpolation.styles,
                    next: $69086cc2f487844f$var$cursor
                };
                return interpolation.name;
            }
            if (interpolation.styles !== undefined) {
                var next = interpolation.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $69086cc2f487844f$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $69086cc2f487844f$var$cursor
                    };
                    next = next.next;
                }
                var styles = interpolation.styles + ";";
                return styles;
            }
            return $69086cc2f487844f$var$createStringFromObject(mergedProps, registered, interpolation);
        case 'function':
            if (mergedProps !== undefined) {
                var previousCursor = $69086cc2f487844f$var$cursor;
                var result = interpolation(mergedProps);
                $69086cc2f487844f$var$cursor = previousCursor;
                return $69086cc2f487844f$var$handleInterpolation(mergedProps, registered, result, couldBeSelectorInterpolation);
            }
            break;
        case 'string':
            var matched, replaced;
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    if (registered == null) return interpolation;
    var cached = registered[interpolation];
    return cached !== undefined && !couldBeSelectorInterpolation ? cached : interpolation;
}
function $69086cc2f487844f$var$createStringFromObject(mergedProps, registered, obj) {
    var string = '';
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $69086cc2f487844f$var$handleInterpolation(mergedProps, registered, obj[i], false);
    else for(var _key in obj){
        var value = obj[_key];
        if (typeof value !== 'object') {
            if (registered != null && registered[value] !== undefined) string += _key + "{" + registered[value] + "}";
            else if ($69086cc2f487844f$var$isProcessableValue(value)) string += $69086cc2f487844f$var$processStyleName(_key) + ":" + $69086cc2f487844f$var$processStyleValue(_key, value) + ";";
        } else if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
            for(var _i = 0; _i < value.length; _i++)if ($69086cc2f487844f$var$isProcessableValue(value[_i])) string += $69086cc2f487844f$var$processStyleName(_key) + ":" + $69086cc2f487844f$var$processStyleValue(_key, value[_i]) + ";";
        } else {
            var interpolated = $69086cc2f487844f$var$handleInterpolation(mergedProps, registered, value, false);
            switch(_key){
                case 'animation':
                case 'animationName':
                    string += $69086cc2f487844f$var$processStyleName(_key) + ":" + interpolated + ";";
                    break;
                default:
                    string += _key + "{" + interpolated + "}";
            }
        }
    }
    return string;
}
var $69086cc2f487844f$var$labelPattern = /label:\s*([^\s;\n{]+)\s*;/g;
var $69086cc2f487844f$var$sourceMapPattern;
// keyframes are stored on the SerializedStyles object as a linked list
var $69086cc2f487844f$var$cursor;
var $69086cc2f487844f$export$6321afa313b251b5 = function serializeStyles(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = '';
    $69086cc2f487844f$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $69086cc2f487844f$var$handleInterpolation(mergedProps, registered, strings, false);
    } else styles += strings[0];
     // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $69086cc2f487844f$var$handleInterpolation(mergedProps, registered, args[i], styles.charCodeAt(styles.length - 1) === 46);
        if (stringMode) styles += strings[i];
    }
    var sourceMap;
    $69086cc2f487844f$var$labelPattern.lastIndex = 0;
    var identifierName = '';
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $69086cc2f487844f$var$labelPattern.exec(styles)) !== null)identifierName += '-' + // $FlowFixMe we know it's not null
    match[1];
    var name = (0, $loC53.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $69086cc2f487844f$var$cursor
    };
};

});
parcelRegister("loC53", function(module, exports) {
$parcel$export(module.exports, "default", () => $f93960dc95cbb8c0$export$2e2bcd8739ae039);
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $f93960dc95cbb8c0$var$murmur2(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}
var $f93960dc95cbb8c0$export$2e2bcd8739ae039 = $f93960dc95cbb8c0$var$murmur2;

});

parcelRegister("3HrAl", function(module, exports) {
$parcel$export(module.exports, "default", () => $2b1ac917655bd244$export$2e2bcd8739ae039);
var $2b1ac917655bd244$var$unitlessKeys = {
    animationIterationCount: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};
var $2b1ac917655bd244$export$2e2bcd8739ae039 = $2b1ac917655bd244$var$unitlessKeys;

});

parcelRegister("1AyrA", function(module, exports) {
$parcel$export(module.exports, "default", () => $1283df19b900b28d$export$2e2bcd8739ae039);
function $1283df19b900b28d$var$memoize(fn) {
    var cache = {};
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}
var $1283df19b900b28d$export$2e2bcd8739ae039 = $1283df19b900b28d$var$memoize;

});



parcelRegister("3lmqY", function(module, exports) {
$parcel$export(module.exports, "default", () => $26f4bc2f022e38ce$export$2e2bcd8739ae039);

var $agqV8 = parcelRequire("agqV8");
function $26f4bc2f022e38ce$var$css() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $agqV8.serializeStyles)(args);
}
var $26f4bc2f022e38ce$export$2e2bcd8739ae039 = $26f4bc2f022e38ce$var$css;

});
parcelRegister("agqV8", function(module, exports) {
$parcel$export(module.exports, "serializeStyles", () => $779047e000cd1662$export$6321afa313b251b5);

var $loC53 = parcelRequire("loC53");

var $3HrAl = parcelRequire("3HrAl");

var $1AyrA = parcelRequire("1AyrA");
var $779047e000cd1662$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $779047e000cd1662$var$UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var $779047e000cd1662$var$hyphenateRegex = /[A-Z]|^ms/g;
var $779047e000cd1662$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $779047e000cd1662$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $779047e000cd1662$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== 'boolean';
};
var $779047e000cd1662$var$processStyleName = (0, $1AyrA.default)(function(styleName) {
    return $779047e000cd1662$var$isCustomProperty(styleName) ? styleName : styleName.replace($779047e000cd1662$var$hyphenateRegex, '-$&').toLowerCase();
});
var $779047e000cd1662$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case 'animation':
        case 'animationName':
            if (typeof value === 'string') return value.replace($779047e000cd1662$var$animationRegex, function(match, p1, p2) {
                $779047e000cd1662$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $779047e000cd1662$var$cursor
                };
                return p1;
            });
    }
    if ((0, $3HrAl.default)[key] !== 1 && !$779047e000cd1662$var$isCustomProperty(key) && typeof value === 'number' && value !== 0) return value + 'px';
    return value;
};
var $779047e000cd1662$var$contentValuePattern, $779047e000cd1662$var$contentValues, $779047e000cd1662$var$oldProcessStyleValue, $779047e000cd1662$var$msPattern, $779047e000cd1662$var$hyphenPattern, $779047e000cd1662$var$hyphenatedCache;
var $779047e000cd1662$var$shouldWarnAboutInterpolatingClassNameFromCss = true;
function $779047e000cd1662$var$handleInterpolation(mergedProps, registered, interpolation, couldBeSelectorInterpolation) {
    if (interpolation == null) return '';
    if (interpolation.__emotion_styles !== undefined) return interpolation;
    switch(typeof interpolation){
        case 'boolean':
            return '';
        case 'object':
            if (interpolation.anim === 1) {
                $779047e000cd1662$var$cursor = {
                    name: interpolation.name,
                    styles: interpolation.styles,
                    next: $779047e000cd1662$var$cursor
                };
                return interpolation.name;
            }
            if (interpolation.styles !== undefined) {
                var next = interpolation.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $779047e000cd1662$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $779047e000cd1662$var$cursor
                    };
                    next = next.next;
                }
                var styles = interpolation.styles + ";";
                return styles;
            }
            return $779047e000cd1662$var$createStringFromObject(mergedProps, registered, interpolation);
        case 'function':
            if (mergedProps !== undefined) {
                var previousCursor = $779047e000cd1662$var$cursor;
                var result = interpolation(mergedProps);
                $779047e000cd1662$var$cursor = previousCursor;
                return $779047e000cd1662$var$handleInterpolation(mergedProps, registered, result, couldBeSelectorInterpolation);
            }
            break;
        case 'string':
            var matched, replaced;
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    if (registered == null) return interpolation;
    var cached = registered[interpolation];
    return cached !== undefined && !couldBeSelectorInterpolation ? cached : interpolation;
}
function $779047e000cd1662$var$createStringFromObject(mergedProps, registered, obj) {
    var string = '';
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $779047e000cd1662$var$handleInterpolation(mergedProps, registered, obj[i], false);
    else for(var _key in obj){
        var value = obj[_key];
        if (typeof value !== 'object') {
            if (registered != null && registered[value] !== undefined) string += _key + "{" + registered[value] + "}";
            else if ($779047e000cd1662$var$isProcessableValue(value)) string += $779047e000cd1662$var$processStyleName(_key) + ":" + $779047e000cd1662$var$processStyleValue(_key, value) + ";";
        } else if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
            for(var _i = 0; _i < value.length; _i++)if ($779047e000cd1662$var$isProcessableValue(value[_i])) string += $779047e000cd1662$var$processStyleName(_key) + ":" + $779047e000cd1662$var$processStyleValue(_key, value[_i]) + ";";
        } else {
            var interpolated = $779047e000cd1662$var$handleInterpolation(mergedProps, registered, value, false);
            switch(_key){
                case 'animation':
                case 'animationName':
                    string += $779047e000cd1662$var$processStyleName(_key) + ":" + interpolated + ";";
                    break;
                default:
                    string += _key + "{" + interpolated + "}";
            }
        }
    }
    return string;
}
var $779047e000cd1662$var$labelPattern = /label:\s*([^\s;\n{]+)\s*;/g;
var $779047e000cd1662$var$sourceMapPattern;
// keyframes are stored on the SerializedStyles object as a linked list
var $779047e000cd1662$var$cursor;
var $779047e000cd1662$export$6321afa313b251b5 = function serializeStyles(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = '';
    $779047e000cd1662$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $779047e000cd1662$var$handleInterpolation(mergedProps, registered, strings, false);
    } else styles += strings[0];
     // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $779047e000cd1662$var$handleInterpolation(mergedProps, registered, args[i], styles.charCodeAt(styles.length - 1) === 46);
        if (stringMode) styles += strings[i];
    }
    var sourceMap;
    $779047e000cd1662$var$labelPattern.lastIndex = 0;
    var identifierName = '';
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $779047e000cd1662$var$labelPattern.exec(styles)) !== null)identifierName += '-' + // $FlowFixMe we know it's not null
    match[1];
    var name = (0, $loC53.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $779047e000cd1662$var$cursor
    };
};

});



parcelRegister("gnQAk", function(module, exports) {
$parcel$export(module.exports, "connect", () => $21ee38c0b066e7de$export$64605811ab45167f);
$parcel$export(module.exports, "Provider8Wrapped", () => $21ee38c0b066e7de$export$a55ac1850eecafb9);
$parcel$export(module.exports, "Provider", () => $21ee38c0b066e7de$export$2881499e37b75b9a);
$parcel$export(module.exports, "createProvider", () => $21ee38c0b066e7de$export$500fbc0cd14cdbaa);
$parcel$export(module.exports, "useStore", () => (parcelRequire("hmfIh")).useStore);
$parcel$export(module.exports, "useSelector", () => (parcelRequire("5ZB7V")).useSelector);
$parcel$export(module.exports, "useDispatch", () => (parcelRequire("63cmO")).useDispatch);
$parcel$export(module.exports, "extractFactoryFunction", () => (parcelRequire("kCbIN")).extractFactoryFunction);
$parcel$export(module.exports, "mapStateToPropsWithErrorHandling", () => (parcelRequire("kCbIN")).mapStateToPropsWithErrorHandling);

var $eJOHy = parcelRequire("eJOHy");
parcelRequire("dyOHn");
var $g8x7N = parcelRequire("g8x7N");
var $6XebS = parcelRequire("6XebS");
var $63cmO = parcelRequire("63cmO");
var $5ZB7V = parcelRequire("5ZB7V");
var $hmfIh = parcelRequire("hmfIh");

var $huzzJ = parcelRequire("huzzJ");

var $kCbIN = parcelRequire("kCbIN");

var $kCbIN = parcelRequire("kCbIN");
const $21ee38c0b066e7de$export$64605811ab45167f = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
mapStateToProps, // eslint-disable-next-line @typescript-eslint/no-explicit-any
mapDispatchToProps, // eslint-disable-next-line @typescript-eslint/no-explicit-any
mergeProps, // eslint-disable-next-line @typescript-eslint/no-explicit-any
options = Object.freeze({}))=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (component)=>{
        const { context: context, storeKey: storeKey, forceV8: forceV8, skipStability: skipStability, ...restOptions } = options;
        const stabilizedMapping = skipStability ? mapStateToProps : (0, $huzzJ.withStability)(component, 'mapStateToProps', mapStateToProps);
        const stabilizedMergeProps = skipStability ? mergeProps : (0, $huzzJ.withStability)(component, 'mergeProps', mergeProps);
        const safeMapStateToProps = (0, $kCbIN.mapStateToPropsWithErrorHandling)(stabilizedMapping);
        const ResultComponent = (0, $g8x7N.default)(safeMapStateToProps, mapDispatchToProps, stabilizedMergeProps, {
            context: context,
            ...restOptions
        })(component);
        ResultComponent.displayName = `Connect(${component.displayName || component.name || typeof component})`;
        return ResultComponent;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    };
const $21ee38c0b066e7de$export$a55ac1850eecafb9 = ({ store: store, children: children, context: context })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6XebS.default), {
        store: store,
        context: context
    }, children);
const $21ee38c0b066e7de$export$2881499e37b75b9a = (0, $6XebS.default);
const $21ee38c0b066e7de$var$makeWrappedProvider8 = // eslint-disable-next-line @typescript-eslint/no-explicit-any
(context)=>(props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($21ee38c0b066e7de$export$2881499e37b75b9a, {
            context: context,
            ...props
        });
const $21ee38c0b066e7de$export$500fbc0cd14cdbaa = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
context)=>$21ee38c0b066e7de$var$makeWrappedProvider8(context);

});
parcelRegister("dyOHn", function(module, exports) {
$parcel$export(module.exports, "connect", () => (parcelRequire("g8x7N")).default);
$parcel$export(module.exports, "createDispatchHook", () => (parcelRequire("63cmO")).createDispatchHook);
$parcel$export(module.exports, "Provider", () => (parcelRequire("6XebS")).default);
$parcel$export(module.exports, "useDispatch", () => (parcelRequire("63cmO")).useDispatch);
$parcel$export(module.exports, "useSelector", () => (parcelRequire("5ZB7V")).useSelector);
$parcel$export(module.exports, "useStore", () => (parcelRequire("hmfIh")).useStore);
// The primary entry point assumes we're working with standard ReactDOM/RN, but
// older versions that do not include `useSyncExternalStore` (React 16.9 - 17.x).
// Because of that, the useSyncExternalStore compat shim is needed.

var $g5PZJ = parcelRequire("g5PZJ");

var $iHcr1 = parcelRequire("iHcr1");
parcelRequire("5IbJJ");
var $aQK2r = parcelRequire("aQK2r");

var $kRvAM = parcelRequire("kRvAM");

var $5ZB7V = parcelRequire("5ZB7V");

var $g8x7N = parcelRequire("g8x7N");
parcelRequire("2kkCU");
(0, $5ZB7V.initializeUseSelector)((0, $iHcr1.useSyncExternalStoreWithSelector));
(0, $g8x7N.initializeConnect)((0, $g5PZJ.useSyncExternalStore)); // Enable batched updates in our subscriptions for use
// with standard React renderers (ReactDOM, React Native)
(0, $kRvAM.setBatch)((0, $aQK2r.unstable_batchedUpdates));

});
parcelRegister("5IbJJ", function(module, exports) {
$parcel$export(module.exports, "unstable_batchedUpdates", () => (parcelRequire("aQK2r")).unstable_batchedUpdates);

var $aQK2r = parcelRequire("aQK2r");

});

parcelRegister("kRvAM", function(module, exports) {
$parcel$export(module.exports, "setBatch", () => $f3014375cecf4f06$export$4b9874722d0da7bc);
$parcel$export(module.exports, "getBatch", () => $f3014375cecf4f06$export$fc47d4c0ba3bd2c6);
// Default to a dummy "batch" implementation that just runs the callback
function $f3014375cecf4f06$var$defaultNoopBatch(callback) {
    callback();
}
let $f3014375cecf4f06$var$batch = $f3014375cecf4f06$var$defaultNoopBatch; // Allow injecting another batching function later
const $f3014375cecf4f06$export$4b9874722d0da7bc = (newBatch)=>$f3014375cecf4f06$var$batch = newBatch; // Supply a getter just to skip dealing with ESM bindings
const $f3014375cecf4f06$export$fc47d4c0ba3bd2c6 = ()=>$f3014375cecf4f06$var$batch;

});

parcelRegister("5ZB7V", function(module, exports) {
$parcel$export(module.exports, "initializeUseSelector", () => $45cf72dd09c39d49$export$e2e6e3f3f3b782e3);
$parcel$export(module.exports, "useSelector", () => $45cf72dd09c39d49$export$2105062e25df4afe);

var $eJOHy = parcelRequire("eJOHy");

var $7rWGW = parcelRequire("7rWGW");

var $78dyn = parcelRequire("78dyn");

var $i21WZ = parcelRequire("i21WZ");
let $45cf72dd09c39d49$var$useSyncExternalStoreWithSelector = (0, $i21WZ.notInitialized);
const $45cf72dd09c39d49$export$e2e6e3f3f3b782e3 = (fn)=>{
    $45cf72dd09c39d49$var$useSyncExternalStoreWithSelector = fn;
};
const $45cf72dd09c39d49$var$refEquality = (a, b)=>a === b;
function $45cf72dd09c39d49$export$2b53f90d2bd1cbfb(context = (0, $78dyn.ReactReduxContext)) {
    const useReduxContext = context === (0, $78dyn.ReactReduxContext) ? (0, $7rWGW.useReduxContext) : (0, $7rWGW.createReduxContextHook)(context);
    return function useSelector(selector, equalityFnOrOptions = {}) {
        const { equalityFn: equalityFn = $45cf72dd09c39d49$var$refEquality, stabilityCheck: stabilityCheck, noopCheck: noopCheck } = typeof equalityFnOrOptions === 'function' ? {
            equalityFn: equalityFnOrOptions
        } : equalityFnOrOptions;
        const { store: store, subscription: subscription, getServerState: getServerState, stabilityCheck: globalStabilityCheck, noopCheck: globalNoopCheck } = useReduxContext();
        const firstRun = (0, $eJOHy.useRef)(true);
        const wrappedSelector = (0, $eJOHy.useCallback)({
            [selector.name] (state) {
                const selected = selector(state);
                var e, e1;
                return selected;
            }
        }[selector.name], [
            selector,
            globalStabilityCheck,
            stabilityCheck
        ]);
        const selectedState = $45cf72dd09c39d49$var$useSyncExternalStoreWithSelector(subscription.addNestedSub, store.getState, getServerState || store.getState, wrappedSelector, equalityFn);
        (0, $eJOHy.useDebugValue)(selectedState);
        return selectedState;
    };
}
const $45cf72dd09c39d49$export$2105062e25df4afe = /*#__PURE__*/ $45cf72dd09c39d49$export$2b53f90d2bd1cbfb();

});
parcelRegister("7rWGW", function(module, exports) {
$parcel$export(module.exports, "createReduxContextHook", () => $56c894f06588e945$export$d4d6226d5fc61558);
$parcel$export(module.exports, "useReduxContext", () => $56c894f06588e945$export$c1275ca9a6fd3ec5);

var $eJOHy = parcelRequire("eJOHy");

var $78dyn = parcelRequire("78dyn");
function $56c894f06588e945$export$d4d6226d5fc61558(context = (0, $78dyn.ReactReduxContext)) {
    return function useReduxContext() {
        const contextValue = (0, $eJOHy.useContext)(context);
        return contextValue;
    };
}
const $56c894f06588e945$export$c1275ca9a6fd3ec5 = /*#__PURE__*/ $56c894f06588e945$export$d4d6226d5fc61558();

});
parcelRegister("78dyn", function(module, exports) {
$parcel$export(module.exports, "ReactReduxContext", () => $5313cb2eb3c09183$export$cc80c08dc91f1c00);

var $eJOHy = parcelRequire("eJOHy");
const $5313cb2eb3c09183$var$ContextKey = Symbol.for(`react-redux-context`);
const $5313cb2eb3c09183$var$gT = typeof globalThis !== "undefined" ? globalThis : /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */ {};
function $5313cb2eb3c09183$var$getContext() {
    var _gT$ContextKey;
    if (!$eJOHy.createContext) return {};
    const contextMap = (_gT$ContextKey = $5313cb2eb3c09183$var$gT[$5313cb2eb3c09183$var$ContextKey]) != null ? _gT$ContextKey : $5313cb2eb3c09183$var$gT[$5313cb2eb3c09183$var$ContextKey] = new Map();
    let realContext = contextMap.get($eJOHy.createContext);
    if (!realContext) {
        realContext = $eJOHy.createContext(null);
        contextMap.set($eJOHy.createContext, realContext);
    }
    return realContext;
}
const $5313cb2eb3c09183$export$cc80c08dc91f1c00 = /*#__PURE__*/ $5313cb2eb3c09183$var$getContext();
var $5313cb2eb3c09183$export$2e2bcd8739ae039 = $5313cb2eb3c09183$export$cc80c08dc91f1c00;

});


parcelRegister("i21WZ", function(module, exports) {
$parcel$export(module.exports, "notInitialized", () => $d209ed3656276774$export$20656a4825650bd0);
const $d209ed3656276774$export$20656a4825650bd0 = ()=>{
    throw new Error('uSES not initialized!');
};

});


parcelRegister("g8x7N", function(module, exports) {
$parcel$export(module.exports, "initializeConnect", () => $03081d44667e6d70$export$36d45daa6a4925b8);
$parcel$export(module.exports, "default", () => $03081d44667e6d70$export$2e2bcd8739ae039);

var $fpB9r = parcelRequire("fpB9r");

var $2unhp = parcelRequire("2unhp");

var $cjwij = parcelRequire("cjwij");

var $eJOHy = parcelRequire("eJOHy");

var $jWaeG = parcelRequire("jWaeG");

var $jYWZ4 = parcelRequire("jYWZ4");

var $hg4T1 = parcelRequire("hg4T1");

var $jTMvt = parcelRequire("jTMvt");

var $cAeBW = parcelRequire("cAeBW");

var $dgnn4 = parcelRequire("dgnn4");

var $6mOyB = parcelRequire("6mOyB");

var $9jj4M = parcelRequire("9jj4M");
parcelRequire("fHL0l");

var $78dyn = parcelRequire("78dyn");

var $i21WZ = parcelRequire("i21WZ");
const $03081d44667e6d70$var$_excluded = [
    "reactReduxForwardedRef"
];
let $03081d44667e6d70$var$useSyncExternalStore = (0, $i21WZ.notInitialized);
const $03081d44667e6d70$export$36d45daa6a4925b8 = (fn)=>{
    $03081d44667e6d70$var$useSyncExternalStore = fn;
}; // Define some constant arrays just to avoid re-creating these
const $03081d44667e6d70$var$EMPTY_ARRAY = [
    null,
    0
];
const $03081d44667e6d70$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
]; // Attempts to stringify whatever not-really-a-component value we were given
// for logging in an error message
const $03081d44667e6d70$var$stringifyComponent = (Comp)=>{
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
// This is "just" a `useLayoutEffect`, but with two modifications:
// - we need to fall back to `useEffect` in SSR to avoid annoying warnings
// - we extract this to a separate function to avoid closing over values
//   and causing memory leaks
function $03081d44667e6d70$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    (0, $6mOyB.useIsomorphicLayoutEffect)(()=>effectFunc(...effectArgs), dependencies);
} // Effect callback, extracted: assign the latest props values to refs for later usage
function $03081d44667e6d70$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    // We want to capture the wrapper props and child props we used for later comparisons
    lastWrapperProps.current = wrapperProps;
    renderIsScheduled.current = false; // If the render was from a store update, clear out that reference and cascade the subscriber update
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
} // Effect callback, extracted: subscribe to the Redux store or nearest connected ancestor,
// check for updates after dispatched actions, and trigger re-renders.
function $03081d44667e6d70$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, additionalSubscribeListener) {
    // If we're not subscribed to the store, nothing to do here
    if (!shouldHandleStateChanges) return ()=>{}; // Capture values for checking if and when this component unmounts
    let didUnsubscribe = false;
    let lastThrownError = null; // We'll run this callback every time a store subscription update propagates to this component
    const checkForUpdates = ()=>{
        if (didUnsubscribe || !isMounted.current) // Don't run stale listeners.
        // Redux doesn't guarantee unsubscriptions happen until next dispatch.
        return;
         // TODO We're currently calling getState ourselves here, rather than letting `uSES` do it
        const latestStoreState = store.getState();
        let newChildProps, error;
        try {
            // Actually run the selector with the most recent store state and wrapper props
            // to determine what the child props should be
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
         // If the child props haven't changed, nothing to do here - cascade the subscription update
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            // Save references to the new child props.  Note that we track the "child props from store update"
            // as a ref instead of a useState/useReducer because we need a way to determine if that value has
            // been processed.  If this went into useState/useReducer, we couldn't clear out the value without
            // forcing another re-render, which we don't want.
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true; // TODO This is hacky and not how `uSES` is meant to be used
            // Trigger the React `useSyncExternalStore` subscriber
            additionalSubscribeListener();
        }
    }; // Actually subscribe to the nearest connected ancestor (or store)
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe(); // Pull data from the store after first render in case the store has
    // changed since we began.
    checkForUpdates();
    const unsubscribeWrapper = ()=>{
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) // It's possible that we caught an error due to a bad mapState function, but the
        // parent re-rendered without this component and we're about to unmount.
        // This shouldn't happen as long as we do top-down subscriptions correctly, but
        // if we ever do those wrong, this throw will surface the error in our tests.
        // In that case, throw the error from here so it doesn't get lost.
        throw lastThrownError;
    };
    return unsubscribeWrapper;
} // Reducer initial state creation for our update reducer
const $03081d44667e6d70$var$initStateUpdates = ()=>$03081d44667e6d70$var$EMPTY_ARRAY;
function $03081d44667e6d70$var$strictEqual(a, b) {
    return a === b;
}
/**
 * Infers the type of props that a connector will inject into a component.
 */ let $03081d44667e6d70$var$hasWarnedAboutDeprecatedPureOption = false;
/**
 * Connects a React component to a Redux store.
 *
 * - Without arguments, just wraps the component, without changing the behavior / props
 *
 * - If 2 params are passed (3rd param, mergeProps, is skipped), default behavior
 * is to override ownProps (as stated in the docs), so what remains is everything that's
 * not a state or dispatch prop
 *
 * - When 3rd param is passed, we don't know if ownProps propagate and whether they
 * should be valid component props, because it depends on mergeProps implementation.
 * As such, it is the user's responsibility to extend ownProps interface from state or
 * dispatch props or both when applicable
 *
 * @param mapStateToProps A function that extracts values from state
 * @param mapDispatchToProps Setup for dispatching actions
 * @param mergeProps Optional callback to merge state and dispatch props together
 * @param options Options for configuring the connection
 *
 */ function $03081d44667e6d70$var$connect(mapStateToProps, mapDispatchToProps, mergeProps, { pure: // The `pure` option has been removed, so TS doesn't like us destructuring this to check its existence.
// @ts-ignore
pure, areStatesEqual: areStatesEqual = $03081d44667e6d70$var$strictEqual, areOwnPropsEqual: areOwnPropsEqual = (0, $9jj4M.default), areStatePropsEqual: areStatePropsEqual = (0, $9jj4M.default), areMergedPropsEqual: areMergedPropsEqual = (0, $9jj4M.default), forwardRef: // use React's forwardRef to expose a ref of the wrapped component
forwardRef = false, context: // the context consumer to use
context = (0, $78dyn.ReactReduxContext) } = {}) {
    const Context = context;
    const initMapStateToProps = (0, $jTMvt.mapStateToPropsFactory)(mapStateToProps);
    const initMapDispatchToProps = (0, $hg4T1.mapDispatchToPropsFactory)(mapDispatchToProps);
    const initMergeProps = (0, $cAeBW.mergePropsFactory)(mergeProps);
    const shouldHandleStateChanges = Boolean(mapStateToProps);
    const wrapWithConnect = (WrappedComponent)=>{
        const wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
        const displayName = `Connect(${wrappedComponentName})`;
        const selectorFactoryOptions = {
            shouldHandleStateChanges: shouldHandleStateChanges,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent,
            initMapStateToProps: // @ts-ignore
            initMapStateToProps,
            initMapDispatchToProps: // @ts-ignore
            initMapDispatchToProps,
            initMergeProps: initMergeProps,
            areStatesEqual: areStatesEqual,
            areStatePropsEqual: areStatePropsEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        };
        function ConnectFunction(props) {
            const [propsContext, reactReduxForwardedRef, wrapperProps] = $eJOHy.useMemo(()=>{
                // Distinguish between actual "data" props that were passed to the wrapper component,
                // and values needed to control behavior (forwarded refs, alternate context instances).
                // To maintain the wrapperProps object reference, memoize this destructuring.
                const { reactReduxForwardedRef: reactReduxForwardedRef } = props, wrapperProps = (0, $2unhp.default)(props, $03081d44667e6d70$var$_excluded);
                return [
                    props.context,
                    reactReduxForwardedRef,
                    wrapperProps
                ];
            }, [
                props
            ]);
            const ContextToUse = $eJOHy.useMemo(()=>{
                // Users may optionally pass in a custom context instance to use instead of our ReactReduxContext.
                // Memoize the check that determines which context instance we should use.
                return propsContext && propsContext.Consumer && // @ts-ignore
                (0, $jWaeG.isContextConsumer)(/*#__PURE__*/ $eJOHy.createElement(propsContext.Consumer, null)) ? propsContext : Context;
            }, [
                propsContext,
                Context
            ]); // Retrieve the store and ancestor subscription via context, if available
            const contextValue = $eJOHy.useContext(ContextToUse); // The store _must_ exist as either a prop or in context.
            // We'll check to see if it _looks_ like a Redux store first.
            // This allows us to pass through a `store` prop that is just a plain value.
            const didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            const didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            const store = didStoreComeFromProps ? props.store : contextValue.store;
            const getServerState = didStoreComeFromContext ? contextValue.getServerState : store.getState;
            const childPropsSelector = $eJOHy.useMemo(()=>{
                // The child props selector needs the store reference as an input.
                // Re-create this selector whenever the store changes.
                return (0, $jYWZ4.default)(store.dispatch, selectorFactoryOptions);
            }, [
                store
            ]);
            const [subscription, notifyNestedSubs] = $eJOHy.useMemo(()=>{
                if (!shouldHandleStateChanges) return $03081d44667e6d70$var$NO_SUBSCRIPTION_ARRAY; // This Subscription's source should match where store came from: props vs. context. A component
                // connected to the store via props shouldn't use subscription from context, or vice versa.
                const subscription = (0, $dgnn4.createSubscription)(store, didStoreComeFromProps ? undefined : contextValue.subscription); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
                // the middle of the notification loop, where `subscription` will then be null. This can
                // probably be avoided if Subscription's listeners logic is changed to not call listeners
                // that have been unsubscribed in the  middle of the notification loop.
                const notifyNestedSubs = subscription.notifyNestedSubs.bind(subscription);
                return [
                    subscription,
                    notifyNestedSubs
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]); // Determine what {store, subscription} value should be put into nested context, if necessary,
            // and memoize that value to avoid unnecessary context updates.
            const overriddenContextValue = $eJOHy.useMemo(()=>{
                if (didStoreComeFromProps) // This component is directly subscribed to a store from props.
                // We don't want descendants reading from this store - pass down whatever
                // the existing context value is from the nearest connected ancestor.
                return contextValue;
                 // Otherwise, put this component's subscription instance into context, so that
                // connected descendants won't update until after this component is done
                return (0, $fpB9r.default)({}, contextValue, {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]); // Set up refs to coordinate values between the subscription effect and the render logic
            const lastChildProps = $eJOHy.useRef();
            const lastWrapperProps = $eJOHy.useRef(wrapperProps);
            const childPropsFromStoreUpdate = $eJOHy.useRef();
            const renderIsScheduled = $eJOHy.useRef(false);
            const isProcessingDispatch = $eJOHy.useRef(false);
            const isMounted = $eJOHy.useRef(false);
            const latestSubscriptionCallbackError = $eJOHy.useRef();
            (0, $6mOyB.useIsomorphicLayoutEffect)(()=>{
                isMounted.current = true;
                return ()=>{
                    isMounted.current = false;
                };
            }, []);
            const actualChildPropsSelector = $eJOHy.useMemo(()=>{
                const selector = ()=>{
                    // Tricky logic here:
                    // - This render may have been triggered by a Redux store update that produced new child props
                    // - However, we may have gotten new wrapper props after that
                    // If we have new child props, and the same wrapper props, we know we should use the new child props as-is.
                    // But, if we have new wrapper props, those might change the child props, so we have to recalculate things.
                    // So, we'll use the child props from store update only if the wrapper props are the same as last time.
                    if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                     // TODO We're reading the store directly in render() here. Bad idea?
                    // This will likely cause Bad Things (TM) to happen in Concurrent Mode.
                    // Note that we do this because on renders _not_ caused by store updates, we need the latest store state
                    // to determine what the child props should be.
                    return childPropsSelector(store.getState(), wrapperProps);
                };
                return selector;
            }, [
                store,
                wrapperProps
            ]); // We need this to execute synchronously every time we re-render. However, React warns
            // about useLayoutEffect in SSR, so we try to detect environment and fall back to
            // just useEffect instead to avoid the warning, since neither will run anyway.
            const subscribeForReact = $eJOHy.useMemo(()=>{
                const subscribe = (reactListener)=>{
                    if (!subscription) return ()=>{};
                    return $03081d44667e6d70$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, reactListener);
                };
                return subscribe;
            }, [
                subscription
            ]);
            $03081d44667e6d70$var$useIsomorphicLayoutEffectWithArgs($03081d44667e6d70$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]);
            let actualChildProps;
            try {
                actualChildProps = $03081d44667e6d70$var$useSyncExternalStore(subscribeForReact, // TODO and we're just passing that through so it triggers a re-render for us rather than relying on `uSES`.
                actualChildPropsSelector, getServerState ? ()=>childPropsSelector(getServerState(), wrapperProps) : actualChildPropsSelector);
            } catch (err) {
                if (latestSubscriptionCallbackError.current) err.message += `\nThe error may be correlated with this previous error:\n${latestSubscriptionCallbackError.current.stack}\n\n`;
                throw err;
            }
            (0, $6mOyB.useIsomorphicLayoutEffect)(()=>{
                latestSubscriptionCallbackError.current = undefined;
                childPropsFromStoreUpdate.current = undefined;
                lastChildProps.current = actualChildProps;
            }); // Now that all that's done, we can finally try to actually render the child component.
            // We memoize the elements for the rendered child component as an optimization.
            const renderedWrappedComponent = $eJOHy.useMemo(()=>{
                return(/*#__PURE__*/ // @ts-ignore
                $eJOHy.createElement(WrappedComponent, (0, $fpB9r.default)({}, actualChildProps, {
                    ref: reactReduxForwardedRef
                })));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]); // If React sees the exact same element reference as last time, it bails out of re-rendering
            // that child, same as if it was wrapped in React.memo() or returned false from shouldComponentUpdate.
            const renderedChild = $eJOHy.useMemo(()=>{
                if (shouldHandleStateChanges) // If this component is subscribed to store updates, we need to pass its own
                // subscription instance down to our descendants. That means rendering the same
                // Context instance, and putting a different value into the context.
                return /*#__PURE__*/ $eJOHy.createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        }
        const _Connect = $eJOHy.memo(ConnectFunction);
        // Add a hacky cast to get the right output type
        const Connect = _Connect;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            const _forwarded = $eJOHy.forwardRef(function forwardConnectRef(props, ref) {
                // @ts-ignore
                return /*#__PURE__*/ $eJOHy.createElement(Connect, (0, $fpB9r.default)({}, props, {
                    reactReduxForwardedRef: ref
                }));
            });
            const forwarded = _forwarded;
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return (0, (/*@__PURE__*/$parcel$interopDefault($cjwij)))(forwarded, WrappedComponent);
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($cjwij)))(Connect, WrappedComponent);
    };
    return wrapWithConnect;
}
var $03081d44667e6d70$export$2e2bcd8739ae039 = $03081d44667e6d70$var$connect;

});
parcelRegister("jWaeG", function(module, exports) {
'use strict';

module.exports = (parcelRequire("avWmE"));

});
parcelRegister("avWmE", function(module, exports) {
$parcel$export(module.exports, "ContextConsumer", () => $7a7a128fdbc9a82b$export$a7c73072b1a182ae, (v) => $7a7a128fdbc9a82b$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $7a7a128fdbc9a82b$export$9f27bc3417b4524d, (v) => $7a7a128fdbc9a82b$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $7a7a128fdbc9a82b$export$db77ccec0bb4ccac, (v) => $7a7a128fdbc9a82b$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $7a7a128fdbc9a82b$export$8392c0c9d3dcbd35, (v) => $7a7a128fdbc9a82b$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $7a7a128fdbc9a82b$export$ffb0004e005737fa, (v) => $7a7a128fdbc9a82b$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $7a7a128fdbc9a82b$export$b624eff549462981, (v) => $7a7a128fdbc9a82b$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $7a7a128fdbc9a82b$export$7897aa7841a5380c, (v) => $7a7a128fdbc9a82b$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $7a7a128fdbc9a82b$export$602eac185826482c, (v) => $7a7a128fdbc9a82b$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $7a7a128fdbc9a82b$export$e2c29f18771995cb, (v) => $7a7a128fdbc9a82b$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $7a7a128fdbc9a82b$export$5f8d39834fd61797, (v) => $7a7a128fdbc9a82b$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $7a7a128fdbc9a82b$export$74bf444e3cd11ea5, (v) => $7a7a128fdbc9a82b$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "SuspenseList", () => $7a7a128fdbc9a82b$export$998bcd577473dd93, (v) => $7a7a128fdbc9a82b$export$998bcd577473dd93 = v);
$parcel$export(module.exports, "isAsyncMode", () => $7a7a128fdbc9a82b$export$92387174baf9b227, (v) => $7a7a128fdbc9a82b$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $7a7a128fdbc9a82b$export$ec112efeb987d9c6, (v) => $7a7a128fdbc9a82b$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $7a7a128fdbc9a82b$export$b706b080d889d2c9, (v) => $7a7a128fdbc9a82b$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $7a7a128fdbc9a82b$export$5be5a87408f70ddc, (v) => $7a7a128fdbc9a82b$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $7a7a128fdbc9a82b$export$45a5e7f76e0caa8d, (v) => $7a7a128fdbc9a82b$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $7a7a128fdbc9a82b$export$455c2e768291efa6, (v) => $7a7a128fdbc9a82b$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $7a7a128fdbc9a82b$export$9522e17588c12572, (v) => $7a7a128fdbc9a82b$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $7a7a128fdbc9a82b$export$2110ac352bb060b9, (v) => $7a7a128fdbc9a82b$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $7a7a128fdbc9a82b$export$56885ab8b9c456ab, (v) => $7a7a128fdbc9a82b$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $7a7a128fdbc9a82b$export$d927fcb6adf8f9de, (v) => $7a7a128fdbc9a82b$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $7a7a128fdbc9a82b$export$b82d16f27459e05a, (v) => $7a7a128fdbc9a82b$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $7a7a128fdbc9a82b$export$522c17b4f5e123e8, (v) => $7a7a128fdbc9a82b$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $7a7a128fdbc9a82b$export$1aabd8a0274ecfd6, (v) => $7a7a128fdbc9a82b$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isSuspenseList", () => $7a7a128fdbc9a82b$export$3d6c20d97e46b957, (v) => $7a7a128fdbc9a82b$export$3d6c20d97e46b957 = v);
$parcel$export(module.exports, "isValidElementType", () => $7a7a128fdbc9a82b$export$9b621391a187a31a, (v) => $7a7a128fdbc9a82b$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $7a7a128fdbc9a82b$export$f5bbd400c2f4426f, (v) => $7a7a128fdbc9a82b$export$f5bbd400c2f4426f = v);
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $7a7a128fdbc9a82b$export$a7c73072b1a182ae;
var $7a7a128fdbc9a82b$export$9f27bc3417b4524d;
var $7a7a128fdbc9a82b$export$db77ccec0bb4ccac;
var $7a7a128fdbc9a82b$export$8392c0c9d3dcbd35;
var $7a7a128fdbc9a82b$export$ffb0004e005737fa;
var $7a7a128fdbc9a82b$export$b624eff549462981;
var $7a7a128fdbc9a82b$export$7897aa7841a5380c;
var $7a7a128fdbc9a82b$export$602eac185826482c;
var $7a7a128fdbc9a82b$export$e2c29f18771995cb;
var $7a7a128fdbc9a82b$export$5f8d39834fd61797;
var $7a7a128fdbc9a82b$export$74bf444e3cd11ea5;
var $7a7a128fdbc9a82b$export$998bcd577473dd93;
var $7a7a128fdbc9a82b$export$92387174baf9b227;
var $7a7a128fdbc9a82b$export$ec112efeb987d9c6;
var $7a7a128fdbc9a82b$export$b706b080d889d2c9;
var $7a7a128fdbc9a82b$export$5be5a87408f70ddc;
var $7a7a128fdbc9a82b$export$45a5e7f76e0caa8d;
var $7a7a128fdbc9a82b$export$455c2e768291efa6;
var $7a7a128fdbc9a82b$export$9522e17588c12572;
var $7a7a128fdbc9a82b$export$2110ac352bb060b9;
var $7a7a128fdbc9a82b$export$56885ab8b9c456ab;
var $7a7a128fdbc9a82b$export$d927fcb6adf8f9de;
var $7a7a128fdbc9a82b$export$b82d16f27459e05a;
var $7a7a128fdbc9a82b$export$522c17b4f5e123e8;
var $7a7a128fdbc9a82b$export$1aabd8a0274ecfd6;
var $7a7a128fdbc9a82b$export$3d6c20d97e46b957;
var $7a7a128fdbc9a82b$export$9b621391a187a31a;
var $7a7a128fdbc9a82b$export$f5bbd400c2f4426f;
'use strict';
var $7a7a128fdbc9a82b$var$b = Symbol.for("react.element"), $7a7a128fdbc9a82b$var$c = Symbol.for("react.portal"), $7a7a128fdbc9a82b$var$d = Symbol.for("react.fragment"), $7a7a128fdbc9a82b$var$e = Symbol.for("react.strict_mode"), $7a7a128fdbc9a82b$var$f = Symbol.for("react.profiler"), $7a7a128fdbc9a82b$var$g = Symbol.for("react.provider"), $7a7a128fdbc9a82b$var$h = Symbol.for("react.context"), $7a7a128fdbc9a82b$var$k = Symbol.for("react.server_context"), $7a7a128fdbc9a82b$var$l = Symbol.for("react.forward_ref"), $7a7a128fdbc9a82b$var$m = Symbol.for("react.suspense"), $7a7a128fdbc9a82b$var$n = Symbol.for("react.suspense_list"), $7a7a128fdbc9a82b$var$p = Symbol.for("react.memo"), $7a7a128fdbc9a82b$var$q = Symbol.for("react.lazy"), $7a7a128fdbc9a82b$var$t = Symbol.for("react.offscreen"), $7a7a128fdbc9a82b$var$u;
$7a7a128fdbc9a82b$var$u = Symbol.for("react.module.reference");
function $7a7a128fdbc9a82b$var$v(a) {
    if ("object" === typeof a && null !== a) {
        var r = a.$$typeof;
        switch(r){
            case $7a7a128fdbc9a82b$var$b:
                switch(a = a.type, a){
                    case $7a7a128fdbc9a82b$var$d:
                    case $7a7a128fdbc9a82b$var$f:
                    case $7a7a128fdbc9a82b$var$e:
                    case $7a7a128fdbc9a82b$var$m:
                    case $7a7a128fdbc9a82b$var$n:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $7a7a128fdbc9a82b$var$k:
                            case $7a7a128fdbc9a82b$var$h:
                            case $7a7a128fdbc9a82b$var$l:
                            case $7a7a128fdbc9a82b$var$q:
                            case $7a7a128fdbc9a82b$var$p:
                            case $7a7a128fdbc9a82b$var$g:
                                return a;
                            default:
                                return r;
                        }
                }
            case $7a7a128fdbc9a82b$var$c:
                return r;
        }
    }
}
$7a7a128fdbc9a82b$export$a7c73072b1a182ae = $7a7a128fdbc9a82b$var$h;
$7a7a128fdbc9a82b$export$9f27bc3417b4524d = $7a7a128fdbc9a82b$var$g;
$7a7a128fdbc9a82b$export$db77ccec0bb4ccac = $7a7a128fdbc9a82b$var$b;
$7a7a128fdbc9a82b$export$8392c0c9d3dcbd35 = $7a7a128fdbc9a82b$var$l;
$7a7a128fdbc9a82b$export$ffb0004e005737fa = $7a7a128fdbc9a82b$var$d;
$7a7a128fdbc9a82b$export$b624eff549462981 = $7a7a128fdbc9a82b$var$q;
$7a7a128fdbc9a82b$export$7897aa7841a5380c = $7a7a128fdbc9a82b$var$p;
$7a7a128fdbc9a82b$export$602eac185826482c = $7a7a128fdbc9a82b$var$c;
$7a7a128fdbc9a82b$export$e2c29f18771995cb = $7a7a128fdbc9a82b$var$f;
$7a7a128fdbc9a82b$export$5f8d39834fd61797 = $7a7a128fdbc9a82b$var$e;
$7a7a128fdbc9a82b$export$74bf444e3cd11ea5 = $7a7a128fdbc9a82b$var$m;
$7a7a128fdbc9a82b$export$998bcd577473dd93 = $7a7a128fdbc9a82b$var$n;
$7a7a128fdbc9a82b$export$92387174baf9b227 = function() {
    return !1;
};
$7a7a128fdbc9a82b$export$ec112efeb987d9c6 = function() {
    return !1;
};
$7a7a128fdbc9a82b$export$b706b080d889d2c9 = function(a) {
    return $7a7a128fdbc9a82b$var$v(a) === $7a7a128fdbc9a82b$var$h;
};
$7a7a128fdbc9a82b$export$5be5a87408f70ddc = function(a) {
    return $7a7a128fdbc9a82b$var$v(a) === $7a7a128fdbc9a82b$var$g;
};
$7a7a128fdbc9a82b$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $7a7a128fdbc9a82b$var$b;
};
$7a7a128fdbc9a82b$export$455c2e768291efa6 = function(a) {
    return $7a7a128fdbc9a82b$var$v(a) === $7a7a128fdbc9a82b$var$l;
};
$7a7a128fdbc9a82b$export$9522e17588c12572 = function(a) {
    return $7a7a128fdbc9a82b$var$v(a) === $7a7a128fdbc9a82b$var$d;
};
$7a7a128fdbc9a82b$export$2110ac352bb060b9 = function(a) {
    return $7a7a128fdbc9a82b$var$v(a) === $7a7a128fdbc9a82b$var$q;
};
$7a7a128fdbc9a82b$export$56885ab8b9c456ab = function(a) {
    return $7a7a128fdbc9a82b$var$v(a) === $7a7a128fdbc9a82b$var$p;
};
$7a7a128fdbc9a82b$export$d927fcb6adf8f9de = function(a) {
    return $7a7a128fdbc9a82b$var$v(a) === $7a7a128fdbc9a82b$var$c;
};
$7a7a128fdbc9a82b$export$b82d16f27459e05a = function(a) {
    return $7a7a128fdbc9a82b$var$v(a) === $7a7a128fdbc9a82b$var$f;
};
$7a7a128fdbc9a82b$export$522c17b4f5e123e8 = function(a) {
    return $7a7a128fdbc9a82b$var$v(a) === $7a7a128fdbc9a82b$var$e;
};
$7a7a128fdbc9a82b$export$1aabd8a0274ecfd6 = function(a) {
    return $7a7a128fdbc9a82b$var$v(a) === $7a7a128fdbc9a82b$var$m;
};
$7a7a128fdbc9a82b$export$3d6c20d97e46b957 = function(a) {
    return $7a7a128fdbc9a82b$var$v(a) === $7a7a128fdbc9a82b$var$n;
};
$7a7a128fdbc9a82b$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $7a7a128fdbc9a82b$var$d || a === $7a7a128fdbc9a82b$var$f || a === $7a7a128fdbc9a82b$var$e || a === $7a7a128fdbc9a82b$var$m || a === $7a7a128fdbc9a82b$var$n || a === $7a7a128fdbc9a82b$var$t || "object" === typeof a && null !== a && (a.$$typeof === $7a7a128fdbc9a82b$var$q || a.$$typeof === $7a7a128fdbc9a82b$var$p || a.$$typeof === $7a7a128fdbc9a82b$var$g || a.$$typeof === $7a7a128fdbc9a82b$var$h || a.$$typeof === $7a7a128fdbc9a82b$var$l || a.$$typeof === $7a7a128fdbc9a82b$var$u || void 0 !== a.getModuleId) ? !0 : !1;
};
$7a7a128fdbc9a82b$export$f5bbd400c2f4426f = $7a7a128fdbc9a82b$var$v;

});


parcelRegister("jYWZ4", function(module, exports) {
$parcel$export(module.exports, "default", () => $e8c15fecffd8c1ff$export$2e2bcd8739ae039);

var $2unhp = parcelRequire("2unhp");
parcelRequire("iBl5P");
const $e8c15fecffd8c1ff$var$_excluded = [
    "initMapStateToProps",
    "initMapDispatchToProps",
    "initMergeProps"
];
function $e8c15fecffd8c1ff$export$d20c0c2ca6eb2b6f(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, { areStatesEqual: areStatesEqual, areOwnPropsEqual: areOwnPropsEqual, areStatePropsEqual: areStatePropsEqual }) {
    let hasRunAtLeastOnce = false;
    let state;
    let ownProps;
    let stateProps;
    let dispatchProps;
    let mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        const nextStateProps = mapStateToProps(state, ownProps);
        const statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        const propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        const stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
}
function $e8c15fecffd8c1ff$export$2e2bcd8739ae039(dispatch, _ref) {
    let { initMapStateToProps: initMapStateToProps, initMapDispatchToProps: initMapDispatchToProps, initMergeProps: initMergeProps } = _ref, options = (0, $2unhp.default)(_ref, $e8c15fecffd8c1ff$var$_excluded);
    const mapStateToProps = initMapStateToProps(dispatch, options);
    const mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    const mergeProps = initMergeProps(dispatch, options);
    return $e8c15fecffd8c1ff$export$d20c0c2ca6eb2b6f(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

});
parcelRegister("iBl5P", function(module, exports) {

var $fHL0l = parcelRequire("fHL0l");
function $d8ac0b5441b683aa$var$verify(selector, methodName) {
    if (!selector) throw new Error(`Unexpected value for ${methodName} in connect.`);
    else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
        if (!Object.prototype.hasOwnProperty.call(selector, 'dependsOnOwnProps')) (0, $fHL0l.default)(`The selector for ${methodName} of connect did not specify a value for dependsOnOwnProps.`);
    }
}
function $d8ac0b5441b683aa$export$2e2bcd8739ae039(mapStateToProps, mapDispatchToProps, mergeProps) {
    $d8ac0b5441b683aa$var$verify(mapStateToProps, 'mapStateToProps');
    $d8ac0b5441b683aa$var$verify(mapDispatchToProps, 'mapDispatchToProps');
    $d8ac0b5441b683aa$var$verify(mergeProps, 'mergeProps');
}

});
parcelRegister("fHL0l", function(module, exports) {
$parcel$export(module.exports, "default", () => $b6ef554bdd26f3f5$export$2e2bcd8739ae039);
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $b6ef554bdd26f3f5$export$2e2bcd8739ae039(message) {
    /* eslint-disable no-console */ if (typeof console !== 'undefined' && typeof console.error === 'function') console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    /* eslint-disable no-empty */ } catch (e) {}
/* eslint-enable no-empty */ }

});



parcelRegister("hg4T1", function(module, exports) {
$parcel$export(module.exports, "mapDispatchToPropsFactory", () => $c907b8a18558462c$export$b69a785ceac019a6);

var $2iQyh = parcelRequire("2iQyh");

var $gYryg = parcelRequire("gYryg");

var $dEnNV = parcelRequire("dEnNV");
function $c907b8a18558462c$export$b69a785ceac019a6(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? (0, $gYryg.wrapMapToPropsConstant)((dispatch)=>(0, $2iQyh.default)(mapDispatchToProps, dispatch)) : !mapDispatchToProps ? (0, $gYryg.wrapMapToPropsConstant)((dispatch)=>({
            dispatch: dispatch
        })) : typeof mapDispatchToProps === 'function' ? (0, $gYryg.wrapMapToPropsFunc)(mapDispatchToProps, 'mapDispatchToProps') : (0, $dEnNV.createInvalidArgFactory)(mapDispatchToProps, 'mapDispatchToProps');
}

});
parcelRegister("2iQyh", function(module, exports) {
$parcel$export(module.exports, "default", () => $1ad606e79345023b$export$2e2bcd8739ae039);
function $1ad606e79345023b$export$2e2bcd8739ae039(actionCreators, dispatch) {
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === 'function') boundActionCreators[key] = (...args)=>dispatch(actionCreator(...args));
    }
    return boundActionCreators;
}

});

parcelRegister("gYryg", function(module, exports) {
$parcel$export(module.exports, "wrapMapToPropsConstant", () => $c5b79f20013eafc2$export$710f7c60f68acd3e);
$parcel$export(module.exports, "wrapMapToPropsFunc", () => $c5b79f20013eafc2$export$8d46c7f53c8c602f);
parcelRequire("eNtVz");
function $c5b79f20013eafc2$export$710f7c60f68acd3e(//  It seems that the dispatch argument
//  could be a dispatch function in some cases (ex: whenMapDispatchToPropsIsMissing)
//  and a state object in some others (ex: whenMapStateToPropsIsMissing)
// eslint-disable-next-line no-unused-vars
getConstant) {
    return function initConstantSelector(dispatch) {
        const constant = getConstant(dispatch);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
function $c5b79f20013eafc2$export$e561b938df936d57(mapToProps) {
    return mapToProps.dependsOnOwnProps ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
function $c5b79f20013eafc2$export$8d46c7f53c8c602f(mapToProps, methodName) {
    return function initProxySelector(dispatch, { displayName: displayName }) {
        const proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch, undefined);
        }; // allow detectFactoryAndVerify to get ownProps
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $c5b79f20013eafc2$export$e561b938df936d57(mapToProps);
            let props = proxy(stateOrDispatch, ownProps);
            if (typeof props === 'function') {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $c5b79f20013eafc2$export$e561b938df936d57(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}

});
parcelRegister("eNtVz", function(module, exports) {

var $2cYft = parcelRequire("2cYft");

var $fHL0l = parcelRequire("fHL0l");
function $ac5cdb45c2257c1e$export$2e2bcd8739ae039(value, displayName, methodName) {
    if (!(0, $2cYft.default)(value)) (0, $fHL0l.default)(`${methodName}() in ${displayName} must return a plain object. Instead received ${value}.`);
}

});
parcelRegister("2cYft", function(module, exports) {
$parcel$export(module.exports, "default", () => $19bb6fde41a70682$export$2e2bcd8739ae039);
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $19bb6fde41a70682$export$2e2bcd8739ae039(obj) {
    if (typeof obj !== 'object' || obj === null) return false;
    let proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    let baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}

});



parcelRegister("dEnNV", function(module, exports) {
$parcel$export(module.exports, "createInvalidArgFactory", () => $9f0179cbbecc1f0d$export$19ef7b929f7e2559);
function $9f0179cbbecc1f0d$export$19ef7b929f7e2559(arg, name) {
    return (dispatch, options)=>{
        throw new Error(`Invalid value of type ${typeof arg} for ${name} argument when connecting component ${options.wrappedComponentName}.`);
    };
}

});


parcelRegister("jTMvt", function(module, exports) {
$parcel$export(module.exports, "mapStateToPropsFactory", () => $e7c8c7cc578f181e$export$e00e93951827eda7);

var $gYryg = parcelRequire("gYryg");

var $dEnNV = parcelRequire("dEnNV");
function $e7c8c7cc578f181e$export$e00e93951827eda7(mapStateToProps) {
    return !mapStateToProps ? (0, $gYryg.wrapMapToPropsConstant)(()=>({})) : typeof mapStateToProps === 'function' ? (0, $gYryg.wrapMapToPropsFunc)(mapStateToProps, 'mapStateToProps') : (0, $dEnNV.createInvalidArgFactory)(mapStateToProps, 'mapStateToProps');
}

});

parcelRegister("cAeBW", function(module, exports) {
$parcel$export(module.exports, "mergePropsFactory", () => $92942e3f5629a6d6$export$17457cf6fa742f84);

var $fpB9r = parcelRequire("fpB9r");
parcelRequire("eNtVz");

var $dEnNV = parcelRequire("dEnNV");
function $92942e3f5629a6d6$export$691c327fc30bc857(stateProps, dispatchProps, ownProps) {
    // @ts-ignore
    return (0, $fpB9r.default)({}, ownProps, stateProps, dispatchProps);
}
function $92942e3f5629a6d6$export$5b105939c84b5234(mergeProps) {
    return function initMergePropsProxy(dispatch, { displayName: displayName, areMergedPropsEqual: areMergedPropsEqual }) {
        let hasRunOnce = false;
        let mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            const nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $92942e3f5629a6d6$export$17457cf6fa742f84(mergeProps) {
    return !mergeProps ? ()=>$92942e3f5629a6d6$export$691c327fc30bc857 : typeof mergeProps === 'function' ? $92942e3f5629a6d6$export$5b105939c84b5234(mergeProps) : (0, $dEnNV.createInvalidArgFactory)(mergeProps, 'mergeProps');
}

});

parcelRegister("dgnn4", function(module, exports) {
$parcel$export(module.exports, "createSubscription", () => $9a7ee5ff44132ef8$export$d567d2b9af322f8f);

var $kRvAM = parcelRequire("kRvAM");
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants
function $9a7ee5ff44132ef8$var$createListenerCollection() {
    const batch = (0, $kRvAM.getBatch)();
    let first = null;
    let last = null;
    return {
        clear () {
            first = null;
            last = null;
        },
        notify () {
            batch(()=>{
                let listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get () {
            let listeners = [];
            let listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe (callback) {
            let isSubscribed = true;
            let listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
const $9a7ee5ff44132ef8$var$nullListeners = {
    notify () {},
    get: ()=>[]
};
function $9a7ee5ff44132ef8$export$d567d2b9af322f8f(store, parentSub) {
    let unsubscribe;
    let listeners = $9a7ee5ff44132ef8$var$nullListeners; // Reasons to keep the subscription active
    let subscriptionsAmount = 0; // Is this specific subscription subscribed (or only nested ones?)
    let selfSubscribed = false;
    function addNestedSub(listener) {
        trySubscribe();
        const cleanupListener = listeners.subscribe(listener); // cleanup nested sub
        let removed = false;
        return ()=>{
            if (!removed) {
                removed = true;
                cleanupListener();
                tryUnsubscribe();
            }
        };
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return selfSubscribed;
    }
    function trySubscribe() {
        subscriptionsAmount++;
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $9a7ee5ff44132ef8$var$createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        subscriptionsAmount--;
        if (unsubscribe && subscriptionsAmount === 0) {
            unsubscribe();
            unsubscribe = undefined;
            listeners.clear();
            listeners = $9a7ee5ff44132ef8$var$nullListeners;
        }
    }
    function trySubscribeSelf() {
        if (!selfSubscribed) {
            selfSubscribed = true;
            trySubscribe();
        }
    }
    function tryUnsubscribeSelf() {
        if (selfSubscribed) {
            selfSubscribed = false;
            tryUnsubscribe();
        }
    }
    const subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribeSelf,
        tryUnsubscribe: tryUnsubscribeSelf,
        getListeners: ()=>listeners
    };
    return subscription;
}

});

parcelRegister("6mOyB", function(module, exports) {
$parcel$export(module.exports, "useIsomorphicLayoutEffect", () => $4a2c03b801fda1b8$export$700979bc83e7db82);

var $eJOHy = parcelRequire("eJOHy");
const $4a2c03b801fda1b8$export$71594e8a50f746f4 = !!(typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined');
const $4a2c03b801fda1b8$export$700979bc83e7db82 = $4a2c03b801fda1b8$export$71594e8a50f746f4 ? $eJOHy.useLayoutEffect : $eJOHy.useEffect;

});

parcelRegister("9jj4M", function(module, exports) {
$parcel$export(module.exports, "default", () => $6c74af7ed78adfc4$export$2e2bcd8739ae039);
function $6c74af7ed78adfc4$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $6c74af7ed78adfc4$export$2e2bcd8739ae039(objA, objB) {
    if ($6c74af7ed78adfc4$var$is(objA, objB)) return true;
    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(let i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$6c74af7ed78adfc4$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}

});


parcelRegister("2kkCU", function(module, exports) {
$parcel$export(module.exports, "Provider", () => (parcelRequire("6XebS")).default);
$parcel$export(module.exports, "connect", () => (parcelRequire("g8x7N")).default);
$parcel$export(module.exports, "useDispatch", () => (parcelRequire("63cmO")).useDispatch);
$parcel$export(module.exports, "createDispatchHook", () => (parcelRequire("63cmO")).createDispatchHook);
$parcel$export(module.exports, "useSelector", () => (parcelRequire("5ZB7V")).useSelector);
$parcel$export(module.exports, "useStore", () => (parcelRequire("hmfIh")).useStore);

var $6XebS = parcelRequire("6XebS");

var $g8x7N = parcelRequire("g8x7N");

var $78dyn = parcelRequire("78dyn");

var $63cmO = parcelRequire("63cmO");

var $5ZB7V = parcelRequire("5ZB7V");

var $hmfIh = parcelRequire("hmfIh");

var $9jj4M = parcelRequire("9jj4M");
parcelRequire("kvcDS");

});
parcelRegister("6XebS", function(module, exports) {
$parcel$export(module.exports, "default", () => $510342b628619a90$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $78dyn = parcelRequire("78dyn");

var $dgnn4 = parcelRequire("dgnn4");

var $6mOyB = parcelRequire("6mOyB");
function $510342b628619a90$var$Provider({ store: store, context: context, children: children, serverState: serverState, stabilityCheck: stabilityCheck = 'once', noopCheck: noopCheck = 'once' }) {
    const contextValue = $eJOHy.useMemo(()=>{
        const subscription = (0, $dgnn4.createSubscription)(store);
        return {
            store: store,
            subscription: subscription,
            getServerState: serverState ? ()=>serverState : undefined,
            stabilityCheck: stabilityCheck,
            noopCheck: noopCheck
        };
    }, [
        store,
        serverState,
        stabilityCheck,
        noopCheck
    ]);
    const previousState = $eJOHy.useMemo(()=>store.getState(), [
        store
    ]);
    (0, $6mOyB.useIsomorphicLayoutEffect)(()=>{
        const { subscription: subscription } = contextValue;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return ()=>{
            subscription.tryUnsubscribe();
            subscription.onStateChange = undefined;
        };
    }, [
        contextValue,
        previousState
    ]);
    const Context = context || (0, $78dyn.ReactReduxContext); // @ts-ignore 'AnyAction' is assignable to the constraint of type 'A', but 'A' could be instantiated with a different subtype
    return /*#__PURE__*/ $eJOHy.createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $510342b628619a90$export$2e2bcd8739ae039 = $510342b628619a90$var$Provider;

});

parcelRegister("63cmO", function(module, exports) {
$parcel$export(module.exports, "createDispatchHook", () => $467c9db534b28306$export$bc9b55530897c558);
$parcel$export(module.exports, "useDispatch", () => $467c9db534b28306$export$8ad76b76a4c905f8);

var $78dyn = parcelRequire("78dyn");

var $hmfIh = parcelRequire("hmfIh");
function $467c9db534b28306$export$bc9b55530897c558(context = (0, $78dyn.ReactReduxContext)) {
    const useStore = context === (0, $78dyn.ReactReduxContext) ? (0, $hmfIh.useStore) : (0, $hmfIh.createStoreHook)(context);
    return function useDispatch() {
        const store = useStore(); // @ts-ignore
        return store.dispatch;
    };
}
const $467c9db534b28306$export$8ad76b76a4c905f8 = /*#__PURE__*/ $467c9db534b28306$export$bc9b55530897c558();

});
parcelRegister("hmfIh", function(module, exports) {
$parcel$export(module.exports, "createStoreHook", () => $ca30ae14ab85f4df$export$671dba69185d0304);
$parcel$export(module.exports, "useStore", () => $ca30ae14ab85f4df$export$6ccbb43953eebf8);

var $78dyn = parcelRequire("78dyn");

var $7rWGW = parcelRequire("7rWGW");
function $ca30ae14ab85f4df$export$671dba69185d0304(context = (0, $78dyn.ReactReduxContext)) {
    const useReduxContext = context === (0, $78dyn.ReactReduxContext) ? (0, $7rWGW.useReduxContext) : (0, $7rWGW.createReduxContextHook)(context);
    return function useStore() {
        const { store: store } = useReduxContext(); // @ts-ignore
        return store;
    };
}
const $ca30ae14ab85f4df$export$6ccbb43953eebf8 = /*#__PURE__*/ $ca30ae14ab85f4df$export$671dba69185d0304();

});


parcelRegister("kvcDS", function(module, exports) {

});



parcelRegister("huzzJ", function(module, exports) {
$parcel$export(module.exports, "withStability", () => $da903b6119e79c54$export$717840dc0c82fbbc);

var $9pTd3 = parcelRequire("9pTd3");

var $fsisP = parcelRequire("fsisP");
/* eslint-disable @typescript-eslint/no-explicit-any, func-names */ const $da903b6119e79c54$var$ARITY = {
    0: (fn)=>function() {
            return fn.call(this);
        },
    1: (fn)=>function(arg1) {
            return fn.call(this, arg1);
        },
    2: (fn)=>function(arg1, arg2) {
            return fn.call(this, arg1, arg2);
        },
    3: (fn)=>function(arg1, arg2, arg3) {
            return fn.call(this, arg1, arg2, arg3);
        }
};
function $da903b6119e79c54$var$defineArity(arity, fn) {
    if (!$da903b6119e79c54$var$ARITY[arity]) throw new Error(`Unsupported arity ${arity}`);
    return $da903b6119e79c54$var$ARITY[arity](fn);
}
const $da903b6119e79c54$var$getDifference = (a, b)=>{
    const diff = {};
    for(const key in a)if (a[key] !== b[key]) diff[key] = a[key];
    return diff;
};
const $da903b6119e79c54$var$getTypes = (a)=>{
    const result = {};
    // eslint-disable-next-line guard-for-in
    for(const key in a)result[key] = typeof a[key];
    return result;
};
const $da903b6119e79c54$var$stability = (component, name, fn)=>{
    const isDevMode = false;
    let override = null;
    return $da903b6119e79c54$var$defineArity(3, (...args)=>{
        if (override) return override(...args);
        const v1 = fn(...args);
        if (typeof v1 === 'function') {
            override = $da903b6119e79c54$var$stability(component, `${name}>`, v1);
            return override(...args);
        }
        const v2 = fn(...args);
        if (!(0, $fsisP.isShallowEqual)(v1, v2)) {
            const displayName = component.displayName || component.name;
            const difference = $da903b6119e79c54$var$getDifference(v1, v2);
            const stabilityAttributes = {
                component: component,
                selector: fn,
                displayName: displayName,
                name: name,
                difference: difference,
                v1: v1,
                v2: v2,
                differenceTypes: $da903b6119e79c54$var$getTypes(difference),
                v1Types: $da903b6119e79c54$var$getTypes(v1),
                v2Types: $da903b6119e79c54$var$getTypes(v2)
            };
            // only log errors in dev mode
            if (isDevMode) // eslint-disable-next-line no-console
            console.error(`Unstable selector ${displayName}:${name}`, stabilityAttributes);
            const error = new Error(`Unstable selector used for ${displayName}:${name} : ${Object.keys(difference).join(',')}`);
            (0, $9pTd3.fireErrorAnalytics)({
                meta: {
                    id: 'stabilityCheck',
                    packageName: 'jiraReactRedux',
                    teamName: 'magma'
                },
                attributes: stabilityAttributes,
                error: error
            });
            // only throw error again in dev mode
            if (isDevMode) throw error;
        }
        return v2;
    });
};
const $da903b6119e79c54$export$717840dc0c82fbbc = (component, name, fn)=>{
    const isDevMode = false;
    if (!isDevMode || !fn || typeof fn !== 'function') return fn;
    // mergeProps cannot return a factory function
    if (name === 'mergeProps') return $da903b6119e79c54$var$defineArity(3, $da903b6119e79c54$var$stability(component, name, fn));
    return $da903b6119e79c54$var$defineArity(3, ()=>$da903b6119e79c54$var$stability(component, name, fn));
};

});
parcelRegister("9pTd3", function(module, exports) {
$parcel$export(module.exports, "VIEW_WHITELIST", () => $94cda853d7341d63$export$3afedfeaaa65a187);
$parcel$export(module.exports, "isNetworkError", () => $94cda853d7341d63$export$476aa014e2fd89d5);
$parcel$export(module.exports, "getStatusCodeGroup", () => $94cda853d7341d63$export$d14e9b22afc87cb3);
$parcel$export(module.exports, "fireErrorAnalytics", () => $94cda853d7341d63$export$a27c21aa3ed8f0f1);
$parcel$export(module.exports, "trackFetchErrors", () => $94cda853d7341d63$export$706c486c6b5abdfb);

var $8dH3d = parcelRequire("8dH3d");

var $4lYQk = parcelRequire("4lYQk");

var $eSnSE = parcelRequire("eSnSE");

var $14RSn = parcelRequire("14RSn");

var $dMM78 = parcelRequire("dMM78");

var $kQnVX = parcelRequire("kQnVX");

var $kRgKj = parcelRequire("kRgKj");
var $2xVsC = parcelRequire("2xVsC");

var $2Mqjh = parcelRequire("2Mqjh");

var $es5G8 = parcelRequire("es5G8");

var $4cTDP = parcelRequire("4cTDP");

var $a9cP9 = parcelRequire("a9cP9");
const $94cda853d7341d63$export$3afedfeaaa65a187 = new Set([
    'project-issue-navigator',
    'jira-router-gin-redirect-entrypoint',
    'jira-business-attachments-app',
    'jira-business-timeline-app',
    'software-list-app',
    'business-list-app',
    'business-calendar',
    'business-calendar-embed',
    'business-calendar-custom-embed',
    'software-calendar',
    'software-calendar-embed',
    'software-calendar-custom-embed'
]);
const $94cda853d7341d63$var$isViewSupported = (view)=>{
    if (!(0, $4cTDP.fg)('jira-report-unhandled-errors-by-view')) return false;
    return $94cda853d7341d63$export$3afedfeaaa65a187.has(view);
};
const $94cda853d7341d63$export$476aa014e2fd89d5 = (error)=>{
    // @ts-expect-error - TS2339 - Property 'networkError' does not exist on type 'Error'. | TS2339 - Property 'networkError' does not exist on type 'Error'.
    const errorToCheck = error.networkError ? error.networkError : error;
    return typeof errorToCheck === 'object' && (errorToCheck instanceof (0, $14RSn.default) || errorToCheck instanceof (0, $14RSn.ValidationError) || // eslint-disable-next-line jira/ff/no-preconditioning
    (0, $4cTDP.fg)('improve_nin_slo_events') && (0, $dMM78.isRelayNetworkWebCrawlerUserAgentDroppingHeaders)(errorToCheck) || (0, $dMM78.isClientFetchError)(errorToCheck));
};
const $94cda853d7341d63$export$d14e9b22afc87cb3 = (error)=>{
    if (error instanceof (0, $14RSn.default)) {
        const { statusCode: statusCode } = error;
        if (statusCode >= 100 && statusCode < 200) return '1xx';
        if (statusCode >= 300 && statusCode < 400) return '3xx';
        if (statusCode >= 400 && statusCode < 500) return '4xx';
        if (statusCode >= 500 && statusCode < 600) return '5xx';
    }
    if (error instanceof (0, $14RSn.ValidationError)) return '4xx';
    if (// eslint-disable-next-line jira/ff/no-preconditioning
    (0, $4cTDP.fg)('improve_nin_slo_events') && (0, $dMM78.isRelayNetworkWebCrawlerUserAgentDroppingHeaders)(error)) return '4xx';
    return 'unknown';
};
const $94cda853d7341d63$var$getTraceId = (error)=>error instanceof (0, $14RSn.default) ? error.traceId : undefined;
const $94cda853d7341d63$var$logErrorToSentry = (event, fullAnalyticsId, error, // eslint-disable-next-line @typescript-eslint/no-explicit-any
details)=>{
    if (event?.context) {
        const fullEvent = (0, $2xVsC.getEvent)(event);
        (0, $es5G8.captureException)(fullAnalyticsId, error, {
            ...details,
            ...fullEvent.payload
        });
    } else (0, $es5G8.captureException)(fullAnalyticsId, error, details);
};
const $94cda853d7341d63$var$logToPrivacyUnsafeSplunk = (fullAnalyticsId, error, errorInfo, meta)=>{
    const errorToLog = {
        message: error.message,
        stack: error.stack,
        // Include the status code group for network errors
        statusCodeGroup: $94cda853d7341d63$export$476aa014e2fd89d5(error) ? $94cda853d7341d63$export$d14e9b22afc87cb3(error) : undefined,
        // Include componentStack if present created by React's componentDidCatch
        componentStack: errorInfo ? errorInfo.componentStack : undefined,
        userLocation: (0, $kQnVX.getUserLocation)(),
        teamName: meta?.teamName,
        packageName: meta?.packageName
    };
    (0, $eSnSE.default).unsafeErrorWithCustomerData(fullAnalyticsId, error.message, errorToLog);
};
const $94cda853d7341d63$export$1bee4e6be783dd26 = (message)=>message.replaceAll(/\w+@\w+/gi, '***@***');
const $94cda853d7341d63$export$a27c21aa3ed8f0f1 = async ({ event: event, error: error, errorInfo: errorInfo, meta: meta, attributes: attributes, sendToPrivacyUnsafeSplunk: sendToPrivacyUnsafeSplunk = false, skipSentry: skipSentry = false, view: view })=>{
    const networkError = error ? $94cda853d7341d63$export$476aa014e2fd89d5(error) : false;
    let eventAttributes;
    if (networkError && error) {
        const statusCodeGroup = $94cda853d7341d63$export$d14e9b22afc87cb3(error);
        const traceId = $94cda853d7341d63$var$getTraceId(error);
        eventAttributes = traceId === null || traceId === undefined ? {
            ...attributes,
            statusCodeGroup: statusCodeGroup
        } : {
            ...attributes,
            statusCodeGroup: statusCodeGroup,
            traceId: traceId
        };
    } else eventAttributes = attributes ?? {};
    const { id: id, packageName: packageName, teamName: teamName } = meta;
    if (false) {
        if (error) throw error;
        else {
            const payload = event && (0, $2xVsC.getEvent)(event).payload;
            throw new Error(JSON.stringify({
                event: payload,
                errorInfo: errorInfo,
                meta: meta,
                attributes: eventAttributes
            }));
        }
    }
    const fullAnalyticsId = packageName !== undefined ? `${packageName}.${id}` : id;
    if (error) {
        if (!networkError && !skipSentry) {
            const details = (0, (/*@__PURE__*/$parcel$interopDefault($4lYQk)))({
                ...eventAttributes,
                packageName: packageName,
                teamName: teamName,
                errorInfo: errorInfo
            }, (0, (/*@__PURE__*/$parcel$interopDefault($8dH3d))));
            $94cda853d7341d63$var$logErrorToSentry(event, fullAnalyticsId, error, details);
            if (event && event?.handlers?.length > 0 && view && $94cda853d7341d63$var$isViewSupported(view)) (0, $kRgKj.fireOperationalAnalytics)(event, 'jiraViewException caught', {
                ...eventAttributes,
                id: id,
                view: view,
                packageName: packageName,
                teamName: teamName,
                errorMessage: typeof error.message === 'string' ? $94cda853d7341d63$export$1bee4e6be783dd26(error.message) : error.message
            });
        }
        // This is a stop gap measure until Sentry is fully rolled out
        if (sendToPrivacyUnsafeSplunk) $94cda853d7341d63$var$logToPrivacyUnsafeSplunk(fullAnalyticsId, error, errorInfo, meta);
        eventAttributes = {
            errorMessage: error.message,
            ...eventAttributes
        };
        if (typeof eventAttributes.errorMessage === 'string') eventAttributes.errorMessage = $94cda853d7341d63$export$1bee4e6be783dd26(eventAttributes.errorMessage);
    }
    if (event && event?.handlers?.length > 0 && (0, $a9cP9.getSource)(event) != null) {
        const attrs = eventAttributes;
        (0, $kRgKj.fireOperationalAnalytics)(event, `${fullAnalyticsId} failed`, attrs);
    } else {
        const gasV3Event = {
            action: 'failed',
            actionSubject: fullAnalyticsId,
            source: 'unknownErrorSource',
            attributes: eventAttributes
        };
        const analyticsClient = await (0, $2Mqjh.getAnalyticsWebClientPromise)();
        analyticsClient.getInstance().sendOperationalEvent(gasV3Event);
    }
};
const $94cda853d7341d63$export$706c486c6b5abdfb = async (payload)=>{
    const { event: event, error: error, id: id, packageName: packageName, attributes: attributes, sendToPrivacyUnsafeSplunk: sendToPrivacyUnsafeSplunk } = payload;
    return $94cda853d7341d63$export$a27c21aa3ed8f0f1({
        event: event,
        error: error,
        attributes: attributes,
        meta: {
            packageName: packageName,
            id: id
        },
        sendToPrivacyUnsafeSplunk: sendToPrivacyUnsafeSplunk
    });
};

});
parcelRegister("eSnSE", function(module, exports) {
$parcel$export(module.exports, "default", () => $172cc434cb4cba67$export$2e2bcd8739ae039);

var $lpMrC = parcelRequire("lpMrC");

var $14RSn = parcelRequire("14RSn");

var $eBhI6 = parcelRequire("eBhI6");

var $gCep5 = parcelRequire("gCep5");

var $3jcme = parcelRequire("3jcme");
const $172cc434cb4cba67$var$MAX_CONCURRENCY_FOR_THROTTLE = 5;
const $172cc434cb4cba67$var$throttleInstance = (0, $gCep5.default)($172cc434cb4cba67$var$MAX_CONCURRENCY_FOR_THROTTLE);
if (typeof window !== 'undefined') window.addEventListener('beforeunload', $172cc434cb4cba67$var$throttleInstance.flush);
// Each log call passes in a location - a path to the file with '.' separation. This utility will
// prepend 'jira.frontend.' to this location before it is sent.
// For example, 'jira.frontend.issue.state.reducers.entities.reducer'.
//
// Log messages and events must only contain privacy-safe information.
const $172cc434cb4cba67$var$isProduction = ()=>true;
const $172cc434cb4cba67$var$sendToServer = (body, endpoint)=>{
    const fetchOptions = {
        ...(0, $eBhI6.getDefaultOptions)(endpoint),
        method: 'POST',
        body: body
    };
    return fetch(endpoint, fetchOptions);
};
const $172cc434cb4cba67$var$sendToConsole = (body, endpoint, level, message, eventType, event)=>{
    // eslint-disable-next-line no-console
    console[level]('%cJIRA %s %c(POST %s)\n%cMessage\n%c%s\n\n%cEvent body\n%c%s\n\n%cException object and Stack trace (expand to jump to source)\n', 'font-size: 14px; font-weight: bold;', level.toUpperCase(), 'font-size: 10px; font-family: monospace;', endpoint, 'font-family: sans-serif; font-weight: bold; font-size: 12px', 'font-family: sans-serif; font-weight: initial;', message, 'font-family: sans-serif; font-weight: bold;', 'font-family: monospace; font-weight: initial;', body, 'font-family: sans-serif; font-size: 12px; font-weight: bold;', event);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const currentWindow = window;
    if (!$172cc434cb4cba67$var$isProduction() && currentWindow.Cypress) {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        if (!window.cypressSafeErrorsLog) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.cypressSafeErrorsLog = [];
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.cypressSafeErrorsLog.push({
            body: body,
            endpoint: endpoint,
            level: level,
            message: message
        });
    }
    if (eventType !== 'object') {
        const errorMessage = `Invalid log API usage: expected event of type 'object', but was ${eventType}`;
        // eslint-disable-next-line no-console
        console.error(errorMessage);
    }
    if (typeof body !== 'string') {
        const errorMessage = `Invalid log API usage: expected event of type 'string', but was ${eventType}; message will be replaced by: ${String(message)}`;
        // eslint-disable-next-line no-console
        console.error(errorMessage);
    }
    return Promise.resolve();
};
const $172cc434cb4cba67$var$joinArrayFields = (error)=>Object.fromEntries(Object.entries(error).map(([key, value])=>{
        if (Array.isArray(value)) return [
            key,
            value.join(', ')
        ];
        return [
            key,
            value
        ];
    }));
const $172cc434cb4cba67$var$transformError = (error)=>{
    const commonProperties = {
        message: error.message,
        stack: error.stack
    };
    // Not importing ValidationError and performing instanceof check because it's causing bundle size increase for skeletons.
    // @ts-expect-error - TS2339 - Property 'errors' does not exist on type 'Error'. | TS2339 - Property 'errors' does not exist on type 'Error'.
    if (error.name === (0, $14RSn.VALIDATION_ERROR_NAME) && error.errors && error.errors.map) {
        // @ts-expect-error - TS2339 - Property 'errors' does not exist on type 'Error'.
        const { errors: errors, ...otherProperties } = error;
        // @ts-expect-error - TS7006 - Parameter 'item' implicitly has an 'any' type.
        const invalidFields = errors.map((item)=>item.field).join(', ');
        // @ts-expect-error - TS2322 - Type '{ name: string; message: string; stack: string | undefined; invalidFields: any; }' is not assignable to type '{ [key: string]: string | number; }'.
        return {
            ...commonProperties,
            invalidFields: invalidFields,
            ...otherProperties
        };
    }
    const result = {
        ...commonProperties,
        ...error
    };
    return $172cc434cb4cba67$var$joinArrayFields(result);
};
const $172cc434cb4cba67$var$transformData = (location, message, event)=>{
    const { name: browserName, version: browserVersion } = (0, $lpMrC.getBrowser)();
    return {
        sentFrom: `jira.frontend.${location}`,
        message: String(message),
        event: event instanceof Error ? $172cc434cb4cba67$var$transformError(event) : event,
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        buildKey: window.BUILD_KEY,
        logTime: new Date().toISOString(),
        browserName: browserName,
        browserVersion: browserVersion
    };
};
const $172cc434cb4cba67$var$sendData = async (level, location, message, event = {})=>{
    if (false) {
        switch(level){
            case 'info':
                // eslint-disable-next-line no-console
                console.info({
                    location: location,
                    message: message,
                    event: event
                });
                break;
            case 'warn':
                // eslint-disable-next-line no-console
                console.warn({
                    location: location,
                    message: message,
                    event: event
                });
                break;
            case 'error':
                // eslint-disable-next-line no-console
                console.error({
                    location: location,
                    message: message,
                    event: event
                });
                break;
            default:
                {
                    // Exhaustive check
                    const never = level;
                    return never;
                }
        }
        return;
    }
    const data = $172cc434cb4cba67$var$transformData(location, message, event);
    const body = JSON.stringify(data);
    const endpoint = `/rest/internal/2/log/safe/${level}`;
    if ($172cc434cb4cba67$var$isProduction()) return new Promise((resolve, reject)=>{
        $172cc434cb4cba67$var$throttleInstance.add(()=>$172cc434cb4cba67$var$sendToServer(body, endpoint).then(()=>resolve()).catch(reject));
    });
    return $172cc434cb4cba67$var$sendToConsole(body, endpoint, level, message, typeof event, event);
};
async function $172cc434cb4cba67$var$rateLimitedSendData(level, location, message, event = {}) {
    return (0, $3jcme.getLoggerRateLimiter)().rateLimit(`${level}.${location}.${String(message).slice(0, 15)}`, ()=>$172cc434cb4cba67$var$sendData(level, location, message, event), ()=>{
        if (!$172cc434cb4cba67$var$isProduction()) // this will be logged to the console because we are in development mode
        return $172cc434cb4cba67$var$sendData('error', 'platform.logging', `Rate limit reached for ${location} - in production log will NOT be sent - ensure you aren't sending too many logs! Original message: ${message}`, event);
    });
}
/** This function logs privacy safe info.
 * The content must not include any personally identifiable information (PII) or user generated content (UGC).
 * In Jira, UGC includes issue keys, project keys etc. Please see go/jira-ugc for more information.
 *
 * @param location the lower-case, '.' separated path to the file that you are logging from.
 * @param message the message to be logged.
 * @param event
 *
 * @example Usage
 * safeInfoWithoutCustomerData('my.code.location', 'Something went wrong');
 * @example Splunk query
 * `micros_jira-prod_all` LoggingResource INFO "my.location.string"
 */ const $172cc434cb4cba67$var$safeInfoWithoutCustomerData = async (location, message, event)=>{
    await $172cc434cb4cba67$var$rateLimitedSendData('info', location, message, event);
};
/** This function logs privacy safe warnings.
 * The content must not include any personally identifiable information (PII) or user generated content (UGC).
 * In Jira, UGC includes issue keys, project keys etc. Please see go/jira-ugc for more information.
 *
 * @param location the lower-case, '.' separated path to the file that you are logging from.
 * @param message the message to be logged.
 * @param event the error that is thrown.
 *
 * @example Usage
 * safeWarnWithoutCustomerData('my.code.location', 'Something went wrong');
 * @example Splunk query
 * `micros_jira-prod_all` LoggingResource WARN "my.location.string"
 */ const $172cc434cb4cba67$var$safeWarnWithoutCustomerData = async (location, message, event)=>{
    await $172cc434cb4cba67$var$rateLimitedSendData('warn', location, message, event);
};
/** This function logs privacy safe errors.
 * The content must not include any personally identifiable information (PII) or user generated content (UGC).
 * In Jira, UGC includes issue keys, project keys etc. Please see go/jira-ugc for more information.
 *
 * @param location the lower-case, '.' separated path to the file that you are logging from.
 * @param message the message to be logged.
 * @param event the error that is thrown.
 *
 * @example Usage
 * safeErrorWithoutCustomerData('my.code.location', 'Something went wrong');
 * @example Splunk query
 * `micros_jira-prod_all` LoggingResource ERROR "my.location.string"
 */ const $172cc434cb4cba67$var$safeErrorWithoutCustomerData = async (location, message, event)=>{
    await $172cc434cb4cba67$var$rateLimitedSendData('error', location, message, event);
};
// This is a stop gap measure until Sentry is fully rolled out
/** This function logs privacy Unsafe warnings.
 *
 * @param location the lower-case, '.' separated path to the file that you are logging from.
 * @param message the message to be logged.
 * @param event the error that is thrown.
 */ const $172cc434cb4cba67$var$unsafeErrorWithCustomerDataNotRateLimited = async (location, message, event = {})=>{
    const data = $172cc434cb4cba67$var$transformData(location, message, event);
    const body = JSON.stringify(data);
    const endpoint = '/rest/internal/2/log/unsafe/frontend-exception';
    if (false) {
        // eslint-disable-next-line no-console
        console.error({
            location: location,
            message: message,
            event: event
        });
        return;
    }
    if ($172cc434cb4cba67$var$isProduction()) return new Promise((resolve, reject)=>{
        $172cc434cb4cba67$var$throttleInstance.add(()=>$172cc434cb4cba67$var$sendToServer(body, endpoint).then(()=>resolve()).catch(reject));
    });
    return $172cc434cb4cba67$var$sendToConsole(body, endpoint, 'error', message, typeof event, event);
};
// This is a stop gap measure until Sentry is fully rolled out
/** This function logs privacy Unsafe warnings.
 * It is rate limited to ensure that we don't overwhelm the endpoint
 *
 * @param location the lower-case, '.' separated path to the file that you are logging from.
 * @param message the message to be logged.
 * @param event the error that is thrown.
 */ async function $172cc434cb4cba67$var$unsafeErrorWithCustomerDataRateLimited(location, message, event = {}) {
    return (0, $3jcme.getLoggerRateLimiter)().rateLimit(`error.${location}${String(message).slice(0, 15)}`, ()=>$172cc434cb4cba67$var$unsafeErrorWithCustomerDataNotRateLimited(location, message, event), ()=>{
        if (!$172cc434cb4cba67$var$isProduction()) // this will be logged to the console because we are in development mode
        return $172cc434cb4cba67$var$sendData('error', 'platform.logging', `Rate limit reached for ${location} - in production log will NOT be sent - ensure you aren't sending too many logs! Original message: ${message}`, event);
    });
}
// This is a stop gap measure until Sentry is fully rolled out
/** This function logs privacy Unsafe warnings.
 * It is rate limited to ensure that we don't overwhelm the endpoint
 *
 * @param location the lower-case, '.' separated path to the file that you are logging from.
 * @param message the message to be logged.
 * @param event the error that is thrown.
 */ async function $172cc434cb4cba67$var$unsafeErrorWithCustomerData(location, message, event = {}) {
    return $172cc434cb4cba67$var$unsafeErrorWithCustomerDataRateLimited(location, message, event);
}
const $172cc434cb4cba67$var$log = {
    safeInfoWithoutCustomerData: $172cc434cb4cba67$var$safeInfoWithoutCustomerData,
    safeWarnWithoutCustomerData: $172cc434cb4cba67$var$safeWarnWithoutCustomerData,
    safeErrorWithoutCustomerData: $172cc434cb4cba67$var$safeErrorWithoutCustomerData,
    unsafeErrorWithCustomerData: $172cc434cb4cba67$var$unsafeErrorWithCustomerData
};
var $172cc434cb4cba67$export$2e2bcd8739ae039 = $172cc434cb4cba67$var$log;

});
parcelRegister("lpMrC", function(module, exports) {
$parcel$export(module.exports, "getBrowser", () => $0ee76e94a0954f16$export$89e15fc796a4a429);
$parcel$export(module.exports, "isIE11", () => $0ee76e94a0954f16$export$f7bad96d83325a34);
$parcel$export(module.exports, "isEdge", () => $0ee76e94a0954f16$export$cac3980734d91fbe);
$parcel$export(module.exports, "isChrome", () => $0ee76e94a0954f16$export$6446a186d09e379e);
$parcel$export(module.exports, "isSafari", () => $0ee76e94a0954f16$export$95df08bae54cb4df);
$parcel$export(module.exports, "isFirefox", () => $0ee76e94a0954f16$export$b7d78993b74f766d);

var $3nEAz = parcelRequire("3nEAz");
let $0ee76e94a0954f16$var$parsedUA;
const $0ee76e94a0954f16$var$parseUserAgent = ()=>{
    if ($0ee76e94a0954f16$var$parsedUA === undefined) {
        const userAgent = typeof navigator !== 'undefined' && navigator.userAgent;
        $0ee76e94a0954f16$var$parsedUA = userAgent ? (0, (/*@__PURE__*/$parcel$interopDefault($3nEAz))).getParser(userAgent) : null;
    }
    return $0ee76e94a0954f16$var$parsedUA;
};
const $0ee76e94a0954f16$var$getBrowserNameAndVersion = ()=>{
    const browser = $0ee76e94a0954f16$var$parseUserAgent();
    if (browser) return browser.getBrowser();
    return {
        name: '',
        version: ''
    };
};
const $0ee76e94a0954f16$var$isGreaterOrEqualToMinimumVersion = (bowserVersion, minimumVersion)=>{
    const parts = bowserVersion.split('.');
    const part1 = parts[0];
    const part2 = parts[1];
    let version;
    if (part2) version = `${part1}.${part2}`;
    else version = part1;
    return Number(version) >= minimumVersion;
};
const $0ee76e94a0954f16$export$89e15fc796a4a429 = ()=>$0ee76e94a0954f16$var$getBrowserNameAndVersion();
const $0ee76e94a0954f16$export$f7bad96d83325a34 = ()=>{
    const { name: name, version: version } = $0ee76e94a0954f16$var$getBrowserNameAndVersion();
    return name === 'Internet Explorer' && version === '11.0';
};
const $0ee76e94a0954f16$export$cac3980734d91fbe = (minimumVersion = 0)=>{
    const { name: name, version: version } = $0ee76e94a0954f16$var$getBrowserNameAndVersion();
    return name === 'Microsoft Edge' && $0ee76e94a0954f16$var$isGreaterOrEqualToMinimumVersion(version || '', minimumVersion);
};
const $0ee76e94a0954f16$export$6446a186d09e379e = (minimumVersion = 0)=>{
    const { name: name, version: version } = $0ee76e94a0954f16$var$getBrowserNameAndVersion();
    return name === 'Chrome' && $0ee76e94a0954f16$var$isGreaterOrEqualToMinimumVersion(version || '', minimumVersion);
};
const $0ee76e94a0954f16$export$95df08bae54cb4df = (minimumVersion = 0)=>{
    const { name: name, version: version } = $0ee76e94a0954f16$var$getBrowserNameAndVersion();
    return name === 'Safari' && $0ee76e94a0954f16$var$isGreaterOrEqualToMinimumVersion(version || '', minimumVersion);
};
const $0ee76e94a0954f16$export$b7d78993b74f766d = (minimumVersion = 0)=>{
    const { name: name, version: version } = $0ee76e94a0954f16$var$getBrowserNameAndVersion();
    return name === 'Firefox' && $0ee76e94a0954f16$var$isGreaterOrEqualToMinimumVersion(version || '', minimumVersion);
};

});
parcelRegister("3nEAz", function(module, exports) {
!function(e, r) {
    module.exports = r();
}(module.exports, function() {
    return function(e) {
        var r = {};
        function t(n) {
            if (r[n]) return r[n].exports;
            var i = r[n] = {
                i: n,
                l: !1,
                exports: {}
            };
            return e[n].call(i.exports, i, i.exports, t), i.l = !0, i.exports;
        }
        return t.m = e, t.c = r, t.d = function(e, r, n) {
            t.o(e, r) || Object.defineProperty(e, r, {
                enumerable: !0,
                get: n
            });
        }, t.r = function(e) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(e, "__esModule", {
                value: !0
            });
        }, t.t = function(e, r) {
            if (1 & r && (e = t(e)), 8 & r) return e;
            if (4 & r && "object" == typeof e && e && e.__esModule) return e;
            var n = Object.create(null);
            if (t.r(n), Object.defineProperty(n, "default", {
                enumerable: !0,
                value: e
            }), 2 & r && "string" != typeof e) for(var i in e)t.d(n, i, (function(r) {
                return e[r];
            }).bind(null, i));
            return n;
        }, t.n = function(e) {
            var r = e && e.__esModule ? function() {
                return e.default;
            } : function() {
                return e;
            };
            return t.d(r, "a", r), r;
        }, t.o = function(e, r) {
            return Object.prototype.hasOwnProperty.call(e, r);
        }, t.p = "", t(t.s = 0);
    }([
        function(e, r, t) {
            "use strict";
            r.__esModule = !0, r.default = void 0;
            var n, i = (n = t(1)) && n.__esModule ? n : {
                default: n
            };
            /*!
 * Bowser - a browser detector
 * https://github.com/lancedikson/bowser
 * MIT License | (c) Dustin Diaz 2012-2015
 * MIT License | (c) Denis Demchenko 2015-2019
 */ var o = function() {
                function e() {}
                return e.getParser = function(e, r) {
                    if (void 0 === r && (r = !1), "string" != typeof e) throw new Error("UserAgent should be a string");
                    return new i.default(e, r);
                }, e.parse = function(e) {
                    return new i.default(e).getResult();
                }, e;
            }();
            r.default = o, e.exports = r.default;
        },
        function(e, r, t) {
            "use strict";
            r.__esModule = !0, r.default = void 0;
            var n, i = (n = t(2)) && n.__esModule ? n : {
                default: n
            };
            var o = function() {
                function e(e, r) {
                    if (void 0 === r && (r = !1), null == e || "" === e) throw new Error("UserAgent parameter can't be empty");
                    this._ua = e, this.parsedResult = {}, !0 !== r && this.parse();
                }
                var r = e.prototype;
                return r.getUA = function() {
                    return this._ua;
                }, r.test = function(e) {
                    return e.test(this._ua);
                }, r.parseBrowser = function() {
                    var e = this;
                    this.parsedResult.browser = {};
                    var r = i.default.find(function(r) {
                        if ("function" == typeof r.test) return r.test(e);
                        if (r.test instanceof Array) return r.test.some(function(r) {
                            return e.test(r);
                        });
                        throw new Error("Browser's test function is not valid");
                    });
                    return r && (this.parsedResult.browser = r.describe(this.getUA())), this.parsedResult.browser;
                }, r.isMobile = function() {
                    return this.test(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i);
                }, r.getBrowser = function() {
                    return this.parsedResult.browser ? this.parsedResult.browser : this.parseBrowser();
                }, r.getBrowserName = function(e) {
                    return e ? String(this.getBrowser().name).toLowerCase() || "" : this.getBrowser().name || "";
                }, r.getBrowserVersion = function() {
                    return this.getBrowser().version;
                }, r.parse = function() {
                    return this.parseBrowser(), this;
                }, r.getResult = function() {
                    return Object.assign({}, this.parsedResult);
                }, e;
            }();
            r.default = o, e.exports = r.default;
        },
        function(e, r, t) {
            "use strict";
            function n(e, r) {
                var t = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                if (t) return (t = t.call(e)).next.bind(t);
                if (Array.isArray(e) || (t = function(e, r) {
                    if (!e) return;
                    if ("string" == typeof e) return i(e, r);
                    var t = Object.prototype.toString.call(e).slice(8, -1);
                    "Object" === t && e.constructor && (t = e.constructor.name);
                    if ("Map" === t || "Set" === t) return Array.from(e);
                    if ("Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return i(e, r);
                }(e)) || r && e && "number" == typeof e.length) {
                    t && (e = t);
                    var n = 0;
                    return function() {
                        return n >= e.length ? {
                            done: !0
                        } : {
                            done: !1,
                            value: e[n++]
                        };
                    };
                }
                throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }
            function i(e, r) {
                (null == r || r > e.length) && (r = e.length);
                for(var t = 0, n = new Array(r); t < r; t++)n[t] = e[t];
                return n;
            }
            r.__esModule = !0, r.default = void 0;
            var o = function(e, r) {
                var t = r.match(e);
                return t && t.length > 0 && t[1] || "";
            }, s = function(e, r) {
                var t = r.match(e);
                return t && t.length > 1 && t[2] || "";
            }, u = /version\/(\d+(\.?_?\d+)+)/i, a = function(e, r) {
                void 0 === e && (e = []);
                for(var t, i = n(e); !(t = i()).done;){
                    var s = t.value, u = o(s, r);
                    if (u) return u;
                }
                return null;
            }, d = [
                {
                    test: [
                        /googlebot/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Googlebot",
                            version: a([
                                /googlebot\/(\d+(\.\d+))/i,
                                u
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /opera/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Opera",
                            version: a([
                                u,
                                /(?:opera)[\s/](\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /opr\/|opios/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Opera",
                            version: a([
                                /(?:opr|opios)[\s/](\S+)/i,
                                u
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /SamsungBrowser/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Samsung Internet for Android",
                            version: a([
                                u,
                                /(?:SamsungBrowser)[\s/](\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /Whale/i
                    ],
                    describe: function(e) {
                        return {
                            name: "NAVER Whale Browser",
                            version: a([
                                u,
                                /(?:whale)[\s/](\d+(?:\.\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /coast/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Opera Coast",
                            version: a([
                                u,
                                /(?:coast)[\s/](\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /opt\/\d+(?:.?_?\d+)+/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Opera Touch",
                            version: a([
                                /(?:opt)[\s/](\d+(\.?_?\d+)+)/i,
                                u
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /msie|trident/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Internet Explorer",
                            version: a([
                                /(?:msie |rv:)(\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /\sedg\//i
                    ],
                    describe: function(e) {
                        return {
                            name: "Microsoft Edge",
                            version: a([
                                /\sedg\/(\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /edg([ea]|ios)/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Microsoft Edge",
                            version: s(/edg([ea]|ios)\/(\d+(\.?_?\d+)+)/i, e)
                        };
                    }
                },
                {
                    test: [
                        /vivaldi/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Vivaldi",
                            version: a([
                                /vivaldi\/(\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /tizen/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Tizen",
                            version: a([
                                /(?:tizen\s?)?browser\/(\d+(\.?_?\d+)+)/i,
                                u
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /firefox|iceweasel|fxios/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Firefox",
                            version: a([
                                /(?:firefox|iceweasel|fxios)[\s/](\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /electron/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Electron",
                            version: a([
                                /(?:electron)\/(\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /chromium/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Chromium",
                            version: a([
                                /(?:chromium)[\s/](\d+(\.?_?\d+)+)/i,
                                u
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /chrome|crios|crmo/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Chrome",
                            version: a([
                                /(?:chrome|crios|crmo)\/(\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /GSA/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Google Search",
                            version: a([
                                /(?:GSA)\/(\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: function(e) {
                        var r = !e.test(/like android/i), t = e.test(/android/i);
                        return r && t;
                    },
                    describe: function(e) {
                        return {
                            name: "Android Browser",
                            version: a([
                                u
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /safari|applewebkit/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Safari",
                            version: a([
                                u
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /.*/i
                    ],
                    describe: function(e) {
                        var r = -1 !== e.search("\\(") ? /^(.*)\/(.*)[ \t]\((.*)/ : /^(.*)\/(.*) /;
                        return {
                            name: o(r, e),
                            version: s(r, e)
                        };
                    }
                }
            ];
            r.default = d, e.exports = r.default;
        }
    ]);
});

});


parcelRegister("14RSn", function(module, exports) {
$parcel$export(module.exports, "ABORT_ERROR_NAME", () => $8e562931b78b64be$export$41b7a909d5bcdc59);
$parcel$export(module.exports, "VALIDATION_ERROR_NAME", () => $8e562931b78b64be$export$e7d64b75be4ed4e4);
$parcel$export(module.exports, "ValidationError", () => $8e562931b78b64be$export$2191b9da168c6cf0);
$parcel$export(module.exports, "isValidationError", () => $8e562931b78b64be$export$f715db496ec47204);
$parcel$export(module.exports, "default", () => $8e562931b78b64be$export$2e2bcd8739ae039);
$parcel$export(module.exports, "isFetchError", () => $8e562931b78b64be$export$96f7e6db4105d70c);
$parcel$export(module.exports, "isRelayNetworkError", () => $8e562931b78b64be$export$1a949ef92fd30eca);
/* eslint-disable max-classes-per-file */ 
var $fJuTR = parcelRequire("fJuTR");
const $8e562931b78b64be$export$764da004e4110fae = 'TypeError';
const $8e562931b78b64be$export$41b7a909d5bcdc59 = 'AbortError';
const $8e562931b78b64be$export$e7d64b75be4ed4e4 = 'ValidationError';
const $8e562931b78b64be$export$83179404a61b001a = 'FetchError';
const $8e562931b78b64be$export$7b6e63f2cd1be6ea = 'RelayNetwork';
class $8e562931b78b64be$export$2191b9da168c6cf0 extends (0, $fJuTR.default) {
    constructor(message, errors = [], statusCode, traceId, originalResponse){
        super(message, {
            cause: errors[0]
        });
        // Setting name to a hardcoded string so it doesn't get obfuscated. This is used for my poor man's instanceof
        // check in common/util/logging/log.js.
        this.name = $8e562931b78b64be$export$e7d64b75be4ed4e4;
        this.errors = errors;
        this.statusCode = statusCode;
        this.skipSentry = true;
        this.traceId = traceId;
        this.originalResponse = originalResponse;
    }
}
const $8e562931b78b64be$export$f715db496ec47204 = (error)=>error.name === $8e562931b78b64be$export$e7d64b75be4ed4e4;
class $8e562931b78b64be$export$2e2bcd8739ae039 extends (0, $fJuTR.default) {
    constructor(statusCode, message, traceId, originalResponse){
        super(message || `Fetch call failed with status code: ${statusCode}`);
        this.name = $8e562931b78b64be$export$83179404a61b001a;
        this.statusCode = statusCode;
        this.originalResponse = originalResponse;
        this.skipSentry = statusCode === 401;
        if (traceId) this.traceId = traceId;
    }
}
const $8e562931b78b64be$export$96f7e6db4105d70c = (error)=>error instanceof $8e562931b78b64be$export$2e2bcd8739ae039 && error.name === $8e562931b78b64be$export$83179404a61b001a;
const $8e562931b78b64be$export$1a949ef92fd30eca = (error)=>error.name === $8e562931b78b64be$export$7b6e63f2cd1be6ea;

});
parcelRegister("fJuTR", function(module, exports) {
$parcel$export(module.exports, "default", () => $53af546acfef61d0$export$2e2bcd8739ae039);
class $53af546acfef61d0$export$2e2bcd8739ae039 extends Error {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(message, options){
        super(message, options);
        this.name = this.constructor.name;
    }
}

});


parcelRegister("eBhI6", function(module, exports) {
$parcel$export(module.exports, "getDefaultOptions", () => $981c2e90f41afbb6$export$430a3269e24b912e);
$parcel$export(module.exports, "defaultOptions", () => $981c2e90f41afbb6$export$ba43bf67f3d48107);

var $kinkG = parcelRequire("kinkG");

var $w06FR = parcelRequire("w06FR");
function $981c2e90f41afbb6$export$430a3269e24b912e(url) {
    let options = {
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/json',
            // Flow's RequestOptions type doesn't allow an array here, but it works in practice ¯\_(ツ)_/¯
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
            Accept: [
                'application/json',
                'text/javascript',
                '*/*'
            ],
            ...false ? {
                // Needed for call to monolith
                'x-ssr-asap-audience': 'jira'
            } : {}
        }
    };
    options = url ? (0, $kinkG.applyObservabilityHeaders)(url, options) : options;
    if (false) options = (0, $w06FR.applySsrFetchConfigOverrideHeaders)(options);
    return options;
}
const $981c2e90f41afbb6$export$ba43bf67f3d48107 = {
    credentials: 'same-origin',
    headers: {
        'Content-Type': 'application/json',
        // Flow's RequestOptions type doesn't allow an array here, but it works in practice ¯\_(ツ)_/¯
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        Accept: [
            'application/json',
            'text/javascript',
            '*/*'
        ],
        ...false ? {
            // Needed for call to monolith
            'x-ssr-asap-audience': 'jira'
        } : {}
    }
};

});
parcelRegister("kinkG", function(module, exports) {
$parcel$export(module.exports, "makeObservabilityHeaders", () => $6d2ed7bdcdc4191d$export$78a090c6aabf87d6);
$parcel$export(module.exports, "applyObservabilityHeaders", () => $6d2ed7bdcdc4191d$export$f51f2ccd07af96d8);

var $3Q6BV = parcelRequire("3Q6BV");

var $fiPhB = parcelRequire("fiPhB");


var $k8mcw = parcelRequire("k8mcw");

var $4rNd6 = parcelRequire("4rNd6");
const $6d2ed7bdcdc4191d$export$78a090c6aabf87d6 = ()=>{
    const headers = {};
    const capability = (0, $k8mcw.getCapability)();
    const capabilityHeader = (0, $4rNd6.getEnhancedCapabilityHeader)(capability);
    if (capabilityHeader) headers[0, $652f5f63189f3e2a$export$9a80695e72849f84] = capabilityHeader;
    const tracingHeaders = (0, $fiPhB.getActiveTraceHttpRequestHeaders)();
    if (tracingHeaders !== null) Object.assign(headers, tracingHeaders);
    if (Object.keys(headers).length === 0) return null;
    return {
        headers: headers
    };
};
const $6d2ed7bdcdc4191d$export$f51f2ccd07af96d8 = (url, options)=>{
    const endpointUrl = new (0, (/*@__PURE__*/$parcel$interopDefault($3Q6BV)))(url);
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (!false && endpointUrl.hostname && endpointUrl.hostname !== window.location.hostname) return options;
    const extraHeaders = $6d2ed7bdcdc4191d$export$78a090c6aabf87d6();
    if (extraHeaders === null) return options;
    return {
        ...options,
        headers: {
            ...options.headers,
            ...extraHeaders.headers
        }
    };
};

});
const $652f5f63189f3e2a$export$ef94a84e2990361c = 'ISSUE_VIEW';
const $652f5f63189f3e2a$export$fc5f182fc9019b1c = 'CLASSIC_BOARD';
const $652f5f63189f3e2a$export$664edf77d4c76110 = 'COMPANY_MANAGED_BOARD';
const $652f5f63189f3e2a$export$b2c0462ff17aa26e = 'BUSINESS_BOARD';
const $652f5f63189f3e2a$export$f154708d773ba5a0 = 'JIRA_BOARD';
const $652f5f63189f3e2a$export$f364828958cffad0 = 'TEAM_MANAGED_BOARD';
const $652f5f63189f3e2a$export$93104dc4eba58ba4 = 'CLASSIC_BACKLOG';
const $652f5f63189f3e2a$export$571692eec8a399e1 = 'COMPANY_MANAGED_BACKLOG';
const $652f5f63189f3e2a$export$c17f34c425972af1 = 'TEAM_MANAGED_BACKLOG';
const $652f5f63189f3e2a$export$d0ad1160bb95ce50 = 'NIN_NEW_ISSUE_NAVIGATOR';
const $652f5f63189f3e2a$export$4695c1a423ffe431 = 'DASHBOARD';
const $652f5f63189f3e2a$export$f999749ac7a2cd1 = 'PLAN_CALENDAR';
const $652f5f63189f3e2a$export$9a80695e72849f84 = 'X-Atlassian-Capability';

parcelRegister("k8mcw", function(module, exports) {
$parcel$export(module.exports, "setCapability", () => $1fed37e95ae289bd$export$60e3f676689faf78);
$parcel$export(module.exports, "getCapability", () => $1fed37e95ae289bd$export$38805c31c710553c);
let $1fed37e95ae289bd$var$activeCapability = null;
const $1fed37e95ae289bd$export$60e3f676689faf78 = (capability)=>{
    $1fed37e95ae289bd$var$activeCapability = capability;
};
const $1fed37e95ae289bd$export$38805c31c710553c = ()=>$1fed37e95ae289bd$var$activeCapability;

});

parcelRegister("4rNd6", function(module, exports) {
$parcel$export(module.exports, "getEnhancedCapabilityHeader", () => $8b72878058a4b1f8$export$8660821f7e55d98b);

var $kVpZx = parcelRequire("kVpZx");

var $2QO3b = parcelRequire("2QO3b");
function $8b72878058a4b1f8$export$8660821f7e55d98b(capability) {
    if (capability == null) return capability;
    const defaultCapabilityHeader = `${capability}--other`;
    const interactionId = (0, $kVpZx.getInteractionId)().current;
    if (!interactionId) return defaultCapabilityHeader;
    const currentInteractionType = (0, $2QO3b.getCurrentInteractionType)(interactionId);
    if (currentInteractionType === 'page_load') return `${capability}--page-load`;
    else if (currentInteractionType === 'transition') return `${capability}--transition`;
    return defaultCapabilityHeader;
}

});


parcelRegister("w06FR", function(module, exports) {
$parcel$export(module.exports, "applySsrFetchConfigOverrideHeaders", () => $51f79fa0d44ea3e7$export$87d0e095d7489e93);

var $4cTDP = parcelRequire("4cTDP");
// Config moved here from https://bitbucket.org/atlassian/tesseract-runtime/src/3f10e7565def764b620b5c85c92b4dd3275dbd3c/services/deploy-service/src/params.ts#lines-247:249
// so that it is set consistently in regular Tesseract and Tesseract dynamic.
const $51f79fa0d44ea3e7$var$SSR_FETCH_CONFIG_OVERRIDES = JSON.stringify({
    atlassianProxy: '/',
    useASAPForAnonymousAtlassianProxy: true,
    atlassianGraphQLGateway: '/gateway/api/graphql'
});
const $51f79fa0d44ea3e7$export$87d0e095d7489e93 = (request)=>{
    if ((0, $4cTDP.fg)('magma-3687-tesseract-fetch-config-overrides')) return {
        ...request,
        headers: {
            ...request.headers,
            'x-ssr-fetch-config-overrides': $51f79fa0d44ea3e7$var$SSR_FETCH_CONFIG_OVERRIDES
        }
    };
    return request;
};

});


parcelRegister("gCep5", function(module, exports) {
$parcel$export(module.exports, "default", () => $395951a63c61d088$export$2e2bcd8739ae039);
const $395951a63c61d088$var$throttleLogs = (limit)=>{
    const queue = [];
    let activeCount = 0;
    const next = ()=>{
        if (queue.length > 0 && activeCount < limit) {
            const fn = queue.shift();
            if (fn) {
                activeCount++;
                fn().finally(()=>{
                    activeCount--;
                    next();
                });
            }
        }
    };
    const add = (fn)=>{
        queue.push(fn);
        next();
    };
    const flush = async ()=>{
        const promises = [];
        while(queue.length > 0){
            const fn = queue.shift();
            if (fn) promises.push(fn());
        }
        await Promise.all(promises);
    };
    return {
        add: add,
        flush: flush
    };
};
var $395951a63c61d088$export$2e2bcd8739ae039 = $395951a63c61d088$var$throttleLogs;

});

parcelRegister("3jcme", function(module, exports) {
$parcel$export(module.exports, "getLoggerRateLimiter", () => $3729ab1fba02f482$export$420cad296e3fe0ba);

var $gleNS = parcelRequire("gleNS");
// each location can only send four requests per minute for each level + location + first 15 chars of message
// This is a upper-bound, not a target so please send less.
const $3729ab1fba02f482$var$rateLimiter = new (0, $gleNS.RateLimiter)(60, 4);
function $3729ab1fba02f482$export$420cad296e3fe0ba() {
    return $3729ab1fba02f482$var$rateLimiter;
}

});
parcelRegister("gleNS", function(module, exports) {
$parcel$export(module.exports, "RateLimiter", () => $e9dffe4e55e10271$export$a2d582f808195701);
// Hello and welcome to your Atlassian backend coding interview
class $e9dffe4e55e10271$export$a2d582f808195701 {
    constructor(windowSize, dropAfterCount){
        this.lastReset = new Date();
        this.counters = new Map();
        if (dropAfterCount <= 0) throw new Error('dropAfterCount must be greater than 0');
        this.windowSize = windowSize;
        this.dropAfterCount = dropAfterCount;
    }
    async rateLimit(key, fn, onLimited) {
        const now = new Date();
        if (now.getTime() - this.lastReset.getTime() > this.windowSize * 1000) {
            this.lastReset = now;
            this.counters.clear();
        }
        const count = this.counters.get(key) || 0;
        if (count >= this.dropAfterCount) return onLimited();
        this.counters.set(key, count + 1);
        return fn();
    }
}

});



parcelRegister("dMM78", function(module, exports) {
$parcel$export(module.exports, "isRelayNetworkWebCrawlerUserAgentDroppingHeaders", () => $4cdd5166b2dde0d7$export$d5a150f340af0273);
$parcel$export(module.exports, "isRelayNetworkAuthorizationError", () => $4cdd5166b2dde0d7$export$cb26277b2c5ea376);
$parcel$export(module.exports, "isHttpClientErrorResponse", () => $4cdd5166b2dde0d7$export$2b62e563f0fadcee);
$parcel$export(module.exports, "isHttpAccessErrorResponse", () => $4cdd5166b2dde0d7$export$3bc75de436f6f6fb);
$parcel$export(module.exports, "isHttpNotFoundErrorResponse", () => $4cdd5166b2dde0d7$export$2a8316eb45cf2506);
$parcel$export(module.exports, "isHttpClientErrorStatusCode", () => $4cdd5166b2dde0d7$export$6e82b047ed95d4a2);
$parcel$export(module.exports, "isHttpTooManyRequestsResponse", () => $4cdd5166b2dde0d7$export$9d73d6caff63cf52);
$parcel$export(module.exports, "isClientFetchError", () => $4cdd5166b2dde0d7$export$2e7adc44463c3f4f);
$parcel$export(module.exports, "isBackendAPIError", () => $4cdd5166b2dde0d7$export$c837012eb09638f0);

var $4cTDP = parcelRequire("4cTDP");

var $14RSn = parcelRequire("14RSn");
const $4cdd5166b2dde0d7$var$webCrawlerUserAgents = [
    'googlebot',
    'bingbot',
    'yandexbot',
    'baiduspider',
    'duckduckbot',
    'gptbot'
];
const $4cdd5166b2dde0d7$export$d5a150f340af0273 = (error)=>{
    if (!(0, $14RSn.isRelayNetworkError)(error)) return false;
    const userAgent = globalThis.navigator?.userAgent?.toLowerCase() || '';
    const isWebCrawler = $4cdd5166b2dde0d7$var$webCrawlerUserAgents.some((crawler)=>userAgent.includes(crawler));
    return isWebCrawler && error?.source?.errors?.[0]?.extensions?.classification === 'BetaHeaderOptInException' && error?.source?.errors?.[0]?.extensions?.statusCode === 400;
};
const $4cdd5166b2dde0d7$export$cb26277b2c5ea376 = (error)=>{
    if (!(0, $14RSn.isRelayNetworkError)(error)) return false;
    return error?.source?.errors?.[0]?.extensions?.statusCode === 401;
};
const $4cdd5166b2dde0d7$export$2b62e563f0fadcee = (error)=>typeof error === 'object' && 'statusCode' in error && error.statusCode >= 400 && error.statusCode < 500 || // Also explicitly include specific cases of 4xx RelayNetworkErrors we should ignore
    // eslint-disable-next-line jira/ff/no-preconditioning
    (0, $4cTDP.fg)('improve_nin_slo_events') && $4cdd5166b2dde0d7$export$d5a150f340af0273(error);
const $4cdd5166b2dde0d7$export$3bc75de436f6f6fb = (error)=>typeof error === 'object' && 'statusCode' in error && (error.statusCode === 401 || error.statusCode === 403);
const $4cdd5166b2dde0d7$export$2a8316eb45cf2506 = (error)=>typeof error === 'object' && 'statusCode' in error && error.statusCode === 404;
const $4cdd5166b2dde0d7$export$6e82b047ed95d4a2 = (statusCode)=>statusCode !== null && statusCode >= 400 && statusCode < 500;
const $4cdd5166b2dde0d7$export$9d73d6caff63cf52 = (error)=>error.statusCode === 429;
const $4cdd5166b2dde0d7$export$c748438cec453c9f = [
    '... is not valid JSON',
    'server with the specified hostname could not be found',
    'cannot parse response',
    'connection failure',
    'Failed to fetch',
    'in JSON at position 0',
    'JSON.parse: unexpected character at line 1 column 1 of the JSON data',
    'JSON.parse: unexpected end of data at line 1 column 1 of the JSON data',
    'Load failed',
    'Network request failed',
    'NetworkError',
    'Syntax or http error',
    'The request timed out',
    'The network connection was lost',
    'The operation was aborted',
    'Unable to fetch manifest',
    'Unexpected end of input',
    'Unexpected end of JSON input',
    'dynamically imported module',
    'Importing a module script failed',
    'CloseEvent: Ping timeout'
];
const $4cdd5166b2dde0d7$export$3876cb851aa46193 = [
    'AbortError',
    'AuthError',
    'ChunkLoadError',
    'NetworkError',
    'Network error'
];
const $4cdd5166b2dde0d7$var$isClientFetchErrorMessage = (message)=>Boolean(message) && !!$4cdd5166b2dde0d7$export$c748438cec453c9f.find((networkErrorMessage)=>// Using `includes` here because the underlying fetch error messages
        // are sometimes wrapped to provide additional context, e.g.
        // "Something went wrong: ${error.message}"
        message.includes(networkErrorMessage));
const $4cdd5166b2dde0d7$export$2e7adc44463c3f4f = (error)=>Boolean(error) && typeof error === 'object' && ($4cdd5166b2dde0d7$export$3876cb851aa46193.includes(error.name) || $4cdd5166b2dde0d7$var$isClientFetchErrorMessage(error.message) || typeof error.cause === 'object' && ($4cdd5166b2dde0d7$export$3876cb851aa46193.includes(error.cause.name) || $4cdd5166b2dde0d7$var$isClientFetchErrorMessage(error.cause.message)));
const $4cdd5166b2dde0d7$export$bc51706fabc78ec4 = [
    'authProviderTimedOut',
    'Call to graphql returned empty issue',
    'endpoint failed with status',
    'Exception while fetching data',
    'fetch-error: no data or no data node',
    'FetchError',
    'GraphQL error',
    'GraphQLNoResultsError',
    'HTTP status',
    'java.lang.',
    'java.net.',
    'java.util.',
    'javax.net.',
    'JSON at position',
    'Network error:',
    'not valid JSON',
    'Problem while calling endpoint',
    'RelayNetwork',
    'Response ended with an error',
    'serverForbidden',
    'serverInvalidBody',
    'serverUnauthorized',
    'serverUnexpectedError'
];
class $4cdd5166b2dde0d7$export$d4090828a4396567 extends Error {
    constructor(message, options){
        super(message);
        this.name = 'BackendAPIError';
        this.cause = options?.cause;
    }
}
const $4cdd5166b2dde0d7$export$c837012eb09638f0 = (error)=>Boolean(error) && typeof error === 'object' && ('statusCode' in error || Boolean(error.cause) && typeof error.cause === 'object' && 'statusCode' in error.cause || 'graphQLErrors' in error || Boolean(error.cause) && typeof error.cause === 'object' && 'graphQLErrors' in error.cause || $4cdd5166b2dde0d7$export$bc51706fabc78ec4.some((v)=>`${error.name}${error.message}${error.cause?.name}${error.cause?.message}`.includes(v)));

});

parcelRegister("kQnVX", function(module, exports) {
$parcel$export(module.exports, "setMatchedRoute", () => $74867c942094a0d3$export$afe84d55f9496537);
$parcel$export(module.exports, "getMatchedRoute", () => $74867c942094a0d3$export$a0bca9c6a43bcc94);
$parcel$export(module.exports, "getRouteName", () => $74867c942094a0d3$export$52f85febe13405);
$parcel$export(module.exports, "getUserLocation", () => $74867c942094a0d3$export$a17b4f8f942a1896);
$parcel$export(module.exports, "getUfoName", () => $74867c942094a0d3$export$fd0dcd3ca7f44a0d);
$parcel$export(module.exports, "getBifrostGroup", () => $74867c942094a0d3$export$ef57e855d1556e79);
$parcel$export(module.exports, "setPreviousRouterState", () => $74867c942094a0d3$export$335179a30e3b3b9);
$parcel$export(module.exports, "getPreviousRouterState", () => $74867c942094a0d3$export$c54513a7c3de8fe7);
$parcel$export(module.exports, "getPreviousSubProduct", () => $74867c942094a0d3$export$20e84c9866aad5d2);
$parcel$export(module.exports, "setSubProduct", () => $74867c942094a0d3$export$37ee9c58e9a550c6);

var $2Mqjh = parcelRequire("2Mqjh");

var $4cTDP = parcelRequire("4cTDP");
let $74867c942094a0d3$var$matchedRoute = null;
const $74867c942094a0d3$export$afe84d55f9496537 = (route, match)=>{
    if (route && match) $74867c942094a0d3$var$matchedRoute = {
        route: route,
        match: match
    };
};
const $74867c942094a0d3$export$a0bca9c6a43bcc94 = ()=>$74867c942094a0d3$var$matchedRoute;
const $74867c942094a0d3$export$52f85febe13405 = ()=>$74867c942094a0d3$var$matchedRoute?.route.name ?? 'unknown';
const $74867c942094a0d3$export$a17b4f8f942a1896 = ()=>`${$74867c942094a0d3$var$matchedRoute?.route.group ?? 'unknown'}:${$74867c942094a0d3$export$52f85febe13405()}`;
const $74867c942094a0d3$export$fd0dcd3ca7f44a0d = ()=>{
    if ((0, $4cTDP.fg)('jfp-magma-report-bifrost-route-attributes')) return $74867c942094a0d3$var$matchedRoute?.route?.ufoName ?? 'unknown';
    return undefined;
};
const $74867c942094a0d3$export$ef57e855d1556e79 = ()=>{
    if ((0, $4cTDP.fg)('jfp-magma-report-bifrost-route-attributes')) return $74867c942094a0d3$var$matchedRoute?.route?.bifrost?.bifrostGroup ?? 'none';
    return undefined;
};
let $74867c942094a0d3$var$previousRouterState = null;
let $74867c942094a0d3$var$previousSubProduct = '';
const $74867c942094a0d3$export$335179a30e3b3b9 = (state)=>{
    $74867c942094a0d3$var$previousRouterState = state;
};
const $74867c942094a0d3$export$c54513a7c3de8fe7 = ()=>$74867c942094a0d3$var$previousRouterState;
const $74867c942094a0d3$export$df8e6f241eebab99 = (subProduct)=>{
    $74867c942094a0d3$var$previousSubProduct = subProduct || '';
};
const $74867c942094a0d3$export$20e84c9866aad5d2 = ()=>$74867c942094a0d3$var$previousSubProduct;
const $74867c942094a0d3$export$37ee9c58e9a550c6 = (subproduct)=>{
    if (subproduct === null) return;
    if ($74867c942094a0d3$var$previousSubProduct !== subproduct) $74867c942094a0d3$export$df8e6f241eebab99(subproduct);
    (0, $2Mqjh.getAnalyticsWebClientPromise)().then((client)=>{
        client.setSubProduct(subproduct);
    });
};
const $74867c942094a0d3$export$e87aa529d29d151b = (route, pathParamValues = {})=>{
    let result = route.path;
    Object.keys(pathParamValues).forEach((pathParamKey)=>{
        result = result.replaceAll(`:${pathParamKey}`, pathParamValues[pathParamKey].toString());
    });
    if (result.indexOf('/:') !== -1) // throwing error to fail early, as the path with not all :param replaced will not be usable, and will elad to other errors down hte line.
    throw new Error(`routePathToUrlPath: values for some path params have not been provided: ${result}`);
    return result;
};

});

parcelRegister("kRgKj", function(module, exports) {
$parcel$export(module.exports, "fireAnalytics", () => $249a118af2db2c46$export$34ac71ce24cddec2);
$parcel$export(module.exports, "fireUIAnalytics", () => $249a118af2db2c46$export$5d00cd31b1bf8e94);
$parcel$export(module.exports, "fireTrackAnalytics", () => $249a118af2db2c46$export$13990ad4625571ed);
$parcel$export(module.exports, "fireTrackAnalyticsDeferred", () => $249a118af2db2c46$export$b6c00a2e59d74c5e);
$parcel$export(module.exports, "fireOperationalAnalytics", () => $249a118af2db2c46$export$79f423cc3fd39762);
$parcel$export(module.exports, "fireOperationalAnalyticsDeferred", () => $249a118af2db2c46$export$6bb7ef8f82969e8f);
$parcel$export(module.exports, "fireScreenAnalytics", () => $249a118af2db2c46$export$6f46fb37ad7d962b);
$parcel$export(module.exports, "fireScreenAnalyticsDeferred", () => $249a118af2db2c46$export$59b89d5a711a4fa);
/**
 * This library is the only place where you'd use raw analytics from atlaskit
 */ 
var $1ilzu = parcelRequire("1ilzu");


var $a9cP9 = parcelRequire("a9cP9");
const $249a118af2db2c46$export$34ac71ce24cddec2 = (event, type, eventOverrides = {})=>{
    // Safe check to prevent SSR to trigger and to avoid sentry errors such as https://ops.internal.atlassian.com/jira/browse/HOT-90825
    if (false) return;
    const clonedEvent = event.clone();
    if (clonedEvent) clonedEvent.update({
        ...eventOverrides,
        analyticsType: type
    }).fire('productAnalytics');
};
const $249a118af2db2c46$var$getActionSubjectFromContext = (event)=>(0, (/*@__PURE__*/$parcel$interopDefault($1ilzu)))(event.context.map((i)=>i.component || i.componentName).filter(Boolean));
const $249a118af2db2c46$var$fireEventWhenIdle = (fireFn, event, ...rest)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (typeof window.requestIdleCallback === 'function') // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.requestIdleCallback(()=>fireFn(event, ...rest));
    else fireFn(event, ...rest);
};
const $249a118af2db2c46$export$5d00cd31b1bf8e94 = (event, ...rest)=>{
    const { action: attrAction, actionSubject: attrSubject, actionSubjectId: actionSubjectId, attributes: attributes } = (0, $a9cP9.getSubjectsFromArguments)(...rest);
    const action = event.payload?.action || attrAction;
    const actionSubject = event.payload?.actionSubject || attrSubject || $249a118af2db2c46$var$getActionSubjectFromContext(event);
    $249a118af2db2c46$var$fireAnalyticsOfType(event, (0, $aa42ce8e355d58fa$export$a1562d08625f5d7e), {
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    });
};
const $249a118af2db2c46$var$capitalize = (str)=>`${str.charAt(0).toUpperCase()}${str.slice(1)}`;
const $249a118af2db2c46$var$fireAnalyticsOfType = (event, eventType, analyticsProps)=>{
    // UI_EVENT_TYPE condition - just not to affect existing events we're sending; not to require update of existing monitoring
    const eventTypeForError = eventType === (0, $aa42ce8e355d58fa$export$a1562d08625f5d7e) ? eventType : $249a118af2db2c46$var$capitalize(eventType.toLowerCase());
    if (!event.clone) throw Error(`There is no analytics event from atlaskit in ${eventTypeForError} event`);
    if (!analyticsProps.action) throw Error(`Mandatory "action" field is missing from ${eventTypeForError} event`);
    if (!analyticsProps.actionSubject) throw Error(`Mandatory "actionSubject" field is missing from ${eventTypeForError} event`);
    $249a118af2db2c46$export$34ac71ce24cddec2(event, eventType, analyticsProps);
};
const $249a118af2db2c46$export$13990ad4625571ed = (event, ...rest)=>{
    const analyticsProps = (0, $a9cP9.getSubjectsFromArguments)(...rest);
    $249a118af2db2c46$var$fireAnalyticsOfType(event, (0, $aa42ce8e355d58fa$export$947dac6c72b26f81), analyticsProps);
};
const $249a118af2db2c46$export$b6c00a2e59d74c5e = (event, ...rest)=>$249a118af2db2c46$var$fireEventWhenIdle($249a118af2db2c46$export$13990ad4625571ed, event, ...rest);
const $249a118af2db2c46$export$79f423cc3fd39762 = (event, ...rest)=>{
    const analyticsProps = (0, $a9cP9.getSubjectsFromArguments)(...rest);
    $249a118af2db2c46$var$fireAnalyticsOfType(event, (0, $aa42ce8e355d58fa$export$12346a674644c156), analyticsProps);
};
const $249a118af2db2c46$export$6bb7ef8f82969e8f = (event, ...rest)=>$249a118af2db2c46$var$fireEventWhenIdle($249a118af2db2c46$export$79f423cc3fd39762, event, ...rest);
const $249a118af2db2c46$export$6f46fb37ad7d962b = (event, attributes = {})=>{
    if (!event.clone) throw Error('There is no analytics event from atlaskit in Screen event');
    $249a118af2db2c46$export$34ac71ce24cddec2(event, (0, $aa42ce8e355d58fa$export$f1d537d508d2945a), {
        attributes: attributes
    });
};
const $249a118af2db2c46$export$59b89d5a711a4fa = (event, attributes = {})=>$249a118af2db2c46$var$fireEventWhenIdle($249a118af2db2c46$export$6f46fb37ad7d962b, event, attributes);

});
// SCREENS
const $aa42ce8e355d58fa$export$f636b5b56f1d624a = 'Screen';
const $aa42ce8e355d58fa$export$9d2de6eebf7462b5 = 'Drawer';
const $aa42ce8e355d58fa$export$1171103ea9083ffa = 'Modal';
const $aa42ce8e355d58fa$export$cae2783c9279926 = 'InlineDialog';
const $aa42ce8e355d58fa$export$d1123261ca8831d2 = 'Dropdown';
const $aa42ce8e355d58fa$export$238d30785c4bca84 = 'Banner';
const $aa42ce8e355d58fa$export$a1562d08625f5d7e = 'UI';
const $aa42ce8e355d58fa$export$947dac6c72b26f81 = 'TRACK';
const $aa42ce8e355d58fa$export$f1d537d508d2945a = 'SCREEN';
const $aa42ce8e355d58fa$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("a9cP9", function(module, exports) {
$parcel$export(module.exports, "getSubjectsFromArguments", () => $c39cdd8e875b9b95$export$c9bdf245bf8922fc);
$parcel$export(module.exports, "getAnalyticsType", () => $c39cdd8e875b9b95$export$a3569ac53b82a914);
$parcel$export(module.exports, "getAttributes", () => $c39cdd8e875b9b95$export$fe94072fee8a6976);
$parcel$export(module.exports, "getSource", () => $c39cdd8e875b9b95$export$dd2b6e807fb37ba3);
$parcel$export(module.exports, "getActionSubject", () => $c39cdd8e875b9b95$export$6f40cdf6d42c018d);
$parcel$export(module.exports, "getAction", () => $c39cdd8e875b9b95$export$6ca3170acb89054);
$parcel$export(module.exports, "getActionSubjectId", () => $c39cdd8e875b9b95$export$b6f8db3ad0711b02);
$parcel$export(module.exports, "getContainerId", () => $c39cdd8e875b9b95$export$7c8178cc9001d237);
$parcel$export(module.exports, "getContainerType", () => $c39cdd8e875b9b95$export$acc6f3e19803b3dc);
$parcel$export(module.exports, "getObjectId", () => $c39cdd8e875b9b95$export$fa986b91291934c7);
$parcel$export(module.exports, "getObjectType", () => $c39cdd8e875b9b95$export$11cc42aebef2ef3a);
$parcel$export(module.exports, "getTags", () => $c39cdd8e875b9b95$export$af63d7414243dad3);
$parcel$export(module.exports, "getContainers", () => $c39cdd8e875b9b95$export$ae861c5c02c4c14c);

var $aX8Tx = parcelRequire("aX8Tx");

var $6dPbw = parcelRequire("6dPbw");

var $1ilzu = parcelRequire("1ilzu");

var $1O6Yz = parcelRequire("1O6Yz");

var $4lYQk = parcelRequire("4lYQk");

var $jvwCK = parcelRequire("jvwCK");
// TODO remove `| ActionSubjectId` as a type option, from the actionSubjectAndAction, As the usage is deprecated
/**
 * @param string - string with format 'actionSubject action' or 'actionSubjectId'. It is recommended to supply an EventOverrides object instead of actionSubjectId.
 */ const $c39cdd8e875b9b95$var$extractDataFromStringAttribute = (actionSubjectAndAction)=>{
    const arr = actionSubjectAndAction.split(' ');
    switch(arr.length){
        /**
		 * @deprecated We no longer support this case as it leads to confusion with how the analytics API should be used.
		 * @see https://hello.atlassian.net/wiki/spaces/TGR/pages/2922733949
		 */ case 1:
            return {
                actionSubject: undefined,
                action: undefined,
                actionSubjectId: arr[0],
                attributes: undefined
            };
        case 2:
            return {
                actionSubject: arr[0],
                action: arr[1],
                actionSubjectId: undefined,
                attributes: undefined
            };
        default:
            throw Error('Event of this type is not supported');
    }
};
const $c39cdd8e875b9b95$export$a502e64ed48035b = (obj)=>{
    const keysCount = Object.keys(obj).length;
    if (keysCount === 4) return 'actionSubjectId' in obj && 'attributes' in obj && 'action' in obj && 'actionSubject' in obj;
    return false;
};
/**
 * @param one - can be either string with format 'actionSubject action', AnalyticsAttributes or EventOverrides.
 * @example
 * ```ts
 * extractDataFromOneAttribute('button clicked') // { actionSubject: 'button', action: 'clicked', actionSubjectId: undefined, attributes: undefined }
 * extractDataFromOneAttribute({ foo: 'bar' }) // { actionSubject: undefined, action: undefined, actionSubjectId: undefined, attributes: { foo: 'bar' } }
 * extractDataFromOneAttribute({
 *  action: 'clicked',
 *  actionSubject: 'button',
 *  actionSubjectId: 'foo',
 *  attributes: { foo: 'bar' }
 * }) // { actionSubject: 'button', action: 'clicked', actionSubjectId: 'foo', attributes: { foo: 'bar' } }
 * ```
 */ const $c39cdd8e875b9b95$var$extractDataFromOneAttribute = (one)=>{
    if (typeof one === 'string') return $c39cdd8e875b9b95$var$extractDataFromStringAttribute(one);
    if ($c39cdd8e875b9b95$export$a502e64ed48035b(one)) return one;
    return {
        actionSubject: undefined,
        action: undefined,
        actionSubjectId: undefined,
        attributes: one
    };
};
const $c39cdd8e875b9b95$var$extractDataFromTwoAttributes = (actionSubjectAndAction, actionSubjectIdOrAttributes)=>{
    if (typeof actionSubjectIdOrAttributes === 'string') {
        const { action: action, actionSubject: actionSubject } = $c39cdd8e875b9b95$var$extractDataFromStringAttribute(actionSubjectAndAction);
        const actionSubjectId = actionSubjectIdOrAttributes;
        return {
            actionSubject: actionSubject,
            action: action,
            actionSubjectId: actionSubjectId,
            attributes: undefined
        };
    }
    const { action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId } = $c39cdd8e875b9b95$var$extractDataFromStringAttribute(actionSubjectAndAction);
    return {
        actionSubject: actionSubject,
        action: action,
        actionSubjectId: actionSubjectId,
        attributes: actionSubjectIdOrAttributes
    };
};
const $c39cdd8e875b9b95$var$extractDataFromThreeAttributes = (actionSubjectAndAction, actionSubjectId, attributes)=>{
    const { action: action, actionSubject: actionSubject } = $c39cdd8e875b9b95$var$extractDataFromStringAttribute(actionSubjectAndAction);
    return {
        actionSubject: actionSubject,
        action: action,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    };
};
const $c39cdd8e875b9b95$var$extractFromContext = (event, property)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    event.context.map((item)=>item[property]);
const $c39cdd8e875b9b95$export$c9bdf245bf8922fc = (...attrs)=>{
    if (!attrs || !attrs.length) return {
        action: undefined,
        actionSubject: undefined,
        actionSubjectId: undefined,
        attributes: undefined
    };
    switch(attrs.length){
        case 1:
            return $c39cdd8e875b9b95$var$extractDataFromOneAttribute(attrs[0]);
        case 2:
            return $c39cdd8e875b9b95$var$extractDataFromTwoAttributes(attrs[0], attrs[1]);
        case 3:
            return $c39cdd8e875b9b95$var$extractDataFromThreeAttributes(attrs[0], attrs[1], attrs[2]);
        default:
            throw Error('Can not fire an empty event');
    }
};
const $c39cdd8e875b9b95$export$a3569ac53b82a914 = (event)=>event.payload.analyticsType;
const $c39cdd8e875b9b95$export$fe94072fee8a6976 = (event)=>{
    const contextAttributes = $c39cdd8e875b9b95$var$extractFromContext(event, 'attributes');
    const sources = $c39cdd8e875b9b95$var$extractFromContext(event, 'source');
    const payloadAttributes = event.payload.attributes;
    const allAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1O6Yz)))(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    contextAttributes.reduce(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (result, extraAttributes)=>(0, (/*@__PURE__*/$parcel$interopDefault($1O6Yz)))(result, extraAttributes), {}), payloadAttributes);
    const namespaces = sources.filter(Boolean).join('.');
    return (0, (/*@__PURE__*/$parcel$interopDefault($4lYQk)))({
        ...allAttributes,
        namespaces: namespaces
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6dPbw))));
};
const $c39cdd8e875b9b95$export$dd2b6e807fb37ba3 = (event)=>(0, (/*@__PURE__*/$parcel$interopDefault($1ilzu)))($c39cdd8e875b9b95$var$extractFromContext(event, 'source').filter(Boolean));
const $c39cdd8e875b9b95$export$6f40cdf6d42c018d = (event)=>{
    const { actionSubject: actionSubject } = event.payload;
    if (actionSubject) return actionSubject;
    const component = (0, (/*@__PURE__*/$parcel$interopDefault($1ilzu)))($c39cdd8e875b9b95$var$extractFromContext(event, 'component').filter(Boolean)) || (0, (/*@__PURE__*/$parcel$interopDefault($1ilzu)))($c39cdd8e875b9b95$var$extractFromContext(event, 'componentName').filter(Boolean));
    return component;
};
const $c39cdd8e875b9b95$export$6ca3170acb89054 = (event)=>event.payload.action;
const $c39cdd8e875b9b95$export$b6f8db3ad0711b02 = (event)=>event.payload.actionSubjectId;
const $c39cdd8e875b9b95$export$7c8178cc9001d237 = (event)=>(0, (/*@__PURE__*/$parcel$interopDefault($1ilzu)))($c39cdd8e875b9b95$var$extractFromContext(event, 'containerId').filter(Boolean));
const $c39cdd8e875b9b95$export$acc6f3e19803b3dc = (event)=>(0, (/*@__PURE__*/$parcel$interopDefault($1ilzu)))($c39cdd8e875b9b95$var$extractFromContext(event, 'containerType').filter(Boolean));
const $c39cdd8e875b9b95$export$fa986b91291934c7 = (event)=>(0, (/*@__PURE__*/$parcel$interopDefault($1ilzu)))($c39cdd8e875b9b95$var$extractFromContext(event, 'objectId').filter(Boolean));
const $c39cdd8e875b9b95$export$11cc42aebef2ef3a = (event)=>(0, (/*@__PURE__*/$parcel$interopDefault($1ilzu)))($c39cdd8e875b9b95$var$extractFromContext(event, 'objectType').filter(Boolean));
const $c39cdd8e875b9b95$export$af63d7414243dad3 = (event)=>{
    const tags = (0, (/*@__PURE__*/$parcel$interopDefault($jvwCK)))((0, (/*@__PURE__*/$parcel$interopDefault($aX8Tx)))($c39cdd8e875b9b95$var$extractFromContext(event, 'tags'))).filter(Boolean);
    return tags.length ? tags : undefined;
};
const $c39cdd8e875b9b95$export$ae861c5c02c4c14c = (event)=>{
    const contextContainers = $c39cdd8e875b9b95$var$extractFromContext(event, 'containers');
    const payloadContainers = event.payload.containers;
    const allContainers = (0, (/*@__PURE__*/$parcel$interopDefault($1O6Yz)))(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    contextContainers.reduce(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (result, extraContainers)=>(0, (/*@__PURE__*/$parcel$interopDefault($1O6Yz)))(result, extraContainers), {}), payloadContainers);
    const finalContainers = (0, (/*@__PURE__*/$parcel$interopDefault($4lYQk)))(allContainers, (0, (/*@__PURE__*/$parcel$interopDefault($6dPbw))));
    return Object.keys(finalContainers).length > 0 ? finalContainers : undefined;
};

});


parcelRegister("2xVsC", function(module, exports) {
$parcel$export(module.exports, "getEvent", () => $1178f990cc19eb4b$export$ee2085e97a04e027);
/**
 * This library is the only place where you'd use raw analytics from atlaskit
 */ 
var $6dPbw = parcelRequire("6dPbw");

var $4lYQk = parcelRequire("4lYQk");


var $a9cP9 = parcelRequire("a9cP9");
const $1178f990cc19eb4b$export$ee2085e97a04e027 = (event)=>{
    const analyticsType = (0, $a9cP9.getAnalyticsType)(event);
    const attributes = (0, $a9cP9.getAttributes)(event);
    const containers = (0, $a9cP9.getContainers)(event);
    const source = (0, $a9cP9.getSource)(event);
    const actionSubject = (0, $a9cP9.getActionSubject)(event);
    if (analyticsType === (0, $aa42ce8e355d58fa$export$f1d537d508d2945a)) return {
        type: (0, $aa42ce8e355d58fa$export$f1d537d508d2945a),
        payload: {
            name: source,
            attributes: attributes,
            containers: containers
        }
    };
    switch(analyticsType){
        case 0, $aa42ce8e355d58fa$export$a1562d08625f5d7e:
        case 0, $aa42ce8e355d58fa$export$947dac6c72b26f81:
        case 0, $aa42ce8e355d58fa$export$12346a674644c156:
            {
                const action = (0, $a9cP9.getAction)(event);
                const actionSubjectId = (0, $a9cP9.getActionSubjectId)(event);
                const containerId = (0, $a9cP9.getContainerId)(event);
                const containerType = (0, $a9cP9.getContainerType)(event);
                const objectId = (0, $a9cP9.getObjectId)(event);
                const objectType = (0, $a9cP9.getObjectType)(event);
                const tags = (0, $a9cP9.getTags)(event);
                return {
                    type: analyticsType,
                    payload: (0, (/*@__PURE__*/$parcel$interopDefault($4lYQk)))({
                        action: action,
                        actionSubject: actionSubject,
                        actionSubjectId: actionSubjectId,
                        source: source,
                        tags: tags,
                        containerId: containerId,
                        containers: containers,
                        containerType: containerType,
                        objectType: objectType,
                        objectId: objectId,
                        attributes: attributes
                    }, (0, (/*@__PURE__*/$parcel$interopDefault($6dPbw))))
                };
            }
        default:
            return {
                payload: {
                    source: source,
                    actionSubject: actionSubject,
                    attributes: attributes,
                    containers: containers
                },
                type: undefined
            };
    }
};

});


parcelRegister("fsisP", function(module, exports) {
$parcel$export(module.exports, "isShallowEqual", () => $8b87dbdf2afb7723$export$2225b4c39d37f8b3);
const $8b87dbdf2afb7723$var$hasOwnProp = Object.prototype.hasOwnProperty;
const $8b87dbdf2afb7723$export$2225b4c39d37f8b3 = (a, b, compare = Object.is)=>{
    if (compare(a, b)) return true;
    if (typeof a !== 'object' || typeof b !== 'object' || a === null || b === null) return false;
    const keysA = Object.keys(a);
    const keysB = Object.keys(b);
    if (keysA.length !== keysB.length) return false;
    let i = keysA.length;
    while(i--){
        const key = keysA[i];
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'unknown'. | TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'unknown'.
        if (!$8b87dbdf2afb7723$var$hasOwnProp.call(b, key) || !compare(a[key], b[key])) return false;
    }
    return true;
};

});


parcelRegister("kCbIN", function(module, exports) {
$parcel$export(module.exports, "extractFactoryFunction", () => $73c76c028127efae$export$d9a70f5f8c7d4785);
$parcel$export(module.exports, "mapStateToPropsWithErrorHandling", () => $73c76c028127efae$export$4b8cb2da7a763ee8);

var $9pTd3 = parcelRequire("9pTd3");
const $73c76c028127efae$export$d9a70f5f8c7d4785 = (fn)=>{
    if (!(fn && typeof fn === 'function' && fn.length === 0)) return fn;
    try {
        const result = fn();
        return typeof result === 'function' ? result : fn;
    } catch (e) {
        return fn;
    }
};
const $73c76c028127efae$export$4b8cb2da7a763ee8 = (mapStateToProps)=>{
    // return non-wrapped mapStateToProps if not a function
    if (!mapStateToProps) return mapStateToProps;
    if (typeof mapStateToProps !== 'function') return mapStateToProps;
    // return wrapped mapStateToProps which catches error, reports it and throws error again
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (...props)=>{
        try {
            return mapStateToProps(...props);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            (0, $9pTd3.fireErrorAnalytics)({
                meta: {
                    id: 'mapStateToProps',
                    packageName: 'jiraReactRedux',
                    teamName: 'magma'
                },
                error: e
            });
            throw e;
        }
    };
};

});


parcelRegister("j4oe4", function(module, exports) {
/**
 * Relay v0.0.0-main-39e79f66
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
module.exports = (parcelRequire("bK27B"));

});
parcelRegister("bK27B", function(module, exports) {
'use strict';

var $iwDoV = parcelRequire("iwDoV");

var $lIoSt = parcelRequire("lIoSt");

var $ywgWz = parcelRequire("ywgWz");

var $PiSbo = parcelRequire("PiSbo");

var $9YzzC = parcelRequire("9YzzC");

var $b9Umy = parcelRequire("b9Umy");

var $4E40D = parcelRequire("4E40D");

var $bdIJW = parcelRequire("bdIJW");

var $bQPKN = parcelRequire("bQPKN");
var $88c5a2e669982c1a$var$loadQuery = $bQPKN.loadQuery;

var $83OIO = parcelRequire("83OIO");

var $1NoLa = parcelRequire("1NoLa");

var $3BGlu = parcelRequire("3BGlu");

var $iahTm = parcelRequire("iahTm");

var $kM8tH = parcelRequire("kM8tH");

var $cOk0k = parcelRequire("cOk0k");

var $dmpY4 = parcelRequire("dmpY4");

var $73jbJ = parcelRequire("73jbJ");

var $xo8pN = parcelRequire("xo8pN");

var $RjuBo = parcelRequire("RjuBo");

var $eyGnt = parcelRequire("eyGnt");

var $i764d = parcelRequire("i764d");

var $dEDMm = parcelRequire("dEDMm");

var $4Iwb3 = parcelRequire("4Iwb3");

var $37Ewn = parcelRequire("37Ewn");
module.exports = {
    ConnectionHandler: $37Ewn.ConnectionHandler,
    QueryRenderer: $9YzzC,
    LocalQueryRenderer: $ywgWz,
    MutationTypes: $37Ewn.MutationTypes,
    RangeOperations: $37Ewn.RangeOperations,
    ReactRelayContext: $iwDoV,
    applyOptimisticMutation: $37Ewn.applyOptimisticMutation,
    commitLocalUpdate: $37Ewn.commitLocalUpdate,
    commitMutation: $37Ewn.commitMutation,
    createFragmentContainer: $lIoSt.createContainer,
    createPaginationContainer: $PiSbo.createContainer,
    createRefetchContainer: $b9Umy.createContainer,
    fetchQuery_DEPRECATED: $37Ewn.fetchQuery_DEPRECATED,
    graphql: $37Ewn.graphql,
    readInlineData: $37Ewn.readInlineData,
    requestSubscription: $37Ewn.requestSubscription,
    EntryPointContainer: $4E40D,
    RelayEnvironmentProvider: $1NoLa,
    ProfilerContext: $83OIO,
    fetchQuery: $37Ewn.fetchQuery,
    loadQuery: $88c5a2e669982c1a$var$loadQuery,
    loadEntryPoint: $bdIJW,
    useClientQuery: $3BGlu,
    useFragment: $kM8tH,
    useLazyLoadQuery: $cOk0k,
    useEntryPointLoader: $iahTm,
    useQueryLoader: $RjuBo,
    useMutation: $dmpY4,
    usePaginationFragment: $73jbJ,
    usePreloadedQuery: $xo8pN,
    useRefetchableFragment: $eyGnt,
    useRelayEnvironment: $i764d,
    useSubscribeToInvalidationState: $dEDMm,
    useSubscription: $4Iwb3
};

});
parcelRegister("iwDoV", function(module, exports) {
'use strict';

var $eJOHy = parcelRequire("eJOHy");

var $37Ewn = parcelRequire("37Ewn");
var $d7c9c759b76478b8$var$createRelayContext = $37Ewn.__internal.createRelayContext;
module.exports = $d7c9c759b76478b8$var$createRelayContext($eJOHy);

});
parcelRegister("37Ewn", function(module, exports) {
/**
 * Relay v0.0.0-main-39e79f66
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
module.exports = (parcelRequire("8nMMe"));

});
parcelRegister("8nMMe", function(module, exports) {
'use strict';

var $fGjVc = parcelRequire("fGjVc");

var $1F1HU = parcelRequire("1F1HU");

var $aogIg = parcelRequire("aogIg");

var $lIESd = parcelRequire("lIESd");

var $jlNVv = parcelRequire("jlNVv");

var $17TCW = parcelRequire("17TCW");

var $2i2Ws = parcelRequire("2i2Ws");

var $crrn5 = parcelRequire("crrn5");

var $ixllC = parcelRequire("ixllC");

var $5k1AH = parcelRequire("5k1AH");

var $fzwni = parcelRequire("fzwni");

var $a0L3N = parcelRequire("a0L3N");

var $dF0sr = parcelRequire("dF0sr");

var $6ic0O = parcelRequire("6ic0O");

var $bzkJN = parcelRequire("bzkJN");

var $fYFnY = parcelRequire("fYFnY");

var $axs8G = parcelRequire("axs8G");
var $61a64ec7bf34b93f$var$generateClientID = $axs8G.generateClientID, $61a64ec7bf34b93f$var$generateUniqueClientID = $axs8G.generateUniqueClientID, $61a64ec7bf34b93f$var$isClientID = $axs8G.isClientID;

var $eV0s5 = parcelRequire("eV0s5");

var $aCt1A = parcelRequire("aCt1A");

var $jyY6u = parcelRequire("jyY6u");
var $61a64ec7bf34b93f$var$isSuspenseSentinel = $jyY6u.isSuspenseSentinel, $61a64ec7bf34b93f$var$suspenseSentinel = $jyY6u.suspenseSentinel;

var $8Zufv = parcelRequire("8Zufv");

var $jd20U = parcelRequire("jd20U");

var $iJHA2 = parcelRequire("iJHA2");

var $frIyf = parcelRequire("frIyf");

var $5eWNm = parcelRequire("5eWNm");

var $l0are = parcelRequire("l0are");

var $fagih = parcelRequire("fagih");

var $g432U = parcelRequire("g432U");

var $6BRxK = parcelRequire("6BRxK");

var $cnpJc = parcelRequire("cnpJc");

var $7eJdF = parcelRequire("7eJdF");

var $f91UN = parcelRequire("f91UN");

var $bafrW = parcelRequire("bafrW");

var $ap10a = parcelRequire("ap10a");

var $hvXwY = parcelRequire("hvXwY");

var $3GT8f = parcelRequire("3GT8f");

var $hElRV = parcelRequire("hElRV");

var $eZC9U = parcelRequire("eZC9U");

var $jXBNZ = parcelRequire("jXBNZ");

var $6bDy3 = parcelRequire("6bDy3");

var $5xF3Q = parcelRequire("5xF3Q");

var $9CTh0 = parcelRequire("9CTh0");

var $mEFEt = parcelRequire("mEFEt");

var $70TNW = parcelRequire("70TNW");

var $eBAOm = parcelRequire("eBAOm");

var $dWG7x = parcelRequire("dWG7x");

var $fbhid = parcelRequire("fbhid");

var $6c38N = parcelRequire("6c38N");

var $l9X9G = parcelRequire("l9X9G");

var $54ow8 = parcelRequire("54ow8");

var $aJJrb = parcelRequire("aJJrb");

var $l4x3v = parcelRequire("l4x3v");

var $llkIA = parcelRequire("llkIA");

var $5tBBd = parcelRequire("5tBBd");

var $e17WK = parcelRequire("e17WK");

var $4cAcq = parcelRequire("4cAcq");

var $bVKeR = parcelRequire("bVKeR");
var $61a64ec7bf34b93f$var$mapStr, $61a64ec7bf34b93f$var$setStr, $61a64ec7bf34b93f$var$promiseStr, $61a64ec7bf34b93f$var$objStr;
module.exports = {
    Environment: $5eWNm,
    Network: $ixllC,
    Observable: $5k1AH,
    QueryResponseCache: $fzwni,
    RecordSource: $7eJdF,
    Record: $fagih,
    ReplaySubject: $e17WK,
    Store: $6BRxK,
    areEqualSelectors: $g432U.areEqualSelectors,
    createFragmentSpecResolver: $eV0s5,
    createNormalizationSelector: $g432U.createNormalizationSelector,
    createOperationDescriptor: $l0are.createOperationDescriptor,
    createReaderSelector: $g432U.createReaderSelector,
    createRequestDescriptor: $l0are.createRequestDescriptor,
    getArgumentValues: $f91UN.getArgumentValues,
    getDataIDsFromFragment: $g432U.getDataIDsFromFragment,
    getDataIDsFromObject: $g432U.getDataIDsFromObject,
    getNode: $bzkJN.getNode,
    getFragment: $bzkJN.getFragment,
    getInlineDataFragment: $bzkJN.getInlineDataFragment,
    getModuleComponentKey: $f91UN.getModuleComponentKey,
    getModuleOperationKey: $f91UN.getModuleOperationKey,
    getPaginationFragment: $bzkJN.getPaginationFragment,
    getPluralSelector: $g432U.getPluralSelector,
    getRefetchableFragment: $bzkJN.getRefetchableFragment,
    getRequest: $bzkJN.getRequest,
    getRequestIdentifier: $70TNW,
    getSelector: $g432U.getSelector,
    getSelectorsFromObject: $g432U.getSelectorsFromObject,
    getSingularSelector: $g432U.getSingularSelector,
    getStorageKey: $f91UN.getStorageKey,
    getVariablesFromFragment: $g432U.getVariablesFromFragment,
    getVariablesFromObject: $g432U.getVariablesFromObject,
    getVariablesFromPluralFragment: $g432U.getVariablesFromPluralFragment,
    getVariablesFromSingularFragment: $g432U.getVariablesFromSingularFragment,
    handlePotentialSnapshotErrors: $dWG7x,
    graphql: $bzkJN.graphql,
    isFragment: $bzkJN.isFragment,
    isInlineDataFragment: $bzkJN.isInlineDataFragment,
    isSuspenseSentinel: $61a64ec7bf34b93f$var$isSuspenseSentinel,
    suspenseSentinel: $61a64ec7bf34b93f$var$suspenseSentinel,
    isRequest: $bzkJN.isRequest,
    readInlineData: $iJHA2,
    MutationTypes: $crrn5.MutationTypes,
    RangeOperations: $crrn5.RangeOperations,
    DefaultHandlerProvider: $lIESd,
    ConnectionHandler: $fGjVc,
    MutationHandlers: $aogIg,
    VIEWER_ID: $ap10a.VIEWER_ID,
    VIEWER_TYPE: $ap10a.VIEWER_TYPE,
    applyOptimisticMutation: $jlNVv,
    commitLocalUpdate: $17TCW,
    commitMutation: $2i2Ws,
    fetchQuery: $a0L3N,
    fetchQuery_DEPRECATED: $dF0sr,
    isRelayModernEnvironment: $8Zufv,
    requestSubscription: $hvXwY,
    ConnectionInterface: $1F1HU,
    PreloadableQueryRegistry: $fYFnY,
    RelayProfiler: $5tBBd,
    createPayloadFor3DField: $3GT8f,
    RelayConcreteNode: $54ow8,
    RelayError: $l4x3v,
    RelayFeatureFlags: $llkIA,
    DEFAULT_HANDLE_KEY: $aJJrb.DEFAULT_HANDLE_KEY,
    FRAGMENTS_KEY: $f91UN.FRAGMENTS_KEY,
    FRAGMENT_OWNER_KEY: $f91UN.FRAGMENT_OWNER_KEY,
    ID_KEY: $f91UN.ID_KEY,
    REF_KEY: $f91UN.REF_KEY,
    REFS_KEY: $f91UN.REFS_KEY,
    ROOT_ID: $f91UN.ROOT_ID,
    ROOT_TYPE: $f91UN.ROOT_TYPE,
    TYPENAME_KEY: $f91UN.TYPENAME_KEY,
    deepFreeze: $hElRV,
    generateClientID: $61a64ec7bf34b93f$var$generateClientID,
    generateUniqueClientID: $61a64ec7bf34b93f$var$generateUniqueClientID,
    getRelayHandleKey: $mEFEt,
    isClientID: $61a64ec7bf34b93f$var$isClientID,
    isPromise: $fbhid,
    isScalarAndEqual: $6c38N,
    recycleNodesInto: $l9X9G,
    stableCopy: $4cAcq,
    getFragmentIdentifier: $eZC9U,
    getRefetchMetadata: $9CTh0,
    getPaginationMetadata: $jXBNZ,
    getPaginationVariables: $6bDy3,
    getPendingOperationsForFragment: $5xF3Q,
    getValueAtPath: $eBAOm,
    __internal: {
        ResolverFragments: $bafrW,
        OperationTracker: $cnpJc,
        createRelayContext: $aCt1A,
        getOperationVariables: $frIyf.getOperationVariables,
        getLocalVariables: $frIyf.getLocalVariables,
        fetchQuery: $6ic0O.fetchQuery,
        fetchQueryDeduped: $6ic0O.fetchQueryDeduped,
        getPromiseForActiveRequest: $6ic0O.getPromiseForActiveRequest,
        getObservableForActiveRequest: $6ic0O.getObservableForActiveRequest,
        normalizeResponse: $jd20U,
        withProvidedVariables: $bVKeR
    }
};

});
parcelRegister("fGjVc", function(module, exports) {
'use strict';

var $axs8G = parcelRequire("axs8G");
var $b6aa3b40152fdfb6$var$generateClientID = $axs8G.generateClientID;

var $f91UN = parcelRequire("f91UN");
var $b6aa3b40152fdfb6$var$getStableStorageKey = $f91UN.getStableStorageKey;

var $mEFEt = parcelRequire("mEFEt");

var $1F1HU = parcelRequire("1F1HU");

var $423Vm = parcelRequire("423Vm");
parcelRequire("dH6ue");
var $b6aa3b40152fdfb6$var$CONNECTION = 'connection';
var $b6aa3b40152fdfb6$var$NEXT_EDGE_INDEX = '__connection_next_edge_index';
function $b6aa3b40152fdfb6$var$update(store, payload) {
    var record = store.get(payload.dataID);
    if (!record) return;
    var _ConnectionInterface$ = $1F1HU.get(), EDGES = _ConnectionInterface$.EDGES, END_CURSOR = _ConnectionInterface$.END_CURSOR, HAS_NEXT_PAGE = _ConnectionInterface$.HAS_NEXT_PAGE, HAS_PREV_PAGE = _ConnectionInterface$.HAS_PREV_PAGE, PAGE_INFO = _ConnectionInterface$.PAGE_INFO, PAGE_INFO_TYPE = _ConnectionInterface$.PAGE_INFO_TYPE, START_CURSOR = _ConnectionInterface$.START_CURSOR;
    var serverConnection = record.getLinkedRecord(payload.fieldKey);
    var serverPageInfo = serverConnection && serverConnection.getLinkedRecord(PAGE_INFO);
    if (!serverConnection) {
        record.setValue(null, payload.handleKey);
        return;
    }
    var clientConnectionID = $b6aa3b40152fdfb6$var$generateClientID(record.getDataID(), payload.handleKey);
    var clientConnectionField = record.getLinkedRecord(payload.handleKey);
    var clientConnection = clientConnectionField !== null && clientConnectionField !== void 0 ? clientConnectionField : store.get(clientConnectionID);
    var clientPageInfo = clientConnection && clientConnection.getLinkedRecord(PAGE_INFO);
    if (!clientConnection) {
        var connection = store.create(clientConnectionID, serverConnection.getType());
        connection.setValue(0, $b6aa3b40152fdfb6$var$NEXT_EDGE_INDEX);
        connection.copyFieldsFrom(serverConnection);
        var serverEdges = serverConnection.getLinkedRecords(EDGES);
        if (serverEdges) {
            serverEdges = serverEdges.map(function(edge) {
                return $b6aa3b40152fdfb6$var$buildConnectionEdge(store, connection, edge);
            });
            connection.setLinkedRecords(serverEdges, EDGES);
        }
        record.setLinkedRecord(connection, payload.handleKey);
        clientPageInfo = store.create($b6aa3b40152fdfb6$var$generateClientID(connection.getDataID(), PAGE_INFO), PAGE_INFO_TYPE);
        clientPageInfo.setValue(false, HAS_NEXT_PAGE);
        clientPageInfo.setValue(false, HAS_PREV_PAGE);
        clientPageInfo.setValue(null, END_CURSOR);
        clientPageInfo.setValue(null, START_CURSOR);
        if (serverPageInfo) clientPageInfo.copyFieldsFrom(serverPageInfo);
        connection.setLinkedRecord(clientPageInfo, PAGE_INFO);
    } else {
        if (clientConnectionField == null) record.setLinkedRecord(clientConnection, payload.handleKey);
        var _connection = clientConnection;
        var _serverEdges = serverConnection.getLinkedRecords(EDGES);
        if (_serverEdges) _serverEdges = _serverEdges.map(function(edge) {
            return $b6aa3b40152fdfb6$var$buildConnectionEdge(store, _connection, edge);
        });
        var prevEdges = _connection.getLinkedRecords(EDGES);
        var prevPageInfo = _connection.getLinkedRecord(PAGE_INFO);
        _connection.copyFieldsFrom(serverConnection);
        if (prevEdges) _connection.setLinkedRecords(prevEdges, EDGES);
        if (prevPageInfo) _connection.setLinkedRecord(prevPageInfo, PAGE_INFO);
        var nextEdges = [];
        var args = payload.args;
        if (prevEdges && _serverEdges) {
            if (args.after != null) {
                var _clientPageInfo;
                var clientEndCursor = (_clientPageInfo = clientPageInfo) === null || _clientPageInfo === void 0 ? void 0 : _clientPageInfo.getValue(END_CURSOR);
                var serverEndCursor = serverPageInfo === null || serverPageInfo === void 0 ? void 0 : serverPageInfo.getValue(END_CURSOR);
                var isAddingEdgesAfterCurrentPage = clientPageInfo && args.after === clientEndCursor;
                var isFillingOutCurrentPage = clientPageInfo && clientEndCursor === serverEndCursor;
                if (isAddingEdgesAfterCurrentPage || isFillingOutCurrentPage) {
                    var nodeIDs = new Set();
                    $b6aa3b40152fdfb6$var$mergeEdges(prevEdges, nextEdges, nodeIDs);
                    $b6aa3b40152fdfb6$var$mergeEdges(_serverEdges, nextEdges, nodeIDs);
                } else return;
            } else if (args.before != null) {
                if (clientPageInfo && args.before === clientPageInfo.getValue(START_CURSOR)) {
                    var _nodeIDs = new Set();
                    $b6aa3b40152fdfb6$var$mergeEdges(_serverEdges, nextEdges, _nodeIDs);
                    $b6aa3b40152fdfb6$var$mergeEdges(prevEdges, nextEdges, _nodeIDs);
                } else return;
            } else nextEdges = _serverEdges;
        } else if (_serverEdges) nextEdges = _serverEdges;
        else nextEdges = prevEdges;
        if (nextEdges != null && nextEdges !== prevEdges) _connection.setLinkedRecords(nextEdges, EDGES);
        if (clientPageInfo && serverPageInfo) {
            if (args.after == null && args.before == null) clientPageInfo.copyFieldsFrom(serverPageInfo);
            else if (args.before != null || args.after == null && args.last) {
                clientPageInfo.setValue(!!serverPageInfo.getValue(HAS_PREV_PAGE), HAS_PREV_PAGE);
                var startCursor = serverPageInfo.getValue(START_CURSOR);
                if (typeof startCursor === 'string') clientPageInfo.setValue(startCursor, START_CURSOR);
            } else if (args.after != null || args.before == null && args.first) {
                clientPageInfo.setValue(!!serverPageInfo.getValue(HAS_NEXT_PAGE), HAS_NEXT_PAGE);
                var endCursor = serverPageInfo.getValue(END_CURSOR);
                if (typeof endCursor === 'string') clientPageInfo.setValue(endCursor, END_CURSOR);
            }
        }
    }
}
function $b6aa3b40152fdfb6$var$getConnection(record, key, filters) {
    var handleKey = $mEFEt($b6aa3b40152fdfb6$var$CONNECTION, key, null);
    return record.getLinkedRecord(handleKey, filters);
}
function $b6aa3b40152fdfb6$var$getConnectionID(recordID, key, filters) {
    var handleKey = $mEFEt($b6aa3b40152fdfb6$var$CONNECTION, key, null);
    var storageKey = $b6aa3b40152fdfb6$var$getStableStorageKey(handleKey, filters);
    return $b6aa3b40152fdfb6$var$generateClientID(recordID, storageKey);
}
function $b6aa3b40152fdfb6$var$insertEdgeAfter(record, newEdge, cursor) {
    var _ConnectionInterface$2 = $1F1HU.get(), CURSOR = _ConnectionInterface$2.CURSOR, EDGES = _ConnectionInterface$2.EDGES;
    var edges = record.getLinkedRecords(EDGES);
    if (!edges) {
        record.setLinkedRecords([
            newEdge
        ], EDGES);
        return;
    }
    var nextEdges;
    if (cursor == null) nextEdges = edges.concat(newEdge);
    else {
        nextEdges = [];
        var foundCursor = false;
        for(var ii = 0; ii < edges.length; ii++){
            var edge = edges[ii];
            nextEdges.push(edge);
            if (edge == null) continue;
            var edgeCursor = edge.getValue(CURSOR);
            if (cursor === edgeCursor) {
                nextEdges.push(newEdge);
                foundCursor = true;
            }
        }
        if (!foundCursor) nextEdges.push(newEdge);
    }
    record.setLinkedRecords(nextEdges, EDGES);
}
function $b6aa3b40152fdfb6$var$createEdge(store, record, node, edgeType) {
    var _ConnectionInterface$3 = $1F1HU.get(), NODE = _ConnectionInterface$3.NODE;
    var edgeID = $b6aa3b40152fdfb6$var$generateClientID(record.getDataID(), node.getDataID());
    var edge = store.get(edgeID);
    if (!edge) edge = store.create(edgeID, edgeType);
    edge.setLinkedRecord(node, NODE);
    if (edge.getValue('cursor') == null) edge.setValue(null, 'cursor');
    return edge;
}
function $b6aa3b40152fdfb6$var$insertEdgeBefore(record, newEdge, cursor) {
    var _ConnectionInterface$4 = $1F1HU.get(), CURSOR = _ConnectionInterface$4.CURSOR, EDGES = _ConnectionInterface$4.EDGES;
    var edges = record.getLinkedRecords(EDGES);
    if (!edges) {
        record.setLinkedRecords([
            newEdge
        ], EDGES);
        return;
    }
    var nextEdges;
    if (cursor == null) nextEdges = [
        newEdge
    ].concat(edges);
    else {
        nextEdges = [];
        var foundCursor = false;
        for(var ii = 0; ii < edges.length; ii++){
            var edge = edges[ii];
            if (edge != null) {
                var edgeCursor = edge.getValue(CURSOR);
                if (cursor === edgeCursor) {
                    nextEdges.push(newEdge);
                    foundCursor = true;
                }
            }
            nextEdges.push(edge);
        }
        if (!foundCursor) nextEdges.unshift(newEdge);
    }
    record.setLinkedRecords(nextEdges, EDGES);
}
function $b6aa3b40152fdfb6$var$deleteNode(record, nodeID) {
    var _ConnectionInterface$5 = $1F1HU.get(), EDGES = _ConnectionInterface$5.EDGES, NODE = _ConnectionInterface$5.NODE;
    var edges = record.getLinkedRecords(EDGES);
    if (!edges) return;
    var nextEdges;
    for(var ii = 0; ii < edges.length; ii++){
        var edge = edges[ii];
        var node = edge && edge.getLinkedRecord(NODE);
        if (node != null && node.getDataID() === nodeID) {
            if (nextEdges === undefined) nextEdges = edges.slice(0, ii);
        } else if (nextEdges !== undefined) nextEdges.push(edge);
    }
    if (nextEdges !== undefined) record.setLinkedRecords(nextEdges, EDGES);
}
function $b6aa3b40152fdfb6$var$buildConnectionEdge(store, connection, edge) {
    if (edge == null) return edge;
    var _ConnectionInterface$6 = $1F1HU.get(), EDGES = _ConnectionInterface$6.EDGES;
    var edgeIndex = connection.getValue($b6aa3b40152fdfb6$var$NEXT_EDGE_INDEX);
    !(typeof edgeIndex === 'number') && $423Vm(false);
    var edgeID = $b6aa3b40152fdfb6$var$generateClientID(connection.getDataID(), EDGES, edgeIndex);
    var connectionEdge = store.create(edgeID, edge.getType());
    connectionEdge.copyFieldsFrom(edge);
    if (connectionEdge.getValue('cursor') == null) connectionEdge.setValue(null, 'cursor');
    connection.setValue(edgeIndex + 1, $b6aa3b40152fdfb6$var$NEXT_EDGE_INDEX);
    return connectionEdge;
}
function $b6aa3b40152fdfb6$var$mergeEdges(sourceEdges, targetEdges, nodeIDs) {
    var _ConnectionInterface$7 = $1F1HU.get(), NODE = _ConnectionInterface$7.NODE;
    for(var ii = 0; ii < sourceEdges.length; ii++){
        var edge = sourceEdges[ii];
        if (!edge) continue;
        var node = edge.getLinkedRecord(NODE);
        var nodeID = node && node.getDataID();
        if (nodeID) {
            if (nodeIDs.has(nodeID)) continue;
            nodeIDs.add(nodeID);
        }
        targetEdges.push(edge);
    }
}
module.exports = {
    buildConnectionEdge: $b6aa3b40152fdfb6$var$buildConnectionEdge,
    createEdge: $b6aa3b40152fdfb6$var$createEdge,
    deleteNode: $b6aa3b40152fdfb6$var$deleteNode,
    getConnection: $b6aa3b40152fdfb6$var$getConnection,
    getConnectionID: $b6aa3b40152fdfb6$var$getConnectionID,
    insertEdgeAfter: $b6aa3b40152fdfb6$var$insertEdgeAfter,
    insertEdgeBefore: $b6aa3b40152fdfb6$var$insertEdgeBefore,
    update: $b6aa3b40152fdfb6$var$update
};

});
parcelRegister("axs8G", function(module, exports) {
'use strict';

var $llkIA = parcelRequire("llkIA");

var $6jf6j = parcelRequire("6jf6j");
var $7ac2d04295c42dbc$var$intern = $6jf6j.intern;
var $7ac2d04295c42dbc$var$PREFIX = 'client:';
function $7ac2d04295c42dbc$var$generateClientID(id, storageKey, index) {
    var internedId = $llkIA.STRING_INTERN_LEVEL <= 0 ? id : $7ac2d04295c42dbc$var$intern(id, $llkIA.MAX_DATA_ID_LENGTH);
    var key = internedId + ':' + storageKey;
    if (index != null) key += ':' + index;
    if (key.indexOf($7ac2d04295c42dbc$var$PREFIX) !== 0) key = $7ac2d04295c42dbc$var$PREFIX + key;
    return key;
}
function $7ac2d04295c42dbc$var$isClientID(id) {
    return id.indexOf($7ac2d04295c42dbc$var$PREFIX) === 0;
}
var $7ac2d04295c42dbc$var$localID = 0;
function $7ac2d04295c42dbc$var$generateUniqueClientID() {
    return "".concat($7ac2d04295c42dbc$var$PREFIX, "local:").concat($7ac2d04295c42dbc$var$localID++);
}
function $7ac2d04295c42dbc$var$generateClientObjectClientID(typename, localId, index) {
    var key = "".concat($7ac2d04295c42dbc$var$PREFIX).concat(typename, ":").concat(localId);
    if (index != null) key += ':' + index;
    return key;
}
module.exports = {
    generateClientID: $7ac2d04295c42dbc$var$generateClientID,
    generateClientObjectClientID: $7ac2d04295c42dbc$var$generateClientObjectClientID,
    generateUniqueClientID: $7ac2d04295c42dbc$var$generateUniqueClientID,
    isClientID: $7ac2d04295c42dbc$var$isClientID
};

});
parcelRegister("llkIA", function(module, exports) {
'use strict';
var $f89ba15567e9139e$var$RelayFeatureFlags = {
    ENABLE_VARIABLE_CONNECTION_KEY: false,
    ENABLE_RELAY_RESOLVERS: false,
    ENABLE_GETFRAGMENTIDENTIFIER_OPTIMIZATION: false,
    ENABLE_FRIENDLY_QUERY_NAME_GQL_URL: false,
    ENABLE_LOAD_QUERY_REQUEST_DEDUPING: true,
    ENABLE_DO_NOT_WRAP_LIVE_QUERY: false,
    ENABLE_NOTIFY_SUBSCRIPTION: false,
    BATCH_ASYNC_MODULE_UPDATES_FN: null,
    ENABLE_CONTAINERS_SUBSCRIBE_ON_COMMIT: false,
    MAX_DATA_ID_LENGTH: null,
    STRING_INTERN_LEVEL: 0,
    LOG_MISSING_RECORDS_IN_PROD: false,
    ENABLE_LOOSE_SUBSCRIPTION_ATTRIBUTION: false,
    ENABLE_OPERATION_TRACKER_OPTIMISTIC_UPDATES: false,
    ENABLE_RELAY_OPERATION_TRACKER_SUSPENSE: false,
    ENABLE_FIELD_ERROR_HANDLING: false,
    ENABLE_FIELD_ERROR_HANDLING_THROW_BY_DEFAULT: false,
    ENABLE_FIELD_ERROR_HANDLING_CATCH_DIRECTIVE: false,
    PROCESS_OPTIMISTIC_UPDATE_BEFORE_SUBSCRIPTION: false,
    MARK_RESOLVER_VALUES_AS_CLEAN_AFTER_FRAGMENT_REREAD: false
};
module.exports = $f89ba15567e9139e$var$RelayFeatureFlags;

});

parcelRegister("6jf6j", function(module, exports) {
'use strict';
var $49803b23d9a7e0a2$var$internTable = new Map();
var $49803b23d9a7e0a2$var$nextIndex = 1;
var $49803b23d9a7e0a2$var$digits = $49803b23d9a7e0a2$var$initDigitTable();
var $49803b23d9a7e0a2$var$INTERN_PREFIX = '\t';
var $49803b23d9a7e0a2$var$ESCAPE_PREFIX = '\v';
function $49803b23d9a7e0a2$var$initDigitTable() {
    var digits = new Set();
    for(var i = 0; i < 10; ++i)digits.add(i.toString());
    return digits;
}
function $49803b23d9a7e0a2$var$escape(str) {
    if (str[0] === $49803b23d9a7e0a2$var$INTERN_PREFIX && $49803b23d9a7e0a2$var$digits.has(str[1]) || str[0] === $49803b23d9a7e0a2$var$ESCAPE_PREFIX) return $49803b23d9a7e0a2$var$ESCAPE_PREFIX + str;
    return str;
}
function $49803b23d9a7e0a2$var$intern(str, limit) {
    if (limit == null || str.length < limit) return $49803b23d9a7e0a2$var$escape(str);
    var internedString = $49803b23d9a7e0a2$var$internTable.get(str);
    if (internedString != null) return internedString;
    internedString = $49803b23d9a7e0a2$var$INTERN_PREFIX + $49803b23d9a7e0a2$var$nextIndex++;
    $49803b23d9a7e0a2$var$internTable.set(str, internedString);
    return internedString;
}
module.exports = {
    intern: $49803b23d9a7e0a2$var$intern
};

});


parcelRegister("f91UN", function(module, exports) {
'use strict';

var $7Wmh0 = parcelRequire("7Wmh0");
var $b0692e931f8c638b$var$_interopRequireDefault = $7Wmh0.default;

var $b0692e931f8c638b$var$_toConsumableArray2 = $b0692e931f8c638b$var$_interopRequireDefault((parcelRequire("gHCmS")));

var $mEFEt = parcelRequire("mEFEt");

var $54ow8 = parcelRequire("54ow8");

var $4cAcq = parcelRequire("4cAcq");

var $423Vm = parcelRequire("423Vm");
var $b0692e931f8c638b$var$VARIABLE = $54ow8.VARIABLE, $b0692e931f8c638b$var$LITERAL = $54ow8.LITERAL, $b0692e931f8c638b$var$OBJECT_VALUE = $54ow8.OBJECT_VALUE, $b0692e931f8c638b$var$LIST_VALUE = $54ow8.LIST_VALUE;
var $b0692e931f8c638b$var$ERRORS_KEY = '__errors';
var $b0692e931f8c638b$var$MODULE_COMPONENT_KEY_PREFIX = '__module_component_';
var $b0692e931f8c638b$var$MODULE_OPERATION_KEY_PREFIX = '__module_operation_';
function $b0692e931f8c638b$var$getArgumentValue(arg, variables) {
    if (arg.kind === $b0692e931f8c638b$var$VARIABLE) return $b0692e931f8c638b$var$getStableVariableValue(arg.variableName, variables);
    else if (arg.kind === $b0692e931f8c638b$var$LITERAL) return arg.value;
    else if (arg.kind === $b0692e931f8c638b$var$OBJECT_VALUE) {
        var value = {};
        arg.fields.forEach(function(field) {
            value[field.name] = $b0692e931f8c638b$var$getArgumentValue(field, variables);
        });
        return value;
    } else if (arg.kind === $b0692e931f8c638b$var$LIST_VALUE) {
        var _value = [];
        arg.items.forEach(function(item) {
            item != null && _value.push($b0692e931f8c638b$var$getArgumentValue(item, variables));
        });
        return _value;
    }
}
function $b0692e931f8c638b$var$getArgumentValues(args, variables, isWithinUnmatchedTypeRefinement) {
    var values = {};
    if (isWithinUnmatchedTypeRefinement) values[$b0692e931f8c638b$var$RelayStoreUtils.FRAGMENT_POINTER_IS_WITHIN_UNMATCHED_TYPE_REFINEMENT] = true;
    if (args) args.forEach(function(arg) {
        values[arg.name] = $b0692e931f8c638b$var$getArgumentValue(arg, variables);
    });
    return values;
}
function $b0692e931f8c638b$var$getHandleStorageKey(handleField, variables) {
    var dynamicKey = handleField.dynamicKey, handle = handleField.handle, key = handleField.key, name = handleField.name, args = handleField.args, filters = handleField.filters;
    var handleName = $mEFEt(handle, key, name);
    var filterArgs = null;
    if (args && filters && args.length !== 0 && filters.length !== 0) filterArgs = args.filter(function(arg) {
        return filters.indexOf(arg.name) > -1;
    });
    if (dynamicKey) filterArgs = filterArgs != null ? [
        dynamicKey
    ].concat((0, $b0692e931f8c638b$var$_toConsumableArray2["default"])(filterArgs)) : [
        dynamicKey
    ];
    if (filterArgs === null) return handleName;
    else return $b0692e931f8c638b$var$formatStorageKey(handleName, $b0692e931f8c638b$var$getArgumentValues(filterArgs, variables));
}
function $b0692e931f8c638b$var$getStorageKey(field, variables) {
    if (field.storageKey) return field.storageKey;
    var args = $b0692e931f8c638b$var$getArguments(field);
    var name = field.name;
    return args && args.length !== 0 ? $b0692e931f8c638b$var$formatStorageKey(name, $b0692e931f8c638b$var$getArgumentValues(args, variables)) : name;
}
function $b0692e931f8c638b$var$getArguments(field) {
    if (field.kind === 'RelayResolver' || field.kind === 'RelayLiveResolver') {
        var _field$fragment2;
        if (field.args == null) {
            var _field$fragment;
            return (_field$fragment = field.fragment) === null || _field$fragment === void 0 ? void 0 : _field$fragment.args;
        }
        if (((_field$fragment2 = field.fragment) === null || _field$fragment2 === void 0 ? void 0 : _field$fragment2.args) == null) return field.args;
        return field.args.concat(field.fragment.args);
    }
    var args = typeof field.args === 'undefined' ? undefined : field.args;
    return args;
}
function $b0692e931f8c638b$var$getStableStorageKey(name, args) {
    return $b0692e931f8c638b$var$formatStorageKey(name, $4cAcq(args));
}
function $b0692e931f8c638b$var$formatStorageKey(name, argValues) {
    if (!argValues) return name;
    var values = [];
    for(var argName in argValues)if (argValues.hasOwnProperty(argName)) {
        var value = argValues[argName];
        if (value != null) {
            var _JSON$stringify;
            values.push(argName + ':' + ((_JSON$stringify = JSON.stringify(value)) !== null && _JSON$stringify !== void 0 ? _JSON$stringify : 'undefined'));
        }
    }
    return values.length === 0 ? name : name + "(".concat(values.join(','), ")");
}
function $b0692e931f8c638b$var$getStableVariableValue(name, variables) {
    !variables.hasOwnProperty(name) && $423Vm(false);
    return $4cAcq(variables[name]);
}
function $b0692e931f8c638b$var$getModuleComponentKey(documentName) {
    return "".concat($b0692e931f8c638b$var$MODULE_COMPONENT_KEY_PREFIX).concat(documentName);
}
function $b0692e931f8c638b$var$getModuleOperationKey(documentName) {
    return "".concat($b0692e931f8c638b$var$MODULE_OPERATION_KEY_PREFIX).concat(documentName);
}
var $b0692e931f8c638b$var$RelayStoreUtils = {
    ACTOR_IDENTIFIER_KEY: '__actorIdentifier',
    CLIENT_EDGE_TRAVERSAL_PATH: '__clientEdgeTraversalPath',
    FRAGMENTS_KEY: '__fragments',
    FRAGMENT_OWNER_KEY: '__fragmentOwner',
    FRAGMENT_POINTER_IS_WITHIN_UNMATCHED_TYPE_REFINEMENT: '$isWithinUnmatchedTypeRefinement',
    FRAGMENT_PROP_NAME_KEY: '__fragmentPropName',
    MODULE_COMPONENT_KEY: '__module_component',
    ERRORS_KEY: $b0692e931f8c638b$var$ERRORS_KEY,
    ID_KEY: '__id',
    REF_KEY: '__ref',
    REFS_KEY: '__refs',
    ROOT_ID: 'client:root',
    ROOT_TYPE: '__Root',
    TYPENAME_KEY: '__typename',
    INVALIDATED_AT_KEY: '__invalidated_at',
    RELAY_RESOLVER_VALUE_KEY: '__resolverValue',
    RELAY_RESOLVER_INVALIDATION_KEY: '__resolverValueMayBeInvalid',
    RELAY_RESOLVER_SNAPSHOT_KEY: '__resolverSnapshot',
    RELAY_RESOLVER_ERROR_KEY: '__resolverError',
    RELAY_RESOLVER_OUTPUT_TYPE_RECORD_IDS: '__resolverOutputTypeRecordIDs',
    formatStorageKey: $b0692e931f8c638b$var$formatStorageKey,
    getArgumentValue: $b0692e931f8c638b$var$getArgumentValue,
    getArgumentValues: $b0692e931f8c638b$var$getArgumentValues,
    getHandleStorageKey: $b0692e931f8c638b$var$getHandleStorageKey,
    getStorageKey: $b0692e931f8c638b$var$getStorageKey,
    getStableStorageKey: $b0692e931f8c638b$var$getStableStorageKey,
    getModuleComponentKey: $b0692e931f8c638b$var$getModuleComponentKey,
    getModuleOperationKey: $b0692e931f8c638b$var$getModuleOperationKey
};
module.exports = $b0692e931f8c638b$var$RelayStoreUtils;

});
parcelRegister("mEFEt", function(module, exports) {
'use strict';

var $aJJrb = parcelRequire("aJJrb");
var $04419a9037b3e9d0$var$DEFAULT_HANDLE_KEY = $aJJrb.DEFAULT_HANDLE_KEY;

var $423Vm = parcelRequire("423Vm");
function $04419a9037b3e9d0$var$getRelayHandleKey(handleName, key, fieldName) {
    if (key && key !== $04419a9037b3e9d0$var$DEFAULT_HANDLE_KEY) return "__".concat(key, "_").concat(handleName);
    !(fieldName != null) && $423Vm(false);
    return "__".concat(fieldName, "_").concat(handleName);
}
module.exports = $04419a9037b3e9d0$var$getRelayHandleKey;

});
parcelRegister("aJJrb", function(module, exports) {
'use strict';
module.exports = {
    DEFAULT_HANDLE_KEY: ''
};

});

parcelRegister("423Vm", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */ var $2efa6493227b631d$var$invariant = function(condition, format, a, b, c, d, e, f) {
    if (!condition) {
        var error;
        if (format === undefined) error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        else {
            var args = [
                a,
                b,
                c,
                d,
                e,
                f
            ];
            var argIndex = 0;
            error = new Error(format.replace(/%s/g, function() {
                return args[argIndex++];
            }));
            error.name = 'Invariant Violation';
        }
        error.framesToPop = 1; // we don't care about invariant's own frame
        throw error;
    }
};
module.exports = $2efa6493227b631d$var$invariant;

});


parcelRegister("54ow8", function(module, exports) {
'use strict';
var $3b10581e79368871$var$RelayConcreteNode = {
    ACTOR_CHANGE: 'ActorChange',
    CATCH_FIELD: 'CatchField',
    CONDITION: 'Condition',
    CLIENT_COMPONENT: 'ClientComponent',
    CLIENT_EDGE_TO_SERVER_OBJECT: 'ClientEdgeToServerObject',
    CLIENT_EDGE_TO_CLIENT_OBJECT: 'ClientEdgeToClientObject',
    CLIENT_EXTENSION: 'ClientExtension',
    DEFER: 'Defer',
    CONNECTION: 'Connection',
    FRAGMENT: 'Fragment',
    FRAGMENT_SPREAD: 'FragmentSpread',
    INLINE_DATA_FRAGMENT_SPREAD: 'InlineDataFragmentSpread',
    INLINE_DATA_FRAGMENT: 'InlineDataFragment',
    INLINE_FRAGMENT: 'InlineFragment',
    LINKED_FIELD: 'LinkedField',
    LINKED_HANDLE: 'LinkedHandle',
    LITERAL: 'Literal',
    LIST_VALUE: 'ListValue',
    LOCAL_ARGUMENT: 'LocalArgument',
    MODULE_IMPORT: 'ModuleImport',
    ALIASED_FRAGMENT_SPREAD: 'AliasedFragmentSpread',
    ALIASED_INLINE_FRAGMENT_SPREAD: 'AliasedInlineFragmentSpread',
    RELAY_RESOLVER: 'RelayResolver',
    RELAY_LIVE_RESOLVER: 'RelayLiveResolver',
    REQUIRED_FIELD: 'RequiredField',
    OBJECT_VALUE: 'ObjectValue',
    OPERATION: 'Operation',
    REQUEST: 'Request',
    ROOT_ARGUMENT: 'RootArgument',
    SCALAR_FIELD: 'ScalarField',
    SCALAR_HANDLE: 'ScalarHandle',
    SPLIT_OPERATION: 'SplitOperation',
    STREAM: 'Stream',
    TYPE_DISCRIMINATOR: 'TypeDiscriminator',
    UPDATABLE_QUERY: 'UpdatableQuery',
    VARIABLE: 'Variable'
};
module.exports = $3b10581e79368871$var$RelayConcreteNode;

});

parcelRegister("4cAcq", function(module, exports) {
'use strict';
function $30f45cda8287ed78$var$stableCopy(value) {
    if (!value || typeof value !== 'object') return value;
    if (Array.isArray(value)) return value.map($30f45cda8287ed78$var$stableCopy);
    var keys = Object.keys(value).sort();
    var stable = {};
    for(var i = 0; i < keys.length; i++)stable[keys[i]] = $30f45cda8287ed78$var$stableCopy(value[keys[i]]);
    return stable;
}
module.exports = $30f45cda8287ed78$var$stableCopy;

});


parcelRegister("1F1HU", function(module, exports) {
'use strict';
var $135af1cfbcbc2887$var$CONNECTION_CALLS = {
    after: true,
    before: true,
    find: true,
    first: true,
    last: true,
    surrounds: true
};
var $135af1cfbcbc2887$var$config = {
    CURSOR: 'cursor',
    EDGES: 'edges',
    END_CURSOR: 'endCursor',
    HAS_NEXT_PAGE: 'hasNextPage',
    HAS_PREV_PAGE: 'hasPreviousPage',
    NODE: 'node',
    PAGE_INFO_TYPE: 'PageInfo',
    PAGE_INFO: 'pageInfo',
    START_CURSOR: 'startCursor'
};
var $135af1cfbcbc2887$var$ConnectionInterface = {
    inject: function inject(newConfig) {
        $135af1cfbcbc2887$var$config = newConfig;
    },
    get: function get() {
        return $135af1cfbcbc2887$var$config;
    },
    isConnectionCall: function isConnectionCall(call) {
        return $135af1cfbcbc2887$var$CONNECTION_CALLS.hasOwnProperty(call.name);
    }
};
module.exports = $135af1cfbcbc2887$var$ConnectionInterface;

});

parcelRegister("dH6ue", function(module, exports) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ 'use strict';

var $geetR = parcelRequire("geetR");
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ function $9f84529ca7fd2258$var$printWarning(format) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function() {
        return args[argIndex++];
    });
    if (typeof console !== 'undefined') console.error(message);
    try {
        // --- Welcome to debugging React ---
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
    } catch (x) {}
}
var $9f84529ca7fd2258$var$warning = $geetR;
module.exports = $9f84529ca7fd2258$var$warning;

});
parcelRegister("geetR", function(module, exports) {
"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ function $bd092fb30e366bea$var$makeEmptyFunction(arg) {
    return function() {
        return arg;
    };
}
/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */ var $bd092fb30e366bea$var$emptyFunction = function emptyFunction() {};
$bd092fb30e366bea$var$emptyFunction.thatReturns = $bd092fb30e366bea$var$makeEmptyFunction;
$bd092fb30e366bea$var$emptyFunction.thatReturnsFalse = $bd092fb30e366bea$var$makeEmptyFunction(false);
$bd092fb30e366bea$var$emptyFunction.thatReturnsTrue = $bd092fb30e366bea$var$makeEmptyFunction(true);
$bd092fb30e366bea$var$emptyFunction.thatReturnsNull = $bd092fb30e366bea$var$makeEmptyFunction(null);
$bd092fb30e366bea$var$emptyFunction.thatReturnsThis = function() {
    return this;
};
$bd092fb30e366bea$var$emptyFunction.thatReturnsArgument = function(arg) {
    return arg;
};
module.exports = $bd092fb30e366bea$var$emptyFunction;

});



parcelRegister("aogIg", function(module, exports) {
'use strict';

var $7Wmh0 = parcelRequire("7Wmh0");
var $79091c19b94289e4$var$_interopRequireDefault = $7Wmh0.default;

var $79091c19b94289e4$var$_createForOfIteratorHelper2 = $79091c19b94289e4$var$_interopRequireDefault((parcelRequire("9CLQ8")));

var $fGjVc = parcelRequire("fGjVc");

var $1F1HU = parcelRequire("1F1HU");

var $423Vm = parcelRequire("423Vm");
parcelRequire("dH6ue");
var $79091c19b94289e4$var$DeleteRecordHandler = {
    update: function update(store, payload) {
        var record = store.get(payload.dataID);
        if (record != null) {
            var idOrIds = record.getValue(payload.fieldKey);
            if (typeof idOrIds === 'string') store["delete"](idOrIds);
            else if (Array.isArray(idOrIds)) idOrIds.forEach(function(id) {
                if (typeof id === 'string') store["delete"](id);
            });
        }
    }
};
var $79091c19b94289e4$var$DeleteEdgeHandler = {
    update: function update(store, payload) {
        var record = store.get(payload.dataID);
        if (record == null) return;
        var connections = payload.handleArgs.connections;
        !(connections != null) && $423Vm(false);
        var idOrIds = record.getValue(payload.fieldKey);
        var idList = Array.isArray(idOrIds) ? idOrIds : [
            idOrIds
        ];
        idList.forEach(function(id) {
            if (typeof id === 'string') {
                var _iterator = (0, $79091c19b94289e4$var$_createForOfIteratorHelper2["default"])(connections), _step;
                try {
                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                        var connectionID = _step.value;
                        var connection = store.get(connectionID);
                        if (connection == null) continue;
                        $fGjVc.deleteNode(connection, id);
                    }
                } catch (err) {
                    _iterator.e(err);
                } finally{
                    _iterator.f();
                }
            }
        });
    }
};
var $79091c19b94289e4$var$AppendEdgeHandler = {
    update: $79091c19b94289e4$var$edgeUpdater($fGjVc.insertEdgeAfter)
};
var $79091c19b94289e4$var$PrependEdgeHandler = {
    update: $79091c19b94289e4$var$edgeUpdater($fGjVc.insertEdgeBefore)
};
var $79091c19b94289e4$var$AppendNodeHandler = {
    update: $79091c19b94289e4$var$nodeUpdater($fGjVc.insertEdgeAfter)
};
var $79091c19b94289e4$var$PrependNodeHandler = {
    update: $79091c19b94289e4$var$nodeUpdater($fGjVc.insertEdgeBefore)
};
function $79091c19b94289e4$var$edgeUpdater(insertFn) {
    return function(store, payload) {
        var _serverEdges;
        var record = store.get(payload.dataID);
        if (record == null) return;
        var connections = payload.handleArgs.connections;
        !(connections != null) && $423Vm(false);
        var singleServerEdge, serverEdges;
        try {
            singleServerEdge = record.getLinkedRecord(payload.fieldKey);
        } catch (_unused) {}
        if (!singleServerEdge) try {
            serverEdges = record.getLinkedRecords(payload.fieldKey);
        } catch (_unused2) {}
        if (singleServerEdge == null && serverEdges == null) return;
        var _ConnectionInterface$ = $1F1HU.get(), NODE = _ConnectionInterface$.NODE, EDGES = _ConnectionInterface$.EDGES;
        var serverEdgeList = (_serverEdges = serverEdges) !== null && _serverEdges !== void 0 ? _serverEdges : [
            singleServerEdge
        ];
        var _iterator2 = (0, $79091c19b94289e4$var$_createForOfIteratorHelper2["default"])(serverEdgeList), _step2;
        try {
            var _loop = function _loop() {
                var serverEdge = _step2.value;
                if (serverEdge == null) return "continue";
                var serverNode = serverEdge.getLinkedRecord('node');
                if (!serverNode) return "continue";
                var serverNodeId = serverNode.getDataID();
                var _iterator3 = (0, $79091c19b94289e4$var$_createForOfIteratorHelper2["default"])(connections), _step3;
                try {
                    for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                        var connectionID = _step3.value;
                        var connection = store.get(connectionID);
                        if (connection == null) continue;
                        var nodeAlreadyExistsInConnection = (_connection$getLinked = connection.getLinkedRecords(EDGES)) === null || _connection$getLinked === void 0 ? void 0 : _connection$getLinked.some(function(edge) {
                            var _edge$getLinkedRecord;
                            return (edge === null || edge === void 0 ? void 0 : (_edge$getLinkedRecord = edge.getLinkedRecord(NODE)) === null || _edge$getLinkedRecord === void 0 ? void 0 : _edge$getLinkedRecord.getDataID()) === serverNodeId;
                        });
                        if (nodeAlreadyExistsInConnection) continue;
                        var clientEdge = $fGjVc.buildConnectionEdge(store, connection, serverEdge);
                        !(clientEdge != null) && $423Vm(false);
                        insertFn(connection, clientEdge);
                    }
                } catch (err) {
                    _iterator3.e(err);
                } finally{
                    _iterator3.f();
                }
            };
            for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                var _connection$getLinked;
                var _ret = _loop();
                if (_ret === "continue") continue;
            }
        } catch (err) {
            _iterator2.e(err);
        } finally{
            _iterator2.f();
        }
    };
}
function $79091c19b94289e4$var$nodeUpdater(insertFn) {
    return function(store, payload) {
        var _serverNodes;
        var record = store.get(payload.dataID);
        if (record == null) return;
        var _payload$handleArgs = payload.handleArgs, connections = _payload$handleArgs.connections, edgeTypeName = _payload$handleArgs.edgeTypeName;
        !(connections != null) && $423Vm(false);
        !(edgeTypeName != null) && $423Vm(false);
        var singleServerNode;
        var serverNodes;
        try {
            singleServerNode = record.getLinkedRecord(payload.fieldKey);
        } catch (_unused3) {}
        if (!singleServerNode) try {
            serverNodes = record.getLinkedRecords(payload.fieldKey);
        } catch (_unused4) {}
        if (singleServerNode == null && serverNodes == null) return;
        var _ConnectionInterface$2 = $1F1HU.get(), NODE = _ConnectionInterface$2.NODE, EDGES = _ConnectionInterface$2.EDGES;
        var serverNodeList = (_serverNodes = serverNodes) !== null && _serverNodes !== void 0 ? _serverNodes : [
            singleServerNode
        ];
        var _iterator4 = (0, $79091c19b94289e4$var$_createForOfIteratorHelper2["default"])(serverNodeList), _step4;
        try {
            var _loop2 = function _loop2() {
                var serverNode = _step4.value;
                if (serverNode == null) return "continue";
                var serverNodeId = serverNode.getDataID();
                var _iterator5 = (0, $79091c19b94289e4$var$_createForOfIteratorHelper2["default"])(connections), _step5;
                try {
                    for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                        var connectionID = _step5.value;
                        var connection = store.get(connectionID);
                        if (connection == null) continue;
                        var nodeAlreadyExistsInConnection = (_connection$getLinked2 = connection.getLinkedRecords(EDGES)) === null || _connection$getLinked2 === void 0 ? void 0 : _connection$getLinked2.some(function(edge) {
                            var _edge$getLinkedRecord2;
                            return (edge === null || edge === void 0 ? void 0 : (_edge$getLinkedRecord2 = edge.getLinkedRecord(NODE)) === null || _edge$getLinkedRecord2 === void 0 ? void 0 : _edge$getLinkedRecord2.getDataID()) === serverNodeId;
                        });
                        if (nodeAlreadyExistsInConnection) continue;
                        var clientEdge = $fGjVc.createEdge(store, connection, serverNode, edgeTypeName);
                        !(clientEdge != null) && $423Vm(false);
                        insertFn(connection, clientEdge);
                    }
                } catch (err) {
                    _iterator5.e(err);
                } finally{
                    _iterator5.f();
                }
            };
            for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                var _connection$getLinked2;
                var _ret2 = _loop2();
                if (_ret2 === "continue") continue;
            }
        } catch (err) {
            _iterator4.e(err);
        } finally{
            _iterator4.f();
        }
    };
}
module.exports = {
    AppendEdgeHandler: $79091c19b94289e4$var$AppendEdgeHandler,
    DeleteRecordHandler: $79091c19b94289e4$var$DeleteRecordHandler,
    PrependEdgeHandler: $79091c19b94289e4$var$PrependEdgeHandler,
    AppendNodeHandler: $79091c19b94289e4$var$AppendNodeHandler,
    PrependNodeHandler: $79091c19b94289e4$var$PrependNodeHandler,
    DeleteEdgeHandler: $79091c19b94289e4$var$DeleteEdgeHandler
};

});

parcelRegister("lIESd", function(module, exports) {
'use strict';

var $fGjVc = parcelRequire("fGjVc");

var $aogIg = parcelRequire("aogIg");

var $423Vm = parcelRequire("423Vm");
function $fcfd69a813b63308$var$RelayDefaultHandlerProvider(handle) {
    switch(handle){
        case 'connection':
            return $fGjVc;
        case 'deleteRecord':
            return $aogIg.DeleteRecordHandler;
        case 'deleteEdge':
            return $aogIg.DeleteEdgeHandler;
        case 'appendEdge':
            return $aogIg.AppendEdgeHandler;
        case 'prependEdge':
            return $aogIg.PrependEdgeHandler;
        case 'appendNode':
            return $aogIg.AppendNodeHandler;
        case 'prependNode':
            return $aogIg.PrependNodeHandler;
    }
    $423Vm(false);
}
module.exports = $fcfd69a813b63308$var$RelayDefaultHandlerProvider;

});

parcelRegister("jlNVv", function(module, exports) {
'use strict';

var $bzkJN = parcelRequire("bzkJN");
var $e166b4dd523280a7$var$getRequest = $bzkJN.getRequest;

var $8Zufv = parcelRequire("8Zufv");

var $l0are = parcelRequire("l0are");
var $e166b4dd523280a7$var$createOperationDescriptor = $l0are.createOperationDescriptor;

var $crrn5 = parcelRequire("crrn5");

var $423Vm = parcelRequire("423Vm");
function $e166b4dd523280a7$var$applyOptimisticMutation(environment, config) {
    !$8Zufv(environment) && $423Vm(false);
    var mutation = $e166b4dd523280a7$var$getRequest(config.mutation);
    if (mutation.params.operationKind !== 'mutation') throw new Error('commitMutation: Expected mutation operation');
    var optimisticUpdater = config.optimisticUpdater;
    var configs = config.configs, optimisticResponse = config.optimisticResponse, variables = config.variables;
    var operation = $e166b4dd523280a7$var$createOperationDescriptor(mutation, variables);
    if (configs) {
        var _RelayDeclarativeMuta = $crrn5.convert(configs, mutation, optimisticUpdater);
        optimisticUpdater = _RelayDeclarativeMuta.optimisticUpdater;
    }
    return environment.applyMutation({
        operation: operation,
        response: optimisticResponse,
        updater: optimisticUpdater
    });
}
module.exports = $e166b4dd523280a7$var$applyOptimisticMutation;

});
parcelRegister("bzkJN", function(module, exports) {
'use strict';

var $54ow8 = parcelRequire("54ow8");

var $423Vm = parcelRequire("423Vm");
parcelRequire("dH6ue");
function $86c30cab6ad939e8$var$graphql(strings) {
    $423Vm(false);
}
function $86c30cab6ad939e8$var$getNode(taggedNode) {
    var node = taggedNode;
    if (typeof node === 'function') node = node();
    else if (node["default"]) node = node["default"];
    return node;
}
function $86c30cab6ad939e8$var$isFragment(node) {
    var fragment = $86c30cab6ad939e8$var$getNode(node);
    return typeof fragment === 'object' && fragment !== null && fragment.kind === $54ow8.FRAGMENT;
}
function $86c30cab6ad939e8$var$isRequest(node) {
    var request = $86c30cab6ad939e8$var$getNode(node);
    return typeof request === 'object' && request !== null && request.kind === $54ow8.REQUEST;
}
function $86c30cab6ad939e8$var$isUpdatableQuery(node) {
    var updatableQuery = $86c30cab6ad939e8$var$getNode(node);
    return typeof updatableQuery === 'object' && updatableQuery !== null && updatableQuery.kind === $54ow8.UPDATABLE_QUERY;
}
function $86c30cab6ad939e8$var$isInlineDataFragment(node) {
    var fragment = $86c30cab6ad939e8$var$getNode(node);
    return typeof fragment === 'object' && fragment !== null && fragment.kind === $54ow8.INLINE_DATA_FRAGMENT;
}
function $86c30cab6ad939e8$var$getFragment(taggedNode) {
    var fragment = $86c30cab6ad939e8$var$getNode(taggedNode);
    !$86c30cab6ad939e8$var$isFragment(fragment) && $423Vm(false);
    return fragment;
}
function $86c30cab6ad939e8$var$getPaginationFragment(taggedNode) {
    var _fragment$metadata;
    var fragment = $86c30cab6ad939e8$var$getFragment(taggedNode);
    var refetch = (_fragment$metadata = fragment.metadata) === null || _fragment$metadata === void 0 ? void 0 : _fragment$metadata.refetch;
    var connection = refetch === null || refetch === void 0 ? void 0 : refetch.connection;
    if (refetch === null || typeof refetch !== 'object' || connection === null || typeof connection !== 'object') return null;
    return fragment;
}
function $86c30cab6ad939e8$var$getRefetchableFragment(taggedNode) {
    var _fragment$metadata2;
    var fragment = $86c30cab6ad939e8$var$getFragment(taggedNode);
    var refetch = (_fragment$metadata2 = fragment.metadata) === null || _fragment$metadata2 === void 0 ? void 0 : _fragment$metadata2.refetch;
    if (refetch === null || typeof refetch !== 'object') return null;
    return fragment;
}
function $86c30cab6ad939e8$var$getRequest(taggedNode) {
    var request = $86c30cab6ad939e8$var$getNode(taggedNode);
    !$86c30cab6ad939e8$var$isRequest(request) && $423Vm(false);
    return request;
}
function $86c30cab6ad939e8$var$getUpdatableQuery(taggedNode) {
    var updatableQuery = $86c30cab6ad939e8$var$getNode(taggedNode);
    !$86c30cab6ad939e8$var$isUpdatableQuery(updatableQuery) && $423Vm(false);
    return updatableQuery;
}
function $86c30cab6ad939e8$var$getInlineDataFragment(taggedNode) {
    var fragment = $86c30cab6ad939e8$var$getNode(taggedNode);
    !$86c30cab6ad939e8$var$isInlineDataFragment(fragment) && $423Vm(false);
    return fragment;
}
module.exports = {
    getFragment: $86c30cab6ad939e8$var$getFragment,
    getNode: $86c30cab6ad939e8$var$getNode,
    getPaginationFragment: $86c30cab6ad939e8$var$getPaginationFragment,
    getRefetchableFragment: $86c30cab6ad939e8$var$getRefetchableFragment,
    getRequest: $86c30cab6ad939e8$var$getRequest,
    getUpdatableQuery: $86c30cab6ad939e8$var$getUpdatableQuery,
    getInlineDataFragment: $86c30cab6ad939e8$var$getInlineDataFragment,
    graphql: $86c30cab6ad939e8$var$graphql,
    isFragment: $86c30cab6ad939e8$var$isFragment,
    isRequest: $86c30cab6ad939e8$var$isRequest,
    isUpdatableQuery: $86c30cab6ad939e8$var$isUpdatableQuery,
    isInlineDataFragment: $86c30cab6ad939e8$var$isInlineDataFragment
};

});

parcelRegister("8Zufv", function(module, exports) {
'use strict';
function $68bb7c1922de71cb$var$isRelayModernEnvironment(environment) {
    return Boolean(environment && environment['@@RelayModernEnvironment']);
}
module.exports = $68bb7c1922de71cb$var$isRelayModernEnvironment;

});

parcelRegister("l0are", function(module, exports) {
'use strict';
parcelRequire("hElRV");

var $70TNW = parcelRequire("70TNW");

var $frIyf = parcelRequire("frIyf");
var $f4a1b1e2561beb9c$var$getOperationVariables = $frIyf.getOperationVariables;

var $g432U = parcelRequire("g432U");
var $f4a1b1e2561beb9c$var$createNormalizationSelector = $g432U.createNormalizationSelector, $f4a1b1e2561beb9c$var$createReaderSelector = $g432U.createReaderSelector;

var $f91UN = parcelRequire("f91UN");
var $f4a1b1e2561beb9c$var$ROOT_ID = $f91UN.ROOT_ID;
function $f4a1b1e2561beb9c$var$createOperationDescriptor(request, variables, cacheConfig) {
    var dataID = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : $f4a1b1e2561beb9c$var$ROOT_ID;
    var operation = request.operation;
    var operationVariables = $f4a1b1e2561beb9c$var$getOperationVariables(operation, request.params.providedVariables, variables);
    var requestDescriptor = $f4a1b1e2561beb9c$var$createRequestDescriptor(request, operationVariables, cacheConfig);
    var operationDescriptor = {
        fragment: $f4a1b1e2561beb9c$var$createReaderSelector(request.fragment, dataID, operationVariables, requestDescriptor),
        request: requestDescriptor,
        root: $f4a1b1e2561beb9c$var$createNormalizationSelector(operation, dataID, operationVariables)
    };
    return operationDescriptor;
}
function $f4a1b1e2561beb9c$var$createRequestDescriptor(request, variables, cacheConfig) {
    var requestDescriptor = {
        identifier: $70TNW(request.params, variables),
        node: request,
        variables: variables,
        cacheConfig: cacheConfig
    };
    return requestDescriptor;
}
module.exports = {
    createOperationDescriptor: $f4a1b1e2561beb9c$var$createOperationDescriptor,
    createRequestDescriptor: $f4a1b1e2561beb9c$var$createRequestDescriptor
};

});
parcelRegister("hElRV", function(module, exports) {
'use strict';
function $cd9722cbb5bd33f0$var$deepFreeze(object) {
    if (!$cd9722cbb5bd33f0$var$shouldBeFrozen(object)) return object;
    Object.freeze(object);
    Object.getOwnPropertyNames(object).forEach(function(name) {
        var property = object[name];
        if (property && typeof property === 'object' && !Object.isFrozen(property)) $cd9722cbb5bd33f0$var$deepFreeze(property);
    });
    return object;
}
function $cd9722cbb5bd33f0$var$shouldBeFrozen(value) {
    return value != null && (Array.isArray(value) || typeof value === 'object' && value.constructor === Object);
}
module.exports = $cd9722cbb5bd33f0$var$deepFreeze;

});

parcelRegister("70TNW", function(module, exports) {
'use strict';

var $4cAcq = parcelRequire("4cAcq");

var $423Vm = parcelRequire("423Vm");
function $51b3d215dec601a9$var$getRequestIdentifier(parameters, variables) {
    var requestID = parameters.cacheID != null ? parameters.cacheID : parameters.id;
    !(requestID != null) && $423Vm(false);
    return requestID + JSON.stringify($4cAcq(variables));
}
module.exports = $51b3d215dec601a9$var$getRequestIdentifier;

});

parcelRegister("frIyf", function(module, exports) {
'use strict';

var $7Wmh0 = parcelRequire("7Wmh0");
var $b3ebef986dcea4d9$var$_interopRequireDefault = $7Wmh0.default;

var $b3ebef986dcea4d9$var$_objectSpread2 = $b3ebef986dcea4d9$var$_interopRequireDefault((parcelRequire("1sB2t")));

var $f91UN = parcelRequire("f91UN");
var $b3ebef986dcea4d9$var$getArgumentValues = $f91UN.getArgumentValues;

var $423Vm = parcelRequire("423Vm");
function $b3ebef986dcea4d9$var$getFragmentVariables(fragment, rootVariables, argumentVariables) {
    if (fragment.argumentDefinitions == null) return argumentVariables;
    var variables;
    fragment.argumentDefinitions.forEach(function(definition) {
        if (argumentVariables.hasOwnProperty(definition.name)) return;
        variables = variables || (0, $b3ebef986dcea4d9$var$_objectSpread2["default"])({}, argumentVariables);
        switch(definition.kind){
            case 'LocalArgument':
                variables[definition.name] = definition.defaultValue;
                break;
            case 'RootArgument':
                if (!rootVariables.hasOwnProperty(definition.name)) {
                    variables[definition.name] = undefined;
                    break;
                }
                variables[definition.name] = rootVariables[definition.name];
                break;
            default:
                definition;
                $423Vm(false);
        }
    });
    return variables || argumentVariables;
}
function $b3ebef986dcea4d9$var$getOperationVariables(operation, providedVariables, variables) {
    var operationVariables = {};
    operation.argumentDefinitions.forEach(function(def) {
        var value = def.defaultValue;
        if (variables[def.name] != null) value = variables[def.name];
        operationVariables[def.name] = value;
    });
    if (providedVariables != null) Object.keys(providedVariables).forEach(function(varName) {
        operationVariables[varName] = providedVariables[varName].get();
    });
    return operationVariables;
}
function $b3ebef986dcea4d9$var$getLocalVariables(currentVariables, argumentDefinitions, args) {
    if (argumentDefinitions == null) return currentVariables;
    var nextVariables = (0, $b3ebef986dcea4d9$var$_objectSpread2["default"])({}, currentVariables);
    var nextArgs = args ? $b3ebef986dcea4d9$var$getArgumentValues(args, currentVariables) : {};
    argumentDefinitions.forEach(function(def) {
        var _nextArgs$def$name;
        var value = (_nextArgs$def$name = nextArgs[def.name]) !== null && _nextArgs$def$name !== void 0 ? _nextArgs$def$name : def.defaultValue;
        nextVariables[def.name] = value;
    });
    return nextVariables;
}
module.exports = {
    getLocalVariables: $b3ebef986dcea4d9$var$getLocalVariables,
    getFragmentVariables: $b3ebef986dcea4d9$var$getFragmentVariables,
    getOperationVariables: $b3ebef986dcea4d9$var$getOperationVariables
};

});

parcelRegister("g432U", function(module, exports) {
'use strict';

var $frIyf = parcelRequire("frIyf");
var $bb1f61f161d71594$var$getFragmentVariables = $frIyf.getFragmentVariables;

var $f91UN = parcelRequire("f91UN");
var $bb1f61f161d71594$var$CLIENT_EDGE_TRAVERSAL_PATH = $f91UN.CLIENT_EDGE_TRAVERSAL_PATH, $bb1f61f161d71594$var$FRAGMENT_OWNER_KEY = $f91UN.FRAGMENT_OWNER_KEY, $bb1f61f161d71594$var$FRAGMENT_POINTER_IS_WITHIN_UNMATCHED_TYPE_REFINEMENT = $f91UN.FRAGMENT_POINTER_IS_WITHIN_UNMATCHED_TYPE_REFINEMENT, $bb1f61f161d71594$var$FRAGMENTS_KEY = $f91UN.FRAGMENTS_KEY, $bb1f61f161d71594$var$ID_KEY = $f91UN.ID_KEY;

var $jT3aJ = parcelRequire("jT3aJ");

var $423Vm = parcelRequire("423Vm");
parcelRequire("dH6ue");
function $bb1f61f161d71594$var$getSingularSelector(fragment, item) {
    !(typeof item === 'object' && item !== null && !Array.isArray(item)) && $423Vm(false);
    var dataID = item[$bb1f61f161d71594$var$ID_KEY];
    var fragments = item[$bb1f61f161d71594$var$FRAGMENTS_KEY];
    var mixedOwner = item[$bb1f61f161d71594$var$FRAGMENT_OWNER_KEY];
    var mixedClientEdgeTraversalPath = item[$bb1f61f161d71594$var$CLIENT_EDGE_TRAVERSAL_PATH];
    if (typeof dataID === 'string' && typeof fragments === 'object' && fragments !== null && typeof fragments[fragment.name] === 'object' && fragments[fragment.name] !== null && typeof mixedOwner === 'object' && mixedOwner !== null && (mixedClientEdgeTraversalPath == null || Array.isArray(mixedClientEdgeTraversalPath))) {
        var owner = mixedOwner;
        var clientEdgeTraversalPath = mixedClientEdgeTraversalPath;
        var argumentVariables = fragments[fragment.name];
        var fragmentVariables = $bb1f61f161d71594$var$getFragmentVariables(fragment, owner.variables, argumentVariables);
        var isWithinUnmatchedTypeRefinement = argumentVariables[$bb1f61f161d71594$var$FRAGMENT_POINTER_IS_WITHIN_UNMATCHED_TYPE_REFINEMENT] === true;
        return $bb1f61f161d71594$var$createReaderSelector(fragment, dataID, fragmentVariables, owner, isWithinUnmatchedTypeRefinement, clientEdgeTraversalPath);
    }
    var stringifiedItem;
    return null;
}
function $bb1f61f161d71594$var$getPluralSelector(fragment, items) {
    var selectors = null;
    items.forEach(function(item, ii) {
        var selector = item != null ? $bb1f61f161d71594$var$getSingularSelector(fragment, item) : null;
        if (selector != null) {
            selectors = selectors || [];
            selectors.push(selector);
        }
    });
    if (selectors == null) return null;
    else return {
        kind: 'PluralReaderSelector',
        selectors: selectors
    };
}
function $bb1f61f161d71594$var$getSelector(fragment, item) {
    if (item == null) return item;
    else if (fragment.metadata && fragment.metadata.plural === true) {
        !Array.isArray(item) && $423Vm(false);
        return $bb1f61f161d71594$var$getPluralSelector(fragment, item);
    } else {
        !!Array.isArray(item) && $423Vm(false);
        return $bb1f61f161d71594$var$getSingularSelector(fragment, item);
    }
}
function $bb1f61f161d71594$var$getSelectorsFromObject(fragments, object) {
    var selectors = {};
    for(var key in fragments)if (fragments.hasOwnProperty(key)) {
        var fragment = fragments[key];
        var item = object[key];
        selectors[key] = $bb1f61f161d71594$var$getSelector(fragment, item);
    }
    return selectors;
}
function $bb1f61f161d71594$var$getDataIDsFromObject(fragments, object) {
    var ids = {};
    for(var key in fragments)if (fragments.hasOwnProperty(key)) {
        var fragment = fragments[key];
        var item = object[key];
        ids[key] = $bb1f61f161d71594$var$getDataIDsFromFragment(fragment, item);
    }
    return ids;
}
function $bb1f61f161d71594$var$getDataIDsFromFragment(fragment, item) {
    if (item == null) return item;
    else if (fragment.metadata && fragment.metadata.plural === true) {
        !Array.isArray(item) && $423Vm(false);
        return $bb1f61f161d71594$var$getDataIDs(fragment, item);
    } else {
        !!Array.isArray(item) && $423Vm(false);
        return $bb1f61f161d71594$var$getDataID(fragment, item);
    }
}
function $bb1f61f161d71594$var$getDataIDs(fragment, items) {
    var ids = null;
    items.forEach(function(item) {
        var id = item != null ? $bb1f61f161d71594$var$getDataID(fragment, item) : null;
        if (id != null) {
            ids = ids || [];
            ids.push(id);
        }
    });
    return ids;
}
function $bb1f61f161d71594$var$getDataID(fragment, item) {
    !(typeof item === 'object' && item !== null && !Array.isArray(item)) && $423Vm(false);
    var dataID = item[$bb1f61f161d71594$var$ID_KEY];
    if (typeof dataID === 'string') return dataID;
    return null;
}
function $bb1f61f161d71594$var$getVariablesFromObject(fragments, object) {
    var variables = {};
    for(var key in fragments)if (fragments.hasOwnProperty(key)) {
        var fragment = fragments[key];
        var item = object[key];
        var itemVariables = $bb1f61f161d71594$var$getVariablesFromFragment(fragment, item);
        Object.assign(variables, itemVariables);
    }
    return variables;
}
function $bb1f61f161d71594$var$getVariablesFromFragment(fragment, item) {
    var _fragment$metadata;
    if (item == null) return {};
    else if (((_fragment$metadata = fragment.metadata) === null || _fragment$metadata === void 0 ? void 0 : _fragment$metadata.plural) === true) {
        !Array.isArray(item) && $423Vm(false);
        return $bb1f61f161d71594$var$getVariablesFromPluralFragment(fragment, item);
    } else {
        !!Array.isArray(item) && $423Vm(false);
        return $bb1f61f161d71594$var$getVariablesFromSingularFragment(fragment, item) || {};
    }
}
function $bb1f61f161d71594$var$getVariablesFromSingularFragment(fragment, item) {
    var selector = $bb1f61f161d71594$var$getSingularSelector(fragment, item);
    if (!selector) return null;
    return selector.variables;
}
function $bb1f61f161d71594$var$getVariablesFromPluralFragment(fragment, items) {
    var variables = {};
    items.forEach(function(value, ii) {
        if (value != null) {
            var itemVariables = $bb1f61f161d71594$var$getVariablesFromSingularFragment(fragment, value);
            if (itemVariables != null) Object.assign(variables, itemVariables);
        }
    });
    return variables;
}
function $bb1f61f161d71594$var$areEqualSingularSelectors(thisSelector, thatSelector) {
    return thisSelector.dataID === thatSelector.dataID && thisSelector.node === thatSelector.node && $jT3aJ(thisSelector.variables, thatSelector.variables) && $bb1f61f161d71594$var$areEqualOwners(thisSelector.owner, thatSelector.owner) && thisSelector.isWithinUnmatchedTypeRefinement === thatSelector.isWithinUnmatchedTypeRefinement && $bb1f61f161d71594$var$areEqualClientEdgeTraversalPaths(thisSelector.clientEdgeTraversalPath, thatSelector.clientEdgeTraversalPath);
}
function $bb1f61f161d71594$var$areEqualOwners(thisOwner, thatOwner) {
    if (thisOwner === thatOwner) return true;
    else return thisOwner.identifier === thatOwner.identifier && $jT3aJ(thisOwner.cacheConfig, thatOwner.cacheConfig);
}
function $bb1f61f161d71594$var$areEqualClientEdgeTraversalPaths(thisPath, thatPath) {
    if (thisPath === thatPath) return true;
    if (thisPath == null || thatPath == null || thisPath.length !== thatPath.length) return false;
    var idx = thisPath.length;
    while(idx--){
        var a = thisPath[idx];
        var b = thatPath[idx];
        if (a === b) continue;
        if (a == null || b == null || a.clientEdgeDestinationID !== b.clientEdgeDestinationID || a.readerClientEdge !== b.readerClientEdge) return false;
    }
    return true;
}
function $bb1f61f161d71594$var$areEqualSelectors(a, b) {
    if (a === b) return true;
    else if (a == null) return b == null;
    else if (b == null) return a == null;
    else if (a.kind === 'SingularReaderSelector' && b.kind === 'SingularReaderSelector') return $bb1f61f161d71594$var$areEqualSingularSelectors(a, b);
    else if (a.kind === 'PluralReaderSelector' && b.kind === 'PluralReaderSelector') return a.selectors.length === b.selectors.length && a.selectors.every(function(s, i) {
        return $bb1f61f161d71594$var$areEqualSingularSelectors(s, b.selectors[i]);
    });
    else return false;
}
function $bb1f61f161d71594$var$createReaderSelector(fragment, dataID, variables, request) {
    var isWithinUnmatchedTypeRefinement = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
    var clientEdgeTraversalPath = arguments.length > 5 ? arguments[5] : undefined;
    return {
        kind: 'SingularReaderSelector',
        dataID: dataID,
        isWithinUnmatchedTypeRefinement: isWithinUnmatchedTypeRefinement,
        clientEdgeTraversalPath: clientEdgeTraversalPath !== null && clientEdgeTraversalPath !== void 0 ? clientEdgeTraversalPath : null,
        node: fragment,
        variables: variables,
        owner: request
    };
}
function $bb1f61f161d71594$var$createNormalizationSelector(node, dataID, variables) {
    return {
        dataID: dataID,
        node: node,
        variables: variables
    };
}
module.exports = {
    areEqualSelectors: $bb1f61f161d71594$var$areEqualSelectors,
    createReaderSelector: $bb1f61f161d71594$var$createReaderSelector,
    createNormalizationSelector: $bb1f61f161d71594$var$createNormalizationSelector,
    getDataIDsFromFragment: $bb1f61f161d71594$var$getDataIDsFromFragment,
    getDataIDsFromObject: $bb1f61f161d71594$var$getDataIDsFromObject,
    getSingularSelector: $bb1f61f161d71594$var$getSingularSelector,
    getPluralSelector: $bb1f61f161d71594$var$getPluralSelector,
    getSelector: $bb1f61f161d71594$var$getSelector,
    getSelectorsFromObject: $bb1f61f161d71594$var$getSelectorsFromObject,
    getVariablesFromSingularFragment: $bb1f61f161d71594$var$getVariablesFromSingularFragment,
    getVariablesFromPluralFragment: $bb1f61f161d71594$var$getVariablesFromPluralFragment,
    getVariablesFromFragment: $bb1f61f161d71594$var$getVariablesFromFragment,
    getVariablesFromObject: $bb1f61f161d71594$var$getVariablesFromObject
};

});
parcelRegister("jT3aJ", function(module, exports) {
"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ var $e7a59d4ebc25735e$var$aStackPool = [];
var $e7a59d4ebc25735e$var$bStackPool = [];
/**
 * Checks if two values are equal. Values may be primitives, arrays, or objects.
 * Returns true if both arguments have the same keys and values.
 *
 * @see http://underscorejs.org
 * @copyright 2009-2013 Jeremy Ashkenas, DocumentCloud Inc.
 * @license MIT
 */ function $e7a59d4ebc25735e$var$areEqual(a, b) {
    var aStack = $e7a59d4ebc25735e$var$aStackPool.length ? $e7a59d4ebc25735e$var$aStackPool.pop() : [];
    var bStack = $e7a59d4ebc25735e$var$bStackPool.length ? $e7a59d4ebc25735e$var$bStackPool.pop() : [];
    var result = $e7a59d4ebc25735e$var$eq(a, b, aStack, bStack);
    aStack.length = 0;
    bStack.length = 0;
    $e7a59d4ebc25735e$var$aStackPool.push(aStack);
    $e7a59d4ebc25735e$var$bStackPool.push(bStack);
    return result;
}
function $e7a59d4ebc25735e$var$eq(a, b, aStack, bStack) {
    if (a === b) // Identical objects are equal. `0 === -0`, but they aren't identical.
    return a !== 0 || 1 / a == 1 / b;
    if (a == null || b == null) // a or b can be `null` or `undefined`
    return false;
    if (typeof a != 'object' || typeof b != 'object') return false;
    var objToStr = Object.prototype.toString;
    var className = objToStr.call(a);
    if (className != objToStr.call(b)) return false;
    switch(className){
        case '[object String]':
            return a == String(b);
        case '[object Number]':
            return isNaN(a) || isNaN(b) ? false : a == Number(b);
        case '[object Date]':
        case '[object Boolean]':
            return +a == +b;
        case '[object RegExp]':
            return a.source == b.source && a.global == b.global && a.multiline == b.multiline && a.ignoreCase == b.ignoreCase;
    } // Assume equality for cyclic structures.
    var length = aStack.length;
    while(length--){
        if (aStack[length] == a) return bStack[length] == b;
    }
    aStack.push(a);
    bStack.push(b);
    var size = 0; // Recursively compare objects and arrays.
    if (className === '[object Array]') {
        size = a.length;
        if (size !== b.length) return false;
         // Deep compare the contents, ignoring non-numeric properties.
        while(size--){
            if (!$e7a59d4ebc25735e$var$eq(a[size], b[size], aStack, bStack)) return false;
        }
    } else {
        if (a.constructor !== b.constructor) return false;
        if (a.hasOwnProperty('valueOf') && b.hasOwnProperty('valueOf')) return a.valueOf() == b.valueOf();
        var keys = Object.keys(a);
        if (keys.length != Object.keys(b).length) return false;
        for(var i = 0; i < keys.length; i++){
            if (!$e7a59d4ebc25735e$var$eq(a[keys[i]], b[keys[i]], aStack, bStack)) return false;
        }
    }
    aStack.pop();
    bStack.pop();
    return true;
}
module.exports = $e7a59d4ebc25735e$var$areEqual;

});



parcelRegister("crrn5", function(module, exports) {
'use strict';

var $7Wmh0 = parcelRequire("7Wmh0");
var $90ed3d0d2216bff9$var$_interopRequireDefault = $7Wmh0.default;

var $90ed3d0d2216bff9$var$_createForOfIteratorHelper2 = $90ed3d0d2216bff9$var$_interopRequireDefault((parcelRequire("9CLQ8")));

var $fGjVc = parcelRequire("fGjVc");
parcelRequire("dH6ue");
var $90ed3d0d2216bff9$var$MutationTypes = Object.freeze({
    RANGE_ADD: 'RANGE_ADD',
    RANGE_DELETE: 'RANGE_DELETE',
    NODE_DELETE: 'NODE_DELETE'
});
var $90ed3d0d2216bff9$var$RangeOperations = Object.freeze({
    APPEND: 'append',
    PREPEND: 'prepend'
});
function $90ed3d0d2216bff9$var$convert(configs, request, optimisticUpdater, updater) {
    var configOptimisticUpdates = optimisticUpdater ? [
        optimisticUpdater
    ] : [];
    var configUpdates = updater ? [
        updater
    ] : [];
    configs.forEach(function(config) {
        switch(config.type){
            case 'NODE_DELETE':
                var nodeDeleteResult = $90ed3d0d2216bff9$var$nodeDelete(config, request);
                if (nodeDeleteResult) {
                    configOptimisticUpdates.push(nodeDeleteResult);
                    configUpdates.push(nodeDeleteResult);
                }
                break;
            case 'RANGE_ADD':
                var rangeAddResult = $90ed3d0d2216bff9$var$rangeAdd(config, request);
                if (rangeAddResult) {
                    configOptimisticUpdates.push(rangeAddResult);
                    configUpdates.push(rangeAddResult);
                }
                break;
            case 'RANGE_DELETE':
                var rangeDeleteResult = $90ed3d0d2216bff9$var$rangeDelete(config, request);
                if (rangeDeleteResult) {
                    configOptimisticUpdates.push(rangeDeleteResult);
                    configUpdates.push(rangeDeleteResult);
                }
                break;
        }
    });
    return {
        optimisticUpdater: function optimisticUpdater(store, data) {
            configOptimisticUpdates.forEach(function(eachOptimisticUpdater) {
                eachOptimisticUpdater(store, data);
            });
        },
        updater: function updater(store, data) {
            configUpdates.forEach(function(eachUpdater) {
                eachUpdater(store, data);
            });
        }
    };
}
function $90ed3d0d2216bff9$var$nodeDelete(config, request) {
    var deletedIDFieldName = config.deletedIDFieldName;
    var rootField = $90ed3d0d2216bff9$var$getRootField(request);
    if (!rootField) return null;
    return function(store, data) {
        var payload = store.getRootField(rootField);
        if (!payload) return;
        var deleteID = payload.getValue(deletedIDFieldName);
        var deleteIDs = Array.isArray(deleteID) ? deleteID : [
            deleteID
        ];
        deleteIDs.forEach(function(id) {
            if (id && typeof id === 'string') store["delete"](id);
        });
    };
}
function $90ed3d0d2216bff9$var$rangeAdd(config, request) {
    var parentID = config.parentID, connectionInfo = config.connectionInfo, edgeName = config.edgeName;
    if (!parentID) return null;
    var rootField = $90ed3d0d2216bff9$var$getRootField(request);
    if (!connectionInfo || !rootField) return null;
    return function(store, data) {
        var parent = store.get(parentID);
        if (!parent) return;
        var payload = store.getRootField(rootField);
        if (!payload) return;
        var serverEdge = payload.getLinkedRecord(edgeName);
        var _iterator = (0, $90ed3d0d2216bff9$var$_createForOfIteratorHelper2["default"])(connectionInfo), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var info = _step.value;
                if (!serverEdge) continue;
                var connection = $fGjVc.getConnection(parent, info.key, info.filters);
                if (!connection) continue;
                var clientEdge = $fGjVc.buildConnectionEdge(store, connection, serverEdge);
                if (!clientEdge) continue;
                switch(info.rangeBehavior){
                    case 'append':
                        $fGjVc.insertEdgeAfter(connection, clientEdge);
                        break;
                    case 'prepend':
                        $fGjVc.insertEdgeBefore(connection, clientEdge);
                        break;
                    default:
                        break;
                }
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
    };
}
function $90ed3d0d2216bff9$var$rangeDelete(config, request) {
    var parentID = config.parentID, connectionKeys = config.connectionKeys, pathToConnection = config.pathToConnection, deletedIDFieldName = config.deletedIDFieldName;
    if (!parentID) return null;
    var rootField = $90ed3d0d2216bff9$var$getRootField(request);
    if (!rootField) return null;
    return function(store, data) {
        if (!data) return;
        var deleteIDs = [];
        var deletedIDField = data[rootField];
        if (deletedIDField && Array.isArray(deletedIDFieldName)) {
            var _iterator2 = (0, $90ed3d0d2216bff9$var$_createForOfIteratorHelper2["default"])(deletedIDFieldName), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var eachField = _step2.value;
                    if (deletedIDField && typeof deletedIDField === 'object') deletedIDField = deletedIDField[eachField];
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
            if (Array.isArray(deletedIDField)) deletedIDField.forEach(function(idObject) {
                if (idObject && idObject.id && typeof idObject === 'object' && typeof idObject.id === 'string') deleteIDs.push(idObject.id);
            });
            else if (deletedIDField && deletedIDField.id && typeof deletedIDField.id === 'string') deleteIDs.push(deletedIDField.id);
        } else if (deletedIDField && typeof deletedIDFieldName === 'string' && typeof deletedIDField === 'object') {
            deletedIDField = deletedIDField[deletedIDFieldName];
            if (typeof deletedIDField === 'string') deleteIDs.push(deletedIDField);
            else if (Array.isArray(deletedIDField)) deletedIDField.forEach(function(id) {
                if (typeof id === 'string') deleteIDs.push(id);
            });
        }
        $90ed3d0d2216bff9$var$deleteNode(parentID, connectionKeys, pathToConnection, store, deleteIDs);
    };
}
function $90ed3d0d2216bff9$var$deleteNode(parentID, connectionKeys, pathToConnection, store, deleteIDs) {
    var parent = store.get(parentID);
    if (!parent) return;
    if (pathToConnection.length < 2) return;
    var recordProxy = parent;
    for(var i = 1; i < pathToConnection.length - 1; i++)if (recordProxy) recordProxy = recordProxy.getLinkedRecord(pathToConnection[i]);
    if (!connectionKeys || !recordProxy) return;
    var _iterator3 = (0, $90ed3d0d2216bff9$var$_createForOfIteratorHelper2["default"])(connectionKeys), _step3;
    try {
        var _loop = function _loop() {
            var key = _step3.value;
            var connection = $fGjVc.getConnection(recordProxy, key.key, key.filters);
            if (connection) deleteIDs.forEach(function(deleteID) {
                $fGjVc.deleteNode(connection, deleteID);
            });
        };
        for(_iterator3.s(); !(_step3 = _iterator3.n()).done;)_loop();
    } catch (err) {
        _iterator3.e(err);
    } finally{
        _iterator3.f();
    }
}
function $90ed3d0d2216bff9$var$getRootField(request) {
    if (request.fragment.selections && request.fragment.selections.length > 0 && request.fragment.selections[0].kind === 'LinkedField') return request.fragment.selections[0].name;
    return null;
}
module.exports = {
    MutationTypes: $90ed3d0d2216bff9$var$MutationTypes,
    RangeOperations: $90ed3d0d2216bff9$var$RangeOperations,
    convert: $90ed3d0d2216bff9$var$convert
};

});


parcelRegister("17TCW", function(module, exports) {
'use strict';
function $0d21984c269b7c25$var$commitLocalUpdate(environment, updater) {
    environment.commitUpdate(updater);
}
module.exports = $0d21984c269b7c25$var$commitLocalUpdate;

});

parcelRegister("2i2Ws", function(module, exports) {
'use strict';

var $7Wmh0 = parcelRequire("7Wmh0");
var $1aaf8b62e9e180f2$var$_interopRequireDefault = $7Wmh0.default;

var $1aaf8b62e9e180f2$var$_toConsumableArray2 = $1aaf8b62e9e180f2$var$_interopRequireDefault((parcelRequire("gHCmS")));

var $bzkJN = parcelRequire("bzkJN");
var $1aaf8b62e9e180f2$var$getRequest = $bzkJN.getRequest;

var $axs8G = parcelRequire("axs8G");
var $1aaf8b62e9e180f2$var$generateUniqueClientID = $axs8G.generateUniqueClientID;

var $8Zufv = parcelRequire("8Zufv");

var $l0are = parcelRequire("l0are");
var $1aaf8b62e9e180f2$var$createOperationDescriptor = $l0are.createOperationDescriptor;

var $crrn5 = parcelRequire("crrn5");
parcelRequire("3Gv15");

var $423Vm = parcelRequire("423Vm");
parcelRequire("dH6ue");
function $1aaf8b62e9e180f2$var$commitMutation(environment, config) {
    !$8Zufv(environment) && $423Vm(false);
    var mutation = $1aaf8b62e9e180f2$var$getRequest(config.mutation);
    if (mutation.params.operationKind !== 'mutation') throw new Error('commitMutation: Expected mutation operation');
    if (mutation.kind !== 'Request') throw new Error('commitMutation: Expected mutation to be of type request');
    var optimisticResponse = config.optimisticResponse, optimisticUpdater = config.optimisticUpdater, updater = config.updater;
    var configs = config.configs, cacheConfig = config.cacheConfig, onError = config.onError, onUnsubscribe = config.onUnsubscribe, variables = config.variables, uploadables = config.uploadables;
    var operation = $1aaf8b62e9e180f2$var$createOperationDescriptor(mutation, variables, cacheConfig, $1aaf8b62e9e180f2$var$generateUniqueClientID());
    if (typeof optimisticResponse === 'function') optimisticResponse = optimisticResponse();
    if (configs) {
        var _RelayDeclarativeMuta = $crrn5.convert(configs, mutation, optimisticUpdater, updater);
        optimisticUpdater = _RelayDeclarativeMuta.optimisticUpdater;
        updater = _RelayDeclarativeMuta.updater;
    }
    var errors = [];
    var subscription = environment.executeMutation({
        operation: operation,
        optimisticResponse: optimisticResponse,
        optimisticUpdater: optimisticUpdater,
        updater: updater,
        uploadables: uploadables
    }).subscribe({
        next: function next(payload) {
            var _config$onNext;
            if (Array.isArray(payload)) payload.forEach(function(item) {
                if (item.errors) errors.push.apply(errors, (0, $1aaf8b62e9e180f2$var$_toConsumableArray2["default"])(item.errors));
            });
            else if (payload.errors) errors.push.apply(errors, (0, $1aaf8b62e9e180f2$var$_toConsumableArray2["default"])(payload.errors));
            (_config$onNext = config.onNext) === null || _config$onNext === void 0 || _config$onNext.call(config);
        },
        complete: function complete() {
            var onCompleted = config.onCompleted;
            if (onCompleted) {
                var snapshot = environment.lookup(operation.fragment);
                onCompleted(snapshot.data, errors.length !== 0 ? errors : null);
            }
        },
        error: onError,
        unsubscribe: onUnsubscribe
    });
    return {
        dispose: subscription.unsubscribe
    };
}
module.exports = $1aaf8b62e9e180f2$var$commitMutation;

});
parcelRegister("3Gv15", function(module, exports) {
'use strict';

var $7Wmh0 = parcelRequire("7Wmh0");
var $2aed5a9598bc1e8b$var$_interopRequireDefault = $7Wmh0.default;

var $2aed5a9598bc1e8b$var$_objectSpread2 = $2aed5a9598bc1e8b$var$_interopRequireDefault((parcelRequire("1sB2t")));

var $54ow8 = parcelRequire("54ow8");
var $2aed5a9598bc1e8b$var$ACTOR_CHANGE = $54ow8.ACTOR_CHANGE, $2aed5a9598bc1e8b$var$CLIENT_COMPONENT = $54ow8.CLIENT_COMPONENT, $2aed5a9598bc1e8b$var$CLIENT_EDGE_TO_CLIENT_OBJECT = $54ow8.CLIENT_EDGE_TO_CLIENT_OBJECT, $2aed5a9598bc1e8b$var$CLIENT_EXTENSION = $54ow8.CLIENT_EXTENSION, $2aed5a9598bc1e8b$var$CONDITION = $54ow8.CONDITION, $2aed5a9598bc1e8b$var$DEFER = $54ow8.DEFER, $2aed5a9598bc1e8b$var$FRAGMENT_SPREAD = $54ow8.FRAGMENT_SPREAD, $2aed5a9598bc1e8b$var$INLINE_FRAGMENT = $54ow8.INLINE_FRAGMENT, $2aed5a9598bc1e8b$var$LINKED_FIELD = $54ow8.LINKED_FIELD, $2aed5a9598bc1e8b$var$LINKED_HANDLE = $54ow8.LINKED_HANDLE, $2aed5a9598bc1e8b$var$MODULE_IMPORT = $54ow8.MODULE_IMPORT, $2aed5a9598bc1e8b$var$RELAY_LIVE_RESOLVER = $54ow8.RELAY_LIVE_RESOLVER, $2aed5a9598bc1e8b$var$RELAY_RESOLVER = $54ow8.RELAY_RESOLVER, $2aed5a9598bc1e8b$var$SCALAR_FIELD = $54ow8.SCALAR_FIELD, $2aed5a9598bc1e8b$var$SCALAR_HANDLE = $54ow8.SCALAR_HANDLE, $2aed5a9598bc1e8b$var$STREAM = $54ow8.STREAM, $2aed5a9598bc1e8b$var$TYPE_DISCRIMINATOR = $54ow8.TYPE_DISCRIMINATOR;
parcelRequire("dH6ue");
var $2aed5a9598bc1e8b$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $2aed5a9598bc1e8b$var$validateMutation = function validateMutation() {};
var $2aed5a9598bc1e8b$var$addFieldToDiff, $2aed5a9598bc1e8b$var$validateSelections, $2aed5a9598bc1e8b$var$validateSelection, $2aed5a9598bc1e8b$var$validateModuleImport, $2aed5a9598bc1e8b$var$validateAbstractKey, $2aed5a9598bc1e8b$var$validateField, $2aed5a9598bc1e8b$var$validateOptimisticResponse;
module.exports = $2aed5a9598bc1e8b$var$validateMutation;

});


parcelRegister("ixllC", function(module, exports) {
'use strict';

var $bVKeR = parcelRequire("bVKeR");

var $5kuby = parcelRequire("5kuby");
var $d7ebde41b4f3d49f$var$convertFetch = $5kuby.convertFetch;

var $423Vm = parcelRequire("423Vm");
function $d7ebde41b4f3d49f$var$create(fetchFn, subscribe) {
    var observeFetch = $d7ebde41b4f3d49f$var$convertFetch(fetchFn);
    function execute(request, variables, cacheConfig, uploadables, logRequestInfo) {
        var operationVariables = $bVKeR(variables, request.providedVariables);
        if (request.operationKind === 'subscription') {
            !subscribe && $423Vm(false);
            !!uploadables && $423Vm(false);
            return subscribe(request, operationVariables, cacheConfig);
        }
        var pollInterval = cacheConfig.poll;
        if (pollInterval != null) {
            !!uploadables && $423Vm(false);
            return observeFetch(request, operationVariables, {
                force: true
            }).poll(pollInterval);
        }
        return observeFetch(request, operationVariables, cacheConfig, uploadables, logRequestInfo);
    }
    return {
        execute: execute
    };
}
module.exports = {
    create: $d7ebde41b4f3d49f$var$create
};

});
parcelRegister("bVKeR", function(module, exports) {
'use strict';
parcelRequire("jT3aJ");
parcelRequire("dH6ue");
var $8af8e29af38e5d6a$var$WEAKMAP_SUPPORTED = typeof WeakMap === 'function';
var $8af8e29af38e5d6a$var$debugCache = $8af8e29af38e5d6a$var$WEAKMAP_SUPPORTED ? new WeakMap() : new Map();
function $8af8e29af38e5d6a$var$withProvidedVariables(userSuppliedVariables, providedVariables) {
    if (providedVariables != null) {
        var operationVariables = {};
        Object.assign(operationVariables, userSuppliedVariables);
        Object.keys(providedVariables).forEach(function(varName) {
            var providerFunction = providedVariables[varName].get;
            var providerResult = providerFunction();
            if (!$8af8e29af38e5d6a$var$debugCache.has(providerFunction)) {
                $8af8e29af38e5d6a$var$debugCache.set(providerFunction, providerResult);
                operationVariables[varName] = providerResult;
            } else {
                var cachedResult = $8af8e29af38e5d6a$var$debugCache.get(providerFunction);
                operationVariables[varName] = cachedResult;
            }
        });
        return operationVariables;
    } else return userSuppliedVariables;
}
$8af8e29af38e5d6a$var$withProvidedVariables.tests_only_resetDebugCache = undefined;
module.exports = $8af8e29af38e5d6a$var$withProvidedVariables;

});

parcelRegister("5kuby", function(module, exports) {
'use strict';

var $5k1AH = parcelRequire("5k1AH");
function $3e163c344943c019$var$convertFetch(fn) {
    return function fetch(request, variables, cacheConfig, uploadables, logRequestInfo) {
        var result = fn(request, variables, cacheConfig, uploadables, logRequestInfo);
        if (result instanceof Error) return $5k1AH.create(function(sink) {
            return sink.error(result);
        });
        return $5k1AH.from(result);
    };
}
module.exports = {
    convertFetch: $3e163c344943c019$var$convertFetch
};

});
parcelRegister("5k1AH", function(module, exports) {
'use strict';

var $fbhid = parcelRequire("fbhid");
var $3e000df0b7bdee41$var$hostReportError = $3e000df0b7bdee41$var$swallowError;
var $3e000df0b7bdee41$var$RelayObservable = /*#__PURE__*/ function() {
    RelayObservable.create = function create(source) {
        return new RelayObservable(source);
    };
    function RelayObservable(source) {
        this._source = source;
    }
    RelayObservable.onUnhandledError = function onUnhandledError(callback) {
        $3e000df0b7bdee41$var$hostReportError = callback;
    };
    RelayObservable.from = function from(obj) {
        return $3e000df0b7bdee41$var$isObservable(obj) ? $3e000df0b7bdee41$var$fromObservable(obj) : $fbhid(obj) ? $3e000df0b7bdee41$var$fromPromise(obj) : $3e000df0b7bdee41$var$fromValue(obj);
    };
    var _proto = RelayObservable.prototype;
    _proto["catch"] = function _catch(fn) {
        var _this = this;
        return RelayObservable.create(function(sink) {
            var subscription;
            _this.subscribe({
                start: function start(sub) {
                    subscription = sub;
                },
                next: sink.next,
                complete: sink.complete,
                error: function error(_error2) {
                    try {
                        fn(_error2).subscribe({
                            start: function start(sub) {
                                subscription = sub;
                            },
                            next: sink.next,
                            complete: sink.complete,
                            error: sink.error
                        });
                    } catch (error2) {
                        sink.error(error2, true);
                    }
                }
            });
            return function() {
                return subscription.unsubscribe();
            };
        });
    };
    _proto.concat = function concat(next) {
        var _this2 = this;
        return RelayObservable.create(function(sink) {
            var current;
            _this2.subscribe({
                start: function start(subscription) {
                    current = subscription;
                },
                next: sink.next,
                error: sink.error,
                complete: function complete() {
                    current = next.subscribe(sink);
                }
            });
            return function() {
                current && current.unsubscribe();
            };
        });
    };
    _proto["do"] = function _do(observer) {
        var _this3 = this;
        return RelayObservable.create(function(sink) {
            var both = function both(action) {
                return function() {
                    try {
                        observer[action] && observer[action].apply(observer, arguments);
                    } catch (error) {
                        $3e000df0b7bdee41$var$hostReportError(error, true);
                    }
                    sink[action] && sink[action].apply(sink, arguments);
                };
            };
            return _this3.subscribe({
                start: both('start'),
                next: both('next'),
                error: both('error'),
                complete: both('complete'),
                unsubscribe: both('unsubscribe')
            });
        });
    };
    _proto["finally"] = function _finally(fn) {
        var _this4 = this;
        return RelayObservable.create(function(sink) {
            var subscription = _this4.subscribe(sink);
            return function() {
                subscription.unsubscribe();
                fn();
            };
        });
    };
    _proto.ifEmpty = function ifEmpty(alternate) {
        var _this5 = this;
        return RelayObservable.create(function(sink) {
            var hasValue = false;
            var current;
            current = _this5.subscribe({
                next: function next(value) {
                    hasValue = true;
                    sink.next(value);
                },
                error: sink.error,
                complete: function complete() {
                    if (hasValue) sink.complete();
                    else current = alternate.subscribe(sink);
                }
            });
            return function() {
                current && current.unsubscribe();
            };
        });
    };
    _proto.subscribe = function subscribe(observer) {
        return $3e000df0b7bdee41$var$_subscribe(this._source, observer);
    };
    _proto.map = function map(fn) {
        var _this6 = this;
        return RelayObservable.create(function(sink) {
            var subscription = _this6.subscribe({
                complete: sink.complete,
                error: sink.error,
                next: function next(value) {
                    try {
                        var mapValue = fn(value);
                        sink.next(mapValue);
                    } catch (error) {
                        sink.error(error, true);
                    }
                }
            });
            return function() {
                subscription.unsubscribe();
            };
        });
    };
    _proto.mergeMap = function mergeMap(fn) {
        var _this7 = this;
        return RelayObservable.create(function(sink) {
            var subscriptions = [];
            function start(subscription) {
                this._sub = subscription;
                subscriptions.push(subscription);
            }
            function complete() {
                subscriptions.splice(subscriptions.indexOf(this._sub), 1);
                if (subscriptions.length === 0) sink.complete();
            }
            _this7.subscribe({
                start: start,
                next: function next(value) {
                    try {
                        if (!sink.closed) RelayObservable.from(fn(value)).subscribe({
                            start: start,
                            next: sink.next,
                            error: sink.error,
                            complete: complete
                        });
                    } catch (error) {
                        sink.error(error, true);
                    }
                },
                error: sink.error,
                complete: complete
            });
            return function() {
                subscriptions.forEach(function(sub) {
                    return sub.unsubscribe();
                });
                subscriptions.length = 0;
            };
        });
    };
    _proto.poll = function poll(pollInterval) {
        var _this8 = this;
        return RelayObservable.create(function(sink) {
            var subscription;
            var timeout;
            var poll = function poll() {
                subscription = _this8.subscribe({
                    next: sink.next,
                    error: sink.error,
                    complete: function complete() {
                        timeout = setTimeout(poll, pollInterval);
                    }
                });
            };
            poll();
            return function() {
                clearTimeout(timeout);
                subscription.unsubscribe();
            };
        });
    };
    _proto.toPromise = function toPromise() {
        var _this9 = this;
        return new Promise(function(resolve, reject) {
            var resolved = false;
            _this9.subscribe({
                next: function next(val) {
                    if (!resolved) {
                        resolved = true;
                        resolve(val);
                    }
                },
                error: reject,
                complete: resolve
            });
        });
    };
    return RelayObservable;
}();
function $3e000df0b7bdee41$var$isObservable(obj) {
    return typeof obj === 'object' && obj !== null && typeof obj.subscribe === 'function';
}
function $3e000df0b7bdee41$var$fromObservable(obj) {
    return obj instanceof $3e000df0b7bdee41$var$RelayObservable ? obj : $3e000df0b7bdee41$var$RelayObservable.create(function(sink) {
        return obj.subscribe(sink);
    });
}
function $3e000df0b7bdee41$var$fromPromise(promise) {
    return $3e000df0b7bdee41$var$RelayObservable.create(function(sink) {
        promise.then(function(value) {
            sink.next(value);
            sink.complete();
        }, sink.error);
    });
}
function $3e000df0b7bdee41$var$fromValue(value) {
    return $3e000df0b7bdee41$var$RelayObservable.create(function(sink) {
        sink.next(value);
        sink.complete();
    });
}
function $3e000df0b7bdee41$var$_subscribe(source, observer) {
    var closed = false;
    var cleanup;
    var withClosed = function withClosed(obj) {
        return Object.defineProperty(obj, 'closed', {
            get: function get() {
                return closed;
            }
        });
    };
    function doCleanup() {
        if (cleanup) {
            if (cleanup.unsubscribe) cleanup.unsubscribe();
            else try {
                cleanup();
            } catch (error) {
                $3e000df0b7bdee41$var$hostReportError(error, true);
            }
            cleanup = undefined;
        }
    }
    var subscription = withClosed({
        unsubscribe: function unsubscribe() {
            if (!closed) {
                closed = true;
                try {
                    observer.unsubscribe && observer.unsubscribe(subscription);
                } catch (error) {
                    $3e000df0b7bdee41$var$hostReportError(error, true);
                } finally{
                    doCleanup();
                }
            }
        }
    });
    try {
        observer.start && observer.start(subscription);
    } catch (error) {
        $3e000df0b7bdee41$var$hostReportError(error, true);
    }
    if (closed) return subscription;
    var sink = withClosed({
        next: function next(value) {
            if (!closed && observer.next) try {
                observer.next(value);
            } catch (error) {
                $3e000df0b7bdee41$var$hostReportError(error, true);
            }
        },
        error: function error(_error3, isUncaughtThrownError) {
            if (closed || !observer.error) {
                closed = true;
                $3e000df0b7bdee41$var$hostReportError(_error3, isUncaughtThrownError || false);
                doCleanup();
            } else {
                closed = true;
                try {
                    observer.error(_error3);
                } catch (error2) {
                    $3e000df0b7bdee41$var$hostReportError(error2, true);
                } finally{
                    doCleanup();
                }
            }
        },
        complete: function complete() {
            if (!closed) {
                closed = true;
                try {
                    observer.complete && observer.complete();
                } catch (error) {
                    $3e000df0b7bdee41$var$hostReportError(error, true);
                } finally{
                    doCleanup();
                }
            }
        }
    });
    try {
        cleanup = source(sink);
    } catch (error) {
        sink.error(error, true);
    }
    if (closed) doCleanup();
    return subscription;
}
function $3e000df0b7bdee41$var$swallowError(_error, _isUncaughtThrownError) {}
module.exports = $3e000df0b7bdee41$var$RelayObservable;

});
parcelRegister("fbhid", function(module, exports) {
'use strict';
function $b0d54c1196b787d5$var$isPromise(p) {
    return p != null && typeof p === 'object' && typeof p.then === 'function';
}
module.exports = $b0d54c1196b787d5$var$isPromise;

});




parcelRegister("fzwni", function(module, exports) {
'use strict';

var $7Wmh0 = parcelRequire("7Wmh0");
var $b5633cdc2ede3c95$var$_interopRequireDefault = $7Wmh0.default;

var $b5633cdc2ede3c95$var$_objectSpread2 = $b5633cdc2ede3c95$var$_interopRequireDefault((parcelRequire("1sB2t")));

var $4cAcq = parcelRequire("4cAcq");

var $423Vm = parcelRequire("423Vm");
var $b5633cdc2ede3c95$var$RelayQueryResponseCache = /*#__PURE__*/ function() {
    function RelayQueryResponseCache(_ref) {
        var size = _ref.size, ttl = _ref.ttl;
        !(size > 0) && $423Vm(false);
        !(ttl > 0) && $423Vm(false);
        this._responses = new Map();
        this._size = size;
        this._ttl = ttl;
    }
    var _proto = RelayQueryResponseCache.prototype;
    _proto.clear = function clear() {
        this._responses.clear();
    };
    _proto.get = function get(queryID, variables) {
        var _this = this;
        var cacheKey = $b5633cdc2ede3c95$var$getCacheKey(queryID, variables);
        this._responses.forEach(function(response, key) {
            if (!$b5633cdc2ede3c95$var$isCurrent(response.fetchTime, _this._ttl)) _this._responses["delete"](key);
        });
        var response = this._responses.get(cacheKey);
        if (response == null) return null;
        if (Array.isArray(response.payload)) return response.payload.map(function(payload) {
            return (0, $b5633cdc2ede3c95$var$_objectSpread2["default"])((0, $b5633cdc2ede3c95$var$_objectSpread2["default"])({}, payload), {}, {
                extensions: (0, $b5633cdc2ede3c95$var$_objectSpread2["default"])((0, $b5633cdc2ede3c95$var$_objectSpread2["default"])({}, payload.extensions), {}, {
                    cacheTimestamp: response.fetchTime
                })
            });
        });
        return (0, $b5633cdc2ede3c95$var$_objectSpread2["default"])((0, $b5633cdc2ede3c95$var$_objectSpread2["default"])({}, response.payload), {}, {
            extensions: (0, $b5633cdc2ede3c95$var$_objectSpread2["default"])((0, $b5633cdc2ede3c95$var$_objectSpread2["default"])({}, response.payload.extensions), {}, {
                cacheTimestamp: response.fetchTime
            })
        });
    };
    _proto.set = function set(queryID, variables, payload) {
        var fetchTime = Date.now();
        var cacheKey = $b5633cdc2ede3c95$var$getCacheKey(queryID, variables);
        this._responses["delete"](cacheKey);
        this._responses.set(cacheKey, {
            fetchTime: fetchTime,
            payload: payload
        });
        if (this._responses.size > this._size) {
            var firstKey = this._responses.keys().next();
            if (!firstKey.done) this._responses["delete"](firstKey.value);
        }
    };
    return RelayQueryResponseCache;
}();
function $b5633cdc2ede3c95$var$getCacheKey(queryID, variables) {
    return JSON.stringify($4cAcq({
        queryID: queryID,
        variables: variables
    }));
}
function $b5633cdc2ede3c95$var$isCurrent(fetchTime, ttl) {
    return fetchTime + ttl >= Date.now();
}
module.exports = $b5633cdc2ede3c95$var$RelayQueryResponseCache;

});

parcelRegister("a0L3N", function(module, exports) {
'use strict';

var $7Wmh0 = parcelRequire("7Wmh0");
var $749e68ab5f36d615$var$_interopRequireDefault = $7Wmh0.default;

var $749e68ab5f36d615$var$_objectSpread2 = $749e68ab5f36d615$var$_interopRequireDefault((parcelRequire("1sB2t")));

var $5k1AH = parcelRequire("5k1AH");

var $l0are = parcelRequire("l0are");
var $749e68ab5f36d615$var$createOperationDescriptor = $l0are.createOperationDescriptor;

var $dWG7x = parcelRequire("dWG7x");

var $6ic0O = parcelRequire("6ic0O");

var $bzkJN = parcelRequire("bzkJN");
var $749e68ab5f36d615$var$getRequest = $bzkJN.getRequest;

var $423Vm = parcelRequire("423Vm");
function $749e68ab5f36d615$var$fetchQuery(environment, query, variables, options) {
    var _options$fetchPolicy;
    var queryNode = $749e68ab5f36d615$var$getRequest(query);
    !(queryNode.params.operationKind === 'query') && $423Vm(false);
    var networkCacheConfig = (0, $749e68ab5f36d615$var$_objectSpread2["default"])({
        force: true
    }, options === null || options === void 0 ? void 0 : options.networkCacheConfig);
    var operation = $749e68ab5f36d615$var$createOperationDescriptor(queryNode, variables, networkCacheConfig);
    var fetchPolicy = (_options$fetchPolicy = options === null || options === void 0 ? void 0 : options.fetchPolicy) !== null && _options$fetchPolicy !== void 0 ? _options$fetchPolicy : 'network-only';
    function readData(snapshot) {
        var _queryNode$fragment$m, _queryNode$fragment$m2;
        $dWG7x(environment, snapshot.missingRequiredFields, snapshot.relayResolverErrors, snapshot.errorResponseFields, (_queryNode$fragment$m = (_queryNode$fragment$m2 = queryNode.fragment.metadata) === null || _queryNode$fragment$m2 === void 0 ? void 0 : _queryNode$fragment$m2.throwOnFieldError) !== null && _queryNode$fragment$m !== void 0 ? _queryNode$fragment$m : false);
        return snapshot.data;
    }
    switch(fetchPolicy){
        case 'network-only':
            return $749e68ab5f36d615$var$getNetworkObservable(environment, operation).map(readData);
        case 'store-or-network':
            if (environment.check(operation).status === 'available') return $5k1AH.from(environment.lookup(operation.fragment)).map(readData);
            return $749e68ab5f36d615$var$getNetworkObservable(environment, operation).map(readData);
        default:
            fetchPolicy;
            throw new Error('fetchQuery: Invalid fetchPolicy ' + fetchPolicy);
    }
}
function $749e68ab5f36d615$var$getNetworkObservable(environment, operation) {
    return $6ic0O.fetchQuery(environment, operation).map(function() {
        return environment.lookup(operation.fragment);
    });
}
module.exports = $749e68ab5f36d615$var$fetchQuery;

});
parcelRegister("dWG7x", function(module, exports) {
'use strict';

var $7Wmh0 = parcelRequire("7Wmh0");
var $a2715d6497c688e7$var$_interopRequireDefault = $7Wmh0.default;

var $a2715d6497c688e7$var$_createForOfIteratorHelper2 = $a2715d6497c688e7$var$_interopRequireDefault((parcelRequire("9CLQ8")));

var $kLcab = parcelRequire("kLcab");

var $a2715d6497c688e7$var$_RelayFeatureFlags = $a2715d6497c688e7$var$_interopRequireDefault((parcelRequire("llkIA")));
function $a2715d6497c688e7$var$handlePotentialSnapshotErrors(environment, missingRequiredFields, relayResolverErrors, errorResponseFields, throwOnFieldError) {
    var _iterator = (0, $a2715d6497c688e7$var$_createForOfIteratorHelper2["default"])(relayResolverErrors), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var resolverError = _step.value;
            environment.relayFieldLogger({
                kind: 'relay_resolver.error',
                owner: resolverError.field.owner,
                fieldPath: resolverError.field.path,
                error: resolverError.error
            });
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    if (relayResolverErrors.length > 0 && ($a2715d6497c688e7$var$_RelayFeatureFlags["default"].ENABLE_FIELD_ERROR_HANDLING_THROW_BY_DEFAULT || throwOnFieldError)) throw new $kLcab.RelayFieldError("Relay: Unexpected resolver exception", relayResolverErrors.map(function(e) {
        return {
            message: e.error.message
        };
    }));
    if (($a2715d6497c688e7$var$_RelayFeatureFlags["default"].ENABLE_FIELD_ERROR_HANDLING || throwOnFieldError) && errorResponseFields != null) {
        if (errorResponseFields != null) {
            var _iterator2 = (0, $a2715d6497c688e7$var$_createForOfIteratorHelper2["default"])(errorResponseFields), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var fieldError = _step2.value;
                    var path = fieldError.path, owner = fieldError.owner, error = fieldError.error;
                    environment.relayFieldLogger({
                        kind: 'relay_field_payload.error',
                        owner: owner,
                        fieldPath: path,
                        error: error
                    });
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
        }
        if ($a2715d6497c688e7$var$_RelayFeatureFlags["default"].ENABLE_FIELD_ERROR_HANDLING_THROW_BY_DEFAULT || throwOnFieldError) throw new $kLcab.RelayFieldError("Relay: Unexpected response payload - this object includes an errors property in which you can access the underlying errors", errorResponseFields.map(function(_ref) {
            var error = _ref.error;
            return error;
        }));
    }
    if (missingRequiredFields != null) switch(missingRequiredFields.action){
        case 'THROW':
            var _missingRequiredField = missingRequiredFields.field, _path = _missingRequiredField.path, _owner = _missingRequiredField.owner;
            environment.relayFieldLogger({
                kind: 'missing_field.throw',
                owner: _owner,
                fieldPath: _path
            });
            throw new Error("Relay: Missing @required value at path '".concat(_path, "' in '").concat(_owner, "'."));
        case 'LOG':
            missingRequiredFields.fields.forEach(function(_ref2) {
                var path = _ref2.path, owner = _ref2.owner;
                environment.relayFieldLogger({
                    kind: 'missing_field.log',
                    owner: owner,
                    fieldPath: path
                });
            });
            break;
        default:
            missingRequiredFields.action;
    }
}
module.exports = $a2715d6497c688e7$var$handlePotentialSnapshotErrors;

});
parcelRegister("kLcab", function(module, exports) {
'use strict';

var $7Wmh0 = parcelRequire("7Wmh0");
var $f1d1a1c8bc5f480e$var$_interopRequireDefault = $7Wmh0.default;

var $f1d1a1c8bc5f480e$var$_objectSpread2 = $f1d1a1c8bc5f480e$var$_interopRequireDefault((parcelRequire("1sB2t")));

var $f1d1a1c8bc5f480e$var$_objectWithoutPropertiesLoose2 = $f1d1a1c8bc5f480e$var$_interopRequireDefault((parcelRequire("h8lLa")));

var $f1d1a1c8bc5f480e$var$_createForOfIteratorHelper2 = $f1d1a1c8bc5f480e$var$_interopRequireDefault((parcelRequire("9CLQ8")));

var $f1d1a1c8bc5f480e$var$_inheritsLoose2 = $f1d1a1c8bc5f480e$var$_interopRequireDefault((parcelRequire("2iule")));

var $f1d1a1c8bc5f480e$var$_wrapNativeSuper2 = $f1d1a1c8bc5f480e$var$_interopRequireDefault((parcelRequire("531MX")));

var $f1d1a1c8bc5f480e$var$_toConsumableArray2 = $f1d1a1c8bc5f480e$var$_interopRequireDefault((parcelRequire("gHCmS")));
var $f1d1a1c8bc5f480e$var$_excluded = [
    "path",
    "locations"
];

var $llkIA = parcelRequire("llkIA");
var $f1d1a1c8bc5f480e$var$SELF = Symbol('$SELF');
var $f1d1a1c8bc5f480e$var$RelayFieldError = /*#__PURE__*/ function(_Error) {
    (0, $f1d1a1c8bc5f480e$var$_inheritsLoose2["default"])(RelayFieldError, _Error);
    function RelayFieldError(message) {
        var _this;
        var errors = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
        _this = _Error.call(this, message) || this;
        _this.name = 'RelayFieldError';
        _this.message = message;
        _this.errors = errors;
        return _this;
    }
    return RelayFieldError;
}(/*#__PURE__*/ (0, $f1d1a1c8bc5f480e$var$_wrapNativeSuper2["default"])(Error));
function $f1d1a1c8bc5f480e$var$buildErrorTrie(errors) {
    if (errors == null) return null;
    if (!$llkIA.ENABLE_FIELD_ERROR_HANDLING) return null;
    var trie = new Map();
    var _iterator = (0, $f1d1a1c8bc5f480e$var$_createForOfIteratorHelper2["default"])(errors), _step;
    try {
        ERRORS: for(_iterator.s(); !(_step = _iterator.n()).done;){
            var _step$value = _step.value, path = _step$value.path, _ = _step$value.locations, error = (0, $f1d1a1c8bc5f480e$var$_objectWithoutPropertiesLoose2["default"])(_step$value, $f1d1a1c8bc5f480e$var$_excluded);
            if (path == null) continue;
            var length = path.length;
            if (length === 0) continue;
            var lastIndex = length - 1;
            var currentTrie = trie;
            for(var index = 0; index < lastIndex; index++){
                var key = path[index];
                var existingValue = currentTrie.get(key);
                if (existingValue instanceof Map) {
                    currentTrie = existingValue;
                    continue;
                }
                var newValue = new Map();
                if (Array.isArray(existingValue)) newValue.set($f1d1a1c8bc5f480e$var$SELF, existingValue);
                currentTrie.set(key, newValue);
                currentTrie = newValue;
            }
            var lastKey = path[lastIndex];
            var container = currentTrie.get(lastKey);
            if (container instanceof Map) {
                currentTrie = container;
                container = currentTrie.get(lastKey);
                lastKey = $f1d1a1c8bc5f480e$var$SELF;
            }
            if (Array.isArray(container)) container.push(error);
            else currentTrie.set(lastKey, [
                error
            ]);
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    return trie;
}
function $f1d1a1c8bc5f480e$var$getErrorsByKey(trie, key) {
    var value = trie.get(key);
    if (value == null) return null;
    if (Array.isArray(value)) return value;
    var errors = [];
    $f1d1a1c8bc5f480e$var$recursivelyCopyErrorsIntoArray(value, errors);
    return errors;
}
function $f1d1a1c8bc5f480e$var$recursivelyCopyErrorsIntoArray(trieOrSet, errors) {
    var _iterator2 = (0, $f1d1a1c8bc5f480e$var$_createForOfIteratorHelper2["default"])(trieOrSet), _step2;
    try {
        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
            var _step2$value = _step2.value, childKey = _step2$value[0], value = _step2$value[1];
            var oldLength = errors.length;
            if (Array.isArray(value)) errors.push.apply(errors, (0, $f1d1a1c8bc5f480e$var$_toConsumableArray2["default"])(value));
            else $f1d1a1c8bc5f480e$var$recursivelyCopyErrorsIntoArray(value, errors);
            if (childKey === $f1d1a1c8bc5f480e$var$SELF) continue;
            var newLength = errors.length;
            for(var index = oldLength; index < newLength; index++){
                var error = errors[index];
                if (error.path == null) errors[index] = (0, $f1d1a1c8bc5f480e$var$_objectSpread2["default"])((0, $f1d1a1c8bc5f480e$var$_objectSpread2["default"])({}, error), {}, {
                    path: [
                        childKey
                    ]
                });
                else error.path.unshift(childKey);
            }
        }
    } catch (err) {
        _iterator2.e(err);
    } finally{
        _iterator2.f();
    }
}
function $f1d1a1c8bc5f480e$var$getNestedErrorTrieByKey(trie, key) {
    var value = trie.get(key);
    if (value instanceof Map) return value;
    return null;
}
module.exports = {
    SELF: $f1d1a1c8bc5f480e$var$SELF,
    buildErrorTrie: $f1d1a1c8bc5f480e$var$buildErrorTrie,
    getNestedErrorTrieByKey: $f1d1a1c8bc5f480e$var$getNestedErrorTrieByKey,
    getErrorsByKey: $f1d1a1c8bc5f480e$var$getErrorsByKey,
    RelayFieldError: $f1d1a1c8bc5f480e$var$RelayFieldError
};

});


parcelRegister("6ic0O", function(module, exports) {
'use strict';

var $5k1AH = parcelRequire("5k1AH");

var $e17WK = parcelRequire("e17WK");

var $423Vm = parcelRequire("423Vm");
var $494dbde224008a65$var$WEAKMAP_SUPPORTED = typeof WeakMap === 'function';
var $494dbde224008a65$var$requestCachesByEnvironment = $494dbde224008a65$var$WEAKMAP_SUPPORTED ? new WeakMap() : new Map();
function $494dbde224008a65$var$fetchQuery(environment, operation) {
    return $494dbde224008a65$var$fetchQueryDeduped(environment, operation.request.identifier, function() {
        return environment.execute({
            operation: operation
        });
    });
}
function $494dbde224008a65$var$fetchQueryDeduped(environment, identifier, fetchFn) {
    return $5k1AH.create(function(sink) {
        var requestCache = $494dbde224008a65$var$getRequestCache(environment);
        var cachedRequest = requestCache.get(identifier);
        if (!cachedRequest) fetchFn()["finally"](function() {
            return requestCache["delete"](identifier);
        }).subscribe({
            start: function start(subscription) {
                cachedRequest = {
                    identifier: identifier,
                    subject: new $e17WK(),
                    subjectForInFlightStatus: new $e17WK(),
                    subscription: subscription,
                    promise: null
                };
                requestCache.set(identifier, cachedRequest);
            },
            next: function next(response) {
                var cachedReq = $494dbde224008a65$var$getCachedRequest(requestCache, identifier);
                cachedReq.subject.next(response);
                cachedReq.subjectForInFlightStatus.next(response);
            },
            error: function error(_error) {
                var cachedReq = $494dbde224008a65$var$getCachedRequest(requestCache, identifier);
                cachedReq.subject.error(_error);
                cachedReq.subjectForInFlightStatus.error(_error);
            },
            complete: function complete() {
                var cachedReq = $494dbde224008a65$var$getCachedRequest(requestCache, identifier);
                cachedReq.subject.complete();
                cachedReq.subjectForInFlightStatus.complete();
            },
            unsubscribe: function unsubscribe(subscription) {
                var cachedReq = $494dbde224008a65$var$getCachedRequest(requestCache, identifier);
                cachedReq.subject.unsubscribe();
                cachedReq.subjectForInFlightStatus.unsubscribe();
            }
        });
        !(cachedRequest != null) && $423Vm(false);
        return $494dbde224008a65$var$getObservableForCachedRequest(requestCache, cachedRequest).subscribe(sink);
    });
}
function $494dbde224008a65$var$getObservableForCachedRequest(requestCache, cachedRequest) {
    return $5k1AH.create(function(sink) {
        var subscription = cachedRequest.subject.subscribe(sink);
        return function() {
            subscription.unsubscribe();
            var cachedRequestInstance = requestCache.get(cachedRequest.identifier);
            if (cachedRequestInstance) {
                var requestSubscription = cachedRequestInstance.subscription;
                if (requestSubscription != null && cachedRequestInstance.subject.getObserverCount() === 0) {
                    requestSubscription.unsubscribe();
                    requestCache["delete"](cachedRequest.identifier);
                }
            }
        };
    });
}
function $494dbde224008a65$var$getActiveStatusObservableForCachedRequest(environment, requestCache, cachedRequest) {
    return $5k1AH.create(function(sink) {
        var subscription = cachedRequest.subjectForInFlightStatus.subscribe({
            error: sink.error,
            next: function next(response) {
                if (!environment.isRequestActive(cachedRequest.identifier)) {
                    sink.complete();
                    return;
                }
                sink.next();
            },
            complete: sink.complete,
            unsubscribe: sink.complete
        });
        return function() {
            subscription.unsubscribe();
        };
    });
}
function $494dbde224008a65$var$getPromiseForActiveRequest(environment, request) {
    var requestCache = $494dbde224008a65$var$getRequestCache(environment);
    var cachedRequest = requestCache.get(request.identifier);
    if (!cachedRequest) return null;
    if (!environment.isRequestActive(cachedRequest.identifier)) return null;
    var promise = new Promise(function(resolve, reject) {
        var resolveOnNext = false;
        $494dbde224008a65$var$getActiveStatusObservableForCachedRequest(environment, requestCache, cachedRequest).subscribe({
            complete: resolve,
            error: reject,
            next: function next(response) {
                if (resolveOnNext) resolve(response);
            }
        });
        resolveOnNext = true;
    });
    return promise;
}
function $494dbde224008a65$var$getObservableForActiveRequest(environment, request) {
    var requestCache = $494dbde224008a65$var$getRequestCache(environment);
    var cachedRequest = requestCache.get(request.identifier);
    if (!cachedRequest) return null;
    if (!environment.isRequestActive(cachedRequest.identifier)) return null;
    return $494dbde224008a65$var$getActiveStatusObservableForCachedRequest(environment, requestCache, cachedRequest);
}
function $494dbde224008a65$var$getRequestCache(environment) {
    var cached = $494dbde224008a65$var$requestCachesByEnvironment.get(environment);
    if (cached != null) return cached;
    var requestCache = new Map();
    $494dbde224008a65$var$requestCachesByEnvironment.set(environment, requestCache);
    return requestCache;
}
function $494dbde224008a65$var$getCachedRequest(requestCache, identifier) {
    var cached = requestCache.get(identifier);
    !(cached != null) && $423Vm(false);
    return cached;
}
module.exports = {
    fetchQuery: $494dbde224008a65$var$fetchQuery,
    fetchQueryDeduped: $494dbde224008a65$var$fetchQueryDeduped,
    getPromiseForActiveRequest: $494dbde224008a65$var$getPromiseForActiveRequest,
    getObservableForActiveRequest: $494dbde224008a65$var$getObservableForActiveRequest
};

});
parcelRegister("e17WK", function(module, exports) {
'use strict';

var $7Wmh0 = parcelRequire("7Wmh0");
var $a34752ae79cb9394$var$_interopRequireDefault = $7Wmh0.default;

var $a34752ae79cb9394$var$_createForOfIteratorHelper2 = $a34752ae79cb9394$var$_interopRequireDefault((parcelRequire("9CLQ8")));

var $a34752ae79cb9394$var$_defineProperty2 = $a34752ae79cb9394$var$_interopRequireDefault((parcelRequire("ky4V8")));

var $5k1AH = parcelRequire("5k1AH");

var $423Vm = parcelRequire("423Vm");
var $a34752ae79cb9394$var$RelayReplaySubject = /*#__PURE__*/ function() {
    function RelayReplaySubject() {
        var _this = this;
        (0, $a34752ae79cb9394$var$_defineProperty2["default"])(this, "_complete", false);
        (0, $a34752ae79cb9394$var$_defineProperty2["default"])(this, "_events", []);
        (0, $a34752ae79cb9394$var$_defineProperty2["default"])(this, "_sinks", new Set());
        (0, $a34752ae79cb9394$var$_defineProperty2["default"])(this, "_subscription", []);
        this._observable = $5k1AH.create(function(sink) {
            _this._sinks.add(sink);
            var events = _this._events;
            for(var i = 0; i < events.length; i++){
                if (sink.closed) break;
                var event = events[i];
                switch(event.kind){
                    case 'complete':
                        sink.complete();
                        break;
                    case 'error':
                        sink.error(event.error);
                        break;
                    case 'next':
                        sink.next(event.data);
                        break;
                    default:
                        event.kind;
                        $423Vm(false);
                }
            }
            return function() {
                _this._sinks["delete"](sink);
            };
        });
    }
    var _proto = RelayReplaySubject.prototype;
    _proto.complete = function complete() {
        if (this._complete === true) return;
        this._complete = true;
        this._events.push({
            kind: 'complete'
        });
        this._sinks.forEach(function(sink) {
            return sink.complete();
        });
    };
    _proto.error = function error(_error) {
        if (this._complete === true) return;
        this._complete = true;
        this._events.push({
            kind: 'error',
            error: _error
        });
        this._sinks.forEach(function(sink) {
            return sink.error(_error);
        });
    };
    _proto.next = function next(data) {
        if (this._complete === true) return;
        this._events.push({
            kind: 'next',
            data: data
        });
        this._sinks.forEach(function(sink) {
            return sink.next(data);
        });
    };
    _proto.subscribe = function subscribe(observer) {
        var subscription = this._observable.subscribe(observer);
        this._subscription.push(subscription);
        return subscription;
    };
    _proto.unsubscribe = function unsubscribe() {
        var _iterator = (0, $a34752ae79cb9394$var$_createForOfIteratorHelper2["default"])(this._subscription), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var subscription = _step.value;
                subscription.unsubscribe();
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        this._subscription = [];
    };
    _proto.getObserverCount = function getObserverCount() {
        return this._sinks.size;
    };
    return RelayReplaySubject;
}();
module.exports = $a34752ae79cb9394$var$RelayReplaySubject;

});



parcelRegister("dF0sr", function(module, exports) {
'use strict';

var $l0are = parcelRequire("l0are");
var $9f1f75963335784c$var$createOperationDescriptor = $l0are.createOperationDescriptor;

var $bzkJN = parcelRequire("bzkJN");
var $9f1f75963335784c$var$getRequest = $bzkJN.getRequest;
function $9f1f75963335784c$var$fetchQuery_DEPRECATED(environment, taggedNode, variables, cacheConfig) {
    var query = $9f1f75963335784c$var$getRequest(taggedNode);
    if (query.params.operationKind !== 'query') throw new Error('fetchQuery: Expected query operation');
    var operation = $9f1f75963335784c$var$createOperationDescriptor(query, variables, cacheConfig);
    return environment.execute({
        operation: operation
    }).map(function() {
        return environment.lookup(operation.fragment).data;
    }).toPromise();
}
module.exports = $9f1f75963335784c$var$fetchQuery_DEPRECATED;

});

parcelRegister("fYFnY", function(module, exports) {
'use strict';
var $ba1c8fec0e3f7c5e$var$PreloadableQueryRegistry = /*#__PURE__*/ function() {
    function PreloadableQueryRegistry() {
        this._preloadableQueries = new Map();
        this._callbacks = new Map();
    }
    var _proto = PreloadableQueryRegistry.prototype;
    _proto.set = function set(key, value) {
        this._preloadableQueries.set(key, value);
        var callbacks = this._callbacks.get(key);
        if (callbacks != null) callbacks.forEach(function(cb) {
            try {
                cb(value);
            } catch (e) {
                setTimeout(function() {
                    throw e;
                }, 0);
            }
        });
    };
    _proto.get = function get(key) {
        return this._preloadableQueries.get(key);
    };
    _proto.onLoad = function onLoad(key, callback) {
        var _this$_callbacks$get;
        var callbacks = (_this$_callbacks$get = this._callbacks.get(key)) !== null && _this$_callbacks$get !== void 0 ? _this$_callbacks$get : new Set();
        callbacks.add(callback);
        var dispose = function dispose() {
            callbacks["delete"](callback);
        };
        this._callbacks.set(key, callbacks);
        return {
            dispose: dispose
        };
    };
    _proto.clear = function clear() {
        this._preloadableQueries.clear();
    };
    return PreloadableQueryRegistry;
}();
var $ba1c8fec0e3f7c5e$var$preloadableQueryRegistry = new $ba1c8fec0e3f7c5e$var$PreloadableQueryRegistry();
module.exports = $ba1c8fec0e3f7c5e$var$preloadableQueryRegistry;

});

parcelRegister("eV0s5", function(module, exports) {
'use strict';

var $dhAmW = parcelRequire("dhAmW");
parcelRequire("dH6ue");
function $adc6bd53fd9cd7ce$var$createFragmentSpecResolver(context, containerName, fragments, props, rootIsQueryRenderer, callback) {
    var fragmentNames;
    return new $dhAmW(context, fragments, props, callback, rootIsQueryRenderer);
}
module.exports = $adc6bd53fd9cd7ce$var$createFragmentSpecResolver;

});
parcelRegister("dhAmW", function(module, exports) {
'use strict';

var $7Wmh0 = parcelRequire("7Wmh0");
var $9ab9130ac9d7bb37$var$_interopRequireDefault = $7Wmh0.default;

var $9ab9130ac9d7bb37$var$_objectSpread2 = $9ab9130ac9d7bb37$var$_interopRequireDefault((parcelRequire("1sB2t")));

var $9ab9130ac9d7bb37$var$_defineProperty2 = $9ab9130ac9d7bb37$var$_interopRequireDefault((parcelRequire("ky4V8")));

var $5xF3Q = parcelRequire("5xF3Q");

var $dWG7x = parcelRequire("dWG7x");

var $6c38N = parcelRequire("6c38N");

var $l9X9G = parcelRequire("l9X9G");

var $llkIA = parcelRequire("llkIA");

var $l0are = parcelRequire("l0are");
var $9ab9130ac9d7bb37$var$createRequestDescriptor = $l0are.createRequestDescriptor;

var $g432U = parcelRequire("g432U");
var $9ab9130ac9d7bb37$var$areEqualSelectors = $g432U.areEqualSelectors, $9ab9130ac9d7bb37$var$createReaderSelector = $g432U.createReaderSelector, $9ab9130ac9d7bb37$var$getSelectorsFromObject = $g432U.getSelectorsFromObject;

var $jT3aJ = parcelRequire("jT3aJ");

var $423Vm = parcelRequire("423Vm");
parcelRequire("dH6ue");
var $9ab9130ac9d7bb37$var$RelayModernFragmentSpecResolver = /*#__PURE__*/ function() {
    function RelayModernFragmentSpecResolver(context, fragments, props, callback, rootIsQueryRenderer) {
        var _this = this;
        (0, $9ab9130ac9d7bb37$var$_defineProperty2["default"])(this, "_onChange", function() {
            _this._stale = true;
            if (typeof _this._callback === 'function') _this._callback();
        });
        this._callback = callback;
        this._context = context;
        this._data = {};
        this._fragments = fragments;
        this._props = {};
        this._resolvers = {};
        this._stale = false;
        this._rootIsQueryRenderer = rootIsQueryRenderer;
        this.setProps(props);
    }
    var _proto = RelayModernFragmentSpecResolver.prototype;
    _proto.dispose = function dispose() {
        for(var key in this._resolvers)if (this._resolvers.hasOwnProperty(key)) $9ab9130ac9d7bb37$var$disposeCallback(this._resolvers[key]);
    };
    _proto.resolve = function resolve() {
        if (this._stale) {
            var prevData = this._data;
            var nextData;
            for(var key in this._resolvers)if (this._resolvers.hasOwnProperty(key)) {
                var resolver = this._resolvers[key];
                var prevItem = prevData[key];
                if (resolver) {
                    var nextItem = resolver.resolve();
                    if (nextData || nextItem !== prevItem) {
                        nextData = nextData || (0, $9ab9130ac9d7bb37$var$_objectSpread2["default"])({}, prevData);
                        nextData[key] = nextItem;
                    }
                } else {
                    var prop = this._props[key];
                    var _nextItem = prop !== undefined ? prop : null;
                    if (nextData || !$6c38N(_nextItem, prevItem)) {
                        nextData = nextData || (0, $9ab9130ac9d7bb37$var$_objectSpread2["default"])({}, prevData);
                        nextData[key] = _nextItem;
                    }
                }
            }
            this._data = nextData || prevData;
            this._stale = false;
        }
        return this._data;
    };
    _proto.setCallback = function setCallback(props, callback) {
        this._callback = callback;
        if ($llkIA.ENABLE_CONTAINERS_SUBSCRIBE_ON_COMMIT === true) this.setProps(props);
    };
    _proto.setProps = function setProps(props) {
        this._props = {};
        var ownedSelectors = $9ab9130ac9d7bb37$var$getSelectorsFromObject(this._fragments, props);
        for(var key in ownedSelectors)if (ownedSelectors.hasOwnProperty(key)) {
            var ownedSelector = ownedSelectors[key];
            var resolver = this._resolvers[key];
            if (ownedSelector == null) {
                if (resolver != null) resolver.dispose();
                resolver = null;
            } else if (ownedSelector.kind === 'PluralReaderSelector') {
                if (resolver == null) resolver = new $9ab9130ac9d7bb37$var$SelectorListResolver(this._context.environment, this._rootIsQueryRenderer, ownedSelector, this._callback != null, this._onChange);
                else {
                    !(resolver instanceof $9ab9130ac9d7bb37$var$SelectorListResolver) && $423Vm(false);
                    resolver.setSelector(ownedSelector);
                }
            } else if (resolver == null) resolver = new $9ab9130ac9d7bb37$var$SelectorResolver(this._context.environment, this._rootIsQueryRenderer, ownedSelector, this._callback != null, this._onChange);
            else {
                !(resolver instanceof $9ab9130ac9d7bb37$var$SelectorResolver) && $423Vm(false);
                resolver.setSelector(ownedSelector);
            }
            this._props[key] = props[key];
            this._resolvers[key] = resolver;
        }
        this._stale = true;
    };
    _proto.setVariables = function setVariables(variables, request) {
        for(var key in this._resolvers)if (this._resolvers.hasOwnProperty(key)) {
            var resolver = this._resolvers[key];
            if (resolver) resolver.setVariables(variables, request);
        }
        this._stale = true;
    };
    return RelayModernFragmentSpecResolver;
}();
var $9ab9130ac9d7bb37$var$SelectorResolver = /*#__PURE__*/ function() {
    function SelectorResolver(environment, rootIsQueryRenderer, selector, subscribeOnConstruction, callback) {
        var _this2 = this;
        (0, $9ab9130ac9d7bb37$var$_defineProperty2["default"])(this, "_onChange", function(snapshot) {
            _this2._data = snapshot.data;
            _this2._isMissingData = snapshot.isMissingData;
            _this2._missingRequiredFields = snapshot.missingRequiredFields;
            _this2._errorResponseFields = snapshot.errorResponseFields;
            _this2._relayResolverErrors = snapshot.relayResolverErrors;
            _this2._callback();
        });
        var _snapshot = environment.lookup(selector);
        this._callback = callback;
        this._data = _snapshot.data;
        this._isMissingData = _snapshot.isMissingData;
        this._missingRequiredFields = _snapshot.missingRequiredFields;
        this._errorResponseFields = _snapshot.errorResponseFields;
        this._relayResolverErrors = _snapshot.relayResolverErrors;
        this._environment = environment;
        this._rootIsQueryRenderer = rootIsQueryRenderer;
        this._selector = selector;
        if ($llkIA.ENABLE_CONTAINERS_SUBSCRIBE_ON_COMMIT === true) {
            if (subscribeOnConstruction) this._subscription = environment.subscribe(_snapshot, this._onChange);
        } else this._subscription = environment.subscribe(_snapshot, this._onChange);
    }
    var _proto2 = SelectorResolver.prototype;
    _proto2.dispose = function dispose() {
        if (this._subscription) {
            this._subscription.dispose();
            this._subscription = null;
        }
    };
    _proto2.resolve = function resolve() {
        var _this$_selector$node$, _this$_selector$node$2;
        if (this._isMissingData === true) {
            var pendingOperationsResult = $5xF3Q(this._environment, this._selector.node, this._selector.owner);
            var promise = pendingOperationsResult === null || pendingOperationsResult === void 0 ? void 0 : pendingOperationsResult.promise;
            if (promise != null) {
                if (this._rootIsQueryRenderer) ;
                else {
                    var _pendingOperationsRes;
                    var pendingOperations = (_pendingOperationsRes = pendingOperationsResult === null || pendingOperationsResult === void 0 ? void 0 : pendingOperationsResult.pendingOperations) !== null && _pendingOperationsRes !== void 0 ? _pendingOperationsRes : [];
                    this._environment.__log({
                        name: 'suspense.fragment',
                        data: this._data,
                        fragment: this._selector.node,
                        isRelayHooks: false,
                        isMissingData: this._isMissingData,
                        isPromiseCached: false,
                        pendingOperations: pendingOperations
                    });
                    throw promise;
                }
            }
        }
        $dWG7x(this._environment, this._missingRequiredFields, this._relayResolverErrors, this._errorResponseFields, (_this$_selector$node$ = (_this$_selector$node$2 = this._selector.node.metadata) === null || _this$_selector$node$2 === void 0 ? void 0 : _this$_selector$node$2.throwOnFieldError) !== null && _this$_selector$node$ !== void 0 ? _this$_selector$node$ : false);
        return this._data;
    };
    _proto2.setSelector = function setSelector(selector) {
        if (this._subscription != null && $9ab9130ac9d7bb37$var$areEqualSelectors(selector, this._selector)) return;
        this.dispose();
        var snapshot = this._environment.lookup(selector);
        this._data = $l9X9G(this._data, snapshot.data);
        this._isMissingData = snapshot.isMissingData;
        this._missingRequiredFields = snapshot.missingRequiredFields;
        this._errorResponseFields = snapshot.errorResponseFields;
        this._relayResolverErrors = snapshot.relayResolverErrors;
        this._selector = selector;
        this._subscription = this._environment.subscribe(snapshot, this._onChange);
    };
    _proto2.setVariables = function setVariables(variables, request) {
        if ($jT3aJ(variables, this._selector.variables)) return;
        var requestDescriptor = $9ab9130ac9d7bb37$var$createRequestDescriptor(request, variables);
        var selector = $9ab9130ac9d7bb37$var$createReaderSelector(this._selector.node, this._selector.dataID, variables, requestDescriptor);
        this.setSelector(selector);
    };
    return SelectorResolver;
}();
var $9ab9130ac9d7bb37$var$SelectorListResolver = /*#__PURE__*/ function() {
    function SelectorListResolver(environment, rootIsQueryRenderer, selector, subscribeOnConstruction, callback) {
        var _this3 = this;
        (0, $9ab9130ac9d7bb37$var$_defineProperty2["default"])(this, "_onChange", function(data) {
            _this3._stale = true;
            _this3._callback();
        });
        this._callback = callback;
        this._data = [];
        this._environment = environment;
        this._resolvers = [];
        this._stale = true;
        this._rootIsQueryRenderer = rootIsQueryRenderer;
        this._subscribeOnConstruction = subscribeOnConstruction;
        this.setSelector(selector);
    }
    var _proto3 = SelectorListResolver.prototype;
    _proto3.dispose = function dispose() {
        this._resolvers.forEach($9ab9130ac9d7bb37$var$disposeCallback);
    };
    _proto3.resolve = function resolve() {
        if (this._stale) {
            var prevData = this._data;
            var nextData;
            for(var ii = 0; ii < this._resolvers.length; ii++){
                var prevItem = prevData[ii];
                var nextItem = this._resolvers[ii].resolve();
                if (nextData || nextItem !== prevItem) {
                    nextData = nextData || prevData.slice(0, ii);
                    nextData.push(nextItem);
                }
            }
            if (!nextData && this._resolvers.length !== prevData.length) nextData = prevData.slice(0, this._resolvers.length);
            this._data = nextData || prevData;
            this._stale = false;
        }
        return this._data;
    };
    _proto3.setSelector = function setSelector(selector) {
        var selectors = selector.selectors;
        while(this._resolvers.length > selectors.length){
            var resolver = this._resolvers.pop();
            resolver.dispose();
        }
        for(var ii = 0; ii < selectors.length; ii++)if (ii < this._resolvers.length) this._resolvers[ii].setSelector(selectors[ii]);
        else this._resolvers[ii] = new $9ab9130ac9d7bb37$var$SelectorResolver(this._environment, this._rootIsQueryRenderer, selectors[ii], this._subscribeOnConstruction, this._onChange);
        this._stale = true;
    };
    _proto3.setVariables = function setVariables(variables, request) {
        this._resolvers.forEach(function(resolver) {
            return resolver.setVariables(variables, request);
        });
        this._stale = true;
    };
    return SelectorListResolver;
}();
function $9ab9130ac9d7bb37$var$disposeCallback(disposable) {
    disposable && disposable.dispose();
}
module.exports = $9ab9130ac9d7bb37$var$RelayModernFragmentSpecResolver;

});
parcelRegister("5xF3Q", function(module, exports) {
'use strict';

var $6ic0O = parcelRequire("6ic0O");
var $408fe2ac8e74efcd$var$getPromiseForActiveRequest = $6ic0O.getPromiseForActiveRequest;
function $408fe2ac8e74efcd$var$getPendingOperationsForFragment(environment, fragmentNode, fragmentOwner) {
    var _pendingOperations$ma, _pendingOperations;
    var pendingOperations = [];
    var promise = $408fe2ac8e74efcd$var$getPromiseForActiveRequest(environment, fragmentOwner);
    if (promise != null) pendingOperations = [
        fragmentOwner
    ];
    else {
        var _result$pendingOperat, _result$promise;
        var result = environment.getOperationTracker().getPendingOperationsAffectingOwner(fragmentOwner);
        pendingOperations = (_result$pendingOperat = result === null || result === void 0 ? void 0 : result.pendingOperations) !== null && _result$pendingOperat !== void 0 ? _result$pendingOperat : [];
        promise = (_result$promise = result === null || result === void 0 ? void 0 : result.promise) !== null && _result$promise !== void 0 ? _result$promise : null;
    }
    if (!promise) return null;
    var pendingOperationName = (_pendingOperations$ma = (_pendingOperations = pendingOperations) === null || _pendingOperations === void 0 ? void 0 : _pendingOperations.map(function(op) {
        return op.node.params.name;
    }).join(',')) !== null && _pendingOperations$ma !== void 0 ? _pendingOperations$ma : null;
    if (pendingOperationName == null || pendingOperationName.length === 0) pendingOperationName = 'Unknown pending operation';
    var fragmentName = fragmentNode.name;
    var promiseDisplayName = pendingOperationName === fragmentName ? "Relay(".concat(pendingOperationName, ")") : "Relay(".concat(pendingOperationName, ":").concat(fragmentName, ")");
    promise.displayName = promiseDisplayName;
    environment.__log({
        name: 'pendingoperation.found',
        fragment: fragmentNode,
        fragmentOwner: fragmentOwner,
        pendingOperations: pendingOperations
    });
    return {
        promise: promise,
        pendingOperations: pendingOperations
    };
}
module.exports = $408fe2ac8e74efcd$var$getPendingOperationsForFragment;

});

parcelRegister("6c38N", function(module, exports) {
'use strict';
function $48264cc9cfcf5c0b$var$isScalarAndEqual(valueA, valueB) {
    return valueA === valueB && (valueA === null || typeof valueA !== 'object');
}
module.exports = $48264cc9cfcf5c0b$var$isScalarAndEqual;

});

parcelRegister("l9X9G", function(module, exports) {
'use strict';
function $f678533f1a3ba215$var$recycleNodesInto(prevData, nextData) {
    return $f678533f1a3ba215$var$recycleNodesIntoImpl(prevData, nextData, true);
}
function $f678533f1a3ba215$var$recycleNodesIntoImpl(prevData, nextData, canMutate) {
    if (prevData === nextData || typeof prevData !== 'object' || !prevData || prevData.constructor !== Object && !Array.isArray(prevData) || typeof nextData !== 'object' || !nextData || nextData.constructor !== Object && !Array.isArray(nextData)) return nextData;
    var canRecycle = false;
    var prevArray = Array.isArray(prevData) ? prevData : null;
    var nextArray = Array.isArray(nextData) ? nextData : null;
    if (prevArray && nextArray) {
        var canMutateNext = canMutate && !Object.isFrozen(nextArray);
        canRecycle = nextArray.reduce(function(wasEqual, nextItem, ii) {
            var prevValue = prevArray[ii];
            var nextValue = $f678533f1a3ba215$var$recycleNodesIntoImpl(prevValue, nextItem, canMutateNext);
            if (nextValue !== nextArray[ii] && canMutateNext) nextArray[ii] = nextValue;
            return wasEqual && nextValue === prevArray[ii];
        }, true) && prevArray.length === nextArray.length;
    } else if (!prevArray && !nextArray) {
        var prevObject = prevData;
        var nextObject = nextData;
        var prevKeys = Object.keys(prevObject);
        var nextKeys = Object.keys(nextObject);
        var _canMutateNext = canMutate && !Object.isFrozen(nextObject);
        canRecycle = nextKeys.reduce(function(wasEqual, key) {
            var prevValue = prevObject[key];
            var nextValue = $f678533f1a3ba215$var$recycleNodesIntoImpl(prevValue, nextObject[key], _canMutateNext);
            if (nextValue !== nextObject[key] && _canMutateNext) nextObject[key] = nextValue;
            return wasEqual && nextValue === prevObject[key];
        }, true) && prevKeys.length === nextKeys.length;
    }
    return canRecycle ? prevData : nextData;
}
module.exports = $f678533f1a3ba215$var$recycleNodesInto;

});



parcelRegister("aCt1A", function(module, exports) {
'use strict';

var $423Vm = parcelRequire("423Vm");
var $7bb3f7a59acf129d$var$relayContext;
var $7bb3f7a59acf129d$var$firstReact;
function $7bb3f7a59acf129d$var$createRelayContext(react) {
    if (!$7bb3f7a59acf129d$var$relayContext) {
        $7bb3f7a59acf129d$var$relayContext = react.createContext(null);
        $7bb3f7a59acf129d$var$firstReact = react;
    }
    !(react === $7bb3f7a59acf129d$var$firstReact) && $423Vm(false);
    return $7bb3f7a59acf129d$var$relayContext;
}
module.exports = $7bb3f7a59acf129d$var$createRelayContext;

});

parcelRegister("jyY6u", function(module, exports) {
'use strict';
var $e3dfd09f49fc8227$var$LIVE_RESOLVER_SUSPENSE_SENTINEL = Object.freeze({
    __LIVE_RESOLVER_SUSPENSE_SENTINEL: true
});
function $e3dfd09f49fc8227$var$suspenseSentinel() {
    return $e3dfd09f49fc8227$var$LIVE_RESOLVER_SUSPENSE_SENTINEL;
}
function $e3dfd09f49fc8227$var$isSuspenseSentinel(value) {
    return value === $e3dfd09f49fc8227$var$LIVE_RESOLVER_SUSPENSE_SENTINEL;
}
module.exports = {
    isSuspenseSentinel: $e3dfd09f49fc8227$var$isSuspenseSentinel,
    suspenseSentinel: $e3dfd09f49fc8227$var$suspenseSentinel
};

});

parcelRegister("jd20U", function(module, exports) {
'use strict';

var $7Wmh0 = parcelRequire("7Wmh0");
var $dfc0cb1c9bab694d$var$_interopRequireDefault = $7Wmh0.default;

var $dfc0cb1c9bab694d$var$_objectSpread2 = $dfc0cb1c9bab694d$var$_interopRequireDefault((parcelRequire("1sB2t")));

var $dfc0cb1c9bab694d$var$_RelayModernRecord = $dfc0cb1c9bab694d$var$_interopRequireDefault((parcelRequire("fagih")));

var $dfc0cb1c9bab694d$var$_RelayRecordSource = $dfc0cb1c9bab694d$var$_interopRequireDefault((parcelRequire("7eJdF")));

var $dfc0cb1c9bab694d$var$_RelayResponseNormalizer = $dfc0cb1c9bab694d$var$_interopRequireDefault((parcelRequire("3cbTo")));
function $dfc0cb1c9bab694d$var$normalizeResponse(response, selector, typeName, options) {
    var _response$extensions;
    var data = response.data, errors = response.errors;
    var source = $dfc0cb1c9bab694d$var$_RelayRecordSource["default"].create();
    var record = $dfc0cb1c9bab694d$var$_RelayModernRecord["default"].create(selector.dataID, typeName);
    source.set(selector.dataID, record);
    var relayPayload = $dfc0cb1c9bab694d$var$_RelayResponseNormalizer["default"].normalize(source, selector, data, options, errors);
    return (0, $dfc0cb1c9bab694d$var$_objectSpread2["default"])((0, $dfc0cb1c9bab694d$var$_objectSpread2["default"])({}, relayPayload), {}, {
        isFinal: ((_response$extensions = response.extensions) === null || _response$extensions === void 0 ? void 0 : _response$extensions.is_final) === true
    });
}
module.exports = $dfc0cb1c9bab694d$var$normalizeResponse;

});
parcelRegister("fagih", function(module, exports) {
'use strict';

var $7Wmh0 = parcelRequire("7Wmh0");
var $b0a46dc9d947049c$var$_interopRequireDefault = $7Wmh0.default;

var $b0a46dc9d947049c$var$_defineProperty2 = $b0a46dc9d947049c$var$_interopRequireDefault((parcelRequire("ky4V8")));

var $b0a46dc9d947049c$var$_objectWithoutPropertiesLoose2 = $b0a46dc9d947049c$var$_interopRequireDefault((parcelRequire("h8lLa")));

var $b0a46dc9d947049c$var$_toPropertyKey2 = $b0a46dc9d947049c$var$_interopRequireDefault((parcelRequire("3Wdje")));

var $b0a46dc9d947049c$var$_objectSpread2 = $b0a46dc9d947049c$var$_interopRequireDefault((parcelRequire("1sB2t")));

var $hElRV = parcelRequire("hElRV");

var $axs8G = parcelRequire("axs8G");
var $b0a46dc9d947049c$var$generateClientObjectClientID = $axs8G.generateClientObjectClientID, $b0a46dc9d947049c$var$isClientID = $axs8G.isClientID;

var $jyY6u = parcelRequire("jyY6u");
var $b0a46dc9d947049c$var$isSuspenseSentinel = $jyY6u.isSuspenseSentinel;

var $f91UN = parcelRequire("f91UN");
var $b0a46dc9d947049c$var$ACTOR_IDENTIFIER_KEY = $f91UN.ACTOR_IDENTIFIER_KEY, $b0a46dc9d947049c$var$ERRORS_KEY = $f91UN.ERRORS_KEY, $b0a46dc9d947049c$var$ID_KEY = $f91UN.ID_KEY, $b0a46dc9d947049c$var$INVALIDATED_AT_KEY = $f91UN.INVALIDATED_AT_KEY, $b0a46dc9d947049c$var$REF_KEY = $f91UN.REF_KEY, $b0a46dc9d947049c$var$REFS_KEY = $f91UN.REFS_KEY, $b0a46dc9d947049c$var$RELAY_RESOLVER_VALUE_KEY = $f91UN.RELAY_RESOLVER_VALUE_KEY, $b0a46dc9d947049c$var$ROOT_ID = $f91UN.ROOT_ID, $b0a46dc9d947049c$var$TYPENAME_KEY = $f91UN.TYPENAME_KEY;

var $jT3aJ = parcelRequire("jT3aJ");

var $423Vm = parcelRequire("423Vm");
parcelRequire("dH6ue");
function $b0a46dc9d947049c$var$clone(record) {
    return (0, $b0a46dc9d947049c$var$_objectSpread2["default"])({}, record);
}
function $b0a46dc9d947049c$var$copyFields(source, sink) {
    for(var key in source){
        if (source.hasOwnProperty(key)) {
            if (key !== $b0a46dc9d947049c$var$ID_KEY && key !== $b0a46dc9d947049c$var$TYPENAME_KEY) sink[key] = source[key];
        }
    }
}
function $b0a46dc9d947049c$var$create(dataID, typeName) {
    var record = {};
    record[$b0a46dc9d947049c$var$ID_KEY] = dataID;
    record[$b0a46dc9d947049c$var$TYPENAME_KEY] = typeName;
    return record;
}
function $b0a46dc9d947049c$var$fromObject(json) {
    return json;
}
function $b0a46dc9d947049c$var$getDataID(record) {
    return record[$b0a46dc9d947049c$var$ID_KEY];
}
function $b0a46dc9d947049c$var$getFields(record) {
    if ($b0a46dc9d947049c$var$ERRORS_KEY in record) return Object.keys(record).filter(function(field) {
        return field !== $b0a46dc9d947049c$var$ERRORS_KEY;
    });
    return Object.keys(record);
}
function $b0a46dc9d947049c$var$getType(record) {
    return record[$b0a46dc9d947049c$var$TYPENAME_KEY];
}
function $b0a46dc9d947049c$var$getErrors(record, storageKey) {
    var _record$ERRORS_KEY;
    return (_record$ERRORS_KEY = record[$b0a46dc9d947049c$var$ERRORS_KEY]) === null || _record$ERRORS_KEY === void 0 ? void 0 : _record$ERRORS_KEY[storageKey];
}
function $b0a46dc9d947049c$var$getValue(record, storageKey) {
    var value = record[storageKey];
    if (value && typeof value === 'object') !(!value.hasOwnProperty($b0a46dc9d947049c$var$REF_KEY) && !value.hasOwnProperty($b0a46dc9d947049c$var$REFS_KEY)) && $423Vm(false);
    return value;
}
function $b0a46dc9d947049c$var$hasValue(record, storageKey) {
    return storageKey in record;
}
function $b0a46dc9d947049c$var$getLinkedRecordID(record, storageKey) {
    var maybeLink = record[storageKey];
    if (maybeLink == null) return maybeLink;
    var link = maybeLink;
    !(typeof link === 'object' && link && typeof link[$b0a46dc9d947049c$var$REF_KEY] === 'string') && $423Vm(false);
    return link[$b0a46dc9d947049c$var$REF_KEY];
}
function $b0a46dc9d947049c$var$hasLinkedRecordID(record, storageKey) {
    var maybeLink = record[storageKey];
    if (maybeLink == null) return false;
    var link = maybeLink;
    return typeof link === 'object' && link && typeof link[$b0a46dc9d947049c$var$REF_KEY] === 'string';
}
function $b0a46dc9d947049c$var$getLinkedRecordIDs(record, storageKey) {
    var links = record[storageKey];
    if (links == null) return links;
    !(typeof links === 'object' && Array.isArray(links[$b0a46dc9d947049c$var$REFS_KEY])) && $423Vm(false);
    return links[$b0a46dc9d947049c$var$REFS_KEY];
}
function $b0a46dc9d947049c$var$hasLinkedRecordIDs(record, storageKey) {
    var links = record[storageKey];
    if (links == null) return false;
    return typeof links === 'object' && Array.isArray(links[$b0a46dc9d947049c$var$REFS_KEY]) && links[$b0a46dc9d947049c$var$REFS_KEY].every(function(link) {
        return typeof link === 'string';
    });
}
function $b0a46dc9d947049c$var$getInvalidationEpoch(record) {
    if (record == null) return null;
    var invalidatedAt = record[$b0a46dc9d947049c$var$INVALIDATED_AT_KEY];
    if (typeof invalidatedAt !== 'number') return null;
    return invalidatedAt;
}
function $b0a46dc9d947049c$var$update(prevRecord, nextRecord) {
    var _updated2;
    var _getType, _getType2, prevID, nextID, prevType, nextType;
    var prevErrorsByKey = prevRecord[$b0a46dc9d947049c$var$ERRORS_KEY];
    var nextErrorsByKey = nextRecord[$b0a46dc9d947049c$var$ERRORS_KEY];
    var updated = null;
    if (prevErrorsByKey == null && nextErrorsByKey == null) {
        var _updated;
        for(var storageKey in nextRecord)if (updated || !$jT3aJ(prevRecord[storageKey], nextRecord[storageKey])) {
            updated = updated !== null ? updated : (0, $b0a46dc9d947049c$var$_objectSpread2["default"])({}, prevRecord);
            updated[storageKey] = nextRecord[storageKey];
        }
        return (_updated = updated) !== null && _updated !== void 0 ? _updated : prevRecord;
    }
    for(var _storageKey2 in nextRecord){
        if (_storageKey2 === $b0a46dc9d947049c$var$ERRORS_KEY) continue;
        var nextValue = nextRecord[_storageKey2];
        var nextErrors = nextErrorsByKey === null || nextErrorsByKey === void 0 ? void 0 : nextErrorsByKey[_storageKey2];
        if (updated == null) {
            var prevValue = prevRecord[_storageKey2];
            var prevErrors = prevErrorsByKey === null || prevErrorsByKey === void 0 ? void 0 : prevErrorsByKey[_storageKey2];
            if ($jT3aJ(prevValue, nextValue) && $jT3aJ(prevErrors, nextErrors)) continue;
            updated = (0, $b0a46dc9d947049c$var$_objectSpread2["default"])({}, prevRecord);
            if (prevErrorsByKey != null) updated[$b0a46dc9d947049c$var$ERRORS_KEY] = (0, $b0a46dc9d947049c$var$_objectSpread2["default"])({}, prevErrorsByKey);
        }
        $b0a46dc9d947049c$var$setValue(updated, _storageKey2, nextValue);
        $b0a46dc9d947049c$var$setErrors(updated, _storageKey2, nextErrors);
    }
    return (_updated2 = updated) !== null && _updated2 !== void 0 ? _updated2 : prevRecord;
}
function $b0a46dc9d947049c$var$merge(record1, record2) {
    var _getType3, _getType4, prevID, nextID, prevType, nextType;
    if ($b0a46dc9d947049c$var$ERRORS_KEY in record1 || $b0a46dc9d947049c$var$ERRORS_KEY in record2) {
        var errors1 = record1[$b0a46dc9d947049c$var$ERRORS_KEY], fields1 = (0, $b0a46dc9d947049c$var$_objectWithoutPropertiesLoose2["default"])(record1, [
            $b0a46dc9d947049c$var$ERRORS_KEY
        ].map($b0a46dc9d947049c$var$_toPropertyKey2["default"]));
        var errors2 = record2[$b0a46dc9d947049c$var$ERRORS_KEY], fields2 = (0, $b0a46dc9d947049c$var$_objectWithoutPropertiesLoose2["default"])(record2, [
            $b0a46dc9d947049c$var$ERRORS_KEY
        ].map($b0a46dc9d947049c$var$_toPropertyKey2["default"]));
        var updated = (0, $b0a46dc9d947049c$var$_objectSpread2["default"])((0, $b0a46dc9d947049c$var$_objectSpread2["default"])({}, fields1), fields2);
        if (errors1 == null && errors2 == null) return updated;
        var updatedErrors = {};
        for(var storageKey in errors1){
            if (fields2.hasOwnProperty(storageKey)) continue;
            updatedErrors[storageKey] = errors1[storageKey];
        }
        for(var _storageKey3 in errors2)updatedErrors[_storageKey3] = errors2[_storageKey3];
        for(var _storageKey in updatedErrors){
            updated[$b0a46dc9d947049c$var$ERRORS_KEY] = updatedErrors;
            break;
        }
        return updated;
    } else return (0, $b0a46dc9d947049c$var$_objectSpread2["default"])((0, $b0a46dc9d947049c$var$_objectSpread2["default"])({}, record1), record2);
}
function $b0a46dc9d947049c$var$freeze(record) {
    $hElRV(record);
}
function $b0a46dc9d947049c$var$setErrors(record, storageKey, errors) {
    var errorsByStorageKey = record[$b0a46dc9d947049c$var$ERRORS_KEY];
    if (errors != null && errors.length > 0) {
        if (errorsByStorageKey == null) record[$b0a46dc9d947049c$var$ERRORS_KEY] = (0, $b0a46dc9d947049c$var$_defineProperty2["default"])({}, storageKey, errors);
        else errorsByStorageKey[storageKey] = errors;
    } else if (errorsByStorageKey != null) {
        if (delete errorsByStorageKey[storageKey]) {
            for(var otherStorageKey in errorsByStorageKey){
                if (errorsByStorageKey.hasOwnProperty(otherStorageKey)) return;
            }
            delete record[$b0a46dc9d947049c$var$ERRORS_KEY];
        }
    }
}
function $b0a46dc9d947049c$var$setValue(record, storageKey, value) {
    var prevID, _getType5, prevType, nextType;
    record[storageKey] = value;
}
function $b0a46dc9d947049c$var$setLinkedRecordID(record, storageKey, linkedID) {
    var link = {};
    link[$b0a46dc9d947049c$var$REF_KEY] = linkedID;
    record[storageKey] = link;
}
function $b0a46dc9d947049c$var$setLinkedRecordIDs(record, storageKey, linkedIDs) {
    var links = {};
    links[$b0a46dc9d947049c$var$REFS_KEY] = linkedIDs;
    record[storageKey] = links;
}
function $b0a46dc9d947049c$var$setActorLinkedRecordID(record, storageKey, actorIdentifier, linkedID) {
    var link = {};
    link[$b0a46dc9d947049c$var$REF_KEY] = linkedID;
    link[$b0a46dc9d947049c$var$ACTOR_IDENTIFIER_KEY] = actorIdentifier;
    record[storageKey] = link;
}
function $b0a46dc9d947049c$var$getActorLinkedRecordID(record, storageKey) {
    var link = record[storageKey];
    if (link == null) return link;
    !(typeof link === 'object' && typeof link[$b0a46dc9d947049c$var$REF_KEY] === 'string' && link[$b0a46dc9d947049c$var$ACTOR_IDENTIFIER_KEY] != null) && $423Vm(false);
    return [
        link[$b0a46dc9d947049c$var$ACTOR_IDENTIFIER_KEY],
        link[$b0a46dc9d947049c$var$REF_KEY]
    ];
}
function $b0a46dc9d947049c$var$getResolverLinkedRecordID(record, typeName) {
    var id = $b0a46dc9d947049c$var$getValue(record, $b0a46dc9d947049c$var$RELAY_RESOLVER_VALUE_KEY);
    if (id == null || $b0a46dc9d947049c$var$isSuspenseSentinel(id)) return null;
    if (typeof id === 'object') id = id.id;
    !(typeof id === 'string') && $423Vm(false);
    return $b0a46dc9d947049c$var$generateClientObjectClientID(typeName, id);
}
function $b0a46dc9d947049c$var$getResolverLinkedRecordIDs(record, typeName) {
    var resolverValue = $b0a46dc9d947049c$var$getValue(record, $b0a46dc9d947049c$var$RELAY_RESOLVER_VALUE_KEY);
    if (resolverValue == null || $b0a46dc9d947049c$var$isSuspenseSentinel(resolverValue)) return null;
    !Array.isArray(resolverValue) && $423Vm(false);
    return resolverValue.map(function(id) {
        if (id == null) return null;
        if (typeof id === 'object') id = id.id;
        !(typeof id === 'string') && $423Vm(false);
        return $b0a46dc9d947049c$var$generateClientObjectClientID(typeName, id);
    });
}
function $b0a46dc9d947049c$var$toJSON(record) {
    return record;
}
module.exports = {
    clone: $b0a46dc9d947049c$var$clone,
    copyFields: $b0a46dc9d947049c$var$copyFields,
    create: $b0a46dc9d947049c$var$create,
    freeze: $b0a46dc9d947049c$var$freeze,
    fromObject: $b0a46dc9d947049c$var$fromObject,
    getDataID: $b0a46dc9d947049c$var$getDataID,
    getErrors: $b0a46dc9d947049c$var$getErrors,
    getFields: $b0a46dc9d947049c$var$getFields,
    getInvalidationEpoch: $b0a46dc9d947049c$var$getInvalidationEpoch,
    getLinkedRecordID: $b0a46dc9d947049c$var$getLinkedRecordID,
    getLinkedRecordIDs: $b0a46dc9d947049c$var$getLinkedRecordIDs,
    getType: $b0a46dc9d947049c$var$getType,
    getValue: $b0a46dc9d947049c$var$getValue,
    hasValue: $b0a46dc9d947049c$var$hasValue,
    hasLinkedRecordID: $b0a46dc9d947049c$var$hasLinkedRecordID,
    hasLinkedRecordIDs: $b0a46dc9d947049c$var$hasLinkedRecordIDs,
    merge: $b0a46dc9d947049c$var$merge,
    setErrors: $b0a46dc9d947049c$var$setErrors,
    setValue: $b0a46dc9d947049c$var$setValue,
    setLinkedRecordID: $b0a46dc9d947049c$var$setLinkedRecordID,
    setLinkedRecordIDs: $b0a46dc9d947049c$var$setLinkedRecordIDs,
    update: $b0a46dc9d947049c$var$update,
    getActorLinkedRecordID: $b0a46dc9d947049c$var$getActorLinkedRecordID,
    setActorLinkedRecordID: $b0a46dc9d947049c$var$setActorLinkedRecordID,
    getResolverLinkedRecordID: $b0a46dc9d947049c$var$getResolverLinkedRecordID,
    getResolverLinkedRecordIDs: $b0a46dc9d947049c$var$getResolverLinkedRecordIDs,
    toJSON: $b0a46dc9d947049c$var$toJSON
};

});

parcelRegister("7eJdF", function(module, exports) {
'use strict';

var $7Wmh0 = parcelRequire("7Wmh0");
var $544cead8fbc2994f$var$_interopRequireDefault = $7Wmh0.default;

var $544cead8fbc2994f$var$_createForOfIteratorHelper2 = $544cead8fbc2994f$var$_interopRequireDefault((parcelRequire("9CLQ8")));

var $fagih = parcelRequire("fagih");

var $jqEGH = parcelRequire("jqEGH");
var $544cead8fbc2994f$var$EXISTENT = $jqEGH.EXISTENT, $544cead8fbc2994f$var$NONEXISTENT = $jqEGH.NONEXISTENT, $544cead8fbc2994f$var$UNKNOWN = $jqEGH.UNKNOWN;
var $544cead8fbc2994f$var$RelayRecordSource = /*#__PURE__*/ function() {
    function RelayRecordSource(records) {
        var _this = this;
        this._records = new Map();
        if (records != null) Object.keys(records).forEach(function(key) {
            var object = records[key];
            var record = $fagih.fromObject(object);
            _this._records.set(key, record);
        });
    }
    RelayRecordSource.create = function create(records) {
        return new RelayRecordSource(records);
    };
    var _proto = RelayRecordSource.prototype;
    _proto.clear = function clear() {
        this._records = new Map();
    };
    _proto["delete"] = function _delete(dataID) {
        this._records.set(dataID, null);
    };
    _proto.get = function get(dataID) {
        return this._records.get(dataID);
    };
    _proto.getRecordIDs = function getRecordIDs() {
        return Array.from(this._records.keys());
    };
    _proto.getStatus = function getStatus(dataID) {
        if (!this._records.has(dataID)) return $544cead8fbc2994f$var$UNKNOWN;
        return this._records.get(dataID) == null ? $544cead8fbc2994f$var$NONEXISTENT : $544cead8fbc2994f$var$EXISTENT;
    };
    _proto.has = function has(dataID) {
        return this._records.has(dataID);
    };
    _proto.remove = function remove(dataID) {
        this._records["delete"](dataID);
    };
    _proto.set = function set(dataID, record) {
        this._records.set(dataID, record);
    };
    _proto.size = function size() {
        return this._records.size;
    };
    _proto.toJSON = function toJSON() {
        var obj = {};
        var _iterator = (0, $544cead8fbc2994f$var$_createForOfIteratorHelper2["default"])(this._records), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var _step$value = _step.value, key = _step$value[0], record = _step$value[1];
                obj[key] = $fagih.toJSON(record);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return obj;
    };
    return RelayRecordSource;
}();
module.exports = $544cead8fbc2994f$var$RelayRecordSource;

});
parcelRegister("jqEGH", function(module, exports) {
'use strict';
var $e25001c7b48816f2$var$RelayRecordState = {
    EXISTENT: 'EXISTENT',
    NONEXISTENT: 'NONEXISTENT',
    UNKNOWN: 'UNKNOWN'
};
module.exports = $e25001c7b48816f2$var$RelayRecordState;

});


parcelRegister("3cbTo", function(module, exports) {
'use strict';

var $7Wmh0 = parcelRequire("7Wmh0");
var $253bb7af5f2c18c5$var$_interopRequireDefault = $7Wmh0.default;

var $253bb7af5f2c18c5$var$_createForOfIteratorHelper2 = $253bb7af5f2c18c5$var$_interopRequireDefault((parcelRequire("9CLQ8")));

var $253bb7af5f2c18c5$var$_toConsumableArray2 = $253bb7af5f2c18c5$var$_interopRequireDefault((parcelRequire("gHCmS")));

var $3QPmH = parcelRequire("3QPmH");
var $253bb7af5f2c18c5$var$ACTOR_IDENTIFIER_FIELD_NAME = $3QPmH.ACTOR_IDENTIFIER_FIELD_NAME, $253bb7af5f2c18c5$var$getActorIdentifierFromPayload = $3QPmH.getActorIdentifierFromPayload;

var $54ow8 = parcelRequire("54ow8");
var $253bb7af5f2c18c5$var$ACTOR_CHANGE = $54ow8.ACTOR_CHANGE, $253bb7af5f2c18c5$var$CLIENT_COMPONENT = $54ow8.CLIENT_COMPONENT, $253bb7af5f2c18c5$var$CLIENT_EDGE_TO_CLIENT_OBJECT = $54ow8.CLIENT_EDGE_TO_CLIENT_OBJECT, $253bb7af5f2c18c5$var$CLIENT_EXTENSION = $54ow8.CLIENT_EXTENSION, $253bb7af5f2c18c5$var$CONDITION = $54ow8.CONDITION, $253bb7af5f2c18c5$var$DEFER = $54ow8.DEFER, $253bb7af5f2c18c5$var$FRAGMENT_SPREAD = $54ow8.FRAGMENT_SPREAD, $253bb7af5f2c18c5$var$INLINE_FRAGMENT = $54ow8.INLINE_FRAGMENT, $253bb7af5f2c18c5$var$LINKED_FIELD = $54ow8.LINKED_FIELD, $253bb7af5f2c18c5$var$LINKED_HANDLE = $54ow8.LINKED_HANDLE, $253bb7af5f2c18c5$var$MODULE_IMPORT = $54ow8.MODULE_IMPORT, $253bb7af5f2c18c5$var$RELAY_LIVE_RESOLVER = $54ow8.RELAY_LIVE_RESOLVER, $253bb7af5f2c18c5$var$RELAY_RESOLVER = $54ow8.RELAY_RESOLVER, $253bb7af5f2c18c5$var$SCALAR_FIELD = $54ow8.SCALAR_FIELD, $253bb7af5f2c18c5$var$SCALAR_HANDLE = $54ow8.SCALAR_HANDLE, $253bb7af5f2c18c5$var$STREAM = $54ow8.STREAM, $253bb7af5f2c18c5$var$TYPE_DISCRIMINATOR = $54ow8.TYPE_DISCRIMINATOR;

var $axs8G = parcelRequire("axs8G");
var $253bb7af5f2c18c5$var$generateClientID = $axs8G.generateClientID, $253bb7af5f2c18c5$var$isClientID = $axs8G.isClientID;

var $frIyf = parcelRequire("frIyf");
var $253bb7af5f2c18c5$var$getLocalVariables = $frIyf.getLocalVariables;

var $kLcab = parcelRequire("kLcab");
var $253bb7af5f2c18c5$var$buildErrorTrie = $kLcab.buildErrorTrie, $253bb7af5f2c18c5$var$getErrorsByKey = $kLcab.getErrorsByKey, $253bb7af5f2c18c5$var$getNestedErrorTrieByKey = $kLcab.getNestedErrorTrieByKey;

var $fagih = parcelRequire("fagih");

var $g432U = parcelRequire("g432U");
var $253bb7af5f2c18c5$var$createNormalizationSelector = $g432U.createNormalizationSelector;

var $f91UN = parcelRequire("f91UN");
var $253bb7af5f2c18c5$var$ROOT_ID = $f91UN.ROOT_ID, $253bb7af5f2c18c5$var$TYPENAME_KEY = $f91UN.TYPENAME_KEY, $253bb7af5f2c18c5$var$getArgumentValues = $f91UN.getArgumentValues, $253bb7af5f2c18c5$var$getHandleStorageKey = $f91UN.getHandleStorageKey, $253bb7af5f2c18c5$var$getModuleComponentKey = $f91UN.getModuleComponentKey, $253bb7af5f2c18c5$var$getModuleOperationKey = $f91UN.getModuleOperationKey, $253bb7af5f2c18c5$var$getStorageKey = $f91UN.getStorageKey;

var $M4yH2 = parcelRequire("M4yH2");
var $253bb7af5f2c18c5$var$TYPE_SCHEMA_TYPE = $M4yH2.TYPE_SCHEMA_TYPE, $253bb7af5f2c18c5$var$generateTypeID = $M4yH2.generateTypeID;
parcelRequire("jT3aJ");

var $423Vm = parcelRequire("423Vm");
parcelRequire("dH6ue");
function $253bb7af5f2c18c5$var$normalize(recordSource, selector, response, options, errors) {
    var dataID = selector.dataID, node = selector.node, variables = selector.variables;
    var normalizer = new $253bb7af5f2c18c5$var$RelayResponseNormalizer(recordSource, variables, options);
    return normalizer.normalizeResponse(node, dataID, response, errors);
}
var $253bb7af5f2c18c5$var$RelayResponseNormalizer = /*#__PURE__*/ function() {
    function RelayResponseNormalizer(recordSource, variables, options) {
        this._actorIdentifier = options.actorIdentifier;
        this._getDataId = options.getDataID;
        this._handleFieldPayloads = [];
        this._treatMissingFieldsAsNull = options.treatMissingFieldsAsNull;
        this._incrementalPlaceholders = [];
        this._isClientExtension = false;
        this._isUnmatchedAbstractType = false;
        this._followupPayloads = [];
        this._path = options.path ? (0, $253bb7af5f2c18c5$var$_toConsumableArray2["default"])(options.path) : [];
        this._recordSource = recordSource;
        this._variables = variables;
        this._shouldProcessClientComponents = options.shouldProcessClientComponents;
    }
    var _proto = RelayResponseNormalizer.prototype;
    _proto.normalizeResponse = function normalizeResponse(node, dataID, data, errors) {
        var record = this._recordSource.get(dataID);
        !record && $423Vm(false);
        this._assignClientAbstractTypes(node);
        this._errorTrie = $253bb7af5f2c18c5$var$buildErrorTrie(errors);
        this._traverseSelections(node, record, data);
        return {
            errors: errors,
            fieldPayloads: this._handleFieldPayloads,
            incrementalPlaceholders: this._incrementalPlaceholders,
            followupPayloads: this._followupPayloads,
            source: this._recordSource,
            isFinal: false
        };
    };
    _proto._assignClientAbstractTypes = function _assignClientAbstractTypes(node) {
        var clientAbstractTypes = node.clientAbstractTypes;
        if (clientAbstractTypes != null) for(var _i = 0, _Object$keys = Object.keys(clientAbstractTypes); _i < _Object$keys.length; _i++){
            var abstractType = _Object$keys[_i];
            var _iterator = (0, $253bb7af5f2c18c5$var$_createForOfIteratorHelper2["default"])(clientAbstractTypes[abstractType]), _step;
            try {
                for(_iterator.s(); !(_step = _iterator.n()).done;){
                    var concreteType = _step.value;
                    var typeID = $253bb7af5f2c18c5$var$generateTypeID(concreteType);
                    var typeRecord = this._recordSource.get(typeID);
                    if (typeRecord == null) {
                        typeRecord = $fagih.create(typeID, $253bb7af5f2c18c5$var$TYPE_SCHEMA_TYPE);
                        this._recordSource.set(typeID, typeRecord);
                    }
                    $fagih.setValue(typeRecord, abstractType, true);
                }
            } catch (err) {
                _iterator.e(err);
            } finally{
                _iterator.f();
            }
        }
    };
    _proto._getVariableValue = function _getVariableValue(name) {
        !this._variables.hasOwnProperty(name) && $423Vm(false);
        return this._variables[name];
    };
    _proto._getRecordType = function _getRecordType(data) {
        var typeName = data[$253bb7af5f2c18c5$var$TYPENAME_KEY];
        !(typeName != null) && $423Vm(false);
        return typeName;
    };
    _proto._traverseSelections = function _traverseSelections(node, record, data) {
        for(var i = 0; i < node.selections.length; i++){
            var selection = node.selections[i];
            switch(selection.kind){
                case $253bb7af5f2c18c5$var$SCALAR_FIELD:
                case $253bb7af5f2c18c5$var$LINKED_FIELD:
                    this._normalizeField(selection, record, data);
                    break;
                case $253bb7af5f2c18c5$var$CONDITION:
                    var conditionValue = Boolean(this._getVariableValue(selection.condition));
                    if (conditionValue === selection.passingValue) this._traverseSelections(selection, record, data);
                    break;
                case $253bb7af5f2c18c5$var$FRAGMENT_SPREAD:
                    var prevVariables = this._variables;
                    this._variables = $253bb7af5f2c18c5$var$getLocalVariables(this._variables, selection.fragment.argumentDefinitions, selection.args);
                    this._traverseSelections(selection.fragment, record, data);
                    this._variables = prevVariables;
                    break;
                case $253bb7af5f2c18c5$var$INLINE_FRAGMENT:
                    var abstractKey = selection.abstractKey;
                    if (abstractKey == null) {
                        var typeName = $fagih.getType(record);
                        if (typeName === selection.type) this._traverseSelections(selection, record, data);
                    } else {
                        var implementsInterface = data.hasOwnProperty(abstractKey);
                        var _typeName = $fagih.getType(record);
                        var typeID = $253bb7af5f2c18c5$var$generateTypeID(_typeName);
                        var typeRecord = this._recordSource.get(typeID);
                        if (typeRecord == null) {
                            typeRecord = $fagih.create(typeID, $253bb7af5f2c18c5$var$TYPE_SCHEMA_TYPE);
                            this._recordSource.set(typeID, typeRecord);
                        }
                        $fagih.setValue(typeRecord, abstractKey, implementsInterface);
                        if (implementsInterface) this._traverseSelections(selection, record, data);
                    }
                    break;
                case $253bb7af5f2c18c5$var$TYPE_DISCRIMINATOR:
                    var _abstractKey = selection.abstractKey;
                    var _implementsInterface = data.hasOwnProperty(_abstractKey);
                    var _typeName2 = $fagih.getType(record);
                    var _typeID = $253bb7af5f2c18c5$var$generateTypeID(_typeName2);
                    var _typeRecord = this._recordSource.get(_typeID);
                    if (_typeRecord == null) {
                        _typeRecord = $fagih.create(_typeID, $253bb7af5f2c18c5$var$TYPE_SCHEMA_TYPE);
                        this._recordSource.set(_typeID, _typeRecord);
                    }
                    $fagih.setValue(_typeRecord, _abstractKey, _implementsInterface);
                    break;
                case $253bb7af5f2c18c5$var$LINKED_HANDLE:
                case $253bb7af5f2c18c5$var$SCALAR_HANDLE:
                    var args = selection.args ? $253bb7af5f2c18c5$var$getArgumentValues(selection.args, this._variables) : {};
                    var fieldKey = $253bb7af5f2c18c5$var$getStorageKey(selection, this._variables);
                    var handleKey = $253bb7af5f2c18c5$var$getHandleStorageKey(selection, this._variables);
                    this._handleFieldPayloads.push({
                        args: args,
                        dataID: $fagih.getDataID(record),
                        fieldKey: fieldKey,
                        handle: selection.handle,
                        handleKey: handleKey,
                        handleArgs: selection.handleArgs ? $253bb7af5f2c18c5$var$getArgumentValues(selection.handleArgs, this._variables) : {}
                    });
                    break;
                case $253bb7af5f2c18c5$var$MODULE_IMPORT:
                    this._normalizeModuleImport(selection, record, data);
                    break;
                case $253bb7af5f2c18c5$var$DEFER:
                    this._normalizeDefer(selection, record, data);
                    break;
                case $253bb7af5f2c18c5$var$STREAM:
                    this._normalizeStream(selection, record, data);
                    break;
                case $253bb7af5f2c18c5$var$CLIENT_EXTENSION:
                    var isClientExtension = this._isClientExtension;
                    this._isClientExtension = true;
                    this._traverseSelections(selection, record, data);
                    this._isClientExtension = isClientExtension;
                    break;
                case $253bb7af5f2c18c5$var$CLIENT_COMPONENT:
                    if (this._shouldProcessClientComponents === false) break;
                    this._traverseSelections(selection.fragment, record, data);
                    break;
                case $253bb7af5f2c18c5$var$ACTOR_CHANGE:
                    this._normalizeActorChange(selection, record, data);
                    break;
                case $253bb7af5f2c18c5$var$RELAY_RESOLVER:
                    this._normalizeResolver(selection, record, data);
                    break;
                case $253bb7af5f2c18c5$var$RELAY_LIVE_RESOLVER:
                    this._normalizeResolver(selection, record, data);
                    break;
                case $253bb7af5f2c18c5$var$CLIENT_EDGE_TO_CLIENT_OBJECT:
                    this._normalizeResolver(selection.backingField, record, data);
                    break;
                default:
                    selection;
                    $423Vm(false);
            }
        }
    };
    _proto._normalizeResolver = function _normalizeResolver(resolver, record, data) {
        if (resolver.fragment != null) this._traverseSelections(resolver.fragment, record, data);
    };
    _proto._normalizeDefer = function _normalizeDefer(defer, record, data) {
        var isDeferred = defer["if"] === null || this._getVariableValue(defer["if"]);
        if (isDeferred === false) this._traverseSelections(defer, record, data);
        else this._incrementalPlaceholders.push({
            kind: 'defer',
            data: data,
            label: defer.label,
            path: (0, $253bb7af5f2c18c5$var$_toConsumableArray2["default"])(this._path),
            selector: $253bb7af5f2c18c5$var$createNormalizationSelector(defer, $fagih.getDataID(record), this._variables),
            typeName: $fagih.getType(record),
            actorIdentifier: this._actorIdentifier
        });
    };
    _proto._normalizeStream = function _normalizeStream(stream, record, data) {
        this._traverseSelections(stream, record, data);
        var isStreamed = stream["if"] === null || this._getVariableValue(stream["if"]);
        if (isStreamed === true) this._incrementalPlaceholders.push({
            kind: 'stream',
            label: stream.label,
            path: (0, $253bb7af5f2c18c5$var$_toConsumableArray2["default"])(this._path),
            parentID: $fagih.getDataID(record),
            node: stream,
            variables: this._variables,
            actorIdentifier: this._actorIdentifier
        });
    };
    _proto._normalizeModuleImport = function _normalizeModuleImport(moduleImport, record, data) {
        !(typeof data === 'object' && data) && $423Vm(false);
        var typeName = $fagih.getType(record);
        var componentKey = $253bb7af5f2c18c5$var$getModuleComponentKey(moduleImport.documentName);
        var componentReference = moduleImport.componentModuleProvider || data[componentKey];
        $fagih.setValue(record, componentKey, componentReference !== null && componentReference !== void 0 ? componentReference : null);
        var operationKey = $253bb7af5f2c18c5$var$getModuleOperationKey(moduleImport.documentName);
        var operationReference = moduleImport.operationModuleProvider || data[operationKey];
        $fagih.setValue(record, operationKey, operationReference !== null && operationReference !== void 0 ? operationReference : null);
        if (operationReference != null) this._followupPayloads.push({
            kind: 'ModuleImportPayload',
            args: moduleImport.args,
            data: data,
            dataID: $fagih.getDataID(record),
            operationReference: operationReference,
            path: (0, $253bb7af5f2c18c5$var$_toConsumableArray2["default"])(this._path),
            typeName: typeName,
            variables: this._variables,
            actorIdentifier: this._actorIdentifier
        });
    };
    _proto._normalizeField = function _normalizeField(selection, record, data) {
        !(typeof data === 'object' && data) && $423Vm(false);
        var responseKey = selection.alias || selection.name;
        var storageKey = $253bb7af5f2c18c5$var$getStorageKey(selection, this._variables);
        var fieldValue = data[responseKey];
        if (fieldValue == null) {
            if (fieldValue === undefined) {
                var isOptionalField = this._isClientExtension || this._isUnmatchedAbstractType;
                if (isOptionalField) return;
                else if (!this._treatMissingFieldsAsNull) return;
            }
            $fagih.setValue(record, storageKey, null);
            var errorTrie = this._errorTrie;
            if (errorTrie != null) {
                var errors = $253bb7af5f2c18c5$var$getErrorsByKey(errorTrie, responseKey);
                if (errors != null) $fagih.setErrors(record, storageKey, errors);
            }
            return;
        }
        if (selection.kind === $253bb7af5f2c18c5$var$SCALAR_FIELD) $fagih.setValue(record, storageKey, fieldValue);
        else if (selection.kind === $253bb7af5f2c18c5$var$LINKED_FIELD) {
            this._path.push(responseKey);
            var oldErrorTrie = this._errorTrie;
            this._errorTrie = oldErrorTrie == null ? null : $253bb7af5f2c18c5$var$getNestedErrorTrieByKey(oldErrorTrie, responseKey);
            if (selection.plural) this._normalizePluralLink(selection, record, storageKey, fieldValue);
            else this._normalizeLink(selection, record, storageKey, fieldValue);
            this._errorTrie = oldErrorTrie;
            this._path.pop();
        } else {
            selection;
            $423Vm(false);
        }
    };
    _proto._normalizeActorChange = function _normalizeActorChange(selection, record, data) {
        var _field$concreteType;
        var field = selection.linkedField;
        !(typeof data === 'object' && data) && $423Vm(false);
        var responseKey = field.alias || field.name;
        var storageKey = $253bb7af5f2c18c5$var$getStorageKey(field, this._variables);
        var fieldValue = data[responseKey];
        if (fieldValue == null) {
            if (fieldValue === undefined) {
                var isOptionalField = this._isClientExtension || this._isUnmatchedAbstractType;
                if (isOptionalField) return;
                else if (!this._treatMissingFieldsAsNull) return;
            }
            $fagih.setValue(record, storageKey, null);
            return;
        }
        var actorIdentifier = $253bb7af5f2c18c5$var$getActorIdentifierFromPayload(fieldValue);
        if (actorIdentifier == null) {
            $fagih.setValue(record, storageKey, null);
            return;
        }
        var typeName = (_field$concreteType = field.concreteType) !== null && _field$concreteType !== void 0 ? _field$concreteType : this._getRecordType(fieldValue);
        var nextID = this._getDataId(fieldValue, typeName) || $fagih.getLinkedRecordID(record, storageKey) || $253bb7af5f2c18c5$var$generateClientID($fagih.getDataID(record), storageKey);
        !(typeof nextID === 'string') && $423Vm(false);
        $fagih.setActorLinkedRecordID(record, storageKey, actorIdentifier, nextID);
        this._followupPayloads.push({
            kind: 'ActorPayload',
            data: fieldValue,
            dataID: nextID,
            path: [].concat((0, $253bb7af5f2c18c5$var$_toConsumableArray2["default"])(this._path), [
                responseKey
            ]),
            typeName: typeName,
            variables: this._variables,
            node: field,
            actorIdentifier: actorIdentifier
        });
    };
    _proto._normalizeLink = function _normalizeLink(field, record, storageKey, fieldValue) {
        var _field$concreteType2;
        !(typeof fieldValue === 'object' && fieldValue) && $423Vm(false);
        var nextID = this._getDataId(fieldValue, (_field$concreteType2 = field.concreteType) !== null && _field$concreteType2 !== void 0 ? _field$concreteType2 : this._getRecordType(fieldValue)) || $fagih.getLinkedRecordID(record, storageKey) || $253bb7af5f2c18c5$var$generateClientID($fagih.getDataID(record), storageKey);
        !(typeof nextID === 'string') && $423Vm(false);
        $fagih.setLinkedRecordID(record, storageKey, nextID);
        var nextRecord = this._recordSource.get(nextID);
        if (!nextRecord) {
            var typeName = field.concreteType || this._getRecordType(fieldValue);
            nextRecord = $fagih.create(nextID, typeName);
            this._recordSource.set(nextID, nextRecord);
        }
        this._traverseSelections(field, nextRecord, fieldValue);
    };
    _proto._normalizePluralLink = function _normalizePluralLink(field, record, storageKey, fieldValue) {
        var _this = this;
        !Array.isArray(fieldValue) && $423Vm(false);
        var prevIDs = $fagih.getLinkedRecordIDs(record, storageKey);
        var nextIDs = [];
        fieldValue.forEach(function(item, nextIndex) {
            var _field$concreteType3;
            if (item == null) {
                nextIDs.push(item);
                return;
            }
            _this._path.push(String(nextIndex));
            var oldErrorTrie = _this._errorTrie;
            _this._errorTrie = oldErrorTrie == null ? null : $253bb7af5f2c18c5$var$getNestedErrorTrieByKey(oldErrorTrie, nextIndex);
            !(typeof item === 'object') && $423Vm(false);
            var nextID = _this._getDataId(item, (_field$concreteType3 = field.concreteType) !== null && _field$concreteType3 !== void 0 ? _field$concreteType3 : _this._getRecordType(item)) || prevIDs && prevIDs[nextIndex] || $253bb7af5f2c18c5$var$generateClientID($fagih.getDataID(record), storageKey, nextIndex);
            !(typeof nextID === 'string') && $423Vm(false);
            nextIDs.push(nextID);
            var nextRecord = _this._recordSource.get(nextID);
            if (!nextRecord) {
                var typeName = field.concreteType || _this._getRecordType(item);
                nextRecord = $fagih.create(nextID, typeName);
                _this._recordSource.set(nextID, nextRecord);
            }
            _this._traverseSelections(field, nextRecord, item);
            _this._errorTrie = oldErrorTrie;
            _this._path.pop();
        });
        $fagih.setLinkedRecordIDs(record, storageKey, nextIDs);
    };
    _proto._validateRecordType = function _validateRecordType(record, field, payload) {
        var _field$concreteType4;
        var typeName = (_field$concreteType4 = field.concreteType) !== null && _field$concreteType4 !== void 0 ? _field$concreteType4 : this._getRecordType(payload);
        var dataID = $fagih.getDataID(record);
    };
    _proto._validateConflictingFieldsWithIdenticalId = function _validateConflictingFieldsWithIdenticalId(record, storageKey, fieldValue) {
        var dataID, previousValue;
    };
    _proto._validateConflictingLinkedFieldsWithIdenticalId = function _validateConflictingLinkedFieldsWithIdenticalId(prevID, nextID, storageKey) {};
    return RelayResponseNormalizer;
}();
module.exports = {
    normalize: $253bb7af5f2c18c5$var$normalize
};

});
parcelRegister("3QPmH", function(module, exports) {
'use strict';
var $2cde12778a3080bd$var$ACTOR_IDENTIFIER_FIELD_NAME = 'actor_key';

var $2BDDE = parcelRequire("2BDDE");
var $2cde12778a3080bd$var$getActorIdentifier = $2BDDE.getActorIdentifier;
function $2cde12778a3080bd$var$getActorIdentifierFromPayload(payload) {
    if (payload != null && typeof payload === 'object' && typeof payload[$2cde12778a3080bd$var$ACTOR_IDENTIFIER_FIELD_NAME] === 'string') return $2cde12778a3080bd$var$getActorIdentifier(payload[$2cde12778a3080bd$var$ACTOR_IDENTIFIER_FIELD_NAME]);
}
module.exports = {
    ACTOR_IDENTIFIER_FIELD_NAME: $2cde12778a3080bd$var$ACTOR_IDENTIFIER_FIELD_NAME,
    getActorIdentifierFromPayload: $2cde12778a3080bd$var$getActorIdentifierFromPayload
};

});
parcelRegister("2BDDE", function(module, exports) {
'use strict';

var $423Vm = parcelRequire("423Vm");
var $1e5dc8db5d1c1517$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE = 'INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE';
function $1e5dc8db5d1c1517$var$assertInternalActorIdentifier(actorIdentifier) {
    !(actorIdentifier === $1e5dc8db5d1c1517$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE) && $423Vm(false);
}
module.exports = {
    assertInternalActorIdentifier: $1e5dc8db5d1c1517$var$assertInternalActorIdentifier,
    getActorIdentifier: function getActorIdentifier(actorID) {
        return actorID;
    },
    getDefaultActorIdentifier: function getDefaultActorIdentifier() {
        throw new Error('Not Implemented');
    },
    INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE: $1e5dc8db5d1c1517$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE
};

});


parcelRegister("M4yH2", function(module, exports) {
'use strict';
var $0908050bd40e4fc0$var$PREFIX = 'client:__type:';
var $0908050bd40e4fc0$var$TYPE_SCHEMA_TYPE = '__TypeSchema';
function $0908050bd40e4fc0$var$generateTypeID(typeName) {
    return $0908050bd40e4fc0$var$PREFIX + typeName;
}
function $0908050bd40e4fc0$var$isTypeID(id) {
    return id.indexOf($0908050bd40e4fc0$var$PREFIX) === 0;
}
module.exports = {
    generateTypeID: $0908050bd40e4fc0$var$generateTypeID,
    isTypeID: $0908050bd40e4fc0$var$isTypeID,
    TYPE_SCHEMA_TYPE: $0908050bd40e4fc0$var$TYPE_SCHEMA_TYPE
};

});



parcelRegister("iJHA2", function(module, exports) {
'use strict';

var $bzkJN = parcelRequire("bzkJN");
var $da3e3c1d0aa263a9$var$getInlineDataFragment = $bzkJN.getInlineDataFragment;

var $f91UN = parcelRequire("f91UN");
var $da3e3c1d0aa263a9$var$FRAGMENTS_KEY = $f91UN.FRAGMENTS_KEY;

var $423Vm = parcelRequire("423Vm");
function $da3e3c1d0aa263a9$var$readInlineData(fragment, fragmentRef) {
    var _fragmentRef$FRAGMENT;
    var inlineDataFragment = $da3e3c1d0aa263a9$var$getInlineDataFragment(fragment);
    if (fragmentRef == null) return fragmentRef;
    !(typeof fragmentRef === 'object') && $423Vm(false);
    var inlineData = (_fragmentRef$FRAGMENT = fragmentRef[$da3e3c1d0aa263a9$var$FRAGMENTS_KEY]) === null || _fragmentRef$FRAGMENT === void 0 ? void 0 : _fragmentRef$FRAGMENT[inlineDataFragment.name];
    !(inlineData != null) && $423Vm(false);
    return inlineData;
}
module.exports = $da3e3c1d0aa263a9$var$readInlineData;

});

parcelRegister("5eWNm", function(module, exports) {
'use strict';

var $7Wmh0 = parcelRequire("7Wmh0");
var $3d0bde05b4ad1f1c$var$_interopRequireDefault = $7Wmh0.default;

var $3d0bde05b4ad1f1c$var$_objectSpread2 = $3d0bde05b4ad1f1c$var$_interopRequireDefault((parcelRequire("1sB2t")));

var $lIESd = parcelRequire("lIESd");

var $2BDDE = parcelRequire("2BDDE");
var $3d0bde05b4ad1f1c$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE = $2BDDE.INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE, $3d0bde05b4ad1f1c$var$assertInternalActorIdentifier = $2BDDE.assertInternalActorIdentifier;

var $5k1AH = parcelRequire("5k1AH");

var $jRAe8 = parcelRequire("jRAe8");

var $cnpJc = parcelRequire("cnpJc");

var $brAuk = parcelRequire("brAuk");

var $kA5Gq = parcelRequire("kA5Gq");

var $dQl2P = parcelRequire("dQl2P");

var $jd20U = parcelRequire("jd20U");

var $cvQ1X = parcelRequire("cvQ1X");

var $b7UpD = parcelRequire("b7UpD");

var $7eJdF = parcelRequire("7eJdF");
parcelRequire("423Vm");
var $3d0bde05b4ad1f1c$var$RelayModernEnvironment = /*#__PURE__*/ function() {
    function RelayModernEnvironment(config) {
        var _this = this;
        var _config$log, _config$relayFieldLog, _config$UNSTABLE_defa, _config$getDataID, _config$missingFieldH, _config$handlerProvid, _config$scheduler, _config$isServer, _config$normalizeResp, _config$operationTrac;
        this.configName = config.configName;
        this._treatMissingFieldsAsNull = config.treatMissingFieldsAsNull === true;
        var operationLoader = config.operationLoader;
        this.__log = (_config$log = config.log) !== null && _config$log !== void 0 ? _config$log : $3d0bde05b4ad1f1c$var$emptyFunction;
        this.relayFieldLogger = (_config$relayFieldLog = config.relayFieldLogger) !== null && _config$relayFieldLog !== void 0 ? _config$relayFieldLog : $dQl2P;
        this._defaultRenderPolicy = (_config$UNSTABLE_defa = config.UNSTABLE_defaultRenderPolicy) !== null && _config$UNSTABLE_defa !== void 0 ? _config$UNSTABLE_defa : 'partial';
        this._operationLoader = operationLoader;
        this._operationExecutions = new Map();
        this._network = $jRAe8(this, config.network);
        this._getDataID = (_config$getDataID = config.getDataID) !== null && _config$getDataID !== void 0 ? _config$getDataID : $kA5Gq;
        this._missingFieldHandlers = (_config$missingFieldH = config.missingFieldHandlers) !== null && _config$missingFieldH !== void 0 ? _config$missingFieldH : [];
        this._publishQueue = new $b7UpD(config.store, (_config$handlerProvid = config.handlerProvider) !== null && _config$handlerProvid !== void 0 ? _config$handlerProvid : $lIESd, this._getDataID, this._missingFieldHandlers);
        this._scheduler = (_config$scheduler = config.scheduler) !== null && _config$scheduler !== void 0 ? _config$scheduler : null;
        this._store = config.store;
        this.options = config.options;
        this._isServer = (_config$isServer = config.isServer) !== null && _config$isServer !== void 0 ? _config$isServer : false;
        this._normalizeResponse = (_config$normalizeResp = config.normalizeResponse) !== null && _config$normalizeResp !== void 0 ? _config$normalizeResp : $jd20U;
        this.__setNet = function(newNet) {
            return _this._network = $jRAe8(_this, newNet);
        };
        var _require2, inspect;
        this._operationTracker = (_config$operationTrac = config.operationTracker) !== null && _config$operationTrac !== void 0 ? _config$operationTrac : new $cnpJc();
        this._shouldProcessClientComponents = config.shouldProcessClientComponents;
        $brAuk(this);
    }
    var _proto = RelayModernEnvironment.prototype;
    _proto.getStore = function getStore() {
        return this._store;
    };
    _proto.getNetwork = function getNetwork() {
        return this._network;
    };
    _proto.getOperationTracker = function getOperationTracker() {
        return this._operationTracker;
    };
    _proto.getScheduler = function getScheduler() {
        return this._scheduler;
    };
    _proto.isRequestActive = function isRequestActive(requestIdentifier) {
        var activeState = this._operationExecutions.get(requestIdentifier);
        return activeState === 'active';
    };
    _proto.UNSTABLE_getDefaultRenderPolicy = function UNSTABLE_getDefaultRenderPolicy() {
        return this._defaultRenderPolicy;
    };
    _proto.applyUpdate = function applyUpdate(optimisticUpdate) {
        var _this2 = this;
        var dispose = function dispose() {
            _this2._scheduleUpdates(function() {
                _this2._publishQueue.revertUpdate(optimisticUpdate);
                _this2._publishQueue.run();
            });
        };
        this._scheduleUpdates(function() {
            _this2._publishQueue.applyUpdate(optimisticUpdate);
            _this2._publishQueue.run();
        });
        return {
            dispose: dispose
        };
    };
    _proto.revertUpdate = function revertUpdate(update) {
        var _this3 = this;
        this._scheduleUpdates(function() {
            _this3._publishQueue.revertUpdate(update);
            _this3._publishQueue.run();
        });
    };
    _proto.replaceUpdate = function replaceUpdate(update, newUpdate) {
        var _this4 = this;
        this._scheduleUpdates(function() {
            _this4._publishQueue.revertUpdate(update);
            _this4._publishQueue.applyUpdate(newUpdate);
            _this4._publishQueue.run();
        });
    };
    _proto.applyMutation = function applyMutation(optimisticConfig) {
        var subscription = this._execute({
            createSource: function createSource() {
                return $5k1AH.create(function(_sink) {});
            },
            isClientPayload: false,
            operation: optimisticConfig.operation,
            optimisticConfig: optimisticConfig,
            updater: null
        }).subscribe({});
        return {
            dispose: function dispose() {
                return subscription.unsubscribe();
            }
        };
    };
    _proto.check = function check(operation) {
        if (this._missingFieldHandlers.length === 0 && !$3d0bde05b4ad1f1c$var$operationHasClientAbstractTypes(operation)) return this._store.check(operation);
        return this._checkSelectorAndHandleMissingFields(operation, this._missingFieldHandlers);
    };
    _proto.commitPayload = function commitPayload(operation, payload) {
        this._execute({
            createSource: function createSource() {
                return $5k1AH.from({
                    data: payload
                });
            },
            isClientPayload: true,
            operation: operation,
            optimisticConfig: null,
            updater: null
        }).subscribe({});
    };
    _proto.commitUpdate = function commitUpdate(updater) {
        var _this5 = this;
        this._scheduleUpdates(function() {
            _this5._publishQueue.commitUpdate(updater);
            _this5._publishQueue.run();
        });
    };
    _proto.lookup = function lookup(readSelector) {
        return this._store.lookup(readSelector);
    };
    _proto.subscribe = function subscribe(snapshot, callback) {
        return this._store.subscribe(snapshot, callback);
    };
    _proto.retain = function retain(operation) {
        return this._store.retain(operation);
    };
    _proto.isServer = function isServer() {
        return this._isServer;
    };
    _proto._checkSelectorAndHandleMissingFields = function _checkSelectorAndHandleMissingFields(operation, handlers) {
        var _this6 = this;
        var target = $7eJdF.create();
        var source = this._store.getSource();
        var result = this._store.check(operation, {
            handlers: handlers,
            defaultActorIdentifier: $3d0bde05b4ad1f1c$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE,
            getSourceForActor: function getSourceForActor(actorIdentifier) {
                $3d0bde05b4ad1f1c$var$assertInternalActorIdentifier(actorIdentifier);
                return source;
            },
            getTargetForActor: function getTargetForActor(actorIdentifier) {
                $3d0bde05b4ad1f1c$var$assertInternalActorIdentifier(actorIdentifier);
                return target;
            }
        });
        if (target.size() > 0) this._scheduleUpdates(function() {
            _this6._publishQueue.commitSource(target);
            _this6._publishQueue.run();
        });
        return result;
    };
    _proto._scheduleUpdates = function _scheduleUpdates(task) {
        var scheduler = this._scheduler;
        if (scheduler != null) scheduler.schedule(task);
        else task();
    };
    _proto.execute = function execute(_ref) {
        var _this7 = this;
        var operation = _ref.operation;
        return this._execute({
            createSource: function createSource() {
                return _this7.getNetwork().execute(operation.request.node.params, operation.request.variables, operation.request.cacheConfig || {}, null);
            },
            isClientPayload: false,
            operation: operation,
            optimisticConfig: null,
            updater: null
        });
    };
    _proto.executeSubscription = function executeSubscription(_ref2) {
        var _this8 = this;
        var operation = _ref2.operation, updater = _ref2.updater;
        return this._execute({
            createSource: function createSource() {
                return _this8.getNetwork().execute(operation.request.node.params, operation.request.variables, operation.request.cacheConfig || {}, null);
            },
            isClientPayload: false,
            operation: operation,
            optimisticConfig: null,
            updater: updater
        });
    };
    _proto.executeMutation = function executeMutation(_ref3) {
        var _this9 = this;
        var operation = _ref3.operation, optimisticResponse = _ref3.optimisticResponse, optimisticUpdater = _ref3.optimisticUpdater, updater = _ref3.updater, uploadables = _ref3.uploadables;
        var optimisticConfig;
        if (optimisticResponse || optimisticUpdater) optimisticConfig = {
            operation: operation,
            response: optimisticResponse,
            updater: optimisticUpdater
        };
        return this._execute({
            createSource: function createSource() {
                return _this9.getNetwork().execute(operation.request.node.params, operation.request.variables, (0, $3d0bde05b4ad1f1c$var$_objectSpread2["default"])((0, $3d0bde05b4ad1f1c$var$_objectSpread2["default"])({}, operation.request.cacheConfig), {}, {
                    force: true
                }), uploadables);
            },
            isClientPayload: false,
            operation: operation,
            optimisticConfig: optimisticConfig,
            updater: updater
        });
    };
    _proto.executeWithSource = function executeWithSource(_ref4) {
        var operation = _ref4.operation, source = _ref4.source;
        return this._execute({
            createSource: function createSource() {
                return source;
            },
            isClientPayload: false,
            operation: operation,
            optimisticConfig: null,
            updater: null
        });
    };
    _proto.toJSON = function toJSON() {
        var _this$configName;
        return "RelayModernEnvironment(".concat((_this$configName = this.configName) !== null && _this$configName !== void 0 ? _this$configName : '', ")");
    };
    _proto._execute = function _execute(_ref5) {
        var _this10 = this;
        var createSource = _ref5.createSource, isClientPayload = _ref5.isClientPayload, operation = _ref5.operation, optimisticConfig = _ref5.optimisticConfig, updater = _ref5.updater;
        var publishQueue = this._publishQueue;
        var store = this._store;
        return $5k1AH.create(function(sink) {
            var executor = $cvQ1X.execute({
                actorIdentifier: $3d0bde05b4ad1f1c$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE,
                getDataID: _this10._getDataID,
                isClientPayload: isClientPayload,
                log: _this10.__log,
                operation: operation,
                operationExecutions: _this10._operationExecutions,
                operationLoader: _this10._operationLoader,
                operationTracker: _this10._operationTracker,
                optimisticConfig: optimisticConfig,
                getPublishQueue: function getPublishQueue(actorIdentifier) {
                    $3d0bde05b4ad1f1c$var$assertInternalActorIdentifier(actorIdentifier);
                    return publishQueue;
                },
                scheduler: _this10._scheduler,
                shouldProcessClientComponents: _this10._shouldProcessClientComponents,
                sink: sink,
                source: createSource(),
                getStore: function getStore(actorIdentifier) {
                    $3d0bde05b4ad1f1c$var$assertInternalActorIdentifier(actorIdentifier);
                    return store;
                },
                treatMissingFieldsAsNull: _this10._treatMissingFieldsAsNull,
                updater: updater,
                normalizeResponse: _this10._normalizeResponse
            });
            return function() {
                return executor.cancel();
            };
        });
    };
    return RelayModernEnvironment;
}();
function $3d0bde05b4ad1f1c$var$operationHasClientAbstractTypes(operation) {
    return operation.root.node.kind === 'Operation' && operation.root.node.clientAbstractTypes != null;
}
$3d0bde05b4ad1f1c$var$RelayModernEnvironment.prototype['@@RelayModernEnvironment'] = true;
function $3d0bde05b4ad1f1c$var$emptyFunction() {}
module.exports = $3d0bde05b4ad1f1c$var$RelayModernEnvironment;

});
parcelRegister("jRAe8", function(module, exports) {
'use strict';

var $bH6k0 = parcelRequire("bH6k0");
function $e75f117a8457b40d$var$wrapNetworkWithLogObserver(env, network) {
    return {
        execute: function execute(params, variables, cacheConfig, uploadables) {
            var networkRequestId = $bH6k0();
            var logObserver = {
                start: function start(subscription) {
                    env.__log({
                        name: 'network.start',
                        networkRequestId: networkRequestId,
                        params: params,
                        variables: variables,
                        cacheConfig: cacheConfig
                    });
                },
                next: function next(response) {
                    env.__log({
                        name: 'network.next',
                        networkRequestId: networkRequestId,
                        response: response
                    });
                },
                error: function error(_error) {
                    env.__log({
                        name: 'network.error',
                        networkRequestId: networkRequestId,
                        error: _error
                    });
                },
                complete: function complete() {
                    env.__log({
                        name: 'network.complete',
                        networkRequestId: networkRequestId
                    });
                },
                unsubscribe: function unsubscribe() {
                    env.__log({
                        name: 'network.unsubscribe',
                        networkRequestId: networkRequestId
                    });
                }
            };
            var logRequestInfo = function logRequestInfo(info) {
                env.__log({
                    name: 'network.info',
                    networkRequestId: networkRequestId,
                    info: info
                });
            };
            return network.execute(params, variables, cacheConfig, uploadables, logRequestInfo)["do"](logObserver);
        }
    };
}
module.exports = $e75f117a8457b40d$var$wrapNetworkWithLogObserver;

});
parcelRegister("bH6k0", function(module, exports) {
'use strict';
var $88389d3d2f707c30$var$id = 100000;
function $88389d3d2f707c30$var$generateID() {
    return $88389d3d2f707c30$var$id++;
}
module.exports = $88389d3d2f707c30$var$generateID;

});


parcelRegister("cnpJc", function(module, exports) {
'use strict';

var $7Wmh0 = parcelRequire("7Wmh0");
var $902b971362e81e75$var$_interopRequireDefault = $7Wmh0.default;

var $902b971362e81e75$var$_createForOfIteratorHelper2 = $902b971362e81e75$var$_interopRequireDefault((parcelRequire("9CLQ8")));

var $423Vm = parcelRequire("423Vm");
var $902b971362e81e75$var$RelayOperationTracker = /*#__PURE__*/ function() {
    function RelayOperationTracker() {
        this._ownersToPendingOperations = new Map();
        this._pendingOperationsToOwners = new Map();
        this._ownersToPendingPromise = new Map();
    }
    var _proto = RelayOperationTracker.prototype;
    _proto.update = function update(pendingOperation, affectedOwners) {
        if (affectedOwners.size === 0) return;
        var pendingOperationIdentifier = pendingOperation.identifier;
        var newlyAffectedOwnersIdentifier = new Set();
        var _iterator = (0, $902b971362e81e75$var$_createForOfIteratorHelper2["default"])(affectedOwners), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var owner = _step.value;
                var ownerIdentifier = owner.identifier;
                var pendingOperationsAffectingOwner = this._ownersToPendingOperations.get(ownerIdentifier);
                if (pendingOperationsAffectingOwner != null) {
                    if (!pendingOperationsAffectingOwner.has(pendingOperationIdentifier)) {
                        pendingOperationsAffectingOwner.set(pendingOperationIdentifier, pendingOperation);
                        newlyAffectedOwnersIdentifier.add(ownerIdentifier);
                    }
                } else {
                    this._ownersToPendingOperations.set(ownerIdentifier, new Map([
                        [
                            pendingOperationIdentifier,
                            pendingOperation
                        ]
                    ]));
                    newlyAffectedOwnersIdentifier.add(ownerIdentifier);
                }
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        if (newlyAffectedOwnersIdentifier.size === 0) return;
        var ownersAffectedByPendingOperation = this._pendingOperationsToOwners.get(pendingOperationIdentifier) || new Set();
        var _iterator2 = (0, $902b971362e81e75$var$_createForOfIteratorHelper2["default"])(newlyAffectedOwnersIdentifier), _step2;
        try {
            for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                var _ownerIdentifier = _step2.value;
                this._resolveOwnerResolvers(_ownerIdentifier);
                ownersAffectedByPendingOperation.add(_ownerIdentifier);
            }
        } catch (err) {
            _iterator2.e(err);
        } finally{
            _iterator2.f();
        }
        this._pendingOperationsToOwners.set(pendingOperationIdentifier, ownersAffectedByPendingOperation);
    };
    _proto.complete = function complete(pendingOperation) {
        var pendingOperationIdentifier = pendingOperation.identifier;
        var affectedOwnersIdentifier = this._pendingOperationsToOwners.get(pendingOperationIdentifier);
        if (affectedOwnersIdentifier == null) return;
        var completedOwnersIdentifier = new Set();
        var updatedOwnersIdentifier = new Set();
        var _iterator3 = (0, $902b971362e81e75$var$_createForOfIteratorHelper2["default"])(affectedOwnersIdentifier), _step3;
        try {
            for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                var ownerIdentifier = _step3.value;
                var pendingOperationsAffectingOwner = this._ownersToPendingOperations.get(ownerIdentifier);
                if (!pendingOperationsAffectingOwner) continue;
                pendingOperationsAffectingOwner["delete"](pendingOperationIdentifier);
                if (pendingOperationsAffectingOwner.size > 0) updatedOwnersIdentifier.add(ownerIdentifier);
                else completedOwnersIdentifier.add(ownerIdentifier);
            }
        } catch (err) {
            _iterator3.e(err);
        } finally{
            _iterator3.f();
        }
        var _iterator4 = (0, $902b971362e81e75$var$_createForOfIteratorHelper2["default"])(completedOwnersIdentifier), _step4;
        try {
            for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                var _ownerIdentifier2 = _step4.value;
                this._resolveOwnerResolvers(_ownerIdentifier2);
                this._ownersToPendingOperations["delete"](_ownerIdentifier2);
            }
        } catch (err) {
            _iterator4.e(err);
        } finally{
            _iterator4.f();
        }
        var _iterator5 = (0, $902b971362e81e75$var$_createForOfIteratorHelper2["default"])(updatedOwnersIdentifier), _step5;
        try {
            for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                var _ownerIdentifier3 = _step5.value;
                this._resolveOwnerResolvers(_ownerIdentifier3);
            }
        } catch (err) {
            _iterator5.e(err);
        } finally{
            _iterator5.f();
        }
        this._pendingOperationsToOwners["delete"](pendingOperationIdentifier);
    };
    _proto._resolveOwnerResolvers = function _resolveOwnerResolvers(ownerIdentifier) {
        var promiseEntry = this._ownersToPendingPromise.get(ownerIdentifier);
        if (promiseEntry != null) promiseEntry.resolve();
        this._ownersToPendingPromise["delete"](ownerIdentifier);
    };
    _proto.getPendingOperationsAffectingOwner = function getPendingOperationsAffectingOwner(owner) {
        var ownerIdentifier = owner.identifier;
        var pendingOperationsForOwner = this._ownersToPendingOperations.get(ownerIdentifier);
        if (pendingOperationsForOwner == null || pendingOperationsForOwner.size === 0) return null;
        var cachedPromiseEntry = this._ownersToPendingPromise.get(ownerIdentifier);
        if (cachedPromiseEntry != null) return {
            promise: cachedPromiseEntry.promise,
            pendingOperations: cachedPromiseEntry.pendingOperations
        };
        var resolve;
        var promise = new Promise(function(r) {
            resolve = r;
        });
        !(resolve != null) && $423Vm(false);
        var pendingOperations = Array.from(pendingOperationsForOwner.values());
        this._ownersToPendingPromise.set(ownerIdentifier, {
            promise: promise,
            resolve: resolve,
            pendingOperations: pendingOperations
        });
        return {
            promise: promise,
            pendingOperations: pendingOperations
        };
    };
    return RelayOperationTracker;
}();
module.exports = $902b971362e81e75$var$RelayOperationTracker;

});

parcelRegister("brAuk", function(module, exports) {
'use strict';
function $854e85213000c4f2$var$registerEnvironmentWithDevTools(environment) {
    var _global = typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : undefined;
    var devToolsHook = _global && _global.__RELAY_DEVTOOLS_HOOK__;
    if (devToolsHook) devToolsHook.registerEnvironment(environment);
}
module.exports = $854e85213000c4f2$var$registerEnvironmentWithDevTools;

});

parcelRegister("kA5Gq", function(module, exports) {
'use strict';

var $ap10a = parcelRequire("ap10a");
var $efbb9404fb8e5bba$var$VIEWER_ID = $ap10a.VIEWER_ID, $efbb9404fb8e5bba$var$VIEWER_TYPE = $ap10a.VIEWER_TYPE;
function $efbb9404fb8e5bba$var$defaultGetDataID(fieldValue, typeName) {
    if (typeName === $efbb9404fb8e5bba$var$VIEWER_TYPE) return fieldValue.id == null ? $efbb9404fb8e5bba$var$VIEWER_ID : fieldValue.id;
    return fieldValue.id;
}
module.exports = $efbb9404fb8e5bba$var$defaultGetDataID;

});
parcelRegister("ap10a", function(module, exports) {
'use strict';

var $axs8G = parcelRequire("axs8G");
var $792d04147ad989e6$var$generateClientID = $axs8G.generateClientID;

var $f91UN = parcelRequire("f91UN");
var $792d04147ad989e6$var$ROOT_ID = $f91UN.ROOT_ID;
var $792d04147ad989e6$var$VIEWER_ID = $792d04147ad989e6$var$generateClientID($792d04147ad989e6$var$ROOT_ID, 'viewer');
var $792d04147ad989e6$var$VIEWER_TYPE = 'Viewer';
module.exports = {
    VIEWER_ID: $792d04147ad989e6$var$VIEWER_ID,
    VIEWER_TYPE: $792d04147ad989e6$var$VIEWER_TYPE
};

});


parcelRegister("dQl2P", function(module, exports) {
'use strict';
var $a14074b1e546167a$var$defaultRelayFieldLogger = function defaultRelayFieldLogger(event) {};
module.exports = $a14074b1e546167a$var$defaultRelayFieldLogger;

});

parcelRegister("cvQ1X", function(module, exports) {
'use strict';

var $7Wmh0 = parcelRequire("7Wmh0");
var $91c0bd7aa3a2480f$var$_interopRequireDefault = $7Wmh0.default;

var $91c0bd7aa3a2480f$var$_createForOfIteratorHelper2 = $91c0bd7aa3a2480f$var$_interopRequireDefault((parcelRequire("9CLQ8")));

var $91c0bd7aa3a2480f$var$_toConsumableArray2 = $91c0bd7aa3a2480f$var$_interopRequireDefault((parcelRequire("gHCmS")));

var $5k1AH = parcelRequire("5k1AH");

var $bH6k0 = parcelRequire("bH6k0");

var $lTsrN = parcelRequire("lTsrN");

var $l4x3v = parcelRequire("l4x3v");

var $llkIA = parcelRequire("llkIA");

var $4cAcq = parcelRequire("4cAcq");

var $8uKTH = parcelRequire("8uKTH");

var $axs8G = parcelRequire("axs8G");
var $91c0bd7aa3a2480f$var$generateClientID = $axs8G.generateClientID, $91c0bd7aa3a2480f$var$generateUniqueClientID = $axs8G.generateUniqueClientID;

var $frIyf = parcelRequire("frIyf");
var $91c0bd7aa3a2480f$var$getLocalVariables = $frIyf.getLocalVariables;

var $fagih = parcelRequire("fagih");

var $g432U = parcelRequire("g432U");
var $91c0bd7aa3a2480f$var$createNormalizationSelector = $g432U.createNormalizationSelector, $91c0bd7aa3a2480f$var$createReaderSelector = $g432U.createReaderSelector;

var $7eJdF = parcelRequire("7eJdF");

var $f91UN = parcelRequire("f91UN");
var $91c0bd7aa3a2480f$var$ROOT_TYPE = $f91UN.ROOT_TYPE, $91c0bd7aa3a2480f$var$TYPENAME_KEY = $f91UN.TYPENAME_KEY, $91c0bd7aa3a2480f$var$getStorageKey = $f91UN.getStorageKey;

var $423Vm = parcelRequire("423Vm");
parcelRequire("dH6ue");
function $91c0bd7aa3a2480f$var$execute(config) {
    return new $91c0bd7aa3a2480f$var$Executor(config);
}
var $91c0bd7aa3a2480f$var$Executor = /*#__PURE__*/ function() {
    function Executor(_ref2) {
        var _this = this;
        var actorIdentifier = _ref2.actorIdentifier, getDataID = _ref2.getDataID, getPublishQueue = _ref2.getPublishQueue, getStore = _ref2.getStore, isClientPayload = _ref2.isClientPayload, operation = _ref2.operation, operationExecutions = _ref2.operationExecutions, operationLoader = _ref2.operationLoader, operationTracker = _ref2.operationTracker, optimisticConfig = _ref2.optimisticConfig, scheduler = _ref2.scheduler, shouldProcessClientComponents = _ref2.shouldProcessClientComponents, sink = _ref2.sink, source = _ref2.source, treatMissingFieldsAsNull = _ref2.treatMissingFieldsAsNull, updater = _ref2.updater, log = _ref2.log, normalizeResponse = _ref2.normalizeResponse;
        this._actorIdentifier = actorIdentifier;
        this._getDataID = getDataID;
        this._treatMissingFieldsAsNull = treatMissingFieldsAsNull;
        this._incrementalPayloadsPending = false;
        this._incrementalResults = new Map();
        this._log = log;
        this._executeId = $bH6k0();
        this._nextSubscriptionId = 0;
        this._operation = operation;
        this._operationExecutions = operationExecutions;
        this._operationLoader = operationLoader;
        this._operationTracker = operationTracker;
        this._operationUpdateEpochs = new Map();
        this._optimisticUpdates = null;
        this._pendingModulePayloadsCount = 0;
        this._getPublishQueue = getPublishQueue;
        this._scheduler = scheduler;
        this._sink = sink;
        this._source = new Map();
        this._state = 'started';
        this._getStore = getStore;
        this._subscriptions = new Map();
        this._updater = updater;
        this._isClientPayload = isClientPayload === true;
        this._isSubscriptionOperation = this._operation.request.node.params.operationKind === 'subscription';
        this._shouldProcessClientComponents = shouldProcessClientComponents;
        this._retainDisposables = new Map();
        this._seenActors = new Set();
        this._completeFns = [];
        this._normalizeResponse = normalizeResponse;
        var id = this._nextSubscriptionId++;
        if ($llkIA.PROCESS_OPTIMISTIC_UPDATE_BEFORE_SUBSCRIPTION && optimisticConfig != null) this._processOptimisticResponse(optimisticConfig.response != null ? {
            data: optimisticConfig.response
        } : null, optimisticConfig.updater, false);
        source.subscribe({
            complete: function complete() {
                return _this._complete(id);
            },
            error: function error(_error2) {
                return _this._error(_error2);
            },
            next: function next(response) {
                try {
                    _this._next(id, response);
                } catch (error) {
                    sink.error(error);
                }
            },
            start: function start(subscription) {
                var _this$_operation$requ;
                _this._start(id, subscription);
                _this._log({
                    name: 'execute.start',
                    executeId: _this._executeId,
                    params: _this._operation.request.node.params,
                    variables: _this._operation.request.variables,
                    cacheConfig: (_this$_operation$requ = _this._operation.request.cacheConfig) !== null && _this$_operation$requ !== void 0 ? _this$_operation$requ : {}
                });
            }
        });
        if (!$llkIA.PROCESS_OPTIMISTIC_UPDATE_BEFORE_SUBSCRIPTION && optimisticConfig != null) this._processOptimisticResponse(optimisticConfig.response != null ? {
            data: optimisticConfig.response
        } : null, optimisticConfig.updater, false);
    }
    var _proto = Executor.prototype;
    _proto.cancel = function cancel() {
        var _this2 = this;
        if (this._state === 'completed') return;
        this._state = 'completed';
        this._operationExecutions["delete"](this._operation.request.identifier);
        if (this._subscriptions.size !== 0) {
            this._subscriptions.forEach(function(sub) {
                return sub.unsubscribe();
            });
            this._subscriptions.clear();
        }
        var optimisticUpdates = this._optimisticUpdates;
        if (optimisticUpdates !== null) {
            this._optimisticUpdates = null;
            optimisticUpdates.forEach(function(update) {
                return _this2._getPublishQueueAndSaveActor().revertUpdate(update);
            });
            this._runPublishQueue();
        }
        this._incrementalResults.clear();
        if (this._asyncStoreUpdateDisposable != null) {
            this._asyncStoreUpdateDisposable.dispose();
            this._asyncStoreUpdateDisposable = null;
        }
        this._completeFns = [];
        this._completeOperationTracker();
        this._disposeRetainedData();
    };
    _proto._updateActiveState = function _updateActiveState() {
        var activeState;
        switch(this._state){
            case 'started':
                activeState = 'active';
                break;
            case 'loading_incremental':
                activeState = 'active';
                break;
            case 'completed':
                activeState = 'inactive';
                break;
            case 'loading_final':
                activeState = this._pendingModulePayloadsCount > 0 ? 'active' : 'inactive';
                break;
            default:
                this._state;
                $423Vm(false);
        }
        this._operationExecutions.set(this._operation.request.identifier, activeState);
    };
    _proto._schedule = function _schedule(task) {
        var _this3 = this;
        var scheduler = this._scheduler;
        if (scheduler != null) {
            var id = this._nextSubscriptionId++;
            $5k1AH.create(function(sink) {
                var cancellationToken = scheduler.schedule(function() {
                    try {
                        task();
                        sink.complete();
                    } catch (error) {
                        sink.error(error);
                    }
                });
                return function() {
                    return scheduler.cancel(cancellationToken);
                };
            }).subscribe({
                complete: function complete() {
                    return _this3._complete(id);
                },
                error: function error(_error3) {
                    return _this3._error(_error3);
                },
                start: function start(subscription) {
                    return _this3._start(id, subscription);
                }
            });
        } else task();
    };
    _proto._complete = function _complete(id) {
        this._subscriptions["delete"](id);
        if (this._subscriptions.size === 0) {
            this.cancel();
            this._sink.complete();
            this._log({
                name: 'execute.complete',
                executeId: this._executeId
            });
        }
    };
    _proto._error = function _error(error) {
        this.cancel();
        this._sink.error(error);
        this._log({
            name: 'execute.error',
            executeId: this._executeId,
            error: error
        });
    };
    _proto._start = function _start(id, subscription) {
        this._subscriptions.set(id, subscription);
        this._updateActiveState();
    };
    _proto._next = function _next(_id, response) {
        var _this4 = this;
        this._schedule(function() {
            var _withDuration = $8uKTH(function() {
                _this4._handleNext(response);
                _this4._maybeCompleteSubscriptionOperationTracking();
            }), duration = _withDuration[0];
            _this4._log({
                name: 'execute.next',
                executeId: _this4._executeId,
                response: response,
                duration: duration
            });
        });
    };
    _proto._handleErrorResponse = function _handleErrorResponse(responses) {
        var _this5 = this;
        var results = [];
        responses.forEach(function(response) {
            if (response.data === null && response.extensions != null && !response.hasOwnProperty('errors')) return;
            else if (response.data == null) {
                var errors = response.hasOwnProperty('errors') && response.errors != null ? response.errors : null;
                var messages = errors ? errors.map(function(_ref3) {
                    var message = _ref3.message;
                    return message;
                }).join('\n') : '(No errors)';
                var error = $l4x3v.create('RelayNetwork', 'No data returned for operation `' + _this5._operation.request.node.params.name + '`, got error(s):\n' + messages + '\n\nSee the error `source` property for more information.');
                error.source = {
                    errors: errors,
                    operation: _this5._operation.request.node,
                    variables: _this5._operation.request.variables
                };
                error.stack;
                throw error;
            } else {
                var responseWithData = response;
                results.push(responseWithData);
            }
        });
        return results;
    };
    _proto._handleOptimisticResponses = function _handleOptimisticResponses(responses) {
        var _response$extensions;
        if (responses.length > 1) {
            if (responses.some(function(responsePart) {
                var _responsePart$extensi;
                return ((_responsePart$extensi = responsePart.extensions) === null || _responsePart$extensi === void 0 ? void 0 : _responsePart$extensi.isOptimistic) === true;
            })) $423Vm(false);
            return false;
        }
        var response = responses[0];
        var isOptimistic = ((_response$extensions = response.extensions) === null || _response$extensions === void 0 ? void 0 : _response$extensions.isOptimistic) === true;
        if (isOptimistic && this._state !== 'started') $423Vm(false);
        if (isOptimistic) {
            this._processOptimisticResponse(response, null, this._treatMissingFieldsAsNull);
            this._sink.next(response);
            return true;
        }
        return false;
    };
    _proto._handleNext = function _handleNext(response) {
        if (this._state === 'completed') return;
        this._seenActors.clear();
        var responses = Array.isArray(response) ? response : [
            response
        ];
        var responsesWithData = this._handleErrorResponse(responses);
        if (responsesWithData.length === 0) {
            var isFinal = responses.some(function(x) {
                var _x$extensions;
                return ((_x$extensions = x.extensions) === null || _x$extensions === void 0 ? void 0 : _x$extensions.is_final) === true;
            });
            if (isFinal) {
                this._state = 'loading_final';
                this._updateActiveState();
                this._incrementalPayloadsPending = false;
            }
            this._sink.next(response);
            return;
        }
        var isOptimistic = this._handleOptimisticResponses(responsesWithData);
        if (isOptimistic) return;
        var _partitionGraphQLResp = $91c0bd7aa3a2480f$var$partitionGraphQLResponses(responsesWithData), nonIncrementalResponses = _partitionGraphQLResp[0], incrementalResponses = _partitionGraphQLResp[1];
        var hasNonIncrementalResponses = nonIncrementalResponses.length > 0;
        if (hasNonIncrementalResponses) {
            if (this._isSubscriptionOperation) {
                var nextID = $91c0bd7aa3a2480f$var$generateUniqueClientID();
                this._operation = {
                    request: this._operation.request,
                    fragment: $91c0bd7aa3a2480f$var$createReaderSelector(this._operation.fragment.node, nextID, this._operation.fragment.variables, this._operation.fragment.owner),
                    root: $91c0bd7aa3a2480f$var$createNormalizationSelector(this._operation.root.node, nextID, this._operation.root.variables)
                };
            }
            var payloadFollowups = this._processResponses(nonIncrementalResponses);
            this._processPayloadFollowups(payloadFollowups);
        }
        if (incrementalResponses.length > 0) {
            var _payloadFollowups = this._processIncrementalResponses(incrementalResponses);
            this._processPayloadFollowups(_payloadFollowups);
        }
        if (this._isSubscriptionOperation) {
            if (responsesWithData[0].extensions == null) responsesWithData[0].extensions = {
                __relay_subscription_root_id: this._operation.fragment.dataID
            };
            else responsesWithData[0].extensions.__relay_subscription_root_id = this._operation.fragment.dataID;
        }
        var updatedOwners = this._runPublishQueue(hasNonIncrementalResponses ? this._operation : undefined);
        if (hasNonIncrementalResponses) {
            if (this._incrementalPayloadsPending) this._retainData();
        }
        this._updateOperationTracker(updatedOwners);
        this._sink.next(response);
    };
    _proto._processOptimisticResponse = function _processOptimisticResponse(response, updater, treatMissingFieldsAsNull) {
        var _this6 = this;
        !(this._optimisticUpdates === null) && $423Vm(false);
        if (response == null && updater == null) return;
        var optimisticUpdates = [];
        if (response) {
            var payload = this._normalizeResponse(response, this._operation.root, $91c0bd7aa3a2480f$var$ROOT_TYPE, {
                actorIdentifier: this._actorIdentifier,
                getDataID: this._getDataID,
                path: [],
                shouldProcessClientComponents: this._shouldProcessClientComponents,
                treatMissingFieldsAsNull: treatMissingFieldsAsNull
            });
            $91c0bd7aa3a2480f$var$validateOptimisticResponsePayload(payload);
            optimisticUpdates.push({
                operation: this._operation,
                payload: payload,
                updater: updater
            });
            this._processOptimisticFollowups(payload, optimisticUpdates);
        } else if (updater) optimisticUpdates.push({
            operation: this._operation,
            payload: {
                errors: null,
                fieldPayloads: null,
                incrementalPlaceholders: null,
                followupPayloads: null,
                source: $7eJdF.create(),
                isFinal: false
            },
            updater: updater
        });
        this._optimisticUpdates = optimisticUpdates;
        optimisticUpdates.forEach(function(update) {
            return _this6._getPublishQueueAndSaveActor().applyUpdate(update);
        });
        var updatedOwners = this._runPublishQueue();
        if ($llkIA.ENABLE_OPERATION_TRACKER_OPTIMISTIC_UPDATES) this._updateOperationTracker(updatedOwners);
    };
    _proto._processOptimisticFollowups = function _processOptimisticFollowups(payload, optimisticUpdates) {
        if (payload.followupPayloads && payload.followupPayloads.length) {
            var followupPayloads = payload.followupPayloads;
            var _iterator = (0, $91c0bd7aa3a2480f$var$_createForOfIteratorHelper2["default"])(followupPayloads), _step;
            try {
                for(_iterator.s(); !(_step = _iterator.n()).done;){
                    var followupPayload = _step.value;
                    switch(followupPayload.kind){
                        case 'ModuleImportPayload':
                            var operationLoader = this._expectOperationLoader();
                            var operation = operationLoader.get(followupPayload.operationReference);
                            if (operation == null) this._processAsyncOptimisticModuleImport(followupPayload);
                            else {
                                var moduleImportOptimisticUpdates = this._processOptimisticModuleImport(operation, followupPayload);
                                optimisticUpdates.push.apply(optimisticUpdates, (0, $91c0bd7aa3a2480f$var$_toConsumableArray2["default"])(moduleImportOptimisticUpdates));
                            }
                            break;
                        case 'ActorPayload':
                            break;
                        default:
                            followupPayload;
                            $423Vm(false);
                    }
                }
            } catch (err) {
                _iterator.e(err);
            } finally{
                _iterator.f();
            }
        }
    };
    _proto._normalizeFollowupPayload = function _normalizeFollowupPayload(followupPayload, normalizationNode) {
        var variables;
        if (normalizationNode.kind === 'SplitOperation' && followupPayload.kind === 'ModuleImportPayload') variables = $91c0bd7aa3a2480f$var$getLocalVariables(followupPayload.variables, normalizationNode.argumentDefinitions, followupPayload.args);
        else variables = followupPayload.variables;
        var selector = $91c0bd7aa3a2480f$var$createNormalizationSelector(normalizationNode, followupPayload.dataID, variables);
        return this._normalizeResponse({
            data: followupPayload.data
        }, selector, followupPayload.typeName, {
            actorIdentifier: this._actorIdentifier,
            getDataID: this._getDataID,
            path: followupPayload.path,
            treatMissingFieldsAsNull: this._treatMissingFieldsAsNull,
            shouldProcessClientComponents: this._shouldProcessClientComponents
        });
    };
    _proto._processOptimisticModuleImport = function _processOptimisticModuleImport(normalizationRootNode, moduleImportPayload) {
        var operation = $lTsrN(normalizationRootNode);
        var optimisticUpdates = [];
        var modulePayload = this._normalizeFollowupPayload(moduleImportPayload, operation);
        $91c0bd7aa3a2480f$var$validateOptimisticResponsePayload(modulePayload);
        optimisticUpdates.push({
            operation: this._operation,
            payload: modulePayload,
            updater: null
        });
        this._processOptimisticFollowups(modulePayload, optimisticUpdates);
        return optimisticUpdates;
    };
    _proto._processAsyncOptimisticModuleImport = function _processAsyncOptimisticModuleImport(moduleImportPayload) {
        var _this7 = this;
        this._expectOperationLoader().load(moduleImportPayload.operationReference).then(function(operation) {
            if (operation == null || _this7._state !== 'started') return;
            var moduleImportOptimisticUpdates = _this7._processOptimisticModuleImport(operation, moduleImportPayload);
            moduleImportOptimisticUpdates.forEach(function(update) {
                return _this7._getPublishQueueAndSaveActor().applyUpdate(update);
            });
            if (_this7._optimisticUpdates == null) ;
            else {
                var _this$_optimisticUpda;
                (_this$_optimisticUpda = _this7._optimisticUpdates).push.apply(_this$_optimisticUpda, (0, $91c0bd7aa3a2480f$var$_toConsumableArray2["default"])(moduleImportOptimisticUpdates));
                _this7._runPublishQueue();
            }
        });
    };
    _proto._processResponses = function _processResponses(responses) {
        var _this8 = this;
        if (this._optimisticUpdates !== null) {
            this._optimisticUpdates.forEach(function(update) {
                _this8._getPublishQueueAndSaveActor().revertUpdate(update);
            });
            this._optimisticUpdates = null;
        }
        this._incrementalPayloadsPending = false;
        this._incrementalResults.clear();
        this._source.clear();
        return responses.map(function(payloadPart) {
            var relayPayload = _this8._normalizeResponse(payloadPart, _this8._operation.root, $91c0bd7aa3a2480f$var$ROOT_TYPE, {
                actorIdentifier: _this8._actorIdentifier,
                getDataID: _this8._getDataID,
                path: [],
                treatMissingFieldsAsNull: _this8._treatMissingFieldsAsNull,
                shouldProcessClientComponents: _this8._shouldProcessClientComponents
            });
            _this8._getPublishQueueAndSaveActor().commitPayload(_this8._operation, relayPayload, _this8._updater);
            return relayPayload;
        });
    };
    _proto._processPayloadFollowups = function _processPayloadFollowups(payloads) {
        var _this9 = this;
        if (this._state === 'completed') return;
        payloads.forEach(function(payload) {
            var incrementalPlaceholders = payload.incrementalPlaceholders, followupPayloads = payload.followupPayloads, isFinal = payload.isFinal;
            _this9._state = isFinal ? 'loading_final' : 'loading_incremental';
            _this9._updateActiveState();
            if (isFinal) _this9._incrementalPayloadsPending = false;
            if (followupPayloads && followupPayloads.length !== 0) followupPayloads.forEach(function(followupPayload) {
                var _followupPayload$acto;
                var prevActorIdentifier = _this9._actorIdentifier;
                _this9._actorIdentifier = (_followupPayload$acto = followupPayload.actorIdentifier) !== null && _followupPayload$acto !== void 0 ? _followupPayload$acto : _this9._actorIdentifier;
                _this9._processFollowupPayload(followupPayload);
                _this9._actorIdentifier = prevActorIdentifier;
            });
            if (incrementalPlaceholders && incrementalPlaceholders.length !== 0) {
                _this9._incrementalPayloadsPending = _this9._state !== 'loading_final';
                incrementalPlaceholders.forEach(function(incrementalPlaceholder) {
                    var _incrementalPlacehold;
                    var prevActorIdentifier = _this9._actorIdentifier;
                    _this9._actorIdentifier = (_incrementalPlacehold = incrementalPlaceholder.actorIdentifier) !== null && _incrementalPlacehold !== void 0 ? _incrementalPlacehold : _this9._actorIdentifier;
                    _this9._processIncrementalPlaceholder(payload, incrementalPlaceholder);
                    _this9._actorIdentifier = prevActorIdentifier;
                });
                if (_this9._isClientPayload || _this9._state === 'loading_final') {
                    var relayPayloads = [];
                    incrementalPlaceholders.forEach(function(placeholder) {
                        if (placeholder.kind === 'defer') relayPayloads.push(_this9._processDeferResponse(placeholder.label, placeholder.path, placeholder, {
                            data: placeholder.data
                        }));
                    });
                    if (relayPayloads.length > 0) _this9._processPayloadFollowups(relayPayloads);
                }
            }
        });
    };
    _proto._maybeCompleteSubscriptionOperationTracking = function _maybeCompleteSubscriptionOperationTracking() {
        if (!this._isSubscriptionOperation) return;
        if (this._pendingModulePayloadsCount === 0 && this._incrementalPayloadsPending === false) this._completeOperationTracker();
    };
    _proto._processFollowupPayload = function _processFollowupPayload(followupPayload) {
        var _this10 = this;
        switch(followupPayload.kind){
            case 'ModuleImportPayload':
                var operationLoader = this._expectOperationLoader();
                var node = operationLoader.get(followupPayload.operationReference);
                if (node != null) this._processFollowupPayloadWithNormalizationNode(followupPayload, $lTsrN(node));
                else {
                    var id = this._nextSubscriptionId++;
                    this._pendingModulePayloadsCount++;
                    var decrementPendingCount = function decrementPendingCount() {
                        _this10._pendingModulePayloadsCount--;
                        _this10._maybeCompleteSubscriptionOperationTracking();
                    };
                    var networkObservable = $5k1AH.from(new Promise(function(resolve, reject) {
                        operationLoader.load(followupPayload.operationReference).then(resolve, reject);
                    }));
                    $5k1AH.create(function(sink) {
                        var cancellationToken;
                        var subscription = networkObservable.subscribe({
                            next: function next(loadedNode) {
                                if (loadedNode != null) {
                                    var publishModuleImportPayload = function publishModuleImportPayload() {
                                        try {
                                            var operation = $lTsrN(loadedNode);
                                            var batchAsyncModuleUpdatesFN = $llkIA.BATCH_ASYNC_MODULE_UPDATES_FN;
                                            var shouldScheduleAsyncStoreUpdate = batchAsyncModuleUpdatesFN != null && _this10._pendingModulePayloadsCount > 1;
                                            var _withDuration2 = $8uKTH(function() {
                                                _this10._handleFollowupPayload(followupPayload, operation);
                                                if (shouldScheduleAsyncStoreUpdate) _this10._scheduleAsyncStoreUpdate(batchAsyncModuleUpdatesFN, sink.complete);
                                                else {
                                                    var updatedOwners = _this10._runPublishQueue();
                                                    _this10._updateOperationTracker(updatedOwners);
                                                }
                                            }), duration = _withDuration2[0];
                                            _this10._log({
                                                name: 'execute.async.module',
                                                executeId: _this10._executeId,
                                                operationName: operation.name,
                                                duration: duration
                                            });
                                            if (!shouldScheduleAsyncStoreUpdate) sink.complete();
                                        } catch (error) {
                                            sink.error(error);
                                        }
                                    };
                                    var scheduler = _this10._scheduler;
                                    if (scheduler == null) publishModuleImportPayload();
                                    else cancellationToken = scheduler.schedule(publishModuleImportPayload);
                                } else sink.complete();
                            },
                            error: sink.error
                        });
                        return function() {
                            subscription.unsubscribe();
                            if (_this10._scheduler != null && cancellationToken != null) _this10._scheduler.cancel(cancellationToken);
                        };
                    }).subscribe({
                        complete: function complete() {
                            _this10._complete(id);
                            decrementPendingCount();
                        },
                        error: function error(_error4) {
                            _this10._error(_error4);
                            decrementPendingCount();
                        },
                        start: function start(subscription) {
                            return _this10._start(id, subscription);
                        }
                    });
                }
                break;
            case 'ActorPayload':
                this._processFollowupPayloadWithNormalizationNode(followupPayload, followupPayload.node);
                break;
            default:
                followupPayload;
                $423Vm(false);
        }
    };
    _proto._processFollowupPayloadWithNormalizationNode = function _processFollowupPayloadWithNormalizationNode(followupPayload, normalizationNode) {
        this._handleFollowupPayload(followupPayload, normalizationNode);
        this._maybeCompleteSubscriptionOperationTracking();
    };
    _proto._handleFollowupPayload = function _handleFollowupPayload(followupPayload, normalizationNode) {
        var relayPayload = this._normalizeFollowupPayload(followupPayload, normalizationNode);
        this._getPublishQueueAndSaveActor().commitPayload(this._operation, relayPayload);
        this._processPayloadFollowups([
            relayPayload
        ]);
    };
    _proto._processIncrementalPlaceholder = function _processIncrementalPlaceholder(relayPayload, placeholder) {
        var _relayPayload$fieldPa;
        var label = placeholder.label, path = placeholder.path;
        var pathKey = path.map(String).join('.');
        var resultForLabel = this._incrementalResults.get(label);
        if (resultForLabel == null) {
            resultForLabel = new Map();
            this._incrementalResults.set(label, resultForLabel);
        }
        var resultForPath = resultForLabel.get(pathKey);
        var pendingResponses = resultForPath != null && resultForPath.kind === 'response' ? resultForPath.responses : null;
        resultForLabel.set(pathKey, {
            kind: 'placeholder',
            placeholder: placeholder
        });
        var parentID;
        if (placeholder.kind === 'stream') parentID = placeholder.parentID;
        else if (placeholder.kind === 'defer') parentID = placeholder.selector.dataID;
        else {
            placeholder;
            $423Vm(false);
        }
        var parentRecord = relayPayload.source.get(parentID);
        var parentPayloads = ((_relayPayload$fieldPa = relayPayload.fieldPayloads) !== null && _relayPayload$fieldPa !== void 0 ? _relayPayload$fieldPa : []).filter(function(fieldPayload) {
            var fieldID = $91c0bd7aa3a2480f$var$generateClientID(fieldPayload.dataID, fieldPayload.fieldKey);
            return fieldPayload.dataID === parentID || fieldID === parentID;
        });
        !(parentRecord != null) && $423Vm(false);
        var nextParentRecord;
        var nextParentPayloads;
        var previousParentEntry = this._source.get(parentID);
        if (previousParentEntry != null) {
            nextParentRecord = $fagih.update(previousParentEntry.record, parentRecord);
            var handlePayloads = new Map();
            var dedupePayload = function dedupePayload(payload) {
                var key = $91c0bd7aa3a2480f$var$stableStringify(payload);
                handlePayloads.set(key, payload);
            };
            previousParentEntry.fieldPayloads.forEach(dedupePayload);
            parentPayloads.forEach(dedupePayload);
            nextParentPayloads = Array.from(handlePayloads.values());
        } else {
            nextParentRecord = parentRecord;
            nextParentPayloads = parentPayloads;
        }
        this._source.set(parentID, {
            record: nextParentRecord,
            fieldPayloads: nextParentPayloads
        });
        if (pendingResponses != null) {
            var payloadFollowups = this._processIncrementalResponses(pendingResponses);
            this._processPayloadFollowups(payloadFollowups);
        }
    };
    _proto._processIncrementalResponses = function _processIncrementalResponses(incrementalResponses) {
        var _this11 = this;
        var relayPayloads = [];
        incrementalResponses.forEach(function(incrementalResponse) {
            var label = incrementalResponse.label, path = incrementalResponse.path, response = incrementalResponse.response;
            var resultForLabel = _this11._incrementalResults.get(label);
            if (resultForLabel == null) {
                resultForLabel = new Map();
                _this11._incrementalResults.set(label, resultForLabel);
            }
            if (label.indexOf('$defer$') !== -1) {
                var pathKey = path.map(String).join('.');
                var resultForPath = resultForLabel.get(pathKey);
                if (resultForPath == null) {
                    resultForPath = {
                        kind: 'response',
                        responses: [
                            incrementalResponse
                        ]
                    };
                    resultForLabel.set(pathKey, resultForPath);
                    return;
                } else if (resultForPath.kind === 'response') {
                    resultForPath.responses.push(incrementalResponse);
                    return;
                }
                var placeholder = resultForPath.placeholder;
                !(placeholder.kind === 'defer') && $423Vm(false);
                relayPayloads.push(_this11._processDeferResponse(label, path, placeholder, response));
            } else {
                var _pathKey = path.slice(0, -2).map(String).join('.');
                var _resultForPath = resultForLabel.get(_pathKey);
                if (_resultForPath == null) {
                    _resultForPath = {
                        kind: 'response',
                        responses: [
                            incrementalResponse
                        ]
                    };
                    resultForLabel.set(_pathKey, _resultForPath);
                    return;
                } else if (_resultForPath.kind === 'response') {
                    _resultForPath.responses.push(incrementalResponse);
                    return;
                }
                var _placeholder = _resultForPath.placeholder;
                !(_placeholder.kind === 'stream') && $423Vm(false);
                relayPayloads.push(_this11._processStreamResponse(label, path, _placeholder, response));
            }
        });
        return relayPayloads;
    };
    _proto._processDeferResponse = function _processDeferResponse(label, path, placeholder, response) {
        var _placeholder$actorIde;
        var parentID = placeholder.selector.dataID;
        var prevActorIdentifier = this._actorIdentifier;
        this._actorIdentifier = (_placeholder$actorIde = placeholder.actorIdentifier) !== null && _placeholder$actorIde !== void 0 ? _placeholder$actorIde : this._actorIdentifier;
        var relayPayload = this._normalizeResponse(response, placeholder.selector, placeholder.typeName, {
            actorIdentifier: this._actorIdentifier,
            getDataID: this._getDataID,
            path: placeholder.path,
            treatMissingFieldsAsNull: this._treatMissingFieldsAsNull,
            shouldProcessClientComponents: this._shouldProcessClientComponents
        });
        this._getPublishQueueAndSaveActor().commitPayload(this._operation, relayPayload);
        var parentEntry = this._source.get(parentID);
        !(parentEntry != null) && $423Vm(false);
        var fieldPayloads = parentEntry.fieldPayloads;
        if (fieldPayloads.length !== 0) {
            var _response$extensions2;
            var handleFieldsRelayPayload = {
                errors: null,
                fieldPayloads: fieldPayloads,
                incrementalPlaceholders: null,
                followupPayloads: null,
                source: $7eJdF.create(),
                isFinal: ((_response$extensions2 = response.extensions) === null || _response$extensions2 === void 0 ? void 0 : _response$extensions2.is_final) === true
            };
            this._getPublishQueueAndSaveActor().commitPayload(this._operation, handleFieldsRelayPayload);
        }
        this._actorIdentifier = prevActorIdentifier;
        return relayPayload;
    };
    _proto._processStreamResponse = function _processStreamResponse(label, path, placeholder, response) {
        var parentID = placeholder.parentID, node = placeholder.node, variables = placeholder.variables, actorIdentifier = placeholder.actorIdentifier;
        var prevActorIdentifier = this._actorIdentifier;
        this._actorIdentifier = actorIdentifier !== null && actorIdentifier !== void 0 ? actorIdentifier : this._actorIdentifier;
        var field = node.selections[0];
        !(field != null && field.kind === 'LinkedField' && field.plural === true) && $423Vm(false);
        var _this$_normalizeStrea = this._normalizeStreamItem(response, parentID, field, variables, path, placeholder.path), fieldPayloads = _this$_normalizeStrea.fieldPayloads, itemID = _this$_normalizeStrea.itemID, itemIndex = _this$_normalizeStrea.itemIndex, prevIDs = _this$_normalizeStrea.prevIDs, relayPayload = _this$_normalizeStrea.relayPayload, storageKey = _this$_normalizeStrea.storageKey;
        this._getPublishQueueAndSaveActor().commitPayload(this._operation, relayPayload, function(store) {
            var currentParentRecord = store.get(parentID);
            if (currentParentRecord == null) return;
            var currentItems = currentParentRecord.getLinkedRecords(storageKey);
            if (currentItems == null) return;
            if (currentItems.length !== prevIDs.length || currentItems.some(function(currentItem, index) {
                return prevIDs[index] !== (currentItem && currentItem.getDataID());
            })) return;
            var nextItems = (0, $91c0bd7aa3a2480f$var$_toConsumableArray2["default"])(currentItems);
            nextItems[itemIndex] = store.get(itemID);
            currentParentRecord.setLinkedRecords(nextItems, storageKey);
        });
        if (fieldPayloads.length !== 0) {
            var handleFieldsRelayPayload = {
                errors: null,
                fieldPayloads: fieldPayloads,
                incrementalPlaceholders: null,
                followupPayloads: null,
                source: $7eJdF.create(),
                isFinal: false
            };
            this._getPublishQueueAndSaveActor().commitPayload(this._operation, handleFieldsRelayPayload);
        }
        this._actorIdentifier = prevActorIdentifier;
        return relayPayload;
    };
    _proto._normalizeStreamItem = function _normalizeStreamItem(response, parentID, field, variables, path, normalizationPath) {
        var _field$alias, _field$concreteType, _ref, _this$_getDataID;
        var data = response.data;
        !(typeof data === 'object') && $423Vm(false);
        var responseKey = (_field$alias = field.alias) !== null && _field$alias !== void 0 ? _field$alias : field.name;
        var storageKey = $91c0bd7aa3a2480f$var$getStorageKey(field, variables);
        var parentEntry = this._source.get(parentID);
        !(parentEntry != null) && $423Vm(false);
        var parentRecord = parentEntry.record, fieldPayloads = parentEntry.fieldPayloads;
        var prevIDs = $fagih.getLinkedRecordIDs(parentRecord, storageKey);
        !(prevIDs != null) && $423Vm(false);
        var finalPathEntry = path[path.length - 1];
        var itemIndex = parseInt(finalPathEntry, 10);
        !(itemIndex === finalPathEntry && itemIndex >= 0) && $423Vm(false);
        var typeName = (_field$concreteType = field.concreteType) !== null && _field$concreteType !== void 0 ? _field$concreteType : data[$91c0bd7aa3a2480f$var$TYPENAME_KEY];
        !(typeof typeName === 'string') && $423Vm(false);
        var itemID = (_ref = (_this$_getDataID = this._getDataID(data, typeName)) !== null && _this$_getDataID !== void 0 ? _this$_getDataID : prevIDs === null || prevIDs === void 0 ? void 0 : prevIDs[itemIndex]) !== null && _ref !== void 0 ? _ref : $91c0bd7aa3a2480f$var$generateClientID(parentID, storageKey, itemIndex);
        !(typeof itemID === 'string') && $423Vm(false);
        var selector = $91c0bd7aa3a2480f$var$createNormalizationSelector(field, itemID, variables);
        var nextParentRecord = $fagih.clone(parentRecord);
        var nextIDs = (0, $91c0bd7aa3a2480f$var$_toConsumableArray2["default"])(prevIDs);
        nextIDs[itemIndex] = itemID;
        $fagih.setLinkedRecordIDs(nextParentRecord, storageKey, nextIDs);
        this._source.set(parentID, {
            record: nextParentRecord,
            fieldPayloads: fieldPayloads
        });
        var relayPayload = this._normalizeResponse(response, selector, typeName, {
            actorIdentifier: this._actorIdentifier,
            getDataID: this._getDataID,
            path: [].concat((0, $91c0bd7aa3a2480f$var$_toConsumableArray2["default"])(normalizationPath), [
                responseKey,
                String(itemIndex)
            ]),
            treatMissingFieldsAsNull: this._treatMissingFieldsAsNull,
            shouldProcessClientComponents: this._shouldProcessClientComponents
        });
        return {
            fieldPayloads: fieldPayloads,
            itemID: itemID,
            itemIndex: itemIndex,
            prevIDs: prevIDs,
            relayPayload: relayPayload,
            storageKey: storageKey
        };
    };
    _proto._scheduleAsyncStoreUpdate = function _scheduleAsyncStoreUpdate(scheduleFn, completeFn) {
        var _this12 = this;
        this._completeFns.push(completeFn);
        if (this._asyncStoreUpdateDisposable != null) return;
        this._asyncStoreUpdateDisposable = scheduleFn(function() {
            _this12._asyncStoreUpdateDisposable = null;
            var updatedOwners = _this12._runPublishQueue();
            _this12._updateOperationTracker(updatedOwners);
            var _iterator2 = (0, $91c0bd7aa3a2480f$var$_createForOfIteratorHelper2["default"])(_this12._completeFns), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var complete = _step2.value;
                    complete();
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
            _this12._completeFns = [];
        });
    };
    _proto._updateOperationTracker = function _updateOperationTracker(updatedOwners) {
        if (updatedOwners != null && updatedOwners.length > 0) this._operationTracker.update(this._operation.request, new Set(updatedOwners));
    };
    _proto._completeOperationTracker = function _completeOperationTracker() {
        this._operationTracker.complete(this._operation.request);
    };
    _proto._getPublishQueueAndSaveActor = function _getPublishQueueAndSaveActor() {
        this._seenActors.add(this._actorIdentifier);
        return this._getPublishQueue(this._actorIdentifier);
    };
    _proto._getActorsToVisit = function _getActorsToVisit() {
        if (this._seenActors.size === 0) return new Set([
            this._actorIdentifier
        ]);
        else return this._seenActors;
    };
    _proto._runPublishQueue = function _runPublishQueue(operation) {
        var updatedOwners = new Set();
        var _iterator3 = (0, $91c0bd7aa3a2480f$var$_createForOfIteratorHelper2["default"])(this._getActorsToVisit()), _step3;
        try {
            for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                var actorIdentifier = _step3.value;
                var owners = this._getPublishQueue(actorIdentifier).run(operation);
                owners.forEach(function(owner) {
                    return updatedOwners.add(owner);
                });
            }
        } catch (err) {
            _iterator3.e(err);
        } finally{
            _iterator3.f();
        }
        return Array.from(updatedOwners);
    };
    _proto._retainData = function _retainData() {
        var _iterator4 = (0, $91c0bd7aa3a2480f$var$_createForOfIteratorHelper2["default"])(this._getActorsToVisit()), _step4;
        try {
            for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                var actorIdentifier = _step4.value;
                if (!this._retainDisposables.has(actorIdentifier)) this._retainDisposables.set(actorIdentifier, this._getStore(actorIdentifier).retain(this._operation));
            }
        } catch (err) {
            _iterator4.e(err);
        } finally{
            _iterator4.f();
        }
    };
    _proto._disposeRetainedData = function _disposeRetainedData() {
        var _iterator5 = (0, $91c0bd7aa3a2480f$var$_createForOfIteratorHelper2["default"])(this._retainDisposables.values()), _step5;
        try {
            for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                var disposable = _step5.value;
                disposable.dispose();
            }
        } catch (err) {
            _iterator5.e(err);
        } finally{
            _iterator5.f();
        }
        this._retainDisposables.clear();
    };
    _proto._expectOperationLoader = function _expectOperationLoader() {
        var operationLoader = this._operationLoader;
        !operationLoader && $423Vm(false);
        return operationLoader;
    };
    return Executor;
}();
function $91c0bd7aa3a2480f$var$partitionGraphQLResponses(responses) {
    var nonIncrementalResponses = [];
    var incrementalResponses = [];
    responses.forEach(function(response) {
        if (response.path != null || response.label != null) {
            var label = response.label, path = response.path;
            if (label == null || path == null) $423Vm(false);
            incrementalResponses.push({
                label: label,
                path: path,
                response: response
            });
        } else nonIncrementalResponses.push(response);
    });
    return [
        nonIncrementalResponses,
        incrementalResponses
    ];
}
function $91c0bd7aa3a2480f$var$stableStringify(value) {
    var _JSON$stringify;
    return (_JSON$stringify = JSON.stringify($4cAcq(value))) !== null && _JSON$stringify !== void 0 ? _JSON$stringify : '';
}
function $91c0bd7aa3a2480f$var$validateOptimisticResponsePayload(payload) {
    var incrementalPlaceholders = payload.incrementalPlaceholders;
    if (incrementalPlaceholders != null && incrementalPlaceholders.length !== 0) $423Vm(false);
}
module.exports = {
    execute: $91c0bd7aa3a2480f$var$execute
};

});
parcelRegister("lTsrN", function(module, exports) {
'use strict';

var $54ow8 = parcelRequire("54ow8");
var $ff04cd10f74f7901$var$REQUEST = $54ow8.REQUEST, $ff04cd10f74f7901$var$SPLIT_OPERATION = $54ow8.SPLIT_OPERATION;
function $ff04cd10f74f7901$var$getOperation(node) {
    switch(node.kind){
        case $ff04cd10f74f7901$var$REQUEST:
            return node.operation;
        case $ff04cd10f74f7901$var$SPLIT_OPERATION:
        default:
            return node;
    }
}
module.exports = $ff04cd10f74f7901$var$getOperation;

});

parcelRegister("l4x3v", function(module, exports) {
'use strict';
function $f5739cd894b09e4e$var$createError(type, name, messageFormat) {
    for(var _len = arguments.length, messageParams = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++)messageParams[_key - 3] = arguments[_key];
    var index = 0;
    var message = messageFormat.replace(/%s/g, function() {
        return String(messageParams[index++]);
    });
    var err = new Error(message);
    var error = Object.assign(err, {
        name: name,
        messageFormat: messageFormat,
        messageParams: messageParams,
        type: type,
        taalOpcodes: [
            2,
            2
        ]
    });
    if (error.stack === undefined) try {
        throw error;
    } catch (_unused) {}
    return error;
}
module.exports = {
    create: function create(name, messageFormat) {
        for(var _len2 = arguments.length, messageParams = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++)messageParams[_key2 - 2] = arguments[_key2];
        return $f5739cd894b09e4e$var$createError.apply(void 0, [
            'error',
            name,
            messageFormat
        ].concat(messageParams));
    },
    createWarning: function createWarning(name, messageFormat) {
        for(var _len3 = arguments.length, messageParams = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++)messageParams[_key3 - 2] = arguments[_key3];
        return $f5739cd894b09e4e$var$createError.apply(void 0, [
            'warn',
            name,
            messageFormat
        ].concat(messageParams));
    }
};

});

parcelRegister("8uKTH", function(module, exports) {
'use strict';
var $62f580ee78db0b1b$var$_window, $62f580ee78db0b1b$var$_window$performance;
var $62f580ee78db0b1b$var$isPerformanceNowAvailable = typeof window !== 'undefined' && typeof (($62f580ee78db0b1b$var$_window = window) === null || $62f580ee78db0b1b$var$_window === void 0 ? void 0 : ($62f580ee78db0b1b$var$_window$performance = $62f580ee78db0b1b$var$_window.performance) === null || $62f580ee78db0b1b$var$_window$performance === void 0 ? void 0 : $62f580ee78db0b1b$var$_window$performance.now) === 'function';
function $62f580ee78db0b1b$var$currentTimestamp() {
    if ($62f580ee78db0b1b$var$isPerformanceNowAvailable) return window.performance.now();
    return Date.now();
}
function $62f580ee78db0b1b$var$withDuration(cb) {
    var startTime = $62f580ee78db0b1b$var$currentTimestamp();
    var result = cb();
    return [
        $62f580ee78db0b1b$var$currentTimestamp() - startTime,
        result
    ];
}
module.exports = $62f580ee78db0b1b$var$withDuration;

});


parcelRegister("b7UpD", function(module, exports) {
'use strict';
var $819c1b798677f5d3$var$_global$ErrorUtils$ap, $819c1b798677f5d3$var$_global$ErrorUtils;

var $bo4TG = parcelRequire("bo4TG");

var $jgxJp = parcelRequire("jgxJp");

var $7OqMf = parcelRequire("7OqMf");

var $ldcaJ = parcelRequire("ldcaJ");

var $7eJdF = parcelRequire("7eJdF");

var $423Vm = parcelRequire("423Vm");
parcelRequire("dH6ue");
var $819c1b798677f5d3$var$_global = typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : undefined;
var $819c1b798677f5d3$var$applyWithGuard = ($819c1b798677f5d3$var$_global$ErrorUtils$ap = $819c1b798677f5d3$var$_global === null || $819c1b798677f5d3$var$_global === void 0 ? void 0 : ($819c1b798677f5d3$var$_global$ErrorUtils = $819c1b798677f5d3$var$_global.ErrorUtils) === null || $819c1b798677f5d3$var$_global$ErrorUtils === void 0 ? void 0 : $819c1b798677f5d3$var$_global$ErrorUtils.applyWithGuard) !== null && $819c1b798677f5d3$var$_global$ErrorUtils$ap !== void 0 ? $819c1b798677f5d3$var$_global$ErrorUtils$ap : function(callback, context, args, onError, name) {
    return callback.apply(context, args);
};
var $819c1b798677f5d3$var$RelayPublishQueue = /*#__PURE__*/ function() {
    function RelayPublishQueue(store, handlerProvider, getDataID, missingFieldHandlers) {
        this._hasStoreSnapshot = false;
        this._handlerProvider = handlerProvider || null;
        this._pendingBackupRebase = false;
        this._pendingData = new Set();
        this._pendingOptimisticUpdates = new Set();
        this._store = store;
        this._appliedOptimisticUpdates = new Set();
        this._gcHold = null;
        this._getDataID = getDataID;
        this._missingFieldHandlers = missingFieldHandlers;
    }
    var _proto = RelayPublishQueue.prototype;
    _proto.applyUpdate = function applyUpdate(updater) {
        !(!this._appliedOptimisticUpdates.has(updater) && !this._pendingOptimisticUpdates.has(updater)) && $423Vm(false);
        this._pendingOptimisticUpdates.add(updater);
    };
    _proto.revertUpdate = function revertUpdate(updater) {
        if (this._pendingOptimisticUpdates.has(updater)) this._pendingOptimisticUpdates["delete"](updater);
        else if (this._appliedOptimisticUpdates.has(updater)) {
            this._pendingBackupRebase = true;
            this._appliedOptimisticUpdates["delete"](updater);
        }
    };
    _proto.revertAll = function revertAll() {
        this._pendingBackupRebase = true;
        this._pendingOptimisticUpdates.clear();
        this._appliedOptimisticUpdates.clear();
    };
    _proto.commitPayload = function commitPayload(operation, payload, updater) {
        this._pendingBackupRebase = true;
        this._pendingData.add({
            kind: 'payload',
            operation: operation,
            payload: payload,
            updater: updater
        });
    };
    _proto.commitUpdate = function commitUpdate(updater) {
        this._pendingBackupRebase = true;
        this._pendingData.add({
            kind: 'updater',
            updater: updater
        });
    };
    _proto.commitSource = function commitSource(source) {
        this._pendingBackupRebase = true;
        this._pendingData.add({
            kind: 'source',
            source: source
        });
    };
    _proto.run = function run(sourceOperation) {
        var runWillClearGcHold = this._appliedOptimisticUpdates === 0 && !!this._gcHold;
        var runIsANoop = !this._pendingBackupRebase && this._pendingOptimisticUpdates.size === 0 && !runWillClearGcHold;
        if (runIsANoop) return [];
        if (this._pendingBackupRebase) {
            if (this._hasStoreSnapshot) {
                this._store.restore();
                this._hasStoreSnapshot = false;
            }
        }
        var invalidatedStore = this._commitData();
        if (this._pendingOptimisticUpdates.size || this._pendingBackupRebase && this._appliedOptimisticUpdates.size) {
            if (!this._hasStoreSnapshot) {
                this._store.snapshot();
                this._hasStoreSnapshot = true;
            }
            this._applyUpdates();
        }
        this._pendingBackupRebase = false;
        if (this._appliedOptimisticUpdates.size > 0) {
            if (!this._gcHold) this._gcHold = this._store.holdGC();
        } else if (this._gcHold) {
            this._gcHold.dispose();
            this._gcHold = null;
        }
        return this._store.notify(sourceOperation, invalidatedStore);
    };
    _proto._publishSourceFromPayload = function _publishSourceFromPayload(pendingPayload) {
        var _this = this;
        var payload = pendingPayload.payload, operation = pendingPayload.operation, updater = pendingPayload.updater;
        var source = payload.source, fieldPayloads = payload.fieldPayloads;
        var mutator = new $bo4TG(this._store.getSource(), source);
        var recordSourceProxy = new $jgxJp(mutator, this._getDataID, this._handlerProvider, this._missingFieldHandlers);
        if (fieldPayloads && fieldPayloads.length) fieldPayloads.forEach(function(fieldPayload) {
            var handler = _this._handlerProvider && _this._handlerProvider(fieldPayload.handle);
            !handler && $423Vm(false);
            handler.update(recordSourceProxy, fieldPayload);
        });
        if (updater) {
            var selector = operation.fragment;
            !(selector != null) && $423Vm(false);
            var recordSourceSelectorProxy = new $7OqMf(mutator, recordSourceProxy, selector, this._missingFieldHandlers);
            var selectorData = $819c1b798677f5d3$var$lookupSelector(source, selector);
            updater(recordSourceSelectorProxy, selectorData);
        }
        var idsMarkedForInvalidation = recordSourceProxy.getIDsMarkedForInvalidation();
        this._store.publish(source, idsMarkedForInvalidation);
        return recordSourceProxy.isStoreMarkedForInvalidation();
    };
    _proto._commitData = function _commitData() {
        var _this2 = this;
        if (!this._pendingData.size) return false;
        var invalidatedStore = false;
        this._pendingData.forEach(function(data) {
            if (data.kind === 'payload') {
                var payloadInvalidatedStore = _this2._publishSourceFromPayload(data);
                invalidatedStore = invalidatedStore || payloadInvalidatedStore;
            } else if (data.kind === 'source') {
                var source = data.source;
                _this2._store.publish(source);
            } else {
                var updater = data.updater;
                var sink = $7eJdF.create();
                var mutator = new $bo4TG(_this2._store.getSource(), sink);
                var recordSourceProxy = new $jgxJp(mutator, _this2._getDataID, _this2._handlerProvider, _this2._missingFieldHandlers);
                $819c1b798677f5d3$var$applyWithGuard(updater, null, [
                    recordSourceProxy
                ], null, 'RelayPublishQueue:commitData');
                invalidatedStore = invalidatedStore || recordSourceProxy.isStoreMarkedForInvalidation();
                var idsMarkedForInvalidation = recordSourceProxy.getIDsMarkedForInvalidation();
                _this2._store.publish(sink, idsMarkedForInvalidation);
            }
        });
        this._pendingData.clear();
        return invalidatedStore;
    };
    _proto._applyUpdates = function _applyUpdates() {
        var _this3 = this;
        var sink = $7eJdF.create();
        var mutator = new $bo4TG(this._store.getSource(), sink);
        var recordSourceProxy = new $jgxJp(mutator, this._getDataID, this._handlerProvider, this._missingFieldHandlers);
        var processUpdate = function processUpdate(optimisticUpdate) {
            if (optimisticUpdate.storeUpdater) {
                var storeUpdater = optimisticUpdate.storeUpdater;
                $819c1b798677f5d3$var$applyWithGuard(storeUpdater, null, [
                    recordSourceProxy
                ], null, 'RelayPublishQueue:applyUpdates');
            } else {
                var operation = optimisticUpdate.operation, payload = optimisticUpdate.payload, updater = optimisticUpdate.updater;
                var source = payload.source, fieldPayloads = payload.fieldPayloads;
                if (source) recordSourceProxy.publishSource(source, fieldPayloads);
                if (updater) {
                    var selectorData;
                    if (source) selectorData = $819c1b798677f5d3$var$lookupSelector(source, operation.fragment);
                    var recordSourceSelectorProxy = new $7OqMf(mutator, recordSourceProxy, operation.fragment, _this3._missingFieldHandlers);
                    $819c1b798677f5d3$var$applyWithGuard(updater, null, [
                        recordSourceSelectorProxy,
                        selectorData
                    ], null, 'RelayPublishQueue:applyUpdates');
                }
            }
        };
        if (this._pendingBackupRebase && this._appliedOptimisticUpdates.size) this._appliedOptimisticUpdates.forEach(processUpdate);
        if (this._pendingOptimisticUpdates.size) {
            this._pendingOptimisticUpdates.forEach(function(optimisticUpdate) {
                processUpdate(optimisticUpdate);
                _this3._appliedOptimisticUpdates.add(optimisticUpdate);
            });
            this._pendingOptimisticUpdates.clear();
        }
        this._store.publish(sink);
    };
    return RelayPublishQueue;
}();
function $819c1b798677f5d3$var$lookupSelector(source, selector) {
    var selectorData = $ldcaJ.read(source, selector).data;
    var deepFreeze;
    return selectorData;
}
module.exports = $819c1b798677f5d3$var$RelayPublishQueue;

});
parcelRegister("bo4TG", function(module, exports) {
'use strict';

var $fagih = parcelRequire("fagih");

var $jqEGH = parcelRequire("jqEGH");
var $84a5bc1606fdb7e0$var$EXISTENT = $jqEGH.EXISTENT;

var $423Vm = parcelRequire("423Vm");
var $84a5bc1606fdb7e0$var$RelayRecordSourceMutator = /*#__PURE__*/ function() {
    function RelayRecordSourceMutator(base, sink) {
        this.__sources = [
            sink,
            base
        ];
        this._base = base;
        this._sink = sink;
    }
    var _proto = RelayRecordSourceMutator.prototype;
    _proto.unstable_getRawRecordWithChanges = function unstable_getRawRecordWithChanges(dataID) {
        var baseRecord = this._base.get(dataID);
        var sinkRecord = this._sink.get(dataID);
        if (sinkRecord === undefined) {
            if (baseRecord == null) return baseRecord;
            var nextRecord = $fagih.clone(baseRecord);
            return nextRecord;
        } else if (sinkRecord === null) return null;
        else if (baseRecord != null) {
            var _nextRecord = $fagih.update(baseRecord, sinkRecord);
            return _nextRecord;
        } else {
            var _nextRecord2 = $fagih.clone(sinkRecord);
            return _nextRecord2;
        }
    };
    _proto._getSinkRecord = function _getSinkRecord(dataID) {
        var sinkRecord = this._sink.get(dataID);
        if (!sinkRecord) {
            var baseRecord = this._base.get(dataID);
            !baseRecord && $423Vm(false);
            sinkRecord = $fagih.create(dataID, $fagih.getType(baseRecord));
            this._sink.set(dataID, sinkRecord);
        }
        return sinkRecord;
    };
    _proto.copyFields = function copyFields(sourceID, sinkID) {
        var sinkSource = this._sink.get(sourceID);
        var baseSource = this._base.get(sourceID);
        !(sinkSource || baseSource) && $423Vm(false);
        var sink = this._getSinkRecord(sinkID);
        if (baseSource) $fagih.copyFields(baseSource, sink);
        if (sinkSource) $fagih.copyFields(sinkSource, sink);
    };
    _proto.copyFieldsFromRecord = function copyFieldsFromRecord(record, sinkID) {
        var sink = this._getSinkRecord(sinkID);
        $fagih.copyFields(record, sink);
    };
    _proto.create = function create(dataID, typeName) {
        !(this._base.getStatus(dataID) !== $84a5bc1606fdb7e0$var$EXISTENT && this._sink.getStatus(dataID) !== $84a5bc1606fdb7e0$var$EXISTENT) && $423Vm(false);
        var record = $fagih.create(dataID, typeName);
        this._sink.set(dataID, record);
    };
    _proto["delete"] = function _delete(dataID) {
        this._sink["delete"](dataID);
    };
    _proto.getStatus = function getStatus(dataID) {
        return this._sink.has(dataID) ? this._sink.getStatus(dataID) : this._base.getStatus(dataID);
    };
    _proto.getType = function getType(dataID) {
        for(var ii = 0; ii < this.__sources.length; ii++){
            var record = this.__sources[ii].get(dataID);
            if (record) return $fagih.getType(record);
            else if (record === null) return null;
        }
    };
    _proto.getValue = function getValue(dataID, storageKey) {
        for(var ii = 0; ii < this.__sources.length; ii++){
            var record = this.__sources[ii].get(dataID);
            if (record) {
                var value = $fagih.getValue(record, storageKey);
                if (value !== undefined) return value;
            } else if (record === null) return null;
        }
    };
    _proto.setValue = function setValue(dataID, storageKey, value) {
        var sinkRecord = this._getSinkRecord(dataID);
        $fagih.setValue(sinkRecord, storageKey, value);
    };
    _proto.getLinkedRecordID = function getLinkedRecordID(dataID, storageKey) {
        for(var ii = 0; ii < this.__sources.length; ii++){
            var record = this.__sources[ii].get(dataID);
            if (record) {
                var linkedID = $fagih.getLinkedRecordID(record, storageKey);
                if (linkedID !== undefined) return linkedID;
            } else if (record === null) return null;
        }
    };
    _proto.setLinkedRecordID = function setLinkedRecordID(dataID, storageKey, linkedID) {
        var sinkRecord = this._getSinkRecord(dataID);
        $fagih.setLinkedRecordID(sinkRecord, storageKey, linkedID);
    };
    _proto.getLinkedRecordIDs = function getLinkedRecordIDs(dataID, storageKey) {
        for(var ii = 0; ii < this.__sources.length; ii++){
            var record = this.__sources[ii].get(dataID);
            if (record) {
                var linkedIDs = $fagih.getLinkedRecordIDs(record, storageKey);
                if (linkedIDs !== undefined) return linkedIDs;
            } else if (record === null) return null;
        }
    };
    _proto.setLinkedRecordIDs = function setLinkedRecordIDs(dataID, storageKey, linkedIDs) {
        var sinkRecord = this._getSinkRecord(dataID);
        $fagih.setLinkedRecordIDs(sinkRecord, storageKey, linkedIDs);
    };
    return RelayRecordSourceMutator;
}();
module.exports = $84a5bc1606fdb7e0$var$RelayRecordSourceMutator;

});

parcelRegister("jgxJp", function(module, exports) {
'use strict';

var $fagih = parcelRequire("fagih");

var $jqEGH = parcelRequire("jqEGH");
var $e069ad4ea50eb11a$var$EXISTENT = $jqEGH.EXISTENT, $e069ad4ea50eb11a$var$NONEXISTENT = $jqEGH.NONEXISTENT;

var $f91UN = parcelRequire("f91UN");
var $e069ad4ea50eb11a$var$ROOT_ID = $f91UN.ROOT_ID, $e069ad4ea50eb11a$var$ROOT_TYPE = $f91UN.ROOT_TYPE;

var $d7vCe = parcelRequire("d7vCe");
var $e069ad4ea50eb11a$var$_readUpdatableFragment = $d7vCe.readUpdatableFragment;

var $gseUX = parcelRequire("gseUX");
var $e069ad4ea50eb11a$var$_readUpdatableQuery = $gseUX.readUpdatableQuery;

var $5jpbK = parcelRequire("5jpbK");

var $423Vm = parcelRequire("423Vm");
var $e069ad4ea50eb11a$var$RelayRecordSourceProxy = /*#__PURE__*/ function() {
    function RelayRecordSourceProxy(mutator, getDataID, handlerProvider, missingFieldHandlers) {
        this.__mutator = mutator;
        this._handlerProvider = handlerProvider || null;
        this._proxies = {};
        this._getDataID = getDataID;
        this._invalidatedStore = false;
        this._idsMarkedForInvalidation = new Set();
        this._missingFieldHandlers = missingFieldHandlers;
    }
    var _proto = RelayRecordSourceProxy.prototype;
    _proto.publishSource = function publishSource(source, fieldPayloads) {
        var _this = this;
        var dataIDs = source.getRecordIDs();
        dataIDs.forEach(function(dataID) {
            var status = source.getStatus(dataID);
            if (status === $e069ad4ea50eb11a$var$EXISTENT) {
                var sourceRecord = source.get(dataID);
                if (sourceRecord) {
                    if (_this.__mutator.getStatus(dataID) !== $e069ad4ea50eb11a$var$EXISTENT) _this.create(dataID, $fagih.getType(sourceRecord));
                    _this.__mutator.copyFieldsFromRecord(sourceRecord, dataID);
                }
            } else if (status === $e069ad4ea50eb11a$var$NONEXISTENT) _this["delete"](dataID);
        });
        if (fieldPayloads && fieldPayloads.length) fieldPayloads.forEach(function(fieldPayload) {
            var handler = _this._handlerProvider && _this._handlerProvider(fieldPayload.handle);
            !handler && $423Vm(false);
            handler.update(_this, fieldPayload);
        });
    };
    _proto.create = function create(dataID, typeName) {
        this.__mutator.create(dataID, typeName);
        delete this._proxies[dataID];
        var record = this.get(dataID);
        !record && $423Vm(false);
        return record;
    };
    _proto["delete"] = function _delete(dataID) {
        !(dataID !== $e069ad4ea50eb11a$var$ROOT_ID) && $423Vm(false);
        delete this._proxies[dataID];
        this.__mutator["delete"](dataID);
    };
    _proto.get = function get(dataID) {
        if (!this._proxies.hasOwnProperty(dataID)) {
            var status = this.__mutator.getStatus(dataID);
            if (status === $e069ad4ea50eb11a$var$EXISTENT) this._proxies[dataID] = new $5jpbK(this, this.__mutator, dataID);
            else this._proxies[dataID] = status === $e069ad4ea50eb11a$var$NONEXISTENT ? null : undefined;
        }
        return this._proxies[dataID];
    };
    _proto.getRoot = function getRoot() {
        var root = this.get($e069ad4ea50eb11a$var$ROOT_ID);
        if (!root) root = this.create($e069ad4ea50eb11a$var$ROOT_ID, $e069ad4ea50eb11a$var$ROOT_TYPE);
        !(root && root.getType() === $e069ad4ea50eb11a$var$ROOT_TYPE) && $423Vm(false);
        return root;
    };
    _proto.invalidateStore = function invalidateStore() {
        this._invalidatedStore = true;
    };
    _proto.isStoreMarkedForInvalidation = function isStoreMarkedForInvalidation() {
        return this._invalidatedStore;
    };
    _proto.markIDForInvalidation = function markIDForInvalidation(dataID) {
        this._idsMarkedForInvalidation.add(dataID);
    };
    _proto.getIDsMarkedForInvalidation = function getIDsMarkedForInvalidation() {
        return this._idsMarkedForInvalidation;
    };
    _proto.readUpdatableQuery = function readUpdatableQuery(query, variables) {
        return $e069ad4ea50eb11a$var$_readUpdatableQuery(query, variables, this, this._missingFieldHandlers);
    };
    _proto.readUpdatableFragment = function readUpdatableFragment(fragment, fragmentReference) {
        return $e069ad4ea50eb11a$var$_readUpdatableFragment(fragment, fragmentReference, this, this._missingFieldHandlers);
    };
    return RelayRecordSourceProxy;
}();
module.exports = $e069ad4ea50eb11a$var$RelayRecordSourceProxy;

});
parcelRegister("d7vCe", function(module, exports) {
'use strict';

var $bzkJN = parcelRequire("bzkJN");
var $98d474007275562a$var$getFragment = $bzkJN.getFragment;

var $g432U = parcelRequire("g432U");
var $98d474007275562a$var$getVariablesFromFragment = $g432U.getVariablesFromFragment;

var $f91UN = parcelRequire("f91UN");
var $98d474007275562a$var$ID_KEY = $f91UN.ID_KEY;

var $dFJtU = parcelRequire("dFJtU");
var $98d474007275562a$var$createUpdatableProxy = $dFJtU.createUpdatableProxy;

var $423Vm = parcelRequire("423Vm");
function $98d474007275562a$var$readUpdatableFragment(fragment, fragmentReference, proxy, missingFieldHandlers) {
    var updatableFragment = $98d474007275562a$var$getFragment(fragment);
    var fragmentVariables = $98d474007275562a$var$getVariablesFromFragment(updatableFragment, fragmentReference);
    var id = fragmentReference[$98d474007275562a$var$ID_KEY];
    var fragmentRoot = proxy.get(id);
    !(fragmentRoot != null) && $423Vm(false);
    return {
        updatableData: $98d474007275562a$var$createUpdatableProxy(fragmentRoot, fragmentVariables, updatableFragment.selections, proxy, missingFieldHandlers)
    };
}
module.exports = {
    readUpdatableFragment: $98d474007275562a$var$readUpdatableFragment
};

});
parcelRegister("dFJtU", function(module, exports) {
'use strict';

var $7Wmh0 = parcelRequire("7Wmh0");
var $9f4262550c37ccd0$var$_interopRequireDefault = $7Wmh0.default;

var $9f4262550c37ccd0$var$_createForOfIteratorHelper2 = $9f4262550c37ccd0$var$_interopRequireDefault((parcelRequire("9CLQ8")));

var $f91UN = parcelRequire("f91UN");
var $9f4262550c37ccd0$var$getArgumentValues = $f91UN.getArgumentValues;

var $54ow8 = parcelRequire("54ow8");
var $9f4262550c37ccd0$var$ACTOR_CHANGE = $54ow8.ACTOR_CHANGE, $9f4262550c37ccd0$var$ALIASED_FRAGMENT_SPREAD = $54ow8.ALIASED_FRAGMENT_SPREAD, $9f4262550c37ccd0$var$ALIASED_INLINE_FRAGMENT_SPREAD = $54ow8.ALIASED_INLINE_FRAGMENT_SPREAD, $9f4262550c37ccd0$var$CATCH_FIELD = $54ow8.CATCH_FIELD, $9f4262550c37ccd0$var$CLIENT_EDGE_TO_CLIENT_OBJECT = $54ow8.CLIENT_EDGE_TO_CLIENT_OBJECT, $9f4262550c37ccd0$var$CLIENT_EDGE_TO_SERVER_OBJECT = $54ow8.CLIENT_EDGE_TO_SERVER_OBJECT, $9f4262550c37ccd0$var$CLIENT_EXTENSION = $54ow8.CLIENT_EXTENSION, $9f4262550c37ccd0$var$CONDITION = $54ow8.CONDITION, $9f4262550c37ccd0$var$DEFER = $54ow8.DEFER, $9f4262550c37ccd0$var$FRAGMENT_SPREAD = $54ow8.FRAGMENT_SPREAD, $9f4262550c37ccd0$var$INLINE_DATA_FRAGMENT_SPREAD = $54ow8.INLINE_DATA_FRAGMENT_SPREAD, $9f4262550c37ccd0$var$INLINE_FRAGMENT = $54ow8.INLINE_FRAGMENT, $9f4262550c37ccd0$var$LINKED_FIELD = $54ow8.LINKED_FIELD, $9f4262550c37ccd0$var$MODULE_IMPORT = $54ow8.MODULE_IMPORT, $9f4262550c37ccd0$var$RELAY_LIVE_RESOLVER = $54ow8.RELAY_LIVE_RESOLVER, $9f4262550c37ccd0$var$RELAY_RESOLVER = $54ow8.RELAY_RESOLVER, $9f4262550c37ccd0$var$REQUIRED_FIELD = $54ow8.REQUIRED_FIELD, $9f4262550c37ccd0$var$SCALAR_FIELD = $54ow8.SCALAR_FIELD, $9f4262550c37ccd0$var$STREAM = $54ow8.STREAM;
var $9f4262550c37ccd0$var$nonUpdatableKeys = [
    'id',
    '__id',
    '__typename',
    'js'
];
function $9f4262550c37ccd0$var$createUpdatableProxy(updatableProxyRootRecord, variables, selections, recordSourceProxy, missingFieldHandlers) {
    var mutableUpdatableProxy = {};
    $9f4262550c37ccd0$var$updateProxyFromSelections(mutableUpdatableProxy, updatableProxyRootRecord, variables, selections, recordSourceProxy, missingFieldHandlers);
    return mutableUpdatableProxy;
}
function $9f4262550c37ccd0$var$updateProxyFromSelections(mutableUpdatableProxy, updatableProxyRootRecord, variables, selections, recordSourceProxy, missingFieldHandlers) {
    var _selection$alias3;
    var _iterator = (0, $9f4262550c37ccd0$var$_createForOfIteratorHelper2["default"])(selections), _step;
    try {
        var _loop = function _loop() {
            var selection = _step.value;
            switch(selection.kind){
                case $9f4262550c37ccd0$var$LINKED_FIELD:
                    if (selection.plural) Object.defineProperty(mutableUpdatableProxy, (_selection$alias = selection.alias) !== null && _selection$alias !== void 0 ? _selection$alias : selection.name, {
                        get: $9f4262550c37ccd0$var$createGetterForPluralLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers),
                        set: $9f4262550c37ccd0$var$createSetterForPluralLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy)
                    });
                    else Object.defineProperty(mutableUpdatableProxy, (_selection$alias2 = selection.alias) !== null && _selection$alias2 !== void 0 ? _selection$alias2 : selection.name, {
                        get: $9f4262550c37ccd0$var$createGetterForSingularLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers),
                        set: $9f4262550c37ccd0$var$createSetterForSingularLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy)
                    });
                    break;
                case $9f4262550c37ccd0$var$SCALAR_FIELD:
                    var scalarFieldName = (_selection$alias3 = selection.alias) !== null && _selection$alias3 !== void 0 ? _selection$alias3 : selection.name;
                    Object.defineProperty(mutableUpdatableProxy, scalarFieldName, {
                        get: function get() {
                            var _selection$args;
                            var newVariables = $9f4262550c37ccd0$var$getArgumentValues((_selection$args = selection.args) !== null && _selection$args !== void 0 ? _selection$args : [], variables);
                            var value = updatableProxyRootRecord.getValue(selection.name, newVariables);
                            if (value == null) value = $9f4262550c37ccd0$var$getScalarUsingMissingFieldHandlers(selection, newVariables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers);
                            return value;
                        },
                        set: $9f4262550c37ccd0$var$nonUpdatableKeys.includes(selection.name) ? undefined : function(newValue) {
                            var _selection$args2;
                            var newVariables = $9f4262550c37ccd0$var$getArgumentValues((_selection$args2 = selection.args) !== null && _selection$args2 !== void 0 ? _selection$args2 : [], variables);
                            updatableProxyRootRecord.setValue__UNSAFE(newValue, selection.name, newVariables);
                        }
                    });
                    break;
                case $9f4262550c37ccd0$var$INLINE_FRAGMENT:
                    if (updatableProxyRootRecord.getType() === selection.type) $9f4262550c37ccd0$var$updateProxyFromSelections(mutableUpdatableProxy, updatableProxyRootRecord, variables, selection.selections, recordSourceProxy, missingFieldHandlers);
                    break;
                case $9f4262550c37ccd0$var$CLIENT_EXTENSION:
                    $9f4262550c37ccd0$var$updateProxyFromSelections(mutableUpdatableProxy, updatableProxyRootRecord, variables, selection.selections, recordSourceProxy, missingFieldHandlers);
                    break;
                case $9f4262550c37ccd0$var$FRAGMENT_SPREAD:
                    break;
                case $9f4262550c37ccd0$var$CONDITION:
                case $9f4262550c37ccd0$var$ACTOR_CHANGE:
                case $9f4262550c37ccd0$var$ALIASED_FRAGMENT_SPREAD:
                case $9f4262550c37ccd0$var$INLINE_DATA_FRAGMENT_SPREAD:
                case $9f4262550c37ccd0$var$ALIASED_INLINE_FRAGMENT_SPREAD:
                case $9f4262550c37ccd0$var$CLIENT_EDGE_TO_CLIENT_OBJECT:
                case $9f4262550c37ccd0$var$CLIENT_EDGE_TO_SERVER_OBJECT:
                case $9f4262550c37ccd0$var$DEFER:
                case $9f4262550c37ccd0$var$MODULE_IMPORT:
                case $9f4262550c37ccd0$var$RELAY_LIVE_RESOLVER:
                case $9f4262550c37ccd0$var$REQUIRED_FIELD:
                case $9f4262550c37ccd0$var$CATCH_FIELD:
                case $9f4262550c37ccd0$var$STREAM:
                case $9f4262550c37ccd0$var$RELAY_RESOLVER:
                    throw new Error('Encountered an unexpected ReaderSelection variant in RelayRecordSourceProxy. This indicates a bug in Relay.');
                default:
                    selection.kind;
                    throw new Error('Encountered an unexpected ReaderSelection variant in RelayRecordSourceProxy. This indicates a bug in Relay.');
            }
        };
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var _selection$alias;
            var _selection$alias2;
            _loop();
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
}
function $9f4262550c37ccd0$var$createSetterForPluralLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy) {
    return function set(newValue) {
        var _selection$args3;
        var newVariables = $9f4262550c37ccd0$var$getArgumentValues((_selection$args3 = selection.args) !== null && _selection$args3 !== void 0 ? _selection$args3 : [], variables);
        if (newValue == null) throw new Error('Do not assign null to plural linked fields; assign an empty array instead.');
        else {
            var recordProxies = newValue.map(function(item) {
                if (item == null) throw new Error('When assigning an array of items, none of the items should be null or undefined.');
                var __id = item.__id;
                if (__id == null) throw new Error('The __id field must be present on each item passed to the setter. This indicates a bug in Relay.');
                var newValueRecord = recordSourceProxy.get(__id);
                if (newValueRecord == null) throw new Error("Did not find item with data id ".concat(__id, " in the store."));
                return newValueRecord;
            });
            updatableProxyRootRecord.setLinkedRecords(recordProxies, selection.name, newVariables);
        }
    };
}
function $9f4262550c37ccd0$var$createSetterForSingularLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy) {
    return function set(newValue) {
        var _selection$args4;
        var newVariables = $9f4262550c37ccd0$var$getArgumentValues((_selection$args4 = selection.args) !== null && _selection$args4 !== void 0 ? _selection$args4 : [], variables);
        if (newValue == null) updatableProxyRootRecord.setValue(newValue, selection.name, newVariables);
        else {
            var __id = newValue.__id;
            if (__id == null) throw new Error('The __id field must be present on the argument. This indicates a bug in Relay.');
            var newValueRecord = recordSourceProxy.get(__id);
            if (newValueRecord == null) throw new Error("Did not find item with data id ".concat(__id, " in the store."));
            updatableProxyRootRecord.setLinkedRecord(newValueRecord, selection.name, newVariables);
        }
    };
}
function $9f4262550c37ccd0$var$createGetterForPluralLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers) {
    return function() {
        var _selection$args5;
        var newVariables = $9f4262550c37ccd0$var$getArgumentValues((_selection$args5 = selection.args) !== null && _selection$args5 !== void 0 ? _selection$args5 : [], variables);
        var linkedRecords = updatableProxyRootRecord.getLinkedRecords(selection.name, newVariables);
        if (linkedRecords === undefined) linkedRecords = $9f4262550c37ccd0$var$getPluralLinkedRecordUsingMissingFieldHandlers(selection, newVariables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers);
        if (linkedRecords != null) return linkedRecords.map(function(linkedRecord) {
            if (linkedRecord != null) {
                var updatableProxy = {};
                $9f4262550c37ccd0$var$updateProxyFromSelections(updatableProxy, linkedRecord, variables, selection.selections, recordSourceProxy, missingFieldHandlers);
                return updatableProxy;
            } else return linkedRecord;
        });
        else return linkedRecords;
    };
}
function $9f4262550c37ccd0$var$createGetterForSingularLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers) {
    return function() {
        var _selection$args6;
        var newVariables = $9f4262550c37ccd0$var$getArgumentValues((_selection$args6 = selection.args) !== null && _selection$args6 !== void 0 ? _selection$args6 : [], variables);
        var linkedRecord = updatableProxyRootRecord.getLinkedRecord(selection.name, newVariables);
        if (linkedRecord === undefined) linkedRecord = $9f4262550c37ccd0$var$getLinkedRecordUsingMissingFieldHandlers(selection, newVariables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers);
        if (linkedRecord != null) {
            var updatableProxy = {};
            $9f4262550c37ccd0$var$updateProxyFromSelections(updatableProxy, linkedRecord, variables, selection.selections, recordSourceProxy, missingFieldHandlers);
            return updatableProxy;
        } else return linkedRecord;
    };
}
function $9f4262550c37ccd0$var$getLinkedRecordUsingMissingFieldHandlers(selection, newVariables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers) {
    var _iterator2 = (0, $9f4262550c37ccd0$var$_createForOfIteratorHelper2["default"])(missingFieldHandlers), _step2;
    try {
        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
            var handler = _step2.value;
            if (handler.kind === 'linked') {
                var newId = handler.handle(selection, updatableProxyRootRecord, newVariables, recordSourceProxy);
                if (newId != null) return recordSourceProxy.get(newId);
            }
        }
    } catch (err) {
        _iterator2.e(err);
    } finally{
        _iterator2.f();
    }
}
function $9f4262550c37ccd0$var$getPluralLinkedRecordUsingMissingFieldHandlers(selection, newVariables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers) {
    var _iterator3 = (0, $9f4262550c37ccd0$var$_createForOfIteratorHelper2["default"])(missingFieldHandlers), _step3;
    try {
        for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
            var handler = _step3.value;
            if (handler.kind === 'pluralLinked') {
                var newIds = handler.handle(selection, updatableProxyRootRecord, newVariables, recordSourceProxy);
                if (newIds != null) return newIds.map(function(newId) {
                    if (newId != null) return recordSourceProxy.get(newId);
                });
            }
        }
    } catch (err) {
        _iterator3.e(err);
    } finally{
        _iterator3.f();
    }
}
function $9f4262550c37ccd0$var$getScalarUsingMissingFieldHandlers(selection, newVariables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers) {
    var _iterator4 = (0, $9f4262550c37ccd0$var$_createForOfIteratorHelper2["default"])(missingFieldHandlers), _step4;
    try {
        for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
            var handler = _step4.value;
            if (handler.kind === 'scalar') {
                var value = handler.handle(selection, updatableProxyRootRecord, newVariables, recordSourceProxy);
                if (value !== undefined) return value;
            }
        }
    } catch (err) {
        _iterator4.e(err);
    } finally{
        _iterator4.f();
    }
}
module.exports = {
    createUpdatableProxy: $9f4262550c37ccd0$var$createUpdatableProxy
};

});


parcelRegister("gseUX", function(module, exports) {
'use strict';

var $bzkJN = parcelRequire("bzkJN");
var $bfaad5331dfecc88$var$getUpdatableQuery = $bzkJN.getUpdatableQuery;

var $dFJtU = parcelRequire("dFJtU");
var $bfaad5331dfecc88$var$createUpdatableProxy = $dFJtU.createUpdatableProxy;
function $bfaad5331dfecc88$var$readUpdatableQuery(query, variables, proxy, missingFieldHandlers) {
    var updatableQuery = $bfaad5331dfecc88$var$getUpdatableQuery(query);
    return {
        updatableData: $bfaad5331dfecc88$var$createUpdatableProxy(proxy.getRoot(), variables, updatableQuery.fragment.selections, proxy, missingFieldHandlers)
    };
}
module.exports = {
    readUpdatableQuery: $bfaad5331dfecc88$var$readUpdatableQuery
};

});

parcelRegister("5jpbK", function(module, exports) {
'use strict';

var $axs8G = parcelRequire("axs8G");
var $3de243fff8d97a24$var$generateClientID = $axs8G.generateClientID;

var $f91UN = parcelRequire("f91UN");
var $3de243fff8d97a24$var$getStableStorageKey = $f91UN.getStableStorageKey;

var $423Vm = parcelRequire("423Vm");
var $3de243fff8d97a24$var$RelayRecordProxy = /*#__PURE__*/ function() {
    function RelayRecordProxy(source, mutator, dataID) {
        this._dataID = dataID;
        this._mutator = mutator;
        this._source = source;
    }
    var _proto = RelayRecordProxy.prototype;
    _proto.copyFieldsFrom = function copyFieldsFrom(source) {
        this._mutator.copyFields(source.getDataID(), this._dataID);
    };
    _proto.getDataID = function getDataID() {
        return this._dataID;
    };
    _proto.getType = function getType() {
        var type = this._mutator.getType(this._dataID);
        !(type != null) && $423Vm(false);
        return type;
    };
    _proto.getValue = function getValue(name, args) {
        var storageKey = $3de243fff8d97a24$var$getStableStorageKey(name, args);
        return this._mutator.getValue(this._dataID, storageKey);
    };
    _proto.setValue = function setValue(value, name, args) {
        !$3de243fff8d97a24$var$isValidLeafValue(value) && $423Vm(false);
        return this.setValue__UNSAFE(value, name, args);
    };
    _proto.setValue__UNSAFE = function setValue__UNSAFE(value, name, args) {
        var storageKey = $3de243fff8d97a24$var$getStableStorageKey(name, args);
        this._mutator.setValue(this._dataID, storageKey, value);
        return this;
    };
    _proto.getLinkedRecord = function getLinkedRecord(name, args) {
        var storageKey = $3de243fff8d97a24$var$getStableStorageKey(name, args);
        var linkedID = this._mutator.getLinkedRecordID(this._dataID, storageKey);
        return linkedID != null ? this._source.get(linkedID) : linkedID;
    };
    _proto.setLinkedRecord = function setLinkedRecord(record, name, args) {
        !(record instanceof RelayRecordProxy) && $423Vm(false);
        var storageKey = $3de243fff8d97a24$var$getStableStorageKey(name, args);
        var linkedID = record.getDataID();
        this._mutator.setLinkedRecordID(this._dataID, storageKey, linkedID);
        return this;
    };
    _proto.getOrCreateLinkedRecord = function getOrCreateLinkedRecord(name, typeName, args) {
        var linkedRecord = this.getLinkedRecord(name, args);
        if (!linkedRecord) {
            var _this$_source$get;
            var storageKey = $3de243fff8d97a24$var$getStableStorageKey(name, args);
            var clientID = $3de243fff8d97a24$var$generateClientID(this.getDataID(), storageKey);
            linkedRecord = (_this$_source$get = this._source.get(clientID)) !== null && _this$_source$get !== void 0 ? _this$_source$get : this._source.create(clientID, typeName);
            this.setLinkedRecord(linkedRecord, name, args);
        }
        return linkedRecord;
    };
    _proto.getLinkedRecords = function getLinkedRecords(name, args) {
        var _this = this;
        var storageKey = $3de243fff8d97a24$var$getStableStorageKey(name, args);
        var linkedIDs = this._mutator.getLinkedRecordIDs(this._dataID, storageKey);
        if (linkedIDs == null) return linkedIDs;
        return linkedIDs.map(function(linkedID) {
            return linkedID != null ? _this._source.get(linkedID) : linkedID;
        });
    };
    _proto.setLinkedRecords = function setLinkedRecords(records, name, args) {
        !Array.isArray(records) && $423Vm(false);
        var storageKey = $3de243fff8d97a24$var$getStableStorageKey(name, args);
        var linkedIDs = records.map(function(record) {
            return record && record.getDataID();
        });
        this._mutator.setLinkedRecordIDs(this._dataID, storageKey, linkedIDs);
        return this;
    };
    _proto.invalidateRecord = function invalidateRecord() {
        this._source.markIDForInvalidation(this._dataID);
    };
    return RelayRecordProxy;
}();
function $3de243fff8d97a24$var$isValidLeafValue(value) {
    return value == null || typeof value !== 'object' || Array.isArray(value) && value.every($3de243fff8d97a24$var$isValidLeafValue);
}
module.exports = $3de243fff8d97a24$var$RelayRecordProxy;

});


parcelRegister("7OqMf", function(module, exports) {
'use strict';

var $f91UN = parcelRequire("f91UN");
var $5b01f94ac4460c0f$var$ROOT_TYPE = $f91UN.ROOT_TYPE, $5b01f94ac4460c0f$var$getStorageKey = $f91UN.getStorageKey;

var $d7vCe = parcelRequire("d7vCe");
var $5b01f94ac4460c0f$var$_readUpdatableFragment = $d7vCe.readUpdatableFragment;

var $gseUX = parcelRequire("gseUX");
var $5b01f94ac4460c0f$var$_readUpdatableQuery = $gseUX.readUpdatableQuery;

var $423Vm = parcelRequire("423Vm");
var $5b01f94ac4460c0f$var$RelayRecordSourceSelectorProxy = /*#__PURE__*/ function() {
    function RelayRecordSourceSelectorProxy(mutator, recordSource, readSelector, missingFieldHandlers) {
        this.__mutator = mutator;
        this.__recordSource = recordSource;
        this._readSelector = readSelector;
        this._missingFieldHandlers = missingFieldHandlers;
    }
    var _proto = RelayRecordSourceSelectorProxy.prototype;
    _proto.create = function create(dataID, typeName) {
        return this.__recordSource.create(dataID, typeName);
    };
    _proto["delete"] = function _delete(dataID) {
        this.__recordSource["delete"](dataID);
    };
    _proto.get = function get(dataID) {
        return this.__recordSource.get(dataID);
    };
    _proto.getRoot = function getRoot() {
        return this.__recordSource.getRoot();
    };
    _proto.getOperationRoot = function getOperationRoot() {
        var root = this.__recordSource.get(this._readSelector.dataID);
        if (!root) root = this.__recordSource.create(this._readSelector.dataID, $5b01f94ac4460c0f$var$ROOT_TYPE);
        return root;
    };
    _proto._getRootField = function _getRootField(selector, fieldName, plural) {
        var field = selector.node.selections.find(function(selection) {
            return selection.kind === 'LinkedField' && selection.name === fieldName || selection.kind === 'RequiredField' && selection.field.name === fieldName;
        });
        if (field && field.kind === 'RequiredField') field = field.field;
        !(field && field.kind === 'LinkedField') && $423Vm(false);
        !(field.plural === plural) && $423Vm(false);
        return field;
    };
    _proto.getRootField = function getRootField(fieldName) {
        var field = this._getRootField(this._readSelector, fieldName, false);
        var storageKey = $5b01f94ac4460c0f$var$getStorageKey(field, this._readSelector.variables);
        return this.getOperationRoot().getLinkedRecord(storageKey);
    };
    _proto.getPluralRootField = function getPluralRootField(fieldName) {
        var field = this._getRootField(this._readSelector, fieldName, true);
        var storageKey = $5b01f94ac4460c0f$var$getStorageKey(field, this._readSelector.variables);
        return this.getOperationRoot().getLinkedRecords(storageKey);
    };
    _proto.invalidateStore = function invalidateStore() {
        this.__recordSource.invalidateStore();
    };
    _proto.readUpdatableQuery = function readUpdatableQuery(query, variables) {
        return $5b01f94ac4460c0f$var$_readUpdatableQuery(query, variables, this, this._missingFieldHandlers);
    };
    _proto.readUpdatableFragment = function readUpdatableFragment(fragment, fragmentReference) {
        return $5b01f94ac4460c0f$var$_readUpdatableFragment(fragment, fragmentReference, this, this._missingFieldHandlers);
    };
    return RelayRecordSourceSelectorProxy;
}();
module.exports = $5b01f94ac4460c0f$var$RelayRecordSourceSelectorProxy;

});

parcelRegister("ldcaJ", function(module, exports) {
'use strict';

var $7Wmh0 = parcelRequire("7Wmh0");
var $f71441030fa79696$var$_interopRequireDefault = $7Wmh0.default;

var $f71441030fa79696$var$_defineProperty2 = $f71441030fa79696$var$_interopRequireDefault((parcelRequire("ky4V8")));

var $f71441030fa79696$var$_createForOfIteratorHelper2 = $f71441030fa79696$var$_interopRequireDefault((parcelRequire("9CLQ8")));

var $f71441030fa79696$var$_toConsumableArray2 = $f71441030fa79696$var$_interopRequireDefault((parcelRequire("gHCmS")));

var $54ow8 = parcelRequire("54ow8");
var $f71441030fa79696$var$ACTOR_CHANGE = $54ow8.ACTOR_CHANGE, $f71441030fa79696$var$ALIASED_FRAGMENT_SPREAD = $54ow8.ALIASED_FRAGMENT_SPREAD, $f71441030fa79696$var$ALIASED_INLINE_FRAGMENT_SPREAD = $54ow8.ALIASED_INLINE_FRAGMENT_SPREAD, $f71441030fa79696$var$CATCH_FIELD = $54ow8.CATCH_FIELD, $f71441030fa79696$var$CLIENT_EDGE_TO_CLIENT_OBJECT = $54ow8.CLIENT_EDGE_TO_CLIENT_OBJECT, $f71441030fa79696$var$CLIENT_EDGE_TO_SERVER_OBJECT = $54ow8.CLIENT_EDGE_TO_SERVER_OBJECT, $f71441030fa79696$var$CLIENT_EXTENSION = $54ow8.CLIENT_EXTENSION, $f71441030fa79696$var$CONDITION = $54ow8.CONDITION, $f71441030fa79696$var$DEFER = $54ow8.DEFER, $f71441030fa79696$var$FRAGMENT_SPREAD = $54ow8.FRAGMENT_SPREAD, $f71441030fa79696$var$INLINE_DATA_FRAGMENT_SPREAD = $54ow8.INLINE_DATA_FRAGMENT_SPREAD, $f71441030fa79696$var$INLINE_FRAGMENT = $54ow8.INLINE_FRAGMENT, $f71441030fa79696$var$LINKED_FIELD = $54ow8.LINKED_FIELD, $f71441030fa79696$var$MODULE_IMPORT = $54ow8.MODULE_IMPORT, $f71441030fa79696$var$RELAY_LIVE_RESOLVER = $54ow8.RELAY_LIVE_RESOLVER, $f71441030fa79696$var$RELAY_RESOLVER = $54ow8.RELAY_RESOLVER, $f71441030fa79696$var$REQUIRED_FIELD = $54ow8.REQUIRED_FIELD, $f71441030fa79696$var$SCALAR_FIELD = $54ow8.SCALAR_FIELD, $f71441030fa79696$var$STREAM = $54ow8.STREAM;

var $llkIA = parcelRequire("llkIA");

var $jyY6u = parcelRequire("jyY6u");
var $f71441030fa79696$var$isSuspenseSentinel = $jyY6u.isSuspenseSentinel;

var $frIyf = parcelRequire("frIyf");

var $fagih = parcelRequire("fagih");

var $f91UN = parcelRequire("f91UN");
var $f71441030fa79696$var$CLIENT_EDGE_TRAVERSAL_PATH = $f91UN.CLIENT_EDGE_TRAVERSAL_PATH, $f71441030fa79696$var$FRAGMENT_OWNER_KEY = $f91UN.FRAGMENT_OWNER_KEY, $f71441030fa79696$var$FRAGMENT_PROP_NAME_KEY = $f91UN.FRAGMENT_PROP_NAME_KEY, $f71441030fa79696$var$FRAGMENTS_KEY = $f91UN.FRAGMENTS_KEY, $f71441030fa79696$var$ID_KEY = $f91UN.ID_KEY, $f71441030fa79696$var$MODULE_COMPONENT_KEY = $f91UN.MODULE_COMPONENT_KEY, $f71441030fa79696$var$ROOT_ID = $f91UN.ROOT_ID, $f71441030fa79696$var$getArgumentValues = $f91UN.getArgumentValues, $f71441030fa79696$var$getModuleComponentKey = $f91UN.getModuleComponentKey, $f71441030fa79696$var$getStorageKey = $f91UN.getStorageKey;

var $5U85g = parcelRequire("5U85g");
var $f71441030fa79696$var$NoopResolverCache = $5U85g.NoopResolverCache;

var $bafrW = parcelRequire("bafrW");
var $f71441030fa79696$var$RESOLVER_FRAGMENT_MISSING_DATA_SENTINEL = $bafrW.RESOLVER_FRAGMENT_MISSING_DATA_SENTINEL, $f71441030fa79696$var$withResolverContext = $bafrW.withResolverContext;

var $M4yH2 = parcelRequire("M4yH2");
var $f71441030fa79696$var$generateTypeID = $M4yH2.generateTypeID;

var $423Vm = parcelRequire("423Vm");
function $f71441030fa79696$var$read(recordSource, selector, resolverCache) {
    var reader = new $f71441030fa79696$var$RelayReader(recordSource, selector, resolverCache !== null && resolverCache !== void 0 ? resolverCache : new $f71441030fa79696$var$NoopResolverCache());
    return reader.read();
}
var $f71441030fa79696$var$RelayReader = /*#__PURE__*/ function() {
    function RelayReader(recordSource, selector, resolverCache) {
        var _selector$clientEdgeT;
        this._clientEdgeTraversalPath = (_selector$clientEdgeT = selector.clientEdgeTraversalPath) !== null && _selector$clientEdgeT !== void 0 && _selector$clientEdgeT.length ? (0, $f71441030fa79696$var$_toConsumableArray2["default"])(selector.clientEdgeTraversalPath) : [];
        this._missingClientEdges = [];
        this._missingLiveResolverFields = [];
        this._isMissingData = false;
        this._isWithinUnmatchedTypeRefinement = false;
        this._missingRequiredFields = null;
        this._errorResponseFields = null;
        this._owner = selector.owner;
        this._recordSource = recordSource;
        this._seenRecords = new Set();
        this._selector = selector;
        this._variables = selector.variables;
        this._resolverCache = resolverCache;
        this._resolverErrors = [];
        this._fragmentName = selector.node.name;
        this._updatedDataIDs = new Set();
    }
    var _proto = RelayReader.prototype;
    _proto.read = function read() {
        var _this$_selector = this._selector, node = _this$_selector.node, dataID = _this$_selector.dataID, isWithinUnmatchedTypeRefinement = _this$_selector.isWithinUnmatchedTypeRefinement;
        var abstractKey = node.abstractKey;
        var record = this._recordSource.get(dataID);
        var isDataExpectedToBePresent = !isWithinUnmatchedTypeRefinement;
        if (isDataExpectedToBePresent && abstractKey == null && record != null) {
            var recordType = $fagih.getType(record);
            if (recordType !== node.type && dataID !== $f71441030fa79696$var$ROOT_ID) isDataExpectedToBePresent = false;
        }
        if (isDataExpectedToBePresent && abstractKey != null && record != null) {
            var implementsInterface = this._implementsInterface(record, abstractKey);
            if (implementsInterface === false) isDataExpectedToBePresent = false;
            else if (implementsInterface == null) this._isMissingData = true;
        }
        this._isWithinUnmatchedTypeRefinement = !isDataExpectedToBePresent;
        var data = this._traverse(node, dataID, null);
        if (this._updatedDataIDs.size > 0) {
            this._resolverCache.notifyUpdatedSubscribers(this._updatedDataIDs);
            this._updatedDataIDs.clear();
        }
        return {
            data: data,
            isMissingData: this._isMissingData && isDataExpectedToBePresent,
            missingClientEdges: this._missingClientEdges.length ? this._missingClientEdges : null,
            missingLiveResolverFields: this._missingLiveResolverFields,
            seenRecords: this._seenRecords,
            selector: this._selector,
            missingRequiredFields: this._missingRequiredFields,
            relayResolverErrors: this._resolverErrors,
            errorResponseFields: this._errorResponseFields
        };
    };
    _proto._maybeAddErrorResponseFields = function _maybeAddErrorResponseFields(record, storageKey) {
        if (!$llkIA.ENABLE_FIELD_ERROR_HANDLING) return;
        var errors = $fagih.getErrors(record, storageKey);
        if (errors == null) return;
        var owner = this._fragmentName;
        if (this._errorResponseFields == null) this._errorResponseFields = [];
        var _iterator = (0, $f71441030fa79696$var$_createForOfIteratorHelper2["default"])(errors), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var _error$path;
                var error = _step.value;
                this._errorResponseFields.push({
                    owner: owner,
                    path: ((_error$path = error.path) !== null && _error$path !== void 0 ? _error$path : []).join('.'),
                    error: error
                });
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
    };
    _proto._markDataAsMissing = function _markDataAsMissing() {
        this._isMissingData = true;
        if (this._clientEdgeTraversalPath.length) {
            var top = this._clientEdgeTraversalPath[this._clientEdgeTraversalPath.length - 1];
            if (top !== null) this._missingClientEdges.push({
                request: top.readerClientEdge.operation,
                clientEdgeDestinationID: top.clientEdgeDestinationID
            });
        }
    };
    _proto._traverse = function _traverse(node, dataID, prevData) {
        var record = this._recordSource.get(dataID);
        this._seenRecords.add(dataID);
        if (record == null) {
            if (record === undefined) this._markDataAsMissing();
            return record;
        }
        var data = prevData || {};
        var hadRequiredData = this._traverseSelections(node.selections, record, data);
        return hadRequiredData ? data : null;
    };
    _proto._getVariableValue = function _getVariableValue(name) {
        !this._variables.hasOwnProperty(name) && $423Vm(false);
        return this._variables[name];
    };
    _proto._maybeReportUnexpectedNull = function _maybeReportUnexpectedNull(fieldPath, action) {
        var _this$_missingRequire;
        if (((_this$_missingRequire = this._missingRequiredFields) === null || _this$_missingRequire === void 0 ? void 0 : _this$_missingRequire.action) === 'THROW') return;
        var owner = this._fragmentName;
        switch(action){
            case 'THROW':
                this._missingRequiredFields = {
                    action: action,
                    field: {
                        path: fieldPath,
                        owner: owner
                    }
                };
                return;
            case 'LOG':
                if (this._missingRequiredFields == null) this._missingRequiredFields = {
                    action: action,
                    fields: [
                        {
                            path: fieldPath,
                            owner: owner
                        }
                    ]
                };
                else this._missingRequiredFields = {
                    action: action,
                    fields: [].concat((0, $f71441030fa79696$var$_toConsumableArray2["default"])(this._missingRequiredFields.fields), [
                        {
                            path: fieldPath,
                            owner: owner
                        }
                    ])
                };
                return;
            default:
                action;
        }
    };
    _proto._handleCatchFieldValue = function _handleCatchFieldValue(selection, record, data, value) {
        var _selection$field$back, _selection$field, _field$alias, _this$_missingRequire2;
        var to = selection.to;
        var field = (_selection$field$back = (_selection$field = selection.field) === null || _selection$field === void 0 ? void 0 : _selection$field.backingField) !== null && _selection$field$back !== void 0 ? _selection$field$back : selection.field;
        var fieldName = (_field$alias = field === null || field === void 0 ? void 0 : field.alias) !== null && _field$alias !== void 0 ? _field$alias : field === null || field === void 0 ? void 0 : field.name;
        !(fieldName != null) && $423Vm(false);
        if (this._errorResponseFields != null) for(var i = 0; i < this._errorResponseFields.length; i++)this._errorResponseFields[i].to = to;
        if (((_this$_missingRequire2 = this._missingRequiredFields) === null || _this$_missingRequire2 === void 0 ? void 0 : _this$_missingRequire2.action) === 'THROW') {
            var _this$_missingRequire3;
            if (((_this$_missingRequire3 = this._missingRequiredFields) === null || _this$_missingRequire3 === void 0 ? void 0 : _this$_missingRequire3.field) == null) return;
            if (this._errorResponseFields == null) this._errorResponseFields = [];
            var _this$_missingRequire4 = this._missingRequiredFields.field, owner = _this$_missingRequire4.owner, path = _this$_missingRequire4.path;
            this._errorResponseFields.push({
                owner: owner,
                path: path,
                error: {
                    message: "Relay: Missing @required value at path '".concat(path, "' in '").concat(owner, "'.")
                },
                to: to
            });
            this._missingRequiredFields = null;
            return;
        }
        if (this._errorResponseFields != null) {
            var errors = this._errorResponseFields.map(function(error) {
                return error.error;
            });
            data[fieldName] = {
                ok: false,
                errors: errors
            };
            return;
        }
        data[fieldName] = {
            ok: true,
            value: value
        };
    };
    _proto._handleRequiredFieldValue = function _handleRequiredFieldValue(selection, value) {
        if (value == null) {
            var action = selection.action;
            if (action !== 'NONE') this._maybeReportUnexpectedNull(selection.path, action);
            return false;
        }
        return true;
    };
    _proto._traverseSelections = function _traverseSelections(selections, record, data) {
        for(var i = 0; i < selections.length; i++){
            var selection = selections[i];
            switch(selection.kind){
                case $f71441030fa79696$var$REQUIRED_FIELD:
                    var requiredFieldValue = this._readClientSideDirectiveField(selection, record, data);
                    if (!this._handleRequiredFieldValue(selection, requiredFieldValue)) return false;
                    break;
                case $f71441030fa79696$var$CATCH_FIELD:
                    var catchFieldValue = this._readClientSideDirectiveField(selection, record, data);
                    if ($llkIA.ENABLE_FIELD_ERROR_HANDLING_CATCH_DIRECTIVE) {
                        if (selection.to != 'NULL') this._handleCatchFieldValue(selection, record, data, catchFieldValue);
                    }
                    break;
                case $f71441030fa79696$var$SCALAR_FIELD:
                    this._readScalar(selection, record, data);
                    break;
                case $f71441030fa79696$var$LINKED_FIELD:
                    if (selection.plural) this._readPluralLink(selection, record, data);
                    else this._readLink(selection, record, data);
                    break;
                case $f71441030fa79696$var$CONDITION:
                    var conditionValue = Boolean(this._getVariableValue(selection.condition));
                    if (conditionValue === selection.passingValue) {
                        var hasExpectedData = this._traverseSelections(selection.selections, record, data);
                        if (!hasExpectedData) return false;
                    }
                    break;
                case $f71441030fa79696$var$INLINE_FRAGMENT:
                    if (this._readInlineFragment(selection, record, data) === false) return false;
                    break;
                case $f71441030fa79696$var$RELAY_LIVE_RESOLVER:
                case $f71441030fa79696$var$RELAY_RESOLVER:
                    if (!$llkIA.ENABLE_RELAY_RESOLVERS) throw new Error('Relay Resolver fields are not yet supported.');
                    this._readResolverField(selection, record, data);
                    break;
                case $f71441030fa79696$var$FRAGMENT_SPREAD:
                    this._createFragmentPointer(selection, record, data);
                    break;
                case $f71441030fa79696$var$ALIASED_FRAGMENT_SPREAD:
                    data[selection.name] = this._createAliasedFragmentSpread(selection, record);
                    break;
                case $f71441030fa79696$var$ALIASED_INLINE_FRAGMENT_SPREAD:
                    var fieldValue = this._readInlineFragment(selection.fragment, record, {});
                    if (fieldValue === false) fieldValue = null;
                    data[selection.name] = fieldValue;
                    break;
                case $f71441030fa79696$var$MODULE_IMPORT:
                    this._readModuleImport(selection, record, data);
                    break;
                case $f71441030fa79696$var$INLINE_DATA_FRAGMENT_SPREAD:
                    this._createInlineDataOrResolverFragmentPointer(selection, record, data);
                    break;
                case $f71441030fa79696$var$DEFER:
                case $f71441030fa79696$var$CLIENT_EXTENSION:
                    var isMissingData = this._isMissingData;
                    var alreadyMissingClientEdges = this._missingClientEdges.length;
                    this._clientEdgeTraversalPath.push(null);
                    var _hasExpectedData = this._traverseSelections(selection.selections, record, data);
                    this._isMissingData = isMissingData || this._missingClientEdges.length > alreadyMissingClientEdges || this._missingLiveResolverFields.length > 0;
                    this._clientEdgeTraversalPath.pop();
                    if (!_hasExpectedData) return false;
                    break;
                case $f71441030fa79696$var$STREAM:
                    var _hasExpectedData2 = this._traverseSelections(selection.selections, record, data);
                    if (!_hasExpectedData2) return false;
                    break;
                case $f71441030fa79696$var$ACTOR_CHANGE:
                    this._readActorChange(selection, record, data);
                    break;
                case $f71441030fa79696$var$CLIENT_EDGE_TO_CLIENT_OBJECT:
                case $f71441030fa79696$var$CLIENT_EDGE_TO_SERVER_OBJECT:
                    this._readClientEdge(selection, record, data);
                    break;
                default:
                    selection;
                    $423Vm(false);
            }
        }
        return true;
    };
    _proto._readClientSideDirectiveField = function _readClientSideDirectiveField(selection, record, data) {
        switch(selection.field.kind){
            case $f71441030fa79696$var$SCALAR_FIELD:
                return this._readScalar(selection.field, record, data);
            case $f71441030fa79696$var$LINKED_FIELD:
                if (selection.field.plural) return this._readPluralLink(selection.field, record, data);
                else return this._readLink(selection.field, record, data);
            case $f71441030fa79696$var$RELAY_RESOLVER:
                if (!$llkIA.ENABLE_RELAY_RESOLVERS) throw new Error('Relay Resolver fields are not yet supported.');
                return this._readResolverField(selection.field, record, data);
            case $f71441030fa79696$var$RELAY_LIVE_RESOLVER:
                if (!$llkIA.ENABLE_RELAY_RESOLVERS) throw new Error('Relay Resolver fields are not yet supported.');
                return this._readResolverField(selection.field, record, data);
            case $f71441030fa79696$var$CLIENT_EDGE_TO_CLIENT_OBJECT:
            case $f71441030fa79696$var$CLIENT_EDGE_TO_SERVER_OBJECT:
                if (!$llkIA.ENABLE_RELAY_RESOLVERS) throw new Error('Relay Resolver fields are not yet supported.');
                return this._readClientEdge(selection.field, record, data);
            default:
                selection.field.kind;
                $423Vm(false);
        }
    };
    _proto._readResolverField = function _readResolverField(field, record, data) {
        var _field$alias2;
        var parentRecordID = $fagih.getDataID(record);
        var result = this._readResolverFieldImpl(field, parentRecordID);
        var fieldName = (_field$alias2 = field.alias) !== null && _field$alias2 !== void 0 ? _field$alias2 : field.name;
        data[fieldName] = result;
        return result;
    };
    _proto._readResolverFieldImpl = function _readResolverFieldImpl(field, parentRecordID) {
        var _this = this;
        var fragment = field.fragment;
        var snapshot;
        var getDataForResolverFragment = function getDataForResolverFragment(singularReaderSelector) {
            if (snapshot != null) return {
                data: snapshot.data,
                isMissingData: snapshot.isMissingData
            };
            snapshot = $f71441030fa79696$var$read(_this._recordSource, singularReaderSelector, _this._resolverCache);
            return {
                data: snapshot.data,
                isMissingData: snapshot.isMissingData
            };
        };
        var evaluate = function evaluate() {
            if (fragment != null) {
                var key = {
                    __id: parentRecordID,
                    __fragmentOwner: _this._owner,
                    __fragments: (0, $f71441030fa79696$var$_defineProperty2["default"])({}, fragment.name, fragment.args ? $f71441030fa79696$var$getArgumentValues(fragment.args, _this._variables) : {})
                };
                var resolverContext = {
                    getDataForResolverFragment: getDataForResolverFragment
                };
                return $f71441030fa79696$var$withResolverContext(resolverContext, function() {
                    var _getResolverValue = $f71441030fa79696$var$getResolverValue(field, _this._variables, key), resolverResult = _getResolverValue[0], resolverError = _getResolverValue[1];
                    return {
                        resolverResult: resolverResult,
                        snapshot: snapshot,
                        error: resolverError
                    };
                });
            } else {
                var _getResolverValue2 = $f71441030fa79696$var$getResolverValue(field, _this._variables, null), resolverResult = _getResolverValue2[0], _resolverError = _getResolverValue2[1];
                return {
                    resolverResult: resolverResult,
                    snapshot: undefined,
                    error: _resolverError
                };
            }
        };
        var _this$_resolverCache$ = this._resolverCache.readFromCacheOrEvaluate(parentRecordID, field, this._variables, evaluate, getDataForResolverFragment), result = _this$_resolverCache$[0], seenRecord = _this$_resolverCache$[1], resolverError = _this$_resolverCache$[2], cachedSnapshot = _this$_resolverCache$[3], suspenseID = _this$_resolverCache$[4], updatedDataIDs = _this$_resolverCache$[5];
        this._propogateResolverMetadata(field.path, cachedSnapshot, resolverError, seenRecord, suspenseID, updatedDataIDs);
        return result;
    };
    _proto._propogateResolverMetadata = function _propogateResolverMetadata(fieldPath, cachedSnapshot, resolverError, seenRecord, suspenseID, updatedDataIDs) {
        if (cachedSnapshot != null) {
            if (cachedSnapshot.missingRequiredFields != null) this._addMissingRequiredFields(cachedSnapshot.missingRequiredFields);
            if (cachedSnapshot.missingClientEdges != null) {
                var _iterator2 = (0, $f71441030fa79696$var$_createForOfIteratorHelper2["default"])(cachedSnapshot.missingClientEdges), _step2;
                try {
                    for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                        var missing = _step2.value;
                        this._missingClientEdges.push(missing);
                    }
                } catch (err) {
                    _iterator2.e(err);
                } finally{
                    _iterator2.f();
                }
            }
            if (cachedSnapshot.missingLiveResolverFields != null) {
                this._isMissingData = this._isMissingData || cachedSnapshot.missingLiveResolverFields.length > 0;
                var _iterator3 = (0, $f71441030fa79696$var$_createForOfIteratorHelper2["default"])(cachedSnapshot.missingLiveResolverFields), _step3;
                try {
                    for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                        var missingResolverField = _step3.value;
                        this._missingLiveResolverFields.push(missingResolverField);
                    }
                } catch (err) {
                    _iterator3.e(err);
                } finally{
                    _iterator3.f();
                }
            }
            var _iterator4 = (0, $f71441030fa79696$var$_createForOfIteratorHelper2["default"])(cachedSnapshot.relayResolverErrors), _step4;
            try {
                for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                    var error = _step4.value;
                    this._resolverErrors.push(error);
                }
            } catch (err) {
                _iterator4.e(err);
            } finally{
                _iterator4.f();
            }
            this._isMissingData = this._isMissingData || cachedSnapshot.isMissingData;
        }
        if (resolverError) this._resolverErrors.push({
            field: {
                path: fieldPath,
                owner: this._fragmentName
            },
            error: resolverError
        });
        if (seenRecord != null) this._seenRecords.add(seenRecord);
        if (suspenseID != null) {
            this._isMissingData = true;
            this._missingLiveResolverFields.push({
                path: "".concat(this._fragmentName, ".").concat(fieldPath),
                liveStateID: suspenseID
            });
        }
        if (updatedDataIDs != null) {
            var _iterator5 = (0, $f71441030fa79696$var$_createForOfIteratorHelper2["default"])(updatedDataIDs), _step5;
            try {
                for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                    var recordID = _step5.value;
                    this._updatedDataIDs.add(recordID);
                }
            } catch (err) {
                _iterator5.e(err);
            } finally{
                _iterator5.f();
            }
        }
    };
    _proto._readClientEdge = function _readClientEdge(field, record, data) {
        var _this2 = this;
        var _backingField$alias;
        var backingField = field.backingField;
        !(backingField.kind !== 'ClientExtension') && $423Vm(false);
        var fieldName = (_backingField$alias = backingField.alias) !== null && _backingField$alias !== void 0 ? _backingField$alias : backingField.name;
        var backingFieldData = {};
        this._traverseSelections([
            backingField
        ], record, backingFieldData);
        var clientEdgeResolverResponse = backingFieldData[fieldName];
        if (clientEdgeResolverResponse == null || $f71441030fa79696$var$isSuspenseSentinel(clientEdgeResolverResponse)) {
            data[fieldName] = clientEdgeResolverResponse;
            return clientEdgeResolverResponse;
        }
        if (field.linkedField.plural) {
            !Array.isArray(clientEdgeResolverResponse) && $423Vm(false);
            var storeIDs;
            !(field.kind === $f71441030fa79696$var$CLIENT_EDGE_TO_CLIENT_OBJECT) && $423Vm(false);
            if (field.backingField.normalizationInfo == null) storeIDs = clientEdgeResolverResponse.map(function(itemResponse) {
                var _field$concreteType;
                var concreteType = (_field$concreteType = field.concreteType) !== null && _field$concreteType !== void 0 ? _field$concreteType : itemResponse.__typename;
                !(typeof concreteType === 'string') && $423Vm(false);
                var localId = $f71441030fa79696$var$extractIdFromResponse(itemResponse);
                var id = _this2._resolverCache.ensureClientRecord(localId, concreteType);
                var modelResolvers = field.modelResolvers;
                if (modelResolvers != null) {
                    var modelResolver = modelResolvers[concreteType];
                    !(modelResolver !== undefined) && $423Vm(false);
                    var model = _this2._readResolverFieldImpl(modelResolver, id);
                    return model != null ? id : null;
                }
                return id;
            });
            else storeIDs = clientEdgeResolverResponse.map($f71441030fa79696$var$extractIdFromResponse);
            this._clientEdgeTraversalPath.push(null);
            var edgeValues = this._readLinkedIds(field.linkedField, storeIDs, record, data);
            this._clientEdgeTraversalPath.pop();
            data[fieldName] = edgeValues;
            return edgeValues;
        } else {
            var _field$concreteType2;
            var id = $f71441030fa79696$var$extractIdFromResponse(clientEdgeResolverResponse);
            var storeID;
            var concreteType = (_field$concreteType2 = field.concreteType) !== null && _field$concreteType2 !== void 0 ? _field$concreteType2 : clientEdgeResolverResponse.__typename;
            var traversalPathSegment;
            if (field.kind === $f71441030fa79696$var$CLIENT_EDGE_TO_CLIENT_OBJECT) {
                if (field.backingField.normalizationInfo == null) {
                    !(typeof concreteType === 'string') && $423Vm(false);
                    storeID = this._resolverCache.ensureClientRecord(id, concreteType);
                    traversalPathSegment = null;
                } else {
                    storeID = id;
                    traversalPathSegment = null;
                }
            } else {
                storeID = id;
                traversalPathSegment = {
                    readerClientEdge: field,
                    clientEdgeDestinationID: id
                };
            }
            var modelResolvers = field.modelResolvers;
            if (modelResolvers != null) {
                !(typeof concreteType === 'string') && $423Vm(false);
                var modelResolver = modelResolvers[concreteType];
                !(modelResolver !== undefined) && $423Vm(false);
                var model = this._readResolverFieldImpl(modelResolver, storeID);
                if (model == null) {
                    data[fieldName] = null;
                    return null;
                }
            }
            this._clientEdgeTraversalPath.push(traversalPathSegment);
            var prevData = data[fieldName];
            !(prevData == null || typeof prevData === 'object') && $423Vm(false);
            var edgeValue = this._traverse(field.linkedField, storeID, prevData);
            this._clientEdgeTraversalPath.pop();
            data[fieldName] = edgeValue;
            return edgeValue;
        }
    };
    _proto._readScalar = function _readScalar(field, record, data) {
        var _field$alias3;
        var fieldName = (_field$alias3 = field.alias) !== null && _field$alias3 !== void 0 ? _field$alias3 : field.name;
        var storageKey = $f71441030fa79696$var$getStorageKey(field, this._variables);
        var value = $fagih.getValue(record, storageKey);
        if (value === null) this._maybeAddErrorResponseFields(record, storageKey);
        else if (value === undefined) this._markDataAsMissing();
        data[fieldName] = value;
        return value;
    };
    _proto._readLink = function _readLink(field, record, data) {
        var _field$alias4;
        var fieldName = (_field$alias4 = field.alias) !== null && _field$alias4 !== void 0 ? _field$alias4 : field.name;
        var storageKey = $f71441030fa79696$var$getStorageKey(field, this._variables);
        var linkedID = $fagih.getLinkedRecordID(record, storageKey);
        if (linkedID == null) {
            data[fieldName] = linkedID;
            if (linkedID === null) this._maybeAddErrorResponseFields(record, storageKey);
            else if (linkedID === undefined) this._markDataAsMissing();
            return linkedID;
        }
        var prevData = data[fieldName];
        !(prevData == null || typeof prevData === 'object') && $423Vm(false);
        var value = this._traverse(field, linkedID, prevData);
        data[fieldName] = value;
        return value;
    };
    _proto._readActorChange = function _readActorChange(field, record, data) {
        var _field$alias5;
        var fieldName = (_field$alias5 = field.alias) !== null && _field$alias5 !== void 0 ? _field$alias5 : field.name;
        var storageKey = $f71441030fa79696$var$getStorageKey(field, this._variables);
        var externalRef = $fagih.getActorLinkedRecordID(record, storageKey);
        if (externalRef == null) {
            data[fieldName] = externalRef;
            if (externalRef === undefined) this._markDataAsMissing();
            else if (externalRef === null) this._maybeAddErrorResponseFields(record, storageKey);
            return data[fieldName];
        }
        var actorIdentifier = externalRef[0], dataID = externalRef[1];
        var fragmentRef = {};
        this._createFragmentPointer(field.fragmentSpread, $fagih.fromObject({
            __id: dataID
        }), fragmentRef);
        data[fieldName] = {
            __fragmentRef: fragmentRef,
            __viewer: actorIdentifier
        };
        return data[fieldName];
    };
    _proto._readPluralLink = function _readPluralLink(field, record, data) {
        var storageKey = $f71441030fa79696$var$getStorageKey(field, this._variables);
        var linkedIDs = $fagih.getLinkedRecordIDs(record, storageKey);
        if (linkedIDs === null) this._maybeAddErrorResponseFields(record, storageKey);
        return this._readLinkedIds(field, linkedIDs, record, data);
    };
    _proto._readLinkedIds = function _readLinkedIds(field, linkedIDs, record, data) {
        var _this3 = this;
        var _field$alias6;
        var fieldName = (_field$alias6 = field.alias) !== null && _field$alias6 !== void 0 ? _field$alias6 : field.name;
        if (linkedIDs == null) {
            data[fieldName] = linkedIDs;
            if (linkedIDs === undefined) this._markDataAsMissing();
            return linkedIDs;
        }
        var prevData = data[fieldName];
        !(prevData == null || Array.isArray(prevData)) && $423Vm(false);
        var linkedArray = prevData || [];
        linkedIDs.forEach(function(linkedID, nextIndex) {
            if (linkedID == null) {
                if (linkedID === undefined) _this3._markDataAsMissing();
                linkedArray[nextIndex] = linkedID;
                return;
            }
            var prevItem = linkedArray[nextIndex];
            !(prevItem == null || typeof prevItem === 'object') && $423Vm(false);
            linkedArray[nextIndex] = _this3._traverse(field, linkedID, prevItem);
        });
        data[fieldName] = linkedArray;
        return linkedArray;
    };
    _proto._readModuleImport = function _readModuleImport(moduleImport, record, data) {
        var componentKey = $f71441030fa79696$var$getModuleComponentKey(moduleImport.documentName);
        var component = $fagih.getValue(record, componentKey);
        if (component == null) {
            if (component === undefined) this._markDataAsMissing();
            return;
        }
        this._createFragmentPointer({
            kind: 'FragmentSpread',
            name: moduleImport.fragmentName,
            args: moduleImport.args
        }, record, data);
        data[$f71441030fa79696$var$FRAGMENT_PROP_NAME_KEY] = moduleImport.fragmentPropName;
        data[$f71441030fa79696$var$MODULE_COMPONENT_KEY] = component;
    };
    _proto._createAliasedFragmentSpread = function _createAliasedFragmentSpread(namedFragmentSpread, record) {
        var abstractKey = namedFragmentSpread.abstractKey;
        if (abstractKey == null) {
            var typeName = $fagih.getType(record);
            if (typeName == null || typeName !== namedFragmentSpread.type) return null;
        } else {
            var implementsInterface = this._implementsInterface(record, abstractKey);
            if (implementsInterface === false) return null;
            else if (implementsInterface == null) {
                this._markDataAsMissing();
                return undefined;
            }
        }
        var fieldData = {};
        this._createFragmentPointer(namedFragmentSpread.fragment, record, fieldData);
        return $fagih.fromObject(fieldData);
    };
    _proto._readInlineFragment = function _readInlineFragment(inlineFragment, record, data) {
        if (inlineFragment.type == null) {
            var hasExpectedData = this._traverseSelections(inlineFragment.selections, record, data);
            if (hasExpectedData === false) return false;
            return data;
        }
        var abstractKey = inlineFragment.abstractKey;
        if (abstractKey == null) {
            var typeName = $fagih.getType(record);
            if (typeName == null || typeName !== inlineFragment.type) return null;
            else {
                var hasExpectedData = this._traverseSelections(inlineFragment.selections, record, data);
                if (!hasExpectedData) return false;
            }
        } else {
            var implementsInterface = this._implementsInterface(record, abstractKey);
            var parentIsMissingData = this._isMissingData;
            var parentIsWithinUnmatchedTypeRefinement = this._isWithinUnmatchedTypeRefinement;
            this._isWithinUnmatchedTypeRefinement = parentIsWithinUnmatchedTypeRefinement || implementsInterface === false;
            this._traverseSelections(inlineFragment.selections, record, data);
            this._isWithinUnmatchedTypeRefinement = parentIsWithinUnmatchedTypeRefinement;
            if (implementsInterface === false) {
                this._isMissingData = parentIsMissingData;
                return undefined;
            } else if (implementsInterface == null) {
                this._markDataAsMissing();
                return null;
            }
        }
        return data;
    };
    _proto._createFragmentPointer = function _createFragmentPointer(fragmentSpread, record, data) {
        var fragmentPointers = data[$f71441030fa79696$var$FRAGMENTS_KEY];
        if (fragmentPointers == null) fragmentPointers = data[$f71441030fa79696$var$FRAGMENTS_KEY] = {};
        !(typeof fragmentPointers === 'object' && fragmentPointers != null) && $423Vm(false);
        if (data[$f71441030fa79696$var$ID_KEY] == null) data[$f71441030fa79696$var$ID_KEY] = $fagih.getDataID(record);
        fragmentPointers[fragmentSpread.name] = $f71441030fa79696$var$getArgumentValues(fragmentSpread.args, this._variables, this._isWithinUnmatchedTypeRefinement);
        data[$f71441030fa79696$var$FRAGMENT_OWNER_KEY] = this._owner;
        if (this._clientEdgeTraversalPath.length > 0 && this._clientEdgeTraversalPath[this._clientEdgeTraversalPath.length - 1] !== null) data[$f71441030fa79696$var$CLIENT_EDGE_TRAVERSAL_PATH] = (0, $f71441030fa79696$var$_toConsumableArray2["default"])(this._clientEdgeTraversalPath);
    };
    _proto._createInlineDataOrResolverFragmentPointer = function _createInlineDataOrResolverFragmentPointer(fragmentSpreadOrFragment, record, data) {
        var fragmentPointers = data[$f71441030fa79696$var$FRAGMENTS_KEY];
        if (fragmentPointers == null) fragmentPointers = data[$f71441030fa79696$var$FRAGMENTS_KEY] = {};
        !(typeof fragmentPointers === 'object' && fragmentPointers != null) && $423Vm(false);
        if (data[$f71441030fa79696$var$ID_KEY] == null) data[$f71441030fa79696$var$ID_KEY] = $fagih.getDataID(record);
        var inlineData = {};
        var parentFragmentName = this._fragmentName;
        this._fragmentName = fragmentSpreadOrFragment.name;
        var parentVariables = this._variables;
        var argumentVariables = fragmentSpreadOrFragment.args ? $f71441030fa79696$var$getArgumentValues(fragmentSpreadOrFragment.args, this._variables) : {};
        this._variables = $frIyf.getFragmentVariables(fragmentSpreadOrFragment, this._owner.variables, argumentVariables);
        this._traverseSelections(fragmentSpreadOrFragment.selections, record, inlineData);
        this._variables = parentVariables;
        this._fragmentName = parentFragmentName;
        fragmentPointers[fragmentSpreadOrFragment.name] = inlineData;
    };
    _proto._addMissingRequiredFields = function _addMissingRequiredFields(additional) {
        if (this._missingRequiredFields == null) {
            this._missingRequiredFields = additional;
            return;
        }
        if (this._missingRequiredFields.action === 'THROW') return;
        if (additional.action === 'THROW') {
            this._missingRequiredFields = additional;
            return;
        }
        this._missingRequiredFields = {
            action: 'LOG',
            fields: [].concat((0, $f71441030fa79696$var$_toConsumableArray2["default"])(this._missingRequiredFields.fields), (0, $f71441030fa79696$var$_toConsumableArray2["default"])(additional.fields))
        };
    };
    _proto._implementsInterface = function _implementsInterface(record, abstractKey) {
        var typeName = $fagih.getType(record);
        var typeRecord = this._recordSource.get($f71441030fa79696$var$generateTypeID(typeName));
        var implementsInterface = typeRecord != null ? $fagih.getValue(typeRecord, abstractKey) : null;
        return implementsInterface;
    };
    return RelayReader;
}();
function $f71441030fa79696$var$getResolverValue(field, variables, fragmentKey) {
    var resolverFunction = typeof field.resolverModule === 'function' ? field.resolverModule : field.resolverModule["default"];
    var resolverResult = null;
    var resolverError = null;
    try {
        var resolverFunctionArgs = [];
        if (field.fragment != null) resolverFunctionArgs.push(fragmentKey);
        var args = field.args ? $f71441030fa79696$var$getArgumentValues(field.args, variables) : undefined;
        resolverFunctionArgs.push(args);
        resolverResult = resolverFunction.apply(null, resolverFunctionArgs);
    } catch (e) {
        if (e === $f71441030fa79696$var$RESOLVER_FRAGMENT_MISSING_DATA_SENTINEL) resolverResult = undefined;
        else resolverError = e;
    }
    return [
        resolverResult,
        resolverError
    ];
}
function $f71441030fa79696$var$extractIdFromResponse(individualResponse) {
    if (typeof individualResponse === 'string') return individualResponse;
    else if (typeof individualResponse === 'object' && individualResponse != null && typeof individualResponse.id === 'string') return individualResponse.id;
    $423Vm(false);
}
module.exports = {
    read: $f71441030fa79696$var$read
};

});
parcelRegister("5U85g", function(module, exports) {
'use strict';

var $7Wmh0 = parcelRequire("7Wmh0");
var $44c873fbe33c23b3$var$_interopRequireDefault = $7Wmh0.default;

var $44c873fbe33c23b3$var$_createForOfIteratorHelper2 = $44c873fbe33c23b3$var$_interopRequireDefault((parcelRequire("9CLQ8")));

var $l9X9G = parcelRequire("l9X9G");

var $54ow8 = parcelRequire("54ow8");
var $44c873fbe33c23b3$var$RELAY_LIVE_RESOLVER = $54ow8.RELAY_LIVE_RESOLVER;

var $llkIA = parcelRequire("llkIA");

var $2UUcW = parcelRequire("2UUcW");

var $axs8G = parcelRequire("axs8G");
var $44c873fbe33c23b3$var$generateClientID = $axs8G.generateClientID;

var $fagih = parcelRequire("fagih");

var $f91UN = parcelRequire("f91UN");
var $44c873fbe33c23b3$var$RELAY_RESOLVER_ERROR_KEY = $f91UN.RELAY_RESOLVER_ERROR_KEY, $44c873fbe33c23b3$var$RELAY_RESOLVER_INVALIDATION_KEY = $f91UN.RELAY_RESOLVER_INVALIDATION_KEY, $44c873fbe33c23b3$var$RELAY_RESOLVER_SNAPSHOT_KEY = $f91UN.RELAY_RESOLVER_SNAPSHOT_KEY, $44c873fbe33c23b3$var$RELAY_RESOLVER_VALUE_KEY = $f91UN.RELAY_RESOLVER_VALUE_KEY, $44c873fbe33c23b3$var$getStorageKey = $f91UN.getStorageKey;

var $423Vm = parcelRequire("423Vm");
parcelRequire("dH6ue");
var $44c873fbe33c23b3$var$emptySet = new Set();
var $44c873fbe33c23b3$var$NoopResolverCache = /*#__PURE__*/ function() {
    function NoopResolverCache() {}
    var _proto = NoopResolverCache.prototype;
    _proto.readFromCacheOrEvaluate = function readFromCacheOrEvaluate(recordID, field, variables, evaluate, getDataForResolverFragment) {
        !(field.kind !== $44c873fbe33c23b3$var$RELAY_LIVE_RESOLVER) && $423Vm(false);
        var _evaluate = evaluate(), resolverResult = _evaluate.resolverResult, snapshot = _evaluate.snapshot, error = _evaluate.error;
        return [
            resolverResult,
            undefined,
            error,
            snapshot,
            undefined,
            undefined
        ];
    };
    _proto.invalidateDataIDs = function invalidateDataIDs(updatedDataIDs) {};
    _proto.ensureClientRecord = function ensureClientRecord(id, typeName) {
        $423Vm(false);
    };
    _proto.notifyUpdatedSubscribers = function notifyUpdatedSubscribers(updatedDataIDs) {};
    return NoopResolverCache;
}();
function $44c873fbe33c23b3$var$addDependencyEdge(edges, from, to) {
    var set = edges.get(from);
    if (!set) {
        set = new Set();
        edges.set(from, set);
    }
    set.add(to);
}
var $44c873fbe33c23b3$var$RecordResolverCache = /*#__PURE__*/ function() {
    function RecordResolverCache(getRecordSource) {
        this._resolverIDToRecordIDs = new Map();
        this._recordIDToResolverIDs = new Map();
        this._getRecordSource = getRecordSource;
    }
    var _proto2 = RecordResolverCache.prototype;
    _proto2.readFromCacheOrEvaluate = function readFromCacheOrEvaluate(recordID, field, variables, evaluate, getDataForResolverFragment) {
        var recordSource = this._getRecordSource();
        var record = recordSource.get(recordID);
        !(record != null) && $423Vm(false);
        var storageKey = $44c873fbe33c23b3$var$getStorageKey(field, variables);
        var linkedID = $fagih.getLinkedRecordID(record, storageKey);
        var linkedRecord = linkedID == null ? null : recordSource.get(linkedID);
        if (linkedRecord == null || this._isInvalid(linkedRecord, getDataForResolverFragment)) {
            var _linkedID;
            linkedID = (_linkedID = linkedID) !== null && _linkedID !== void 0 ? _linkedID : $44c873fbe33c23b3$var$generateClientID(recordID, storageKey);
            linkedRecord = $fagih.create(linkedID, '__RELAY_RESOLVER__');
            var evaluationResult = evaluate();
            $2UUcW(evaluationResult.resolverResult);
            $fagih.setValue(linkedRecord, $44c873fbe33c23b3$var$RELAY_RESOLVER_VALUE_KEY, evaluationResult.resolverResult);
            $fagih.setValue(linkedRecord, $44c873fbe33c23b3$var$RELAY_RESOLVER_SNAPSHOT_KEY, evaluationResult.snapshot);
            $fagih.setValue(linkedRecord, $44c873fbe33c23b3$var$RELAY_RESOLVER_ERROR_KEY, evaluationResult.error);
            recordSource.set(linkedID, linkedRecord);
            var currentRecord = recordSource.get(recordID);
            !(currentRecord != null) && $423Vm(false);
            var nextRecord = $fagih.clone(currentRecord);
            $fagih.setLinkedRecordID(nextRecord, storageKey, linkedID);
            recordSource.set(recordID, nextRecord);
            if (field.fragment != null) {
                var _evaluationResult$sna;
                var fragmentStorageKey = $44c873fbe33c23b3$var$getStorageKey(field.fragment, variables);
                var resolverID = $44c873fbe33c23b3$var$generateClientID(recordID, fragmentStorageKey);
                $44c873fbe33c23b3$var$addDependencyEdge(this._resolverIDToRecordIDs, resolverID, linkedID);
                $44c873fbe33c23b3$var$addDependencyEdge(this._recordIDToResolverIDs, recordID, resolverID);
                var seenRecordIds = (_evaluationResult$sna = evaluationResult.snapshot) === null || _evaluationResult$sna === void 0 ? void 0 : _evaluationResult$sna.seenRecords;
                if (seenRecordIds != null) {
                    var _iterator = (0, $44c873fbe33c23b3$var$_createForOfIteratorHelper2["default"])(seenRecordIds), _step;
                    try {
                        for(_iterator.s(); !(_step = _iterator.n()).done;){
                            var seenRecordID = _step.value;
                            $44c873fbe33c23b3$var$addDependencyEdge(this._recordIDToResolverIDs, seenRecordID, resolverID);
                        }
                    } catch (err) {
                        _iterator.e(err);
                    } finally{
                        _iterator.f();
                    }
                }
            }
        }
        var answer = $fagih.getValue(linkedRecord, $44c873fbe33c23b3$var$RELAY_RESOLVER_VALUE_KEY);
        var snapshot = $fagih.getValue(linkedRecord, $44c873fbe33c23b3$var$RELAY_RESOLVER_SNAPSHOT_KEY);
        var error = $fagih.getValue(linkedRecord, $44c873fbe33c23b3$var$RELAY_RESOLVER_ERROR_KEY);
        return [
            answer,
            linkedID,
            error,
            snapshot,
            undefined,
            undefined
        ];
    };
    _proto2.invalidateDataIDs = function invalidateDataIDs(updatedDataIDs) {
        var recordSource = this._getRecordSource();
        var visited = new Set();
        var recordsToVisit = Array.from(updatedDataIDs);
        while(recordsToVisit.length){
            var recordID = recordsToVisit.pop();
            updatedDataIDs.add(recordID);
            var _iterator2 = (0, $44c873fbe33c23b3$var$_createForOfIteratorHelper2["default"])((_this$_recordIDToReso = this._recordIDToResolverIDs.get(recordID)) !== null && _this$_recordIDToReso !== void 0 ? _this$_recordIDToReso : $44c873fbe33c23b3$var$emptySet), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var _this$_recordIDToReso;
                    var fragment = _step2.value;
                    if (!visited.has(fragment)) {
                        var _iterator3 = (0, $44c873fbe33c23b3$var$_createForOfIteratorHelper2["default"])((_this$_resolverIDToRe = this._resolverIDToRecordIDs.get(fragment)) !== null && _this$_resolverIDToRe !== void 0 ? _this$_resolverIDToRe : $44c873fbe33c23b3$var$emptySet), _step3;
                        try {
                            for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                                var _this$_resolverIDToRe;
                                var anotherRecordID = _step3.value;
                                this._markInvalidatedResolverRecord(anotherRecordID, recordSource, updatedDataIDs);
                                if (!visited.has(anotherRecordID)) recordsToVisit.push(anotherRecordID);
                            }
                        } catch (err) {
                            _iterator3.e(err);
                        } finally{
                            _iterator3.f();
                        }
                    }
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
        }
    };
    _proto2._markInvalidatedResolverRecord = function _markInvalidatedResolverRecord(dataID, recordSource, updatedDataIDs) {
        var record = recordSource.get(dataID);
        if (!record) return;
        var nextRecord = $fagih.clone(record);
        $fagih.setValue(nextRecord, $44c873fbe33c23b3$var$RELAY_RESOLVER_INVALIDATION_KEY, true);
        recordSource.set(dataID, nextRecord);
    };
    _proto2._isInvalid = function _isInvalid(record, getDataForResolverFragment) {
        if (!$fagih.getValue(record, $44c873fbe33c23b3$var$RELAY_RESOLVER_INVALIDATION_KEY)) return false;
        var snapshot = $fagih.getValue(record, $44c873fbe33c23b3$var$RELAY_RESOLVER_SNAPSHOT_KEY);
        var originalInputs = snapshot === null || snapshot === void 0 ? void 0 : snapshot.data;
        var readerSelector = snapshot === null || snapshot === void 0 ? void 0 : snapshot.selector;
        if (originalInputs == null || readerSelector == null) return true;
        var _getDataForResolverFr = getDataForResolverFragment(readerSelector), latestValues = _getDataForResolverFr.data;
        var recycled = $l9X9G(originalInputs, latestValues);
        if (recycled !== originalInputs) return true;
        if ($llkIA.MARK_RESOLVER_VALUES_AS_CLEAN_AFTER_FRAGMENT_REREAD) {
            var nextRecord = $fagih.clone(record);
            $fagih.setValue(nextRecord, $44c873fbe33c23b3$var$RELAY_RESOLVER_INVALIDATION_KEY, false);
            var recordSource = this._getRecordSource();
            recordSource.set($fagih.getDataID(record), nextRecord);
        }
        return false;
    };
    _proto2.ensureClientRecord = function ensureClientRecord(id, typename) {
        $423Vm(false);
    };
    _proto2.notifyUpdatedSubscribers = function notifyUpdatedSubscribers(updatedDataIDs) {
        $423Vm(false);
    };
    return RecordResolverCache;
}();
module.exports = {
    NoopResolverCache: $44c873fbe33c23b3$var$NoopResolverCache,
    RecordResolverCache: $44c873fbe33c23b3$var$RecordResolverCache
};

});
parcelRegister("2UUcW", function(module, exports) {
'use strict';
module.exports = function shallowFreeze(value) {
    if (typeof value === 'object' && value != null && (Array.isArray(value) || value.constructor === Object)) Object.freeze(value);
};

});


parcelRegister("bafrW", function(module, exports) {
'use strict';

var $bzkJN = parcelRequire("bzkJN");
var $820c9cdc28ba0cad$var$getFragment = $bzkJN.getFragment;

var $g432U = parcelRequire("g432U");
var $820c9cdc28ba0cad$var$getSelector = $g432U.getSelector;

var $423Vm = parcelRequire("423Vm");
var $820c9cdc28ba0cad$var$contextStack = [];
function $820c9cdc28ba0cad$var$withResolverContext(context, cb) {
    $820c9cdc28ba0cad$var$contextStack.push(context);
    try {
        return cb();
    } finally{
        $820c9cdc28ba0cad$var$contextStack.pop();
    }
}
function $820c9cdc28ba0cad$var$readFragment(fragmentInput, fragmentKey) {
    if (!$820c9cdc28ba0cad$var$contextStack.length) throw new Error('readFragment should be called only from within a Relay Resolver function.');
    var context = $820c9cdc28ba0cad$var$contextStack[$820c9cdc28ba0cad$var$contextStack.length - 1];
    var fragmentNode = $820c9cdc28ba0cad$var$getFragment(fragmentInput);
    var fragmentSelector = $820c9cdc28ba0cad$var$getSelector(fragmentNode, fragmentKey);
    !(fragmentSelector != null) && $423Vm(false);
    !(fragmentSelector.kind === 'SingularReaderSelector') && $423Vm(false);
    var _context$getDataForRe = context.getDataForResolverFragment(fragmentSelector, fragmentKey), data = _context$getDataForRe.data, isMissingData = _context$getDataForRe.isMissingData;
    if (isMissingData) throw $820c9cdc28ba0cad$var$RESOLVER_FRAGMENT_MISSING_DATA_SENTINEL;
    return data;
}
var $820c9cdc28ba0cad$var$RESOLVER_FRAGMENT_MISSING_DATA_SENTINEL = {};
module.exports = {
    readFragment: $820c9cdc28ba0cad$var$readFragment,
    withResolverContext: $820c9cdc28ba0cad$var$withResolverContext,
    RESOLVER_FRAGMENT_MISSING_DATA_SENTINEL: $820c9cdc28ba0cad$var$RESOLVER_FRAGMENT_MISSING_DATA_SENTINEL
};

});




parcelRegister("6BRxK", function(module, exports) {
'use strict';

var $7Wmh0 = parcelRequire("7Wmh0");
var $4cffbb5acf7faa1d$var$_interopRequireDefault = $7Wmh0.default;

var $4cffbb5acf7faa1d$var$_createForOfIteratorHelper2 = $4cffbb5acf7faa1d$var$_interopRequireDefault((parcelRequire("9CLQ8")));

var $4cffbb5acf7faa1d$var$_defineProperty2 = $4cffbb5acf7faa1d$var$_interopRequireDefault((parcelRequire("ky4V8")));

var $2BDDE = parcelRequire("2BDDE");
var $4cffbb5acf7faa1d$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE = $2BDDE.INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE, $4cffbb5acf7faa1d$var$assertInternalActorIdentifier = $2BDDE.assertInternalActorIdentifier;
parcelRequire("hElRV");

var $llkIA = parcelRequire("llkIA");

var $1fgZt = parcelRequire("1fgZt");

var $6mJYj = parcelRequire("6mJYj");

var $kA5Gq = parcelRequire("kA5Gq");

var $fagih = parcelRequire("fagih");

var $9bopL = parcelRequire("9bopL");

var $ldcaJ = parcelRequire("ldcaJ");

var $bg1wj = parcelRequire("bg1wj");

var $dc1NV = parcelRequire("dc1NV");

var $f91UN = parcelRequire("f91UN");

var $f91UN = parcelRequire("f91UN");
var $4cffbb5acf7faa1d$var$ROOT_ID = $f91UN.ROOT_ID, $4cffbb5acf7faa1d$var$ROOT_TYPE = $f91UN.ROOT_TYPE;

var $5U85g = parcelRequire("5U85g");
var $4cffbb5acf7faa1d$var$RecordResolverCache = $5U85g.RecordResolverCache;

var $423Vm = parcelRequire("423Vm");
var $4cffbb5acf7faa1d$var$DEFAULT_RELEASE_BUFFER_SIZE = 10;
var $4cffbb5acf7faa1d$var$RelayModernStore = /*#__PURE__*/ function() {
    function RelayModernStore(source, options) {
        var _this = this;
        var _options$gcReleaseBuf, _options$gcScheduler, _options$getDataID, _options$log, _options$operationLoa;
        (0, $4cffbb5acf7faa1d$var$_defineProperty2["default"])(this, "_gcStep", function() {
            if (_this._gcRun) {
                if (_this._gcRun.next().done) _this._gcRun = null;
                else _this._gcScheduler(_this._gcStep);
            }
        });
        var storeIDs, ii, record;
        this._currentWriteEpoch = 0;
        this._gcHoldCounter = 0;
        this._gcReleaseBufferSize = (_options$gcReleaseBuf = options === null || options === void 0 ? void 0 : options.gcReleaseBufferSize) !== null && _options$gcReleaseBuf !== void 0 ? _options$gcReleaseBuf : $4cffbb5acf7faa1d$var$DEFAULT_RELEASE_BUFFER_SIZE;
        this._gcRun = null;
        this._gcScheduler = (_options$gcScheduler = options === null || options === void 0 ? void 0 : options.gcScheduler) !== null && _options$gcScheduler !== void 0 ? _options$gcScheduler : $1fgZt;
        this._getDataID = (_options$getDataID = options === null || options === void 0 ? void 0 : options.getDataID) !== null && _options$getDataID !== void 0 ? _options$getDataID : $kA5Gq;
        this._globalInvalidationEpoch = null;
        this._invalidationSubscriptions = new Set();
        this._invalidatedRecordIDs = new Set();
        this.__log = (_options$log = options === null || options === void 0 ? void 0 : options.log) !== null && _options$log !== void 0 ? _options$log : null;
        this._queryCacheExpirationTime = options === null || options === void 0 ? void 0 : options.queryCacheExpirationTime;
        this._operationLoader = (_options$operationLoa = options === null || options === void 0 ? void 0 : options.operationLoader) !== null && _options$operationLoa !== void 0 ? _options$operationLoa : null;
        this._optimisticSource = null;
        this._recordSource = source;
        this._releaseBuffer = [];
        this._roots = new Map();
        this._shouldScheduleGC = false;
        this._resolverCache = new $4cffbb5acf7faa1d$var$RecordResolverCache(function() {
            return _this._getMutableRecordSource();
        });
        this._storeSubscriptions = new $dc1NV(options === null || options === void 0 ? void 0 : options.log, this._resolverCache);
        this._updatedRecordIDs = new Set();
        this._shouldProcessClientComponents = options === null || options === void 0 ? void 0 : options.shouldProcessClientComponents;
        $4cffbb5acf7faa1d$var$initializeRecordSource(this._recordSource);
    }
    var _proto = RelayModernStore.prototype;
    _proto.getSource = function getSource() {
        var _this$_optimisticSour;
        return (_this$_optimisticSour = this._optimisticSource) !== null && _this$_optimisticSour !== void 0 ? _this$_optimisticSour : this._recordSource;
    };
    _proto._getMutableRecordSource = function _getMutableRecordSource() {
        var _this$_optimisticSour2;
        return (_this$_optimisticSour2 = this._optimisticSource) !== null && _this$_optimisticSour2 !== void 0 ? _this$_optimisticSour2 : this._recordSource;
    };
    _proto.check = function check(operation, options) {
        var _options$handlers, _options$getSourceFor, _options$getTargetFor, _options$defaultActor;
        var selector = operation.root;
        var source = this._getMutableRecordSource();
        var globalInvalidationEpoch = this._globalInvalidationEpoch;
        var rootEntry = this._roots.get(operation.request.identifier);
        var operationLastWrittenAt = rootEntry != null ? rootEntry.epoch : null;
        if (globalInvalidationEpoch != null) {
            if (operationLastWrittenAt == null || operationLastWrittenAt <= globalInvalidationEpoch) return {
                status: 'stale'
            };
        }
        var handlers = (_options$handlers = options === null || options === void 0 ? void 0 : options.handlers) !== null && _options$handlers !== void 0 ? _options$handlers : [];
        var getSourceForActor = (_options$getSourceFor = options === null || options === void 0 ? void 0 : options.getSourceForActor) !== null && _options$getSourceFor !== void 0 ? _options$getSourceFor : function(actorIdentifier) {
            $4cffbb5acf7faa1d$var$assertInternalActorIdentifier(actorIdentifier);
            return source;
        };
        var getTargetForActor = (_options$getTargetFor = options === null || options === void 0 ? void 0 : options.getTargetForActor) !== null && _options$getTargetFor !== void 0 ? _options$getTargetFor : function(actorIdentifier) {
            $4cffbb5acf7faa1d$var$assertInternalActorIdentifier(actorIdentifier);
            return source;
        };
        var operationAvailability = $6mJYj.check(getSourceForActor, getTargetForActor, (_options$defaultActor = options === null || options === void 0 ? void 0 : options.defaultActorIdentifier) !== null && _options$defaultActor !== void 0 ? _options$defaultActor : $4cffbb5acf7faa1d$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE, selector, handlers, this._operationLoader, this._getDataID, this._shouldProcessClientComponents);
        return $4cffbb5acf7faa1d$var$getAvailabilityStatus(operationAvailability, operationLastWrittenAt, rootEntry === null || rootEntry === void 0 ? void 0 : rootEntry.fetchTime, this._queryCacheExpirationTime);
    };
    _proto.retain = function retain(operation) {
        var _this2 = this;
        var id = operation.request.identifier;
        var disposed = false;
        var dispose = function dispose() {
            if (disposed) return;
            disposed = true;
            var rootEntry = _this2._roots.get(id);
            if (rootEntry == null) return;
            rootEntry.refCount--;
            if (rootEntry.refCount === 0) {
                var _queryCacheExpirationTime = _this2._queryCacheExpirationTime;
                var rootEntryIsStale = rootEntry.fetchTime != null && _queryCacheExpirationTime != null && rootEntry.fetchTime <= Date.now() - _queryCacheExpirationTime;
                if (rootEntryIsStale) {
                    _this2._roots["delete"](id);
                    _this2.scheduleGC();
                } else {
                    _this2._releaseBuffer.push(id);
                    if (_this2._releaseBuffer.length > _this2._gcReleaseBufferSize) {
                        var _id = _this2._releaseBuffer.shift();
                        _this2._roots["delete"](_id);
                        _this2.scheduleGC();
                    }
                }
            }
        };
        var rootEntry = this._roots.get(id);
        if (rootEntry != null) {
            if (rootEntry.refCount === 0) this._releaseBuffer = this._releaseBuffer.filter(function(_id) {
                return _id !== id;
            });
            rootEntry.refCount += 1;
        } else this._roots.set(id, {
            operation: operation,
            refCount: 1,
            epoch: null,
            fetchTime: null
        });
        return {
            dispose: dispose
        };
    };
    _proto.lookup = function lookup(selector) {
        var source = this.getSource();
        var snapshot = $ldcaJ.read(source, selector, this._resolverCache);
        return snapshot;
    };
    _proto.notify = function notify(sourceOperation, invalidateStore) {
        var _this3 = this;
        var log = this.__log;
        if (log != null) log({
            name: 'store.notify.start',
            sourceOperation: sourceOperation
        });
        this._currentWriteEpoch++;
        if (invalidateStore === true) this._globalInvalidationEpoch = this._currentWriteEpoch;
        if ($llkIA.ENABLE_RELAY_RESOLVERS) this._resolverCache.invalidateDataIDs(this._updatedRecordIDs);
        var source = this.getSource();
        var updatedOwners = [];
        this._storeSubscriptions.updateSubscriptions(source, this._updatedRecordIDs, updatedOwners, sourceOperation);
        this._invalidationSubscriptions.forEach(function(subscription) {
            _this3._updateInvalidationSubscription(subscription, invalidateStore === true);
        });
        if (log != null) log({
            name: 'store.notify.complete',
            sourceOperation: sourceOperation,
            updatedRecordIDs: this._updatedRecordIDs,
            invalidatedRecordIDs: this._invalidatedRecordIDs
        });
        this._updatedRecordIDs.clear();
        this._invalidatedRecordIDs.clear();
        if (sourceOperation != null) {
            var id = sourceOperation.request.identifier;
            var rootEntry = this._roots.get(id);
            if (rootEntry != null) {
                rootEntry.epoch = this._currentWriteEpoch;
                rootEntry.fetchTime = Date.now();
            } else if (sourceOperation.request.node.params.operationKind === 'query' && this._gcReleaseBufferSize > 0 && this._releaseBuffer.length < this._gcReleaseBufferSize) {
                var temporaryRootEntry = {
                    operation: sourceOperation,
                    refCount: 0,
                    epoch: this._currentWriteEpoch,
                    fetchTime: Date.now()
                };
                this._releaseBuffer.push(id);
                this._roots.set(id, temporaryRootEntry);
            }
        }
        return updatedOwners;
    };
    _proto.publish = function publish(source, idsMarkedForInvalidation) {
        var target = this._getMutableRecordSource();
        $4cffbb5acf7faa1d$var$updateTargetFromSource(target, source, this._currentWriteEpoch + 1, idsMarkedForInvalidation, this._updatedRecordIDs, this._invalidatedRecordIDs);
        var log = this.__log;
        if (log != null) log({
            name: 'store.publish',
            source: source,
            optimistic: target === this._optimisticSource
        });
    };
    _proto.subscribe = function subscribe(snapshot, callback) {
        return this._storeSubscriptions.subscribe(snapshot, callback);
    };
    _proto.holdGC = function holdGC() {
        var _this4 = this;
        if (this._gcRun) {
            this._gcRun = null;
            this._shouldScheduleGC = true;
        }
        this._gcHoldCounter++;
        var dispose = function dispose() {
            if (_this4._gcHoldCounter > 0) {
                _this4._gcHoldCounter--;
                if (_this4._gcHoldCounter === 0 && _this4._shouldScheduleGC) {
                    _this4.scheduleGC();
                    _this4._shouldScheduleGC = false;
                }
            }
        };
        return {
            dispose: dispose
        };
    };
    _proto.toJSON = function toJSON() {
        return 'RelayModernStore()';
    };
    _proto.getEpoch = function getEpoch() {
        return this._currentWriteEpoch;
    };
    _proto.__getUpdatedRecordIDs = function __getUpdatedRecordIDs() {
        return this._updatedRecordIDs;
    };
    _proto.lookupInvalidationState = function lookupInvalidationState(dataIDs) {
        var _this5 = this;
        var invalidations = new Map();
        dataIDs.forEach(function(dataID) {
            var _RelayModernRecord$ge;
            var record = _this5.getSource().get(dataID);
            invalidations.set(dataID, (_RelayModernRecord$ge = $fagih.getInvalidationEpoch(record)) !== null && _RelayModernRecord$ge !== void 0 ? _RelayModernRecord$ge : null);
        });
        invalidations.set('global', this._globalInvalidationEpoch);
        return {
            dataIDs: dataIDs,
            invalidations: invalidations
        };
    };
    _proto.checkInvalidationState = function checkInvalidationState(prevInvalidationState) {
        var latestInvalidationState = this.lookupInvalidationState(prevInvalidationState.dataIDs);
        var currentInvalidations = latestInvalidationState.invalidations;
        var prevInvalidations = prevInvalidationState.invalidations;
        if (currentInvalidations.get('global') !== prevInvalidations.get('global')) return true;
        var _iterator = (0, $4cffbb5acf7faa1d$var$_createForOfIteratorHelper2["default"])(prevInvalidationState.dataIDs), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var dataID = _step.value;
                if (currentInvalidations.get(dataID) !== prevInvalidations.get(dataID)) return true;
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return false;
    };
    _proto.subscribeToInvalidationState = function subscribeToInvalidationState(invalidationState, callback) {
        var _this6 = this;
        var subscription = {
            callback: callback,
            invalidationState: invalidationState
        };
        var dispose = function dispose() {
            _this6._invalidationSubscriptions["delete"](subscription);
        };
        this._invalidationSubscriptions.add(subscription);
        return {
            dispose: dispose
        };
    };
    _proto._updateInvalidationSubscription = function _updateInvalidationSubscription(subscription, invalidatedStore) {
        var _this7 = this;
        var callback = subscription.callback, invalidationState = subscription.invalidationState;
        var dataIDs = invalidationState.dataIDs;
        var isSubscribedToInvalidatedIDs = invalidatedStore || dataIDs.some(function(dataID) {
            return _this7._invalidatedRecordIDs.has(dataID);
        });
        if (!isSubscribedToInvalidatedIDs) return;
        callback();
    };
    _proto.snapshot = function snapshot() {
        !(this._optimisticSource == null) && $423Vm(false);
        var log = this.__log;
        if (log != null) log({
            name: 'store.snapshot'
        });
        this._storeSubscriptions.snapshotSubscriptions(this.getSource());
        if (this._gcRun) {
            this._gcRun = null;
            this._shouldScheduleGC = true;
        }
        this._optimisticSource = $9bopL.create(this.getSource());
    };
    _proto.restore = function restore() {
        !(this._optimisticSource != null) && $423Vm(false);
        var log = this.__log;
        if (log != null) log({
            name: 'store.restore'
        });
        this._optimisticSource = null;
        if (this._shouldScheduleGC) this.scheduleGC();
        this._storeSubscriptions.restoreSubscriptions();
    };
    _proto.scheduleGC = function scheduleGC() {
        if (this._gcHoldCounter > 0) {
            this._shouldScheduleGC = true;
            return;
        }
        if (this._gcRun) return;
        this._gcRun = this._collect();
        this._gcScheduler(this._gcStep);
    };
    _proto.__gc = function __gc() {
        if (this._optimisticSource != null) return;
        var gcRun = this._collect();
        while(!gcRun.next().done);
    };
    _proto._collect = function* _collect() {
        top: while(true){
            var startEpoch = this._currentWriteEpoch;
            var references = new Set();
            var _iterator2 = (0, $4cffbb5acf7faa1d$var$_createForOfIteratorHelper2["default"])(this._roots.values()), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var operation = _step2.value.operation;
                    var selector = operation.root;
                    $bg1wj.mark(this._recordSource, selector, references, this._operationLoader, this._shouldProcessClientComponents);
                    yield;
                    if (startEpoch !== this._currentWriteEpoch) continue top;
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
            var log = this.__log;
            if (log != null) log({
                name: 'store.gc',
                references: references
            });
            if (references.size === 0) this._recordSource.clear();
            else {
                var storeIDs = this._recordSource.getRecordIDs();
                for(var ii = 0; ii < storeIDs.length; ii++){
                    var dataID = storeIDs[ii];
                    if (!references.has(dataID)) this._recordSource.remove(dataID);
                }
            }
            return;
        }
    };
    return RelayModernStore;
}();
function $4cffbb5acf7faa1d$var$initializeRecordSource(target) {
    if (!target.has($4cffbb5acf7faa1d$var$ROOT_ID)) {
        var rootRecord = $fagih.create($4cffbb5acf7faa1d$var$ROOT_ID, $4cffbb5acf7faa1d$var$ROOT_TYPE);
        target.set($4cffbb5acf7faa1d$var$ROOT_ID, rootRecord);
    }
}
function $4cffbb5acf7faa1d$var$updateTargetFromSource(target, source, currentWriteEpoch, idsMarkedForInvalidation, updatedRecordIDs, invalidatedRecordIDs) {
    if (idsMarkedForInvalidation) idsMarkedForInvalidation.forEach(function(dataID) {
        var targetRecord = target.get(dataID);
        var sourceRecord = source.get(dataID);
        if (sourceRecord === null) return;
        var nextRecord;
        if (targetRecord != null) nextRecord = $fagih.clone(targetRecord);
        else nextRecord = sourceRecord != null ? $fagih.clone(sourceRecord) : null;
        if (!nextRecord) return;
        $fagih.setValue(nextRecord, $f91UN.INVALIDATED_AT_KEY, currentWriteEpoch);
        invalidatedRecordIDs.add(dataID);
        target.set(dataID, nextRecord);
    });
    var dataIDs = source.getRecordIDs();
    for(var ii = 0; ii < dataIDs.length; ii++){
        var dataID = dataIDs[ii];
        var sourceRecord = source.get(dataID);
        var targetRecord = target.get(dataID);
        if (sourceRecord && targetRecord) {
            var nextRecord = $fagih.update(targetRecord, sourceRecord);
            if (nextRecord !== targetRecord) {
                updatedRecordIDs.add(dataID);
                target.set(dataID, nextRecord);
            }
        } else if (sourceRecord === null) {
            target["delete"](dataID);
            if (targetRecord !== null) updatedRecordIDs.add(dataID);
        } else if (sourceRecord) {
            target.set(dataID, sourceRecord);
            updatedRecordIDs.add(dataID);
        }
    }
}
function $4cffbb5acf7faa1d$var$getAvailabilityStatus(operationAvailability, operationLastWrittenAt, operationFetchTime, queryCacheExpirationTime) {
    var mostRecentlyInvalidatedAt = operationAvailability.mostRecentlyInvalidatedAt, status = operationAvailability.status;
    if (typeof mostRecentlyInvalidatedAt === 'number') {
        if (operationLastWrittenAt == null || mostRecentlyInvalidatedAt > operationLastWrittenAt) return {
            status: 'stale'
        };
    }
    if (status === 'missing') return {
        status: 'missing'
    };
    if (operationFetchTime != null && queryCacheExpirationTime != null) {
        var isStale = operationFetchTime <= Date.now() - queryCacheExpirationTime;
        if (isStale) return {
            status: 'stale'
        };
    }
    return {
        status: 'available',
        fetchTime: operationFetchTime !== null && operationFetchTime !== void 0 ? operationFetchTime : null
    };
}
module.exports = $4cffbb5acf7faa1d$var$RelayModernStore;

});
parcelRegister("1fgZt", function(module, exports) {
'use strict';
var $0e845f1af95bc79b$var$resolvedPromise = Promise.resolve();
function $0e845f1af95bc79b$var$resolveImmediate(callback) {
    $0e845f1af95bc79b$var$resolvedPromise.then(callback)["catch"]($0e845f1af95bc79b$var$throwNext);
}
function $0e845f1af95bc79b$var$throwNext(error) {
    setTimeout(function() {
        throw error;
    }, 0);
}
module.exports = $0e845f1af95bc79b$var$resolveImmediate;

});

parcelRegister("6mJYj", function(module, exports) {
'use strict';

var $7Wmh0 = parcelRequire("7Wmh0");
var $013233705e766187$var$_interopRequireDefault = $7Wmh0.default;

var $013233705e766187$var$_createForOfIteratorHelper2 = $013233705e766187$var$_interopRequireDefault((parcelRequire("9CLQ8")));

var $bo4TG = parcelRequire("bo4TG");

var $jgxJp = parcelRequire("jgxJp");

var $lTsrN = parcelRequire("lTsrN");

var $54ow8 = parcelRequire("54ow8");

var $axs8G = parcelRequire("axs8G");
var $013233705e766187$var$isClientID = $axs8G.isClientID;

var $bCK2V = parcelRequire("bCK2V");

var $lmcgP = parcelRequire("lmcgP");

var $frIyf = parcelRequire("frIyf");
var $013233705e766187$var$getLocalVariables = $frIyf.getLocalVariables;

var $fagih = parcelRequire("fagih");

var $jqEGH = parcelRequire("jqEGH");
var $013233705e766187$var$EXISTENT = $jqEGH.EXISTENT, $013233705e766187$var$UNKNOWN = $jqEGH.UNKNOWN;

var $f91UN = parcelRequire("f91UN");

var $M4yH2 = parcelRequire("M4yH2");
var $013233705e766187$var$TYPE_SCHEMA_TYPE = $M4yH2.TYPE_SCHEMA_TYPE, $013233705e766187$var$generateTypeID = $M4yH2.generateTypeID;

var $423Vm = parcelRequire("423Vm");
var $013233705e766187$var$ACTOR_CHANGE = $54ow8.ACTOR_CHANGE, $013233705e766187$var$CONDITION = $54ow8.CONDITION, $013233705e766187$var$CLIENT_COMPONENT = $54ow8.CLIENT_COMPONENT, $013233705e766187$var$CLIENT_EXTENSION = $54ow8.CLIENT_EXTENSION, $013233705e766187$var$CLIENT_EDGE_TO_CLIENT_OBJECT = $54ow8.CLIENT_EDGE_TO_CLIENT_OBJECT, $013233705e766187$var$DEFER = $54ow8.DEFER, $013233705e766187$var$FRAGMENT_SPREAD = $54ow8.FRAGMENT_SPREAD, $013233705e766187$var$INLINE_FRAGMENT = $54ow8.INLINE_FRAGMENT, $013233705e766187$var$LINKED_FIELD = $54ow8.LINKED_FIELD, $013233705e766187$var$LINKED_HANDLE = $54ow8.LINKED_HANDLE, $013233705e766187$var$MODULE_IMPORT = $54ow8.MODULE_IMPORT, $013233705e766187$var$RELAY_RESOLVER = $54ow8.RELAY_RESOLVER, $013233705e766187$var$RELAY_LIVE_RESOLVER = $54ow8.RELAY_LIVE_RESOLVER, $013233705e766187$var$SCALAR_FIELD = $54ow8.SCALAR_FIELD, $013233705e766187$var$SCALAR_HANDLE = $54ow8.SCALAR_HANDLE, $013233705e766187$var$STREAM = $54ow8.STREAM, $013233705e766187$var$TYPE_DISCRIMINATOR = $54ow8.TYPE_DISCRIMINATOR;
var $013233705e766187$var$getModuleOperationKey = $f91UN.getModuleOperationKey, $013233705e766187$var$getStorageKey = $f91UN.getStorageKey, $013233705e766187$var$getArgumentValues = $f91UN.getArgumentValues;
function $013233705e766187$var$check(getSourceForActor, getTargetForActor, defaultActorIdentifier, selector, handlers, operationLoader, getDataID, shouldProcessClientComponents) {
    var dataID = selector.dataID, node = selector.node, variables = selector.variables;
    var checker = new $013233705e766187$var$DataChecker(getSourceForActor, getTargetForActor, defaultActorIdentifier, variables, handlers, operationLoader, getDataID, shouldProcessClientComponents);
    return checker.check(node, dataID);
}
var $013233705e766187$var$DataChecker = /*#__PURE__*/ function() {
    function DataChecker(getSourceForActor, getTargetForActor, defaultActorIdentifier, variables, handlers, operationLoader, getDataID, shouldProcessClientComponents) {
        this._getSourceForActor = getSourceForActor;
        this._getTargetForActor = getTargetForActor;
        this._getDataID = getDataID;
        this._source = getSourceForActor(defaultActorIdentifier);
        this._mutatorRecordSourceProxyCache = new Map();
        var _this$_getMutatorAndR = this._getMutatorAndRecordProxyForActor(defaultActorIdentifier), mutator = _this$_getMutatorAndR[0], recordSourceProxy = _this$_getMutatorAndR[1];
        this._mostRecentlyInvalidatedAt = null;
        this._handlers = handlers;
        this._mutator = mutator;
        this._operationLoader = operationLoader !== null && operationLoader !== void 0 ? operationLoader : null;
        this._recordSourceProxy = recordSourceProxy;
        this._recordWasMissing = false;
        this._variables = variables;
        this._shouldProcessClientComponents = shouldProcessClientComponents;
    }
    var _proto = DataChecker.prototype;
    _proto._getMutatorAndRecordProxyForActor = function _getMutatorAndRecordProxyForActor(actorIdentifier) {
        var tuple = this._mutatorRecordSourceProxyCache.get(actorIdentifier);
        if (tuple == null) {
            var target = this._getTargetForActor(actorIdentifier);
            var mutator = new $bo4TG(this._getSourceForActor(actorIdentifier), target);
            var recordSourceProxy = new $jgxJp(mutator, this._getDataID, undefined, this._handlers);
            tuple = [
                mutator,
                recordSourceProxy
            ];
            this._mutatorRecordSourceProxyCache.set(actorIdentifier, tuple);
        }
        return tuple;
    };
    _proto.check = function check(node, dataID) {
        this._assignClientAbstractTypes(node);
        this._traverse(node, dataID);
        return this._recordWasMissing === true ? {
            status: 'missing',
            mostRecentlyInvalidatedAt: this._mostRecentlyInvalidatedAt
        } : {
            status: 'available',
            mostRecentlyInvalidatedAt: this._mostRecentlyInvalidatedAt
        };
    };
    _proto._getVariableValue = function _getVariableValue(name) {
        !this._variables.hasOwnProperty(name) && $423Vm(false);
        return this._variables[name];
    };
    _proto._handleMissing = function _handleMissing() {
        this._recordWasMissing = true;
    };
    _proto._handleMissingScalarField = function _handleMissingScalarField(field, dataID) {
        if (field.name === 'id' && field.alias == null && $013233705e766187$var$isClientID(dataID)) return undefined;
        var args = field.args != undefined ? $013233705e766187$var$getArgumentValues(field.args, this._variables) : {};
        var _iterator = (0, $013233705e766187$var$_createForOfIteratorHelper2["default"])(this._handlers), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var handler = _step.value;
                if (handler.kind === 'scalar') {
                    var newValue = handler.handle(field, this._recordSourceProxy.get(dataID), args, this._recordSourceProxy);
                    if (newValue !== undefined) return newValue;
                }
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        this._handleMissing();
    };
    _proto._handleMissingLinkField = function _handleMissingLinkField(field, dataID) {
        var args = field.args != undefined ? $013233705e766187$var$getArgumentValues(field.args, this._variables) : {};
        var _iterator2 = (0, $013233705e766187$var$_createForOfIteratorHelper2["default"])(this._handlers), _step2;
        try {
            for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                var handler = _step2.value;
                if (handler.kind === 'linked') {
                    var newValue = handler.handle(field, this._recordSourceProxy.get(dataID), args, this._recordSourceProxy);
                    if (newValue !== undefined && (newValue === null || this._mutator.getStatus(newValue) === $013233705e766187$var$EXISTENT)) return newValue;
                }
            }
        } catch (err) {
            _iterator2.e(err);
        } finally{
            _iterator2.f();
        }
        this._handleMissing();
    };
    _proto._handleMissingPluralLinkField = function _handleMissingPluralLinkField(field, dataID) {
        var _this = this;
        var args = field.args != undefined ? $013233705e766187$var$getArgumentValues(field.args, this._variables) : {};
        var _iterator3 = (0, $013233705e766187$var$_createForOfIteratorHelper2["default"])(this._handlers), _step3;
        try {
            for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                var handler = _step3.value;
                if (handler.kind === 'pluralLinked') {
                    var newValue = handler.handle(field, this._recordSourceProxy.get(dataID), args, this._recordSourceProxy);
                    if (newValue != null) {
                        var allItemsKnown = newValue.every(function(linkedID) {
                            return linkedID != null && _this._mutator.getStatus(linkedID) === $013233705e766187$var$EXISTENT;
                        });
                        if (allItemsKnown) return newValue;
                    } else if (newValue === null) return null;
                }
            }
        } catch (err) {
            _iterator3.e(err);
        } finally{
            _iterator3.f();
        }
        this._handleMissing();
    };
    _proto._traverse = function _traverse(node, dataID) {
        var status = this._mutator.getStatus(dataID);
        if (status === $013233705e766187$var$UNKNOWN) this._handleMissing();
        if (status === $013233705e766187$var$EXISTENT) {
            var record = this._source.get(dataID);
            var invalidatedAt = $fagih.getInvalidationEpoch(record);
            if (invalidatedAt != null) this._mostRecentlyInvalidatedAt = this._mostRecentlyInvalidatedAt != null ? Math.max(this._mostRecentlyInvalidatedAt, invalidatedAt) : invalidatedAt;
            this._traverseSelections(node.selections, dataID);
        }
    };
    _proto._traverseSelections = function _traverseSelections(selections, dataID) {
        var _this2 = this;
        selections.forEach(function(selection) {
            switch(selection.kind){
                case $013233705e766187$var$SCALAR_FIELD:
                    _this2._checkScalar(selection, dataID);
                    break;
                case $013233705e766187$var$LINKED_FIELD:
                    if (selection.plural) _this2._checkPluralLink(selection, dataID);
                    else _this2._checkLink(selection, dataID);
                    break;
                case $013233705e766187$var$ACTOR_CHANGE:
                    _this2._checkActorChange(selection.linkedField, dataID);
                    break;
                case $013233705e766187$var$CONDITION:
                    var conditionValue = Boolean(_this2._getVariableValue(selection.condition));
                    if (conditionValue === selection.passingValue) _this2._traverseSelections(selection.selections, dataID);
                    break;
                case $013233705e766187$var$INLINE_FRAGMENT:
                    var _abstractKey = selection.abstractKey;
                    if (_abstractKey == null) {
                        var typeName = _this2._mutator.getType(dataID);
                        if (typeName === selection.type) _this2._traverseSelections(selection.selections, dataID);
                    } else {
                        var _recordType = _this2._mutator.getType(dataID);
                        !(_recordType != null) && $423Vm(false);
                        var _typeID = $013233705e766187$var$generateTypeID(_recordType);
                        var _implementsInterface = _this2._mutator.getValue(_typeID, _abstractKey);
                        if (_implementsInterface === true) _this2._traverseSelections(selection.selections, dataID);
                        else if (_implementsInterface == null) _this2._handleMissing();
                    }
                    break;
                case $013233705e766187$var$LINKED_HANDLE:
                    var handleField = $bCK2V(selection, selections, _this2._variables);
                    if (handleField.plural) _this2._checkPluralLink(handleField, dataID);
                    else _this2._checkLink(handleField, dataID);
                    break;
                case $013233705e766187$var$SCALAR_HANDLE:
                    var _handleField = $lmcgP(selection, selections, _this2._variables);
                    _this2._checkScalar(_handleField, dataID);
                    break;
                case $013233705e766187$var$MODULE_IMPORT:
                    _this2._checkModuleImport(selection, dataID);
                    break;
                case $013233705e766187$var$DEFER:
                case $013233705e766187$var$STREAM:
                    _this2._traverseSelections(selection.selections, dataID);
                    break;
                case $013233705e766187$var$FRAGMENT_SPREAD:
                    var prevVariables = _this2._variables;
                    _this2._variables = $013233705e766187$var$getLocalVariables(_this2._variables, selection.fragment.argumentDefinitions, selection.args);
                    _this2._traverseSelections(selection.fragment.selections, dataID);
                    _this2._variables = prevVariables;
                    break;
                case $013233705e766187$var$CLIENT_EXTENSION:
                    var recordWasMissing = _this2._recordWasMissing;
                    _this2._traverseSelections(selection.selections, dataID);
                    _this2._recordWasMissing = recordWasMissing;
                    break;
                case $013233705e766187$var$TYPE_DISCRIMINATOR:
                    var abstractKey = selection.abstractKey;
                    var recordType = _this2._mutator.getType(dataID);
                    !(recordType != null) && $423Vm(false);
                    var typeID = $013233705e766187$var$generateTypeID(recordType);
                    var implementsInterface = _this2._mutator.getValue(typeID, abstractKey);
                    if (implementsInterface == null) _this2._handleMissing();
                    break;
                case $013233705e766187$var$CLIENT_COMPONENT:
                    if (_this2._shouldProcessClientComponents === false) break;
                    _this2._traverseSelections(selection.fragment.selections, dataID);
                    break;
                case $013233705e766187$var$RELAY_RESOLVER:
                    _this2._checkResolver(selection, dataID);
                    break;
                case $013233705e766187$var$RELAY_LIVE_RESOLVER:
                    _this2._checkResolver(selection, dataID);
                    break;
                case $013233705e766187$var$CLIENT_EDGE_TO_CLIENT_OBJECT:
                    _this2._checkResolver(selection.backingField, dataID);
                    break;
                default:
                    selection;
                    $423Vm(false);
            }
        });
    };
    _proto._checkResolver = function _checkResolver(resolver, dataID) {
        if (resolver.fragment) this._traverseSelections([
            resolver.fragment
        ], dataID);
    };
    _proto._checkModuleImport = function _checkModuleImport(moduleImport, dataID) {
        var operationLoader = this._operationLoader;
        !(operationLoader !== null) && $423Vm(false);
        var operationKey = $013233705e766187$var$getModuleOperationKey(moduleImport.documentName);
        var operationReference = this._mutator.getValue(dataID, operationKey);
        if (operationReference == null) {
            if (operationReference === undefined) this._handleMissing();
            return;
        }
        var normalizationRootNode = operationLoader.get(operationReference);
        if (normalizationRootNode != null) {
            var operation = $lTsrN(normalizationRootNode);
            var prevVariables = this._variables;
            this._variables = $013233705e766187$var$getLocalVariables(this._variables, operation.argumentDefinitions, moduleImport.args);
            this._traverse(operation, dataID);
            this._variables = prevVariables;
        } else this._handleMissing();
    };
    _proto._checkScalar = function _checkScalar(field, dataID) {
        var storageKey = $013233705e766187$var$getStorageKey(field, this._variables);
        var fieldValue = this._mutator.getValue(dataID, storageKey);
        if (fieldValue === undefined) {
            fieldValue = this._handleMissingScalarField(field, dataID);
            if (fieldValue !== undefined) this._mutator.setValue(dataID, storageKey, fieldValue);
        }
    };
    _proto._checkLink = function _checkLink(field, dataID) {
        var storageKey = $013233705e766187$var$getStorageKey(field, this._variables);
        var linkedID = this._mutator.getLinkedRecordID(dataID, storageKey);
        if (linkedID === undefined) {
            linkedID = this._handleMissingLinkField(field, dataID);
            if (linkedID != null) this._mutator.setLinkedRecordID(dataID, storageKey, linkedID);
            else if (linkedID === null) this._mutator.setValue(dataID, storageKey, null);
        }
        if (linkedID != null) this._traverse(field, linkedID);
    };
    _proto._checkPluralLink = function _checkPluralLink(field, dataID) {
        var _this3 = this;
        var storageKey = $013233705e766187$var$getStorageKey(field, this._variables);
        var linkedIDs = this._mutator.getLinkedRecordIDs(dataID, storageKey);
        if (linkedIDs === undefined) {
            linkedIDs = this._handleMissingPluralLinkField(field, dataID);
            if (linkedIDs != null) this._mutator.setLinkedRecordIDs(dataID, storageKey, linkedIDs);
            else if (linkedIDs === null) this._mutator.setValue(dataID, storageKey, null);
        }
        if (linkedIDs) linkedIDs.forEach(function(linkedID) {
            if (linkedID != null) _this3._traverse(field, linkedID);
        });
    };
    _proto._checkActorChange = function _checkActorChange(field, dataID) {
        var storageKey = $013233705e766187$var$getStorageKey(field, this._variables);
        var record = this._source.get(dataID);
        var tuple = record != null ? $fagih.getActorLinkedRecordID(record, storageKey) : record;
        if (tuple == null) {
            if (tuple === undefined) this._handleMissing();
        } else {
            var actorIdentifier = tuple[0], linkedID = tuple[1];
            var prevSource = this._source;
            var prevMutator = this._mutator;
            var prevRecordSourceProxy = this._recordSourceProxy;
            var _this$_getMutatorAndR2 = this._getMutatorAndRecordProxyForActor(actorIdentifier), mutator = _this$_getMutatorAndR2[0], recordSourceProxy = _this$_getMutatorAndR2[1];
            this._source = this._getSourceForActor(actorIdentifier);
            this._mutator = mutator;
            this._recordSourceProxy = recordSourceProxy;
            this._assignClientAbstractTypes(field);
            this._traverse(field, linkedID);
            this._source = prevSource;
            this._mutator = prevMutator;
            this._recordSourceProxy = prevRecordSourceProxy;
        }
    };
    _proto._assignClientAbstractTypes = function _assignClientAbstractTypes(node) {
        var clientAbstractTypes = node.clientAbstractTypes;
        if (clientAbstractTypes != null) for(var _i = 0, _Object$keys = Object.keys(clientAbstractTypes); _i < _Object$keys.length; _i++){
            var abstractType = _Object$keys[_i];
            var _iterator4 = (0, $013233705e766187$var$_createForOfIteratorHelper2["default"])(clientAbstractTypes[abstractType]), _step4;
            try {
                for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                    var concreteType = _step4.value;
                    var typeID = $013233705e766187$var$generateTypeID(concreteType);
                    if (this._source.get(typeID) == null) this._mutator.create(typeID, $013233705e766187$var$TYPE_SCHEMA_TYPE);
                    if (this._mutator.getValue(typeID, abstractType) == null) this._mutator.setValue(typeID, abstractType, true);
                }
            } catch (err) {
                _iterator4.e(err);
            } finally{
                _iterator4.f();
            }
        }
    };
    return DataChecker;
}();
module.exports = {
    check: $013233705e766187$var$check
};

});
parcelRegister("bCK2V", function(module, exports) {
'use strict';

var $54ow8 = parcelRequire("54ow8");
var $8766f625be73ad10$var$LINKED_FIELD = $54ow8.LINKED_FIELD;

var $f91UN = parcelRequire("f91UN");
var $8766f625be73ad10$var$getHandleStorageKey = $f91UN.getHandleStorageKey;

var $jT3aJ = parcelRequire("jT3aJ");

var $423Vm = parcelRequire("423Vm");
function $8766f625be73ad10$var$cloneRelayHandleSourceField(handleField, selections, variables) {
    var sourceField = selections.find(function(source) {
        return source.kind === $8766f625be73ad10$var$LINKED_FIELD && source.name === handleField.name && source.alias === handleField.alias && $jT3aJ(source.args, handleField.args);
    });
    !(sourceField && sourceField.kind === $8766f625be73ad10$var$LINKED_FIELD) && $423Vm(false);
    var handleKey = $8766f625be73ad10$var$getHandleStorageKey(handleField, variables);
    return {
        kind: 'LinkedField',
        alias: sourceField.alias,
        name: handleKey,
        storageKey: handleKey,
        args: null,
        concreteType: sourceField.concreteType,
        plural: sourceField.plural,
        selections: sourceField.selections
    };
}
module.exports = $8766f625be73ad10$var$cloneRelayHandleSourceField;

});

parcelRegister("lmcgP", function(module, exports) {
'use strict';

var $54ow8 = parcelRequire("54ow8");
var $f8c52bb4b2fe6144$var$SCALAR_FIELD = $54ow8.SCALAR_FIELD;

var $f91UN = parcelRequire("f91UN");
var $f8c52bb4b2fe6144$var$getHandleStorageKey = $f91UN.getHandleStorageKey;

var $jT3aJ = parcelRequire("jT3aJ");

var $423Vm = parcelRequire("423Vm");
function $f8c52bb4b2fe6144$var$cloneRelayScalarHandleSourceField(handleField, selections, variables) {
    var sourceField = selections.find(function(source) {
        return source.kind === $f8c52bb4b2fe6144$var$SCALAR_FIELD && source.name === handleField.name && source.alias === handleField.alias && $jT3aJ(source.args, handleField.args);
    });
    !(sourceField && sourceField.kind === $f8c52bb4b2fe6144$var$SCALAR_FIELD) && $423Vm(false);
    var handleKey = $f8c52bb4b2fe6144$var$getHandleStorageKey(handleField, variables);
    return {
        kind: 'ScalarField',
        alias: sourceField.alias,
        name: handleKey,
        storageKey: handleKey,
        args: null
    };
}
module.exports = $f8c52bb4b2fe6144$var$cloneRelayScalarHandleSourceField;

});


parcelRegister("9bopL", function(module, exports) {
'use strict';

var $7Wmh0 = parcelRequire("7Wmh0");
var $6af8145cdd596e9a$var$_interopRequireDefault = $7Wmh0.default;

var $6af8145cdd596e9a$var$_objectSpread2 = $6af8145cdd596e9a$var$_interopRequireDefault((parcelRequire("1sB2t")));

var $fagih = parcelRequire("fagih");

var $7eJdF = parcelRequire("7eJdF");

var $423Vm = parcelRequire("423Vm");
var $6af8145cdd596e9a$var$UNPUBLISH_RECORD_SENTINEL = $fagih.fromObject(Object.freeze({
    __UNPUBLISH_RECORD_SENTINEL: true
}));
var $6af8145cdd596e9a$var$RelayOptimisticRecordSource = /*#__PURE__*/ function() {
    function RelayOptimisticRecordSource(base) {
        this._base = base;
        this._sink = $7eJdF.create();
    }
    var _proto = RelayOptimisticRecordSource.prototype;
    _proto.has = function has(dataID) {
        if (this._sink.has(dataID)) {
            var sinkRecord = this._sink.get(dataID);
            return sinkRecord !== $6af8145cdd596e9a$var$UNPUBLISH_RECORD_SENTINEL;
        } else return this._base.has(dataID);
    };
    _proto.get = function get(dataID) {
        if (this._sink.has(dataID)) {
            var sinkRecord = this._sink.get(dataID);
            if (sinkRecord === $6af8145cdd596e9a$var$UNPUBLISH_RECORD_SENTINEL) return undefined;
            else return sinkRecord;
        } else return this._base.get(dataID);
    };
    _proto.getStatus = function getStatus(dataID) {
        var record = this.get(dataID);
        if (record === undefined) return 'UNKNOWN';
        else if (record === null) return 'NONEXISTENT';
        else return 'EXISTENT';
    };
    _proto.clear = function clear() {
        this._base = $7eJdF.create();
        this._sink.clear();
    };
    _proto["delete"] = function _delete(dataID) {
        this._sink["delete"](dataID);
    };
    _proto.remove = function remove(dataID) {
        this._sink.set(dataID, $6af8145cdd596e9a$var$UNPUBLISH_RECORD_SENTINEL);
    };
    _proto.set = function set(dataID, record) {
        this._sink.set(dataID, record);
    };
    _proto.getRecordIDs = function getRecordIDs() {
        return Object.keys(this.toJSON());
    };
    _proto.size = function size() {
        return Object.keys(this.toJSON()).length;
    };
    _proto.toJSON = function toJSON() {
        var _this = this;
        var merged = (0, $6af8145cdd596e9a$var$_objectSpread2["default"])({}, this._base.toJSON());
        this._sink.getRecordIDs().forEach(function(dataID) {
            var record = _this.get(dataID);
            if (record === undefined) delete merged[dataID];
            else merged[dataID] = $fagih.toJSON(record);
        });
        return merged;
    };
    _proto.getOptimisticRecordIDs = function getOptimisticRecordIDs() {
        return new Set(this._sink.getRecordIDs());
    };
    return RelayOptimisticRecordSource;
}();
function $6af8145cdd596e9a$var$create(base) {
    return new $6af8145cdd596e9a$var$RelayOptimisticRecordSource(base);
}
function $6af8145cdd596e9a$var$getOptimisticRecordIDs(source) {
    !(source instanceof $6af8145cdd596e9a$var$RelayOptimisticRecordSource) && $423Vm(false);
    return source.getOptimisticRecordIDs();
}
module.exports = {
    create: $6af8145cdd596e9a$var$create,
    getOptimisticRecordIDs: $6af8145cdd596e9a$var$getOptimisticRecordIDs
};

});

parcelRegister("bg1wj", function(module, exports) {
'use strict';

var $7Wmh0 = parcelRequire("7Wmh0");
var $83225e3aced9793c$var$_interopRequireDefault = $7Wmh0.default;

var $83225e3aced9793c$var$_createForOfIteratorHelper2 = $83225e3aced9793c$var$_interopRequireDefault((parcelRequire("9CLQ8")));

var $lTsrN = parcelRequire("lTsrN");

var $54ow8 = parcelRequire("54ow8");

var $bCK2V = parcelRequire("bCK2V");

var $bhYu6 = parcelRequire("bhYu6");

var $frIyf = parcelRequire("frIyf");
var $83225e3aced9793c$var$getLocalVariables = $frIyf.getLocalVariables;

var $fagih = parcelRequire("fagih");

var $f91UN = parcelRequire("f91UN");

var $M4yH2 = parcelRequire("M4yH2");
var $83225e3aced9793c$var$generateTypeID = $M4yH2.generateTypeID;

var $423Vm = parcelRequire("423Vm");
var $83225e3aced9793c$var$ACTOR_CHANGE = $54ow8.ACTOR_CHANGE, $83225e3aced9793c$var$CONDITION = $54ow8.CONDITION, $83225e3aced9793c$var$CLIENT_COMPONENT = $54ow8.CLIENT_COMPONENT, $83225e3aced9793c$var$CLIENT_EXTENSION = $54ow8.CLIENT_EXTENSION, $83225e3aced9793c$var$DEFER = $54ow8.DEFER, $83225e3aced9793c$var$FRAGMENT_SPREAD = $54ow8.FRAGMENT_SPREAD, $83225e3aced9793c$var$INLINE_FRAGMENT = $54ow8.INLINE_FRAGMENT, $83225e3aced9793c$var$LINKED_FIELD = $54ow8.LINKED_FIELD, $83225e3aced9793c$var$MODULE_IMPORT = $54ow8.MODULE_IMPORT, $83225e3aced9793c$var$LINKED_HANDLE = $54ow8.LINKED_HANDLE, $83225e3aced9793c$var$SCALAR_FIELD = $54ow8.SCALAR_FIELD, $83225e3aced9793c$var$SCALAR_HANDLE = $54ow8.SCALAR_HANDLE, $83225e3aced9793c$var$STREAM = $54ow8.STREAM, $83225e3aced9793c$var$TYPE_DISCRIMINATOR = $54ow8.TYPE_DISCRIMINATOR, $83225e3aced9793c$var$RELAY_RESOLVER = $54ow8.RELAY_RESOLVER, $83225e3aced9793c$var$RELAY_LIVE_RESOLVER = $54ow8.RELAY_LIVE_RESOLVER, $83225e3aced9793c$var$CLIENT_EDGE_TO_CLIENT_OBJECT = $54ow8.CLIENT_EDGE_TO_CLIENT_OBJECT;
var $83225e3aced9793c$var$getStorageKey = $f91UN.getStorageKey, $83225e3aced9793c$var$getModuleOperationKey = $f91UN.getModuleOperationKey;
function $83225e3aced9793c$var$mark(recordSource, selector, references, operationLoader, shouldProcessClientComponents) {
    var dataID = selector.dataID, node = selector.node, variables = selector.variables;
    var marker = new $83225e3aced9793c$var$RelayReferenceMarker(recordSource, variables, references, operationLoader, shouldProcessClientComponents);
    marker.mark(node, dataID);
}
var $83225e3aced9793c$var$RelayReferenceMarker = /*#__PURE__*/ function() {
    function RelayReferenceMarker(recordSource, variables, references, operationLoader, shouldProcessClientComponents) {
        this._operationLoader = operationLoader !== null && operationLoader !== void 0 ? operationLoader : null;
        this._operationName = null;
        this._recordSource = recordSource;
        this._references = references;
        this._variables = variables;
        this._shouldProcessClientComponents = shouldProcessClientComponents;
    }
    var _proto = RelayReferenceMarker.prototype;
    _proto.mark = function mark(node, dataID) {
        if (node.kind === 'Operation' || node.kind === 'SplitOperation') this._operationName = node.name;
        this._traverse(node, dataID);
    };
    _proto._traverse = function _traverse(node, dataID) {
        this._references.add(dataID);
        var record = this._recordSource.get(dataID);
        if (record == null) return;
        this._traverseSelections(node.selections, record);
    };
    _proto._getVariableValue = function _getVariableValue(name) {
        !this._variables.hasOwnProperty(name) && $423Vm(false);
        return this._variables[name];
    };
    _proto._traverseSelections = function _traverseSelections(selections, record) {
        var _this = this;
        selections.forEach(function(selection) {
            switch(selection.kind){
                case $83225e3aced9793c$var$ACTOR_CHANGE:
                    _this._traverseLink(selection.linkedField, record);
                    break;
                case $83225e3aced9793c$var$LINKED_FIELD:
                    if (selection.plural) _this._traversePluralLink(selection, record);
                    else _this._traverseLink(selection, record);
                    break;
                case $83225e3aced9793c$var$CONDITION:
                    var conditionValue = Boolean(_this._getVariableValue(selection.condition));
                    if (conditionValue === selection.passingValue) _this._traverseSelections(selection.selections, record);
                    break;
                case $83225e3aced9793c$var$INLINE_FRAGMENT:
                    if (selection.abstractKey == null) {
                        var typeName = $fagih.getType(record);
                        if (typeName != null && typeName === selection.type || typeName === $f91UN.ROOT_TYPE) _this._traverseSelections(selection.selections, record);
                    } else {
                        var _typeName = $fagih.getType(record);
                        var typeID = $83225e3aced9793c$var$generateTypeID(_typeName);
                        _this._references.add(typeID);
                        _this._traverseSelections(selection.selections, record);
                    }
                    break;
                case $83225e3aced9793c$var$FRAGMENT_SPREAD:
                    var prevVariables = _this._variables;
                    _this._variables = $83225e3aced9793c$var$getLocalVariables(_this._variables, selection.fragment.argumentDefinitions, selection.args);
                    _this._traverseSelections(selection.fragment.selections, record);
                    _this._variables = prevVariables;
                    break;
                case $83225e3aced9793c$var$LINKED_HANDLE:
                    var handleField = $bCK2V(selection, selections, _this._variables);
                    if (handleField.plural) _this._traversePluralLink(handleField, record);
                    else _this._traverseLink(handleField, record);
                    break;
                case $83225e3aced9793c$var$DEFER:
                case $83225e3aced9793c$var$STREAM:
                    _this._traverseSelections(selection.selections, record);
                    break;
                case $83225e3aced9793c$var$SCALAR_FIELD:
                case $83225e3aced9793c$var$SCALAR_HANDLE:
                    break;
                case $83225e3aced9793c$var$TYPE_DISCRIMINATOR:
                    var _typeName2 = $fagih.getType(record);
                    var _typeID = $83225e3aced9793c$var$generateTypeID(_typeName2);
                    _this._references.add(_typeID);
                    break;
                case $83225e3aced9793c$var$MODULE_IMPORT:
                    _this._traverseModuleImport(selection, record);
                    break;
                case $83225e3aced9793c$var$CLIENT_EXTENSION:
                    _this._traverseSelections(selection.selections, record);
                    break;
                case $83225e3aced9793c$var$CLIENT_COMPONENT:
                    if (_this._shouldProcessClientComponents === false) break;
                    _this._traverseSelections(selection.fragment.selections, record);
                    break;
                case $83225e3aced9793c$var$RELAY_RESOLVER:
                    _this._traverseResolverField(selection, record);
                    break;
                case $83225e3aced9793c$var$RELAY_LIVE_RESOLVER:
                    _this._traverseResolverField(selection, record);
                    break;
                case $83225e3aced9793c$var$CLIENT_EDGE_TO_CLIENT_OBJECT:
                    _this._traverseClientEdgeToClientObject(selection, record);
                    break;
                default:
                    selection;
                    $423Vm(false);
            }
        });
    };
    _proto._traverseClientEdgeToClientObject = function _traverseClientEdgeToClientObject(field, record) {
        var dataID = this._traverseResolverField(field.backingField, record);
        if (dataID == null) return;
        var resolverRecord = this._recordSource.get(dataID);
        if (resolverRecord == null) return;
        if (field.backingField.isOutputType) {
            var outputTypeRecordIDs = $bhYu6(resolverRecord);
            if (outputTypeRecordIDs != null) {
                var _iterator = (0, $83225e3aced9793c$var$_createForOfIteratorHelper2["default"])(outputTypeRecordIDs), _step;
                try {
                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                        var _dataID = _step.value;
                        this._references.add(_dataID);
                    }
                } catch (err) {
                    _iterator.e(err);
                } finally{
                    _iterator.f();
                }
            }
        } else {
            var linkedField = field.linkedField;
            var concreteType = linkedField.concreteType;
            if (concreteType == null) return;
            if (linkedField.plural) {
                var dataIDs = $fagih.getResolverLinkedRecordIDs(resolverRecord, concreteType);
                if (dataIDs != null) {
                    var _iterator2 = (0, $83225e3aced9793c$var$_createForOfIteratorHelper2["default"])(dataIDs), _step2;
                    try {
                        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                            var _dataID2 = _step2.value;
                            if (_dataID2 != null) this._traverse(linkedField, _dataID2);
                        }
                    } catch (err) {
                        _iterator2.e(err);
                    } finally{
                        _iterator2.f();
                    }
                }
            } else {
                var _dataID3 = $fagih.getResolverLinkedRecordID(resolverRecord, concreteType);
                if (_dataID3 != null) this._traverse(linkedField, _dataID3);
            }
        }
    };
    _proto._traverseResolverField = function _traverseResolverField(field, record) {
        var storageKey = $83225e3aced9793c$var$getStorageKey(field, this._variables);
        var dataID = $fagih.getLinkedRecordID(record, storageKey);
        if (dataID != null) this._references.add(dataID);
        var fragment = field.fragment;
        if (fragment != null) this._traverseSelections([
            fragment
        ], record);
        return dataID;
    };
    _proto._traverseModuleImport = function _traverseModuleImport(moduleImport, record) {
        var _this$_operationName;
        var operationLoader = this._operationLoader;
        !(operationLoader !== null) && $423Vm(false);
        var operationKey = $83225e3aced9793c$var$getModuleOperationKey(moduleImport.documentName);
        var operationReference = $fagih.getValue(record, operationKey);
        if (operationReference == null) return;
        var normalizationRootNode = operationLoader.get(operationReference);
        if (normalizationRootNode != null) {
            var operation = $lTsrN(normalizationRootNode);
            var prevVariables = this._variables;
            this._variables = $83225e3aced9793c$var$getLocalVariables(this._variables, operation.argumentDefinitions, moduleImport.args);
            this._traverseSelections(operation.selections, record);
            this._variables = prevVariables;
        }
    };
    _proto._traverseLink = function _traverseLink(field, record) {
        var storageKey = $83225e3aced9793c$var$getStorageKey(field, this._variables);
        var linkedID = $fagih.getLinkedRecordID(record, storageKey);
        if (linkedID == null) return;
        this._traverse(field, linkedID);
    };
    _proto._traversePluralLink = function _traversePluralLink(field, record) {
        var _this2 = this;
        var storageKey = $83225e3aced9793c$var$getStorageKey(field, this._variables);
        var linkedIDs = $fagih.getLinkedRecordIDs(record, storageKey);
        if (linkedIDs == null) return;
        linkedIDs.forEach(function(linkedID) {
            if (linkedID != null) _this2._traverse(field, linkedID);
        });
    };
    return RelayReferenceMarker;
}();
module.exports = {
    mark: $83225e3aced9793c$var$mark
};

});
parcelRegister("bhYu6", function(module, exports) {
'use strict';

var $fagih = parcelRequire("fagih");

var $f91UN = parcelRequire("f91UN");
var $8380333195e836c0$var$RELAY_RESOLVER_OUTPUT_TYPE_RECORD_IDS = $f91UN.RELAY_RESOLVER_OUTPUT_TYPE_RECORD_IDS;

var $423Vm = parcelRequire("423Vm");
function $8380333195e836c0$var$getOutputTypeRecordIDs(record) {
    var maybeOutputTypeRecordIDs = $fagih.getValue(record, $8380333195e836c0$var$RELAY_RESOLVER_OUTPUT_TYPE_RECORD_IDS);
    if (maybeOutputTypeRecordIDs == null) return null;
    !(maybeOutputTypeRecordIDs instanceof Set) && $423Vm(false);
    return maybeOutputTypeRecordIDs;
}
module.exports = $8380333195e836c0$var$getOutputTypeRecordIDs;

});


parcelRegister("dc1NV", function(module, exports) {
'use strict';
parcelRequire("hElRV");

var $l9X9G = parcelRequire("l9X9G");

var $llkIA = parcelRequire("llkIA");

var $9ToBQ = parcelRequire("9ToBQ");

var $4s4px = parcelRequire("4s4px");

var $ldcaJ = parcelRequire("ldcaJ");
var $99adcba28dc81a0b$var$RelayStoreSubscriptions = /*#__PURE__*/ function() {
    function RelayStoreSubscriptions(log, resolverCache) {
        this._subscriptions = new Set();
        this.__log = log;
        this._resolverCache = resolverCache;
    }
    var _proto = RelayStoreSubscriptions.prototype;
    _proto.subscribe = function subscribe(snapshot, callback) {
        var _this = this;
        var subscription = {
            backup: null,
            callback: callback,
            snapshot: snapshot,
            stale: false
        };
        var dispose = function dispose() {
            _this._subscriptions["delete"](subscription);
        };
        this._subscriptions.add(subscription);
        return {
            dispose: dispose
        };
    };
    _proto.snapshotSubscriptions = function snapshotSubscriptions(source) {
        var _this2 = this;
        this._subscriptions.forEach(function(subscription) {
            if (!subscription.stale) {
                subscription.backup = subscription.snapshot;
                return;
            }
            var snapshot = subscription.snapshot;
            var backup = $ldcaJ.read(source, snapshot.selector, _this2._resolverCache);
            var nextData = $l9X9G(snapshot.data, backup.data);
            backup.data = nextData;
            subscription.backup = backup;
        });
    };
    _proto.restoreSubscriptions = function restoreSubscriptions() {
        this._subscriptions.forEach(function(subscription) {
            var backup = subscription.backup;
            subscription.backup = null;
            if (backup) {
                if (backup.data !== subscription.snapshot.data) subscription.stale = true;
                subscription.snapshot = {
                    data: subscription.snapshot.data,
                    isMissingData: backup.isMissingData,
                    missingClientEdges: backup.missingClientEdges,
                    missingLiveResolverFields: backup.missingLiveResolverFields,
                    seenRecords: backup.seenRecords,
                    selector: backup.selector,
                    missingRequiredFields: backup.missingRequiredFields,
                    relayResolverErrors: backup.relayResolverErrors,
                    errorResponseFields: backup.errorResponseFields
                };
            } else subscription.stale = true;
        });
    };
    _proto.updateSubscriptions = function updateSubscriptions(source, updatedRecordIDs, updatedOwners, sourceOperation) {
        var _this3 = this;
        var hasUpdatedRecords = updatedRecordIDs.size !== 0;
        this._subscriptions.forEach(function(subscription) {
            var owner = _this3._updateSubscription(source, subscription, updatedRecordIDs, hasUpdatedRecords, sourceOperation);
            if (owner != null) updatedOwners.push(owner);
        });
    };
    _proto._updateSubscription = function _updateSubscription(source, subscription, updatedRecordIDs, hasUpdatedRecords, sourceOperation) {
        var backup = subscription.backup, callback = subscription.callback, snapshot = subscription.snapshot, stale = subscription.stale;
        var hasOverlappingUpdates = hasUpdatedRecords && $9ToBQ(snapshot.seenRecords, updatedRecordIDs);
        if (!stale && !hasOverlappingUpdates) return;
        var nextSnapshot = hasOverlappingUpdates || !backup ? $ldcaJ.read(source, snapshot.selector, this._resolverCache) : backup;
        var nextData = $l9X9G(snapshot.data, nextSnapshot.data);
        nextSnapshot = {
            data: nextData,
            isMissingData: nextSnapshot.isMissingData,
            missingClientEdges: nextSnapshot.missingClientEdges,
            missingLiveResolverFields: nextSnapshot.missingLiveResolverFields,
            seenRecords: nextSnapshot.seenRecords,
            selector: nextSnapshot.selector,
            missingRequiredFields: nextSnapshot.missingRequiredFields,
            relayResolverErrors: nextSnapshot.relayResolverErrors,
            errorResponseFields: nextSnapshot.errorResponseFields
        };
        subscription.snapshot = nextSnapshot;
        subscription.stale = false;
        if (nextSnapshot.data !== snapshot.data) {
            if (this.__log && $llkIA.ENABLE_NOTIFY_SUBSCRIPTION) this.__log({
                name: 'store.notify.subscription',
                sourceOperation: sourceOperation,
                snapshot: snapshot,
                nextSnapshot: nextSnapshot
            });
            callback(nextSnapshot);
            return snapshot.selector.owner;
        }
        if ($llkIA.ENABLE_LOOSE_SUBSCRIPTION_ATTRIBUTION && (stale || $4s4px(snapshot.seenRecords, updatedRecordIDs))) return snapshot.selector.owner;
    };
    return RelayStoreSubscriptions;
}();
module.exports = $99adcba28dc81a0b$var$RelayStoreSubscriptions;

});
parcelRegister("9ToBQ", function(module, exports) {
'use strict';
var $733c570b70927c5d$var$ITERATOR_KEY = Symbol.iterator;
function $733c570b70927c5d$var$hasOverlappingIDs(seenRecords, updatedRecordIDs) {
    var iterator = seenRecords[$733c570b70927c5d$var$ITERATOR_KEY]();
    var next = iterator.next();
    while(!next.done){
        var key = next.value;
        if (updatedRecordIDs.has(key)) return true;
        next = iterator.next();
    }
    return false;
}
module.exports = $733c570b70927c5d$var$hasOverlappingIDs;

});

parcelRegister("4s4px", function(module, exports) {
'use strict';

var $f91UN = parcelRequire("f91UN");
var $33dd32db364a47f8$var$ROOT_ID = $f91UN.ROOT_ID;

var $ap10a = parcelRequire("ap10a");
var $33dd32db364a47f8$var$VIEWER_ID = $ap10a.VIEWER_ID;
var $33dd32db364a47f8$var$ITERATOR_KEY = Symbol.iterator;
function $33dd32db364a47f8$var$hasSignificantOverlappingIDs(seenRecords, updatedRecordIDs) {
    var iterator = seenRecords[$33dd32db364a47f8$var$ITERATOR_KEY]();
    var next = iterator.next();
    while(!next.done){
        var key = next.value;
        if (updatedRecordIDs.has(key) && key !== $33dd32db364a47f8$var$ROOT_ID && key !== $33dd32db364a47f8$var$VIEWER_ID) return true;
        next = iterator.next();
    }
    return false;
}
module.exports = $33dd32db364a47f8$var$hasSignificantOverlappingIDs;

});



parcelRegister("hvXwY", function(module, exports) {
'use strict';

var $crrn5 = parcelRequire("crrn5");

var $bzkJN = parcelRequire("bzkJN");
var $cc03827f783f8d2f$var$getRequest = $bzkJN.getRequest;

var $l0are = parcelRequire("l0are");
var $cc03827f783f8d2f$var$createOperationDescriptor = $l0are.createOperationDescriptor;

var $g432U = parcelRequire("g432U");
var $cc03827f783f8d2f$var$createReaderSelector = $g432U.createReaderSelector;
parcelRequire("dH6ue");
function $cc03827f783f8d2f$var$requestSubscription(environment, config) {
    var subscription = $cc03827f783f8d2f$var$getRequest(config.subscription);
    if (subscription.params.operationKind !== 'subscription') throw new Error('requestSubscription: Must use Subscription operation');
    var configs = config.configs, onCompleted = config.onCompleted, onError = config.onError, onNext = config.onNext, variables = config.variables, cacheConfig = config.cacheConfig;
    var operation = $cc03827f783f8d2f$var$createOperationDescriptor(subscription, variables, cacheConfig);
    var _ref = configs ? $crrn5.convert(configs, subscription, null, config.updater) : config, updater = _ref.updater;
    var sub = environment.executeSubscription({
        operation: operation,
        updater: updater
    }).subscribe({
        next: function next(responses) {
            if (onNext != null) {
                var selector = operation.fragment;
                var nextID;
                if (Array.isArray(responses)) {
                    var _responses$, _responses$$extension;
                    nextID = (_responses$ = responses[0]) === null || _responses$ === void 0 ? void 0 : (_responses$$extension = _responses$.extensions) === null || _responses$$extension === void 0 ? void 0 : _responses$$extension.__relay_subscription_root_id;
                } else {
                    var _responses$extensions;
                    nextID = (_responses$extensions = responses.extensions) === null || _responses$extensions === void 0 ? void 0 : _responses$extensions.__relay_subscription_root_id;
                }
                if (typeof nextID === 'string') selector = $cc03827f783f8d2f$var$createReaderSelector(selector.node, nextID, selector.variables, selector.owner);
                var data = environment.lookup(selector).data;
                onNext(data);
            }
        },
        error: onError,
        complete: onCompleted
    });
    return {
        dispose: sub.unsubscribe
    };
}
module.exports = $cc03827f783f8d2f$var$requestSubscription;

});

parcelRegister("3GT8f", function(module, exports) {
'use strict';

var $7Wmh0 = parcelRequire("7Wmh0");
var $2b000f6de53fe34f$var$_interopRequireDefault = $7Wmh0.default;

var $2b000f6de53fe34f$var$_objectSpread2 = $2b000f6de53fe34f$var$_interopRequireDefault((parcelRequire("1sB2t")));

var $f91UN = parcelRequire("f91UN");
var $2b000f6de53fe34f$var$getModuleComponentKey = $f91UN.getModuleComponentKey, $2b000f6de53fe34f$var$getModuleOperationKey = $f91UN.getModuleOperationKey;
function $2b000f6de53fe34f$var$createPayloadFor3DField(name, operation, component, response) {
    var data = (0, $2b000f6de53fe34f$var$_objectSpread2["default"])({}, response);
    data[$2b000f6de53fe34f$var$getModuleComponentKey(name)] = component;
    data[$2b000f6de53fe34f$var$getModuleOperationKey(name)] = operation;
    return data;
}
module.exports = $2b000f6de53fe34f$var$createPayloadFor3DField;

});

parcelRegister("eZC9U", function(module, exports) {
'use strict';

var $g432U = parcelRequire("g432U");
var $aea45cbaea558bae$var$getDataIDsFromFragment = $g432U.getDataIDsFromFragment, $aea45cbaea558bae$var$getSelector = $g432U.getSelector, $aea45cbaea558bae$var$getVariablesFromFragment = $g432U.getVariablesFromFragment;

var $2FmBz = parcelRequire("2FmBz");

var $llkIA = parcelRequire("llkIA");

var $4cAcq = parcelRequire("4cAcq");

var $6jf6j = parcelRequire("6jf6j");
var $aea45cbaea558bae$var$intern = $6jf6j.intern;
function $aea45cbaea558bae$var$getFragmentIdentifier(fragmentNode, fragmentRef) {
    var selector = $aea45cbaea558bae$var$getSelector(fragmentNode, fragmentRef);
    var fragmentOwnerIdentifier = selector == null ? 'null' : selector.kind === 'SingularReaderSelector' ? selector.owner.identifier : '[' + selector.selectors.map(function(sel) {
        return sel.owner.identifier;
    }).join(',') + ']';
    var fragmentVariables = $aea45cbaea558bae$var$getVariablesFromFragment(fragmentNode, fragmentRef);
    var dataIDs = $aea45cbaea558bae$var$getDataIDsFromFragment(fragmentNode, fragmentRef);
    if ($llkIA.ENABLE_GETFRAGMENTIDENTIFIER_OPTIMIZATION) {
        var ids = typeof dataIDs === 'undefined' ? 'missing' : dataIDs == null ? 'null' : Array.isArray(dataIDs) ? '[' + dataIDs.join(',') + ']' : dataIDs;
        ids = $llkIA.STRING_INTERN_LEVEL <= 1 ? ids : $aea45cbaea558bae$var$intern(ids, $llkIA.MAX_DATA_ID_LENGTH);
        return fragmentOwnerIdentifier + '/' + fragmentNode.name + '/' + (fragmentVariables == null || $2FmBz(fragmentVariables) ? '{}' : JSON.stringify($4cAcq(fragmentVariables))) + '/' + ids;
    } else {
        var _JSON$stringify;
        var _ids = (_JSON$stringify = JSON.stringify(dataIDs)) !== null && _JSON$stringify !== void 0 ? _JSON$stringify : 'missing';
        _ids = $llkIA.STRING_INTERN_LEVEL <= 1 ? _ids : $aea45cbaea558bae$var$intern(_ids, $llkIA.MAX_DATA_ID_LENGTH);
        return fragmentOwnerIdentifier + '/' + fragmentNode.name + '/' + JSON.stringify($4cAcq(fragmentVariables)) + '/' + _ids;
    }
}
module.exports = $aea45cbaea558bae$var$getFragmentIdentifier;

});
parcelRegister("2FmBz", function(module, exports) {
'use strict';
var $1f10f1fddd98d755$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $1f10f1fddd98d755$var$isEmptyObject(obj) {
    for(var _key in obj){
        if ($1f10f1fddd98d755$var$hasOwnProperty.call(obj, _key)) return false;
    }
    return true;
}
module.exports = $1f10f1fddd98d755$var$isEmptyObject;

});


parcelRegister("jXBNZ", function(module, exports) {
'use strict';

var $9CTh0 = parcelRequire("9CTh0");

var $423Vm = parcelRequire("423Vm");
function $e880da5f23c6ae03$var$getPaginationMetadata(fragmentNode, componentDisplayName) {
    var _fragmentNode$metadat, _fragmentNode$metadat2;
    var _getRefetchMetadata = $9CTh0(fragmentNode, componentDisplayName), paginationRequest = _getRefetchMetadata.refetchableRequest, refetchMetadata = _getRefetchMetadata.refetchMetadata;
    var paginationMetadata = refetchMetadata.connection;
    !(paginationMetadata != null) && $423Vm(false);
    var connectionPathInFragmentData = paginationMetadata.path;
    var connectionMetadata = ((_fragmentNode$metadat = (_fragmentNode$metadat2 = fragmentNode.metadata) === null || _fragmentNode$metadat2 === void 0 ? void 0 : _fragmentNode$metadat2.connection) !== null && _fragmentNode$metadat !== void 0 ? _fragmentNode$metadat : [])[0];
    !(connectionMetadata != null) && $423Vm(false);
    var identifierInfo = refetchMetadata.identifierInfo;
    !((identifierInfo === null || identifierInfo === void 0 ? void 0 : identifierInfo.identifierField) == null || typeof identifierInfo.identifierField === 'string') && $423Vm(false);
    return {
        connectionPathInFragmentData: connectionPathInFragmentData,
        identifierField: identifierInfo === null || identifierInfo === void 0 ? void 0 : identifierInfo.identifierField,
        paginationRequest: paginationRequest,
        paginationMetadata: paginationMetadata,
        stream: connectionMetadata.stream === true
    };
}
module.exports = $e880da5f23c6ae03$var$getPaginationMetadata;

});
parcelRegister("9CTh0", function(module, exports) {
'use strict';

var $423Vm = parcelRequire("423Vm");
function $702289ce259ac08f$var$getRefetchMetadata(fragmentNode, componentDisplayName) {
    var _fragmentNode$metadat, _fragmentNode$metadat2;
    !(((_fragmentNode$metadat = fragmentNode.metadata) === null || _fragmentNode$metadat === void 0 ? void 0 : _fragmentNode$metadat.plural) !== true) && $423Vm(false);
    var refetchMetadata = (_fragmentNode$metadat2 = fragmentNode.metadata) === null || _fragmentNode$metadat2 === void 0 ? void 0 : _fragmentNode$metadat2.refetch;
    !(refetchMetadata != null) && $423Vm(false);
    var refetchableRequest = refetchMetadata.operation["default"] ? refetchMetadata.operation["default"] : refetchMetadata.operation;
    var fragmentRefPathInResponse = refetchMetadata.fragmentPathInResult;
    !(typeof refetchableRequest !== 'string') && $423Vm(false);
    var identifierInfo = refetchMetadata.identifierInfo;
    if (identifierInfo != null) {
        !(identifierInfo.identifierField == null || typeof identifierInfo.identifierField === 'string') && $423Vm(false);
        !(identifierInfo.identifierQueryVariableName == null || typeof identifierInfo.identifierQueryVariableName === 'string') && $423Vm(false);
    }
    return {
        fragmentRefPathInResponse: fragmentRefPathInResponse,
        identifierInfo: identifierInfo,
        refetchableRequest: refetchableRequest,
        refetchMetadata: refetchMetadata
    };
}
module.exports = $702289ce259ac08f$var$getRefetchMetadata;

});


parcelRegister("6bDy3", function(module, exports) {
'use strict';

var $7Wmh0 = parcelRequire("7Wmh0");
var $48127299345ba21c$var$_interopRequireDefault = $7Wmh0.default;

var $48127299345ba21c$var$_defineProperty2 = $48127299345ba21c$var$_interopRequireDefault((parcelRequire("ky4V8")));

var $48127299345ba21c$var$_objectSpread4 = $48127299345ba21c$var$_interopRequireDefault((parcelRequire("1sB2t")));

var $423Vm = parcelRequire("423Vm");
parcelRequire("dH6ue");
function $48127299345ba21c$var$getPaginationVariables(direction, count, cursor, baseVariables, extraVariables, paginationMetadata) {
    var _objectSpread3;
    var backwardMetadata = paginationMetadata.backward, forwardMetadata = paginationMetadata.forward;
    if (direction === 'backward') {
        var _objectSpread2;
        !(backwardMetadata != null && backwardMetadata.count != null && backwardMetadata.cursor != null) && $423Vm(false);
        var _paginationVariables = (0, $48127299345ba21c$var$_objectSpread4["default"])((0, $48127299345ba21c$var$_objectSpread4["default"])((0, $48127299345ba21c$var$_objectSpread4["default"])({}, baseVariables), extraVariables), {}, (_objectSpread2 = {}, (0, $48127299345ba21c$var$_defineProperty2["default"])(_objectSpread2, backwardMetadata.cursor, cursor), (0, $48127299345ba21c$var$_defineProperty2["default"])(_objectSpread2, backwardMetadata.count, count), _objectSpread2));
        if (forwardMetadata && forwardMetadata.cursor) _paginationVariables[forwardMetadata.cursor] = null;
        if (forwardMetadata && forwardMetadata.count) _paginationVariables[forwardMetadata.count] = null;
        return _paginationVariables;
    }
    !(forwardMetadata != null && forwardMetadata.count != null && forwardMetadata.cursor != null) && $423Vm(false);
    var paginationVariables = (0, $48127299345ba21c$var$_objectSpread4["default"])((0, $48127299345ba21c$var$_objectSpread4["default"])((0, $48127299345ba21c$var$_objectSpread4["default"])({}, baseVariables), extraVariables), {}, (_objectSpread3 = {}, (0, $48127299345ba21c$var$_defineProperty2["default"])(_objectSpread3, forwardMetadata.cursor, cursor), (0, $48127299345ba21c$var$_defineProperty2["default"])(_objectSpread3, forwardMetadata.count, count), _objectSpread3));
    if (backwardMetadata && backwardMetadata.cursor) paginationVariables[backwardMetadata.cursor] = null;
    if (backwardMetadata && backwardMetadata.count) paginationVariables[backwardMetadata.count] = null;
    return paginationVariables;
}
module.exports = $48127299345ba21c$var$getPaginationVariables;

});

parcelRegister("eBAOm", function(module, exports) {
'use strict';

var $7Wmh0 = parcelRequire("7Wmh0");
var $aa21135cc582885d$var$_interopRequireDefault = $7Wmh0.default;

var $aa21135cc582885d$var$_createForOfIteratorHelper2 = $aa21135cc582885d$var$_interopRequireDefault((parcelRequire("9CLQ8")));

var $423Vm = parcelRequire("423Vm");
function $aa21135cc582885d$var$getValueAtPath(data, path) {
    var result = data;
    var _iterator = (0, $aa21135cc582885d$var$_createForOfIteratorHelper2["default"])(path), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var key = _step.value;
            if (result == null) return null;
            if (typeof key === 'number') {
                !Array.isArray(result) && $423Vm(false);
                result = result[key];
            } else {
                !(typeof result === 'object' && !Array.isArray(result)) && $423Vm(false);
                result = result[key];
            }
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    return result;
}
module.exports = $aa21135cc582885d$var$getValueAtPath;

});

parcelRegister("5tBBd", function(module, exports) {
'use strict';
var $3fccd39d5351da5e$var$profileHandlersByName = {};
var $3fccd39d5351da5e$var$defaultProfiler = {
    stop: function stop() {}
};
var $3fccd39d5351da5e$var$RelayProfiler = {
    profile: function profile(name, state) {
        var handlers = $3fccd39d5351da5e$var$profileHandlersByName[name];
        if (handlers && handlers.length > 0) {
            var stopHandlers = [];
            for(var ii = handlers.length - 1; ii >= 0; ii--){
                var stopHandler = handlers[ii](name, state);
                stopHandlers.unshift(stopHandler);
            }
            return {
                stop: function stop(error) {
                    stopHandlers.forEach(function(stopHandler) {
                        return stopHandler(error);
                    });
                }
            };
        }
        return $3fccd39d5351da5e$var$defaultProfiler;
    },
    attachProfileHandler: function attachProfileHandler(name, handler) {
        if (!$3fccd39d5351da5e$var$profileHandlersByName.hasOwnProperty(name)) $3fccd39d5351da5e$var$profileHandlersByName[name] = [];
        $3fccd39d5351da5e$var$profileHandlersByName[name].push(handler);
    },
    detachProfileHandler: function detachProfileHandler(name, handler) {
        if ($3fccd39d5351da5e$var$profileHandlersByName.hasOwnProperty(name)) $3fccd39d5351da5e$var$removeFromArray($3fccd39d5351da5e$var$profileHandlersByName[name], handler);
    }
};
function $3fccd39d5351da5e$var$removeFromArray(array, element) {
    var index = array.indexOf(element);
    if (index !== -1) array.splice(index, 1);
}
module.exports = $3fccd39d5351da5e$var$RelayProfiler;

});




parcelRegister("lIoSt", function(module, exports) {
'use strict';

var $7Wmh0 = parcelRequire("7Wmh0");
var $fcf10137915a07fe$var$_interopRequireDefault = $7Wmh0.default;

var $fcf10137915a07fe$var$_extends2 = $fcf10137915a07fe$var$_interopRequireDefault((parcelRequire("6bgQp")));

var $fcf10137915a07fe$var$_objectWithoutPropertiesLoose2 = $fcf10137915a07fe$var$_interopRequireDefault((parcelRequire("h8lLa")));

var $fcf10137915a07fe$var$_assertThisInitialized2 = $fcf10137915a07fe$var$_interopRequireDefault((parcelRequire("7GwkG")));

var $fcf10137915a07fe$var$_inheritsLoose2 = $fcf10137915a07fe$var$_interopRequireDefault((parcelRequire("2iule")));

var $fcf10137915a07fe$var$_defineProperty2 = $fcf10137915a07fe$var$_interopRequireDefault((parcelRequire("ky4V8")));
var $fcf10137915a07fe$var$_excluded = [
    "componentRef",
    "__relayContext",
    "__rootIsQueryRenderer"
];

var $ewnEa = parcelRequire("ewnEa");

var $4fb0r = parcelRequire("4fb0r");
var $fcf10137915a07fe$var$getContainerName = $4fb0r.getContainerName;

var $hVPOR = parcelRequire("hVPOR");
var $fcf10137915a07fe$var$assertRelayContext = $hVPOR.assertRelayContext;

var $jT3aJ = parcelRequire("jT3aJ");

var $eJOHy = parcelRequire("eJOHy");

var $37Ewn = parcelRequire("37Ewn");
var $fcf10137915a07fe$var$createFragmentSpecResolver = $37Ewn.createFragmentSpecResolver, $fcf10137915a07fe$var$getDataIDsFromObject = $37Ewn.getDataIDsFromObject, $fcf10137915a07fe$var$isScalarAndEqual = $37Ewn.isScalarAndEqual;
function $fcf10137915a07fe$var$createContainerWithFragments(Component, fragments) {
    var _class;
    var containerName = $fcf10137915a07fe$var$getContainerName(Component);
    return _class = /*#__PURE__*/ function(_React$Component) {
        (0, $fcf10137915a07fe$var$_inheritsLoose2["default"])(_class, _React$Component);
        function _class(props) {
            var _props$__rootIsQueryR, _this;
            _this = _React$Component.call(this, props) || this;
            (0, $fcf10137915a07fe$var$_defineProperty2["default"])((0, $fcf10137915a07fe$var$_assertThisInitialized2["default"])(_this), "_handleFragmentDataUpdate", function() {
                var resolverFromThisUpdate = _this.state.resolver;
                _this.setState(function(updatedState) {
                    return resolverFromThisUpdate === updatedState.resolver ? {
                        data: updatedState.resolver.resolve(),
                        relayProp: $fcf10137915a07fe$var$getRelayProp(updatedState.relayProp.environment)
                    } : null;
                });
            });
            var relayContext = $fcf10137915a07fe$var$assertRelayContext(props.__relayContext);
            var rootIsQueryRenderer = (_props$__rootIsQueryR = props.__rootIsQueryRenderer) !== null && _props$__rootIsQueryR !== void 0 ? _props$__rootIsQueryR : false;
            var resolver = $fcf10137915a07fe$var$createFragmentSpecResolver(relayContext, containerName, fragments, props, rootIsQueryRenderer);
            _this.state = {
                data: resolver.resolve(),
                prevProps: props,
                prevPropsContext: relayContext,
                relayProp: $fcf10137915a07fe$var$getRelayProp(relayContext.environment),
                resolver: resolver
            };
            return _this;
        }
        _class.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
            var _nextProps$__rootIsQu;
            var prevProps = prevState.prevProps;
            var relayContext = $fcf10137915a07fe$var$assertRelayContext(nextProps.__relayContext);
            var rootIsQueryRenderer = (_nextProps$__rootIsQu = nextProps.__rootIsQueryRenderer) !== null && _nextProps$__rootIsQu !== void 0 ? _nextProps$__rootIsQu : false;
            var prevIDs = $fcf10137915a07fe$var$getDataIDsFromObject(fragments, prevProps);
            var nextIDs = $fcf10137915a07fe$var$getDataIDsFromObject(fragments, nextProps);
            var resolver = prevState.resolver;
            if (prevState.prevPropsContext.environment !== relayContext.environment || !$jT3aJ(prevIDs, nextIDs)) {
                resolver = $fcf10137915a07fe$var$createFragmentSpecResolver(relayContext, containerName, fragments, nextProps, rootIsQueryRenderer);
                return {
                    data: resolver.resolve(),
                    prevPropsContext: relayContext,
                    prevProps: nextProps,
                    relayProp: $fcf10137915a07fe$var$getRelayProp(relayContext.environment),
                    resolver: resolver
                };
            } else {
                resolver.setProps(nextProps);
                var data = resolver.resolve();
                if (data !== prevState.data) return {
                    data: data,
                    prevProps: nextProps,
                    prevPropsContext: relayContext,
                    relayProp: $fcf10137915a07fe$var$getRelayProp(relayContext.environment)
                };
            }
            return null;
        };
        var _proto = _class.prototype;
        _proto.componentDidMount = function componentDidMount() {
            this._subscribeToNewResolverAndRerenderIfStoreHasChanged();
        };
        _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
            if (this.state.resolver !== prevState.resolver) {
                prevState.resolver.dispose();
                this._subscribeToNewResolverAndRerenderIfStoreHasChanged();
            } else this._rerenderIfStoreHasChanged();
        };
        _proto.componentWillUnmount = function componentWillUnmount() {
            this.state.resolver.dispose();
        };
        _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
            if (nextState.data !== this.state.data) return true;
            var keys = Object.keys(nextProps);
            for(var ii = 0; ii < keys.length; ii++){
                var key = keys[ii];
                if (key === '__relayContext') {
                    if (nextState.prevPropsContext.environment !== this.state.prevPropsContext.environment) return true;
                } else {
                    if (!fragments.hasOwnProperty(key) && !$fcf10137915a07fe$var$isScalarAndEqual(nextProps[key], this.props[key])) return true;
                }
            }
            return false;
        };
        _proto._rerenderIfStoreHasChanged = function _rerenderIfStoreHasChanged() {
            var _this$state = this.state, data = _this$state.data, resolver = _this$state.resolver;
            var maybeNewData = resolver.resolve();
            if (data !== maybeNewData) this.setState({
                data: maybeNewData
            });
        };
        _proto._subscribeToNewResolverAndRerenderIfStoreHasChanged = function _subscribeToNewResolverAndRerenderIfStoreHasChanged() {
            var _this$state2 = this.state, data = _this$state2.data, resolver = _this$state2.resolver;
            var maybeNewData = resolver.resolve();
            resolver.setCallback(this.props, this._handleFragmentDataUpdate);
            if (data !== maybeNewData) this.setState({
                data: maybeNewData
            });
        };
        _proto.render = function render() {
            var _this$props = this.props, componentRef = _this$props.componentRef, __relayContext = _this$props.__relayContext, __rootIsQueryRenderer = _this$props.__rootIsQueryRenderer, props = (0, $fcf10137915a07fe$var$_objectWithoutPropertiesLoose2["default"])(_this$props, $fcf10137915a07fe$var$_excluded);
            return /*#__PURE__*/ $eJOHy.createElement(Component, (0, $fcf10137915a07fe$var$_extends2["default"])({}, props, this.state.data, {
                ref: componentRef,
                relay: this.state.relayProp
            }));
        };
        return _class;
    }($eJOHy.Component), (0, $fcf10137915a07fe$var$_defineProperty2["default"])(_class, "displayName", containerName), _class;
}
function $fcf10137915a07fe$var$getRelayProp(environment) {
    return {
        environment: environment
    };
}
function $fcf10137915a07fe$var$createContainer(Component, fragmentSpec) {
    return $ewnEa(Component, fragmentSpec, $fcf10137915a07fe$var$createContainerWithFragments);
}
module.exports = {
    createContainer: $fcf10137915a07fe$var$createContainer
};

});
parcelRegister("ewnEa", function(module, exports) {
'use strict';

var $7Wmh0 = parcelRequire("7Wmh0");
var $a926659dac9e6fb6$var$_interopRequireDefault = $7Wmh0.default;

var $a926659dac9e6fb6$var$_extends2 = $a926659dac9e6fb6$var$_interopRequireDefault((parcelRequire("6bgQp")));

var $9hDqn = parcelRequire("9hDqn");

var $4fb0r = parcelRequire("4fb0r");
var $a926659dac9e6fb6$var$getComponentName = $4fb0r.getComponentName, $a926659dac9e6fb6$var$getContainerName = $4fb0r.getContainerName;

var $iwDoV = parcelRequire("iwDoV");

var $1AnXR = parcelRequire("1AnXR");

var $423Vm = parcelRequire("423Vm");

var $eJOHy = parcelRequire("eJOHy");

var $37Ewn = parcelRequire("37Ewn");
var $a926659dac9e6fb6$var$getFragment = $37Ewn.getFragment;
var $a926659dac9e6fb6$var$useContext = $eJOHy.useContext;
function $a926659dac9e6fb6$var$buildReactRelayContainer(ComponentClass, fragmentSpec, createContainerWithFragments) {
    var containerName = $a926659dac9e6fb6$var$getContainerName(ComponentClass);
    $9hDqn($a926659dac9e6fb6$var$getComponentName(ComponentClass), fragmentSpec);
    var fragments = {};
    for(var key in fragmentSpec)fragments[key] = $a926659dac9e6fb6$var$getFragment(fragmentSpec[key]);
    var Container = createContainerWithFragments(ComponentClass, fragments);
    Container.displayName = containerName;
    function ForwardRef(props, ref) {
        var _queryRendererContext;
        var context = $a926659dac9e6fb6$var$useContext($iwDoV);
        !(context != null) && $423Vm(false);
        var queryRendererContext = $a926659dac9e6fb6$var$useContext($1AnXR);
        return /*#__PURE__*/ $eJOHy.createElement(Container, (0, $a926659dac9e6fb6$var$_extends2["default"])({}, props, {
            __relayContext: context,
            __rootIsQueryRenderer: (_queryRendererContext = queryRendererContext === null || queryRendererContext === void 0 ? void 0 : queryRendererContext.rootIsQueryRenderer) !== null && _queryRendererContext !== void 0 ? _queryRendererContext : false,
            componentRef: props.componentRef || ref
        }));
    }
    ForwardRef.displayName = containerName;
    var ForwardContainer = $eJOHy.forwardRef(ForwardRef);
    return ForwardContainer;
}
module.exports = $a926659dac9e6fb6$var$buildReactRelayContainer;

});
parcelRegister("9hDqn", function(module, exports) {
'use strict';

var $423Vm = parcelRequire("423Vm");
function $6c24487269492c59$var$assertFragmentMap(componentName, fragmentSpec) {
    !(fragmentSpec && typeof fragmentSpec === 'object') && $423Vm(false);
    for(var key in fragmentSpec)if (fragmentSpec.hasOwnProperty(key)) {
        var fragment = fragmentSpec[key];
        !(fragment && (typeof fragment === 'object' || typeof fragment === 'function')) && $423Vm(false);
    }
}
module.exports = $6c24487269492c59$var$assertFragmentMap;

});

parcelRegister("4fb0r", function(module, exports) {
'use strict';
function $317119b4028e7fed$var$getComponentName(component) {
    return component.displayName || component.name || 'Component';
}
function $317119b4028e7fed$var$getContainerName(Component) {
    return 'Relay(' + $317119b4028e7fed$var$getComponentName(Component) + ')';
}
module.exports = {
    getComponentName: $317119b4028e7fed$var$getComponentName,
    getContainerName: $317119b4028e7fed$var$getContainerName
};

});

parcelRegister("1AnXR", function(module, exports) {
'use strict';

var $eJOHy = parcelRequire("eJOHy");
module.exports = $eJOHy.createContext({
    rootIsQueryRenderer: false
});

});


parcelRegister("hVPOR", function(module, exports) {
'use strict';

var $4GAHd = parcelRequire("4GAHd");

var $423Vm = parcelRequire("423Vm");
function $d0dff4ca7738c0c4$var$assertRelayContext(relay) {
    !$d0dff4ca7738c0c4$var$isRelayContext(relay) && $423Vm(false);
    return relay;
}
function $d0dff4ca7738c0c4$var$isRelayContext(context) {
    return typeof context === 'object' && context !== null && !Array.isArray(context) && $4GAHd(context.environment);
}
module.exports = {
    assertRelayContext: $d0dff4ca7738c0c4$var$assertRelayContext,
    isRelayContext: $d0dff4ca7738c0c4$var$isRelayContext
};

});
parcelRegister("4GAHd", function(module, exports) {
'use strict';
function $36978cb6d1f0cc8c$var$isRelayEnvironment(environment) {
    return typeof environment === 'object' && environment !== null && typeof environment.check === 'function' && typeof environment.lookup === 'function' && typeof environment.retain === 'function' && typeof environment.execute === 'function' && typeof environment.subscribe === 'function';
}
module.exports = $36978cb6d1f0cc8c$var$isRelayEnvironment;

});



parcelRegister("ywgWz", function(module, exports) {
'use strict';

var $iwDoV = parcelRequire("iwDoV");

var $1AnXR = parcelRequire("1AnXR");

var $jT3aJ = parcelRequire("jT3aJ");

var $eJOHy = parcelRequire("eJOHy");

var $37Ewn = parcelRequire("37Ewn");
var $067c35b19af3410d$var$createOperationDescriptor = $37Ewn.createOperationDescriptor, $067c35b19af3410d$var$deepFreeze = $37Ewn.deepFreeze, $067c35b19af3410d$var$getRequest = $37Ewn.getRequest;
var $067c35b19af3410d$var$useLayoutEffect = $eJOHy.useLayoutEffect, $067c35b19af3410d$var$useState = $eJOHy.useState, $067c35b19af3410d$var$useRef = $eJOHy.useRef, $067c35b19af3410d$var$useMemo = $eJOHy.useMemo;
var $067c35b19af3410d$var$queryRendererContext = {
    rootIsQueryRenderer: true
};
function $067c35b19af3410d$var$useDeepCompare(value) {
    var latestValue = $eJOHy.useRef(value);
    if (!$jT3aJ(latestValue.current, value)) latestValue.current = value;
    return latestValue.current;
}
function $067c35b19af3410d$var$ReactRelayLocalQueryRenderer(props) {
    var environment = props.environment, query = props.query, variables = props.variables, render = props.render;
    var latestVariables = $067c35b19af3410d$var$useDeepCompare(variables);
    var operation = $067c35b19af3410d$var$useMemo(function() {
        var request = $067c35b19af3410d$var$getRequest(query);
        return $067c35b19af3410d$var$createOperationDescriptor(request, latestVariables);
    }, [
        query,
        latestVariables
    ]);
    var relayContext = $067c35b19af3410d$var$useMemo(function() {
        return {
            environment: environment
        };
    }, [
        environment
    ]);
    var dataRef = $067c35b19af3410d$var$useRef(null);
    var _useState = $067c35b19af3410d$var$useState(null), forceUpdate = _useState[1];
    var cleanupFnRef = $067c35b19af3410d$var$useRef(null);
    var snapshot = $067c35b19af3410d$var$useMemo(function() {
        environment.check(operation);
        var res = environment.lookup(operation.fragment);
        dataRef.current = res.data;
        var retainDisposable = environment.retain(operation);
        var subscribeDisposable = environment.subscribe(res, function(newSnapshot) {
            dataRef.current = newSnapshot.data;
            forceUpdate(dataRef.current);
        });
        var disposed = false;
        function nextCleanupFn() {
            if (!disposed) {
                disposed = true;
                cleanupFnRef.current = null;
                retainDisposable.dispose();
                subscribeDisposable.dispose();
            }
        }
        if (cleanupFnRef.current) cleanupFnRef.current();
        cleanupFnRef.current = nextCleanupFn;
        return res;
    }, [
        environment,
        operation
    ]);
    $067c35b19af3410d$var$useLayoutEffect(function() {
        var cleanupFn = cleanupFnRef.current;
        return function() {
            cleanupFn && cleanupFn();
        };
    }, [
        snapshot
    ]);
    return /*#__PURE__*/ $eJOHy.createElement($iwDoV.Provider, {
        value: relayContext
    }, /*#__PURE__*/ $eJOHy.createElement($1AnXR.Provider, {
        value: $067c35b19af3410d$var$queryRendererContext
    }, render({
        props: dataRef.current
    })));
}
module.exports = $067c35b19af3410d$var$ReactRelayLocalQueryRenderer;

});

parcelRegister("PiSbo", function(module, exports) {
'use strict';

var $7Wmh0 = parcelRequire("7Wmh0");
var $09a3674d70f945e9$var$_interopRequireDefault = $7Wmh0.default;

var $09a3674d70f945e9$var$_extends2 = $09a3674d70f945e9$var$_interopRequireDefault((parcelRequire("6bgQp")));

var $09a3674d70f945e9$var$_objectWithoutPropertiesLoose2 = $09a3674d70f945e9$var$_interopRequireDefault((parcelRequire("h8lLa")));

var $09a3674d70f945e9$var$_assertThisInitialized2 = $09a3674d70f945e9$var$_interopRequireDefault((parcelRequire("7GwkG")));

var $09a3674d70f945e9$var$_inheritsLoose2 = $09a3674d70f945e9$var$_interopRequireDefault((parcelRequire("2iule")));

var $09a3674d70f945e9$var$_defineProperty2 = $09a3674d70f945e9$var$_interopRequireDefault((parcelRequire("ky4V8")));

var $09a3674d70f945e9$var$_objectSpread3 = $09a3674d70f945e9$var$_interopRequireDefault((parcelRequire("1sB2t")));
var $09a3674d70f945e9$var$_excluded = [
    "componentRef"
], $09a3674d70f945e9$var$_excluded2 = [
    "componentRef",
    "__relayContext",
    "__rootIsQueryRenderer"
], $09a3674d70f945e9$var$_excluded3 = [
    "componentRef",
    "__relayContext",
    "__rootIsQueryRenderer"
];

var $ewnEa = parcelRequire("ewnEa");

var $jr3rR = parcelRequire("jr3rR");

var $4fb0r = parcelRequire("4fb0r");
var $09a3674d70f945e9$var$getComponentName = $4fb0r.getComponentName, $09a3674d70f945e9$var$getContainerName = $4fb0r.getContainerName;

var $iwDoV = parcelRequire("iwDoV");

var $fMCgV = parcelRequire("fMCgV");

var $hVPOR = parcelRequire("hVPOR");
var $09a3674d70f945e9$var$assertRelayContext = $hVPOR.assertRelayContext;

var $jT3aJ = parcelRequire("jT3aJ");

var $423Vm = parcelRequire("423Vm");

var $eJOHy = parcelRequire("eJOHy");

var $37Ewn = parcelRequire("37Ewn");
var $09a3674d70f945e9$var$ConnectionInterface = $37Ewn.ConnectionInterface, $09a3674d70f945e9$var$Observable = $37Ewn.Observable, $09a3674d70f945e9$var$RelayFeatureFlags = $37Ewn.RelayFeatureFlags, $09a3674d70f945e9$var$createFragmentSpecResolver = $37Ewn.createFragmentSpecResolver, $09a3674d70f945e9$var$createOperationDescriptor = $37Ewn.createOperationDescriptor, $09a3674d70f945e9$var$getDataIDsFromObject = $37Ewn.getDataIDsFromObject, $09a3674d70f945e9$var$getRequest = $37Ewn.getRequest, $09a3674d70f945e9$var$getVariablesFromObject = $37Ewn.getVariablesFromObject, $09a3674d70f945e9$var$isScalarAndEqual = $37Ewn.isScalarAndEqual;
parcelRequire("dH6ue");
var $09a3674d70f945e9$var$FORWARD = 'forward';
function $09a3674d70f945e9$var$createGetConnectionFromProps(metadata) {
    var path = metadata.path;
    !path && $423Vm(false);
    return function(props) {
        var data = props[metadata.fragmentName];
        for(var i = 0; i < path.length; i++){
            if (!data || typeof data !== 'object') return null;
            data = data[path[i]];
        }
        return data;
    };
}
function $09a3674d70f945e9$var$createGetFragmentVariables(metadata) {
    var countVariable = metadata.count;
    !countVariable && $423Vm(false);
    return function(prevVars, totalCount) {
        return (0, $09a3674d70f945e9$var$_objectSpread3["default"])((0, $09a3674d70f945e9$var$_objectSpread3["default"])({}, prevVars), {}, (0, $09a3674d70f945e9$var$_defineProperty2["default"])({}, countVariable, totalCount));
    };
}
function $09a3674d70f945e9$var$findConnectionMetadata(fragments) {
    var foundConnectionMetadata = null;
    var isRelayModern = false;
    for(var fragmentName in fragments){
        var fragment = fragments[fragmentName];
        var connectionMetadata = fragment.metadata && fragment.metadata.connection;
        if (fragment.metadata !== undefined) isRelayModern = true;
        if (connectionMetadata) {
            !(connectionMetadata.length === 1) && $423Vm(false);
            !!foundConnectionMetadata && $423Vm(false);
            foundConnectionMetadata = (0, $09a3674d70f945e9$var$_objectSpread3["default"])((0, $09a3674d70f945e9$var$_objectSpread3["default"])({}, connectionMetadata[0]), {}, {
                fragmentName: fragmentName
            });
        }
    }
    !(!isRelayModern || foundConnectionMetadata !== null) && $423Vm(false);
    return foundConnectionMetadata || {};
}
function $09a3674d70f945e9$var$toObserver(observerOrCallback) {
    return typeof observerOrCallback === 'function' ? {
        error: observerOrCallback,
        complete: observerOrCallback,
        unsubscribe: function unsubscribe(subscription) {
            typeof observerOrCallback === 'function' && observerOrCallback();
        }
    } : observerOrCallback || {};
}
function $09a3674d70f945e9$var$createContainerWithFragments(Component, fragments, connectionConfig) {
    var _class;
    var componentName = $09a3674d70f945e9$var$getComponentName(Component);
    var containerName = $09a3674d70f945e9$var$getContainerName(Component);
    var metadata = $09a3674d70f945e9$var$findConnectionMetadata(fragments);
    var getConnectionFromProps = connectionConfig.getConnectionFromProps || $09a3674d70f945e9$var$createGetConnectionFromProps(metadata);
    var direction = connectionConfig.direction || metadata.direction;
    !direction && $423Vm(false);
    var getFragmentVariables = connectionConfig.getFragmentVariables || $09a3674d70f945e9$var$createGetFragmentVariables(metadata);
    return _class = /*#__PURE__*/ function(_React$Component) {
        (0, $09a3674d70f945e9$var$_inheritsLoose2["default"])(_class, _React$Component);
        function _class(props) {
            var _props$__rootIsQueryR, _this;
            _this = _React$Component.call(this, props) || this;
            (0, $09a3674d70f945e9$var$_defineProperty2["default"])((0, $09a3674d70f945e9$var$_assertThisInitialized2["default"])(_this), "_handleFragmentDataUpdate", function() {
                _this.setState({
                    data: _this._resolver.resolve()
                });
            });
            (0, $09a3674d70f945e9$var$_defineProperty2["default"])((0, $09a3674d70f945e9$var$_assertThisInitialized2["default"])(_this), "_hasMore", function() {
                var connectionData = _this._getConnectionData();
                return !!(connectionData && connectionData.hasMore && connectionData.cursor);
            });
            (0, $09a3674d70f945e9$var$_defineProperty2["default"])((0, $09a3674d70f945e9$var$_assertThisInitialized2["default"])(_this), "_isLoading", function() {
                return !!_this._refetchSubscription;
            });
            (0, $09a3674d70f945e9$var$_defineProperty2["default"])((0, $09a3674d70f945e9$var$_assertThisInitialized2["default"])(_this), "_refetchConnection", function(totalCount, observerOrCallback, refetchVariables) {
                if (!_this._canFetchPage('refetchConnection')) return {
                    dispose: function dispose() {}
                };
                _this._refetchVariables = refetchVariables;
                var paginatingVariables = {
                    count: totalCount,
                    cursor: null,
                    totalCount: totalCount
                };
                var fetch = _this._fetchPage(paginatingVariables, $09a3674d70f945e9$var$toObserver(observerOrCallback), {
                    force: true
                });
                return {
                    dispose: fetch.unsubscribe
                };
            });
            (0, $09a3674d70f945e9$var$_defineProperty2["default"])((0, $09a3674d70f945e9$var$_assertThisInitialized2["default"])(_this), "_loadMore", function(pageSize, observerOrCallback, options) {
                if (!_this._canFetchPage('loadMore')) return {
                    dispose: function dispose() {}
                };
                var observer = $09a3674d70f945e9$var$toObserver(observerOrCallback);
                var connectionData = _this._getConnectionData();
                if (!connectionData) {
                    $09a3674d70f945e9$var$Observable.create(function(sink) {
                        return sink.complete();
                    }).subscribe(observer);
                    return null;
                }
                var totalCount = connectionData.edgeCount + pageSize;
                if (options && options.force) return _this._refetchConnection(totalCount, observerOrCallback);
                var _ConnectionInterface$ = $09a3674d70f945e9$var$ConnectionInterface.get(), END_CURSOR = _ConnectionInterface$.END_CURSOR, START_CURSOR = _ConnectionInterface$.START_CURSOR;
                var cursor = connectionData.cursor;
                var paginatingVariables = {
                    count: pageSize,
                    cursor: cursor,
                    totalCount: totalCount
                };
                var fetch = _this._fetchPage(paginatingVariables, observer, options);
                return {
                    dispose: fetch.unsubscribe
                };
            });
            var relayContext = $09a3674d70f945e9$var$assertRelayContext(props.__relayContext);
            var rootIsQueryRenderer = (_props$__rootIsQueryR = props.__rootIsQueryRenderer) !== null && _props$__rootIsQueryR !== void 0 ? _props$__rootIsQueryR : false;
            _this._isARequestInFlight = false;
            _this._refetchSubscription = null;
            _this._refetchVariables = null;
            if ($09a3674d70f945e9$var$RelayFeatureFlags.ENABLE_CONTAINERS_SUBSCRIBE_ON_COMMIT === true) _this._resolver = $09a3674d70f945e9$var$createFragmentSpecResolver(relayContext, containerName, fragments, props, rootIsQueryRenderer);
            else _this._resolver = $09a3674d70f945e9$var$createFragmentSpecResolver(relayContext, containerName, fragments, props, rootIsQueryRenderer, _this._handleFragmentDataUpdate);
            _this.state = {
                data: _this._resolver.resolve(),
                prevContext: relayContext,
                contextForChildren: relayContext,
                relayProp: _this._buildRelayProp(relayContext),
                resolverGeneration: 0
            };
            _this._isUnmounted = false;
            _this._hasFetched = false;
            return _this;
        }
        var _proto = _class.prototype;
        _proto.componentDidMount = function componentDidMount() {
            this._isUnmounted = false;
            if ($09a3674d70f945e9$var$RelayFeatureFlags.ENABLE_CONTAINERS_SUBSCRIBE_ON_COMMIT === true) this._subscribeToNewResolverAndRerenderIfStoreHasChanged();
        };
        _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
            if ($09a3674d70f945e9$var$RelayFeatureFlags.ENABLE_CONTAINERS_SUBSCRIBE_ON_COMMIT === true) {
                if (prevState.resolverGeneration !== this.state.resolverGeneration) this._subscribeToNewResolverAndRerenderIfStoreHasChanged();
                else this._rerenderIfStoreHasChanged();
            }
        };
        _proto.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps(nextProps) {
            var _this2 = this;
            var _nextProps$__rootIsQu;
            var relayContext = $09a3674d70f945e9$var$assertRelayContext(nextProps.__relayContext);
            var rootIsQueryRenderer = (_nextProps$__rootIsQu = nextProps.__rootIsQueryRenderer) !== null && _nextProps$__rootIsQu !== void 0 ? _nextProps$__rootIsQu : false;
            var prevIDs = $09a3674d70f945e9$var$getDataIDsFromObject(fragments, this.props);
            var nextIDs = $09a3674d70f945e9$var$getDataIDsFromObject(fragments, nextProps);
            var prevRootVariables = $jr3rR(fragments, this.props);
            var nextRootVariables = $jr3rR(fragments, nextProps);
            if (relayContext.environment !== this.state.prevContext.environment || !$jT3aJ(prevRootVariables, nextRootVariables) || !$jT3aJ(prevIDs, nextIDs)) {
                this._cleanup();
                if ($09a3674d70f945e9$var$RelayFeatureFlags.ENABLE_CONTAINERS_SUBSCRIBE_ON_COMMIT === true) this._resolver = $09a3674d70f945e9$var$createFragmentSpecResolver(relayContext, containerName, fragments, nextProps, rootIsQueryRenderer);
                else this._resolver = $09a3674d70f945e9$var$createFragmentSpecResolver(relayContext, containerName, fragments, nextProps, rootIsQueryRenderer, this._handleFragmentDataUpdate);
                this.setState(function(prevState) {
                    return {
                        prevContext: relayContext,
                        contextForChildren: relayContext,
                        relayProp: _this2._buildRelayProp(relayContext),
                        resolverGeneration: prevState.resolverGeneration + 1
                    };
                });
            } else if (!this._hasFetched) this._resolver.setProps(nextProps);
            var data = this._resolver.resolve();
            if (data !== this.state.data) this.setState({
                data: data
            });
        };
        _proto.componentWillUnmount = function componentWillUnmount() {
            this._isUnmounted = true;
            this._cleanup();
        };
        _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
            if (nextState.data !== this.state.data || nextState.relayProp !== this.state.relayProp || nextState.resolverGeneration !== this.state.resolverGeneration) return true;
            var keys = Object.keys(nextProps);
            for(var ii = 0; ii < keys.length; ii++){
                var key = keys[ii];
                if (key === '__relayContext') {
                    if (nextState.prevContext.environment !== this.state.prevContext.environment) return true;
                } else {
                    if (!fragments.hasOwnProperty(key) && !$09a3674d70f945e9$var$isScalarAndEqual(nextProps[key], this.props[key])) return true;
                }
            }
            return false;
        };
        _proto._buildRelayProp = function _buildRelayProp(relayContext) {
            return {
                hasMore: this._hasMore,
                isLoading: this._isLoading,
                loadMore: this._loadMore,
                refetchConnection: this._refetchConnection,
                environment: relayContext.environment
            };
        };
        _proto._rerenderIfStoreHasChanged = function _rerenderIfStoreHasChanged() {
            var data = this.state.data;
            var maybeNewData = this._resolver.resolve();
            if (data !== maybeNewData) this.setState({
                data: maybeNewData
            });
        };
        _proto._subscribeToNewResolverAndRerenderIfStoreHasChanged = function _subscribeToNewResolverAndRerenderIfStoreHasChanged() {
            var data = this.state.data;
            var maybeNewData = this._resolver.resolve();
            this._resolver.setCallback(this.props, this._handleFragmentDataUpdate);
            if (data !== maybeNewData) this.setState({
                data: maybeNewData
            });
        };
        _proto._getConnectionData = function _getConnectionData() {
            var _this$props = this.props, _ = _this$props.componentRef, restProps = (0, $09a3674d70f945e9$var$_objectWithoutPropertiesLoose2["default"])(_this$props, $09a3674d70f945e9$var$_excluded);
            var props = (0, $09a3674d70f945e9$var$_objectSpread3["default"])((0, $09a3674d70f945e9$var$_objectSpread3["default"])({}, restProps), this.state.data);
            var connectionData = getConnectionFromProps(props);
            if (connectionData == null) return null;
            var _ConnectionInterface$2 = $09a3674d70f945e9$var$ConnectionInterface.get(), EDGES = _ConnectionInterface$2.EDGES, PAGE_INFO = _ConnectionInterface$2.PAGE_INFO, HAS_NEXT_PAGE = _ConnectionInterface$2.HAS_NEXT_PAGE, HAS_PREV_PAGE = _ConnectionInterface$2.HAS_PREV_PAGE, END_CURSOR = _ConnectionInterface$2.END_CURSOR, START_CURSOR = _ConnectionInterface$2.START_CURSOR;
            !(typeof connectionData === 'object') && $423Vm(false);
            var edges = connectionData[EDGES];
            var pageInfo = connectionData[PAGE_INFO];
            if (edges == null || pageInfo == null) return null;
            !Array.isArray(edges) && $423Vm(false);
            !(typeof pageInfo === 'object') && $423Vm(false);
            var hasMore = direction === $09a3674d70f945e9$var$FORWARD ? pageInfo[HAS_NEXT_PAGE] : pageInfo[HAS_PREV_PAGE];
            var cursor = direction === $09a3674d70f945e9$var$FORWARD ? pageInfo[END_CURSOR] : pageInfo[START_CURSOR];
            if (typeof hasMore !== 'boolean' || edges.length !== 0 && typeof cursor === 'undefined') return null;
            return {
                cursor: cursor,
                edgeCount: edges.length,
                hasMore: hasMore
            };
        };
        _proto._getQueryFetcher = function _getQueryFetcher() {
            if (!this._queryFetcher) this._queryFetcher = new $fMCgV();
            return this._queryFetcher;
        };
        _proto._canFetchPage = function _canFetchPage(method) {
            if (this._isUnmounted) return false;
            return true;
        };
        _proto._fetchPage = function _fetchPage(paginatingVariables, observer, options) {
            var _this3 = this;
            var _assertRelayContext = $09a3674d70f945e9$var$assertRelayContext(this.props.__relayContext), environment = _assertRelayContext.environment;
            var _this$props2 = this.props, _ = _this$props2.componentRef, __relayContext = _this$props2.__relayContext, __rootIsQueryRenderer = _this$props2.__rootIsQueryRenderer, restProps = (0, $09a3674d70f945e9$var$_objectWithoutPropertiesLoose2["default"])(_this$props2, $09a3674d70f945e9$var$_excluded2);
            var props = (0, $09a3674d70f945e9$var$_objectSpread3["default"])((0, $09a3674d70f945e9$var$_objectSpread3["default"])({}, restProps), this.state.data);
            var fragmentVariables;
            var rootVariables = $jr3rR(fragments, restProps);
            fragmentVariables = $09a3674d70f945e9$var$getVariablesFromObject(fragments, restProps);
            fragmentVariables = (0, $09a3674d70f945e9$var$_objectSpread3["default"])((0, $09a3674d70f945e9$var$_objectSpread3["default"])((0, $09a3674d70f945e9$var$_objectSpread3["default"])({}, rootVariables), fragmentVariables), this._refetchVariables);
            var fetchVariables = connectionConfig.getVariables(props, {
                count: paginatingVariables.count,
                cursor: paginatingVariables.cursor
            }, fragmentVariables);
            !(typeof fetchVariables === 'object' && fetchVariables !== null) && $423Vm(false);
            fetchVariables = (0, $09a3674d70f945e9$var$_objectSpread3["default"])((0, $09a3674d70f945e9$var$_objectSpread3["default"])({}, fetchVariables), this._refetchVariables);
            fragmentVariables = (0, $09a3674d70f945e9$var$_objectSpread3["default"])((0, $09a3674d70f945e9$var$_objectSpread3["default"])({}, fetchVariables), fragmentVariables);
            var cacheConfig = options ? {
                force: !!options.force
            } : undefined;
            if (cacheConfig != null && (options === null || options === void 0 ? void 0 : options.metadata) != null) cacheConfig.metadata = options === null || options === void 0 ? void 0 : options.metadata;
            var request = $09a3674d70f945e9$var$getRequest(connectionConfig.query);
            var operation = $09a3674d70f945e9$var$createOperationDescriptor(request, fetchVariables, cacheConfig);
            var refetchSubscription = null;
            if (this._refetchSubscription) this._refetchSubscription.unsubscribe();
            this._hasFetched = true;
            var onNext = function onNext(payload, complete) {
                var prevData = _this3._resolver.resolve();
                _this3._resolver.setVariables(getFragmentVariables(fragmentVariables, paginatingVariables.totalCount), operation.request.node);
                var nextData = _this3._resolver.resolve();
                if (!$jT3aJ(prevData, nextData)) _this3.setState({
                    data: nextData,
                    contextForChildren: {
                        environment: _this3.props.__relayContext.environment
                    }
                }, complete);
                else complete();
            };
            var cleanup = function cleanup() {
                if (_this3._refetchSubscription === refetchSubscription) {
                    _this3._refetchSubscription = null;
                    _this3._isARequestInFlight = false;
                }
            };
            this._isARequestInFlight = true;
            refetchSubscription = this._getQueryFetcher().execute({
                environment: environment,
                operation: operation,
                preservePreviousReferences: true
            }).mergeMap(function(payload) {
                return $09a3674d70f945e9$var$Observable.create(function(sink) {
                    onNext(payload, function() {
                        sink.next();
                        sink.complete();
                    });
                });
            })["do"]({
                error: cleanup,
                complete: cleanup,
                unsubscribe: cleanup
            }).subscribe(observer || {});
            this._refetchSubscription = this._isARequestInFlight ? refetchSubscription : null;
            return refetchSubscription;
        };
        _proto._cleanup = function _cleanup() {
            this._resolver.dispose();
            this._refetchVariables = null;
            this._hasFetched = false;
            if (this._refetchSubscription) {
                this._refetchSubscription.unsubscribe();
                this._refetchSubscription = null;
                this._isARequestInFlight = false;
            }
            if (this._queryFetcher) this._queryFetcher.dispose();
        };
        _proto.render = function render() {
            var _this$props3 = this.props, componentRef = _this$props3.componentRef, __relayContext = _this$props3.__relayContext, __rootIsQueryRenderer = _this$props3.__rootIsQueryRenderer, props = (0, $09a3674d70f945e9$var$_objectWithoutPropertiesLoose2["default"])(_this$props3, $09a3674d70f945e9$var$_excluded3);
            return /*#__PURE__*/ $eJOHy.createElement($iwDoV.Provider, {
                value: this.state.contextForChildren
            }, /*#__PURE__*/ $eJOHy.createElement(Component, (0, $09a3674d70f945e9$var$_extends2["default"])({}, props, this.state.data, {
                ref: componentRef,
                relay: this.state.relayProp
            })));
        };
        return _class;
    }($eJOHy.Component), (0, $09a3674d70f945e9$var$_defineProperty2["default"])(_class, "displayName", containerName), _class;
}
function $09a3674d70f945e9$var$createContainer(Component, fragmentSpec, connectionConfig) {
    return $ewnEa(Component, fragmentSpec, function(ComponentClass, fragments) {
        return $09a3674d70f945e9$var$createContainerWithFragments(ComponentClass, fragments, connectionConfig);
    });
}
module.exports = {
    createContainer: $09a3674d70f945e9$var$createContainer
};

});
parcelRegister("jr3rR", function(module, exports) {
'use strict';

var $7Wmh0 = parcelRequire("7Wmh0");
var $e26336b8e929a986$var$_interopRequireDefault = $7Wmh0.default;

var $e26336b8e929a986$var$_objectSpread2 = $e26336b8e929a986$var$_interopRequireDefault((parcelRequire("1sB2t")));

var $37Ewn = parcelRequire("37Ewn");
var $e26336b8e929a986$var$getSelector = $37Ewn.getSelector;
function $e26336b8e929a986$var$getRootVariablesForFragments(fragments, props) {
    var rootVariables = {};
    Object.keys(fragments).forEach(function(key) {
        var _selector$selectors$, _selector$selectors$2, _selector$owner$varia;
        var fragmentNode = fragments[key];
        var fragmentRef = props[key];
        var selector = $e26336b8e929a986$var$getSelector(fragmentNode, fragmentRef);
        var fragmentOwnerVariables = selector != null && selector.kind === 'PluralReaderSelector' ? (_selector$selectors$ = (_selector$selectors$2 = selector.selectors[0]) === null || _selector$selectors$2 === void 0 ? void 0 : _selector$selectors$2.owner.variables) !== null && _selector$selectors$ !== void 0 ? _selector$selectors$ : {} : (_selector$owner$varia = selector === null || selector === void 0 ? void 0 : selector.owner.variables) !== null && _selector$owner$varia !== void 0 ? _selector$owner$varia : {};
        rootVariables = (0, $e26336b8e929a986$var$_objectSpread2["default"])((0, $e26336b8e929a986$var$_objectSpread2["default"])({}, rootVariables), fragmentOwnerVariables);
    });
    return rootVariables;
}
module.exports = $e26336b8e929a986$var$getRootVariablesForFragments;

});

parcelRegister("fMCgV", function(module, exports) {
'use strict';

var $7Wmh0 = parcelRequire("7Wmh0");
var $b7d906b42d060be1$var$_interopRequireDefault = $7Wmh0.default;

var $b7d906b42d060be1$var$_defineProperty2 = $b7d906b42d060be1$var$_interopRequireDefault((parcelRequire("ky4V8")));

var $423Vm = parcelRequire("423Vm");

var $37Ewn = parcelRequire("37Ewn");
var $b7d906b42d060be1$var$fetchQuery = $37Ewn.__internal.fetchQuery, $b7d906b42d060be1$var$createOperationDescriptor = $37Ewn.createOperationDescriptor, $b7d906b42d060be1$var$isRelayModernEnvironment = $37Ewn.isRelayModernEnvironment;
var $b7d906b42d060be1$var$ReactRelayQueryFetcher = /*#__PURE__*/ function() {
    function ReactRelayQueryFetcher(args) {
        (0, $b7d906b42d060be1$var$_defineProperty2["default"])(this, "_selectionReferences", []);
        (0, $b7d906b42d060be1$var$_defineProperty2["default"])(this, "_didFetchFinish", false);
        if (args != null) {
            this._cacheSelectionReference = args.cacheSelectionReference;
            this._selectionReferences = args.selectionReferences;
        }
    }
    var _proto = ReactRelayQueryFetcher.prototype;
    _proto.getSelectionReferences = function getSelectionReferences() {
        return {
            cacheSelectionReference: this._cacheSelectionReference,
            selectionReferences: this._selectionReferences
        };
    };
    _proto.lookupInStore = function lookupInStore(environment, operation, fetchPolicy) {
        if (fetchPolicy === 'store-and-network' || fetchPolicy === 'store-or-network') {
            if (environment.check(operation).status === 'available') {
                this._retainCachedOperation(environment, operation);
                return environment.lookup(operation.fragment);
            }
        }
        return null;
    };
    _proto.getFetchResult = function getFetchResult() {
        if (this._didFetchFinish) {
            if (this._error != null) return {
                error: this._error
            };
            else if (this._snapshot != null) return {
                snapshot: this._snapshot
            };
        } else return null;
    };
    _proto.execute = function execute(_ref) {
        var _this = this;
        var environment = _ref.environment, operation = _ref.operation, _ref$preservePrevious = _ref.preservePreviousReferences, preservePreviousReferences = _ref$preservePrevious === void 0 ? false : _ref$preservePrevious;
        var reference = environment.retain(operation);
        var error = function error() {
            _this._selectionReferences = _this._selectionReferences.concat(reference);
        };
        var complete = function complete() {
            if (!preservePreviousReferences) _this.disposeSelectionReferences();
            _this._selectionReferences = _this._selectionReferences.concat(reference);
        };
        var unsubscribe = function unsubscribe() {
            _this._selectionReferences = _this._selectionReferences.concat(reference);
        };
        if (!$b7d906b42d060be1$var$isRelayModernEnvironment(environment)) return environment.execute({
            operation: operation
        })["do"]({
            error: error,
            complete: complete,
            unsubscribe: unsubscribe
        });
        return $b7d906b42d060be1$var$fetchQuery(environment, operation)["do"]({
            error: error,
            complete: complete,
            unsubscribe: unsubscribe
        });
    };
    _proto.setOnDataChange = function setOnDataChange(onDataChange) {
        !this._fetchOptions && $423Vm(false);
        if (typeof onDataChange === 'function') {
            this._fetchOptions.onDataChangeCallbacks = this._fetchOptions.onDataChangeCallbacks || [];
            this._fetchOptions.onDataChangeCallbacks.push(onDataChange);
            if (this._didFetchFinish) {
                if (this._error != null) onDataChange({
                    error: this._error
                });
                else if (this._snapshot != null) onDataChange({
                    snapshot: this._snapshot
                });
            }
        }
    };
    _proto.fetch = function fetch(fetchOptions, cacheConfigOverride) {
        var _this2 = this;
        var environment = fetchOptions.environment, operation = fetchOptions.operation, onDataChange = fetchOptions.onDataChange;
        var fetchHasReturned = false;
        var _error;
        this.disposeRequest();
        var oldOnDataChangeCallbacks = this._fetchOptions && this._fetchOptions.onDataChangeCallbacks;
        this._fetchOptions = {
            environment: environment,
            onDataChangeCallbacks: oldOnDataChangeCallbacks || [],
            operation: operation
        };
        if (onDataChange && this._fetchOptions.onDataChangeCallbacks.indexOf(onDataChange) === -1) this._fetchOptions.onDataChangeCallbacks.push(onDataChange);
        var operationOverride = cacheConfigOverride ? $b7d906b42d060be1$var$createOperationDescriptor(operation.request.node, operation.request.variables, cacheConfigOverride) : operation;
        var request = this.execute({
            environment: environment,
            operation: operationOverride
        })["finally"](function() {
            _this2._pendingRequest = null;
        }).subscribe({
            next: function next() {
                _this2._didFetchFinish = true;
                _this2._error = null;
                _this2._onQueryDataAvailable({
                    notifyFirstResult: fetchHasReturned
                });
            },
            error: function error(err) {
                _this2._didFetchFinish = true;
                _this2._error = err;
                _this2._snapshot = null;
                var onDataChangeCallbacks = _this2._fetchOptions && _this2._fetchOptions.onDataChangeCallbacks;
                if (fetchHasReturned) {
                    if (onDataChangeCallbacks) onDataChangeCallbacks.forEach(function(onDataChange) {
                        onDataChange({
                            error: err
                        });
                    });
                } else _error = err;
            }
        });
        this._pendingRequest = {
            dispose: function dispose() {
                request.unsubscribe();
            }
        };
        fetchHasReturned = true;
        if (_error) throw _error;
        return this._snapshot;
    };
    _proto.retry = function retry(cacheConfigOverride) {
        !this._fetchOptions && $423Vm(false);
        return this.fetch({
            environment: this._fetchOptions.environment,
            operation: this._fetchOptions.operation,
            onDataChange: null
        }, cacheConfigOverride);
    };
    _proto.dispose = function dispose() {
        this.disposeRequest();
        this.disposeSelectionReferences();
    };
    _proto.disposeRequest = function disposeRequest() {
        this._error = null;
        this._snapshot = null;
        if (this._pendingRequest) this._pendingRequest.dispose();
        if (this._rootSubscription) {
            this._rootSubscription.dispose();
            this._rootSubscription = null;
        }
    };
    _proto._retainCachedOperation = function _retainCachedOperation(environment, operation) {
        this._disposeCacheSelectionReference();
        this._cacheSelectionReference = environment.retain(operation);
    };
    _proto._disposeCacheSelectionReference = function _disposeCacheSelectionReference() {
        this._cacheSelectionReference && this._cacheSelectionReference.dispose();
        this._cacheSelectionReference = null;
    };
    _proto.disposeSelectionReferences = function disposeSelectionReferences() {
        this._disposeCacheSelectionReference();
        this._selectionReferences.forEach(function(r) {
            return r.dispose();
        });
        this._selectionReferences = [];
    };
    _proto._onQueryDataAvailable = function _onQueryDataAvailable(_ref2) {
        var _this3 = this;
        var notifyFirstResult = _ref2.notifyFirstResult;
        !this._fetchOptions && $423Vm(false);
        var _this$_fetchOptions = this._fetchOptions, environment = _this$_fetchOptions.environment, onDataChangeCallbacks = _this$_fetchOptions.onDataChangeCallbacks, operation = _this$_fetchOptions.operation;
        if (this._snapshot) return;
        this._snapshot = environment.lookup(operation.fragment);
        this._rootSubscription = environment.subscribe(this._snapshot, function(snapshot) {
            if (_this3._fetchOptions != null) {
                var maybeNewOnDataChangeCallbacks = _this3._fetchOptions.onDataChangeCallbacks;
                if (Array.isArray(maybeNewOnDataChangeCallbacks)) maybeNewOnDataChangeCallbacks.forEach(function(onDataChange) {
                    return onDataChange({
                        snapshot: snapshot
                    });
                });
            }
        });
        if (this._snapshot && notifyFirstResult && Array.isArray(onDataChangeCallbacks)) {
            var snapshot = this._snapshot;
            onDataChangeCallbacks.forEach(function(onDataChange) {
                return onDataChange({
                    snapshot: snapshot
                });
            });
        }
    };
    return ReactRelayQueryFetcher;
}();
module.exports = $b7d906b42d060be1$var$ReactRelayQueryFetcher;

});


parcelRegister("9YzzC", function(module, exports) {
'use strict';

var $7Wmh0 = parcelRequire("7Wmh0");
var $74354fcadaea219a$var$_interopRequireDefault = $7Wmh0.default;

var $74354fcadaea219a$var$_objectSpread2 = $74354fcadaea219a$var$_interopRequireDefault((parcelRequire("1sB2t")));

var $74354fcadaea219a$var$_assertThisInitialized2 = $74354fcadaea219a$var$_interopRequireDefault((parcelRequire("7GwkG")));

var $74354fcadaea219a$var$_inheritsLoose2 = $74354fcadaea219a$var$_interopRequireDefault((parcelRequire("2iule")));

var $74354fcadaea219a$var$_defineProperty2 = $74354fcadaea219a$var$_interopRequireDefault((parcelRequire("ky4V8")));

var $iwDoV = parcelRequire("iwDoV");

var $fMCgV = parcelRequire("fMCgV");

var $1AnXR = parcelRequire("1AnXR");

var $jT3aJ = parcelRequire("jT3aJ");

var $eJOHy = parcelRequire("eJOHy");

var $37Ewn = parcelRequire("37Ewn");
var $74354fcadaea219a$var$createOperationDescriptor = $37Ewn.createOperationDescriptor, $74354fcadaea219a$var$deepFreeze = $37Ewn.deepFreeze, $74354fcadaea219a$var$getRequest = $37Ewn.getRequest;
var $74354fcadaea219a$var$requestCache = {};
var $74354fcadaea219a$var$queryRendererContext = {
    rootIsQueryRenderer: true
};
var $74354fcadaea219a$var$ReactRelayQueryRenderer = /*#__PURE__*/ function(_React$Component) {
    (0, $74354fcadaea219a$var$_inheritsLoose2["default"])(ReactRelayQueryRenderer, _React$Component);
    function ReactRelayQueryRenderer(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        (0, $74354fcadaea219a$var$_defineProperty2["default"])((0, $74354fcadaea219a$var$_assertThisInitialized2["default"])(_this), "_handleDataChange", function(params) {
            var error = params.error == null ? null : params.error;
            var snapshot = params.snapshot == null ? null : params.snapshot;
            _this.setState(function(prevState) {
                var prevRequestCacheKey = prevState.requestCacheKey;
                if (prevRequestCacheKey) delete $74354fcadaea219a$var$requestCache[prevRequestCacheKey];
                if (snapshot === prevState.snapshot && error === prevState.error) return null;
                return {
                    renderProps: $74354fcadaea219a$var$getRenderProps(error, snapshot, prevState.queryFetcher, prevState.retryCallbacks),
                    snapshot: snapshot,
                    requestCacheKey: null
                };
            });
        });
        var retryCallbacks = {
            handleDataChange: null,
            handleRetryAfterError: null
        };
        var queryFetcher;
        var requestCacheKey;
        if (props.query) {
            var query = props.query;
            var request = $74354fcadaea219a$var$getRequest(query);
            requestCacheKey = $74354fcadaea219a$var$getRequestCacheKey(request.params, props.variables);
            queryFetcher = $74354fcadaea219a$var$requestCache[requestCacheKey] ? $74354fcadaea219a$var$requestCache[requestCacheKey].queryFetcher : new $fMCgV();
        } else queryFetcher = new $fMCgV();
        _this._maybeHiddenOrFastRefresh = false;
        _this.state = (0, $74354fcadaea219a$var$_objectSpread2["default"])({
            prevPropsEnvironment: props.environment,
            prevPropsVariables: props.variables,
            prevQuery: props.query,
            queryFetcher: queryFetcher,
            retryCallbacks: retryCallbacks
        }, $74354fcadaea219a$var$fetchQueryAndComputeStateFromProps(props, queryFetcher, retryCallbacks, requestCacheKey));
        return _this;
    }
    ReactRelayQueryRenderer.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
        if (prevState.prevQuery !== nextProps.query || prevState.prevPropsEnvironment !== nextProps.environment || !$jT3aJ(prevState.prevPropsVariables, nextProps.variables)) return $74354fcadaea219a$var$resetQueryStateForUpdate(nextProps, prevState);
        return null;
    };
    var _proto = ReactRelayQueryRenderer.prototype;
    _proto.componentDidMount = function componentDidMount() {
        var _this2 = this;
        if (this._maybeHiddenOrFastRefresh === true) {
            this._maybeHiddenOrFastRefresh = false;
            this.setState(function(prevState) {
                var newState = $74354fcadaea219a$var$resetQueryStateForUpdate(_this2.props, prevState);
                var requestCacheKey = newState.requestCacheKey, queryFetcher = newState.queryFetcher;
                if (requestCacheKey != null && $74354fcadaea219a$var$requestCache[requestCacheKey] != null) queryFetcher.setOnDataChange(_this2._handleDataChange);
                return newState;
            });
            return;
        }
        var _this$state = this.state, retryCallbacks = _this$state.retryCallbacks, queryFetcher = _this$state.queryFetcher, requestCacheKey = _this$state.requestCacheKey;
        if (requestCacheKey) delete $74354fcadaea219a$var$requestCache[requestCacheKey];
        retryCallbacks.handleDataChange = this._handleDataChange;
        retryCallbacks.handleRetryAfterError = function(error) {
            return _this2.setState(function(prevState) {
                var prevRequestCacheKey = prevState.requestCacheKey;
                if (prevRequestCacheKey) delete $74354fcadaea219a$var$requestCache[prevRequestCacheKey];
                return {
                    renderProps: $74354fcadaea219a$var$getLoadingRenderProps(),
                    requestCacheKey: null
                };
            });
        };
        if (this.props.query) queryFetcher.setOnDataChange(this._handleDataChange);
    };
    _proto.componentDidUpdate = function componentDidUpdate(_prevProps, prevState) {
        var _this$state2 = this.state, queryFetcher = _this$state2.queryFetcher, requestCacheKey = _this$state2.requestCacheKey;
        if (requestCacheKey) {
            delete $74354fcadaea219a$var$requestCache[requestCacheKey];
            delete this.state.requestCacheKey;
        }
        if (this.props.query && queryFetcher !== prevState.queryFetcher) queryFetcher.setOnDataChange(this._handleDataChange);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.state.queryFetcher.dispose();
        this._maybeHiddenOrFastRefresh = true;
    };
    _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
        return nextProps.render !== this.props.render || nextState.renderProps !== this.state.renderProps;
    };
    _proto.render = function render() {
        var _this$state3 = this.state, renderProps = _this$state3.renderProps, relayContext = _this$state3.relayContext;
        return /*#__PURE__*/ $eJOHy.createElement($iwDoV.Provider, {
            value: relayContext
        }, /*#__PURE__*/ $eJOHy.createElement($1AnXR.Provider, {
            value: $74354fcadaea219a$var$queryRendererContext
        }, this.props.render(renderProps)));
    };
    return ReactRelayQueryRenderer;
}($eJOHy.Component);
function $74354fcadaea219a$var$getLoadingRenderProps() {
    return {
        error: null,
        props: null,
        retry: null
    };
}
function $74354fcadaea219a$var$getEmptyRenderProps() {
    return {
        error: null,
        props: {},
        retry: null
    };
}
function $74354fcadaea219a$var$getRenderProps(error, snapshot, queryFetcher, retryCallbacks) {
    return {
        error: error ? error : null,
        props: snapshot ? snapshot.data : null,
        retry: function retry(cacheConfigOverride) {
            var syncSnapshot = queryFetcher.retry(cacheConfigOverride);
            if (syncSnapshot && typeof retryCallbacks.handleDataChange === 'function') retryCallbacks.handleDataChange({
                snapshot: syncSnapshot
            });
            else if (error && typeof retryCallbacks.handleRetryAfterError === 'function') retryCallbacks.handleRetryAfterError(error);
        }
    };
}
function $74354fcadaea219a$var$getRequestCacheKey(request, variables) {
    return JSON.stringify({
        id: request.cacheID ? request.cacheID : request.id,
        variables: variables
    });
}
function $74354fcadaea219a$var$resetQueryStateForUpdate(props, prevState) {
    var query = props.query;
    var prevSelectionReferences = prevState.queryFetcher.getSelectionReferences();
    prevState.queryFetcher.disposeRequest();
    var queryFetcher;
    if (query) {
        var request = $74354fcadaea219a$var$getRequest(query);
        var requestCacheKey = $74354fcadaea219a$var$getRequestCacheKey(request.params, props.variables);
        queryFetcher = $74354fcadaea219a$var$requestCache[requestCacheKey] ? $74354fcadaea219a$var$requestCache[requestCacheKey].queryFetcher : new $fMCgV(prevSelectionReferences);
    } else queryFetcher = new $fMCgV(prevSelectionReferences);
    return (0, $74354fcadaea219a$var$_objectSpread2["default"])({
        prevQuery: props.query,
        prevPropsEnvironment: props.environment,
        prevPropsVariables: props.variables,
        queryFetcher: queryFetcher
    }, $74354fcadaea219a$var$fetchQueryAndComputeStateFromProps(props, queryFetcher, prevState.retryCallbacks));
}
function $74354fcadaea219a$var$fetchQueryAndComputeStateFromProps(props, queryFetcher, retryCallbacks, requestCacheKey) {
    var environment = props.environment, query = props.query, variables = props.variables, cacheConfig = props.cacheConfig;
    var genericEnvironment = environment;
    if (query) {
        var request = $74354fcadaea219a$var$getRequest(query);
        var operation = $74354fcadaea219a$var$createOperationDescriptor(request, variables, cacheConfig);
        var relayContext = {
            environment: genericEnvironment
        };
        if (typeof requestCacheKey === 'string' && $74354fcadaea219a$var$requestCache[requestCacheKey]) {
            var snapshot = $74354fcadaea219a$var$requestCache[requestCacheKey].snapshot;
            if (snapshot) return {
                error: null,
                relayContext: relayContext,
                renderProps: $74354fcadaea219a$var$getRenderProps(null, snapshot, queryFetcher, retryCallbacks),
                snapshot: snapshot,
                requestCacheKey: requestCacheKey
            };
            else return {
                error: null,
                relayContext: relayContext,
                renderProps: $74354fcadaea219a$var$getLoadingRenderProps(),
                snapshot: null,
                requestCacheKey: requestCacheKey
            };
        }
        try {
            var storeSnapshot = queryFetcher.lookupInStore(genericEnvironment, operation, props.fetchPolicy);
            var querySnapshot = queryFetcher.fetch({
                environment: genericEnvironment,
                onDataChange: null,
                operation: operation
            });
            var _snapshot = querySnapshot || storeSnapshot;
            requestCacheKey = requestCacheKey || $74354fcadaea219a$var$getRequestCacheKey(request.params, props.variables);
            $74354fcadaea219a$var$requestCache[requestCacheKey] = {
                queryFetcher: queryFetcher,
                snapshot: _snapshot
            };
            if (!_snapshot) return {
                error: null,
                relayContext: relayContext,
                renderProps: $74354fcadaea219a$var$getLoadingRenderProps(),
                snapshot: null,
                requestCacheKey: requestCacheKey
            };
            return {
                error: null,
                relayContext: relayContext,
                renderProps: $74354fcadaea219a$var$getRenderProps(null, _snapshot, queryFetcher, retryCallbacks),
                snapshot: _snapshot,
                requestCacheKey: requestCacheKey
            };
        } catch (error) {
            return {
                error: error,
                relayContext: relayContext,
                renderProps: $74354fcadaea219a$var$getRenderProps(error, null, queryFetcher, retryCallbacks),
                snapshot: null,
                requestCacheKey: requestCacheKey
            };
        }
    } else {
        queryFetcher.dispose();
        var _relayContext = {
            environment: genericEnvironment
        };
        return {
            error: null,
            relayContext: _relayContext,
            renderProps: $74354fcadaea219a$var$getEmptyRenderProps(),
            requestCacheKey: null
        };
    }
}
module.exports = $74354fcadaea219a$var$ReactRelayQueryRenderer;

});

parcelRegister("b9Umy", function(module, exports) {
'use strict';

var $7Wmh0 = parcelRequire("7Wmh0");
var $81fc4173c7999519$var$_interopRequireDefault = $7Wmh0.default;

var $81fc4173c7999519$var$_extends2 = $81fc4173c7999519$var$_interopRequireDefault((parcelRequire("6bgQp")));

var $81fc4173c7999519$var$_objectWithoutPropertiesLoose2 = $81fc4173c7999519$var$_interopRequireDefault((parcelRequire("h8lLa")));

var $81fc4173c7999519$var$_objectSpread2 = $81fc4173c7999519$var$_interopRequireDefault((parcelRequire("1sB2t")));

var $81fc4173c7999519$var$_assertThisInitialized2 = $81fc4173c7999519$var$_interopRequireDefault((parcelRequire("7GwkG")));

var $81fc4173c7999519$var$_inheritsLoose2 = $81fc4173c7999519$var$_interopRequireDefault((parcelRequire("2iule")));

var $81fc4173c7999519$var$_defineProperty2 = $81fc4173c7999519$var$_interopRequireDefault((parcelRequire("ky4V8")));
var $81fc4173c7999519$var$_excluded = [
    "componentRef",
    "__relayContext",
    "__rootIsQueryRenderer"
];

var $ewnEa = parcelRequire("ewnEa");

var $jr3rR = parcelRequire("jr3rR");

var $4fb0r = parcelRequire("4fb0r");
var $81fc4173c7999519$var$getContainerName = $4fb0r.getContainerName;

var $iwDoV = parcelRequire("iwDoV");

var $fMCgV = parcelRequire("fMCgV");

var $hVPOR = parcelRequire("hVPOR");
var $81fc4173c7999519$var$assertRelayContext = $hVPOR.assertRelayContext;

var $jT3aJ = parcelRequire("jT3aJ");

var $eJOHy = parcelRequire("eJOHy");

var $37Ewn = parcelRequire("37Ewn");
var $81fc4173c7999519$var$Observable = $37Ewn.Observable, $81fc4173c7999519$var$createFragmentSpecResolver = $37Ewn.createFragmentSpecResolver, $81fc4173c7999519$var$createOperationDescriptor = $37Ewn.createOperationDescriptor, $81fc4173c7999519$var$getDataIDsFromObject = $37Ewn.getDataIDsFromObject, $81fc4173c7999519$var$getRequest = $37Ewn.getRequest, $81fc4173c7999519$var$getVariablesFromObject = $37Ewn.getVariablesFromObject, $81fc4173c7999519$var$isScalarAndEqual = $37Ewn.isScalarAndEqual;
parcelRequire("dH6ue");
function $81fc4173c7999519$var$createContainerWithFragments(Component, fragments, taggedNode) {
    var _class;
    var containerName = $81fc4173c7999519$var$getContainerName(Component);
    return _class = /*#__PURE__*/ function(_React$Component) {
        (0, $81fc4173c7999519$var$_inheritsLoose2["default"])(_class, _React$Component);
        function _class(props) {
            var _props$__rootIsQueryR, _this;
            _this = _React$Component.call(this, props) || this;
            (0, $81fc4173c7999519$var$_defineProperty2["default"])((0, $81fc4173c7999519$var$_assertThisInitialized2["default"])(_this), "_handleFragmentDataUpdate", function() {
                var resolverFromThisUpdate = _this.state.resolver;
                _this.setState(function(updatedState) {
                    return resolverFromThisUpdate === updatedState.resolver ? {
                        data: updatedState.resolver.resolve()
                    } : null;
                });
            });
            (0, $81fc4173c7999519$var$_defineProperty2["default"])((0, $81fc4173c7999519$var$_assertThisInitialized2["default"])(_this), "_refetch", function(refetchVariables, renderVariables, observerOrCallback, options) {
                if (_this._isUnmounted) return {
                    dispose: function dispose() {}
                };
                var _assertRelayContext = $81fc4173c7999519$var$assertRelayContext(_this.props.__relayContext), environment = _assertRelayContext.environment;
                var rootVariables = $jr3rR(fragments, _this.props);
                var fetchVariables = typeof refetchVariables === 'function' ? refetchVariables(_this._getFragmentVariables()) : refetchVariables;
                fetchVariables = (0, $81fc4173c7999519$var$_objectSpread2["default"])((0, $81fc4173c7999519$var$_objectSpread2["default"])({}, rootVariables), fetchVariables);
                var fragmentVariables = renderVariables ? (0, $81fc4173c7999519$var$_objectSpread2["default"])((0, $81fc4173c7999519$var$_objectSpread2["default"])({}, fetchVariables), renderVariables) : fetchVariables;
                var cacheConfig = options ? {
                    force: !!options.force
                } : undefined;
                if (cacheConfig != null && (options === null || options === void 0 ? void 0 : options.metadata) != null) cacheConfig.metadata = options === null || options === void 0 ? void 0 : options.metadata;
                var observer = typeof observerOrCallback === 'function' ? {
                    next: observerOrCallback,
                    error: observerOrCallback
                } : observerOrCallback || {};
                var query = $81fc4173c7999519$var$getRequest(taggedNode);
                var operation = $81fc4173c7999519$var$createOperationDescriptor(query, fetchVariables, cacheConfig);
                _this.state.localVariables = fetchVariables;
                _this._refetchSubscription && _this._refetchSubscription.unsubscribe();
                var refetchSubscription;
                var storeSnapshot = _this._getQueryFetcher().lookupInStore(environment, operation, options === null || options === void 0 ? void 0 : options.fetchPolicy);
                if (storeSnapshot != null) {
                    _this.state.resolver.setVariables(fragmentVariables, operation.request.node);
                    _this.setState(function(latestState) {
                        return {
                            data: latestState.resolver.resolve(),
                            contextForChildren: {
                                environment: _this.props.__relayContext.environment
                            }
                        };
                    }, function() {
                        observer.next && observer.next();
                        observer.complete && observer.complete();
                    });
                    return {
                        dispose: function dispose() {}
                    };
                }
                _this._getQueryFetcher().execute({
                    environment: environment,
                    operation: operation,
                    preservePreviousReferences: true
                }).mergeMap(function(response) {
                    _this.state.resolver.setVariables(fragmentVariables, operation.request.node);
                    return $81fc4173c7999519$var$Observable.create(function(sink) {
                        return _this.setState(function(latestState) {
                            return {
                                data: latestState.resolver.resolve(),
                                contextForChildren: {
                                    environment: _this.props.__relayContext.environment
                                }
                            };
                        }, function() {
                            sink.next();
                            sink.complete();
                        });
                    });
                })["finally"](function() {
                    if (_this._refetchSubscription === refetchSubscription) _this._refetchSubscription = null;
                }).subscribe((0, $81fc4173c7999519$var$_objectSpread2["default"])((0, $81fc4173c7999519$var$_objectSpread2["default"])({}, observer), {}, {
                    start: function start(subscription) {
                        _this._refetchSubscription = refetchSubscription = subscription;
                        observer.start && observer.start(subscription);
                    }
                }));
                return {
                    dispose: function dispose() {
                        refetchSubscription && refetchSubscription.unsubscribe();
                    }
                };
            });
            var relayContext = $81fc4173c7999519$var$assertRelayContext(props.__relayContext);
            var rootIsQueryRenderer = (_props$__rootIsQueryR = props.__rootIsQueryRenderer) !== null && _props$__rootIsQueryR !== void 0 ? _props$__rootIsQueryR : false;
            _this._refetchSubscription = null;
            var resolver = $81fc4173c7999519$var$createFragmentSpecResolver(relayContext, containerName, fragments, props, rootIsQueryRenderer);
            _this.state = {
                data: resolver.resolve(),
                localVariables: null,
                prevProps: props,
                prevPropsContext: relayContext,
                contextForChildren: relayContext,
                relayProp: $81fc4173c7999519$var$getRelayProp(relayContext.environment, _this._refetch),
                resolver: resolver
            };
            _this._isUnmounted = false;
            return _this;
        }
        var _proto = _class.prototype;
        _proto.componentDidMount = function componentDidMount() {
            this._isUnmounted = false;
            this._subscribeToNewResolverAndRerenderIfStoreHasChanged();
        };
        _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
            if (this.state.resolver !== prevState.resolver) {
                prevState.resolver.dispose();
                this._queryFetcher && this._queryFetcher.dispose();
                this._refetchSubscription && this._refetchSubscription.unsubscribe();
                this._subscribeToNewResolverAndRerenderIfStoreHasChanged();
            } else this._rerenderIfStoreHasChanged();
        };
        _class.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
            var _nextProps$__rootIsQu;
            var prevProps = prevState.prevProps;
            var relayContext = $81fc4173c7999519$var$assertRelayContext(nextProps.__relayContext);
            var rootIsQueryRenderer = (_nextProps$__rootIsQu = nextProps.__rootIsQueryRenderer) !== null && _nextProps$__rootIsQu !== void 0 ? _nextProps$__rootIsQu : false;
            var prevIDs = $81fc4173c7999519$var$getDataIDsFromObject(fragments, prevProps);
            var nextIDs = $81fc4173c7999519$var$getDataIDsFromObject(fragments, nextProps);
            var prevRootVariables = $jr3rR(fragments, prevProps);
            var nextRootVariables = $jr3rR(fragments, nextProps);
            var resolver = prevState.resolver;
            if (prevState.prevPropsContext.environment !== relayContext.environment || !$jT3aJ(prevRootVariables, nextRootVariables) || !$jT3aJ(prevIDs, nextIDs)) {
                resolver = $81fc4173c7999519$var$createFragmentSpecResolver(relayContext, containerName, fragments, nextProps, rootIsQueryRenderer);
                return {
                    data: resolver.resolve(),
                    localVariables: null,
                    prevProps: nextProps,
                    prevPropsContext: relayContext,
                    contextForChildren: relayContext,
                    relayProp: $81fc4173c7999519$var$getRelayProp(relayContext.environment, prevState.relayProp.refetch),
                    resolver: resolver
                };
            } else if (!prevState.localVariables) resolver.setProps(nextProps);
            var data = resolver.resolve();
            if (data !== prevState.data) return {
                data: data,
                prevProps: nextProps
            };
            return null;
        };
        _proto.componentWillUnmount = function componentWillUnmount() {
            this._isUnmounted = true;
            this.state.resolver.dispose();
            this._queryFetcher && this._queryFetcher.dispose();
            this._refetchSubscription && this._refetchSubscription.unsubscribe();
        };
        _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
            if (nextState.data !== this.state.data || nextState.relayProp !== this.state.relayProp) return true;
            var keys = Object.keys(nextProps);
            for(var ii = 0; ii < keys.length; ii++){
                var key = keys[ii];
                if (key === '__relayContext') {
                    if (this.state.prevPropsContext.environment !== nextState.prevPropsContext.environment) return true;
                } else {
                    if (!fragments.hasOwnProperty(key) && !$81fc4173c7999519$var$isScalarAndEqual(nextProps[key], this.props[key])) return true;
                }
            }
            return false;
        };
        _proto._rerenderIfStoreHasChanged = function _rerenderIfStoreHasChanged() {
            var _this$state = this.state, data = _this$state.data, resolver = _this$state.resolver;
            var maybeNewData = resolver.resolve();
            if (data !== maybeNewData) this.setState({
                data: maybeNewData
            });
        };
        _proto._subscribeToNewResolverAndRerenderIfStoreHasChanged = function _subscribeToNewResolverAndRerenderIfStoreHasChanged() {
            var _this$state2 = this.state, data = _this$state2.data, resolver = _this$state2.resolver;
            var maybeNewData = resolver.resolve();
            resolver.setCallback(this.props, this._handleFragmentDataUpdate);
            if (data !== maybeNewData) this.setState({
                data: maybeNewData
            });
        };
        _proto._getFragmentVariables = function _getFragmentVariables() {
            return $81fc4173c7999519$var$getVariablesFromObject(fragments, this.props);
        };
        _proto._getQueryFetcher = function _getQueryFetcher() {
            if (!this._queryFetcher) this._queryFetcher = new $fMCgV();
            return this._queryFetcher;
        };
        _proto.render = function render() {
            var _this$props = this.props, componentRef = _this$props.componentRef, __relayContext = _this$props.__relayContext, __rootIsQueryRenderer = _this$props.__rootIsQueryRenderer, props = (0, $81fc4173c7999519$var$_objectWithoutPropertiesLoose2["default"])(_this$props, $81fc4173c7999519$var$_excluded);
            var _this$state3 = this.state, relayProp = _this$state3.relayProp, contextForChildren = _this$state3.contextForChildren;
            return /*#__PURE__*/ $eJOHy.createElement($iwDoV.Provider, {
                value: contextForChildren
            }, /*#__PURE__*/ $eJOHy.createElement(Component, (0, $81fc4173c7999519$var$_extends2["default"])({}, props, this.state.data, {
                ref: componentRef,
                relay: relayProp
            })));
        };
        return _class;
    }($eJOHy.Component), (0, $81fc4173c7999519$var$_defineProperty2["default"])(_class, "displayName", containerName), _class;
}
function $81fc4173c7999519$var$getRelayProp(environment, refetch) {
    return {
        environment: environment,
        refetch: refetch
    };
}
function $81fc4173c7999519$var$createContainer(Component, fragmentSpec, taggedNode) {
    return $ewnEa(Component, fragmentSpec, function(ComponentClass, fragments) {
        return $81fc4173c7999519$var$createContainerWithFragments(ComponentClass, fragments, taggedNode);
    });
}
module.exports = {
    createContainer: $81fc4173c7999519$var$createContainer
};

});

parcelRegister("4E40D", function(module, exports) {
'use strict';

var $83OIO = parcelRequire("83OIO");

var $i764d = parcelRequire("i764d");

var $eJOHy = parcelRequire("eJOHy");

var $eJOHy = parcelRequire("eJOHy");
var $361e02060da056a2$var$useContext = $eJOHy.useContext, $361e02060da056a2$var$useEffect = $eJOHy.useEffect;
parcelRequire("dH6ue");
function $361e02060da056a2$var$EntryPointContainer(_ref) {
    var entryPointReference = _ref.entryPointReference, props = _ref.props;
    var getComponent = entryPointReference.getComponent, queries = entryPointReference.queries, entryPoints = entryPointReference.entryPoints, extraProps = entryPointReference.extraProps, rootModuleID = entryPointReference.rootModuleID;
    var Component = getComponent();
    var profilerContext = $361e02060da056a2$var$useContext($83OIO);
    var environment = $i764d();
    $361e02060da056a2$var$useEffect(function() {
        environment.__log({
            name: 'entrypoint.root.consume',
            profilerContext: profilerContext,
            rootModuleID: rootModuleID
        });
    }, [
        environment,
        profilerContext,
        rootModuleID
    ]);
    return /*#__PURE__*/ $eJOHy.createElement(Component, {
        entryPoints: entryPoints,
        extraProps: extraProps,
        props: props,
        queries: queries
    });
}
module.exports = $361e02060da056a2$var$EntryPointContainer;

});
parcelRegister("83OIO", function(module, exports) {
'use strict';

var $eJOHy = parcelRequire("eJOHy");
var $5de5f2db126910d4$var$ProfilerContext = $eJOHy.createContext({
    wrapPrepareQueryResource: function wrapPrepareQueryResource(cb) {
        return cb();
    }
});
module.exports = $5de5f2db126910d4$var$ProfilerContext;

});

parcelRegister("i764d", function(module, exports) {
'use strict';

var $iwDoV = parcelRequire("iwDoV");

var $423Vm = parcelRequire("423Vm");

var $eJOHy = parcelRequire("eJOHy");
var $d2fd963610ea9364$var$useContext = $eJOHy.useContext;
function $d2fd963610ea9364$var$useRelayEnvironment() {
    var context = $d2fd963610ea9364$var$useContext($iwDoV);
    !(context != null) && $423Vm(false);
    return context.environment;
}
module.exports = $d2fd963610ea9364$var$useRelayEnvironment;

});


parcelRegister("bdIJW", function(module, exports) {
'use strict';

var $bQPKN = parcelRequire("bQPKN");
var $82b39d074ed8d5a2$var$loadQuery = $bQPKN.loadQuery;
function $82b39d074ed8d5a2$var$loadEntryPoint(environmentProvider, entryPoint, entryPointParams) {
    var loadingPromise = null;
    if (entryPoint.root.getModuleIfRequired() == null) loadingPromise = entryPoint.root.load();
    var preloadProps = entryPoint.getPreloadProps(entryPointParams);
    var queries = preloadProps.queries, entryPoints = preloadProps.entryPoints, extraProps = preloadProps.extraProps;
    var preloadedQueries = {};
    var preloadedEntryPoints = {};
    if (queries != null) {
        var queriesPropNames = Object.keys(queries);
        queriesPropNames.forEach(function(queryPropName) {
            var _queries$queryPropNam = queries[queryPropName], environmentProviderOptions = _queries$queryPropNam.environmentProviderOptions, options = _queries$queryPropNam.options, parameters = _queries$queryPropNam.parameters, variables = _queries$queryPropNam.variables;
            var environment = environmentProvider.getEnvironment(environmentProviderOptions);
            preloadedQueries[queryPropName] = $82b39d074ed8d5a2$var$loadQuery(environment, parameters, variables, {
                fetchPolicy: options === null || options === void 0 ? void 0 : options.fetchPolicy,
                networkCacheConfig: options === null || options === void 0 ? void 0 : options.networkCacheConfig,
                __nameForWarning: 'loadEntryPoint'
            }, environmentProviderOptions);
        });
    }
    if (entryPoints != null) {
        var entryPointPropNames = Object.keys(entryPoints);
        entryPointPropNames.forEach(function(entryPointPropName) {
            var entryPointDescription = entryPoints[entryPointPropName];
            if (entryPointDescription == null) return;
            var nestedEntryPoint = entryPointDescription.entryPoint, nestedParams = entryPointDescription.entryPointParams;
            preloadedEntryPoints[entryPointPropName] = $82b39d074ed8d5a2$var$loadEntryPoint(environmentProvider, nestedEntryPoint, nestedParams);
        });
    }
    var isDisposed = false;
    return {
        dispose: function dispose() {
            if (isDisposed) return;
            if (preloadedQueries != null) Object.values(preloadedQueries).forEach(function(_ref) {
                var innerDispose = _ref.dispose;
                innerDispose();
            });
            if (preloadedEntryPoints != null) Object.values(preloadedEntryPoints).forEach(function(_ref2) {
                var innerDispose = _ref2.dispose;
                innerDispose();
            });
            isDisposed = true;
        },
        entryPoints: preloadedEntryPoints,
        extraProps: extraProps !== null && extraProps !== void 0 ? extraProps : null,
        getComponent: function getComponent() {
            var componentModule = entryPoint.root.getModuleIfRequired();
            if (componentModule == null) {
                var _loadingPromise;
                loadingPromise = (_loadingPromise = loadingPromise) !== null && _loadingPromise !== void 0 ? _loadingPromise : entryPoint.root.load();
                throw loadingPromise;
            }
            var component = componentModule["default"] != null ? componentModule["default"] : componentModule;
            return component;
        },
        get isDisposed () {
            return isDisposed;
        },
        queries: preloadedQueries,
        rootModuleID: entryPoint.root.getModuleId()
    };
}
module.exports = $82b39d074ed8d5a2$var$loadEntryPoint;

});
parcelRegister("bQPKN", function(module, exports) {
'use strict';

var $7Wmh0 = parcelRequire("7Wmh0");
var $8a0cb23d99e78ca8$var$_interopRequireDefault = $7Wmh0.default;

var $8a0cb23d99e78ca8$var$_objectSpread2 = $8a0cb23d99e78ca8$var$_interopRequireDefault((parcelRequire("1sB2t")));

var $423Vm = parcelRequire("423Vm");

var $eJOHy = parcelRequire("eJOHy");

var $37Ewn = parcelRequire("37Ewn");
var $8a0cb23d99e78ca8$var$fetchQueryDeduped = $37Ewn.__internal.fetchQueryDeduped, $8a0cb23d99e78ca8$var$Observable = $37Ewn.Observable, $8a0cb23d99e78ca8$var$PreloadableQueryRegistry = $37Ewn.PreloadableQueryRegistry, $8a0cb23d99e78ca8$var$RelayFeatureFlags = $37Ewn.RelayFeatureFlags, $8a0cb23d99e78ca8$var$ReplaySubject = $37Ewn.ReplaySubject, $8a0cb23d99e78ca8$var$createOperationDescriptor = $37Ewn.createOperationDescriptor, $8a0cb23d99e78ca8$var$getRequest = $37Ewn.getRequest, $8a0cb23d99e78ca8$var$getRequestIdentifier = $37Ewn.getRequestIdentifier;
parcelRequire("dH6ue");
var $8a0cb23d99e78ca8$var$RenderDispatcher = null;
var $8a0cb23d99e78ca8$var$fetchKey = 100001;
function $8a0cb23d99e78ca8$var$useTrackLoadQueryInRender() {
    if ($8a0cb23d99e78ca8$var$RenderDispatcher === null) {
        var _React$__SECRET_INTER, _React$__SECRET_INTER2;
        $8a0cb23d99e78ca8$var$RenderDispatcher = (_React$__SECRET_INTER = $eJOHy.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED) === null || _React$__SECRET_INTER === void 0 ? void 0 : (_React$__SECRET_INTER2 = _React$__SECRET_INTER.ReactCurrentDispatcher) === null || _React$__SECRET_INTER2 === void 0 ? void 0 : _React$__SECRET_INTER2.current;
    }
}
function $8a0cb23d99e78ca8$var$loadQuery(environment, preloadableRequest, variables, options, environmentProviderOptions) {
    var _React$__SECRET_INTER3, _React$__SECRET_INTER4, _options$__nameForWar, _options$fetchPolicy;
    var CurrentDispatcher = (_React$__SECRET_INTER3 = $eJOHy.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED) === null || _React$__SECRET_INTER3 === void 0 ? void 0 : (_React$__SECRET_INTER4 = _React$__SECRET_INTER3.ReactCurrentDispatcher) === null || _React$__SECRET_INTER4 === void 0 ? void 0 : _React$__SECRET_INTER4.current;
    $8a0cb23d99e78ca8$var$fetchKey++;
    var fetchPolicy = (_options$fetchPolicy = options === null || options === void 0 ? void 0 : options.fetchPolicy) !== null && _options$fetchPolicy !== void 0 ? _options$fetchPolicy : 'store-or-network';
    var networkCacheConfig = (0, $8a0cb23d99e78ca8$var$_objectSpread2["default"])((0, $8a0cb23d99e78ca8$var$_objectSpread2["default"])({}, options === null || options === void 0 ? void 0 : options.networkCacheConfig), {}, {
        force: true
    });
    var retainReference;
    var didExecuteNetworkSource = false;
    var executeWithNetworkSource = function executeWithNetworkSource(operation, networkObservable) {
        didExecuteNetworkSource = true;
        return environment.executeWithSource({
            operation: operation,
            source: networkObservable
        });
    };
    var executionSubject = new $8a0cb23d99e78ca8$var$ReplaySubject();
    var returnedObservable = $8a0cb23d99e78ca8$var$Observable.create(function(sink) {
        return executionSubject.subscribe(sink);
    });
    var unsubscribeFromNetworkRequest;
    var networkError = null;
    var didMakeNetworkRequest = false;
    var makeNetworkRequest = function makeNetworkRequest(params) {
        didMakeNetworkRequest = true;
        var observable;
        var subject = new $8a0cb23d99e78ca8$var$ReplaySubject();
        if ($8a0cb23d99e78ca8$var$RelayFeatureFlags.ENABLE_LOAD_QUERY_REQUEST_DEDUPING === true) {
            var identifier = 'raw-network-request-' + $8a0cb23d99e78ca8$var$getRequestIdentifier(params, variables);
            observable = $8a0cb23d99e78ca8$var$fetchQueryDeduped(environment, identifier, function() {
                var network = environment.getNetwork();
                return network.execute(params, variables, networkCacheConfig);
            });
        } else {
            var network = environment.getNetwork();
            observable = network.execute(params, variables, networkCacheConfig);
        }
        var _observable$subscribe = observable.subscribe({
            error: function error(err) {
                networkError = err;
                subject.error(err);
            },
            next: function next(data) {
                subject.next(data);
            },
            complete: function complete() {
                subject.complete();
            }
        }), unsubscribe = _observable$subscribe.unsubscribe;
        unsubscribeFromNetworkRequest = unsubscribe;
        return $8a0cb23d99e78ca8$var$Observable.create(function(sink) {
            var subjectSubscription = subject.subscribe(sink);
            return function() {
                subjectSubscription.unsubscribe();
                unsubscribeFromNetworkRequest();
            };
        });
    };
    var unsubscribeFromExecution;
    var executeDeduped = function executeDeduped(operation, fetchFn) {
        if ($8a0cb23d99e78ca8$var$RelayFeatureFlags.ENABLE_LOAD_QUERY_REQUEST_DEDUPING === true) didMakeNetworkRequest = true;
        var _fetchQueryDeduped$su = $8a0cb23d99e78ca8$var$fetchQueryDeduped(environment, operation.request.identifier, fetchFn).subscribe({
            error: function error(err) {
                executionSubject.error(err);
            },
            next: function next(data) {
                executionSubject.next(data);
            },
            complete: function complete() {
                executionSubject.complete();
            }
        });
        unsubscribeFromExecution = _fetchQueryDeduped$su.unsubscribe;
    };
    var checkAvailabilityAndExecute = function checkAvailabilityAndExecute(concreteRequest) {
        var operation = $8a0cb23d99e78ca8$var$createOperationDescriptor(concreteRequest, variables, networkCacheConfig);
        retainReference = environment.retain(operation);
        if (fetchPolicy === 'store-only') return;
        var shouldFetch = fetchPolicy !== 'store-or-network' || environment.check(operation).status !== 'available';
        if (shouldFetch) executeDeduped(operation, function() {
            var networkObservable = makeNetworkRequest(concreteRequest.params);
            var executeObservable = executeWithNetworkSource(operation, networkObservable);
            return executeObservable;
        });
    };
    var params;
    var cancelOnLoadCallback;
    var queryId;
    if (preloadableRequest.kind === 'PreloadableConcreteRequest') {
        var preloadableConcreteRequest = preloadableRequest;
        params = preloadableConcreteRequest.params;
        var _params = params;
        queryId = _params.id;
        !(queryId !== null) && $423Vm(false);
        var _module = $8a0cb23d99e78ca8$var$PreloadableQueryRegistry.get(queryId);
        if (_module != null) checkAvailabilityAndExecute(_module);
        else {
            var networkObservable = fetchPolicy === 'store-only' ? null : makeNetworkRequest(params);
            var _PreloadableQueryRegi = $8a0cb23d99e78ca8$var$PreloadableQueryRegistry.onLoad(queryId, function(preloadedModule) {
                cancelOnLoadCallback();
                var operation = $8a0cb23d99e78ca8$var$createOperationDescriptor(preloadedModule, variables, networkCacheConfig);
                retainReference = environment.retain(operation);
                if (networkObservable != null) executeDeduped(operation, function() {
                    return executeWithNetworkSource(operation, networkObservable);
                });
            });
            cancelOnLoadCallback = _PreloadableQueryRegi.dispose;
        }
    } else {
        var graphQlTaggedNode = preloadableRequest;
        var request = $8a0cb23d99e78ca8$var$getRequest(graphQlTaggedNode);
        params = request.params;
        queryId = params.cacheID != null ? params.cacheID : params.id;
        checkAvailabilityAndExecute(request);
    }
    var isDisposed = false;
    var isReleased = false;
    var isNetworkRequestCancelled = false;
    var releaseQuery = function releaseQuery() {
        if (isReleased) return;
        retainReference && retainReference.dispose();
        isReleased = true;
    };
    var cancelNetworkRequest = function cancelNetworkRequest() {
        if (isNetworkRequestCancelled) return;
        if (didExecuteNetworkSource) unsubscribeFromExecution && unsubscribeFromExecution();
        else unsubscribeFromNetworkRequest && unsubscribeFromNetworkRequest();
        cancelOnLoadCallback && cancelOnLoadCallback();
        isNetworkRequestCancelled = true;
    };
    return {
        kind: 'PreloadedQuery',
        environment: environment,
        environmentProviderOptions: environmentProviderOptions,
        dispose: function dispose() {
            if (isDisposed) return;
            releaseQuery();
            cancelNetworkRequest();
            isDisposed = true;
        },
        releaseQuery: releaseQuery,
        cancelNetworkRequest: cancelNetworkRequest,
        fetchKey: $8a0cb23d99e78ca8$var$fetchKey,
        id: queryId,
        get isDisposed () {
            return isDisposed || isReleased;
        },
        get networkError () {
            return networkError;
        },
        name: params.name,
        networkCacheConfig: networkCacheConfig,
        fetchPolicy: fetchPolicy,
        source: didMakeNetworkRequest ? returnedObservable : undefined,
        variables: variables
    };
}
module.exports = {
    loadQuery: $8a0cb23d99e78ca8$var$loadQuery,
    useTrackLoadQueryInRender: $8a0cb23d99e78ca8$var$useTrackLoadQueryInRender
};

});


parcelRegister("1NoLa", function(module, exports) {
'use strict';

var $iwDoV = parcelRequire("iwDoV");

var $eJOHy = parcelRequire("eJOHy");
var $14ed92d12184afe6$var$useMemo = $eJOHy.useMemo;
function $14ed92d12184afe6$var$RelayEnvironmentProvider(props) {
    var children = props.children, environment = props.environment, getEnvironmentForActor = props.getEnvironmentForActor;
    var context = $14ed92d12184afe6$var$useMemo(function() {
        return {
            environment: environment,
            getEnvironmentForActor: getEnvironmentForActor
        };
    }, [
        environment,
        getEnvironmentForActor
    ]);
    return /*#__PURE__*/ $eJOHy.createElement($iwDoV.Provider, {
        value: context
    }, children);
}
module.exports = $14ed92d12184afe6$var$RelayEnvironmentProvider;

});

parcelRegister("3BGlu", function(module, exports) {
'use strict';

var $7Wmh0 = parcelRequire("7Wmh0");
var $2a05acc03babe8ba$var$_interopRequireDefault = $7Wmh0.default;

var $2a05acc03babe8ba$var$_objectSpread2 = $2a05acc03babe8ba$var$_interopRequireDefault((parcelRequire("1sB2t")));

var $cOk0k = parcelRequire("cOk0k");
function $2a05acc03babe8ba$var$useClientQuery(gqlQuery, variables, options) {
    var query = gqlQuery;
    return $cOk0k(query, variables, (0, $2a05acc03babe8ba$var$_objectSpread2["default"])((0, $2a05acc03babe8ba$var$_objectSpread2["default"])({}, options), {}, {
        fetchPolicy: 'store-only'
    }));
}
module.exports = $2a05acc03babe8ba$var$useClientQuery;

});
parcelRegister("cOk0k", function(module, exports) {
'use strict';

var $bQPKN = parcelRequire("bQPKN");
var $9539abfa1b618313$var$useTrackLoadQueryInRender = $bQPKN.useTrackLoadQueryInRender;

var $1dVZ2 = parcelRequire("1dVZ2");

var $jcK8M = parcelRequire("jcK8M");

var $i764d = parcelRequire("i764d");

var $37Ewn = parcelRequire("37Ewn");
var $9539abfa1b618313$var$fetchQuery = $37Ewn.__internal.fetchQuery;
function $9539abfa1b618313$var$useLazyLoadQuery(gqlQuery, variables, options) {
    $9539abfa1b618313$var$useTrackLoadQueryInRender();
    var environment = $i764d();
    var query = $jcK8M(gqlQuery, variables, options && options.networkCacheConfig ? options.networkCacheConfig : {
        force: true
    });
    var data = $1dVZ2({
        componentDisplayName: 'useLazyLoadQuery()',
        fetchKey: options === null || options === void 0 ? void 0 : options.fetchKey,
        fetchObservable: $9539abfa1b618313$var$fetchQuery(environment, query),
        fetchPolicy: options === null || options === void 0 ? void 0 : options.fetchPolicy,
        query: query,
        renderPolicy: options === null || options === void 0 ? void 0 : options.UNSTABLE_renderPolicy
    });
    return data;
}
module.exports = $9539abfa1b618313$var$useLazyLoadQuery;

});
parcelRegister("1dVZ2", function(module, exports) {
'use strict';

var $83OIO = parcelRequire("83OIO");

var $eROlK = parcelRequire("eROlK");
var $0e43fba5c20cb7e1$var$getQueryCacheIdentifier = $eROlK.getQueryCacheIdentifier, $0e43fba5c20cb7e1$var$getQueryResourceForEnvironment = $eROlK.getQueryResourceForEnvironment;

var $cfu4g = parcelRequire("cfu4g");

var $810gN = parcelRequire("810gN");

var $i764d = parcelRequire("i764d");

var $eJOHy = parcelRequire("eJOHy");
var $0e43fba5c20cb7e1$var$useContext = $eJOHy.useContext, $0e43fba5c20cb7e1$var$useEffect = $eJOHy.useEffect, $0e43fba5c20cb7e1$var$useState = $eJOHy.useState, $0e43fba5c20cb7e1$var$useRef = $eJOHy.useRef;
function $0e43fba5c20cb7e1$var$useLazyLoadQueryNode(_ref) {
    var query = _ref.query, componentDisplayName = _ref.componentDisplayName, fetchObservable = _ref.fetchObservable, fetchPolicy = _ref.fetchPolicy, fetchKey = _ref.fetchKey, renderPolicy = _ref.renderPolicy;
    var environment = $i764d();
    var profilerContext = $0e43fba5c20cb7e1$var$useContext($83OIO);
    var QueryResource = $0e43fba5c20cb7e1$var$getQueryResourceForEnvironment(environment);
    var _useState = $0e43fba5c20cb7e1$var$useState(0), forceUpdateKey = _useState[0], forceUpdate = _useState[1];
    var _useFetchTrackingRef = $cfu4g(), startFetch = _useFetchTrackingRef.startFetch, completeFetch = _useFetchTrackingRef.completeFetch;
    var cacheBreaker = "".concat(forceUpdateKey, "-").concat(fetchKey !== null && fetchKey !== void 0 ? fetchKey : '');
    var cacheIdentifier = $0e43fba5c20cb7e1$var$getQueryCacheIdentifier(environment, query, fetchPolicy, renderPolicy, cacheBreaker);
    var preparedQueryResult = profilerContext.wrapPrepareQueryResource(function() {
        return QueryResource.prepareWithIdentifier(cacheIdentifier, query, fetchObservable, fetchPolicy, renderPolicy, {
            start: startFetch,
            complete: completeFetch,
            error: completeFetch
        }, profilerContext);
    });
    var maybeHiddenOrFastRefresh = $0e43fba5c20cb7e1$var$useRef(false);
    $0e43fba5c20cb7e1$var$useEffect(function() {
        return function() {
            maybeHiddenOrFastRefresh.current = true;
        };
    }, []);
    $0e43fba5c20cb7e1$var$useEffect(function() {
        if (maybeHiddenOrFastRefresh.current === true) {
            maybeHiddenOrFastRefresh.current = false;
            forceUpdate(function(n) {
                return n + 1;
            });
            return;
        }
        var disposable = QueryResource.retain(preparedQueryResult, profilerContext);
        return function() {
            disposable.dispose();
        };
    }, [
        environment,
        cacheIdentifier
    ]);
    $0e43fba5c20cb7e1$var$useEffect(function() {
        QueryResource.releaseTemporaryRetain(preparedQueryResult);
    });
    var fragmentNode = preparedQueryResult.fragmentNode, fragmentRef = preparedQueryResult.fragmentRef;
    var data = $810gN(fragmentNode, fragmentRef, componentDisplayName);
    return data;
}
module.exports = $0e43fba5c20cb7e1$var$useLazyLoadQueryNode;

});
parcelRegister("eROlK", function(module, exports) {
'use strict';

var $7Wmh0 = parcelRequire("7Wmh0");
var $ad2d125b86175bda$var$_interopRequireDefault = $7Wmh0.default;

var $ad2d125b86175bda$var$_objectSpread2 = $ad2d125b86175bda$var$_interopRequireDefault((parcelRequire("1sB2t")));

var $ad2d125b86175bda$var$_defineProperty2 = $ad2d125b86175bda$var$_interopRequireDefault((parcelRequire("ky4V8")));

var $ipJzn = parcelRequire("ipJzn");

var $fso1r = parcelRequire("fso1r");

var $423Vm = parcelRequire("423Vm");

var $37Ewn = parcelRequire("37Ewn");
var $ad2d125b86175bda$var$isPromise = $37Ewn.isPromise;
parcelRequire("dH6ue");
var $ad2d125b86175bda$var$CACHE_CAPACITY = 1000;
var $ad2d125b86175bda$var$DEFAULT_FETCH_POLICY = 'store-or-network';
var $ad2d125b86175bda$var$DEFAULT_LIVE_FETCH_POLICY = 'store-and-network';
var $ad2d125b86175bda$var$WEAKMAP_SUPPORTED = typeof WeakMap === 'function';
function $ad2d125b86175bda$var$operationIsLiveQuery(operation) {
    return operation.request.node.params.metadata.live !== undefined;
}
function $ad2d125b86175bda$var$getQueryCacheIdentifier(environment, operation, maybeFetchPolicy, maybeRenderPolicy, cacheBreaker) {
    var fetchPolicy = maybeFetchPolicy !== null && maybeFetchPolicy !== void 0 ? maybeFetchPolicy : $ad2d125b86175bda$var$operationIsLiveQuery(operation) ? $ad2d125b86175bda$var$DEFAULT_LIVE_FETCH_POLICY : $ad2d125b86175bda$var$DEFAULT_FETCH_POLICY;
    var renderPolicy = maybeRenderPolicy !== null && maybeRenderPolicy !== void 0 ? maybeRenderPolicy : environment.UNSTABLE_getDefaultRenderPolicy();
    var cacheIdentifier = "".concat(fetchPolicy, "-").concat(renderPolicy, "-").concat(operation.request.identifier);
    if (cacheBreaker != null) return "".concat(cacheIdentifier, "-").concat(cacheBreaker);
    return cacheIdentifier;
}
function $ad2d125b86175bda$var$getQueryResult(operation, cacheIdentifier) {
    var rootFragmentRef = {
        __id: operation.fragment.dataID,
        __fragments: (0, $ad2d125b86175bda$var$_defineProperty2["default"])({}, operation.fragment.node.name, operation.request.variables),
        __fragmentOwner: operation.request
    };
    return {
        cacheIdentifier: cacheIdentifier,
        fragmentNode: operation.request.node.fragment,
        fragmentRef: rootFragmentRef,
        operation: operation
    };
}
var $ad2d125b86175bda$var$nextID = 200000;
function $ad2d125b86175bda$var$createCacheEntry(cacheIdentifier, operation, operationAvailability, value, networkSubscription, onDispose) {
    var isLiveQuery = $ad2d125b86175bda$var$operationIsLiveQuery(operation);
    var currentValue = value;
    var currentNetworkSubscription = networkSubscription;
    var suspenseResource = new $fso1r(function(environment) {
        var retention = environment.retain(operation);
        return {
            dispose: function dispose() {
                if (isLiveQuery && currentNetworkSubscription != null) currentNetworkSubscription.unsubscribe();
                retention.dispose();
                onDispose(cacheEntry);
            }
        };
    });
    var cacheEntry = {
        cacheIdentifier: cacheIdentifier,
        id: $ad2d125b86175bda$var$nextID++,
        processedPayloadsCount: 0,
        operationAvailability: operationAvailability,
        getValue: function getValue() {
            return currentValue;
        },
        setValue: function setValue(val) {
            currentValue = val;
        },
        setNetworkSubscription: function setNetworkSubscription(subscription) {
            if (isLiveQuery && currentNetworkSubscription != null) currentNetworkSubscription.unsubscribe();
            currentNetworkSubscription = subscription;
        },
        temporaryRetain: function temporaryRetain(environment) {
            return suspenseResource.temporaryRetain(environment);
        },
        permanentRetain: function permanentRetain(environment) {
            return suspenseResource.permanentRetain(environment);
        },
        releaseTemporaryRetain: function releaseTemporaryRetain() {
            suspenseResource.releaseTemporaryRetain();
        }
    };
    return cacheEntry;
}
var $ad2d125b86175bda$var$QueryResourceImpl = /*#__PURE__*/ function() {
    function QueryResourceImpl(environment) {
        var _this = this;
        (0, $ad2d125b86175bda$var$_defineProperty2["default"])(this, "_clearCacheEntry", function(cacheEntry) {
            _this._cache["delete"](cacheEntry.cacheIdentifier);
        });
        this._environment = environment;
        this._cache = $ipJzn.create($ad2d125b86175bda$var$CACHE_CAPACITY);
    }
    var _proto = QueryResourceImpl.prototype;
    _proto.prepare = function prepare(operation, fetchObservable, maybeFetchPolicy, maybeRenderPolicy, observer, cacheBreaker, profilerContext) {
        var cacheIdentifier = $ad2d125b86175bda$var$getQueryCacheIdentifier(this._environment, operation, maybeFetchPolicy, maybeRenderPolicy, cacheBreaker);
        return this.prepareWithIdentifier(cacheIdentifier, operation, fetchObservable, maybeFetchPolicy, maybeRenderPolicy, observer, profilerContext);
    };
    _proto.prepareWithIdentifier = function prepareWithIdentifier(cacheIdentifier, operation, fetchObservable, maybeFetchPolicy, maybeRenderPolicy, observer, profilerContext) {
        var environment = this._environment;
        var fetchPolicy = maybeFetchPolicy !== null && maybeFetchPolicy !== void 0 ? maybeFetchPolicy : $ad2d125b86175bda$var$operationIsLiveQuery(operation) ? $ad2d125b86175bda$var$DEFAULT_LIVE_FETCH_POLICY : $ad2d125b86175bda$var$DEFAULT_FETCH_POLICY;
        var renderPolicy = maybeRenderPolicy !== null && maybeRenderPolicy !== void 0 ? maybeRenderPolicy : environment.UNSTABLE_getDefaultRenderPolicy();
        var cacheEntry = this._cache.get(cacheIdentifier);
        var temporaryRetainDisposable = null;
        var entryWasCached = cacheEntry != null;
        if (cacheEntry == null) cacheEntry = this._fetchAndSaveQuery(cacheIdentifier, operation, fetchObservable, fetchPolicy, renderPolicy, profilerContext, (0, $ad2d125b86175bda$var$_objectSpread2["default"])((0, $ad2d125b86175bda$var$_objectSpread2["default"])({}, observer), {}, {
            unsubscribe: function unsubscribe(subscription) {
                if (temporaryRetainDisposable != null) temporaryRetainDisposable.dispose();
                var observerUnsubscribe = observer === null || observer === void 0 ? void 0 : observer.unsubscribe;
                observerUnsubscribe && observerUnsubscribe(subscription);
            }
        }));
        temporaryRetainDisposable = cacheEntry.temporaryRetain(environment);
        var cachedValue = cacheEntry.getValue();
        if ($ad2d125b86175bda$var$isPromise(cachedValue)) {
            environment.__log({
                name: 'suspense.query',
                fetchPolicy: fetchPolicy,
                isPromiseCached: entryWasCached,
                operation: operation,
                queryAvailability: cacheEntry.operationAvailability,
                renderPolicy: renderPolicy
            });
            throw cachedValue;
        }
        if (cachedValue instanceof Error) throw cachedValue;
        return cachedValue;
    };
    _proto.retain = function retain(queryResult, profilerContext) {
        var environment = this._environment;
        var cacheIdentifier = queryResult.cacheIdentifier, operation = queryResult.operation;
        var cacheEntry = this._getOrCreateCacheEntry(cacheIdentifier, operation, null, queryResult, null);
        var disposable = cacheEntry.permanentRetain(environment);
        environment.__log({
            name: 'queryresource.retain',
            profilerContext: profilerContext,
            resourceID: cacheEntry.id
        });
        return {
            dispose: function dispose() {
                disposable.dispose();
            }
        };
    };
    _proto.releaseTemporaryRetain = function releaseTemporaryRetain(queryResult) {
        var cacheEntry = this._cache.get(queryResult.cacheIdentifier);
        if (cacheEntry != null) cacheEntry.releaseTemporaryRetain();
    };
    _proto.TESTS_ONLY__getCacheEntry = function TESTS_ONLY__getCacheEntry(operation, maybeFetchPolicy, maybeRenderPolicy, cacheBreaker) {
        var environment = this._environment;
        var cacheIdentifier = $ad2d125b86175bda$var$getQueryCacheIdentifier(environment, operation, maybeFetchPolicy, maybeRenderPolicy, cacheBreaker);
        return this._cache.get(cacheIdentifier);
    };
    _proto._getOrCreateCacheEntry = function _getOrCreateCacheEntry(cacheIdentifier, operation, operationAvailability, value, networkSubscription) {
        var cacheEntry = this._cache.get(cacheIdentifier);
        if (cacheEntry == null) {
            cacheEntry = $ad2d125b86175bda$var$createCacheEntry(cacheIdentifier, operation, operationAvailability, value, networkSubscription, this._clearCacheEntry);
            this._cache.set(cacheIdentifier, cacheEntry);
        }
        return cacheEntry;
    };
    _proto._fetchAndSaveQuery = function _fetchAndSaveQuery(cacheIdentifier, operation, fetchObservable, fetchPolicy, renderPolicy, profilerContext, observer) {
        var _this2 = this;
        var environment = this._environment;
        var queryAvailability = environment.check(operation);
        var queryStatus = queryAvailability.status;
        var hasFullQuery = queryStatus === 'available';
        var canPartialRender = hasFullQuery || renderPolicy === 'partial' && queryStatus !== 'stale';
        var shouldFetch;
        var shouldAllowRender;
        var resolveNetworkPromise = function resolveNetworkPromise() {};
        switch(fetchPolicy){
            case 'store-only':
                shouldFetch = false;
                shouldAllowRender = true;
                break;
            case 'store-or-network':
                shouldFetch = !hasFullQuery;
                shouldAllowRender = canPartialRender;
                break;
            case 'store-and-network':
                shouldFetch = true;
                shouldAllowRender = canPartialRender;
                break;
            case 'network-only':
            default:
                shouldFetch = true;
                shouldAllowRender = false;
                break;
        }
        if (shouldAllowRender) {
            var queryResult = $ad2d125b86175bda$var$getQueryResult(operation, cacheIdentifier);
            var _cacheEntry = $ad2d125b86175bda$var$createCacheEntry(cacheIdentifier, operation, queryAvailability, queryResult, null, this._clearCacheEntry);
            this._cache.set(cacheIdentifier, _cacheEntry);
        }
        if (shouldFetch) {
            var _queryResult = $ad2d125b86175bda$var$getQueryResult(operation, cacheIdentifier);
            var networkSubscription;
            fetchObservable.subscribe({
                start: function start(subscription) {
                    networkSubscription = subscription;
                    var cacheEntry = _this2._cache.get(cacheIdentifier);
                    if (cacheEntry) cacheEntry.setNetworkSubscription(networkSubscription);
                    var observerStart = observer === null || observer === void 0 ? void 0 : observer.start;
                    if (observerStart) {
                        var subscriptionWithConditionalCancelation = (0, $ad2d125b86175bda$var$_objectSpread2["default"])((0, $ad2d125b86175bda$var$_objectSpread2["default"])({}, subscription), {}, {
                            unsubscribe: function unsubscribe() {
                                if ($ad2d125b86175bda$var$operationIsLiveQuery(operation)) subscription.unsubscribe();
                            }
                        });
                        observerStart(subscriptionWithConditionalCancelation);
                    }
                },
                next: function next() {
                    var cacheEntry = _this2._getOrCreateCacheEntry(cacheIdentifier, operation, queryAvailability, _queryResult, networkSubscription);
                    cacheEntry.processedPayloadsCount += 1;
                    cacheEntry.setValue(_queryResult);
                    resolveNetworkPromise();
                    var observerNext = observer === null || observer === void 0 ? void 0 : observer.next;
                    if (observerNext != null) {
                        var snapshot = environment.lookup(operation.fragment);
                        observerNext(snapshot);
                    }
                },
                error: function error(_error) {
                    var cacheEntry = _this2._getOrCreateCacheEntry(cacheIdentifier, operation, queryAvailability, _error, networkSubscription);
                    if (cacheEntry.processedPayloadsCount === 0) cacheEntry.setValue(_error);
                    resolveNetworkPromise();
                    networkSubscription = null;
                    cacheEntry.setNetworkSubscription(null);
                    var observerError = observer === null || observer === void 0 ? void 0 : observer.error;
                    observerError && observerError(_error);
                },
                complete: function complete() {
                    resolveNetworkPromise();
                    networkSubscription = null;
                    var cacheEntry = _this2._cache.get(cacheIdentifier);
                    if (cacheEntry) cacheEntry.setNetworkSubscription(null);
                    var observerComplete = observer === null || observer === void 0 ? void 0 : observer.complete;
                    observerComplete && observerComplete();
                },
                unsubscribe: observer === null || observer === void 0 ? void 0 : observer.unsubscribe
            });
            var _cacheEntry2 = this._cache.get(cacheIdentifier);
            if (!_cacheEntry2) {
                var networkPromise = new Promise(function(resolve) {
                    resolveNetworkPromise = resolve;
                });
                networkPromise.displayName = 'Relay(' + operation.fragment.node.name + ')';
                _cacheEntry2 = $ad2d125b86175bda$var$createCacheEntry(cacheIdentifier, operation, queryAvailability, networkPromise, networkSubscription, this._clearCacheEntry);
                this._cache.set(cacheIdentifier, _cacheEntry2);
            }
        } else {
            var observerComplete = observer === null || observer === void 0 ? void 0 : observer.complete;
            observerComplete && observerComplete();
        }
        var cacheEntry = this._cache.get(cacheIdentifier);
        !(cacheEntry != null) && $423Vm(false);
        environment.__log({
            name: 'queryresource.fetch',
            resourceID: cacheEntry.id,
            operation: operation,
            profilerContext: profilerContext,
            fetchPolicy: fetchPolicy,
            renderPolicy: renderPolicy,
            queryAvailability: queryAvailability,
            shouldFetch: shouldFetch
        });
        return cacheEntry;
    };
    return QueryResourceImpl;
}();
function $ad2d125b86175bda$var$createQueryResource(environment) {
    return new $ad2d125b86175bda$var$QueryResourceImpl(environment);
}
var $ad2d125b86175bda$var$dataResources = $ad2d125b86175bda$var$WEAKMAP_SUPPORTED ? new WeakMap() : new Map();
function $ad2d125b86175bda$var$getQueryResourceForEnvironment(environment) {
    var cached = $ad2d125b86175bda$var$dataResources.get(environment);
    if (cached) return cached;
    var newDataResource = $ad2d125b86175bda$var$createQueryResource(environment);
    $ad2d125b86175bda$var$dataResources.set(environment, newDataResource);
    return newDataResource;
}
module.exports = {
    createQueryResource: $ad2d125b86175bda$var$createQueryResource,
    getQueryResourceForEnvironment: $ad2d125b86175bda$var$getQueryResourceForEnvironment,
    getQueryCacheIdentifier: $ad2d125b86175bda$var$getQueryCacheIdentifier
};

});
parcelRegister("ipJzn", function(module, exports) {
'use strict';

var $423Vm = parcelRequire("423Vm");
var $d67de8f0dc46030b$var$LRUCache = /*#__PURE__*/ function() {
    function LRUCache(capacity) {
        this._capacity = capacity;
        !(this._capacity > 0) && $423Vm(false);
        this._map = new Map();
    }
    var _proto = LRUCache.prototype;
    _proto.set = function set(key, value) {
        this._map["delete"](key);
        this._map.set(key, value);
        if (this._map.size > this._capacity) {
            var firstKey = this._map.keys().next();
            if (!firstKey.done) this._map["delete"](firstKey.value);
        }
    };
    _proto.get = function get(key) {
        var value = this._map.get(key);
        if (value != null) {
            this._map["delete"](key);
            this._map.set(key, value);
        }
        return value;
    };
    _proto.has = function has(key) {
        return this._map.has(key);
    };
    _proto["delete"] = function _delete(key) {
        this._map["delete"](key);
    };
    _proto.size = function size() {
        return this._map.size;
    };
    _proto.capacity = function capacity() {
        return this._capacity - this._map.size;
    };
    _proto.clear = function clear() {
        this._map.clear();
    };
    return LRUCache;
}();
function $d67de8f0dc46030b$var$create(capacity) {
    return new $d67de8f0dc46030b$var$LRUCache(capacity);
}
module.exports = {
    create: $d67de8f0dc46030b$var$create
};

});

parcelRegister("fso1r", function(module, exports) {
'use strict';

var $7Wmh0 = parcelRequire("7Wmh0");
var $b40c1ae015e103b0$var$_interopRequireDefault = $7Wmh0.default;

var $b40c1ae015e103b0$var$_defineProperty2 = $b40c1ae015e103b0$var$_interopRequireDefault((parcelRequire("ky4V8")));
parcelRequire("dH6ue");
var $b40c1ae015e103b0$var$TEMPORARY_RETAIN_DURATION_MS = 300000;
var $b40c1ae015e103b0$var$SuspenseResource = /*#__PURE__*/ function() {
    function SuspenseResource(retain) {
        var _this = this;
        (0, $b40c1ae015e103b0$var$_defineProperty2["default"])(this, "_retainCount", 0);
        (0, $b40c1ae015e103b0$var$_defineProperty2["default"])(this, "_retainDisposable", null);
        (0, $b40c1ae015e103b0$var$_defineProperty2["default"])(this, "_releaseTemporaryRetain", null);
        this._retain = function(environment) {
            _this._retainCount++;
            if (_this._retainCount === 1) _this._retainDisposable = retain(environment);
            return {
                dispose: function dispose() {
                    _this._retainCount = Math.max(0, _this._retainCount - 1);
                    if (_this._retainCount === 0) {
                        if (_this._retainDisposable != null) {
                            _this._retainDisposable.dispose();
                            _this._retainDisposable = null;
                        }
                    }
                }
            };
        };
    }
    var _proto = SuspenseResource.prototype;
    _proto.temporaryRetain = function temporaryRetain(environment) {
        var _this2 = this;
        var _this$_releaseTempora;
        if (environment.isServer()) return {
            dispose: function dispose() {}
        };
        var retention = this._retain(environment);
        var releaseQueryTimeout = null;
        var releaseTemporaryRetain = function releaseTemporaryRetain() {
            clearTimeout(releaseQueryTimeout);
            releaseQueryTimeout = null;
            _this2._releaseTemporaryRetain = null;
            retention.dispose();
        };
        releaseQueryTimeout = setTimeout(releaseTemporaryRetain, $b40c1ae015e103b0$var$TEMPORARY_RETAIN_DURATION_MS);
        (_this$_releaseTempora = this._releaseTemporaryRetain) === null || _this$_releaseTempora === void 0 || _this$_releaseTempora.call(this);
        this._releaseTemporaryRetain = releaseTemporaryRetain;
        return {
            dispose: function dispose() {
                var _this$_releaseTempora2;
                (_this$_releaseTempora2 = _this2._releaseTemporaryRetain) === null || _this$_releaseTempora2 === void 0 || _this$_releaseTempora2.call(_this2);
            }
        };
    };
    _proto.permanentRetain = function permanentRetain(environment) {
        var disposable = this._retain(environment);
        this.releaseTemporaryRetain();
        return disposable;
    };
    _proto.releaseTemporaryRetain = function releaseTemporaryRetain() {
        var _this$_releaseTempora3;
        (_this$_releaseTempora3 = this._releaseTemporaryRetain) === null || _this$_releaseTempora3 === void 0 || _this$_releaseTempora3.call(this);
        this._releaseTemporaryRetain = null;
    };
    _proto.getRetainCount = function getRetainCount() {
        return this._retainCount;
    };
    return SuspenseResource;
}();
module.exports = $b40c1ae015e103b0$var$SuspenseResource;

});


parcelRegister("cfu4g", function(module, exports) {
'use strict';

var $aBQW7 = parcelRequire("aBQW7");

var $eJOHy = parcelRequire("eJOHy");
var $8eae359a39f84f7a$var$useCallback = $eJOHy.useCallback, $8eae359a39f84f7a$var$useEffect = $eJOHy.useEffect;
function $8eae359a39f84f7a$var$useFetchTrackingRef() {
    var subscriptionRef = $aBQW7(null);
    var isFetchingRef = $aBQW7(false);
    var disposeFetch = $8eae359a39f84f7a$var$useCallback(function() {
        if (subscriptionRef.current != null) {
            subscriptionRef.current.unsubscribe();
            subscriptionRef.current = null;
        }
        isFetchingRef.current = false;
    }, []);
    var startFetch = $8eae359a39f84f7a$var$useCallback(function(subscription) {
        subscriptionRef.current = subscription;
        isFetchingRef.current = true;
    }, []);
    var completeFetch = $8eae359a39f84f7a$var$useCallback(function() {
        subscriptionRef.current = null;
        isFetchingRef.current = false;
    }, []);
    $8eae359a39f84f7a$var$useEffect(function() {
        return disposeFetch;
    }, [
        disposeFetch
    ]);
    return {
        isFetchingRef: isFetchingRef,
        startFetch: startFetch,
        disposeFetch: disposeFetch,
        completeFetch: completeFetch
    };
}
module.exports = $8eae359a39f84f7a$var$useFetchTrackingRef;

});
parcelRegister("aBQW7", function(module, exports) {
'use strict';

var $eJOHy = parcelRequire("eJOHy");
var $7b966c25e34413c3$var$useMemo = $eJOHy.useMemo;
function $7b966c25e34413c3$var$useUnsafeRef_DEPRECATED(init) {
    return $7b966c25e34413c3$var$useMemo(function() {
        return {
            current: init
        };
    }, []);
}
module.exports = $7b966c25e34413c3$var$useUnsafeRef_DEPRECATED;

});


parcelRegister("810gN", function(module, exports) {
'use strict';

var $7Wmh0 = parcelRequire("7Wmh0");
var $5d5ea0564d57c601$var$_interopRequireDefault = $7Wmh0.default;

var $5d5ea0564d57c601$var$_objectSpread2 = $5d5ea0564d57c601$var$_interopRequireDefault((parcelRequire("1sB2t")));

var $5d5ea0564d57c601$var$_createForOfIteratorHelper2 = $5d5ea0564d57c601$var$_interopRequireDefault((parcelRequire("9CLQ8")));

var $5d5ea0564d57c601$var$_toConsumableArray2 = $5d5ea0564d57c601$var$_interopRequireDefault((parcelRequire("gHCmS")));

var $eROlK = parcelRequire("eROlK");
var $5d5ea0564d57c601$var$getQueryResourceForEnvironment = $eROlK.getQueryResourceForEnvironment;

var $i764d = parcelRequire("i764d");

var $423Vm = parcelRequire("423Vm");

var $eJOHy = parcelRequire("eJOHy");
var $5d5ea0564d57c601$var$useDebugValue = $eJOHy.useDebugValue, $5d5ea0564d57c601$var$useEffect = $eJOHy.useEffect, $5d5ea0564d57c601$var$useMemo = $eJOHy.useMemo, $5d5ea0564d57c601$var$useRef = $eJOHy.useRef, $5d5ea0564d57c601$var$useState = $eJOHy.useState;

var $37Ewn = parcelRequire("37Ewn");
var $5d5ea0564d57c601$var$_require3$__internal = $37Ewn.__internal, $5d5ea0564d57c601$var$fetchQueryInternal = $5d5ea0564d57c601$var$_require3$__internal.fetchQuery, $5d5ea0564d57c601$var$getPromiseForActiveRequest = $5d5ea0564d57c601$var$_require3$__internal.getPromiseForActiveRequest, $5d5ea0564d57c601$var$RelayFeatureFlags = $37Ewn.RelayFeatureFlags, $5d5ea0564d57c601$var$areEqualSelectors = $37Ewn.areEqualSelectors, $5d5ea0564d57c601$var$createOperationDescriptor = $37Ewn.createOperationDescriptor, $5d5ea0564d57c601$var$getPendingOperationsForFragment = $37Ewn.getPendingOperationsForFragment, $5d5ea0564d57c601$var$getSelector = $37Ewn.getSelector, $5d5ea0564d57c601$var$getVariablesFromFragment = $37Ewn.getVariablesFromFragment, $5d5ea0564d57c601$var$handlePotentialSnapshotErrors = $37Ewn.handlePotentialSnapshotErrors, $5d5ea0564d57c601$var$recycleNodesInto = $37Ewn.recycleNodesInto;
parcelRequire("dH6ue");
function $5d5ea0564d57c601$var$isMissingData(state) {
    if (state.kind === 'bailout') return false;
    else if (state.kind === 'singular') return state.snapshot.isMissingData;
    else return state.snapshots.some(function(s) {
        return s.isMissingData;
    });
}
function $5d5ea0564d57c601$var$getMissingClientEdges(state) {
    if (state.kind === 'bailout') return null;
    else if (state.kind === 'singular') {
        var _state$snapshot$missi;
        return (_state$snapshot$missi = state.snapshot.missingClientEdges) !== null && _state$snapshot$missi !== void 0 ? _state$snapshot$missi : null;
    } else {
        var edges = null;
        var _iterator = (0, $5d5ea0564d57c601$var$_createForOfIteratorHelper2["default"])(state.snapshots), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var snapshot = _step.value;
                if (snapshot.missingClientEdges) {
                    var _edges;
                    edges = (_edges = edges) !== null && _edges !== void 0 ? _edges : [];
                    var _iterator2 = (0, $5d5ea0564d57c601$var$_createForOfIteratorHelper2["default"])(snapshot.missingClientEdges), _step2;
                    try {
                        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                            var edge = _step2.value;
                            edges.push(edge);
                        }
                    } catch (err) {
                        _iterator2.e(err);
                    } finally{
                        _iterator2.f();
                    }
                }
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return edges;
    }
}
function $5d5ea0564d57c601$var$getSuspendingLiveResolver(state) {
    if (state.kind === 'bailout') return null;
    else if (state.kind === 'singular') {
        var _state$snapshot$missi2;
        return (_state$snapshot$missi2 = state.snapshot.missingLiveResolverFields) !== null && _state$snapshot$missi2 !== void 0 ? _state$snapshot$missi2 : null;
    } else {
        var missingFields = null;
        var _iterator3 = (0, $5d5ea0564d57c601$var$_createForOfIteratorHelper2["default"])(state.snapshots), _step3;
        try {
            for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                var snapshot = _step3.value;
                if (snapshot.missingLiveResolverFields) {
                    var _missingFields;
                    missingFields = (_missingFields = missingFields) !== null && _missingFields !== void 0 ? _missingFields : [];
                    var _iterator4 = (0, $5d5ea0564d57c601$var$_createForOfIteratorHelper2["default"])(snapshot.missingLiveResolverFields), _step4;
                    try {
                        for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                            var edge = _step4.value;
                            missingFields.push(edge);
                        }
                    } catch (err) {
                        _iterator4.e(err);
                    } finally{
                        _iterator4.f();
                    }
                }
            }
        } catch (err) {
            _iterator3.e(err);
        } finally{
            _iterator3.f();
        }
        return missingFields;
    }
}
function $5d5ea0564d57c601$var$handlePotentialSnapshotErrorsForState(environment, state) {
    if (state.kind === 'singular') {
        var _state$snapshot$selec, _state$snapshot$selec2;
        $5d5ea0564d57c601$var$handlePotentialSnapshotErrors(environment, state.snapshot.missingRequiredFields, state.snapshot.relayResolverErrors, state.snapshot.errorResponseFields, (_state$snapshot$selec = (_state$snapshot$selec2 = state.snapshot.selector.node.metadata) === null || _state$snapshot$selec2 === void 0 ? void 0 : _state$snapshot$selec2.throwOnFieldError) !== null && _state$snapshot$selec !== void 0 ? _state$snapshot$selec : false);
    } else if (state.kind === 'plural') {
        var _iterator5 = (0, $5d5ea0564d57c601$var$_createForOfIteratorHelper2["default"])(state.snapshots), _step5;
        try {
            for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                var _snapshot$selector$no, _snapshot$selector$no2;
                var snapshot = _step5.value;
                $5d5ea0564d57c601$var$handlePotentialSnapshotErrors(environment, snapshot.missingRequiredFields, snapshot.relayResolverErrors, snapshot.errorResponseFields, (_snapshot$selector$no = (_snapshot$selector$no2 = snapshot.selector.node.metadata) === null || _snapshot$selector$no2 === void 0 ? void 0 : _snapshot$selector$no2.throwOnFieldError) !== null && _snapshot$selector$no !== void 0 ? _snapshot$selector$no : false);
            }
        } catch (err) {
            _iterator5.e(err);
        } finally{
            _iterator5.f();
        }
    }
}
function $5d5ea0564d57c601$var$handleMissedUpdates(environment, state) {
    if (state.kind === 'bailout') return null;
    var currentEpoch = environment.getStore().getEpoch();
    if (currentEpoch === state.epoch) return null;
    if (state.kind === 'singular') {
        var currentSnapshot = environment.lookup(state.snapshot.selector);
        var updatedData = $5d5ea0564d57c601$var$recycleNodesInto(state.snapshot.data, currentSnapshot.data);
        var updatedCurrentSnapshot = {
            data: updatedData,
            isMissingData: currentSnapshot.isMissingData,
            missingClientEdges: currentSnapshot.missingClientEdges,
            missingLiveResolverFields: currentSnapshot.missingLiveResolverFields,
            seenRecords: currentSnapshot.seenRecords,
            selector: currentSnapshot.selector,
            missingRequiredFields: currentSnapshot.missingRequiredFields,
            relayResolverErrors: currentSnapshot.relayResolverErrors,
            errorResponseFields: currentSnapshot.errorResponseFields
        };
        return [
            updatedData !== state.snapshot.data,
            {
                kind: 'singular',
                snapshot: updatedCurrentSnapshot,
                epoch: currentEpoch
            }
        ];
    } else {
        var didMissUpdates = false;
        var currentSnapshots = [];
        for(var index = 0; index < state.snapshots.length; index++){
            var snapshot = state.snapshots[index];
            var _currentSnapshot = environment.lookup(snapshot.selector);
            var _updatedData = $5d5ea0564d57c601$var$recycleNodesInto(snapshot.data, _currentSnapshot.data);
            var _updatedCurrentSnapshot = {
                data: _updatedData,
                isMissingData: _currentSnapshot.isMissingData,
                missingClientEdges: _currentSnapshot.missingClientEdges,
                missingLiveResolverFields: _currentSnapshot.missingLiveResolverFields,
                seenRecords: _currentSnapshot.seenRecords,
                selector: _currentSnapshot.selector,
                missingRequiredFields: _currentSnapshot.missingRequiredFields,
                relayResolverErrors: _currentSnapshot.relayResolverErrors,
                errorResponseFields: _currentSnapshot.errorResponseFields
            };
            if (_updatedData !== snapshot.data) didMissUpdates = true;
            currentSnapshots.push(_updatedCurrentSnapshot);
        }
        !(currentSnapshots.length === state.snapshots.length) && $423Vm(false);
        return [
            didMissUpdates,
            {
                kind: 'plural',
                snapshots: currentSnapshots,
                epoch: currentEpoch
            }
        ];
    }
}
function $5d5ea0564d57c601$var$handleMissingClientEdge(environment, parentFragmentNode, parentFragmentRef, missingClientEdgeRequestInfo, queryOptions) {
    var originalVariables = $5d5ea0564d57c601$var$getVariablesFromFragment(parentFragmentNode, parentFragmentRef);
    var variables = (0, $5d5ea0564d57c601$var$_objectSpread2["default"])((0, $5d5ea0564d57c601$var$_objectSpread2["default"])({}, originalVariables), {}, {
        id: missingClientEdgeRequestInfo.clientEdgeDestinationID
    });
    var queryOperationDescriptor = $5d5ea0564d57c601$var$createOperationDescriptor(missingClientEdgeRequestInfo.request, variables, queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.networkCacheConfig);
    var QueryResource = $5d5ea0564d57c601$var$getQueryResourceForEnvironment(environment);
    var queryResult = QueryResource.prepare(queryOperationDescriptor, $5d5ea0564d57c601$var$fetchQueryInternal(environment, queryOperationDescriptor), queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.fetchPolicy);
    return [
        queryResult,
        $5d5ea0564d57c601$var$getPromiseForActiveRequest(environment, queryOperationDescriptor.request)
    ];
}
function $5d5ea0564d57c601$var$subscribeToSnapshot(environment, state, setState, hasPendingStateChanges) {
    if (state.kind === 'bailout') return function() {};
    else if (state.kind === 'singular') {
        var disposable = environment.subscribe(state.snapshot, function(latestSnapshot) {
            setState(function(prevState) {
                if (prevState.kind !== 'singular' || prevState.snapshot.selector !== latestSnapshot.selector) {
                    var updates = $5d5ea0564d57c601$var$handleMissedUpdates(environment, prevState);
                    if (updates != null) {
                        var dataChanged = updates[0], nextState = updates[1];
                        environment.__log({
                            name: 'useFragment.subscription.missedUpdates',
                            hasDataChanges: dataChanged
                        });
                        hasPendingStateChanges.current = dataChanged;
                        return dataChanged ? nextState : prevState;
                    } else return prevState;
                }
                hasPendingStateChanges.current = true;
                return {
                    kind: 'singular',
                    snapshot: latestSnapshot,
                    epoch: environment.getStore().getEpoch()
                };
            });
        });
        return function() {
            disposable.dispose();
        };
    } else {
        var disposables = state.snapshots.map(function(snapshot, index) {
            return environment.subscribe(snapshot, function(latestSnapshot) {
                setState(function(prevState) {
                    var _prevState$snapshots$;
                    if (prevState.kind !== 'plural' || ((_prevState$snapshots$ = prevState.snapshots[index]) === null || _prevState$snapshots$ === void 0 ? void 0 : _prevState$snapshots$.selector) !== latestSnapshot.selector) {
                        var updates = $5d5ea0564d57c601$var$handleMissedUpdates(environment, prevState);
                        if (updates != null) {
                            var dataChanged = updates[0], nextState = updates[1];
                            environment.__log({
                                name: 'useFragment.subscription.missedUpdates',
                                hasDataChanges: dataChanged
                            });
                            hasPendingStateChanges.current = hasPendingStateChanges.current || dataChanged;
                            return dataChanged ? nextState : prevState;
                        } else return prevState;
                    }
                    var updated = (0, $5d5ea0564d57c601$var$_toConsumableArray2["default"])(prevState.snapshots);
                    updated[index] = latestSnapshot;
                    hasPendingStateChanges.current = true;
                    return {
                        kind: 'plural',
                        snapshots: updated,
                        epoch: environment.getStore().getEpoch()
                    };
                });
            });
        });
        return function() {
            var _iterator6 = (0, $5d5ea0564d57c601$var$_createForOfIteratorHelper2["default"])(disposables), _step6;
            try {
                for(_iterator6.s(); !(_step6 = _iterator6.n()).done;){
                    var d = _step6.value;
                    d.dispose();
                }
            } catch (err) {
                _iterator6.e(err);
            } finally{
                _iterator6.f();
            }
        };
    }
}
function $5d5ea0564d57c601$var$getFragmentState(environment, fragmentSelector) {
    if (fragmentSelector == null) return {
        kind: 'bailout'
    };
    else if (fragmentSelector.kind === 'PluralReaderSelector') return {
        kind: 'plural',
        snapshots: fragmentSelector.selectors.map(function(s) {
            return environment.lookup(s);
        }),
        epoch: environment.getStore().getEpoch()
    };
    else return {
        kind: 'singular',
        snapshot: environment.lookup(fragmentSelector),
        epoch: environment.getStore().getEpoch()
    };
}
function $5d5ea0564d57c601$var$useFragmentInternal(fragmentNode, fragmentRef, hookDisplayName, queryOptions) {
    var _fragmentNode$metadat, _fragmentNode$metadat2;
    var fragmentSelector = $5d5ea0564d57c601$var$useMemo(function() {
        return $5d5ea0564d57c601$var$getSelector(fragmentNode, fragmentRef);
    }, [
        fragmentNode,
        fragmentRef
    ]);
    var isPlural = (fragmentNode === null || fragmentNode === void 0 ? void 0 : (_fragmentNode$metadat = fragmentNode.metadata) === null || _fragmentNode$metadat === void 0 ? void 0 : _fragmentNode$metadat.plural) === true;
    if (isPlural) !(fragmentRef == null || Array.isArray(fragmentRef)) && $423Vm(false);
    else !!Array.isArray(fragmentRef) && $423Vm(false);
    !(fragmentRef == null || isPlural && Array.isArray(fragmentRef) && fragmentRef.length === 0 || fragmentSelector != null) && $423Vm(false);
    var environment = $i764d();
    var _useState = $5d5ea0564d57c601$var$useState(function() {
        return $5d5ea0564d57c601$var$getFragmentState(environment, fragmentSelector);
    }), _state = _useState[0], setState = _useState[1];
    var state = _state;
    var _useState2 = $5d5ea0564d57c601$var$useState(state), _subscribedState = _useState2[0], setSubscribedState = _useState2[1];
    var subscribedState = _subscribedState;
    var _useState3 = $5d5ea0564d57c601$var$useState(fragmentSelector), previousFragmentSelector = _useState3[0], setPreviousFragmentSelector = _useState3[1];
    var _useState4 = $5d5ea0564d57c601$var$useState(environment), previousEnvironment = _useState4[0], setPreviousEnvironment = _useState4[1];
    if (!$5d5ea0564d57c601$var$areEqualSelectors(fragmentSelector, previousFragmentSelector) || environment !== previousEnvironment) {
        setPreviousFragmentSelector(fragmentSelector);
        setPreviousEnvironment(environment);
        var newState = $5d5ea0564d57c601$var$getFragmentState(environment, fragmentSelector);
        setState(newState);
        setSubscribedState(newState);
        state = newState;
        subscribedState = newState;
    }
    var committedFragmentSelectorRef = $5d5ea0564d57c601$var$useRef(false);
    $5d5ea0564d57c601$var$useEffect(function() {
        committedFragmentSelectorRef.current = fragmentSelector;
    }, [
        fragmentSelector
    ]);
    if (((_fragmentNode$metadat2 = fragmentNode.metadata) === null || _fragmentNode$metadat2 === void 0 ? void 0 : _fragmentNode$metadat2.hasClientEdges) === true) {
        var _useMemo = $5d5ea0564d57c601$var$useMemo(function() {
            var missingClientEdges = $5d5ea0564d57c601$var$getMissingClientEdges(state);
            var clientEdgeQueries;
            var activeRequestPromises = [];
            if (missingClientEdges !== null && missingClientEdges !== void 0 && missingClientEdges.length) {
                clientEdgeQueries = [];
                var _iterator7 = (0, $5d5ea0564d57c601$var$_createForOfIteratorHelper2["default"])(missingClientEdges), _step7;
                try {
                    for(_iterator7.s(); !(_step7 = _iterator7.n()).done;){
                        var edge = _step7.value;
                        var _handleMissingClientE = $5d5ea0564d57c601$var$handleMissingClientEdge(environment, fragmentNode, fragmentRef, edge, queryOptions), queryResult = _handleMissingClientE[0], requestPromise = _handleMissingClientE[1];
                        clientEdgeQueries.push(queryResult);
                        if (requestPromise != null) activeRequestPromises.push(requestPromise);
                    }
                } catch (err) {
                    _iterator7.e(err);
                } finally{
                    _iterator7.f();
                }
            }
            return [
                clientEdgeQueries,
                activeRequestPromises
            ];
        }, [
            state,
            environment,
            fragmentNode,
            fragmentRef,
            queryOptions
        ]), clientEdgeQueries = _useMemo[0], activeRequestPromises = _useMemo[1];
        if (activeRequestPromises.length) throw Promise.all(activeRequestPromises);
        $5d5ea0564d57c601$var$useEffect(function() {
            var QueryResource = $5d5ea0564d57c601$var$getQueryResourceForEnvironment(environment);
            if (clientEdgeQueries !== null && clientEdgeQueries !== void 0 && clientEdgeQueries.length) {
                var disposables = [];
                var _iterator8 = (0, $5d5ea0564d57c601$var$_createForOfIteratorHelper2["default"])(clientEdgeQueries), _step8;
                try {
                    for(_iterator8.s(); !(_step8 = _iterator8.n()).done;){
                        var query = _step8.value;
                        disposables.push(QueryResource.retain(query));
                    }
                } catch (err) {
                    _iterator8.e(err);
                } finally{
                    _iterator8.f();
                }
                return function() {
                    var _iterator9 = (0, $5d5ea0564d57c601$var$_createForOfIteratorHelper2["default"])(disposables), _step9;
                    try {
                        for(_iterator9.s(); !(_step9 = _iterator9.n()).done;){
                            var disposable = _step9.value;
                            disposable.dispose();
                        }
                    } catch (err) {
                        _iterator9.e(err);
                    } finally{
                        _iterator9.f();
                    }
                };
            }
        }, [
            environment,
            clientEdgeQueries
        ]);
    }
    if ($5d5ea0564d57c601$var$isMissingData(state)) {
        var suspendingLiveResolvers = $5d5ea0564d57c601$var$getSuspendingLiveResolver(state);
        if (suspendingLiveResolvers != null && suspendingLiveResolvers.length > 0) throw Promise.all(suspendingLiveResolvers.map(function(_ref) {
            var liveStateID = _ref.liveStateID;
            return environment.getStore().getLiveResolverPromise(liveStateID);
        }));
        if ($5d5ea0564d57c601$var$RelayFeatureFlags.ENABLE_RELAY_OPERATION_TRACKER_SUSPENSE || environment !== previousEnvironment || !committedFragmentSelectorRef.current || !$5d5ea0564d57c601$var$areEqualSelectors(committedFragmentSelectorRef.current, fragmentSelector)) {
            !(fragmentSelector != null) && $423Vm(false);
            var fragmentOwner = fragmentSelector.kind === 'PluralReaderSelector' ? fragmentSelector.selectors[0].owner : fragmentSelector.owner;
            var pendingOperationsResult = $5d5ea0564d57c601$var$getPendingOperationsForFragment(environment, fragmentNode, fragmentOwner);
            if (pendingOperationsResult) throw pendingOperationsResult.promise;
        }
    }
    $5d5ea0564d57c601$var$handlePotentialSnapshotErrorsForState(environment, state);
    var hasPendingStateChanges = $5d5ea0564d57c601$var$useRef(false);
    $5d5ea0564d57c601$var$useEffect(function() {
        var currentState = subscribedState;
        var updates = $5d5ea0564d57c601$var$handleMissedUpdates(environment, subscribedState);
        if (updates !== null) {
            var didMissUpdates = updates[0], updatedState = updates[1];
            if (didMissUpdates) setState(updatedState);
            currentState = updatedState;
        }
        return $5d5ea0564d57c601$var$subscribeToSnapshot(environment, currentState, setState, hasPendingStateChanges);
    }, [
        environment,
        subscribedState
    ]);
    if (hasPendingStateChanges.current) {
        var updates = $5d5ea0564d57c601$var$handleMissedUpdates(environment, state);
        if (updates != null) {
            var hasStateUpdates = updates[0], updatedState = updates[1];
            if (hasStateUpdates) {
                setState(updatedState);
                state = updatedState;
            }
        }
        hasPendingStateChanges.current = false;
    }
    var data;
    if (isPlural) {
        var fragmentRefIsNullish = fragmentRef == null;
        data = $5d5ea0564d57c601$var$useMemo(function() {
            if (state.kind === 'bailout') return fragmentRefIsNullish ? null : [];
            else {
                !(state.kind === 'plural') && $423Vm(false);
                return state.snapshots.map(function(s) {
                    return s.data;
                });
            }
        }, [
            state,
            fragmentRefIsNullish
        ]);
    } else if (state.kind === 'bailout') data = null;
    else {
        !(state.kind === 'singular') && $423Vm(false);
        data = state.snapshot.data;
    }
    if ($5d5ea0564d57c601$var$RelayFeatureFlags.LOG_MISSING_RECORDS_IN_PROD || false) fragmentRef != null && (data === undefined || Array.isArray(data) && data.length > 0 && data.every(function(d) {
        return d === undefined;
    }));
    return data;
}
module.exports = $5d5ea0564d57c601$var$useFragmentInternal;

});


parcelRegister("jcK8M", function(module, exports) {
'use strict';

var $j9ccn = parcelRequire("j9ccn");

var $eJOHy = parcelRequire("eJOHy");

var $37Ewn = parcelRequire("37Ewn");
var $dfb2edde5359d0bd$var$createOperationDescriptor = $37Ewn.createOperationDescriptor, $dfb2edde5359d0bd$var$getRequest = $37Ewn.getRequest;
var $dfb2edde5359d0bd$var$useMemo = $eJOHy.useMemo;
function $dfb2edde5359d0bd$var$useMemoOperationDescriptor(gqlQuery, variables, cacheConfig) {
    var memoVariables = $j9ccn(variables);
    var memoCacheConfig = $j9ccn(cacheConfig || {});
    return $dfb2edde5359d0bd$var$useMemo(function() {
        return $dfb2edde5359d0bd$var$createOperationDescriptor($dfb2edde5359d0bd$var$getRequest(gqlQuery), memoVariables, memoCacheConfig);
    }, [
        gqlQuery,
        memoVariables,
        memoCacheConfig
    ]);
}
module.exports = $dfb2edde5359d0bd$var$useMemoOperationDescriptor;

});
parcelRegister("j9ccn", function(module, exports) {
'use strict';

var $jT3aJ = parcelRequire("jT3aJ");

var $eJOHy = parcelRequire("eJOHy");
var $df0851f72c703f6b$var$useState = $eJOHy.useState;
function $df0851f72c703f6b$var$useMemoVariables(variables) {
    var _useState = $df0851f72c703f6b$var$useState(variables), mirroredVariables = _useState[0], setMirroredVariables = _useState[1];
    if ($jT3aJ(variables, mirroredVariables)) return mirroredVariables;
    else {
        setMirroredVariables(variables);
        return variables;
    }
}
module.exports = $df0851f72c703f6b$var$useMemoVariables;

});




parcelRegister("iahTm", function(module, exports) {
'use strict';

var $7Wmh0 = parcelRequire("7Wmh0");
var $d3970a272c381933$var$_interopRequireDefault = $7Wmh0.default;

var $d3970a272c381933$var$_createForOfIteratorHelper2 = $d3970a272c381933$var$_interopRequireDefault((parcelRequire("9CLQ8")));

var $bdIJW = parcelRequire("bdIJW");

var $bQPKN = parcelRequire("bQPKN");
var $d3970a272c381933$var$useTrackLoadQueryInRender = $bQPKN.useTrackLoadQueryInRender;

var $ga5fu = parcelRequire("ga5fu");

var $eJOHy = parcelRequire("eJOHy");
var $d3970a272c381933$var$useCallback = $eJOHy.useCallback, $d3970a272c381933$var$useEffect = $eJOHy.useEffect, $d3970a272c381933$var$useRef = $eJOHy.useRef, $d3970a272c381933$var$useState = $eJOHy.useState;
var $d3970a272c381933$var$initialNullEntryPointReferenceState = {
    kind: 'NullEntryPointReference'
};
function $d3970a272c381933$var$useLoadEntryPoint(environmentProvider, entryPoint, options) {
    var _options$TEST_ONLY__i, _options$TEST_ONLY__i2, _options$TEST_ONLY__i3, _options$TEST_ONLY__i4;
    $d3970a272c381933$var$useTrackLoadQueryInRender();
    var initialEntryPointReferenceInternal = (_options$TEST_ONLY__i = options === null || options === void 0 ? void 0 : (_options$TEST_ONLY__i2 = options.TEST_ONLY__initialEntryPointData) === null || _options$TEST_ONLY__i2 === void 0 ? void 0 : _options$TEST_ONLY__i2.entryPointReference) !== null && _options$TEST_ONLY__i !== void 0 ? _options$TEST_ONLY__i : $d3970a272c381933$var$initialNullEntryPointReferenceState;
    var initialEntryPointParamsInternal = (_options$TEST_ONLY__i3 = options === null || options === void 0 ? void 0 : (_options$TEST_ONLY__i4 = options.TEST_ONLY__initialEntryPointData) === null || _options$TEST_ONLY__i4 === void 0 ? void 0 : _options$TEST_ONLY__i4.entryPointParams) !== null && _options$TEST_ONLY__i3 !== void 0 ? _options$TEST_ONLY__i3 : null;
    var isMountedRef = $ga5fu();
    var undisposedEntryPointReferencesRef = $d3970a272c381933$var$useRef(new Set([
        initialEntryPointReferenceInternal
    ]));
    var _useState = $d3970a272c381933$var$useState(initialEntryPointReferenceInternal), entryPointReference = _useState[0], setEntryPointReference = _useState[1];
    var _useState2 = $d3970a272c381933$var$useState(initialEntryPointParamsInternal), entryPointParams = _useState2[0], setEntryPointParams = _useState2[1];
    var disposeEntryPoint = $d3970a272c381933$var$useCallback(function() {
        if (isMountedRef.current) {
            var nullEntryPointReference = {
                kind: 'NullEntryPointReference'
            };
            undisposedEntryPointReferencesRef.current.add(nullEntryPointReference);
            setEntryPointReference(nullEntryPointReference);
        }
    }, [
        setEntryPointReference,
        isMountedRef
    ]);
    var entryPointLoaderCallback = $d3970a272c381933$var$useCallback(function(params) {
        if (isMountedRef.current) {
            var updatedEntryPointReference = $bdIJW(environmentProvider, entryPoint, params);
            undisposedEntryPointReferencesRef.current.add(updatedEntryPointReference);
            setEntryPointReference(updatedEntryPointReference);
            setEntryPointParams(params);
        }
    }, [
        environmentProvider,
        entryPoint,
        setEntryPointReference,
        isMountedRef
    ]);
    var maybeHiddenOrFastRefresh = $d3970a272c381933$var$useRef(false);
    $d3970a272c381933$var$useEffect(function() {
        return function() {
            maybeHiddenOrFastRefresh.current = true;
        };
    }, []);
    $d3970a272c381933$var$useEffect(function() {
        if (maybeHiddenOrFastRefresh.current === true) {
            maybeHiddenOrFastRefresh.current = false;
            if (entryPointReference.kind !== 'NullEntryPointReference' && entryPointParams != null) entryPointLoaderCallback(entryPointParams);
            return;
        }
        var undisposedEntryPointReferences = undisposedEntryPointReferencesRef.current;
        if (isMountedRef.current) {
            var _iterator = (0, $d3970a272c381933$var$_createForOfIteratorHelper2["default"])(undisposedEntryPointReferences), _step;
            try {
                for(_iterator.s(); !(_step = _iterator.n()).done;){
                    var undisposedEntryPointReference = _step.value;
                    if (undisposedEntryPointReference === entryPointReference) break;
                    undisposedEntryPointReferences["delete"](undisposedEntryPointReference);
                    if (undisposedEntryPointReference.kind !== 'NullEntryPointReference') undisposedEntryPointReference.dispose();
                }
            } catch (err) {
                _iterator.e(err);
            } finally{
                _iterator.f();
            }
        }
    }, [
        entryPointReference,
        entryPointParams,
        entryPointLoaderCallback,
        isMountedRef
    ]);
    $d3970a272c381933$var$useEffect(function() {
        return function disposeAllRemainingEntryPointReferences() {
            var _iterator2 = (0, $d3970a272c381933$var$_createForOfIteratorHelper2["default"])(undisposedEntryPointReferencesRef.current), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var unhandledStateChange = _step2.value;
                    if (unhandledStateChange.kind !== 'NullEntryPointReference') unhandledStateChange.dispose();
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
        };
    }, []);
    return [
        entryPointReference.kind === 'NullEntryPointReference' ? null : entryPointReference,
        entryPointLoaderCallback,
        disposeEntryPoint
    ];
}
module.exports = $d3970a272c381933$var$useLoadEntryPoint;

});
parcelRegister("ga5fu", function(module, exports) {
'use strict';

var $eJOHy = parcelRequire("eJOHy");
var $bc41a6d400a83499$var$useEffect = $eJOHy.useEffect, $bc41a6d400a83499$var$useRef = $eJOHy.useRef;
function $bc41a6d400a83499$var$useIsMountedRef() {
    var isMountedRef = $bc41a6d400a83499$var$useRef(true);
    $bc41a6d400a83499$var$useEffect(function() {
        isMountedRef.current = true;
        return function() {
            isMountedRef.current = false;
        };
    }, []);
    return isMountedRef;
}
module.exports = $bc41a6d400a83499$var$useIsMountedRef;

});


parcelRegister("kM8tH", function(module, exports) {
'use strict';

var $bQPKN = parcelRequire("bQPKN");
var $f1feddeb1feddf3c$var$useTrackLoadQueryInRender = $bQPKN.useTrackLoadQueryInRender;

var $810gN = parcelRequire("810gN");

var $3LVgx = parcelRequire("3LVgx");

var $eJOHy = parcelRequire("eJOHy");
var $f1feddeb1feddf3c$var$useDebugValue = $eJOHy.useDebugValue;

var $37Ewn = parcelRequire("37Ewn");
var $f1feddeb1feddf3c$var$getFragment = $37Ewn.getFragment;
function $f1feddeb1feddf3c$var$useFragment(fragment, key) {
    $f1feddeb1feddf3c$var$useTrackLoadQueryInRender();
    var fragmentNode = $f1feddeb1feddf3c$var$getFragment(fragment);
    $3LVgx(fragmentNode, 'first argument of useFragment()');
    var data = $810gN(fragmentNode, key, 'useFragment()');
    return data;
}
module.exports = $f1feddeb1feddf3c$var$useFragment;

});
parcelRegister("3LVgx", function(module, exports) {
'use strict';
parcelRequire("aBQW7");
parcelRequire("dH6ue");
function $2bf22ea4de2dd33d$var$useStaticFragmentNodeWarning(fragmentNode, warningContext) {
    var initialPropRef;
}
module.exports = $2bf22ea4de2dd33d$var$useStaticFragmentNodeWarning;

});


parcelRegister("dmpY4", function(module, exports) {
'use strict';

var $7Wmh0 = parcelRequire("7Wmh0");
var $9ba179201d43597f$var$_interopRequireDefault = $7Wmh0.default;

var $9ba179201d43597f$var$_objectSpread2 = $9ba179201d43597f$var$_interopRequireDefault((parcelRequire("1sB2t")));

var $ga5fu = parcelRequire("ga5fu");

var $i764d = parcelRequire("i764d");

var $eJOHy = parcelRequire("eJOHy");

var $37Ewn = parcelRequire("37Ewn");
var $9ba179201d43597f$var$defaultCommitMutation = $37Ewn.commitMutation;
var $9ba179201d43597f$var$useState = $eJOHy.useState, $9ba179201d43597f$var$useEffect = $eJOHy.useEffect, $9ba179201d43597f$var$useRef = $eJOHy.useRef, $9ba179201d43597f$var$useCallback = $eJOHy.useCallback;
function $9ba179201d43597f$var$useMutation(mutation) {
    var commitMutationFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $9ba179201d43597f$var$defaultCommitMutation;
    var environment = $i764d();
    var isMountedRef = $ga5fu();
    var environmentRef = $9ba179201d43597f$var$useRef(environment);
    var mutationRef = $9ba179201d43597f$var$useRef(mutation);
    var inFlightMutationsRef = $9ba179201d43597f$var$useRef(new Set());
    var _useState = $9ba179201d43597f$var$useState(false), isMutationInFlight = _useState[0], setMutationInFlight = _useState[1];
    var cleanup = $9ba179201d43597f$var$useCallback(function(disposable) {
        if (environmentRef.current === environment && mutationRef.current === mutation) {
            inFlightMutationsRef.current["delete"](disposable);
            if (isMountedRef.current) setMutationInFlight(inFlightMutationsRef.current.size > 0);
        }
    }, [
        environment,
        isMountedRef,
        mutation
    ]);
    $9ba179201d43597f$var$useEffect(function() {
        if (environmentRef.current !== environment || mutationRef.current !== mutation) {
            inFlightMutationsRef.current = new Set();
            if (isMountedRef.current) setMutationInFlight(false);
            environmentRef.current = environment;
            mutationRef.current = mutation;
        }
    }, [
        environment,
        isMountedRef,
        mutation
    ]);
    var commit = $9ba179201d43597f$var$useCallback(function(config) {
        if (isMountedRef.current) setMutationInFlight(true);
        var disposable = commitMutationFn(environment, (0, $9ba179201d43597f$var$_objectSpread2["default"])((0, $9ba179201d43597f$var$_objectSpread2["default"])({}, config), {}, {
            mutation: mutation,
            onCompleted: function onCompleted(response, errors) {
                var _config$onCompleted;
                cleanup(disposable);
                (_config$onCompleted = config.onCompleted) === null || _config$onCompleted === void 0 || _config$onCompleted.call(config, response, errors);
            },
            onError: function onError(error) {
                var _config$onError;
                cleanup(disposable);
                (_config$onError = config.onError) === null || _config$onError === void 0 || _config$onError.call(config, error);
            },
            onUnsubscribe: function onUnsubscribe() {
                var _config$onUnsubscribe;
                cleanup(disposable);
                (_config$onUnsubscribe = config.onUnsubscribe) === null || _config$onUnsubscribe === void 0 || _config$onUnsubscribe.call(config);
            },
            onNext: function onNext() {
                var _config$onNext;
                (_config$onNext = config.onNext) === null || _config$onNext === void 0 || _config$onNext.call(config);
            }
        }));
        inFlightMutationsRef.current.add(disposable);
        return disposable;
    }, [
        cleanup,
        commitMutationFn,
        environment,
        isMountedRef,
        mutation
    ]);
    return [
        commit,
        isMutationInFlight
    ];
}
module.exports = $9ba179201d43597f$var$useMutation;

});

parcelRegister("73jbJ", function(module, exports) {
'use strict';

var $7Wmh0 = parcelRequire("7Wmh0");
var $5227b2929a54e0be$var$_interopRequireDefault = $7Wmh0.default;

var $5227b2929a54e0be$var$_objectSpread2 = $5227b2929a54e0be$var$_interopRequireDefault((parcelRequire("1sB2t")));

var $kGxpc = parcelRequire("kGxpc");

var $9mvki = parcelRequire("9mvki");

var $i764d = parcelRequire("i764d");

var $3LVgx = parcelRequire("3LVgx");

var $eJOHy = parcelRequire("eJOHy");
var $5227b2929a54e0be$var$useCallback = $eJOHy.useCallback, $5227b2929a54e0be$var$useDebugValue = $eJOHy.useDebugValue, $5227b2929a54e0be$var$useState = $eJOHy.useState;

var $37Ewn = parcelRequire("37Ewn");
var $5227b2929a54e0be$var$getFragment = $37Ewn.getFragment, $5227b2929a54e0be$var$getFragmentIdentifier = $37Ewn.getFragmentIdentifier, $5227b2929a54e0be$var$getPaginationMetadata = $37Ewn.getPaginationMetadata;
function $5227b2929a54e0be$var$usePaginationFragment(fragmentInput, parentFragmentRef) {
    var fragmentNode = $5227b2929a54e0be$var$getFragment(fragmentInput);
    $3LVgx(fragmentNode, 'first argument of usePaginationFragment()');
    var componentDisplayName = 'usePaginationFragment()';
    var _getPaginationMetadat = $5227b2929a54e0be$var$getPaginationMetadata(fragmentNode, componentDisplayName), connectionPathInFragmentData = _getPaginationMetadat.connectionPathInFragmentData, paginationRequest = _getPaginationMetadat.paginationRequest, paginationMetadata = _getPaginationMetadat.paginationMetadata;
    var _useRefetchableFragme = $9mvki(fragmentNode, parentFragmentRef, componentDisplayName), fragmentData = _useRefetchableFragme.fragmentData, fragmentRef = _useRefetchableFragme.fragmentRef, refetch = _useRefetchableFragme.refetch;
    var fragmentIdentifier = $5227b2929a54e0be$var$getFragmentIdentifier(fragmentNode, fragmentRef);
    var _useLoadMore = $5227b2929a54e0be$var$useLoadMore({
        componentDisplayName: componentDisplayName,
        connectionPathInFragmentData: connectionPathInFragmentData,
        direction: 'backward',
        fragmentData: fragmentData,
        fragmentIdentifier: fragmentIdentifier,
        fragmentNode: fragmentNode,
        fragmentRef: fragmentRef,
        paginationMetadata: paginationMetadata,
        paginationRequest: paginationRequest
    }), loadPrevious = _useLoadMore[0], hasPrevious = _useLoadMore[1], isLoadingPrevious = _useLoadMore[2], disposeFetchPrevious = _useLoadMore[3];
    var _useLoadMore2 = $5227b2929a54e0be$var$useLoadMore({
        componentDisplayName: componentDisplayName,
        connectionPathInFragmentData: connectionPathInFragmentData,
        direction: 'forward',
        fragmentData: fragmentData,
        fragmentIdentifier: fragmentIdentifier,
        fragmentNode: fragmentNode,
        fragmentRef: fragmentRef,
        paginationMetadata: paginationMetadata,
        paginationRequest: paginationRequest
    }), loadNext = _useLoadMore2[0], hasNext = _useLoadMore2[1], isLoadingNext = _useLoadMore2[2], disposeFetchNext = _useLoadMore2[3];
    var refetchPagination = $5227b2929a54e0be$var$useCallback(function(variables, options) {
        disposeFetchNext();
        disposeFetchPrevious();
        return refetch(variables, (0, $5227b2929a54e0be$var$_objectSpread2["default"])((0, $5227b2929a54e0be$var$_objectSpread2["default"])({}, options), {}, {
            __environment: undefined
        }));
    }, [
        disposeFetchNext,
        disposeFetchPrevious,
        refetch
    ]);
    return {
        data: fragmentData,
        loadNext: loadNext,
        loadPrevious: loadPrevious,
        hasNext: hasNext,
        hasPrevious: hasPrevious,
        isLoadingNext: isLoadingNext,
        isLoadingPrevious: isLoadingPrevious,
        refetch: refetchPagination
    };
}
function $5227b2929a54e0be$var$useLoadMore(args) {
    var environment = $i764d();
    var _useState = $5227b2929a54e0be$var$useState(false), isLoadingMore = _useState[0], reallySetIsLoadingMore = _useState[1];
    var setIsLoadingMore = function setIsLoadingMore(value) {
        var _environment$getSched;
        var schedule = (_environment$getSched = environment.getScheduler()) === null || _environment$getSched === void 0 ? void 0 : _environment$getSched.schedule;
        if (schedule) schedule(function() {
            reallySetIsLoadingMore(value);
        });
        else reallySetIsLoadingMore(value);
    };
    var observer = {
        start: function start() {
            return setIsLoadingMore(true);
        },
        complete: function complete() {
            return setIsLoadingMore(false);
        },
        error: function error() {
            return setIsLoadingMore(false);
        }
    };
    var handleReset = function handleReset() {
        return setIsLoadingMore(false);
    };
    var _useLoadMoreFunction = $kGxpc((0, $5227b2929a54e0be$var$_objectSpread2["default"])((0, $5227b2929a54e0be$var$_objectSpread2["default"])({}, args), {}, {
        observer: observer,
        onReset: handleReset
    })), loadMore = _useLoadMoreFunction[0], hasMore = _useLoadMoreFunction[1], disposeFetch = _useLoadMoreFunction[2];
    return [
        loadMore,
        hasMore,
        isLoadingMore,
        disposeFetch
    ];
}
module.exports = $5227b2929a54e0be$var$usePaginationFragment;

});
parcelRegister("kGxpc", function(module, exports) {
'use strict';

var $7Wmh0 = parcelRequire("7Wmh0");
var $f0f1a489cc0e6cef$var$_interopRequireDefault = $7Wmh0.default;

var $f0f1a489cc0e6cef$var$_objectSpread2 = $f0f1a489cc0e6cef$var$_interopRequireDefault((parcelRequire("1sB2t")));

var $cfu4g = parcelRequire("cfu4g");

var $ga5fu = parcelRequire("ga5fu");

var $fay79 = parcelRequire("fay79");

var $i764d = parcelRequire("i764d");

var $423Vm = parcelRequire("423Vm");

var $eJOHy = parcelRequire("eJOHy");
var $f0f1a489cc0e6cef$var$useCallback = $eJOHy.useCallback, $f0f1a489cc0e6cef$var$useEffect = $eJOHy.useEffect, $f0f1a489cc0e6cef$var$useState = $eJOHy.useState;

var $37Ewn = parcelRequire("37Ewn");
var $f0f1a489cc0e6cef$var$fetchQuery = $37Ewn.__internal.fetchQuery, $f0f1a489cc0e6cef$var$ConnectionInterface = $37Ewn.ConnectionInterface, $f0f1a489cc0e6cef$var$createOperationDescriptor = $37Ewn.createOperationDescriptor, $f0f1a489cc0e6cef$var$getPaginationVariables = $37Ewn.getPaginationVariables, $f0f1a489cc0e6cef$var$getRefetchMetadata = $37Ewn.getRefetchMetadata, $f0f1a489cc0e6cef$var$getSelector = $37Ewn.getSelector, $f0f1a489cc0e6cef$var$getValueAtPath = $37Ewn.getValueAtPath;
parcelRequire("dH6ue");
function $f0f1a489cc0e6cef$var$useLoadMoreFunction(args) {
    var direction = args.direction, fragmentNode = args.fragmentNode, fragmentRef = args.fragmentRef, fragmentIdentifier = args.fragmentIdentifier, fragmentData = args.fragmentData, connectionPathInFragmentData = args.connectionPathInFragmentData, paginationRequest = args.paginationRequest, paginationMetadata = args.paginationMetadata, componentDisplayName = args.componentDisplayName, observer = args.observer, onReset = args.onReset;
    var environment = $i764d();
    var _useFetchTrackingRef = $cfu4g(), isFetchingRef = _useFetchTrackingRef.isFetchingRef, startFetch = _useFetchTrackingRef.startFetch, disposeFetch = _useFetchTrackingRef.disposeFetch, completeFetch = _useFetchTrackingRef.completeFetch;
    var _getRefetchMetadata = $f0f1a489cc0e6cef$var$getRefetchMetadata(fragmentNode, componentDisplayName), identifierInfo = _getRefetchMetadata.identifierInfo;
    var identifierValue = (identifierInfo === null || identifierInfo === void 0 ? void 0 : identifierInfo.identifierField) != null && fragmentData != null && typeof fragmentData === 'object' ? fragmentData[identifierInfo.identifierField] : null;
    var isMountedRef = $ga5fu();
    var _useState = $f0f1a489cc0e6cef$var$useState(environment), mirroredEnvironment = _useState[0], setMirroredEnvironment = _useState[1];
    var _useState2 = $f0f1a489cc0e6cef$var$useState(fragmentIdentifier), mirroredFragmentIdentifier = _useState2[0], setMirroredFragmentIdentifier = _useState2[1];
    var isParentQueryActive = $fay79(fragmentNode, fragmentRef);
    var shouldReset = environment !== mirroredEnvironment || fragmentIdentifier !== mirroredFragmentIdentifier;
    if (shouldReset) {
        disposeFetch();
        onReset();
        setMirroredEnvironment(environment);
        setMirroredFragmentIdentifier(fragmentIdentifier);
    }
    var _getConnectionState = $f0f1a489cc0e6cef$var$getConnectionState(direction, fragmentNode, fragmentData, connectionPathInFragmentData), cursor = _getConnectionState.cursor, hasMore = _getConnectionState.hasMore;
    $f0f1a489cc0e6cef$var$useEffect(function() {
        return function() {
            disposeFetch();
        };
    }, [
        disposeFetch
    ]);
    var loadMore = $f0f1a489cc0e6cef$var$useCallback(function(count, options) {
        var onComplete = options === null || options === void 0 ? void 0 : options.onComplete;
        if (isMountedRef.current !== true) return {
            dispose: function dispose() {}
        };
        var fragmentSelector = $f0f1a489cc0e6cef$var$getSelector(fragmentNode, fragmentRef);
        if (isFetchingRef.current === true || fragmentData == null || isParentQueryActive) {
            fragmentSelector;
            if (onComplete) onComplete(null);
            return {
                dispose: function dispose() {}
            };
        }
        !(fragmentSelector != null && fragmentSelector.kind !== 'PluralReaderSelector') && $423Vm(false);
        var parentVariables = fragmentSelector.owner.variables;
        var fragmentVariables = fragmentSelector.variables;
        var extraVariables = options === null || options === void 0 ? void 0 : options.UNSTABLE_extraVariables;
        var baseVariables = (0, $f0f1a489cc0e6cef$var$_objectSpread2["default"])((0, $f0f1a489cc0e6cef$var$_objectSpread2["default"])({}, parentVariables), fragmentVariables);
        var paginationVariables = $f0f1a489cc0e6cef$var$getPaginationVariables(direction, count, cursor, baseVariables, (0, $f0f1a489cc0e6cef$var$_objectSpread2["default"])({}, extraVariables), paginationMetadata);
        if (identifierInfo != null) {
            typeof identifierValue;
            paginationVariables[identifierInfo.identifierQueryVariableName] = identifierValue;
        }
        var paginationQuery = $f0f1a489cc0e6cef$var$createOperationDescriptor(paginationRequest, paginationVariables, {
            force: true
        });
        $f0f1a489cc0e6cef$var$fetchQuery(environment, paginationQuery).subscribe((0, $f0f1a489cc0e6cef$var$_objectSpread2["default"])((0, $f0f1a489cc0e6cef$var$_objectSpread2["default"])({}, observer), {}, {
            start: function start(subscription) {
                startFetch(subscription);
                observer.start && observer.start(subscription);
            },
            complete: function complete() {
                completeFetch();
                observer.complete && observer.complete();
                onComplete && onComplete(null);
            },
            error: function error(_error) {
                completeFetch();
                observer.error && observer.error(_error);
                onComplete && onComplete(_error);
            }
        }));
        return {
            dispose: disposeFetch
        };
    }, [
        environment,
        identifierValue,
        direction,
        cursor,
        startFetch,
        disposeFetch,
        completeFetch,
        isFetchingRef,
        isParentQueryActive,
        fragmentData,
        fragmentNode.name,
        fragmentRef,
        componentDisplayName
    ]);
    return [
        loadMore,
        hasMore,
        disposeFetch
    ];
}
function $f0f1a489cc0e6cef$var$getConnectionState(direction, fragmentNode, fragmentData, connectionPathInFragmentData) {
    var _pageInfo$END_CURSOR, _pageInfo$START_CURSO;
    var _ConnectionInterface$ = $f0f1a489cc0e6cef$var$ConnectionInterface.get(), EDGES = _ConnectionInterface$.EDGES, PAGE_INFO = _ConnectionInterface$.PAGE_INFO, HAS_NEXT_PAGE = _ConnectionInterface$.HAS_NEXT_PAGE, HAS_PREV_PAGE = _ConnectionInterface$.HAS_PREV_PAGE, END_CURSOR = _ConnectionInterface$.END_CURSOR, START_CURSOR = _ConnectionInterface$.START_CURSOR;
    var connection = $f0f1a489cc0e6cef$var$getValueAtPath(fragmentData, connectionPathInFragmentData);
    if (connection == null) return {
        cursor: null,
        hasMore: false
    };
    !(typeof connection === 'object') && $423Vm(false);
    var edges = connection[EDGES];
    var pageInfo = connection[PAGE_INFO];
    if (edges == null || pageInfo == null) return {
        cursor: null,
        hasMore: false
    };
    !Array.isArray(edges) && $423Vm(false);
    !(typeof pageInfo === 'object') && $423Vm(false);
    var cursor = direction === 'forward' ? (_pageInfo$END_CURSOR = pageInfo[END_CURSOR]) !== null && _pageInfo$END_CURSOR !== void 0 ? _pageInfo$END_CURSOR : null : (_pageInfo$START_CURSO = pageInfo[START_CURSOR]) !== null && _pageInfo$START_CURSO !== void 0 ? _pageInfo$START_CURSO : null;
    !(cursor === null || typeof cursor === 'string') && $423Vm(false);
    var hasMore;
    if (direction === 'forward') hasMore = cursor != null && pageInfo[HAS_NEXT_PAGE] === true;
    else hasMore = cursor != null && pageInfo[HAS_PREV_PAGE] === true;
    return {
        cursor: cursor,
        hasMore: hasMore
    };
}
module.exports = $f0f1a489cc0e6cef$var$useLoadMoreFunction;

});
parcelRegister("fay79", function(module, exports) {
'use strict';

var $i764d = parcelRequire("i764d");

var $423Vm = parcelRequire("423Vm");

var $eJOHy = parcelRequire("eJOHy");

var $37Ewn = parcelRequire("37Ewn");
var $b0b24094720e41e8$var$getObservableForActiveRequest = $37Ewn.__internal.getObservableForActiveRequest, $b0b24094720e41e8$var$getSelector = $37Ewn.getSelector;
var $b0b24094720e41e8$var$useEffect = $eJOHy.useEffect, $b0b24094720e41e8$var$useState = $eJOHy.useState, $b0b24094720e41e8$var$useMemo = $eJOHy.useMemo;
function $b0b24094720e41e8$var$useIsOperationNodeActive(fragmentNode, fragmentRef) {
    var environment = $i764d();
    var observable = $b0b24094720e41e8$var$useMemo(function() {
        var selector = $b0b24094720e41e8$var$getSelector(fragmentNode, fragmentRef);
        if (selector == null) return null;
        !(selector.kind === 'SingularReaderSelector') && $423Vm(false);
        return $b0b24094720e41e8$var$getObservableForActiveRequest(environment, selector.owner);
    }, [
        environment,
        fragmentNode,
        fragmentRef
    ]);
    var _useState = $b0b24094720e41e8$var$useState(observable != null), isActive = _useState[0], setIsActive = _useState[1];
    $b0b24094720e41e8$var$useEffect(function() {
        var subscription;
        setIsActive(observable != null);
        if (observable != null) {
            var onCompleteOrError = function onCompleteOrError() {
                setIsActive(false);
            };
            subscription = observable.subscribe({
                complete: onCompleteOrError,
                error: onCompleteOrError
            });
        }
        return function() {
            if (subscription) subscription.unsubscribe();
        };
    }, [
        observable
    ]);
    return isActive;
}
module.exports = $b0b24094720e41e8$var$useIsOperationNodeActive;

});


parcelRegister("9mvki", function(module, exports) {
'use strict';

var $7Wmh0 = parcelRequire("7Wmh0");
var $6d0e77e30c4bb071$var$_interopRequireDefault = $7Wmh0.default;

var $6d0e77e30c4bb071$var$_objectSpread2 = $6d0e77e30c4bb071$var$_interopRequireDefault((parcelRequire("1sB2t")));

var $83OIO = parcelRequire("83OIO");

var $eROlK = parcelRequire("eROlK");
var $6d0e77e30c4bb071$var$getQueryResourceForEnvironment = $eROlK.getQueryResourceForEnvironment;

var $h8fzh = parcelRequire("h8fzh");

var $810gN = parcelRequire("810gN");

var $ga5fu = parcelRequire("ga5fu");

var $RjuBo = parcelRequire("RjuBo");

var $i764d = parcelRequire("i764d");

var $423Vm = parcelRequire("423Vm");

var $eJOHy = parcelRequire("eJOHy");
var $6d0e77e30c4bb071$var$useCallback = $eJOHy.useCallback, $6d0e77e30c4bb071$var$useContext = $eJOHy.useContext, $6d0e77e30c4bb071$var$useReducer = $eJOHy.useReducer;

var $37Ewn = parcelRequire("37Ewn");
var $6d0e77e30c4bb071$var$fetchQuery = $37Ewn.__internal.fetchQuery, $6d0e77e30c4bb071$var$createOperationDescriptor = $37Ewn.createOperationDescriptor, $6d0e77e30c4bb071$var$getFragmentIdentifier = $37Ewn.getFragmentIdentifier, $6d0e77e30c4bb071$var$getRefetchMetadata = $37Ewn.getRefetchMetadata, $6d0e77e30c4bb071$var$getSelector = $37Ewn.getSelector, $6d0e77e30c4bb071$var$getValueAtPath = $37Ewn.getValueAtPath;
parcelRequire("dH6ue");
function $6d0e77e30c4bb071$var$reducer(state, action) {
    switch(action.type){
        case 'refetch':
            var _action$refetchEnviro;
            return (0, $6d0e77e30c4bb071$var$_objectSpread2["default"])((0, $6d0e77e30c4bb071$var$_objectSpread2["default"])({}, state), {}, {
                fetchPolicy: action.fetchPolicy,
                mirroredEnvironment: (_action$refetchEnviro = action.refetchEnvironment) !== null && _action$refetchEnviro !== void 0 ? _action$refetchEnviro : state.mirroredEnvironment,
                onComplete: action.onComplete,
                refetchEnvironment: action.refetchEnvironment,
                refetchQuery: action.refetchQuery,
                renderPolicy: action.renderPolicy
            });
        case 'reset':
            return {
                fetchPolicy: undefined,
                mirroredEnvironment: action.environment,
                mirroredFragmentIdentifier: action.fragmentIdentifier,
                onComplete: undefined,
                refetchQuery: null,
                renderPolicy: undefined
            };
        default:
            action.type;
            throw new Error('useRefetchableFragmentNode: Unexpected action type');
    }
}
function $6d0e77e30c4bb071$var$useRefetchableFragmentNode(fragmentNode, parentFragmentRef, componentDisplayName) {
    var parentEnvironment = $i764d();
    var _getRefetchMetadata = $6d0e77e30c4bb071$var$getRefetchMetadata(fragmentNode, componentDisplayName), refetchableRequest = _getRefetchMetadata.refetchableRequest, fragmentRefPathInResponse = _getRefetchMetadata.fragmentRefPathInResponse, identifierInfo = _getRefetchMetadata.identifierInfo;
    var fragmentIdentifier = $6d0e77e30c4bb071$var$getFragmentIdentifier(fragmentNode, parentFragmentRef);
    var _useReducer = $6d0e77e30c4bb071$var$useReducer($6d0e77e30c4bb071$var$reducer, {
        fetchPolicy: undefined,
        mirroredEnvironment: parentEnvironment,
        mirroredFragmentIdentifier: fragmentIdentifier,
        onComplete: undefined,
        refetchEnvironment: null,
        refetchQuery: null,
        renderPolicy: undefined
    }), refetchState = _useReducer[0], dispatch = _useReducer[1];
    var fetchPolicy = refetchState.fetchPolicy, mirroredEnvironment = refetchState.mirroredEnvironment, mirroredFragmentIdentifier = refetchState.mirroredFragmentIdentifier, onComplete = refetchState.onComplete, refetchEnvironment = refetchState.refetchEnvironment, refetchQuery = refetchState.refetchQuery, renderPolicy = refetchState.renderPolicy;
    var environment = refetchEnvironment !== null && refetchEnvironment !== void 0 ? refetchEnvironment : parentEnvironment;
    var QueryResource = $6d0e77e30c4bb071$var$getQueryResourceForEnvironment(environment);
    var profilerContext = $6d0e77e30c4bb071$var$useContext($83OIO);
    var shouldReset = environment !== mirroredEnvironment || fragmentIdentifier !== mirroredFragmentIdentifier;
    var _useQueryLoader = $RjuBo(refetchableRequest), queryRef = _useQueryLoader[0], loadQuery = _useQueryLoader[1], disposeQuery = _useQueryLoader[2];
    var fragmentRef = parentFragmentRef;
    if (shouldReset) {
        dispatch({
            type: 'reset',
            environment: environment,
            fragmentIdentifier: fragmentIdentifier
        });
        disposeQuery();
    } else if (refetchQuery != null && queryRef != null) {
        var debugPreviousIDAndTypename;
        var handleQueryCompleted = function handleQueryCompleted(maybeError) {
            onComplete && onComplete(maybeError !== null && maybeError !== void 0 ? maybeError : null);
        };
        var fetchObservable = queryRef.source != null ? queryRef.source : $6d0e77e30c4bb071$var$fetchQuery(environment, refetchQuery);
        var queryResult = profilerContext.wrapPrepareQueryResource(function() {
            return QueryResource.prepare(refetchQuery, fetchObservable, fetchPolicy, renderPolicy, {
                error: handleQueryCompleted,
                complete: function complete() {
                    handleQueryCompleted();
                }
            }, queryRef.fetchKey, profilerContext);
        });
        var queryData = $h8fzh(environment, queryResult.fragmentNode, queryResult.fragmentRef, componentDisplayName).data;
        !(queryData != null) && $423Vm(false);
        var refetchedFragmentRef = $6d0e77e30c4bb071$var$getValueAtPath(queryData, fragmentRefPathInResponse);
        fragmentRef = refetchedFragmentRef;
    }
    var fragmentData = $810gN(fragmentNode, fragmentRef, componentDisplayName);
    var refetch = $6d0e77e30c4bb071$var$useRefetchFunction(componentDisplayName, dispatch, disposeQuery, fragmentData, fragmentIdentifier, fragmentNode, fragmentRefPathInResponse, identifierInfo, loadQuery, parentFragmentRef, refetchableRequest);
    return {
        fragmentData: fragmentData,
        fragmentRef: fragmentRef,
        refetch: refetch
    };
}
function $6d0e77e30c4bb071$var$useRefetchFunction(componentDisplayName, dispatch, disposeQuery, fragmentData, fragmentIdentifier, fragmentNode, fragmentRefPathInResponse, identifierInfo, loadQuery, parentFragmentRef, refetchableRequest) {
    var isMountedRef = $ga5fu();
    var identifierValue = (identifierInfo === null || identifierInfo === void 0 ? void 0 : identifierInfo.identifierField) != null && fragmentData != null && typeof fragmentData === 'object' ? fragmentData[identifierInfo.identifierField] : null;
    return $6d0e77e30c4bb071$var$useCallback(function(providedRefetchVariables, options) {
        if (isMountedRef.current !== true) return {
            dispose: function dispose() {}
        };
        parentFragmentRef;
        var refetchEnvironment = options === null || options === void 0 ? void 0 : options.__environment;
        var fetchPolicy = options === null || options === void 0 ? void 0 : options.fetchPolicy;
        var renderPolicy = options === null || options === void 0 ? void 0 : options.UNSTABLE_renderPolicy;
        var onComplete = options === null || options === void 0 ? void 0 : options.onComplete;
        var fragmentSelector = $6d0e77e30c4bb071$var$getSelector(fragmentNode, parentFragmentRef);
        var parentVariables;
        var fragmentVariables;
        if (fragmentSelector == null) {
            parentVariables = {};
            fragmentVariables = {};
        } else if (fragmentSelector.kind === 'PluralReaderSelector') {
            var _fragmentSelector$sel, _fragmentSelector$sel2, _fragmentSelector$sel3, _fragmentSelector$sel4;
            parentVariables = (_fragmentSelector$sel = (_fragmentSelector$sel2 = fragmentSelector.selectors[0]) === null || _fragmentSelector$sel2 === void 0 ? void 0 : _fragmentSelector$sel2.owner.variables) !== null && _fragmentSelector$sel !== void 0 ? _fragmentSelector$sel : {};
            fragmentVariables = (_fragmentSelector$sel3 = (_fragmentSelector$sel4 = fragmentSelector.selectors[0]) === null || _fragmentSelector$sel4 === void 0 ? void 0 : _fragmentSelector$sel4.variables) !== null && _fragmentSelector$sel3 !== void 0 ? _fragmentSelector$sel3 : {};
        } else {
            parentVariables = fragmentSelector.owner.variables;
            fragmentVariables = fragmentSelector.variables;
        }
        var refetchVariables = (0, $6d0e77e30c4bb071$var$_objectSpread2["default"])((0, $6d0e77e30c4bb071$var$_objectSpread2["default"])((0, $6d0e77e30c4bb071$var$_objectSpread2["default"])({}, parentVariables), fragmentVariables), providedRefetchVariables);
        if (identifierInfo != null && !providedRefetchVariables.hasOwnProperty(identifierInfo.identifierQueryVariableName)) {
            typeof identifierValue;
            refetchVariables[identifierInfo.identifierQueryVariableName] = identifierValue;
        }
        var refetchQuery = $6d0e77e30c4bb071$var$createOperationDescriptor(refetchableRequest, refetchVariables, {
            force: true
        });
        loadQuery(refetchQuery.request.variables, {
            fetchPolicy: fetchPolicy,
            __environment: refetchEnvironment,
            __nameForWarning: 'refetch'
        });
        dispatch({
            type: 'refetch',
            fetchPolicy: fetchPolicy,
            onComplete: onComplete,
            refetchEnvironment: refetchEnvironment,
            refetchQuery: refetchQuery,
            renderPolicy: renderPolicy
        });
        return {
            dispose: disposeQuery
        };
    }, [
        fragmentIdentifier,
        dispatch,
        disposeQuery,
        identifierValue,
        loadQuery
    ]);
}
var $6d0e77e30c4bb071$var$debugFunctions;
module.exports = $6d0e77e30c4bb071$var$useRefetchableFragmentNode;

});
parcelRegister("h8fzh", function(module, exports) {
'use strict';

var $7Wmh0 = parcelRequire("7Wmh0");
var $c78f4285acbb5761$var$_interopRequireDefault = $7Wmh0.default;

var $c78f4285acbb5761$var$_objectSpread2 = $c78f4285acbb5761$var$_interopRequireDefault((parcelRequire("1sB2t")));

var $c78f4285acbb5761$var$_createForOfIteratorHelper2 = $c78f4285acbb5761$var$_interopRequireDefault((parcelRequire("9CLQ8")));

var $eROlK = parcelRequire("eROlK");
var $c78f4285acbb5761$var$getQueryResourceForEnvironment = $eROlK.getQueryResourceForEnvironment;

var $423Vm = parcelRequire("423Vm");

var $37Ewn = parcelRequire("37Ewn");
var $c78f4285acbb5761$var$fetchQueryInternal = $37Ewn.__internal.fetchQuery, $c78f4285acbb5761$var$RelayFeatureFlags = $37Ewn.RelayFeatureFlags, $c78f4285acbb5761$var$createOperationDescriptor = $37Ewn.createOperationDescriptor, $c78f4285acbb5761$var$getPendingOperationsForFragment = $37Ewn.getPendingOperationsForFragment, $c78f4285acbb5761$var$getSelector = $37Ewn.getSelector, $c78f4285acbb5761$var$getVariablesFromFragment = $37Ewn.getVariablesFromFragment, $c78f4285acbb5761$var$handlePotentialSnapshotErrors = $37Ewn.handlePotentialSnapshotErrors;
parcelRequire("dH6ue");
function $c78f4285acbb5761$var$isMissingData(state) {
    if (state.kind === 'bailout') return false;
    else if (state.kind === 'singular') return state.snapshot.isMissingData;
    else return state.snapshots.some(function(s) {
        return s.isMissingData;
    });
}
function $c78f4285acbb5761$var$getMissingClientEdges(state) {
    if (state.kind === 'bailout') return null;
    else if (state.kind === 'singular') {
        var _state$snapshot$missi;
        return (_state$snapshot$missi = state.snapshot.missingClientEdges) !== null && _state$snapshot$missi !== void 0 ? _state$snapshot$missi : null;
    } else {
        var edges = null;
        var _iterator = (0, $c78f4285acbb5761$var$_createForOfIteratorHelper2["default"])(state.snapshots), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var snapshot = _step.value;
                if (snapshot.missingClientEdges) {
                    var _edges;
                    edges = (_edges = edges) !== null && _edges !== void 0 ? _edges : [];
                    var _iterator2 = (0, $c78f4285acbb5761$var$_createForOfIteratorHelper2["default"])(snapshot.missingClientEdges), _step2;
                    try {
                        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                            var edge = _step2.value;
                            edges.push(edge);
                        }
                    } catch (err) {
                        _iterator2.e(err);
                    } finally{
                        _iterator2.f();
                    }
                }
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return edges;
    }
}
function $c78f4285acbb5761$var$handlePotentialSnapshotErrorsForState(environment, state) {
    if (state.kind === 'singular') {
        var _state$snapshot$selec, _state$snapshot$selec2;
        $c78f4285acbb5761$var$handlePotentialSnapshotErrors(environment, state.snapshot.missingRequiredFields, state.snapshot.relayResolverErrors, state.snapshot.errorResponseFields, (_state$snapshot$selec = (_state$snapshot$selec2 = state.snapshot.selector.node.metadata) === null || _state$snapshot$selec2 === void 0 ? void 0 : _state$snapshot$selec2.throwOnFieldError) !== null && _state$snapshot$selec !== void 0 ? _state$snapshot$selec : false);
    } else if (state.kind === 'plural') {
        var _iterator3 = (0, $c78f4285acbb5761$var$_createForOfIteratorHelper2["default"])(state.snapshots), _step3;
        try {
            for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                var _snapshot$selector$no, _snapshot$selector$no2;
                var snapshot = _step3.value;
                $c78f4285acbb5761$var$handlePotentialSnapshotErrors(environment, snapshot.missingRequiredFields, snapshot.relayResolverErrors, snapshot.errorResponseFields, (_snapshot$selector$no = (_snapshot$selector$no2 = snapshot.selector.node.metadata) === null || _snapshot$selector$no2 === void 0 ? void 0 : _snapshot$selector$no2.throwOnFieldError) !== null && _snapshot$selector$no !== void 0 ? _snapshot$selector$no : false);
            }
        } catch (err) {
            _iterator3.e(err);
        } finally{
            _iterator3.f();
        }
    }
}
function $c78f4285acbb5761$var$handleMissingClientEdge(environment, parentFragmentNode, parentFragmentRef, missingClientEdgeRequestInfo, queryOptions) {
    var originalVariables = $c78f4285acbb5761$var$getVariablesFromFragment(parentFragmentNode, parentFragmentRef);
    var variables = (0, $c78f4285acbb5761$var$_objectSpread2["default"])((0, $c78f4285acbb5761$var$_objectSpread2["default"])({}, originalVariables), {}, {
        id: missingClientEdgeRequestInfo.clientEdgeDestinationID
    });
    var queryOperationDescriptor = $c78f4285acbb5761$var$createOperationDescriptor(missingClientEdgeRequestInfo.request, variables, queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.networkCacheConfig);
    var QueryResource = $c78f4285acbb5761$var$getQueryResourceForEnvironment(environment);
    return QueryResource.prepare(queryOperationDescriptor, $c78f4285acbb5761$var$fetchQueryInternal(environment, queryOperationDescriptor), queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.fetchPolicy);
}
function $c78f4285acbb5761$var$getFragmentState(environment, fragmentSelector) {
    if (fragmentSelector == null) return {
        kind: 'bailout'
    };
    else if (fragmentSelector.kind === 'PluralReaderSelector') {
        if (fragmentSelector.selectors.length === 0) return {
            kind: 'bailout'
        };
        else return {
            kind: 'plural',
            snapshots: fragmentSelector.selectors.map(function(s) {
                return environment.lookup(s);
            }),
            epoch: environment.getStore().getEpoch()
        };
    } else return {
        kind: 'singular',
        snapshot: environment.lookup(fragmentSelector),
        epoch: environment.getStore().getEpoch()
    };
}
function $c78f4285acbb5761$var$readFragmentInternal(environment, fragmentNode, fragmentRef, hookDisplayName, queryOptions, fragmentKey) {
    var _fragmentNode$metadat, _fragmentNode$metadat2;
    var fragmentSelector = $c78f4285acbb5761$var$getSelector(fragmentNode, fragmentRef);
    var isPlural = (fragmentNode === null || fragmentNode === void 0 ? void 0 : (_fragmentNode$metadat = fragmentNode.metadata) === null || _fragmentNode$metadat === void 0 ? void 0 : _fragmentNode$metadat.plural) === true;
    if (isPlural) !(fragmentRef == null || Array.isArray(fragmentRef)) && $423Vm(false);
    else !!Array.isArray(fragmentRef) && $423Vm(false);
    !(fragmentRef == null || isPlural && Array.isArray(fragmentRef) && fragmentRef.length === 0 || fragmentSelector != null) && $423Vm(false);
    var state = $c78f4285acbb5761$var$getFragmentState(environment, fragmentSelector);
    var clientEdgeQueries = null;
    if (((_fragmentNode$metadat2 = fragmentNode.metadata) === null || _fragmentNode$metadat2 === void 0 ? void 0 : _fragmentNode$metadat2.hasClientEdges) === true) {
        var missingClientEdges = $c78f4285acbb5761$var$getMissingClientEdges(state);
        if (missingClientEdges !== null && missingClientEdges !== void 0 && missingClientEdges.length) {
            clientEdgeQueries = [];
            var _iterator4 = (0, $c78f4285acbb5761$var$_createForOfIteratorHelper2["default"])(missingClientEdges), _step4;
            try {
                for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                    var edge = _step4.value;
                    clientEdgeQueries.push($c78f4285acbb5761$var$handleMissingClientEdge(environment, fragmentNode, fragmentRef, edge, queryOptions));
                }
            } catch (err) {
                _iterator4.e(err);
            } finally{
                _iterator4.f();
            }
        }
    }
    if ($c78f4285acbb5761$var$isMissingData(state)) {
        !(fragmentSelector != null) && $423Vm(false);
        var fragmentOwner = fragmentSelector.kind === 'PluralReaderSelector' ? fragmentSelector.selectors[0].owner : fragmentSelector.owner;
        var pendingOperationsResult = $c78f4285acbb5761$var$getPendingOperationsForFragment(environment, fragmentNode, fragmentOwner);
        if (pendingOperationsResult) throw pendingOperationsResult.promise;
        $c78f4285acbb5761$var$handlePotentialSnapshotErrorsForState(environment, state);
    }
    var data;
    if (state.kind === 'bailout') data = isPlural ? [] : null;
    else if (state.kind === 'singular') data = state.snapshot.data;
    else data = state.snapshots.map(function(s) {
        return s.data;
    });
    if ($c78f4285acbb5761$var$RelayFeatureFlags.LOG_MISSING_RECORDS_IN_PROD || false) fragmentRef != null && (data === undefined || Array.isArray(data) && data.length > 0 && data.every(function(d) {
        return d === undefined;
    }));
    return {
        data: data,
        clientEdgeQueries: clientEdgeQueries
    };
}
module.exports = $c78f4285acbb5761$var$readFragmentInternal;

});

parcelRegister("RjuBo", function(module, exports) {
'use strict';

var $7Wmh0 = parcelRequire("7Wmh0");
var $0a04122c2bad62be$var$_interopRequireDefault = $7Wmh0.default;

var $0a04122c2bad62be$var$_createForOfIteratorHelper2 = $0a04122c2bad62be$var$_interopRequireDefault((parcelRequire("9CLQ8")));

var $bQPKN = parcelRequire("bQPKN");
var $0a04122c2bad62be$var$loadQuery = $bQPKN.loadQuery, $0a04122c2bad62be$var$useTrackLoadQueryInRender = $bQPKN.useTrackLoadQueryInRender;

var $ga5fu = parcelRequire("ga5fu");

var $i764d = parcelRequire("i764d");

var $eJOHy = parcelRequire("eJOHy");
var $0a04122c2bad62be$var$useCallback = $eJOHy.useCallback, $0a04122c2bad62be$var$useEffect = $eJOHy.useEffect, $0a04122c2bad62be$var$useRef = $eJOHy.useRef, $0a04122c2bad62be$var$useState = $eJOHy.useState;

var $37Ewn = parcelRequire("37Ewn");
var $0a04122c2bad62be$var$getRequest = $37Ewn.getRequest;
var $0a04122c2bad62be$var$initialNullQueryReferenceState = {
    kind: 'NullQueryReference'
};
function $0a04122c2bad62be$var$requestIsLiveQuery(preloadableRequest) {
    if (preloadableRequest.kind === 'PreloadableConcreteRequest') return preloadableRequest.params.metadata.live !== undefined;
    var request = $0a04122c2bad62be$var$getRequest(preloadableRequest);
    return request.params.metadata.live !== undefined;
}
function $0a04122c2bad62be$var$useQueryLoader(preloadableRequest, initialQueryReference) {
    var initialQueryReferenceInternal = initialQueryReference !== null && initialQueryReference !== void 0 ? initialQueryReference : $0a04122c2bad62be$var$initialNullQueryReferenceState;
    var environment = $i764d();
    $0a04122c2bad62be$var$useTrackLoadQueryInRender();
    var isMountedRef = $ga5fu();
    var undisposedQueryReferencesRef = $0a04122c2bad62be$var$useRef(new Set([
        initialQueryReferenceInternal
    ]));
    var _useState = $0a04122c2bad62be$var$useState(function() {
        return initialQueryReferenceInternal;
    }), queryReference = _useState[0], setQueryReference = _useState[1];
    var _useState2 = $0a04122c2bad62be$var$useState(function() {
        return initialQueryReferenceInternal;
    }), previousInitialQueryReference = _useState2[0], setPreviousInitialQueryReference = _useState2[1];
    if (initialQueryReferenceInternal !== previousInitialQueryReference) {
        undisposedQueryReferencesRef.current.add(initialQueryReferenceInternal);
        setPreviousInitialQueryReference(initialQueryReferenceInternal);
        setQueryReference(initialQueryReferenceInternal);
    }
    var disposeQuery = $0a04122c2bad62be$var$useCallback(function() {
        if (isMountedRef.current) {
            undisposedQueryReferencesRef.current.add($0a04122c2bad62be$var$initialNullQueryReferenceState);
            setQueryReference($0a04122c2bad62be$var$initialNullQueryReferenceState);
        }
    }, [
        isMountedRef
    ]);
    var queryLoaderCallback = $0a04122c2bad62be$var$useCallback(function(variables, options) {
        var mergedOptions = options != null && options.hasOwnProperty('__environment') ? {
            fetchPolicy: options.fetchPolicy,
            networkCacheConfig: options.networkCacheConfig,
            __nameForWarning: options.__nameForWarning
        } : options;
        if (isMountedRef.current) {
            var _options$__environmen;
            var updatedQueryReference = $0a04122c2bad62be$var$loadQuery((_options$__environmen = options === null || options === void 0 ? void 0 : options.__environment) !== null && _options$__environmen !== void 0 ? _options$__environmen : environment, preloadableRequest, variables, mergedOptions);
            undisposedQueryReferencesRef.current.add(updatedQueryReference);
            setQueryReference(updatedQueryReference);
        }
    }, [
        environment,
        preloadableRequest,
        setQueryReference,
        isMountedRef
    ]);
    var maybeHiddenOrFastRefresh = $0a04122c2bad62be$var$useRef(false);
    $0a04122c2bad62be$var$useEffect(function() {
        return function() {
            maybeHiddenOrFastRefresh.current = true;
        };
    }, []);
    $0a04122c2bad62be$var$useEffect(function() {
        if (maybeHiddenOrFastRefresh.current === true) {
            maybeHiddenOrFastRefresh.current = false;
            if (queryReference.kind !== 'NullQueryReference') queryLoaderCallback(queryReference.variables, {
                fetchPolicy: queryReference.fetchPolicy,
                networkCacheConfig: queryReference.networkCacheConfig
            });
            return;
        }
        var undisposedQueryReferences = undisposedQueryReferencesRef.current;
        if (isMountedRef.current) {
            var _iterator = (0, $0a04122c2bad62be$var$_createForOfIteratorHelper2["default"])(undisposedQueryReferences), _step;
            try {
                for(_iterator.s(); !(_step = _iterator.n()).done;){
                    var undisposedQueryReference = _step.value;
                    if (undisposedQueryReference === queryReference) break;
                    undisposedQueryReferences["delete"](undisposedQueryReference);
                    if (undisposedQueryReference.kind !== 'NullQueryReference') {
                        if ($0a04122c2bad62be$var$requestIsLiveQuery(preloadableRequest)) undisposedQueryReference.dispose && undisposedQueryReference.dispose();
                        else undisposedQueryReference.releaseQuery && undisposedQueryReference.releaseQuery();
                    }
                }
            } catch (err) {
                _iterator.e(err);
            } finally{
                _iterator.f();
            }
        }
    }, [
        queryReference,
        isMountedRef,
        queryLoaderCallback,
        preloadableRequest
    ]);
    $0a04122c2bad62be$var$useEffect(function() {
        return function disposeAllRemainingQueryReferences() {
            var _iterator2 = (0, $0a04122c2bad62be$var$_createForOfIteratorHelper2["default"])(undisposedQueryReferencesRef.current), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var undisposedQueryReference = _step2.value;
                    if (undisposedQueryReference.kind !== 'NullQueryReference') {
                        if ($0a04122c2bad62be$var$requestIsLiveQuery(preloadableRequest)) undisposedQueryReference.dispose && undisposedQueryReference.dispose();
                        else undisposedQueryReference.releaseQuery && undisposedQueryReference.releaseQuery();
                    }
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
        };
    }, [
        preloadableRequest
    ]);
    return [
        queryReference.kind === 'NullQueryReference' ? null : queryReference,
        queryLoaderCallback,
        disposeQuery
    ];
}
module.exports = $0a04122c2bad62be$var$useQueryLoader;

});



parcelRegister("xo8pN", function(module, exports) {
'use strict';

var $bQPKN = parcelRequire("bQPKN");
var $0645cdd5f88fb767$var$useTrackLoadQueryInRender = $bQPKN.useTrackLoadQueryInRender;

var $1dVZ2 = parcelRequire("1dVZ2");

var $jcK8M = parcelRequire("jcK8M");

var $i764d = parcelRequire("i764d");

var $423Vm = parcelRequire("423Vm");

var $eJOHy = parcelRequire("eJOHy");
var $0645cdd5f88fb767$var$useDebugValue = $eJOHy.useDebugValue;

var $37Ewn = parcelRequire("37Ewn");
var $0645cdd5f88fb767$var$_require3$__internal = $37Ewn.__internal, $0645cdd5f88fb767$var$fetchQueryDeduped = $0645cdd5f88fb767$var$_require3$__internal.fetchQueryDeduped, $0645cdd5f88fb767$var$fetchQuery = $0645cdd5f88fb767$var$_require3$__internal.fetchQuery;
parcelRequire("dH6ue");
function $0645cdd5f88fb767$var$usePreloadedQuery(gqlQuery, preloadedQuery, options) {
    $0645cdd5f88fb767$var$useTrackLoadQueryInRender();
    var environment = $i764d();
    var fetchKey = preloadedQuery.fetchKey, fetchPolicy = preloadedQuery.fetchPolicy, source = preloadedQuery.source, variables = preloadedQuery.variables, networkCacheConfig = preloadedQuery.networkCacheConfig;
    var operation = $jcK8M(gqlQuery, variables, networkCacheConfig);
    var useLazyLoadQueryNodeParams;
    if (preloadedQuery.kind === 'PreloadedQuery_DEPRECATED') {
        !(operation.request.node.params.name === preloadedQuery.name) && $423Vm(false);
        useLazyLoadQueryNodeParams = {
            componentDisplayName: 'usePreloadedQuery()',
            fetchKey: fetchKey,
            fetchObservable: $0645cdd5f88fb767$var$fetchQueryDeduped(environment, operation.request.identifier, function() {
                if (environment === preloadedQuery.environment && source != null) return environment.executeWithSource({
                    operation: operation,
                    source: source
                });
                else return environment.execute({
                    operation: operation
                });
            }),
            fetchPolicy: fetchPolicy,
            query: operation,
            renderPolicy: options === null || options === void 0 ? void 0 : options.UNSTABLE_renderPolicy
        };
    } else {
        var fallbackFetchObservable = $0645cdd5f88fb767$var$fetchQuery(environment, operation);
        var fetchObservable;
        if (source != null && environment === preloadedQuery.environment) fetchObservable = source.ifEmpty(fallbackFetchObservable);
        else if (environment !== preloadedQuery.environment) fetchObservable = fallbackFetchObservable;
        else fetchObservable = fallbackFetchObservable;
        useLazyLoadQueryNodeParams = {
            componentDisplayName: 'usePreloadedQuery()',
            fetchObservable: fetchObservable,
            fetchKey: fetchKey,
            fetchPolicy: fetchPolicy,
            query: operation,
            renderPolicy: options === null || options === void 0 ? void 0 : options.UNSTABLE_renderPolicy
        };
    }
    var data = $1dVZ2(useLazyLoadQueryNodeParams);
    return data;
}
module.exports = $0645cdd5f88fb767$var$usePreloadedQuery;

});

parcelRegister("eyGnt", function(module, exports) {
'use strict';

var $9mvki = parcelRequire("9mvki");

var $3LVgx = parcelRequire("3LVgx");

var $eJOHy = parcelRequire("eJOHy");
var $a9951cf30017cc7b$var$useDebugValue = $eJOHy.useDebugValue;

var $37Ewn = parcelRequire("37Ewn");
var $a9951cf30017cc7b$var$getFragment = $37Ewn.getFragment;
function $a9951cf30017cc7b$var$useRefetchableFragment(fragmentInput, fragmentRef) {
    var fragmentNode = $a9951cf30017cc7b$var$getFragment(fragmentInput);
    $3LVgx(fragmentNode, 'first argument of useRefetchableFragment()');
    var _useRefetchableFragme = $9mvki(fragmentNode, fragmentRef, 'useRefetchableFragment()'), fragmentData = _useRefetchableFragme.fragmentData, refetch = _useRefetchableFragme.refetch;
    return [
        fragmentData,
        refetch
    ];
}
module.exports = $a9951cf30017cc7b$var$useRefetchableFragment;

});

parcelRegister("dEDMm", function(module, exports) {
'use strict';

var $i764d = parcelRequire("i764d");

var $eJOHy = parcelRequire("eJOHy");
var $9f0dde172138f214$var$useEffect = $eJOHy.useEffect, $9f0dde172138f214$var$useRef = $eJOHy.useRef;
function $9f0dde172138f214$var$useSubscribeToInvalidationState(dataIDs, callback) {
    var environment = $i764d();
    var disposableRef = $9f0dde172138f214$var$useRef(null);
    var stableDataIDs = Array.from(dataIDs).sort().join('');
    $9f0dde172138f214$var$useEffect(function() {
        var store = environment.getStore();
        var invalidationState = store.lookupInvalidationState(dataIDs);
        var disposable = store.subscribeToInvalidationState(invalidationState, callback);
        disposableRef.current = disposable;
        return function() {
            return disposable.dispose();
        };
    }, [
        stableDataIDs,
        callback,
        environment
    ]);
    return {
        dispose: function dispose() {
            if (disposableRef.current != null) disposableRef.current.dispose();
        }
    };
}
module.exports = $9f0dde172138f214$var$useSubscribeToInvalidationState;

});

parcelRegister("4Iwb3", function(module, exports) {
'use strict';

var $i764d = parcelRequire("i764d");

var $eJOHy = parcelRequire("eJOHy");
var $36f43b3ea07ee90e$var$useEffect = $eJOHy.useEffect;

var $37Ewn = parcelRequire("37Ewn");
var $36f43b3ea07ee90e$var$requestSubscription = $37Ewn.requestSubscription;
function $36f43b3ea07ee90e$var$useSubscription(config, requestSubscriptionFn) {
    var actualRequestSubscription = requestSubscriptionFn !== null && requestSubscriptionFn !== void 0 ? requestSubscriptionFn : $36f43b3ea07ee90e$var$requestSubscription;
    var environment = $i764d();
    $36f43b3ea07ee90e$var$useEffect(function() {
        var _actualRequestSubscri = actualRequestSubscription(environment, config), dispose = _actualRequestSubscri.dispose;
        return dispose;
    }, [
        environment,
        config,
        actualRequestSubscription
    ]);
}
module.exports = $36f43b3ea07ee90e$var$useSubscription;

});




parcelRegister("8BYfx", function(module, exports) {
/*
 *          __        ___
 *    _____/ /___  __/ (_)____
 *   / ___/ __/ / / / / / ___/
 *  (__  ) /_/ /_/ / / (__  )
 * /____/\__/\__, /_/_/____/
 *          /____/
 *
 * light - weight css preprocessor @licence MIT
 */ (function(factory) {
    module.exports = factory(null);
})(/** @param {*=} options */ function factory(options) {
    'use strict';
    /**
	 * Notes
	 *
	 * The ['<method name>'] pattern is used to support closure compiler
	 * the jsdoc signatures are also used to the same effect
	 *
	 * ----
	 *
	 * int + int + int === n4 [faster]
	 *
	 * vs
	 *
	 * int === n1 && int === n2 && int === n3
	 *
	 * ----
	 *
	 * switch (int) { case ints...} [faster]
	 *
	 * vs
	 *
	 * if (int == 1 && int === 2 ...)
	 *
	 * ----
	 *
	 * The (first*n1 + second*n2 + third*n3) format used in the property parser
	 * is a simple way to hash the sequence of characters
	 * taking into account the index they occur in
	 * since any number of 3 character sequences could produce duplicates.
	 *
	 * On the other hand sequences that are directly tied to the index of the character
	 * resolve a far more accurate measure, it's also faster
	 * to evaluate one condition in a switch statement
	 * than three in an if statement regardless of the added math.
	 *
	 * This allows the vendor prefixer to be both small and fast.
	 */ var nullptn = /^\0+/g /* matches leading null characters */ ;
    var formatptn = /[\0\r\f]/g /* matches new line, null and formfeed characters */ ;
    var colonptn = /: */g /* splits animation rules */ ;
    var cursorptn = /zoo|gra/ /* assert cursor varient */ ;
    var transformptn = /([,: ])(transform)/g /* vendor prefix transform, older webkit */ ;
    var animationptn = /,+\s*(?![^(]*[)])/g /* splits multiple shorthand notation animations */ ;
    var propertiesptn = / +\s*(?![^(]*[)])/g /* animation properties */ ;
    var elementptn = / *[\0] */g /* selector elements */ ;
    var selectorptn = /,\r+?/g /* splits selectors */ ;
    var andptn = /([\t\r\n ])*\f?&/g /* match & */ ;
    var escapeptn = /:global\(((?:[^\(\)\[\]]*|\[.*\]|\([^\(\)]*\))*)\)/g /* matches :global(.*) */ ;
    var invalidptn = /\W+/g /* removes invalid characters from keyframes */ ;
    var keyframeptn = /@(k\w+)\s*(\S*)\s*/ /* matches @keyframes $1 */ ;
    var plcholdrptn = /::(place)/g /* match ::placeholder varient */ ;
    var readonlyptn = /:(read-only)/g /* match :read-only varient */ ;
    var beforeptn = /\s+(?=[{\];=:>])/g /* matches \s before ] ; = : */ ;
    var afterptn = /([[}=:>])\s+/g /* matches \s after characters [ } = : */ ;
    var tailptn = /(\{[^{]+?);(?=\})/g /* matches tail semi-colons ;} */ ;
    var whiteptn = /\s{2,}/g /* matches repeating whitespace */ ;
    var pseudoptn = /([^\(])(:+) */g /* pseudo element */ ;
    var writingptn = /[svh]\w+-[tblr]{2}/ /* match writing mode property values */ ;
    var gradientptn = /([\w-]+t\()/g /* match *gradient property */ ;
    var supportsptn = /\(\s*(.*)\s*\)/g /* match supports (groups) */ ;
    var propertyptn = /([\s\S]*?);/g /* match properties leading semicolon */ ;
    var selfptn = /-self|flex-/g /* match flex- and -self in align-self: flex-*; */ ;
    var pseudofmt = /[^]*?(:[rp][el]a[\w-]+)[^]*/ /* extrats :readonly or :placholder from selector */ ;
    var trimptn = /[ \t]+$/ /* match tail whitspace */ ;
    var dimensionptn = /stretch|:\s*\w+\-(?:conte|avail)/ /* match max/min/fit-content, fill-available */ ;
    var imgsrcptn = /([^-])(image-set\()/;
    /* vendors */ var webkit = '-webkit-';
    var moz = '-moz-';
    var ms = '-ms-';
    /* character codes */ var SEMICOLON = 59 /* ; */ ;
    var CLOSEBRACES = 125 /* } */ ;
    var OPENBRACES = 123 /* { */ ;
    var OPENPARENTHESES = 40 /* ( */ ;
    var CLOSEPARENTHESES = 41 /* ) */ ;
    var OPENBRACKET = 91 /* [ */ ;
    var CLOSEBRACKET = 93 /* ] */ ;
    var NEWLINE = 10 /* \n */ ;
    var CARRIAGE = 13 /* \r */ ;
    var TAB = 9 /* \t */ ;
    var AT = 64 /* @ */ ;
    var SPACE = 32 /*   */ ;
    var AND = 38 /* & */ ;
    var DASH = 45 /* - */ ;
    var UNDERSCORE = 95 /* _ */ ;
    var STAR = 42 /* * */ ;
    var COMMA = 44 /* , */ ;
    var COLON = 58 /* : */ ;
    var SINGLEQUOTE = 39 /* ' */ ;
    var DOUBLEQUOTE = 34 /* " */ ;
    var FOWARDSLASH = 47 /* / */ ;
    var GREATERTHAN = 62 /* > */ ;
    var PLUS = 43 /* + */ ;
    var TILDE = 126 /* ~ */ ;
    var NULL = 0 /* \0 */ ;
    var FORMFEED = 12 /* \f */ ;
    var VERTICALTAB = 11 /* \v */ ;
    /* special identifiers */ var KEYFRAME = 107 /* k */ ;
    var MEDIA = 109 /* m */ ;
    var SUPPORTS = 115 /* s */ ;
    var PLACEHOLDER = 112 /* p */ ;
    var READONLY = 111 /* o */ ;
    var IMPORT = 105 /* <at>i */ ;
    var CHARSET = 99 /* <at>c */ ;
    var DOCUMENT = 100 /* <at>d */ ;
    var PAGE = 112 /* <at>p */ ;
    var column = 1 /* current column */ ;
    var line = 1 /* current line numebr */ ;
    var pattern = 0 /* :pattern */ ;
    var cascade = 1 /* #id h1 h2 vs h1#id h2#id  */ ;
    var prefix = 1 /* vendor prefix */ ;
    var escape = 1 /* escape :global() pattern */ ;
    var compress = 0 /* compress output */ ;
    var semicolon = 0 /* no/semicolon option */ ;
    var preserve = 0 /* preserve empty selectors */ ;
    /* empty reference */ var array = [];
    /* plugins */ var plugins = [];
    var plugged = 0;
    var should = null;
    /* plugin context */ var POSTS = -2;
    var PREPS = -1;
    var UNKWN = 0;
    var PROPS = 1;
    var BLCKS = 2;
    var ATRUL = 3;
    /* plugin newline context */ var unkwn = 0;
    /* keyframe animation */ var keyed = 1;
    var key = '';
    /* selector namespace */ var nscopealt = '';
    var nscope = '';
    /**
	 * Compile
	 *
	 * @param {Array<string>} parent
	 * @param {Array<string>} current
	 * @param {string} body
	 * @param {number} id
	 * @param {number} depth
	 * @return {string}
	 */ function compile(parent, current, body, id, depth) {
        var bracket = 0 /* brackets [] */ ;
        var comment = 0 /* comments /* // or /* */ ;
        var parentheses = 0 /* functions () */ ;
        var quote = 0 /* quotes '', "" */ ;
        var first = 0 /* first character code */ ;
        var second = 0 /* second character code */ ;
        var code = 0 /* current character code */ ;
        var tail = 0 /* previous character code */ ;
        var trail = 0 /* character before previous code */ ;
        var peak = 0 /* previous non-whitespace code */ ;
        var counter = 0 /* count sequence termination */ ;
        var context = 0 /* track current context */ ;
        var atrule = 0 /* track @at-rule context */ ;
        var pseudo = 0 /* track pseudo token index */ ;
        var caret = 0 /* current character index */ ;
        var format = 0 /* control character formating context */ ;
        var insert = 0 /* auto semicolon insertion */ ;
        var invert = 0 /* inverted selector pattern */ ;
        var length = 0 /* generic length address */ ;
        var eof = body.length /* end of file(length) */ ;
        var eol = eof - 1 /* end of file(characters) */ ;
        var char = '' /* current character */ ;
        var chars = '' /* current buffer of characters */ ;
        var child = '' /* next buffer of characters */ ;
        var out = '' /* compiled body */ ;
        var children = '' /* compiled children */ ;
        var flat = '' /* compiled leafs */ ;
        var selector /* generic selector address */ ;
        var result /* generic address */ ;
        // ...build body
        while(caret < eof){
            code = body.charCodeAt(caret);
            // eof varient
            if (caret === eol) // last character + noop context, add synthetic padding for noop context to terminate
            {
                if (comment + quote + parentheses + bracket !== 0) {
                    if (comment !== 0) code = comment === FOWARDSLASH ? NEWLINE : FOWARDSLASH;
                    quote = parentheses = bracket = 0;
                    eof++;
                    eol++;
                }
            }
            if (comment + quote + parentheses + bracket === 0) {
                // eof varient
                if (caret === eol) {
                    if (format > 0) chars = chars.replace(formatptn, '');
                    if (chars.trim().length > 0) {
                        switch(code){
                            case SPACE:
                            case TAB:
                            case SEMICOLON:
                            case CARRIAGE:
                            case NEWLINE:
                                break;
                            default:
                                chars += body.charAt(caret);
                        }
                        code = SEMICOLON;
                    }
                }
                // auto semicolon insertion
                if (insert === 1) switch(code){
                    // false flags
                    case OPENBRACES:
                    case CLOSEBRACES:
                    case SEMICOLON:
                    case DOUBLEQUOTE:
                    case SINGLEQUOTE:
                    case OPENPARENTHESES:
                    case CLOSEPARENTHESES:
                    case COMMA:
                        insert = 0;
                    // ignore
                    case TAB:
                    case CARRIAGE:
                    case NEWLINE:
                    case SPACE:
                        break;
                    // valid
                    default:
                        insert = 0;
                        length = caret;
                        first = code;
                        caret--;
                        code = SEMICOLON;
                        while(length < eof)switch(body.charCodeAt(length++)){
                            case NEWLINE:
                            case CARRIAGE:
                            case SEMICOLON:
                                ++caret;
                                code = first;
                                length = eof;
                                break;
                            case COLON:
                                if (format > 0) {
                                    ++caret;
                                    code = first;
                                }
                            case OPENBRACES:
                                length = eof;
                        }
                }
                // token varient
                switch(code){
                    case OPENBRACES:
                        chars = chars.trim();
                        first = chars.charCodeAt(0);
                        counter = 1;
                        length = ++caret;
                        while(caret < eof){
                            switch(code = body.charCodeAt(caret)){
                                case OPENBRACES:
                                    counter++;
                                    break;
                                case CLOSEBRACES:
                                    counter--;
                                    break;
                                case FOWARDSLASH:
                                    switch(second = body.charCodeAt(caret + 1)){
                                        // /*, //
                                        case STAR:
                                        case FOWARDSLASH:
                                            caret = delimited(second, caret, eol, body);
                                    }
                                    break;
                                // given "[" === 91 & "]" === 93 hence forth 91 + 1 + 1 === 93
                                case OPENBRACKET:
                                    code++;
                                // given "(" === 40 & ")" === 41 hence forth 40 + 1 === 41
                                case OPENPARENTHESES:
                                    code++;
                                // quote tail delimiter is identical to the head delimiter hence noop,
                                // fallthrough clauses have been shifted to the correct tail delimiter
                                case DOUBLEQUOTE:
                                case SINGLEQUOTE:
                                    while(caret++ < eol){
                                        if (body.charCodeAt(caret) === code) break;
                                    }
                            }
                            if (counter === 0) break;
                            caret++;
                        }
                        child = body.substring(length, caret);
                        if (first === NULL) first = (chars = chars.replace(nullptn, '').trim()).charCodeAt(0);
                        switch(first){
                            // @at-rule
                            case AT:
                                if (format > 0) chars = chars.replace(formatptn, '');
                                second = chars.charCodeAt(1);
                                switch(second){
                                    case DOCUMENT:
                                    case MEDIA:
                                    case SUPPORTS:
                                    case DASH:
                                        selector = current;
                                        break;
                                    default:
                                        selector = array;
                                }
                                child = compile(current, selector, child, second, depth + 1);
                                length = child.length;
                                // preserve empty @at-rule
                                if (preserve > 0 && length === 0) length = chars.length;
                                // execute plugins, @at-rule context
                                if (plugged > 0) {
                                    selector = select(array, chars, invert);
                                    result = proxy(ATRUL, child, selector, current, line, column, length, second, depth, id);
                                    chars = selector.join('');
                                    if (result !== void 0) {
                                        if ((length = (child = result.trim()).length) === 0) {
                                            second = 0;
                                            child = '';
                                        }
                                    }
                                }
                                if (length > 0) switch(second){
                                    case SUPPORTS:
                                        chars = chars.replace(supportsptn, supports);
                                    case DOCUMENT:
                                    case MEDIA:
                                    case DASH:
                                        child = chars + '{' + child + '}';
                                        break;
                                    case KEYFRAME:
                                        chars = chars.replace(keyframeptn, '$1 $2' + (keyed > 0 ? key : ''));
                                        child = chars + '{' + child + '}';
                                        if (prefix === 1 || prefix === 2 && vendor('@' + child, 3)) child = '@' + webkit + child + '@' + child;
                                        else child = '@' + child;
                                        break;
                                    default:
                                        child = chars + child;
                                        if (id === PAGE) child = (out += child, '');
                                }
                                else child = '';
                                break;
                            // selector
                            default:
                                child = compile(current, select(current, chars, invert), child, id, depth + 1);
                        }
                        children += child;
                        // reset
                        context = 0;
                        insert = 0;
                        pseudo = 0;
                        format = 0;
                        invert = 0;
                        atrule = 0;
                        chars = '';
                        child = '';
                        code = body.charCodeAt(++caret);
                        break;
                    case CLOSEBRACES:
                    case SEMICOLON:
                        chars = (format > 0 ? chars.replace(formatptn, '') : chars).trim();
                        if ((length = chars.length) > 1) {
                            // monkey-patch missing colon
                            if (pseudo === 0) {
                                first = chars.charCodeAt(0);
                                // first character is a letter or dash, buffer has a space character
                                if (first === DASH || first > 96 && first < 123) length = (chars = chars.replace(' ', ':')).length;
                            }
                            // execute plugins, property context
                            if (plugged > 0) {
                                if ((result = proxy(PROPS, chars, current, parent, line, column, out.length, id, depth, id)) !== void 0) {
                                    if ((length = (chars = result.trim()).length) === 0) chars = '\0\0';
                                }
                            }
                            first = chars.charCodeAt(0);
                            second = chars.charCodeAt(1);
                            switch(first){
                                case NULL:
                                    break;
                                case AT:
                                    if (second === IMPORT || second === CHARSET) {
                                        flat += chars + body.charAt(caret);
                                        break;
                                    }
                                default:
                                    if (chars.charCodeAt(length - 1) === COLON) break;
                                    out += property(chars, first, second, chars.charCodeAt(2));
                            }
                        }
                        // reset
                        context = 0;
                        insert = 0;
                        pseudo = 0;
                        format = 0;
                        invert = 0;
                        chars = '';
                        code = body.charCodeAt(++caret);
                        break;
                }
            }
            // parse characters
            switch(code){
                case CARRIAGE:
                case NEWLINE:
                    // auto insert semicolon
                    if (comment + quote + parentheses + bracket + semicolon === 0) // valid non-whitespace characters that
                    // may precede a newline
                    switch(peak){
                        case CLOSEPARENTHESES:
                        case SINGLEQUOTE:
                        case DOUBLEQUOTE:
                        case AT:
                        case TILDE:
                        case GREATERTHAN:
                        case STAR:
                        case PLUS:
                        case FOWARDSLASH:
                        case DASH:
                        case COLON:
                        case COMMA:
                        case SEMICOLON:
                        case OPENBRACES:
                        case CLOSEBRACES:
                            break;
                        default:
                            // current buffer has a colon
                            if (pseudo > 0) insert = 1;
                    }
                    // terminate line comment
                    if (comment === FOWARDSLASH) comment = 0;
                    else if (cascade + context === 0 && id !== KEYFRAME && chars.length > 0) {
                        format = 1;
                        chars += '\0';
                    }
                    // execute plugins, newline context
                    if (plugged * unkwn > 0) proxy(UNKWN, chars, current, parent, line, column, out.length, id, depth, id);
                    // next line, reset column position
                    column = 1;
                    line++;
                    break;
                case SEMICOLON:
                case CLOSEBRACES:
                    if (comment + quote + parentheses + bracket === 0) {
                        column++;
                        break;
                    }
                default:
                    // increment column position
                    column++;
                    // current character
                    char = body.charAt(caret);
                    // remove comments, escape functions, strings, attributes and prepare selectors
                    switch(code){
                        case TAB:
                        case SPACE:
                            if (quote + bracket + comment === 0) switch(tail){
                                case COMMA:
                                case COLON:
                                case TAB:
                                case SPACE:
                                    char = '';
                                    break;
                                default:
                                    if (code !== SPACE) char = ' ';
                            }
                            break;
                        // escape breaking control characters
                        case NULL:
                            char = '\\0';
                            break;
                        case FORMFEED:
                            char = '\\f';
                            break;
                        case VERTICALTAB:
                            char = '\\v';
                            break;
                        // &
                        case AND:
                            // inverted selector pattern i.e html &
                            if (quote + comment + bracket === 0 && cascade > 0) {
                                invert = 1;
                                format = 1;
                                char = '\f' + char;
                            }
                            break;
                        // ::p<l>aceholder, l
                        // :read-on<l>y, l
                        case 108:
                            if (quote + comment + bracket + pattern === 0 && pseudo > 0) switch(caret - pseudo){
                                // ::placeholder
                                case 2:
                                    if (tail === PLACEHOLDER && body.charCodeAt(caret - 3) === COLON) pattern = tail;
                                // :read-only
                                case 8:
                                    if (trail === READONLY) pattern = trail;
                            }
                            break;
                        // :<pattern>
                        case COLON:
                            if (quote + comment + bracket === 0) pseudo = caret;
                            break;
                        // selectors
                        case COMMA:
                            if (comment + parentheses + quote + bracket === 0) {
                                format = 1;
                                char += '\r';
                            }
                            break;
                        // quotes
                        case DOUBLEQUOTE:
                        case SINGLEQUOTE:
                            if (comment === 0) quote = quote === code ? 0 : quote === 0 ? code : quote;
                            break;
                        // attributes
                        case OPENBRACKET:
                            if (quote + comment + parentheses === 0) bracket++;
                            break;
                        case CLOSEBRACKET:
                            if (quote + comment + parentheses === 0) bracket--;
                            break;
                        // functions
                        case CLOSEPARENTHESES:
                            if (quote + comment + bracket === 0) parentheses--;
                            break;
                        case OPENPARENTHESES:
                            if (quote + comment + bracket === 0) {
                                if (context === 0) switch(tail * 2 + trail * 3){
                                    // :matches
                                    case 533:
                                        break;
                                    // :global, :not, :nth-child etc...
                                    default:
                                        counter = 0;
                                        context = 1;
                                }
                                parentheses++;
                            }
                            break;
                        case AT:
                            if (comment + parentheses + quote + bracket + pseudo + atrule === 0) atrule = 1;
                            break;
                        // block/line comments
                        case STAR:
                        case FOWARDSLASH:
                            if (quote + bracket + parentheses > 0) break;
                            switch(comment){
                                // initialize line/block comment context
                                case 0:
                                    switch(code * 2 + body.charCodeAt(caret + 1) * 3){
                                        // //
                                        case 235:
                                            comment = FOWARDSLASH;
                                            break;
                                        // /*
                                        case 220:
                                            length = caret;
                                            comment = STAR;
                                            break;
                                    }
                                    break;
                                // end block comment context
                                case STAR:
                                    if (code === FOWARDSLASH && tail === STAR && length + 2 !== caret) {
                                        // /*<!> ... */, !
                                        if (body.charCodeAt(length + 2) === 33) out += body.substring(length, caret + 1);
                                        char = '';
                                        comment = 0;
                                    }
                            }
                    }
                    // ignore comment blocks
                    if (comment === 0) {
                        // aggressive isolation mode, divide each individual selector
                        // including selectors in :not function but excluding selectors in :global function
                        if (cascade + quote + bracket + atrule === 0 && id !== KEYFRAME && code !== SEMICOLON) switch(code){
                            case COMMA:
                            case TILDE:
                            case GREATERTHAN:
                            case PLUS:
                            case CLOSEPARENTHESES:
                            case OPENPARENTHESES:
                                if (context === 0) {
                                    // outside of an isolated context i.e nth-child(<...>)
                                    switch(tail){
                                        case TAB:
                                        case SPACE:
                                        case NEWLINE:
                                        case CARRIAGE:
                                            char = char + '\0';
                                            break;
                                        default:
                                            char = '\0' + char + (code === COMMA ? '' : '\0');
                                    }
                                    format = 1;
                                } else // within an isolated context, sleep untill it's terminated
                                switch(code){
                                    case OPENPARENTHESES:
                                        // :globa<l>(
                                        if (pseudo + 7 === caret && tail === 108) pseudo = 0;
                                        context = ++counter;
                                        break;
                                    case CLOSEPARENTHESES:
                                        if ((context = --counter) === 0) {
                                            format = 1;
                                            char += '\0';
                                        }
                                        break;
                                }
                                break;
                            case TAB:
                            case SPACE:
                                switch(tail){
                                    case NULL:
                                    case OPENBRACES:
                                    case CLOSEBRACES:
                                    case SEMICOLON:
                                    case COMMA:
                                    case FORMFEED:
                                    case TAB:
                                    case SPACE:
                                    case NEWLINE:
                                    case CARRIAGE:
                                        break;
                                    default:
                                        // ignore in isolated contexts
                                        if (context === 0) {
                                            format = 1;
                                            char += '\0';
                                        }
                                }
                        }
                        // concat buffer of characters
                        chars += char;
                        // previous non-whitespace character code
                        if (code !== SPACE && code !== TAB) peak = code;
                    }
            }
            // tail character codes
            trail = tail;
            tail = code;
            // visit every character
            caret++;
        }
        length = out.length;
        // preserve empty selector
        if (preserve > 0) {
            if (length === 0 && children.length === 0 && current[0].length === 0 === false) {
                if (id !== MEDIA || current.length === 1 && (cascade > 0 ? nscopealt : nscope) === current[0]) length = current.join(',').length + 2;
            }
        }
        if (length > 0) {
            // cascade isolation mode?
            selector = cascade === 0 && id !== KEYFRAME ? isolate(current) : current;
            // execute plugins, block context
            if (plugged > 0) {
                result = proxy(BLCKS, out, selector, parent, line, column, length, id, depth, id);
                if (result !== void 0 && (out = result).length === 0) return flat + out + children;
            }
            out = selector.join(',') + '{' + out + '}';
            if (prefix * pattern !== 0) {
                if (prefix === 2 && !vendor(out, 2)) pattern = 0;
                switch(pattern){
                    // ::read-only
                    case READONLY:
                        out = out.replace(readonlyptn, ':' + moz + '$1') + out;
                        break;
                    // ::placeholder
                    case PLACEHOLDER:
                        out = out.replace(plcholdrptn, '::' + webkit + 'input-$1') + out.replace(plcholdrptn, '::' + moz + '$1') + out.replace(plcholdrptn, ':' + ms + 'input-$1') + out;
                        break;
                }
                pattern = 0;
            }
        }
        return flat + out + children;
    }
    /**
	 * Select
	 *
	 * @param {Array<string>} parent
	 * @param {string} current
	 * @param {number} invert
	 * @return {Array<string>}
	 */ function select(parent, current, invert) {
        var selectors = current.trim().split(selectorptn);
        var out = selectors;
        var length = selectors.length;
        var l = parent.length;
        switch(l){
            // 0-1 parent selectors
            case 0:
            case 1:
                for(var i = 0, selector = l === 0 ? '' : parent[0] + ' '; i < length; ++i)out[i] = scope(selector, out[i], invert, l).trim();
                break;
            // >2 parent selectors, nested
            default:
                for(var i = 0, j = 0, out = []; i < length; ++i)for(var k = 0; k < l; ++k)out[j++] = scope(parent[k] + ' ', selectors[i], invert, l).trim();
        }
        return out;
    }
    /**
	 * Scope
	 *
	 * @param {string} parent
	 * @param {string} current
	 * @param {number} invert
	 * @param {number} level
	 * @return {string}
	 */ function scope(parent, current, invert, level) {
        var selector = current;
        var code = selector.charCodeAt(0);
        // trim leading whitespace
        if (code < 33) code = (selector = selector.trim()).charCodeAt(0);
        switch(code){
            // &
            case AND:
                switch(cascade + level){
                    case 0:
                    case 1:
                        if (parent.trim().length === 0) break;
                    default:
                        return selector.replace(andptn, '$1' + parent.trim());
                }
                break;
            // :
            case COLON:
                switch(selector.charCodeAt(1)){
                    // g in :global
                    case 103:
                        if (escape > 0 && cascade > 0) return selector.replace(escapeptn, '$1').replace(andptn, '$1' + nscope);
                        break;
                    default:
                        // :hover
                        return parent.trim() + selector.replace(andptn, '$1' + parent.trim());
                }
            default:
                // html &
                if (invert * cascade > 0 && selector.indexOf('\f') > 0) return selector.replace(andptn, (parent.charCodeAt(0) === COLON ? '' : '$1') + parent.trim());
        }
        return parent + selector;
    }
    /**
	 * Property
	 *
	 * @param {string} input
	 * @param {number} first
	 * @param {number} second
	 * @param {number} third
	 * @return {string}
	 */ function property(input, first, second, third) {
        var index = 0;
        var out = input + ';';
        var hash = first * 2 + second * 3 + third * 4;
        var cache;
        // animation: a, n, i characters
        if (hash === 944) return animation(out);
        else if (prefix === 0 || prefix === 2 && !vendor(out, 1)) return out;
        // vendor prefix
        switch(hash){
            // text-decoration/text-size-adjust/text-shadow/text-align/text-transform: t, e, x
            case 1015:
                // text-shadow/text-align/text-transform, a
                return out.charCodeAt(10) === 97 ? webkit + out + out : out;
            // filter/fill f, i, l
            case 951:
                // filter, t
                return out.charCodeAt(3) === 116 ? webkit + out + out : out;
            // color/column, c, o, l
            case 963:
                // column, n
                return out.charCodeAt(5) === 110 ? webkit + out + out : out;
            // box-decoration-break, b, o, x
            case 1009:
                if (out.charCodeAt(4) !== 100) break;
            // mask, m, a, s
            // clip-path, c, l, i
            case 969:
            case 942:
                return webkit + out + out;
            // appearance: a, p, p
            case 978:
                return webkit + out + moz + out + out;
            // hyphens: h, y, p
            // user-select: u, s, e
            case 1019:
            case 983:
                return webkit + out + moz + out + ms + out + out;
            // background/backface-visibility, b, a, c
            case 883:
                // backface-visibility, -
                if (out.charCodeAt(8) === DASH) return webkit + out + out;
                // image-set(...)
                if (out.indexOf('image-set(', 11) > 0) return out.replace(imgsrcptn, '$1' + webkit + '$2') + out;
                return out;
            // flex: f, l, e
            case 932:
                if (out.charCodeAt(4) === DASH) switch(out.charCodeAt(5)){
                    // flex-grow, g
                    case 103:
                        return webkit + 'box-' + out.replace('-grow', '') + webkit + out + ms + out.replace('grow', 'positive') + out;
                    // flex-shrink, s
                    case 115:
                        return webkit + out + ms + out.replace('shrink', 'negative') + out;
                    // flex-basis, b
                    case 98:
                        return webkit + out + ms + out.replace('basis', 'preferred-size') + out;
                }
                return webkit + out + ms + out + out;
            // order: o, r, d
            case 964:
                return webkit + out + ms + 'flex' + '-' + out + out;
            // justify-items/justify-content, j, u, s
            case 1023:
                // justify-content, c
                if (out.charCodeAt(8) !== 99) break;
                cache = out.substring(out.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify');
                return webkit + 'box-pack' + cache + webkit + out + ms + 'flex-pack' + cache + out;
            // cursor, c, u, r
            case 1005:
                return cursorptn.test(out) ? out.replace(colonptn, ':' + webkit) + out.replace(colonptn, ':' + moz) + out : out;
            // writing-mode, w, r, i
            case 1000:
                cache = out.substring(13).trim();
                index = cache.indexOf('-') + 1;
                switch(cache.charCodeAt(0) + cache.charCodeAt(index)){
                    // vertical-lr
                    case 226:
                        cache = out.replace(writingptn, 'tb');
                        break;
                    // vertical-rl
                    case 232:
                        cache = out.replace(writingptn, 'tb-rl');
                        break;
                    // horizontal-tb
                    case 220:
                        cache = out.replace(writingptn, 'lr');
                        break;
                    default:
                        return out;
                }
                return webkit + out + ms + cache + out;
            // position: sticky
            case 1017:
                if (out.indexOf('sticky', 9) === -1) return out;
            // display(flex/inline-flex/inline-box): d, i, s
            case 975:
                index = (out = input).length - 10;
                cache = (out.charCodeAt(index) === 33 ? out.substring(0, index) : out).substring(input.indexOf(':', 7) + 1).trim();
                switch(hash = cache.charCodeAt(0) + (cache.charCodeAt(7) | 0)){
                    // inline-
                    case 203:
                        // inline-box
                        if (cache.charCodeAt(8) < 111) break;
                    // inline-box/sticky
                    case 115:
                        out = out.replace(cache, webkit + cache) + ';' + out;
                        break;
                    // inline-flex
                    // flex
                    case 207:
                    case 102:
                        out = out.replace(cache, webkit + (hash > 102 ? 'inline-' : '') + 'box') + ';' + out.replace(cache, webkit + cache) + ';' + out.replace(cache, ms + cache + 'box') + ';' + out;
                }
                return out + ';';
            // align-items, align-center, align-self: a, l, i, -
            case 938:
                if (out.charCodeAt(5) === DASH) switch(out.charCodeAt(6)){
                    // align-items, i
                    case 105:
                        cache = out.replace('-items', '');
                        return webkit + out + webkit + 'box-' + cache + ms + 'flex-' + cache + out;
                    // align-self, s
                    case 115:
                        return webkit + out + ms + 'flex-item-' + out.replace(selfptn, '') + out;
                    // align-content
                    default:
                        return webkit + out + ms + 'flex-line-pack' + out.replace('align-content', '').replace(selfptn, '') + out;
                }
                break;
            // min/max
            case 973:
            case 989:
                // min-/max- height/width/block-size/inline-size
                if (out.charCodeAt(3) !== DASH || out.charCodeAt(4) === 122) break;
            // height/width: min-content / width: max-content
            case 931:
            case 953:
                if (dimensionptn.test(input) === true) {
                    // stretch
                    if ((cache = input.substring(input.indexOf(':') + 1)).charCodeAt(0) === 115) return property(input.replace('stretch', 'fill-available'), first, second, third).replace(':fill-available', ':stretch');
                    else return out.replace(cache, webkit + cache) + out.replace(cache, moz + cache.replace('fill-', '')) + out;
                }
                break;
            // transform, transition: t, r, a
            case 962:
                out = webkit + out + (out.charCodeAt(5) === 102 ? ms + out : '') + out;
                // transitions
                if (second + third === 211 && out.charCodeAt(13) === 105 && out.indexOf('transform', 10) > 0) return out.substring(0, out.indexOf(';', 27) + 1).replace(transformptn, '$1' + webkit + '$2') + out;
                break;
        }
        return out;
    }
    /**
	 * Vendor
	 *
	 * @param {string} content
	 * @param {number} context
	 * @return {boolean}
	 */ function vendor(content, context) {
        var index = content.indexOf(context === 1 ? ':' : '{');
        var key = content.substring(0, context !== 3 ? index : 10);
        var value = content.substring(index + 1, content.length - 1);
        return should(context !== 2 ? key : key.replace(pseudofmt, '$1'), value, context);
    }
    /**
	 * Supports
	 *
	 * @param {string} match
	 * @param {string} group
	 * @return {string}
	 */ function supports(match, group) {
        var out = property(group, group.charCodeAt(0), group.charCodeAt(1), group.charCodeAt(2));
        return out !== group + ';' ? out.replace(propertyptn, ' or ($1)').substring(4) : '(' + group + ')';
    }
    /**
	 * Animation
	 *
	 * @param {string} input
	 * @return {string}
	 */ function animation(input) {
        var length = input.length;
        var index = input.indexOf(':', 9) + 1;
        var declare = input.substring(0, index).trim();
        var out = input.substring(index, length - 1).trim();
        switch(input.charCodeAt(9) * keyed){
            case 0:
                break;
            // animation-*, -
            case DASH:
                // animation-name, n
                if (input.charCodeAt(10) !== 110) break;
            // animation/animation-name
            default:
                // split in case of multiple animations
                var list = out.split((out = '', animationptn));
                for(var i = 0, index = 0, length = list.length; i < length; index = 0, ++i){
                    var value = list[i];
                    var items = value.split(propertiesptn);
                    while(value = items[index]){
                        var peak = value.charCodeAt(0);
                        if (keyed === 1 && (// letters
                        peak > AT && peak < 90 || peak > 96 && peak < 123 || peak === UNDERSCORE || // dash but not in sequence i.e --
                        peak === DASH && value.charCodeAt(1) !== DASH)) // not a number/function
                        switch(isNaN(parseFloat(value)) + (value.indexOf('(') !== -1)){
                            case 1:
                                switch(value){
                                    // not a valid reserved keyword
                                    case 'infinite':
                                    case 'alternate':
                                    case 'backwards':
                                    case 'running':
                                    case 'normal':
                                    case 'forwards':
                                    case 'both':
                                    case 'none':
                                    case 'linear':
                                    case 'ease':
                                    case 'ease-in':
                                    case 'ease-out':
                                    case 'ease-in-out':
                                    case 'paused':
                                    case 'reverse':
                                    case 'alternate-reverse':
                                    case 'inherit':
                                    case 'initial':
                                    case 'unset':
                                    case 'step-start':
                                    case 'step-end':
                                        break;
                                    default:
                                        value += key;
                                }
                        }
                        items[index++] = value;
                    }
                    out += (i === 0 ? '' : ',') + items.join(' ');
                }
        }
        out = declare + out + ';';
        if (prefix === 1 || prefix === 2 && vendor(out, 1)) return webkit + out + out;
        return out;
    }
    /**
	 * Isolate
	 *
	 * @param {Array<string>} current
	 */ function isolate(current) {
        for(var i = 0, length = current.length, selector = Array(length), padding, element; i < length; ++i){
            // split individual elements in a selector i.e h1 h2 === [h1, h2]
            var elements = current[i].split(elementptn);
            var out = '';
            for(var j = 0, size = 0, tail = 0, code = 0, l = elements.length; j < l; ++j){
                // empty element
                if ((size = (element = elements[j]).length) === 0 && l > 1) continue;
                tail = out.charCodeAt(out.length - 1);
                code = element.charCodeAt(0);
                padding = '';
                if (j !== 0) // determine if we need padding
                switch(tail){
                    case STAR:
                    case TILDE:
                    case GREATERTHAN:
                    case PLUS:
                    case SPACE:
                    case OPENPARENTHESES:
                        break;
                    default:
                        padding = ' ';
                }
                switch(code){
                    case AND:
                        element = padding + nscopealt;
                    case TILDE:
                    case GREATERTHAN:
                    case PLUS:
                    case SPACE:
                    case CLOSEPARENTHESES:
                    case OPENPARENTHESES:
                        break;
                    case OPENBRACKET:
                        element = padding + element + nscopealt;
                        break;
                    case COLON:
                        switch(element.charCodeAt(1) * 2 + element.charCodeAt(2) * 3){
                            // :global
                            case 530:
                                if (escape > 0) {
                                    element = padding + element.substring(8, size - 1);
                                    break;
                                }
                            // :hover, :nth-child(), ...
                            default:
                                if (j < 1 || elements[j - 1].length < 1) element = padding + nscopealt + element;
                        }
                        break;
                    case COMMA:
                        padding = '';
                    default:
                        if (size > 1 && element.indexOf(':') > 0) element = padding + element.replace(pseudoptn, '$1' + nscopealt + '$2');
                        else element = padding + element + nscopealt;
                }
                out += element;
            }
            selector[i] = out.replace(formatptn, '').trim();
        }
        return selector;
    }
    /**
	 * Proxy
	 *
	 * @param {number} context
	 * @param {string} content
	 * @param {Array<string>} selectors
	 * @param {Array<string>} parents
	 * @param {number} line
	 * @param {number} column
	 * @param {number} length
	 * @param {number} id
	 * @param {number} depth
	 * @param {number} at
	 * @return {(string|void|*)}
	 */ function proxy(context, content, selectors, parents, line, column, length, id, depth, at) {
        for(var i = 0, out = content, next; i < plugged; ++i)switch(next = plugins[i].call(stylis, context, out, selectors, parents, line, column, length, id, depth, at)){
            case void 0:
            case false:
            case true:
            case null:
                break;
            default:
                out = next;
        }
        if (out !== content) return out;
    }
    /**
	 * @param {number} code
	 * @param {number} index
	 * @param {number} length
	 * @param {string} body
	 * @return {number}
	 */ function delimited(code, index, length, body) {
        for(var i = index + 1; i < length; ++i)switch(body.charCodeAt(i)){
            // /*
            case FOWARDSLASH:
                if (code === STAR) {
                    if (body.charCodeAt(i - 1) === STAR && index + 2 !== i) return i + 1;
                }
                break;
            // //
            case NEWLINE:
                if (code === FOWARDSLASH) return i + 1;
        }
        return i;
    }
    /**
	 * @param {number} type
	 * @param {number} index
	 * @param {number} length
	 * @param {number} find
	 * @param {string} body
	 * @return {number}
	 */ function match(type, index, length, body) {
        for(var i = index + 1; i < length; ++i)switch(body.charCodeAt(i)){
            case type:
                return i;
        }
        return i;
    }
    /**
	 * Minify
	 *
	 * @param {(string|*)} output
	 * @return {string}
	 */ function minify(output) {
        return output.replace(formatptn, '').replace(beforeptn, '').replace(afterptn, '$1').replace(tailptn, '$1').replace(whiteptn, ' ');
    }
    /**
	 * Use
	 *
	 * @param {(Array<function(...?)>|function(...?)|number|void)?} plugin
	 */ function use(plugin) {
        switch(plugin){
            case void 0:
            case null:
                plugged = plugins.length = 0;
                break;
            default:
                if (typeof plugin === 'function') plugins[plugged++] = plugin;
                else if (typeof plugin === 'object') for(var i = 0, length = plugin.length; i < length; ++i)use(plugin[i]);
                else unkwn = !!plugin | 0;
        }
        return use;
    }
    /**
	 * Set
	 *
	 * @param {*} options
	 */ function set(options) {
        for(var name in options){
            var value = options[name];
            switch(name){
                case 'keyframe':
                    keyed = value | 0;
                    break;
                case 'global':
                    escape = value | 0;
                    break;
                case 'cascade':
                    cascade = value | 0;
                    break;
                case 'compress':
                    compress = value | 0;
                    break;
                case 'semicolon':
                    semicolon = value | 0;
                    break;
                case 'preserve':
                    preserve = value | 0;
                    break;
                case 'prefix':
                    should = null;
                    if (!value) prefix = 0;
                    else if (typeof value !== 'function') prefix = 1;
                    else {
                        prefix = 2;
                        should = value;
                    }
            }
        }
        return set;
    }
    /**
	 * Stylis
	 *
	 * @param {string} selector
	 * @param {string} input
	 * @return {*}
	 */ function stylis(selector, input) {
        if (this !== void 0 && this.constructor === stylis) return factory(selector);
        // setup
        var ns = selector;
        var code = ns.charCodeAt(0);
        // trim leading whitespace
        if (code < 33) code = (ns = ns.trim()).charCodeAt(0);
        // keyframe/animation namespace
        if (keyed > 0) key = ns.replace(invalidptn, code === OPENBRACKET ? '' : '-');
        // reset, used to assert if a plugin is moneky-patching the return value
        code = 1;
        // cascade/isolate
        if (cascade === 1) nscope = ns;
        else nscopealt = ns;
        var selectors = [
            nscope
        ];
        var result;
        // execute plugins, pre-process context
        if (plugged > 0) {
            result = proxy(PREPS, input, selectors, selectors, line, column, 0, 0, 0, 0);
            if (result !== void 0 && typeof result === 'string') input = result;
        }
        // build
        var output = compile(array, selectors, input, 0, 0);
        // execute plugins, post-process context
        if (plugged > 0) {
            result = proxy(POSTS, output, selectors, selectors, line, column, output.length, 0, 0, 0);
            // bypass minification
            if (result !== void 0 && typeof (output = result) !== 'string') code = 0;
        }
        // reset
        key = '';
        nscope = '';
        nscopealt = '';
        pattern = 0;
        line = 1;
        column = 1;
        return compress * code === 0 ? output : minify(output);
    }
    stylis['use'] = use;
    stylis['set'] = set;
    if (options !== void 0) set(options);
    return stylis;
});

});

parcelRegister("jV1Wh", function(module, exports) {
(function(factory) {
    module.exports = factory();
})(function() {
    'use strict';
    return function(insertRule) {
        var delimiter = '/*|*/';
        var needle = delimiter + '}';
        function toSheet(block) {
            if (block) try {
                insertRule(block + '}');
            } catch (e) {}
        }
        return function ruleSheet(context, content, selectors, parents, line, column, length, ns, depth, at) {
            switch(context){
                // property
                case 1:
                    // @import
                    if (depth === 0 && content.charCodeAt(0) === 64) return insertRule(content + ';'), '';
                    break;
                // selector
                case 2:
                    if (ns === 0) return content + delimiter;
                    break;
                // at-rule
                case 3:
                    switch(ns){
                        // @font-face, @page
                        case 102:
                        case 112:
                            return insertRule(selectors[0] + content), '';
                        default:
                            return content + (at === 0 ? delimiter : '');
                    }
                case -2:
                    content.split(needle).forEach(toSheet);
            }
        };
    };
});

});

parcelRegister("aFLNS", function(module, exports) {
'use strict';

module.exports = (parcelRequire("eb9hx"));

});
parcelRegister("eb9hx", function(module, exports) {
$parcel$export(module.exports, "AsyncMode", () => $a5294af71d7ee63e$export$2b8d127b894957b9, (v) => $a5294af71d7ee63e$export$2b8d127b894957b9 = v);
$parcel$export(module.exports, "ConcurrentMode", () => $a5294af71d7ee63e$export$cea3a54a6425200c, (v) => $a5294af71d7ee63e$export$cea3a54a6425200c = v);
$parcel$export(module.exports, "ContextConsumer", () => $a5294af71d7ee63e$export$a7c73072b1a182ae, (v) => $a5294af71d7ee63e$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $a5294af71d7ee63e$export$9f27bc3417b4524d, (v) => $a5294af71d7ee63e$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $a5294af71d7ee63e$export$db77ccec0bb4ccac, (v) => $a5294af71d7ee63e$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $a5294af71d7ee63e$export$8392c0c9d3dcbd35, (v) => $a5294af71d7ee63e$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $a5294af71d7ee63e$export$ffb0004e005737fa, (v) => $a5294af71d7ee63e$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $a5294af71d7ee63e$export$b624eff549462981, (v) => $a5294af71d7ee63e$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $a5294af71d7ee63e$export$7897aa7841a5380c, (v) => $a5294af71d7ee63e$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $a5294af71d7ee63e$export$602eac185826482c, (v) => $a5294af71d7ee63e$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $a5294af71d7ee63e$export$e2c29f18771995cb, (v) => $a5294af71d7ee63e$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $a5294af71d7ee63e$export$5f8d39834fd61797, (v) => $a5294af71d7ee63e$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $a5294af71d7ee63e$export$74bf444e3cd11ea5, (v) => $a5294af71d7ee63e$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $a5294af71d7ee63e$export$92387174baf9b227, (v) => $a5294af71d7ee63e$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $a5294af71d7ee63e$export$ec112efeb987d9c6, (v) => $a5294af71d7ee63e$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $a5294af71d7ee63e$export$b706b080d889d2c9, (v) => $a5294af71d7ee63e$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $a5294af71d7ee63e$export$5be5a87408f70ddc, (v) => $a5294af71d7ee63e$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $a5294af71d7ee63e$export$45a5e7f76e0caa8d, (v) => $a5294af71d7ee63e$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $a5294af71d7ee63e$export$455c2e768291efa6, (v) => $a5294af71d7ee63e$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $a5294af71d7ee63e$export$9522e17588c12572, (v) => $a5294af71d7ee63e$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $a5294af71d7ee63e$export$2110ac352bb060b9, (v) => $a5294af71d7ee63e$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $a5294af71d7ee63e$export$56885ab8b9c456ab, (v) => $a5294af71d7ee63e$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $a5294af71d7ee63e$export$d927fcb6adf8f9de, (v) => $a5294af71d7ee63e$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $a5294af71d7ee63e$export$b82d16f27459e05a, (v) => $a5294af71d7ee63e$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $a5294af71d7ee63e$export$522c17b4f5e123e8, (v) => $a5294af71d7ee63e$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $a5294af71d7ee63e$export$1aabd8a0274ecfd6, (v) => $a5294af71d7ee63e$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $a5294af71d7ee63e$export$9b621391a187a31a, (v) => $a5294af71d7ee63e$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $a5294af71d7ee63e$export$f5bbd400c2f4426f, (v) => $a5294af71d7ee63e$export$f5bbd400c2f4426f = v);
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $a5294af71d7ee63e$export$2b8d127b894957b9;
var $a5294af71d7ee63e$export$cea3a54a6425200c;
var $a5294af71d7ee63e$export$a7c73072b1a182ae;
var $a5294af71d7ee63e$export$9f27bc3417b4524d;
var $a5294af71d7ee63e$export$db77ccec0bb4ccac;
var $a5294af71d7ee63e$export$8392c0c9d3dcbd35;
var $a5294af71d7ee63e$export$ffb0004e005737fa;
var $a5294af71d7ee63e$export$b624eff549462981;
var $a5294af71d7ee63e$export$7897aa7841a5380c;
var $a5294af71d7ee63e$export$602eac185826482c;
var $a5294af71d7ee63e$export$e2c29f18771995cb;
var $a5294af71d7ee63e$export$5f8d39834fd61797;
var $a5294af71d7ee63e$export$74bf444e3cd11ea5;
var $a5294af71d7ee63e$export$92387174baf9b227;
var $a5294af71d7ee63e$export$ec112efeb987d9c6;
var $a5294af71d7ee63e$export$b706b080d889d2c9;
var $a5294af71d7ee63e$export$5be5a87408f70ddc;
var $a5294af71d7ee63e$export$45a5e7f76e0caa8d;
var $a5294af71d7ee63e$export$455c2e768291efa6;
var $a5294af71d7ee63e$export$9522e17588c12572;
var $a5294af71d7ee63e$export$2110ac352bb060b9;
var $a5294af71d7ee63e$export$56885ab8b9c456ab;
var $a5294af71d7ee63e$export$d927fcb6adf8f9de;
var $a5294af71d7ee63e$export$b82d16f27459e05a;
var $a5294af71d7ee63e$export$522c17b4f5e123e8;
var $a5294af71d7ee63e$export$1aabd8a0274ecfd6;
var $a5294af71d7ee63e$export$9b621391a187a31a;
var $a5294af71d7ee63e$export$f5bbd400c2f4426f;
'use strict';
var $a5294af71d7ee63e$var$b = "function" === typeof Symbol && Symbol.for, $a5294af71d7ee63e$var$c = $a5294af71d7ee63e$var$b ? Symbol.for("react.element") : 60103, $a5294af71d7ee63e$var$d = $a5294af71d7ee63e$var$b ? Symbol.for("react.portal") : 60106, $a5294af71d7ee63e$var$e = $a5294af71d7ee63e$var$b ? Symbol.for("react.fragment") : 60107, $a5294af71d7ee63e$var$f = $a5294af71d7ee63e$var$b ? Symbol.for("react.strict_mode") : 60108, $a5294af71d7ee63e$var$g = $a5294af71d7ee63e$var$b ? Symbol.for("react.profiler") : 60114, $a5294af71d7ee63e$var$h = $a5294af71d7ee63e$var$b ? Symbol.for("react.provider") : 60109, $a5294af71d7ee63e$var$k = $a5294af71d7ee63e$var$b ? Symbol.for("react.context") : 60110, $a5294af71d7ee63e$var$l = $a5294af71d7ee63e$var$b ? Symbol.for("react.async_mode") : 60111, $a5294af71d7ee63e$var$m = $a5294af71d7ee63e$var$b ? Symbol.for("react.concurrent_mode") : 60111, $a5294af71d7ee63e$var$n = $a5294af71d7ee63e$var$b ? Symbol.for("react.forward_ref") : 60112, $a5294af71d7ee63e$var$p = $a5294af71d7ee63e$var$b ? Symbol.for("react.suspense") : 60113, $a5294af71d7ee63e$var$q = $a5294af71d7ee63e$var$b ? Symbol.for("react.suspense_list") : 60120, $a5294af71d7ee63e$var$r = $a5294af71d7ee63e$var$b ? Symbol.for("react.memo") : 60115, $a5294af71d7ee63e$var$t = $a5294af71d7ee63e$var$b ? Symbol.for("react.lazy") : 60116, $a5294af71d7ee63e$var$v = $a5294af71d7ee63e$var$b ? Symbol.for("react.block") : 60121, $a5294af71d7ee63e$var$w = $a5294af71d7ee63e$var$b ? Symbol.for("react.fundamental") : 60117, $a5294af71d7ee63e$var$x = $a5294af71d7ee63e$var$b ? Symbol.for("react.responder") : 60118, $a5294af71d7ee63e$var$y = $a5294af71d7ee63e$var$b ? Symbol.for("react.scope") : 60119;
function $a5294af71d7ee63e$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $a5294af71d7ee63e$var$c:
                switch(a = a.type, a){
                    case $a5294af71d7ee63e$var$l:
                    case $a5294af71d7ee63e$var$m:
                    case $a5294af71d7ee63e$var$e:
                    case $a5294af71d7ee63e$var$g:
                    case $a5294af71d7ee63e$var$f:
                    case $a5294af71d7ee63e$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $a5294af71d7ee63e$var$k:
                            case $a5294af71d7ee63e$var$n:
                            case $a5294af71d7ee63e$var$t:
                            case $a5294af71d7ee63e$var$r:
                            case $a5294af71d7ee63e$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $a5294af71d7ee63e$var$d:
                return u;
        }
    }
}
function $a5294af71d7ee63e$var$A(a) {
    return $a5294af71d7ee63e$var$z(a) === $a5294af71d7ee63e$var$m;
}
$a5294af71d7ee63e$export$2b8d127b894957b9 = $a5294af71d7ee63e$var$l;
$a5294af71d7ee63e$export$cea3a54a6425200c = $a5294af71d7ee63e$var$m;
$a5294af71d7ee63e$export$a7c73072b1a182ae = $a5294af71d7ee63e$var$k;
$a5294af71d7ee63e$export$9f27bc3417b4524d = $a5294af71d7ee63e$var$h;
$a5294af71d7ee63e$export$db77ccec0bb4ccac = $a5294af71d7ee63e$var$c;
$a5294af71d7ee63e$export$8392c0c9d3dcbd35 = $a5294af71d7ee63e$var$n;
$a5294af71d7ee63e$export$ffb0004e005737fa = $a5294af71d7ee63e$var$e;
$a5294af71d7ee63e$export$b624eff549462981 = $a5294af71d7ee63e$var$t;
$a5294af71d7ee63e$export$7897aa7841a5380c = $a5294af71d7ee63e$var$r;
$a5294af71d7ee63e$export$602eac185826482c = $a5294af71d7ee63e$var$d;
$a5294af71d7ee63e$export$e2c29f18771995cb = $a5294af71d7ee63e$var$g;
$a5294af71d7ee63e$export$5f8d39834fd61797 = $a5294af71d7ee63e$var$f;
$a5294af71d7ee63e$export$74bf444e3cd11ea5 = $a5294af71d7ee63e$var$p;
$a5294af71d7ee63e$export$92387174baf9b227 = function(a) {
    return $a5294af71d7ee63e$var$A(a) || $a5294af71d7ee63e$var$z(a) === $a5294af71d7ee63e$var$l;
};
$a5294af71d7ee63e$export$ec112efeb987d9c6 = $a5294af71d7ee63e$var$A;
$a5294af71d7ee63e$export$b706b080d889d2c9 = function(a) {
    return $a5294af71d7ee63e$var$z(a) === $a5294af71d7ee63e$var$k;
};
$a5294af71d7ee63e$export$5be5a87408f70ddc = function(a) {
    return $a5294af71d7ee63e$var$z(a) === $a5294af71d7ee63e$var$h;
};
$a5294af71d7ee63e$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $a5294af71d7ee63e$var$c;
};
$a5294af71d7ee63e$export$455c2e768291efa6 = function(a) {
    return $a5294af71d7ee63e$var$z(a) === $a5294af71d7ee63e$var$n;
};
$a5294af71d7ee63e$export$9522e17588c12572 = function(a) {
    return $a5294af71d7ee63e$var$z(a) === $a5294af71d7ee63e$var$e;
};
$a5294af71d7ee63e$export$2110ac352bb060b9 = function(a) {
    return $a5294af71d7ee63e$var$z(a) === $a5294af71d7ee63e$var$t;
};
$a5294af71d7ee63e$export$56885ab8b9c456ab = function(a) {
    return $a5294af71d7ee63e$var$z(a) === $a5294af71d7ee63e$var$r;
};
$a5294af71d7ee63e$export$d927fcb6adf8f9de = function(a) {
    return $a5294af71d7ee63e$var$z(a) === $a5294af71d7ee63e$var$d;
};
$a5294af71d7ee63e$export$b82d16f27459e05a = function(a) {
    return $a5294af71d7ee63e$var$z(a) === $a5294af71d7ee63e$var$g;
};
$a5294af71d7ee63e$export$522c17b4f5e123e8 = function(a) {
    return $a5294af71d7ee63e$var$z(a) === $a5294af71d7ee63e$var$f;
};
$a5294af71d7ee63e$export$1aabd8a0274ecfd6 = function(a) {
    return $a5294af71d7ee63e$var$z(a) === $a5294af71d7ee63e$var$p;
};
$a5294af71d7ee63e$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $a5294af71d7ee63e$var$e || a === $a5294af71d7ee63e$var$m || a === $a5294af71d7ee63e$var$g || a === $a5294af71d7ee63e$var$f || a === $a5294af71d7ee63e$var$p || a === $a5294af71d7ee63e$var$q || "object" === typeof a && null !== a && (a.$$typeof === $a5294af71d7ee63e$var$t || a.$$typeof === $a5294af71d7ee63e$var$r || a.$$typeof === $a5294af71d7ee63e$var$h || a.$$typeof === $a5294af71d7ee63e$var$k || a.$$typeof === $a5294af71d7ee63e$var$n || a.$$typeof === $a5294af71d7ee63e$var$w || a.$$typeof === $a5294af71d7ee63e$var$x || a.$$typeof === $a5294af71d7ee63e$var$y || a.$$typeof === $a5294af71d7ee63e$var$v);
};
$a5294af71d7ee63e$export$f5bbd400c2f4426f = $a5294af71d7ee63e$var$z;

});


parcelRegister("9eopB", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $6b885b90e26b1c0a$export$2e2bcd8739ae039);
function $6b885b90e26b1c0a$var$isAbsolute(pathname) {
    return pathname.charAt(0) === '/';
}
// About 1.5x faster than the two-arg version of Array#splice()
function $6b885b90e26b1c0a$var$spliceOne(list, index) {
    for(var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1)list[i] = list[k];
    list.pop();
}
// This implementation is based heavily on node's url.parse
function $6b885b90e26b1c0a$var$resolvePathname(to) {
    var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var toParts = to && to.split('/') || [];
    var fromParts = from && from.split('/') || [];
    var isToAbs = to && $6b885b90e26b1c0a$var$isAbsolute(to);
    var isFromAbs = from && $6b885b90e26b1c0a$var$isAbsolute(from);
    var mustEndAbs = isToAbs || isFromAbs;
    if (to && $6b885b90e26b1c0a$var$isAbsolute(to)) // to is absolute
    fromParts = toParts;
    else if (toParts.length) {
        // to is relative, drop the filename
        fromParts.pop();
        fromParts = fromParts.concat(toParts);
    }
    if (!fromParts.length) return '/';
    var hasTrailingSlash = void 0;
    if (fromParts.length) {
        var last = fromParts[fromParts.length - 1];
        hasTrailingSlash = last === '.' || last === '..' || last === '';
    } else hasTrailingSlash = false;
    var up = 0;
    for(var i = fromParts.length; i >= 0; i--){
        var part = fromParts[i];
        if (part === '.') $6b885b90e26b1c0a$var$spliceOne(fromParts, i);
        else if (part === '..') {
            $6b885b90e26b1c0a$var$spliceOne(fromParts, i);
            up++;
        } else if (up) {
            $6b885b90e26b1c0a$var$spliceOne(fromParts, i);
            up--;
        }
    }
    if (!mustEndAbs) for(; up--; up)fromParts.unshift('..');
    if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !$6b885b90e26b1c0a$var$isAbsolute(fromParts[0]))) fromParts.unshift('');
    var result = fromParts.join('/');
    if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';
    return result;
}
var $6b885b90e26b1c0a$export$2e2bcd8739ae039 = $6b885b90e26b1c0a$var$resolvePathname;

});

parcelRegister("L36vo", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $08d6cc469e5984fb$export$2e2bcd8739ae039);
var $08d6cc469e5984fb$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
function $08d6cc469e5984fb$var$valueEqual(a, b) {
    if (a === b) return true;
    if (a == null || b == null) return false;
    if (Array.isArray(a)) return Array.isArray(b) && a.length === b.length && a.every(function(item, index) {
        return $08d6cc469e5984fb$var$valueEqual(item, b[index]);
    });
    var aType = typeof a === 'undefined' ? 'undefined' : $08d6cc469e5984fb$var$_typeof(a);
    var bType = typeof b === 'undefined' ? 'undefined' : $08d6cc469e5984fb$var$_typeof(b);
    if (aType !== bType) return false;
    if (aType === 'object') {
        var aValue = a.valueOf();
        var bValue = b.valueOf();
        if (aValue !== a || bValue !== b) return $08d6cc469e5984fb$var$valueEqual(aValue, bValue);
        var aKeys = Object.keys(a);
        var bKeys = Object.keys(b);
        if (aKeys.length !== bKeys.length) return false;
        return aKeys.every(function(key) {
            return $08d6cc469e5984fb$var$valueEqual(a[key], b[key]);
        });
    }
    return false;
}
var $08d6cc469e5984fb$export$2e2bcd8739ae039 = $08d6cc469e5984fb$var$valueEqual;

});

parcelRegister("gt9Am", function(module, exports) {
'use strict';

module.exports = (parcelRequire("ipybr"));

});
parcelRegister("ipybr", function(module, exports) {
$parcel$export(module.exports, "Fragment", () => $d67513ef9307f89e$export$ffb0004e005737fa, (v) => $d67513ef9307f89e$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $d67513ef9307f89e$export$34b9dba7ce09269b, (v) => $d67513ef9307f89e$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $d67513ef9307f89e$export$25062201e9e25d76, (v) => $d67513ef9307f89e$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $d67513ef9307f89e$export$ffb0004e005737fa;
var $d67513ef9307f89e$export$34b9dba7ce09269b;
var $d67513ef9307f89e$export$25062201e9e25d76;
'use strict';

var $eJOHy = parcelRequire("eJOHy");
var $d67513ef9307f89e$var$k = Symbol.for("react.element"), $d67513ef9307f89e$var$l = Symbol.for("react.fragment"), $d67513ef9307f89e$var$m = Object.prototype.hasOwnProperty, $d67513ef9307f89e$var$n = $eJOHy.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $d67513ef9307f89e$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $d67513ef9307f89e$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$d67513ef9307f89e$var$m.call(a, b) && !$d67513ef9307f89e$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $d67513ef9307f89e$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $d67513ef9307f89e$var$n.current
    };
}
$d67513ef9307f89e$export$ffb0004e005737fa = $d67513ef9307f89e$var$l;
$d67513ef9307f89e$export$34b9dba7ce09269b = $d67513ef9307f89e$var$q;
$d67513ef9307f89e$export$25062201e9e25d76 = $d67513ef9307f89e$var$q;

});


parcelRegister("6MHAp", function(module, exports) {
$parcel$export(module.exports, "default", () => $4f09091820f25d47$export$2e2bcd8739ae039);

var $6k6gF = parcelRequire("6k6gF");

var $8wHm7 = parcelRequire("8wHm7");
var $j8Lvq = parcelRequire("j8Lvq");
var $b3dLq = parcelRequire("b3dLq");
var $arU3I = parcelRequire("arU3I");
var $e7JU7 = parcelRequire("e7JU7");
var $eYmbE = parcelRequire("eYmbE");
parcelRequire("lmeHY");
parcelRequire("5f4Il");
var $4f09091820f25d47$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $8wHm7.peek)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $8wHm7.token)(character)) break;
        (0, $8wHm7.next)();
    }
    return (0, $8wHm7.slice)(begin, (0, $8wHm7.position));
};
var $4f09091820f25d47$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $8wHm7.token)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $8wHm7.peek)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $4f09091820f25d47$var$identifierWithPointTracking((0, $8wHm7.position) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $8wHm7.delimit)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $8wHm7.peek)() === 58 ? '&\f' : '';
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $j8Lvq.from)(character);
    }
    while (character = (0, $8wHm7.next)());
    return parsed;
};
var $4f09091820f25d47$var$getRules = function getRules(value, points) {
    return (0, $8wHm7.dealloc)($4f09091820f25d47$var$toRules((0, $8wHm7.alloc)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $4f09091820f25d47$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $4f09091820f25d47$var$compat = function compat(element) {
    if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value, parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== 'rule'){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$4f09091820f25d47$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $4f09091820f25d47$var$fixedElements.set(element, true);
    var points = [];
    var rules = $4f09091820f25d47$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $4f09091820f25d47$var$removeLabel = function removeLabel(element) {
    if (element.type === 'decl') {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = '';
            element.value = '';
        }
    }
};
/* eslint-disable no-fallthrough */ function $4f09091820f25d47$var$prefix(value, length) {
    switch((0, $j8Lvq.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $arU3I.WEBKIT) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $arU3I.WEBKIT) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $arU3I.WEBKIT) + value + (0, $arU3I.MOZ) + value + (0, $arU3I.MS) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $arU3I.WEBKIT) + value + (0, $arU3I.MS) + value + value;
        // order
        case 6165:
            return (0, $arU3I.WEBKIT) + value + (0, $arU3I.MS) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, $arU3I.WEBKIT) + value + (0, $j8Lvq.replace)(value, /(\w+).+(:[^]+)/, (0, $arU3I.WEBKIT) + 'box-$1$2' + (0, $arU3I.MS) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, $arU3I.WEBKIT) + value + (0, $arU3I.MS) + 'flex-item-' + (0, $j8Lvq.replace)(value, /flex-|-self/, '') + value;
        // align-content
        case 4675:
            return (0, $arU3I.WEBKIT) + value + (0, $arU3I.MS) + 'flex-line-pack' + (0, $j8Lvq.replace)(value, /align-content|flex-|-self/, '') + value;
        // flex-shrink
        case 5548:
            return (0, $arU3I.WEBKIT) + value + (0, $arU3I.MS) + (0, $j8Lvq.replace)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, $arU3I.WEBKIT) + value + (0, $arU3I.MS) + (0, $j8Lvq.replace)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, $arU3I.WEBKIT) + 'box-' + (0, $j8Lvq.replace)(value, '-grow', '') + (0, $arU3I.WEBKIT) + value + (0, $arU3I.MS) + (0, $j8Lvq.replace)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, $arU3I.WEBKIT) + (0, $j8Lvq.replace)(value, /([^-])(transform)/g, '$1' + (0, $arU3I.WEBKIT) + '$2') + value;
        // cursor
        case 6187:
            return (0, $j8Lvq.replace)((0, $j8Lvq.replace)((0, $j8Lvq.replace)(value, /(zoom-|grab)/, (0, $arU3I.WEBKIT) + '$1'), /(image-set)/, (0, $arU3I.WEBKIT) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $j8Lvq.replace)(value, /(image-set\([^]*)/, (0, $arU3I.WEBKIT) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, $j8Lvq.replace)((0, $j8Lvq.replace)(value, /(.+:)(flex-)?(.*)/, (0, $arU3I.WEBKIT) + 'box-pack:$3' + (0, $arU3I.MS) + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + (0, $arU3I.WEBKIT) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $j8Lvq.replace)(value, /(.+)-inline(.+)/, (0, $arU3I.WEBKIT) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $j8Lvq.strlen)(value) - 1 - length > 6) switch((0, $j8Lvq.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $j8Lvq.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $j8Lvq.replace)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, $arU3I.WEBKIT) + '$2-$3' + '$1' + (0, $arU3I.MOZ) + ((0, $j8Lvq.charat)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, $j8Lvq.indexof)(value, 'stretch') ? $4f09091820f25d47$var$prefix((0, $j8Lvq.replace)(value, 'stretch', 'fill-available'), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $j8Lvq.charat)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $j8Lvq.charat)(value, (0, $j8Lvq.strlen)(value) - 3 - (~(0, $j8Lvq.indexof)(value, '!important') && 10))){
                // stic(k)y
                case 107:
                    return (0, $j8Lvq.replace)(value, ':', ':' + (0, $arU3I.WEBKIT)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $j8Lvq.replace)(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + (0, $arU3I.WEBKIT) + ((0, $j8Lvq.charat)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, $arU3I.WEBKIT) + '$2$3' + '$1' + (0, $arU3I.MS) + '$2box$3') + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $j8Lvq.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $arU3I.WEBKIT) + value + (0, $arU3I.MS) + (0, $j8Lvq.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, $arU3I.WEBKIT) + value + (0, $arU3I.MS) + (0, $j8Lvq.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, $arU3I.WEBKIT) + value + (0, $arU3I.MS) + (0, $j8Lvq.replace)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
            return (0, $arU3I.WEBKIT) + value + (0, $arU3I.MS) + value + value;
    }
    return value;
}
var $4f09091820f25d47$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $arU3I.DECLARATION:
                element["return"] = $4f09091820f25d47$var$prefix(element.value, element.length);
                break;
            case 0, $arU3I.KEYFRAMES:
                return (0, $eYmbE.serialize)([
                    (0, $8wHm7.copy)(element, {
                        value: (0, $j8Lvq.replace)(element.value, '@', '@' + (0, $arU3I.WEBKIT))
                    })
                ], callback);
            case 0, $arU3I.RULESET:
                if (element.length) return (0, $j8Lvq.combine)(element.props, function(value) {
                    switch((0, $j8Lvq.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            return (0, $eYmbE.serialize)([
                                (0, $8wHm7.copy)(element, {
                                    props: [
                                        (0, $j8Lvq.replace)(value, /:(read-\w+)/, ':' + (0, $arU3I.MOZ) + '$1')
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case '::placeholder':
                            return (0, $eYmbE.serialize)([
                                (0, $8wHm7.copy)(element, {
                                    props: [
                                        (0, $j8Lvq.replace)(value, /:(plac\w+)/, ':' + (0, $arU3I.WEBKIT) + 'input-$1')
                                    ]
                                }),
                                (0, $8wHm7.copy)(element, {
                                    props: [
                                        (0, $j8Lvq.replace)(value, /:(plac\w+)/, ':' + (0, $arU3I.MOZ) + '$1')
                                    ]
                                }),
                                (0, $8wHm7.copy)(element, {
                                    props: [
                                        (0, $j8Lvq.replace)(value, /:(plac\w+)/, (0, $arU3I.MS) + 'input-$1')
                                    ]
                                })
                            ], callback);
                    }
                    return '';
                });
        }
    }
};
var $4f09091820f25d47$var$defaultStylisPlugins = [
    $4f09091820f25d47$var$prefixer
];
var $4f09091820f25d47$export$2e2bcd8739ae039 = function /*: EmotionCache */ createCache(options) {
    var key = options.key;
    if (key === 'css') {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute('data-emotion');
            if (dataEmotionAttribute.indexOf(' ') === -1) return;
            document.head.appendChild(node);
            node.setAttribute('data-s', '');
        });
    }
    var stylisPlugins = options.stylisPlugins || $4f09091820f25d47$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    /* : Node */ var nodesToHydrate = [];
    container = options.container || document.head;
    Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function(node) {
        var attrib = node.getAttribute("data-emotion").split(' ');
        for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
        nodesToHydrate.push(node);
    });
    var _insert;
    /*: (
  selector: string,
  serialized: SerializedStyles,
  sheet: StyleSheet,
  shouldCache: boolean
  ) => string | void */ var omnipresentPlugins = [
        $4f09091820f25d47$var$compat,
        $4f09091820f25d47$var$removeLabel
    ];
    var currentSheet;
    var finalizingPlugins = [
        (0, $eYmbE.stringify),
        (0, $e7JU7.rulesheet)(function(rule) {
            currentSheet.insert(rule);
        })
    ];
    var serializer = (0, $e7JU7.middleware)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
    var stylis = function stylis(styles) {
        return (0, $eYmbE.serialize)((0, $b3dLq.compile)(styles), serializer);
    };
    _insert = function /*: void */ insert(selector, serialized, sheet, shouldCache) {
        currentSheet = sheet;
        stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
        if (shouldCache) cache.inserted[serialized.name] = true;
    };
    var cache = {
        key: key,
        sheet: new (0, $6k6gF.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};

});
parcelRegister("8wHm7", function(module, exports) {
$parcel$export(module.exports, "position", () => $6352f172199bc44c$export$5880b8b5730aff45);
$parcel$export(module.exports, "node", () => $6352f172199bc44c$export$35059013cd4a06db);
$parcel$export(module.exports, "copy", () => $6352f172199bc44c$export$784d13d8ee351f07);
$parcel$export(module.exports, "char", () => $6352f172199bc44c$export$eba6f6f03b0a92e7);
$parcel$export(module.exports, "prev", () => $6352f172199bc44c$export$232faf9add678146);
$parcel$export(module.exports, "next", () => $6352f172199bc44c$export$48cfd1e771a65c4f);
$parcel$export(module.exports, "peek", () => $6352f172199bc44c$export$4d3fb11e950abb9e);
$parcel$export(module.exports, "caret", () => $6352f172199bc44c$export$e88cb2efb12ae807);
$parcel$export(module.exports, "slice", () => $6352f172199bc44c$export$58adb3bec8346d0f);
$parcel$export(module.exports, "token", () => $6352f172199bc44c$export$9e1725a4cfeada27);
$parcel$export(module.exports, "alloc", () => $6352f172199bc44c$export$2de70f21292aac9e);
$parcel$export(module.exports, "dealloc", () => $6352f172199bc44c$export$45918ac1574455b1);
$parcel$export(module.exports, "delimit", () => $6352f172199bc44c$export$410ac95b9ec204b8);
$parcel$export(module.exports, "tokenize", () => $6352f172199bc44c$export$660b2ee2d4fb4eff);
$parcel$export(module.exports, "whitespace", () => $6352f172199bc44c$export$7af1228ff777d175);
$parcel$export(module.exports, "identifier", () => $6352f172199bc44c$export$c2ab62c7bf24634);
$parcel$export(module.exports, "escaping", () => $6352f172199bc44c$export$955ba06d119e085e);
$parcel$export(module.exports, "commenter", () => $6352f172199bc44c$export$4254d4e2b3745c4c);

var $j8Lvq = parcelRequire("j8Lvq");
var $6352f172199bc44c$export$53f1d5ea8de3d7c = 1;
var $6352f172199bc44c$export$4e0c71f277ca26b3 = 1;
var $6352f172199bc44c$export$f24224f1c91d8156 = 0;
var $6352f172199bc44c$export$5880b8b5730aff45 = 0;
var $6352f172199bc44c$export$c0306caf338ac095 = 0;
var $6352f172199bc44c$export$30a86d91af8ff6e6 = '';
function $6352f172199bc44c$export$35059013cd4a06db(value, root, parent, type, props, children, length) {
    return {
        value: value,
        root: root,
        parent: parent,
        type: type,
        props: props,
        children: children,
        line: $6352f172199bc44c$export$53f1d5ea8de3d7c,
        column: $6352f172199bc44c$export$4e0c71f277ca26b3,
        length: length,
        return: ''
    };
}
function $6352f172199bc44c$export$784d13d8ee351f07(root, props) {
    return (0, $j8Lvq.assign)($6352f172199bc44c$export$35059013cd4a06db('', null, null, '', null, null, 0), root, {
        length: -root.length
    }, props);
}
function $6352f172199bc44c$export$eba6f6f03b0a92e7() {
    return $6352f172199bc44c$export$c0306caf338ac095;
}
function $6352f172199bc44c$export$232faf9add678146() {
    $6352f172199bc44c$export$c0306caf338ac095 = $6352f172199bc44c$export$5880b8b5730aff45 > 0 ? (0, $j8Lvq.charat)($6352f172199bc44c$export$30a86d91af8ff6e6, --$6352f172199bc44c$export$5880b8b5730aff45) : 0;
    if ($6352f172199bc44c$export$4e0c71f277ca26b3--, $6352f172199bc44c$export$c0306caf338ac095 === 10) $6352f172199bc44c$export$4e0c71f277ca26b3 = 1, $6352f172199bc44c$export$53f1d5ea8de3d7c--;
    return $6352f172199bc44c$export$c0306caf338ac095;
}
function $6352f172199bc44c$export$48cfd1e771a65c4f() {
    $6352f172199bc44c$export$c0306caf338ac095 = $6352f172199bc44c$export$5880b8b5730aff45 < $6352f172199bc44c$export$f24224f1c91d8156 ? (0, $j8Lvq.charat)($6352f172199bc44c$export$30a86d91af8ff6e6, $6352f172199bc44c$export$5880b8b5730aff45++) : 0;
    if ($6352f172199bc44c$export$4e0c71f277ca26b3++, $6352f172199bc44c$export$c0306caf338ac095 === 10) $6352f172199bc44c$export$4e0c71f277ca26b3 = 1, $6352f172199bc44c$export$53f1d5ea8de3d7c++;
    return $6352f172199bc44c$export$c0306caf338ac095;
}
function $6352f172199bc44c$export$4d3fb11e950abb9e() {
    return (0, $j8Lvq.charat)($6352f172199bc44c$export$30a86d91af8ff6e6, $6352f172199bc44c$export$5880b8b5730aff45);
}
function $6352f172199bc44c$export$e88cb2efb12ae807() {
    return $6352f172199bc44c$export$5880b8b5730aff45;
}
function $6352f172199bc44c$export$58adb3bec8346d0f(begin, end) {
    return (0, $j8Lvq.substr)($6352f172199bc44c$export$30a86d91af8ff6e6, begin, end);
}
function $6352f172199bc44c$export$9e1725a4cfeada27(type) {
    switch(type){
        // \0 \t \n \r \s whitespace token
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        // ! + , / > @ ~ isolate token
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        // ; { } breakpoint token
        case 59:
        case 123:
        case 125:
            return 4;
        // : accompanied token
        case 58:
            return 3;
        // " ' ( [ opening delimit token
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        // ) ] closing delimit token
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $6352f172199bc44c$export$2de70f21292aac9e(value) {
    return $6352f172199bc44c$export$53f1d5ea8de3d7c = $6352f172199bc44c$export$4e0c71f277ca26b3 = 1, $6352f172199bc44c$export$f24224f1c91d8156 = (0, $j8Lvq.strlen)($6352f172199bc44c$export$30a86d91af8ff6e6 = value), $6352f172199bc44c$export$5880b8b5730aff45 = 0, [];
}
function $6352f172199bc44c$export$45918ac1574455b1(value) {
    return $6352f172199bc44c$export$30a86d91af8ff6e6 = '', value;
}
function $6352f172199bc44c$export$410ac95b9ec204b8(type) {
    return (0, $j8Lvq.trim)($6352f172199bc44c$export$58adb3bec8346d0f($6352f172199bc44c$export$5880b8b5730aff45 - 1, $6352f172199bc44c$export$c889f2fcc19dbf12(type === 91 ? type + 2 : type === 40 ? type + 1 : type)));
}
function $6352f172199bc44c$export$660b2ee2d4fb4eff(value) {
    return $6352f172199bc44c$export$45918ac1574455b1($6352f172199bc44c$export$5f8c09e3ae6f64e1($6352f172199bc44c$export$2de70f21292aac9e(value)));
}
function $6352f172199bc44c$export$7af1228ff777d175(type) {
    while($6352f172199bc44c$export$c0306caf338ac095 = $6352f172199bc44c$export$4d3fb11e950abb9e())if ($6352f172199bc44c$export$c0306caf338ac095 < 33) $6352f172199bc44c$export$48cfd1e771a65c4f();
    else break;
    return $6352f172199bc44c$export$9e1725a4cfeada27(type) > 2 || $6352f172199bc44c$export$9e1725a4cfeada27($6352f172199bc44c$export$c0306caf338ac095) > 3 ? '' : ' ';
}
function $6352f172199bc44c$export$5f8c09e3ae6f64e1(children) {
    while($6352f172199bc44c$export$48cfd1e771a65c4f())switch($6352f172199bc44c$export$9e1725a4cfeada27($6352f172199bc44c$export$c0306caf338ac095)){
        case 0:
            (0, $j8Lvq.append)($6352f172199bc44c$export$c2ab62c7bf24634($6352f172199bc44c$export$5880b8b5730aff45 - 1), children);
            break;
        case 2:
            (0, $j8Lvq.append)($6352f172199bc44c$export$410ac95b9ec204b8($6352f172199bc44c$export$c0306caf338ac095), children);
            break;
        default:
            (0, $j8Lvq.append)((0, $j8Lvq.from)($6352f172199bc44c$export$c0306caf338ac095), children);
    }
    return children;
}
function $6352f172199bc44c$export$955ba06d119e085e(index, count) {
    while(--count && $6352f172199bc44c$export$48cfd1e771a65c4f())// not 0-9 A-F a-f
    if ($6352f172199bc44c$export$c0306caf338ac095 < 48 || $6352f172199bc44c$export$c0306caf338ac095 > 102 || $6352f172199bc44c$export$c0306caf338ac095 > 57 && $6352f172199bc44c$export$c0306caf338ac095 < 65 || $6352f172199bc44c$export$c0306caf338ac095 > 70 && $6352f172199bc44c$export$c0306caf338ac095 < 97) break;
    return $6352f172199bc44c$export$58adb3bec8346d0f(index, $6352f172199bc44c$export$e88cb2efb12ae807() + (count < 6 && $6352f172199bc44c$export$4d3fb11e950abb9e() == 32 && $6352f172199bc44c$export$48cfd1e771a65c4f() == 32));
}
function $6352f172199bc44c$export$c889f2fcc19dbf12(type) {
    while($6352f172199bc44c$export$48cfd1e771a65c4f())switch($6352f172199bc44c$export$c0306caf338ac095){
        // ] ) " '
        case type:
            return $6352f172199bc44c$export$5880b8b5730aff45;
        // " '
        case 34:
        case 39:
            if (type !== 34 && type !== 39) $6352f172199bc44c$export$c889f2fcc19dbf12($6352f172199bc44c$export$c0306caf338ac095);
            break;
        // (
        case 40:
            if (type === 41) $6352f172199bc44c$export$c889f2fcc19dbf12(type);
            break;
        // \
        case 92:
            $6352f172199bc44c$export$48cfd1e771a65c4f();
            break;
    }
    return $6352f172199bc44c$export$5880b8b5730aff45;
}
function $6352f172199bc44c$export$4254d4e2b3745c4c(type, index) {
    while($6352f172199bc44c$export$48cfd1e771a65c4f())// //
    if (type + $6352f172199bc44c$export$c0306caf338ac095 === 57) break;
    else if (type + $6352f172199bc44c$export$c0306caf338ac095 === 84 && $6352f172199bc44c$export$4d3fb11e950abb9e() === 47) break;
    return '/*' + $6352f172199bc44c$export$58adb3bec8346d0f(index, $6352f172199bc44c$export$5880b8b5730aff45 - 1) + '*' + (0, $j8Lvq.from)(type === 47 ? type : $6352f172199bc44c$export$48cfd1e771a65c4f());
}
function $6352f172199bc44c$export$c2ab62c7bf24634(index) {
    while(!$6352f172199bc44c$export$9e1725a4cfeada27($6352f172199bc44c$export$4d3fb11e950abb9e()))$6352f172199bc44c$export$48cfd1e771a65c4f();
    return $6352f172199bc44c$export$58adb3bec8346d0f(index, $6352f172199bc44c$export$5880b8b5730aff45);
}

});
parcelRegister("j8Lvq", function(module, exports) {
$parcel$export(module.exports, "abs", () => $def39d5f0f1c1042$export$2335f513bbd82c6d);
$parcel$export(module.exports, "from", () => $def39d5f0f1c1042$export$6788812c4e6611e6);
$parcel$export(module.exports, "assign", () => $def39d5f0f1c1042$export$e6e34fd1f2686227);
$parcel$export(module.exports, "hash", () => $def39d5f0f1c1042$export$d6af199866bfb566);
$parcel$export(module.exports, "charat", () => $def39d5f0f1c1042$export$a9db5e087081082d);
$parcel$export(module.exports, "trim", () => $def39d5f0f1c1042$export$87c2784dc9fc4ab);
$parcel$export(module.exports, "match", () => $def39d5f0f1c1042$export$4659b591c19bdf3d);
$parcel$export(module.exports, "replace", () => $def39d5f0f1c1042$export$77ad94ebf1c2b9ed);
$parcel$export(module.exports, "indexof", () => $def39d5f0f1c1042$export$f8e21b1e77979a08);
$parcel$export(module.exports, "substr", () => $def39d5f0f1c1042$export$2f35ab04d2335697);
$parcel$export(module.exports, "strlen", () => $def39d5f0f1c1042$export$36776f635604f274);
$parcel$export(module.exports, "sizeof", () => $def39d5f0f1c1042$export$f9084667e487ed46);
$parcel$export(module.exports, "append", () => $def39d5f0f1c1042$export$10d8903dec122b9d);
$parcel$export(module.exports, "combine", () => $def39d5f0f1c1042$export$1be1fc439b849fdf);
/**
 * @param {number}
 * @return {number}
 */ var $def39d5f0f1c1042$export$2335f513bbd82c6d = Math.abs;
var $def39d5f0f1c1042$export$6788812c4e6611e6 = String.fromCharCode;
var $def39d5f0f1c1042$export$e6e34fd1f2686227 = Object.assign;
function $def39d5f0f1c1042$export$d6af199866bfb566(value, length) {
    return $def39d5f0f1c1042$export$a9db5e087081082d(value, 0) ^ 45 ? (((length << 2 ^ $def39d5f0f1c1042$export$a9db5e087081082d(value, 0)) << 2 ^ $def39d5f0f1c1042$export$a9db5e087081082d(value, 1)) << 2 ^ $def39d5f0f1c1042$export$a9db5e087081082d(value, 2)) << 2 ^ $def39d5f0f1c1042$export$a9db5e087081082d(value, 3) : 0;
}
function $def39d5f0f1c1042$export$87c2784dc9fc4ab(value) {
    return value.trim();
}
function $def39d5f0f1c1042$export$4659b591c19bdf3d(value, pattern) {
    return (value = pattern.exec(value)) ? value[0] : value;
}
function $def39d5f0f1c1042$export$77ad94ebf1c2b9ed(value, pattern, replacement) {
    return value.replace(pattern, replacement);
}
function $def39d5f0f1c1042$export$f8e21b1e77979a08(value, search) {
    return value.indexOf(search);
}
function $def39d5f0f1c1042$export$a9db5e087081082d(value, index) {
    return value.charCodeAt(index) | 0;
}
function $def39d5f0f1c1042$export$2f35ab04d2335697(value, begin, end) {
    return value.slice(begin, end);
}
function $def39d5f0f1c1042$export$36776f635604f274(value) {
    return value.length;
}
function $def39d5f0f1c1042$export$f9084667e487ed46(value) {
    return value.length;
}
function $def39d5f0f1c1042$export$10d8903dec122b9d(value, array) {
    return array.push(value), value;
}
function $def39d5f0f1c1042$export$1be1fc439b849fdf(array, callback) {
    return array.map(callback).join('');
}

});


parcelRegister("b3dLq", function(module, exports) {
$parcel$export(module.exports, "compile", () => $80baa6c0d5e06825$export$ef7acd7185315e22);

var $arU3I = parcelRequire("arU3I");

var $j8Lvq = parcelRequire("j8Lvq");

var $8wHm7 = parcelRequire("8wHm7");
function $80baa6c0d5e06825$export$ef7acd7185315e22(value) {
    return (0, $8wHm7.dealloc)($80baa6c0d5e06825$export$98e6a39c04603d36('', null, null, null, [
        ''
    ], value = (0, $8wHm7.alloc)(value), 0, [
        0
    ], value));
}
function $80baa6c0d5e06825$export$98e6a39c04603d36(value, root, parent, rule, rules, rulesets, pseudo, points, declarations) {
    var index = 0;
    var offset = 0;
    var length = pseudo;
    var atrule = 0;
    var property = 0;
    var previous = 0;
    var variable = 1;
    var scanning = 1;
    var ampersand = 1;
    var character = 0;
    var type = '';
    var props = rules;
    var children = rulesets;
    var reference = rule;
    var characters = type;
    while(scanning)switch(previous = character, character = (0, $8wHm7.next)()){
        // (
        case 40:
            if (previous != 108 && (0, $j8Lvq.charat)(characters, length - 1) == 58) {
                if ((0, $j8Lvq.indexof)(characters += (0, $j8Lvq.replace)((0, $8wHm7.delimit)(character), '&', '&\f'), '&\f') != -1) ampersand = -1;
                break;
            }
        // " ' [
        case 34:
        case 39:
        case 91:
            characters += (0, $8wHm7.delimit)(character);
            break;
        // \t \n \r \s
        case 9:
        case 10:
        case 13:
        case 32:
            characters += (0, $8wHm7.whitespace)(previous);
            break;
        // \
        case 92:
            characters += (0, $8wHm7.escaping)((0, $8wHm7.caret)() - 1, 7);
            continue;
        // /
        case 47:
            switch((0, $8wHm7.peek)()){
                case 42:
                case 47:
                    (0, $j8Lvq.append)($80baa6c0d5e06825$export$4a34f930e789283c((0, $8wHm7.commenter)((0, $8wHm7.next)(), (0, $8wHm7.caret)()), root, parent), declarations);
                    break;
                default:
                    characters += '/';
            }
            break;
        // {
        case 123 * variable:
            points[index++] = (0, $j8Lvq.strlen)(characters) * ampersand;
        // } ; \0
        case 125 * variable:
        case 59:
        case 0:
            switch(character){
                // \0 }
                case 0:
                case 125:
                    scanning = 0;
                // ;
                case 59 + offset:
                    if (ampersand == -1) characters = (0, $j8Lvq.replace)(characters, /\f/g, '');
                    if (property > 0 && (0, $j8Lvq.strlen)(characters) - length) (0, $j8Lvq.append)(property > 32 ? $80baa6c0d5e06825$export$f8483753829ec8f3(characters + ';', rule, parent, length - 1) : $80baa6c0d5e06825$export$f8483753829ec8f3((0, $j8Lvq.replace)(characters, ' ', '') + ';', rule, parent, length - 2), declarations);
                    break;
                // @ ;
                case 59:
                    characters += ';';
                // { rule/at-rule
                default:
                    (0, $j8Lvq.append)(reference = $80baa6c0d5e06825$export$3307ffa7023ede1e(characters, root, parent, index, offset, rules, points, type, props = [], children = [], length), rulesets);
                    if (character === 123) {
                        if (offset === 0) $80baa6c0d5e06825$export$98e6a39c04603d36(characters, root, reference, reference, props, rulesets, length, points, children);
                        else switch(atrule === 99 && (0, $j8Lvq.charat)(characters, 3) === 110 ? 100 : atrule){
                            // d l m s
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $80baa6c0d5e06825$export$98e6a39c04603d36(value, reference, reference, rule && (0, $j8Lvq.append)($80baa6c0d5e06825$export$3307ffa7023ede1e(value, reference, reference, 0, 0, rules, points, type, rules, props = [], length), children), rules, children, length, points, rule ? props : children);
                                break;
                            default:
                                $80baa6c0d5e06825$export$98e6a39c04603d36(characters, reference, reference, reference, [
                                    ''
                                ], children, 0, points, children);
                        }
                    }
            }
            index = offset = property = 0, variable = ampersand = 1, type = characters = '', length = pseudo;
            break;
        // :
        case 58:
            length = 1 + (0, $j8Lvq.strlen)(characters), property = previous;
        default:
            if (variable < 1) {
                if (character == 123) --variable;
                else if (character == 125 && variable++ == 0 && (0, $8wHm7.prev)() == 125) continue;
            }
            switch(characters += (0, $j8Lvq.from)(character), character * variable){
                // &
                case 38:
                    ampersand = offset > 0 ? 1 : (characters += '\f', -1);
                    break;
                // ,
                case 44:
                    points[index++] = ((0, $j8Lvq.strlen)(characters) - 1) * ampersand, ampersand = 1;
                    break;
                // @
                case 64:
                    // -
                    if ((0, $8wHm7.peek)() === 45) characters += (0, $8wHm7.delimit)((0, $8wHm7.next)());
                    atrule = (0, $8wHm7.peek)(), offset = length = (0, $j8Lvq.strlen)(type = characters += (0, $8wHm7.identifier)((0, $8wHm7.caret)())), character++;
                    break;
                // -
                case 45:
                    if (previous === 45 && (0, $j8Lvq.strlen)(characters) == 2) variable = 0;
            }
    }
    return rulesets;
}
function $80baa6c0d5e06825$export$3307ffa7023ede1e(value, root, parent, index, offset, rules, points, type, props, children, length) {
    var post = offset - 1;
    var rule = offset === 0 ? rules : [
        ''
    ];
    var size = (0, $j8Lvq.sizeof)(rule);
    for(var i = 0, j = 0, k = 0; i < index; ++i)for(var x = 0, y = (0, $j8Lvq.substr)(value, post + 1, post = (0, $j8Lvq.abs)(j = points[i])), z = value; x < size; ++x)if (z = (0, $j8Lvq.trim)(j > 0 ? rule[x] + ' ' + y : (0, $j8Lvq.replace)(y, /&\f/g, rule[x]))) props[k++] = z;
    return (0, $8wHm7.node)(value, root, parent, offset === 0 ? (0, $arU3I.RULESET) : type, props, children, length);
}
function $80baa6c0d5e06825$export$4a34f930e789283c(value, root, parent) {
    return (0, $8wHm7.node)(value, root, parent, (0, $arU3I.COMMENT), (0, $j8Lvq.from)((0, $8wHm7.char)()), (0, $j8Lvq.substr)(value, 2, -2), 0);
}
function $80baa6c0d5e06825$export$f8483753829ec8f3(value, root, parent, length) {
    return (0, $8wHm7.node)(value, root, parent, (0, $arU3I.DECLARATION), (0, $j8Lvq.substr)(value, 0, length), (0, $j8Lvq.substr)(value, length + 1, -1), length);
}

});
parcelRegister("arU3I", function(module, exports) {
$parcel$export(module.exports, "MS", () => $79b7e91d70cbaebb$export$71ad59f2e432cfe8);
$parcel$export(module.exports, "MOZ", () => $79b7e91d70cbaebb$export$2c0f367103c8d01c);
$parcel$export(module.exports, "WEBKIT", () => $79b7e91d70cbaebb$export$39dfd62a25e0fe93);
$parcel$export(module.exports, "COMMENT", () => $79b7e91d70cbaebb$export$a29989082612d0d9);
$parcel$export(module.exports, "RULESET", () => $79b7e91d70cbaebb$export$aa3a2e812ca8570d);
$parcel$export(module.exports, "DECLARATION", () => $79b7e91d70cbaebb$export$527d108ccf083c2b);
$parcel$export(module.exports, "IMPORT", () => $79b7e91d70cbaebb$export$a763edbf796b780a);
$parcel$export(module.exports, "KEYFRAMES", () => $79b7e91d70cbaebb$export$b44a8529a35fcb60);
$parcel$export(module.exports, "LAYER", () => $79b7e91d70cbaebb$export$d773506282b3cfe6);
var $79b7e91d70cbaebb$export$71ad59f2e432cfe8 = '-ms-';
var $79b7e91d70cbaebb$export$2c0f367103c8d01c = '-moz-';
var $79b7e91d70cbaebb$export$39dfd62a25e0fe93 = '-webkit-';
var $79b7e91d70cbaebb$export$a29989082612d0d9 = 'comm';
var $79b7e91d70cbaebb$export$aa3a2e812ca8570d = 'rule';
var $79b7e91d70cbaebb$export$527d108ccf083c2b = 'decl';
var $79b7e91d70cbaebb$export$d3d35020fa5b54f0 = '@page';
var $79b7e91d70cbaebb$export$500415a86c544f73 = '@media';
var $79b7e91d70cbaebb$export$a763edbf796b780a = '@import';
var $79b7e91d70cbaebb$export$2790aeb8b4e5c826 = '@charset';
var $79b7e91d70cbaebb$export$1cc683e23b84b133 = '@viewport';
var $79b7e91d70cbaebb$export$9447a5efea57e862 = '@supports';
var $79b7e91d70cbaebb$export$ef011b4e114b1fba = '@document';
var $79b7e91d70cbaebb$export$6aad947bda0f3f46 = '@namespace';
var $79b7e91d70cbaebb$export$b44a8529a35fcb60 = '@keyframes';
var $79b7e91d70cbaebb$export$2c16de31893252e6 = '@font-face';
var $79b7e91d70cbaebb$export$3d846dd52e150c6f = '@counter-style';
var $79b7e91d70cbaebb$export$22314bfbb57653fe = '@font-feature-values';
var $79b7e91d70cbaebb$export$d773506282b3cfe6 = '@layer';

});


parcelRegister("e7JU7", function(module, exports) {
$parcel$export(module.exports, "middleware", () => $a48553c048589430$export$5a7767152ae0305f);
$parcel$export(module.exports, "rulesheet", () => $a48553c048589430$export$38bcb760f1d4871c);

var $arU3I = parcelRequire("arU3I");

var $j8Lvq = parcelRequire("j8Lvq");

var $8wHm7 = parcelRequire("8wHm7");

var $eYmbE = parcelRequire("eYmbE");

var $1RkAJ = parcelRequire("1RkAJ");
function $a48553c048589430$export$5a7767152ae0305f(collection) {
    var length = (0, $j8Lvq.sizeof)(collection);
    return function(element, index, children, callback) {
        var output = '';
        for(var i = 0; i < length; i++)output += collection[i](element, index, children, callback) || '';
        return output;
    };
}
function $a48553c048589430$export$38bcb760f1d4871c(callback) {
    return function(element) {
        if (!element.root) {
            if (element = element.return) callback(element);
        }
    };
}
function $a48553c048589430$export$e08c7d021b829b7a(element, index, children, callback) {
    if (element.length > -1) {
        if (!element.return) switch(element.type){
            case 0, $arU3I.DECLARATION:
                element.return = (0, $1RkAJ.prefix)(element.value, element.length, children);
                return;
            case 0, $arU3I.KEYFRAMES:
                return (0, $eYmbE.serialize)([
                    (0, $8wHm7.copy)(element, {
                        value: (0, $j8Lvq.replace)(element.value, '@', '@' + (0, $arU3I.WEBKIT))
                    })
                ], callback);
            case 0, $arU3I.RULESET:
                if (element.length) return (0, $j8Lvq.combine)(element.props, function(value) {
                    switch((0, $j8Lvq.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            return (0, $eYmbE.serialize)([
                                (0, $8wHm7.copy)(element, {
                                    props: [
                                        (0, $j8Lvq.replace)(value, /:(read-\w+)/, ':' + (0, $arU3I.MOZ) + '$1')
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case '::placeholder':
                            return (0, $eYmbE.serialize)([
                                (0, $8wHm7.copy)(element, {
                                    props: [
                                        (0, $j8Lvq.replace)(value, /:(plac\w+)/, ':' + (0, $arU3I.WEBKIT) + 'input-$1')
                                    ]
                                }),
                                (0, $8wHm7.copy)(element, {
                                    props: [
                                        (0, $j8Lvq.replace)(value, /:(plac\w+)/, ':' + (0, $arU3I.MOZ) + '$1')
                                    ]
                                }),
                                (0, $8wHm7.copy)(element, {
                                    props: [
                                        (0, $j8Lvq.replace)(value, /:(plac\w+)/, (0, $arU3I.MS) + 'input-$1')
                                    ]
                                })
                            ], callback);
                    }
                    return '';
                });
        }
    }
}
function $a48553c048589430$export$76a88f7de6507443(element) {
    switch(element.type){
        case 0, $arU3I.RULESET:
            element.props = element.props.map(function(value) {
                return (0, $j8Lvq.combine)((0, $8wHm7.tokenize)(value), function(value, index, children) {
                    switch((0, $j8Lvq.charat)(value, 0)){
                        // \f
                        case 12:
                            return (0, $j8Lvq.substr)(value, 1, (0, $j8Lvq.strlen)(value));
                        // \0 ( + > ~
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return value;
                        // :
                        case 58:
                            if (children[++index] === 'global') children[index] = '', children[++index] = '\f' + (0, $j8Lvq.substr)(children[index], index = 1, -1);
                        // \s
                        case 32:
                            return index === 1 ? '' : value;
                        default:
                            switch(index){
                                case 0:
                                    element = value;
                                    return (0, $j8Lvq.sizeof)(children) > 1 ? '' : value;
                                case index = (0, $j8Lvq.sizeof)(children) - 1:
                                case 2:
                                    return index === 2 ? value + element + element : value + element;
                                default:
                                    return value;
                            }
                    }
                });
            });
    }
}

});
parcelRegister("eYmbE", function(module, exports) {
$parcel$export(module.exports, "serialize", () => $ae67e120341fb49f$export$dfdc1655ccc5b9cb);
$parcel$export(module.exports, "stringify", () => $ae67e120341fb49f$export$fac44ee5b035f737);

var $arU3I = parcelRequire("arU3I");

var $j8Lvq = parcelRequire("j8Lvq");
function $ae67e120341fb49f$export$dfdc1655ccc5b9cb(children, callback) {
    var output = '';
    var length = (0, $j8Lvq.sizeof)(children);
    for(var i = 0; i < length; i++)output += callback(children[i], i, children, callback) || '';
    return output;
}
function $ae67e120341fb49f$export$fac44ee5b035f737(element, index, children, callback) {
    switch(element.type){
        case 0, $arU3I.LAYER:
            if (element.children.length) break;
        case 0, $arU3I.IMPORT:
        case 0, $arU3I.DECLARATION:
            return element.return = element.return || element.value;
        case 0, $arU3I.COMMENT:
            return '';
        case 0, $arU3I.KEYFRAMES:
            return element.return = element.value + '{' + $ae67e120341fb49f$export$dfdc1655ccc5b9cb(element.children, callback) + '}';
        case 0, $arU3I.RULESET:
            element.value = element.props.join(',');
    }
    return (0, $j8Lvq.strlen)(children = $ae67e120341fb49f$export$dfdc1655ccc5b9cb(element.children, callback)) ? element.return = element.value + '{' + children + '}' : '';
}

});

parcelRegister("1RkAJ", function(module, exports) {
$parcel$export(module.exports, "prefix", () => $15aab6ba5e17e08b$export$82e9f45cca5ba907);

var $arU3I = parcelRequire("arU3I");

var $j8Lvq = parcelRequire("j8Lvq");
function $15aab6ba5e17e08b$export$82e9f45cca5ba907(value, length, children) {
    switch((0, $j8Lvq.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $arU3I.WEBKIT) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        // text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        // mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position, mask-composite,
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        // background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $arU3I.WEBKIT) + value + value;
        // tab-size
        case 4789:
            return (0, $arU3I.MOZ) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $arU3I.WEBKIT) + value + (0, $arU3I.MOZ) + value + (0, $arU3I.MS) + value + value;
        // writing-mode
        case 5936:
            switch((0, $j8Lvq.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $arU3I.WEBKIT) + value + (0, $arU3I.MS) + (0, $j8Lvq.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, $arU3I.WEBKIT) + value + (0, $arU3I.MS) + (0, $j8Lvq.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, $arU3I.WEBKIT) + value + (0, $arU3I.MS) + (0, $j8Lvq.replace)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
        // flex, flex-direction, scroll-snap-type, writing-mode
        case 6828:
        case 4268:
        case 2903:
            return (0, $arU3I.WEBKIT) + value + (0, $arU3I.MS) + value + value;
        // order
        case 6165:
            return (0, $arU3I.WEBKIT) + value + (0, $arU3I.MS) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, $arU3I.WEBKIT) + value + (0, $j8Lvq.replace)(value, /(\w+).+(:[^]+)/, (0, $arU3I.WEBKIT) + 'box-$1$2' + (0, $arU3I.MS) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, $arU3I.WEBKIT) + value + (0, $arU3I.MS) + 'flex-item-' + (0, $j8Lvq.replace)(value, /flex-|-self/g, '') + (!(0, $j8Lvq.match)(value, /flex-|baseline/) ? (0, $arU3I.MS) + 'grid-row-' + (0, $j8Lvq.replace)(value, /flex-|-self/g, '') : '') + value;
        // align-content
        case 4675:
            return (0, $arU3I.WEBKIT) + value + (0, $arU3I.MS) + 'flex-line-pack' + (0, $j8Lvq.replace)(value, /align-content|flex-|-self/g, '') + value;
        // flex-shrink
        case 5548:
            return (0, $arU3I.WEBKIT) + value + (0, $arU3I.MS) + (0, $j8Lvq.replace)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, $arU3I.WEBKIT) + value + (0, $arU3I.MS) + (0, $j8Lvq.replace)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, $arU3I.WEBKIT) + 'box-' + (0, $j8Lvq.replace)(value, '-grow', '') + (0, $arU3I.WEBKIT) + value + (0, $arU3I.MS) + (0, $j8Lvq.replace)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, $arU3I.WEBKIT) + (0, $j8Lvq.replace)(value, /([^-])(transform)/g, '$1' + (0, $arU3I.WEBKIT) + '$2') + value;
        // cursor
        case 6187:
            return (0, $j8Lvq.replace)((0, $j8Lvq.replace)((0, $j8Lvq.replace)(value, /(zoom-|grab)/, (0, $arU3I.WEBKIT) + '$1'), /(image-set)/, (0, $arU3I.WEBKIT) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $j8Lvq.replace)(value, /(image-set\([^]*)/, (0, $arU3I.WEBKIT) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, $j8Lvq.replace)((0, $j8Lvq.replace)(value, /(.+:)(flex-)?(.*)/, (0, $arU3I.WEBKIT) + 'box-pack:$3' + (0, $arU3I.MS) + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + (0, $arU3I.WEBKIT) + value + value;
        // justify-self
        case 4200:
            if (!(0, $j8Lvq.match)(value, /flex-|baseline/)) return (0, $arU3I.MS) + 'grid-column-align' + (0, $j8Lvq.substr)(value, length) + value;
            break;
        // grid-template-(columns|rows)
        case 2592:
        case 3360:
            return (0, $arU3I.MS) + (0, $j8Lvq.replace)(value, 'template-', '') + value;
        // grid-(row|column)-start
        case 4384:
        case 3616:
            if (children && children.some(function(element, index) {
                return length = index, (0, $j8Lvq.match)(element.props, /grid-\w+-end/);
            })) return ~(0, $j8Lvq.indexof)(value + (children = children[length].value), 'span') ? value : (0, $arU3I.MS) + (0, $j8Lvq.replace)(value, '-start', '') + value + (0, $arU3I.MS) + 'grid-row-span:' + (~(0, $j8Lvq.indexof)(children, 'span') ? (0, $j8Lvq.match)(children, /\d+/) : +(0, $j8Lvq.match)(children, /\d+/) - +(0, $j8Lvq.match)(value, /\d+/)) + ';';
            return (0, $arU3I.MS) + (0, $j8Lvq.replace)(value, '-start', '') + value;
        // grid-(row|column)-end
        case 4896:
        case 4128:
            return children && children.some(function(element) {
                return (0, $j8Lvq.match)(element.props, /grid-\w+-start/);
            }) ? value : (0, $arU3I.MS) + (0, $j8Lvq.replace)((0, $j8Lvq.replace)(value, '-end', '-span'), 'span ', '') + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $j8Lvq.replace)(value, /(.+)-inline(.+)/, (0, $arU3I.WEBKIT) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $j8Lvq.strlen)(value) - 1 - length > 6) switch((0, $j8Lvq.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $j8Lvq.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $j8Lvq.replace)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, $arU3I.WEBKIT) + '$2-$3' + '$1' + (0, $arU3I.MOZ) + ((0, $j8Lvq.charat)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, $j8Lvq.indexof)(value, 'stretch') ? $15aab6ba5e17e08b$export$82e9f45cca5ba907((0, $j8Lvq.replace)(value, 'stretch', 'fill-available'), length, children) + value : value;
            }
            break;
        // grid-(column|row)
        case 5152:
        case 5920:
            return (0, $j8Lvq.replace)(value, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(_, a, b, c, d, e, f) {
                return (0, $arU3I.MS) + a + ':' + b + f + (c ? (0, $arU3I.MS) + a + '-span:' + (d ? e : +e - +b) + f : '') + value;
            });
        // position: sticky
        case 4949:
            // stick(y)?
            if ((0, $j8Lvq.charat)(value, length + 6) === 121) return (0, $j8Lvq.replace)(value, ':', ':' + (0, $arU3I.WEBKIT)) + value;
            break;
        // display: (flex|inline-flex|grid|inline-grid)
        case 6444:
            switch((0, $j8Lvq.charat)(value, (0, $j8Lvq.charat)(value, 14) === 45 ? 18 : 11)){
                // (inline-)?fle(x)
                case 120:
                    return (0, $j8Lvq.replace)(value, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, '$1' + (0, $arU3I.WEBKIT) + ((0, $j8Lvq.charat)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, $arU3I.WEBKIT) + '$2$3' + '$1' + (0, $arU3I.MS) + '$2box$3') + value;
                // (inline-)?gri(d)
                case 100:
                    return (0, $j8Lvq.replace)(value, ':', ':' + (0, $arU3I.MS)) + value;
            }
            break;
        // scroll-margin, scroll-margin-(top|right|bottom|left)
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return (0, $j8Lvq.replace)(value, 'scroll-', 'scroll-snap-') + value;
    }
    return value;
}

});


parcelRegister("lmeHY", function(module, exports) {
var $f8c70fd1ba4a8b42$export$2e2bcd8739ae039 = function weakMemoize(func) {
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // Use non-null assertion because we just checked that the cache `has` it
        // This allows us to remove `undefined` from the return value
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};

});

parcelRegister("5f4Il", function(module, exports) {
function $3d1202990aebbd8c$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRegister("jYbZr", function(module, exports) {
$parcel$export(module.exports, "default", () => $e89cebe6d5bd0e49$export$2e2bcd8739ae039);
var $e89cebe6d5bd0e49$export$2e2bcd8739ae039 = function weakMemoize(func) {
    // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // $FlowFixMe
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};

});

parcelRegister("2xvzl", function(module, exports) {
$parcel$export(module.exports, "serializeStyles", () => $1d9726d140765a17$export$6321afa313b251b5);

var $8VlA2 = parcelRequire("8VlA2");

var $yK0yZ = parcelRequire("yK0yZ");

var $h10P5 = parcelRequire("h10P5");
var $1d9726d140765a17$var$isDevelopment = false;
var $1d9726d140765a17$var$hyphenateRegex = /[A-Z]|^ms/g;
var $1d9726d140765a17$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $1d9726d140765a17$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $1d9726d140765a17$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== 'boolean';
};
var $1d9726d140765a17$var$processStyleName = /* #__PURE__ */ (0, $h10P5.default)(function(styleName) {
    return $1d9726d140765a17$var$isCustomProperty(styleName) ? styleName : styleName.replace($1d9726d140765a17$var$hyphenateRegex, '-$&').toLowerCase();
});
var $1d9726d140765a17$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case 'animation':
        case 'animationName':
            if (typeof value === 'string') return value.replace($1d9726d140765a17$var$animationRegex, function(match, p1, p2) {
                $1d9726d140765a17$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $1d9726d140765a17$var$cursor
                };
                return p1;
            });
    }
    if ((0, $yK0yZ.default)[key] !== 1 && !$1d9726d140765a17$var$isCustomProperty(key) && typeof value === 'number' && value !== 0) return value + 'px';
    return value;
};
var $1d9726d140765a17$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $1d9726d140765a17$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return '';
    var componentSelector = interpolation;
    if (componentSelector.__emotion_styles !== undefined) return componentSelector;
    switch(typeof interpolation){
        case 'boolean':
            return '';
        case 'object':
            var keyframes = interpolation;
            if (keyframes.anim === 1) {
                $1d9726d140765a17$var$cursor = {
                    name: keyframes.name,
                    styles: keyframes.styles,
                    next: $1d9726d140765a17$var$cursor
                };
                return keyframes.name;
            }
            var serializedStyles = interpolation;
            if (serializedStyles.styles !== undefined) {
                var next = serializedStyles.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $1d9726d140765a17$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $1d9726d140765a17$var$cursor
                    };
                    next = next.next;
                }
                var styles = serializedStyles.styles + ";";
                return styles;
            }
            return $1d9726d140765a17$var$createStringFromObject(mergedProps, registered, interpolation);
        case 'function':
            if (mergedProps !== undefined) {
                var previousCursor = $1d9726d140765a17$var$cursor;
                var result = interpolation(mergedProps);
                $1d9726d140765a17$var$cursor = previousCursor;
                return $1d9726d140765a17$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    var asString = interpolation;
    if (registered == null) return asString;
    var cached = registered[asString];
    return cached !== undefined ? cached : asString;
}
function $1d9726d140765a17$var$createStringFromObject(mergedProps, registered, obj) {
    var string = '';
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $1d9726d140765a17$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var key in obj){
        var value = obj[key];
        if (typeof value !== 'object') {
            var asString = value;
            if (registered != null && registered[asString] !== undefined) string += key + "{" + registered[asString] + "}";
            else if ($1d9726d140765a17$var$isProcessableValue(asString)) string += $1d9726d140765a17$var$processStyleName(key) + ":" + $1d9726d140765a17$var$processStyleValue(key, asString) + ";";
        } else {
            if (key === 'NO_COMPONENT_SELECTOR' && $1d9726d140765a17$var$isDevelopment) throw new Error($1d9726d140765a17$var$noComponentSelectorMessage);
            if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($1d9726d140765a17$var$isProcessableValue(value[_i])) string += $1d9726d140765a17$var$processStyleName(key) + ":" + $1d9726d140765a17$var$processStyleValue(key, value[_i]) + ";";
            } else {
                var interpolated = $1d9726d140765a17$var$handleInterpolation(mergedProps, registered, value);
                switch(key){
                    case 'animation':
                    case 'animationName':
                        string += $1d9726d140765a17$var$processStyleName(key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $1d9726d140765a17$var$labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g;
// keyframes are stored on the SerializedStyles object as a linked list
var $1d9726d140765a17$var$cursor;
function $1d9726d140765a17$export$6321afa313b251b5(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = '';
    $1d9726d140765a17$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $1d9726d140765a17$var$handleInterpolation(mergedProps, registered, strings);
    } else {
        var asTemplateStringsArr = strings;
        styles += asTemplateStringsArr[0];
    } // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $1d9726d140765a17$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) {
            var templateStringsArr = strings;
            styles += templateStringsArr[i];
        }
    }
    $1d9726d140765a17$var$labelPattern.lastIndex = 0;
    var identifierName = '';
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $1d9726d140765a17$var$labelPattern.exec(styles)) !== null)identifierName += '-' + match[1];
    var name = (0, $8VlA2.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $1d9726d140765a17$var$cursor
    };
}

});
parcelRegister("8VlA2", function(module, exports) {
$parcel$export(module.exports, "default", () => $67f462faefa57ed8$export$2e2bcd8739ae039);
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $67f462faefa57ed8$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}

});

parcelRegister("yK0yZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $0686dd569e7ee192$export$2e2bcd8739ae039);
var $0686dd569e7ee192$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    scale: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};

});

parcelRegister("h10P5", function(module, exports) {
$parcel$export(module.exports, "default", () => $c6332b1d49661eae$export$2e2bcd8739ae039);
function $c6332b1d49661eae$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRegister("27Ipq", function(module, exports) {
$parcel$export(module.exports, "useInsertionEffectAlwaysWithSyncFallback", () => $18beaeec8a251d9b$export$db21c7ffa21794e7);
$parcel$export(module.exports, "useInsertionEffectWithLayoutFallback", () => $18beaeec8a251d9b$export$811a713a7276cb9d);

var $eJOHy = parcelRequire("eJOHy");
var $18beaeec8a251d9b$var$syncFallback = function syncFallback(create) {
    return create();
};
var $18beaeec8a251d9b$var$useInsertionEffect = $eJOHy.useInsertionEffect ? $eJOHy.useInsertionEffect : false;
var $18beaeec8a251d9b$export$db21c7ffa21794e7 = $18beaeec8a251d9b$var$useInsertionEffect || $18beaeec8a251d9b$var$syncFallback;
var $18beaeec8a251d9b$export$811a713a7276cb9d = $18beaeec8a251d9b$var$useInsertionEffect || $eJOHy.useLayoutEffect;

});

parcelRegister("hcewu", function(module, exports) {
$parcel$export(module.exports, "default", () => $c84ed2a28be66bc7$export$2e2bcd8739ae039);
const $c84ed2a28be66bc7$var$UNDERSCORE_UNICODE = 95;
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $c84ed2a28be66bc7$var$ATOMIC_GROUP_LENGTH = 5;
function $c84ed2a28be66bc7$export$2e2bcd8739ae039(classNames) {
    if (classNames.length <= 1 && (!classNames[0] || classNames[0].indexOf(' ') === -1)) // short circuit if there's no custom class names.
    return classNames[0] || undefined;
    const atomicGroups = {};
    for(let i = 0; i < classNames.length; i++){
        const cls = classNames[i];
        if (!cls) continue;
        const groups = cls.split(' ');
        for(let x = 0; x < groups.length; x++){
            const atomic = groups[x];
            const atomicGroupName = atomic.slice(0, atomic.charCodeAt(0) === $c84ed2a28be66bc7$var$UNDERSCORE_UNICODE ? $c84ed2a28be66bc7$var$ATOMIC_GROUP_LENGTH : undefined);
            atomicGroups[atomicGroupName] = atomic;
        }
    }
    let str = '';
    for(const key in atomicGroups){
        const value = atomicGroups[key];
        str += value + ' ';
    }
    return str.slice(0, -1);
}

});

parcelRegister("7pA0u", function(module, exports) {
$parcel$export(module.exports, "useMemoOne", () => $5656cc6bea3b8e5a$export$b6feb8998cd9b342);
$parcel$export(module.exports, "useCallbackOne", () => $5656cc6bea3b8e5a$export$33752cf3ee811995);
$parcel$export(module.exports, "useMemo", () => $5656cc6bea3b8e5a$export$1538c33de8887b59);
$parcel$export(module.exports, "useCallback", () => $5656cc6bea3b8e5a$export$35808ee640e87ca7);

var $eJOHy = parcelRequire("eJOHy");
function $5656cc6bea3b8e5a$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (newInputs[i] !== lastInputs[i]) return false;
    }
    return true;
}
function $5656cc6bea3b8e5a$export$b6feb8998cd9b342(getResult, inputs) {
    var initial = (0, $eJOHy.useState)(function() {
        return {
            inputs: inputs,
            result: getResult()
        };
    })[0];
    var committed = (0, $eJOHy.useRef)(initial);
    var isInputMatch = Boolean(inputs && committed.current.inputs && $5656cc6bea3b8e5a$var$areInputsEqual(inputs, committed.current.inputs));
    var cache = isInputMatch ? committed.current : {
        inputs: inputs,
        result: getResult()
    };
    (0, $eJOHy.useEffect)(function() {
        committed.current = cache;
    }, [
        cache
    ]);
    return cache.result;
}
function $5656cc6bea3b8e5a$export$33752cf3ee811995(callback, inputs) {
    return $5656cc6bea3b8e5a$export$b6feb8998cd9b342(function() {
        return callback;
    }, inputs);
}
var $5656cc6bea3b8e5a$export$1538c33de8887b59 = $5656cc6bea3b8e5a$export$b6feb8998cd9b342;
var $5656cc6bea3b8e5a$export$35808ee640e87ca7 = $5656cc6bea3b8e5a$export$33752cf3ee811995;

});

parcelRegister("3C1kS", function(module, exports) {
$parcel$export(module.exports, "createStrictAPI", () => $2a15f4f8e92cd49e$export$39716b4af53f4ad);

var $hxC95 = parcelRequire("hxC95");

var $k0ahr = parcelRequire("k0ahr");
function $2a15f4f8e92cd49e$export$39716b4af53f4ad() {
    return {
        css () {
            throw (0, $hxC95.createStrictSetupError)();
        },
        cssMap () {
            throw (0, $hxC95.createStrictSetupError)();
        },
        cx: $k0ahr.cx,
        XCSSProp () {
            throw (0, $hxC95.createStrictSetupError)();
        }
    };
}

});
parcelRegister("hxC95", function(module, exports) {
$parcel$export(module.exports, "createStrictSetupError", () => $cc531ba1905d4480$export$c4df1cb0c2b4d77c);
const $cc531ba1905d4480$export$6c9a87045746941d = ()=>{
    return new Error(`
 \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2557}   \u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2557}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}\u{255A}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{255D}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551} \u{255A}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}
 \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}

  @compiled/react

  Code was executed when it shouldn't have. This could have happened because:

  1. You haven't configured a transformer yet. Visit https://compiledcssinjs.com/docs/installation and follow the instructions.
  2. You have duplicate versions of React and hooks are blowing up. You need to de-duplicate your dependencies.

  Good luck!
`);
};
const $cc531ba1905d4480$export$c4df1cb0c2b4d77c = ()=>{
    return new Error(`
 \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2557}   \u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2557}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}\u{255A}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{255D}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551} \u{255A}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}
 \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}

  @compiled/react

  Code was executed when it shouldn't have. To resolve make sure to:

  1. Set up Compiled.
  2. Configure importSources in your Compiled config to point to the module that exports the output of createStrictAPI().

  For more information visit https://compiledcssinjs.com/docs/installation and follow the instructions.
`);
};

});

parcelRegister("k0ahr", function(module, exports) {
$parcel$export(module.exports, "cx", () => $e8fbc83689ec9379$export$a274e22fb40f762e);

var $hcewu = parcelRequire("hcewu");
const $e8fbc83689ec9379$export$a274e22fb40f762e = (...styles)=>{
    // At runtime TStyles is resolved down to strings, but not at compile time.
    // We circumvent the type system here because of that.
    const actualStyles = styles;
    // The output should be a union type of passed in styles. This ensures the call
    // site of xcss prop can raise violations when disallowed styles have been passed.
    return (0, $hcewu.default)(actualStyles);
};

});


parcelRegister("4eDgu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bindAll = module.exports.bind = void 0;

var $h1Nlq = parcelRequire("h1Nlq");
Object.defineProperty(module.exports, "bind", {
    enumerable: true,
    get: function() {
        return $h1Nlq.bind;
    }
});

var $5vQ95 = parcelRequire("5vQ95");
Object.defineProperty(module.exports, "bindAll", {
    enumerable: true,
    get: function() {
        return $5vQ95.bindAll;
    }
});

});
parcelRegister("h1Nlq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bind = void 0;
function $c658ce717baebc2a$var$bind(target, _a) {
    var type = _a.type, listener = _a.listener, options = _a.options;
    target.addEventListener(type, listener, options);
    return function unbind() {
        target.removeEventListener(type, listener, options);
    };
}
module.exports.bind = $c658ce717baebc2a$var$bind;

});

parcelRegister("5vQ95", function(module, exports) {
"use strict";
var $40384c0050703d0c$var$__assign = module.exports && module.exports.__assign || function() {
    $40384c0050703d0c$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $40384c0050703d0c$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bindAll = void 0;

var $h1Nlq = parcelRequire("h1Nlq");
function $40384c0050703d0c$var$toOptions(value) {
    if (typeof value === 'undefined') return undefined;
    if (typeof value === 'boolean') return {
        capture: value
    };
    return value;
}
function $40384c0050703d0c$var$getBinding(original, sharedOptions) {
    if (sharedOptions == null) return original;
    var binding = $40384c0050703d0c$var$__assign($40384c0050703d0c$var$__assign({}, original), {
        options: $40384c0050703d0c$var$__assign($40384c0050703d0c$var$__assign({}, $40384c0050703d0c$var$toOptions(sharedOptions)), $40384c0050703d0c$var$toOptions(original.options))
    });
    return binding;
}
function $40384c0050703d0c$var$bindAll(target, bindings, sharedOptions) {
    var unbinds = bindings.map(function(original) {
        var binding = $40384c0050703d0c$var$getBinding(original, sharedOptions);
        return (0, $h1Nlq.bind)(target, binding);
    });
    return function unbindAll() {
        unbinds.forEach(function(unbind) {
            return unbind();
        });
    };
}
module.exports.bindAll = $40384c0050703d0c$var$bindAll;

});


parcelRegister("aVrYR", function(module, exports) {
/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */ var $7f44ee9e3f9748b2$var$hasElementType = typeof Element !== 'undefined';
var $7f44ee9e3f9748b2$var$hasMap = typeof Map === 'function';
var $7f44ee9e3f9748b2$var$hasSet = typeof Set === 'function';
var $7f44ee9e3f9748b2$var$hasArrayBuffer = typeof ArrayBuffer === 'function' && !!ArrayBuffer.isView;
// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js
function $7f44ee9e3f9748b2$var$equal(a, b) {
    // START: fast-deep-equal es6/index.js 3.1.3
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!$7f44ee9e3f9748b2$var$equal(a[i], b[i])) return false;
            return true;
        }
        // START: Modifications:
        // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
        //    to co-exist with es5.
        // 2. Replace `for of` with es5 compliant iteration using `for`.
        //    Basically, take:
        //
        //    ```js
        //    for (i of a.entries())
        //      if (!b.has(i[0])) return false;
        //    ```
        //
        //    ... and convert to:
        //
        //    ```js
        //    it = a.entries();
        //    while (!(i = it.next()).done)
        //      if (!b.has(i.value[0])) return false;
        //    ```
        //
        //    **Note**: `i` access switches to `i.value`.
        var it;
        if ($7f44ee9e3f9748b2$var$hasMap && a instanceof Map && b instanceof Map) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!$7f44ee9e3f9748b2$var$equal(i.value[1], b.get(i.value[0]))) return false;
            return true;
        }
        if ($7f44ee9e3f9748b2$var$hasSet && a instanceof Set && b instanceof Set) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            return true;
        }
        // END: Modifications
        if ($7f44ee9e3f9748b2$var$hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (a[i] !== b[i]) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        // START: Modifications:
        // Apply guards for `Object.create(null)` handling. See:
        // - https://github.com/FormidableLabs/react-fast-compare/issues/64
        // - https://github.com/epoberezkin/fast-deep-equal/issues/49
        if (a.valueOf !== Object.prototype.valueOf && typeof a.valueOf === 'function' && typeof b.valueOf === 'function') return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString && typeof a.toString === 'function' && typeof b.toString === 'function') return a.toString() === b.toString();
        // END: Modifications
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        // END: fast-deep-equal
        // START: react-fast-compare
        // custom handling for DOM elements
        if ($7f44ee9e3f9748b2$var$hasElementType && a instanceof Element) return false;
        // custom handling for React/Preact
        for(i = length; i-- !== 0;){
            if ((keys[i] === '_owner' || keys[i] === '__v' || keys[i] === '__o') && a.$$typeof) continue;
            // all other properties should be traversed as usual
            if (!$7f44ee9e3f9748b2$var$equal(a[keys[i]], b[keys[i]])) return false;
        }
        // END: react-fast-compare
        // START: fast-deep-equal
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
module.exports = function isEqual(a, b) {
    try {
        return $7f44ee9e3f9748b2$var$equal(a, b);
    } catch (error) {
        if ((error.message || '').match(/stack|recursion/i)) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn('react-fast-compare cannot handle circular refs');
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};

});

parcelRegister("o0Fzr", function(module, exports) {
$parcel$export(module.exports, "useUID", () => $0482c2f4025eff22$export$87d05f07e65211f1);
$parcel$export(module.exports, "useUIDSeed", () => $0482c2f4025eff22$export$bb5ca5fba6fb4f1f);

var $eJOHy = parcelRequire("eJOHy");

var $ck4u4 = parcelRequire("ck4u4");
var $0482c2f4025eff22$var$generateUID = function(context) {
    var quartz = context || (0, $ck4u4.counter);
    var prefix = (0, $ck4u4.getPrefix)(quartz);
    var id = (0, $ck4u4.getId)(quartz);
    var uid = prefix + id;
    var gen = function(item) {
        return uid + quartz.uid(item);
    };
    return {
        uid: uid,
        gen: gen
    };
};
var $0482c2f4025eff22$var$useUIDState = function() {
    // @ts-ignore
    return $eJOHy.useState($0482c2f4025eff22$var$generateUID($eJOHy.useContext((0, $ck4u4.source))));
};
var $0482c2f4025eff22$export$87d05f07e65211f1 = function() {
    var uid = $0482c2f4025eff22$var$useUIDState()[0].uid;
    return uid;
};
var $0482c2f4025eff22$export$bb5ca5fba6fb4f1f = function() {
    var gen = $0482c2f4025eff22$var$useUIDState()[0].gen;
    return gen;
};

});
parcelRegister("ck4u4", function(module, exports) {
$parcel$export(module.exports, "counter", () => $8f8ad4b8f775a7db$export$e575061ef2a070eb);
$parcel$export(module.exports, "source", () => $8f8ad4b8f775a7db$export$b4d5da5f34fb77ad);
$parcel$export(module.exports, "getId", () => $8f8ad4b8f775a7db$export$218c8c3169c024d2);
$parcel$export(module.exports, "getPrefix", () => $8f8ad4b8f775a7db$export$36e24695f02d4503);

var $eJOHy = parcelRequire("eJOHy");

var $2846K = parcelRequire("2846K");
var $8f8ad4b8f775a7db$export$1921362e86c73c88 = function(prefix) {
    if (prefix === void 0) prefix = '';
    return {
        value: 1,
        prefix: prefix,
        uid: (0, $2846K.generateUID)()
    };
};
var $8f8ad4b8f775a7db$export$e575061ef2a070eb = $8f8ad4b8f775a7db$export$1921362e86c73c88();
var $8f8ad4b8f775a7db$export$b4d5da5f34fb77ad = $eJOHy.createContext($8f8ad4b8f775a7db$export$1921362e86c73c88());
var $8f8ad4b8f775a7db$export$218c8c3169c024d2 = function(source) {
    return source.value++;
};
var $8f8ad4b8f775a7db$export$36e24695f02d4503 = function(source) {
    return source ? source.prefix : '';
};

});
parcelRegister("2846K", function(module, exports) {
$parcel$export(module.exports, "generateUID", () => $18cf83e1d049cf6c$export$bdbb4cbb3078e58d);
$parcel$export(module.exports, "uid", () => $18cf83e1d049cf6c$export$e2a22331486dcca0);
/**
 * generates a UID factory
 * @internal
 * @example
 * const uid = generateUID();
 * uid(object) = 1;
 * uid(object) = 1;
 * uid(anotherObject) = 2;
 */ var $18cf83e1d049cf6c$export$bdbb4cbb3078e58d = function() {
    var counter = 1;
    var map = new WeakMap();
    /**
     * @borrows {uid}
     */ var uid = function(item, index) {
        if (typeof item === 'number' || typeof item === 'string') return index ? "idx-" + index : "val-" + item;
        if (!map.has(item)) {
            map.set(item, counter++);
            return uid(item);
        }
        return 'uid' + map.get(item);
    };
    return uid;
};
var $18cf83e1d049cf6c$export$e2a22331486dcca0 = $18cf83e1d049cf6c$export$bdbb4cbb3078e58d();

});



parcelRegister("9Hk5t", function(module, exports) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var $70f7b61e05ad3ed2$var$__DEV__ = false;
var $70f7b61e05ad3ed2$var$warning = function() {};
if ($70f7b61e05ad3ed2$var$__DEV__) {
    var $70f7b61e05ad3ed2$var$printWarning = function printWarning(format, args) {
        var len = arguments.length;
        args = new Array(len > 1 ? len - 1 : 0);
        for(var key = 1; key < len; key++)args[key - 1] = arguments[key];
        var argIndex = 0;
        var message = 'Warning: ' + format.replace(/%s/g, function() {
            return args[argIndex++];
        });
        if (typeof console !== 'undefined') console.error(message);
        try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
        } catch (x) {}
    };
    $70f7b61e05ad3ed2$var$warning = function(condition, format, args) {
        var len = arguments.length;
        args = new Array(len > 2 ? len - 2 : 0);
        for(var key = 2; key < len; key++)args[key - 2] = arguments[key];
        if (format === undefined) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
        if (!condition) $70f7b61e05ad3ed2$var$printWarning.apply(null, [
            format
        ].concat(args));
    };
}
module.exports = $70f7b61e05ad3ed2$var$warning;

});

parcelRegister("bZyX7", function(module, exports) {
'use strict';
/**
 * Check if we're required to add a port number.
 *
 * @see https://url.spec.whatwg.org/#default-port
 * @param {Number|String} port Port number we need to check
 * @param {String} protocol Protocol we need to check against.
 * @returns {Boolean} Is it a default port for the given protocol
 * @api private
 */ module.exports = function required(port, protocol) {
    protocol = protocol.split(':')[0];
    port = +port;
    if (!port) return false;
    switch(protocol){
        case 'http':
        case 'ws':
            return port !== 80;
        case 'https':
        case 'wss':
            return port !== 443;
        case 'ftp':
            return port !== 21;
        case 'gopher':
            return port !== 70;
        case 'file':
            return false;
    }
    return port !== 0;
};

});

parcelRegister("aS7kJ", function(module, exports) {
$parcel$export(module.exports, "stringify", () => $7ea4a2c3ddc8bf05$export$fac44ee5b035f737, (v) => $7ea4a2c3ddc8bf05$export$fac44ee5b035f737 = v);
$parcel$export(module.exports, "parse", () => $7ea4a2c3ddc8bf05$export$98e6a39c04603d36, (v) => $7ea4a2c3ddc8bf05$export$98e6a39c04603d36 = v);
//
// Expose the module.
//
var $7ea4a2c3ddc8bf05$export$fac44ee5b035f737;
var $7ea4a2c3ddc8bf05$export$98e6a39c04603d36;
'use strict';
var $7ea4a2c3ddc8bf05$var$has = Object.prototype.hasOwnProperty, $7ea4a2c3ddc8bf05$var$undef;
/**
 * Decode a URI encoded string.
 *
 * @param {String} input The URI encoded string.
 * @returns {String|Null} The decoded string.
 * @api private
 */ function $7ea4a2c3ddc8bf05$var$decode(input) {
    try {
        return decodeURIComponent(input.replace(/\+/g, ' '));
    } catch (e) {
        return null;
    }
}
/**
 * Attempts to encode a given input.
 *
 * @param {String} input The string that needs to be encoded.
 * @returns {String|Null} The encoded string.
 * @api private
 */ function $7ea4a2c3ddc8bf05$var$encode(input) {
    try {
        return encodeURIComponent(input);
    } catch (e) {
        return null;
    }
}
/**
 * Simple query string parser.
 *
 * @param {String} query The query string that needs to be parsed.
 * @returns {Object}
 * @api public
 */ function $7ea4a2c3ddc8bf05$var$querystring(query) {
    var parser = /([^=?&]+)=?([^&]*)/g, result = {}, part;
    while(part = parser.exec(query)){
        var key = $7ea4a2c3ddc8bf05$var$decode(part[1]), value = $7ea4a2c3ddc8bf05$var$decode(part[2]);
        //
        // Prevent overriding of existing properties. This ensures that build-in
        // methods like `toString` or __proto__ are not overriden by malicious
        // querystrings.
        //
        // In the case if failed decoding, we want to omit the key/value pairs
        // from the result.
        //
        if (key === null || value === null || key in result) continue;
        result[key] = value;
    }
    return result;
}
/**
 * Transform a query string to an object.
 *
 * @param {Object} obj Object that should be transformed.
 * @param {String} prefix Optional prefix.
 * @returns {String}
 * @api public
 */ function $7ea4a2c3ddc8bf05$var$querystringify(obj, prefix) {
    prefix = prefix || '';
    var pairs = [], value, key;
    //
    // Optionally prefix with a '?' if needed
    //
    if ('string' !== typeof prefix) prefix = '?';
    for(key in obj)if ($7ea4a2c3ddc8bf05$var$has.call(obj, key)) {
        value = obj[key];
        //
        // Edge cases where we actually want to encode the value to an empty
        // string instead of the stringified value.
        //
        if (!value && (value === null || value === $7ea4a2c3ddc8bf05$var$undef || isNaN(value))) value = '';
        key = encodeURIComponent(key);
        value = encodeURIComponent(value);
        //
        // If we failed to encode the strings, we should bail out as we don't
        // want to add invalid strings to the query.
        //
        if (key === null || value === null) continue;
        pairs.push(key + '=' + value);
    }
    return pairs.length ? prefix + pairs.join('&') : '';
}
$7ea4a2c3ddc8bf05$export$fac44ee5b035f737 = $7ea4a2c3ddc8bf05$var$querystringify;
$7ea4a2c3ddc8bf05$export$98e6a39c04603d36 = $7ea4a2c3ddc8bf05$var$querystring;

});

parcelRegister("44nSH", function(module, exports) {

var $fcFT5 = parcelRequire("fcFT5");

var $g3Lth = parcelRequire("g3Lth");

var $jpEb3 = parcelRequire("jpEb3");
/** `Object#toString` result references. */ var $2f6a0f776b9bcf01$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $2f6a0f776b9bcf01$var$funcProto = Function.prototype, $2f6a0f776b9bcf01$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $2f6a0f776b9bcf01$var$funcToString = $2f6a0f776b9bcf01$var$funcProto.toString;
/** Used to check objects for own properties. */ var $2f6a0f776b9bcf01$var$hasOwnProperty = $2f6a0f776b9bcf01$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $2f6a0f776b9bcf01$var$objectCtorString = $2f6a0f776b9bcf01$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $2f6a0f776b9bcf01$var$isPlainObject(value) {
    if (!$jpEb3(value) || $fcFT5(value) != $2f6a0f776b9bcf01$var$objectTag) return false;
    var proto = $g3Lth(value);
    if (proto === null) return true;
    var Ctor = $2f6a0f776b9bcf01$var$hasOwnProperty.call(proto, 'constructor') && proto.constructor;
    return typeof Ctor == 'function' && Ctor instanceof Ctor && $2f6a0f776b9bcf01$var$funcToString.call(Ctor) == $2f6a0f776b9bcf01$var$objectCtorString;
}
module.exports = $2f6a0f776b9bcf01$var$isPlainObject;

});
parcelRegister("fcFT5", function(module, exports) {

var $2wx9n = parcelRequire("2wx9n");

var $220pH = parcelRequire("220pH");

var $8ZX4i = parcelRequire("8ZX4i");
/** `Object#toString` result references. */ var $b11877fab77c2492$var$nullTag = '[object Null]', $b11877fab77c2492$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $b11877fab77c2492$var$symToStringTag = $2wx9n ? $2wx9n.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $b11877fab77c2492$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $b11877fab77c2492$var$undefinedTag : $b11877fab77c2492$var$nullTag;
    return $b11877fab77c2492$var$symToStringTag && $b11877fab77c2492$var$symToStringTag in Object(value) ? $220pH(value) : $8ZX4i(value);
}
module.exports = $b11877fab77c2492$var$baseGetTag;

});
parcelRegister("2wx9n", function(module, exports) {

var $kyIkP = parcelRequire("kyIkP");
/** Built-in value references. */ var $1d6848e2b856f088$var$Symbol = $kyIkP.Symbol;
module.exports = $1d6848e2b856f088$var$Symbol;

});
parcelRegister("kyIkP", function(module, exports) {

var $bZvG7 = parcelRequire("bZvG7");
/** Detect free variable `self`. */ var $ef795fa13164dcc8$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $ef795fa13164dcc8$var$root = $bZvG7 || $ef795fa13164dcc8$var$freeSelf || Function('return this')();
module.exports = $ef795fa13164dcc8$var$root;

});
parcelRegister("bZvG7", function(module, exports) {
/** Detect free variable `global` from Node.js. */ var $8badf6db57cfb508$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
module.exports = $8badf6db57cfb508$var$freeGlobal;

});



parcelRegister("220pH", function(module, exports) {

var $2wx9n = parcelRequire("2wx9n");
/** Used for built-in method references. */ var $17ac16c9cbc3d03a$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $17ac16c9cbc3d03a$var$hasOwnProperty = $17ac16c9cbc3d03a$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $17ac16c9cbc3d03a$var$nativeObjectToString = $17ac16c9cbc3d03a$var$objectProto.toString;
/** Built-in value references. */ var $17ac16c9cbc3d03a$var$symToStringTag = $2wx9n ? $2wx9n.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $17ac16c9cbc3d03a$var$getRawTag(value) {
    var isOwn = $17ac16c9cbc3d03a$var$hasOwnProperty.call(value, $17ac16c9cbc3d03a$var$symToStringTag), tag = value[$17ac16c9cbc3d03a$var$symToStringTag];
    try {
        value[$17ac16c9cbc3d03a$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $17ac16c9cbc3d03a$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$17ac16c9cbc3d03a$var$symToStringTag] = tag;
        else delete value[$17ac16c9cbc3d03a$var$symToStringTag];
    }
    return result;
}
module.exports = $17ac16c9cbc3d03a$var$getRawTag;

});

parcelRegister("8ZX4i", function(module, exports) {
/** Used for built-in method references. */ var $68d1d6fac8296e78$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $68d1d6fac8296e78$var$nativeObjectToString = $68d1d6fac8296e78$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $68d1d6fac8296e78$var$objectToString(value) {
    return $68d1d6fac8296e78$var$nativeObjectToString.call(value);
}
module.exports = $68d1d6fac8296e78$var$objectToString;

});


parcelRegister("g3Lth", function(module, exports) {

var $7OQ5y = parcelRequire("7OQ5y");
/** Built-in value references. */ var $bb11bff104747753$var$getPrototype = $7OQ5y(Object.getPrototypeOf, Object);
module.exports = $bb11bff104747753$var$getPrototype;

});
parcelRegister("7OQ5y", function(module, exports) {
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $5b159ba108d945f0$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
module.exports = $5b159ba108d945f0$var$overArg;

});


parcelRegister("jpEb3", function(module, exports) {
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $e21f84817c50b14e$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
module.exports = $e21f84817c50b14e$var$isObjectLike;

});


parcelRegister("2KZeD", function(module, exports) {
$parcel$export(module.exports, "default", () => $201f60a1af26d747$export$2e2bcd8739ae039);
/* global window */ 
var $k13ik = parcelRequire("k13ik");
var root;
if (typeof self !== 'undefined') root = self;
else if (typeof window !== 'undefined') root = window;
else if (typeof $parcel$global !== 'undefined') root = $parcel$global;
else root = module;
var result = (0, $k13ik.default)(root);
var $201f60a1af26d747$export$2e2bcd8739ae039 = result;

});
parcelRegister("k13ik", function(module, exports) {
$parcel$export(module.exports, "default", () => $e92674e0ae683617$export$2e2bcd8739ae039);
function $e92674e0ae683617$export$2e2bcd8739ae039(root) {
    var result;
    var Symbol = root.Symbol;
    if (typeof Symbol === 'function') {
        if (Symbol.observable) result = Symbol.observable;
        else {
            result = Symbol('observable');
            Symbol.observable = result;
        }
    } else result = '@@observable';
    return result;
}

});


parcelRegister("ailDh", function(module, exports) {
$parcel$export(module.exports, "default", () => $77ec5d9524ac0560$export$2e2bcd8739ae039);

var $9dyz7 = parcelRequire("9dyz7");
function $77ec5d9524ac0560$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.add(className);
    else if (!(0, $9dyz7.default)(element, className)) {
        if (typeof element.className === 'string') element.className = element.className + " " + className;
        else element.setAttribute('class', (element.className && element.className.baseVal || '') + " " + className);
    }
}

});
parcelRegister("9dyz7", function(module, exports) {
$parcel$export(module.exports, "default", () => $6b6023f18739a0eb$export$2e2bcd8739ae039);
/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */ function $6b6023f18739a0eb$export$2e2bcd8739ae039(element, className) {
    if (element.classList) return !!className && element.classList.contains(className);
    return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}

});


parcelRegister("2IfFn", function(module, exports) {
$parcel$export(module.exports, "default", () => $1f9bd7dc3642c1cf$export$2e2bcd8739ae039);
function $1f9bd7dc3642c1cf$var$replaceClassName(origClass, classToRemove) {
    return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}
function $1f9bd7dc3642c1cf$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.remove(className);
    else if (typeof element.className === 'string') element.className = $1f9bd7dc3642c1cf$var$replaceClassName(element.className, className);
    else element.setAttribute('class', $1f9bd7dc3642c1cf$var$replaceClassName(element.className && element.className.baseVal || '', className));
}

});

parcelRegister("lOA8N", function(module, exports) {

});

parcelRegister("LFmXM", function(module, exports) {
$parcel$export(module.exports, "default", () => $08f47aff49550149$export$2e2bcd8739ae039);
var $08f47aff49550149$var$safeIsNaN = Number.isNaN || function ponyfill(value) {
    return typeof value === 'number' && value !== value;
};
function $08f47aff49550149$var$isEqual(first, second) {
    if (first === second) return true;
    if ($08f47aff49550149$var$safeIsNaN(first) && $08f47aff49550149$var$safeIsNaN(second)) return true;
    return false;
}
function $08f47aff49550149$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (!$08f47aff49550149$var$isEqual(newInputs[i], lastInputs[i])) return false;
    }
    return true;
}
function $08f47aff49550149$export$2e2bcd8739ae039(resultFn, isEqual) {
    if (isEqual === void 0) isEqual = $08f47aff49550149$var$areInputsEqual;
    var cache = null;
    function memoized() {
        var newArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)newArgs[_i] = arguments[_i];
        if (cache && cache.lastThis === this && isEqual(newArgs, cache.lastArgs)) return cache.lastResult;
        var lastResult = resultFn.apply(this, newArgs);
        cache = {
            lastResult: lastResult,
            lastArgs: newArgs,
            lastThis: this
        };
        return lastResult;
    }
    memoized.clear = function clear() {
        cache = null;
    };
    return memoized;
}

});

parcelRegister("7oY9g", function(module, exports) {
$parcel$export(module.exports, "default", () => $d2d6713ffbd374aa$export$2e2bcd8739ae039);

var $59rsN = parcelRequire("59rsN");

var $11lp0 = parcelRequire("11lp0");
let $d2d6713ffbd374aa$var$cache;
function $d2d6713ffbd374aa$export$2e2bcd8739ae039(name) {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const globalVar = typeof window !== 'undefined' ? window : globalThis;
    try {
        if (!$d2d6713ffbd374aa$var$cache) {
            if (false && typeof globalVar.__SSR_SYNC_READ_EXP_VAL__ === 'function' && // if global variable is ready, then don't reach out to native
            // API, stay within js runtime is faster
            !globalVar._statsigValuesReady) try {
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                const config = globalVar.__SSR_SYNC_READ_EXP_VAL__('killswitch', 'value', []);
                $d2d6713ffbd374aa$var$cache = new Set(config.map((d)=>d.toLowerCase()));
                return $d2d6713ffbd374aa$var$cache.has(name.toLowerCase());
            } catch (error) {
                // eslint-disable-next-line no-console
                console.error(JSON.stringify({
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    message: error.message,
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    stack: error.stack
                }));
            }
            else {
                (0, $11lp0.UNSAFE_initIfNeeded)();
                // Using this to access a dynamic parameter
                // Killswitching is known destructive, hence the lack of exposure
                const config = (0, $59rsN.default).getExperimentValue('killswitch', 'value', [], {
                    fireExperimentExposure: false
                });
                $d2d6713ffbd374aa$var$cache = new Set(config.map((d)=>d.toLowerCase()));
            }
        }
        return $d2d6713ffbd374aa$var$cache.has(name.toLowerCase());
    } catch (e) {
        return false;
    }
}

});

parcelRegister("6E16M", function(module, exports) {
$parcel$export(module.exports, "createContainer", () => $3156949479055223$export$26ae5ca175b4ec5a);

var $eJOHy = parcelRequire("eJOHy");

var $bJFuI = parcelRequire("bJFuI");

var $luRis = parcelRequire("luRis");

var $14kUX = parcelRequire("14kUX");

var $bjd2g = parcelRequire("bjd2g");
// eslint-disable-next-line @typescript-eslint/no-empty-function -- ERROR TO BE FIXED
const $3156949479055223$var$noop = ()=>()=>{};
function $3156949479055223$export$26ae5ca175b4ec5a(StoreOrOptions = {}, { onInit: onInit = $3156949479055223$var$noop, onUpdate: onUpdate = $3156949479055223$var$noop, onCleanup: onCleanup = $3156949479055223$var$noop, displayName: displayName = '', getIsConcurrentSafe: getIsConcurrentSafe } = {}) {
    if ('key' in StoreOrOptions) {
        const Store = StoreOrOptions;
        const dn = displayName || `Container(${Store.key.split('__')[0]})`;
        return $3156949479055223$var$createFunctionContainer({
            displayName: dn,
            // compat fields
            override: {
                Store: Store,
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment -- ERROR TO BE FIXED
                // @ts-ignore Object.assign expects Object as params
                // but logical expression can return false
                // Ignoring TS to retain original source
                // eslint-disable-next-line prefer-object-spread -- ERROR TO BE FIXED
                handlers: Object.assign({}, onInit !== $3156949479055223$var$noop && {
                    onInit: ()=>onInit()
                }, onCleanup !== $3156949479055223$var$noop && {
                    onDestroy: ()=>onCleanup()
                }, // TODO: on next major pass through next/prev props args
                onUpdate !== $3156949479055223$var$noop && {
                    onContainerUpdate: ()=>onUpdate()
                })
            },
            getIsConcurrentSafe: getIsConcurrentSafe
        });
    }
    return $3156949479055223$var$createFunctionContainer(StoreOrOptions);
}
function $3156949479055223$var$useRegistry(scope, isGlobal, { globalRegistry: globalRegistry }) {
    return (0, $eJOHy.useMemo)(()=>{
        const isLocal = !scope && !isGlobal;
        return isLocal ? new (0, $14kUX.StoreRegistry)('__local__') : globalRegistry;
    }, [
        scope,
        isGlobal,
        globalRegistry
    ]);
}
function $3156949479055223$var$useContainedStore(scope, registry, propsRef, check, override) {
    // Store contained scopes in a map, but throwing it away on scope change
    // PLEASE CONFIRM THESE DEPENDENCIES ARE CORRECT
    // eslint-disable-next-line react-hooks/exhaustive-deps, @typescript-eslint/no-explicit-any, react-hooks/exhaustive-deps -- PLEASE FIX THIS SUPPRESSION
    const containedStores = (0, $eJOHy.useMemo)(()=>new Map(), [
        scope
    ]);
    const getContainedStore = (0, $eJOHy.useCallback)((Store)=>{
        let containedStore = containedStores.get(Store);
        // first time it gets called we add store to contained map bound
        // so we can provide props to actions (only triggered by children)
        if (!containedStore) {
            const isExisting = registry.hasStore(Store, scope);
            const config = {
                props: ()=>propsRef.current.sub,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- ERROR TO BE FIXED
                contained: check
            };
            const { storeState: storeState } = registry.getStore(Store, scope, config);
            const actions = (0, $luRis.bindActions)(Store.actions, storeState, config);
            const handlers = (0, $luRis.bindActions)(// eslint-disable-next-line prefer-object-spread -- ERROR TO BE FIXED
            Object.assign({}, Store.handlers, override?.handlers), storeState, config, actions);
            containedStore = {
                storeState: storeState,
                actions: actions,
                handlers: handlers,
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment -- ERROR TO BE FIXED
                // @ts-ignore - TS2345 Argument of type '[]' is not assignable to parameter of type 'Parameters<TActions[string]>'.
                unsubscribe: undefined
            };
            containedStores.set(Store, containedStore);
            // Signal store is contained and ready now, so by the time
            // consumers subscribe we already have updated the store (if needed).
            // Also if override maintain legacy behaviour, triggered on every mount
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment -- ERROR TO BE FIXED
            // @ts-ignore - TS2345 Argument of type '[]' is not assignable to parameter of type 'Parameters<TActions[string]>'.
            if (!isExisting || override) handlers.onInit?.();
        }
        return containedStore;
    }, [
        containedStores,
        scope,
        registry,
        propsRef,
        check,
        override
    ]);
    return [
        containedStores,
        getContainedStore
    ];
}
function $3156949479055223$var$useApi(check, // eslint-disable-next-line @typescript-eslint/no-explicit-any -- ERROR TO BE FIXED
getContainedStore, { globalRegistry: globalRegistry, retrieveStore: retrieveStore }, isConcurrentSafe) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- ERROR TO BE FIXED
    const retrieveRef = (0, $eJOHy.useRef)(isConcurrentSafe ? (Store)=>check(Store) ? getContainedStore(Store) : retrieveStore(Store) : undefined);
    if (isConcurrentSafe) // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $eJOHy.useLayoutEffect)(()=>{
        retrieveRef.current = (Store)=>check(Store) ? getContainedStore(Store) : retrieveStore(Store);
    }, [
        check,
        getContainedStore,
        retrieveStore
    ]);
    else retrieveRef.current = (Store)=>check(Store) ? getContainedStore(Store) : retrieveStore(Store);
    // This api is "frozen", as changing it will trigger re-render across all consumers
    // so we link retrieveStore dynamically and manually call notify() on scope change
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- ERROR TO BE FIXED
    return (0, $eJOHy.useMemo)(()=>({
            globalRegistry: globalRegistry,
            retrieveStore: (s)=>retrieveRef?.current?.(s)
        }), [
        globalRegistry
    ]);
}
function $3156949479055223$var$createFunctionContainer({ displayName: displayName, override: override, getIsConcurrentSafe: getIsConcurrentSafe } = {}) {
    const check = (store)=>override ? store === override.Store : store.containedBy === FunctionContainer;
    function FunctionContainer(props) {
        const isConcurrentSafe = getIsConcurrentSafe?.() ?? false;
        const { children: children, ...restProps } = props;
        const { scope: scope, isGlobal: isGlobal, ...subProps } = restProps;
        const ctx = (0, $eJOHy.useContext)((0, $bJFuI.Context));
        const registry = $3156949479055223$var$useRegistry(scope, isGlobal, ctx);
        // Store props in a ref to avoid re-binding actions when they change and re-rendering all
        // consumers unnecessarily. The update is handled by an effect on the component instead
        const propsRef = (0, $eJOHy.useRef)({
            prev: null,
            next: restProps,
            sub: subProps
        });
        if (!isConcurrentSafe) propsRef.current = {
            prev: propsRef.current.next,
            next: restProps,
            sub: subProps
        };
        const [containedStores, getContainedStore] = $3156949479055223$var$useContainedStore(scope, registry, propsRef, check, override);
        // Use a stable object as is passed as value to context Provider
        const api = $3156949479055223$var$useApi(check, getContainedStore, ctx, isConcurrentSafe);
        if (isConcurrentSafe) // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $eJOHy.useLayoutEffect)(()=>{
            propsRef.current = {
                prev: propsRef.current.next,
                next: restProps,
                sub: subProps
            };
            if (!(0, $bjd2g.default)(propsRef.current.next, propsRef.current.prev)) containedStores.forEach(({ handlers: handlers })=>{
                handlers.onContainerUpdate?.(propsRef.current.next, propsRef.current.prev);
            });
        }, [
            containedStores,
            restProps,
            subProps
        ]);
        else if (!(0, $bjd2g.default)(propsRef.current.next, propsRef.current.prev)) containedStores.forEach(({ handlers: handlers })=>{
            handlers.onContainerUpdate?.(propsRef.current.next, propsRef.current.prev);
        });
        // Every time we add/remove a contained store, we ensure we are subscribed to the updates
        // as an effect to properly handle strict mode
        (0, $eJOHy.useEffect)(()=>{
            containedStores.forEach((containedStore)=>{
                if (!containedStore.unsubscribe) {
                    const unsub = containedStore.storeState.subscribe(()=>containedStore.handlers.onUpdate?.());
                    // eslint-disable-next-line no-param-reassign
                    containedStore.unsubscribe = ()=>{
                        unsub();
                        // eslint-disable-next-line no-param-reassign
                        containedStore.unsubscribe = undefined;
                    };
                }
            });
        }, [
            containedStores,
            containedStores.size
        ]);
        if (isConcurrentSafe) // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $eJOHy.useLayoutEffect)(()=>{
            if (override && !containedStores.size && (scope || isGlobal)) getContainedStore(override.Store);
        }, [
            containedStores.size,
            getContainedStore,
            isGlobal,
            scope
        ]);
        else if (override && !containedStores.size && (scope || isGlobal)) getContainedStore(override.Store);
        // This listens for scope change or component unmount, to notify all consumers
        // so all work is done on cleanup
        (0, $eJOHy.useEffect)(()=>()=>{
                containedStores.forEach(({ storeState: storeState, handlers: handlers, unsubscribe: unsubscribe }, Store)=>{
                    // Detatch container from subscription
                    unsubscribe?.();
                    // Trigger a forced update on all subscribers as we opted out from context
                    // Some might have already re-rendered naturally, but we "force update" all anyway.
                    // This is sub-optimal as if there are other containers with the same
                    // old scope id we will re-render those too, but still better than context
                    storeState.notify();
                    // Given unsubscription is handled by useSyncExternalStore, we have no control on when
                    // React decides to do it. So we schedule on next tick to run last
                    Promise.resolve().then(()=>{
                        if (!storeState.listeners().size && // ensure registry has not already created a new store with same scope
                        storeState === registry.getStore(Store, scope, null)?.storeState) {
                            handlers.onDestroy?.();
                            // We only delete scoped stores, as global shall persist and local are auto-deleted
                            if (!isGlobal) registry.deleteStore(Store, scope);
                        }
                    });
                });
            // no need to reset containedStores as the map is already bound to scope
            }, [
            registry,
            scope,
            containedStores,
            isGlobal
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bJFuI.Context).Provider, {
            value: api
        }, children);
    }
    FunctionContainer.displayName = displayName || 'Container';
    return FunctionContainer;
}

});
parcelRegister("bJFuI", function(module, exports) {
$parcel$export(module.exports, "Context", () => $fb14520456c06a8a$export$841858b892ce1f4c);

var $eJOHy = parcelRequire("eJOHy");

var $14kUX = parcelRequire("14kUX");
const $fb14520456c06a8a$export$841858b892ce1f4c = /*#__PURE__*/ (0, $eJOHy.createContext)({
    globalRegistry: (0, $14kUX.defaultRegistry),
    retrieveStore: (Store)=>(0, $14kUX.defaultRegistry).getStore(Store)
});

});
parcelRegister("14kUX", function(module, exports) {
$parcel$export(module.exports, "StoreRegistry", () => $1444b1a5460bb9fc$export$acb47f32da33501e);
$parcel$export(module.exports, "defaultRegistry", () => $1444b1a5460bb9fc$export$9d726ae4880b1060);

var $5lAE7 = parcelRequire("5lAE7");

var $luRis = parcelRequire("luRis");

var $l1IUf = parcelRequire("l1IUf");
const $1444b1a5460bb9fc$export$e4d628ba0054221b = '__global__';
class $1444b1a5460bb9fc$export$acb47f32da33501e {
    constructor(defaultScope = '__global__'){
        this.defaultScope = defaultScope;
        this.// eslint-disable-next-line @typescript-eslint/no-explicit-any
        stores = new Map();
        this.initStore = (key, Store, config)=>{
            const { initialState: initialState, actions: actions, behavior: behavior } = Store;
            if (Store.containedBy && !config.contained(Store)) {
                const err = new Error(`Store ${Store.key} should be contained by a container but it is used globally. ` + 'While it might still work, it will likely cause unexpected behaviours.');
                if ((0, $5lAE7.default).scheduling()) Promise.reject(err);
                else throw err;
            }
            const storeState = (0, $l1IUf.default)(key, initialState, behavior);
            let boundActions;
            const store = {
                storeState: storeState,
                // these are used only when container-less, so we generate them on-demand
                get actions () {
                    if (!boundActions) boundActions = (0, $luRis.bindActions)(actions, storeState, config);
                    return boundActions;
                }
            };
            this.stores.set(key, store);
            return store;
        };
        this.hasStore = (Store, scopeId = this.defaultScope)=>{
            const key = this.generateKey(Store, scopeId);
            return this.stores.has(key);
        };
        this.getStore = (Store, scopeId = this.defaultScope, config = {
            props: ()=>({}),
            contained: ()=>false
        })=>{
            const key = this.generateKey(Store, scopeId);
            return this.stores.get(key) || config && this.initStore(key, Store, config);
        };
        this.deleteStore = (Store, scopeId = this.defaultScope)=>{
            const key = this.generateKey(Store, scopeId);
            this.stores.delete(key);
        };
        this.generateKey = (Store, scopeId)=>`${Store.key}@${scopeId}`;
        this.defaultScope = defaultScope;
    }
}
const $1444b1a5460bb9fc$export$9d726ae4880b1060 = new $1444b1a5460bb9fc$export$acb47f32da33501e();

});
parcelRegister("5lAE7", function(module, exports) {
$parcel$export(module.exports, "default", () => $77b1ca0349f0543d$export$2e2bcd8739ae039);
const $77b1ca0349f0543d$var$supports = {
    scheduling () {
        // FIXME: this condition causes tests not to represent the real browser behaviour
        return typeof window !== 'undefined' && typeof MessageChannel === 'function';
    }
};
var $77b1ca0349f0543d$export$2e2bcd8739ae039 = $77b1ca0349f0543d$var$supports;

});

parcelRegister("luRis", function(module, exports) {
$parcel$export(module.exports, "bindActions", () => $25fcc17e70c2044b$export$5ee1d46cd0883a22);

var $awqaz = parcelRequire("awqaz");
const $25fcc17e70c2044b$var$namedMutator = (// storeState should be StoreState<TState>
// but this mutator's signature doesn't match
// the mutator's actual type of (Partial<TState>) => void
// eslint-disable-next-line @typescript-eslint/no-explicit-any
storeState, actionName)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (...arg)=>{
        // eslint-disable-next-line no-param-reassign
        storeState.mutator.actionName = actionName;
        return storeState.mutator(...arg);
    };
const $25fcc17e70c2044b$var$warnings = new WeakMap();
const $25fcc17e70c2044b$export$5f944353e69b9bf3 = (storeState, actionFn, actionKey, config, actions)=>{
    const callThunk = (instance, thunkFn, actionName)=>thunkFn({
            setState: (0, $awqaz.default).devtools ? $25fcc17e70c2044b$var$namedMutator(instance.storeState, actionName) : instance.storeState.mutator,
            getState: instance.storeState.getState,
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore - TS2353 actions() is a deprecated API
            get actions () {
                if (!$25fcc17e70c2044b$var$warnings.has(actionFn)) $25fcc17e70c2044b$var$warnings.set(actionFn, // eslint-disable-next-line no-console
                console.warn("react-sweet-state 'actions' property has been deprecated and will be removed in the next mayor. " + `Please check action '${actionName}' of Store '${instance.storeState.key}' and use 'dispatch' instead`));
                return actions;
            },
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            dispatch: (tFn)=>callThunk(instance, tFn, `${actionName}.dispatch`)
        }, config.props());
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (...args)=>callThunk({
            storeState: storeState,
            actions: actions
        }, actionFn(...args), actionKey);
};
const $25fcc17e70c2044b$export$5ee1d46cd0883a22 = (actions, storeState, config, boundActions = null)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    Object.keys(actions).reduce((acc, k)=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        acc[k] = $25fcc17e70c2044b$export$5f944353e69b9bf3(storeState, actions[k], // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        k, config, boundActions || acc);
        return acc;
    }, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    {});

});
parcelRegister("awqaz", function(module, exports) {
$parcel$export(module.exports, "default", () => $8368802e083610fd$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
const $8368802e083610fd$var$defaultMutator = (prevState, partialState)=>// Merge the partial state and the previous state.
    ({
        ...prevState,
        ...partialState
    });
const $8368802e083610fd$var$defaults = {
    batchUpdates: 'useSyncExternalStore' in (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))),
    devtools: false,
    middlewares: new Set(),
    mutator: $8368802e083610fd$var$defaultMutator
};
var $8368802e083610fd$export$2e2bcd8739ae039 = $8368802e083610fd$var$defaults;

});


parcelRegister("l1IUf", function(module, exports) {
$parcel$export(module.exports, "default", () => $2602e9ac6437e563$export$2e2bcd8739ae039);

var $awqaz = parcelRequire("awqaz");

var $cIZon = parcelRequire("cIZon");

var $d95Ds = parcelRequire("d95Ds");

var $yTY9o = parcelRequire("yTY9o");
function $2602e9ac6437e563$var$createStoreState(key, initialState, behavior) {
    const listeners = new Set();
    const startState = typeof initialState === 'function' ? initialState() : initialState;
    let currentState = startState;
    const storeState = {
        key: key,
        getState () {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- ERROR TO BE FIXED
            return currentState;
        },
        setState (nextState) {
            currentState = nextState;
            if (behavior === 'strict') // In strict mode, we notify all handlers immediately
            // to avoid tearing and sync with other solutions (like Redux) using same model
            storeState.notify();
            else // Instead of notifying all handlers immediately, we wait next tick
            // so multiple actions affecting the same store gets combined
            (0, $yTY9o.default)(storeState.notify);
        },
        resetState () {
            storeState.setState(startState);
        },
        notify () {
            for (const listener of listeners)listener(storeState.getState());
        },
        subscribe (listener) {
            listeners.add(listener);
            return function unsubscribe() {
                listeners.delete(listener);
            };
        },
        listeners () {
            return listeners;
        },
        // Added to satisfy StoreState<TState> type
        // eslint-disable-next-line @typescript-eslint/no-empty-function -- ERROR TO BE FIXED
        mutator: ()=>{}
    };
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- ERROR TO BE FIXED
    storeState.mutator = (0, $d95Ds.default)(storeState, (0, $awqaz.default).middlewares);
    return storeState;
}
var // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- ERROR TO BE FIXED
$2602e9ac6437e563$export$2e2bcd8739ae039 = (0, $cIZon.default)($2602e9ac6437e563$var$createStoreState);

});
parcelRegister("cIZon", function(module, exports) {
$parcel$export(module.exports, "default", () => $ca66407c11485231$export$2e2bcd8739ae039);

var $awqaz = parcelRequire("awqaz");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $ca66407c11485231$var$connectDevTools = (storeState, config)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const devTools = window.__REDUX_DEVTOOLS_EXTENSION__.connect({
        name: `Store ${storeState.key}`,
        serialize: true,
        trace: true,
        ...config
    });
    devTools.init(storeState.getState());
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    devTools.subscribe((message)=>{
        if (message.type === 'DISPATCH') // eslint-disable-next-line default-case
        switch(message.payload.type){
            case 'RESET':
                storeState.resetState();
                devTools.init(storeState.getState());
                return;
            case 'COMMIT':
                devTools.init(storeState.getState());
                return;
            case 'ROLLBACK':
                storeState.setState(JSON.parse(message.state));
                devTools.init(storeState.getState());
                return;
            case 'JUMP_TO_STATE':
            case 'JUMP_TO_ACTION':
                storeState.setState(JSON.parse(message.state));
        }
        else if (message.type === 'ACTION') {
            const action = JSON.parse(message.payload);
            storeState.setState(action.payload);
        }
    });
    return devTools;
};
const $ca66407c11485231$var$withDevtools = (createStoreState)=>(...args)=>{
        const storeState = createStoreState(...args);
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        if ((0, $awqaz.default).devtools && window && window.__REDUX_DEVTOOLS_EXTENSION__) {
            const origMutator = storeState.mutator;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            let devTools;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const devtoolMutator = (arg)=>{
                const result = origMutator(arg);
                try {
                    if (!devTools) {
                        const config = typeof (0, $awqaz.default).devtools === 'function' ? (0, $awqaz.default).devtools(storeState) : {};
                        devTools = $ca66407c11485231$var$connectDevTools(storeState, config);
                    }
                    devTools.send({
                        type: storeState.mutator.actionName,
                        payload: arg
                    }, storeState.getState(), {}, storeState.key);
                } catch (err) {
                /* ignore devtools errors */ }
                return result;
            };
            storeState.mutator = devtoolMutator;
        }
        return storeState;
    };
var $ca66407c11485231$export$2e2bcd8739ae039 = $ca66407c11485231$var$withDevtools;

});

parcelRegister("d95Ds", function(module, exports) {
$parcel$export(module.exports, "default", () => $7dd228899084ec38$export$2e2bcd8739ae039);

var $awqaz = parcelRequire("awqaz");

var $f4Kgd = parcelRequire("f4Kgd");
const $7dd228899084ec38$var$applyMiddleware = (storeState, middlewares)=>Array.from(middlewares).concat((0, $f4Kgd.default)).reduceRight((next, mw)=>mw(storeState)(next), (0, $awqaz.default).mutator);
var $7dd228899084ec38$export$2e2bcd8739ae039 = $7dd228899084ec38$var$applyMiddleware;

});
parcelRegister("f4Kgd", function(module, exports) {
$parcel$export(module.exports, "default", () => $5dacf923e54816d3$export$2e2bcd8739ae039);

var $bjd2g = parcelRequire("bjd2g");
const $5dacf923e54816d3$var$updateMiddleware = (storeState)=>(next)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (arg)=>{
            let output;
            const state = storeState.getState();
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const nextState = next(state, arg, (out)=>{
                output = out;
            });
            if (!(0, $bjd2g.default)(nextState, state)) storeState.setState(nextState);
            return output;
        };
var $5dacf923e54816d3$export$2e2bcd8739ae039 = $5dacf923e54816d3$var$updateMiddleware;

});
parcelRegister("bjd2g", function(module, exports) {
$parcel$export(module.exports, "default", () => $6559274b411a4266$export$2e2bcd8739ae039);
// Mostly copied from fbjs/packages/fbjs/src/core/shallowEqual.js
// enhanced with keys cache as might get called multiple times with same args
const $6559274b411a4266$var$CACHE = new WeakMap();
function $6559274b411a4266$export$2e2bcd8739ae039(objA, objB) {
    if (objA === objB) return true;
    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) return false;
    if (Array.isArray(objA) && Array.isArray(objB)) {
        // do array comparison
        if (objA.length !== objB.length) return false;
        for(let i = 0; i < objA.length; i++){
            if (objA[i] !== objB[i]) return false;
        }
        return true;
    }
    // Handle Date, RegExp, String, Number, ... and complex objects
    const strA = `${objA}`;
    const strB = `${objB}`;
    if (strA !== strB || strA[0] === '[' && strA !== '[object Object]') return false;
    // do object comparison
    let keysA;
    if ($6559274b411a4266$var$CACHE.has(objA)) keysA = $6559274b411a4266$var$CACHE.get(objA);
    else {
        keysA = Object.keys(objA);
        $6559274b411a4266$var$CACHE.set(objA, keysA);
    }
    let keysB;
    if ($6559274b411a4266$var$CACHE.has(objB)) keysB = $6559274b411a4266$var$CACHE.get(objB);
    else {
        keysB = Object.keys(objB);
        $6559274b411a4266$var$CACHE.set(objB, keysB);
    }
    if (keysA.length !== keysB.length) return false;
    // Test for A's keys different from B.
    for(let i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) return false;
    }
    return true;
}

});



parcelRegister("yTY9o", function(module, exports) {
$parcel$export(module.exports, "scheduleSyncFlush", () => $0696eca987801700$export$aaf852812ad1ebe4);
$parcel$export(module.exports, "default", () => $0696eca987801700$export$2e2bcd8739ae039);

var $awqaz = parcelRequire("awqaz");

var $21QSd = parcelRequire("21QSd");

var $5lAE7 = parcelRequire("5lAE7");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $0696eca987801700$var$SCHEDULE_QUEUE = [];
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $0696eca987801700$var$SYNC_QUEUE = $0696eca987801700$var$SCHEDULE_QUEUE;
let $0696eca987801700$var$scheduled;
let $0696eca987801700$var$syncDepth = 0;
const $0696eca987801700$export$aaf852812ad1ebe4 = (cb)=>{
    try {
        $0696eca987801700$var$syncDepth++;
        cb();
    } finally{
        $0696eca987801700$var$syncDepth--;
        if ($0696eca987801700$var$syncDepth === 0) (0, $21QSd.executeBatchedUpdate)(()=>{
            let queueFn;
            // eslint-disable-next-line no-cond-assign
            while(queueFn = $0696eca987801700$var$SYNC_QUEUE.shift())queueFn();
        });
    }
};
function $0696eca987801700$export$2e2bcd8739ae039(fn) {
    // if we are in node/tests or feature disabled, make updates sync batched
    if (!(0, $awqaz.default).batchUpdates || !(0, $5lAE7.default).scheduling()) return (0, $21QSd.executeBatchedUpdate)(()=>fn());
    if ($0696eca987801700$var$syncDepth) {
        // we are in sync mode
        if (!$0696eca987801700$var$SYNC_QUEUE.includes(fn)) $0696eca987801700$var$SYNC_QUEUE.push(fn);
        return;
    }
    // Add to queue if not already there
    // so we avoid multiple notifications to same store listeners
    if (!$0696eca987801700$var$SCHEDULE_QUEUE.includes(fn)) $0696eca987801700$var$SCHEDULE_QUEUE.push(fn);
    // if something already started schedule, skip
    if ($0696eca987801700$var$scheduled) return;
    $0696eca987801700$var$scheduled = (0, $21QSd.batch)(()=>{
        let queueFn;
        // eslint-disable-next-line no-cond-assign
        while(queueFn = $0696eca987801700$var$SCHEDULE_QUEUE.shift())queueFn();
        $0696eca987801700$var$scheduled = null;
    });
}

});
parcelRegister("21QSd", function(module, exports) {
$parcel$export(module.exports, "executeBatchedUpdate", () => $a4fbd5076c568b83$export$da0d6fbc8215c86e);
$parcel$export(module.exports, "batch", () => $a4fbd5076c568b83$export$712ea50be43a7858);
// eslint-disable-next-line camelcase

var $aQK2r = parcelRequire("aQK2r");

var $jbhXM = parcelRequire("jbhXM");

var $awqaz = parcelRequire("awqaz");

var $5lAE7 = parcelRequire("5lAE7");
const $a4fbd5076c568b83$export$da0d6fbc8215c86e = (fn)=>{
    return (0, $aQK2r.unstable_batchedUpdates)(fn);
};
let $a4fbd5076c568b83$var$isInsideBatchedSchedule = false;
function $a4fbd5076c568b83$export$712ea50be43a7858(fn) {
    // if we are in node/tests or nested schedule
    if (!(0, $awqaz.default).batchUpdates || !(0, $5lAE7.default).scheduling() || $a4fbd5076c568b83$var$isInsideBatchedSchedule) return $a4fbd5076c568b83$export$da0d6fbc8215c86e(fn);
    $a4fbd5076c568b83$var$isInsideBatchedSchedule = true;
    // Use ImmediatePriority as it has -1ms timeout
    // https://github.com/facebook/react/blob/main/packages/scheduler/src/forks/Scheduler.js#L65
    return (0, $jbhXM.unstable_scheduleCallback)((0, $jbhXM.unstable_ImmediatePriority), ()=>{
        (0, $aQK2r.unstable_batchedUpdates)(fn);
        $a4fbd5076c568b83$var$isInsideBatchedSchedule = false;
    });
}

});






parcelRegister("iJq0l", function(module, exports) {
$parcel$export(module.exports, "createHook", () => $fdef0a00a6025d35$export$e7f733c8fc2b8a24);
$parcel$export(module.exports, "createSelectorHook", () => $fdef0a00a6025d35$export$2b53f90d2bd1cbfb);
$parcel$export(module.exports, "createActionsHook", () => $fdef0a00a6025d35$export$7c643e1d6648e418);
$parcel$export(module.exports, "createStateHook", () => $fdef0a00a6025d35$export$6e4e5611de132e85);

var $eJOHy = parcelRequire("eJOHy");

var $g5PZJ = parcelRequire("g5PZJ");

var $j5V5L = parcelRequire("j5V5L");

var $bJFuI = parcelRequire("bJFuI");

var $9Sys8 = parcelRequire("9Sys8");
const $fdef0a00a6025d35$var$EMPTY_SELECTOR = ()=>undefined;
const $fdef0a00a6025d35$var$DEFAULT_SELECTOR = (state)=>state;
function $fdef0a00a6025d35$export$e7f733c8fc2b8a24(// eslint-disable-next-line @typescript-eslint/no-explicit-any
Store, // eslint-disable-next-line @typescript-eslint/no-explicit-any
{ selector: selector } = {}) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function useSweetState(propsArg) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const { retrieveStore: retrieveStore } = (0, $eJOHy.useContext)((0, $bJFuI.Context));
        const { storeState: storeState, actions: actions } = retrieveStore(Store);
        const hasPropsArg = propsArg !== undefined;
        const propsArgRef = (0, $eJOHy.useRef)(propsArg);
        propsArgRef.current = propsArg;
        const stateSelector = (0, $eJOHy.useMemo)(()=>{
            if (selector) return (0, $9Sys8.getSelectorInstance)(selector, storeState, hasPropsArg);
            return selector === null ? $fdef0a00a6025d35$var$EMPTY_SELECTOR : $fdef0a00a6025d35$var$DEFAULT_SELECTOR;
        }, [
            hasPropsArg,
            storeState
        ]);
        const forceUpdate = (0, $eJOHy.useState)({})[1];
        const getSnapshot = (0, $eJOHy.useCallback)(()=>{
            // parent scope has changed and notify was explicitly triggered by the container
            // we need to force the hook to re-render to listen new storeState
            if (retrieveStore(Store).storeState !== storeState) forceUpdate({});
            const state = storeState.getState();
            return stateSelector(state, propsArgRef.current);
        }, [
            retrieveStore,
            storeState,
            stateSelector,
            forceUpdate
        ]);
        const currentState = (0, $g5PZJ.useSyncExternalStore)(storeState.subscribe, getSnapshot, getSnapshot);
        return [
            currentState,
            actions
        ];
    };
}
function $fdef0a00a6025d35$export$2b53f90d2bd1cbfb(Store) {
    return function useSweetState(selector) {
        const { retrieveStore: retrieveStore } = (0, $eJOHy.useContext)((0, $bJFuI.Context));
        const { storeState: storeState } = retrieveStore(Store);
        const [, forceUpdate] = (0, $eJOHy.useState)({});
        const previousSelectorRef = (0, $eJOHy.useRef)(selector);
        const selectorRef = (0, $eJOHy.useRef)(selector);
        const selectedStateRef = (0, $eJOHy.useRef)(selectorRef.current(storeState.getState()));
        const previousState = (0, $eJOHy.useRef)(storeState.getState());
        (0, $eJOHy.useEffect)(()=>{
            if (selectorRef.current !== selector) {
                selectorRef.current = selector;
                if (!(0, $j5V5L.default)(selectorRef.current(storeState.getState()), selectedStateRef.current)) forceUpdate({});
            }
        }, [
            selector,
            storeState
        ]);
        const getSnapshot = (0, $eJOHy.useCallback)(()=>{
            const state = storeState.getState();
            if (previousState.current !== state || previousSelectorRef.current !== selectorRef.current) {
                const nextSelectedState = selectorRef.current(state);
                if ((0, $j5V5L.default)(nextSelectedState, selectedStateRef.current)) return selectedStateRef.current;
                previousSelectorRef.current = selectorRef.current;
                selectedStateRef.current = nextSelectedState;
                previousState.current = state;
            }
            return selectedStateRef.current;
        }, [
            storeState
        ]);
        return (0, $g5PZJ.useSyncExternalStore)(storeState.subscribe, getSnapshot, getSnapshot);
    };
}
function $fdef0a00a6025d35$export$7c643e1d6648e418(Store) {
    const useHook = $fdef0a00a6025d35$export$e7f733c8fc2b8a24(Store, {
        selector: null
    });
    return function useSweetStateActions() {
        return useHook()[1];
    };
}
function $fdef0a00a6025d35$export$6e4e5611de132e85(Store, { selector: selector } = {}) {
    const useHook = $fdef0a00a6025d35$export$e7f733c8fc2b8a24(Store, {
        selector: selector
    });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function useSweetStateState(propsArg) {
        return useHook(propsArg)[0];
    };
}

});
parcelRegister("j5V5L", function(module, exports) {
$parcel$export(module.exports, "default", () => $8d7de49daf819093$export$2e2bcd8739ae039);

var $iOzZS = parcelRequire("iOzZS");
/**
 * Shallow equal using '===' comparison and one-level array checks.
 *
 * WARNING: This is not a true shallow equal, use @atlassian/jira-platform-shallow-equal.
 *
 * @see {@link http://go.atlassian.com/shallow-equal}
 *
 * @param {*} obj1
 * @param {*} obj2
 * @returns {boolean}
 */ const $8d7de49daf819093$var$isShallowEqual = (obj1, obj2)=>{
    if (obj1 === obj2) return true;
    if (!obj1 || !obj2) return false;
    const item1Keys = Object.keys(obj1).sort();
    const item2Keys = Object.keys(obj2).sort();
    // are keys equal?
    if (!(0, $iOzZS.default)(item1Keys, item2Keys)) return false;
    // are the values equal?
    const areValuesEqual = item2Keys.every((key)=>{
        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        const value = obj1[key];
        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        const nextValue = obj2[key];
        if (value === nextValue) return true;
        return Array.isArray(nextValue) && Array.isArray(value) && (0, $iOzZS.default)(value, nextValue);
    });
    return areValuesEqual;
};
var $8d7de49daf819093$export$2e2bcd8739ae039 = $8d7de49daf819093$var$isShallowEqual;

});
parcelRegister("iOzZS", function(module, exports) {
$parcel$export(module.exports, "default", () => $e34919ee7f3643d5$export$2e2bcd8739ae039);
/**
 * Returns true if the two given arrays are equal one level deep
 */ const $e34919ee7f3643d5$var$isArrayEqual = (array1 = [], array2 = [])=>{
    // @ts-expect-error - This comparison appears to be unintentional because the types 'readonly T[]' and 'readonly U[]' have no overlap.
    if (array1 === array2) return true;
    // check one level deep
    // @ts-expect-error - This comparison appears to be unintentional because the types 'T' and 'U' have no overlap.
    return array1.length === array2.length && array1.every((item, index)=>item === array2[index]);
};
var $e34919ee7f3643d5$export$2e2bcd8739ae039 = $e34919ee7f3643d5$var$isArrayEqual;

});


parcelRegister("9Sys8", function(module, exports) {
$parcel$export(module.exports, "getSelectorInstance", () => $55b9c1dedf1aff9e$export$38d24f3c60944dd5);

var $4MchI = parcelRequire("4MchI");
function $55b9c1dedf1aff9e$export$d2c200d79fc82f8c(selector) {
    const isReselector = typeof selector.resultFunc === 'function' && Array.isArray(selector.dependencies);
    const dependencies = isReselector ? selector.dependencies : [
        (s)=>s,
        (_, p)=>p
    ];
    const resultFunc = isReselector ? selector.resultFunc : selector;
    return (0, $4MchI.createSelector)(dependencies, resultFunc);
}
const $55b9c1dedf1aff9e$var$cache = new WeakMap();
function $55b9c1dedf1aff9e$export$38d24f3c60944dd5(selector, storeState, hasProps) {
    if (!hasProps) {
        if (!$55b9c1dedf1aff9e$var$cache.has(storeState)) $55b9c1dedf1aff9e$var$cache.set(storeState, new WeakMap());
        const scopeSelectors = $55b9c1dedf1aff9e$var$cache.get(storeState);
        if (!scopeSelectors.has(selector)) scopeSelectors.set(selector, $55b9c1dedf1aff9e$export$d2c200d79fc82f8c(selector));
        return scopeSelectors.get(selector);
    }
    return $55b9c1dedf1aff9e$export$d2c200d79fc82f8c(selector);
}

});
parcelRegister("4MchI", function(module, exports) {
$parcel$export(module.exports, "createSelector", () => $814d68dc09e85a91$export$595d22ed68ca2841);

var $Y202J = parcelRequire("Y202J");
function $814d68dc09e85a91$export$595d22ed68ca2841(...funcs) {
    const resultFunc = funcs.pop();
    const dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;
    const memoizedResultFunc = (0, $Y202J.default)(function() {
        // eslint-disable-next-line prefer-spread, prefer-rest-params -- ERROR TO BE FIXED
        return resultFunc.apply(null, arguments);
    });
    // this memoisation is optimised for 2 arguments (state, props)
    const selector = (0, $Y202J.default)(function() {
        // calculate all dependencies results
        const params = [];
        for(let i = 0; i < dependencies.length; i++)// eslint-disable-next-line prefer-rest-params -- ERROR TO BE FIXED
        params.push(dependencies[i].apply(null, arguments));
        // then call the final func with all them as arguments
        // eslint-disable-next-line prefer-spread -- ERROR TO BE FIXED
        return memoizedResultFunc.apply(null, params);
    }, true);
    // expose so we can create per scope selectors
    // API compatible with reselect@^4
    selector.resultFunc = resultFunc;
    selector.dependencies = dependencies;
    return selector;
}

});
parcelRegister("Y202J", function(module, exports) {
$parcel$export(module.exports, "default", () => $5b032e5300d7197e$export$2e2bcd8739ae039);

var $bjd2g = parcelRequire("bjd2g");
function $5b032e5300d7197e$var$exactEqual(objA, objB) {
    return objA === objB;
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any -- PLEASE FIX THIS SUPPRESSION
function $5b032e5300d7197e$var$areArgumentsEqual(propsMode, prev, next) {
    if (prev === null || next === null || prev.length !== next.length) return false;
    // If propsMode and 2 arguments, means it is an input selector
    // and we check for shallow equality on 2nd one to optimise props
    if (propsMode && prev.length === 2) return prev[0] === next[0] && (0, $bjd2g.default)(prev[1], next[1]);
    for(let i = 0; i < prev.length; i++){
        if (!$5b032e5300d7197e$var$exactEqual(prev[i], next[i])) return false;
    }
    return true;
}
/**
 * Tailor made memoisation
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any -- PLEASE FIX THIS SUPPRESSION
const $5b032e5300d7197e$var$memoize = function(resultFn, propsMode = false) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- PLEASE FIX THIS SUPPRESSION
    let lastArgs = [];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- PLEASE FIX THIS SUPPRESSION
    let lastResult;
    let calledOnce = false;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- PLEASE FIX THIS SUPPRESSION
    const result = function() {
        // eslint-disable-next-line prefer-rest-params -- PLEASE FIX THIS SUPPRESSION
        if (calledOnce && $5b032e5300d7197e$var$areArgumentsEqual(propsMode, arguments, lastArgs)) return lastResult;
        // eslint-disable-next-line prefer-rest-params -- PLEASE FIX THIS SUPPRESSION
        const nextResult = resultFn.apply(this, arguments);
        if (!propsMode && (0, $bjd2g.default)(nextResult, lastResult)) return lastResult;
        lastResult = nextResult;
        calledOnce = true;
        // eslint-disable-next-line prefer-rest-params -- PLEASE FIX THIS SUPPRESSION
        lastArgs = arguments;
        return lastResult;
    };
    return result;
};
var $5b032e5300d7197e$export$2e2bcd8739ae039 = $5b032e5300d7197e$var$memoize;

});




parcelRegister("ht3nQ", function(module, exports) {
$parcel$export(module.exports, "createSubscriber", () => $02a17a4a0bfb4c05$export$48f338a7e080595c);
/* eslint-disable guard-for-in */ /* eslint-disable @typescript-eslint/no-explicit-any */ 
var $iJq0l = parcelRequire("iJq0l");
function $02a17a4a0bfb4c05$var$hasAdditionalProps(props) {
    for(const i in props)return true;
    return false;
}
function $02a17a4a0bfb4c05$export$48f338a7e080595c(Store, { selector: selector, displayName: displayName = '' } = {}) {
    const useStore = (0, $iJq0l.createHook)(Store, {
        selector: selector
    });
    const Subscriber = function({ children: children, ...rest }) {
        const api = useStore($02a17a4a0bfb4c05$var$hasAdditionalProps(rest) ? rest : undefined);
        return children(...api);
    };
    Subscriber.displayName = displayName || `Subscriber(${Store.key.split('__')[0]})`;
    return Subscriber;
}

});

parcelRegister("GtRbT", function(module, exports) {
$parcel$export(module.exports, "createStore", () => $3cdd6ae6fb7cec32$export$f51a9068ac82ea43);

var $4AiDO = parcelRequire("4AiDO");
function $3cdd6ae6fb7cec32$var$createKey(initialState, actions, name) {
    const src = !name ? Object.keys(actions).reduce((acc, k)=>acc + actions[k].toString(), '') : '';
    return [
        name,
        (0, $4AiDO.default)(src + JSON.stringify(initialState))
    ].filter(Boolean).join('__');
}
function $3cdd6ae6fb7cec32$export$f51a9068ac82ea43({ name: name = '', initialState: initialState, actions: actions, containedBy: containedBy, handlers: handlers = {}, behavior: behavior }) {
    let key;
    return {
        get key () {
            // lazy evaluate key on first access
            // eslint-disable-next-line no-return-assign,@typescript-eslint/no-explicit-any
            return key || (key = $3cdd6ae6fb7cec32$var$createKey(initialState, actions, name));
        },
        initialState: // @ts-expect-error TS2322: Type StateInitializer<TState> is not assignable to type TState
        initialState,
        actions: actions,
        containedBy: containedBy,
        handlers: handlers,
        behavior: behavior
    };
}

});
parcelRegister("4AiDO", function(module, exports) {
$parcel$export(module.exports, "default", () => $0b05e048b44f8497$export$2e2bcd8739ae039);
// murmurhash2 via https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
// eslint-disable-next-line camelcase -- ERROR TO BE FIXED
function $0b05e048b44f8497$export$2e2bcd8739ae039(str) {
    let l = str.length;
    // eslint-disable-next-line no-bitwise -- ERROR TO BE FIXED
    let h = l ^ l;
    let i = 0;
    let k;
    while(l >= 4){
        k = // eslint-disable-next-line no-bitwise -- ERROR TO BE FIXED
        str.charCodeAt(i) & 0xff | // eslint-disable-next-line no-bitwise -- ERROR TO BE FIXED
        (str.charCodeAt(++i) & 0xff) << 8 | // eslint-disable-next-line no-bitwise -- ERROR TO BE FIXED
        (str.charCodeAt(++i) & 0xff) << 16 | // eslint-disable-next-line no-bitwise -- ERROR TO BE FIXED
        (str.charCodeAt(++i) & 0xff) << 24;
        // eslint-disable-next-line no-bitwise -- ERROR TO BE FIXED
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        // eslint-disable-next-line no-bitwise -- ERROR TO BE FIXED
        k ^= k >>> 24;
        // eslint-disable-next-line no-bitwise -- ERROR TO BE FIXED
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        // eslint-disable-next-line no-bitwise -- ERROR TO BE FIXED
        h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;
        l -= 4;
        ++i;
    }
    // eslint-disable-next-line default-case -- ERROR TO BE FIXED
    switch(l){
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment -- ERROR TO BE FIXED
        // @ts-ignore match original source
        case 3:
            // eslint-disable-next-line no-bitwise -- ERROR TO BE FIXED
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment -- ERROR TO BE FIXED
        // @ts-ignore match original source
        // eslint-disable-next-line no-fallthrough -- ERROR TO BE FIXED
        case 2:
            // eslint-disable-next-line no-bitwise -- ERROR TO BE FIXED
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        // eslint-disable-next-line no-fallthrough -- ERROR TO BE FIXED
        case 1:
            // eslint-disable-next-line no-bitwise -- ERROR TO BE FIXED
            h ^= str.charCodeAt(i) & 0xff;
            // eslint-disable-next-line no-bitwise -- ERROR TO BE FIXED
            h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    }
    // eslint-disable-next-line no-bitwise -- ERROR TO BE FIXED
    h ^= h >>> 13;
    // eslint-disable-next-line no-bitwise -- ERROR TO BE FIXED
    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    // eslint-disable-next-line no-bitwise -- ERROR TO BE FIXED
    h ^= h >>> 15;
    // eslint-disable-next-line no-bitwise -- ERROR TO BE FIXED
    return (h >>> 0).toString(36);
}

});


parcelRegister("5G60L", function(module, exports) {
$parcel$export(module.exports, "initAnalyticsWebClient", () => $62d98a33d04b8944$export$bb0df2ec3a6c8120);
$parcel$export(module.exports, "getAnalyticsWebClient", () => $62d98a33d04b8944$export$e9ba7ef9458d1a4a);

var $1kFb3 = parcelRequire("1kFb3");

var $2Mqjh = parcelRequire("2Mqjh");

var $4cTDP = parcelRequire("4cTDP");

var $dkyQc = parcelRequire("dkyQc");

var $7PLBZ = parcelRequire("7PLBZ");
const $62d98a33d04b8944$export$bb0df2ec3a6c8120 = (attrs)=>{
    let internalClientInitialised;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (!window.analyticsWebClient) try {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.analyticsWebClient = false ? (0, $7PLBZ.default) : new (0, $dkyQc.default)();
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        internalClientInitialised = window.analyticsWebClient.init(attrs);
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.analyticsWebClient.setOriginTracingHandlers({
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-expect-error
            atlOrigin: (encodedOrigin)=>{
                const origin = (0, $1kFb3.default).fromEncoded(encodedOrigin);
                const attributes = origin.toAnalyticsAttributes();
                return {
                    originTracingAttributes: {
                        id: 'originId' in attributes ? attributes.originId : undefined,
                        product: 'originProduct' in attributes ? attributes.originProduct : undefined,
                        library: attributes.originLibrary
                    },
                    taskSessionId: origin.id ?? undefined
                };
            }
        });
    } catch (err) {
        if (typeof window !== 'undefined' && (0, $4cTDP.fg)('jfp-magma-report-error-when-init-analytics')) window.reportError(new Error('Failed to initialize analytics client', {
            cause: err
        }));
    }
    else // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    internalClientInitialised = !!window.analyticsWebClient.getInstance();
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion, jira/jira-ssr/no-unchecked-globals-usage
    (0, $2Mqjh.resolveAnalyticsWebClientPromise)(window.analyticsWebClient);
    return internalClientInitialised;
};
const $62d98a33d04b8944$export$e9ba7ef9458d1a4a = ()=>window.analyticsWebClient;

});
parcelRegister("dkyQc", function(module, exports) {
$parcel$export(module.exports, "default", () => $85d2378021ba91ca$export$2e2bcd8739ae039);

var $12DRg = parcelRequire("12DRg");

var $kjcdO = parcelRequire("kjcdO");
var $6g1o6 = parcelRequire("6g1o6");
var $78ewy = parcelRequire("78ewy");

var $bSAWv = parcelRequire("bSAWv");


var $7vlU3 = parcelRequire("7vlU3");
class $85d2378021ba91ca$export$2e2bcd8739ae039 {
    resetBlockingDuration() {
        this.eventCount = 0;
        this.blockingDuration = 0;
    }
    init({ tenantId: tenantId, userId: userId, subProduct: subProduct, embeddedProduct: embeddedProduct, product: product, environment: environment, locale: locale, callback: callback, shouldTriggerUIViewed: shouldTriggerUIViewed = true, solutions: solutions, theme: theme, orgId: orgId, workspaceId: workspaceId }) {
        const start = performance.now();
        this.analyticsClient = new (0, $6g1o6.default)({
            env: environment || (0, $78ewy.envType).DEV,
            product: product,
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            version: window.BUILD_KEY || 'unknown',
            origin: (0, $78ewy.originType).WEB,
            locale: locale
        }, {
            useStargate: true,
            delayQueueCompressors: [
                new (0, $kjcdO.CompressionRule)((0, $bSAWv.canCompress), (0, $bSAWv.buildCompressionFunction)(50))
            ],
            ...globalThis.localDevContext?.PILLAR_LOCAL_DEVELOPMENT ?? false ? {
                apiHostProtocol: globalThis.localDevContext?.__PILLAR_ENABLE_HTTPS ?? false ? 'https' : 'http'
            } : {},
            onNewSessionStarted: this.onNewSessionStarted
        });
        if (!this.analyticsClient) return false;
        if (tenantId) this.analyticsClient.setTenantInfo((0, $78ewy.tenantType).CLOUD_ID, tenantId);
        if (userId) this.analyticsClient.setUserInfo((0, $78ewy.userType).ATLASSIAN_ACCOUNT, userId);
        if (subProduct) this.analyticsClient.setSubproduct(subProduct);
        if (orgId) this.analyticsClient.setOrgInfo(orgId);
        if (workspaceId) this.analyticsClient.setWorkspaceInfo(workspaceId);
        this.clearUIViewedAttributes();
        if (solutions || theme) {
            const OStheme = // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window && window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
            this.setUIViewedAttributes({
                ...solutions && {
                    solutions: solutions
                },
                ...theme && {
                    theme: theme,
                    OStheme: OStheme
                }
            });
        }
        if (embeddedProduct) this.analyticsClient.setEmbeddedProduct(embeddedProduct);
        if (shouldTriggerUIViewed) {
            const callbackFn = typeof callback === 'function' ? callback : (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)));
            this.analyticsClient.startUIViewedEvent(callbackFn);
        }
        // Set init time
        this.initTime = performance.now() - start;
        return true;
    }
    sendEvent(event) {
        if ((0, $7vlU3.isAnalyticsEvent)(event)) {
            const { type: type, payload: payload } = event;
            const start = performance.now();
            if (this.amplitudeSRAttributesInjector) this.amplitudeSRAttributesInjector(payload);
            switch(type){
                case 0, $aa42ce8e355d58fa$export$a1562d08625f5d7e:
                    this.analyticsClient.sendUIEvent(payload);
                    break;
                case 0, $aa42ce8e355d58fa$export$947dac6c72b26f81:
                    this.analyticsClient.sendTrackEvent(payload);
                    break;
                case 0, $aa42ce8e355d58fa$export$12346a674644c156:
                    this.analyticsClient.sendOperationalEvent(payload);
                    break;
                case 0, $aa42ce8e355d58fa$export$f1d537d508d2945a:
                    this.analyticsClient.sendScreenEvent(payload);
                    break;
                default:
                    break;
            }
            // Increment the blocking duration
            this.blockingDuration += performance.now() - start;
            this.eventCount += 1;
        }
    }
    isInitialized() {
        return this.analyticsClient && this.initTime > 0;
    }
    getInstance() {
        return this.analyticsClient;
    }
    setSubProduct(subProduct) {
        this.analyticsClient.setSubproduct(subProduct);
    }
    setUIViewedAttributes(attributes) {
        this.analyticsClient.setUIViewedAttributes({
            ...this.analyticsClient.getUIViewedAttributes(),
            ...attributes
        });
    }
    setEmbeddedProduct(embeddedProduct) {
        this.analyticsClient.setEmbeddedProduct(embeddedProduct);
    }
    removeUIViewedAttribute(key) {
        const { [key]: value, ...rest } = this.analyticsClient.getUIViewedAttributes();
        this.analyticsClient.setUIViewedAttributes({
            ...rest
        });
    }
    clearUIViewedAttributes() {
        this.analyticsClient.clearUIViewedAttributes();
    }
    clearEmbeddedProduct() {
        this.analyticsClient.clearEmbeddedProduct();
    }
    stopApdexEvent(payload) {
        this.analyticsClient.stopApdexEvent(payload);
    }
    setOriginTracingHandlers(originTracingHandlerMapping) {
        this.analyticsClient.setOriginTracingHandlers(originTracingHandlerMapping);
    }
    onNewSessionStarted() {
        this.updateAmplitudeSRClient && this.updateAmplitudeSRClient();
    }
    setUpdateAmplitudeSRClient(callbackFn) {
        this.updateAmplitudeSRClient = callbackFn;
    }
    setAmplitudeSRAttributesInjector(callbackFn) {
        this.amplitudeSRAttributesInjector = callbackFn;
    }
}

});
parcelRegister("7vlU3", function(module, exports) {
$parcel$export(module.exports, "isAnalyticsEvent", () => $85b23c61e8135151$export$ad4be5c2ec28cecf);
const $85b23c61e8135151$export$2bace62c90203a60 = [
    'SCREEN',
    'UI',
    'TRACK',
    'OPERATIONAL'
];
const $85b23c61e8135151$export$ad4be5c2ec28cecf = (value)=>typeof value === 'object' && value !== null && 'type' in value && typeof value.type === 'string' && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    $85b23c61e8135151$export$2bace62c90203a60.includes(value.type);

});


parcelRegister("7PLBZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $c73b56737c236c6d$export$2e2bcd8739ae039);

var $12DRg = parcelRequire("12DRg");
const $c73b56737c236c6d$var$SSRAnalyticsWebClient = {
    initTime: 0,
    eventCount: 0,
    blockingDuration: 0,
    amplitudeSRAttributesInjector: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
    updateAmplitudeSRClient: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
    resetBlockingDuration: ()=>undefined,
    init: (attrs)=>!!attrs,
    sendEvent: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
    // @ts-expect-error - TS2741 - Property 'prototype' is missing in type '{}' but required in type 'AnalyticsWebClient'.
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    getInstance: ()=>new Proxy({}, {
            get: ()=>()=>{}
        }),
    setSubProduct: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
    setUIViewedAttributes: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
    removeUIViewedAttribute: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
    setEmbeddedProduct: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
    clearUIViewedAttributes: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
    clearEmbeddedProduct: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
    stopApdexEvent: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
    setOriginTracingHandlers: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
    onNewSessionStarted: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
    setUpdateAmplitudeSRClient: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
    setAmplitudeSRAttributesInjector: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
    isInitialized: ()=>false
};
var $c73b56737c236c6d$export$2e2bcd8739ae039 = $c73b56737c236c6d$var$SSRAnalyticsWebClient;

});


parcelRegister("5Ovjr", function(module, exports) {
$parcel$export(module.exports, "Buffer", () => $43b9e9491693ed0a$export$a143d493d941bafc, (v) => $43b9e9491693ed0a$export$a143d493d941bafc = v);
$parcel$export(module.exports, "SlowBuffer", () => $43b9e9491693ed0a$export$e4cf37d7f6fb9e0a, (v) => $43b9e9491693ed0a$export$e4cf37d7f6fb9e0a = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $43b9e9491693ed0a$export$f99ded8fe4b79145, (v) => $43b9e9491693ed0a$export$f99ded8fe4b79145 = v);
$parcel$export(module.exports, "kMaxLength", () => $43b9e9491693ed0a$export$599f31c3813fae4d, (v) => $43b9e9491693ed0a$export$599f31c3813fae4d = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $43b9e9491693ed0a$export$a143d493d941bafc;
var $43b9e9491693ed0a$export$e4cf37d7f6fb9e0a;
var $43b9e9491693ed0a$export$f99ded8fe4b79145;
var $43b9e9491693ed0a$export$599f31c3813fae4d;
'use strict';

var $jO8QN = parcelRequire("jO8QN");

var $1guYm = parcelRequire("1guYm");
const $43b9e9491693ed0a$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$43b9e9491693ed0a$export$a143d493d941bafc = $43b9e9491693ed0a$var$Buffer;
$43b9e9491693ed0a$export$e4cf37d7f6fb9e0a = $43b9e9491693ed0a$var$SlowBuffer;
$43b9e9491693ed0a$export$f99ded8fe4b79145 = 50;
const $43b9e9491693ed0a$var$K_MAX_LENGTH = 0x7fffffff;
$43b9e9491693ed0a$export$599f31c3813fae4d = $43b9e9491693ed0a$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $43b9e9491693ed0a$var$Buffer.TYPED_ARRAY_SUPPORT = $43b9e9491693ed0a$var$typedArraySupport();
if (!$43b9e9491693ed0a$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $43b9e9491693ed0a$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($43b9e9491693ed0a$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$43b9e9491693ed0a$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($43b9e9491693ed0a$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$43b9e9491693ed0a$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $43b9e9491693ed0a$var$createBuffer(length) {
    if (length > $43b9e9491693ed0a$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $43b9e9491693ed0a$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $43b9e9491693ed0a$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $43b9e9491693ed0a$var$allocUnsafe(arg);
    }
    return $43b9e9491693ed0a$var$from(arg, encodingOrOffset, length);
}
$43b9e9491693ed0a$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $43b9e9491693ed0a$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $43b9e9491693ed0a$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $43b9e9491693ed0a$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($43b9e9491693ed0a$var$isInstance(value, ArrayBuffer) || value && $43b9e9491693ed0a$var$isInstance(value.buffer, ArrayBuffer)) return $43b9e9491693ed0a$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($43b9e9491693ed0a$var$isInstance(value, SharedArrayBuffer) || value && $43b9e9491693ed0a$var$isInstance(value.buffer, SharedArrayBuffer))) return $43b9e9491693ed0a$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $43b9e9491693ed0a$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $43b9e9491693ed0a$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $43b9e9491693ed0a$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $43b9e9491693ed0a$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $43b9e9491693ed0a$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($43b9e9491693ed0a$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($43b9e9491693ed0a$var$Buffer, Uint8Array);
function $43b9e9491693ed0a$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $43b9e9491693ed0a$var$alloc(size, fill, encoding) {
    $43b9e9491693ed0a$var$assertSize(size);
    if (size <= 0) return $43b9e9491693ed0a$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $43b9e9491693ed0a$var$createBuffer(size).fill(fill, encoding) : $43b9e9491693ed0a$var$createBuffer(size).fill(fill);
    return $43b9e9491693ed0a$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $43b9e9491693ed0a$var$Buffer.alloc = function(size, fill, encoding) {
    return $43b9e9491693ed0a$var$alloc(size, fill, encoding);
};
function $43b9e9491693ed0a$var$allocUnsafe(size) {
    $43b9e9491693ed0a$var$assertSize(size);
    return $43b9e9491693ed0a$var$createBuffer(size < 0 ? 0 : $43b9e9491693ed0a$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $43b9e9491693ed0a$var$Buffer.allocUnsafe = function(size) {
    return $43b9e9491693ed0a$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $43b9e9491693ed0a$var$Buffer.allocUnsafeSlow = function(size) {
    return $43b9e9491693ed0a$var$allocUnsafe(size);
};
function $43b9e9491693ed0a$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$43b9e9491693ed0a$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $43b9e9491693ed0a$var$byteLength(string, encoding) | 0;
    let buf = $43b9e9491693ed0a$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $43b9e9491693ed0a$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $43b9e9491693ed0a$var$checked(array.length) | 0;
    const buf = $43b9e9491693ed0a$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $43b9e9491693ed0a$var$fromArrayView(arrayView) {
    if ($43b9e9491693ed0a$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $43b9e9491693ed0a$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $43b9e9491693ed0a$var$fromArrayLike(arrayView);
}
function $43b9e9491693ed0a$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $43b9e9491693ed0a$var$Buffer.prototype);
    return buf;
}
function $43b9e9491693ed0a$var$fromObject(obj) {
    if ($43b9e9491693ed0a$var$Buffer.isBuffer(obj)) {
        const len = $43b9e9491693ed0a$var$checked(obj.length) | 0;
        const buf = $43b9e9491693ed0a$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $43b9e9491693ed0a$var$numberIsNaN(obj.length)) return $43b9e9491693ed0a$var$createBuffer(0);
        return $43b9e9491693ed0a$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $43b9e9491693ed0a$var$fromArrayLike(obj.data);
}
function $43b9e9491693ed0a$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $43b9e9491693ed0a$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $43b9e9491693ed0a$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $43b9e9491693ed0a$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $43b9e9491693ed0a$var$Buffer.alloc(+length);
}
$43b9e9491693ed0a$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $43b9e9491693ed0a$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$43b9e9491693ed0a$var$Buffer.compare = function compare(a, b) {
    if ($43b9e9491693ed0a$var$isInstance(a, Uint8Array)) a = $43b9e9491693ed0a$var$Buffer.from(a, a.offset, a.byteLength);
    if ($43b9e9491693ed0a$var$isInstance(b, Uint8Array)) b = $43b9e9491693ed0a$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$43b9e9491693ed0a$var$Buffer.isBuffer(a) || !$43b9e9491693ed0a$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$43b9e9491693ed0a$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$43b9e9491693ed0a$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $43b9e9491693ed0a$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $43b9e9491693ed0a$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($43b9e9491693ed0a$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$43b9e9491693ed0a$var$Buffer.isBuffer(buf)) buf = $43b9e9491693ed0a$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$43b9e9491693ed0a$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $43b9e9491693ed0a$var$byteLength(string, encoding) {
    if ($43b9e9491693ed0a$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $43b9e9491693ed0a$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $43b9e9491693ed0a$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $43b9e9491693ed0a$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $43b9e9491693ed0a$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$43b9e9491693ed0a$var$Buffer.byteLength = $43b9e9491693ed0a$var$byteLength;
function $43b9e9491693ed0a$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $43b9e9491693ed0a$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $43b9e9491693ed0a$var$utf8Slice(this, start, end);
        case 'ascii':
            return $43b9e9491693ed0a$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $43b9e9491693ed0a$var$latin1Slice(this, start, end);
        case 'base64':
            return $43b9e9491693ed0a$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $43b9e9491693ed0a$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$43b9e9491693ed0a$var$Buffer.prototype._isBuffer = true;
function $43b9e9491693ed0a$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$43b9e9491693ed0a$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$43b9e9491693ed0a$var$swap(this, i, i + 1);
    return this;
};
$43b9e9491693ed0a$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $43b9e9491693ed0a$var$swap(this, i, i + 3);
        $43b9e9491693ed0a$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$43b9e9491693ed0a$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $43b9e9491693ed0a$var$swap(this, i, i + 7);
        $43b9e9491693ed0a$var$swap(this, i + 1, i + 6);
        $43b9e9491693ed0a$var$swap(this, i + 2, i + 5);
        $43b9e9491693ed0a$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$43b9e9491693ed0a$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $43b9e9491693ed0a$var$utf8Slice(this, 0, length);
    return $43b9e9491693ed0a$var$slowToString.apply(this, arguments);
};
$43b9e9491693ed0a$var$Buffer.prototype.toLocaleString = $43b9e9491693ed0a$var$Buffer.prototype.toString;
$43b9e9491693ed0a$var$Buffer.prototype.equals = function equals(b) {
    if (!$43b9e9491693ed0a$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $43b9e9491693ed0a$var$Buffer.compare(this, b) === 0;
};
$43b9e9491693ed0a$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $43b9e9491693ed0a$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($43b9e9491693ed0a$var$customInspectSymbol) $43b9e9491693ed0a$var$Buffer.prototype[$43b9e9491693ed0a$var$customInspectSymbol] = $43b9e9491693ed0a$var$Buffer.prototype.inspect;
$43b9e9491693ed0a$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($43b9e9491693ed0a$var$isInstance(target, Uint8Array)) target = $43b9e9491693ed0a$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$43b9e9491693ed0a$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $43b9e9491693ed0a$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($43b9e9491693ed0a$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $43b9e9491693ed0a$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($43b9e9491693ed0a$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $43b9e9491693ed0a$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $43b9e9491693ed0a$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $43b9e9491693ed0a$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$43b9e9491693ed0a$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$43b9e9491693ed0a$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $43b9e9491693ed0a$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$43b9e9491693ed0a$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $43b9e9491693ed0a$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $43b9e9491693ed0a$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($43b9e9491693ed0a$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $43b9e9491693ed0a$var$utf8Write(buf, string, offset, length) {
    return $43b9e9491693ed0a$var$blitBuffer($43b9e9491693ed0a$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $43b9e9491693ed0a$var$asciiWrite(buf, string, offset, length) {
    return $43b9e9491693ed0a$var$blitBuffer($43b9e9491693ed0a$var$asciiToBytes(string), buf, offset, length);
}
function $43b9e9491693ed0a$var$base64Write(buf, string, offset, length) {
    return $43b9e9491693ed0a$var$blitBuffer($43b9e9491693ed0a$var$base64ToBytes(string), buf, offset, length);
}
function $43b9e9491693ed0a$var$ucs2Write(buf, string, offset, length) {
    return $43b9e9491693ed0a$var$blitBuffer($43b9e9491693ed0a$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$43b9e9491693ed0a$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $43b9e9491693ed0a$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $43b9e9491693ed0a$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $43b9e9491693ed0a$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $43b9e9491693ed0a$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $43b9e9491693ed0a$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$43b9e9491693ed0a$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $43b9e9491693ed0a$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $jO8QN.fromByteArray(buf);
    else return $jO8QN.fromByteArray(buf.slice(start, end));
}
function $43b9e9491693ed0a$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $43b9e9491693ed0a$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $43b9e9491693ed0a$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $43b9e9491693ed0a$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $43b9e9491693ed0a$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $43b9e9491693ed0a$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $43b9e9491693ed0a$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $43b9e9491693ed0a$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $43b9e9491693ed0a$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $43b9e9491693ed0a$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $43b9e9491693ed0a$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$43b9e9491693ed0a$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $43b9e9491693ed0a$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $43b9e9491693ed0a$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$43b9e9491693ed0a$var$Buffer.prototype.readUintLE = $43b9e9491693ed0a$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $43b9e9491693ed0a$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$43b9e9491693ed0a$var$Buffer.prototype.readUintBE = $43b9e9491693ed0a$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $43b9e9491693ed0a$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$43b9e9491693ed0a$var$Buffer.prototype.readUint8 = $43b9e9491693ed0a$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $43b9e9491693ed0a$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$43b9e9491693ed0a$var$Buffer.prototype.readUint16LE = $43b9e9491693ed0a$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $43b9e9491693ed0a$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$43b9e9491693ed0a$var$Buffer.prototype.readUint16BE = $43b9e9491693ed0a$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $43b9e9491693ed0a$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$43b9e9491693ed0a$var$Buffer.prototype.readUint32LE = $43b9e9491693ed0a$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $43b9e9491693ed0a$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$43b9e9491693ed0a$var$Buffer.prototype.readUint32BE = $43b9e9491693ed0a$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $43b9e9491693ed0a$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$43b9e9491693ed0a$var$Buffer.prototype.readBigUInt64LE = $43b9e9491693ed0a$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $43b9e9491693ed0a$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $43b9e9491693ed0a$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$43b9e9491693ed0a$var$Buffer.prototype.readBigUInt64BE = $43b9e9491693ed0a$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $43b9e9491693ed0a$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $43b9e9491693ed0a$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$43b9e9491693ed0a$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $43b9e9491693ed0a$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$43b9e9491693ed0a$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $43b9e9491693ed0a$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$43b9e9491693ed0a$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $43b9e9491693ed0a$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$43b9e9491693ed0a$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $43b9e9491693ed0a$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$43b9e9491693ed0a$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $43b9e9491693ed0a$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$43b9e9491693ed0a$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $43b9e9491693ed0a$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$43b9e9491693ed0a$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $43b9e9491693ed0a$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$43b9e9491693ed0a$var$Buffer.prototype.readBigInt64LE = $43b9e9491693ed0a$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $43b9e9491693ed0a$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $43b9e9491693ed0a$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$43b9e9491693ed0a$var$Buffer.prototype.readBigInt64BE = $43b9e9491693ed0a$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $43b9e9491693ed0a$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $43b9e9491693ed0a$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$43b9e9491693ed0a$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $43b9e9491693ed0a$var$checkOffset(offset, 4, this.length);
    return $1guYm.read(this, offset, true, 23, 4);
};
$43b9e9491693ed0a$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $43b9e9491693ed0a$var$checkOffset(offset, 4, this.length);
    return $1guYm.read(this, offset, false, 23, 4);
};
$43b9e9491693ed0a$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $43b9e9491693ed0a$var$checkOffset(offset, 8, this.length);
    return $1guYm.read(this, offset, true, 52, 8);
};
$43b9e9491693ed0a$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $43b9e9491693ed0a$var$checkOffset(offset, 8, this.length);
    return $1guYm.read(this, offset, false, 52, 8);
};
function $43b9e9491693ed0a$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$43b9e9491693ed0a$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$43b9e9491693ed0a$var$Buffer.prototype.writeUintLE = $43b9e9491693ed0a$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $43b9e9491693ed0a$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$43b9e9491693ed0a$var$Buffer.prototype.writeUintBE = $43b9e9491693ed0a$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $43b9e9491693ed0a$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$43b9e9491693ed0a$var$Buffer.prototype.writeUint8 = $43b9e9491693ed0a$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $43b9e9491693ed0a$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$43b9e9491693ed0a$var$Buffer.prototype.writeUint16LE = $43b9e9491693ed0a$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $43b9e9491693ed0a$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$43b9e9491693ed0a$var$Buffer.prototype.writeUint16BE = $43b9e9491693ed0a$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $43b9e9491693ed0a$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$43b9e9491693ed0a$var$Buffer.prototype.writeUint32LE = $43b9e9491693ed0a$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $43b9e9491693ed0a$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$43b9e9491693ed0a$var$Buffer.prototype.writeUint32BE = $43b9e9491693ed0a$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $43b9e9491693ed0a$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $43b9e9491693ed0a$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $43b9e9491693ed0a$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $43b9e9491693ed0a$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $43b9e9491693ed0a$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$43b9e9491693ed0a$var$Buffer.prototype.writeBigUInt64LE = $43b9e9491693ed0a$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $43b9e9491693ed0a$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$43b9e9491693ed0a$var$Buffer.prototype.writeBigUInt64BE = $43b9e9491693ed0a$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $43b9e9491693ed0a$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$43b9e9491693ed0a$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $43b9e9491693ed0a$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$43b9e9491693ed0a$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $43b9e9491693ed0a$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$43b9e9491693ed0a$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $43b9e9491693ed0a$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$43b9e9491693ed0a$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $43b9e9491693ed0a$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$43b9e9491693ed0a$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $43b9e9491693ed0a$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$43b9e9491693ed0a$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $43b9e9491693ed0a$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$43b9e9491693ed0a$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $43b9e9491693ed0a$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$43b9e9491693ed0a$var$Buffer.prototype.writeBigInt64LE = $43b9e9491693ed0a$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $43b9e9491693ed0a$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$43b9e9491693ed0a$var$Buffer.prototype.writeBigInt64BE = $43b9e9491693ed0a$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $43b9e9491693ed0a$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $43b9e9491693ed0a$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $43b9e9491693ed0a$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $43b9e9491693ed0a$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $1guYm.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$43b9e9491693ed0a$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $43b9e9491693ed0a$var$writeFloat(this, value, offset, true, noAssert);
};
$43b9e9491693ed0a$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $43b9e9491693ed0a$var$writeFloat(this, value, offset, false, noAssert);
};
function $43b9e9491693ed0a$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $43b9e9491693ed0a$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $1guYm.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$43b9e9491693ed0a$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $43b9e9491693ed0a$var$writeDouble(this, value, offset, true, noAssert);
};
$43b9e9491693ed0a$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $43b9e9491693ed0a$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$43b9e9491693ed0a$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$43b9e9491693ed0a$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$43b9e9491693ed0a$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$43b9e9491693ed0a$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $43b9e9491693ed0a$var$Buffer.isBuffer(val) ? val : $43b9e9491693ed0a$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $43b9e9491693ed0a$var$errors = {};
function $43b9e9491693ed0a$var$E(sym, getMessage, Base) {
    $43b9e9491693ed0a$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$43b9e9491693ed0a$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$43b9e9491693ed0a$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$43b9e9491693ed0a$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $43b9e9491693ed0a$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $43b9e9491693ed0a$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $43b9e9491693ed0a$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $43b9e9491693ed0a$var$checkBounds(buf, offset, byteLength) {
    $43b9e9491693ed0a$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $43b9e9491693ed0a$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $43b9e9491693ed0a$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $43b9e9491693ed0a$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $43b9e9491693ed0a$var$checkBounds(buf, offset, byteLength);
}
function $43b9e9491693ed0a$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $43b9e9491693ed0a$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $43b9e9491693ed0a$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $43b9e9491693ed0a$var$validateNumber(value, type);
        throw new $43b9e9491693ed0a$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $43b9e9491693ed0a$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $43b9e9491693ed0a$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $43b9e9491693ed0a$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $43b9e9491693ed0a$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($43b9e9491693ed0a$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $43b9e9491693ed0a$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $43b9e9491693ed0a$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $43b9e9491693ed0a$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $43b9e9491693ed0a$var$base64ToBytes(str) {
    return $jO8QN.toByteArray($43b9e9491693ed0a$var$base64clean(str));
}
function $43b9e9491693ed0a$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $43b9e9491693ed0a$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $43b9e9491693ed0a$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $43b9e9491693ed0a$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $43b9e9491693ed0a$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $43b9e9491693ed0a$var$BufferBigIntNotDefined : fn;
}
function $43b9e9491693ed0a$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});
parcelRegister("jO8QN", function(module, exports) {
$parcel$export(module.exports, "toByteArray", () => $e6b98d613ccd78db$export$d622b2ad8d90c771, (v) => $e6b98d613ccd78db$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $e6b98d613ccd78db$export$6100ba28696e12de, (v) => $e6b98d613ccd78db$export$6100ba28696e12de = v);
var $e6b98d613ccd78db$export$a48f0734ac7c2329;
var $e6b98d613ccd78db$export$d622b2ad8d90c771;
var $e6b98d613ccd78db$export$6100ba28696e12de;
'use strict';
$e6b98d613ccd78db$export$a48f0734ac7c2329 = $e6b98d613ccd78db$var$byteLength;
$e6b98d613ccd78db$export$d622b2ad8d90c771 = $e6b98d613ccd78db$var$toByteArray;
$e6b98d613ccd78db$export$6100ba28696e12de = $e6b98d613ccd78db$var$fromByteArray;
var $e6b98d613ccd78db$var$lookup = [];
var $e6b98d613ccd78db$var$revLookup = [];
var $e6b98d613ccd78db$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $e6b98d613ccd78db$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $e6b98d613ccd78db$var$i = 0, $e6b98d613ccd78db$var$len = $e6b98d613ccd78db$var$code.length; $e6b98d613ccd78db$var$i < $e6b98d613ccd78db$var$len; ++$e6b98d613ccd78db$var$i){
    $e6b98d613ccd78db$var$lookup[$e6b98d613ccd78db$var$i] = $e6b98d613ccd78db$var$code[$e6b98d613ccd78db$var$i];
    $e6b98d613ccd78db$var$revLookup[$e6b98d613ccd78db$var$code.charCodeAt($e6b98d613ccd78db$var$i)] = $e6b98d613ccd78db$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$e6b98d613ccd78db$var$revLookup['-'.charCodeAt(0)] = 62;
$e6b98d613ccd78db$var$revLookup['_'.charCodeAt(0)] = 63;
function $e6b98d613ccd78db$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $e6b98d613ccd78db$var$byteLength(b64) {
    var lens = $e6b98d613ccd78db$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $e6b98d613ccd78db$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $e6b98d613ccd78db$var$toByteArray(b64) {
    var tmp;
    var lens = $e6b98d613ccd78db$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $e6b98d613ccd78db$var$Arr($e6b98d613ccd78db$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $e6b98d613ccd78db$var$revLookup[b64.charCodeAt(i)] << 18 | $e6b98d613ccd78db$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $e6b98d613ccd78db$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $e6b98d613ccd78db$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $e6b98d613ccd78db$var$revLookup[b64.charCodeAt(i)] << 2 | $e6b98d613ccd78db$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $e6b98d613ccd78db$var$revLookup[b64.charCodeAt(i)] << 10 | $e6b98d613ccd78db$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $e6b98d613ccd78db$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $e6b98d613ccd78db$var$tripletToBase64(num) {
    return $e6b98d613ccd78db$var$lookup[num >> 18 & 0x3F] + $e6b98d613ccd78db$var$lookup[num >> 12 & 0x3F] + $e6b98d613ccd78db$var$lookup[num >> 6 & 0x3F] + $e6b98d613ccd78db$var$lookup[num & 0x3F];
}
function $e6b98d613ccd78db$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($e6b98d613ccd78db$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $e6b98d613ccd78db$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($e6b98d613ccd78db$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($e6b98d613ccd78db$var$lookup[tmp >> 2] + $e6b98d613ccd78db$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($e6b98d613ccd78db$var$lookup[tmp >> 10] + $e6b98d613ccd78db$var$lookup[tmp >> 4 & 0x3F] + $e6b98d613ccd78db$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

});

parcelRegister("1guYm", function(module, exports) {
$parcel$export(module.exports, "read", () => $0ebf4f93c80a75c9$export$aafa59e2e03f2942, (v) => $0ebf4f93c80a75c9$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $0ebf4f93c80a75c9$export$68d8715fc104d294, (v) => $0ebf4f93c80a75c9$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $0ebf4f93c80a75c9$export$aafa59e2e03f2942;
var $0ebf4f93c80a75c9$export$68d8715fc104d294;
$0ebf4f93c80a75c9$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$0ebf4f93c80a75c9$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});


parcelRegister("32Uwr", function(module, exports) {
'use strict';

var $5BEiv = parcelRequire("5BEiv");

var $3Zdci = parcelRequire("3Zdci");

var $840D7 = parcelRequire("840D7");
module.exports = {
    formats: $840D7,
    parse: $3Zdci,
    stringify: $5BEiv
};

});
parcelRegister("5BEiv", function(module, exports) {
'use strict';

var $6siLO = parcelRequire("6siLO");

var $8lLMe = parcelRequire("8lLMe");

var $840D7 = parcelRequire("840D7");
var $414faaac2f2763fe$var$has = Object.prototype.hasOwnProperty;
var $414faaac2f2763fe$var$arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + '[]';
    },
    comma: 'comma',
    indices: function indices(prefix, key) {
        return prefix + '[' + key + ']';
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};
var $414faaac2f2763fe$var$isArray = Array.isArray;
var $414faaac2f2763fe$var$push = Array.prototype.push;
var $414faaac2f2763fe$var$pushToArray = function(arr, valueOrArray) {
    $414faaac2f2763fe$var$push.apply(arr, $414faaac2f2763fe$var$isArray(valueOrArray) ? valueOrArray : [
        valueOrArray
    ]);
};
var $414faaac2f2763fe$var$toISO = Date.prototype.toISOString;
var $414faaac2f2763fe$var$defaultFormat = $840D7.default;
var $414faaac2f2763fe$var$defaults = {
    addQueryPrefix: false,
    allowDots: false,
    charset: 'utf-8',
    charsetSentinel: false,
    delimiter: '&',
    encode: true,
    encoder: $8lLMe.encode,
    encodeValuesOnly: false,
    format: $414faaac2f2763fe$var$defaultFormat,
    formatter: $840D7.formatters[$414faaac2f2763fe$var$defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return $414faaac2f2763fe$var$toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};
var $414faaac2f2763fe$var$isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === 'string' || typeof v === 'number' || typeof v === 'boolean' || typeof v === 'symbol' || typeof v === 'bigint';
};
var $414faaac2f2763fe$var$sentinel = {};
var $414faaac2f2763fe$var$stringify = function stringify(object, prefix, generateArrayPrefix, commaRoundTrip, strictNullHandling, skipNulls, encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, sideChannel) {
    var obj = object;
    var tmpSc = sideChannel;
    var step = 0;
    var findFlag = false;
    while((tmpSc = tmpSc.get($414faaac2f2763fe$var$sentinel)) !== void 0 && !findFlag){
        // Where object last appeared in the ref tree
        var pos = tmpSc.get(object);
        step += 1;
        if (typeof pos !== 'undefined') {
            if (pos === step) throw new RangeError('Cyclic object value');
            else findFlag = true; // Break while
        }
        if (typeof tmpSc.get($414faaac2f2763fe$var$sentinel) === 'undefined') step = 0;
    }
    if (typeof filter === 'function') obj = filter(prefix, obj);
    else if (obj instanceof Date) obj = serializeDate(obj);
    else if (generateArrayPrefix === 'comma' && $414faaac2f2763fe$var$isArray(obj)) obj = $8lLMe.maybeMap(obj, function(value) {
        if (value instanceof Date) return serializeDate(value);
        return value;
    });
    if (obj === null) {
        if (strictNullHandling) return encoder && !encodeValuesOnly ? encoder(prefix, $414faaac2f2763fe$var$defaults.encoder, charset, 'key', format) : prefix;
        obj = '';
    }
    if ($414faaac2f2763fe$var$isNonNullishPrimitive(obj) || $8lLMe.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, $414faaac2f2763fe$var$defaults.encoder, charset, 'key', format);
            return [
                formatter(keyValue) + '=' + formatter(encoder(obj, $414faaac2f2763fe$var$defaults.encoder, charset, 'value', format))
            ];
        }
        return [
            formatter(prefix) + '=' + formatter(String(obj))
        ];
    }
    var values = [];
    if (typeof obj === 'undefined') return values;
    var objKeys;
    if (generateArrayPrefix === 'comma' && $414faaac2f2763fe$var$isArray(obj)) {
        // we need to join elements in
        if (encodeValuesOnly && encoder) obj = $8lLMe.maybeMap(obj, encoder);
        objKeys = [
            {
                value: obj.length > 0 ? obj.join(',') || null : void 0
            }
        ];
    } else if ($414faaac2f2763fe$var$isArray(filter)) objKeys = filter;
    else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }
    var adjustedPrefix = commaRoundTrip && $414faaac2f2763fe$var$isArray(obj) && obj.length === 1 ? prefix + '[]' : prefix;
    for(var j = 0; j < objKeys.length; ++j){
        var key = objKeys[j];
        var value = typeof key === 'object' && typeof key.value !== 'undefined' ? key.value : obj[key];
        if (skipNulls && value === null) continue;
        var keyPrefix = $414faaac2f2763fe$var$isArray(obj) ? typeof generateArrayPrefix === 'function' ? generateArrayPrefix(adjustedPrefix, key) : adjustedPrefix : adjustedPrefix + (allowDots ? '.' + key : '[' + key + ']');
        sideChannel.set(object, step);
        var valueSideChannel = $6siLO();
        valueSideChannel.set($414faaac2f2763fe$var$sentinel, sideChannel);
        $414faaac2f2763fe$var$pushToArray(values, stringify(value, keyPrefix, generateArrayPrefix, commaRoundTrip, strictNullHandling, skipNulls, generateArrayPrefix === 'comma' && encodeValuesOnly && $414faaac2f2763fe$var$isArray(obj) ? null : encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, valueSideChannel));
    }
    return values;
};
var $414faaac2f2763fe$var$normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) return $414faaac2f2763fe$var$defaults;
    if (opts.encoder !== null && typeof opts.encoder !== 'undefined' && typeof opts.encoder !== 'function') throw new TypeError('Encoder has to be a function.');
    var charset = opts.charset || $414faaac2f2763fe$var$defaults.charset;
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    var format = $840D7.default;
    if (typeof opts.format !== 'undefined') {
        if (!$414faaac2f2763fe$var$has.call($840D7.formatters, opts.format)) throw new TypeError('Unknown format option provided.');
        format = opts.format;
    }
    var formatter = $840D7.formatters[format];
    var filter = $414faaac2f2763fe$var$defaults.filter;
    if (typeof opts.filter === 'function' || $414faaac2f2763fe$var$isArray(opts.filter)) filter = opts.filter;
    return {
        addQueryPrefix: typeof opts.addQueryPrefix === 'boolean' ? opts.addQueryPrefix : $414faaac2f2763fe$var$defaults.addQueryPrefix,
        allowDots: typeof opts.allowDots === 'undefined' ? $414faaac2f2763fe$var$defaults.allowDots : !!opts.allowDots,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : $414faaac2f2763fe$var$defaults.charsetSentinel,
        delimiter: typeof opts.delimiter === 'undefined' ? $414faaac2f2763fe$var$defaults.delimiter : opts.delimiter,
        encode: typeof opts.encode === 'boolean' ? opts.encode : $414faaac2f2763fe$var$defaults.encode,
        encoder: typeof opts.encoder === 'function' ? opts.encoder : $414faaac2f2763fe$var$defaults.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === 'boolean' ? opts.encodeValuesOnly : $414faaac2f2763fe$var$defaults.encodeValuesOnly,
        filter: filter,
        format: format,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === 'function' ? opts.serializeDate : $414faaac2f2763fe$var$defaults.serializeDate,
        skipNulls: typeof opts.skipNulls === 'boolean' ? opts.skipNulls : $414faaac2f2763fe$var$defaults.skipNulls,
        sort: typeof opts.sort === 'function' ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : $414faaac2f2763fe$var$defaults.strictNullHandling
    };
};
module.exports = function(object, opts) {
    var obj = object;
    var options = $414faaac2f2763fe$var$normalizeStringifyOptions(opts);
    var objKeys;
    var filter;
    if (typeof options.filter === 'function') {
        filter = options.filter;
        obj = filter('', obj);
    } else if ($414faaac2f2763fe$var$isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }
    var keys = [];
    if (typeof obj !== 'object' || obj === null) return '';
    var arrayFormat;
    if (opts && opts.arrayFormat in $414faaac2f2763fe$var$arrayPrefixGenerators) arrayFormat = opts.arrayFormat;
    else if (opts && 'indices' in opts) arrayFormat = opts.indices ? 'indices' : 'repeat';
    else arrayFormat = 'indices';
    var generateArrayPrefix = $414faaac2f2763fe$var$arrayPrefixGenerators[arrayFormat];
    if (opts && 'commaRoundTrip' in opts && typeof opts.commaRoundTrip !== 'boolean') throw new TypeError('`commaRoundTrip` must be a boolean, or absent');
    var commaRoundTrip = generateArrayPrefix === 'comma' && opts && opts.commaRoundTrip;
    if (!objKeys) objKeys = Object.keys(obj);
    if (options.sort) objKeys.sort(options.sort);
    var sideChannel = $6siLO();
    for(var i = 0; i < objKeys.length; ++i){
        var key = objKeys[i];
        if (options.skipNulls && obj[key] === null) continue;
        $414faaac2f2763fe$var$pushToArray(keys, $414faaac2f2763fe$var$stringify(obj[key], key, generateArrayPrefix, commaRoundTrip, options.strictNullHandling, options.skipNulls, options.encode ? options.encoder : null, options.filter, options.sort, options.allowDots, options.serializeDate, options.format, options.formatter, options.encodeValuesOnly, options.charset, sideChannel));
    }
    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? '?' : '';
    if (options.charsetSentinel) {
        if (options.charset === 'iso-8859-1') // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
        prefix += 'utf8=%26%2310003%3B&';
        else // encodeURIComponent('✓')
        prefix += 'utf8=%E2%9C%93&';
    }
    return joined.length > 0 ? prefix + joined : '';
};

});
parcelRegister("6siLO", function(module, exports) {
'use strict';

var $imbfI = parcelRequire("imbfI");

var $ei9z1 = parcelRequire("ei9z1");

var $5MEcF = parcelRequire("5MEcF");

var $fb4bS = parcelRequire("fb4bS");

var $k4N9m = parcelRequire("k4N9m");
var $4b33eaf585dbfaa2$var$makeChannel = $k4N9m || $fb4bS || $5MEcF;
/** @type {import('.')} */ module.exports = function getSideChannel() {
    /** @typedef {ReturnType<typeof getSideChannel>} Channel */ /** @type {Channel | undefined} */ var $channelData;
    /** @type {Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $imbfI('Side channel does not contain ' + $ei9z1(key));
        },
        'delete': function(key) {
            return !!$channelData && $channelData['delete'](key);
        },
        get: function(key) {
            return $channelData && $channelData.get(key);
        },
        has: function(key) {
            return !!$channelData && $channelData.has(key);
        },
        set: function(key, value) {
            if (!$channelData) $channelData = $4b33eaf585dbfaa2$var$makeChannel();
            $channelData.set(key, value);
        }
    };
    // @ts-expect-error TODO: figure out why this is erroring
    return channel;
};

});
parcelRegister("imbfI", function(module, exports) {
'use strict';
/** @type {import('./type')} */ module.exports = TypeError;

});

parcelRegister("ei9z1", function(module, exports) {
var $a67a2a4b86bd6e86$var$hasMap = typeof Map === 'function' && Map.prototype;
var $a67a2a4b86bd6e86$var$mapSizeDescriptor = Object.getOwnPropertyDescriptor && $a67a2a4b86bd6e86$var$hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, 'size') : null;
var $a67a2a4b86bd6e86$var$mapSize = $a67a2a4b86bd6e86$var$hasMap && $a67a2a4b86bd6e86$var$mapSizeDescriptor && typeof $a67a2a4b86bd6e86$var$mapSizeDescriptor.get === 'function' ? $a67a2a4b86bd6e86$var$mapSizeDescriptor.get : null;
var $a67a2a4b86bd6e86$var$mapForEach = $a67a2a4b86bd6e86$var$hasMap && Map.prototype.forEach;
var $a67a2a4b86bd6e86$var$hasSet = typeof Set === 'function' && Set.prototype;
var $a67a2a4b86bd6e86$var$setSizeDescriptor = Object.getOwnPropertyDescriptor && $a67a2a4b86bd6e86$var$hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, 'size') : null;
var $a67a2a4b86bd6e86$var$setSize = $a67a2a4b86bd6e86$var$hasSet && $a67a2a4b86bd6e86$var$setSizeDescriptor && typeof $a67a2a4b86bd6e86$var$setSizeDescriptor.get === 'function' ? $a67a2a4b86bd6e86$var$setSizeDescriptor.get : null;
var $a67a2a4b86bd6e86$var$setForEach = $a67a2a4b86bd6e86$var$hasSet && Set.prototype.forEach;
var $a67a2a4b86bd6e86$var$hasWeakMap = typeof WeakMap === 'function' && WeakMap.prototype;
var $a67a2a4b86bd6e86$var$weakMapHas = $a67a2a4b86bd6e86$var$hasWeakMap ? WeakMap.prototype.has : null;
var $a67a2a4b86bd6e86$var$hasWeakSet = typeof WeakSet === 'function' && WeakSet.prototype;
var $a67a2a4b86bd6e86$var$weakSetHas = $a67a2a4b86bd6e86$var$hasWeakSet ? WeakSet.prototype.has : null;
var $a67a2a4b86bd6e86$var$hasWeakRef = typeof WeakRef === 'function' && WeakRef.prototype;
var $a67a2a4b86bd6e86$var$weakRefDeref = $a67a2a4b86bd6e86$var$hasWeakRef ? WeakRef.prototype.deref : null;
var $a67a2a4b86bd6e86$var$booleanValueOf = Boolean.prototype.valueOf;
var $a67a2a4b86bd6e86$var$objectToString = Object.prototype.toString;
var $a67a2a4b86bd6e86$var$functionToString = Function.prototype.toString;
var $a67a2a4b86bd6e86$var$$match = String.prototype.match;
var $a67a2a4b86bd6e86$var$$slice = String.prototype.slice;
var $a67a2a4b86bd6e86$var$$replace = String.prototype.replace;
var $a67a2a4b86bd6e86$var$$toUpperCase = String.prototype.toUpperCase;
var $a67a2a4b86bd6e86$var$$toLowerCase = String.prototype.toLowerCase;
var $a67a2a4b86bd6e86$var$$test = RegExp.prototype.test;
var $a67a2a4b86bd6e86$var$$concat = Array.prototype.concat;
var $a67a2a4b86bd6e86$var$$join = Array.prototype.join;
var $a67a2a4b86bd6e86$var$$arrSlice = Array.prototype.slice;
var $a67a2a4b86bd6e86$var$$floor = Math.floor;
var $a67a2a4b86bd6e86$var$bigIntValueOf = typeof BigInt === 'function' ? BigInt.prototype.valueOf : null;
var $a67a2a4b86bd6e86$var$gOPS = Object.getOwnPropertySymbols;
var $a67a2a4b86bd6e86$var$symToString = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol' ? Symbol.prototype.toString : null;
var $a67a2a4b86bd6e86$var$hasShammedSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'object';
// ie, `has-tostringtag/shams
var $a67a2a4b86bd6e86$var$toStringTag = typeof Symbol === 'function' && Symbol.toStringTag && (typeof Symbol.toStringTag === $a67a2a4b86bd6e86$var$hasShammedSymbols ? 'object' : 'symbol') ? Symbol.toStringTag : null;
var $a67a2a4b86bd6e86$var$isEnumerable = Object.prototype.propertyIsEnumerable;
var $a67a2a4b86bd6e86$var$gPO = (typeof Reflect === 'function' ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype // eslint-disable-line no-proto
 ? function(O) {
    return O.__proto__; // eslint-disable-line no-proto
} : null);
function $a67a2a4b86bd6e86$var$addNumericSeparator(num, str) {
    if (num === Infinity || num === -Infinity || num !== num || num && num > -1000 && num < 1000 || $a67a2a4b86bd6e86$var$$test.call(/e/, str)) return str;
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof num === 'number') {
        var int = num < 0 ? -$a67a2a4b86bd6e86$var$$floor(-num) : $a67a2a4b86bd6e86$var$$floor(num); // trunc(num)
        if (int !== num) {
            var intStr = String(int);
            var dec = $a67a2a4b86bd6e86$var$$slice.call(str, intStr.length + 1);
            return $a67a2a4b86bd6e86$var$$replace.call(intStr, sepRegex, '$&_') + '.' + $a67a2a4b86bd6e86$var$$replace.call($a67a2a4b86bd6e86$var$$replace.call(dec, /([0-9]{3})/g, '$&_'), /_$/, '');
        }
    }
    return $a67a2a4b86bd6e86$var$$replace.call(str, sepRegex, '$&_');
}

var $lOA8N = parcelRequire("lOA8N");
var $a67a2a4b86bd6e86$var$inspectCustom = $lOA8N.custom;
var $a67a2a4b86bd6e86$var$inspectSymbol = $a67a2a4b86bd6e86$var$isSymbol($a67a2a4b86bd6e86$var$inspectCustom) ? $a67a2a4b86bd6e86$var$inspectCustom : null;
var $a67a2a4b86bd6e86$var$quotes = {
    __proto__: null,
    'double': '"',
    single: "'"
};
var $a67a2a4b86bd6e86$var$quoteREs = {
    __proto__: null,
    'double': /(["\\])/g,
    single: /(['\\])/g
};
module.exports = function inspect_(obj, options, depth, seen) {
    var opts = options || {};
    if ($a67a2a4b86bd6e86$var$has(opts, 'quoteStyle') && !$a67a2a4b86bd6e86$var$has($a67a2a4b86bd6e86$var$quotes, opts.quoteStyle)) throw new TypeError('option "quoteStyle" must be "single" or "double"');
    if ($a67a2a4b86bd6e86$var$has(opts, 'maxStringLength') && (typeof opts.maxStringLength === 'number' ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity : opts.maxStringLength !== null)) throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    var customInspect = $a67a2a4b86bd6e86$var$has(opts, 'customInspect') ? opts.customInspect : true;
    if (typeof customInspect !== 'boolean' && customInspect !== 'symbol') throw new TypeError('option "customInspect", if provided, must be `true`, `false`, or `\'symbol\'`');
    if ($a67a2a4b86bd6e86$var$has(opts, 'indent') && opts.indent !== null && opts.indent !== '\t' && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)) throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    if ($a67a2a4b86bd6e86$var$has(opts, 'numericSeparator') && typeof opts.numericSeparator !== 'boolean') throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    var numericSeparator = opts.numericSeparator;
    if (typeof obj === 'undefined') return 'undefined';
    if (obj === null) return 'null';
    if (typeof obj === 'boolean') return obj ? 'true' : 'false';
    if (typeof obj === 'string') return $a67a2a4b86bd6e86$var$inspectString(obj, opts);
    if (typeof obj === 'number') {
        if (obj === 0) return Infinity / obj > 0 ? '0' : '-0';
        var str = String(obj);
        return numericSeparator ? $a67a2a4b86bd6e86$var$addNumericSeparator(obj, str) : str;
    }
    if (typeof obj === 'bigint') {
        var bigIntStr = String(obj) + 'n';
        return numericSeparator ? $a67a2a4b86bd6e86$var$addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }
    var maxDepth = typeof opts.depth === 'undefined' ? 5 : opts.depth;
    if (typeof depth === 'undefined') depth = 0;
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === 'object') return $a67a2a4b86bd6e86$var$isArray(obj) ? '[Array]' : '[Object]';
    var indent = $a67a2a4b86bd6e86$var$getIndent(opts, depth);
    if (typeof seen === 'undefined') seen = [];
    else if ($a67a2a4b86bd6e86$var$indexOf(seen, obj) >= 0) return '[Circular]';
    function inspect(value, from, noIndent) {
        if (from) {
            seen = $a67a2a4b86bd6e86$var$$arrSlice.call(seen);
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if ($a67a2a4b86bd6e86$var$has(opts, 'quoteStyle')) newOpts.quoteStyle = opts.quoteStyle;
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }
    if (typeof obj === 'function' && !$a67a2a4b86bd6e86$var$isRegExp(obj)) {
        var name = $a67a2a4b86bd6e86$var$nameOf(obj);
        var keys = $a67a2a4b86bd6e86$var$arrObjKeys(obj, inspect);
        return '[Function' + (name ? ': ' + name : ' (anonymous)') + ']' + (keys.length > 0 ? ' { ' + $a67a2a4b86bd6e86$var$$join.call(keys, ', ') + ' }' : '');
    }
    if ($a67a2a4b86bd6e86$var$isSymbol(obj)) {
        var symString = $a67a2a4b86bd6e86$var$hasShammedSymbols ? $a67a2a4b86bd6e86$var$$replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, '$1') : $a67a2a4b86bd6e86$var$symToString.call(obj);
        return typeof obj === 'object' && !$a67a2a4b86bd6e86$var$hasShammedSymbols ? $a67a2a4b86bd6e86$var$markBoxed(symString) : symString;
    }
    if ($a67a2a4b86bd6e86$var$isElement(obj)) {
        var s = '<' + $a67a2a4b86bd6e86$var$$toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];
        for(var i = 0; i < attrs.length; i++)s += ' ' + attrs[i].name + '=' + $a67a2a4b86bd6e86$var$wrapQuotes($a67a2a4b86bd6e86$var$quote(attrs[i].value), 'double', opts);
        s += '>';
        if (obj.childNodes && obj.childNodes.length) s += '...';
        s += '</' + $a67a2a4b86bd6e86$var$$toLowerCase.call(String(obj.nodeName)) + '>';
        return s;
    }
    if ($a67a2a4b86bd6e86$var$isArray(obj)) {
        if (obj.length === 0) return '[]';
        var xs = $a67a2a4b86bd6e86$var$arrObjKeys(obj, inspect);
        if (indent && !$a67a2a4b86bd6e86$var$singleLineValues(xs)) return '[' + $a67a2a4b86bd6e86$var$indentedJoin(xs, indent) + ']';
        return '[ ' + $a67a2a4b86bd6e86$var$$join.call(xs, ', ') + ' ]';
    }
    if ($a67a2a4b86bd6e86$var$isError(obj)) {
        var parts = $a67a2a4b86bd6e86$var$arrObjKeys(obj, inspect);
        if (!('cause' in Error.prototype) && 'cause' in obj && !$a67a2a4b86bd6e86$var$isEnumerable.call(obj, 'cause')) return '{ [' + String(obj) + '] ' + $a67a2a4b86bd6e86$var$$join.call($a67a2a4b86bd6e86$var$$concat.call('[cause]: ' + inspect(obj.cause), parts), ', ') + ' }';
        if (parts.length === 0) return '[' + String(obj) + ']';
        return '{ [' + String(obj) + '] ' + $a67a2a4b86bd6e86$var$$join.call(parts, ', ') + ' }';
    }
    if (typeof obj === 'object' && customInspect) {
        if ($a67a2a4b86bd6e86$var$inspectSymbol && typeof obj[$a67a2a4b86bd6e86$var$inspectSymbol] === 'function' && $lOA8N) return $lOA8N(obj, {
            depth: maxDepth - depth
        });
        else if (customInspect !== 'symbol' && typeof obj.inspect === 'function') return obj.inspect();
    }
    if ($a67a2a4b86bd6e86$var$isMap(obj)) {
        var mapParts = [];
        if ($a67a2a4b86bd6e86$var$mapForEach) $a67a2a4b86bd6e86$var$mapForEach.call(obj, function(value, key) {
            mapParts.push(inspect(key, obj, true) + ' => ' + inspect(value, obj));
        });
        return $a67a2a4b86bd6e86$var$collectionOf('Map', $a67a2a4b86bd6e86$var$mapSize.call(obj), mapParts, indent);
    }
    if ($a67a2a4b86bd6e86$var$isSet(obj)) {
        var setParts = [];
        if ($a67a2a4b86bd6e86$var$setForEach) $a67a2a4b86bd6e86$var$setForEach.call(obj, function(value) {
            setParts.push(inspect(value, obj));
        });
        return $a67a2a4b86bd6e86$var$collectionOf('Set', $a67a2a4b86bd6e86$var$setSize.call(obj), setParts, indent);
    }
    if ($a67a2a4b86bd6e86$var$isWeakMap(obj)) return $a67a2a4b86bd6e86$var$weakCollectionOf('WeakMap');
    if ($a67a2a4b86bd6e86$var$isWeakSet(obj)) return $a67a2a4b86bd6e86$var$weakCollectionOf('WeakSet');
    if ($a67a2a4b86bd6e86$var$isWeakRef(obj)) return $a67a2a4b86bd6e86$var$weakCollectionOf('WeakRef');
    if ($a67a2a4b86bd6e86$var$isNumber(obj)) return $a67a2a4b86bd6e86$var$markBoxed(inspect(Number(obj)));
    if ($a67a2a4b86bd6e86$var$isBigInt(obj)) return $a67a2a4b86bd6e86$var$markBoxed(inspect($a67a2a4b86bd6e86$var$bigIntValueOf.call(obj)));
    if ($a67a2a4b86bd6e86$var$isBoolean(obj)) return $a67a2a4b86bd6e86$var$markBoxed($a67a2a4b86bd6e86$var$booleanValueOf.call(obj));
    if ($a67a2a4b86bd6e86$var$isString(obj)) return $a67a2a4b86bd6e86$var$markBoxed(inspect(String(obj)));
    // note: in IE 8, sometimes `global !== window` but both are the prototypes of each other
    /* eslint-env browser */ if (typeof window !== 'undefined' && obj === window) return '{ [object Window] }';
    if (typeof globalThis !== 'undefined' && obj === globalThis || typeof $parcel$global !== 'undefined' && obj === $parcel$global) return '{ [object globalThis] }';
    if (!$a67a2a4b86bd6e86$var$isDate(obj) && !$a67a2a4b86bd6e86$var$isRegExp(obj)) {
        var ys = $a67a2a4b86bd6e86$var$arrObjKeys(obj, inspect);
        var isPlainObject = $a67a2a4b86bd6e86$var$gPO ? $a67a2a4b86bd6e86$var$gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? '' : 'null prototype';
        var stringTag = !isPlainObject && $a67a2a4b86bd6e86$var$toStringTag && Object(obj) === obj && $a67a2a4b86bd6e86$var$toStringTag in obj ? $a67a2a4b86bd6e86$var$$slice.call($a67a2a4b86bd6e86$var$toStr(obj), 8, -1) : protoTag ? 'Object' : '';
        var constructorTag = isPlainObject || typeof obj.constructor !== 'function' ? '' : obj.constructor.name ? obj.constructor.name + ' ' : '';
        var tag = constructorTag + (stringTag || protoTag ? '[' + $a67a2a4b86bd6e86$var$$join.call($a67a2a4b86bd6e86$var$$concat.call([], stringTag || [], protoTag || []), ': ') + '] ' : '');
        if (ys.length === 0) return tag + '{}';
        if (indent) return tag + '{' + $a67a2a4b86bd6e86$var$indentedJoin(ys, indent) + '}';
        return tag + '{ ' + $a67a2a4b86bd6e86$var$$join.call(ys, ', ') + ' }';
    }
    return String(obj);
};
function $a67a2a4b86bd6e86$var$wrapQuotes(s, defaultStyle, opts) {
    var style = opts.quoteStyle || defaultStyle;
    var quoteChar = $a67a2a4b86bd6e86$var$quotes[style];
    return quoteChar + s + quoteChar;
}
function $a67a2a4b86bd6e86$var$quote(s) {
    return $a67a2a4b86bd6e86$var$$replace.call(String(s), /"/g, '&quot;');
}
function $a67a2a4b86bd6e86$var$canTrustToString(obj) {
    return !$a67a2a4b86bd6e86$var$toStringTag || !(typeof obj === 'object' && ($a67a2a4b86bd6e86$var$toStringTag in obj || typeof obj[$a67a2a4b86bd6e86$var$toStringTag] !== 'undefined'));
}
function $a67a2a4b86bd6e86$var$isArray(obj) {
    return $a67a2a4b86bd6e86$var$toStr(obj) === '[object Array]' && $a67a2a4b86bd6e86$var$canTrustToString(obj);
}
function $a67a2a4b86bd6e86$var$isDate(obj) {
    return $a67a2a4b86bd6e86$var$toStr(obj) === '[object Date]' && $a67a2a4b86bd6e86$var$canTrustToString(obj);
}
function $a67a2a4b86bd6e86$var$isRegExp(obj) {
    return $a67a2a4b86bd6e86$var$toStr(obj) === '[object RegExp]' && $a67a2a4b86bd6e86$var$canTrustToString(obj);
}
function $a67a2a4b86bd6e86$var$isError(obj) {
    return $a67a2a4b86bd6e86$var$toStr(obj) === '[object Error]' && $a67a2a4b86bd6e86$var$canTrustToString(obj);
}
function $a67a2a4b86bd6e86$var$isString(obj) {
    return $a67a2a4b86bd6e86$var$toStr(obj) === '[object String]' && $a67a2a4b86bd6e86$var$canTrustToString(obj);
}
function $a67a2a4b86bd6e86$var$isNumber(obj) {
    return $a67a2a4b86bd6e86$var$toStr(obj) === '[object Number]' && $a67a2a4b86bd6e86$var$canTrustToString(obj);
}
function $a67a2a4b86bd6e86$var$isBoolean(obj) {
    return $a67a2a4b86bd6e86$var$toStr(obj) === '[object Boolean]' && $a67a2a4b86bd6e86$var$canTrustToString(obj);
}
// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function $a67a2a4b86bd6e86$var$isSymbol(obj) {
    if ($a67a2a4b86bd6e86$var$hasShammedSymbols) return obj && typeof obj === 'object' && obj instanceof Symbol;
    if (typeof obj === 'symbol') return true;
    if (!obj || typeof obj !== 'object' || !$a67a2a4b86bd6e86$var$symToString) return false;
    try {
        $a67a2a4b86bd6e86$var$symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}
function $a67a2a4b86bd6e86$var$isBigInt(obj) {
    if (!obj || typeof obj !== 'object' || !$a67a2a4b86bd6e86$var$bigIntValueOf) return false;
    try {
        $a67a2a4b86bd6e86$var$bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}
var $a67a2a4b86bd6e86$var$hasOwn = Object.prototype.hasOwnProperty || function(key) {
    return key in this;
};
function $a67a2a4b86bd6e86$var$has(obj, key) {
    return $a67a2a4b86bd6e86$var$hasOwn.call(obj, key);
}
function $a67a2a4b86bd6e86$var$toStr(obj) {
    return $a67a2a4b86bd6e86$var$objectToString.call(obj);
}
function $a67a2a4b86bd6e86$var$nameOf(f) {
    if (f.name) return f.name;
    var m = $a67a2a4b86bd6e86$var$$match.call($a67a2a4b86bd6e86$var$functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) return m[1];
    return null;
}
function $a67a2a4b86bd6e86$var$indexOf(xs, x) {
    if (xs.indexOf) return xs.indexOf(x);
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}
function $a67a2a4b86bd6e86$var$isMap(x) {
    if (!$a67a2a4b86bd6e86$var$mapSize || !x || typeof x !== 'object') return false;
    try {
        $a67a2a4b86bd6e86$var$mapSize.call(x);
        try {
            $a67a2a4b86bd6e86$var$setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $a67a2a4b86bd6e86$var$isWeakMap(x) {
    if (!$a67a2a4b86bd6e86$var$weakMapHas || !x || typeof x !== 'object') return false;
    try {
        $a67a2a4b86bd6e86$var$weakMapHas.call(x, $a67a2a4b86bd6e86$var$weakMapHas);
        try {
            $a67a2a4b86bd6e86$var$weakSetHas.call(x, $a67a2a4b86bd6e86$var$weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $a67a2a4b86bd6e86$var$isWeakRef(x) {
    if (!$a67a2a4b86bd6e86$var$weakRefDeref || !x || typeof x !== 'object') return false;
    try {
        $a67a2a4b86bd6e86$var$weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}
function $a67a2a4b86bd6e86$var$isSet(x) {
    if (!$a67a2a4b86bd6e86$var$setSize || !x || typeof x !== 'object') return false;
    try {
        $a67a2a4b86bd6e86$var$setSize.call(x);
        try {
            $a67a2a4b86bd6e86$var$mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $a67a2a4b86bd6e86$var$isWeakSet(x) {
    if (!$a67a2a4b86bd6e86$var$weakSetHas || !x || typeof x !== 'object') return false;
    try {
        $a67a2a4b86bd6e86$var$weakSetHas.call(x, $a67a2a4b86bd6e86$var$weakSetHas);
        try {
            $a67a2a4b86bd6e86$var$weakMapHas.call(x, $a67a2a4b86bd6e86$var$weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $a67a2a4b86bd6e86$var$isElement(x) {
    if (!x || typeof x !== 'object') return false;
    if (typeof HTMLElement !== 'undefined' && x instanceof HTMLElement) return true;
    return typeof x.nodeName === 'string' && typeof x.getAttribute === 'function';
}
function $a67a2a4b86bd6e86$var$inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = '... ' + remaining + ' more character' + (remaining > 1 ? 's' : '');
        return $a67a2a4b86bd6e86$var$inspectString($a67a2a4b86bd6e86$var$$slice.call(str, 0, opts.maxStringLength), opts) + trailer;
    }
    var quoteRE = $a67a2a4b86bd6e86$var$quoteREs[opts.quoteStyle || 'single'];
    quoteRE.lastIndex = 0;
    // eslint-disable-next-line no-control-regex
    var s = $a67a2a4b86bd6e86$var$$replace.call($a67a2a4b86bd6e86$var$$replace.call(str, quoteRE, '\\$1'), /[\x00-\x1f]/g, $a67a2a4b86bd6e86$var$lowbyte);
    return $a67a2a4b86bd6e86$var$wrapQuotes(s, 'single', opts);
}
function $a67a2a4b86bd6e86$var$lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: 'b',
        9: 't',
        10: 'n',
        12: 'f',
        13: 'r'
    }[n];
    if (x) return '\\' + x;
    return '\\x' + (n < 0x10 ? '0' : '') + $a67a2a4b86bd6e86$var$$toUpperCase.call(n.toString(16));
}
function $a67a2a4b86bd6e86$var$markBoxed(str) {
    return 'Object(' + str + ')';
}
function $a67a2a4b86bd6e86$var$weakCollectionOf(type) {
    return type + ' { ? }';
}
function $a67a2a4b86bd6e86$var$collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? $a67a2a4b86bd6e86$var$indentedJoin(entries, indent) : $a67a2a4b86bd6e86$var$$join.call(entries, ', ');
    return type + ' (' + size + ') {' + joinedEntries + '}';
}
function $a67a2a4b86bd6e86$var$singleLineValues(xs) {
    for(var i = 0; i < xs.length; i++){
        if ($a67a2a4b86bd6e86$var$indexOf(xs[i], '\n') >= 0) return false;
    }
    return true;
}
function $a67a2a4b86bd6e86$var$getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === '\t') baseIndent = '\t';
    else if (typeof opts.indent === 'number' && opts.indent > 0) baseIndent = $a67a2a4b86bd6e86$var$$join.call(Array(opts.indent + 1), ' ');
    else return null;
    return {
        base: baseIndent,
        prev: $a67a2a4b86bd6e86$var$$join.call(Array(depth + 1), baseIndent)
    };
}
function $a67a2a4b86bd6e86$var$indentedJoin(xs, indent) {
    if (xs.length === 0) return '';
    var lineJoiner = '\n' + indent.prev + indent.base;
    return lineJoiner + $a67a2a4b86bd6e86$var$$join.call(xs, ',' + lineJoiner) + '\n' + indent.prev;
}
function $a67a2a4b86bd6e86$var$arrObjKeys(obj, inspect) {
    var isArr = $a67a2a4b86bd6e86$var$isArray(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for(var i = 0; i < obj.length; i++)xs[i] = $a67a2a4b86bd6e86$var$has(obj, i) ? inspect(obj[i], obj) : '';
    }
    var syms = typeof $a67a2a4b86bd6e86$var$gOPS === 'function' ? $a67a2a4b86bd6e86$var$gOPS(obj) : [];
    var symMap;
    if ($a67a2a4b86bd6e86$var$hasShammedSymbols) {
        symMap = {};
        for(var k = 0; k < syms.length; k++)symMap['$' + syms[k]] = syms[k];
    }
    for(var key in obj){
        if (!$a67a2a4b86bd6e86$var$has(obj, key)) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if ($a67a2a4b86bd6e86$var$hasShammedSymbols && symMap['$' + key] instanceof Symbol) continue; // eslint-disable-line no-restricted-syntax, no-continue
        else if ($a67a2a4b86bd6e86$var$$test.call(/[^\w$]/, key)) xs.push(inspect(key, obj) + ': ' + inspect(obj[key], obj));
        else xs.push(key + ': ' + inspect(obj[key], obj));
    }
    if (typeof $a67a2a4b86bd6e86$var$gOPS === 'function') {
        for(var j = 0; j < syms.length; j++)if ($a67a2a4b86bd6e86$var$isEnumerable.call(obj, syms[j])) xs.push('[' + inspect(syms[j]) + ']: ' + inspect(obj[syms[j]], obj));
    }
    return xs;
}

});

parcelRegister("5MEcF", function(module, exports) {
'use strict';

var $ei9z1 = parcelRequire("ei9z1");

var $imbfI = parcelRequire("imbfI");
/*
* This function traverses the list returning the node corresponding to the given key.
*
* That node is also moved to the head of the list, so that if it's accessed again we don't need to traverse the whole list.
* By doing so, all the recently used nodes can be accessed relatively quickly.
*/ /** @type {import('./list.d.ts').listGetNode} */ // eslint-disable-next-line consistent-return
var $43609ef8ebe3e23b$var$listGetNode = function(list, key, isDelete) {
    /** @type {typeof list | NonNullable<(typeof list)['next']>} */ var prev = list;
    /** @type {(typeof list)['next']} */ var curr;
    // eslint-disable-next-line eqeqeq
    for(; (curr = prev.next) != null; prev = curr)if (curr.key === key) {
        prev.next = curr.next;
        if (!isDelete) {
            // eslint-disable-next-line no-extra-parens
            curr.next = /** @type {NonNullable<typeof list.next>} */ list.next;
            list.next = curr; // eslint-disable-line no-param-reassign
        }
        return curr;
    }
};
/** @type {import('./list.d.ts').listGet} */ var $43609ef8ebe3e23b$var$listGet = function(objects, key) {
    if (!objects) return void 0;
    var node = $43609ef8ebe3e23b$var$listGetNode(objects, key);
    return node && node.value;
};
/** @type {import('./list.d.ts').listSet} */ var $43609ef8ebe3e23b$var$listSet = function(objects, key, value) {
    var node = $43609ef8ebe3e23b$var$listGetNode(objects, key);
    if (node) node.value = value;
    else // Prepend the new node to the beginning of the list
    objects.next = /** @type {import('./list.d.ts').ListNode<typeof value, typeof key>} */ {
        key: key,
        next: objects.next,
        value: value
    };
};
/** @type {import('./list.d.ts').listHas} */ var $43609ef8ebe3e23b$var$listHas = function(objects, key) {
    if (!objects) return false;
    return !!$43609ef8ebe3e23b$var$listGetNode(objects, key);
};
/** @type {import('./list.d.ts').listDelete} */ // eslint-disable-next-line consistent-return
var $43609ef8ebe3e23b$var$listDelete = function(objects, key) {
    if (objects) return $43609ef8ebe3e23b$var$listGetNode(objects, key, true);
};
/** @type {import('.')} */ module.exports = function getSideChannelList() {
    /** @typedef {ReturnType<typeof getSideChannelList>} Channel */ /** @typedef {Parameters<Channel['get']>[0]} K */ /** @typedef {Parameters<Channel['set']>[1]} V */ /** @type {import('./list.d.ts').RootNode<V, K> | undefined} */ var $o;
    /** @type {Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $imbfI('Side channel does not contain ' + $ei9z1(key));
        },
        'delete': function(key) {
            var root = $o && $o.next;
            var deletedNode = $43609ef8ebe3e23b$var$listDelete($o, key);
            if (deletedNode && root && root === deletedNode) $o = void 0;
            return !!deletedNode;
        },
        get: function(key) {
            return $43609ef8ebe3e23b$var$listGet($o, key);
        },
        has: function(key) {
            return $43609ef8ebe3e23b$var$listHas($o, key);
        },
        set: function(key, value) {
            if (!$o) // Initialize the linked list as an empty node, so that we don't have to special-case handling of the first node: we can always refer to it as (previous node).next, instead of something like (list).head
            $o = {
                next: void 0
            };
            // eslint-disable-next-line no-extra-parens
            $43609ef8ebe3e23b$var$listSet(/** @type {NonNullable<typeof $o>} */ $o, key, value);
        }
    };
    // @ts-expect-error TODO: figure out why this is erroring
    return channel;
};

});

parcelRegister("fb4bS", function(module, exports) {
'use strict';

var $1b3Ts = parcelRequire("1b3Ts");

var $f8M6V = parcelRequire("f8M6V");

var $ei9z1 = parcelRequire("ei9z1");

var $imbfI = parcelRequire("imbfI");
var $b0cb224174fd5b39$var$$Map = $1b3Ts('%Map%', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K) => V} */ var $b0cb224174fd5b39$var$$mapGet = $f8M6V('Map.prototype.get', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K, value: V) => void} */ var $b0cb224174fd5b39$var$$mapSet = $f8M6V('Map.prototype.set', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K) => boolean} */ var $b0cb224174fd5b39$var$$mapHas = $f8M6V('Map.prototype.has', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K) => boolean} */ var $b0cb224174fd5b39$var$$mapDelete = $f8M6V('Map.prototype.delete', true);
/** @type {<K, V>(thisArg: Map<K, V>) => number} */ var $b0cb224174fd5b39$var$$mapSize = $f8M6V('Map.prototype.size', true);
/** @type {import('.')} */ module.exports = !!$b0cb224174fd5b39$var$$Map && /** @type {Exclude<import('.'), false>} */ function getSideChannelMap() {
    /** @typedef {ReturnType<typeof getSideChannelMap>} Channel */ /** @typedef {Parameters<Channel['get']>[0]} K */ /** @typedef {Parameters<Channel['set']>[1]} V */ /** @type {Map<K, V> | undefined} */ var $m;
    /** @type {Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $imbfI('Side channel does not contain ' + $ei9z1(key));
        },
        'delete': function(key) {
            if ($m) {
                var result = $b0cb224174fd5b39$var$$mapDelete($m, key);
                if ($b0cb224174fd5b39$var$$mapSize($m) === 0) $m = void 0;
                return result;
            }
            return false;
        },
        get: function(key) {
            if ($m) return $b0cb224174fd5b39$var$$mapGet($m, key);
        },
        has: function(key) {
            if ($m) return $b0cb224174fd5b39$var$$mapHas($m, key);
            return false;
        },
        set: function(key, value) {
            if (!$m) // @ts-expect-error TS can't handle narrowing a variable inside a closure
            $m = new $b0cb224174fd5b39$var$$Map();
            $b0cb224174fd5b39$var$$mapSet($m, key, value);
        }
    };
    // @ts-expect-error TODO: figure out why TS is erroring here
    return channel;
};

});
parcelRegister("1b3Ts", function(module, exports) {
'use strict';
var $0db9d6af03f2962b$var$undefined1;

var $cAzwJ = parcelRequire("cAzwJ");

var $b2puG = parcelRequire("b2puG");

var $6RORS = parcelRequire("6RORS");

var $5KlAG = parcelRequire("5KlAG");

var $fVnN9 = parcelRequire("fVnN9");

var $bqoCM = parcelRequire("bqoCM");

var $imbfI = parcelRequire("imbfI");

var $P3stF = parcelRequire("P3stF");

var $7ObkT = parcelRequire("7ObkT");

var $flK97 = parcelRequire("flK97");

var $51cuw = parcelRequire("51cuw");

var $ka2TH = parcelRequire("ka2TH");

var $bxSFZ = parcelRequire("bxSFZ");

var $gkkDl = parcelRequire("gkkDl");

var $jpST6 = parcelRequire("jpST6");
var $0db9d6af03f2962b$var$$Function = Function;
// eslint-disable-next-line consistent-return
var $0db9d6af03f2962b$var$getEvalledConstructor = function(expressionSyntax) {
    try {
        return $0db9d6af03f2962b$var$$Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
    } catch (e) {}
};

var $kwOoE = parcelRequire("kwOoE");

var $1Yj66 = parcelRequire("1Yj66");
var $0db9d6af03f2962b$var$throwTypeError = function() {
    throw new $imbfI();
};
var $0db9d6af03f2962b$var$ThrowTypeError = $kwOoE ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $0db9d6af03f2962b$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $kwOoE(arguments, 'callee').get;
        } catch (gOPDthrows) {
            return $0db9d6af03f2962b$var$throwTypeError;
        }
    }
}() : $0db9d6af03f2962b$var$throwTypeError;

var $0db9d6af03f2962b$var$hasSymbols = (parcelRequire("hscEj"))();

var $9SzeH = parcelRequire("9SzeH");

var $dZ46W = parcelRequire("dZ46W");

var $kyib7 = parcelRequire("kyib7");

var $gJ8ML = parcelRequire("gJ8ML");

var $hI0J6 = parcelRequire("hI0J6");
var $0db9d6af03f2962b$var$needsEval = {};
var $0db9d6af03f2962b$var$TypedArray = typeof Uint8Array === 'undefined' || !$9SzeH ? undefined : $9SzeH(Uint8Array);
var $0db9d6af03f2962b$var$INTRINSICS = {
    __proto__: null,
    '%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
    '%Array%': Array,
    '%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
    '%ArrayIteratorPrototype%': $0db9d6af03f2962b$var$hasSymbols && $9SzeH ? $9SzeH([][Symbol.iterator]()) : undefined,
    '%AsyncFromSyncIteratorPrototype%': undefined,
    '%AsyncFunction%': $0db9d6af03f2962b$var$needsEval,
    '%AsyncGenerator%': $0db9d6af03f2962b$var$needsEval,
    '%AsyncGeneratorFunction%': $0db9d6af03f2962b$var$needsEval,
    '%AsyncIteratorPrototype%': $0db9d6af03f2962b$var$needsEval,
    '%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
    '%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
    '%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
    '%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
    '%Boolean%': Boolean,
    '%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
    '%Date%': Date,
    '%decodeURI%': decodeURI,
    '%decodeURIComponent%': decodeURIComponent,
    '%encodeURI%': encodeURI,
    '%encodeURIComponent%': encodeURIComponent,
    '%Error%': $b2puG,
    '%eval%': eval,
    '%EvalError%': $6RORS,
    '%Float16Array%': typeof Float16Array === 'undefined' ? undefined : Float16Array,
    '%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
    '%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
    '%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
    '%Function%': $0db9d6af03f2962b$var$$Function,
    '%GeneratorFunction%': $0db9d6af03f2962b$var$needsEval,
    '%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
    '%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
    '%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
    '%isFinite%': isFinite,
    '%isNaN%': isNaN,
    '%IteratorPrototype%': $0db9d6af03f2962b$var$hasSymbols && $9SzeH ? $9SzeH($9SzeH([][Symbol.iterator]())) : undefined,
    '%JSON%': typeof JSON === 'object' ? JSON : undefined,
    '%Map%': typeof Map === 'undefined' ? undefined : Map,
    '%MapIteratorPrototype%': typeof Map === 'undefined' || !$0db9d6af03f2962b$var$hasSymbols || !$9SzeH ? undefined : $9SzeH(new Map()[Symbol.iterator]()),
    '%Math%': Math,
    '%Number%': Number,
    '%Object%': $cAzwJ,
    '%Object.getOwnPropertyDescriptor%': $kwOoE,
    '%parseFloat%': parseFloat,
    '%parseInt%': parseInt,
    '%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
    '%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
    '%RangeError%': $5KlAG,
    '%ReferenceError%': $fVnN9,
    '%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
    '%RegExp%': RegExp,
    '%Set%': typeof Set === 'undefined' ? undefined : Set,
    '%SetIteratorPrototype%': typeof Set === 'undefined' || !$0db9d6af03f2962b$var$hasSymbols || !$9SzeH ? undefined : $9SzeH(new Set()[Symbol.iterator]()),
    '%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
    '%String%': String,
    '%StringIteratorPrototype%': $0db9d6af03f2962b$var$hasSymbols && $9SzeH ? $9SzeH(''[Symbol.iterator]()) : undefined,
    '%Symbol%': $0db9d6af03f2962b$var$hasSymbols ? Symbol : undefined,
    '%SyntaxError%': $bqoCM,
    '%ThrowTypeError%': $0db9d6af03f2962b$var$ThrowTypeError,
    '%TypedArray%': $0db9d6af03f2962b$var$TypedArray,
    '%TypeError%': $imbfI,
    '%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
    '%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
    '%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
    '%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
    '%URIError%': $P3stF,
    '%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
    '%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
    '%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet,
    '%Function.prototype.call%': $hI0J6,
    '%Function.prototype.apply%': $gJ8ML,
    '%Object.defineProperty%': $1Yj66,
    '%Object.getPrototypeOf%': $dZ46W,
    '%Math.abs%': $7ObkT,
    '%Math.floor%': $flK97,
    '%Math.max%': $51cuw,
    '%Math.min%': $ka2TH,
    '%Math.pow%': $bxSFZ,
    '%Math.round%': $gkkDl,
    '%Math.sign%': $jpST6,
    '%Reflect.getPrototypeOf%': $kyib7
};
if ($9SzeH) try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var $0db9d6af03f2962b$var$errorProto = $9SzeH($9SzeH(e));
    $0db9d6af03f2962b$var$INTRINSICS['%Error.prototype%'] = $0db9d6af03f2962b$var$errorProto;
}
var $0db9d6af03f2962b$var$doEval = function doEval(name) {
    var value;
    if (name === '%AsyncFunction%') value = $0db9d6af03f2962b$var$getEvalledConstructor('async function () {}');
    else if (name === '%GeneratorFunction%') value = $0db9d6af03f2962b$var$getEvalledConstructor('function* () {}');
    else if (name === '%AsyncGeneratorFunction%') value = $0db9d6af03f2962b$var$getEvalledConstructor('async function* () {}');
    else if (name === '%AsyncGenerator%') {
        var fn = doEval('%AsyncGeneratorFunction%');
        if (fn) value = fn.prototype;
    } else if (name === '%AsyncIteratorPrototype%') {
        var gen = doEval('%AsyncGenerator%');
        if (gen && $9SzeH) value = $9SzeH(gen.prototype);
    }
    $0db9d6af03f2962b$var$INTRINSICS[name] = value;
    return value;
};
var $0db9d6af03f2962b$var$LEGACY_ALIASES = {
    __proto__: null,
    '%ArrayBufferPrototype%': [
        'ArrayBuffer',
        'prototype'
    ],
    '%ArrayPrototype%': [
        'Array',
        'prototype'
    ],
    '%ArrayProto_entries%': [
        'Array',
        'prototype',
        'entries'
    ],
    '%ArrayProto_forEach%': [
        'Array',
        'prototype',
        'forEach'
    ],
    '%ArrayProto_keys%': [
        'Array',
        'prototype',
        'keys'
    ],
    '%ArrayProto_values%': [
        'Array',
        'prototype',
        'values'
    ],
    '%AsyncFunctionPrototype%': [
        'AsyncFunction',
        'prototype'
    ],
    '%AsyncGenerator%': [
        'AsyncGeneratorFunction',
        'prototype'
    ],
    '%AsyncGeneratorPrototype%': [
        'AsyncGeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%BooleanPrototype%': [
        'Boolean',
        'prototype'
    ],
    '%DataViewPrototype%': [
        'DataView',
        'prototype'
    ],
    '%DatePrototype%': [
        'Date',
        'prototype'
    ],
    '%ErrorPrototype%': [
        'Error',
        'prototype'
    ],
    '%EvalErrorPrototype%': [
        'EvalError',
        'prototype'
    ],
    '%Float32ArrayPrototype%': [
        'Float32Array',
        'prototype'
    ],
    '%Float64ArrayPrototype%': [
        'Float64Array',
        'prototype'
    ],
    '%FunctionPrototype%': [
        'Function',
        'prototype'
    ],
    '%Generator%': [
        'GeneratorFunction',
        'prototype'
    ],
    '%GeneratorPrototype%': [
        'GeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%Int8ArrayPrototype%': [
        'Int8Array',
        'prototype'
    ],
    '%Int16ArrayPrototype%': [
        'Int16Array',
        'prototype'
    ],
    '%Int32ArrayPrototype%': [
        'Int32Array',
        'prototype'
    ],
    '%JSONParse%': [
        'JSON',
        'parse'
    ],
    '%JSONStringify%': [
        'JSON',
        'stringify'
    ],
    '%MapPrototype%': [
        'Map',
        'prototype'
    ],
    '%NumberPrototype%': [
        'Number',
        'prototype'
    ],
    '%ObjectPrototype%': [
        'Object',
        'prototype'
    ],
    '%ObjProto_toString%': [
        'Object',
        'prototype',
        'toString'
    ],
    '%ObjProto_valueOf%': [
        'Object',
        'prototype',
        'valueOf'
    ],
    '%PromisePrototype%': [
        'Promise',
        'prototype'
    ],
    '%PromiseProto_then%': [
        'Promise',
        'prototype',
        'then'
    ],
    '%Promise_all%': [
        'Promise',
        'all'
    ],
    '%Promise_reject%': [
        'Promise',
        'reject'
    ],
    '%Promise_resolve%': [
        'Promise',
        'resolve'
    ],
    '%RangeErrorPrototype%': [
        'RangeError',
        'prototype'
    ],
    '%ReferenceErrorPrototype%': [
        'ReferenceError',
        'prototype'
    ],
    '%RegExpPrototype%': [
        'RegExp',
        'prototype'
    ],
    '%SetPrototype%': [
        'Set',
        'prototype'
    ],
    '%SharedArrayBufferPrototype%': [
        'SharedArrayBuffer',
        'prototype'
    ],
    '%StringPrototype%': [
        'String',
        'prototype'
    ],
    '%SymbolPrototype%': [
        'Symbol',
        'prototype'
    ],
    '%SyntaxErrorPrototype%': [
        'SyntaxError',
        'prototype'
    ],
    '%TypedArrayPrototype%': [
        'TypedArray',
        'prototype'
    ],
    '%TypeErrorPrototype%': [
        'TypeError',
        'prototype'
    ],
    '%Uint8ArrayPrototype%': [
        'Uint8Array',
        'prototype'
    ],
    '%Uint8ClampedArrayPrototype%': [
        'Uint8ClampedArray',
        'prototype'
    ],
    '%Uint16ArrayPrototype%': [
        'Uint16Array',
        'prototype'
    ],
    '%Uint32ArrayPrototype%': [
        'Uint32Array',
        'prototype'
    ],
    '%URIErrorPrototype%': [
        'URIError',
        'prototype'
    ],
    '%WeakMapPrototype%': [
        'WeakMap',
        'prototype'
    ],
    '%WeakSetPrototype%': [
        'WeakSet',
        'prototype'
    ]
};

var $inBv6 = parcelRequire("inBv6");

var $aZSJo = parcelRequire("aZSJo");
var $0db9d6af03f2962b$var$$concat = $inBv6.call($hI0J6, Array.prototype.concat);
var $0db9d6af03f2962b$var$$spliceApply = $inBv6.call($gJ8ML, Array.prototype.splice);
var $0db9d6af03f2962b$var$$replace = $inBv6.call($hI0J6, String.prototype.replace);
var $0db9d6af03f2962b$var$$strSlice = $inBv6.call($hI0J6, String.prototype.slice);
var $0db9d6af03f2962b$var$$exec = $inBv6.call($hI0J6, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $0db9d6af03f2962b$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $0db9d6af03f2962b$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $0db9d6af03f2962b$var$stringToPath = function stringToPath(string) {
    var first = $0db9d6af03f2962b$var$$strSlice(string, 0, 1);
    var last = $0db9d6af03f2962b$var$$strSlice(string, -1);
    if (first === '%' && last !== '%') throw new $bqoCM('invalid intrinsic syntax, expected closing `%`');
    else if (last === '%' && first !== '%') throw new $bqoCM('invalid intrinsic syntax, expected opening `%`');
    var result = [];
    $0db9d6af03f2962b$var$$replace(string, $0db9d6af03f2962b$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $0db9d6af03f2962b$var$$replace(subString, $0db9d6af03f2962b$var$reEscapeChar, '$1') : number || match;
    });
    return result;
};
/* end adaptation */ var $0db9d6af03f2962b$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if ($aZSJo($0db9d6af03f2962b$var$LEGACY_ALIASES, intrinsicName)) {
        alias = $0db9d6af03f2962b$var$LEGACY_ALIASES[intrinsicName];
        intrinsicName = '%' + alias[0] + '%';
    }
    if ($aZSJo($0db9d6af03f2962b$var$INTRINSICS, intrinsicName)) {
        var value = $0db9d6af03f2962b$var$INTRINSICS[intrinsicName];
        if (value === $0db9d6af03f2962b$var$needsEval) value = $0db9d6af03f2962b$var$doEval(intrinsicName);
        if (typeof value === 'undefined' && !allowMissing) throw new $imbfI('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $bqoCM('intrinsic ' + name + ' does not exist!');
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== 'string' || name.length === 0) throw new $imbfI('intrinsic name must be a non-empty string');
    if (arguments.length > 1 && typeof allowMissing !== 'boolean') throw new $imbfI('"allowMissing" argument must be a boolean');
    if ($0db9d6af03f2962b$var$$exec(/^%?[^%]*%?$/, name) === null) throw new $bqoCM('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
    var parts = $0db9d6af03f2962b$var$stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : '';
    var intrinsic = $0db9d6af03f2962b$var$getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $0db9d6af03f2962b$var$$spliceApply(parts, $0db9d6af03f2962b$var$$concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $0db9d6af03f2962b$var$$strSlice(part, 0, 1);
        var last = $0db9d6af03f2962b$var$$strSlice(part, -1);
        if ((first === '"' || first === "'" || first === '`' || last === '"' || last === "'" || last === '`') && first !== last) throw new $bqoCM('property names with quotes must have matching quotes');
        if (part === 'constructor' || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += '.' + part;
        intrinsicRealName = '%' + intrinsicBaseName + '%';
        if ($aZSJo($0db9d6af03f2962b$var$INTRINSICS, intrinsicRealName)) value = $0db9d6af03f2962b$var$INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $imbfI('base intrinsic for ' + name + ' exists, but the property is not available.');
                return void 0;
            }
            if ($kwOoE && i + 1 >= parts.length) {
                var desc = $kwOoE(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && 'get' in desc && !('originalValue' in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = $aZSJo(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) $0db9d6af03f2962b$var$INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};

});
parcelRegister("cAzwJ", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = Object;

});

parcelRegister("b2puG", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = Error;

});

parcelRegister("6RORS", function(module, exports) {
'use strict';
/** @type {import('./eval')} */ module.exports = EvalError;

});

parcelRegister("5KlAG", function(module, exports) {
'use strict';
/** @type {import('./range')} */ module.exports = RangeError;

});

parcelRegister("fVnN9", function(module, exports) {
'use strict';
/** @type {import('./ref')} */ module.exports = ReferenceError;

});

parcelRegister("bqoCM", function(module, exports) {
'use strict';
/** @type {import('./syntax')} */ module.exports = SyntaxError;

});

parcelRegister("P3stF", function(module, exports) {
'use strict';
/** @type {import('./uri')} */ module.exports = URIError;

});

parcelRegister("7ObkT", function(module, exports) {
'use strict';
/** @type {import('./abs')} */ module.exports = Math.abs;

});

parcelRegister("flK97", function(module, exports) {
'use strict';
/** @type {import('./floor')} */ module.exports = Math.floor;

});

parcelRegister("51cuw", function(module, exports) {
'use strict';
/** @type {import('./max')} */ module.exports = Math.max;

});

parcelRegister("ka2TH", function(module, exports) {
'use strict';
/** @type {import('./min')} */ module.exports = Math.min;

});

parcelRegister("bxSFZ", function(module, exports) {
'use strict';
/** @type {import('./pow')} */ module.exports = Math.pow;

});

parcelRegister("gkkDl", function(module, exports) {
'use strict';
/** @type {import('./round')} */ module.exports = Math.round;

});

parcelRegister("jpST6", function(module, exports) {
'use strict';

var $iZgBh = parcelRequire("iZgBh");
/** @type {import('./sign')} */ module.exports = function sign(number) {
    if ($iZgBh(number) || number === 0) return number;
    return number < 0 ? -1 : 1;
};

});
parcelRegister("iZgBh", function(module, exports) {
'use strict';
/** @type {import('./isNaN')} */ module.exports = Number.isNaN || function isNaN(a) {
    return a !== a;
};

});


parcelRegister("kwOoE", function(module, exports) {
'use strict';

var $f6sbl = parcelRequire("f6sbl");
var $ef1de382c41d80d7$require$$gOPD = $f6sbl;
if ($ef1de382c41d80d7$require$$gOPD) try {
    $ef1de382c41d80d7$require$$gOPD([], 'length');
} catch (e) {
    // IE 8 has a broken gOPD
    $ef1de382c41d80d7$require$$gOPD = null;
}
module.exports = $ef1de382c41d80d7$require$$gOPD;

});
parcelRegister("f6sbl", function(module, exports) {
'use strict';
/** @type {import('./gOPD')} */ module.exports = Object.getOwnPropertyDescriptor;

});


parcelRegister("1Yj66", function(module, exports) {
'use strict';
/** @type {import('.')} */ var $16fa356816639152$var$$defineProperty = Object.defineProperty || false;
if ($16fa356816639152$var$$defineProperty) try {
    $16fa356816639152$var$$defineProperty({}, 'a', {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $16fa356816639152$var$$defineProperty = false;
}
module.exports = $16fa356816639152$var$$defineProperty;

});

parcelRegister("hscEj", function(module, exports) {
'use strict';
var $cb4edd0e75614b8d$var$origSymbol = typeof Symbol !== 'undefined' && Symbol;

var $cwWvF = parcelRequire("cwWvF");
/** @type {import('.')} */ module.exports = function hasNativeSymbols() {
    if (typeof $cb4edd0e75614b8d$var$origSymbol !== 'function') return false;
    if (typeof Symbol !== 'function') return false;
    if (typeof $cb4edd0e75614b8d$var$origSymbol('foo') !== 'symbol') return false;
    if (typeof Symbol('bar') !== 'symbol') return false;
    return $cwWvF();
};

});
parcelRegister("cwWvF", function(module, exports) {
'use strict';
/** @type {import('./shams')} */ /* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') return false;
    if (typeof Symbol.iterator === 'symbol') return true;
    /** @type {{ [k in symbol]?: unknown }} */ var obj = {};
    var sym = Symbol('test');
    var symObj = Object(sym);
    if (typeof sym === 'string') return false;
    if (Object.prototype.toString.call(sym) !== '[object Symbol]') return false;
    if (Object.prototype.toString.call(symObj) !== '[object Symbol]') return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(var _ in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === 'function') {
        // eslint-disable-next-line no-extra-parens
        var descriptor = /** @type {PropertyDescriptor} */ Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

});


parcelRegister("9SzeH", function(module, exports) {
'use strict';

var $kyib7 = parcelRequire("kyib7");

var $dZ46W = parcelRequire("dZ46W");

var $75rAh = parcelRequire("75rAh");
/** @type {import('.')} */ module.exports = $kyib7 ? function getProto(O) {
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $kyib7(O);
} : $dZ46W ? function getProto(O) {
    if (!O || typeof O !== 'object' && typeof O !== 'function') throw new TypeError('getProto: not an object');
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $dZ46W(O);
} : $75rAh ? function getProto(O) {
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $75rAh(O);
} : null;

});
parcelRegister("kyib7", function(module, exports) {
'use strict';
/** @type {import('./Reflect.getPrototypeOf')} */ module.exports = typeof Reflect !== 'undefined' && Reflect.getPrototypeOf || null;

});

parcelRegister("dZ46W", function(module, exports) {
'use strict';

var $cAzwJ = parcelRequire("cAzwJ");
/** @type {import('./Object.getPrototypeOf')} */ module.exports = $cAzwJ.getPrototypeOf || null;

});

parcelRegister("75rAh", function(module, exports) {
'use strict';

var $giui0 = parcelRequire("giui0");

var $kwOoE = parcelRequire("kwOoE");
var $528e65ae15a37bd0$var$hasProtoAccessor;
try {
    // eslint-disable-next-line no-extra-parens, no-proto
    $528e65ae15a37bd0$var$hasProtoAccessor = /** @type {{ __proto__?: typeof Array.prototype }} */ [].__proto__ === Array.prototype;
} catch (e) {
    if (!e || typeof e !== 'object' || !('code' in e) || e.code !== 'ERR_PROTO_ACCESS') throw e;
}
// eslint-disable-next-line no-extra-parens
var $528e65ae15a37bd0$var$desc = !!$528e65ae15a37bd0$var$hasProtoAccessor && $kwOoE && $kwOoE(Object.prototype, /** @type {keyof typeof Object.prototype} */ '__proto__');
var $528e65ae15a37bd0$var$$Object = Object;
var $528e65ae15a37bd0$var$$getPrototypeOf = $528e65ae15a37bd0$var$$Object.getPrototypeOf;
/** @type {import('./get')} */ module.exports = $528e65ae15a37bd0$var$desc && typeof $528e65ae15a37bd0$var$desc.get === 'function' ? $giui0([
    $528e65ae15a37bd0$var$desc.get
]) : typeof $528e65ae15a37bd0$var$$getPrototypeOf === 'function' ? /** @type {import('./get')} */ function getDunder(value) {
    // eslint-disable-next-line eqeqeq
    return $528e65ae15a37bd0$var$$getPrototypeOf(value == null ? value : $528e65ae15a37bd0$var$$Object(value));
} : false;

});
parcelRegister("giui0", function(module, exports) {
'use strict';

var $inBv6 = parcelRequire("inBv6");

var $imbfI = parcelRequire("imbfI");

var $hI0J6 = parcelRequire("hI0J6");

var $9xm9a = parcelRequire("9xm9a");
/** @type {(args: [Function, thisArg?: unknown, ...args: unknown[]]) => Function} TODO FIXME, find a way to use import('.') */ module.exports = function callBindBasic(args) {
    if (args.length < 1 || typeof args[0] !== 'function') throw new $imbfI('a function is required');
    return $9xm9a($inBv6, $hI0J6, args);
};

});
parcelRegister("inBv6", function(module, exports) {
'use strict';

var $jIJHT = parcelRequire("jIJHT");
module.exports = Function.prototype.bind || $jIJHT;

});
parcelRegister("jIJHT", function(module, exports) {
'use strict';
/* eslint no-invalid-this: 1 */ var $e5b594d8b609bbe7$var$ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var $e5b594d8b609bbe7$var$toStr = Object.prototype.toString;
var $e5b594d8b609bbe7$var$max = Math.max;
var $e5b594d8b609bbe7$var$funcType = '[object Function]';
var $e5b594d8b609bbe7$var$concatty = function concatty(a, b) {
    var arr = [];
    for(var i = 0; i < a.length; i += 1)arr[i] = a[i];
    for(var j = 0; j < b.length; j += 1)arr[j + a.length] = b[j];
    return arr;
};
var $e5b594d8b609bbe7$var$slicy = function slicy(arrLike, offset) {
    var arr = [];
    for(var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1)arr[j] = arrLike[i];
    return arr;
};
var $e5b594d8b609bbe7$var$joiny = function(arr, joiner) {
    var str = '';
    for(var i = 0; i < arr.length; i += 1){
        str += arr[i];
        if (i + 1 < arr.length) str += joiner;
    }
    return str;
};
module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || $e5b594d8b609bbe7$var$toStr.apply(target) !== $e5b594d8b609bbe7$var$funcType) throw new TypeError($e5b594d8b609bbe7$var$ERROR_MESSAGE + target);
    var args = $e5b594d8b609bbe7$var$slicy(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, $e5b594d8b609bbe7$var$concatty(args, arguments));
            if (Object(result) === result) return result;
            return this;
        }
        return target.apply(that, $e5b594d8b609bbe7$var$concatty(args, arguments));
    };
    var boundLength = $e5b594d8b609bbe7$var$max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs[i] = '$' + i;
    bound = Function('binder', 'return function (' + $e5b594d8b609bbe7$var$joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }')(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};

});


parcelRegister("hI0J6", function(module, exports) {
'use strict';
/** @type {import('./functionCall')} */ module.exports = Function.prototype.call;

});

parcelRegister("9xm9a", function(module, exports) {
'use strict';

var $inBv6 = parcelRequire("inBv6");

var $gJ8ML = parcelRequire("gJ8ML");

var $hI0J6 = parcelRequire("hI0J6");

var $hVYnJ = parcelRequire("hVYnJ");
/** @type {import('./actualApply')} */ module.exports = $hVYnJ || $inBv6.call($hI0J6, $gJ8ML);

});
parcelRegister("gJ8ML", function(module, exports) {
'use strict';
/** @type {import('./functionApply')} */ module.exports = Function.prototype.apply;

});

parcelRegister("hVYnJ", function(module, exports) {
'use strict';
/** @type {import('./reflectApply')} */ module.exports = typeof Reflect !== 'undefined' && Reflect && Reflect.apply;

});





parcelRegister("aZSJo", function(module, exports) {
'use strict';
var $801a0e5d4d107659$var$call = Function.prototype.call;
var $801a0e5d4d107659$var$$hasOwn = Object.prototype.hasOwnProperty;

var $inBv6 = parcelRequire("inBv6");
/** @type {import('.')} */ module.exports = $inBv6.call($801a0e5d4d107659$var$call, $801a0e5d4d107659$var$$hasOwn);

});


parcelRegister("f8M6V", function(module, exports) {
'use strict';

var $1b3Ts = parcelRequire("1b3Ts");

var $giui0 = parcelRequire("giui0");
/** @type {(thisArg: string, searchString: string, position?: number) => number} */ var $b05cec235cb4c256$var$$indexOf = $giui0([
    $1b3Ts('%String.prototype.indexOf%')
]);
/** @type {import('.')} */ module.exports = function callBoundIntrinsic(name, allowMissing) {
    /* eslint no-extra-parens: 0 */ var intrinsic = /** @type {(this: unknown, ...args: unknown[]) => unknown} */ $1b3Ts(name, !!allowMissing);
    if (typeof intrinsic === 'function' && $b05cec235cb4c256$var$$indexOf(name, '.prototype.') > -1) return $giui0(/** @type {const} */ [
        intrinsic
    ]);
    return intrinsic;
};

});


parcelRegister("k4N9m", function(module, exports) {
'use strict';

var $1b3Ts = parcelRequire("1b3Ts");

var $f8M6V = parcelRequire("f8M6V");

var $ei9z1 = parcelRequire("ei9z1");

var $fb4bS = parcelRequire("fb4bS");

var $imbfI = parcelRequire("imbfI");
var $e9da4e84b91c7738$var$$WeakMap = $1b3Ts('%WeakMap%', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => V} */ var $e9da4e84b91c7738$var$$weakMapGet = $f8M6V('WeakMap.prototype.get', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K, value: V) => void} */ var $e9da4e84b91c7738$var$$weakMapSet = $f8M6V('WeakMap.prototype.set', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => boolean} */ var $e9da4e84b91c7738$var$$weakMapHas = $f8M6V('WeakMap.prototype.has', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => boolean} */ var $e9da4e84b91c7738$var$$weakMapDelete = $f8M6V('WeakMap.prototype.delete', true);
/** @type {import('.')} */ module.exports = $e9da4e84b91c7738$var$$WeakMap ? /** @type {Exclude<import('.'), false>} */ function getSideChannelWeakMap() {
    /** @typedef {ReturnType<typeof getSideChannelWeakMap>} Channel */ /** @typedef {Parameters<Channel['get']>[0]} K */ /** @typedef {Parameters<Channel['set']>[1]} V */ /** @type {WeakMap<K & object, V> | undefined} */ var $wm;
    /** @type {Channel | undefined} */ var $m;
    /** @type {Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $imbfI('Side channel does not contain ' + $ei9z1(key));
        },
        'delete': function(key) {
            if ($e9da4e84b91c7738$var$$WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                if ($wm) return $e9da4e84b91c7738$var$$weakMapDelete($wm, key);
            } else if ($fb4bS) {
                if ($m) return $m['delete'](key);
            }
            return false;
        },
        get: function(key) {
            if ($e9da4e84b91c7738$var$$WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                if ($wm) return $e9da4e84b91c7738$var$$weakMapGet($wm, key);
            }
            return $m && $m.get(key);
        },
        has: function(key) {
            if ($e9da4e84b91c7738$var$$WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                if ($wm) return $e9da4e84b91c7738$var$$weakMapHas($wm, key);
            }
            return !!$m && $m.has(key);
        },
        set: function(key, value) {
            if ($e9da4e84b91c7738$var$$WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                if (!$wm) $wm = new $e9da4e84b91c7738$var$$WeakMap();
                $e9da4e84b91c7738$var$$weakMapSet($wm, key, value);
            } else if ($fb4bS) {
                if (!$m) $m = $fb4bS();
                // eslint-disable-next-line no-extra-parens
                /** @type {NonNullable<typeof $m>} */ $m.set(key, value);
            }
        }
    };
    // @ts-expect-error TODO: figure out why this is erroring
    return channel;
} : $fb4bS;

});


parcelRegister("8lLMe", function(module, exports) {
'use strict';

var $840D7 = parcelRequire("840D7");
var $614558692437b4be$var$has = Object.prototype.hasOwnProperty;
var $614558692437b4be$var$isArray = Array.isArray;
var $614558692437b4be$var$hexTable = function() {
    var array = [];
    for(var i = 0; i < 256; ++i)array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
    return array;
}();
var $614558692437b4be$var$compactQueue = function compactQueue(queue) {
    while(queue.length > 1){
        var item = queue.pop();
        var obj = item.obj[item.prop];
        if ($614558692437b4be$var$isArray(obj)) {
            var compacted = [];
            for(var j = 0; j < obj.length; ++j)if (typeof obj[j] !== 'undefined') compacted.push(obj[j]);
            item.obj[item.prop] = compacted;
        }
    }
};
var $614558692437b4be$var$arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? Object.create(null) : {};
    for(var i = 0; i < source.length; ++i)if (typeof source[i] !== 'undefined') obj[i] = source[i];
    return obj;
};
var $614558692437b4be$var$merge = function merge(target, source, options) {
    /* eslint no-param-reassign: 0 */ if (!source) return target;
    if (typeof source !== 'object') {
        if ($614558692437b4be$var$isArray(target)) target.push(source);
        else if (target && typeof target === 'object') {
            if (options && (options.plainObjects || options.allowPrototypes) || !$614558692437b4be$var$has.call(Object.prototype, source)) target[source] = true;
        } else return [
            target,
            source
        ];
        return target;
    }
    if (!target || typeof target !== 'object') return [
        target
    ].concat(source);
    var mergeTarget = target;
    if ($614558692437b4be$var$isArray(target) && !$614558692437b4be$var$isArray(source)) mergeTarget = $614558692437b4be$var$arrayToObject(target, options);
    if ($614558692437b4be$var$isArray(target) && $614558692437b4be$var$isArray(source)) {
        source.forEach(function(item, i) {
            if ($614558692437b4be$var$has.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === 'object' && item && typeof item === 'object') target[i] = merge(targetItem, item, options);
                else target.push(item);
            } else target[i] = item;
        });
        return target;
    }
    return Object.keys(source).reduce(function(acc, key) {
        var value = source[key];
        if ($614558692437b4be$var$has.call(acc, key)) acc[key] = merge(acc[key], value, options);
        else acc[key] = value;
        return acc;
    }, mergeTarget);
};
var $614558692437b4be$var$assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function(acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};
var $614558692437b4be$var$decode = function(str, decoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, ' ');
    if (charset === 'iso-8859-1') // unescape never throws, no try...catch needed:
    return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};
var $614558692437b4be$var$encode = function encode(str, defaultEncoder, charset, kind, format) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) return str;
    var string = str;
    if (typeof str === 'symbol') string = Symbol.prototype.toString.call(str);
    else if (typeof str !== 'string') string = String(str);
    if (charset === 'iso-8859-1') return escape(string).replace(/%u[0-9a-f]{4}/gi, function($0) {
        return '%26%23' + parseInt($0.slice(2), 16) + '%3B';
    });
    var out = '';
    for(var i = 0; i < string.length; ++i){
        var c = string.charCodeAt(i);
        if (c === 0x2D // -
         || c === 0x2E // .
         || c === 0x5F // _
         || c === 0x7E // ~
         || c >= 0x30 && c <= 0x39 // 0-9
         || c >= 0x41 && c <= 0x5A // a-z
         || c >= 0x61 && c <= 0x7A // A-Z
         || format === $840D7.RFC1738 && (c === 0x28 || c === 0x29) // ( )
        ) {
            out += string.charAt(i);
            continue;
        }
        if (c < 0x80) {
            out = out + $614558692437b4be$var$hexTable[c];
            continue;
        }
        if (c < 0x800) {
            out = out + ($614558692437b4be$var$hexTable[0xC0 | c >> 6] + $614558692437b4be$var$hexTable[0x80 | c & 0x3F]);
            continue;
        }
        if (c < 0xD800 || c >= 0xE000) {
            out = out + ($614558692437b4be$var$hexTable[0xE0 | c >> 12] + $614558692437b4be$var$hexTable[0x80 | c >> 6 & 0x3F] + $614558692437b4be$var$hexTable[0x80 | c & 0x3F]);
            continue;
        }
        i += 1;
        c = 0x10000 + ((c & 0x3FF) << 10 | string.charCodeAt(i) & 0x3FF);
        /* eslint operator-linebreak: [2, "before"] */ out += $614558692437b4be$var$hexTable[0xF0 | c >> 18] + $614558692437b4be$var$hexTable[0x80 | c >> 12 & 0x3F] + $614558692437b4be$var$hexTable[0x80 | c >> 6 & 0x3F] + $614558692437b4be$var$hexTable[0x80 | c & 0x3F];
    }
    return out;
};
var $614558692437b4be$var$compact = function compact(value) {
    var queue = [
        {
            obj: {
                o: value
            },
            prop: 'o'
        }
    ];
    var refs = [];
    for(var i = 0; i < queue.length; ++i){
        var item = queue[i];
        var obj = item.obj[item.prop];
        var keys = Object.keys(obj);
        for(var j = 0; j < keys.length; ++j){
            var key = keys[j];
            var val = obj[key];
            if (typeof val === 'object' && val !== null && refs.indexOf(val) === -1) {
                queue.push({
                    obj: obj,
                    prop: key
                });
                refs.push(val);
            }
        }
    }
    $614558692437b4be$var$compactQueue(queue);
    return value;
};
var $614558692437b4be$var$isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === '[object RegExp]';
};
var $614558692437b4be$var$isBuffer = function isBuffer(obj) {
    if (!obj || typeof obj !== 'object') return false;
    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};
var $614558692437b4be$var$combine = function combine(a, b) {
    return [].concat(a, b);
};
var $614558692437b4be$var$maybeMap = function maybeMap(val, fn) {
    if ($614558692437b4be$var$isArray(val)) {
        var mapped = [];
        for(var i = 0; i < val.length; i += 1)mapped.push(fn(val[i]));
        return mapped;
    }
    return fn(val);
};
module.exports = {
    arrayToObject: $614558692437b4be$var$arrayToObject,
    assign: $614558692437b4be$var$assign,
    combine: $614558692437b4be$var$combine,
    compact: $614558692437b4be$var$compact,
    decode: $614558692437b4be$var$decode,
    encode: $614558692437b4be$var$encode,
    isBuffer: $614558692437b4be$var$isBuffer,
    isRegExp: $614558692437b4be$var$isRegExp,
    maybeMap: $614558692437b4be$var$maybeMap,
    merge: $614558692437b4be$var$merge
};

});
parcelRegister("840D7", function(module, exports) {
'use strict';
var $5def2f8685b79f4e$var$replace = String.prototype.replace;
var $5def2f8685b79f4e$var$percentTwenties = /%20/g;
var $5def2f8685b79f4e$var$Format = {
    RFC1738: 'RFC1738',
    RFC3986: 'RFC3986'
};
module.exports = {
    'default': $5def2f8685b79f4e$var$Format.RFC3986,
    formatters: {
        RFC1738: function(value) {
            return $5def2f8685b79f4e$var$replace.call(value, $5def2f8685b79f4e$var$percentTwenties, '+');
        },
        RFC3986: function(value) {
            return String(value);
        }
    },
    RFC1738: $5def2f8685b79f4e$var$Format.RFC1738,
    RFC3986: $5def2f8685b79f4e$var$Format.RFC3986
};

});



parcelRegister("3Zdci", function(module, exports) {
'use strict';

var $8lLMe = parcelRequire("8lLMe");
var $2e714e531c665c63$var$has = Object.prototype.hasOwnProperty;
var $2e714e531c665c63$var$isArray = Array.isArray;
var $2e714e531c665c63$var$defaults = {
    allowDots: false,
    allowPrototypes: false,
    allowSparse: false,
    arrayLimit: 20,
    charset: 'utf-8',
    charsetSentinel: false,
    comma: false,
    decoder: $8lLMe.decode,
    delimiter: '&',
    depth: 5,
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictNullHandling: false
};
var $2e714e531c665c63$var$interpretNumericEntities = function(str) {
    return str.replace(/&#(\d+);/g, function($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};
var $2e714e531c665c63$var$parseArrayValue = function(val, options) {
    if (val && typeof val === 'string' && options.comma && val.indexOf(',') > -1) return val.split(',');
    return val;
};
// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var $2e714e531c665c63$var$isoSentinel = 'utf8=%26%2310003%3B'; // encodeURIComponent('&#10003;')
// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var $2e714e531c665c63$var$charsetSentinel = 'utf8=%E2%9C%93'; // encodeURIComponent('✓')
var $2e714e531c665c63$var$parseValues = function parseQueryStringValues(str, options) {
    var obj = {
        __proto__: null
    };
    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, limit);
    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;
    var charset = options.charset;
    if (options.charsetSentinel) {
        for(i = 0; i < parts.length; ++i)if (parts[i].indexOf('utf8=') === 0) {
            if (parts[i] === $2e714e531c665c63$var$charsetSentinel) charset = 'utf-8';
            else if (parts[i] === $2e714e531c665c63$var$isoSentinel) charset = 'iso-8859-1';
            skipIndex = i;
            i = parts.length; // The eslint settings do not allow break;
        }
    }
    for(i = 0; i < parts.length; ++i){
        if (i === skipIndex) continue;
        var part = parts[i];
        var bracketEqualsPos = part.indexOf(']=');
        var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;
        var key, val;
        if (pos === -1) {
            key = options.decoder(part, $2e714e531c665c63$var$defaults.decoder, charset, 'key');
            val = options.strictNullHandling ? null : '';
        } else {
            key = options.decoder(part.slice(0, pos), $2e714e531c665c63$var$defaults.decoder, charset, 'key');
            val = $8lLMe.maybeMap($2e714e531c665c63$var$parseArrayValue(part.slice(pos + 1), options), function(encodedVal) {
                return options.decoder(encodedVal, $2e714e531c665c63$var$defaults.decoder, charset, 'value');
            });
        }
        if (val && options.interpretNumericEntities && charset === 'iso-8859-1') val = $2e714e531c665c63$var$interpretNumericEntities(val);
        if (part.indexOf('[]=') > -1) val = $2e714e531c665c63$var$isArray(val) ? [
            val
        ] : val;
        if ($2e714e531c665c63$var$has.call(obj, key)) obj[key] = $8lLMe.combine(obj[key], val);
        else obj[key] = val;
    }
    return obj;
};
var $2e714e531c665c63$var$parseObject = function(chain, val, options, valuesParsed) {
    var leaf = valuesParsed ? val : $2e714e531c665c63$var$parseArrayValue(val, options);
    for(var i = chain.length - 1; i >= 0; --i){
        var obj;
        var root = chain[i];
        if (root === '[]' && options.parseArrays) obj = [].concat(leaf);
        else {
            obj = options.plainObjects ? Object.create(null) : {};
            var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
            var index = parseInt(cleanRoot, 10);
            if (!options.parseArrays && cleanRoot === '') obj = {
                0: leaf
            };
            else if (!isNaN(index) && root !== cleanRoot && String(index) === cleanRoot && index >= 0 && options.parseArrays && index <= options.arrayLimit) {
                obj = [];
                obj[index] = leaf;
            } else if (cleanRoot !== '__proto__') obj[cleanRoot] = leaf;
        }
        leaf = obj;
    }
    return leaf;
};
var $2e714e531c665c63$var$parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
    if (!givenKey) return;
    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;
    // The regex chunks
    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;
    // Get the parent
    var segment = options.depth > 0 && brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;
    // Stash the parent if it exists
    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
        if (!options.plainObjects && $2e714e531c665c63$var$has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) return;
        }
        keys.push(parent);
    }
    // Loop through children appending to the array until we hit depth
    var i = 0;
    while(options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth){
        i += 1;
        if (!options.plainObjects && $2e714e531c665c63$var$has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) return;
        }
        keys.push(segment[1]);
    }
    // If there's a remainder, just add whatever is left
    if (segment) keys.push('[' + key.slice(segment.index) + ']');
    return $2e714e531c665c63$var$parseObject(keys, val, options, valuesParsed);
};
var $2e714e531c665c63$var$normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) return $2e714e531c665c63$var$defaults;
    if (opts.decoder !== null && opts.decoder !== undefined && typeof opts.decoder !== 'function') throw new TypeError('Decoder has to be a function.');
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    var charset = typeof opts.charset === 'undefined' ? $2e714e531c665c63$var$defaults.charset : opts.charset;
    return {
        allowDots: typeof opts.allowDots === 'undefined' ? $2e714e531c665c63$var$defaults.allowDots : !!opts.allowDots,
        allowPrototypes: typeof opts.allowPrototypes === 'boolean' ? opts.allowPrototypes : $2e714e531c665c63$var$defaults.allowPrototypes,
        allowSparse: typeof opts.allowSparse === 'boolean' ? opts.allowSparse : $2e714e531c665c63$var$defaults.allowSparse,
        arrayLimit: typeof opts.arrayLimit === 'number' ? opts.arrayLimit : $2e714e531c665c63$var$defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : $2e714e531c665c63$var$defaults.charsetSentinel,
        comma: typeof opts.comma === 'boolean' ? opts.comma : $2e714e531c665c63$var$defaults.comma,
        decoder: typeof opts.decoder === 'function' ? opts.decoder : $2e714e531c665c63$var$defaults.decoder,
        delimiter: typeof opts.delimiter === 'string' || $8lLMe.isRegExp(opts.delimiter) ? opts.delimiter : $2e714e531c665c63$var$defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: typeof opts.depth === 'number' || opts.depth === false ? +opts.depth : $2e714e531c665c63$var$defaults.depth,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === 'boolean' ? opts.interpretNumericEntities : $2e714e531c665c63$var$defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === 'number' ? opts.parameterLimit : $2e714e531c665c63$var$defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === 'boolean' ? opts.plainObjects : $2e714e531c665c63$var$defaults.plainObjects,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : $2e714e531c665c63$var$defaults.strictNullHandling
    };
};
module.exports = function(str, opts) {
    var options = $2e714e531c665c63$var$normalizeParseOptions(opts);
    if (str === '' || str === null || typeof str === 'undefined') return options.plainObjects ? Object.create(null) : {};
    var tempObj = typeof str === 'string' ? $2e714e531c665c63$var$parseValues(str, options) : str;
    var obj = options.plainObjects ? Object.create(null) : {};
    // Iterate over the keys and setup the new object
    var keys = Object.keys(tempObj);
    for(var i = 0; i < keys.length; ++i){
        var key = keys[i];
        var newObj = $2e714e531c665c63$var$parseKeys(key, tempObj[key], options, typeof str === 'string');
        obj = $8lLMe.merge(obj, newObj, options);
    }
    if (options.allowSparse === true) return obj;
    return $8lLMe.compact(obj);
};

});


parcelRegister("1JHoV", function(module, exports) {
'use strict';
module.exports = (str)=>encodeURIComponent(str).replace(/[!'()*]/g, (x)=>`%${x.charCodeAt(0).toString(16).toUpperCase()}`);

});

parcelRegister("2iO0O", function(module, exports) {
'use strict';
var $1ad40e96a05a6e30$var$token = '%[a-f0-9]{2}';
var $1ad40e96a05a6e30$var$singleMatcher = new RegExp('(' + $1ad40e96a05a6e30$var$token + ')|([^%]+?)', 'gi');
var $1ad40e96a05a6e30$var$multiMatcher = new RegExp('(' + $1ad40e96a05a6e30$var$token + ')+', 'gi');
function $1ad40e96a05a6e30$var$decodeComponents(components, split) {
    try {
        // Try to decode the entire string first
        return [
            decodeURIComponent(components.join(''))
        ];
    } catch (err) {
    // Do nothing
    }
    if (components.length === 1) return components;
    split = split || 1;
    // Split the array in 2 parts
    var left = components.slice(0, split);
    var right = components.slice(split);
    return Array.prototype.concat.call([], $1ad40e96a05a6e30$var$decodeComponents(left), $1ad40e96a05a6e30$var$decodeComponents(right));
}
function $1ad40e96a05a6e30$var$decode(input) {
    try {
        return decodeURIComponent(input);
    } catch (err) {
        var tokens = input.match($1ad40e96a05a6e30$var$singleMatcher) || [];
        for(var i = 1; i < tokens.length; i++){
            input = $1ad40e96a05a6e30$var$decodeComponents(tokens, i).join('');
            tokens = input.match($1ad40e96a05a6e30$var$singleMatcher) || [];
        }
        return input;
    }
}
function $1ad40e96a05a6e30$var$customDecodeURIComponent(input) {
    // Keep track of all the replacements and prefill the map with the `BOM`
    var replaceMap = {
        '%FE%FF': '\uFFFD\uFFFD',
        '%FF%FE': '\uFFFD\uFFFD'
    };
    var match = $1ad40e96a05a6e30$var$multiMatcher.exec(input);
    while(match){
        try {
            // Decode as big chunks as possible
            replaceMap[match[0]] = decodeURIComponent(match[0]);
        } catch (err) {
            var result = $1ad40e96a05a6e30$var$decode(match[0]);
            if (result !== match[0]) replaceMap[match[0]] = result;
        }
        match = $1ad40e96a05a6e30$var$multiMatcher.exec(input);
    }
    // Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
    replaceMap['%C2'] = '\uFFFD';
    var entries = Object.keys(replaceMap);
    for(var i = 0; i < entries.length; i++){
        // Replace all decoded components
        var key = entries[i];
        input = input.replace(new RegExp(key, 'g'), replaceMap[key]);
    }
    return input;
}
module.exports = function(encodedURI) {
    if (typeof encodedURI !== 'string') throw new TypeError('Expected `encodedURI` to be of type `string`, got `' + typeof encodedURI + '`');
    try {
        encodedURI = encodedURI.replace(/\+/g, ' ');
        // Try the built in decoder first
        return decodeURIComponent(encodedURI);
    } catch (err) {
        // Fallback to a more advanced decoder
        return $1ad40e96a05a6e30$var$customDecodeURIComponent(encodedURI);
    }
};

});

parcelRegister("bhk36", function(module, exports) {
'use strict';
module.exports = (string, separator)=>{
    if (!(typeof string === 'string' && typeof separator === 'string')) throw new TypeError('Expected the arguments to be of type `string`');
    if (separator === '') return [
        string
    ];
    const separatorIndex = string.indexOf(separator);
    if (separatorIndex === -1) return [
        string
    ];
    return [
        string.slice(0, separatorIndex),
        string.slice(separatorIndex + separator.length)
    ];
};

});

parcelRegister("a2hoO", function(module, exports) {
'use strict';
module.exports = function(obj, predicate) {
    var ret = {};
    var keys = Object.keys(obj);
    var isArr = Array.isArray(predicate);
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        var val = obj[key];
        if (isArr ? predicate.indexOf(key) !== -1 : predicate(key, val, obj)) ret[key] = val;
    }
    return ret;
};

});

parcelRegister("2Ow0n", function(module, exports) {
'use strict';

var $4NlF5 = parcelRequire("4NlF5");
/**
 * Expose `traverse`.
 */ module.exports = $20c913d73e3529a8$var$traverse;
/**
 * Recursively traverse an object or array, and convert
 * all ISO date strings parse into Date objects.
 *
 * @param {Object} input - object, array, or string to convert
 * @param {Boolean} strict - only convert strings with year, month, and date
 * @return {Object}
 */ function $20c913d73e3529a8$var$traverse(input, strict) {
    if (strict === undefined) strict = true;
    if (input && typeof input === 'object') return $20c913d73e3529a8$var$traverseObject(input, strict);
    else if (Array.isArray(input)) return $20c913d73e3529a8$var$traverseArray(input, strict);
    else if ($4NlF5.is(input, strict)) return $4NlF5.parse(input);
    return input;
}
/**
 * Object traverser helper function.
 *
 * @param {Object} obj - object to traverse
 * @param {Boolean} strict - only convert strings with year, month, and date
 * @return {Object}
 */ function $20c913d73e3529a8$var$traverseObject(obj, strict) {
    Object.keys(obj).forEach(function(key) {
        obj[key] = $20c913d73e3529a8$var$traverse(obj[key], strict);
    });
    return obj;
}
/**
 * Array traverser helper function
 *
 * @param {Array} arr - array to traverse
 * @param {Boolean} strict - only convert strings with year, month, and date
 * @return {Array}
 */ function $20c913d73e3529a8$var$traverseArray(arr, strict) {
    arr.forEach(function(value, index) {
        arr[index] = $20c913d73e3529a8$var$traverse(value, strict);
    });
    return arr;
}

});
parcelRegister("4NlF5", function(module, exports) {
$parcel$export(module.exports, "parse", () => $37dc8a970ce8bd04$export$98e6a39c04603d36, (v) => $37dc8a970ce8bd04$export$98e6a39c04603d36 = v);
$parcel$export(module.exports, "is", () => $37dc8a970ce8bd04$export$226b3eccf92c9ed9, (v) => $37dc8a970ce8bd04$export$226b3eccf92c9ed9 = v);
/**
 * Convert an ISO date string to a date. Fallback to native `Date.parse`.
 *
 * https://github.com/csnover/js-iso8601/blob/lax/iso8601.js
 *
 * @param {String} iso
 * @return {Date}
 */ var $37dc8a970ce8bd04$export$98e6a39c04603d36;
/**
 * Checks whether a `string` is an ISO date string. `strict` mode requires that
 * the date string at least have a year, month and date.
 *
 * @param {String} string
 * @param {Boolean} strict
 * @return {Boolean}
 */ var $37dc8a970ce8bd04$export$226b3eccf92c9ed9;
'use strict';
/**
 * Matcher, slightly modified from:
 *
 * https://github.com/csnover/js-iso8601/blob/lax/iso8601.js
 */ var $37dc8a970ce8bd04$var$matcher = /^(\d{4})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:([ T])(\d{2}):?(\d{2})(?::?(\d{2})(?:[,\.](\d{1,}))?)?(?:(Z)|([+\-])(\d{2})(?::?(\d{2}))?)?)?$/;
$37dc8a970ce8bd04$export$98e6a39c04603d36 = function(iso) {
    var numericKeys = [
        1,
        5,
        6,
        7,
        11,
        12
    ];
    var arr = $37dc8a970ce8bd04$var$matcher.exec(iso);
    var offset = 0;
    // fallback to native parsing
    if (!arr) return new Date(iso);
    /* eslint-disable no-cond-assign */ // remove undefined values
    for(var i = 0, val; val = numericKeys[i]; i++)arr[val] = parseInt(arr[val], 10) || 0;
    /* eslint-enable no-cond-assign */ // allow undefined days and months
    arr[2] = parseInt(arr[2], 10) || 1;
    arr[3] = parseInt(arr[3], 10) || 1;
    // month is 0-11
    arr[2]--;
    // allow abitrary sub-second precision
    arr[8] = arr[8] ? (arr[8] + '00').substring(0, 3) : 0;
    // apply timezone if one exists
    if (arr[4] === ' ') offset = new Date().getTimezoneOffset();
    else if (arr[9] !== 'Z' && arr[10]) {
        offset = arr[11] * 60 + arr[12];
        if (arr[10] === '+') offset = 0 - offset;
    }
    var millis = Date.UTC(arr[1], arr[2], arr[3], arr[5], arr[6] + offset, arr[7], arr[8]);
    return new Date(millis);
};
$37dc8a970ce8bd04$export$226b3eccf92c9ed9 = function(string, strict) {
    if (typeof string !== 'string') return false;
    if (strict && /^\d{4}-\d{2}-\d{2}/.test(string) === false) return false;
    return $37dc8a970ce8bd04$var$matcher.test(string);
};

});


parcelRegister("l4vpb", function(module, exports) {
(function(root, factory) {
    module.exports = factory();
})(module.exports, function() {
    /**
   * @constructor
   */ function UrlTemplate() {}
    /**
   * @private
   * @param {string} str
   * @return {string}
   */ UrlTemplate.prototype.encodeReserved = function(str) {
        return str.split(/(%[0-9A-Fa-f]{2})/g).map(function(part) {
            if (!/%[0-9A-Fa-f]/.test(part)) part = encodeURI(part).replace(/%5B/g, '[').replace(/%5D/g, ']');
            return part;
        }).join('');
    };
    /**
   * @private
   * @param {string} str
   * @return {string}
   */ UrlTemplate.prototype.encodeUnreserved = function(str) {
        return encodeURIComponent(str).replace(/[!'()*]/g, function(c) {
            return '%' + c.charCodeAt(0).toString(16).toUpperCase();
        });
    };
    /**
   * @private
   * @param {string} operator
   * @param {string} value
   * @param {string} key
   * @return {string}
   */ UrlTemplate.prototype.encodeValue = function(operator, value, key) {
        value = operator === '+' || operator === '#' ? this.encodeReserved(value) : this.encodeUnreserved(value);
        if (key) return this.encodeUnreserved(key) + '=' + value;
        else return value;
    };
    /**
   * @private
   * @param {*} value
   * @return {boolean}
   */ UrlTemplate.prototype.isDefined = function(value) {
        return value !== undefined && value !== null;
    };
    /**
   * @private
   * @param {string}
   * @return {boolean}
   */ UrlTemplate.prototype.isKeyOperator = function(operator) {
        return operator === ';' || operator === '&' || operator === '?';
    };
    /**
   * @private
   * @param {Object} context
   * @param {string} operator
   * @param {string} key
   * @param {string} modifier
   */ UrlTemplate.prototype.getValues = function(context, operator, key, modifier) {
        var value = context[key], result = [];
        if (this.isDefined(value) && value !== '') {
            if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
                value = value.toString();
                if (modifier && modifier !== '*') value = value.substring(0, parseInt(modifier, 10));
                result.push(this.encodeValue(operator, value, this.isKeyOperator(operator) ? key : null));
            } else if (modifier === '*') {
                if (Array.isArray(value)) value.filter(this.isDefined).forEach(function(value) {
                    result.push(this.encodeValue(operator, value, this.isKeyOperator(operator) ? key : null));
                }, this);
                else Object.keys(value).forEach(function(k) {
                    if (this.isDefined(value[k])) result.push(this.encodeValue(operator, value[k], k));
                }, this);
            } else {
                var tmp = [];
                if (Array.isArray(value)) value.filter(this.isDefined).forEach(function(value) {
                    tmp.push(this.encodeValue(operator, value));
                }, this);
                else Object.keys(value).forEach(function(k) {
                    if (this.isDefined(value[k])) {
                        tmp.push(this.encodeUnreserved(k));
                        tmp.push(this.encodeValue(operator, value[k].toString()));
                    }
                }, this);
                if (this.isKeyOperator(operator)) result.push(this.encodeUnreserved(key) + '=' + tmp.join(','));
                else if (tmp.length !== 0) result.push(tmp.join(','));
            }
        } else {
            if (operator === ';') {
                if (this.isDefined(value)) result.push(this.encodeUnreserved(key));
            } else if (value === '' && (operator === '&' || operator === '?')) result.push(this.encodeUnreserved(key) + '=');
            else if (value === '') result.push('');
        }
        return result;
    };
    /**
   * @param {string} template
   * @return {function(Object):string}
   */ UrlTemplate.prototype.parse = function(template) {
        var that = this;
        var operators = [
            '+',
            '#',
            '.',
            '/',
            ';',
            '?',
            '&'
        ];
        return {
            expand: function(context) {
                return template.replace(/\{([^\{\}]+)\}|([^\{\}]+)/g, function(_, expression, literal) {
                    if (expression) {
                        var operator = null, values = [];
                        if (operators.indexOf(expression.charAt(0)) !== -1) {
                            operator = expression.charAt(0);
                            expression = expression.substr(1);
                        }
                        expression.split(/,/g).forEach(function(variable) {
                            var tmp = /([^:\*]*)(?::(\d+)|(\*))?/.exec(variable);
                            values.push.apply(values, that.getValues(context, operator, tmp[1], tmp[2] || tmp[3]));
                        });
                        if (operator && operator !== '+') {
                            var separator = ',';
                            if (operator === '?') separator = '&';
                            else if (operator !== '#') separator = operator;
                            return (values.length !== 0 ? operator : '') + values.join(separator);
                        } else return values.join(',');
                    } else return that.encodeReserved(literal);
                });
            }
        };
    };
    return new UrlTemplate();
});

});

parcelRegister("02u1x", function(module, exports) {
'use strict';
module.exports = typeof self === 'object' && self.self === self && self || typeof $parcel$global === 'object' && $parcel$global.global === $parcel$global && $parcel$global || module.exports;

});

parcelRegister("gRw8I", function(module, exports) {
$parcel$export(module.exports, "di", () => $c46a86d20365f03b$export$479d1ccc5f2ab701);

var $hbWUh = parcelRequire("hbWUh");

var $g5EyN = parcelRequire("g5EyN");
function $c46a86d20365f03b$export$479d1ccc5f2ab701(target, ...deps) {
    // Read context and grab all the dependencies override Providers in the tree
    const { getDependencies: getDependencies } = // grab value from alt renderer (eg react-test-renderer)
    (0, $hbWUh.Context)._currentRenderer2 && (0, $hbWUh.Context)._currentValue2 || // grab value from default renderer
    (0, $hbWUh.Context)._currentValue || (0, $g5EyN.globalDi);
    return getDependencies(deps, target);
}

});
parcelRegister("hbWUh", function(module, exports) {
$parcel$export(module.exports, "Context", () => $c84128680f478aa5$export$841858b892ce1f4c);

var $eJOHy = parcelRequire("eJOHy");

var $g5EyN = parcelRequire("g5EyN");
const $c84128680f478aa5$export$841858b892ce1f4c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createContext({
    getDependencies: (0, $g5EyN.globalDi).getDependencies
});

});
parcelRegister("g5EyN", function(module, exports) {
$parcel$export(module.exports, "globalDi", () => $bb6c936886e62508$export$a775919ebd7dd28a);

var $2LjoR = parcelRequire("2LjoR");

var $lKDUN = parcelRequire("lKDUN");
const $bb6c936886e62508$var$replacementMap = new Map();
const $bb6c936886e62508$export$a775919ebd7dd28a = {
    getDependencies (realDeps, targetChild) {
        if ($bb6c936886e62508$var$replacementMap.size) for(let i = 0; i < realDeps.length; i++){
            const replacedInj = (0, $lKDUN.findInjectable)($bb6c936886e62508$var$replacementMap, realDeps[i], targetChild);
            if (replacedInj) realDeps[i] = replacedInj.value;
        }
        return realDeps;
    },
    use (injs) {
        if ($bb6c936886e62508$var$replacementMap.size) throw new Error(`${(0, $2LjoR.PACKAGE_NAME)} has replacements configured already. ` + `Implicit merging is not supported, so please concatenate injectables. ` + `If this is not expected, please file a bug report`);
        injs.forEach((inj)=>(0, $lKDUN.addInjectableToMap)($bb6c936886e62508$var$replacementMap, inj));
    },
    clear () {
        $bb6c936886e62508$var$replacementMap.clear();
    },
    _fromProvider (injs, props = {}) {
        injs.forEach((inj)=>{
            if (props.global || (0, $2LjoR.diRegistry).get(inj).global) (0, $lKDUN.addInjectableToMap)($bb6c936886e62508$var$replacementMap, inj);
        });
    },
    _remove (injs) {
        injs.forEach((inj)=>(0, $lKDUN.removeInjectableFromMap)($bb6c936886e62508$var$replacementMap, inj));
    }
};
function $bb6c936886e62508$export$b887ce09d70113f9(thunk, deps) {
    $bb6c936886e62508$export$a775919ebd7dd28a.use(deps);
    let result;
    try {
        result = thunk();
        return result;
    } finally{
        // autocleanup dependences if either async or sync
        if (result && typeof result === 'object' && typeof result.then === 'function') // dont use finally as it "multiplies" rejected promises
        result.then($bb6c936886e62508$export$a775919ebd7dd28a.clear, $bb6c936886e62508$export$a775919ebd7dd28a.clear);
        else $bb6c936886e62508$export$a775919ebd7dd28a.clear();
    }
}

});
parcelRegister("2LjoR", function(module, exports) {
$parcel$export(module.exports, "diRegistry", () => $202f050203814336$export$4203fb010fad9bf0);
$parcel$export(module.exports, "PACKAGE_NAME", () => $202f050203814336$export$b8b9d90f9e5bd72b);
const $202f050203814336$export$4203fb010fad9bf0 = new WeakMap();
const $202f050203814336$export$b8b9d90f9e5bd72b = 'react-magnetic-di';

});

parcelRegister("lKDUN", function(module, exports) {
$parcel$export(module.exports, "warnOnce", () => $fd5cdb273d325ae8$export$5b28268982f175ba);
$parcel$export(module.exports, "addInjectableToMap", () => $fd5cdb273d325ae8$export$7a7134bdd2f9ae2e);
$parcel$export(module.exports, "removeInjectableFromMap", () => $fd5cdb273d325ae8$export$8057a2244a849b7b);
$parcel$export(module.exports, "getDisplayName", () => $fd5cdb273d325ae8$export$be63e0664592e141);
$parcel$export(module.exports, "findInjectable", () => $fd5cdb273d325ae8$export$7c436e151c3ee289);

var $2LjoR = parcelRequire("2LjoR");

var $s9egt = parcelRequire("s9egt");
let $fd5cdb273d325ae8$var$hasWarned = false;
function $fd5cdb273d325ae8$export$5b28268982f175ba(message) {
    if (!$fd5cdb273d325ae8$var$hasWarned) {
        // eslint-disable-next-line no-console
        console.warn('Warning:', message);
        $fd5cdb273d325ae8$var$hasWarned = true;
    }
}
function $fd5cdb273d325ae8$export$7a7134bdd2f9ae2e(replacementMap, inj) {
    const injObj = (0, $2LjoR.diRegistry).get(inj);
    if (!injObj) throw new Error(`Seems like you are trying to use "${inj}" as injectable, but magnetic-di needs the return value of "injectable()"`);
    if (injObj.track) (0, $s9egt.stats).set(injObj);
    if (replacementMap.has(injObj.from)) replacementMap.get(injObj.from).add(injObj);
    else replacementMap.set(injObj.from, new Set([
        injObj
    ]));
    return replacementMap;
}
function $fd5cdb273d325ae8$export$8057a2244a849b7b(replacementMap, inj) {
    const injObj = (0, $2LjoR.diRegistry).get(inj);
    const injectables = replacementMap.get(injObj.from) || new Set();
    if (injectables.size === 1) replacementMap.delete(injObj.from);
    else injectables.delete(injObj);
}
function $fd5cdb273d325ae8$export$be63e0664592e141(Comp, wrapper = '') {
    const name = Comp.displayName || Comp.name;
    return !name || !wrapper ? name : `${wrapper}(${name})`;
}
function $fd5cdb273d325ae8$export$1c9f709888824e05(fn) {
    const source = fn.toString();
    const [, args] = source.match(/const \[[^\]]+\] = .*di.*\(\w+[,\s]+([^)]+)/) || [];
    return args;
}
function $fd5cdb273d325ae8$export$7c436e151c3ee289(replacementMap, dep, targetChild) {
    const injectables = replacementMap.get(dep);
    if (!injectables) return null;
    // loop all injectables for the dep, with targeted ones preferred
    let anyCandidate = null;
    let targetCandidate = null;
    for (const inj of injectables){
        var _inj$targets;
        if (!inj.targets) anyCandidate = inj;
        if ((_inj$targets = inj.targets) != null && _inj$targets.has(targetChild)) targetCandidate = inj;
    }
    const candidate = targetCandidate || anyCandidate;
    (0, $s9egt.stats).track(candidate);
    return candidate;
}

});
parcelRegister("s9egt", function(module, exports) {
$parcel$export(module.exports, "stats", () => $0549c6576fcc4ebf$export$7804429c45dff272);
const $0549c6576fcc4ebf$var$createState = ()=>({
        unused: new Map(),
        used: new Set(),
        provided: new Set()
    });
const $0549c6576fcc4ebf$export$7804429c45dff272 = {
    state: $0549c6576fcc4ebf$var$createState(),
    set (inj) {
        var _inj$value;
        // allow injectable override without flagging as unused
        for (let unusedInj of this.state.unused.keys())if (unusedInj.from === inj.from) this.state.unused.delete(unusedInj);
        this.state.unused.set(inj, new Error(`Unused "di" injectable: ${((_inj$value = inj.value) == null ? void 0 : _inj$value.displayName) || inj.value}.`, {
            cause: inj.cause
        }));
    },
    track (inj) {
        if (!inj) return;
        this.state.unused.delete(inj);
        this.state.used.add(inj);
        this.state.provided.add(inj.from);
        // reset to avoid potential memory leaks via stack traces
        inj.cause = null;
    },
    reset () {
        this.state = $0549c6576fcc4ebf$var$createState();
    },
    unused () {
        return Array.from(this.state.unused.entries()).map(([inj, error])=>({
                get: ()=>inj.value,
                error: ()=>error
            }));
    }
};

});





parcelRegister("dnskZ", function(module, exports) {
$parcel$export(module.exports, "__extends", () => $9bd3679aa577eb4e$export$a8ba968b8961cb8a);
$parcel$export(module.exports, "__assign", () => $9bd3679aa577eb4e$export$18ce0697a983be9b);
$parcel$export(module.exports, "__rest", () => $9bd3679aa577eb4e$export$3c9a16f847548506);
$parcel$export(module.exports, "__awaiter", () => $9bd3679aa577eb4e$export$1050f835b63b671e);
$parcel$export(module.exports, "__generator", () => $9bd3679aa577eb4e$export$67ebef60e6f28a6);
$parcel$export(module.exports, "__exportStar", () => $9bd3679aa577eb4e$export$f33643c0debef087);
$parcel$export(module.exports, "__values", () => $9bd3679aa577eb4e$export$19a8beecd37a4c45);
$parcel$export(module.exports, "__read", () => $9bd3679aa577eb4e$export$8d051b38c9118094);
$parcel$export(module.exports, "__spread", () => $9bd3679aa577eb4e$export$afc72e2116322959);
$parcel$export(module.exports, "__spreadArrays", () => $9bd3679aa577eb4e$export$6388937ca91ccae8);
$parcel$export(module.exports, "__spreadArray", () => $9bd3679aa577eb4e$export$1216008129fb82ed);
$parcel$export(module.exports, "__importStar", () => $9bd3679aa577eb4e$export$c21735bcef00d192);
$parcel$export(module.exports, "__importDefault", () => $9bd3679aa577eb4e$export$da59b14a69baef04);
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $9bd3679aa577eb4e$var$extendStatics = function(d, b) {
    $9bd3679aa577eb4e$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $9bd3679aa577eb4e$var$extendStatics(d, b);
};
function $9bd3679aa577eb4e$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $9bd3679aa577eb4e$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $9bd3679aa577eb4e$export$18ce0697a983be9b = function() {
    $9bd3679aa577eb4e$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $9bd3679aa577eb4e$export$18ce0697a983be9b.apply(this, arguments);
};
function $9bd3679aa577eb4e$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $9bd3679aa577eb4e$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $9bd3679aa577eb4e$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $9bd3679aa577eb4e$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $9bd3679aa577eb4e$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $9bd3679aa577eb4e$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $9bd3679aa577eb4e$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $9bd3679aa577eb4e$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $9bd3679aa577eb4e$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $9bd3679aa577eb4e$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $9bd3679aa577eb4e$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $9bd3679aa577eb4e$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $9bd3679aa577eb4e$export$45d3717a4c69092e(o, m, p);
}
function $9bd3679aa577eb4e$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $9bd3679aa577eb4e$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $9bd3679aa577eb4e$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($9bd3679aa577eb4e$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $9bd3679aa577eb4e$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $9bd3679aa577eb4e$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $9bd3679aa577eb4e$export$10c90e4f7922046c(v) {
    return this instanceof $9bd3679aa577eb4e$export$10c90e4f7922046c ? (this.v = v, this) : new $9bd3679aa577eb4e$export$10c90e4f7922046c(v);
}
function $9bd3679aa577eb4e$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $9bd3679aa577eb4e$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $9bd3679aa577eb4e$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $9bd3679aa577eb4e$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $9bd3679aa577eb4e$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $9bd3679aa577eb4e$export$19a8beecd37a4c45 === "function" ? $9bd3679aa577eb4e$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $9bd3679aa577eb4e$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $9bd3679aa577eb4e$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $9bd3679aa577eb4e$var$ownKeys = function(o) {
    $9bd3679aa577eb4e$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $9bd3679aa577eb4e$var$ownKeys(o);
};
function $9bd3679aa577eb4e$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $9bd3679aa577eb4e$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $9bd3679aa577eb4e$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $9bd3679aa577eb4e$var$__setModuleDefault(result, mod);
    return result;
}
function $9bd3679aa577eb4e$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $9bd3679aa577eb4e$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $9bd3679aa577eb4e$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $9bd3679aa577eb4e$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $9bd3679aa577eb4e$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $9bd3679aa577eb4e$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $9bd3679aa577eb4e$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $9bd3679aa577eb4e$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $9bd3679aa577eb4e$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $9bd3679aa577eb4e$export$2e2bcd8739ae039 = {
    __extends: $9bd3679aa577eb4e$export$a8ba968b8961cb8a,
    __assign: $9bd3679aa577eb4e$export$18ce0697a983be9b,
    __rest: $9bd3679aa577eb4e$export$3c9a16f847548506,
    __decorate: $9bd3679aa577eb4e$export$29e00dfd3077644b,
    __param: $9bd3679aa577eb4e$export$d5ad3fd78186038f,
    __esDecorate: $9bd3679aa577eb4e$export$3a84e1ae4e97e9b0,
    __runInitializers: $9bd3679aa577eb4e$export$d831c04e792af3d,
    __propKey: $9bd3679aa577eb4e$export$6a2a36740a146cb8,
    __setFunctionName: $9bd3679aa577eb4e$export$d1a06452d3489bc7,
    __metadata: $9bd3679aa577eb4e$export$f1db080c865becb9,
    __awaiter: $9bd3679aa577eb4e$export$1050f835b63b671e,
    __generator: $9bd3679aa577eb4e$export$67ebef60e6f28a6,
    __createBinding: $9bd3679aa577eb4e$export$45d3717a4c69092e,
    __exportStar: $9bd3679aa577eb4e$export$f33643c0debef087,
    __values: $9bd3679aa577eb4e$export$19a8beecd37a4c45,
    __read: $9bd3679aa577eb4e$export$8d051b38c9118094,
    __spread: $9bd3679aa577eb4e$export$afc72e2116322959,
    __spreadArrays: $9bd3679aa577eb4e$export$6388937ca91ccae8,
    __spreadArray: $9bd3679aa577eb4e$export$1216008129fb82ed,
    __await: $9bd3679aa577eb4e$export$10c90e4f7922046c,
    __asyncGenerator: $9bd3679aa577eb4e$export$e427f37a30a4de9b,
    __asyncDelegator: $9bd3679aa577eb4e$export$bbd80228419bb833,
    __asyncValues: $9bd3679aa577eb4e$export$e3b29a3d6162315f,
    __makeTemplateObject: $9bd3679aa577eb4e$export$4fb47efe1390b86f,
    __importStar: $9bd3679aa577eb4e$export$c21735bcef00d192,
    __importDefault: $9bd3679aa577eb4e$export$da59b14a69baef04,
    __classPrivateFieldGet: $9bd3679aa577eb4e$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $9bd3679aa577eb4e$export$d40a35129aaff81f,
    __classPrivateFieldIn: $9bd3679aa577eb4e$export$81fdc39f203e4e04,
    __addDisposableResource: $9bd3679aa577eb4e$export$88ac25d8e944e405,
    __disposeResources: $9bd3679aa577eb4e$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $9bd3679aa577eb4e$export$889dfb5d17574b0b
};

});

parcelRegister("A7PQX", function(module, exports) {
$parcel$export(module.exports, "invariant", () => $06c970d7c2f8892a$export$f5708dca728d7177);
/**
 * Cannot do Math.log(x) / Math.log(10) bc if IEEE floating point issue
 * @param x number
 */ function $06c970d7c2f8892a$export$f535bb00660c42db(x) {
    // Cannot count string length via Number.toString because it may use scientific notation
    // for very small or very large numbers.
    return Math.floor(Math.log(x) * Math.LOG10E);
}
function $06c970d7c2f8892a$export$76d90c956114f2c2(s, times) {
    if (typeof s.repeat === 'function') return s.repeat(times);
    var arr = new Array(times);
    for(var i = 0; i < arr.length; i++)arr[i] = s;
    return arr.join('');
}
function $06c970d7c2f8892a$export$489176b9ebc725cc(map, pl, field, value) {
    if (!map.get(pl)) map.set(pl, Object.create(null));
    var slots = map.get(pl);
    slots[field] = value;
}
function $06c970d7c2f8892a$export$d21499e79b5c28e2(map, pl, props) {
    for(var _i = 0, _a = Object.keys(props); _i < _a.length; _i++){
        var k = _a[_i];
        $06c970d7c2f8892a$export$489176b9ebc725cc(map, pl, k, props[k]);
    }
}
function $06c970d7c2f8892a$export$3fae2929ed23c202(map, pl, field) {
    return $06c970d7c2f8892a$export$ca4e2274c058dd9f(map, pl, field)[field];
}
function $06c970d7c2f8892a$export$ca4e2274c058dd9f(map, pl) {
    var fields = [];
    for(var _i = 2; _i < arguments.length; _i++)fields[_i - 2] = arguments[_i];
    var slots = map.get(pl);
    if (!slots) throw new TypeError("".concat(pl, " InternalSlot has not been initialized"));
    return fields.reduce(function(all, f) {
        all[f] = slots[f];
        return all;
    }, Object.create(null));
}
function $06c970d7c2f8892a$export$25c75e09b890f24e(patternPart) {
    return patternPart.type === 'literal';
}
function $06c970d7c2f8892a$export$fdab3c20aae16ddf(target, name, _a) {
    var value = _a.value;
    Object.defineProperty(target, name, {
        configurable: true,
        enumerable: false,
        writable: true,
        value: value
    });
}
var $06c970d7c2f8892a$export$9049a02e759202e4 = /-u(?:-[0-9a-z]{2,8})+/gi;
function $06c970d7c2f8892a$export$f5708dca728d7177(condition, message, Err) {
    if (Err === void 0) Err = Error;
    if (!condition) throw new Err(message);
}

});

parcelRegister("99KvW", function(module, exports) {
$parcel$export(module.exports, "filterProps", () => $6aa9091020a4953b$export$d697c39a2985a4c);
$parcel$export(module.exports, "DEFAULT_INTL_CONFIG", () => $6aa9091020a4953b$export$b52f8d6fc0d47415);
$parcel$export(module.exports, "createIntlCache", () => $6aa9091020a4953b$export$51c4f4e973f2dc00);
$parcel$export(module.exports, "createFormatters", () => $6aa9091020a4953b$export$c3f4cd5551df13fd);
$parcel$export(module.exports, "getNamedFormat", () => $6aa9091020a4953b$export$4ee1db8ce44a209b);

var $dnskZ = parcelRequire("dnskZ");

var $gbVAh = parcelRequire("gbVAh");

var $4X6rq = parcelRequire("4X6rq");

var $6zNca = parcelRequire("6zNca");
function $6aa9091020a4953b$export$d697c39a2985a4c(props, allowlist, defaults) {
    if (defaults === void 0) defaults = {};
    return allowlist.reduce(function(filtered, name) {
        if (name in props) filtered[name] = props[name];
        else if (name in defaults) filtered[name] = defaults[name];
        return filtered;
    }, {});
}
var $6aa9091020a4953b$var$defaultErrorHandler = function(error) {};
var $6aa9091020a4953b$var$defaultWarnHandler = function(warning) {};
var $6aa9091020a4953b$export$b52f8d6fc0d47415 = {
    formats: {},
    messages: {},
    timeZone: undefined,
    defaultLocale: 'en',
    defaultFormats: {},
    fallbackOnEmptyString: true,
    onError: $6aa9091020a4953b$var$defaultErrorHandler,
    onWarn: $6aa9091020a4953b$var$defaultWarnHandler
};
function $6aa9091020a4953b$export$51c4f4e973f2dc00() {
    return {
        dateTime: {},
        number: {},
        message: {},
        relativeTime: {},
        pluralRules: {},
        list: {},
        displayNames: {}
    };
}
function $6aa9091020a4953b$var$createFastMemoizeCache(store) {
    return {
        create: function() {
            return {
                get: function(key) {
                    return store[key];
                },
                set: function(key, value) {
                    store[key] = value;
                }
            };
        }
    };
}
function $6aa9091020a4953b$export$c3f4cd5551df13fd(cache) {
    if (cache === void 0) cache = $6aa9091020a4953b$export$51c4f4e973f2dc00();
    var RelativeTimeFormat = Intl.RelativeTimeFormat;
    var ListFormat = Intl.ListFormat;
    var DisplayNames = Intl.DisplayNames;
    var getDateTimeFormat = (0, $4X6rq.default)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0, $dnskZ.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: $6aa9091020a4953b$var$createFastMemoizeCache(cache.dateTime),
        strategy: (0, $4X6rq.strategies).variadic
    });
    var getNumberFormat = (0, $4X6rq.default)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.NumberFormat).bind.apply(_a, (0, $dnskZ.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: $6aa9091020a4953b$var$createFastMemoizeCache(cache.number),
        strategy: (0, $4X6rq.strategies).variadic
    });
    var getPluralRules = (0, $4X6rq.default)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.PluralRules).bind.apply(_a, (0, $dnskZ.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: $6aa9091020a4953b$var$createFastMemoizeCache(cache.pluralRules),
        strategy: (0, $4X6rq.strategies).variadic
    });
    return {
        getDateTimeFormat: getDateTimeFormat,
        getNumberFormat: getNumberFormat,
        getMessageFormat: (0, $4X6rq.default)(function(message, locales, overrideFormats, opts) {
            return new (0, $gbVAh.IntlMessageFormat)(message, locales, overrideFormats, (0, $dnskZ.__assign)({
                formatters: {
                    getNumberFormat: getNumberFormat,
                    getDateTimeFormat: getDateTimeFormat,
                    getPluralRules: getPluralRules
                }
            }, opts || {}));
        }, {
            cache: $6aa9091020a4953b$var$createFastMemoizeCache(cache.message),
            strategy: (0, $4X6rq.strategies).variadic
        }),
        getRelativeTimeFormat: (0, $4X6rq.default)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (RelativeTimeFormat.bind.apply(RelativeTimeFormat, (0, $dnskZ.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $6aa9091020a4953b$var$createFastMemoizeCache(cache.relativeTime),
            strategy: (0, $4X6rq.strategies).variadic
        }),
        getPluralRules: getPluralRules,
        getListFormat: (0, $4X6rq.default)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (ListFormat.bind.apply(ListFormat, (0, $dnskZ.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $6aa9091020a4953b$var$createFastMemoizeCache(cache.list),
            strategy: (0, $4X6rq.strategies).variadic
        }),
        getDisplayNames: (0, $4X6rq.default)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (DisplayNames.bind.apply(DisplayNames, (0, $dnskZ.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $6aa9091020a4953b$var$createFastMemoizeCache(cache.displayNames),
            strategy: (0, $4X6rq.strategies).variadic
        })
    };
}
function $6aa9091020a4953b$export$4ee1db8ce44a209b(formats, type, name, onError) {
    var formatType = formats && formats[type];
    var format;
    if (formatType) format = formatType[name];
    if (format) return format;
    onError(new (0, $6zNca.UnsupportedFormatterError)("No ".concat(type, " format named: ").concat(name)));
}

});
parcelRegister("gbVAh", function(module, exports) {
$parcel$export(module.exports, "IntlMessageFormat", () => $bc9a5771ea7efaeb$export$d342343268debc40);
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ 
var $dnskZ = parcelRequire("dnskZ");

var $g41Aa = parcelRequire("g41Aa");

var $kPkc1 = parcelRequire("kPkc1");

var $3ucBM = parcelRequire("3ucBM");
// -- MessageFormat --------------------------------------------------------
function $bc9a5771ea7efaeb$var$mergeConfig(c1, c2) {
    if (!c2) return c1;
    return (0, $dnskZ.__assign)((0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, c1 || {}), c2 || {}), Object.keys(c1).reduce(function(all, k) {
        all[k] = (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, c1[k]), c2[k] || {});
        return all;
    }, {}));
}
function $bc9a5771ea7efaeb$var$mergeConfigs(defaultConfig, configs) {
    if (!configs) return defaultConfig;
    return Object.keys(defaultConfig).reduce(function(all, k) {
        all[k] = $bc9a5771ea7efaeb$var$mergeConfig(defaultConfig[k], configs[k]);
        return all;
    }, (0, $dnskZ.__assign)({}, defaultConfig));
}
function $bc9a5771ea7efaeb$var$createFastMemoizeCache(store) {
    return {
        create: function() {
            return {
                get: function(key) {
                    return store[key];
                },
                set: function(key, value) {
                    store[key] = value;
                }
            };
        }
    };
}
function $bc9a5771ea7efaeb$var$createDefaultFormatters(cache) {
    if (cache === void 0) cache = {
        number: {},
        dateTime: {},
        pluralRules: {}
    };
    return {
        getNumberFormat: (0, $kPkc1.default)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.NumberFormat).bind.apply(_a, (0, $dnskZ.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $bc9a5771ea7efaeb$var$createFastMemoizeCache(cache.number),
            strategy: (0, $kPkc1.strategies).variadic
        }),
        getDateTimeFormat: (0, $kPkc1.default)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0, $dnskZ.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $bc9a5771ea7efaeb$var$createFastMemoizeCache(cache.dateTime),
            strategy: (0, $kPkc1.strategies).variadic
        }),
        getPluralRules: (0, $kPkc1.default)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.PluralRules).bind.apply(_a, (0, $dnskZ.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $bc9a5771ea7efaeb$var$createFastMemoizeCache(cache.pluralRules),
            strategy: (0, $kPkc1.strategies).variadic
        })
    };
}
var $bc9a5771ea7efaeb$export$d342343268debc40 = /** @class */ function() {
    function IntlMessageFormat(message, locales, overrideFormats, opts) {
        var _this = this;
        if (locales === void 0) locales = IntlMessageFormat.defaultLocale;
        this.formatterCache = {
            number: {},
            dateTime: {},
            pluralRules: {}
        };
        this.format = function(values) {
            var parts = _this.formatToParts(values);
            // Hot path for straight simple msg translations
            if (parts.length === 1) return parts[0].value;
            var result = parts.reduce(function(all, part) {
                if (!all.length || part.type !== (0, $3ucBM.PART_TYPE).literal || typeof all[all.length - 1] !== 'string') all.push(part.value);
                else all[all.length - 1] += part.value;
                return all;
            }, []);
            if (result.length <= 1) return result[0] || '';
            return result;
        };
        this.formatToParts = function(values) {
            return (0, $3ucBM.formatToParts)(_this.ast, _this.locales, _this.formatters, _this.formats, values, undefined, _this.message);
        };
        this.resolvedOptions = function() {
            return {
                locale: _this.resolvedLocale.toString()
            };
        };
        this.getAst = function() {
            return _this.ast;
        };
        // Defined first because it's used to build the format pattern.
        this.locales = locales;
        this.resolvedLocale = IntlMessageFormat.resolveLocale(locales);
        if (typeof message === 'string') {
            this.message = message;
            if (!IntlMessageFormat.__parse) throw new TypeError('IntlMessageFormat.__parse must be set to process `message` of type `string`');
            // Parse string messages into an AST.
            this.ast = IntlMessageFormat.__parse(message, {
                ignoreTag: opts === null || opts === void 0 ? void 0 : opts.ignoreTag,
                locale: this.resolvedLocale
            });
        } else this.ast = message;
        if (!Array.isArray(this.ast)) throw new TypeError('A message must be provided as a String or AST.');
        // Creates a new object with the specified `formats` merged with the default
        // formats.
        this.formats = $bc9a5771ea7efaeb$var$mergeConfigs(IntlMessageFormat.formats, overrideFormats);
        this.formatters = opts && opts.formatters || $bc9a5771ea7efaeb$var$createDefaultFormatters(this.formatterCache);
    }
    Object.defineProperty(IntlMessageFormat, "defaultLocale", {
        get: function() {
            if (!IntlMessageFormat.memoizedDefaultLocale) IntlMessageFormat.memoizedDefaultLocale = new Intl.NumberFormat().resolvedOptions().locale;
            return IntlMessageFormat.memoizedDefaultLocale;
        },
        enumerable: false,
        configurable: true
    });
    IntlMessageFormat.memoizedDefaultLocale = null;
    IntlMessageFormat.resolveLocale = function(locales) {
        var supportedLocales = Intl.NumberFormat.supportedLocalesOf(locales);
        if (supportedLocales.length > 0) return new Intl.Locale(supportedLocales[0]);
        return new Intl.Locale(typeof locales === 'string' ? locales : locales[0]);
    };
    IntlMessageFormat.__parse = (0, $g41Aa.parse);
    // Default format options used as the prototype of the `formats` provided to the
    // constructor. These are used when constructing the internal Intl.NumberFormat
    // and Intl.DateTimeFormat instances.
    IntlMessageFormat.formats = {
        number: {
            integer: {
                maximumFractionDigits: 0
            },
            currency: {
                style: 'currency'
            },
            percent: {
                style: 'percent'
            }
        },
        date: {
            short: {
                month: 'numeric',
                day: 'numeric',
                year: '2-digit'
            },
            medium: {
                month: 'short',
                day: 'numeric',
                year: 'numeric'
            },
            long: {
                month: 'long',
                day: 'numeric',
                year: 'numeric'
            },
            full: {
                weekday: 'long',
                month: 'long',
                day: 'numeric',
                year: 'numeric'
            }
        },
        time: {
            short: {
                hour: 'numeric',
                minute: 'numeric'
            },
            medium: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric'
            },
            long: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                timeZoneName: 'short'
            },
            full: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                timeZoneName: 'short'
            }
        }
    };
    return IntlMessageFormat;
}();

});
parcelRegister("g41Aa", function(module, exports) {
$parcel$export(module.exports, "isArgumentElement", () => (parcelRequire("ahqHA")).isArgumentElement);
$parcel$export(module.exports, "isDateElement", () => (parcelRequire("ahqHA")).isDateElement);
$parcel$export(module.exports, "isDateTimeSkeleton", () => (parcelRequire("ahqHA")).isDateTimeSkeleton);
$parcel$export(module.exports, "isLiteralElement", () => (parcelRequire("ahqHA")).isLiteralElement);
$parcel$export(module.exports, "isNumberElement", () => (parcelRequire("ahqHA")).isNumberElement);
$parcel$export(module.exports, "isNumberSkeleton", () => (parcelRequire("ahqHA")).isNumberSkeleton);
$parcel$export(module.exports, "isPluralElement", () => (parcelRequire("ahqHA")).isPluralElement);
$parcel$export(module.exports, "isPoundElement", () => (parcelRequire("ahqHA")).isPoundElement);
$parcel$export(module.exports, "isSelectElement", () => (parcelRequire("ahqHA")).isSelectElement);
$parcel$export(module.exports, "isTagElement", () => (parcelRequire("ahqHA")).isTagElement);
$parcel$export(module.exports, "isTimeElement", () => (parcelRequire("ahqHA")).isTimeElement);
$parcel$export(module.exports, "parse", () => $bb1e3f445773a6b0$export$98e6a39c04603d36);

var $dnskZ = parcelRequire("dnskZ");

var $68xKs = parcelRequire("68xKs");

var $hfokV = parcelRequire("hfokV");

var $ahqHA = parcelRequire("ahqHA");
function $bb1e3f445773a6b0$var$pruneLocation(els) {
    els.forEach(function(el) {
        delete el.location;
        if ((0, $ahqHA.isSelectElement)(el) || (0, $ahqHA.isPluralElement)(el)) for(var k in el.options){
            delete el.options[k].location;
            $bb1e3f445773a6b0$var$pruneLocation(el.options[k].value);
        }
        else if ((0, $ahqHA.isNumberElement)(el) && (0, $ahqHA.isNumberSkeleton)(el.style)) delete el.style.location;
        else if (((0, $ahqHA.isDateElement)(el) || (0, $ahqHA.isTimeElement)(el)) && (0, $ahqHA.isDateTimeSkeleton)(el.style)) delete el.style.location;
        else if ((0, $ahqHA.isTagElement)(el)) $bb1e3f445773a6b0$var$pruneLocation(el.children);
    });
}
function $bb1e3f445773a6b0$export$98e6a39c04603d36(message, opts) {
    if (opts === void 0) opts = {};
    opts = (0, $dnskZ.__assign)({
        shouldParseSkeletons: true,
        requiresOtherClause: true
    }, opts);
    var result = new (0, $hfokV.Parser)(message, opts).parse();
    if (result.err) {
        var error = SyntaxError((0, $68xKs.ErrorKind)[result.err.kind]);
        // @ts-expect-error Assign to error object
        error.location = result.err.location;
        // @ts-expect-error Assign to error object
        error.originalMessage = result.err.message;
        throw error;
    }
    if (!(opts === null || opts === void 0 ? void 0 : opts.captureLocation)) $bb1e3f445773a6b0$var$pruneLocation(result.val);
    return result.val;
}

});
parcelRegister("68xKs", function(module, exports) {
$parcel$export(module.exports, "ErrorKind", () => $477dab255bda9e68$export$896afd8541959ee5);
var $477dab255bda9e68$export$896afd8541959ee5;
(function(ErrorKind) {
    /** Argument is unclosed (e.g. `{0`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_CLOSING_BRACE"] = 1] = "EXPECT_ARGUMENT_CLOSING_BRACE";
    /** Argument is empty (e.g. `{}`). */ ErrorKind[ErrorKind["EMPTY_ARGUMENT"] = 2] = "EMPTY_ARGUMENT";
    /** Argument is malformed (e.g. `{foo!}``) */ ErrorKind[ErrorKind["MALFORMED_ARGUMENT"] = 3] = "MALFORMED_ARGUMENT";
    /** Expect an argument type (e.g. `{foo,}`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_TYPE"] = 4] = "EXPECT_ARGUMENT_TYPE";
    /** Unsupported argument type (e.g. `{foo,foo}`) */ ErrorKind[ErrorKind["INVALID_ARGUMENT_TYPE"] = 5] = "INVALID_ARGUMENT_TYPE";
    /** Expect an argument style (e.g. `{foo, number, }`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_STYLE"] = 6] = "EXPECT_ARGUMENT_STYLE";
    /** The number skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_NUMBER_SKELETON"] = 7] = "INVALID_NUMBER_SKELETON";
    /** The date time skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_DATE_TIME_SKELETON"] = 8] = "INVALID_DATE_TIME_SKELETON";
    /** Exepct a number skeleton following the `::` (e.g. `{foo, number, ::}`) */ ErrorKind[ErrorKind["EXPECT_NUMBER_SKELETON"] = 9] = "EXPECT_NUMBER_SKELETON";
    /** Exepct a date time skeleton following the `::` (e.g. `{foo, date, ::}`) */ ErrorKind[ErrorKind["EXPECT_DATE_TIME_SKELETON"] = 10] = "EXPECT_DATE_TIME_SKELETON";
    /** Unmatched apostrophes in the argument style (e.g. `{foo, number, 'test`) */ ErrorKind[ErrorKind["UNCLOSED_QUOTE_IN_ARGUMENT_STYLE"] = 11] = "UNCLOSED_QUOTE_IN_ARGUMENT_STYLE";
    /** Missing select argument options (e.g. `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_OPTIONS"] = 12] = "EXPECT_SELECT_ARGUMENT_OPTIONS";
    /** Expecting an offset value in `plural` or `selectordinal` argument (e.g `{foo, plural, offset}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE"] = 13] = "EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Offset value in `plural` or `selectordinal` is invalid (e.g. `{foo, plural, offset: x}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_OFFSET_VALUE"] = 14] = "INVALID_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Expecting a selector in `select` argument (e.g `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR"] = 15] = "EXPECT_SELECT_ARGUMENT_SELECTOR";
    /** Expecting a selector in `plural` or `selectordinal` argument (e.g `{foo, plural}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR"] = 16] = "EXPECT_PLURAL_ARGUMENT_SELECTOR";
    /** Expecting a message fragment after the `select` selector (e.g. `{foo, select, apple}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT"] = 17] = "EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT";
    /**
     * Expecting a message fragment after the `plural` or `selectordinal` selector
     * (e.g. `{foo, plural, one}`)
     */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT"] = 18] = "EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT";
    /** Selector in `plural` or `selectordinal` is malformed (e.g. `{foo, plural, =x {#}}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_SELECTOR"] = 19] = "INVALID_PLURAL_ARGUMENT_SELECTOR";
    /**
     * Duplicate selectors in `plural` or `selectordinal` argument.
     * (e.g. {foo, plural, one {#} one {#}})
     */ ErrorKind[ErrorKind["DUPLICATE_PLURAL_ARGUMENT_SELECTOR"] = 20] = "DUPLICATE_PLURAL_ARGUMENT_SELECTOR";
    /** Duplicate selectors in `select` argument.
     * (e.g. {foo, select, apple {apple} apple {apple}})
     */ ErrorKind[ErrorKind["DUPLICATE_SELECT_ARGUMENT_SELECTOR"] = 21] = "DUPLICATE_SELECT_ARGUMENT_SELECTOR";
    /** Plural or select argument option must have `other` clause. */ ErrorKind[ErrorKind["MISSING_OTHER_CLAUSE"] = 22] = "MISSING_OTHER_CLAUSE";
    /** The tag is malformed. (e.g. `<bold!>foo</bold!>) */ ErrorKind[ErrorKind["INVALID_TAG"] = 23] = "INVALID_TAG";
    /** The tag name is invalid. (e.g. `<123>foo</123>`) */ ErrorKind[ErrorKind["INVALID_TAG_NAME"] = 25] = "INVALID_TAG_NAME";
    /** The closing tag does not match the opening tag. (e.g. `<bold>foo</italic>`) */ ErrorKind[ErrorKind["UNMATCHED_CLOSING_TAG"] = 26] = "UNMATCHED_CLOSING_TAG";
    /** The opening tag has unmatched closing tag. (e.g. `<bold>foo`) */ ErrorKind[ErrorKind["UNCLOSED_TAG"] = 27] = "UNCLOSED_TAG";
})($477dab255bda9e68$export$896afd8541959ee5 || ($477dab255bda9e68$export$896afd8541959ee5 = {}));

});

parcelRegister("hfokV", function(module, exports) {
$parcel$export(module.exports, "Parser", () => $c8e6b719f493a7f9$export$7acfa6ed01010e37);

var $dnskZ = parcelRequire("dnskZ");

var $68xKs = parcelRequire("68xKs");

var $ahqHA = parcelRequire("ahqHA");

var $4ucz0 = parcelRequire("4ucz0");
parcelRequire("8zw08");
var $gAvuh = parcelRequire("gAvuh");
var $37PcY = parcelRequire("37PcY");

var $cVbPs = parcelRequire("cVbPs");
var $c8e6b719f493a7f9$var$_a;
var $c8e6b719f493a7f9$var$SPACE_SEPARATOR_START_REGEX = new RegExp("^".concat((0, $4ucz0.SPACE_SEPARATOR_REGEX).source, "*"));
var $c8e6b719f493a7f9$var$SPACE_SEPARATOR_END_REGEX = new RegExp("".concat((0, $4ucz0.SPACE_SEPARATOR_REGEX).source, "*$"));
function $c8e6b719f493a7f9$var$createLocation(start, end) {
    return {
        start: start,
        end: end
    };
}
// #region Ponyfills
// Consolidate these variables up top for easier toggling during debugging
var $c8e6b719f493a7f9$var$hasNativeStartsWith = !!String.prototype.startsWith;
var $c8e6b719f493a7f9$var$hasNativeFromCodePoint = !!String.fromCodePoint;
var $c8e6b719f493a7f9$var$hasNativeFromEntries = !!Object.fromEntries;
var $c8e6b719f493a7f9$var$hasNativeCodePointAt = !!String.prototype.codePointAt;
var $c8e6b719f493a7f9$var$hasTrimStart = !!String.prototype.trimStart;
var $c8e6b719f493a7f9$var$hasTrimEnd = !!String.prototype.trimEnd;
var $c8e6b719f493a7f9$var$hasNativeIsSafeInteger = !!Number.isSafeInteger;
var $c8e6b719f493a7f9$var$isSafeInteger = $c8e6b719f493a7f9$var$hasNativeIsSafeInteger ? Number.isSafeInteger : function(n) {
    return typeof n === 'number' && isFinite(n) && Math.floor(n) === n && Math.abs(n) <= 0x1fffffffffffff;
};
// IE11 does not support y and u.
var $c8e6b719f493a7f9$var$REGEX_SUPPORTS_U_AND_Y = true;
try {
    var $c8e6b719f493a7f9$var$re = $c8e6b719f493a7f9$var$RE('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
    /**
     * legacy Edge or Xbox One browser
     * Unicode flag support: supported
     * Pattern_Syntax support: not supported
     * See https://github.com/formatjs/formatjs/issues/2822
     */ $c8e6b719f493a7f9$var$REGEX_SUPPORTS_U_AND_Y = (($c8e6b719f493a7f9$var$_a = $c8e6b719f493a7f9$var$re.exec('a')) === null || $c8e6b719f493a7f9$var$_a === void 0 ? void 0 : $c8e6b719f493a7f9$var$_a[0]) === 'a';
} catch (_) {
    $c8e6b719f493a7f9$var$REGEX_SUPPORTS_U_AND_Y = false;
}
var $c8e6b719f493a7f9$var$startsWith = $c8e6b719f493a7f9$var$hasNativeStartsWith ? function startsWith(s, search, position) {
    return s.startsWith(search, position);
} : function startsWith(s, search, position) {
    return s.slice(position, position + search.length) === search;
};
var $c8e6b719f493a7f9$var$fromCodePoint = $c8e6b719f493a7f9$var$hasNativeFromCodePoint ? String.fromCodePoint : function fromCodePoint() {
    var codePoints = [];
    for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
    var elements = '';
    var length = codePoints.length;
    var i = 0;
    var code;
    while(length > i){
        code = codePoints[i++];
        if (code > 0x10ffff) throw RangeError(code + ' is not a valid code point');
        elements += code < 0x10000 ? String.fromCharCode(code) : String.fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00);
    }
    return elements;
};
var $c8e6b719f493a7f9$var$fromEntries = // native
$c8e6b719f493a7f9$var$hasNativeFromEntries ? Object.fromEntries : function fromEntries(entries) {
    var obj = {};
    for(var _i = 0, entries_1 = entries; _i < entries_1.length; _i++){
        var _a = entries_1[_i], k = _a[0], v = _a[1];
        obj[k] = v;
    }
    return obj;
};
var $c8e6b719f493a7f9$var$codePointAt = $c8e6b719f493a7f9$var$hasNativeCodePointAt ? function codePointAt(s, index) {
    return s.codePointAt(index);
} : function codePointAt(s, index) {
    var size = s.length;
    if (index < 0 || index >= size) return undefined;
    var first = s.charCodeAt(index);
    var second;
    return first < 0xd800 || first > 0xdbff || index + 1 === size || (second = s.charCodeAt(index + 1)) < 0xdc00 || second > 0xdfff ? first : (first - 0xd800 << 10) + (second - 0xdc00) + 0x10000;
};
var $c8e6b719f493a7f9$var$trimStart = $c8e6b719f493a7f9$var$hasTrimStart ? function trimStart(s) {
    return s.trimStart();
} : function trimStart(s) {
    return s.replace($c8e6b719f493a7f9$var$SPACE_SEPARATOR_START_REGEX, '');
};
var $c8e6b719f493a7f9$var$trimEnd = $c8e6b719f493a7f9$var$hasTrimEnd ? function trimEnd(s) {
    return s.trimEnd();
} : function trimEnd(s) {
    return s.replace($c8e6b719f493a7f9$var$SPACE_SEPARATOR_END_REGEX, '');
};
// Prevent minifier to translate new RegExp to literal form that might cause syntax error on IE11.
function $c8e6b719f493a7f9$var$RE(s, flag) {
    return new RegExp(s, flag);
}
// #endregion
var $c8e6b719f493a7f9$var$matchIdentifierAtIndex;
if ($c8e6b719f493a7f9$var$REGEX_SUPPORTS_U_AND_Y) {
    // Native
    var $c8e6b719f493a7f9$var$IDENTIFIER_PREFIX_RE_1 = $c8e6b719f493a7f9$var$RE('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
    $c8e6b719f493a7f9$var$matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
        var _a;
        $c8e6b719f493a7f9$var$IDENTIFIER_PREFIX_RE_1.lastIndex = index;
        var match = $c8e6b719f493a7f9$var$IDENTIFIER_PREFIX_RE_1.exec(s);
        return (_a = match[1]) !== null && _a !== void 0 ? _a : '';
    };
} else // IE11
$c8e6b719f493a7f9$var$matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
    var match = [];
    while(true){
        var c = $c8e6b719f493a7f9$var$codePointAt(s, index);
        if (c === undefined || $c8e6b719f493a7f9$var$_isWhiteSpace(c) || $c8e6b719f493a7f9$var$_isPatternSyntax(c)) break;
        match.push(c);
        index += c >= 0x10000 ? 2 : 1;
    }
    return $c8e6b719f493a7f9$var$fromCodePoint.apply(void 0, match);
};
var $c8e6b719f493a7f9$export$7acfa6ed01010e37 = /** @class */ function() {
    function Parser(message, options) {
        if (options === void 0) options = {};
        this.message = message;
        this.position = {
            offset: 0,
            line: 1,
            column: 1
        };
        this.ignoreTag = !!options.ignoreTag;
        this.locale = options.locale;
        this.requiresOtherClause = !!options.requiresOtherClause;
        this.shouldParseSkeletons = !!options.shouldParseSkeletons;
    }
    Parser.prototype.parse = function() {
        if (this.offset() !== 0) throw Error('parser can only be used once');
        return this.parseMessage(0, '', false);
    };
    Parser.prototype.parseMessage = function(nestingLevel, parentArgType, expectingCloseTag) {
        var elements = [];
        while(!this.isEOF()){
            var char = this.char();
            if (char === 123 /* `{` */ ) {
                var result = this.parseArgument(nestingLevel, expectingCloseTag);
                if (result.err) return result;
                elements.push(result.val);
            } else if (char === 125 /* `}` */  && nestingLevel > 0) break;
            else if (char === 35 /* `#` */  && (parentArgType === 'plural' || parentArgType === 'selectordinal')) {
                var position = this.clonePosition();
                this.bump();
                elements.push({
                    type: (0, $ahqHA.TYPE).pound,
                    location: $c8e6b719f493a7f9$var$createLocation(position, this.clonePosition())
                });
            } else if (char === 60 /* `<` */  && !this.ignoreTag && this.peek() === 47 // char code for '/'
            ) {
                if (expectingCloseTag) break;
                else return this.error((0, $68xKs.ErrorKind).UNMATCHED_CLOSING_TAG, $c8e6b719f493a7f9$var$createLocation(this.clonePosition(), this.clonePosition()));
            } else if (char === 60 /* `<` */  && !this.ignoreTag && $c8e6b719f493a7f9$var$_isAlpha(this.peek() || 0)) {
                var result = this.parseTag(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            } else {
                var result = this.parseLiteral(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            }
        }
        return {
            val: elements,
            err: null
        };
    };
    /**
     * A tag name must start with an ASCII lower/upper case letter. The grammar is based on the
     * [custom element name][] except that a dash is NOT always mandatory and uppercase letters
     * are accepted:
     *
     * ```
     * tag ::= "<" tagName (whitespace)* "/>" | "<" tagName (whitespace)* ">" message "</" tagName (whitespace)* ">"
     * tagName ::= [a-z] (PENChar)*
     * PENChar ::=
     *     "-" | "." | [0-9] | "_" | [a-z] | [A-Z] | #xB7 | [#xC0-#xD6] | [#xD8-#xF6] | [#xF8-#x37D] |
     *     [#x37F-#x1FFF] | [#x200C-#x200D] | [#x203F-#x2040] | [#x2070-#x218F] | [#x2C00-#x2FEF] |
     *     [#x3001-#xD7FF] | [#xF900-#xFDCF] | [#xFDF0-#xFFFD] | [#x10000-#xEFFFF]
     * ```
     *
     * [custom element name]: https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
     * NOTE: We're a bit more lax here since HTML technically does not allow uppercase HTML element but we do
     * since other tag-based engines like React allow it
     */ Parser.prototype.parseTag = function(nestingLevel, parentArgType) {
        var startPosition = this.clonePosition();
        this.bump(); // `<`
        var tagName = this.parseTagName();
        this.bumpSpace();
        if (this.bumpIf('/>')) // Self closing tag
        return {
            val: {
                type: (0, $ahqHA.TYPE).literal,
                value: "<".concat(tagName, "/>"),
                location: $c8e6b719f493a7f9$var$createLocation(startPosition, this.clonePosition())
            },
            err: null
        };
        else if (this.bumpIf('>')) {
            var childrenResult = this.parseMessage(nestingLevel + 1, parentArgType, true);
            if (childrenResult.err) return childrenResult;
            var children = childrenResult.val;
            // Expecting a close tag
            var endTagStartPosition = this.clonePosition();
            if (this.bumpIf('</')) {
                if (this.isEOF() || !$c8e6b719f493a7f9$var$_isAlpha(this.char())) return this.error((0, $68xKs.ErrorKind).INVALID_TAG, $c8e6b719f493a7f9$var$createLocation(endTagStartPosition, this.clonePosition()));
                var closingTagNameStartPosition = this.clonePosition();
                var closingTagName = this.parseTagName();
                if (tagName !== closingTagName) return this.error((0, $68xKs.ErrorKind).UNMATCHED_CLOSING_TAG, $c8e6b719f493a7f9$var$createLocation(closingTagNameStartPosition, this.clonePosition()));
                this.bumpSpace();
                if (!this.bumpIf('>')) return this.error((0, $68xKs.ErrorKind).INVALID_TAG, $c8e6b719f493a7f9$var$createLocation(endTagStartPosition, this.clonePosition()));
                return {
                    val: {
                        type: (0, $ahqHA.TYPE).tag,
                        value: tagName,
                        children: children,
                        location: $c8e6b719f493a7f9$var$createLocation(startPosition, this.clonePosition())
                    },
                    err: null
                };
            } else return this.error((0, $68xKs.ErrorKind).UNCLOSED_TAG, $c8e6b719f493a7f9$var$createLocation(startPosition, this.clonePosition()));
        } else return this.error((0, $68xKs.ErrorKind).INVALID_TAG, $c8e6b719f493a7f9$var$createLocation(startPosition, this.clonePosition()));
    };
    /**
     * This method assumes that the caller has peeked ahead for the first tag character.
     */ Parser.prototype.parseTagName = function() {
        var startOffset = this.offset();
        this.bump(); // the first tag name character
        while(!this.isEOF() && $c8e6b719f493a7f9$var$_isPotentialElementNameChar(this.char()))this.bump();
        return this.message.slice(startOffset, this.offset());
    };
    Parser.prototype.parseLiteral = function(nestingLevel, parentArgType) {
        var start = this.clonePosition();
        var value = '';
        while(true){
            var parseQuoteResult = this.tryParseQuote(parentArgType);
            if (parseQuoteResult) {
                value += parseQuoteResult;
                continue;
            }
            var parseUnquotedResult = this.tryParseUnquoted(nestingLevel, parentArgType);
            if (parseUnquotedResult) {
                value += parseUnquotedResult;
                continue;
            }
            var parseLeftAngleResult = this.tryParseLeftAngleBracket();
            if (parseLeftAngleResult) {
                value += parseLeftAngleResult;
                continue;
            }
            break;
        }
        var location = $c8e6b719f493a7f9$var$createLocation(start, this.clonePosition());
        return {
            val: {
                type: (0, $ahqHA.TYPE).literal,
                value: value,
                location: location
            },
            err: null
        };
    };
    Parser.prototype.tryParseLeftAngleBracket = function() {
        if (!this.isEOF() && this.char() === 60 /* `<` */  && (this.ignoreTag || // If at the opening tag or closing tag position, bail.
        !$c8e6b719f493a7f9$var$_isAlphaOrSlash(this.peek() || 0))) {
            this.bump(); // `<`
            return '<';
        }
        return null;
    };
    /**
     * Starting with ICU 4.8, an ASCII apostrophe only starts quoted text if it immediately precedes
     * a character that requires quoting (that is, "only where needed"), and works the same in
     * nested messages as on the top level of the pattern. The new behavior is otherwise compatible.
     */ Parser.prototype.tryParseQuote = function(parentArgType) {
        if (this.isEOF() || this.char() !== 39 /* `'` */ ) return null;
        // Parse escaped char following the apostrophe, or early return if there is no escaped char.
        // Check if is valid escaped character
        switch(this.peek()){
            case 39 /* `'` */ :
                // double quote, should return as a single quote.
                this.bump();
                this.bump();
                return "'";
            // '{', '<', '>', '}'
            case 123:
            case 60:
            case 62:
            case 125:
                break;
            case 35:
                if (parentArgType === 'plural' || parentArgType === 'selectordinal') break;
                return null;
            default:
                return null;
        }
        this.bump(); // apostrophe
        var codePoints = [
            this.char()
        ]; // escaped char
        this.bump();
        // read chars until the optional closing apostrophe is found
        while(!this.isEOF()){
            var ch = this.char();
            if (ch === 39 /* `'` */ ) {
                if (this.peek() === 39 /* `'` */ ) {
                    codePoints.push(39);
                    // Bump one more time because we need to skip 2 characters.
                    this.bump();
                } else {
                    // Optional closing apostrophe.
                    this.bump();
                    break;
                }
            } else codePoints.push(ch);
            this.bump();
        }
        return $c8e6b719f493a7f9$var$fromCodePoint.apply(void 0, codePoints);
    };
    Parser.prototype.tryParseUnquoted = function(nestingLevel, parentArgType) {
        if (this.isEOF()) return null;
        var ch = this.char();
        if (ch === 60 /* `<` */  || ch === 123 /* `{` */  || ch === 35 /* `#` */  && (parentArgType === 'plural' || parentArgType === 'selectordinal') || ch === 125 /* `}` */  && nestingLevel > 0) return null;
        else {
            this.bump();
            return $c8e6b719f493a7f9$var$fromCodePoint(ch);
        }
    };
    Parser.prototype.parseArgument = function(nestingLevel, expectingCloseTag) {
        var openingBracePosition = this.clonePosition();
        this.bump(); // `{`
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, $68xKs.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $c8e6b719f493a7f9$var$createLocation(openingBracePosition, this.clonePosition()));
        if (this.char() === 125 /* `}` */ ) {
            this.bump();
            return this.error((0, $68xKs.ErrorKind).EMPTY_ARGUMENT, $c8e6b719f493a7f9$var$createLocation(openingBracePosition, this.clonePosition()));
        }
        // argument name
        var value = this.parseIdentifierIfPossible().value;
        if (!value) return this.error((0, $68xKs.ErrorKind).MALFORMED_ARGUMENT, $c8e6b719f493a7f9$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, $68xKs.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $c8e6b719f493a7f9$var$createLocation(openingBracePosition, this.clonePosition()));
        switch(this.char()){
            // Simple argument: `{name}`
            case 125 /* `}` */ :
                this.bump(); // `}`
                return {
                    val: {
                        type: (0, $ahqHA.TYPE).argument,
                        // value does not include the opening and closing braces.
                        value: value,
                        location: $c8e6b719f493a7f9$var$createLocation(openingBracePosition, this.clonePosition())
                    },
                    err: null
                };
            // Argument with options: `{name, format, ...}`
            case 44 /* `,` */ :
                this.bump(); // `,`
                this.bumpSpace();
                if (this.isEOF()) return this.error((0, $68xKs.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $c8e6b719f493a7f9$var$createLocation(openingBracePosition, this.clonePosition()));
                return this.parseArgumentOptions(nestingLevel, expectingCloseTag, value, openingBracePosition);
            default:
                return this.error((0, $68xKs.ErrorKind).MALFORMED_ARGUMENT, $c8e6b719f493a7f9$var$createLocation(openingBracePosition, this.clonePosition()));
        }
    };
    /**
     * Advance the parser until the end of the identifier, if it is currently on
     * an identifier character. Return an empty string otherwise.
     */ Parser.prototype.parseIdentifierIfPossible = function() {
        var startingPosition = this.clonePosition();
        var startOffset = this.offset();
        var value = $c8e6b719f493a7f9$var$matchIdentifierAtIndex(this.message, startOffset);
        var endOffset = startOffset + value.length;
        this.bumpTo(endOffset);
        var endPosition = this.clonePosition();
        var location = $c8e6b719f493a7f9$var$createLocation(startingPosition, endPosition);
        return {
            value: value,
            location: location
        };
    };
    Parser.prototype.parseArgumentOptions = function(nestingLevel, expectingCloseTag, value, openingBracePosition) {
        var _a;
        // Parse this range:
        // {name, type, style}
        //        ^---^
        var typeStartPosition = this.clonePosition();
        var argType = this.parseIdentifierIfPossible().value;
        var typeEndPosition = this.clonePosition();
        switch(argType){
            case '':
                // Expecting a style string number, date, time, plural, selectordinal, or select.
                return this.error((0, $68xKs.ErrorKind).EXPECT_ARGUMENT_TYPE, $c8e6b719f493a7f9$var$createLocation(typeStartPosition, typeEndPosition));
            case 'number':
            case 'date':
            case 'time':
                // Parse this range:
                // {name, number, style}
                //              ^-------^
                this.bumpSpace();
                var styleAndLocation = null;
                if (this.bumpIf(',')) {
                    this.bumpSpace();
                    var styleStartPosition = this.clonePosition();
                    var result = this.parseSimpleArgStyleIfPossible();
                    if (result.err) return result;
                    var style = $c8e6b719f493a7f9$var$trimEnd(result.val);
                    if (style.length === 0) return this.error((0, $68xKs.ErrorKind).EXPECT_ARGUMENT_STYLE, $c8e6b719f493a7f9$var$createLocation(this.clonePosition(), this.clonePosition()));
                    var styleLocation = $c8e6b719f493a7f9$var$createLocation(styleStartPosition, this.clonePosition());
                    styleAndLocation = {
                        style: style,
                        styleLocation: styleLocation
                    };
                }
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_1 = $c8e6b719f493a7f9$var$createLocation(openingBracePosition, this.clonePosition());
                // Extract style or skeleton
                if (styleAndLocation && $c8e6b719f493a7f9$var$startsWith(styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style, '::', 0)) {
                    // Skeleton starts with `::`.
                    var skeleton = $c8e6b719f493a7f9$var$trimStart(styleAndLocation.style.slice(2));
                    if (argType === 'number') {
                        var result = this.parseNumberSkeletonFromString(skeleton, styleAndLocation.styleLocation);
                        if (result.err) return result;
                        return {
                            val: {
                                type: (0, $ahqHA.TYPE).number,
                                value: value,
                                location: location_1,
                                style: result.val
                            },
                            err: null
                        };
                    } else {
                        if (skeleton.length === 0) return this.error((0, $68xKs.ErrorKind).EXPECT_DATE_TIME_SKELETON, location_1);
                        var dateTimePattern = skeleton;
                        // Get "best match" pattern only if locale is passed, if not, let it
                        // pass as-is where `parseDateTimeSkeleton()` will throw an error
                        // for unsupported patterns.
                        if (this.locale) dateTimePattern = (0, $cVbPs.getBestPattern)(skeleton, this.locale);
                        var style = {
                            type: (0, $ahqHA.SKELETON_TYPE).dateTime,
                            pattern: dateTimePattern,
                            location: styleAndLocation.styleLocation,
                            parsedOptions: this.shouldParseSkeletons ? (0, $gAvuh.parseDateTimeSkeleton)(dateTimePattern) : {}
                        };
                        var type = argType === 'date' ? (0, $ahqHA.TYPE).date : (0, $ahqHA.TYPE).time;
                        return {
                            val: {
                                type: type,
                                value: value,
                                location: location_1,
                                style: style
                            },
                            err: null
                        };
                    }
                }
                // Regular style or no style.
                return {
                    val: {
                        type: argType === 'number' ? (0, $ahqHA.TYPE).number : argType === 'date' ? (0, $ahqHA.TYPE).date : (0, $ahqHA.TYPE).time,
                        value: value,
                        location: location_1,
                        style: (_a = styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style) !== null && _a !== void 0 ? _a : null
                    },
                    err: null
                };
            case 'plural':
            case 'selectordinal':
            case 'select':
                // Parse this range:
                // {name, plural, options}
                //              ^---------^
                var typeEndPosition_1 = this.clonePosition();
                this.bumpSpace();
                if (!this.bumpIf(',')) return this.error((0, $68xKs.ErrorKind).EXPECT_SELECT_ARGUMENT_OPTIONS, $c8e6b719f493a7f9$var$createLocation(typeEndPosition_1, (0, $dnskZ.__assign)({}, typeEndPosition_1)));
                this.bumpSpace();
                // Parse offset:
                // {name, plural, offset:1, options}
                //                ^-----^
                //
                // or the first option:
                //
                // {name, plural, one {...} other {...}}
                //                ^--^
                var identifierAndLocation = this.parseIdentifierIfPossible();
                var pluralOffset = 0;
                if (argType !== 'select' && identifierAndLocation.value === 'offset') {
                    if (!this.bumpIf(':')) return this.error((0, $68xKs.ErrorKind).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, $c8e6b719f493a7f9$var$createLocation(this.clonePosition(), this.clonePosition()));
                    this.bumpSpace();
                    var result = this.tryParseDecimalInteger((0, $68xKs.ErrorKind).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, (0, $68xKs.ErrorKind).INVALID_PLURAL_ARGUMENT_OFFSET_VALUE);
                    if (result.err) return result;
                    // Parse another identifier for option parsing
                    this.bumpSpace();
                    identifierAndLocation = this.parseIdentifierIfPossible();
                    pluralOffset = result.val;
                }
                var optionsResult = this.tryParsePluralOrSelectOptions(nestingLevel, argType, expectingCloseTag, identifierAndLocation);
                if (optionsResult.err) return optionsResult;
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_2 = $c8e6b719f493a7f9$var$createLocation(openingBracePosition, this.clonePosition());
                if (argType === 'select') return {
                    val: {
                        type: (0, $ahqHA.TYPE).select,
                        value: value,
                        options: $c8e6b719f493a7f9$var$fromEntries(optionsResult.val),
                        location: location_2
                    },
                    err: null
                };
                else return {
                    val: {
                        type: (0, $ahqHA.TYPE).plural,
                        value: value,
                        options: $c8e6b719f493a7f9$var$fromEntries(optionsResult.val),
                        offset: pluralOffset,
                        pluralType: argType === 'plural' ? 'cardinal' : 'ordinal',
                        location: location_2
                    },
                    err: null
                };
            default:
                return this.error((0, $68xKs.ErrorKind).INVALID_ARGUMENT_TYPE, $c8e6b719f493a7f9$var$createLocation(typeStartPosition, typeEndPosition));
        }
    };
    Parser.prototype.tryParseArgumentClose = function(openingBracePosition) {
        // Parse: {value, number, ::currency/GBP }
        //
        if (this.isEOF() || this.char() !== 125 /* `}` */ ) return this.error((0, $68xKs.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $c8e6b719f493a7f9$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bump(); // `}`
        return {
            val: true,
            err: null
        };
    };
    /**
     * See: https://github.com/unicode-org/icu/blob/af7ed1f6d2298013dc303628438ec4abe1f16479/icu4c/source/common/messagepattern.cpp#L659
     */ Parser.prototype.parseSimpleArgStyleIfPossible = function() {
        var nestedBraces = 0;
        var startPosition = this.clonePosition();
        while(!this.isEOF()){
            var ch = this.char();
            switch(ch){
                case 39 /* `'` */ :
                    // Treat apostrophe as quoting but include it in the style part.
                    // Find the end of the quoted literal text.
                    this.bump();
                    var apostrophePosition = this.clonePosition();
                    if (!this.bumpUntil("'")) return this.error((0, $68xKs.ErrorKind).UNCLOSED_QUOTE_IN_ARGUMENT_STYLE, $c8e6b719f493a7f9$var$createLocation(apostrophePosition, this.clonePosition()));
                    this.bump();
                    break;
                case 123 /* `{` */ :
                    nestedBraces += 1;
                    this.bump();
                    break;
                case 125 /* `}` */ :
                    if (nestedBraces > 0) nestedBraces -= 1;
                    else return {
                        val: this.message.slice(startPosition.offset, this.offset()),
                        err: null
                    };
                    break;
                default:
                    this.bump();
                    break;
            }
        }
        return {
            val: this.message.slice(startPosition.offset, this.offset()),
            err: null
        };
    };
    Parser.prototype.parseNumberSkeletonFromString = function(skeleton, location) {
        var tokens = [];
        try {
            tokens = (0, $37PcY.parseNumberSkeletonFromString)(skeleton);
        } catch (e) {
            return this.error((0, $68xKs.ErrorKind).INVALID_NUMBER_SKELETON, location);
        }
        return {
            val: {
                type: (0, $ahqHA.SKELETON_TYPE).number,
                tokens: tokens,
                location: location,
                parsedOptions: this.shouldParseSkeletons ? (0, $37PcY.parseNumberSkeleton)(tokens) : {}
            },
            err: null
        };
    };
    /**
     * @param nesting_level The current nesting level of messages.
     *     This can be positive when parsing message fragment in select or plural argument options.
     * @param parent_arg_type The parent argument's type.
     * @param parsed_first_identifier If provided, this is the first identifier-like selector of
     *     the argument. It is a by-product of a previous parsing attempt.
     * @param expecting_close_tag If true, this message is directly or indirectly nested inside
     *     between a pair of opening and closing tags. The nested message will not parse beyond
     *     the closing tag boundary.
     */ Parser.prototype.tryParsePluralOrSelectOptions = function(nestingLevel, parentArgType, expectCloseTag, parsedFirstIdentifier) {
        var _a;
        var hasOtherClause = false;
        var options = [];
        var parsedSelectors = new Set();
        var selector = parsedFirstIdentifier.value, selectorLocation = parsedFirstIdentifier.location;
        // Parse:
        // one {one apple}
        // ^--^
        while(true){
            if (selector.length === 0) {
                var startPosition = this.clonePosition();
                if (parentArgType !== 'select' && this.bumpIf('=')) {
                    // Try parse `={number}` selector
                    var result = this.tryParseDecimalInteger((0, $68xKs.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR, (0, $68xKs.ErrorKind).INVALID_PLURAL_ARGUMENT_SELECTOR);
                    if (result.err) return result;
                    selectorLocation = $c8e6b719f493a7f9$var$createLocation(startPosition, this.clonePosition());
                    selector = this.message.slice(startPosition.offset, this.offset());
                } else break;
            }
            // Duplicate selector clauses
            if (parsedSelectors.has(selector)) return this.error(parentArgType === 'select' ? (0, $68xKs.ErrorKind).DUPLICATE_SELECT_ARGUMENT_SELECTOR : (0, $68xKs.ErrorKind).DUPLICATE_PLURAL_ARGUMENT_SELECTOR, selectorLocation);
            if (selector === 'other') hasOtherClause = true;
            // Parse:
            // one {one apple}
            //     ^----------^
            this.bumpSpace();
            var openingBracePosition = this.clonePosition();
            if (!this.bumpIf('{')) return this.error(parentArgType === 'select' ? (0, $68xKs.ErrorKind).EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT : (0, $68xKs.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT, $c8e6b719f493a7f9$var$createLocation(this.clonePosition(), this.clonePosition()));
            var fragmentResult = this.parseMessage(nestingLevel + 1, parentArgType, expectCloseTag);
            if (fragmentResult.err) return fragmentResult;
            var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
            if (argCloseResult.err) return argCloseResult;
            options.push([
                selector,
                {
                    value: fragmentResult.val,
                    location: $c8e6b719f493a7f9$var$createLocation(openingBracePosition, this.clonePosition())
                }
            ]);
            // Keep track of the existing selectors
            parsedSelectors.add(selector);
            // Prep next selector clause.
            this.bumpSpace();
            _a = this.parseIdentifierIfPossible(), selector = _a.value, selectorLocation = _a.location;
        }
        if (options.length === 0) return this.error(parentArgType === 'select' ? (0, $68xKs.ErrorKind).EXPECT_SELECT_ARGUMENT_SELECTOR : (0, $68xKs.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR, $c8e6b719f493a7f9$var$createLocation(this.clonePosition(), this.clonePosition()));
        if (this.requiresOtherClause && !hasOtherClause) return this.error((0, $68xKs.ErrorKind).MISSING_OTHER_CLAUSE, $c8e6b719f493a7f9$var$createLocation(this.clonePosition(), this.clonePosition()));
        return {
            val: options,
            err: null
        };
    };
    Parser.prototype.tryParseDecimalInteger = function(expectNumberError, invalidNumberError) {
        var sign = 1;
        var startingPosition = this.clonePosition();
        if (this.bumpIf('+')) ;
        else if (this.bumpIf('-')) sign = -1;
        var hasDigits = false;
        var decimal = 0;
        while(!this.isEOF()){
            var ch = this.char();
            if (ch >= 48 /* `0` */  && ch <= 57 /* `9` */ ) {
                hasDigits = true;
                decimal = decimal * 10 + (ch - 48);
                this.bump();
            } else break;
        }
        var location = $c8e6b719f493a7f9$var$createLocation(startingPosition, this.clonePosition());
        if (!hasDigits) return this.error(expectNumberError, location);
        decimal *= sign;
        if (!$c8e6b719f493a7f9$var$isSafeInteger(decimal)) return this.error(invalidNumberError, location);
        return {
            val: decimal,
            err: null
        };
    };
    Parser.prototype.offset = function() {
        return this.position.offset;
    };
    Parser.prototype.isEOF = function() {
        return this.offset() === this.message.length;
    };
    Parser.prototype.clonePosition = function() {
        // This is much faster than `Object.assign` or spread.
        return {
            offset: this.position.offset,
            line: this.position.line,
            column: this.position.column
        };
    };
    /**
     * Return the code point at the current position of the parser.
     * Throws if the index is out of bound.
     */ Parser.prototype.char = function() {
        var offset = this.position.offset;
        if (offset >= this.message.length) throw Error('out of bound');
        var code = $c8e6b719f493a7f9$var$codePointAt(this.message, offset);
        if (code === undefined) throw Error("Offset ".concat(offset, " is at invalid UTF-16 code unit boundary"));
        return code;
    };
    Parser.prototype.error = function(kind, location) {
        return {
            val: null,
            err: {
                kind: kind,
                message: this.message,
                location: location
            }
        };
    };
    /** Bump the parser to the next UTF-16 code unit. */ Parser.prototype.bump = function() {
        if (this.isEOF()) return;
        var code = this.char();
        if (code === 10 /* '\n' */ ) {
            this.position.line += 1;
            this.position.column = 1;
            this.position.offset += 1;
        } else {
            this.position.column += 1;
            // 0 ~ 0x10000 -> unicode BMP, otherwise skip the surrogate pair.
            this.position.offset += code < 0x10000 ? 1 : 2;
        }
    };
    /**
     * If the substring starting at the current position of the parser has
     * the given prefix, then bump the parser to the character immediately
     * following the prefix and return true. Otherwise, don't bump the parser
     * and return false.
     */ Parser.prototype.bumpIf = function(prefix) {
        if ($c8e6b719f493a7f9$var$startsWith(this.message, prefix, this.offset())) {
            for(var i = 0; i < prefix.length; i++)this.bump();
            return true;
        }
        return false;
    };
    /**
     * Bump the parser until the pattern character is found and return `true`.
     * Otherwise bump to the end of the file and return `false`.
     */ Parser.prototype.bumpUntil = function(pattern) {
        var currentOffset = this.offset();
        var index = this.message.indexOf(pattern, currentOffset);
        if (index >= 0) {
            this.bumpTo(index);
            return true;
        } else {
            this.bumpTo(this.message.length);
            return false;
        }
    };
    /**
     * Bump the parser to the target offset.
     * If target offset is beyond the end of the input, bump the parser to the end of the input.
     */ Parser.prototype.bumpTo = function(targetOffset) {
        if (this.offset() > targetOffset) throw Error("targetOffset ".concat(targetOffset, " must be greater than or equal to the current offset ").concat(this.offset()));
        targetOffset = Math.min(targetOffset, this.message.length);
        while(true){
            var offset = this.offset();
            if (offset === targetOffset) break;
            if (offset > targetOffset) throw Error("targetOffset ".concat(targetOffset, " is at invalid UTF-16 code unit boundary"));
            this.bump();
            if (this.isEOF()) break;
        }
    };
    /** advance the parser through all whitespace to the next non-whitespace code unit. */ Parser.prototype.bumpSpace = function() {
        while(!this.isEOF() && $c8e6b719f493a7f9$var$_isWhiteSpace(this.char()))this.bump();
    };
    /**
     * Peek at the *next* Unicode codepoint in the input without advancing the parser.
     * If the input has been exhausted, then this returns null.
     */ Parser.prototype.peek = function() {
        if (this.isEOF()) return null;
        var code = this.char();
        var offset = this.offset();
        var nextCode = this.message.charCodeAt(offset + (code >= 0x10000 ? 2 : 1));
        return nextCode !== null && nextCode !== void 0 ? nextCode : null;
    };
    return Parser;
}();
/**
 * This check if codepoint is alphabet (lower & uppercase)
 * @param codepoint
 * @returns
 */ function $c8e6b719f493a7f9$var$_isAlpha(codepoint) {
    return codepoint >= 97 && codepoint <= 122 || codepoint >= 65 && codepoint <= 90;
}
function $c8e6b719f493a7f9$var$_isAlphaOrSlash(codepoint) {
    return $c8e6b719f493a7f9$var$_isAlpha(codepoint) || codepoint === 47; /* '/' */ 
}
/** See `parseTag` function docs. */ function $c8e6b719f493a7f9$var$_isPotentialElementNameChar(c) {
    return c === 45 /* '-' */  || c === 46 /* '.' */  || c >= 48 && c <= 57 || c === 95 /* '_' */  || c >= 97 && c <= 122 || c >= 65 && c <= 90 || c == 0xb7 || c >= 0xc0 && c <= 0xd6 || c >= 0xd8 && c <= 0xf6 || c >= 0xf8 && c <= 0x37d || c >= 0x37f && c <= 0x1fff || c >= 0x200c && c <= 0x200d || c >= 0x203f && c <= 0x2040 || c >= 0x2070 && c <= 0x218f || c >= 0x2c00 && c <= 0x2fef || c >= 0x3001 && c <= 0xd7ff || c >= 0xf900 && c <= 0xfdcf || c >= 0xfdf0 && c <= 0xfffd || c >= 0x10000 && c <= 0xeffff;
}
/**
 * Code point equivalent of regex `\p{White_Space}`.
 * From: https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function $c8e6b719f493a7f9$var$_isWhiteSpace(c) {
    return c >= 0x0009 && c <= 0x000d || c === 0x0020 || c === 0x0085 || c >= 0x200e && c <= 0x200f || c === 0x2028 || c === 0x2029;
}
/**
 * Code point equivalent of regex `\p{Pattern_Syntax}`.
 * See https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function $c8e6b719f493a7f9$var$_isPatternSyntax(c) {
    return c >= 0x0021 && c <= 0x0023 || c === 0x0024 || c >= 0x0025 && c <= 0x0027 || c === 0x0028 || c === 0x0029 || c === 0x002a || c === 0x002b || c === 0x002c || c === 0x002d || c >= 0x002e && c <= 0x002f || c >= 0x003a && c <= 0x003b || c >= 0x003c && c <= 0x003e || c >= 0x003f && c <= 0x0040 || c === 0x005b || c === 0x005c || c === 0x005d || c === 0x005e || c === 0x0060 || c === 0x007b || c === 0x007c || c === 0x007d || c === 0x007e || c === 0x00a1 || c >= 0x00a2 && c <= 0x00a5 || c === 0x00a6 || c === 0x00a7 || c === 0x00a9 || c === 0x00ab || c === 0x00ac || c === 0x00ae || c === 0x00b0 || c === 0x00b1 || c === 0x00b6 || c === 0x00bb || c === 0x00bf || c === 0x00d7 || c === 0x00f7 || c >= 0x2010 && c <= 0x2015 || c >= 0x2016 && c <= 0x2017 || c === 0x2018 || c === 0x2019 || c === 0x201a || c >= 0x201b && c <= 0x201c || c === 0x201d || c === 0x201e || c === 0x201f || c >= 0x2020 && c <= 0x2027 || c >= 0x2030 && c <= 0x2038 || c === 0x2039 || c === 0x203a || c >= 0x203b && c <= 0x203e || c >= 0x2041 && c <= 0x2043 || c === 0x2044 || c === 0x2045 || c === 0x2046 || c >= 0x2047 && c <= 0x2051 || c === 0x2052 || c === 0x2053 || c >= 0x2055 && c <= 0x205e || c >= 0x2190 && c <= 0x2194 || c >= 0x2195 && c <= 0x2199 || c >= 0x219a && c <= 0x219b || c >= 0x219c && c <= 0x219f || c === 0x21a0 || c >= 0x21a1 && c <= 0x21a2 || c === 0x21a3 || c >= 0x21a4 && c <= 0x21a5 || c === 0x21a6 || c >= 0x21a7 && c <= 0x21ad || c === 0x21ae || c >= 0x21af && c <= 0x21cd || c >= 0x21ce && c <= 0x21cf || c >= 0x21d0 && c <= 0x21d1 || c === 0x21d2 || c === 0x21d3 || c === 0x21d4 || c >= 0x21d5 && c <= 0x21f3 || c >= 0x21f4 && c <= 0x22ff || c >= 0x2300 && c <= 0x2307 || c === 0x2308 || c === 0x2309 || c === 0x230a || c === 0x230b || c >= 0x230c && c <= 0x231f || c >= 0x2320 && c <= 0x2321 || c >= 0x2322 && c <= 0x2328 || c === 0x2329 || c === 0x232a || c >= 0x232b && c <= 0x237b || c === 0x237c || c >= 0x237d && c <= 0x239a || c >= 0x239b && c <= 0x23b3 || c >= 0x23b4 && c <= 0x23db || c >= 0x23dc && c <= 0x23e1 || c >= 0x23e2 && c <= 0x2426 || c >= 0x2427 && c <= 0x243f || c >= 0x2440 && c <= 0x244a || c >= 0x244b && c <= 0x245f || c >= 0x2500 && c <= 0x25b6 || c === 0x25b7 || c >= 0x25b8 && c <= 0x25c0 || c === 0x25c1 || c >= 0x25c2 && c <= 0x25f7 || c >= 0x25f8 && c <= 0x25ff || c >= 0x2600 && c <= 0x266e || c === 0x266f || c >= 0x2670 && c <= 0x2767 || c === 0x2768 || c === 0x2769 || c === 0x276a || c === 0x276b || c === 0x276c || c === 0x276d || c === 0x276e || c === 0x276f || c === 0x2770 || c === 0x2771 || c === 0x2772 || c === 0x2773 || c === 0x2774 || c === 0x2775 || c >= 0x2794 && c <= 0x27bf || c >= 0x27c0 && c <= 0x27c4 || c === 0x27c5 || c === 0x27c6 || c >= 0x27c7 && c <= 0x27e5 || c === 0x27e6 || c === 0x27e7 || c === 0x27e8 || c === 0x27e9 || c === 0x27ea || c === 0x27eb || c === 0x27ec || c === 0x27ed || c === 0x27ee || c === 0x27ef || c >= 0x27f0 && c <= 0x27ff || c >= 0x2800 && c <= 0x28ff || c >= 0x2900 && c <= 0x2982 || c === 0x2983 || c === 0x2984 || c === 0x2985 || c === 0x2986 || c === 0x2987 || c === 0x2988 || c === 0x2989 || c === 0x298a || c === 0x298b || c === 0x298c || c === 0x298d || c === 0x298e || c === 0x298f || c === 0x2990 || c === 0x2991 || c === 0x2992 || c === 0x2993 || c === 0x2994 || c === 0x2995 || c === 0x2996 || c === 0x2997 || c === 0x2998 || c >= 0x2999 && c <= 0x29d7 || c === 0x29d8 || c === 0x29d9 || c === 0x29da || c === 0x29db || c >= 0x29dc && c <= 0x29fb || c === 0x29fc || c === 0x29fd || c >= 0x29fe && c <= 0x2aff || c >= 0x2b00 && c <= 0x2b2f || c >= 0x2b30 && c <= 0x2b44 || c >= 0x2b45 && c <= 0x2b46 || c >= 0x2b47 && c <= 0x2b4c || c >= 0x2b4d && c <= 0x2b73 || c >= 0x2b74 && c <= 0x2b75 || c >= 0x2b76 && c <= 0x2b95 || c === 0x2b96 || c >= 0x2b97 && c <= 0x2bff || c >= 0x2e00 && c <= 0x2e01 || c === 0x2e02 || c === 0x2e03 || c === 0x2e04 || c === 0x2e05 || c >= 0x2e06 && c <= 0x2e08 || c === 0x2e09 || c === 0x2e0a || c === 0x2e0b || c === 0x2e0c || c === 0x2e0d || c >= 0x2e0e && c <= 0x2e16 || c === 0x2e17 || c >= 0x2e18 && c <= 0x2e19 || c === 0x2e1a || c === 0x2e1b || c === 0x2e1c || c === 0x2e1d || c >= 0x2e1e && c <= 0x2e1f || c === 0x2e20 || c === 0x2e21 || c === 0x2e22 || c === 0x2e23 || c === 0x2e24 || c === 0x2e25 || c === 0x2e26 || c === 0x2e27 || c === 0x2e28 || c === 0x2e29 || c >= 0x2e2a && c <= 0x2e2e || c === 0x2e2f || c >= 0x2e30 && c <= 0x2e39 || c >= 0x2e3a && c <= 0x2e3b || c >= 0x2e3c && c <= 0x2e3f || c === 0x2e40 || c === 0x2e41 || c === 0x2e42 || c >= 0x2e43 && c <= 0x2e4f || c >= 0x2e50 && c <= 0x2e51 || c === 0x2e52 || c >= 0x2e53 && c <= 0x2e7f || c >= 0x3001 && c <= 0x3003 || c === 0x3008 || c === 0x3009 || c === 0x300a || c === 0x300b || c === 0x300c || c === 0x300d || c === 0x300e || c === 0x300f || c === 0x3010 || c === 0x3011 || c >= 0x3012 && c <= 0x3013 || c === 0x3014 || c === 0x3015 || c === 0x3016 || c === 0x3017 || c === 0x3018 || c === 0x3019 || c === 0x301a || c === 0x301b || c === 0x301c || c === 0x301d || c >= 0x301e && c <= 0x301f || c === 0x3020 || c === 0x3030 || c === 0xfd3e || c === 0xfd3f || c >= 0xfe45 && c <= 0xfe46;
}

});
parcelRegister("ahqHA", function(module, exports) {
$parcel$export(module.exports, "TYPE", () => $77c0346137417d2a$export$b87f371cbc396fcf);
$parcel$export(module.exports, "SKELETON_TYPE", () => $77c0346137417d2a$export$906452485466fa53);
$parcel$export(module.exports, "isLiteralElement", () => $77c0346137417d2a$export$cfa10c5697238752);
$parcel$export(module.exports, "isArgumentElement", () => $77c0346137417d2a$export$4f55724281bdfaf9);
$parcel$export(module.exports, "isNumberElement", () => $77c0346137417d2a$export$e11187b219e191e1);
$parcel$export(module.exports, "isDateElement", () => $77c0346137417d2a$export$32d811605da75f40);
$parcel$export(module.exports, "isTimeElement", () => $77c0346137417d2a$export$34ec46f596b1702f);
$parcel$export(module.exports, "isSelectElement", () => $77c0346137417d2a$export$dcfe1c11d168b5a1);
$parcel$export(module.exports, "isPluralElement", () => $77c0346137417d2a$export$6c796d116f0a4fbc);
$parcel$export(module.exports, "isPoundElement", () => $77c0346137417d2a$export$c0ece297bdd0c082);
$parcel$export(module.exports, "isTagElement", () => $77c0346137417d2a$export$5c83de34745812b);
$parcel$export(module.exports, "isNumberSkeleton", () => $77c0346137417d2a$export$3f9a19cd4152eda3);
$parcel$export(module.exports, "isDateTimeSkeleton", () => $77c0346137417d2a$export$7680c41f1a55f4cf);
var $77c0346137417d2a$export$b87f371cbc396fcf;
(function(TYPE) {
    /**
     * Raw text
     */ TYPE[TYPE["literal"] = 0] = "literal";
    /**
     * Variable w/o any format, e.g `var` in `this is a {var}`
     */ TYPE[TYPE["argument"] = 1] = "argument";
    /**
     * Variable w/ number format
     */ TYPE[TYPE["number"] = 2] = "number";
    /**
     * Variable w/ date format
     */ TYPE[TYPE["date"] = 3] = "date";
    /**
     * Variable w/ time format
     */ TYPE[TYPE["time"] = 4] = "time";
    /**
     * Variable w/ select format
     */ TYPE[TYPE["select"] = 5] = "select";
    /**
     * Variable w/ plural format
     */ TYPE[TYPE["plural"] = 6] = "plural";
    /**
     * Only possible within plural argument.
     * This is the `#` symbol that will be substituted with the count.
     */ TYPE[TYPE["pound"] = 7] = "pound";
    /**
     * XML-like tag
     */ TYPE[TYPE["tag"] = 8] = "tag";
})($77c0346137417d2a$export$b87f371cbc396fcf || ($77c0346137417d2a$export$b87f371cbc396fcf = {}));
var $77c0346137417d2a$export$906452485466fa53;
(function(SKELETON_TYPE) {
    SKELETON_TYPE[SKELETON_TYPE["number"] = 0] = "number";
    SKELETON_TYPE[SKELETON_TYPE["dateTime"] = 1] = "dateTime";
})($77c0346137417d2a$export$906452485466fa53 || ($77c0346137417d2a$export$906452485466fa53 = {}));
function $77c0346137417d2a$export$cfa10c5697238752(el) {
    return el.type === $77c0346137417d2a$export$b87f371cbc396fcf.literal;
}
function $77c0346137417d2a$export$4f55724281bdfaf9(el) {
    return el.type === $77c0346137417d2a$export$b87f371cbc396fcf.argument;
}
function $77c0346137417d2a$export$e11187b219e191e1(el) {
    return el.type === $77c0346137417d2a$export$b87f371cbc396fcf.number;
}
function $77c0346137417d2a$export$32d811605da75f40(el) {
    return el.type === $77c0346137417d2a$export$b87f371cbc396fcf.date;
}
function $77c0346137417d2a$export$34ec46f596b1702f(el) {
    return el.type === $77c0346137417d2a$export$b87f371cbc396fcf.time;
}
function $77c0346137417d2a$export$dcfe1c11d168b5a1(el) {
    return el.type === $77c0346137417d2a$export$b87f371cbc396fcf.select;
}
function $77c0346137417d2a$export$6c796d116f0a4fbc(el) {
    return el.type === $77c0346137417d2a$export$b87f371cbc396fcf.plural;
}
function $77c0346137417d2a$export$c0ece297bdd0c082(el) {
    return el.type === $77c0346137417d2a$export$b87f371cbc396fcf.pound;
}
function $77c0346137417d2a$export$5c83de34745812b(el) {
    return el.type === $77c0346137417d2a$export$b87f371cbc396fcf.tag;
}
function $77c0346137417d2a$export$3f9a19cd4152eda3(el) {
    return !!(el && typeof el === 'object' && el.type === $77c0346137417d2a$export$906452485466fa53.number);
}
function $77c0346137417d2a$export$7680c41f1a55f4cf(el) {
    return !!(el && typeof el === 'object' && el.type === $77c0346137417d2a$export$906452485466fa53.dateTime);
}
function $77c0346137417d2a$export$f0ac572c1121c662(value) {
    return {
        type: $77c0346137417d2a$export$b87f371cbc396fcf.literal,
        value: value
    };
}
function $77c0346137417d2a$export$425e864b0ba114f1(value, style) {
    return {
        type: $77c0346137417d2a$export$b87f371cbc396fcf.number,
        value: value,
        style: style
    };
}

});

parcelRegister("4ucz0", function(module, exports) {
$parcel$export(module.exports, "SPACE_SEPARATOR_REGEX", () => $3443b59ed32ac442$export$523451f94304dd6c);
// @generated from regex-gen.ts
var $3443b59ed32ac442$export$523451f94304dd6c = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/;
var $3443b59ed32ac442$export$2b8db14d8bcaece7 = /[\t-\r \x85\u200E\u200F\u2028\u2029]/;

});

parcelRegister("8zw08", function(module, exports) {
$parcel$export(module.exports, "parseDateTimeSkeleton", () => (parcelRequire("gAvuh")).parseDateTimeSkeleton);
$parcel$export(module.exports, "parseNumberSkeleton", () => (parcelRequire("37PcY")).parseNumberSkeleton);
$parcel$export(module.exports, "parseNumberSkeletonFromString", () => (parcelRequire("37PcY")).parseNumberSkeletonFromString);
parcelRequire("gAvuh");
parcelRequire("37PcY");

});
parcelRegister("gAvuh", function(module, exports) {
$parcel$export(module.exports, "parseDateTimeSkeleton", () => $c1386ede2bd0dabb$export$f7b99fb377fe69fa);
/**
 * https://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * Credit: https://github.com/caridy/intl-datetimeformat-pattern/blob/master/index.js
 * with some tweaks
 */ var $c1386ede2bd0dabb$var$DATE_TIME_REGEX = /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
function $c1386ede2bd0dabb$export$f7b99fb377fe69fa(skeleton) {
    var result = {};
    skeleton.replace($c1386ede2bd0dabb$var$DATE_TIME_REGEX, function(match) {
        var len = match.length;
        switch(match[0]){
            // Era
            case 'G':
                result.era = len === 4 ? 'long' : len === 5 ? 'narrow' : 'short';
                break;
            // Year
            case 'y':
                result.year = len === 2 ? '2-digit' : 'numeric';
                break;
            case 'Y':
            case 'u':
            case 'U':
            case 'r':
                throw new RangeError('`Y/u/U/r` (year) patterns are not supported, use `y` instead');
            // Quarter
            case 'q':
            case 'Q':
                throw new RangeError('`q/Q` (quarter) patterns are not supported');
            // Month
            case 'M':
            case 'L':
                result.month = [
                    'numeric',
                    '2-digit',
                    'short',
                    'long',
                    'narrow'
                ][len - 1];
                break;
            // Week
            case 'w':
            case 'W':
                throw new RangeError('`w/W` (week) patterns are not supported');
            case 'd':
                result.day = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'D':
            case 'F':
            case 'g':
                throw new RangeError('`D/F/g` (day) patterns are not supported, use `d` instead');
            // Weekday
            case 'E':
                result.weekday = len === 4 ? 'short' : len === 5 ? 'narrow' : 'short';
                break;
            case 'e':
                if (len < 4) throw new RangeError('`e..eee` (weekday) patterns are not supported');
                result.weekday = [
                    'short',
                    'long',
                    'narrow',
                    'short'
                ][len - 4];
                break;
            case 'c':
                if (len < 4) throw new RangeError('`c..ccc` (weekday) patterns are not supported');
                result.weekday = [
                    'short',
                    'long',
                    'narrow',
                    'short'
                ][len - 4];
                break;
            // Period
            case 'a':
                result.hour12 = true;
                break;
            case 'b':
            case 'B':
                throw new RangeError('`b/B` (period) patterns are not supported, use `a` instead');
            // Hour
            case 'h':
                result.hourCycle = 'h12';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'H':
                result.hourCycle = 'h23';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'K':
                result.hourCycle = 'h11';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'k':
                result.hourCycle = 'h24';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'j':
            case 'J':
            case 'C':
                throw new RangeError('`j/J/C` (hour) patterns are not supported, use `h/H/K/k` instead');
            // Minute
            case 'm':
                result.minute = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            // Second
            case 's':
                result.second = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'S':
            case 'A':
                throw new RangeError('`S/A` (second) patterns are not supported, use `s` instead');
            // Zone
            case 'z':
                result.timeZoneName = len < 4 ? 'short' : 'long';
                break;
            case 'Z':
            case 'O':
            case 'v':
            case 'V':
            case 'X':
            case 'x':
                throw new RangeError('`Z/O/v/V/X/x` (timeZone) patterns are not supported, use `z` instead');
        }
        return '';
    });
    return result;
}

});

parcelRegister("37PcY", function(module, exports) {
$parcel$export(module.exports, "parseNumberSkeletonFromString", () => $2469bf6b329677ed$export$71cee2f16fba2480);
$parcel$export(module.exports, "parseNumberSkeleton", () => $2469bf6b329677ed$export$47c6f8480bda3e11);

var $dnskZ = parcelRequire("dnskZ");

var $5mecK = parcelRequire("5mecK");
function $2469bf6b329677ed$export$71cee2f16fba2480(skeleton) {
    if (skeleton.length === 0) throw new Error('Number skeleton cannot be empty');
    // Parse the skeleton
    var stringTokens = skeleton.split((0, $5mecK.WHITE_SPACE_REGEX)).filter(function(x) {
        return x.length > 0;
    });
    var tokens = [];
    for(var _i = 0, stringTokens_1 = stringTokens; _i < stringTokens_1.length; _i++){
        var stringToken = stringTokens_1[_i];
        var stemAndOptions = stringToken.split('/');
        if (stemAndOptions.length === 0) throw new Error('Invalid number skeleton');
        var stem = stemAndOptions[0], options = stemAndOptions.slice(1);
        for(var _a = 0, options_1 = options; _a < options_1.length; _a++){
            var option = options_1[_a];
            if (option.length === 0) throw new Error('Invalid number skeleton');
        }
        tokens.push({
            stem: stem,
            options: options
        });
    }
    return tokens;
}
function $2469bf6b329677ed$var$icuUnitToEcma(unit) {
    return unit.replace(/^(.*?)-/, '');
}
var $2469bf6b329677ed$var$FRACTION_PRECISION_REGEX = /^\.(?:(0+)(\*)?|(#+)|(0+)(#+))$/g;
var $2469bf6b329677ed$var$SIGNIFICANT_PRECISION_REGEX = /^(@+)?(\+|#+)?[rs]?$/g;
var $2469bf6b329677ed$var$INTEGER_WIDTH_REGEX = /(\*)(0+)|(#+)(0+)|(0+)/g;
var $2469bf6b329677ed$var$CONCISE_INTEGER_WIDTH_REGEX = /^(0+)$/;
function $2469bf6b329677ed$var$parseSignificantPrecision(str) {
    var result = {};
    if (str[str.length - 1] === 'r') result.roundingPriority = 'morePrecision';
    else if (str[str.length - 1] === 's') result.roundingPriority = 'lessPrecision';
    str.replace($2469bf6b329677ed$var$SIGNIFICANT_PRECISION_REGEX, function(_, g1, g2) {
        // @@@ case
        if (typeof g2 !== 'string') {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length;
        } else if (g2 === '+') result.minimumSignificantDigits = g1.length;
        else if (g1[0] === '#') result.maximumSignificantDigits = g1.length;
        else {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length + (typeof g2 === 'string' ? g2.length : 0);
        }
        return '';
    });
    return result;
}
function $2469bf6b329677ed$var$parseSign(str) {
    switch(str){
        case 'sign-auto':
            return {
                signDisplay: 'auto'
            };
        case 'sign-accounting':
        case '()':
            return {
                currencySign: 'accounting'
            };
        case 'sign-always':
        case '+!':
            return {
                signDisplay: 'always'
            };
        case 'sign-accounting-always':
        case '()!':
            return {
                signDisplay: 'always',
                currencySign: 'accounting'
            };
        case 'sign-except-zero':
        case '+?':
            return {
                signDisplay: 'exceptZero'
            };
        case 'sign-accounting-except-zero':
        case '()?':
            return {
                signDisplay: 'exceptZero',
                currencySign: 'accounting'
            };
        case 'sign-never':
        case '+_':
            return {
                signDisplay: 'never'
            };
    }
}
function $2469bf6b329677ed$var$parseConciseScientificAndEngineeringStem(stem) {
    // Engineering
    var result;
    if (stem[0] === 'E' && stem[1] === 'E') {
        result = {
            notation: 'engineering'
        };
        stem = stem.slice(2);
    } else if (stem[0] === 'E') {
        result = {
            notation: 'scientific'
        };
        stem = stem.slice(1);
    }
    if (result) {
        var signDisplay = stem.slice(0, 2);
        if (signDisplay === '+!') {
            result.signDisplay = 'always';
            stem = stem.slice(2);
        } else if (signDisplay === '+?') {
            result.signDisplay = 'exceptZero';
            stem = stem.slice(2);
        }
        if (!$2469bf6b329677ed$var$CONCISE_INTEGER_WIDTH_REGEX.test(stem)) throw new Error('Malformed concise eng/scientific notation');
        result.minimumIntegerDigits = stem.length;
    }
    return result;
}
function $2469bf6b329677ed$var$parseNotationOptions(opt) {
    var result = {};
    var signOpts = $2469bf6b329677ed$var$parseSign(opt);
    if (signOpts) return signOpts;
    return result;
}
function $2469bf6b329677ed$export$47c6f8480bda3e11(tokens) {
    var result = {};
    for(var _i = 0, tokens_1 = tokens; _i < tokens_1.length; _i++){
        var token = tokens_1[_i];
        switch(token.stem){
            case 'percent':
            case '%':
                result.style = 'percent';
                continue;
            case '%x100':
                result.style = 'percent';
                result.scale = 100;
                continue;
            case 'currency':
                result.style = 'currency';
                result.currency = token.options[0];
                continue;
            case 'group-off':
            case ',_':
                result.useGrouping = false;
                continue;
            case 'precision-integer':
            case '.':
                result.maximumFractionDigits = 0;
                continue;
            case 'measure-unit':
            case 'unit':
                result.style = 'unit';
                result.unit = $2469bf6b329677ed$var$icuUnitToEcma(token.options[0]);
                continue;
            case 'compact-short':
            case 'K':
                result.notation = 'compact';
                result.compactDisplay = 'short';
                continue;
            case 'compact-long':
            case 'KK':
                result.notation = 'compact';
                result.compactDisplay = 'long';
                continue;
            case 'scientific':
                result = (0, $dnskZ.__assign)((0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, result), {
                    notation: 'scientific'
                }), token.options.reduce(function(all, opt) {
                    return (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, all), $2469bf6b329677ed$var$parseNotationOptions(opt));
                }, {}));
                continue;
            case 'engineering':
                result = (0, $dnskZ.__assign)((0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, result), {
                    notation: 'engineering'
                }), token.options.reduce(function(all, opt) {
                    return (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, all), $2469bf6b329677ed$var$parseNotationOptions(opt));
                }, {}));
                continue;
            case 'notation-simple':
                result.notation = 'standard';
                continue;
            // https://github.com/unicode-org/icu/blob/master/icu4c/source/i18n/unicode/unumberformatter.h
            case 'unit-width-narrow':
                result.currencyDisplay = 'narrowSymbol';
                result.unitDisplay = 'narrow';
                continue;
            case 'unit-width-short':
                result.currencyDisplay = 'code';
                result.unitDisplay = 'short';
                continue;
            case 'unit-width-full-name':
                result.currencyDisplay = 'name';
                result.unitDisplay = 'long';
                continue;
            case 'unit-width-iso-code':
                result.currencyDisplay = 'symbol';
                continue;
            case 'scale':
                result.scale = parseFloat(token.options[0]);
                continue;
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
            case 'integer-width':
                if (token.options.length > 1) throw new RangeError('integer-width stems only accept a single optional option');
                token.options[0].replace($2469bf6b329677ed$var$INTEGER_WIDTH_REGEX, function(_, g1, g2, g3, g4, g5) {
                    if (g1) result.minimumIntegerDigits = g2.length;
                    else if (g3 && g4) throw new Error('We currently do not support maximum integer digits');
                    else if (g5) throw new Error('We currently do not support exact integer digits');
                    return '';
                });
                continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
        if ($2469bf6b329677ed$var$CONCISE_INTEGER_WIDTH_REGEX.test(token.stem)) {
            result.minimumIntegerDigits = token.stem.length;
            continue;
        }
        if ($2469bf6b329677ed$var$FRACTION_PRECISION_REGEX.test(token.stem)) {
            // Precision
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#fraction-precision
            // precision-integer case
            if (token.options.length > 1) throw new RangeError('Fraction-precision stems only accept a single optional option');
            token.stem.replace($2469bf6b329677ed$var$FRACTION_PRECISION_REGEX, function(_, g1, g2, g3, g4, g5) {
                // .000* case (before ICU67 it was .000+)
                if (g2 === '*') result.minimumFractionDigits = g1.length;
                else if (g3 && g3[0] === '#') result.maximumFractionDigits = g3.length;
                else if (g4 && g5) {
                    result.minimumFractionDigits = g4.length;
                    result.maximumFractionDigits = g4.length + g5.length;
                } else {
                    result.minimumFractionDigits = g1.length;
                    result.maximumFractionDigits = g1.length;
                }
                return '';
            });
            var opt = token.options[0];
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#trailing-zero-display
            if (opt === 'w') result = (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, result), {
                trailingZeroDisplay: 'stripIfInteger'
            });
            else if (opt) result = (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, result), $2469bf6b329677ed$var$parseSignificantPrecision(opt));
            continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#significant-digits-precision
        if ($2469bf6b329677ed$var$SIGNIFICANT_PRECISION_REGEX.test(token.stem)) {
            result = (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, result), $2469bf6b329677ed$var$parseSignificantPrecision(token.stem));
            continue;
        }
        var signOpts = $2469bf6b329677ed$var$parseSign(token.stem);
        if (signOpts) result = (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, result), signOpts);
        var conciseScientificAndEngineeringOpts = $2469bf6b329677ed$var$parseConciseScientificAndEngineeringStem(token.stem);
        if (conciseScientificAndEngineeringOpts) result = (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, result), conciseScientificAndEngineeringOpts);
    }
    return result;
}

});
parcelRegister("5mecK", function(module, exports) {
$parcel$export(module.exports, "WHITE_SPACE_REGEX", () => $3e6a068f4b3e39e9$export$2b8db14d8bcaece7);
// @generated from regex-gen.ts
var $3e6a068f4b3e39e9$export$2b8db14d8bcaece7 = /[\t-\r \x85\u200E\u200F\u2028\u2029]/i;

});



parcelRegister("cVbPs", function(module, exports) {
$parcel$export(module.exports, "getBestPattern", () => $9683fbe3a81a17cd$export$29c5368be8904d27);

var $ksomy = parcelRequire("ksomy");
function $9683fbe3a81a17cd$export$29c5368be8904d27(skeleton, locale) {
    var skeletonCopy = '';
    for(var patternPos = 0; patternPos < skeleton.length; patternPos++){
        var patternChar = skeleton.charAt(patternPos);
        if (patternChar === 'j') {
            var extraLength = 0;
            while(patternPos + 1 < skeleton.length && skeleton.charAt(patternPos + 1) === patternChar){
                extraLength++;
                patternPos++;
            }
            var hourLen = 1 + (extraLength & 1);
            var dayPeriodLen = extraLength < 2 ? 1 : 3 + (extraLength >> 1);
            var dayPeriodChar = 'a';
            var hourChar = $9683fbe3a81a17cd$var$getDefaultHourSymbolFromLocale(locale);
            if (hourChar == 'H' || hourChar == 'k') dayPeriodLen = 0;
            while(dayPeriodLen-- > 0)skeletonCopy += dayPeriodChar;
            while(hourLen-- > 0)skeletonCopy = hourChar + skeletonCopy;
        } else if (patternChar === 'J') skeletonCopy += 'H';
        else skeletonCopy += patternChar;
    }
    return skeletonCopy;
}
/**
 * Maps the [hour cycle type](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/hourCycle)
 * of the given `locale` to the corresponding time pattern.
 * @param locale
 */ function $9683fbe3a81a17cd$var$getDefaultHourSymbolFromLocale(locale) {
    var hourCycle = locale.hourCycle;
    if (hourCycle === undefined && // @ts-ignore hourCycle(s) is not identified yet
    locale.hourCycles && // @ts-ignore
    locale.hourCycles.length) // @ts-ignore
    hourCycle = locale.hourCycles[0];
    if (hourCycle) switch(hourCycle){
        case 'h24':
            return 'k';
        case 'h23':
            return 'H';
        case 'h12':
            return 'h';
        case 'h11':
            return 'K';
        default:
            throw new Error('Invalid hourCycle');
    }
    // TODO: Once hourCycle is fully supported remove the following with data generation
    var languageTag = locale.language;
    var regionTag;
    if (languageTag !== 'root') regionTag = locale.maximize().region;
    var hourCycles = (0, $ksomy.timeData)[regionTag || ''] || (0, $ksomy.timeData)[languageTag || ''] || (0, $ksomy.timeData)["".concat(languageTag, "-001")] || (0, $ksomy.timeData)['001'];
    return hourCycles[0];
}

});
parcelRegister("ksomy", function(module, exports) {
$parcel$export(module.exports, "timeData", () => $ee49521bf228ea60$export$a8c9209db4084317);
// @generated from time-data-gen.ts
// prettier-ignore  
var $ee49521bf228ea60$export$a8c9209db4084317 = {
    "AX": [
        "H"
    ],
    "BQ": [
        "H"
    ],
    "CP": [
        "H"
    ],
    "CZ": [
        "H"
    ],
    "DK": [
        "H"
    ],
    "FI": [
        "H"
    ],
    "ID": [
        "H"
    ],
    "IS": [
        "H"
    ],
    "ML": [
        "H"
    ],
    "NE": [
        "H"
    ],
    "RU": [
        "H"
    ],
    "SE": [
        "H"
    ],
    "SJ": [
        "H"
    ],
    "SK": [
        "H"
    ],
    "AS": [
        "h",
        "H"
    ],
    "BT": [
        "h",
        "H"
    ],
    "DJ": [
        "h",
        "H"
    ],
    "ER": [
        "h",
        "H"
    ],
    "GH": [
        "h",
        "H"
    ],
    "IN": [
        "h",
        "H"
    ],
    "LS": [
        "h",
        "H"
    ],
    "PG": [
        "h",
        "H"
    ],
    "PW": [
        "h",
        "H"
    ],
    "SO": [
        "h",
        "H"
    ],
    "TO": [
        "h",
        "H"
    ],
    "VU": [
        "h",
        "H"
    ],
    "WS": [
        "h",
        "H"
    ],
    "001": [
        "H",
        "h"
    ],
    "AL": [
        "h",
        "H",
        "hB"
    ],
    "TD": [
        "h",
        "H",
        "hB"
    ],
    "ca-ES": [
        "H",
        "h",
        "hB"
    ],
    "CF": [
        "H",
        "h",
        "hB"
    ],
    "CM": [
        "H",
        "h",
        "hB"
    ],
    "fr-CA": [
        "H",
        "h",
        "hB"
    ],
    "gl-ES": [
        "H",
        "h",
        "hB"
    ],
    "it-CH": [
        "H",
        "h",
        "hB"
    ],
    "it-IT": [
        "H",
        "h",
        "hB"
    ],
    "LU": [
        "H",
        "h",
        "hB"
    ],
    "NP": [
        "H",
        "h",
        "hB"
    ],
    "PF": [
        "H",
        "h",
        "hB"
    ],
    "SC": [
        "H",
        "h",
        "hB"
    ],
    "SM": [
        "H",
        "h",
        "hB"
    ],
    "SN": [
        "H",
        "h",
        "hB"
    ],
    "TF": [
        "H",
        "h",
        "hB"
    ],
    "VA": [
        "H",
        "h",
        "hB"
    ],
    "CY": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "GR": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "CO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "DO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KP": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "NA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "VE": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "AC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "BW": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "BZ": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "DG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "FK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GB": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IM": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IO": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "JE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "LT": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MS": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NF": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NR": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NU": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "PN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SH": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "TA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ZA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "af-ZA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "AR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CL": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CU": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "EA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-BO": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-BR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-EC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-ES": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-GQ": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-PE": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "GT": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "HN": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "IC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KG": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KM": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "LK": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MX": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "NI": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "PY": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "SV": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "UY": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "JP": [
        "H",
        "h",
        "K"
    ],
    "AD": [
        "H",
        "hB"
    ],
    "AM": [
        "H",
        "hB"
    ],
    "AO": [
        "H",
        "hB"
    ],
    "AT": [
        "H",
        "hB"
    ],
    "AW": [
        "H",
        "hB"
    ],
    "BE": [
        "H",
        "hB"
    ],
    "BF": [
        "H",
        "hB"
    ],
    "BJ": [
        "H",
        "hB"
    ],
    "BL": [
        "H",
        "hB"
    ],
    "BR": [
        "H",
        "hB"
    ],
    "CG": [
        "H",
        "hB"
    ],
    "CI": [
        "H",
        "hB"
    ],
    "CV": [
        "H",
        "hB"
    ],
    "DE": [
        "H",
        "hB"
    ],
    "EE": [
        "H",
        "hB"
    ],
    "FR": [
        "H",
        "hB"
    ],
    "GA": [
        "H",
        "hB"
    ],
    "GF": [
        "H",
        "hB"
    ],
    "GN": [
        "H",
        "hB"
    ],
    "GP": [
        "H",
        "hB"
    ],
    "GW": [
        "H",
        "hB"
    ],
    "HR": [
        "H",
        "hB"
    ],
    "IL": [
        "H",
        "hB"
    ],
    "IT": [
        "H",
        "hB"
    ],
    "KZ": [
        "H",
        "hB"
    ],
    "MC": [
        "H",
        "hB"
    ],
    "MD": [
        "H",
        "hB"
    ],
    "MF": [
        "H",
        "hB"
    ],
    "MQ": [
        "H",
        "hB"
    ],
    "MZ": [
        "H",
        "hB"
    ],
    "NC": [
        "H",
        "hB"
    ],
    "NL": [
        "H",
        "hB"
    ],
    "PM": [
        "H",
        "hB"
    ],
    "PT": [
        "H",
        "hB"
    ],
    "RE": [
        "H",
        "hB"
    ],
    "RO": [
        "H",
        "hB"
    ],
    "SI": [
        "H",
        "hB"
    ],
    "SR": [
        "H",
        "hB"
    ],
    "ST": [
        "H",
        "hB"
    ],
    "TG": [
        "H",
        "hB"
    ],
    "TR": [
        "H",
        "hB"
    ],
    "WF": [
        "H",
        "hB"
    ],
    "YT": [
        "H",
        "hB"
    ],
    "BD": [
        "h",
        "hB",
        "H"
    ],
    "PK": [
        "h",
        "hB",
        "H"
    ],
    "AZ": [
        "H",
        "hB",
        "h"
    ],
    "BA": [
        "H",
        "hB",
        "h"
    ],
    "BG": [
        "H",
        "hB",
        "h"
    ],
    "CH": [
        "H",
        "hB",
        "h"
    ],
    "GE": [
        "H",
        "hB",
        "h"
    ],
    "LI": [
        "H",
        "hB",
        "h"
    ],
    "ME": [
        "H",
        "hB",
        "h"
    ],
    "RS": [
        "H",
        "hB",
        "h"
    ],
    "UA": [
        "H",
        "hB",
        "h"
    ],
    "UZ": [
        "H",
        "hB",
        "h"
    ],
    "XK": [
        "H",
        "hB",
        "h"
    ],
    "AG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "CA": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "DM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "en-001": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FJ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GD": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "JM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KN": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LR": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MH": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MP": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MW": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "NZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SL": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TT": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "UM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "US": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ZM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BO": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "EC": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "ES": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "GQ": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "PE": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "AE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ar-001": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "BH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "DZ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EG": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "HK": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "IQ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "JO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "KW": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "LB": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "LY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MR": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "OM": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PS": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "QA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SD": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "TN": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "YE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "AF": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "LA": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "CN": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "LV": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "TL": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "zu-ZA": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "CD": [
        "hB",
        "H"
    ],
    "IR": [
        "hB",
        "H"
    ],
    "hi-IN": [
        "hB",
        "h",
        "H"
    ],
    "kn-IN": [
        "hB",
        "h",
        "H"
    ],
    "ml-IN": [
        "hB",
        "h",
        "H"
    ],
    "te-IN": [
        "hB",
        "h",
        "H"
    ],
    "KH": [
        "hB",
        "h",
        "H",
        "hb"
    ],
    "ta-IN": [
        "hB",
        "h",
        "hb",
        "H"
    ],
    "BN": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "MY": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "ET": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "gu-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "mr-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "pa-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "TW": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "KE": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "MM": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "TZ": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UG": [
        "hB",
        "hb",
        "H",
        "h"
    ]
};

});




parcelRegister("kPkc1", function(module, exports) {
$parcel$export(module.exports, "default", () => $f2983bee993f7829$export$2e2bcd8739ae039);
$parcel$export(module.exports, "strategies", () => $f2983bee993f7829$export$c5491a8691a23b9e);
//
// Main
//
function $f2983bee993f7829$export$2e2bcd8739ae039(fn, options) {
    var cache = options && options.cache ? options.cache : $f2983bee993f7829$var$cacheDefault;
    var serializer = options && options.serializer ? options.serializer : $f2983bee993f7829$var$serializerDefault;
    var strategy = options && options.strategy ? options.strategy : $f2983bee993f7829$var$strategyDefault;
    return strategy(fn, {
        cache: cache,
        serializer: serializer
    });
}
//
// Strategy
//
function $f2983bee993f7829$var$isPrimitive(value) {
    return value == null || typeof value === 'number' || typeof value === 'boolean'; // || typeof value === "string" 'unsafe' primitive for our needs
}
function $f2983bee993f7829$var$monadic(fn, cache, serializer, arg) {
    var cacheKey = $f2983bee993f7829$var$isPrimitive(arg) ? arg : serializer(arg);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.call(this, arg);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $f2983bee993f7829$var$variadic(fn, cache, serializer) {
    var args = Array.prototype.slice.call(arguments, 3);
    var cacheKey = serializer(args);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.apply(this, args);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $f2983bee993f7829$var$assemble(fn, context, strategy, cache, serialize) {
    return strategy.bind(context, fn, cache, serialize);
}
function $f2983bee993f7829$var$strategyDefault(fn, options) {
    var strategy = fn.length === 1 ? $f2983bee993f7829$var$monadic : $f2983bee993f7829$var$variadic;
    return $f2983bee993f7829$var$assemble(fn, this, strategy, options.cache.create(), options.serializer);
}
function $f2983bee993f7829$var$strategyVariadic(fn, options) {
    return $f2983bee993f7829$var$assemble(fn, this, $f2983bee993f7829$var$variadic, options.cache.create(), options.serializer);
}
function $f2983bee993f7829$var$strategyMonadic(fn, options) {
    return $f2983bee993f7829$var$assemble(fn, this, $f2983bee993f7829$var$monadic, options.cache.create(), options.serializer);
}
//
// Serializer
//
var $f2983bee993f7829$var$serializerDefault = function() {
    return JSON.stringify(arguments);
};
//
// Cache
//
function $f2983bee993f7829$var$ObjectWithoutPrototypeCache() {
    this.cache = Object.create(null);
}
$f2983bee993f7829$var$ObjectWithoutPrototypeCache.prototype.get = function(key) {
    return this.cache[key];
};
$f2983bee993f7829$var$ObjectWithoutPrototypeCache.prototype.set = function(key, value) {
    this.cache[key] = value;
};
var $f2983bee993f7829$var$cacheDefault = {
    create: function create() {
        // @ts-ignore
        return new $f2983bee993f7829$var$ObjectWithoutPrototypeCache();
    }
};
var $f2983bee993f7829$export$c5491a8691a23b9e = {
    variadic: $f2983bee993f7829$var$strategyVariadic,
    monadic: $f2983bee993f7829$var$strategyMonadic
};

});

parcelRegister("3ucBM", function(module, exports) {
$parcel$export(module.exports, "PART_TYPE", () => $289df4353e80724f$export$49694c2877b44c57);
$parcel$export(module.exports, "isFormatXMLElementFn", () => $289df4353e80724f$export$df0c12a2d414a163);
$parcel$export(module.exports, "formatToParts", () => $289df4353e80724f$export$275d4a3bb5f66fda);
parcelRequire("g41Aa");
var $ahqHA = parcelRequire("ahqHA");

var $klPYX = parcelRequire("klPYX");
var $289df4353e80724f$export$49694c2877b44c57;
(function(PART_TYPE) {
    PART_TYPE[PART_TYPE["literal"] = 0] = "literal";
    PART_TYPE[PART_TYPE["object"] = 1] = "object";
})($289df4353e80724f$export$49694c2877b44c57 || ($289df4353e80724f$export$49694c2877b44c57 = {}));
function $289df4353e80724f$var$mergeLiteral(parts) {
    if (parts.length < 2) return parts;
    return parts.reduce(function(all, part) {
        var lastPart = all[all.length - 1];
        if (!lastPart || lastPart.type !== $289df4353e80724f$export$49694c2877b44c57.literal || part.type !== $289df4353e80724f$export$49694c2877b44c57.literal) all.push(part);
        else lastPart.value += part.value;
        return all;
    }, []);
}
function $289df4353e80724f$export$df0c12a2d414a163(el) {
    return typeof el === 'function';
}
function $289df4353e80724f$export$275d4a3bb5f66fda(els, locales, formatters, formats, values, currentPluralValue, // For debugging
originalMessage) {
    // Hot path for straight simple msg translations
    if (els.length === 1 && (0, $ahqHA.isLiteralElement)(els[0])) return [
        {
            type: $289df4353e80724f$export$49694c2877b44c57.literal,
            value: els[0].value
        }
    ];
    var result = [];
    for(var _i = 0, els_1 = els; _i < els_1.length; _i++){
        var el = els_1[_i];
        // Exit early for string parts.
        if ((0, $ahqHA.isLiteralElement)(el)) {
            result.push({
                type: $289df4353e80724f$export$49694c2877b44c57.literal,
                value: el.value
            });
            continue;
        }
        // TODO: should this part be literal type?
        // Replace `#` in plural rules with the actual numeric value.
        if ((0, $ahqHA.isPoundElement)(el)) {
            if (typeof currentPluralValue === 'number') result.push({
                type: $289df4353e80724f$export$49694c2877b44c57.literal,
                value: formatters.getNumberFormat(locales).format(currentPluralValue)
            });
            continue;
        }
        var varName = el.value;
        // Enforce that all required values are provided by the caller.
        if (!(values && varName in values)) throw new (0, $klPYX.MissingValueError)(varName, originalMessage);
        var value = values[varName];
        if ((0, $ahqHA.isArgumentElement)(el)) {
            if (!value || typeof value === 'string' || typeof value === 'number') value = typeof value === 'string' || typeof value === 'number' ? String(value) : '';
            result.push({
                type: typeof value === 'string' ? $289df4353e80724f$export$49694c2877b44c57.literal : $289df4353e80724f$export$49694c2877b44c57.object,
                value: value
            });
            continue;
        }
        // Recursively format plural and select parts' option — which can be a
        // nested pattern structure. The choosing of the option to use is
        // abstracted-by and delegated-to the part helper object.
        if ((0, $ahqHA.isDateElement)(el)) {
            var style = typeof el.style === 'string' ? formats.date[el.style] : (0, $ahqHA.isDateTimeSkeleton)(el.style) ? el.style.parsedOptions : undefined;
            result.push({
                type: $289df4353e80724f$export$49694c2877b44c57.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $ahqHA.isTimeElement)(el)) {
            var style = typeof el.style === 'string' ? formats.time[el.style] : (0, $ahqHA.isDateTimeSkeleton)(el.style) ? el.style.parsedOptions : formats.time.medium;
            result.push({
                type: $289df4353e80724f$export$49694c2877b44c57.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $ahqHA.isNumberElement)(el)) {
            var style = typeof el.style === 'string' ? formats.number[el.style] : (0, $ahqHA.isNumberSkeleton)(el.style) ? el.style.parsedOptions : undefined;
            if (style && style.scale) value = value * (style.scale || 1);
            result.push({
                type: $289df4353e80724f$export$49694c2877b44c57.literal,
                value: formatters.getNumberFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $ahqHA.isTagElement)(el)) {
            var children = el.children, value_1 = el.value;
            var formatFn = values[value_1];
            if (!$289df4353e80724f$export$df0c12a2d414a163(formatFn)) throw new (0, $klPYX.InvalidValueTypeError)(value_1, 'function', originalMessage);
            var parts = $289df4353e80724f$export$275d4a3bb5f66fda(children, locales, formatters, formats, values, currentPluralValue);
            var chunks = formatFn(parts.map(function(p) {
                return p.value;
            }));
            if (!Array.isArray(chunks)) chunks = [
                chunks
            ];
            result.push.apply(result, chunks.map(function(c) {
                return {
                    type: typeof c === 'string' ? $289df4353e80724f$export$49694c2877b44c57.literal : $289df4353e80724f$export$49694c2877b44c57.object,
                    value: c
                };
            }));
        }
        if ((0, $ahqHA.isSelectElement)(el)) {
            var opt = el.options[value] || el.options.other;
            if (!opt) throw new (0, $klPYX.InvalidValueError)(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, $289df4353e80724f$export$275d4a3bb5f66fda(opt.value, locales, formatters, formats, values));
            continue;
        }
        if ((0, $ahqHA.isPluralElement)(el)) {
            var opt = el.options["=".concat(value)];
            if (!opt) {
                if (!Intl.PluralRules) throw new (0, $klPYX.FormatError)("Intl.PluralRules is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-pluralrules\"\n", (0, $klPYX.ErrorCode).MISSING_INTL_API, originalMessage);
                var rule = formatters.getPluralRules(locales, {
                    type: el.pluralType
                }).select(value - (el.offset || 0));
                opt = el.options[rule] || el.options.other;
            }
            if (!opt) throw new (0, $klPYX.InvalidValueError)(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, $289df4353e80724f$export$275d4a3bb5f66fda(opt.value, locales, formatters, formats, values, value - (el.offset || 0)));
            continue;
        }
    }
    return $289df4353e80724f$var$mergeLiteral(result);
}

});
parcelRegister("klPYX", function(module, exports) {
$parcel$export(module.exports, "ErrorCode", () => $ed0e17652168f1bf$export$d4e71bc0b80dc0fb);
$parcel$export(module.exports, "FormatError", () => $ed0e17652168f1bf$export$7369836851cc1329);
$parcel$export(module.exports, "InvalidValueError", () => $ed0e17652168f1bf$export$565c3afc07dfa382);
$parcel$export(module.exports, "InvalidValueTypeError", () => $ed0e17652168f1bf$export$cbc0db47c750f7c9);
$parcel$export(module.exports, "MissingValueError", () => $ed0e17652168f1bf$export$8bfc137e4d23fdf0);

var $dnskZ = parcelRequire("dnskZ");
var $ed0e17652168f1bf$export$d4e71bc0b80dc0fb;
(function(ErrorCode) {
    // When we have a placeholder but no value to format
    ErrorCode["MISSING_VALUE"] = "MISSING_VALUE";
    // When value supplied is invalid
    ErrorCode["INVALID_VALUE"] = "INVALID_VALUE";
    // When we need specific Intl API but it's not available
    ErrorCode["MISSING_INTL_API"] = "MISSING_INTL_API";
})($ed0e17652168f1bf$export$d4e71bc0b80dc0fb || ($ed0e17652168f1bf$export$d4e71bc0b80dc0fb = {}));
var $ed0e17652168f1bf$export$7369836851cc1329 = /** @class */ function(_super) {
    (0, $dnskZ.__extends)(FormatError, _super);
    function FormatError(msg, code, originalMessage) {
        var _this = _super.call(this, msg) || this;
        _this.code = code;
        _this.originalMessage = originalMessage;
        return _this;
    }
    FormatError.prototype.toString = function() {
        return "[formatjs Error: ".concat(this.code, "] ").concat(this.message);
    };
    return FormatError;
}(Error);
var $ed0e17652168f1bf$export$565c3afc07dfa382 = /** @class */ function(_super) {
    (0, $dnskZ.__extends)(InvalidValueError, _super);
    function InvalidValueError(variableId, value, options, originalMessage) {
        return _super.call(this, "Invalid values for \"".concat(variableId, "\": \"").concat(value, "\". Options are \"").concat(Object.keys(options).join('", "'), "\""), $ed0e17652168f1bf$export$d4e71bc0b80dc0fb.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueError;
}($ed0e17652168f1bf$export$7369836851cc1329);
var $ed0e17652168f1bf$export$cbc0db47c750f7c9 = /** @class */ function(_super) {
    (0, $dnskZ.__extends)(InvalidValueTypeError, _super);
    function InvalidValueTypeError(value, type, originalMessage) {
        return _super.call(this, "Value for \"".concat(value, "\" must be of type ").concat(type), $ed0e17652168f1bf$export$d4e71bc0b80dc0fb.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueTypeError;
}($ed0e17652168f1bf$export$7369836851cc1329);
var $ed0e17652168f1bf$export$8bfc137e4d23fdf0 = /** @class */ function(_super) {
    (0, $dnskZ.__extends)(MissingValueError, _super);
    function MissingValueError(variableId, originalMessage) {
        return _super.call(this, "The intl string context variable \"".concat(variableId, "\" was not provided to the string \"").concat(originalMessage, "\""), $ed0e17652168f1bf$export$d4e71bc0b80dc0fb.MISSING_VALUE, originalMessage) || this;
    }
    return MissingValueError;
}($ed0e17652168f1bf$export$7369836851cc1329);

});



parcelRegister("4X6rq", function(module, exports) {
$parcel$export(module.exports, "default", () => $39b1ab4009bd1fb3$export$2e2bcd8739ae039);
$parcel$export(module.exports, "strategies", () => $39b1ab4009bd1fb3$export$c5491a8691a23b9e);
//
// Main
//
function $39b1ab4009bd1fb3$export$2e2bcd8739ae039(fn, options) {
    var cache = options && options.cache ? options.cache : $39b1ab4009bd1fb3$var$cacheDefault;
    var serializer = options && options.serializer ? options.serializer : $39b1ab4009bd1fb3$var$serializerDefault;
    var strategy = options && options.strategy ? options.strategy : $39b1ab4009bd1fb3$var$strategyDefault;
    return strategy(fn, {
        cache: cache,
        serializer: serializer
    });
}
//
// Strategy
//
function $39b1ab4009bd1fb3$var$isPrimitive(value) {
    return value == null || typeof value === 'number' || typeof value === 'boolean'; // || typeof value === "string" 'unsafe' primitive for our needs
}
function $39b1ab4009bd1fb3$var$monadic(fn, cache, serializer, arg) {
    var cacheKey = $39b1ab4009bd1fb3$var$isPrimitive(arg) ? arg : serializer(arg);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.call(this, arg);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $39b1ab4009bd1fb3$var$variadic(fn, cache, serializer) {
    var args = Array.prototype.slice.call(arguments, 3);
    var cacheKey = serializer(args);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.apply(this, args);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $39b1ab4009bd1fb3$var$assemble(fn, context, strategy, cache, serialize) {
    return strategy.bind(context, fn, cache, serialize);
}
function $39b1ab4009bd1fb3$var$strategyDefault(fn, options) {
    var strategy = fn.length === 1 ? $39b1ab4009bd1fb3$var$monadic : $39b1ab4009bd1fb3$var$variadic;
    return $39b1ab4009bd1fb3$var$assemble(fn, this, strategy, options.cache.create(), options.serializer);
}
function $39b1ab4009bd1fb3$var$strategyVariadic(fn, options) {
    return $39b1ab4009bd1fb3$var$assemble(fn, this, $39b1ab4009bd1fb3$var$variadic, options.cache.create(), options.serializer);
}
function $39b1ab4009bd1fb3$var$strategyMonadic(fn, options) {
    return $39b1ab4009bd1fb3$var$assemble(fn, this, $39b1ab4009bd1fb3$var$monadic, options.cache.create(), options.serializer);
}
//
// Serializer
//
var $39b1ab4009bd1fb3$var$serializerDefault = function() {
    return JSON.stringify(arguments);
};
//
// Cache
//
function $39b1ab4009bd1fb3$var$ObjectWithoutPrototypeCache() {
    this.cache = Object.create(null);
}
$39b1ab4009bd1fb3$var$ObjectWithoutPrototypeCache.prototype.get = function(key) {
    return this.cache[key];
};
$39b1ab4009bd1fb3$var$ObjectWithoutPrototypeCache.prototype.set = function(key, value) {
    this.cache[key] = value;
};
var $39b1ab4009bd1fb3$var$cacheDefault = {
    create: function create() {
        // @ts-ignore
        return new $39b1ab4009bd1fb3$var$ObjectWithoutPrototypeCache();
    }
};
var $39b1ab4009bd1fb3$export$c5491a8691a23b9e = {
    variadic: $39b1ab4009bd1fb3$var$strategyVariadic,
    monadic: $39b1ab4009bd1fb3$var$strategyMonadic
};

});

parcelRegister("6zNca", function(module, exports) {
$parcel$export(module.exports, "IntlErrorCode", () => $4c9c2c1ffb8f75b3$export$557d6acb76e8a244);
$parcel$export(module.exports, "IntlError", () => $4c9c2c1ffb8f75b3$export$c016d36112f6ddf8);
$parcel$export(module.exports, "UnsupportedFormatterError", () => $4c9c2c1ffb8f75b3$export$549f97e137a05c90);
$parcel$export(module.exports, "InvalidConfigError", () => $4c9c2c1ffb8f75b3$export$3ca04dd7fb305893);
$parcel$export(module.exports, "MissingDataError", () => $4c9c2c1ffb8f75b3$export$c1eaf877d81384b6);
$parcel$export(module.exports, "IntlFormatError", () => $4c9c2c1ffb8f75b3$export$e3b7eee1dbc44895);
$parcel$export(module.exports, "MessageFormatError", () => $4c9c2c1ffb8f75b3$export$74a601a3d3f31621);
$parcel$export(module.exports, "MissingTranslationError", () => $4c9c2c1ffb8f75b3$export$2ddcb436d0aa3688);

var $dnskZ = parcelRequire("dnskZ");
var $4c9c2c1ffb8f75b3$export$557d6acb76e8a244;
(function(IntlErrorCode) {
    IntlErrorCode["FORMAT_ERROR"] = "FORMAT_ERROR";
    IntlErrorCode["UNSUPPORTED_FORMATTER"] = "UNSUPPORTED_FORMATTER";
    IntlErrorCode["INVALID_CONFIG"] = "INVALID_CONFIG";
    IntlErrorCode["MISSING_DATA"] = "MISSING_DATA";
    IntlErrorCode["MISSING_TRANSLATION"] = "MISSING_TRANSLATION";
})($4c9c2c1ffb8f75b3$export$557d6acb76e8a244 || ($4c9c2c1ffb8f75b3$export$557d6acb76e8a244 = {}));
var $4c9c2c1ffb8f75b3$export$c016d36112f6ddf8 = /** @class */ function(_super) {
    (0, $dnskZ.__extends)(IntlError, _super);
    function IntlError(code, message, exception) {
        var _this = this;
        var err = exception ? exception instanceof Error ? exception : new Error(String(exception)) : undefined;
        _this = _super.call(this, "[@formatjs/intl Error ".concat(code, "] ").concat(message, " \n").concat(err ? "\n".concat(err.message, "\n").concat(err.stack) : '')) || this;
        _this.code = code;
        // @ts-ignore just so we don't need to declare dep on @types/node
        if (typeof Error.captureStackTrace === 'function') // @ts-ignore just so we don't need to declare dep on @types/node
        Error.captureStackTrace(_this, IntlError);
        return _this;
    }
    return IntlError;
}(Error);
var $4c9c2c1ffb8f75b3$export$549f97e137a05c90 = /** @class */ function(_super) {
    (0, $dnskZ.__extends)(UnsupportedFormatterError, _super);
    function UnsupportedFormatterError(message, exception) {
        return _super.call(this, $4c9c2c1ffb8f75b3$export$557d6acb76e8a244.UNSUPPORTED_FORMATTER, message, exception) || this;
    }
    return UnsupportedFormatterError;
}($4c9c2c1ffb8f75b3$export$c016d36112f6ddf8);
var $4c9c2c1ffb8f75b3$export$3ca04dd7fb305893 = /** @class */ function(_super) {
    (0, $dnskZ.__extends)(InvalidConfigError, _super);
    function InvalidConfigError(message, exception) {
        return _super.call(this, $4c9c2c1ffb8f75b3$export$557d6acb76e8a244.INVALID_CONFIG, message, exception) || this;
    }
    return InvalidConfigError;
}($4c9c2c1ffb8f75b3$export$c016d36112f6ddf8);
var $4c9c2c1ffb8f75b3$export$c1eaf877d81384b6 = /** @class */ function(_super) {
    (0, $dnskZ.__extends)(MissingDataError, _super);
    function MissingDataError(message, exception) {
        return _super.call(this, $4c9c2c1ffb8f75b3$export$557d6acb76e8a244.MISSING_DATA, message, exception) || this;
    }
    return MissingDataError;
}($4c9c2c1ffb8f75b3$export$c016d36112f6ddf8);
var $4c9c2c1ffb8f75b3$export$e3b7eee1dbc44895 = /** @class */ function(_super) {
    (0, $dnskZ.__extends)(IntlFormatError, _super);
    function IntlFormatError(message, locale, exception) {
        return _super.call(this, $4c9c2c1ffb8f75b3$export$557d6acb76e8a244.FORMAT_ERROR, "".concat(message, " \nLocale: ").concat(locale, "\n"), exception) || this;
    }
    return IntlFormatError;
}($4c9c2c1ffb8f75b3$export$c016d36112f6ddf8);
var $4c9c2c1ffb8f75b3$export$74a601a3d3f31621 = /** @class */ function(_super) {
    (0, $dnskZ.__extends)(MessageFormatError, _super);
    function MessageFormatError(message, locale, descriptor, exception) {
        var _this = _super.call(this, "".concat(message, " \nMessageID: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.id, "\nDefault Message: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.defaultMessage, "\nDescription: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.description, " \n"), locale, exception) || this;
        _this.descriptor = descriptor;
        return _this;
    }
    return MessageFormatError;
}($4c9c2c1ffb8f75b3$export$e3b7eee1dbc44895);
var $4c9c2c1ffb8f75b3$export$2ddcb436d0aa3688 = /** @class */ function(_super) {
    (0, $dnskZ.__extends)(MissingTranslationError, _super);
    function MissingTranslationError(descriptor, locale) {
        var _this = _super.call(this, $4c9c2c1ffb8f75b3$export$557d6acb76e8a244.MISSING_TRANSLATION, "Missing message: \"".concat(descriptor.id, "\" for locale \"").concat(locale, "\", using ").concat(descriptor.defaultMessage ? 'default message' : 'id', " as fallback.")) || this;
        _this.descriptor = descriptor;
        return _this;
    }
    return MissingTranslationError;
}($4c9c2c1ffb8f75b3$export$c016d36112f6ddf8);

});


parcelRegister("3ovvM", function(module, exports) {
$parcel$export(module.exports, "createIntl", () => $278c0e892a60e8df$export$7e4cbedfdd7b4c0d);

var $dnskZ = parcelRequire("dnskZ");

var $99KvW = parcelRequire("99KvW");

var $6zNca = parcelRequire("6zNca");

var $5QGbs = parcelRequire("5QGbs");

var $dZR7g = parcelRequire("dZR7g");

var $kCU0o = parcelRequire("kCU0o");

var $h6Vo4 = parcelRequire("h6Vo4");

var $gC2Rt = parcelRequire("gC2Rt");

var $jQfMu = parcelRequire("jQfMu");

var $9zWXp = parcelRequire("9zWXp");
function $278c0e892a60e8df$var$messagesContainString(messages) {
    var firstMessage = messages ? messages[Object.keys(messages)[0]] : undefined;
    return typeof firstMessage === 'string';
}
function $278c0e892a60e8df$var$verifyConfigMessages(config) {
    if (config.onWarn && config.defaultRichTextElements && $278c0e892a60e8df$var$messagesContainString(config.messages || {})) config.onWarn("[@formatjs/intl] \"defaultRichTextElements\" was specified but \"message\" was not pre-compiled. \nPlease consider using \"@formatjs/cli\" to pre-compile your messages for performance.\nFor more details see https://formatjs.io/docs/getting-started/message-distribution");
}
function $278c0e892a60e8df$export$7e4cbedfdd7b4c0d(config, cache) {
    var formatters = (0, $99KvW.createFormatters)(cache);
    var resolvedConfig = (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, (0, $99KvW.DEFAULT_INTL_CONFIG)), config);
    var locale = resolvedConfig.locale, defaultLocale = resolvedConfig.defaultLocale, onError = resolvedConfig.onError;
    if (!locale) {
        if (onError) onError(new (0, $6zNca.InvalidConfigError)("\"locale\" was not configured, using \"".concat(defaultLocale, "\" as fallback. See https://formatjs.io/docs/react-intl/api#intlshape for more details")));
        // Since there's no registered locale data for `locale`, this will
        // fallback to the `defaultLocale` to make sure things can render.
        // The `messages` are overridden to the `defaultProps` empty object
        // to maintain referential equality across re-renders. It's assumed
        // each <FormattedMessage> contains a `defaultMessage` prop.
        resolvedConfig.locale = resolvedConfig.defaultLocale || 'en';
    } else if (!Intl.NumberFormat.supportedLocalesOf(locale).length && onError) onError(new (0, $6zNca.MissingDataError)("Missing locale data for locale: \"".concat(locale, "\" in Intl.NumberFormat. Using default locale: \"").concat(defaultLocale, "\" as fallback. See https://formatjs.io/docs/react-intl#runtime-requirements for more details")));
    else if (!Intl.DateTimeFormat.supportedLocalesOf(locale).length && onError) onError(new (0, $6zNca.MissingDataError)("Missing locale data for locale: \"".concat(locale, "\" in Intl.DateTimeFormat. Using default locale: \"").concat(defaultLocale, "\" as fallback. See https://formatjs.io/docs/react-intl#runtime-requirements for more details")));
    $278c0e892a60e8df$var$verifyConfigMessages(resolvedConfig);
    return (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, resolvedConfig), {
        formatters: formatters,
        formatNumber: (0, $5QGbs.formatNumber).bind(null, resolvedConfig, formatters.getNumberFormat),
        formatNumberToParts: (0, $5QGbs.formatNumberToParts).bind(null, resolvedConfig, formatters.getNumberFormat),
        formatRelativeTime: (0, $dZR7g.formatRelativeTime).bind(null, resolvedConfig, formatters.getRelativeTimeFormat),
        formatDate: (0, $kCU0o.formatDate).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatDateToParts: (0, $kCU0o.formatDateToParts).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatTime: (0, $kCU0o.formatTime).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatDateTimeRange: (0, $kCU0o.formatDateTimeRange).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatTimeToParts: (0, $kCU0o.formatTimeToParts).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatPlural: (0, $h6Vo4.formatPlural).bind(null, resolvedConfig, formatters.getPluralRules),
        formatMessage: (0, $gC2Rt.formatMessage).bind(null, resolvedConfig, formatters),
        $t: (0, $gC2Rt.formatMessage).bind(null, resolvedConfig, formatters),
        formatList: (0, $jQfMu.formatList).bind(null, resolvedConfig, formatters.getListFormat),
        formatListToParts: (0, $jQfMu.formatListToParts).bind(null, resolvedConfig, formatters.getListFormat),
        formatDisplayName: (0, $9zWXp.formatDisplayName).bind(null, resolvedConfig, formatters.getDisplayNames)
    });
}

});
parcelRegister("5QGbs", function(module, exports) {
$parcel$export(module.exports, "formatNumber", () => $442287e595ae9d89$export$f5dd818bff069720);
$parcel$export(module.exports, "formatNumberToParts", () => $442287e595ae9d89$export$6871080848f10b2f);

var $99KvW = parcelRequire("99KvW");

var $6zNca = parcelRequire("6zNca");
var $442287e595ae9d89$var$NUMBER_FORMAT_OPTIONS = [
    'localeMatcher',
    'style',
    'currency',
    'currencyDisplay',
    'unit',
    'unitDisplay',
    'useGrouping',
    'minimumIntegerDigits',
    'minimumFractionDigits',
    'maximumFractionDigits',
    'minimumSignificantDigits',
    'maximumSignificantDigits',
    // ES2020 NumberFormat
    'compactDisplay',
    'currencyDisplay',
    'currencySign',
    'notation',
    'signDisplay',
    'unit',
    'unitDisplay',
    'numberingSystem'
];
function $442287e595ae9d89$export$a7f9565e3c81cd54(_a, getNumberFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = format && (0, $99KvW.getNamedFormat)(formats, 'number', format, onError) || {};
    var filteredOptions = (0, $99KvW.filterProps)(options, $442287e595ae9d89$var$NUMBER_FORMAT_OPTIONS, defaults);
    return getNumberFormat(locale, filteredOptions);
}
function $442287e595ae9d89$export$f5dd818bff069720(config, getNumberFormat, value, options) {
    if (options === void 0) options = {};
    try {
        return $442287e595ae9d89$export$a7f9565e3c81cd54(config, getNumberFormat, options).format(value);
    } catch (e) {
        config.onError(new (0, $6zNca.IntlError)((0, $6zNca.IntlErrorCode).FORMAT_ERROR, 'Error formatting number.', e));
    }
    return String(value);
}
function $442287e595ae9d89$export$6871080848f10b2f(config, getNumberFormat, value, options) {
    if (options === void 0) options = {};
    try {
        return $442287e595ae9d89$export$a7f9565e3c81cd54(config, getNumberFormat, options).formatToParts(value);
    } catch (e) {
        config.onError(new (0, $6zNca.IntlError)((0, $6zNca.IntlErrorCode).FORMAT_ERROR, 'Error formatting number.', e));
    }
    return [];
}

});

parcelRegister("dZR7g", function(module, exports) {
$parcel$export(module.exports, "formatRelativeTime", () => $02a13244a4658d8c$export$b4ea3b48dcf921f6);

var $99KvW = parcelRequire("99KvW");

var $klPYX = parcelRequire("klPYX");

var $6zNca = parcelRequire("6zNca");
var $02a13244a4658d8c$var$RELATIVE_TIME_FORMAT_OPTIONS = [
    'numeric',
    'style'
];
function $02a13244a4658d8c$var$getFormatter(_a, getRelativeTimeFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = !!format && (0, $99KvW.getNamedFormat)(formats, 'relative', format, onError) || {};
    var filteredOptions = (0, $99KvW.filterProps)(options, $02a13244a4658d8c$var$RELATIVE_TIME_FORMAT_OPTIONS, defaults);
    return getRelativeTimeFormat(locale, filteredOptions);
}
function $02a13244a4658d8c$export$b4ea3b48dcf921f6(config, getRelativeTimeFormat, value, unit, options) {
    if (options === void 0) options = {};
    if (!unit) unit = 'second';
    var RelativeTimeFormat = Intl.RelativeTimeFormat;
    if (!RelativeTimeFormat) config.onError(new (0, $klPYX.FormatError)("Intl.RelativeTimeFormat is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-relativetimeformat\"\n", (0, $klPYX.ErrorCode).MISSING_INTL_API));
    try {
        return $02a13244a4658d8c$var$getFormatter(config, getRelativeTimeFormat, options).format(value, unit);
    } catch (e) {
        config.onError(new (0, $6zNca.IntlFormatError)('Error formatting relative time.', config.locale, e));
    }
    return String(value);
}

});

parcelRegister("kCU0o", function(module, exports) {
$parcel$export(module.exports, "formatDate", () => $f042ccbfccd416ba$export$3ae94a2503e890a1);
$parcel$export(module.exports, "formatTime", () => $f042ccbfccd416ba$export$3203edd9e5edd663);
$parcel$export(module.exports, "formatDateTimeRange", () => $f042ccbfccd416ba$export$a7fc3a91cb2ec376);
$parcel$export(module.exports, "formatDateToParts", () => $f042ccbfccd416ba$export$dc1f059bce486b1);
$parcel$export(module.exports, "formatTimeToParts", () => $f042ccbfccd416ba$export$af6e5d7a5c73edeb);

var $dnskZ = parcelRequire("dnskZ");

var $99KvW = parcelRequire("99KvW");

var $6zNca = parcelRequire("6zNca");
var $f042ccbfccd416ba$var$DATE_TIME_FORMAT_OPTIONS = [
    'localeMatcher',
    'formatMatcher',
    'timeZone',
    'hour12',
    'weekday',
    'era',
    'year',
    'month',
    'day',
    'hour',
    'minute',
    'second',
    'timeZoneName',
    'hourCycle',
    'dateStyle',
    'timeStyle',
    'calendar',
    // 'dayPeriod',
    'numberingSystem'
];
function $f042ccbfccd416ba$export$a7f9565e3c81cd54(_a, type, getDateTimeFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError, timeZone = _a.timeZone;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, timeZone && {
        timeZone: timeZone
    }), format && (0, $99KvW.getNamedFormat)(formats, type, format, onError));
    var filteredOptions = (0, $99KvW.filterProps)(options, $f042ccbfccd416ba$var$DATE_TIME_FORMAT_OPTIONS, defaults);
    if (type === 'time' && !filteredOptions.hour && !filteredOptions.minute && !filteredOptions.second && !filteredOptions.timeStyle && !filteredOptions.dateStyle) // Add default formatting options if hour, minute, or second isn't defined.
    filteredOptions = (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, filteredOptions), {
        hour: 'numeric',
        minute: 'numeric'
    });
    return getDateTimeFormat(locale, filteredOptions);
}
function $f042ccbfccd416ba$export$3ae94a2503e890a1(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return $f042ccbfccd416ba$export$a7f9565e3c81cd54(config, 'date', getDateTimeFormat, options).format(date);
    } catch (e) {
        config.onError(new (0, $6zNca.IntlError)((0, $6zNca.IntlErrorCode).FORMAT_ERROR, 'Error formatting date.', e));
    }
    return String(date);
}
function $f042ccbfccd416ba$export$3203edd9e5edd663(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return $f042ccbfccd416ba$export$a7f9565e3c81cd54(config, 'time', getDateTimeFormat, options).format(date);
    } catch (e) {
        config.onError(new (0, $6zNca.IntlError)((0, $6zNca.IntlErrorCode).FORMAT_ERROR, 'Error formatting time.', e));
    }
    return String(date);
}
function $f042ccbfccd416ba$export$a7fc3a91cb2ec376(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var from = _a[0], to = _a[1], _b = _a[2], options = _b === void 0 ? {} : _b;
    var timeZone = config.timeZone, locale = config.locale, onError = config.onError;
    var filteredOptions = (0, $99KvW.filterProps)(options, $f042ccbfccd416ba$var$DATE_TIME_FORMAT_OPTIONS, timeZone ? {
        timeZone: timeZone
    } : {});
    try {
        return getDateTimeFormat(locale, filteredOptions).formatRange(from, to);
    } catch (e) {
        onError(new (0, $6zNca.IntlError)((0, $6zNca.IntlErrorCode).FORMAT_ERROR, 'Error formatting date time range.', e));
    }
    return String(from);
}
function $f042ccbfccd416ba$export$dc1f059bce486b1(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return $f042ccbfccd416ba$export$a7f9565e3c81cd54(config, 'date', getDateTimeFormat, options).formatToParts(date);
    } catch (e) {
        config.onError(new (0, $6zNca.IntlError)((0, $6zNca.IntlErrorCode).FORMAT_ERROR, 'Error formatting date.', e));
    }
    return [];
}
function $f042ccbfccd416ba$export$af6e5d7a5c73edeb(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return $f042ccbfccd416ba$export$a7f9565e3c81cd54(config, 'time', getDateTimeFormat, options).formatToParts(date);
    } catch (e) {
        config.onError(new (0, $6zNca.IntlError)((0, $6zNca.IntlErrorCode).FORMAT_ERROR, 'Error formatting time.', e));
    }
    return [];
}

});

parcelRegister("h6Vo4", function(module, exports) {
$parcel$export(module.exports, "formatPlural", () => $c74f8321367ae911$export$bbbd05c900f3568d);

var $99KvW = parcelRequire("99KvW");

var $6zNca = parcelRequire("6zNca");

var $klPYX = parcelRequire("klPYX");
var $c74f8321367ae911$var$PLURAL_FORMAT_OPTIONS = [
    'localeMatcher',
    'type'
];
function $c74f8321367ae911$export$bbbd05c900f3568d(_a, getPluralRules, value, options) {
    var locale = _a.locale, onError = _a.onError;
    if (options === void 0) options = {};
    if (!Intl.PluralRules) onError(new (0, $klPYX.FormatError)("Intl.PluralRules is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-pluralrules\"\n", (0, $klPYX.ErrorCode).MISSING_INTL_API));
    var filteredOptions = (0, $99KvW.filterProps)(options, $c74f8321367ae911$var$PLURAL_FORMAT_OPTIONS);
    try {
        return getPluralRules(locale, filteredOptions).select(value);
    } catch (e) {
        onError(new (0, $6zNca.IntlFormatError)('Error formatting plural.', locale, e));
    }
    return 'other';
}

});

parcelRegister("gC2Rt", function(module, exports) {
$parcel$export(module.exports, "formatMessage", () => $c1826a29cf38fd84$export$25868d1e8e76735f);

var $dnskZ = parcelRequire("dnskZ");

var $A7PQX = parcelRequire("A7PQX");

var $gbVAh = parcelRequire("gbVAh");

var $6zNca = parcelRequire("6zNca");
parcelRequire("kYJR9");
var $O1ybS = parcelRequire("O1ybS");
function $c1826a29cf38fd84$var$setTimeZoneInOptions(opts, timeZone) {
    return Object.keys(opts).reduce(function(all, k) {
        all[k] = (0, $dnskZ.__assign)({
            timeZone: timeZone
        }, opts[k]);
        return all;
    }, {});
}
function $c1826a29cf38fd84$var$deepMergeOptions(opts1, opts2) {
    var keys = Object.keys((0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, opts1), opts2));
    return keys.reduce(function(all, k) {
        all[k] = (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, opts1[k] || {}), opts2[k] || {});
        return all;
    }, {});
}
function $c1826a29cf38fd84$var$deepMergeFormatsAndSetTimeZone(f1, timeZone) {
    if (!timeZone) return f1;
    var mfFormats = (0, $gbVAh.IntlMessageFormat).formats;
    return (0, $dnskZ.__assign)((0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, mfFormats), f1), {
        date: $c1826a29cf38fd84$var$deepMergeOptions($c1826a29cf38fd84$var$setTimeZoneInOptions(mfFormats.date, timeZone), $c1826a29cf38fd84$var$setTimeZoneInOptions(f1.date || {}, timeZone)),
        time: $c1826a29cf38fd84$var$deepMergeOptions($c1826a29cf38fd84$var$setTimeZoneInOptions(mfFormats.time, timeZone), $c1826a29cf38fd84$var$setTimeZoneInOptions(f1.time || {}, timeZone))
    });
}
function $c1826a29cf38fd84$export$25868d1e8e76735f(_a, state, messageDescriptor, values, opts) {
    var locale = _a.locale, formats = _a.formats, messages = _a.messages, defaultLocale = _a.defaultLocale, defaultFormats = _a.defaultFormats, fallbackOnEmptyString = _a.fallbackOnEmptyString, onError = _a.onError, timeZone = _a.timeZone, defaultRichTextElements = _a.defaultRichTextElements;
    if (messageDescriptor === void 0) messageDescriptor = {
        id: ''
    };
    var msgId = messageDescriptor.id, defaultMessage = messageDescriptor.defaultMessage;
    // `id` is a required field of a Message Descriptor.
    (0, $A7PQX.invariant)(!!msgId, "[@formatjs/intl] An `id` must be provided to format a message. You can either:\n1. Configure your build toolchain with [babel-plugin-formatjs](https://formatjs.io/docs/tooling/babel-plugin)\nor [@formatjs/ts-transformer](https://formatjs.io/docs/tooling/ts-transformer) OR\n2. Configure your `eslint` config to include [eslint-plugin-formatjs](https://formatjs.io/docs/tooling/linter#enforce-id)\nto autofix this issue");
    var id = String(msgId);
    var message = // In case messages is Object.create(null)
    // e.g import('foo.json') from webpack)
    // See https://github.com/formatjs/formatjs/issues/1914
    messages && Object.prototype.hasOwnProperty.call(messages, id) && messages[id];
    // IMPORTANT: Hot path if `message` is AST with a single literal node
    if (Array.isArray(message) && message.length === 1 && message[0].type === (0, $O1ybS.TYPE).literal) return message[0].value;
    // IMPORTANT: Hot path straight lookup for performance
    if (!values && message && typeof message === 'string' && !defaultRichTextElements) return message.replace(/'\{(.*?)\}'/gi, "{$1}");
    values = (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, defaultRichTextElements), values || {});
    formats = $c1826a29cf38fd84$var$deepMergeFormatsAndSetTimeZone(formats, timeZone);
    defaultFormats = $c1826a29cf38fd84$var$deepMergeFormatsAndSetTimeZone(defaultFormats, timeZone);
    if (!message) {
        if (fallbackOnEmptyString === false && message === '') return message;
        if (!defaultMessage || locale && locale.toLowerCase() !== defaultLocale.toLowerCase()) // This prevents warnings from littering the console in development
        // when no `messages` are passed into the <IntlProvider> for the
        // default locale.
        onError(new (0, $6zNca.MissingTranslationError)(messageDescriptor, locale));
        if (defaultMessage) try {
            var formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts);
            return formatter.format(values);
        } catch (e) {
            onError(new (0, $6zNca.MessageFormatError)("Error formatting default message for: \"".concat(id, "\", rendering default message verbatim"), locale, messageDescriptor, e));
            return typeof defaultMessage === 'string' ? defaultMessage : id;
        }
        return id;
    }
    // We have the translated message
    try {
        var formatter = state.getMessageFormat(message, locale, formats, (0, $dnskZ.__assign)({
            formatters: state
        }, opts || {}));
        return formatter.format(values);
    } catch (e) {
        onError(new (0, $6zNca.MessageFormatError)("Error formatting message: \"".concat(id, "\", using ").concat(defaultMessage ? 'default message' : 'id', " as fallback."), locale, messageDescriptor, e));
    }
    if (defaultMessage) try {
        var formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts);
        return formatter.format(values);
    } catch (e) {
        onError(new (0, $6zNca.MessageFormatError)("Error formatting the default message for: \"".concat(id, "\", rendering message verbatim"), locale, messageDescriptor, e));
    }
    if (typeof message === 'string') return message;
    if (typeof defaultMessage === 'string') return defaultMessage;
    return id;
}

});
parcelRegister("kYJR9", function(module, exports) {
$parcel$export(module.exports, "isDateElement", () => (parcelRequire("O1ybS")).isDateElement);
$parcel$export(module.exports, "isDateTimeSkeleton", () => (parcelRequire("O1ybS")).isDateTimeSkeleton);
$parcel$export(module.exports, "isNumberElement", () => (parcelRequire("O1ybS")).isNumberElement);
$parcel$export(module.exports, "isNumberSkeleton", () => (parcelRequire("O1ybS")).isNumberSkeleton);
$parcel$export(module.exports, "isPluralElement", () => (parcelRequire("O1ybS")).isPluralElement);
$parcel$export(module.exports, "isSelectElement", () => (parcelRequire("O1ybS")).isSelectElement);
$parcel$export(module.exports, "isTagElement", () => (parcelRequire("O1ybS")).isTagElement);
$parcel$export(module.exports, "isTimeElement", () => (parcelRequire("O1ybS")).isTimeElement);
$parcel$export(module.exports, "TYPE", () => (parcelRequire("O1ybS")).TYPE);

var $dnskZ = parcelRequire("dnskZ");

var $1ZHGg = parcelRequire("1ZHGg");

var $aLPux = parcelRequire("aLPux");

var $O1ybS = parcelRequire("O1ybS");
function $f45cfb559f6f15e9$var$pruneLocation(els) {
    els.forEach(function(el) {
        delete el.location;
        if ((0, $O1ybS.isSelectElement)(el) || (0, $O1ybS.isPluralElement)(el)) for(var k in el.options){
            delete el.options[k].location;
            $f45cfb559f6f15e9$var$pruneLocation(el.options[k].value);
        }
        else if ((0, $O1ybS.isNumberElement)(el) && (0, $O1ybS.isNumberSkeleton)(el.style)) delete el.style.location;
        else if (((0, $O1ybS.isDateElement)(el) || (0, $O1ybS.isTimeElement)(el)) && (0, $O1ybS.isDateTimeSkeleton)(el.style)) delete el.style.location;
        else if ((0, $O1ybS.isTagElement)(el)) $f45cfb559f6f15e9$var$pruneLocation(el.children);
    });
}
function $f45cfb559f6f15e9$export$98e6a39c04603d36(message, opts) {
    if (opts === void 0) opts = {};
    opts = (0, $dnskZ.__assign)({
        shouldParseSkeletons: true,
        requiresOtherClause: true
    }, opts);
    var result = new (0, $aLPux.Parser)(message, opts).parse();
    if (result.err) {
        var error = SyntaxError((0, $1ZHGg.ErrorKind)[result.err.kind]);
        // @ts-expect-error Assign to error object
        error.location = result.err.location;
        // @ts-expect-error Assign to error object
        error.originalMessage = result.err.message;
        throw error;
    }
    if (!(opts === null || opts === void 0 ? void 0 : opts.captureLocation)) $f45cfb559f6f15e9$var$pruneLocation(result.val);
    return result.val;
}

});
parcelRegister("1ZHGg", function(module, exports) {
$parcel$export(module.exports, "ErrorKind", () => $173d5effafd7ec63$export$896afd8541959ee5);
var $173d5effafd7ec63$export$896afd8541959ee5;
(function(ErrorKind) {
    /** Argument is unclosed (e.g. `{0`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_CLOSING_BRACE"] = 1] = "EXPECT_ARGUMENT_CLOSING_BRACE";
    /** Argument is empty (e.g. `{}`). */ ErrorKind[ErrorKind["EMPTY_ARGUMENT"] = 2] = "EMPTY_ARGUMENT";
    /** Argument is malformed (e.g. `{foo!}``) */ ErrorKind[ErrorKind["MALFORMED_ARGUMENT"] = 3] = "MALFORMED_ARGUMENT";
    /** Expect an argument type (e.g. `{foo,}`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_TYPE"] = 4] = "EXPECT_ARGUMENT_TYPE";
    /** Unsupported argument type (e.g. `{foo,foo}`) */ ErrorKind[ErrorKind["INVALID_ARGUMENT_TYPE"] = 5] = "INVALID_ARGUMENT_TYPE";
    /** Expect an argument style (e.g. `{foo, number, }`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_STYLE"] = 6] = "EXPECT_ARGUMENT_STYLE";
    /** The number skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_NUMBER_SKELETON"] = 7] = "INVALID_NUMBER_SKELETON";
    /** The date time skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_DATE_TIME_SKELETON"] = 8] = "INVALID_DATE_TIME_SKELETON";
    /** Exepct a number skeleton following the `::` (e.g. `{foo, number, ::}`) */ ErrorKind[ErrorKind["EXPECT_NUMBER_SKELETON"] = 9] = "EXPECT_NUMBER_SKELETON";
    /** Exepct a date time skeleton following the `::` (e.g. `{foo, date, ::}`) */ ErrorKind[ErrorKind["EXPECT_DATE_TIME_SKELETON"] = 10] = "EXPECT_DATE_TIME_SKELETON";
    /** Unmatched apostrophes in the argument style (e.g. `{foo, number, 'test`) */ ErrorKind[ErrorKind["UNCLOSED_QUOTE_IN_ARGUMENT_STYLE"] = 11] = "UNCLOSED_QUOTE_IN_ARGUMENT_STYLE";
    /** Missing select argument options (e.g. `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_OPTIONS"] = 12] = "EXPECT_SELECT_ARGUMENT_OPTIONS";
    /** Expecting an offset value in `plural` or `selectordinal` argument (e.g `{foo, plural, offset}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE"] = 13] = "EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Offset value in `plural` or `selectordinal` is invalid (e.g. `{foo, plural, offset: x}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_OFFSET_VALUE"] = 14] = "INVALID_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Expecting a selector in `select` argument (e.g `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR"] = 15] = "EXPECT_SELECT_ARGUMENT_SELECTOR";
    /** Expecting a selector in `plural` or `selectordinal` argument (e.g `{foo, plural}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR"] = 16] = "EXPECT_PLURAL_ARGUMENT_SELECTOR";
    /** Expecting a message fragment after the `select` selector (e.g. `{foo, select, apple}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT"] = 17] = "EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT";
    /**
     * Expecting a message fragment after the `plural` or `selectordinal` selector
     * (e.g. `{foo, plural, one}`)
     */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT"] = 18] = "EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT";
    /** Selector in `plural` or `selectordinal` is malformed (e.g. `{foo, plural, =x {#}}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_SELECTOR"] = 19] = "INVALID_PLURAL_ARGUMENT_SELECTOR";
    /**
     * Duplicate selectors in `plural` or `selectordinal` argument.
     * (e.g. {foo, plural, one {#} one {#}})
     */ ErrorKind[ErrorKind["DUPLICATE_PLURAL_ARGUMENT_SELECTOR"] = 20] = "DUPLICATE_PLURAL_ARGUMENT_SELECTOR";
    /** Duplicate selectors in `select` argument.
     * (e.g. {foo, select, apple {apple} apple {apple}})
     */ ErrorKind[ErrorKind["DUPLICATE_SELECT_ARGUMENT_SELECTOR"] = 21] = "DUPLICATE_SELECT_ARGUMENT_SELECTOR";
    /** Plural or select argument option must have `other` clause. */ ErrorKind[ErrorKind["MISSING_OTHER_CLAUSE"] = 22] = "MISSING_OTHER_CLAUSE";
    /** The tag is malformed. (e.g. `<bold!>foo</bold!>) */ ErrorKind[ErrorKind["INVALID_TAG"] = 23] = "INVALID_TAG";
    /** The tag name is invalid. (e.g. `<123>foo</123>`) */ ErrorKind[ErrorKind["INVALID_TAG_NAME"] = 25] = "INVALID_TAG_NAME";
    /** The closing tag does not match the opening tag. (e.g. `<bold>foo</italic>`) */ ErrorKind[ErrorKind["UNMATCHED_CLOSING_TAG"] = 26] = "UNMATCHED_CLOSING_TAG";
    /** The opening tag has unmatched closing tag. (e.g. `<bold>foo`) */ ErrorKind[ErrorKind["UNCLOSED_TAG"] = 27] = "UNCLOSED_TAG";
})($173d5effafd7ec63$export$896afd8541959ee5 || ($173d5effafd7ec63$export$896afd8541959ee5 = {}));

});

parcelRegister("aLPux", function(module, exports) {
$parcel$export(module.exports, "Parser", () => $7d763c4f95a6dca4$export$7acfa6ed01010e37);

var $dnskZ = parcelRequire("dnskZ");

var $1ZHGg = parcelRequire("1ZHGg");

var $O1ybS = parcelRequire("O1ybS");

var $kmILk = parcelRequire("kmILk");
parcelRequire("8zw08");
var $gAvuh = parcelRequire("gAvuh");
var $37PcY = parcelRequire("37PcY");

var $lfGUA = parcelRequire("lfGUA");
var $7d763c4f95a6dca4$var$_a;
var $7d763c4f95a6dca4$var$SPACE_SEPARATOR_START_REGEX = new RegExp("^".concat((0, $kmILk.SPACE_SEPARATOR_REGEX).source, "*"));
var $7d763c4f95a6dca4$var$SPACE_SEPARATOR_END_REGEX = new RegExp("".concat((0, $kmILk.SPACE_SEPARATOR_REGEX).source, "*$"));
function $7d763c4f95a6dca4$var$createLocation(start, end) {
    return {
        start: start,
        end: end
    };
}
// #region Ponyfills
// Consolidate these variables up top for easier toggling during debugging
var $7d763c4f95a6dca4$var$hasNativeStartsWith = !!String.prototype.startsWith;
var $7d763c4f95a6dca4$var$hasNativeFromCodePoint = !!String.fromCodePoint;
var $7d763c4f95a6dca4$var$hasNativeFromEntries = !!Object.fromEntries;
var $7d763c4f95a6dca4$var$hasNativeCodePointAt = !!String.prototype.codePointAt;
var $7d763c4f95a6dca4$var$hasTrimStart = !!String.prototype.trimStart;
var $7d763c4f95a6dca4$var$hasTrimEnd = !!String.prototype.trimEnd;
var $7d763c4f95a6dca4$var$hasNativeIsSafeInteger = !!Number.isSafeInteger;
var $7d763c4f95a6dca4$var$isSafeInteger = $7d763c4f95a6dca4$var$hasNativeIsSafeInteger ? Number.isSafeInteger : function(n) {
    return typeof n === 'number' && isFinite(n) && Math.floor(n) === n && Math.abs(n) <= 0x1fffffffffffff;
};
// IE11 does not support y and u.
var $7d763c4f95a6dca4$var$REGEX_SUPPORTS_U_AND_Y = true;
try {
    var $7d763c4f95a6dca4$var$re = $7d763c4f95a6dca4$var$RE('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
    /**
     * legacy Edge or Xbox One browser
     * Unicode flag support: supported
     * Pattern_Syntax support: not supported
     * See https://github.com/formatjs/formatjs/issues/2822
     */ $7d763c4f95a6dca4$var$REGEX_SUPPORTS_U_AND_Y = (($7d763c4f95a6dca4$var$_a = $7d763c4f95a6dca4$var$re.exec('a')) === null || $7d763c4f95a6dca4$var$_a === void 0 ? void 0 : $7d763c4f95a6dca4$var$_a[0]) === 'a';
} catch (_) {
    $7d763c4f95a6dca4$var$REGEX_SUPPORTS_U_AND_Y = false;
}
var $7d763c4f95a6dca4$var$startsWith = $7d763c4f95a6dca4$var$hasNativeStartsWith ? function startsWith(s, search, position) {
    return s.startsWith(search, position);
} : function startsWith(s, search, position) {
    return s.slice(position, position + search.length) === search;
};
var $7d763c4f95a6dca4$var$fromCodePoint = $7d763c4f95a6dca4$var$hasNativeFromCodePoint ? String.fromCodePoint : function fromCodePoint() {
    var codePoints = [];
    for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
    var elements = '';
    var length = codePoints.length;
    var i = 0;
    var code;
    while(length > i){
        code = codePoints[i++];
        if (code > 0x10ffff) throw RangeError(code + ' is not a valid code point');
        elements += code < 0x10000 ? String.fromCharCode(code) : String.fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00);
    }
    return elements;
};
var $7d763c4f95a6dca4$var$fromEntries = // native
$7d763c4f95a6dca4$var$hasNativeFromEntries ? Object.fromEntries : function fromEntries(entries) {
    var obj = {};
    for(var _i = 0, entries_1 = entries; _i < entries_1.length; _i++){
        var _a = entries_1[_i], k = _a[0], v = _a[1];
        obj[k] = v;
    }
    return obj;
};
var $7d763c4f95a6dca4$var$codePointAt = $7d763c4f95a6dca4$var$hasNativeCodePointAt ? function codePointAt(s, index) {
    return s.codePointAt(index);
} : function codePointAt(s, index) {
    var size = s.length;
    if (index < 0 || index >= size) return undefined;
    var first = s.charCodeAt(index);
    var second;
    return first < 0xd800 || first > 0xdbff || index + 1 === size || (second = s.charCodeAt(index + 1)) < 0xdc00 || second > 0xdfff ? first : (first - 0xd800 << 10) + (second - 0xdc00) + 0x10000;
};
var $7d763c4f95a6dca4$var$trimStart = $7d763c4f95a6dca4$var$hasTrimStart ? function trimStart(s) {
    return s.trimStart();
} : function trimStart(s) {
    return s.replace($7d763c4f95a6dca4$var$SPACE_SEPARATOR_START_REGEX, '');
};
var $7d763c4f95a6dca4$var$trimEnd = $7d763c4f95a6dca4$var$hasTrimEnd ? function trimEnd(s) {
    return s.trimEnd();
} : function trimEnd(s) {
    return s.replace($7d763c4f95a6dca4$var$SPACE_SEPARATOR_END_REGEX, '');
};
// Prevent minifier to translate new RegExp to literal form that might cause syntax error on IE11.
function $7d763c4f95a6dca4$var$RE(s, flag) {
    return new RegExp(s, flag);
}
// #endregion
var $7d763c4f95a6dca4$var$matchIdentifierAtIndex;
if ($7d763c4f95a6dca4$var$REGEX_SUPPORTS_U_AND_Y) {
    // Native
    var $7d763c4f95a6dca4$var$IDENTIFIER_PREFIX_RE_1 = $7d763c4f95a6dca4$var$RE('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
    $7d763c4f95a6dca4$var$matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
        var _a;
        $7d763c4f95a6dca4$var$IDENTIFIER_PREFIX_RE_1.lastIndex = index;
        var match = $7d763c4f95a6dca4$var$IDENTIFIER_PREFIX_RE_1.exec(s);
        return (_a = match[1]) !== null && _a !== void 0 ? _a : '';
    };
} else // IE11
$7d763c4f95a6dca4$var$matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
    var match = [];
    while(true){
        var c = $7d763c4f95a6dca4$var$codePointAt(s, index);
        if (c === undefined || $7d763c4f95a6dca4$var$_isWhiteSpace(c) || $7d763c4f95a6dca4$var$_isPatternSyntax(c)) break;
        match.push(c);
        index += c >= 0x10000 ? 2 : 1;
    }
    return $7d763c4f95a6dca4$var$fromCodePoint.apply(void 0, match);
};
var $7d763c4f95a6dca4$export$7acfa6ed01010e37 = /** @class */ function() {
    function Parser(message, options) {
        if (options === void 0) options = {};
        this.message = message;
        this.position = {
            offset: 0,
            line: 1,
            column: 1
        };
        this.ignoreTag = !!options.ignoreTag;
        this.locale = options.locale;
        this.requiresOtherClause = !!options.requiresOtherClause;
        this.shouldParseSkeletons = !!options.shouldParseSkeletons;
    }
    Parser.prototype.parse = function() {
        if (this.offset() !== 0) throw Error('parser can only be used once');
        return this.parseMessage(0, '', false);
    };
    Parser.prototype.parseMessage = function(nestingLevel, parentArgType, expectingCloseTag) {
        var elements = [];
        while(!this.isEOF()){
            var char = this.char();
            if (char === 123 /* `{` */ ) {
                var result = this.parseArgument(nestingLevel, expectingCloseTag);
                if (result.err) return result;
                elements.push(result.val);
            } else if (char === 125 /* `}` */  && nestingLevel > 0) break;
            else if (char === 35 /* `#` */  && (parentArgType === 'plural' || parentArgType === 'selectordinal')) {
                var position = this.clonePosition();
                this.bump();
                elements.push({
                    type: (0, $O1ybS.TYPE).pound,
                    location: $7d763c4f95a6dca4$var$createLocation(position, this.clonePosition())
                });
            } else if (char === 60 /* `<` */  && !this.ignoreTag && this.peek() === 47 // char code for '/'
            ) {
                if (expectingCloseTag) break;
                else return this.error((0, $1ZHGg.ErrorKind).UNMATCHED_CLOSING_TAG, $7d763c4f95a6dca4$var$createLocation(this.clonePosition(), this.clonePosition()));
            } else if (char === 60 /* `<` */  && !this.ignoreTag && $7d763c4f95a6dca4$var$_isAlpha(this.peek() || 0)) {
                var result = this.parseTag(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            } else {
                var result = this.parseLiteral(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            }
        }
        return {
            val: elements,
            err: null
        };
    };
    /**
     * A tag name must start with an ASCII lower/upper case letter. The grammar is based on the
     * [custom element name][] except that a dash is NOT always mandatory and uppercase letters
     * are accepted:
     *
     * ```
     * tag ::= "<" tagName (whitespace)* "/>" | "<" tagName (whitespace)* ">" message "</" tagName (whitespace)* ">"
     * tagName ::= [a-z] (PENChar)*
     * PENChar ::=
     *     "-" | "." | [0-9] | "_" | [a-z] | [A-Z] | #xB7 | [#xC0-#xD6] | [#xD8-#xF6] | [#xF8-#x37D] |
     *     [#x37F-#x1FFF] | [#x200C-#x200D] | [#x203F-#x2040] | [#x2070-#x218F] | [#x2C00-#x2FEF] |
     *     [#x3001-#xD7FF] | [#xF900-#xFDCF] | [#xFDF0-#xFFFD] | [#x10000-#xEFFFF]
     * ```
     *
     * [custom element name]: https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
     * NOTE: We're a bit more lax here since HTML technically does not allow uppercase HTML element but we do
     * since other tag-based engines like React allow it
     */ Parser.prototype.parseTag = function(nestingLevel, parentArgType) {
        var startPosition = this.clonePosition();
        this.bump(); // `<`
        var tagName = this.parseTagName();
        this.bumpSpace();
        if (this.bumpIf('/>')) // Self closing tag
        return {
            val: {
                type: (0, $O1ybS.TYPE).literal,
                value: "<".concat(tagName, "/>"),
                location: $7d763c4f95a6dca4$var$createLocation(startPosition, this.clonePosition())
            },
            err: null
        };
        else if (this.bumpIf('>')) {
            var childrenResult = this.parseMessage(nestingLevel + 1, parentArgType, true);
            if (childrenResult.err) return childrenResult;
            var children = childrenResult.val;
            // Expecting a close tag
            var endTagStartPosition = this.clonePosition();
            if (this.bumpIf('</')) {
                if (this.isEOF() || !$7d763c4f95a6dca4$var$_isAlpha(this.char())) return this.error((0, $1ZHGg.ErrorKind).INVALID_TAG, $7d763c4f95a6dca4$var$createLocation(endTagStartPosition, this.clonePosition()));
                var closingTagNameStartPosition = this.clonePosition();
                var closingTagName = this.parseTagName();
                if (tagName !== closingTagName) return this.error((0, $1ZHGg.ErrorKind).UNMATCHED_CLOSING_TAG, $7d763c4f95a6dca4$var$createLocation(closingTagNameStartPosition, this.clonePosition()));
                this.bumpSpace();
                if (!this.bumpIf('>')) return this.error((0, $1ZHGg.ErrorKind).INVALID_TAG, $7d763c4f95a6dca4$var$createLocation(endTagStartPosition, this.clonePosition()));
                return {
                    val: {
                        type: (0, $O1ybS.TYPE).tag,
                        value: tagName,
                        children: children,
                        location: $7d763c4f95a6dca4$var$createLocation(startPosition, this.clonePosition())
                    },
                    err: null
                };
            } else return this.error((0, $1ZHGg.ErrorKind).UNCLOSED_TAG, $7d763c4f95a6dca4$var$createLocation(startPosition, this.clonePosition()));
        } else return this.error((0, $1ZHGg.ErrorKind).INVALID_TAG, $7d763c4f95a6dca4$var$createLocation(startPosition, this.clonePosition()));
    };
    /**
     * This method assumes that the caller has peeked ahead for the first tag character.
     */ Parser.prototype.parseTagName = function() {
        var startOffset = this.offset();
        this.bump(); // the first tag name character
        while(!this.isEOF() && $7d763c4f95a6dca4$var$_isPotentialElementNameChar(this.char()))this.bump();
        return this.message.slice(startOffset, this.offset());
    };
    Parser.prototype.parseLiteral = function(nestingLevel, parentArgType) {
        var start = this.clonePosition();
        var value = '';
        while(true){
            var parseQuoteResult = this.tryParseQuote(parentArgType);
            if (parseQuoteResult) {
                value += parseQuoteResult;
                continue;
            }
            var parseUnquotedResult = this.tryParseUnquoted(nestingLevel, parentArgType);
            if (parseUnquotedResult) {
                value += parseUnquotedResult;
                continue;
            }
            var parseLeftAngleResult = this.tryParseLeftAngleBracket();
            if (parseLeftAngleResult) {
                value += parseLeftAngleResult;
                continue;
            }
            break;
        }
        var location = $7d763c4f95a6dca4$var$createLocation(start, this.clonePosition());
        return {
            val: {
                type: (0, $O1ybS.TYPE).literal,
                value: value,
                location: location
            },
            err: null
        };
    };
    Parser.prototype.tryParseLeftAngleBracket = function() {
        if (!this.isEOF() && this.char() === 60 /* `<` */  && (this.ignoreTag || // If at the opening tag or closing tag position, bail.
        !$7d763c4f95a6dca4$var$_isAlphaOrSlash(this.peek() || 0))) {
            this.bump(); // `<`
            return '<';
        }
        return null;
    };
    /**
     * Starting with ICU 4.8, an ASCII apostrophe only starts quoted text if it immediately precedes
     * a character that requires quoting (that is, "only where needed"), and works the same in
     * nested messages as on the top level of the pattern. The new behavior is otherwise compatible.
     */ Parser.prototype.tryParseQuote = function(parentArgType) {
        if (this.isEOF() || this.char() !== 39 /* `'` */ ) return null;
        // Parse escaped char following the apostrophe, or early return if there is no escaped char.
        // Check if is valid escaped character
        switch(this.peek()){
            case 39 /* `'` */ :
                // double quote, should return as a single quote.
                this.bump();
                this.bump();
                return "'";
            // '{', '<', '>', '}'
            case 123:
            case 60:
            case 62:
            case 125:
                break;
            case 35:
                if (parentArgType === 'plural' || parentArgType === 'selectordinal') break;
                return null;
            default:
                return null;
        }
        this.bump(); // apostrophe
        var codePoints = [
            this.char()
        ]; // escaped char
        this.bump();
        // read chars until the optional closing apostrophe is found
        while(!this.isEOF()){
            var ch = this.char();
            if (ch === 39 /* `'` */ ) {
                if (this.peek() === 39 /* `'` */ ) {
                    codePoints.push(39);
                    // Bump one more time because we need to skip 2 characters.
                    this.bump();
                } else {
                    // Optional closing apostrophe.
                    this.bump();
                    break;
                }
            } else codePoints.push(ch);
            this.bump();
        }
        return $7d763c4f95a6dca4$var$fromCodePoint.apply(void 0, codePoints);
    };
    Parser.prototype.tryParseUnquoted = function(nestingLevel, parentArgType) {
        if (this.isEOF()) return null;
        var ch = this.char();
        if (ch === 60 /* `<` */  || ch === 123 /* `{` */  || ch === 35 /* `#` */  && (parentArgType === 'plural' || parentArgType === 'selectordinal') || ch === 125 /* `}` */  && nestingLevel > 0) return null;
        else {
            this.bump();
            return $7d763c4f95a6dca4$var$fromCodePoint(ch);
        }
    };
    Parser.prototype.parseArgument = function(nestingLevel, expectingCloseTag) {
        var openingBracePosition = this.clonePosition();
        this.bump(); // `{`
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, $1ZHGg.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $7d763c4f95a6dca4$var$createLocation(openingBracePosition, this.clonePosition()));
        if (this.char() === 125 /* `}` */ ) {
            this.bump();
            return this.error((0, $1ZHGg.ErrorKind).EMPTY_ARGUMENT, $7d763c4f95a6dca4$var$createLocation(openingBracePosition, this.clonePosition()));
        }
        // argument name
        var value = this.parseIdentifierIfPossible().value;
        if (!value) return this.error((0, $1ZHGg.ErrorKind).MALFORMED_ARGUMENT, $7d763c4f95a6dca4$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, $1ZHGg.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $7d763c4f95a6dca4$var$createLocation(openingBracePosition, this.clonePosition()));
        switch(this.char()){
            // Simple argument: `{name}`
            case 125 /* `}` */ :
                this.bump(); // `}`
                return {
                    val: {
                        type: (0, $O1ybS.TYPE).argument,
                        // value does not include the opening and closing braces.
                        value: value,
                        location: $7d763c4f95a6dca4$var$createLocation(openingBracePosition, this.clonePosition())
                    },
                    err: null
                };
            // Argument with options: `{name, format, ...}`
            case 44 /* `,` */ :
                this.bump(); // `,`
                this.bumpSpace();
                if (this.isEOF()) return this.error((0, $1ZHGg.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $7d763c4f95a6dca4$var$createLocation(openingBracePosition, this.clonePosition()));
                return this.parseArgumentOptions(nestingLevel, expectingCloseTag, value, openingBracePosition);
            default:
                return this.error((0, $1ZHGg.ErrorKind).MALFORMED_ARGUMENT, $7d763c4f95a6dca4$var$createLocation(openingBracePosition, this.clonePosition()));
        }
    };
    /**
     * Advance the parser until the end of the identifier, if it is currently on
     * an identifier character. Return an empty string otherwise.
     */ Parser.prototype.parseIdentifierIfPossible = function() {
        var startingPosition = this.clonePosition();
        var startOffset = this.offset();
        var value = $7d763c4f95a6dca4$var$matchIdentifierAtIndex(this.message, startOffset);
        var endOffset = startOffset + value.length;
        this.bumpTo(endOffset);
        var endPosition = this.clonePosition();
        var location = $7d763c4f95a6dca4$var$createLocation(startingPosition, endPosition);
        return {
            value: value,
            location: location
        };
    };
    Parser.prototype.parseArgumentOptions = function(nestingLevel, expectingCloseTag, value, openingBracePosition) {
        var _a;
        // Parse this range:
        // {name, type, style}
        //        ^---^
        var typeStartPosition = this.clonePosition();
        var argType = this.parseIdentifierIfPossible().value;
        var typeEndPosition = this.clonePosition();
        switch(argType){
            case '':
                // Expecting a style string number, date, time, plural, selectordinal, or select.
                return this.error((0, $1ZHGg.ErrorKind).EXPECT_ARGUMENT_TYPE, $7d763c4f95a6dca4$var$createLocation(typeStartPosition, typeEndPosition));
            case 'number':
            case 'date':
            case 'time':
                // Parse this range:
                // {name, number, style}
                //              ^-------^
                this.bumpSpace();
                var styleAndLocation = null;
                if (this.bumpIf(',')) {
                    this.bumpSpace();
                    var styleStartPosition = this.clonePosition();
                    var result = this.parseSimpleArgStyleIfPossible();
                    if (result.err) return result;
                    var style = $7d763c4f95a6dca4$var$trimEnd(result.val);
                    if (style.length === 0) return this.error((0, $1ZHGg.ErrorKind).EXPECT_ARGUMENT_STYLE, $7d763c4f95a6dca4$var$createLocation(this.clonePosition(), this.clonePosition()));
                    var styleLocation = $7d763c4f95a6dca4$var$createLocation(styleStartPosition, this.clonePosition());
                    styleAndLocation = {
                        style: style,
                        styleLocation: styleLocation
                    };
                }
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_1 = $7d763c4f95a6dca4$var$createLocation(openingBracePosition, this.clonePosition());
                // Extract style or skeleton
                if (styleAndLocation && $7d763c4f95a6dca4$var$startsWith(styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style, '::', 0)) {
                    // Skeleton starts with `::`.
                    var skeleton = $7d763c4f95a6dca4$var$trimStart(styleAndLocation.style.slice(2));
                    if (argType === 'number') {
                        var result = this.parseNumberSkeletonFromString(skeleton, styleAndLocation.styleLocation);
                        if (result.err) return result;
                        return {
                            val: {
                                type: (0, $O1ybS.TYPE).number,
                                value: value,
                                location: location_1,
                                style: result.val
                            },
                            err: null
                        };
                    } else {
                        if (skeleton.length === 0) return this.error((0, $1ZHGg.ErrorKind).EXPECT_DATE_TIME_SKELETON, location_1);
                        var dateTimePattern = skeleton;
                        // Get "best match" pattern only if locale is passed, if not, let it
                        // pass as-is where `parseDateTimeSkeleton()` will throw an error
                        // for unsupported patterns.
                        if (this.locale) dateTimePattern = (0, $lfGUA.getBestPattern)(skeleton, this.locale);
                        var style = {
                            type: (0, $O1ybS.SKELETON_TYPE).dateTime,
                            pattern: dateTimePattern,
                            location: styleAndLocation.styleLocation,
                            parsedOptions: this.shouldParseSkeletons ? (0, $gAvuh.parseDateTimeSkeleton)(dateTimePattern) : {}
                        };
                        var type = argType === 'date' ? (0, $O1ybS.TYPE).date : (0, $O1ybS.TYPE).time;
                        return {
                            val: {
                                type: type,
                                value: value,
                                location: location_1,
                                style: style
                            },
                            err: null
                        };
                    }
                }
                // Regular style or no style.
                return {
                    val: {
                        type: argType === 'number' ? (0, $O1ybS.TYPE).number : argType === 'date' ? (0, $O1ybS.TYPE).date : (0, $O1ybS.TYPE).time,
                        value: value,
                        location: location_1,
                        style: (_a = styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style) !== null && _a !== void 0 ? _a : null
                    },
                    err: null
                };
            case 'plural':
            case 'selectordinal':
            case 'select':
                // Parse this range:
                // {name, plural, options}
                //              ^---------^
                var typeEndPosition_1 = this.clonePosition();
                this.bumpSpace();
                if (!this.bumpIf(',')) return this.error((0, $1ZHGg.ErrorKind).EXPECT_SELECT_ARGUMENT_OPTIONS, $7d763c4f95a6dca4$var$createLocation(typeEndPosition_1, (0, $dnskZ.__assign)({}, typeEndPosition_1)));
                this.bumpSpace();
                // Parse offset:
                // {name, plural, offset:1, options}
                //                ^-----^
                //
                // or the first option:
                //
                // {name, plural, one {...} other {...}}
                //                ^--^
                var identifierAndLocation = this.parseIdentifierIfPossible();
                var pluralOffset = 0;
                if (argType !== 'select' && identifierAndLocation.value === 'offset') {
                    if (!this.bumpIf(':')) return this.error((0, $1ZHGg.ErrorKind).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, $7d763c4f95a6dca4$var$createLocation(this.clonePosition(), this.clonePosition()));
                    this.bumpSpace();
                    var result = this.tryParseDecimalInteger((0, $1ZHGg.ErrorKind).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, (0, $1ZHGg.ErrorKind).INVALID_PLURAL_ARGUMENT_OFFSET_VALUE);
                    if (result.err) return result;
                    // Parse another identifier for option parsing
                    this.bumpSpace();
                    identifierAndLocation = this.parseIdentifierIfPossible();
                    pluralOffset = result.val;
                }
                var optionsResult = this.tryParsePluralOrSelectOptions(nestingLevel, argType, expectingCloseTag, identifierAndLocation);
                if (optionsResult.err) return optionsResult;
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_2 = $7d763c4f95a6dca4$var$createLocation(openingBracePosition, this.clonePosition());
                if (argType === 'select') return {
                    val: {
                        type: (0, $O1ybS.TYPE).select,
                        value: value,
                        options: $7d763c4f95a6dca4$var$fromEntries(optionsResult.val),
                        location: location_2
                    },
                    err: null
                };
                else return {
                    val: {
                        type: (0, $O1ybS.TYPE).plural,
                        value: value,
                        options: $7d763c4f95a6dca4$var$fromEntries(optionsResult.val),
                        offset: pluralOffset,
                        pluralType: argType === 'plural' ? 'cardinal' : 'ordinal',
                        location: location_2
                    },
                    err: null
                };
            default:
                return this.error((0, $1ZHGg.ErrorKind).INVALID_ARGUMENT_TYPE, $7d763c4f95a6dca4$var$createLocation(typeStartPosition, typeEndPosition));
        }
    };
    Parser.prototype.tryParseArgumentClose = function(openingBracePosition) {
        // Parse: {value, number, ::currency/GBP }
        //
        if (this.isEOF() || this.char() !== 125 /* `}` */ ) return this.error((0, $1ZHGg.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $7d763c4f95a6dca4$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bump(); // `}`
        return {
            val: true,
            err: null
        };
    };
    /**
     * See: https://github.com/unicode-org/icu/blob/af7ed1f6d2298013dc303628438ec4abe1f16479/icu4c/source/common/messagepattern.cpp#L659
     */ Parser.prototype.parseSimpleArgStyleIfPossible = function() {
        var nestedBraces = 0;
        var startPosition = this.clonePosition();
        while(!this.isEOF()){
            var ch = this.char();
            switch(ch){
                case 39 /* `'` */ :
                    // Treat apostrophe as quoting but include it in the style part.
                    // Find the end of the quoted literal text.
                    this.bump();
                    var apostrophePosition = this.clonePosition();
                    if (!this.bumpUntil("'")) return this.error((0, $1ZHGg.ErrorKind).UNCLOSED_QUOTE_IN_ARGUMENT_STYLE, $7d763c4f95a6dca4$var$createLocation(apostrophePosition, this.clonePosition()));
                    this.bump();
                    break;
                case 123 /* `{` */ :
                    nestedBraces += 1;
                    this.bump();
                    break;
                case 125 /* `}` */ :
                    if (nestedBraces > 0) nestedBraces -= 1;
                    else return {
                        val: this.message.slice(startPosition.offset, this.offset()),
                        err: null
                    };
                    break;
                default:
                    this.bump();
                    break;
            }
        }
        return {
            val: this.message.slice(startPosition.offset, this.offset()),
            err: null
        };
    };
    Parser.prototype.parseNumberSkeletonFromString = function(skeleton, location) {
        var tokens = [];
        try {
            tokens = (0, $37PcY.parseNumberSkeletonFromString)(skeleton);
        } catch (e) {
            return this.error((0, $1ZHGg.ErrorKind).INVALID_NUMBER_SKELETON, location);
        }
        return {
            val: {
                type: (0, $O1ybS.SKELETON_TYPE).number,
                tokens: tokens,
                location: location,
                parsedOptions: this.shouldParseSkeletons ? (0, $37PcY.parseNumberSkeleton)(tokens) : {}
            },
            err: null
        };
    };
    /**
     * @param nesting_level The current nesting level of messages.
     *     This can be positive when parsing message fragment in select or plural argument options.
     * @param parent_arg_type The parent argument's type.
     * @param parsed_first_identifier If provided, this is the first identifier-like selector of
     *     the argument. It is a by-product of a previous parsing attempt.
     * @param expecting_close_tag If true, this message is directly or indirectly nested inside
     *     between a pair of opening and closing tags. The nested message will not parse beyond
     *     the closing tag boundary.
     */ Parser.prototype.tryParsePluralOrSelectOptions = function(nestingLevel, parentArgType, expectCloseTag, parsedFirstIdentifier) {
        var _a;
        var hasOtherClause = false;
        var options = [];
        var parsedSelectors = new Set();
        var selector = parsedFirstIdentifier.value, selectorLocation = parsedFirstIdentifier.location;
        // Parse:
        // one {one apple}
        // ^--^
        while(true){
            if (selector.length === 0) {
                var startPosition = this.clonePosition();
                if (parentArgType !== 'select' && this.bumpIf('=')) {
                    // Try parse `={number}` selector
                    var result = this.tryParseDecimalInteger((0, $1ZHGg.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR, (0, $1ZHGg.ErrorKind).INVALID_PLURAL_ARGUMENT_SELECTOR);
                    if (result.err) return result;
                    selectorLocation = $7d763c4f95a6dca4$var$createLocation(startPosition, this.clonePosition());
                    selector = this.message.slice(startPosition.offset, this.offset());
                } else break;
            }
            // Duplicate selector clauses
            if (parsedSelectors.has(selector)) return this.error(parentArgType === 'select' ? (0, $1ZHGg.ErrorKind).DUPLICATE_SELECT_ARGUMENT_SELECTOR : (0, $1ZHGg.ErrorKind).DUPLICATE_PLURAL_ARGUMENT_SELECTOR, selectorLocation);
            if (selector === 'other') hasOtherClause = true;
            // Parse:
            // one {one apple}
            //     ^----------^
            this.bumpSpace();
            var openingBracePosition = this.clonePosition();
            if (!this.bumpIf('{')) return this.error(parentArgType === 'select' ? (0, $1ZHGg.ErrorKind).EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT : (0, $1ZHGg.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT, $7d763c4f95a6dca4$var$createLocation(this.clonePosition(), this.clonePosition()));
            var fragmentResult = this.parseMessage(nestingLevel + 1, parentArgType, expectCloseTag);
            if (fragmentResult.err) return fragmentResult;
            var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
            if (argCloseResult.err) return argCloseResult;
            options.push([
                selector,
                {
                    value: fragmentResult.val,
                    location: $7d763c4f95a6dca4$var$createLocation(openingBracePosition, this.clonePosition())
                }
            ]);
            // Keep track of the existing selectors
            parsedSelectors.add(selector);
            // Prep next selector clause.
            this.bumpSpace();
            _a = this.parseIdentifierIfPossible(), selector = _a.value, selectorLocation = _a.location;
        }
        if (options.length === 0) return this.error(parentArgType === 'select' ? (0, $1ZHGg.ErrorKind).EXPECT_SELECT_ARGUMENT_SELECTOR : (0, $1ZHGg.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR, $7d763c4f95a6dca4$var$createLocation(this.clonePosition(), this.clonePosition()));
        if (this.requiresOtherClause && !hasOtherClause) return this.error((0, $1ZHGg.ErrorKind).MISSING_OTHER_CLAUSE, $7d763c4f95a6dca4$var$createLocation(this.clonePosition(), this.clonePosition()));
        return {
            val: options,
            err: null
        };
    };
    Parser.prototype.tryParseDecimalInteger = function(expectNumberError, invalidNumberError) {
        var sign = 1;
        var startingPosition = this.clonePosition();
        if (this.bumpIf('+')) ;
        else if (this.bumpIf('-')) sign = -1;
        var hasDigits = false;
        var decimal = 0;
        while(!this.isEOF()){
            var ch = this.char();
            if (ch >= 48 /* `0` */  && ch <= 57 /* `9` */ ) {
                hasDigits = true;
                decimal = decimal * 10 + (ch - 48);
                this.bump();
            } else break;
        }
        var location = $7d763c4f95a6dca4$var$createLocation(startingPosition, this.clonePosition());
        if (!hasDigits) return this.error(expectNumberError, location);
        decimal *= sign;
        if (!$7d763c4f95a6dca4$var$isSafeInteger(decimal)) return this.error(invalidNumberError, location);
        return {
            val: decimal,
            err: null
        };
    };
    Parser.prototype.offset = function() {
        return this.position.offset;
    };
    Parser.prototype.isEOF = function() {
        return this.offset() === this.message.length;
    };
    Parser.prototype.clonePosition = function() {
        // This is much faster than `Object.assign` or spread.
        return {
            offset: this.position.offset,
            line: this.position.line,
            column: this.position.column
        };
    };
    /**
     * Return the code point at the current position of the parser.
     * Throws if the index is out of bound.
     */ Parser.prototype.char = function() {
        var offset = this.position.offset;
        if (offset >= this.message.length) throw Error('out of bound');
        var code = $7d763c4f95a6dca4$var$codePointAt(this.message, offset);
        if (code === undefined) throw Error("Offset ".concat(offset, " is at invalid UTF-16 code unit boundary"));
        return code;
    };
    Parser.prototype.error = function(kind, location) {
        return {
            val: null,
            err: {
                kind: kind,
                message: this.message,
                location: location
            }
        };
    };
    /** Bump the parser to the next UTF-16 code unit. */ Parser.prototype.bump = function() {
        if (this.isEOF()) return;
        var code = this.char();
        if (code === 10 /* '\n' */ ) {
            this.position.line += 1;
            this.position.column = 1;
            this.position.offset += 1;
        } else {
            this.position.column += 1;
            // 0 ~ 0x10000 -> unicode BMP, otherwise skip the surrogate pair.
            this.position.offset += code < 0x10000 ? 1 : 2;
        }
    };
    /**
     * If the substring starting at the current position of the parser has
     * the given prefix, then bump the parser to the character immediately
     * following the prefix and return true. Otherwise, don't bump the parser
     * and return false.
     */ Parser.prototype.bumpIf = function(prefix) {
        if ($7d763c4f95a6dca4$var$startsWith(this.message, prefix, this.offset())) {
            for(var i = 0; i < prefix.length; i++)this.bump();
            return true;
        }
        return false;
    };
    /**
     * Bump the parser until the pattern character is found and return `true`.
     * Otherwise bump to the end of the file and return `false`.
     */ Parser.prototype.bumpUntil = function(pattern) {
        var currentOffset = this.offset();
        var index = this.message.indexOf(pattern, currentOffset);
        if (index >= 0) {
            this.bumpTo(index);
            return true;
        } else {
            this.bumpTo(this.message.length);
            return false;
        }
    };
    /**
     * Bump the parser to the target offset.
     * If target offset is beyond the end of the input, bump the parser to the end of the input.
     */ Parser.prototype.bumpTo = function(targetOffset) {
        if (this.offset() > targetOffset) throw Error("targetOffset ".concat(targetOffset, " must be greater than or equal to the current offset ").concat(this.offset()));
        targetOffset = Math.min(targetOffset, this.message.length);
        while(true){
            var offset = this.offset();
            if (offset === targetOffset) break;
            if (offset > targetOffset) throw Error("targetOffset ".concat(targetOffset, " is at invalid UTF-16 code unit boundary"));
            this.bump();
            if (this.isEOF()) break;
        }
    };
    /** advance the parser through all whitespace to the next non-whitespace code unit. */ Parser.prototype.bumpSpace = function() {
        while(!this.isEOF() && $7d763c4f95a6dca4$var$_isWhiteSpace(this.char()))this.bump();
    };
    /**
     * Peek at the *next* Unicode codepoint in the input without advancing the parser.
     * If the input has been exhausted, then this returns null.
     */ Parser.prototype.peek = function() {
        if (this.isEOF()) return null;
        var code = this.char();
        var offset = this.offset();
        var nextCode = this.message.charCodeAt(offset + (code >= 0x10000 ? 2 : 1));
        return nextCode !== null && nextCode !== void 0 ? nextCode : null;
    };
    return Parser;
}();
/**
 * This check if codepoint is alphabet (lower & uppercase)
 * @param codepoint
 * @returns
 */ function $7d763c4f95a6dca4$var$_isAlpha(codepoint) {
    return codepoint >= 97 && codepoint <= 122 || codepoint >= 65 && codepoint <= 90;
}
function $7d763c4f95a6dca4$var$_isAlphaOrSlash(codepoint) {
    return $7d763c4f95a6dca4$var$_isAlpha(codepoint) || codepoint === 47; /* '/' */ 
}
/** See `parseTag` function docs. */ function $7d763c4f95a6dca4$var$_isPotentialElementNameChar(c) {
    return c === 45 /* '-' */  || c === 46 /* '.' */  || c >= 48 && c <= 57 || c === 95 /* '_' */  || c >= 97 && c <= 122 || c >= 65 && c <= 90 || c == 0xb7 || c >= 0xc0 && c <= 0xd6 || c >= 0xd8 && c <= 0xf6 || c >= 0xf8 && c <= 0x37d || c >= 0x37f && c <= 0x1fff || c >= 0x200c && c <= 0x200d || c >= 0x203f && c <= 0x2040 || c >= 0x2070 && c <= 0x218f || c >= 0x2c00 && c <= 0x2fef || c >= 0x3001 && c <= 0xd7ff || c >= 0xf900 && c <= 0xfdcf || c >= 0xfdf0 && c <= 0xfffd || c >= 0x10000 && c <= 0xeffff;
}
/**
 * Code point equivalent of regex `\p{White_Space}`.
 * From: https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function $7d763c4f95a6dca4$var$_isWhiteSpace(c) {
    return c >= 0x0009 && c <= 0x000d || c === 0x0020 || c === 0x0085 || c >= 0x200e && c <= 0x200f || c === 0x2028 || c === 0x2029;
}
/**
 * Code point equivalent of regex `\p{Pattern_Syntax}`.
 * See https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function $7d763c4f95a6dca4$var$_isPatternSyntax(c) {
    return c >= 0x0021 && c <= 0x0023 || c === 0x0024 || c >= 0x0025 && c <= 0x0027 || c === 0x0028 || c === 0x0029 || c === 0x002a || c === 0x002b || c === 0x002c || c === 0x002d || c >= 0x002e && c <= 0x002f || c >= 0x003a && c <= 0x003b || c >= 0x003c && c <= 0x003e || c >= 0x003f && c <= 0x0040 || c === 0x005b || c === 0x005c || c === 0x005d || c === 0x005e || c === 0x0060 || c === 0x007b || c === 0x007c || c === 0x007d || c === 0x007e || c === 0x00a1 || c >= 0x00a2 && c <= 0x00a5 || c === 0x00a6 || c === 0x00a7 || c === 0x00a9 || c === 0x00ab || c === 0x00ac || c === 0x00ae || c === 0x00b0 || c === 0x00b1 || c === 0x00b6 || c === 0x00bb || c === 0x00bf || c === 0x00d7 || c === 0x00f7 || c >= 0x2010 && c <= 0x2015 || c >= 0x2016 && c <= 0x2017 || c === 0x2018 || c === 0x2019 || c === 0x201a || c >= 0x201b && c <= 0x201c || c === 0x201d || c === 0x201e || c === 0x201f || c >= 0x2020 && c <= 0x2027 || c >= 0x2030 && c <= 0x2038 || c === 0x2039 || c === 0x203a || c >= 0x203b && c <= 0x203e || c >= 0x2041 && c <= 0x2043 || c === 0x2044 || c === 0x2045 || c === 0x2046 || c >= 0x2047 && c <= 0x2051 || c === 0x2052 || c === 0x2053 || c >= 0x2055 && c <= 0x205e || c >= 0x2190 && c <= 0x2194 || c >= 0x2195 && c <= 0x2199 || c >= 0x219a && c <= 0x219b || c >= 0x219c && c <= 0x219f || c === 0x21a0 || c >= 0x21a1 && c <= 0x21a2 || c === 0x21a3 || c >= 0x21a4 && c <= 0x21a5 || c === 0x21a6 || c >= 0x21a7 && c <= 0x21ad || c === 0x21ae || c >= 0x21af && c <= 0x21cd || c >= 0x21ce && c <= 0x21cf || c >= 0x21d0 && c <= 0x21d1 || c === 0x21d2 || c === 0x21d3 || c === 0x21d4 || c >= 0x21d5 && c <= 0x21f3 || c >= 0x21f4 && c <= 0x22ff || c >= 0x2300 && c <= 0x2307 || c === 0x2308 || c === 0x2309 || c === 0x230a || c === 0x230b || c >= 0x230c && c <= 0x231f || c >= 0x2320 && c <= 0x2321 || c >= 0x2322 && c <= 0x2328 || c === 0x2329 || c === 0x232a || c >= 0x232b && c <= 0x237b || c === 0x237c || c >= 0x237d && c <= 0x239a || c >= 0x239b && c <= 0x23b3 || c >= 0x23b4 && c <= 0x23db || c >= 0x23dc && c <= 0x23e1 || c >= 0x23e2 && c <= 0x2426 || c >= 0x2427 && c <= 0x243f || c >= 0x2440 && c <= 0x244a || c >= 0x244b && c <= 0x245f || c >= 0x2500 && c <= 0x25b6 || c === 0x25b7 || c >= 0x25b8 && c <= 0x25c0 || c === 0x25c1 || c >= 0x25c2 && c <= 0x25f7 || c >= 0x25f8 && c <= 0x25ff || c >= 0x2600 && c <= 0x266e || c === 0x266f || c >= 0x2670 && c <= 0x2767 || c === 0x2768 || c === 0x2769 || c === 0x276a || c === 0x276b || c === 0x276c || c === 0x276d || c === 0x276e || c === 0x276f || c === 0x2770 || c === 0x2771 || c === 0x2772 || c === 0x2773 || c === 0x2774 || c === 0x2775 || c >= 0x2794 && c <= 0x27bf || c >= 0x27c0 && c <= 0x27c4 || c === 0x27c5 || c === 0x27c6 || c >= 0x27c7 && c <= 0x27e5 || c === 0x27e6 || c === 0x27e7 || c === 0x27e8 || c === 0x27e9 || c === 0x27ea || c === 0x27eb || c === 0x27ec || c === 0x27ed || c === 0x27ee || c === 0x27ef || c >= 0x27f0 && c <= 0x27ff || c >= 0x2800 && c <= 0x28ff || c >= 0x2900 && c <= 0x2982 || c === 0x2983 || c === 0x2984 || c === 0x2985 || c === 0x2986 || c === 0x2987 || c === 0x2988 || c === 0x2989 || c === 0x298a || c === 0x298b || c === 0x298c || c === 0x298d || c === 0x298e || c === 0x298f || c === 0x2990 || c === 0x2991 || c === 0x2992 || c === 0x2993 || c === 0x2994 || c === 0x2995 || c === 0x2996 || c === 0x2997 || c === 0x2998 || c >= 0x2999 && c <= 0x29d7 || c === 0x29d8 || c === 0x29d9 || c === 0x29da || c === 0x29db || c >= 0x29dc && c <= 0x29fb || c === 0x29fc || c === 0x29fd || c >= 0x29fe && c <= 0x2aff || c >= 0x2b00 && c <= 0x2b2f || c >= 0x2b30 && c <= 0x2b44 || c >= 0x2b45 && c <= 0x2b46 || c >= 0x2b47 && c <= 0x2b4c || c >= 0x2b4d && c <= 0x2b73 || c >= 0x2b74 && c <= 0x2b75 || c >= 0x2b76 && c <= 0x2b95 || c === 0x2b96 || c >= 0x2b97 && c <= 0x2bff || c >= 0x2e00 && c <= 0x2e01 || c === 0x2e02 || c === 0x2e03 || c === 0x2e04 || c === 0x2e05 || c >= 0x2e06 && c <= 0x2e08 || c === 0x2e09 || c === 0x2e0a || c === 0x2e0b || c === 0x2e0c || c === 0x2e0d || c >= 0x2e0e && c <= 0x2e16 || c === 0x2e17 || c >= 0x2e18 && c <= 0x2e19 || c === 0x2e1a || c === 0x2e1b || c === 0x2e1c || c === 0x2e1d || c >= 0x2e1e && c <= 0x2e1f || c === 0x2e20 || c === 0x2e21 || c === 0x2e22 || c === 0x2e23 || c === 0x2e24 || c === 0x2e25 || c === 0x2e26 || c === 0x2e27 || c === 0x2e28 || c === 0x2e29 || c >= 0x2e2a && c <= 0x2e2e || c === 0x2e2f || c >= 0x2e30 && c <= 0x2e39 || c >= 0x2e3a && c <= 0x2e3b || c >= 0x2e3c && c <= 0x2e3f || c === 0x2e40 || c === 0x2e41 || c === 0x2e42 || c >= 0x2e43 && c <= 0x2e4f || c >= 0x2e50 && c <= 0x2e51 || c === 0x2e52 || c >= 0x2e53 && c <= 0x2e7f || c >= 0x3001 && c <= 0x3003 || c === 0x3008 || c === 0x3009 || c === 0x300a || c === 0x300b || c === 0x300c || c === 0x300d || c === 0x300e || c === 0x300f || c === 0x3010 || c === 0x3011 || c >= 0x3012 && c <= 0x3013 || c === 0x3014 || c === 0x3015 || c === 0x3016 || c === 0x3017 || c === 0x3018 || c === 0x3019 || c === 0x301a || c === 0x301b || c === 0x301c || c === 0x301d || c >= 0x301e && c <= 0x301f || c === 0x3020 || c === 0x3030 || c === 0xfd3e || c === 0xfd3f || c >= 0xfe45 && c <= 0xfe46;
}

});
parcelRegister("O1ybS", function(module, exports) {
$parcel$export(module.exports, "TYPE", () => $0965df83fca6380a$export$b87f371cbc396fcf);
$parcel$export(module.exports, "SKELETON_TYPE", () => $0965df83fca6380a$export$906452485466fa53);
$parcel$export(module.exports, "isNumberElement", () => $0965df83fca6380a$export$e11187b219e191e1);
$parcel$export(module.exports, "isDateElement", () => $0965df83fca6380a$export$32d811605da75f40);
$parcel$export(module.exports, "isTimeElement", () => $0965df83fca6380a$export$34ec46f596b1702f);
$parcel$export(module.exports, "isSelectElement", () => $0965df83fca6380a$export$dcfe1c11d168b5a1);
$parcel$export(module.exports, "isPluralElement", () => $0965df83fca6380a$export$6c796d116f0a4fbc);
$parcel$export(module.exports, "isTagElement", () => $0965df83fca6380a$export$5c83de34745812b);
$parcel$export(module.exports, "isNumberSkeleton", () => $0965df83fca6380a$export$3f9a19cd4152eda3);
$parcel$export(module.exports, "isDateTimeSkeleton", () => $0965df83fca6380a$export$7680c41f1a55f4cf);
var $0965df83fca6380a$export$b87f371cbc396fcf;
(function(TYPE) {
    /**
     * Raw text
     */ TYPE[TYPE["literal"] = 0] = "literal";
    /**
     * Variable w/o any format, e.g `var` in `this is a {var}`
     */ TYPE[TYPE["argument"] = 1] = "argument";
    /**
     * Variable w/ number format
     */ TYPE[TYPE["number"] = 2] = "number";
    /**
     * Variable w/ date format
     */ TYPE[TYPE["date"] = 3] = "date";
    /**
     * Variable w/ time format
     */ TYPE[TYPE["time"] = 4] = "time";
    /**
     * Variable w/ select format
     */ TYPE[TYPE["select"] = 5] = "select";
    /**
     * Variable w/ plural format
     */ TYPE[TYPE["plural"] = 6] = "plural";
    /**
     * Only possible within plural argument.
     * This is the `#` symbol that will be substituted with the count.
     */ TYPE[TYPE["pound"] = 7] = "pound";
    /**
     * XML-like tag
     */ TYPE[TYPE["tag"] = 8] = "tag";
})($0965df83fca6380a$export$b87f371cbc396fcf || ($0965df83fca6380a$export$b87f371cbc396fcf = {}));
var $0965df83fca6380a$export$906452485466fa53;
(function(SKELETON_TYPE) {
    SKELETON_TYPE[SKELETON_TYPE["number"] = 0] = "number";
    SKELETON_TYPE[SKELETON_TYPE["dateTime"] = 1] = "dateTime";
})($0965df83fca6380a$export$906452485466fa53 || ($0965df83fca6380a$export$906452485466fa53 = {}));
function $0965df83fca6380a$export$cfa10c5697238752(el) {
    return el.type === $0965df83fca6380a$export$b87f371cbc396fcf.literal;
}
function $0965df83fca6380a$export$4f55724281bdfaf9(el) {
    return el.type === $0965df83fca6380a$export$b87f371cbc396fcf.argument;
}
function $0965df83fca6380a$export$e11187b219e191e1(el) {
    return el.type === $0965df83fca6380a$export$b87f371cbc396fcf.number;
}
function $0965df83fca6380a$export$32d811605da75f40(el) {
    return el.type === $0965df83fca6380a$export$b87f371cbc396fcf.date;
}
function $0965df83fca6380a$export$34ec46f596b1702f(el) {
    return el.type === $0965df83fca6380a$export$b87f371cbc396fcf.time;
}
function $0965df83fca6380a$export$dcfe1c11d168b5a1(el) {
    return el.type === $0965df83fca6380a$export$b87f371cbc396fcf.select;
}
function $0965df83fca6380a$export$6c796d116f0a4fbc(el) {
    return el.type === $0965df83fca6380a$export$b87f371cbc396fcf.plural;
}
function $0965df83fca6380a$export$c0ece297bdd0c082(el) {
    return el.type === $0965df83fca6380a$export$b87f371cbc396fcf.pound;
}
function $0965df83fca6380a$export$5c83de34745812b(el) {
    return el.type === $0965df83fca6380a$export$b87f371cbc396fcf.tag;
}
function $0965df83fca6380a$export$3f9a19cd4152eda3(el) {
    return !!(el && typeof el === 'object' && el.type === $0965df83fca6380a$export$906452485466fa53.number);
}
function $0965df83fca6380a$export$7680c41f1a55f4cf(el) {
    return !!(el && typeof el === 'object' && el.type === $0965df83fca6380a$export$906452485466fa53.dateTime);
}
function $0965df83fca6380a$export$f0ac572c1121c662(value) {
    return {
        type: $0965df83fca6380a$export$b87f371cbc396fcf.literal,
        value: value
    };
}
function $0965df83fca6380a$export$425e864b0ba114f1(value, style) {
    return {
        type: $0965df83fca6380a$export$b87f371cbc396fcf.number,
        value: value,
        style: style
    };
}

});

parcelRegister("kmILk", function(module, exports) {
$parcel$export(module.exports, "SPACE_SEPARATOR_REGEX", () => $ed38959479f3cfcd$export$523451f94304dd6c);
// @generated from regex-gen.ts
var $ed38959479f3cfcd$export$523451f94304dd6c = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/;
var $ed38959479f3cfcd$export$2b8db14d8bcaece7 = /[\t-\r \x85\u200E\u200F\u2028\u2029]/;

});

parcelRegister("lfGUA", function(module, exports) {
$parcel$export(module.exports, "getBestPattern", () => $f78c490a4e380746$export$29c5368be8904d27);

var $haD7r = parcelRequire("haD7r");
function $f78c490a4e380746$export$29c5368be8904d27(skeleton, locale) {
    var skeletonCopy = '';
    for(var patternPos = 0; patternPos < skeleton.length; patternPos++){
        var patternChar = skeleton.charAt(patternPos);
        if (patternChar === 'j') {
            var extraLength = 0;
            while(patternPos + 1 < skeleton.length && skeleton.charAt(patternPos + 1) === patternChar){
                extraLength++;
                patternPos++;
            }
            var hourLen = 1 + (extraLength & 1);
            var dayPeriodLen = extraLength < 2 ? 1 : 3 + (extraLength >> 1);
            var dayPeriodChar = 'a';
            var hourChar = $f78c490a4e380746$var$getDefaultHourSymbolFromLocale(locale);
            if (hourChar == 'H' || hourChar == 'k') dayPeriodLen = 0;
            while(dayPeriodLen-- > 0)skeletonCopy += dayPeriodChar;
            while(hourLen-- > 0)skeletonCopy = hourChar + skeletonCopy;
        } else if (patternChar === 'J') skeletonCopy += 'H';
        else skeletonCopy += patternChar;
    }
    return skeletonCopy;
}
/**
 * Maps the [hour cycle type](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/hourCycle)
 * of the given `locale` to the corresponding time pattern.
 * @param locale
 */ function $f78c490a4e380746$var$getDefaultHourSymbolFromLocale(locale) {
    var hourCycle = locale.hourCycle;
    if (hourCycle === undefined && // @ts-ignore hourCycle(s) is not identified yet
    locale.hourCycles && // @ts-ignore
    locale.hourCycles.length) // @ts-ignore
    hourCycle = locale.hourCycles[0];
    if (hourCycle) switch(hourCycle){
        case 'h24':
            return 'k';
        case 'h23':
            return 'H';
        case 'h12':
            return 'h';
        case 'h11':
            return 'K';
        default:
            throw new Error('Invalid hourCycle');
    }
    // TODO: Once hourCycle is fully supported remove the following with data generation
    var languageTag = locale.language;
    var regionTag;
    if (languageTag !== 'root') regionTag = locale.maximize().region;
    var hourCycles = (0, $haD7r.timeData)[regionTag || ''] || (0, $haD7r.timeData)[languageTag || ''] || (0, $haD7r.timeData)["".concat(languageTag, "-001")] || (0, $haD7r.timeData)['001'];
    return hourCycles[0];
}

});
parcelRegister("haD7r", function(module, exports) {
$parcel$export(module.exports, "timeData", () => $c801b713101653a8$export$a8c9209db4084317);
// @generated from time-data-gen.ts
// prettier-ignore  
var $c801b713101653a8$export$a8c9209db4084317 = {
    "AX": [
        "H"
    ],
    "BQ": [
        "H"
    ],
    "CP": [
        "H"
    ],
    "CZ": [
        "H"
    ],
    "DK": [
        "H"
    ],
    "FI": [
        "H"
    ],
    "ID": [
        "H"
    ],
    "IS": [
        "H"
    ],
    "ML": [
        "H"
    ],
    "NE": [
        "H"
    ],
    "RU": [
        "H"
    ],
    "SE": [
        "H"
    ],
    "SJ": [
        "H"
    ],
    "SK": [
        "H"
    ],
    "AS": [
        "h",
        "H"
    ],
    "BT": [
        "h",
        "H"
    ],
    "DJ": [
        "h",
        "H"
    ],
    "ER": [
        "h",
        "H"
    ],
    "GH": [
        "h",
        "H"
    ],
    "IN": [
        "h",
        "H"
    ],
    "LS": [
        "h",
        "H"
    ],
    "PG": [
        "h",
        "H"
    ],
    "PW": [
        "h",
        "H"
    ],
    "SO": [
        "h",
        "H"
    ],
    "TO": [
        "h",
        "H"
    ],
    "VU": [
        "h",
        "H"
    ],
    "WS": [
        "h",
        "H"
    ],
    "001": [
        "H",
        "h"
    ],
    "AL": [
        "h",
        "H",
        "hB"
    ],
    "TD": [
        "h",
        "H",
        "hB"
    ],
    "ca-ES": [
        "H",
        "h",
        "hB"
    ],
    "CF": [
        "H",
        "h",
        "hB"
    ],
    "CM": [
        "H",
        "h",
        "hB"
    ],
    "fr-CA": [
        "H",
        "h",
        "hB"
    ],
    "gl-ES": [
        "H",
        "h",
        "hB"
    ],
    "it-CH": [
        "H",
        "h",
        "hB"
    ],
    "it-IT": [
        "H",
        "h",
        "hB"
    ],
    "LU": [
        "H",
        "h",
        "hB"
    ],
    "NP": [
        "H",
        "h",
        "hB"
    ],
    "PF": [
        "H",
        "h",
        "hB"
    ],
    "SC": [
        "H",
        "h",
        "hB"
    ],
    "SM": [
        "H",
        "h",
        "hB"
    ],
    "SN": [
        "H",
        "h",
        "hB"
    ],
    "TF": [
        "H",
        "h",
        "hB"
    ],
    "VA": [
        "H",
        "h",
        "hB"
    ],
    "CY": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "GR": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "CO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "DO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KP": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "NA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "VE": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "AC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "BW": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "BZ": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "DG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "FK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GB": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IM": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IO": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "JE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "LT": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MS": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NF": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NR": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NU": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "PN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SH": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "TA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ZA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "af-ZA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "AR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CL": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CU": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "EA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-BO": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-BR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-EC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-ES": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-GQ": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-PE": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "GT": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "HN": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "IC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KG": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KM": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "LK": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MX": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "NI": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "PY": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "SV": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "UY": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "JP": [
        "H",
        "h",
        "K"
    ],
    "AD": [
        "H",
        "hB"
    ],
    "AM": [
        "H",
        "hB"
    ],
    "AO": [
        "H",
        "hB"
    ],
    "AT": [
        "H",
        "hB"
    ],
    "AW": [
        "H",
        "hB"
    ],
    "BE": [
        "H",
        "hB"
    ],
    "BF": [
        "H",
        "hB"
    ],
    "BJ": [
        "H",
        "hB"
    ],
    "BL": [
        "H",
        "hB"
    ],
    "BR": [
        "H",
        "hB"
    ],
    "CG": [
        "H",
        "hB"
    ],
    "CI": [
        "H",
        "hB"
    ],
    "CV": [
        "H",
        "hB"
    ],
    "DE": [
        "H",
        "hB"
    ],
    "EE": [
        "H",
        "hB"
    ],
    "FR": [
        "H",
        "hB"
    ],
    "GA": [
        "H",
        "hB"
    ],
    "GF": [
        "H",
        "hB"
    ],
    "GN": [
        "H",
        "hB"
    ],
    "GP": [
        "H",
        "hB"
    ],
    "GW": [
        "H",
        "hB"
    ],
    "HR": [
        "H",
        "hB"
    ],
    "IL": [
        "H",
        "hB"
    ],
    "IT": [
        "H",
        "hB"
    ],
    "KZ": [
        "H",
        "hB"
    ],
    "MC": [
        "H",
        "hB"
    ],
    "MD": [
        "H",
        "hB"
    ],
    "MF": [
        "H",
        "hB"
    ],
    "MQ": [
        "H",
        "hB"
    ],
    "MZ": [
        "H",
        "hB"
    ],
    "NC": [
        "H",
        "hB"
    ],
    "NL": [
        "H",
        "hB"
    ],
    "PM": [
        "H",
        "hB"
    ],
    "PT": [
        "H",
        "hB"
    ],
    "RE": [
        "H",
        "hB"
    ],
    "RO": [
        "H",
        "hB"
    ],
    "SI": [
        "H",
        "hB"
    ],
    "SR": [
        "H",
        "hB"
    ],
    "ST": [
        "H",
        "hB"
    ],
    "TG": [
        "H",
        "hB"
    ],
    "TR": [
        "H",
        "hB"
    ],
    "WF": [
        "H",
        "hB"
    ],
    "YT": [
        "H",
        "hB"
    ],
    "BD": [
        "h",
        "hB",
        "H"
    ],
    "PK": [
        "h",
        "hB",
        "H"
    ],
    "AZ": [
        "H",
        "hB",
        "h"
    ],
    "BA": [
        "H",
        "hB",
        "h"
    ],
    "BG": [
        "H",
        "hB",
        "h"
    ],
    "CH": [
        "H",
        "hB",
        "h"
    ],
    "GE": [
        "H",
        "hB",
        "h"
    ],
    "LI": [
        "H",
        "hB",
        "h"
    ],
    "ME": [
        "H",
        "hB",
        "h"
    ],
    "RS": [
        "H",
        "hB",
        "h"
    ],
    "UA": [
        "H",
        "hB",
        "h"
    ],
    "UZ": [
        "H",
        "hB",
        "h"
    ],
    "XK": [
        "H",
        "hB",
        "h"
    ],
    "AG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "CA": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "DM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "en-001": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FJ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GD": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "JM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KN": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LR": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MH": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MP": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MW": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "NZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SL": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TT": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "UM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "US": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ZM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BO": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "EC": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "ES": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "GQ": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "PE": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "AE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ar-001": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "BH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "DZ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EG": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "HK": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "IQ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "JO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "KW": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "LB": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "LY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MR": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "OM": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PS": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "QA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SD": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "TN": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "YE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "AF": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "LA": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "CN": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "LV": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "TL": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "zu-ZA": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "CD": [
        "hB",
        "H"
    ],
    "IR": [
        "hB",
        "H"
    ],
    "hi-IN": [
        "hB",
        "h",
        "H"
    ],
    "kn-IN": [
        "hB",
        "h",
        "H"
    ],
    "ml-IN": [
        "hB",
        "h",
        "H"
    ],
    "te-IN": [
        "hB",
        "h",
        "H"
    ],
    "KH": [
        "hB",
        "h",
        "H",
        "hb"
    ],
    "ta-IN": [
        "hB",
        "h",
        "hb",
        "H"
    ],
    "BN": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "MY": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "ET": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "gu-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "mr-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "pa-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "TW": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "KE": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "MM": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "TZ": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UG": [
        "hB",
        "hb",
        "H",
        "h"
    ]
};

});





parcelRegister("jQfMu", function(module, exports) {
$parcel$export(module.exports, "formatList", () => $e71f1d779d9d4fb6$export$e8b8be48b45905bb);
$parcel$export(module.exports, "formatListToParts", () => $e71f1d779d9d4fb6$export$6f284aad1934db69);

var $dnskZ = parcelRequire("dnskZ");

var $99KvW = parcelRequire("99KvW");

var $klPYX = parcelRequire("klPYX");

var $6zNca = parcelRequire("6zNca");
var $e71f1d779d9d4fb6$var$LIST_FORMAT_OPTIONS = [
    'localeMatcher',
    'type',
    'style'
];
var $e71f1d779d9d4fb6$var$now = Date.now();
function $e71f1d779d9d4fb6$var$generateToken(i) {
    return "".concat($e71f1d779d9d4fb6$var$now, "_").concat(i, "_").concat($e71f1d779d9d4fb6$var$now);
}
function $e71f1d779d9d4fb6$export$e8b8be48b45905bb(opts, getListFormat, values, options) {
    if (options === void 0) options = {};
    var results = $e71f1d779d9d4fb6$export$6f284aad1934db69(opts, getListFormat, values, options).reduce(function(all, el) {
        var val = el.value;
        if (typeof val !== 'string') all.push(val);
        else if (typeof all[all.length - 1] === 'string') all[all.length - 1] += val;
        else all.push(val);
        return all;
    }, []);
    return results.length === 1 ? results[0] : results;
}
function $e71f1d779d9d4fb6$export$6f284aad1934db69(_a, getListFormat, values, options) {
    var locale = _a.locale, onError = _a.onError;
    if (options === void 0) options = {};
    var ListFormat = Intl.ListFormat;
    if (!ListFormat) onError(new (0, $klPYX.FormatError)("Intl.ListFormat is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-listformat\"\n", (0, $klPYX.ErrorCode).MISSING_INTL_API));
    var filteredOptions = (0, $99KvW.filterProps)(options, $e71f1d779d9d4fb6$var$LIST_FORMAT_OPTIONS);
    try {
        var richValues_1 = {};
        var serializedValues = values.map(function(v, i) {
            if (typeof v === 'object') {
                var id = $e71f1d779d9d4fb6$var$generateToken(i);
                richValues_1[id] = v;
                return id;
            }
            return String(v);
        });
        return getListFormat(locale, filteredOptions).formatToParts(serializedValues).map(function(part) {
            return part.type === 'literal' ? part : (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, part), {
                value: richValues_1[part.value] || part.value
            });
        });
    } catch (e) {
        onError(new (0, $6zNca.IntlError)((0, $6zNca.IntlErrorCode).FORMAT_ERROR, 'Error formatting list.', e));
    }
    // @ts-ignore
    return values;
}

});

parcelRegister("9zWXp", function(module, exports) {
$parcel$export(module.exports, "formatDisplayName", () => $6f951da1f8779f62$export$62fe1a4d9e891fa2);

var $99KvW = parcelRequire("99KvW");

var $klPYX = parcelRequire("klPYX");

var $6zNca = parcelRequire("6zNca");
var $6f951da1f8779f62$var$DISPLAY_NAMES_OPTONS = [
    'localeMatcher',
    'style',
    'type',
    'fallback'
];
function $6f951da1f8779f62$export$62fe1a4d9e891fa2(_a, getDisplayNames, value, options) {
    var locale = _a.locale, onError = _a.onError;
    var DisplayNames = Intl.DisplayNames;
    if (!DisplayNames) onError(new (0, $klPYX.FormatError)("Intl.DisplayNames is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-displaynames\"\n", (0, $klPYX.ErrorCode).MISSING_INTL_API));
    var filteredOptions = (0, $99KvW.filterProps)(options, $6f951da1f8779f62$var$DISPLAY_NAMES_OPTONS);
    try {
        return getDisplayNames(locale, filteredOptions).of(value);
    } catch (e) {
        onError(new (0, $6zNca.IntlError)((0, $6zNca.IntlErrorCode).FORMAT_ERROR, 'Error formatting display name.', e));
    }
}

});


parcelRegister("8GOss", function(module, exports) {
$parcel$export(module.exports, "default", () => $653962e2eb0097ca$export$2e2bcd8739ae039);
var $653962e2eb0097ca$var$isProduction = true;
var $653962e2eb0097ca$var$prefix = 'Invariant failed';
function $653962e2eb0097ca$export$2e2bcd8739ae039(condition, message) {
    if (condition) return;
    if ($653962e2eb0097ca$var$isProduction) throw new Error($653962e2eb0097ca$var$prefix);
    var provided = typeof message === 'function' ? message() : message;
    var value = provided ? "".concat($653962e2eb0097ca$var$prefix, ": ").concat(provided) : $653962e2eb0097ca$var$prefix;
    throw new Error(value);
}

});

parcelRegister("gamVI", function(module, exports) {
$parcel$export(module.exports, "captureException", () => $bc4f5dea156c0553$export$f5282963edea4a68);
$parcel$export(module.exports, "captureMessage", () => $bc4f5dea156c0553$export$45654777c133ae80);
$parcel$export(module.exports, "captureEvent", () => $bc4f5dea156c0553$export$1462b974fdcf6ba2);
$parcel$export(module.exports, "configureScope", () => $bc4f5dea156c0553$export$99d44f04437e9cb8);
$parcel$export(module.exports, "addBreadcrumb", () => $bc4f5dea156c0553$export$efda9a273d7a036d);
$parcel$export(module.exports, "setContext", () => $bc4f5dea156c0553$export$2f04de43fe27971a);
$parcel$export(module.exports, "setExtras", () => $bc4f5dea156c0553$export$bb4922da0dd51b92);
$parcel$export(module.exports, "setTags", () => $bc4f5dea156c0553$export$74a8fb34822092e6);
$parcel$export(module.exports, "setExtra", () => $bc4f5dea156c0553$export$8e8e7789d42ed61d);
$parcel$export(module.exports, "setTag", () => $bc4f5dea156c0553$export$a37d07ee78eb4569);
$parcel$export(module.exports, "setUser", () => $bc4f5dea156c0553$export$8b6bb3dd62a01be2);
$parcel$export(module.exports, "withScope", () => $bc4f5dea156c0553$export$ec58d9285c204497);
$parcel$export(module.exports, "startTransaction", () => $bc4f5dea156c0553$export$e262da7ae6480481);

var $dnskZ = parcelRequire("dnskZ");

var $kObcn = parcelRequire("kObcn");
/**
 * This calls a function on the current hub.
 * @param method function to call on hub.
 * @param args to pass to function.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $bc4f5dea156c0553$var$callOnHub(method) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    var hub = (0, $kObcn.getCurrentHub)();
    if (hub && hub[method]) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return hub[method].apply(hub, (0, $dnskZ.__spread)(args));
    throw new Error("No hub defined or " + method + " was not found on the hub, please open a bug report.");
}
function $bc4f5dea156c0553$export$f5282963edea4a68(exception, captureContext) {
    var syntheticException = new Error('Sentry syntheticException');
    return $bc4f5dea156c0553$var$callOnHub('captureException', exception, {
        captureContext: captureContext,
        originalException: exception,
        syntheticException: syntheticException
    });
}
function $bc4f5dea156c0553$export$45654777c133ae80(message, captureContext) {
    var syntheticException = new Error(message);
    // This is necessary to provide explicit scopes upgrade, without changing the original
    // arity of the `captureMessage(message, level)` method.
    var level = typeof captureContext === 'string' ? captureContext : undefined;
    var context = typeof captureContext !== 'string' ? {
        captureContext: captureContext
    } : undefined;
    return $bc4f5dea156c0553$var$callOnHub('captureMessage', message, level, (0, $dnskZ.__assign)({
        originalException: message,
        syntheticException: syntheticException
    }, context));
}
function $bc4f5dea156c0553$export$1462b974fdcf6ba2(event) {
    return $bc4f5dea156c0553$var$callOnHub('captureEvent', event);
}
function $bc4f5dea156c0553$export$99d44f04437e9cb8(callback) {
    $bc4f5dea156c0553$var$callOnHub('configureScope', callback);
}
function $bc4f5dea156c0553$export$efda9a273d7a036d(breadcrumb) {
    $bc4f5dea156c0553$var$callOnHub('addBreadcrumb', breadcrumb);
}
function $bc4f5dea156c0553$export$2f04de43fe27971a(name, context) {
    $bc4f5dea156c0553$var$callOnHub('setContext', name, context);
}
function $bc4f5dea156c0553$export$bb4922da0dd51b92(extras) {
    $bc4f5dea156c0553$var$callOnHub('setExtras', extras);
}
function $bc4f5dea156c0553$export$74a8fb34822092e6(tags) {
    $bc4f5dea156c0553$var$callOnHub('setTags', tags);
}
function $bc4f5dea156c0553$export$8e8e7789d42ed61d(key, extra) {
    $bc4f5dea156c0553$var$callOnHub('setExtra', key, extra);
}
function $bc4f5dea156c0553$export$a37d07ee78eb4569(key, value) {
    $bc4f5dea156c0553$var$callOnHub('setTag', key, value);
}
function $bc4f5dea156c0553$export$8b6bb3dd62a01be2(user) {
    $bc4f5dea156c0553$var$callOnHub('setUser', user);
}
function $bc4f5dea156c0553$export$ec58d9285c204497(callback) {
    $bc4f5dea156c0553$var$callOnHub('withScope', callback);
}
function $bc4f5dea156c0553$export$5b9bc6fc91daaf9f(method) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    $bc4f5dea156c0553$var$callOnHub.apply(void 0, (0, $dnskZ.__spread)([
        '_invokeClient',
        method
    ], args));
}
function $bc4f5dea156c0553$export$e262da7ae6480481(context, customSamplingContext) {
    return $bc4f5dea156c0553$var$callOnHub('startTransaction', (0, $dnskZ.__assign)({}, context), customSamplingContext);
}

});
parcelRegister("kObcn", function(module, exports) {
$parcel$export(module.exports, "Hub", () => $f26129f576e7a4b9$export$8c41bb232f1008b1);
$parcel$export(module.exports, "makeMain", () => $f26129f576e7a4b9$export$4188a14ad302d1bc);
$parcel$export(module.exports, "getHubFromCarrier", () => $f26129f576e7a4b9$export$bfa8a924a84a76b7);
$parcel$export(module.exports, "getCurrentHub", () => $f26129f576e7a4b9$export$a07cdf6544bbd7c);

var $dnskZ = parcelRequire("dnskZ");
parcelRequire("7Nv7F");
var $8Hu2u = parcelRequire("8Hu2u");
var $jwZVu = parcelRequire("jwZVu");
var $dr7Gi = parcelRequire("dr7Gi");
var $lBG93 = parcelRequire("lBG93");
var $eiQXL = parcelRequire("eiQXL");

var $dfeQ8 = parcelRequire("dfeQ8");

var $e58Qh = parcelRequire("e58Qh");

var $cido5 = parcelRequire("cido5");
var $f26129f576e7a4b9$export$24a86ef7798177e4 = 4;
/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */ var $f26129f576e7a4b9$var$DEFAULT_BREADCRUMBS = 100;
/**
 * @inheritDoc
 */ var $f26129f576e7a4b9$export$8c41bb232f1008b1 = /** @class */ function() {
    /**
     * Creates a new instance of the hub, will push one {@link Layer} into the
     * internal stack on creation.
     *
     * @param client bound to the hub.
     * @param scope bound to the hub.
     * @param version number, higher number means higher priority.
     */ function Hub(client, scope, _version) {
        if (scope === void 0) scope = new (0, $e58Qh.Scope)();
        if (_version === void 0) _version = $f26129f576e7a4b9$export$24a86ef7798177e4;
        this._version = _version;
        /** Is a {@link Layer}[] containing the client and scope */ this._stack = [
            {}
        ];
        this.getStackTop().scope = scope;
        if (client) this.bindClient(client);
    }
    /**
     * @inheritDoc
     */ Hub.prototype.isOlderThan = function(version) {
        return this._version < version;
    };
    /**
     * @inheritDoc
     */ Hub.prototype.bindClient = function(client) {
        var top = this.getStackTop();
        top.client = client;
        if (client && client.setupIntegrations) client.setupIntegrations();
    };
    /**
     * @inheritDoc
     */ Hub.prototype.pushScope = function() {
        // We want to clone the content of prev scope
        var scope = (0, $e58Qh.Scope).clone(this.getScope());
        this.getStack().push({
            client: this.getClient(),
            scope: scope
        });
        return scope;
    };
    /**
     * @inheritDoc
     */ Hub.prototype.popScope = function() {
        if (this.getStack().length <= 1) return false;
        return !!this.getStack().pop();
    };
    /**
     * @inheritDoc
     */ Hub.prototype.withScope = function(callback) {
        var scope = this.pushScope();
        try {
            callback(scope);
        } finally{
            this.popScope();
        }
    };
    /**
     * @inheritDoc
     */ Hub.prototype.getClient = function() {
        return this.getStackTop().client;
    };
    /** Returns the scope of the top stack. */ Hub.prototype.getScope = function() {
        return this.getStackTop().scope;
    };
    /** Returns the scope stack for domains or the process. */ Hub.prototype.getStack = function() {
        return this._stack;
    };
    /** Returns the topmost scope layer in the order domain > local > process. */ Hub.prototype.getStackTop = function() {
        return this._stack[this._stack.length - 1];
    };
    /**
     * @inheritDoc
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    Hub.prototype.captureException = function(exception, hint) {
        var eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, $eiQXL.uuid4)();
        var finalHint = hint;
        // If there's no explicit hint provided, mimic the same thing that would happen
        // in the minimal itself to create a consistent behavior.
        // We don't do this in the client, as it's the lowest level API, and doing this,
        // would prevent user from having full control over direct calls.
        if (!hint) {
            var syntheticException = void 0;
            try {
                throw new Error('Sentry syntheticException');
            } catch (exception) {
                syntheticException = exception;
            }
            finalHint = {
                originalException: exception,
                syntheticException: syntheticException
            };
        }
        this._invokeClient('captureException', exception, (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, finalHint), {
            event_id: eventId
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */ Hub.prototype.captureMessage = function(message, level, hint) {
        var eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, $eiQXL.uuid4)();
        var finalHint = hint;
        // If there's no explicit hint provided, mimic the same thing that would happen
        // in the minimal itself to create a consistent behavior.
        // We don't do this in the client, as it's the lowest level API, and doing this,
        // would prevent user from having full control over direct calls.
        if (!hint) {
            var syntheticException = void 0;
            try {
                throw new Error(message);
            } catch (exception) {
                syntheticException = exception;
            }
            finalHint = {
                originalException: message,
                syntheticException: syntheticException
            };
        }
        this._invokeClient('captureMessage', message, level, (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, finalHint), {
            event_id: eventId
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */ Hub.prototype.captureEvent = function(event, hint) {
        var eventId = hint && hint.event_id ? hint.event_id : (0, $eiQXL.uuid4)();
        if (event.type !== 'transaction') this._lastEventId = eventId;
        this._invokeClient('captureEvent', event, (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, hint), {
            event_id: eventId
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */ Hub.prototype.lastEventId = function() {
        return this._lastEventId;
    };
    /**
     * @inheritDoc
     */ Hub.prototype.addBreadcrumb = function(breadcrumb, hint) {
        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
        if (!scope || !client) return;
        // eslint-disable-next-line @typescript-eslint/unbound-method
        var _b = client.getOptions && client.getOptions() || {}, _c = _b.beforeBreadcrumb, beforeBreadcrumb = _c === void 0 ? null : _c, _d = _b.maxBreadcrumbs, maxBreadcrumbs = _d === void 0 ? $f26129f576e7a4b9$var$DEFAULT_BREADCRUMBS : _d;
        if (maxBreadcrumbs <= 0) return;
        var timestamp = (0, $jwZVu.dateTimestampInSeconds)();
        var mergedBreadcrumb = (0, $dnskZ.__assign)({
            timestamp: timestamp
        }, breadcrumb);
        var finalBreadcrumb = beforeBreadcrumb ? (0, $8Hu2u.consoleSandbox)(function() {
            return beforeBreadcrumb(mergedBreadcrumb, hint);
        }) : mergedBreadcrumb;
        if (finalBreadcrumb === null) return;
        scope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.setUser = function(user) {
        var scope = this.getScope();
        if (scope) scope.setUser(user);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.setTags = function(tags) {
        var scope = this.getScope();
        if (scope) scope.setTags(tags);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.setExtras = function(extras) {
        var scope = this.getScope();
        if (scope) scope.setExtras(extras);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.setTag = function(key, value) {
        var scope = this.getScope();
        if (scope) scope.setTag(key, value);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.setExtra = function(key, extra) {
        var scope = this.getScope();
        if (scope) scope.setExtra(key, extra);
    };
    /**
     * @inheritDoc
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Hub.prototype.setContext = function(name, context) {
        var scope = this.getScope();
        if (scope) scope.setContext(name, context);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.configureScope = function(callback) {
        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
        if (scope && client) callback(scope);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.run = function(callback) {
        var oldHub = $f26129f576e7a4b9$export$4188a14ad302d1bc(this);
        try {
            callback(this);
        } finally{
            $f26129f576e7a4b9$export$4188a14ad302d1bc(oldHub);
        }
    };
    /**
     * @inheritDoc
     */ Hub.prototype.getIntegration = function(integration) {
        var client = this.getClient();
        if (!client) return null;
        try {
            return client.getIntegration(integration);
        } catch (_oO) {
            (0, $dfeQ8.IS_DEBUG_BUILD) && (0, $8Hu2u.logger).warn("Cannot retrieve integration " + integration.id + " from the current Hub");
            return null;
        }
    };
    /**
     * @inheritDoc
     */ Hub.prototype.startSpan = function(context) {
        return this._callExtensionMethod('startSpan', context);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.startTransaction = function(context, customSamplingContext) {
        return this._callExtensionMethod('startTransaction', context, customSamplingContext);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.traceHeaders = function() {
        return this._callExtensionMethod('traceHeaders');
    };
    /**
     * @inheritDoc
     */ Hub.prototype.captureSession = function(endSession) {
        if (endSession === void 0) endSession = false;
        // both send the update and pull the session from the scope
        if (endSession) return this.endSession();
        // only send the update
        this._sendSessionUpdate();
    };
    /**
     * @inheritDoc
     */ Hub.prototype.endSession = function() {
        var layer = this.getStackTop();
        var scope = layer && layer.scope;
        var session = scope && scope.getSession();
        if (session) session.close();
        this._sendSessionUpdate();
        // the session is over; take it off of the scope
        if (scope) scope.setSession();
    };
    /**
     * @inheritDoc
     */ Hub.prototype.startSession = function(context) {
        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
        var _b = client && client.getOptions() || {}, release = _b.release, environment = _b.environment;
        // Will fetch userAgent if called from browser sdk
        var global = (0, $dr7Gi.getGlobalObject)();
        var userAgent = (global.navigator || {}).userAgent;
        var session = new (0, $cido5.Session)((0, $dnskZ.__assign)((0, $dnskZ.__assign)((0, $dnskZ.__assign)({
            release: release,
            environment: environment
        }, scope && {
            user: scope.getUser()
        }), userAgent && {
            userAgent: userAgent
        }), context));
        if (scope) {
            // End existing session if there's one
            var currentSession = scope.getSession && scope.getSession();
            if (currentSession && currentSession.status === 'ok') currentSession.update({
                status: 'exited'
            });
            this.endSession();
            // Afterwards we set the new session on the scope
            scope.setSession(session);
        }
        return session;
    };
    /**
     * Sends the current Session on the scope
     */ Hub.prototype._sendSessionUpdate = function() {
        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
        if (!scope) return;
        var session = scope.getSession && scope.getSession();
        if (session) {
            if (client && client.captureSession) client.captureSession(session);
        }
    };
    /**
     * Internal helper function to call a method on the top client if it exists.
     *
     * @param method The method to call on the client.
     * @param args Arguments to pass to the client function.
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Hub.prototype._invokeClient = function(method) {
        var _a;
        var args = [];
        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
        var _b = this.getStackTop(), scope = _b.scope, client = _b.client;
        if (client && client[method]) // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any
        (_a = client)[method].apply(_a, (0, $dnskZ.__spread)(args, [
            scope
        ]));
    };
    /**
     * Calls global extension method and binding current instance to the function call
     */ // @ts-ignore Function lacks ending return statement and return type does not include 'undefined'. ts(2366)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Hub.prototype._callExtensionMethod = function(method) {
        var args = [];
        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
        var carrier = $f26129f576e7a4b9$export$19eade501500c6c1();
        var sentry = carrier.__SENTRY__;
        if (sentry && sentry.extensions && typeof sentry.extensions[method] === 'function') return sentry.extensions[method].apply(this, args);
        (0, $dfeQ8.IS_DEBUG_BUILD) && (0, $8Hu2u.logger).warn("Extension method " + method + " couldn't be found, doing nothing.");
    };
    return Hub;
}();
function $f26129f576e7a4b9$export$19eade501500c6c1() {
    var carrier = (0, $dr7Gi.getGlobalObject)();
    carrier.__SENTRY__ = carrier.__SENTRY__ || {
        extensions: {},
        hub: undefined
    };
    return carrier;
}
function $f26129f576e7a4b9$export$4188a14ad302d1bc(hub) {
    var registry = $f26129f576e7a4b9$export$19eade501500c6c1();
    var oldHub = $f26129f576e7a4b9$export$bfa8a924a84a76b7(registry);
    $f26129f576e7a4b9$export$849f05434e95d2f2(registry, hub);
    return oldHub;
}
function $f26129f576e7a4b9$export$a07cdf6544bbd7c() {
    // Get main carrier (global for every environment)
    var registry = $f26129f576e7a4b9$export$19eade501500c6c1();
    // If there's no hub, or its an old API, assign a new one
    if (!$f26129f576e7a4b9$var$hasHubOnCarrier(registry) || $f26129f576e7a4b9$export$bfa8a924a84a76b7(registry).isOlderThan($f26129f576e7a4b9$export$24a86ef7798177e4)) $f26129f576e7a4b9$export$849f05434e95d2f2(registry, new $f26129f576e7a4b9$export$8c41bb232f1008b1());
    // Prefer domains over global if they are there (applicable only to Node environment)
    if ((0, $lBG93.isNodeEnv)()) return $f26129f576e7a4b9$var$getHubFromActiveDomain(registry);
    // Return hub that lives on a global object
    return $f26129f576e7a4b9$export$bfa8a924a84a76b7(registry);
}
function $f26129f576e7a4b9$export$1c4d656130202699() {
    (0, $dfeQ8.IS_DEBUG_BUILD) && (0, $8Hu2u.logger).warn('Function `getActiveDomain` is deprecated and will be removed in a future version.');
    var sentry = $f26129f576e7a4b9$export$19eade501500c6c1().__SENTRY__;
    return sentry && sentry.extensions && sentry.extensions.domain && sentry.extensions.domain.active;
}
/**
 * Try to read the hub from an active domain, and fallback to the registry if one doesn't exist
 * @returns discovered hub
 */ function $f26129f576e7a4b9$var$getHubFromActiveDomain(registry) {
    try {
        var sentry = $f26129f576e7a4b9$export$19eade501500c6c1().__SENTRY__;
        var activeDomain = sentry && sentry.extensions && sentry.extensions.domain && sentry.extensions.domain.active;
        // If there's no active domain, just return global hub
        if (!activeDomain) return $f26129f576e7a4b9$export$bfa8a924a84a76b7(registry);
        // If there's no hub on current domain, or it's an old API, assign a new one
        if (!$f26129f576e7a4b9$var$hasHubOnCarrier(activeDomain) || $f26129f576e7a4b9$export$bfa8a924a84a76b7(activeDomain).isOlderThan($f26129f576e7a4b9$export$24a86ef7798177e4)) {
            var registryHubTopStack = $f26129f576e7a4b9$export$bfa8a924a84a76b7(registry).getStackTop();
            $f26129f576e7a4b9$export$849f05434e95d2f2(activeDomain, new $f26129f576e7a4b9$export$8c41bb232f1008b1(registryHubTopStack.client, (0, $e58Qh.Scope).clone(registryHubTopStack.scope)));
        }
        // Return hub that lives on a domain
        return $f26129f576e7a4b9$export$bfa8a924a84a76b7(activeDomain);
    } catch (_Oo) {
        // Return hub that lives on a global object
        return $f26129f576e7a4b9$export$bfa8a924a84a76b7(registry);
    }
}
/**
 * This will tell whether a carrier has a hub on it or not
 * @param carrier object
 */ function $f26129f576e7a4b9$var$hasHubOnCarrier(carrier) {
    return !!(carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub);
}
function $f26129f576e7a4b9$export$bfa8a924a84a76b7(carrier) {
    return (0, $dr7Gi.getGlobalSingleton)('hub', function() {
        return new $f26129f576e7a4b9$export$8c41bb232f1008b1();
    }, carrier);
}
function $f26129f576e7a4b9$export$849f05434e95d2f2(carrier, hub) {
    if (!carrier) return false;
    var __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    __SENTRY__.hub = hub;
    return true;
}

});
parcelRegister("7Nv7F", function(module, exports) {
$parcel$export(module.exports, "getGlobalObject", () => (parcelRequire("dr7Gi")).getGlobalObject);
$parcel$export(module.exports, "getGlobalSingleton", () => (parcelRequire("dr7Gi")).getGlobalSingleton);
$parcel$export(module.exports, "isPlainObject", () => (parcelRequire("8brdh")).isPlainObject);
$parcel$export(module.exports, "isThenable", () => (parcelRequire("8brdh")).isThenable);
$parcel$export(module.exports, "consoleSandbox", () => (parcelRequire("8Hu2u")).consoleSandbox);
$parcel$export(module.exports, "logger", () => (parcelRequire("8Hu2u")).logger);
$parcel$export(module.exports, "uuid4", () => (parcelRequire("eiQXL")).uuid4);
$parcel$export(module.exports, "dropUndefinedKeys", () => (parcelRequire("2jc66")).dropUndefinedKeys);
$parcel$export(module.exports, "SyncPromise", () => (parcelRequire("4TNFb")).SyncPromise);





parcelRequire("dr7Gi");

parcelRequire("8brdh");
parcelRequire("8Hu2u");

parcelRequire("eiQXL");

var $lBG93 = parcelRequire("lBG93");

parcelRequire("2jc66");







parcelRequire("4TNFb");

var $jwZVu = parcelRequire("jwZVu");





$parcel$exportWildcard(module.exports, $lBG93);
$parcel$exportWildcard(module.exports, $jwZVu);

});
parcelRegister("dr7Gi", function(module, exports) {
$parcel$export(module.exports, "getGlobalObject", () => $9c83c147a00f774e$export$256479dc0cea61c4);
$parcel$export(module.exports, "getGlobalSingleton", () => $9c83c147a00f774e$export$7e223ec222791509);
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */ 
var $lBG93 = parcelRequire("lBG93");
var $9c83c147a00f774e$var$fallbackGlobalObject = {};
function $9c83c147a00f774e$export$256479dc0cea61c4() {
    return (0, $lBG93.isNodeEnv)() ? $parcel$global : typeof window !== 'undefined' // eslint-disable-line no-restricted-globals
     ? window // eslint-disable-line no-restricted-globals
     : typeof self !== 'undefined' ? self : $9c83c147a00f774e$var$fallbackGlobalObject;
}
function $9c83c147a00f774e$export$7e223ec222791509(name, creator, obj) {
    var global1 = obj || $9c83c147a00f774e$export$256479dc0cea61c4();
    var __SENTRY__ = global1.__SENTRY__ = global1.__SENTRY__ || {};
    var singleton = __SENTRY__[name] || (__SENTRY__[name] = creator());
    return singleton;
}

});
parcelRegister("lBG93", function(module, exports) {
$parcel$export(module.exports, "isNodeEnv", () => isNodeEnv, (v) => isNodeEnv = v);
$parcel$export(module.exports, "dynamicRequire", () => dynamicRequire, (v) => dynamicRequire = v);
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */ 
var $9BsEt = parcelRequire("9BsEt");

var $igDjg = parcelRequire("igDjg");
function isNodeEnv() {
    // explicitly check for browser bundles as those can be optimized statically
    // by terser/rollup.
    return !(0, $9BsEt.isBrowserBundle)() && Object.prototype.toString.call(typeof $igDjg !== 'undefined' ? $igDjg : 0) === '[object process]';
}
function dynamicRequire(mod, request) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return mod.require(request);
}
function loadModule(moduleName) {
    var mod;
    try {
        mod = dynamicRequire(module, moduleName);
    } catch (e) {
    // no-empty
    }
    try {
        var cwd = dynamicRequire(module, 'process').cwd;
        mod = dynamicRequire(module, cwd() + "/node_modules/" + moduleName);
    } catch (e) {
    // no-empty
    }
    return mod;
}

});
parcelRegister("9BsEt", function(module, exports) {
$parcel$export(module.exports, "isBrowserBundle", () => $6fddcb6a826c1a9f$export$2928c40372e623c0);
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These fags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */ /**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */ function $6fddcb6a826c1a9f$export$2928c40372e623c0() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== 'undefined' && !!__SENTRY_BROWSER_BUNDLE__;
}

});



parcelRegister("8brdh", function(module, exports) {
$parcel$export(module.exports, "isError", () => $5f5475c85d16fa63$export$e6127cc7fe7395c3);
$parcel$export(module.exports, "isInstanceOf", () => $5f5475c85d16fa63$export$49034edbe6b62415);
$parcel$export(module.exports, "isString", () => $5f5475c85d16fa63$export$844ec244b1367d54);
$parcel$export(module.exports, "isPrimitive", () => $5f5475c85d16fa63$export$c3825b437cbdea5c);
$parcel$export(module.exports, "isPlainObject", () => $5f5475c85d16fa63$export$53b83ca8eaab0383);
$parcel$export(module.exports, "isEvent", () => $5f5475c85d16fa63$export$9671ea99bd126ace);
$parcel$export(module.exports, "isElement", () => $5f5475c85d16fa63$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isRegExp", () => $5f5475c85d16fa63$export$49841c62b9eff15);
$parcel$export(module.exports, "isThenable", () => $5f5475c85d16fa63$export$f5b060c2914b97c8);
/* eslint-disable @typescript-eslint/no-explicit-any */ /* eslint-disable @typescript-eslint/explicit-module-boundary-types */ // eslint-disable-next-line @typescript-eslint/unbound-method
var $5f5475c85d16fa63$var$objectToString = Object.prototype.toString;
function $5f5475c85d16fa63$export$e6127cc7fe7395c3(wat) {
    switch($5f5475c85d16fa63$var$objectToString.call(wat)){
        case '[object Error]':
        case '[object Exception]':
        case '[object DOMException]':
            return true;
        default:
            return $5f5475c85d16fa63$export$49034edbe6b62415(wat, Error);
    }
}
function $5f5475c85d16fa63$var$isBuiltin(wat, ty) {
    return $5f5475c85d16fa63$var$objectToString.call(wat) === "[object " + ty + "]";
}
function $5f5475c85d16fa63$export$9f9636d330b71954(wat) {
    return $5f5475c85d16fa63$var$isBuiltin(wat, 'ErrorEvent');
}
function $5f5475c85d16fa63$export$ef9e2056653f0c8e(wat) {
    return $5f5475c85d16fa63$var$isBuiltin(wat, 'DOMError');
}
function $5f5475c85d16fa63$export$12e869b2a583f783(wat) {
    return $5f5475c85d16fa63$var$isBuiltin(wat, 'DOMException');
}
function $5f5475c85d16fa63$export$844ec244b1367d54(wat) {
    return $5f5475c85d16fa63$var$isBuiltin(wat, 'String');
}
function $5f5475c85d16fa63$export$c3825b437cbdea5c(wat) {
    return wat === null || typeof wat !== 'object' && typeof wat !== 'function';
}
function $5f5475c85d16fa63$export$53b83ca8eaab0383(wat) {
    return $5f5475c85d16fa63$var$isBuiltin(wat, 'Object');
}
function $5f5475c85d16fa63$export$9671ea99bd126ace(wat) {
    return typeof Event !== 'undefined' && $5f5475c85d16fa63$export$49034edbe6b62415(wat, Event);
}
function $5f5475c85d16fa63$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== 'undefined' && $5f5475c85d16fa63$export$49034edbe6b62415(wat, Element);
}
function $5f5475c85d16fa63$export$49841c62b9eff15(wat) {
    return $5f5475c85d16fa63$var$isBuiltin(wat, 'RegExp');
}
function $5f5475c85d16fa63$export$f5b060c2914b97c8(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat && wat.then && typeof wat.then === 'function');
}
function $5f5475c85d16fa63$export$bc2894c7158efbac(wat) {
    return $5f5475c85d16fa63$export$53b83ca8eaab0383(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
}
function $5f5475c85d16fa63$export$c9f5652083b8129d(wat) {
    return typeof wat === 'number' && wat !== wat;
}
function $5f5475c85d16fa63$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch (_e) {
        return false;
    }
}

});

parcelRegister("8Hu2u", function(module, exports) {
$parcel$export(module.exports, "consoleSandbox", () => $6559a407498e0d6c$export$cda52e2a8927a2ca);
$parcel$export(module.exports, "logger", () => $6559a407498e0d6c$export$af88d00dbe7f521);

var $dnskZ = parcelRequire("dnskZ");

var $eps4K = parcelRequire("eps4K");

var $dr7Gi = parcelRequire("dr7Gi");
// TODO: Implement different loggers for different environments
var $6559a407498e0d6c$var$global = (0, $dr7Gi.getGlobalObject)();
/** Prefix for logging strings */ var $6559a407498e0d6c$var$PREFIX = 'Sentry Logger ';
var $6559a407498e0d6c$export$2a2b1d2252a69ecb = [
    'debug',
    'info',
    'warn',
    'error',
    'log',
    'assert'
];
function $6559a407498e0d6c$export$cda52e2a8927a2ca(callback) {
    var global = (0, $dr7Gi.getGlobalObject)();
    if (!('console' in global)) return callback();
    var originalConsole = global.console;
    var wrappedLevels = {};
    // Restore all wrapped console methods
    $6559a407498e0d6c$export$2a2b1d2252a69ecb.forEach(function(level) {
        // TODO(v7): Remove this check as it's only needed for Node 6
        var originalWrappedFunc = originalConsole[level] && originalConsole[level].__sentry_original__;
        if (level in global.console && originalWrappedFunc) {
            wrappedLevels[level] = originalConsole[level];
            originalConsole[level] = originalWrappedFunc;
        }
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        Object.keys(wrappedLevels).forEach(function(level) {
            originalConsole[level] = wrappedLevels[level];
        });
    }
}
function $6559a407498e0d6c$var$makeLogger() {
    var enabled = false;
    var logger = {
        enable: function() {
            enabled = true;
        },
        disable: function() {
            enabled = false;
        }
    };
    if (0, $eps4K.IS_DEBUG_BUILD) $6559a407498e0d6c$export$2a2b1d2252a69ecb.forEach(function(name) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        logger[name] = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (enabled) $6559a407498e0d6c$export$cda52e2a8927a2ca(function() {
                var _a;
                (_a = $6559a407498e0d6c$var$global.console)[name].apply(_a, (0, $dnskZ.__spread)([
                    $6559a407498e0d6c$var$PREFIX + "[" + name + "]:"
                ], args));
            });
        };
    });
    else $6559a407498e0d6c$export$2a2b1d2252a69ecb.forEach(function(name) {
        logger[name] = function() {
            return undefined;
        };
    });
    return logger;
}
// Ensure we only have a single logger instance, even if multiple versions of @sentry/utils are being used
var $6559a407498e0d6c$export$af88d00dbe7f521;
if (0, $eps4K.IS_DEBUG_BUILD) $6559a407498e0d6c$export$af88d00dbe7f521 = (0, $dr7Gi.getGlobalSingleton)('logger', $6559a407498e0d6c$var$makeLogger);
else $6559a407498e0d6c$export$af88d00dbe7f521 = $6559a407498e0d6c$var$makeLogger();

});
parcelRegister("eps4K", function(module, exports) {
$parcel$export(module.exports, "IS_DEBUG_BUILD", () => $02b50d1fe2a2ce49$export$48a8984ec0bf2e44);
/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */ /** Flag that is true for debug builds, false otherwise. */ var $02b50d1fe2a2ce49$export$48a8984ec0bf2e44 = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;

});


parcelRegister("eiQXL", function(module, exports) {
$parcel$export(module.exports, "uuid4", () => $a69bd475722e6fe3$export$19f53698e68b2496);

var $dnskZ = parcelRequire("dnskZ");

var $dr7Gi = parcelRequire("dr7Gi");

var $2jc66 = parcelRequire("2jc66");

var $kwNcv = parcelRequire("kwNcv");
function $a69bd475722e6fe3$export$19f53698e68b2496() {
    var global = (0, $dr7Gi.getGlobalObject)();
    var crypto = global.crypto || global.msCrypto;
    if (!(crypto === void 0) && crypto.getRandomValues) {
        // Use window.crypto API if available
        var arr = new Uint16Array(8);
        crypto.getRandomValues(arr);
        // set 4 in byte 7
        // eslint-disable-next-line no-bitwise
        arr[3] = arr[3] & 0xfff | 0x4000;
        // set 2 most significant bits of byte 9 to '10'
        // eslint-disable-next-line no-bitwise
        arr[4] = arr[4] & 0x3fff | 0x8000;
        var pad = function(num) {
            var v = num.toString(16);
            while(v.length < 4)v = "0" + v;
            return v;
        };
        return pad(arr[0]) + pad(arr[1]) + pad(arr[2]) + pad(arr[3]) + pad(arr[4]) + pad(arr[5]) + pad(arr[6]) + pad(arr[7]);
    }
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        // eslint-disable-next-line no-bitwise
        var r = Math.random() * 16 | 0;
        // eslint-disable-next-line no-bitwise
        var v = c === 'x' ? r : r & 0x3 | 0x8;
        return v.toString(16);
    });
}
function $a69bd475722e6fe3$export$7a5253c0f62e0150(url) {
    if (!url) return {};
    var match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    // coerce to undefined values to empty string so we don't get 'undefined'
    var query = match[6] || '';
    var fragment = match[8] || '';
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        relative: match[5] + query + fragment
    };
}
function $a69bd475722e6fe3$var$getFirstException(event) {
    return event.exception && event.exception.values ? event.exception.values[0] : undefined;
}
function $a69bd475722e6fe3$export$4157119e2b157127(event) {
    var message = event.message, eventId = event.event_id;
    if (message) return message;
    var firstException = $a69bd475722e6fe3$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return firstException.type + ": " + firstException.value;
        return firstException.type || firstException.value || eventId || '<unknown>';
    }
    return eventId || '<unknown>';
}
function $a69bd475722e6fe3$export$f26508487bf83ee7(event, value, type) {
    var exception = event.exception = event.exception || {};
    var values = exception.values = exception.values || [];
    var firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || '';
    if (!firstException.type) firstException.type = type || 'Error';
}
function $a69bd475722e6fe3$export$c69a9a0313b03bb1(event, newMechanism) {
    var firstException = $a69bd475722e6fe3$var$getFirstException(event);
    if (!firstException) return;
    var defaultMechanism = {
        type: 'generic',
        handled: true
    };
    var currentMechanism = firstException.mechanism;
    firstException.mechanism = (0, $dnskZ.__assign)((0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, defaultMechanism), currentMechanism), newMechanism);
    if (newMechanism && 'data' in newMechanism) {
        var mergedData = (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, currentMechanism && currentMechanism.data), newMechanism.data);
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
var $a69bd475722e6fe3$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
function $a69bd475722e6fe3$export$d364f2020ab30578(input) {
    var match = input.match($a69bd475722e6fe3$var$SEMVER_REGEXP) || [];
    var major = parseInt(match[1], 10);
    var minor = parseInt(match[2], 10);
    var patch = parseInt(match[3], 10);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
function $a69bd475722e6fe3$export$ec2291bfc64632f0(lines, frame, linesOfContext) {
    if (linesOfContext === void 0) linesOfContext = 5;
    var lineno = frame.lineno || 0;
    var maxLines = lines.length;
    var sourceLine = Math.max(Math.min(maxLines, lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map(function(line) {
        return (0, $kwNcv.snipLine)(line, 0);
    });
    frame.context_line = (0, $kwNcv.snipLine)(lines[Math.min(maxLines - 1, sourceLine)], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map(function(line) {
        return (0, $kwNcv.snipLine)(line, 0);
    });
}
function $a69bd475722e6fe3$export$ce084c78234bd35(urlPath) {
    // eslint-disable-next-line no-useless-escape
    return urlPath.split(/[\?#]/, 1)[0];
}
function $a69bd475722e6fe3$export$6de4ffac6a2f1098(exception) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (exception && exception.__sentry_captured__) return true;
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0, $2jc66.addNonEnumerableProperty)(exception, '__sentry_captured__', true);
    } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}

});
parcelRegister("2jc66", function(module, exports) {
$parcel$export(module.exports, "addNonEnumerableProperty", () => $1ae6bd6610998de1$export$e73679ffaf56810e);
$parcel$export(module.exports, "dropUndefinedKeys", () => $1ae6bd6610998de1$export$d25f2688db1bb433);

var $dnskZ = parcelRequire("dnskZ");

var $8ticJ = parcelRequire("8ticJ");

var $8brdh = parcelRequire("8brdh");

var $kwNcv = parcelRequire("kwNcv");
function $1ae6bd6610998de1$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    var original = source[name];
    var wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === 'function') try {
        $1ae6bd6610998de1$export$5c1499e2e5d010ae(wrapped, original);
    } catch (_Oo) {
    // This can throw if multiple fill happens on a global object like XMLHttpRequest
    // Fixes https://github.com/getsentry/sentry-javascript/issues/2043
    }
    source[name] = wrapped;
}
function $1ae6bd6610998de1$export$e73679ffaf56810e(obj, name, value) {
    Object.defineProperty(obj, name, {
        // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
        value: value,
        writable: true,
        configurable: true
    });
}
function $1ae6bd6610998de1$export$5c1499e2e5d010ae(wrapped, original) {
    var proto = original.prototype || {};
    wrapped.prototype = original.prototype = proto;
    $1ae6bd6610998de1$export$e73679ffaf56810e(wrapped, '__sentry_original__', original);
}
function $1ae6bd6610998de1$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
function $1ae6bd6610998de1$export$9ef804feabbcbaf1(object) {
    return Object.keys(object).map(function(key) {
        return encodeURIComponent(key) + "=" + encodeURIComponent(object[key]);
    }).join('&');
}
function $1ae6bd6610998de1$export$62ff257738bf57f5(value) {
    var newObj = value;
    if ((0, $8brdh.isError)(value)) newObj = (0, $dnskZ.__assign)({
        message: value.message,
        name: value.name,
        stack: value.stack
    }, $1ae6bd6610998de1$var$getOwnProperties(value));
    else if ((0, $8brdh.isEvent)(value)) {
        var event_1 = value;
        newObj = (0, $dnskZ.__assign)({
            type: event_1.type,
            target: $1ae6bd6610998de1$var$serializeEventTarget(event_1.target),
            currentTarget: $1ae6bd6610998de1$var$serializeEventTarget(event_1.currentTarget)
        }, $1ae6bd6610998de1$var$getOwnProperties(event_1));
        if (typeof CustomEvent !== 'undefined' && (0, $8brdh.isInstanceOf)(value, CustomEvent)) newObj.detail = event_1.detail;
    }
    return newObj;
}
/** Creates a string representation of the target of an `Event` object */ function $1ae6bd6610998de1$var$serializeEventTarget(target) {
    try {
        return (0, $8brdh.isElement)(target) ? (0, $8ticJ.htmlTreeAsString)(target) : Object.prototype.toString.call(target);
    } catch (_oO) {
        return '<unknown>';
    }
}
/** Filters out all but an object's own properties */ function $1ae6bd6610998de1$var$getOwnProperties(obj) {
    var extractedProps = {};
    for(var property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
    return extractedProps;
}
function $1ae6bd6610998de1$export$b0244d5063c0b61b(exception, maxLength) {
    if (maxLength === void 0) maxLength = 40;
    var keys = Object.keys($1ae6bd6610998de1$export$62ff257738bf57f5(exception));
    keys.sort();
    if (!keys.length) return '[object has no keys]';
    if (keys[0].length >= maxLength) return (0, $kwNcv.truncate)(keys[0], maxLength);
    for(var includedKeys = keys.length; includedKeys > 0; includedKeys--){
        var serialized = keys.slice(0, includedKeys).join(', ');
        if (serialized.length > maxLength) continue;
        if (includedKeys === keys.length) return serialized;
        return (0, $kwNcv.truncate)(serialized, maxLength);
    }
    return '';
}
function $1ae6bd6610998de1$export$d25f2688db1bb433(val) {
    var e_1, _a;
    if ((0, $8brdh.isPlainObject)(val)) {
        var rv = {};
        try {
            for(var _b = (0, $dnskZ.__values)(Object.keys(val)), _c = _b.next(); !_c.done; _c = _b.next()){
                var key = _c.value;
                if (typeof val[key] !== 'undefined') rv[key] = $1ae6bd6610998de1$export$d25f2688db1bb433(val[key]);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return rv;
    }
    if (Array.isArray(val)) return val.map($1ae6bd6610998de1$export$d25f2688db1bb433);
    return val;
}
function $1ae6bd6610998de1$export$92b78acdbe066b6b(wat) {
    var objectified;
    switch(true){
        case wat === undefined || wat === null:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === 'symbol' || typeof wat === 'bigint':
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $8brdh.isPrimitive)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}

});
parcelRegister("8ticJ", function(module, exports) {
$parcel$export(module.exports, "htmlTreeAsString", () => $62af272ecc2f972d$export$5647df6b7814ac86);

var $dr7Gi = parcelRequire("dr7Gi");

var $8brdh = parcelRequire("8brdh");
function $62af272ecc2f972d$export$5647df6b7814ac86(elem, keyAttrs) {
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        var currentElem = elem;
        var MAX_TRAVERSE_HEIGHT = 5;
        var MAX_OUTPUT_LEN = 80;
        var out = [];
        var height = 0;
        var len = 0;
        var separator = ' > ';
        var sepLength = separator.length;
        var nextStr = void 0;
        // eslint-disable-next-line no-plusplus
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $62af272ecc2f972d$var$_htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds MAX_OUTPUT_LEN
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === 'html' || height > 1 && len + out.length * sepLength + nextStr.length >= MAX_OUTPUT_LEN) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (_oO) {
        return '<unknown>';
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $62af272ecc2f972d$var$_htmlElementAsString(el, keyAttrs) {
    var elem = el;
    var out = [];
    var className;
    var classes;
    var key;
    var attr;
    var i;
    if (!elem || !elem.tagName) return '';
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    var keyAttrPairs = keyAttrs && keyAttrs.length ? keyAttrs.filter(function(keyAttr) {
        return elem.getAttribute(keyAttr);
    }).map(function(keyAttr) {
        return [
            keyAttr,
            elem.getAttribute(keyAttr)
        ];
    }) : null;
    if (keyAttrPairs && keyAttrPairs.length) keyAttrPairs.forEach(function(keyAttrPair) {
        out.push("[" + keyAttrPair[0] + "=\"" + keyAttrPair[1] + "\"]");
    });
    else {
        if (elem.id) out.push("#" + elem.id);
        // eslint-disable-next-line prefer-const
        className = elem.className;
        if (className && (0, $8brdh.isString)(className)) {
            classes = className.split(/\s+/);
            for(i = 0; i < classes.length; i++)out.push("." + classes[i]);
        }
    }
    var allowedAttrs = [
        'type',
        'name',
        'title',
        'alt'
    ];
    for(i = 0; i < allowedAttrs.length; i++){
        key = allowedAttrs[i];
        attr = elem.getAttribute(key);
        if (attr) out.push("[" + key + "=\"" + attr + "\"]");
    }
    return out.join('');
}
function $62af272ecc2f972d$export$1cfafeee2987818b() {
    var global = (0, $dr7Gi.getGlobalObject)();
    try {
        return global.document.location.href;
    } catch (oO) {
        return '';
    }
}

});

parcelRegister("kwNcv", function(module, exports) {
$parcel$export(module.exports, "truncate", () => $ef1cf6048c9babbf$export$6a506b36fdea397d);
$parcel$export(module.exports, "snipLine", () => $ef1cf6048c9babbf$export$4215662d762d6f9d);

var $8brdh = parcelRequire("8brdh");
function $ef1cf6048c9babbf$export$6a506b36fdea397d(str, max) {
    if (max === void 0) max = 0;
    if (typeof str !== 'string' || max === 0) return str;
    return str.length <= max ? str : str.substr(0, max) + "...";
}
function $ef1cf6048c9babbf$export$4215662d762d6f9d(line, colno) {
    var newLine = line;
    var lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    var start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    var end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = "'{snip} " + newLine;
    if (end < lineLength) newLine += ' {snip}';
    return newLine;
}
function $ef1cf6048c9babbf$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return '';
    var output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(var i = 0; i < input.length; i++){
        var value = input[i];
        try {
            output.push(String(value));
        } catch (e) {
            output.push('[value cannot be serialized]');
        }
    }
    return output.join(delimiter);
}
function $ef1cf6048c9babbf$export$cdded5b28a5f8c6d(value, pattern) {
    if (!(0, $8brdh.isString)(value)) return false;
    if ((0, $8brdh.isRegExp)(pattern)) return pattern.test(value);
    if (typeof pattern === 'string') return value.indexOf(pattern) !== -1;
    return false;
}
function $ef1cf6048c9babbf$export$466fc863a824cea6(regexString) {
    // escape the hyphen separately so we can also replace it with a unicode literal hyphen, to avoid the problems
    // discussed in https://github.com/sindresorhus/escape-string-regexp/issues/20.
    return regexString.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&').replace(/-/g, '\\x2d');
}

});



parcelRegister("4TNFb", function(module, exports) {
$parcel$export(module.exports, "SyncPromise", () => $3912d290d37b4bbb$export$6f292d4960313241);
/* eslint-disable @typescript-eslint/explicit-function-return-type */ /* eslint-disable @typescript-eslint/typedef */ /* eslint-disable @typescript-eslint/explicit-module-boundary-types */ /* eslint-disable @typescript-eslint/no-explicit-any */ 
var $8brdh = parcelRequire("8brdh");
function $3912d290d37b4bbb$export$1fda8aa4d135f8aa(value) {
    return new $3912d290d37b4bbb$export$6f292d4960313241(function(resolve) {
        resolve(value);
    });
}
function $3912d290d37b4bbb$export$78e43115b553f358(reason) {
    return new $3912d290d37b4bbb$export$6f292d4960313241(function(_, reject) {
        reject(reason);
    });
}
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */ var $3912d290d37b4bbb$export$6f292d4960313241 = /** @class */ function() {
    function SyncPromise(executor) {
        var _this = this;
        this._state = 0 /* PENDING */ ;
        this._handlers = [];
        /** JSDoc */ this._resolve = function(value) {
            _this._setResult(1 /* RESOLVED */ , value);
        };
        /** JSDoc */ this._reject = function(reason) {
            _this._setResult(2 /* REJECTED */ , reason);
        };
        /** JSDoc */ this._setResult = function(state, value) {
            if (_this._state !== 0 /* PENDING */ ) return;
            if ((0, $8brdh.isThenable)(value)) {
                value.then(_this._resolve, _this._reject);
                return;
            }
            _this._state = state;
            _this._value = value;
            _this._executeHandlers();
        };
        /** JSDoc */ this._executeHandlers = function() {
            if (_this._state === 0 /* PENDING */ ) return;
            var cachedHandlers = _this._handlers.slice();
            _this._handlers = [];
            cachedHandlers.forEach(function(handler) {
                if (handler[0]) return;
                if (_this._state === 1 /* RESOLVED */ ) // eslint-disable-next-line @typescript-eslint/no-floating-promises
                handler[1](_this._value);
                if (_this._state === 2 /* REJECTED */ ) handler[2](_this._value);
                handler[0] = true;
            });
        };
        try {
            executor(this._resolve, this._reject);
        } catch (e) {
            this._reject(e);
        }
    }
    /** JSDoc */ SyncPromise.prototype.then = function(onfulfilled, onrejected) {
        var _this = this;
        return new SyncPromise(function(resolve, reject) {
            _this._handlers.push([
                false,
                function(result) {
                    if (!onfulfilled) // TODO: ¯\_(ツ)_/¯
                    // TODO: FIXME
                    resolve(result);
                    else try {
                        resolve(onfulfilled(result));
                    } catch (e) {
                        reject(e);
                    }
                },
                function(reason) {
                    if (!onrejected) reject(reason);
                    else try {
                        resolve(onrejected(reason));
                    } catch (e) {
                        reject(e);
                    }
                }
            ]);
            _this._executeHandlers();
        });
    };
    /** JSDoc */ SyncPromise.prototype.catch = function(onrejected) {
        return this.then(function(val) {
            return val;
        }, onrejected);
    };
    /** JSDoc */ SyncPromise.prototype.finally = function(onfinally) {
        var _this = this;
        return new SyncPromise(function(resolve, reject) {
            var val;
            var isRejected;
            return _this.then(function(value) {
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, function(reason) {
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(function() {
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    };
    return SyncPromise;
}();

});

parcelRegister("jwZVu", function(module, exports) {
$parcel$export(module.exports, "dateTimestampInSeconds", () => dateTimestampInSeconds, (v) => dateTimestampInSeconds = v);
$parcel$export(module.exports, "timestampInSeconds", () => timestampInSeconds, (v) => timestampInSeconds = v);

var $dr7Gi = parcelRequire("dr7Gi");

var $lBG93 = parcelRequire("lBG93");
/**
 * A TimestampSource implementation for environments that do not support the Performance Web API natively.
 *
 * Note that this TimestampSource does not use a monotonic clock. A call to `nowSeconds` may return a timestamp earlier
 * than a previously returned value. We do not try to emulate a monotonic behavior in order to facilitate debugging. It
 * is more obvious to explain "why does my span have negative duration" than "why my spans have zero duration".
 */ var dateTimestampSource = {
    nowSeconds: function() {
        return Date.now() / 1000;
    }
};
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function getBrowserPerformance() {
    var performance = (0, $dr7Gi.getGlobalObject)().performance;
    if (!performance || !performance.now) return undefined;
    // Replace performance.timeOrigin with our own timeOrigin based on Date.now().
    //
    // This is a partial workaround for browsers reporting performance.timeOrigin such that performance.timeOrigin +
    // performance.now() gives a date arbitrarily in the past.
    //
    // Additionally, computing timeOrigin in this way fills the gap for browsers where performance.timeOrigin is
    // undefined.
    //
    // The assumption that performance.timeOrigin + performance.now() ~= Date.now() is flawed, but we depend on it to
    // interact with data coming out of performance entries.
    //
    // Note that despite recommendations against it in the spec, browsers implement the Performance API with a clock that
    // might stop when the computer is asleep (and perhaps under other circumstances). Such behavior causes
    // performance.timeOrigin + performance.now() to have an arbitrary skew over Date.now(). In laptop computers, we have
    // observed skews that can be as long as days, weeks or months.
    //
    // See https://github.com/getsentry/sentry-javascript/issues/2590.
    //
    // BUG: despite our best intentions, this workaround has its limitations. It mostly addresses timings of pageload
    // transactions, but ignores the skew built up over time that can aversely affect timestamps of navigation
    // transactions of long-lived web pages.
    var timeOrigin = Date.now() - performance.now();
    return {
        now: function() {
            return performance.now();
        },
        timeOrigin: timeOrigin
    };
}
/**
 * Returns the native Performance API implementation from Node.js. Returns undefined in old Node.js versions that don't
 * implement the API.
 */ function getNodePerformance() {
    try {
        var perfHooks = (0, $lBG93.dynamicRequire)(module, 'perf_hooks');
        return perfHooks.performance;
    } catch (_) {
        return undefined;
    }
}
/**
 * The Performance API implementation for the current platform, if available.
 */ var platformPerformance = (0, $lBG93.isNodeEnv)() ? getNodePerformance() : getBrowserPerformance();
var timestampSource = platformPerformance === undefined ? dateTimestampSource : {
    nowSeconds: function() {
        return (platformPerformance.timeOrigin + platformPerformance.now()) / 1000;
    }
};
var dateTimestampInSeconds = dateTimestampSource.nowSeconds.bind(dateTimestampSource);
var timestampInSeconds = timestampSource.nowSeconds.bind(timestampSource);
var timestampWithMs = timestampInSeconds;
var usingPerformanceAPI = platformPerformance !== undefined;
var _browserPerformanceTimeOriginMode;
var browserPerformanceTimeOrigin = function() {
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    var performance = (0, $dr7Gi.getGlobalObject)().performance;
    if (!performance || !performance.now) {
        _browserPerformanceTimeOriginMode = 'none';
        return undefined;
    }
    var threshold = 3600000;
    var performanceNow = performance.now();
    var dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    var timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    var timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    var navigationStart = performance.timing && performance.timing.navigationStart;
    var hasNavigationStart = typeof navigationStart === 'number';
    // if navigationStart isn't available set delta to threshold so it isn't used
    var navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    var navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) {
            _browserPerformanceTimeOriginMode = 'timeOrigin';
            return performance.timeOrigin;
        } else {
            _browserPerformanceTimeOriginMode = 'navigationStart';
            return navigationStart;
        }
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    _browserPerformanceTimeOriginMode = 'dateNow';
    return dateNow;
}();

});


parcelRegister("dfeQ8", function(module, exports) {
$parcel$export(module.exports, "IS_DEBUG_BUILD", () => $9a482ff7e608b6d4$export$48a8984ec0bf2e44);
/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */ /** Flag that is true for debug builds, false otherwise. */ var $9a482ff7e608b6d4$export$48a8984ec0bf2e44 = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;

});

parcelRegister("e58Qh", function(module, exports) {
$parcel$export(module.exports, "Scope", () => $02a54bf05e37a025$export$775b6bb06e53a214);
$parcel$export(module.exports, "addGlobalEventProcessor", () => $02a54bf05e37a025$export$8e4e25f54d456511);

var $dnskZ = parcelRequire("dnskZ");
parcelRequire("7Nv7F");
var $jwZVu = parcelRequire("jwZVu");
var $dr7Gi = parcelRequire("dr7Gi");
var $8brdh = parcelRequire("8brdh");
var $4TNFb = parcelRequire("4TNFb");
/**
 * Absolute maximum number of breadcrumbs added to an event.
 * The `maxBreadcrumbs` option cannot be higher than this value.
 */ var $02a54bf05e37a025$var$MAX_BREADCRUMBS = 100;
/**
 * Holds additional event information. {@link Scope.applyToEvent} will be
 * called by the client before an event will be sent.
 */ var $02a54bf05e37a025$export$775b6bb06e53a214 = /** @class */ function() {
    function Scope() {
        /** Flag if notifying is happening. */ this._notifyingListeners = false;
        /** Callback for client to receive scope changes. */ this._scopeListeners = [];
        /** Callback list that will be called after {@link applyToEvent}. */ this._eventProcessors = [];
        /** Array of breadcrumbs. */ this._breadcrumbs = [];
        /** User */ this._user = {};
        /** Tags */ this._tags = {};
        /** Extra */ this._extra = {};
        /** Contexts */ this._contexts = {};
        /**
         * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
         * sent to Sentry
         */ this._sdkProcessingMetadata = {};
    }
    /**
     * Inherit values from the parent scope.
     * @param scope to clone.
     */ Scope.clone = function(scope) {
        var newScope = new Scope();
        if (scope) {
            newScope._breadcrumbs = (0, $dnskZ.__spread)(scope._breadcrumbs);
            newScope._tags = (0, $dnskZ.__assign)({}, scope._tags);
            newScope._extra = (0, $dnskZ.__assign)({}, scope._extra);
            newScope._contexts = (0, $dnskZ.__assign)({}, scope._contexts);
            newScope._user = scope._user;
            newScope._level = scope._level;
            newScope._span = scope._span;
            newScope._session = scope._session;
            newScope._transactionName = scope._transactionName;
            newScope._fingerprint = scope._fingerprint;
            newScope._eventProcessors = (0, $dnskZ.__spread)(scope._eventProcessors);
            newScope._requestSession = scope._requestSession;
        }
        return newScope;
    };
    /**
     * Add internal on change listener. Used for sub SDKs that need to store the scope.
     * @hidden
     */ Scope.prototype.addScopeListener = function(callback) {
        this._scopeListeners.push(callback);
    };
    /**
     * @inheritDoc
     */ Scope.prototype.addEventProcessor = function(callback) {
        this._eventProcessors.push(callback);
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setUser = function(user) {
        this._user = user || {};
        if (this._session) this._session.update({
            user: user
        });
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.getUser = function() {
        return this._user;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.getRequestSession = function() {
        return this._requestSession;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setRequestSession = function(requestSession) {
        this._requestSession = requestSession;
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setTags = function(tags) {
        this._tags = (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, this._tags), tags);
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setTag = function(key, value) {
        var _a;
        this._tags = (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, this._tags), (_a = {}, _a[key] = value, _a));
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setExtras = function(extras) {
        this._extra = (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, this._extra), extras);
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setExtra = function(key, extra) {
        var _a;
        this._extra = (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, this._extra), (_a = {}, _a[key] = extra, _a));
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setFingerprint = function(fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setLevel = function(level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setTransactionName = function(name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * Can be removed in major version.
     * @deprecated in favor of {@link this.setTransactionName}
     */ Scope.prototype.setTransaction = function(name) {
        return this.setTransactionName(name);
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setContext = function(key, context) {
        var _a;
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts = (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, this._contexts), (_a = {}, _a[key] = context, _a));
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setSpan = function(span) {
        this._span = span;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.getSpan = function() {
        return this._span;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.getTransaction = function() {
        // Often, this span (if it exists at all) will be a transaction, but it's not guaranteed to be. Regardless, it will
        // have a pointer to the currently-active transaction.
        var span = this.getSpan();
        return span && span.transaction;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setSession = function(session) {
        if (!session) delete this._session;
        else this._session = session;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.getSession = function() {
        return this._session;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.update = function(captureContext) {
        if (!captureContext) return this;
        if (typeof captureContext === 'function') {
            var updatedScope = captureContext(this);
            return updatedScope instanceof Scope ? updatedScope : this;
        }
        if (captureContext instanceof Scope) {
            this._tags = (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, this._tags), captureContext._tags);
            this._extra = (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, this._extra), captureContext._extra);
            this._contexts = (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, this._contexts), captureContext._contexts);
            if (captureContext._user && Object.keys(captureContext._user).length) this._user = captureContext._user;
            if (captureContext._level) this._level = captureContext._level;
            if (captureContext._fingerprint) this._fingerprint = captureContext._fingerprint;
            if (captureContext._requestSession) this._requestSession = captureContext._requestSession;
        } else if ((0, $8brdh.isPlainObject)(captureContext)) {
            // eslint-disable-next-line no-param-reassign
            captureContext;
            this._tags = (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, this._tags), captureContext.tags);
            this._extra = (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, this._extra), captureContext.extra);
            this._contexts = (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, this._contexts), captureContext.contexts);
            if (captureContext.user) this._user = captureContext.user;
            if (captureContext.level) this._level = captureContext.level;
            if (captureContext.fingerprint) this._fingerprint = captureContext.fingerprint;
            if (captureContext.requestSession) this._requestSession = captureContext.requestSession;
        }
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.clear = function() {
        this._breadcrumbs = [];
        this._tags = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = undefined;
        this._transactionName = undefined;
        this._fingerprint = undefined;
        this._requestSession = undefined;
        this._span = undefined;
        this._session = undefined;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.addBreadcrumb = function(breadcrumb, maxBreadcrumbs) {
        var maxCrumbs = typeof maxBreadcrumbs === 'number' ? Math.min(maxBreadcrumbs, $02a54bf05e37a025$var$MAX_BREADCRUMBS) : $02a54bf05e37a025$var$MAX_BREADCRUMBS;
        // No data has been changed, so don't notify scope listeners
        if (maxCrumbs <= 0) return this;
        var mergedBreadcrumb = (0, $dnskZ.__assign)({
            timestamp: (0, $jwZVu.dateTimestampInSeconds)()
        }, breadcrumb);
        this._breadcrumbs = (0, $dnskZ.__spread)(this._breadcrumbs, [
            mergedBreadcrumb
        ]).slice(-maxCrumbs);
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.clearBreadcrumbs = function() {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    };
    /**
     * Applies the current context and fingerprint to the event.
     * Note that breadcrumbs will be added by the client.
     * Also if the event has already breadcrumbs on it, we do not merge them.
     * @param event Event
     * @param hint May contain additional information about the original exception.
     * @hidden
     */ Scope.prototype.applyToEvent = function(event, hint) {
        if (this._extra && Object.keys(this._extra).length) event.extra = (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, this._extra), event.extra);
        if (this._tags && Object.keys(this._tags).length) event.tags = (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, this._tags), event.tags);
        if (this._user && Object.keys(this._user).length) event.user = (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, this._user), event.user);
        if (this._contexts && Object.keys(this._contexts).length) event.contexts = (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, this._contexts), event.contexts);
        if (this._level) event.level = this._level;
        if (this._transactionName) event.transaction = this._transactionName;
        // We want to set the trace context for normal events only if there isn't already
        // a trace context on the event. There is a product feature in place where we link
        // errors with transaction and it relies on that.
        if (this._span) {
            event.contexts = (0, $dnskZ.__assign)({
                trace: this._span.getTraceContext()
            }, event.contexts);
            var transactionName = this._span.transaction && this._span.transaction.name;
            if (transactionName) event.tags = (0, $dnskZ.__assign)({
                transaction: transactionName
            }, event.tags);
        }
        this._applyFingerprint(event);
        event.breadcrumbs = (0, $dnskZ.__spread)(event.breadcrumbs || [], this._breadcrumbs);
        event.breadcrumbs = event.breadcrumbs.length > 0 ? event.breadcrumbs : undefined;
        event.sdkProcessingMetadata = this._sdkProcessingMetadata;
        return this._notifyEventProcessors((0, $dnskZ.__spread)($02a54bf05e37a025$var$getGlobalEventProcessors(), this._eventProcessors), event, hint);
    };
    /**
     * Add data which will be accessible during event processing but won't get sent to Sentry
     */ Scope.prototype.setSDKProcessingMetadata = function(newData) {
        this._sdkProcessingMetadata = (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, this._sdkProcessingMetadata), newData);
        return this;
    };
    /**
     * This will be called after {@link applyToEvent} is finished.
     */ Scope.prototype._notifyEventProcessors = function(processors, event, hint, index) {
        var _this = this;
        if (index === void 0) index = 0;
        return new (0, $4TNFb.SyncPromise)(function(resolve, reject) {
            var processor = processors[index];
            if (event === null || typeof processor !== 'function') resolve(event);
            else {
                var result = processor((0, $dnskZ.__assign)({}, event), hint);
                if ((0, $8brdh.isThenable)(result)) result.then(function(final) {
                    return _this._notifyEventProcessors(processors, final, hint, index + 1).then(resolve);
                }).then(null, reject);
                else _this._notifyEventProcessors(processors, result, hint, index + 1).then(resolve).then(null, reject);
            }
        });
    };
    /**
     * This will be called on every set call.
     */ Scope.prototype._notifyScopeListeners = function() {
        var _this = this;
        // We need this check for this._notifyingListeners to be able to work on scope during updates
        // If this check is not here we'll produce endless recursion when something is done with the scope
        // during the callback.
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach(function(callback) {
                callback(_this);
            });
            this._notifyingListeners = false;
        }
    };
    /**
     * Applies fingerprint from the scope to the event if there's one,
     * uses message if there's one instead or get rid of empty fingerprint
     */ Scope.prototype._applyFingerprint = function(event) {
        // Make sure it's an array first and we actually have something in place
        event.fingerprint = event.fingerprint ? Array.isArray(event.fingerprint) ? event.fingerprint : [
            event.fingerprint
        ] : [];
        // If we have something on the scope, then merge it with event
        if (this._fingerprint) event.fingerprint = event.fingerprint.concat(this._fingerprint);
        // If we have no data at all, remove empty array default
        if (event.fingerprint && !event.fingerprint.length) delete event.fingerprint;
    };
    return Scope;
}();
/**
 * Returns the global event processors.
 */ function $02a54bf05e37a025$var$getGlobalEventProcessors() {
    return (0, $dr7Gi.getGlobalSingleton)('globalEventProcessors', function() {
        return [];
    });
}
function $02a54bf05e37a025$export$8e4e25f54d456511(callback) {
    $02a54bf05e37a025$var$getGlobalEventProcessors().push(callback);
}

});

parcelRegister("cido5", function(module, exports) {
$parcel$export(module.exports, "Session", () => $8f318cf6999630c4$export$1fb4852a55678982);
parcelRequire("7Nv7F");
var $2jc66 = parcelRequire("2jc66");
var $jwZVu = parcelRequire("jwZVu");
var $eiQXL = parcelRequire("eiQXL");
/**
 * @inheritdoc
 */ var $8f318cf6999630c4$export$1fb4852a55678982 = /** @class */ function() {
    function Session(context) {
        this.errors = 0;
        this.sid = (0, $eiQXL.uuid4)();
        this.duration = 0;
        this.status = 'ok';
        this.init = true;
        this.ignoreDuration = false;
        // Both timestamp and started are in seconds since the UNIX epoch.
        var startingTime = (0, $jwZVu.timestampInSeconds)();
        this.timestamp = startingTime;
        this.started = startingTime;
        if (context) this.update(context);
    }
    /** JSDoc */ // eslint-disable-next-line complexity
    Session.prototype.update = function(context) {
        if (context === void 0) context = {};
        if (context.user) {
            if (!this.ipAddress && context.user.ip_address) this.ipAddress = context.user.ip_address;
            if (!this.did && !context.did) this.did = context.user.id || context.user.email || context.user.username;
        }
        this.timestamp = context.timestamp || (0, $jwZVu.timestampInSeconds)();
        if (context.ignoreDuration) this.ignoreDuration = context.ignoreDuration;
        if (context.sid) // Good enough uuid validation. — Kamil
        this.sid = context.sid.length === 32 ? context.sid : (0, $eiQXL.uuid4)();
        if (context.init !== undefined) this.init = context.init;
        if (!this.did && context.did) this.did = "" + context.did;
        if (typeof context.started === 'number') this.started = context.started;
        if (this.ignoreDuration) this.duration = undefined;
        else if (typeof context.duration === 'number') this.duration = context.duration;
        else {
            var duration = this.timestamp - this.started;
            this.duration = duration >= 0 ? duration : 0;
        }
        if (context.release) this.release = context.release;
        if (context.environment) this.environment = context.environment;
        if (!this.ipAddress && context.ipAddress) this.ipAddress = context.ipAddress;
        if (!this.userAgent && context.userAgent) this.userAgent = context.userAgent;
        if (typeof context.errors === 'number') this.errors = context.errors;
        if (context.status) this.status = context.status;
    };
    /** JSDoc */ Session.prototype.close = function(status) {
        if (status) this.update({
            status: status
        });
        else if (this.status === 'ok') this.update({
            status: 'exited'
        });
        else this.update();
    };
    /** JSDoc */ Session.prototype.toJSON = function() {
        return (0, $2jc66.dropUndefinedKeys)({
            sid: "" + this.sid,
            init: this.init,
            // Make sure that sec is converted to ms for date constructor
            started: new Date(this.started * 1000).toISOString(),
            timestamp: new Date(this.timestamp * 1000).toISOString(),
            status: this.status,
            errors: this.errors,
            did: typeof this.did === 'number' || typeof this.did === 'string' ? "" + this.did : undefined,
            duration: this.duration,
            attrs: {
                release: this.release,
                environment: this.environment,
                ip_address: this.ipAddress,
                user_agent: this.userAgent
            }
        });
    };
    return Session;
}();

});



parcelRegister("kfvK2", function(module, exports) {
$parcel$export(module.exports, "getRouterState", () => $64677f5188050f02$export$ebf37f7e180b13a9);
$parcel$export(module.exports, "RouterStore", () => $64677f5188050f02$export$1cf0ecab63b1963c);
$parcel$export(module.exports, "RouterContainer", () => $64677f5188050f02$export$d6b817abe7a77ea5);
$parcel$export(module.exports, "useRouterStore", () => $64677f5188050f02$export$9569010eab09ae9e);
$parcel$export(module.exports, "useRouterStoreActions", () => $64677f5188050f02$export$ada49399abf7a3a1);
$parcel$export(module.exports, "createRouterSelector", () => $64677f5188050f02$export$95ab46bba7ea7a22);
$parcel$export(module.exports, "useIsActiveRoute", () => $64677f5188050f02$export$4273485d5c0831e0);
$parcel$export(module.exports, "addRouteListener", () => $64677f5188050f02$export$6ec8251cd652e31a);

var $fdDkm = parcelRequire("fdDkm");

var $gRw8I = parcelRequire("gRw8I");

var $eSnSE = parcelRequire("eSnSE");

var $7oY9g = parcelRequire("7oY9g");

var $21QSd = parcelRequire("21QSd");
var $iJq0l = parcelRequire("iJq0l");
var $6E16M = parcelRequire("6E16M");
var $GtRbT = parcelRequire("GtRbT");
var $14kUX = parcelRequire("14kUX");

var $lzBvk = parcelRequire("lzBvk");

var $GNVfd = parcelRequire("GNVfd");

var $02kpm = parcelRequire("02kpm");

var $5ZRFW = parcelRequire("5ZRFW");

var $30bwc = parcelRequire("30bwc");

var $eA736 = parcelRequire("eA736");

var $2IUk2 = parcelRequire("2IUk2");
const $64677f5188050f02$export$36d128238e6b60f5 = {
    action: (0, $lzBvk.DEFAULT_ACTION),
    basePath: '',
    location: (0, $lzBvk.DEFAULT_HISTORY).location,
    history: (0, $lzBvk.DEFAULT_HISTORY),
    match: (0, $lzBvk.DEFAULT_MATCH),
    onPrefetch: undefined,
    query: {},
    route: (0, $lzBvk.DEFAULT_ROUTE),
    routes: [],
    unlisten: null,
    plugins: [],
    isLazyRoutes: false,
    hasPerformedLazyTransition: false
};
const $64677f5188050f02$var$actions = {
    /**
	 * Bootstraps the store with initial data.
	 *
	 */ bootstrapStore: (props)=>({ setState: setState, dispatch: dispatch })=>{
            const { basePath: basePath = '', history: history, initialRoute: initialRoute, onPrefetch: onPrefetch, routes: routes, plugins: plugins, isLazyRoutes: isLazyRoutes } = props;
            const routerContext = (0, $eA736.findRouterContext)(initialRoute ? [
                initialRoute
            ] : routes, {
                location: history.location,
                basePath: basePath
            });
            setState({
                ...routerContext,
                basePath: basePath,
                history: history,
                onPrefetch: onPrefetch,
                routes: routes,
                location: history.location,
                action: history.action,
                plugins: plugins,
                isLazyRoutes: isLazyRoutes,
                hasPerformedLazyTransition: false
            });
            if (!(0, $5ZRFW.isServerEnvironment)()) dispatch($64677f5188050f02$var$actions.listen());
        },
    /**
	 * Starts listening to browser history and sets the unlisten function in state.
	 * Will request route resources on route change.
	 *
	 */ listen: ()=>({ getState: getState, setState: setState })=>{
            const { history: history, unlisten: unlisten } = getState();
            if (unlisten) unlisten();
            const stopListening = history.listen((...update)=>{
                const location = update.length === 2 ? update[0] : update[0].location;
                const action = update.length === 2 ? update[1] : update[0].action;
                const { plugins: plugins, routes: routes, basePath: basePath, match: currentMatch, route: currentRoute, query: currentQuery, isLazyRoutes: isLazyRoutes, hasPerformedLazyTransition: hasPerformedLazyTransition } = getState();
                const nextContext = (0, $eA736.findRouterContext)(routes, {
                    location: location,
                    basePath: basePath
                });
                const prevContext = {
                    route: currentRoute,
                    match: currentMatch,
                    query: currentQuery
                };
                const shouldReloadByPlugin = new Map(plugins.map((plugin)=>[
                        plugin.id,
                        (0, $2IUk2.shouldReload)({
                            context: nextContext,
                            prevContext: prevContext,
                            pluginId: plugin.id
                        })
                    ]));
                const updateState = ()=>{
                    plugins.forEach((p)=>{
                        if (shouldReloadByPlugin.get(p.id)) p.beforeRouteLoad?.({
                            context: prevContext,
                            nextContext: nextContext
                        });
                    });
                    // If:
                    // * we are in the "lazy routes experiment",
                    // * we haven't killswitched this logger
                    // * and it's the first transition since loading the route list
                    // - log it as a "successful transition"
                    // This will let us work out a proper(-ish) success metric. Killswitch is just in case the
                    // log volume proves excessive
                    let nextHasPerformedLazyTransition = hasPerformedLazyTransition;
                    if (isLazyRoutes && !hasPerformedLazyTransition) {
                        if (!(0, $7oY9g.default)('lazyroute_success_logger')) // Since we're doing a transition, we don't need to await as this _should_ complete
                        // (and we don't want to block)
                        (0, $eSnSE.default).safeInfoWithoutCustomerData('lazy_routes.transition', 'success', {
                            route: nextContext.route.name
                        });
                        nextHasPerformedLazyTransition = true;
                    }
                    setState({
                        ...nextContext,
                        location: location,
                        action: action,
                        hasPerformedLazyTransition: nextHasPerformedLazyTransition
                    });
                    plugins.forEach((p)=>{
                        if (shouldReloadByPlugin.get(p.id)) p.routeLoad?.({
                            context: nextContext,
                            prevContext: prevContext
                        });
                    });
                };
                updateState();
            });
            setState({
                unlisten: stopListening
            });
        },
    push: (path, state)=>({ getState: getState })=>{
            (0, $gRw8I.di)(window);
            const { history: history, basePath: basePath } = getState();
            if ((0, $2IUk2.isExternalAbsolutePath)(path)) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.location.assign(path);
            else history.push((0, $2IUk2.getRelativePath)(path, basePath), state);
        },
    pushTo: (route, attributes = {})=>({ getState: getState })=>{
            const { history: history, basePath: basePath } = getState();
            const location = (0, $GNVfd.generateLocationFromPath)(route.path, {
                ...attributes,
                basePath: basePath
            });
            (0, $30bwc.warmupMatchRouteCache)(route, location.pathname, attributes.query, basePath);
            history.push(location, attributes?.state);
        },
    replace: (path, state)=>({ getState: getState })=>{
            (0, $gRw8I.di)(window);
            const { history: history, basePath: basePath } = getState();
            if ((0, $2IUk2.isExternalAbsolutePath)(path)) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.location.replace(path);
            else history.replace((0, $2IUk2.getRelativePath)(path, basePath), state);
        },
    replaceTo: (route, attributes = {})=>({ getState: getState })=>{
            const { history: history, basePath: basePath } = getState();
            const location = (0, $GNVfd.generateLocationFromPath)(route.path, {
                ...attributes,
                basePath: basePath
            });
            (0, $30bwc.warmupMatchRouteCache)(route, location.pathname, attributes.query, basePath);
            history.replace(location, attributes?.state);
        },
    goBack: ()=>({ getState: getState })=>{
            const { history: history } = getState();
            // history@4 uses goBack(), history@5 uses back()
            if ('goBack' in history) history.goBack();
            else throw new Error('History does not support goBack');
        },
    goForward: ()=>({ getState: getState })=>{
            const { history: history } = getState();
            // history@4 uses goForward(), history@5 uses forward()
            if ('goForward' in history) history.goForward();
            else throw new Error('History does not support goForward');
        },
    registerBlock: (blocker)=>({ getState: getState })=>{
            const { history: history } = getState();
            return history.block(blocker);
        },
    getContext: ()=>({ getState: getState })=>{
            const { query: query, route: route, match: match } = getState();
            return {
                query: query,
                route: route,
                match: match
            };
        },
    getBasePath: ()=>({ getState: getState })=>{
            const { basePath: basePath } = getState();
            return basePath;
        },
    updateQueryParam: (params, updateType = 'push')=>({ getState: getState })=>{
            const { query: existingQueryParams, history: history, location: location } = getState();
            const updatedQueryParams = {
                ...existingQueryParams,
                ...params
            };
            // remove undefined keys
            Object.keys(updatedQueryParams).forEach((key)=>updatedQueryParams[key] === undefined && delete updatedQueryParams[key]);
            const existingPath = (0, $2IUk2.updateQueryParams)(location, existingQueryParams);
            const updatedPath = (0, $2IUk2.updateQueryParams)(location, updatedQueryParams);
            if (updatedPath !== existingPath) history[updateType](updatedPath);
        },
    updatePathParam: (params, updateType = 'push')=>({ getState: getState })=>{
            const { history: history, location: location, route: { path: path }, match: { params: existingPathParams }, basePath: basePath } = getState();
            const pathWithBasePath = basePath + path;
            const updatedPathParams = {
                ...existingPathParams,
                ...params
            };
            const updatedPath = (0, $02kpm.generatePath)(pathWithBasePath, updatedPathParams);
            const updatedLocation = {
                ...location,
                pathname: updatedPath
            };
            const existingRelativePath = (0, $2IUk2.getRelativeURLFromLocation)(location);
            const updatedRelativePath = (0, $2IUk2.getRelativeURLFromLocation)(updatedLocation);
            if (updatedRelativePath !== existingRelativePath) history[updateType](updatedRelativePath);
        },
    loadPlugins: ()=>({ getState: getState })=>{
            const { plugins: plugins, match: match, query: query, route: route } = getState();
            plugins.forEach((p)=>p.routeLoad?.({
                    context: {
                        match: match,
                        query: query,
                        route: route
                    }
                }));
        },
    prefetchRoute: (path, nextContext)=>({ getState: getState })=>{
            const { plugins: plugins, routes: routes, basePath: basePath, onPrefetch: onPrefetch } = getState();
            const { route: route, match: match, query: query } = $64677f5188050f02$export$ebf37f7e180b13a9();
            if (!nextContext && !(0, $2IUk2.isExternalAbsolutePath)(path)) {
                const location = (0, $fdDkm.parsePath)((0, $2IUk2.getRelativePath)(path, basePath));
                // eslint-disable-next-line no-param-reassign
                nextContext = (0, $eA736.findRouterContext)(routes, {
                    location: location,
                    basePath: basePath
                });
            }
            if (nextContext == null) return;
            const nextLocationContext = nextContext;
            (0, $21QSd.batch)(()=>{
                plugins.forEach((p)=>p.routePrefetch?.({
                        context: {
                            route: route,
                            match: match,
                            query: query
                        },
                        nextContext: nextLocationContext
                    }));
                if (onPrefetch) onPrefetch(nextLocationContext);
            });
        },
    setRoutes: (routes)=>({ getState: getState, setState: setState })=>{
            const { routes: currentRoutes, history: history } = getState();
            const currentRoutesByName = Object.fromEntries(currentRoutes.map((r)=>[
                    r.name,
                    r
                ]));
            // To ensure that history is preserved, we need to find any current routes
            // in the new route map, and ensure that object identity for that route
            // is preserved in the new route map
            for(let i = 0; i < routes.length; i++){
                const route = routes[i];
                if (Object.hasOwn(currentRoutesByName, route.name)) // eslint-disable-next-line no-param-reassign
                routes[i] = currentRoutesByName[route.name];
            }
            // Refresh info in history for transition blocking
            history.refreshRoutes && history.refreshRoutes(routes);
            setState({
                routes: routes
            });
        }
};
const $64677f5188050f02$export$1cf0ecab63b1963c = (0, $GtRbT.createStore)({
    initialState: $64677f5188050f02$export$36d128238e6b60f5,
    actions: $64677f5188050f02$var$actions,
    name: 'router'
});
const $64677f5188050f02$export$d6b817abe7a77ea5 = (0, $6E16M.createContainer)($64677f5188050f02$export$1cf0ecab63b1963c, {
    displayName: 'RouterContainer',
    onInit: ()=>({ dispatch: dispatch }, props)=>{
            dispatch($64677f5188050f02$var$actions.bootstrapStore(props));
            !(0, $5ZRFW.isServerEnvironment)() && dispatch($64677f5188050f02$var$actions.loadPlugins());
        },
    onCleanup: ()=>(state)=>{
            if (!(0, $5ZRFW.isServerEnvironment)()) {
                const { unlisten: unlisten } = state.getState();
                unlisten && unlisten();
            }
        }
});
const $64677f5188050f02$export$9569010eab09ae9e = (0, $iJq0l.createHook)($64677f5188050f02$export$1cf0ecab63b1963c);
const $64677f5188050f02$export$ada49399abf7a3a1 = (0, $iJq0l.createActionsHook)($64677f5188050f02$export$1cf0ecab63b1963c);
function $64677f5188050f02$export$95ab46bba7ea7a22(selector) {
    const useHook = (0, $iJq0l.createHook)($64677f5188050f02$export$1cf0ecab63b1963c, {
        selector: selector
    });
    return function useRouterSelector(...args) {
        // @ts-expect-error TS2345
        return useHook(...args)[0];
    };
}
const $64677f5188050f02$export$5ccad187366c8494 = ()=>// @ts-ignore calling `getStore` without providing a scopeId
    (0, $14kUX.defaultRegistry).getStore($64677f5188050f02$export$1cf0ecab63b1963c);
const $64677f5188050f02$export$ebf37f7e180b13a9 = ()=>$64677f5188050f02$export$5ccad187366c8494().storeState.getState();
const $64677f5188050f02$export$4273485d5c0831e0 = (routeOrRoutes)=>{
    const selector = $64677f5188050f02$export$95ab46bba7ea7a22(({ route: currentRoute })=>{
        if (typeof routeOrRoutes === 'string') return currentRoute.name === routeOrRoutes;
        return routeOrRoutes.has(currentRoute.name);
    });
    return selector();
};
const $64677f5188050f02$export$6ec8251cd652e31a = (listener)=>{
    const store = $64677f5188050f02$export$5ccad187366c8494();
    const unsubscriber = store.storeState.subscribe(listener);
    return ()=>unsubscriber();
};

});
parcelRegister("lzBvk", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_MATCH", () => $4058fca14b76dd16$export$2de13e891a662beb);
$parcel$export(module.exports, "DEFAULT_ROUTE", () => $4058fca14b76dd16$export$4eadc79233226325);
$parcel$export(module.exports, "DEFAULT_HISTORY", () => $4058fca14b76dd16$export$39607c9878cf5148);
$parcel$export(module.exports, "DEFAULT_ACTION", () => $4058fca14b76dd16$export$fa440ddf675c8a93);

var $e43Ye = parcelRequire("e43Ye");
const $4058fca14b76dd16$export$2de13e891a662beb = {
    params: {},
    isExact: false,
    path: '',
    url: '',
    query: {}
};
const $4058fca14b76dd16$export$4eadc79233226325 = {
    path: '',
    component: ()=>null,
    name: ''
};
const $4058fca14b76dd16$export$39607c9878cf5148 = (0, $e43Ye.createLegacyHistory)();
const $4058fca14b76dd16$export$fa440ddf675c8a93 = 'POP';

});
parcelRegister("e43Ye", function(module, exports) {
$parcel$export(module.exports, "createLegacyHistory", () => $45959acc9c343cf3$export$883c3f3b6c000133);

var $3s8bj = parcelRequire("3s8bj");

var $12DRg = parcelRequire("12DRg");

var $fdDkm = parcelRequire("fdDkm");

var $gRw8I = parcelRequire("gRw8I");
const $45959acc9c343cf3$var$hasWindow = ()=>typeof window !== 'undefined';
const $45959acc9c343cf3$var$methodsPlaceholders = {
    push: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
    replace: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
    goBack: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
    goForward: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
    listen: ()=>(0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
    block: ()=>(0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
    refreshRoutes: ()=>(0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
};
const $45959acc9c343cf3$var$getLocation = ()=>{
    (0, $gRw8I.di)(window);
    // todo - don't force non-optional search and hash
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const { pathname: pathname = '', search: search = '', hash: hash = '' } = $45959acc9c343cf3$var$hasWindow() && window.location || {};
    return {
        pathname: pathname,
        search: search,
        hash: hash
    };
};
const $45959acc9c343cf3$var$createLegacyListener = (updateExposedLocation)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const node = document.querySelector('#content');
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    let prevHref = window.location.href;
    let listeners = [];
    const historyStack = [
        prevHref
    ];
    // note: window.history.length is capped at 50 entries
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    let prevHistoryLength = window.history.length;
    let historyIndex = 0;
    const getAction = ()=>{
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const currentHref = window.location.href;
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        if (prevHistoryLength === window.history.length) {
            if (historyStack[historyIndex - 1] === currentHref) {
                historyIndex -= 1;
                return 'POP';
            }
            if (historyStack[historyIndex + 1] === currentHref) {
                historyIndex += 1;
                return 'POP';
            }
            historyStack[historyStack.length - 1] = currentHref;
            return 'REPLACE';
        }
        historyStack.push(currentHref);
        historyIndex += 1;
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        prevHistoryLength = window.history.length;
        return 'PUSH';
    };
    const onNodeChanges = (0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))(()=>{
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        if (prevHref !== window.location.href) {
            const newLocation = $45959acc9c343cf3$var$getLocation();
            const action = getAction();
            updateExposedLocation(newLocation, action);
            listeners.forEach((listener)=>listener(newLocation, action));
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            prevHref = window.location.href;
        }
    }, 50);
    if (node) {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const observer = new window.MutationObserver(onNodeChanges);
        observer.observe(node, {
            childList: true,
            subtree: true,
            attributes: true,
            characterData: true
        });
    }
    return (listener)=>{
        listeners = listeners.concat(listener);
        return ()=>{
            listeners = listeners.filter((lst)=>lst !== listener);
        };
    };
};
const $45959acc9c343cf3$export$883c3f3b6c000133 = ()=>{
    (0, $gRw8I.di)(window);
    let currentLocation = $45959acc9c343cf3$var$getLocation();
    let currentAction = 'PUSH';
    const updateExposedLocation = (v, a)=>{
        currentLocation = v;
        currentAction = a;
    };
    return {
        get location () {
            return currentLocation;
        },
        get length () {
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            return $45959acc9c343cf3$var$hasWindow() ? window.history.length : 1; // default length is 1
        },
        get action () {
            return currentAction;
        },
        ...$45959acc9c343cf3$var$hasWindow() ? {
            push: (path)=>// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                window.location.assign(typeof path === 'string' ? path : (0, $fdDkm.createPath)(path || {})),
            replace: (path)=>// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                window.history.replaceState({}, // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                document.title, typeof path === 'string' ? path : (0, $fdDkm.createPath)(path || {})),
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            goBack: ()=>window.history.back(),
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            goForward: ()=>window.history.forward(),
            listen: $45959acc9c343cf3$var$createLegacyListener(updateExposedLocation),
            block: ()=>(0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
            createHref: (location)=>(0, $fdDkm.createPath)(location),
            refreshRoutes: ()=>(0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
        } : $45959acc9c343cf3$var$methodsPlaceholders
    };
};

});


parcelRegister("GNVfd", function(module, exports) {
$parcel$export(module.exports, "generateLocationFromPath", () => $1daf91f3b38f7f33$export$37e0729cc751960b);

var $3Q6BV = parcelRequire("3Q6BV");

var $3QHPX = parcelRequire("3QHPX");
function $1daf91f3b38f7f33$export$37e0729cc751960b(pattern = '/', options = {}) {
    const { params: params = {}, query: query = {}, basePath: basePath = '' } = options;
    // @ts-ignore stringify accepts two params but it's type doesn't say so
    const stringifiedQuery = (0, $3Q6BV.qs).stringify(query, true);
    const pathname = pattern === '/' ? pattern : (0, $3QHPX.compile)(pattern)(params);
    return {
        pathname: `${basePath}${pathname}`,
        search: stringifiedQuery,
        hash: ''
    };
}

});
parcelRegister("3QHPX", function(module, exports) {
$parcel$export(module.exports, "compile", () => $27ec7eec64616611$export$ef7acd7185315e22);
$parcel$export(module.exports, "pathToRegexp", () => $27ec7eec64616611$export$71304158c7e35877);
// Taken from https://github.com/pillarjs/path-to-regexp/blob/v6.2.1/src/index.ts
// To address version mismatch with root package.json
/**
 * Tokenizer results.
 */ /**
 * Tokenize input string.
 */ function $27ec7eec64616611$var$lexer(str) {
    const tokens = [];
    let i = 0;
    while(i < str.length){
        const char = str[i];
        if (char === '*' || char === '+' || char === '?') {
            tokens.push({
                type: 'MODIFIER',
                index: i,
                value: str[i++]
            });
            continue;
        }
        if (char === '\\') {
            tokens.push({
                type: 'ESCAPED_CHAR',
                index: i++,
                value: str[i++]
            });
            continue;
        }
        if (char === '{') {
            tokens.push({
                type: 'OPEN',
                index: i,
                value: str[i++]
            });
            continue;
        }
        if (char === '}') {
            tokens.push({
                type: 'CLOSE',
                index: i,
                value: str[i++]
            });
            continue;
        }
        if (char === ':') {
            let name = '';
            let j = i + 1;
            while(j < str.length){
                const code = str.charCodeAt(j);
                if (// `0-9`
                code >= 48 && code <= 57 || // `A-Z`
                code >= 65 && code <= 90 || // `a-z`
                code >= 97 && code <= 122 || // `_`
                code === 95) {
                    name += str[j++];
                    continue;
                }
                break;
            }
            if (!name) throw new TypeError(`Missing parameter name at ${i}`);
            tokens.push({
                type: 'NAME',
                index: i,
                value: name
            });
            i = j;
            continue;
        }
        if (char === '(') {
            let count = 1;
            let pattern = '';
            let j = i + 1;
            if (str[j] === '?') throw new TypeError(`Pattern cannot start with "?" at ${j}`);
            while(j < str.length){
                if (str[j] === '\\') {
                    pattern += str[j++] + str[j++];
                    continue;
                }
                if (str[j] === ')') {
                    count--;
                    if (count === 0) {
                        j++;
                        break;
                    }
                } else if (str[j] === '(') {
                    count++;
                    if (str[j + 1] !== '?') throw new TypeError(`Capturing groups are not allowed at ${j}`);
                }
                pattern += str[j++];
            }
            if (count) throw new TypeError(`Unbalanced pattern at ${i}`);
            if (!pattern) throw new TypeError(`Missing pattern at ${i}`);
            tokens.push({
                type: 'PATTERN',
                index: i,
                value: pattern
            });
            i = j;
            continue;
        }
        tokens.push({
            type: 'CHAR',
            index: i,
            value: str[i++]
        });
    }
    tokens.push({
        type: 'END',
        index: i,
        value: ''
    });
    return tokens;
}
function $27ec7eec64616611$export$98e6a39c04603d36(str, options = {}) {
    const tokens = $27ec7eec64616611$var$lexer(str);
    const { prefixes: prefixes = './' } = options;
    const defaultPattern = `[^${$27ec7eec64616611$var$escapeString(options.delimiter || '/#?')}]+?`;
    const result = [];
    let key = 0;
    let i = 0;
    let path = '';
    const tryConsume = (type)=>{
        if (i < tokens.length && tokens[i].type === type) return tokens[i++].value;
    };
    const mustConsume = (type)=>{
        const value = tryConsume(type);
        if (value !== undefined) return value;
        const { type: nextType, index: index } = tokens[i];
        throw new TypeError(`Unexpected ${nextType} at ${index}, expected ${type}`);
    };
    const consumeText = ()=>{
        // eslint-disable-next-line @typescript-eslint/no-shadow -- ERROR TO BE FIXED
        let result = '';
        let value;
        // eslint-disable-next-line no-cond-assign -- ERROR TO BE FIXED
        while(value = tryConsume('CHAR') || tryConsume('ESCAPED_CHAR'))result += value;
        return result;
    };
    while(i < tokens.length){
        const char = tryConsume('CHAR');
        const name = tryConsume('NAME');
        const pattern = tryConsume('PATTERN');
        if (name || pattern) {
            let prefix = char || '';
            if (prefixes.indexOf(prefix) === -1) {
                path += prefix;
                prefix = '';
            }
            if (path) {
                result.push(path);
                path = '';
            }
            result.push({
                name: name || key++,
                prefix: prefix,
                suffix: '',
                pattern: pattern || defaultPattern,
                modifier: tryConsume('MODIFIER') || ''
            });
            continue;
        }
        const value = char || tryConsume('ESCAPED_CHAR');
        if (value) {
            path += value;
            continue;
        }
        if (path) {
            result.push(path);
            path = '';
        }
        const open = tryConsume('OPEN');
        if (open) {
            const prefix = consumeText();
            // eslint-disable-next-line @typescript-eslint/no-shadow -- ERROR TO BE FIXED
            const name = tryConsume('NAME') || '';
            // eslint-disable-next-line @typescript-eslint/no-shadow -- ERROR TO BE FIXED
            const pattern = tryConsume('PATTERN') || '';
            const suffix = consumeText();
            mustConsume('CLOSE');
            result.push({
                name: name || (pattern ? key++ : ''),
                pattern: name && !pattern ? defaultPattern : pattern,
                prefix: prefix,
                suffix: suffix,
                modifier: tryConsume('MODIFIER') || ''
            });
            continue;
        }
        mustConsume('END');
    }
    return result;
}
function $27ec7eec64616611$export$ef7acd7185315e22(str, options) {
    return $27ec7eec64616611$export$5b9bad9e403cf3d9($27ec7eec64616611$export$98e6a39c04603d36(str, options), options);
}
function $27ec7eec64616611$export$5b9bad9e403cf3d9(tokens, options = {}) {
    const reFlags = $27ec7eec64616611$var$flags(options);
    const { encode: encode = (x)=>x, validate: validate = true } = options;
    // Compile all the tokens into regexps.
    // eslint-disable-next-line array-callback-return -- ERROR TO BE FIXED
    const matches = tokens.map((token)=>{
        if (typeof token === 'object') return new RegExp(`^(?:${token.pattern})$`, reFlags);
    });
    return (data)=>{
        let path = '';
        for(let i = 0; i < tokens.length; i++){
            const token = tokens[i];
            if (typeof token === 'string') {
                path += token;
                continue;
            }
            const value = data ? data[token.name] : undefined;
            const optional = token.modifier === '?' || token.modifier === '*';
            const repeat = token.modifier === '*' || token.modifier === '+';
            if (Array.isArray(value)) {
                if (!repeat) throw new TypeError(`Expected "${token.name}" to not repeat, but got an array`);
                if (value.length === 0) {
                    // eslint-disable-next-line no-continue -- ERROR TO BE FIXED
                    if (optional) continue;
                    throw new TypeError(`Expected "${token.name}" to not be empty`);
                }
                for(let j = 0; j < value.length; j++){
                    const segment = encode(value[j], token);
                    if (validate && !matches[i].test(segment)) throw new TypeError(`Expected all "${token.name}" to match "${token.pattern}", but got "${segment}"`);
                    path += token.prefix + segment + token.suffix;
                }
                continue;
            }
            if (typeof value === 'string' || typeof value === 'number') {
                const segment = encode(String(value), token);
                if (validate && !matches[i].test(segment)) throw new TypeError(`Expected "${token.name}" to match "${token.pattern}", but got "${segment}"`);
                path += token.prefix + segment + token.suffix;
                continue;
            }
            // eslint-disable-next-line no-continue -- ERROR TO BE FIXED
            if (optional) continue;
            const typeOfMessage = repeat ? 'an array' : 'a string';
            throw new TypeError(`Expected "${token.name}" to be ${typeOfMessage}`);
        }
        return path;
    };
}
function $27ec7eec64616611$export$4659b591c19bdf3d(str, options) {
    const keys = [];
    const re = $27ec7eec64616611$export$71304158c7e35877(str, keys, options);
    return $27ec7eec64616611$export$968e97c88708237a(re, keys, options);
}
function $27ec7eec64616611$export$968e97c88708237a(re, keys, options = {}) {
    const { decode: decode = (x)=>x } = options;
    return function(pathname) {
        const m = re.exec(pathname);
        if (!m) return false;
        const { 0: path, index: index } = m;
        const params = Object.create(null);
        for(let i = 1; i < m.length; i++){
            // eslint-disable-next-line no-continue -- ERROR TO BE FIXED
            if (m[i] === undefined) continue;
            const key = keys[i - 1];
            if (key.modifier === '*' || key.modifier === '+') params[key.name] = m[i].split(key.prefix + key.suffix).map((value)=>decode(value, key));
            else params[key.name] = decode(m[i], key);
        }
        return {
            path: path,
            index: index,
            params: params
        };
    };
}
/**
 * Escape a regular expression string.
 */ function $27ec7eec64616611$var$escapeString(str) {
    return str.replace(/([.+*?=^!:${}()[\]|/\\])/g, '\\$1');
}
/**
 * Get the flags for a regexp from the options.
 */ function $27ec7eec64616611$var$flags(options) {
    return options && options.sensitive ? '' : 'i';
}
/**
 * Pull out keys from a regexp.
 */ function $27ec7eec64616611$var$regexpToRegexp(path, keys) {
    if (!keys) return path;
    const groupsRegex = /\((?:\?<(.*?)>)?(?!\?)/g;
    let index = 0;
    let execResult = groupsRegex.exec(path.source);
    while(execResult){
        keys.push({
            // Use parenthesized substring match if available, index otherwise
            name: execResult[1] || index++,
            prefix: '',
            suffix: '',
            modifier: '',
            pattern: ''
        });
        execResult = groupsRegex.exec(path.source);
    }
    return path;
}
/**
 * Transform an array into a regexp.
 */ function $27ec7eec64616611$var$arrayToRegexp(paths, keys, options) {
    const parts = paths.map((path)=>$27ec7eec64616611$export$71304158c7e35877(path, keys, options).source);
    return new RegExp(`(?:${parts.join('|')})`, $27ec7eec64616611$var$flags(options));
}
/**
 * Create a path regexp from string input.
 */ function $27ec7eec64616611$var$stringToRegexp(path, keys, options) {
    return $27ec7eec64616611$export$9a9303716def6456($27ec7eec64616611$export$98e6a39c04603d36(path, options), keys, options);
}
function $27ec7eec64616611$export$9a9303716def6456(tokens, keys, options = {}) {
    const { strict: strict = false, start: start = true, end: end = true, encode: encode = (x)=>x, delimiter: delimiter = '/#?', endsWith: endsWith = '' } = options;
    const endsWithRe = `[${$27ec7eec64616611$var$escapeString(endsWith)}]|$`;
    const delimiterRe = `[${$27ec7eec64616611$var$escapeString(delimiter)}]`;
    let route = start ? '^' : '';
    // Iterate over the tokens and create our regexp string.
    for (const token of tokens)if (typeof token === 'string') route += $27ec7eec64616611$var$escapeString(encode(token));
    else {
        const prefix = $27ec7eec64616611$var$escapeString(encode(token.prefix));
        const suffix = $27ec7eec64616611$var$escapeString(encode(token.suffix));
        if (token.pattern) {
            if (keys) keys.push(token);
            if (prefix || suffix) {
                if (token.modifier === '+' || token.modifier === '*') {
                    const mod = token.modifier === '*' ? '?' : '';
                    route += `(?:${prefix}((?:${token.pattern})(?:${suffix}${prefix}(?:${token.pattern}))*)${suffix})${mod}`;
                } else route += `(?:${prefix}(${token.pattern})${suffix})${token.modifier}`;
            } else if (token.modifier === '+' || token.modifier === '*') route += `((?:${token.pattern})${token.modifier})`;
            else route += `(${token.pattern})${token.modifier}`;
        } else route += `(?:${prefix}${suffix})${token.modifier}`;
    }
    if (end) {
        if (!strict) route += `${delimiterRe}?`;
        route += !options.endsWith ? '$' : `(?=${endsWithRe})`;
    } else {
        const endToken = tokens[tokens.length - 1];
        const isEndDelimited = typeof endToken === 'string' ? delimiterRe.indexOf(endToken[endToken.length - 1]) > -1 : endToken === undefined;
        if (!strict) route += `(?:${delimiterRe}(?=${endsWithRe}))?`;
        if (!isEndDelimited) route += `(?=${delimiterRe}|${endsWithRe})`;
    }
    return new RegExp(route, $27ec7eec64616611$var$flags(options));
}
function $27ec7eec64616611$export$71304158c7e35877(path, keys, options) {
    if (path instanceof RegExp) return $27ec7eec64616611$var$regexpToRegexp(path, keys);
    if (Array.isArray(path)) return $27ec7eec64616611$var$arrayToRegexp(path, keys, options);
    return $27ec7eec64616611$var$stringToRegexp(path, keys, options);
}

});


parcelRegister("02kpm", function(module, exports) {
$parcel$export(module.exports, "generatePath", () => $56b2dbfda175a6dd$export$82476f982757e71e);

var $3QHPX = parcelRequire("3QHPX");
const $56b2dbfda175a6dd$export$82476f982757e71e = (pattern = '/', params)=>pattern === '/' ? pattern : (0, $3QHPX.compile)(pattern)(params);

});

parcelRegister("5ZRFW", function(module, exports) {
$parcel$export(module.exports, "isServerEnvironment", () => $f14e1842c9e6065b$export$455cc18296abe008);
/**
 * @see https://github.com/jsdom/jsdom/releases/tag/12.0.0
 * @see https://github.com/jsdom/jsdom/issues/1537
 */ 
var $igDjg = parcelRequire("igDjg");
const $f14e1842c9e6065b$var$isJsDomEnvironment = ()=>// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.name === 'nodejs' || // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    navigator?.userAgent.includes('Node.js') || // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    navigator?.userAgent.includes('jsdom');
const $f14e1842c9e6065b$export$455cc18296abe008 = ()=>{
    if (typeof window === 'undefined' || typeof $igDjg !== 'undefined' && $igDjg.versions != null && $igDjg.versions.node != null) return true;
    if ($f14e1842c9e6065b$var$isJsDomEnvironment()) return true;
    return false;
};

});

parcelRegister("30bwc", function(module, exports) {
$parcel$export(module.exports, "warmupMatchRouteCache", () => $1dd2a25cc0751014$export$4e76f1d455ef7c95);
$parcel$export(module.exports, "default", () => $1dd2a25cc0751014$export$2e2bcd8739ae039);

var $2gqQL = parcelRequire("2gqQL");

var $7d5z2 = parcelRequire("7d5z2");
const $1dd2a25cc0751014$var$isLegacyRoutes = (routes)=>{
    // a naive way to check if the routes are legacy routes
    return routes[routes.length - 1]?.name === 'legacy-fallback';
};
const $1dd2a25cc0751014$export$ce5b73cebfeaa567 = (routes, pathname, queryParams, basePath = '')=>{
    const useOrderIndependentMatching = $1dd2a25cc0751014$var$isLegacyRoutes(routes) === false;
    const matchRoute = useOrderIndependentMatching ? (0, $2gqQL.default) : (0, $7d5z2.default);
    return matchRoute(routes, pathname, queryParams, basePath);
};
const $1dd2a25cc0751014$export$4e76f1d455ef7c95 = (route, pathname, queryParams, basePath = '')=>{
    // no need to check legacy routes because `warmupMatchRouteCache` is used for SPA only
    return (0, $2gqQL.default)([
        route
    ], pathname, queryParams, basePath);
};
const $1dd2a25cc0751014$var$defaultMatchRoute = (routes, pathname, queryParams, basePath = '')=>{
    const useOrderIndependentMatching = $1dd2a25cc0751014$var$isLegacyRoutes(routes) === false;
    const matchRoute = useOrderIndependentMatching ? (0, $2gqQL.default) : (0, $7d5z2.default);
    const matchedRoute = matchRoute(routes, pathname, queryParams, basePath);
    return matchedRoute;
};
var $1dd2a25cc0751014$export$2e2bcd8739ae039 = $1dd2a25cc0751014$var$defaultMatchRoute;

});
parcelRegister("2gqQL", function(module, exports) {
$parcel$export(module.exports, "default", () => $1c8e9f7b0c877355$export$2e2bcd8739ae039);

var $8cM56 = parcelRequire("8cM56");

var $gWZHi = parcelRequire("gWZHi");

var $9TzUL = parcelRequire("9TzUL");
const $1c8e9f7b0c877355$var$matchRoute = (routes, pathname, queryParams = {}, basePath = '')=>{
    const cachedMatch = (0, $9TzUL.matchRouteCache).get(pathname, queryParams, basePath);
    if (cachedMatch && routes.includes(cachedMatch.route)) return cachedMatch;
    const matchedRoute = (0, $8cM56.default)(routes, pathname, queryParams, basePath);
    if (!matchedRoute) return null;
    (0, $gWZHi.default)(matchedRoute.route);
    (0, $9TzUL.matchRouteCache).set(pathname, queryParams, basePath, matchedRoute);
    return matchedRoute;
};
var $1c8e9f7b0c877355$export$2e2bcd8739ae039 = $1c8e9f7b0c877355$var$matchRoute;

});
parcelRegister("gWZHi", function(module, exports) {
$parcel$export(module.exports, "default", () => $608725cbc65b1879$export$2e2bcd8739ae039);
const $608725cbc65b1879$var$deduplicateResources = (route)=>{
    // Apply resource de-duping to the route
    if ('resources' in route && Array.isArray(route.resources)) Object.assign(route, {
        resources: [
            ...new Set(route.resources)
        ]
    });
};
const $608725cbc65b1879$var$extractlazyOpts = (route)=>{
    if ('lazyOpts' in route && typeof route.lazyOpts === 'function') {
        const opts = route.lazyOpts();
        Object.assign(route, opts);
        // eslint-disable-next-line no-param-reassign
        delete route.lazyOpts;
    }
};
// This function mutates the route object by applying a series of transformations.
// such as deduplicating resources
// and calling the lazyOpts function to extract the lazy options and apply them to the route.
// (This is to defer the evaluation of the lazy options until the route is actually matched)
const $608725cbc65b1879$var$unsafeMutateRoute = (route)=>{
    // make sure `extractlazyOpts` is called before `deduplicateResources`
    // because `resources` is a lazy option
    [
        $608725cbc65b1879$var$extractlazyOpts,
        $608725cbc65b1879$var$deduplicateResources
    ].forEach((fn)=>fn(route));
};
var $608725cbc65b1879$export$2e2bcd8739ae039 = $608725cbc65b1879$var$unsafeMutateRoute;

});

parcelRegister("9TzUL", function(module, exports) {
$parcel$export(module.exports, "matchRouteCache", () => $dc231373db1aa547$export$f594abf16a5ad948);
const $dc231373db1aa547$var$MAX_CACHE_SIZE = 1000;
function $dc231373db1aa547$var$shallowEqual(objA, objB) {
    if (objA === objB) return true;
    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    // Test for A's keys different from B.
    for(let i = 0; i < keysA.length; i++){
        if (!Object.hasOwn(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) return false;
    }
    return true;
}
const $dc231373db1aa547$export$f594abf16a5ad948 = {
    cache: new Map(),
    get (pathname, queryObj, basePath) {
        const pathCache = this.cache.get(basePath + pathname);
        if (pathCache) for (const [key, value] of pathCache){
            if ($dc231373db1aa547$var$shallowEqual(key, queryObj)) return value;
        }
    },
    set (pathname, queryObj, basePath, matchRoute) {
        if (this.cache.size > $dc231373db1aa547$var$MAX_CACHE_SIZE) this.cache.clear();
        const pathCache = this.cache.get(basePath + pathname);
        if (pathCache) {
            if (pathCache.size > $dc231373db1aa547$var$MAX_CACHE_SIZE / 10) pathCache.clear();
            pathCache.set(queryObj, matchRoute);
        } else this.cache.set(basePath + pathname, new Map([
            [
                queryObj,
                matchRoute
            ]
        ]));
    }
};

});


parcelRegister("7d5z2", function(module, exports) {
$parcel$export(module.exports, "default", () => $1ee6a8647edd97ac$export$2e2bcd8739ae039);

var $3Q6BV = parcelRequire("3Q6BV");

var $gWZHi = parcelRequire("gWZHi");

var $5S4UL = parcelRequire("5S4UL");

var $cfcMr = parcelRequire("cfcMr");
/**
 * Does the given `pathname` and `queryStr` match a route in `routes`.
 *
 * Heavily based on https://github.com/ReactTraining/react-router/blob/master/packages/react-router-config/modules/matchRoute.js
 *
 * Note: This does not support nested routes at this stage.
 */ const $1ee6a8647edd97ac$var$matchRoute = (routes, pathname, queryParams = {}, basePath = '')=>{
    const queryParamObject = typeof queryParams === 'string' ? (0, $3Q6BV.qs).parse(queryParams) : queryParams;
    const cachedMatch = (0, $cfcMr.matchRouteCache).get(pathname, queryParamObject, basePath);
    if (cachedMatch && routes.includes(cachedMatch.route)) return cachedMatch;
    for(let i = 0; i < routes.length; i++){
        const matchedRoute = (0, $5S4UL.default)(routes[i], pathname, queryParamObject, basePath);
        if (matchedRoute) {
            (0, $gWZHi.default)(matchedRoute.route);
            (0, $cfcMr.matchRouteCache).set(pathname, queryParamObject, basePath, matchedRoute);
            return matchedRoute;
        }
    }
    return null;
};
const $1ee6a8647edd97ac$export$ce5b73cebfeaa567 = (routes, pathname, queryParams, basePath = '')=>{
    return $1ee6a8647edd97ac$var$matchRoute(routes, pathname, queryParams, basePath);
};
const $1ee6a8647edd97ac$export$4e76f1d455ef7c95 = (route, pathname, queryParams, basePath = '')=>{
    return $1ee6a8647edd97ac$var$matchRoute([
        route
    ], pathname, queryParams, basePath);
};
var $1ee6a8647edd97ac$export$2e2bcd8739ae039 = $1ee6a8647edd97ac$var$matchRoute;

});
parcelRegister("5S4UL", function(module, exports) {
$parcel$export(module.exports, "default", () => $e9a506d06fd2ab93$export$2e2bcd8739ae039);

var $2FFIV = parcelRequire("2FFIV");

var $fKdol = parcelRequire("fKdol");
/* This should match what react-router does to compute a root match. */ const $e9a506d06fd2ab93$var$computeRootMatch = (pathname)=>({
        path: '/',
        url: '/',
        params: {},
        isExact: pathname === '/',
        query: {}
    });
function $e9a506d06fd2ab93$var$execRouteMatching(route, pathname, queryObj, basePath) {
    const pathMatch = route.path ? (0, $2FFIV.default)(pathname, {
        path: route.path,
        exact: route.exact,
        basePath: basePath
    }) : $e9a506d06fd2ab93$var$computeRootMatch(pathname);
    let match = pathMatch;
    if (pathMatch && route.query) match = (0, $fKdol.default)(route.query, queryObj, pathMatch);
    else if (pathMatch) match = {
        ...pathMatch,
        query: {}
    };
    if (match) return {
        match: match,
        route: route
    };
    return null;
}
var $e9a506d06fd2ab93$export$2e2bcd8739ae039 = $e9a506d06fd2ab93$var$execRouteMatching;

});
parcelRegister("2FFIV", function(module, exports) {
$parcel$export(module.exports, "default", () => $0aa3cd516765db4e$export$2e2bcd8739ae039);
// TAKEN FROM https://github.com/ReactTraining/react-router/blob/master/packages/react-router/modules/matchPath.js

var $3QHPX = parcelRequire("3QHPX");
const $0aa3cd516765db4e$var$cache = {};
const $0aa3cd516765db4e$var$cacheLimit = 10000;
let $0aa3cd516765db4e$var$cacheCount = 0;
function $0aa3cd516765db4e$var$compilePath(path, options) {
    const cacheKey = `${options.end}${options.strict}${options.sensitive}`;
    const pathCache = $0aa3cd516765db4e$var$cache[cacheKey] || ($0aa3cd516765db4e$var$cache[cacheKey] = {});
    if (pathCache[path]) return pathCache[path];
    const keys = [];
    const regexp = (0, $3QHPX.pathToRegexp)(path, keys, options);
    const result = {
        regexp: regexp,
        keys: keys
    };
    if ($0aa3cd516765db4e$var$cacheCount < $0aa3cd516765db4e$var$cacheLimit) {
        pathCache[path] = result;
        $0aa3cd516765db4e$var$cacheCount++;
    }
    return result;
}
/**
 * Public API for matching a URL pathname to a path.
 * TODO: reduce returns Array<never>
 */ function $0aa3cd516765db4e$var$matchPath(pathname, options = {}) {
    if (typeof options === 'string' || Array.isArray(options)) // eslint-disable-next-line no-param-reassign
    options = {
        path: options
    };
    const { path: p, exact: exact = false, strict: strict = false, sensitive: sensitive = false, basePath: basePath = '' } = options;
    const paths = [].concat(basePath + p);
    return paths.reduce((matched, path)=>{
        if (!path && path !== '') return null;
        if (matched) return matched;
        const { regexp: regexp, keys: keys } = $0aa3cd516765db4e$var$compilePath(path, {
            end: exact,
            strict: strict,
            sensitive: sensitive
        });
        const match = regexp.exec(pathname);
        if (!match) return null;
        const [url, ...values] = match;
        const isExact = pathname === url;
        if (exact && !isExact) return null;
        return {
            path: path,
            url: path === '/' && url === '' ? '/' : url,
            isExact: isExact,
            params: keys.reduce((memo, key, index)=>{
                // eslint-disable-next-line no-param-reassign
                memo[key.name] = values[index];
                return memo;
            }, {})
        };
    }, null);
}
var $0aa3cd516765db4e$export$2e2bcd8739ae039 = $0aa3cd516765db4e$var$matchPath;

});

parcelRegister("fKdol", function(module, exports) {
$parcel$export(module.exports, "default", () => $2863ab3683603dde$export$2e2bcd8739ae039);
/**
 * Matches `queryStr` against config stored in `queryConfig`.
 *
 * Returns `pathMatch` with an additional query prop with query params if the match succeeds,
 * otherwise returns null.
 *
 */ function $2863ab3683603dde$var$matchQuery(queryConfig, queryParams, pathMatch) {
    const queryMatch = {};
    const isMatchingQuery = queryConfig.every((query)=>{
        // eslint-disable-next-line prefer-const
        let [names, value] = query.split('=');
        let negation = false;
        /* Check if negative matching query param (eg 'foo!=1') */ if (query.includes('!=')) {
            names = names.substring(0, names.length - 1);
            negation = true;
        }
        /* Allow alternate query params presence (eg 'foo|bar') */ const matched = names.split('|').map((name)=>{
            let isOptional = false;
            /* Check if optional query param (eg 'foo?') */ if (name.includes('?')) {
                // eslint-disable-next-line no-param-reassign
                name = name.substring(0, name.length - 1);
                isOptional = true;
            }
            /* First check if queryParams contains the relevant param */ let match = Object.prototype.hasOwnProperty.call(queryParams, name);
            /* Save actual value so we expose it as part of match object */ if (match) queryMatch[name] = queryParams[name] || '';
            /* If no value matching required or it is optional and the param is missing */ if (!value || isOptional && !match) return isOptional || match;
            if (value.startsWith('(')) /* Handle value being a regexp eg 's=(\\d+)' */ match = new RegExp(`^${value}$`).test(queryParams[name] || '');
            else /* Handle value exact matching eg 's=123' */ match = queryParams[name] === value;
            return negation ? !match : match;
        });
        /* If at least one of alternate query params matches then it is a match */ return matched.includes(true);
    });
    return isMatchingQuery ? {
        ...pathMatch,
        query: queryMatch
    } : null;
}
var $2863ab3683603dde$export$2e2bcd8739ae039 = $2863ab3683603dde$var$matchQuery;

});


parcelRegister("cfcMr", function(module, exports) {
$parcel$export(module.exports, "matchRouteCache", () => $b7cfabb2eadcca1a$export$f594abf16a5ad948);
const $b7cfabb2eadcca1a$var$MAX_CACHE_SIZE = 1000;
function $b7cfabb2eadcca1a$var$shallowEqual(objA, objB) {
    if (objA === objB) return true;
    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    // Test for A's keys different from B.
    for(let i = 0; i < keysA.length; i++){
        if (!Object.hasOwn(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) return false;
    }
    return true;
}
const $b7cfabb2eadcca1a$export$f594abf16a5ad948 = {
    cache: new Map(),
    get (pathname, queryObj, basePath) {
        const pathCache = this.cache.get(basePath + pathname);
        if (pathCache) for (const [key, value] of pathCache){
            if ($b7cfabb2eadcca1a$var$shallowEqual(key, queryObj)) return value;
        }
    },
    set (pathname, queryObj, basePath, matchRoute) {
        if (this.cache.size > $b7cfabb2eadcca1a$var$MAX_CACHE_SIZE) this.cache.clear();
        const pathCache = this.cache.get(basePath + pathname);
        if (pathCache) {
            if (pathCache.size > $b7cfabb2eadcca1a$var$MAX_CACHE_SIZE / 10) pathCache.clear();
            pathCache.set(queryObj, matchRoute);
        } else this.cache.set(basePath + pathname, new Map([
            [
                queryObj,
                matchRoute
            ]
        ]));
    }
};

});



parcelRegister("eA736", function(module, exports) {
$parcel$export(module.exports, "createRouterContext", () => $c5b82ba2cf5a94f9$export$faed15f35ddc6f99);
$parcel$export(module.exports, "findRouterContext", () => $c5b82ba2cf5a94f9$export$a0bd0313cbeabd49);

var $3Q6BV = parcelRequire("3Q6BV");

var $lzBvk = parcelRequire("lzBvk");

var $02kpm = parcelRequire("02kpm");

var $30bwc = parcelRequire("30bwc");
const $c5b82ba2cf5a94f9$export$faed15f35ddc6f99 = (route, options = {})=>{
    const { params: params = {}, query: query = {}, basePath: basePath = '' } = options;
    const pathname = (0, $02kpm.generatePath)(route.path, params);
    const matchedRoute = (0, $30bwc.default)([
        route
    ], pathname, query, basePath);
    return {
        route: route,
        match: matchedRoute ? matchedRoute.match : (0, $lzBvk.DEFAULT_MATCH),
        query: query
    };
};
const $c5b82ba2cf5a94f9$export$a0bd0313cbeabd49 = (routes, options)=>{
    const { location: location, basePath: basePath = '' } = options;
    const { pathname: pathname, search: search } = location;
    const query = (0, $3Q6BV.qs).parse(search);
    const matchedRoute = (0, $30bwc.default)(routes, pathname, query, basePath);
    return {
        query: query,
        route: matchedRoute ? matchedRoute.route : (0, $lzBvk.DEFAULT_ROUTE),
        match: matchedRoute ? matchedRoute.match : (0, $lzBvk.DEFAULT_MATCH)
    };
};

});

parcelRegister("2IUk2", function(module, exports) {
$parcel$export(module.exports, "isExternalAbsolutePath", () => $1c51109bed0cb185$export$2fa6dede99f181e5);
$parcel$export(module.exports, "getRelativePath", () => $1c51109bed0cb185$export$ae9fda833d91ed65);
$parcel$export(module.exports, "updateQueryParams", () => $1c51109bed0cb185$export$92377f461a797888);
$parcel$export(module.exports, "getRelativeURLFromLocation", () => $1c51109bed0cb185$export$9ae1c7c875ef309d);
$parcel$export(module.exports, "shouldReload", () => $1c51109bed0cb185$export$c9237620ff7fdf7c);

var $3Q6BV = parcelRequire("3Q6BV");

var $72TKt = parcelRequire("72TKt");
const $1c51109bed0cb185$var$stripTrailingSlash = (path)=>path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
const $1c51109bed0cb185$var$addLeadingSlash = (path)=>path.charAt(0) === '/' ? path : `/${path}`;
const $1c51109bed0cb185$export$b8ce2e8154d1dff1 = (path, prefix = '')=>{
    if (prefix) {
        // eslint-disable-next-line no-param-reassign
        prefix = $1c51109bed0cb185$var$stripTrailingSlash(prefix);
        // eslint-disable-next-line no-param-reassign
        prefix = $1c51109bed0cb185$var$addLeadingSlash(prefix);
        // eslint-disable-next-line no-param-reassign
        path = $1c51109bed0cb185$var$addLeadingSlash(path);
    }
    return prefix + path;
};
const $1c51109bed0cb185$export$e83e3719fc818ee5 = (path)=>{
    const regex = new RegExp('^([a-z]+://|//)', 'i');
    return regex.test(path);
};
const $1c51109bed0cb185$export$2fa6dede99f181e5 = (path)=>{
    if (typeof path !== 'string' || !$1c51109bed0cb185$export$e83e3719fc818ee5(path)) return false;
    const pathHostname = new (0, (/*@__PURE__*/$parcel$interopDefault($3Q6BV)))(path).hostname;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const currentHostname = new (0, (/*@__PURE__*/$parcel$interopDefault($3Q6BV)))(window.location.href).hostname;
    return pathHostname !== currentHostname;
};
const $1c51109bed0cb185$export$ae9fda833d91ed65 = (path, prefix = '')=>{
    if (typeof path !== 'string') return path;
    if (!$1c51109bed0cb185$export$e83e3719fc818ee5(path)) {
        // eslint-disable-next-line no-param-reassign
        path = $1c51109bed0cb185$export$b8ce2e8154d1dff1(path, prefix);
        return path;
    }
    const url = new (0, (/*@__PURE__*/$parcel$interopDefault($3Q6BV)))(path);
    return `${url.pathname}${url.query}${url.hash}`;
};
const $1c51109bed0cb185$export$92377f461a797888 = (location, query)=>{
    // @ts-ignore stringify accepts two params but it's type doesn't say so
    const stringifiedQuery = (0, $3Q6BV.qs).stringify(query, true);
    return `${location.pathname}${stringifiedQuery}${location.hash}`;
};
const $1c51109bed0cb185$export$9ae1c7c875ef309d = (location)=>`${location.pathname}${location.search}${location.hash}`;
const $1c51109bed0cb185$export$c9237620ff7fdf7c = ({ context: context, prevContext: prevContext, pluginId: pluginId })=>{
    const sameRoute = (0, $72TKt.isSameRouteMatch)({
        prevContextMatch: prevContext.match,
        nextContextMatch: context.match
    });
    // keep old behaviour for Resources plugin
    // load Route only if path/query/params changed, and ignore the rest of query-params
    const defaultShouldReload = pluginId === 'resources-plugin' || !sameRoute;
    if (context.route === prevContext.route && context.route.EXPERIMENTAL__shouldReload) {
        const routeChoice = context.route.EXPERIMENTAL__shouldReload({
            context: context,
            prevContext: prevContext,
            pluginId: pluginId,
            defaultShouldReload: defaultShouldReload
        });
        if (typeof routeChoice === 'boolean') return routeChoice;
    }
    return defaultShouldReload;
};

});
parcelRegister("72TKt", function(module, exports) {
$parcel$export(module.exports, "isSameRouteMatch", () => $b419fd9afc3b9dd3$export$5997e70fc4543270);
const $b419fd9afc3b9dd3$var$isShallowEqual = (o1, o2)=>{
    const objKeys1 = Object.keys(o1);
    const objKeys2 = Object.keys(o2);
    if (objKeys1.length !== objKeys2.length) return false;
    return objKeys1.every((key)=>o1[key] === o2[key]);
};
const $b419fd9afc3b9dd3$export$5997e70fc4543270 = ({ prevContextMatch: prevContextMatch, nextContextMatch: nextContextMatch })=>prevContextMatch.path === nextContextMatch.path && $b419fd9afc3b9dd3$var$isShallowEqual(prevContextMatch.query, nextContextMatch.query) && $b419fd9afc3b9dd3$var$isShallowEqual(prevContextMatch.params, nextContextMatch.params);

});



parcelRegister("83DiZ", function(module, exports) {
$parcel$export(module.exports, "useRouterActions", () => $14c2c53301e65e26$export$402e82ff1b20594b);

var $kfvK2 = parcelRequire("kfvK2");
const $14c2c53301e65e26$export$402e82ff1b20594b = ()=>(0, $kfvK2.useRouterStoreActions)();

});

parcelRegister("dVcSp", function(module, exports) {
$parcel$export(module.exports, "default", () => $a22a963dc5cd9f42$export$2e2bcd8739ae039);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */ var $a22a963dc5cd9f42$var$__assign = function() {
    $a22a963dc5cd9f42$var$__assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $a22a963dc5cd9f42$var$__assign.apply(this, arguments);
};
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $a22a963dc5cd9f42$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
var $a22a963dc5cd9f42$var$isObject_1 = $a22a963dc5cd9f42$var$isObject;
var $a22a963dc5cd9f42$var$commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof $parcel$global !== 'undefined' ? $parcel$global : typeof self !== 'undefined' ? self : {};
/** Detect free variable `global` from Node.js. */ var $a22a963dc5cd9f42$var$freeGlobal = typeof $a22a963dc5cd9f42$var$commonjsGlobal == 'object' && $a22a963dc5cd9f42$var$commonjsGlobal && $a22a963dc5cd9f42$var$commonjsGlobal.Object === Object && $a22a963dc5cd9f42$var$commonjsGlobal;
var $a22a963dc5cd9f42$var$_freeGlobal = $a22a963dc5cd9f42$var$freeGlobal;
/** Detect free variable `self`. */ var $a22a963dc5cd9f42$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $a22a963dc5cd9f42$var$root = $a22a963dc5cd9f42$var$_freeGlobal || $a22a963dc5cd9f42$var$freeSelf || Function('return this')();
var $a22a963dc5cd9f42$var$_root = $a22a963dc5cd9f42$var$root;
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $a22a963dc5cd9f42$var$now = function() {
    return $a22a963dc5cd9f42$var$_root.Date.now();
};
var $a22a963dc5cd9f42$var$now_1 = $a22a963dc5cd9f42$var$now;
/** Built-in value references. */ var $a22a963dc5cd9f42$var$Symbol = $a22a963dc5cd9f42$var$_root.Symbol;
var $a22a963dc5cd9f42$var$_Symbol = $a22a963dc5cd9f42$var$Symbol;
/** Used for built-in method references. */ var $a22a963dc5cd9f42$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $a22a963dc5cd9f42$var$hasOwnProperty = $a22a963dc5cd9f42$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $a22a963dc5cd9f42$var$nativeObjectToString = $a22a963dc5cd9f42$var$objectProto.toString;
/** Built-in value references. */ var $a22a963dc5cd9f42$var$symToStringTag = $a22a963dc5cd9f42$var$_Symbol ? $a22a963dc5cd9f42$var$_Symbol.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $a22a963dc5cd9f42$var$getRawTag(value) {
    var isOwn = $a22a963dc5cd9f42$var$hasOwnProperty.call(value, $a22a963dc5cd9f42$var$symToStringTag), tag = value[$a22a963dc5cd9f42$var$symToStringTag];
    try {
        value[$a22a963dc5cd9f42$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $a22a963dc5cd9f42$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$a22a963dc5cd9f42$var$symToStringTag] = tag;
        else delete value[$a22a963dc5cd9f42$var$symToStringTag];
    }
    return result;
}
var $a22a963dc5cd9f42$var$_getRawTag = $a22a963dc5cd9f42$var$getRawTag;
/** Used for built-in method references. */ var $a22a963dc5cd9f42$var$objectProto$1 = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $a22a963dc5cd9f42$var$nativeObjectToString$1 = $a22a963dc5cd9f42$var$objectProto$1.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $a22a963dc5cd9f42$var$objectToString(value) {
    return $a22a963dc5cd9f42$var$nativeObjectToString$1.call(value);
}
var $a22a963dc5cd9f42$var$_objectToString = $a22a963dc5cd9f42$var$objectToString;
/** `Object#toString` result references. */ var $a22a963dc5cd9f42$var$nullTag = '[object Null]', $a22a963dc5cd9f42$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $a22a963dc5cd9f42$var$symToStringTag$1 = $a22a963dc5cd9f42$var$_Symbol ? $a22a963dc5cd9f42$var$_Symbol.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $a22a963dc5cd9f42$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $a22a963dc5cd9f42$var$undefinedTag : $a22a963dc5cd9f42$var$nullTag;
    return $a22a963dc5cd9f42$var$symToStringTag$1 && $a22a963dc5cd9f42$var$symToStringTag$1 in Object(value) ? $a22a963dc5cd9f42$var$_getRawTag(value) : $a22a963dc5cd9f42$var$_objectToString(value);
}
var $a22a963dc5cd9f42$var$_baseGetTag = $a22a963dc5cd9f42$var$baseGetTag;
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $a22a963dc5cd9f42$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
var $a22a963dc5cd9f42$var$isObjectLike_1 = $a22a963dc5cd9f42$var$isObjectLike;
/** `Object#toString` result references. */ var $a22a963dc5cd9f42$var$symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $a22a963dc5cd9f42$var$isSymbol(value) {
    return typeof value == 'symbol' || $a22a963dc5cd9f42$var$isObjectLike_1(value) && $a22a963dc5cd9f42$var$_baseGetTag(value) == $a22a963dc5cd9f42$var$symbolTag;
}
var $a22a963dc5cd9f42$var$isSymbol_1 = $a22a963dc5cd9f42$var$isSymbol;
/** Used as references for various `Number` constants. */ var $a22a963dc5cd9f42$var$NAN = 0 / 0;
/** Used to match leading and trailing whitespace. */ var $a22a963dc5cd9f42$var$reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var $a22a963dc5cd9f42$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $a22a963dc5cd9f42$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $a22a963dc5cd9f42$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $a22a963dc5cd9f42$var$freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $a22a963dc5cd9f42$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ($a22a963dc5cd9f42$var$isSymbol_1(value)) return $a22a963dc5cd9f42$var$NAN;
    if ($a22a963dc5cd9f42$var$isObject_1(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = $a22a963dc5cd9f42$var$isObject_1(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = value.replace($a22a963dc5cd9f42$var$reTrim, '');
    var isBinary = $a22a963dc5cd9f42$var$reIsBinary.test(value);
    return isBinary || $a22a963dc5cd9f42$var$reIsOctal.test(value) ? $a22a963dc5cd9f42$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $a22a963dc5cd9f42$var$reIsBadHex.test(value) ? $a22a963dc5cd9f42$var$NAN : +value;
}
var $a22a963dc5cd9f42$var$toNumber_1 = $a22a963dc5cd9f42$var$toNumber;
/** Error message constants. */ var $a22a963dc5cd9f42$var$FUNC_ERROR_TEXT = 'Expected a function';
/* Built-in method references for those with the same name as other `lodash` methods. */ var $a22a963dc5cd9f42$var$nativeMax = Math.max, $a22a963dc5cd9f42$var$nativeMin = Math.min;
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $a22a963dc5cd9f42$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != 'function') throw new TypeError($a22a963dc5cd9f42$var$FUNC_ERROR_TEXT);
    wait = $a22a963dc5cd9f42$var$toNumber_1(wait) || 0;
    if ($a22a963dc5cd9f42$var$isObject_1(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? $a22a963dc5cd9f42$var$nativeMax($a22a963dc5cd9f42$var$toNumber_1(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
        return maxing ? $a22a963dc5cd9f42$var$nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $a22a963dc5cd9f42$var$now_1();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($a22a963dc5cd9f42$var$now_1());
    }
    function debounced() {
        var time = $a22a963dc5cd9f42$var$now_1(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
var $a22a963dc5cd9f42$var$debounce_1 = $a22a963dc5cd9f42$var$debounce;
/** Error message constants. */ var $a22a963dc5cd9f42$var$FUNC_ERROR_TEXT$1 = 'Expected a function';
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */ function $a22a963dc5cd9f42$var$throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != 'function') throw new TypeError($a22a963dc5cd9f42$var$FUNC_ERROR_TEXT$1);
    if ($a22a963dc5cd9f42$var$isObject_1(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    return $a22a963dc5cd9f42$var$debounce_1(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
    });
}
var $a22a963dc5cd9f42$var$throttle_1 = $a22a963dc5cd9f42$var$throttle;
var $a22a963dc5cd9f42$var$windowIdleEvents = [
    'scroll',
    'resize'
];
var $a22a963dc5cd9f42$var$documentIdleEvents = [
    'wheel',
    'keydown',
    'keyup',
    'mousedown',
    'mousemove',
    'touchstart',
    'touchmove',
    'click',
    'contextmenu'
];
var $a22a963dc5cd9f42$var$BrowserInteractionTime = /** @class */ function() {
    function BrowserInteractionTime(_a) {
        var _b = _a.timeIntervalEllapsedCallbacks, timeIntervalEllapsedCallbacks = _b === void 0 ? [] : _b, _c = _a.absoluteTimeEllapsedCallbacks, absoluteTimeEllapsedCallbacks = _c === void 0 ? [] : _c, _d = _a.checkCallbacksIntervalMs, checkCallbacksIntervalMs = _d === void 0 ? 100 : _d, _e = _a.browserTabInactiveCallbacks, browserTabInactiveCallbacks = _e === void 0 ? [] : _e, _f = _a.idleCallbacks, idleCallbacks = _f === void 0 ? [] : _f, _g = _a.stopTimerOnTabchange, stopTimerOnTabchange = _g === void 0 ? true : _g, _h = _a.activeCallbacks, activeCallbacks = _h === void 0 ? [] : _h, _j = _a.browserTabActiveCallbacks, browserTabActiveCallbacks = _j === void 0 ? [] : _j, _k = _a.idleTimeoutMs, idleTimeoutMs = _k === void 0 ? 3000 : _k;
        var _this = this;
        this.onBrowserTabInactive = function() {
            // if running pause timer
            if (_this.isRunning() && _this.stopTimerOnTabchange) _this.stopTimer();
            _this.browserTabInactiveCallbacks.forEach(function(fn) {
                return fn(_this.getTimeInMilliseconds());
            });
        };
        this.onBrowserTabActive = function() {
            // if not running start timer
            if (!_this.isRunning()) _this.startTimer();
            _this.browserTabActiveCallbacks.forEach(function(fn) {
                return fn(_this.getTimeInMilliseconds());
            });
        };
        this.onBrowserActiveChange = function() {
            if (document.visibilityState === 'visible') _this.onBrowserTabActive();
            else _this.onBrowserTabInactive();
        };
        this.onTimePassed = function() {
            // check all callbacks time and if passed execute callback
            _this.absoluteTimeEllapsedCallbacks.forEach(function(_a, index) {
                var callback = _a.callback, pending = _a.pending, timeInMilliseconds = _a.timeInMilliseconds;
                if (pending && timeInMilliseconds <= _this.getTimeInMilliseconds()) {
                    callback(_this.getTimeInMilliseconds());
                    _this.absoluteTimeEllapsedCallbacks[index].pending = false;
                }
            });
            _this.timeIntervalEllapsedCallbacks.forEach(function(_a, index) {
                var callback = _a.callback, timeInMilliseconds = _a.timeInMilliseconds, multiplier = _a.multiplier;
                if (timeInMilliseconds <= _this.getTimeInMilliseconds()) {
                    callback(_this.getTimeInMilliseconds());
                    _this.timeIntervalEllapsedCallbacks[index].timeInMilliseconds = multiplier(timeInMilliseconds);
                }
            });
            if (_this.currentIdleTimeMs >= _this.idleTimeoutMs && _this.isRunning()) {
                _this.idle = true;
                _this.stopTimer();
                _this.idleCallbacks.forEach(function(fn) {
                    return fn(_this.getTimeInMilliseconds());
                });
            } else _this.currentIdleTimeMs += _this.checkCallbacksIntervalMs;
        };
        this.resetIdleTime = function() {
            if (_this.idle) _this.startTimer();
            _this.activeCallbacks.forEach(function(fn) {
                return fn(_this.getTimeInMilliseconds());
            });
            _this.idle = false;
            _this.currentIdleTimeMs = 0;
        };
        this.registerEventListeners = function() {
            var documentListenerOptions = {
                passive: true
            };
            var windowListenerOptions = $a22a963dc5cd9f42$var$__assign({}, documentListenerOptions, {
                capture: true
            });
            document.addEventListener('visibilitychange', _this.onBrowserActiveChange);
            var throttleResetIdleTime = $a22a963dc5cd9f42$var$throttle_1(_this.resetIdleTime, 2000, {
                leading: true,
                trailing: false
            });
            $a22a963dc5cd9f42$var$windowIdleEvents.forEach(function(event) {
                window.addEventListener(event, throttleResetIdleTime, windowListenerOptions);
            });
            $a22a963dc5cd9f42$var$documentIdleEvents.forEach(function(event) {
                return document.addEventListener(event, throttleResetIdleTime, documentListenerOptions);
            });
        };
        this.unregisterEventListeners = function() {
            document.removeEventListener('visibilitychange', _this.onBrowserActiveChange);
            $a22a963dc5cd9f42$var$windowIdleEvents.forEach(function(event) {
                return window.removeEventListener(event, _this.resetIdleTime);
            });
            $a22a963dc5cd9f42$var$documentIdleEvents.forEach(function(event) {
                return document.removeEventListener(event, _this.resetIdleTime);
            });
        };
        this.checkCallbacksOnInterval = function() {
            _this.checkCallbackIntervalId = window.setInterval(function() {
                _this.onTimePassed();
            }, _this.checkCallbacksIntervalMs);
        };
        this.startTimer = function() {
            if (!_this.checkCallbackIntervalId) _this.checkCallbacksOnInterval();
            var last = _this.times[_this.times.length - 1];
            if (last && last.stop === null) return;
            _this.times.push({
                start: performance.now(),
                stop: null
            });
            _this.running = true;
        };
        this.stopTimer = function() {
            if (!_this.times.length) return;
            _this.times[_this.times.length - 1].stop = performance.now();
            _this.running = false;
        };
        this.addTimeIntervalEllapsedCallback = function(timeIntervalEllapsedCallback) {
            _this.timeIntervalEllapsedCallbacks.push(timeIntervalEllapsedCallback);
        };
        this.addAbsoluteTimeEllapsedCallback = function(absoluteTimeEllapsedCallback) {
            _this.absoluteTimeEllapsedCallbacks.push(absoluteTimeEllapsedCallback);
        };
        this.addBrowserTabInactiveCallback = function(browserTabInactiveCallback) {
            _this.browserTabInactiveCallbacks.push(browserTabInactiveCallback);
        };
        this.addBrowserTabActiveCallback = function(browserTabActiveCallback) {
            _this.browserTabActiveCallbacks.push(browserTabActiveCallback);
        };
        this.addIdleCallback = function(inactiveCallback) {
            _this.idleCallbacks.push(inactiveCallback);
        };
        this.addActiveCallback = function(activeCallback) {
            _this.activeCallbacks.push(activeCallback);
        };
        this.getTimeInMilliseconds = function() {
            return _this.times.reduce(function(acc, current) {
                if (current.stop) acc = acc + (current.stop - current.start);
                else acc = acc + (performance.now() - current.start);
                return acc;
            }, 0);
        };
        this.isRunning = function() {
            return _this.running;
        };
        this.isIdle = function() {
            return _this.idle;
        };
        this.reset = function() {
            _this.times = [];
        };
        this.destroy = function() {
            _this.unregisterEventListeners();
            if (_this.checkCallbackIntervalId) window.clearInterval(_this.checkCallbackIntervalId);
        };
        this.running = false;
        this.times = [];
        this.idle = false;
        this.currentIdleTimeMs = 0;
        this.marks = {};
        this.measures = {};
        this.stopTimerOnTabchange = stopTimerOnTabchange;
        this.browserTabActiveCallbacks = browserTabActiveCallbacks;
        this.browserTabInactiveCallbacks = browserTabInactiveCallbacks;
        this.checkCallbacksIntervalMs = checkCallbacksIntervalMs;
        this.idleTimeoutMs = idleTimeoutMs;
        this.timeIntervalEllapsedCallbacks = timeIntervalEllapsedCallbacks;
        this.absoluteTimeEllapsedCallbacks = absoluteTimeEllapsedCallbacks;
        this.idleCallbacks = idleCallbacks;
        this.activeCallbacks = activeCallbacks;
        this.registerEventListeners();
    }
    BrowserInteractionTime.prototype.mark = function(key) {
        if (!this.marks[key]) this.marks[key] = [];
        this.marks[key].push({
            time: this.getTimeInMilliseconds()
        });
    };
    BrowserInteractionTime.prototype.getMarks = function(name) {
        if (this.marks[name].length < 1) return;
        return this.marks[name];
    };
    BrowserInteractionTime.prototype.measure = function(name, startMarkName, endMarkName) {
        var startMarks = this.marks[startMarkName];
        var startMark = startMarks[startMarks.length - 1];
        var endMarks = this.marks[endMarkName];
        var endMark = endMarks[endMarks.length - 1];
        if (!this.measures[name]) this.measures[name] = [];
        this.measures[name].push({
            name: name,
            startTime: startMark.time,
            duration: endMark.time - startMark.time
        });
    };
    BrowserInteractionTime.prototype.getMeasures = function(name) {
        if (!this.measures[name] && this.measures[name].length < 1) return;
        return this.measures[name];
    };
    return BrowserInteractionTime;
}();
var $a22a963dc5cd9f42$export$2e2bcd8739ae039 = $a22a963dc5cd9f42$var$BrowserInteractionTime;

});

parcelRegister("lcB5K", function(module, exports) {
$parcel$export(module.exports, "RouterActions", () => $3a55a344d1a32d98$export$b371fa9cf762ad06);

var $eJOHy = parcelRequire("eJOHy");

var $83DiZ = parcelRequire("83DiZ");
const $3a55a344d1a32d98$export$b371fa9cf762ad06 = ({ children: children })=>{
    const actions = (0, $83DiZ.useRouterActions)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children(actions));
};
$3a55a344d1a32d98$export$b371fa9cf762ad06.displayName = 'RouterActions';

});

parcelRegister("gCY1z", function(module, exports) {
$parcel$export(module.exports, "useRouter", () => $24aae8767f89aaa0$export$9a302a45f65d0572);

var $kfvK2 = parcelRequire("kfvK2");
const $24aae8767f89aaa0$export$9a302a45f65d0572 = ()=>(0, $kfvK2.useRouterStore)();

});

parcelRegister("c9uTK", function(module, exports) {
$parcel$export(module.exports, "Link", () => $09c5ab453f8e06c4$export$a6c7ac8248d6e38a);
/* eslint-disable jira/filename-case */ 
var $eJOHy = parcelRequire("eJOHy");

var $fdDkm = parcelRequire("fdDkm");

var $GNVfd = parcelRequire("GNVfd");

var $eA736 = parcelRequire("eA736");

var $kfvK2 = parcelRequire("kfvK2");

var $8cwKD = parcelRequire("8cwKD");

var $kHmeH = parcelRequire("kHmeH");
const $09c5ab453f8e06c4$var$PREFETCH_DELAY = 225;
const $09c5ab453f8e06c4$export$a6c7ac8248d6e38a = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ children: children, target: target = '_self', replace: replace = false, href: href, to: to, onClick: onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onPointerDown: onPointerDown, onFocus: onFocus, onBlur: onBlur, type: linkType = 'a', params: params, query: query, prefetch: prefetch = false, state: state, ...rest }, ref)=>{
    const routerActions = (0, $kfvK2.useRouterStoreActions)();
    const { schedule: schedule, cancel: cancel } = (0, $8cwKD.useTimeout)($09c5ab453f8e06c4$var$PREFETCH_DELAY);
    const validLinkType = linkType === 'a' || linkType === 'button' ? linkType : 'a';
    const [route, setRoute] = (0, $eJOHy.useState)(()=>{
        if (to && typeof to !== 'string') {
            if ('then' in to) to.then((r)=>setRoute('default' in r ? r.default : r));
            else return to;
        }
    });
    (0, $eJOHy.useEffect)(()=>{
        if (to && typeof to !== 'string' && !route && 'then' in to) // eslint-disable-next-line react-you-might-not-need-an-effect/no-pass-live-state-to-parent
        to.then((r)=>setRoute('default' in r ? r.default : r));
    }, [
        to,
        route
    ]);
    let routeValue = route;
    if (!routeValue && to && typeof to !== 'string' && !('then' in to)) // use the prop instead of the value in useState
    routeValue = to;
    const routeAttributes = {
        params: params,
        query: query,
        basePath: routerActions.getBasePath()
    };
    const linkDestination = // eslint-disable-next-line no-nested-ternary
    href != null ? href : typeof to !== 'string' ? routeValue && (0, $fdDkm.createPath)((0, $GNVfd.generateLocationFromPath)(routeValue.path, routeAttributes)) || '' : to;
    const staticBasePath = href == null && typeof to === 'string' ? routeAttributes.basePath : '';
    const triggerPrefetch = (0, $eJOHy.useCallback)(()=>{
        // ignore if async route not ready yet
        if (typeof to !== 'string' && !routeValue) return;
        const context = typeof to !== 'string' && routeValue ? (0, $eA736.createRouterContext)(routeValue, {
            params: params,
            query: query
        }) : null;
        routerActions.prefetchRoute(linkDestination, context);
    // omit params & query as already in linkDestination
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        routeValue,
        linkDestination,
        routerActions
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (prefetch === 'mount') schedule(triggerPrefetch);
        return cancel;
    }, [
        prefetch,
        schedule,
        cancel,
        triggerPrefetch
    ]);
    const handleLinkPress = (e)=>(0, $kHmeH.handleNavigation)(e, {
            onClick: onClick,
            target: target,
            replace: replace,
            routerActions: routerActions,
            href: linkDestination,
            to: routeValue && [
                routeValue,
                {
                    params: params,
                    query: query
                }
            ],
            state: state
        });
    const handleMouseEnter = (e)=>{
        if (prefetch === 'hover') schedule(triggerPrefetch);
        onMouseEnter && onMouseEnter(e);
    };
    const handleMouseLeave = (e)=>{
        if (prefetch === 'hover') cancel();
        onMouseLeave && onMouseLeave(e);
    };
    const handleFocus = (e)=>{
        if (prefetch === 'hover') schedule(triggerPrefetch);
        onFocus && onFocus(e);
    };
    const handleBlur = (e)=>{
        if (prefetch === 'hover') cancel();
        onBlur && onBlur(e);
    };
    const handlePointerDown = (e)=>{
        if (prefetch === 'hover') {
            cancel();
            triggerPrefetch();
        }
        onPointerDown && onPointerDown(e);
    };
    return /*#__PURE__*/ (0, $eJOHy.createElement)(validLinkType, {
        ...rest,
        href: `${staticBasePath}${linkDestination}`,
        target: target,
        onClick: handleLinkPress,
        onKeyDown: handleLinkPress,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        onFocus: handleFocus,
        onBlur: handleBlur,
        onPointerDown: handlePointerDown,
        ref: ref
    }, children);
});
$09c5ab453f8e06c4$export$a6c7ac8248d6e38a.displayName = 'Link';

});
parcelRegister("8cwKD", function(module, exports) {
$parcel$export(module.exports, "useTimeout", () => $390218dcc0db629b$export$d8e6abf214c9ec0f);

var $eJOHy = parcelRequire("eJOHy");
const $390218dcc0db629b$export$d8e6abf214c9ec0f = (delay)=>{
    const timeoutId = (0, $eJOHy.useRef)();
    const schedule = (0, $eJOHy.useCallback)((callback)=>{
        if (timeoutId.current) clearTimeout(timeoutId.current);
        timeoutId.current = setTimeout(callback, delay);
    }, [
        delay
    ]);
    const cancel = (0, $eJOHy.useCallback)(()=>{
        clearTimeout(timeoutId.current);
    }, []);
    return {
        schedule: schedule,
        cancel: cancel
    };
};

});

parcelRegister("kHmeH", function(module, exports) {
$parcel$export(module.exports, "handleNavigation", () => $619da4fed371b959$export$706ad1af8096e280);

var $63nup = parcelRequire("63nup");
const $619da4fed371b959$export$706ad1af8096e280 = (event, { onClick: onClick, target: target, replace: replace, routerActions: routerActions, href: href, to: to, state: state })=>{
    if ((0, $63nup.isKeyboardEvent)(event) && event.key !== 'Enter') return;
    onClick && onClick(event);
    if (!event.defaultPrevented && // onClick prevented default
    ((0, $63nup.isKeyboardEvent)(event) && event.key === 'Enter' || event.button === 0) && // ignore everything but left clicks and Enter key
    (!target || target === '_self') && // let browser handle "target=_blank" etc.
    !(0, $63nup.isModifiedEvent)(event) // ignore clicks with modifier keys
    ) {
        event.preventDefault();
        if (to) {
            const method = replace ? routerActions.replaceTo : routerActions.pushTo;
            method(...to, state);
        } else {
            const method = replace ? routerActions.replace : routerActions.push;
            method(href, state);
        }
    }
};

});
parcelRegister("63nup", function(module, exports) {
$parcel$export(module.exports, "isModifiedEvent", () => $56250b07ecde8e76$export$642c6f14f6d4bbd5);
$parcel$export(module.exports, "isKeyboardEvent", () => $56250b07ecde8e76$export$130b789831072f4c);
const $56250b07ecde8e76$export$642c6f14f6d4bbd5 = (event)=>!!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
const $56250b07ecde8e76$export$130b789831072f4c = (event)=>[
        'keypress',
        'keydown',
        'keyup'
    ].includes(event.type);

});



parcelRegister("bkb9R", function(module, exports) {
$parcel$export(module.exports, "Router", () => $a8c443c78b16bb41$export$55185c17a0fcbe46);
/* eslint-disable jira/filename-case */ 
var $eJOHy = parcelRequire("eJOHy");

var $kfvK2 = parcelRequire("kfvK2");
const $a8c443c78b16bb41$export$55185c17a0fcbe46 = ({ basePath: basePath, children: children, history: history, initialRoute: initialRoute, isGlobal: isGlobal = true, plugins: plugins, onPrefetch: onPrefetch, routes: routes, isLazyRoutes: isLazyRoutes = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kfvK2.RouterContainer), {
        basePath: basePath,
        history: history,
        initialRoute: initialRoute,
        isGlobal: isGlobal,
        onPrefetch: onPrefetch,
        plugins: plugins ?? [],
        routes: routes,
        isLazyRoutes: isLazyRoutes
    }, children);

});

parcelRegister("uCHeL", function(module, exports) {
$parcel$export(module.exports, "getResourceStore", () => $df78c3e374ea9484$export$6f6057d42352becb);
$parcel$export(module.exports, "useResourceStore", () => $df78c3e374ea9484$export$ac3608e0bb357c7);
$parcel$export(module.exports, "useResourceStoreActions", () => $df78c3e374ea9484$export$98e41a62c9bef75e);
$parcel$export(module.exports, "useResourceStoreContext", () => $df78c3e374ea9484$export$e59f52df235ac7b3);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");
var $6E16M = parcelRequire("6E16M");
var $GtRbT = parcelRequire("GtRbT");
var $ht3nQ = parcelRequire("ht3nQ");
var $14kUX = parcelRequire("14kUX");

var $5ZRFW = parcelRequire("5ZRFW");

var $304ta = parcelRequire("304ta");

var $k3E37 = parcelRequire("k3E37");

var $iGGIX = parcelRequire("iGGIX");

var $dSu1v = parcelRequire("dSu1v");

var $1lL1f = parcelRequire("1lL1f");

var $gCUyT = parcelRequire("gCUyT");

var $7lv26 = parcelRequire("7lv26");

var $lOUVD = parcelRequire("lOUVD");

var $glYDH = parcelRequire("glYDH");

var $hc6Iv = parcelRequire("hc6Iv");

var $4TaPc = parcelRequire("4TaPc");

var $la6KB = parcelRequire("la6KB");

var $kmBPv = parcelRequire("kmBPv");

const $df78c3e374ea9484$export$3f1be494d407b77a = {
    /**
	 * Clears a resource for the current key, or where context is not provided all keys.
	 */ clearResource: (resource, routerStoreContext)=>({ getState: getState, dispatch: dispatch })=>{
            const { type: type, getKey: getKey } = resource;
            const { context: context } = getState();
            if (routerStoreContext) {
                const key = getKey(routerStoreContext, context);
                dispatch((0, $lOUVD.deleteResourceState)(type, key));
                dispatch((0, $dSu1v.executeForDependents)(resource, (dependentResource)=>$df78c3e374ea9484$export$3f1be494d407b77a.clearResource(dependentResource, routerStoreContext)));
            } else dispatch((0, $lOUVD.deleteResourceState)(type));
        },
    /**
	 * Update the data property for a resource in the cache and reset expiresAt based
	 * on maxAge.
	 */ updateResourceState: (resource, routerStoreContext, getNewSliceData)=>({ getState: getState, dispatch: dispatch })=>{
            const { type: type, getKey: getKey, maxAge: maxAge } = resource;
            const { context: context, ...resourceStoreState } = getState();
            const key = getKey(routerStoreContext, context);
            const prevSlice = (0, $304ta.getSliceForResource)(resourceStoreState, {
                type: type,
                key: key
            });
            const data = getNewSliceData(prevSlice.data);
            const changes = prevSlice.loading ? {
                data: data,
                error: null,
                loading: true
            } : {
                data: data,
                error: null,
                loading: false,
                promise: Promise.resolve(data)
            };
            const newSlice = {
                ...prevSlice,
                ...changes,
                expiresAt: (0, $1lL1f.getExpiresAt)(maxAge),
                accessedAt: (0, $k3E37.getAccessedAt)()
            };
            dispatch((0, $lOUVD.setResourceState)(type, key, newSlice));
            // trigger dependent resources on change
            if (newSlice.data !== prevSlice.data) dispatch((0, $dSu1v.executeForDependents)(resource, (dependentResource)=>$df78c3e374ea9484$export$3f1be494d407b77a.getResourceFromRemote(dependentResource, routerStoreContext, {})));
        },
    /**
	 * Get a single resource, either from the cache if it exists and has not expired, or
	 * the remote if it has expired.
	 */ getResource: (resource, routerStoreContext, options)=>async ({ getState: getState, dispatch: dispatch })=>{
            const { type: type, getKey: getKey, maxAge: maxAge } = resource;
            const { context: context } = getState();
            const key = getKey(routerStoreContext, context);
            let cached = dispatch((0, $lOUVD.getResourceState)(type, key));
            if (cached && (0, $hc6Iv.shouldUseCache)(cached)) {
                if ((0, $hc6Iv.isFromSsr)(cached)) {
                    const withResolvedPromise = (0, $4TaPc.setSsrDataPromise)(cached);
                    cached = (0, $1lL1f.setExpiresAt)(withResolvedPromise, maxAge);
                }
                cached.accessedAt = (0, $k3E37.getAccessedAt)();
                dispatch((0, $lOUVD.setResourceState)(type, key, cached));
                return cached;
            }
            return dispatch($df78c3e374ea9484$export$3f1be494d407b77a.getResourceFromRemote(resource, routerStoreContext, options));
        },
    /**
	 * Request a single resource and update the resource cache.
	 */ getResourceFromRemote: (resource, routerStoreContext, options)=>async ({ getState: getState, dispatch: dispatch })=>{
            const { type: type, getKey: getKey, maxAge: maxAge } = resource;
            const { context: context } = getState();
            const key = getKey(routerStoreContext, context);
            const prevSlice = dispatch((0, $lOUVD.getResourceState)(type, key)) || (0, $gCUyT.getDefaultStateSlice)();
            // abort request if already in flight
            if (prevSlice.loading) return prevSlice;
            dispatch((0, $7lv26.validateLRUCache)(resource, key));
            let loadingSlice = dispatch((0, $lOUVD.getPrefetchSlice)(type, key));
            if (!loadingSlice) loadingSlice = (0, $iGGIX.createLoadingSlice)({
                context: context,
                dependencies: ()=>dispatch((0, $dSu1v.getDependencies)(resource, routerStoreContext, options)),
                options: options,
                resource: resource,
                routerStoreContext: routerStoreContext
            });
            let resolvedSlice;
            if (loadingSlice.data === prevSlice.data) // same data (by reference) means nothing has changed and we can avoid loading state
            resolvedSlice = {};
            else {
                // enter loading state
                dispatch((0, $lOUVD.setResourceState)(type, key, {
                    ...prevSlice,
                    ...loadingSlice,
                    data: maxAge === 0 ? null : prevSlice.data,
                    error: maxAge === 0 ? null : prevSlice.error,
                    loading: true,
                    accessedAt: (0, $k3E37.getAccessedAt)()
                }));
                // trigger dependent resources to also load
                dispatch((0, $dSu1v.executeForDependents)(resource, (dependentResource)=>$df78c3e374ea9484$export$3f1be494d407b77a.getResourceFromRemote(dependentResource, routerStoreContext, options)));
                // in case another action occurred while loading promise may not be the one we started with
                // we need to re-assign promise consistent with error/data that we are assigning here
                try {
                    const data = loadingSlice.data ?? await loadingSlice.promise;
                    resolvedSlice = {
                        data: data,
                        error: null,
                        loading: false,
                        promise: loadingSlice.promise
                    };
                } catch (error) {
                    if (error instanceof (0, $la6KB.TimeoutError)) resolvedSlice = {
                        error: // data: do not replace existing data
                        error,
                        loading: true,
                        promise: null
                    };
                    else resolvedSlice = {
                        error: // data: do not replace existing data
                        // @ts-ignore
                        error,
                        loading: false,
                        promise: loadingSlice.promise
                    };
                }
            }
            // ensure most recent data when return occurs
            const recentSlice = dispatch((0, $lOUVD.getResourceState)(type, key));
            const finalSlice = {
                ...recentSlice || prevSlice,
                ...resolvedSlice,
                accessedAt: (0, $k3E37.getAccessedAt)(),
                expiresAt: (0, $1lL1f.getExpiresAt)(maxAge)
            };
            // protect against race conditions: if resources get cleared while await happens, we discard the result
            if (recentSlice || loadingSlice.data !== undefined) dispatch((0, $lOUVD.setResourceState)(type, key, finalSlice));
            return finalSlice;
        },
    /**
	 * Prefetch a single resource and store in the prefetch cache.
	 */ prefetchResourceFromRemote: (resource, routerStoreContext, options)=>async ({ getState: getState, dispatch: dispatch })=>{
            const { type: type, getKey: getKey } = resource;
            const { context: context } = getState();
            const key = getKey(routerStoreContext, context);
            const prevSlice = dispatch((0, $lOUVD.getResourceState)(type, key)) || (0, $gCUyT.getDefaultStateSlice)();
            // abort request if already in flight
            if (prevSlice.loading) return;
            if (prevSlice.data && prevSlice.expiresAt && prevSlice.expiresAt > Date.now()) // if the resource is not expired, return the current data
            return;
            let loadingSlice = dispatch((0, $lOUVD.getPrefetchSlice)(type, key));
            if (!loadingSlice) loadingSlice = (0, $iGGIX.createLoadingSlice)({
                context: context,
                dependencies: ()=>dispatch((0, $dSu1v.getDependencies)(resource, routerStoreContext, options)),
                options: options,
                resource: resource,
                routerStoreContext: routerStoreContext
            });
            // save deferred value to be used also by dependents
            dispatch((0, $lOUVD.setPrefetchSlice)(type, key, loadingSlice));
            // trigger dependent resources to also prefetch
            dispatch((0, $dSu1v.executeForDependents)(resource, (dependentResource)=>$df78c3e374ea9484$export$3f1be494d407b77a.prefetchResourceFromRemote(dependentResource, routerStoreContext, options)));
        }
};
const $df78c3e374ea9484$export$e324594224ef24da = {
    /**
	 * Clears a resource for the current key, or where context is not provided all keys.
	 * Execute such that dependencies on current route will be cleared.
	 */ clearResource: (resource, routerStoreContext)=>(0, $dSu1v.actionWithDependencies)(routerStoreContext?.route?.resources, resource, $df78c3e374ea9484$export$3f1be494d407b77a.clearResource(resource, routerStoreContext ?? null)),
    /**
	 * Update the data property for a resource in the cache and reset expiresAt based
	 * on maxAge.
	 * Execute such that dependencies on current route will be updated.
	 */ updateResourceState: (resource, routerStoreContext, getNewSliceData)=>(0, $dSu1v.actionWithDependencies)(routerStoreContext.route.resources, resource, $df78c3e374ea9484$export$3f1be494d407b77a.updateResourceState(resource, routerStoreContext, getNewSliceData)),
    /**
	 * Get a single resource, either from the cache if it exists and has not expired, or
	 * the remote if it has expired.
	 * Execute such that dependencies on current route will be updated.
	 */ getResource: (resource, routerStoreContext, options)=>(0, $dSu1v.actionWithDependencies)(routerStoreContext.route.resources, resource, $df78c3e374ea9484$export$3f1be494d407b77a.getResource(resource, routerStoreContext, options)),
    /**
	 * Request a single resource and update the resource cache.
	 * Execute such that dependencies on current route will be updated.
	 */ getResourceFromRemote: (resource, routerStoreContext, options)=>(0, $dSu1v.actionWithDependencies)(routerStoreContext.route.resources, resource, $df78c3e374ea9484$export$3f1be494d407b77a.getResourceFromRemote(resource, routerStoreContext, options)),
    /**
	 * Request all resources.
	 */ requestAllResources: (routerStoreContext, options = {})=>({ dispatch: dispatch })=>{
            const { route: routeDefault } = routerStoreContext || {};
            const route = routeDefault;
            if (!route || !route.resources) return Promise.all([]);
            return Promise.all(dispatch($df78c3e374ea9484$export$e324594224ef24da.requestResources(route.resources, routerStoreContext, options)));
        },
    /**
	 * Cleans expired resources and resets them back to their initial state.
	 * We need to do this when transitioning into a route.
	 */ cleanExpiredResources: (resources, routerStoreContext)=>({ getState: getState, dispatch: dispatch })=>{
            const { context: resourceContext } = getState();
            resources.forEach((resource)=>{
                const { type: type, getKey: getKey } = resource;
                const key = getKey(routerStoreContext, resourceContext);
                const slice = dispatch((0, $lOUVD.getResourceState)(type, key));
                if (slice && (!slice.expiresAt || slice.expiresAt < Date.now())) dispatch((0, $lOUVD.deleteResourceState)(type, key));
            });
        },
    /**
	 * Requests a specific set of resources.
	 */ requestResources: (resources, routerStoreContext, options)=>{
        const { onlyGetCritical: onlyGetCritical } = options;
        const predicate = (0, $5ZRFW.isServerEnvironment)() ? ({ isBrowserOnly: isBrowserOnly, isCritical: isCritical })=>{
            if (isBrowserOnly) return false;
            /*
					 * Cookie circuit breaker logic - when cookie circuit breaker is OPEN we pass
					 * the onlyGetCritical parameter so that the request doesn't time out
					 * */ // resource is critical, always return
            if (isCritical) return true;
            // resource is not critical and onlyGetCritical option has been passed
            if (onlyGetCritical) return false;
            return true;
        } : ({ skipBrowser: skipBrowser })=>!skipBrowser;
        return (0, $dSu1v.mapActionWithDependencies)(routerStoreContext.route.resources?.filter(predicate), resources.filter(predicate), (resource)=>$df78c3e374ea9484$export$3f1be494d407b77a.getResource(resource, routerStoreContext, options));
    },
    /**
	 * Prefetch a specific set of resources.
	 */ prefetchResources: (resources, routerStoreContext, options)=>(0, $dSu1v.mapActionWithDependencies)(routerStoreContext.route.resources, resources, (resource)=>$df78c3e374ea9484$export$3f1be494d407b77a.prefetchResourceFromRemote(resource, routerStoreContext, {
                ...options,
                prefetch: true
            })),
    /**
	 * Hydrates the store with state.
	 * Will not override pre-hydrated state.
	 */ hydrate: ({ resourceData: resourceData, resourceContext: resourceContext })=>({ getState: getState, setState: setState })=>{
            const { data: data, context: context } = getState();
            function getNextStateValue(prev, next) {
                if (!Object.keys(prev).length && next && Object.keys(next).length) return next;
                return prev;
            }
            const hydratedData = (0, $kmBPv.transformData)(getNextStateValue(data, resourceData), ({ error: error, expiresAt: expiresAt, loading: loading, ...rest })=>{
                const deserializedError = !error ? null : (0, $glYDH.deserializeError)(error);
                const isTimeoutError = deserializedError?.name === 'TimeoutError';
                return {
                    ...rest,
                    expiresAt: isTimeoutError ? Date.now() - 1 : expiresAt,
                    loading: isTimeoutError ? false : loading,
                    error: deserializedError
                };
            });
            setState({
                data: hydratedData,
                context: getNextStateValue(context, resourceContext)
            });
        },
    /**
	 * Gets the store's context
	 */ getContext: ()=>({ getState: getState })=>getState().context,
    /**
	 * Returns safe, portable and rehydratable data.
	 */ getSafeData: ()=>({ getState: getState })=>(0, $kmBPv.transformData)(getState().data, ({ data: data, key: key, error: error, loading: loading })=>({
                    data: data,
                    key: key,
                    promise: null,
                    expiresAt: null,
                    accessedAt: null,
                    error: !error ? null : (0, $glYDH.serializeError)(error instanceof Error ? error : new Error(JSON.stringify(error))),
                    loading: error instanceof (0, $la6KB.TimeoutError) ? loading : false
                }))
};
const $df78c3e374ea9484$export$94f50dade551bd01 = (0, $GtRbT.createStore)({
    initialState: {
        data: {},
        context: {},
        executing: null,
        prefetching: null
    },
    actions: $df78c3e374ea9484$export$e324594224ef24da,
    name: 'router-resources'
});
const $df78c3e374ea9484$export$cc90fb9c37c5589d = (0, $6E16M.createContainer)($df78c3e374ea9484$export$94f50dade551bd01, {
    displayName: 'ResourceContainer'
});
const $df78c3e374ea9484$export$fee1a6213543bd78 = (0, $ht3nQ.createSubscriber)($df78c3e374ea9484$export$94f50dade551bd01, {
    displayName: 'ResourceSelectorSubscriber',
    selector: (state, props)=>(0, $304ta.getSliceForResource)(state, {
            type: props.resourceType,
            key: props.resourceKey
        })
});
const $df78c3e374ea9484$export$6f6057d42352becb = ()=>// @ts-ignore not providing a scopeId param
    (0, $14kUX.defaultRegistry).getStore($df78c3e374ea9484$export$94f50dade551bd01);
const $df78c3e374ea9484$export$ac3608e0bb357c7 = (0, $iJq0l.createHook)($df78c3e374ea9484$export$94f50dade551bd01, {
    selector: (0, $304ta.getSliceForResource)
});
const $df78c3e374ea9484$export$98e41a62c9bef75e = (0, $iJq0l.createActionsHook)($df78c3e374ea9484$export$94f50dade551bd01);
const $df78c3e374ea9484$export$e59f52df235ac7b3 = (0, $iJq0l.createHook)($df78c3e374ea9484$export$94f50dade551bd01, {
    selector: (0, $304ta.getResourceStoreContext)
});

});
parcelRegister("304ta", function(module, exports) {
$parcel$export(module.exports, "getSliceForResource", () => $60217f456defcef0$export$c9ed509724feb827);
$parcel$export(module.exports, "getResourceStoreContext", () => $60217f456defcef0$export$6a0b1779210de0ee);

var $gCUyT = parcelRequire("gCUyT");
const $60217f456defcef0$var$defaultStateSlice = (0, $gCUyT.getDefaultStateSlice)();
const $60217f456defcef0$export$c9ed509724feb827 = (state, props)=>{
    const { type: type, key: key } = props;
    const slice = state.data[type] && state.data[type][key];
    // The return of this needs to be stable object references - no cloning/spreading or new objects
    // otherwise it will cause re-renders in components that use this selector
    return slice || $60217f456defcef0$var$defaultStateSlice;
};
const $60217f456defcef0$export$6a0b1779210de0ee = (state)=>state.context;

});
parcelRegister("gCUyT", function(module, exports) {
$parcel$export(module.exports, "getDefaultStateSlice", () => $fabcd6254ae2e581$export$fa8e33c3301e2e94);

var $k3E37 = parcelRequire("k3E37");


var $1lL1f = parcelRequire("1lL1f");

var $lh0kQ = parcelRequire("lh0kQ");
const $fabcd6254ae2e581$export$fa8e33c3301e2e94 = ()=>({
        ...(0, $lh0kQ.BASE_DEFAULT_STATE_SLICE),
        expiresAt: (0, $1lL1f.getExpiresAt)((0, $3a6f6559ec260003$export$12c1dc38ea1692da)),
        accessedAt: (0, $k3E37.getAccessedAt)()
    });

});
parcelRegister("k3E37", function(module, exports) {
$parcel$export(module.exports, "getAccessedAt", () => $f182f079e91569e0$export$9ccb639b7a119f61);
const $f182f079e91569e0$export$9ccb639b7a119f61 = ()=>Date.now();

});

const $3a6f6559ec260003$export$881d135f98d8d7d0 = 100;
const $3a6f6559ec260003$export$9ab5bdcb8a1d6c34 = false;
const $3a6f6559ec260003$export$f267d0e9ab3eb265 = false;
const $3a6f6559ec260003$export$12c1dc38ea1692da = 0;
const $3a6f6559ec260003$export$c6d9b82b8528dcc3 = false;

parcelRegister("1lL1f", function(module, exports) {
$parcel$export(module.exports, "getExpiresAt", () => $97ea51069ab49170$export$b65d7ba7fbf150f1);
$parcel$export(module.exports, "setExpiresAt", () => $97ea51069ab49170$export$18d1d420fd588368);
const $97ea51069ab49170$export$b65d7ba7fbf150f1 = (maxAge)=>Date.now() + maxAge;
const $97ea51069ab49170$export$18d1d420fd588368 = (slice, maxAge)=>slice.expiresAt === null ? {
        ...slice,
        expiresAt: $97ea51069ab49170$export$b65d7ba7fbf150f1(maxAge)
    } : slice;

});

parcelRegister("lh0kQ", function(module, exports) {
$parcel$export(module.exports, "BASE_DEFAULT_STATE_SLICE", () => $1456b128e6ed87fc$export$2df85a734ff5ed27);
/**
 * The base defaults which should be fed into any factory that needs to derive other props.
 */ const $1456b128e6ed87fc$export$2df85a734ff5ed27 = {
    data: null,
    error: null,
    loading: false,
    promise: null
};

});



parcelRegister("iGGIX", function(module, exports) {
$parcel$export(module.exports, "createLoadingSlice", () => $a6ab75bb5236060b$export$dc62515c8f0b52dd);


var $1lL1f = parcelRequire("1lL1f");

var $9ffu0 = parcelRequire("9ffu0");

var $la6KB = parcelRequire("la6KB");

var $f5uRt = parcelRequire("f5uRt");
function $a6ab75bb5236060b$export$dc62515c8f0b52dd({ context: context, dependencies: dependencies, options: options, resource: resource, routerStoreContext: routerStoreContext }) {
    const { type: type, getData: getData } = resource;
    const { prefetch: prefetch, timeout: timeout } = options;
    // hard errors in dependencies or getData are converted into softer async error
    let promiseOrData;
    try {
        promiseOrData = getData({
            ...routerStoreContext,
            isPrefetch: !!prefetch,
            dependencies: dependencies()
        }, context);
    } catch (error) {
        promiseOrData = Promise.reject(error);
    }
    // ensure the promise includes any timeout error
    const timeoutGuard = timeout ? (0, $9ffu0.generateTimeGuard)(timeout) : null;
    // check if getData was sync, by looking for a Promise-like shape
    const data = typeof promiseOrData?.then === 'function' ? undefined : promiseOrData;
    // eslint-disable-next-line no-nested-ternary
    const promise = timeout ? Promise.race([
        promiseOrData,
        timeoutGuard?.promise
    ]).then((maybeData)=>{
        if (timeoutGuard && !timeoutGuard.isPending) throw new (0, $la6KB.TimeoutError)(type);
        timeoutGuard?.timerId && clearTimeout(timeoutGuard.timerId);
        return maybeData;
    }) : data !== undefined ? Promise.resolve(data) : promiseOrData;
    const resourceMaxAge = (0, $1lL1f.getExpiresAt)(resource.maxAge ?? (0, $3a6f6559ec260003$export$12c1dc38ea1692da));
    return {
        promise: promise,
        data: data,
        expiresAt: prefetch ? Math.max(resourceMaxAge, (0, $1lL1f.getExpiresAt)((0, $f5uRt.DEFAULT_PREFETCH_MAX_AGE))) : resourceMaxAge
    };
}

});
parcelRegister("9ffu0", function(module, exports) {
$parcel$export(module.exports, "generateTimeGuard", () => $ab08893489dc5a13$export$58634b3a58ae66b7);
const $ab08893489dc5a13$export$58634b3a58ae66b7 = (duration)=>{
    const promiseState = {
        timerId: null,
        isPending: true,
        promise: undefined
    };
    promiseState.promise = new Promise((r)=>{
        const timerId = setTimeout(()=>{
            promiseState.isPending = false;
            r();
        }, duration);
        promiseState.timerId = timerId;
    });
    return promiseState;
};

});

parcelRegister("la6KB", function(module, exports) {
$parcel$export(module.exports, "TimeoutError", () => $6ccf999d1f6c7977$export$66d311bf29d5c89c);
class $6ccf999d1f6c7977$export$66d311bf29d5c89c extends Error {
    constructor(message){
        super(`Resource timed out: ${message}`);
        this.name = 'TimeoutError';
    }
}

});

parcelRegister("f5uRt", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_PREFETCH_MAX_AGE", () => $93aac161d3c61089$export$37d3126be6549b13);
const $93aac161d3c61089$export$37d3126be6549b13 = 10000;

});


parcelRegister("dSu1v", function(module, exports) {
$parcel$export(module.exports, "ResourceDependencyError", () => $7cd4a0ebb7e273c9$export$492ad57edfe1e919);
$parcel$export(module.exports, "actionWithDependencies", () => $7cd4a0ebb7e273c9$export$5f7e1fd85734e71e);
$parcel$export(module.exports, "mapActionWithDependencies", () => $7cd4a0ebb7e273c9$export$f71a65c89c987a02);
$parcel$export(module.exports, "executeForDependents", () => $7cd4a0ebb7e273c9$export$7d1ffac63c68405d);
$parcel$export(module.exports, "getDependencies", () => $7cd4a0ebb7e273c9$export$75915f81f2a6540a);

var $gCUyT = parcelRequire("gCUyT");

var $lOUVD = parcelRequire("lOUVD");
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/fromEntries
const $7cd4a0ebb7e273c9$var$fromEntries = Object.fromEntries ?? ((entries)=>Object.assign({}, ...entries.map(([k, v])=>({
            [k]: v
        }))));
const $7cd4a0ebb7e273c9$var$matchType = (a)=>(b)=>{
        const [{ type: typeA }] = Array.isArray(a) ? a : [
            a
        ];
        const [{ type: typeB }] = Array.isArray(b) ? b : [
            b
        ];
        return typeA === typeB;
    };
class $7cd4a0ebb7e273c9$export$492ad57edfe1e919 extends Error {
    constructor(message){
        super(message);
        this.name = 'ResourceDependencyError';
    }
}
const $7cd4a0ebb7e273c9$export$12600f2e0e7fb2cc = (routeResources, tuples)=>({ getState: getState, setState: setState, dispatch: dispatch })=>{
        if (getState().executing) throw new Error('execution is already in progress');
        // check if there are resources and if so if there are any resources with dependencies
        const hasDependentResources = routeResources?.some(({ depends: depends })=>depends?.length) ?? false;
        if (!hasDependentResources) return tuples.map(([, action])=>dispatch(action));
        // some resources might not be listed on the route resources so must be dispatched separate from executing state
        const listedTuples = tuples.filter(([resource])=>routeResources?.some($7cd4a0ebb7e273c9$var$matchType(resource)));
        if (listedTuples.length === 0) return tuples.map(([, action])=>dispatch(action));
        // accumulate the dependency types for all executing resources
        // find downstream resources that may also execute and include their dependencies too
        // include the resource type as well in the list
        // we don't validate that these are legal dependencies
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const [dependentTypes] = routeResources.reduce((acc, { type: type, depends: depends })=>{
            const [dependencies, executableTypes] = acc;
            const isExecutable = executableTypes.includes(type) || !!depends?.some((dependency)=>executableTypes.includes(dependency));
            return isExecutable ? [
                depends ? [
                    ...dependencies,
                    ...depends,
                    type
                ] : dependencies,
                [
                    ...executableTypes,
                    type
                ]
            ] : acc;
        }, [
            [],
            listedTuples.map(([{ type: type }])=>type)
        ]).filter((v, i, a)=>a.indexOf(v) === i);
        // resources that are completely independent are preferable to be dispatched separate from executing state
        const dependentTuples = listedTuples.filter(([{ type: type }])=>dependentTypes.includes(type));
        if (dependentTuples.length === 0) return tuples.map(([, action])=>dispatch(action));
        // additionally find all direct dependencies of these executing or possibly executing resources
        // we don't validate that these are legal dependencies
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const dependentAndDependencyTypes = routeResources.filter(({ type: type })=>dependentTypes.includes(type)).reduce((acc, { type: type, depends: depends })=>{
            if (depends) acc.push(...depends);
            acc.push(type);
            return acc;
        }, []).filter((v, i, a)=>a.indexOf(v) === i);
        // setup executing tuples in route resource order
        // this state allows actions to call executeForDependents() to influence actions that follow
        // the list includes dependency resources so that getDependencies() may validate without needing route resources
        // we use the resource definition of the given tuple where present or otherwise the definition from route resources
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const executingTuples = routeResources.filter(({ type: type })=>dependentAndDependencyTypes.includes(type)).map((resource)=>tuples.find($7cd4a0ebb7e273c9$var$matchType(resource)) ?? [
                resource,
                null
            ]);
        setState({
            executing: executingTuples
        });
        // dispatch sequentially during which executeForDependents() can cause tuples to change
        const executedResults = executingTuples.map(([{ type: expectedType }], i)=>{
            const latestTuple = getState().executing?.[i];
            const [{ type: latestType }, maybeAction] = latestTuple ?? [
                {}
            ];
            if (latestType !== expectedType) {
                setState({
                    executing: null
                });
                throw new Error('execution reached an inconsistent state');
            }
            return maybeAction ? dispatch(maybeAction) : undefined;
        });
        setState({
            executing: null
        });
        // pick existing execution result or dispatch any remaining independent actions
        return tuples.map(([resource, action])=>{
            const index = executingTuples.findIndex($7cd4a0ebb7e273c9$var$matchType(resource));
            return index < 0 ? dispatch(action) : executedResults[index];
        });
    };
const $7cd4a0ebb7e273c9$export$5f7e1fd85734e71e = (routeResources, resource, action)=>({ dispatch: dispatch })=>dispatch($7cd4a0ebb7e273c9$export$12600f2e0e7fb2cc(routeResources, [
            [
                resource,
                action
            ]
        ]))[0];
const $7cd4a0ebb7e273c9$export$f71a65c89c987a02 = (routeResources, resources, actionCreator)=>$7cd4a0ebb7e273c9$export$12600f2e0e7fb2cc(routeResources, resources.map((resource)=>[
            resource,
            actionCreator(resource)
        ]));
const $7cd4a0ebb7e273c9$export$7d1ffac63c68405d = (resource, actionCreator)=>({ getState: getState, setState: setState })=>{
        const { executing: tuples } = getState();
        // find the given resource in the currently executing tuples
        const indexForResource = tuples?.findIndex($7cd4a0ebb7e273c9$var$matchType(resource)) ?? -1;
        if (indexForResource < 0) return;
        // find dependent resources following given resource and revise their action
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const executing = tuples.map((tuple, i)=>{
            const [tupleResource] = tuple;
            return i > indexForResource && tupleResource.depends?.includes(resource.type) ? [
                tupleResource,
                actionCreator(tupleResource)
            ] : tuple;
        });
        setState({
            executing: executing
        });
    };
const $7cd4a0ebb7e273c9$export$75915f81f2a6540a = (resource, routerStoreContext, options)=>({ getState: getState, dispatch: dispatch })=>{
        const { type: type, depends: depends } = resource;
        // optimise the case of no dependencies
        if (!depends?.length) return {};
        const { executing: tuples, context: resourceStoreContext } = getState();
        // dependent resource cannot be called outside execution state
        // find the given resource type in the currently executing tuples
        const indexForResource = tuples?.findIndex($7cd4a0ebb7e273c9$var$matchType(resource)) ?? -1;
        if (indexForResource < 0) throw new $7cd4a0ebb7e273c9$export$492ad57edfe1e919(`Missing resource: "${type}" has dependencies so must not be missing`);
        // find tuples index for all the dependency elements
        const dependencyIndexTuples = depends.map(// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (dependency)=>[
                dependency,
                tuples.findIndex($7cd4a0ebb7e273c9$var$matchType({
                    type: dependency
                }))
            ]);
        // we rely on executing tuples including all dependencies of the caller resource
        dependencyIndexTuples.forEach(([dependency, index])=>{
            if (index < 0) throw new $7cd4a0ebb7e273c9$export$492ad57edfe1e919(`Missing resource: "${type}" depends "${dependency}" which is missing`);
            if (index > indexForResource) throw new $7cd4a0ebb7e273c9$export$492ad57edfe1e919(`Illegal dependency: "${type}" depends "${dependency}" so "${dependency}" must precede "${type}"`);
        });
        return $7cd4a0ebb7e273c9$var$fromEntries(dependencyIndexTuples.map(([dependencyType, index])=>{
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const { getKey: getKey } = tuples[index][0];
            const key = getKey(routerStoreContext, resourceStoreContext);
            let slice = dispatch((0, $lOUVD.getResourceState)(dependencyType, key)) || (0, $gCUyT.getDefaultStateSlice)();
            // when prefetching we provide only the promise to dependands
            const prefetchSlice = options.prefetch ? dispatch((0, $lOUVD.getPrefetchSlice)(dependencyType, key)) : undefined;
            if (prefetchSlice) slice = {
                ...slice,
                // not spreading prefetchSlice to persist previous slice data
                promise: prefetchSlice.promise,
                expiresAt: prefetchSlice.expiresAt,
                loading: true
            };
            return [
                dependencyType,
                slice
            ];
        }));
    };

});
parcelRegister("lOUVD", function(module, exports) {
$parcel$export(module.exports, "getPrefetchSlice", () => $5d9ef66c037e7d73$export$11374758be89e40);
$parcel$export(module.exports, "setPrefetchSlice", () => $5d9ef66c037e7d73$export$1e32615dc8354436);
$parcel$export(module.exports, "setResourceState", () => $5d9ef66c037e7d73$export$704f800f263b050e);
$parcel$export(module.exports, "getResourceState", () => $5d9ef66c037e7d73$export$5fc90c33b03fffb);
$parcel$export(module.exports, "deleteResourceState", () => $5d9ef66c037e7d73$export$d40f35dc5952864b);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $5d9ef66c037e7d73$export$11374758be89e40 = (type, key)=>({ getState: getState })=>{
        const { prefetching: prefetching } = getState();
        const slice = prefetching?.[type]?.[key];
        // check if slice is still fresh
        if (slice && Date.now() < Number(slice.expiresAt)) return slice;
        return undefined;
    };
const $5d9ef66c037e7d73$export$1e32615dc8354436 = (type, key, slice)=>({ setState: setState, getState: getState })=>{
        const { prefetching: prefetching } = getState();
        // avoid doing extra set if same value
        if (prefetching?.[type]?.[key] === slice) return;
        // cheap optimisation to provide prefetched result syncronously
        slice?.promise?.then((maybeData)=>{
            // eslint-disable-next-line no-param-reassign
            slice.data = maybeData;
        });
        setState({
            prefetching: {
                ...prefetching,
                [type]: {
                    ...prefetching?.[type],
                    [key]: slice
                }
            }
        });
    };
const $5d9ef66c037e7d73$export$704f800f263b050e = (type, key, state)=>({ setState: setState, getState: getState, dispatch: dispatch })=>{
        const { data: data } = getState();
        // every time we override a resource we kill its prefetched
        dispatch($5d9ef66c037e7d73$export$1e32615dc8354436(type, key, undefined));
        setState({
            data: {
                ...data,
                [type]: {
                    ...data[type] || {},
                    [key]: state
                }
            }
        });
    };
const $5d9ef66c037e7d73$export$5fc90c33b03fffb = (type, key)=>({ getState: getState })=>{
        const { data: { [type]: resourceDataForType } } = getState();
        return resourceDataForType?.[key];
    };
const $5d9ef66c037e7d73$export$d40f35dc5952864b = (type, key)=>({ getState: getState, setState: setState })=>{
        const { data: data } = getState();
        const { [type]: resourceForType, ...remainingData } = data;
        if (key === undefined) setState({
            data: remainingData
        });
        else if (resourceForType) {
            const { [key]: _, ...remainingForType } = resourceForType;
            setState({
                data: {
                    ...remainingData,
                    [type]: remainingForType
                }
            });
        }
    };

});


parcelRegister("7lv26", function(module, exports) {
$parcel$export(module.exports, "validateLRUCache", () => $7c12c431bcf80a87$export$89440b7623c2c75c);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $lOUVD = parcelRequire("lOUVD");
const $7c12c431bcf80a87$export$65824bf86829963 = (routeResourceDataForType, currentKey)=>Object.keys(routeResourceDataForType).filter((resourceDataKey)=>{
        const { [resourceDataKey]: { expiresAt: expiresAt } } = routeResourceDataForType;
        return resourceDataKey !== currentKey && expiresAt && expiresAt <= Date.now();
    });
const $7c12c431bcf80a87$export$6288d3096045088f = (maxCache, resourceDataForType, currentKey)=>{
    if (maxCache === Infinity || maxCache < 1) return null;
    const resourceDataKeys = Object.keys(resourceDataForType);
    if (resourceDataKeys.length < maxCache) return null;
    const expiredResourceDataKeys = $7c12c431bcf80a87$export$65824bf86829963(resourceDataForType, currentKey);
    if (expiredResourceDataKeys.length > 0) return expiredResourceDataKeys[0];
    return resourceDataKeys.reduce((leastRecentKey, key)=>{
        const { [key]: { accessedAt: accessedAt }, [leastRecentKey]: { accessedAt: leastRecentAccessedAt } } = resourceDataForType;
        if (accessedAt && leastRecentAccessedAt && accessedAt < leastRecentAccessedAt) return key;
        return leastRecentKey;
    }, resourceDataKeys[0]);
};
const $7c12c431bcf80a87$export$89440b7623c2c75c = (resource, key)=>({ getState: getState, dispatch: dispatch })=>{
        const { type: type, maxCache: maxCache } = resource;
        const { data: { [type]: resourceDataForType } } = getState();
        if (!resourceDataForType) return;
        const keyTobeDeleted = $7c12c431bcf80a87$export$6288d3096045088f(maxCache, resourceDataForType, key);
        if (!keyTobeDeleted) return;
        dispatch((0, $lOUVD.deleteResourceState)(type, keyTobeDeleted));
    };

});

parcelRegister("glYDH", function(module, exports) {
$parcel$export(module.exports, "serializeError", () => $c3115195571617e9$export$46ff38bc6bdea8fb);
$parcel$export(module.exports, "deserializeError", () => $c3115195571617e9$export$64cddc1e268e9046);
// NOTE! This has been copy pasted from https://github.com/sindresorhus/serialize-error/blob/master/index.js
// When the router moves to its own package, this must become a dependency
// For now, we have put it here so that we don't need to get it included in Jira's vendor bundle
class $c3115195571617e9$var$NonError extends Error {
    constructor(message){
        super(message);
        this.name = 'NonError';
        if (Error.captureStackTrace) Error.captureStackTrace(this, $c3115195571617e9$var$NonError);
    }
}
const $c3115195571617e9$var$commonProperties = [
    'name',
    'message',
    'stack',
    'code'
];
const $c3115195571617e9$var$destroyCircular = (from, seen, to_)=>{
    const to = to_ || (Array.isArray(from) ? [] : {});
    seen.push(from);
    for (const [key, value] of Object.entries(from)){
        if (typeof value === 'function') continue;
        if (!value || typeof value !== 'object') {
            to[key] = value;
            continue;
        }
        if (!seen.includes(from[key])) {
            to[key] = $c3115195571617e9$var$destroyCircular(from[key], seen.slice());
            continue;
        }
        to[key] = '[Circular]';
    }
    for (const property of $c3115195571617e9$var$commonProperties)if (typeof from[property] === 'string') to[property] = from[property];
    return to;
};
const $c3115195571617e9$export$46ff38bc6bdea8fb = (value)=>{
    if (typeof value === 'object' && value !== null) return $c3115195571617e9$var$destroyCircular(value, []);
    // People sometimes throw things besides Error objects…
    if (typeof value === 'function') // `JSON.stringify()` discards functions. We do too, unless a function is thrown directly.
    return `[Function: ${value.name || 'anonymous'}]`;
    return value;
};
const $c3115195571617e9$export$64cddc1e268e9046 = (value)=>{
    if (value instanceof Error) return value;
    if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
        const newError = new Error();
        $c3115195571617e9$var$destroyCircular(value, [], newError);
        return newError;
    }
    return new $c3115195571617e9$var$NonError(value);
};

});

parcelRegister("hc6Iv", function(module, exports) {
$parcel$export(module.exports, "isFromSsr", () => $d1d47bae016e23af$export$b25d2963b8a3488a);
$parcel$export(module.exports, "shouldUseCache", () => $d1d47bae016e23af$export$399de8c43d0ece3c);
const $d1d47bae016e23af$export$b25d2963b8a3488a = ({ expiresAt: expiresAt })=>expiresAt === null;
const $d1d47bae016e23af$var$isFresh = (resource)=>{
    if ($d1d47bae016e23af$export$b25d2963b8a3488a(resource)) return true;
    return Date.now() < Number(resource.expiresAt);
};
const $d1d47bae016e23af$export$399de8c43d0ece3c = (resource)=>{
    if (resource?.error?.name === 'TimeoutError') return false;
    if (resource.loading) return true;
    if ($d1d47bae016e23af$var$isFresh(resource)) return true;
    return false;
};

});

parcelRegister("4TaPc", function(module, exports) {
$parcel$export(module.exports, "setSsrDataPromise", () => $8c899c45263ea53d$export$2e4da1b414980956);
const $8c899c45263ea53d$export$2e4da1b414980956 = (slice)=>slice.promise === null ? {
        ...slice,
        promise: Promise.resolve(slice.data)
    } : slice;

});

parcelRegister("kmBPv", function(module, exports) {
$parcel$export(module.exports, "transformData", () => $6ad233edd212123d$export$3ceb62baab058c6b);
const $6ad233edd212123d$export$3ceb62baab058c6b = (data, transformer)=>Object.keys(data).reduce((acc, type)=>{
        if (!acc[type]) acc[type] = {};
        Object.keys(data[type]).forEach((key)=>{
            const slice = data[type][key];
            acc[type][key] = transformer(slice);
        });
        return acc;
    }, {});

});


parcelRegister("l1VxS", function(module, exports) {
$parcel$export(module.exports, "createResource", () => $f320aadf7554ca3a$export$edd172c6c83c39cc);

const $f320aadf7554ca3a$var$handleGetDataLoader = (asyncImport)=>async (...args)=>{
        const { default: getDataFn } = await asyncImport();
        return getDataFn(...args);
    };
const $f320aadf7554ca3a$export$edd172c6c83c39cc = (arg)=>({
        type: arg.type,
        getKey: arg.getKey,
        getData: arg.getData ?? $f320aadf7554ca3a$var$handleGetDataLoader(arg.getDataLoader),
        maxAge: typeof arg.maxAge === 'number' ? arg.maxAge : (0, $3a6f6559ec260003$export$12c1dc38ea1692da),
        maxCache: typeof arg.maxCache === 'number' ? arg.maxCache : (0, $3a6f6559ec260003$export$881d135f98d8d7d0),
        isBrowserOnly: typeof arg.isBrowserOnly === 'boolean' ? arg.isBrowserOnly : (0, $3a6f6559ec260003$export$9ab5bdcb8a1d6c34),
        skipBrowser: typeof arg.skipBrowser === 'boolean' ? arg.skipBrowser : (0, $3a6f6559ec260003$export$f267d0e9ab3eb265),
        depends: arg.depends ?? null,
        isCritical: typeof arg.isCritical === 'boolean' ? arg.isCritical : (0, $3a6f6559ec260003$export$c6d9b82b8528dcc3)
    });

});

parcelRegister("eJrcF", function(module, exports) {
$parcel$export(module.exports, "useResourceBase", () => $473329ba7e1a3704$export$2bfcb6c1e4488bac);
$parcel$export(module.exports, "useResource", () => $473329ba7e1a3704$export$9f6abfd74295843b);

var $eJOHy = parcelRequire("eJOHy");

var $iJq0l = parcelRequire("iJq0l");

var $4cTDP = parcelRequire("4cTDP");

var $kfvK2 = parcelRequire("kfvK2");

var $uCHeL = parcelRequire("uCHeL");
const $473329ba7e1a3704$export$2bfcb6c1e4488bac = (resource, options)=>{
    const actions = (0, $uCHeL.useResourceStoreActions)();
    const { getContext: getRouterContext } = (0, $kfvK2.useRouterStoreActions)();
    // Dynamically generate a router subscriber based on the resource:
    // makes the component re-render only when key changes instead of
    // after every route change
    const useKey = (0, $eJOHy.useMemo)(()=>(0, $iJq0l.createHook)((0, $kfvK2.RouterStore), {
            selector: ({ match: match, query: query, route: route }, keyArg)=>resource.getKey(keyArg != null ? keyArg : {
                    match: match,
                    query: query,
                    route: route
                }, actions.getContext())
        }), [
        resource,
        actions
    ]);
    // eslint-disable-next-line @typescript-eslint/no-non-null-asserted-optional-chain, @typescript-eslint/no-non-null-assertion
    const key = useKey(options?.routerContext)[0];
    const [slice] = (0, $uCHeL.useResourceStore)({
        type: resource.type,
        key: key
    });
    // we keep route context bound to key, so route context won't refresh
    // unless key changes. This allows refresh to be called on effect cleanup
    // or asynchronously, when route context might already have changed
    const routerContext = (0, $eJOHy.useMemo)(// eslint-disable-next-line @typescript-eslint/no-non-null-asserted-optional-chain, @typescript-eslint/no-non-null-assertion
    ()=>options?.routerContext || getRouterContext(), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        key
    ]);
    const update = (0, $eJOHy.useCallback)((updater)=>{
        actions.updateResourceState(resource, routerContext, updater);
    }, [
        resource,
        routerContext,
        actions
    ]);
    const clear = (0, $eJOHy.useCallback)(()=>{
        actions.clearResource(resource, routerContext);
    }, [
        resource,
        routerContext,
        actions
    ]);
    const clearAll = (0, $eJOHy.useCallback)(()=>{
        actions.clearResource(resource);
    }, [
        resource,
        actions
    ]);
    const refresh = (0, $eJOHy.useCallback)(()=>{
        actions.getResourceFromRemote(resource, routerContext, {
            prefetch: false
        });
    }, [
        resource,
        routerContext,
        actions
    ]);
    return (0, $eJOHy.useMemo)(()=>({
            ...slice,
            update: update,
            key: key,
            refresh: refresh,
            clear: clear,
            clearAll: clearAll
        }), [
        clear,
        clearAll,
        key,
        refresh,
        slice,
        update
    ]);
};
const $473329ba7e1a3704$export$e5bcff138e5b419e = (resource, options)=>{
    const state = $473329ba7e1a3704$export$2bfcb6c1e4488bac(resource, options);
    const { loading: loading, promise: promise } = state;
    if (loading && promise != null) throw promise;
    return state;
};
const $473329ba7e1a3704$export$9f6abfd74295843b = (resource, options)=>{
    return false && (0, $4cTDP.fg)('jfp-magma-resource-suspense-support') ? $473329ba7e1a3704$export$e5bcff138e5b419e(resource, options) : $473329ba7e1a3704$export$2bfcb6c1e4488bac(resource, options);
};

});

parcelRegister("95O7y", function(module, exports) {
$parcel$export(module.exports, "useQueryParam", () => $342a3c9e29557be5$export$ae316f0eeb712a36);

var $eJOHy = parcelRequire("eJOHy");

var $iJq0l = parcelRequire("iJq0l");

var $kfvK2 = parcelRequire("kfvK2");
const $342a3c9e29557be5$var$createQueryParamHook = (0, $iJq0l.createHook)((0, $kfvK2.RouterStore), {
    selector: ({ query: query }, { paramKey: paramKey })=>query[paramKey]
});
const $342a3c9e29557be5$export$ae316f0eeb712a36 = (paramKey)=>{
    const [paramVal, routerActions] = $342a3c9e29557be5$var$createQueryParamHook({
        paramKey: paramKey
    });
    const setQueryParam = (0, $eJOHy.useCallback)((newValue, updateType)=>{
        routerActions.updateQueryParam({
            [paramKey]: newValue
        }, updateType);
    }, [
        paramKey,
        routerActions
    ]);
    return [
        paramVal,
        setQueryParam
    ];
};

});

parcelRegister("2FqDG", function(module, exports) {
$parcel$export(module.exports, "usePathParam", () => $ff0e0a6ea6c84e64$export$8c8591dcd57728e6);

var $eJOHy = parcelRequire("eJOHy");

var $iJq0l = parcelRequire("iJq0l");

var $kfvK2 = parcelRequire("kfvK2");
const $ff0e0a6ea6c84e64$var$createPathParamHook = (0, $iJq0l.createHook)((0, $kfvK2.RouterStore), {
    selector: ({ match: { params: params } }, { paramKey: paramKey })=>params[paramKey]
});
const $ff0e0a6ea6c84e64$export$8c8591dcd57728e6 = (paramKey)=>{
    const [paramVal, routerActions] = $ff0e0a6ea6c84e64$var$createPathParamHook({
        paramKey: paramKey
    });
    const setPathParam = (0, $eJOHy.useCallback)((newValue, updateType)=>{
        routerActions.updatePathParam({
            [paramKey]: newValue
        }, updateType);
    }, [
        paramKey,
        routerActions
    ]);
    return [
        paramVal,
        setPathParam
    ];
};

});

parcelRegister("2Ce3h", function(module, exports) {
$parcel$export(module.exports, "addResourcesListener", () => $84ea0bf8bf5572de$export$dee7bf9fc0ff48c3);

var $uCHeL = parcelRequire("uCHeL");
const $84ea0bf8bf5572de$export$dee7bf9fc0ff48c3 = (fn)=>(0, $uCHeL.getResourceStore)().storeState.subscribe(fn);

});

parcelRegister("ivzXw", function(module, exports) {
$parcel$export(module.exports, "RouterSubscriber", () => $cfb8c2b74bfc0921$export$672d721d310ff5f0);

var $eJOHy = parcelRequire("eJOHy");

var $5ZRFW = parcelRequire("5ZRFW");

var $kfvK2 = parcelRequire("kfvK2");
const $cfb8c2b74bfc0921$export$672d721d310ff5f0 = ({ children: children })=>{
    const [state, { listen: listen, ...actions }] = (0, $kfvK2.useRouterStore)();
    if (!state.unlisten && !(0, $5ZRFW.isServerEnvironment)()) listen();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children(state, actions));
};

});

parcelRegister("2mHfh", function(module, exports) {
$parcel$export(module.exports, "Redirect", () => $e969beef0b047328$export$2d8d895a0a0f636e);

var $eJOHy = parcelRequire("eJOHy");

var $fdDkm = parcelRequire("fdDkm");


var $GNVfd = parcelRequire("GNVfd");

var $gCY1z = parcelRequire("gCY1z");
// eslint-disable-next-line jira/react/no-class-components
class $e969beef0b047328$var$Redirector extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = {
            push: false
        };
    }
    componentDidMount() {
        const { to: to, location: location, push: push, params: params, query: query, actions: actions } = this.props;
        const routeAttributes = {
            params: params,
            query: query,
            basePath: actions.getBasePath()
        };
        const newPath = // eslint-disable-next-line no-nested-ternary
        typeof to === 'object' ? 'path' in to ? (0, $fdDkm.createPath)((0, $GNVfd.generateLocationFromPath)(to.path, routeAttributes)) : (0, $fdDkm.createPath)(to) : to;
        const currentPath = (0, $fdDkm.createPath)(location);
        const action = push ? actions.push : actions.replace;
        if (currentPath === newPath) return;
        action(newPath);
    }
    render() {
        return null;
    }
}
const $e969beef0b047328$export$c98fd7767e1bf30c = ({ to: to, params: params, query: query })=>{
    const getRedirectPath = ()=>{
        if (typeof to === 'string') return to;
        if ('path' in to) {
            const routeAttributes = {
                params: params,
                query: query
            };
            return (0, $fdDkm.createPath)((0, $GNVfd.generateLocationFromPath)(to.path, routeAttributes));
        }
        return (0, $fdDkm.createPath)(to);
    };
    const redirectPath = getRedirectPath();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("meta", {
        httpEquiv: "refresh",
        content: `0; url=${redirectPath}`,
        "data-testid": "@atlassian/react-resource-router.controllers.redirect.server-redirect-meta"
    });
};
const $e969beef0b047328$export$2d8d895a0a0f636e = (props)=>{
    const [{ location: location }, actions] = (0, $gCY1z.useRouter)();
    return (0, $9790b8dfe6f31c81$export$19d68f5aa485d903) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e969beef0b047328$export$c98fd7767e1bf30c, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e969beef0b047328$var$Redirector, {
        actions: actions,
        location: location,
        ...props
    });
};

});

parcelRegister("jJaSe", function(module, exports) {
$parcel$export(module.exports, "withRouter", () => $4d721bd0fe730a6c$export$369b6b2b30582e8e);

var $eJOHy = parcelRequire("eJOHy");

var $kfvK2 = parcelRequire("kfvK2");
const $4d721bd0fe730a6c$var$getWrappedComponentDisplayName = (component)=>{
    let componentDisplayName = 'UNDEFINED';
    const { displayName: displayName, name: name } = component;
    if (displayName) componentDisplayName = displayName;
    if (name) componentDisplayName = name;
    return `withRouter(${componentDisplayName})`;
};
const $4d721bd0fe730a6c$export$369b6b2b30582e8e = (WrappedComponent)=>{
    const displayName = $4d721bd0fe730a6c$var$getWrappedComponentDisplayName(WrappedComponent);
    const Component = WrappedComponent;
    const ComponentWithRouter = (props)=>{
        const [{ action: action, history: history, location: location, match: match, query: query, route: route }, { push: push, replace: replace }] = (0, $kfvK2.useRouterStore)();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Component, {
            ...props,
            action: action,
            history: history,
            location: location,
            match: match,
            push: push,
            query: query,
            replace: replace,
            route: route
        });
    };
    ComponentWithRouter.displayName = displayName;
    return ComponentWithRouter;
};

});

parcelRegister("bN0d5", function(module, exports) {
/*Copyright (c) 2020 Jason Zissman
Permission is hereby granted, free of charge, to any person obtaining a copy of
this software and associated documentation files (the "Software"), to deal in
the Software without restriction, including without limitation the rights to
use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of
the Software, and to permit persons to whom the Software is furnished to do so,
subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
*/ (()=>{
    ((root, factory)=>{
        if (0, module.exports) // CommonJS
        return module.exports = factory();
        else if (typeof define === 'function' && define.amd) // AMD
        define([], ()=>{
            return root.TimeMe = factory();
        });
        else // Global Variables
        return root.TimeMe = factory();
    })(module.exports, ()=>{
        let TimeMe = {
            startStopTimes: {},
            idleTimeoutMs: 30000,
            currentIdleTimeMs: 0,
            checkIdleStateRateMs: 250,
            isUserCurrentlyOnPage: true,
            isUserCurrentlyIdle: false,
            currentPageName: "default-page-name",
            timeElapsedCallbacks: [],
            userLeftCallbacks: [],
            userReturnCallbacks: [],
            trackTimeOnElement: (elementId)=>{
                let element = document.getElementById(elementId);
                if (element) {
                    element.addEventListener("mouseover", ()=>{
                        TimeMe.startTimer(elementId);
                    });
                    element.addEventListener("mousemove", ()=>{
                        TimeMe.startTimer(elementId);
                    });
                    element.addEventListener("mouseleave", ()=>{
                        TimeMe.stopTimer(elementId);
                    });
                    element.addEventListener("keypress", ()=>{
                        TimeMe.startTimer(elementId);
                    });
                    element.addEventListener("focus", ()=>{
                        TimeMe.startTimer(elementId);
                    });
                }
            },
            getTimeOnElementInSeconds: (elementId)=>{
                let time = TimeMe.getTimeOnPageInSeconds(elementId);
                if (time) return time;
                else return 0;
            },
            // startTime is optional. If provided, must be of type Date(). By providing
            // startTime, you are overriding the internal timing mechanism and manually
            // indicating the start time.
            startTimer: (pageName, startTime)=>{
                if (!pageName) pageName = TimeMe.currentPageName;
                if (TimeMe.startStopTimes[pageName] === undefined) TimeMe.startStopTimes[pageName] = [];
                else {
                    let arrayOfTimes = TimeMe.startStopTimes[pageName];
                    let latestStartStopEntry = arrayOfTimes[arrayOfTimes.length - 1];
                    if (latestStartStopEntry !== undefined && latestStartStopEntry.stopTime === undefined) // Can't start new timer until previous finishes.
                    return;
                }
                TimeMe.startStopTimes[pageName].push({
                    "startTime": startTime || new Date(),
                    "stopTime": undefined
                });
            },
            stopAllTimers: ()=>{
                let pageNames = Object.keys(TimeMe.startStopTimes);
                for(let i = 0; i < pageNames.length; i++)TimeMe.stopTimer(pageNames[i]);
            },
            // stopTime is optional. If provided, must be of type Date(). By providing
            // stopTime, you are overriding the internal timing mechanism and manually
            // indicating the stop time.
            stopTimer: (pageName, stopTime)=>{
                if (!pageName) pageName = TimeMe.currentPageName;
                let arrayOfTimes = TimeMe.startStopTimes[pageName];
                if (arrayOfTimes === undefined || arrayOfTimes.length === 0) // Can't stop timer before you've started it.
                return;
                if (arrayOfTimes[arrayOfTimes.length - 1].stopTime === undefined) arrayOfTimes[arrayOfTimes.length - 1].stopTime = stopTime || new Date();
            },
            getTimeOnCurrentPageInSeconds: ()=>{
                return TimeMe.getTimeOnPageInSeconds(TimeMe.currentPageName);
            },
            getTimeOnPageInSeconds: (pageName)=>{
                let timeInMs = TimeMe.getTimeOnPageInMilliseconds(pageName);
                if (timeInMs === undefined) return undefined;
                else return timeInMs / 1000;
            },
            getTimeOnCurrentPageInMilliseconds: ()=>{
                return TimeMe.getTimeOnPageInMilliseconds(TimeMe.currentPageName);
            },
            getTimeOnPageInMilliseconds: (pageName)=>{
                let totalTimeOnPage = 0;
                let arrayOfTimes = TimeMe.startStopTimes[pageName];
                if (arrayOfTimes === undefined) // Can't get time on page before you've started the timer.
                return;
                let timeSpentOnPageInSeconds = 0;
                for(let i = 0; i < arrayOfTimes.length; i++){
                    let startTime = arrayOfTimes[i].startTime;
                    let stopTime = arrayOfTimes[i].stopTime;
                    if (stopTime === undefined) stopTime = new Date();
                    let difference = stopTime - startTime;
                    timeSpentOnPageInSeconds += difference;
                }
                totalTimeOnPage = Number(timeSpentOnPageInSeconds);
                return totalTimeOnPage;
            },
            getTimeOnAllPagesInSeconds: ()=>{
                let allTimes = [];
                let pageNames = Object.keys(TimeMe.startStopTimes);
                for(let i = 0; i < pageNames.length; i++){
                    let pageName = pageNames[i];
                    let timeOnPage = TimeMe.getTimeOnPageInSeconds(pageName);
                    allTimes.push({
                        "pageName": pageName,
                        "timeOnPage": timeOnPage
                    });
                }
                return allTimes;
            },
            setIdleDurationInSeconds: (duration)=>{
                let durationFloat = parseFloat(duration);
                if (isNaN(durationFloat) === false) TimeMe.idleTimeoutMs = duration * 1000;
                else throw {
                    name: "InvalidDurationException",
                    message: "An invalid duration time (" + duration + ") was provided."
                };
            },
            setCurrentPageName: (pageName)=>{
                TimeMe.currentPageName = pageName;
            },
            resetRecordedPageTime: (pageName)=>{
                delete TimeMe.startStopTimes[pageName];
            },
            resetAllRecordedPageTimes: ()=>{
                let pageNames = Object.keys(TimeMe.startStopTimes);
                for(let i = 0; i < pageNames.length; i++)TimeMe.resetRecordedPageTime(pageNames[i]);
            },
            userActivityDetected: ()=>{
                if (TimeMe.isUserCurrentlyIdle) TimeMe.triggerUserHasReturned();
                TimeMe.resetIdleCountdown();
            },
            resetIdleCountdown: ()=>{
                TimeMe.isUserCurrentlyIdle = false;
                TimeMe.currentIdleTimeMs = 0;
            },
            callWhenUserLeaves: (callback, numberOfTimesToInvoke)=>{
                TimeMe.userLeftCallbacks.push({
                    callback: callback,
                    numberOfTimesToInvoke: numberOfTimesToInvoke
                });
            },
            callWhenUserReturns: (callback, numberOfTimesToInvoke)=>{
                TimeMe.userReturnCallbacks.push({
                    callback: callback,
                    numberOfTimesToInvoke: numberOfTimesToInvoke
                });
            },
            triggerUserHasReturned: ()=>{
                if (!TimeMe.isUserCurrentlyOnPage) {
                    TimeMe.isUserCurrentlyOnPage = true;
                    TimeMe.resetIdleCountdown();
                    for(let i = 0; i < TimeMe.userReturnCallbacks.length; i++){
                        let userReturnedCallback = TimeMe.userReturnCallbacks[i];
                        let numberTimes = userReturnedCallback.numberOfTimesToInvoke;
                        if (isNaN(numberTimes) || numberTimes === undefined || numberTimes > 0) {
                            userReturnedCallback.numberOfTimesToInvoke -= 1;
                            userReturnedCallback.callback();
                        }
                    }
                }
                TimeMe.startTimer();
            },
            // TODO - we are muddying the waters in between
            // 'user left page' and 'user gone idle'. Really should be
            // two separate concepts entirely. Need to break this into smaller  functions
            // for either scenario.
            triggerUserHasLeftPageOrGoneIdle: ()=>{
                if (TimeMe.isUserCurrentlyOnPage) {
                    TimeMe.isUserCurrentlyOnPage = false;
                    for(let i = 0; i < TimeMe.userLeftCallbacks.length; i++){
                        let userHasLeftCallback = TimeMe.userLeftCallbacks[i];
                        let numberTimes = userHasLeftCallback.numberOfTimesToInvoke;
                        if (isNaN(numberTimes) || numberTimes === undefined || numberTimes > 0) {
                            userHasLeftCallback.numberOfTimesToInvoke -= 1;
                            userHasLeftCallback.callback();
                        }
                    }
                }
                TimeMe.stopAllTimers();
            },
            callAfterTimeElapsedInSeconds: (timeInSeconds, callback)=>{
                TimeMe.timeElapsedCallbacks.push({
                    timeInSeconds: timeInSeconds,
                    callback: callback,
                    pending: true
                });
            },
            checkIdleState: ()=>{
                for(let i = 0; i < TimeMe.timeElapsedCallbacks.length; i++)if (TimeMe.timeElapsedCallbacks[i].pending && TimeMe.getTimeOnCurrentPageInSeconds() > TimeMe.timeElapsedCallbacks[i].timeInSeconds) {
                    TimeMe.timeElapsedCallbacks[i].callback();
                    TimeMe.timeElapsedCallbacks[i].pending = false;
                }
                if (TimeMe.isUserCurrentlyIdle === false && TimeMe.currentIdleTimeMs > TimeMe.idleTimeoutMs) {
                    TimeMe.isUserCurrentlyIdle = true;
                    TimeMe.triggerUserHasLeftPageOrGoneIdle();
                } else TimeMe.currentIdleTimeMs += TimeMe.checkIdleStateRateMs;
            },
            visibilityChangeEventName: undefined,
            hiddenPropName: undefined,
            listenForVisibilityEvents: (trackWhenUserLeavesPage, trackWhenUserGoesIdle)=>{
                if (trackWhenUserLeavesPage) TimeMe.listenForUserLeavesOrReturnsEvents();
                if (trackWhenUserGoesIdle) TimeMe.listForIdleEvents();
            },
            listenForUserLeavesOrReturnsEvents: ()=>{
                if (typeof document.hidden !== "undefined") {
                    TimeMe.hiddenPropName = "hidden";
                    TimeMe.visibilityChangeEventName = "visibilitychange";
                } else if (typeof document.mozHidden !== "undefined") {
                    TimeMe.hiddenPropName = "mozHidden";
                    TimeMe.visibilityChangeEventName = "mozvisibilitychange";
                } else if (typeof document.msHidden !== "undefined") {
                    TimeMe.hiddenPropName = "msHidden";
                    TimeMe.visibilityChangeEventName = "msvisibilitychange";
                } else if (typeof document.webkitHidden !== "undefined") {
                    TimeMe.hiddenPropName = "webkitHidden";
                    TimeMe.visibilityChangeEventName = "webkitvisibilitychange";
                }
                document.addEventListener(TimeMe.visibilityChangeEventName, ()=>{
                    if (document[TimeMe.hiddenPropName]) TimeMe.triggerUserHasLeftPageOrGoneIdle();
                    else TimeMe.triggerUserHasReturned();
                }, false);
                window.addEventListener('blur', ()=>{
                    TimeMe.triggerUserHasLeftPageOrGoneIdle();
                });
                window.addEventListener('focus', ()=>{
                    TimeMe.triggerUserHasReturned();
                });
            },
            listForIdleEvents: ()=>{
                document.addEventListener("mousemove", ()=>{
                    TimeMe.userActivityDetected();
                });
                document.addEventListener("keyup", ()=>{
                    TimeMe.userActivityDetected();
                });
                document.addEventListener("touchstart", ()=>{
                    TimeMe.userActivityDetected();
                });
                window.addEventListener("scroll", ()=>{
                    TimeMe.userActivityDetected();
                });
                setInterval(()=>{
                    if (TimeMe.isUserCurrentlyIdle !== true) TimeMe.checkIdleState();
                }, TimeMe.checkIdleStateRateMs);
            },
            websocket: undefined,
            websocketHost: undefined,
            setUpWebsocket: (websocketOptions)=>{
                if (window.WebSocket && websocketOptions) {
                    let websocketHost = websocketOptions.websocketHost; // "ws://hostname:port"
                    try {
                        TimeMe.websocket = new WebSocket(websocketHost);
                        window.onbeforeunload = ()=>{
                            TimeMe.sendCurrentTime(websocketOptions.appId);
                        };
                        TimeMe.websocket.onopen = ()=>{
                            TimeMe.sendInitWsRequest(websocketOptions.appId);
                        };
                        TimeMe.websocket.onerror = (error)=>{
                            if (console) console.log("Error occurred in websocket connection: " + error);
                        };
                        TimeMe.websocket.onmessage = (event)=>{
                            if (console) console.log(event.data);
                        };
                    } catch (error) {
                        if (console) console.error("Failed to connect to websocket host.  Error:" + error);
                    }
                }
            },
            websocketSend: (data)=>{
                TimeMe.websocket.send(JSON.stringify(data));
            },
            sendCurrentTime: (appId)=>{
                let timeSpentOnPage = TimeMe.getTimeOnCurrentPageInMilliseconds();
                let data = {
                    type: "INSERT_TIME",
                    appId: appId,
                    timeOnPageMs: timeSpentOnPage,
                    pageName: TimeMe.currentPageName
                };
                TimeMe.websocketSend(data);
            },
            sendInitWsRequest: (appId)=>{
                let data = {
                    type: "INIT",
                    appId: appId
                };
                TimeMe.websocketSend(data);
            },
            initialize: (options)=>{
                let idleTimeoutInSeconds = TimeMe.idleTimeoutMs || 30;
                let currentPageName = TimeMe.currentPageName || "default-page-name";
                let websocketOptions = undefined;
                let initialStartTime = undefined;
                let trackWhenUserLeavesPage = true;
                let trackWhenUserGoesIdle = true;
                if (options) {
                    idleTimeoutInSeconds = options.idleTimeoutInSeconds || idleTimeoutInSeconds;
                    currentPageName = options.currentPageName || currentPageName;
                    websocketOptions = options.websocketOptions;
                    initialStartTime = options.initialStartTime;
                    if (options.trackWhenUserLeavesPage === false) trackWhenUserLeavesPage = false;
                    if (options.trackWhenUserGoesIdle === false) trackWhenUserGoesIdle = false;
                }
                TimeMe.setIdleDurationInSeconds(idleTimeoutInSeconds);
                TimeMe.setCurrentPageName(currentPageName);
                TimeMe.setUpWebsocket(websocketOptions);
                TimeMe.listenForVisibilityEvents(trackWhenUserLeavesPage, trackWhenUserGoesIdle);
                // TODO - only do this if page currently visible.
                TimeMe.startTimer(undefined, initialStartTime);
            }
        };
        return TimeMe;
    });
}).call(module.exports);

});

parcelRegister("gKOiq", function(module, exports) {
$parcel$export(module.exports, "MemoryRouter", () => $51ab8e4ea9660c8e$export$ae46f04cfaffe093);

var $eJOHy = parcelRequire("eJOHy");

var $fdDkm = parcelRequire("fdDkm");

var $bkb9R = parcelRequire("bkb9R");
function $51ab8e4ea9660c8e$export$ae46f04cfaffe093(props) {
    const history = (0, $eJOHy.useMemo)(()=>(0, $fdDkm.createMemoryHistory)(props.location ? {
            initialEntries: [
                props.location
            ]
        } : {}), [
        props.location
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bkb9R.Router), {
        ...props,
        history: history,
        isGlobal: false,
        plugins: props?.plugins ?? []
    });
}

});

parcelRegister("9PBMj", function(module, exports) {
$parcel$export(module.exports, "RouteComponent", () => $6ffa28adf9a82e94$export$7903e4b73fc7d6c3);

var $eJOHy = parcelRequire("eJOHy");

var $gCY1z = parcelRequire("gCY1z");
const $6ffa28adf9a82e94$export$7903e4b73fc7d6c3 = ()=>{
    const [{ action: action, location: location, match: match, query: query, route: route }] = (0, $gCY1z.useRouter)();
    if (!route || !route.component) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(route.component, {
        action: action,
        location: location,
        match: match,
        query: query,
        route: route
    });
};

});

parcelRegister("lsam2", function(module, exports) {
$parcel$export(module.exports, "ResourceSubscriber", () => $a5bfceff07760b69$export$fee1a6213543bd78);

var $eJOHy = parcelRequire("eJOHy");

var $eJrcF = parcelRequire("eJrcF");
const $a5bfceff07760b69$export$fee1a6213543bd78 = ({ children: children, resource: resource, options: options })=>{
    const result = (0, $eJrcF.useResource)(resource, options);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children(result));
};

});

const $c9cb1b3997607889$export$ce553301d55c2fd8 = 'fedramp-moderate';
const $c9cb1b3997607889$export$f005e2e9f707cb5f = 'commercial';
const $c9cb1b3997607889$export$bd6b5a7802d76127 = 'fedramp-fedex';
const $c9cb1b3997607889$export$a739cd5aac835909 = 'stg';
const $c9cb1b3997607889$export$42dd0cdd351a4a9 = 'prod';
const $c9cb1b3997607889$export$404582bc18fe4d9e = 'dev';

const $54dbbe6dc88f8bd2$export$42f4885608027d0c = 'non_boolean';

const $e9db81972dce4ebc$export$f636b5b56f1d624a = 'Screen';
const $e9db81972dce4ebc$export$9d2de6eebf7462b5 = 'Drawer';
const $e9db81972dce4ebc$export$1171103ea9083ffa = 'Modal';
const $e9db81972dce4ebc$export$cae2783c9279926 = 'InlineDialog';
const $e9db81972dce4ebc$export$d1123261ca8831d2 = 'Dropdown';
const $e9db81972dce4ebc$export$a1562d08625f5d7e = 'UI';
const $e9db81972dce4ebc$export$947dac6c72b26f81 = 'TRACK';
const $e9db81972dce4ebc$export$f1d537d508d2945a = 'SCREEN';
const $e9db81972dce4ebc$export$12346a674644c156 = 'OPERATIONAL';
const $e9db81972dce4ebc$export$2ceccf177fae277c = 'analyticsBridge';

var $7bb4c1736002a04a$exports = {};
$parcel$export($7bb4c1736002a04a$exports, "R50", () => $7bb4c1736002a04a$export$4b84fd0e2c617bd);
$parcel$export($7bb4c1736002a04a$exports, "R75", () => $7bb4c1736002a04a$export$b34b069eff244586);
$parcel$export($7bb4c1736002a04a$exports, "R100", () => $7bb4c1736002a04a$export$be802dd0d8b57f35);
$parcel$export($7bb4c1736002a04a$exports, "R200", () => $7bb4c1736002a04a$export$60847d42f9da92a6);
$parcel$export($7bb4c1736002a04a$exports, "R300", () => $7bb4c1736002a04a$export$4a7404f376229999);
$parcel$export($7bb4c1736002a04a$exports, "R400", () => $7bb4c1736002a04a$export$2010d0fb4295b346);
$parcel$export($7bb4c1736002a04a$exports, "R500", () => $7bb4c1736002a04a$export$2837b5a1a71d5c02);
$parcel$export($7bb4c1736002a04a$exports, "Y50", () => $7bb4c1736002a04a$export$8d9596b529bbb9cf);
$parcel$export($7bb4c1736002a04a$exports, "Y75", () => $7bb4c1736002a04a$export$41060a744ab0b7ae);
$parcel$export($7bb4c1736002a04a$exports, "Y100", () => $7bb4c1736002a04a$export$1cc05bbbf340e559);
$parcel$export($7bb4c1736002a04a$exports, "Y200", () => $7bb4c1736002a04a$export$5aae31392d72caaa);
$parcel$export($7bb4c1736002a04a$exports, "Y300", () => $7bb4c1736002a04a$export$c6930421db9fa514);
$parcel$export($7bb4c1736002a04a$exports, "Y400", () => $7bb4c1736002a04a$export$59619663aa6500fb);
$parcel$export($7bb4c1736002a04a$exports, "Y500", () => $7bb4c1736002a04a$export$874739ea9e379ab6);
$parcel$export($7bb4c1736002a04a$exports, "G50", () => $7bb4c1736002a04a$export$8a6341c32b6a3ee6);
$parcel$export($7bb4c1736002a04a$exports, "G75", () => $7bb4c1736002a04a$export$69a3bf21b9686c2b);
$parcel$export($7bb4c1736002a04a$exports, "G100", () => $7bb4c1736002a04a$export$afbce1382ec95f73);
$parcel$export($7bb4c1736002a04a$exports, "G200", () => $7bb4c1736002a04a$export$747d86715d4175de);
$parcel$export($7bb4c1736002a04a$exports, "G300", () => $7bb4c1736002a04a$export$940e1f69e873f202);
$parcel$export($7bb4c1736002a04a$exports, "G400", () => $7bb4c1736002a04a$export$a49394138f7b8e85);
$parcel$export($7bb4c1736002a04a$exports, "G500", () => $7bb4c1736002a04a$export$6fa04827ac68a4fb);
$parcel$export($7bb4c1736002a04a$exports, "B50", () => $7bb4c1736002a04a$export$226de0355ed012f8);
$parcel$export($7bb4c1736002a04a$exports, "B75", () => $7bb4c1736002a04a$export$8c13c2ee36917869);
$parcel$export($7bb4c1736002a04a$exports, "B100", () => $7bb4c1736002a04a$export$ecfc1dff386a3e7a);
$parcel$export($7bb4c1736002a04a$exports, "B200", () => $7bb4c1736002a04a$export$215b7063051591f1);
$parcel$export($7bb4c1736002a04a$exports, "B300", () => $7bb4c1736002a04a$export$e62e8919cca44969);
$parcel$export($7bb4c1736002a04a$exports, "B400", () => $7bb4c1736002a04a$export$b3de0ae08da2ce64);
$parcel$export($7bb4c1736002a04a$exports, "B500", () => $7bb4c1736002a04a$export$a6ee3d71bc067634);
$parcel$export($7bb4c1736002a04a$exports, "B600", () => $7bb4c1736002a04a$export$67f15409e87642a1);
$parcel$export($7bb4c1736002a04a$exports, "B700", () => $7bb4c1736002a04a$export$f0539dbc42dbb067);
$parcel$export($7bb4c1736002a04a$exports, "P50", () => $7bb4c1736002a04a$export$363e4475840015bb);
$parcel$export($7bb4c1736002a04a$exports, "P75", () => $7bb4c1736002a04a$export$4b0a4417ed59760f);
$parcel$export($7bb4c1736002a04a$exports, "P100", () => $7bb4c1736002a04a$export$6011520a64d9a187);
$parcel$export($7bb4c1736002a04a$exports, "P200", () => $7bb4c1736002a04a$export$a7175d4e9206bc80);
$parcel$export($7bb4c1736002a04a$exports, "P300", () => $7bb4c1736002a04a$export$b48405b95304b5a1);
$parcel$export($7bb4c1736002a04a$exports, "P400", () => $7bb4c1736002a04a$export$c71e4279dd54a18d);
$parcel$export($7bb4c1736002a04a$exports, "P500", () => $7bb4c1736002a04a$export$147899de772240ec);
$parcel$export($7bb4c1736002a04a$exports, "T50", () => $7bb4c1736002a04a$export$2cf711fe14c66f06);
$parcel$export($7bb4c1736002a04a$exports, "T75", () => $7bb4c1736002a04a$export$7a8f4d33f6f9772c);
$parcel$export($7bb4c1736002a04a$exports, "T100", () => $7bb4c1736002a04a$export$776c9c497ef08533);
$parcel$export($7bb4c1736002a04a$exports, "T200", () => $7bb4c1736002a04a$export$69cb3ca10c1e330e);
$parcel$export($7bb4c1736002a04a$exports, "T300", () => $7bb4c1736002a04a$export$9dc1ef0f3f48059b);
$parcel$export($7bb4c1736002a04a$exports, "T400", () => $7bb4c1736002a04a$export$7c835c78b6fcdef8);
$parcel$export($7bb4c1736002a04a$exports, "T500", () => $7bb4c1736002a04a$export$6036577f95c3877e);
$parcel$export($7bb4c1736002a04a$exports, "N0", () => $7bb4c1736002a04a$export$29a4f05edc054374);
$parcel$export($7bb4c1736002a04a$exports, "N10", () => $7bb4c1736002a04a$export$e655ef011c4aa1a2);
$parcel$export($7bb4c1736002a04a$exports, "N20", () => $7bb4c1736002a04a$export$9fdfb749e33cdf97);
$parcel$export($7bb4c1736002a04a$exports, "N30", () => $7bb4c1736002a04a$export$3e51e8f1440314ba);
$parcel$export($7bb4c1736002a04a$exports, "N40", () => $7bb4c1736002a04a$export$1ce2d1575d444ceb);
$parcel$export($7bb4c1736002a04a$exports, "N50", () => $7bb4c1736002a04a$export$8754fc7e6d8b3000);
$parcel$export($7bb4c1736002a04a$exports, "N60", () => $7bb4c1736002a04a$export$c2e91cbeada39b8b);
$parcel$export($7bb4c1736002a04a$exports, "N70", () => $7bb4c1736002a04a$export$5f71e19f3a7ad9de);
$parcel$export($7bb4c1736002a04a$exports, "N80", () => $7bb4c1736002a04a$export$eaa8c8a70ac22806);
$parcel$export($7bb4c1736002a04a$exports, "N90", () => $7bb4c1736002a04a$export$7c87d337fb91a97d);
$parcel$export($7bb4c1736002a04a$exports, "N100", () => $7bb4c1736002a04a$export$d6447c357493214f);
$parcel$export($7bb4c1736002a04a$exports, "N200", () => $7bb4c1736002a04a$export$f563ee71e9ee74cd);
$parcel$export($7bb4c1736002a04a$exports, "N300", () => $7bb4c1736002a04a$export$e2ef2124cf4024b1);
$parcel$export($7bb4c1736002a04a$exports, "N400", () => $7bb4c1736002a04a$export$eece5f492e429f08);
$parcel$export($7bb4c1736002a04a$exports, "N500", () => $7bb4c1736002a04a$export$c39c0fe0f26207ae);
$parcel$export($7bb4c1736002a04a$exports, "N600", () => $7bb4c1736002a04a$export$7090862dc3038a9f);
$parcel$export($7bb4c1736002a04a$exports, "N700", () => $7bb4c1736002a04a$export$ad0bacf983b7ddaa);
$parcel$export($7bb4c1736002a04a$exports, "N800", () => $7bb4c1736002a04a$export$7d61b15e0da132af);
$parcel$export($7bb4c1736002a04a$exports, "N900", () => $7bb4c1736002a04a$export$fbda843f0a27fe96);
$parcel$export($7bb4c1736002a04a$exports, "N10A", () => $7bb4c1736002a04a$export$791e57b27ca738ef);
$parcel$export($7bb4c1736002a04a$exports, "N20A", () => $7bb4c1736002a04a$export$8d43898f60b96a82);
$parcel$export($7bb4c1736002a04a$exports, "N30A", () => $7bb4c1736002a04a$export$920c0d5c49070351);
$parcel$export($7bb4c1736002a04a$exports, "N40A", () => $7bb4c1736002a04a$export$46987b49aab6d1a8);
$parcel$export($7bb4c1736002a04a$exports, "N50A", () => $7bb4c1736002a04a$export$7d3359664e8bb0e5);
$parcel$export($7bb4c1736002a04a$exports, "N60A", () => $7bb4c1736002a04a$export$d2d3bedfb276cac0);
$parcel$export($7bb4c1736002a04a$exports, "N70A", () => $7bb4c1736002a04a$export$6e5e7499ff054f6d);
$parcel$export($7bb4c1736002a04a$exports, "N80A", () => $7bb4c1736002a04a$export$59264b346c877fa7);
$parcel$export($7bb4c1736002a04a$exports, "N90A", () => $7bb4c1736002a04a$export$d092757d7c64925c);
$parcel$export($7bb4c1736002a04a$exports, "N100A", () => $7bb4c1736002a04a$export$486ab785e4bac3c6);
$parcel$export($7bb4c1736002a04a$exports, "N200A", () => $7bb4c1736002a04a$export$fba592bbc6419fea);
$parcel$export($7bb4c1736002a04a$exports, "N300A", () => $7bb4c1736002a04a$export$13609db0e6812ab8);
$parcel$export($7bb4c1736002a04a$exports, "N400A", () => $7bb4c1736002a04a$export$fbae4efaa892d883);
$parcel$export($7bb4c1736002a04a$exports, "N500A", () => $7bb4c1736002a04a$export$f13946d26f440ce6);
$parcel$export($7bb4c1736002a04a$exports, "N600A", () => $7bb4c1736002a04a$export$19f58225ac52a306);
$parcel$export($7bb4c1736002a04a$exports, "N700A", () => $7bb4c1736002a04a$export$6384f09da70e7b62);
$parcel$export($7bb4c1736002a04a$exports, "N800A", () => $7bb4c1736002a04a$export$d0dccc730683edc2);
$parcel$export($7bb4c1736002a04a$exports, "DN900", () => $7bb4c1736002a04a$export$2f6319cf7d736c2a);
$parcel$export($7bb4c1736002a04a$exports, "DN800", () => $7bb4c1736002a04a$export$95126bc8884d6634);
$parcel$export($7bb4c1736002a04a$exports, "DN700", () => $7bb4c1736002a04a$export$8338d8c35d44ff1);
$parcel$export($7bb4c1736002a04a$exports, "DN600", () => $7bb4c1736002a04a$export$5368d76ae4fbbda7);
$parcel$export($7bb4c1736002a04a$exports, "DN500", () => $7bb4c1736002a04a$export$9f0a771d16ec8d36);
$parcel$export($7bb4c1736002a04a$exports, "DN400", () => $7bb4c1736002a04a$export$abcf8c38338b4aa5);
$parcel$export($7bb4c1736002a04a$exports, "DN300", () => $7bb4c1736002a04a$export$97e81faa16a182c7);
$parcel$export($7bb4c1736002a04a$exports, "DN200", () => $7bb4c1736002a04a$export$bfe21c59123ecf33);
$parcel$export($7bb4c1736002a04a$exports, "DN100", () => $7bb4c1736002a04a$export$ee82aa2ea6a1558);
$parcel$export($7bb4c1736002a04a$exports, "DN90", () => $7bb4c1736002a04a$export$682927c6ed76be02);
$parcel$export($7bb4c1736002a04a$exports, "DN80", () => $7bb4c1736002a04a$export$91fd9994c5be9757);
$parcel$export($7bb4c1736002a04a$exports, "DN70", () => $7bb4c1736002a04a$export$d281fbfe3cff2df6);
$parcel$export($7bb4c1736002a04a$exports, "DN60", () => $7bb4c1736002a04a$export$3902c91d8b98a753);
$parcel$export($7bb4c1736002a04a$exports, "DN50", () => $7bb4c1736002a04a$export$8e8133c1ba5845b5);
$parcel$export($7bb4c1736002a04a$exports, "DN40", () => $7bb4c1736002a04a$export$33ff357f6620b39);
$parcel$export($7bb4c1736002a04a$exports, "DN30", () => $7bb4c1736002a04a$export$633847cf062b69e0);
$parcel$export($7bb4c1736002a04a$exports, "DN20", () => $7bb4c1736002a04a$export$9776a6e503bdbf76);
$parcel$export($7bb4c1736002a04a$exports, "DN10", () => $7bb4c1736002a04a$export$6c813d5160dff5db);
$parcel$export($7bb4c1736002a04a$exports, "DN0", () => $7bb4c1736002a04a$export$3d4f271a500072a);
$parcel$export($7bb4c1736002a04a$exports, "DN800A", () => $7bb4c1736002a04a$export$fe151285c22759ec);
$parcel$export($7bb4c1736002a04a$exports, "DN700A", () => $7bb4c1736002a04a$export$a101c6190d0da34);
$parcel$export($7bb4c1736002a04a$exports, "DN600A", () => $7bb4c1736002a04a$export$4b16f52932fda51);
$parcel$export($7bb4c1736002a04a$exports, "DN500A", () => $7bb4c1736002a04a$export$a74bcd7b9845b0d8);
$parcel$export($7bb4c1736002a04a$exports, "DN400A", () => $7bb4c1736002a04a$export$9209c179316d1751);
$parcel$export($7bb4c1736002a04a$exports, "DN300A", () => $7bb4c1736002a04a$export$88f55133f636c8dd);
$parcel$export($7bb4c1736002a04a$exports, "DN200A", () => $7bb4c1736002a04a$export$51126f85d1009512);
$parcel$export($7bb4c1736002a04a$exports, "DN100A", () => $7bb4c1736002a04a$export$a069b547bd23af78);
$parcel$export($7bb4c1736002a04a$exports, "DN90A", () => $7bb4c1736002a04a$export$40cce05af3b2600a);
$parcel$export($7bb4c1736002a04a$exports, "DN80A", () => $7bb4c1736002a04a$export$b78942185925a0d);
$parcel$export($7bb4c1736002a04a$exports, "DN70A", () => $7bb4c1736002a04a$export$e058fb44b8eaafca);
$parcel$export($7bb4c1736002a04a$exports, "DN60A", () => $7bb4c1736002a04a$export$92b0b8de26920c18);
$parcel$export($7bb4c1736002a04a$exports, "DN50A", () => $7bb4c1736002a04a$export$67564f7459d3fc9e);
$parcel$export($7bb4c1736002a04a$exports, "DN40A", () => $7bb4c1736002a04a$export$77868e1ca884ffa3);
$parcel$export($7bb4c1736002a04a$exports, "DN30A", () => $7bb4c1736002a04a$export$2afd71d7d3ea2cd5);
$parcel$export($7bb4c1736002a04a$exports, "DN20A", () => $7bb4c1736002a04a$export$f2a0acaab9972c70);
$parcel$export($7bb4c1736002a04a$exports, "DN10A", () => $7bb4c1736002a04a$export$9ab70e67d6475361);
$parcel$export($7bb4c1736002a04a$exports, "T30", () => $7bb4c1736002a04a$export$d2adc5dedf09fced);
$parcel$export($7bb4c1736002a04a$exports, "L50", () => $7bb4c1736002a04a$export$f51762073d2bb381);
$parcel$export($7bb4c1736002a04a$exports, "L75", () => $7bb4c1736002a04a$export$95e26d54def96891);
// Reds
const $7bb4c1736002a04a$export$4b84fd0e2c617bd = '#FFEBE6';
const $7bb4c1736002a04a$export$b34b069eff244586 = '#FFBDAD';
const $7bb4c1736002a04a$export$be802dd0d8b57f35 = '#FF8F73';
const $7bb4c1736002a04a$export$60847d42f9da92a6 = '#FF7452';
const $7bb4c1736002a04a$export$4a7404f376229999 = '#FF5630';
const $7bb4c1736002a04a$export$2010d0fb4295b346 = '#DE350B';
const $7bb4c1736002a04a$export$2837b5a1a71d5c02 = '#BF2600';
const $7bb4c1736002a04a$export$8d9596b529bbb9cf = '#FFFAE6';
const $7bb4c1736002a04a$export$41060a744ab0b7ae = '#FFF0B3';
const $7bb4c1736002a04a$export$1cc05bbbf340e559 = '#FFE380';
const $7bb4c1736002a04a$export$5aae31392d72caaa = '#FFC400';
const $7bb4c1736002a04a$export$c6930421db9fa514 = '#FFAB00';
const $7bb4c1736002a04a$export$59619663aa6500fb = '#FF991F';
const $7bb4c1736002a04a$export$874739ea9e379ab6 = '#FF8B00';
const $7bb4c1736002a04a$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $7bb4c1736002a04a$export$69a3bf21b9686c2b = '#ABF5D1';
const $7bb4c1736002a04a$export$afbce1382ec95f73 = '#79F2C0';
const $7bb4c1736002a04a$export$747d86715d4175de = '#57D9A3';
const $7bb4c1736002a04a$export$940e1f69e873f202 = '#36B37E';
const $7bb4c1736002a04a$export$a49394138f7b8e85 = '#00875A';
const $7bb4c1736002a04a$export$6fa04827ac68a4fb = '#006644';
const $7bb4c1736002a04a$export$226de0355ed012f8 = '#DEEBFF';
const $7bb4c1736002a04a$export$8c13c2ee36917869 = '#B3D4FF';
const $7bb4c1736002a04a$export$ecfc1dff386a3e7a = '#4C9AFF';
const $7bb4c1736002a04a$export$215b7063051591f1 = '#2684FF';
const $7bb4c1736002a04a$export$e62e8919cca44969 = '#0065FF';
const $7bb4c1736002a04a$export$b3de0ae08da2ce64 = '#0052CC';
const $7bb4c1736002a04a$export$a6ee3d71bc067634 = '#0747A6';
const $7bb4c1736002a04a$export$67f15409e87642a1 = '#669DF1';
const $7bb4c1736002a04a$export$f0539dbc42dbb067 = '#8FB8F6';
const $7bb4c1736002a04a$export$363e4475840015bb = '#EAE6FF';
const $7bb4c1736002a04a$export$4b0a4417ed59760f = '#C0B6F2';
const $7bb4c1736002a04a$export$6011520a64d9a187 = '#998DD9';
const $7bb4c1736002a04a$export$a7175d4e9206bc80 = '#8777D9';
const $7bb4c1736002a04a$export$b48405b95304b5a1 = '#6554C0';
const $7bb4c1736002a04a$export$c71e4279dd54a18d = '#5243AA';
const $7bb4c1736002a04a$export$147899de772240ec = '#403294';
const $7bb4c1736002a04a$export$2cf711fe14c66f06 = '#E6FCFF';
const $7bb4c1736002a04a$export$7a8f4d33f6f9772c = '#B3F5FF';
const $7bb4c1736002a04a$export$776c9c497ef08533 = '#79E2F2';
const $7bb4c1736002a04a$export$69cb3ca10c1e330e = '#00C7E6';
const $7bb4c1736002a04a$export$9dc1ef0f3f48059b = '#00B8D9';
const $7bb4c1736002a04a$export$7c835c78b6fcdef8 = '#00A3BF';
const $7bb4c1736002a04a$export$6036577f95c3877e = '#008DA6';
const $7bb4c1736002a04a$export$29a4f05edc054374 = '#FFFFFF';
const $7bb4c1736002a04a$export$e655ef011c4aa1a2 = '#FAFBFC';
const $7bb4c1736002a04a$export$9fdfb749e33cdf97 = '#F4F5F7';
const $7bb4c1736002a04a$export$3e51e8f1440314ba = '#EBECF0';
const $7bb4c1736002a04a$export$1ce2d1575d444ceb = '#DFE1E6';
const $7bb4c1736002a04a$export$8754fc7e6d8b3000 = '#C1C7D0';
const $7bb4c1736002a04a$export$c2e91cbeada39b8b = '#B3BAC5';
const $7bb4c1736002a04a$export$5f71e19f3a7ad9de = '#A5ADBA';
const $7bb4c1736002a04a$export$eaa8c8a70ac22806 = '#97A0AF';
const $7bb4c1736002a04a$export$7c87d337fb91a97d = '#8993A4';
const $7bb4c1736002a04a$export$d6447c357493214f = '#7A869A';
const $7bb4c1736002a04a$export$f563ee71e9ee74cd = '#6B778C';
const $7bb4c1736002a04a$export$e2ef2124cf4024b1 = '#5E6C84';
const $7bb4c1736002a04a$export$eece5f492e429f08 = '#505F79';
const $7bb4c1736002a04a$export$c39c0fe0f26207ae = '#42526E';
const $7bb4c1736002a04a$export$7090862dc3038a9f = '#344563';
const $7bb4c1736002a04a$export$ad0bacf983b7ddaa = '#253858';
const $7bb4c1736002a04a$export$7d61b15e0da132af = '#172B4D';
const $7bb4c1736002a04a$export$fbda843f0a27fe96 = '#091E42';
const $7bb4c1736002a04a$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $7bb4c1736002a04a$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $7bb4c1736002a04a$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $7bb4c1736002a04a$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $7bb4c1736002a04a$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $7bb4c1736002a04a$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $7bb4c1736002a04a$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $7bb4c1736002a04a$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $7bb4c1736002a04a$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $7bb4c1736002a04a$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $7bb4c1736002a04a$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $7bb4c1736002a04a$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $7bb4c1736002a04a$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $7bb4c1736002a04a$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $7bb4c1736002a04a$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $7bb4c1736002a04a$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $7bb4c1736002a04a$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $7bb4c1736002a04a$export$2f6319cf7d736c2a = '#E6EDFA';
const $7bb4c1736002a04a$export$95126bc8884d6634 = '#DCE5F5';
const $7bb4c1736002a04a$export$8338d8c35d44ff1 = '#CED9EB';
const $7bb4c1736002a04a$export$5368d76ae4fbbda7 = '#B8C7E0';
const $7bb4c1736002a04a$export$9f0a771d16ec8d36 = '#ABBBD6';
const $7bb4c1736002a04a$export$abcf8c38338b4aa5 = '#9FB0CC';
const $7bb4c1736002a04a$export$97e81faa16a182c7 = '#8C9CB8';
const $7bb4c1736002a04a$export$bfe21c59123ecf33 = '#7988A3';
const $7bb4c1736002a04a$export$ee82aa2ea6a1558 = '#67758F';
const $7bb4c1736002a04a$export$682927c6ed76be02 = '#56637A';
const $7bb4c1736002a04a$export$91fd9994c5be9757 = '#455166';
const $7bb4c1736002a04a$export$d281fbfe3cff2df6 = '#3B475C';
const $7bb4c1736002a04a$export$3902c91d8b98a753 = '#313D52';
const $7bb4c1736002a04a$export$8e8133c1ba5845b5 = '#283447';
const $7bb4c1736002a04a$export$33ff357f6620b39 = '#202B3D';
const $7bb4c1736002a04a$export$633847cf062b69e0 = '#1B2638';
const $7bb4c1736002a04a$export$9776a6e503bdbf76 = '#121A29';
const $7bb4c1736002a04a$export$6c813d5160dff5db = '#0E1624';
const $7bb4c1736002a04a$export$3d4f271a500072a = '#0D1424';
const $7bb4c1736002a04a$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $7bb4c1736002a04a$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $7bb4c1736002a04a$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $7bb4c1736002a04a$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $7bb4c1736002a04a$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $7bb4c1736002a04a$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $7bb4c1736002a04a$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $7bb4c1736002a04a$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $7bb4c1736002a04a$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $7bb4c1736002a04a$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $7bb4c1736002a04a$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $7bb4c1736002a04a$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $7bb4c1736002a04a$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $7bb4c1736002a04a$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $7bb4c1736002a04a$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $7bb4c1736002a04a$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $7bb4c1736002a04a$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $7bb4c1736002a04a$export$d2adc5dedf09fced = '#292A2E';
const $7bb4c1736002a04a$export$f51762073d2bb381 = '#94C748';
const $7bb4c1736002a04a$export$95e26d54def96891 = '#B3DF72';

/**
 * Character key codes which can be used in keyboard events.
 */ const $9f42f4c07a71299e$export$390330c10ff2b9a1 = 'ArrowUp';
const $9f42f4c07a71299e$export$a80636c6f41931fe = 'ArrowDown';
const $9f42f4c07a71299e$export$4af703091671bc = 'Home';
const $9f42f4c07a71299e$export$e2bc30913faa5db7 = 'End';
const $9f42f4c07a71299e$export$10f6869ed0a7d75b = 'Tab';
const $9f42f4c07a71299e$export$8152f929a25a0ff4 = 'Enter';
const $9f42f4c07a71299e$export$e51a3576c045c8d5 = 'Space';
const $9f42f4c07a71299e$export$2bb790b9008907b4 = 'Escape';

const $3d9529cd8ff26a50$export$e4c79eb95c23a0da = 'atlaskit-portal-container';
const $3d9529cd8ff26a50$export$72f415121273627e = 'body > .atlaskit-portal-container';
const $3d9529cd8ff26a50$export$13f57c02915787b3 = 'atlaskit-portal';

const $31a7f3563d375095$export$ed5835cc67e87f72 = 'akPortalMount';
const $31a7f3563d375095$export$80816bd900e5bd00 = 'akPortalUnmount';

// Media uses a namespaced analytics context under the following key MEDIA_CONTEXT.
const $5bf02ef989474068$export$70df29c238ba7306 = 'mediaCtx'; // However we don't export any JSX component to create that namespaced analytics context.
 // In media components, analytics context is being created by this component:
 // @see packages/media/media-common/src/analytics/withMediaAnalyticsContext.tsx

// same types defined in analytics-web-client but avoid creating dependency with that
const $d6f34b7bd34f6138$export$a1562d08625f5d7e = 'ui';
const $d6f34b7bd34f6138$export$947dac6c72b26f81 = 'track';
const $d6f34b7bd34f6138$export$f1d537d508d2945a = 'screen';
const $d6f34b7bd34f6138$export$12346a674644c156 = 'operational';
const $d6f34b7bd34f6138$export$b055de0e665cb20c = 'unknown';

const $a09d0fc1237ba534$export$d6830277b06edd6 = 'normal';

const $71feb0ebe2f021d7$export$cf090d5281b5ae06 = 10000;
const $71feb0ebe2f021d7$export$8575e30be0feb909 = 30000;

const $10b5883439ef237e$export$3288b14b6745c572 = 204;
const $10b5883439ef237e$export$c09e7ea0fc79f34f = 409;
const $10b5883439ef237e$export$974c37534b0191b1 = 503;


$parcel$global.rlb("kVX56")
//# sourceMappingURL=shared~vendor~ar.712bbd6e.js.map
